/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 93:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-circle-right';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f138';
var svgPathData = 'M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.xn = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 119:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ 583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Parameters_Parameters; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/Parameters/Parameters.vue?vue&type=template&id=438b64bf
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{attrs:{"type":"hidden","name":"billing_contact"},domProps:{"value":_vm.value.billing_contact ? _vm.value.billing_contact.id : null}}),_c('ContactSelect',{attrs:{"validationName":"billing_contact","label":"Contact facturation","customer":_vm.value.customer,"disabled":!_vm.value.customer},model:{value:(_vm.value.billing_contact),callback:function ($$v) {_vm.$set(_vm.value, "billing_contact", $$v)},expression:"value.billing_contact"}}),_c('b-form-group',{attrs:{"label":"Conditions générales de vente"}},[_c('SaleTermsSelect',{attrs:{"name":"sale_term","reduce":opt =>opt.id},model:{value:(_vm.value.sale_term_id),callback:function ($$v) {_vm.$set(_vm.value, "sale_term_id", $$v)},expression:"value.sale_term_id"}})],1),_c('b-form-group',{attrs:{"label":"Moyens de paiement acceptés","label-class":"mb-1"}},[_c('k-form-checkbox-group',{attrs:{"options":_vm.paymentMethods,"text-field":"label","value-field":"id"},model:{value:(_vm.localPaymentMethods),callback:function ($$v) {_vm.localPaymentMethods=$$v},expression:"localPaymentMethods"}}),(_vm.localPaymentMethods.length > 0)?_vm._l((_vm.localPaymentMethods),function(id){return _c('input',{key:id,attrs:{"validation-name":"payment_methods","type":"hidden","name":"payment_methods[]"},domProps:{"value":id}})}):_c('input',{attrs:{"type":"hidden","name":"payment_methods"},domProps:{"value":null}})],2),(_vm.type !== 'credit')?[_c('b-form-group',{attrs:{"label":"Taux d'escompe"}},[_c('b-input-group',{staticStyle:{"max-width":"140px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"escompte_rate","min":0,"max":100},model:{value:(_vm.value.escompte_rate),callback:function ($$v) {_vm.$set(_vm.value, "escompte_rate", $$v)},expression:"value.escompte_rate"}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux de pénalité"}},[_c('b-input-group',{staticStyle:{"max-width":"140px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"penalty_rate","min":0,"max":100,"disabled":_vm.value.penalty_rate_law},model:{value:(_vm.value.penalty_rate),callback:function ($$v) {_vm.$set(_vm.value, "penalty_rate", $$v)},expression:"value.penalty_rate"}})],1),_c('input',{attrs:{"type":"hidden","name":"penalty_rate_law"},domProps:{"value":_vm.value.penalty_rate_law}}),_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.value.penalty_rate_law),callback:function ($$v) {_vm.$set(_vm.value, "penalty_rate_law", $$v)},expression:"value.penalty_rate_law"}},[_c('p',{staticClass:"mb-0"},[_vm._v(" Afficher la mention suivante : ")]),_c('small',[_vm._v(" En cas de retard de paiement, application d'intérêts de 3 fois le taux légal selon la loi n°2008-776 du 4 août 2008. ")])])],1),_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Frais de recouvrement"}},[_c('input',{attrs:{"type":"hidden","name":"collection_costs_law"},domProps:{"value":_vm.value.collection_costs_law}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.value.collection_costs_law),callback:function ($$v) {_vm.$set(_vm.value, "collection_costs_law", $$v)},expression:"value.collection_costs_law"}},[_c('p',{staticClass:"mb-0"},[_vm._v(" Afficher la mention suivante : ")]),_c('small',[_vm._v(" En cas de retard de paiement, application d'une indemnité forfaitaire pour frais de recouvrement de 40€ selon l'article D. 441-5 du code du commerce. ")])])],1)]:_vm._e(),(_vm.value.currency && _vm.currency.id !== _vm.value.currency.id)?_c('b-form-group',{staticStyle:{"max-width":"140px"},attrs:{"label":"Taux de change"}},[_c('b-input-group',{attrs:{"append":_vm.value.currency.symbol + ' = 1 ' + _vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"exchange_rate"},model:{value:(_vm.value.exchange_rate),callback:function ($$v) {_vm.$set(_vm.value, "exchange_rate", $$v)},expression:"value.exchange_rate"}})],1)],1):_vm._e()],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: ./src/components/SaleTermsSelect/SaleTermsSelect.vue + 3 modules
var SaleTermsSelect = __webpack_require__(95150);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/Parameters/Parameters.ts?vue&type=script&lang=ts&external







var Parameters = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Parameters, _super);
    function Parameters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localPaymentMethods = [];
        return _this;
    }
    Parameters.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPaymentMethods()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Parameters.prototype.watchPaymentMethods = function () {
        var methods = this.value.payment_methods ? this.value.payment_methods : [];
        this.localPaymentMethods = methods.map(function (method) { return method.id; });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], Parameters.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Parameters.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.payment_methods', { immediate: true })
    ], Parameters.prototype, "watchPaymentMethods", null);
    Parameters = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContactSelect: customers_vue_.ContactSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup,
                KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormNumber: form_vue_.KFormNumber, KFormCheckbox: form_vue_.KFormCheckbox,
                SaleTermsSelect: SaleTermsSelect/* default */.A
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadPaymentMethods'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['paymentMethods'])), (0,external_vuex_.mapGetters)('user', ['currency']))
        })
    ], Parameters);
    return Parameters;
}(lib/* Vue */.lD));
/* harmony default export */ var Parametersvue_type_script_lang_ts_external = (Parameters);

;// ./src/components/Form/Parameters/Parameters.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Parameters_Parametersvue_type_script_lang_ts_external = (Parametersvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/Parameters/Parameters.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Parameters_Parametersvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Parameters_Parameters = (component.exports);

/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(51873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var bootstrap_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19529);
/* harmony import */ var bootstrap_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue__WEBPACK_IMPORTED_MODULE_1__);



var SalesPdfOptionsMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(SalesPdfOptionsMixin, _super);
    function SalesPdfOptionsMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.amounts = [
            { id: 1, label: _this.$t('sales.form.pdfOptions.amountsChoice1') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.amountsChoice2') },
            { id: 3, label: _this.$t('sales.form.pdfOptions.amountsChoice3') },
            { id: 4, label: _this.$t('sales.form.pdfOptions.amountsChoice4') }
        ];
        _this.discounts = [
            { id: 1, label: _this.$t('sales.form.pdfOptions.discountChoice1') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.discountChoice2') },
            { id: 3, label: _this.$t('sales.form.pdfOptions.discountChoice3') },
            { id: 4, label: _this.$t('sales.form.pdfOptions.discountChoice4') }
        ];
        _this.comments = [
            { id: 1, label: _this.$t('sales.form.pdfOptions.commentsChoice1') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.commentsChoice2') }
        ];
        _this.units = [
            { id: 0, label: _this.$t('sales.form.pdfOptions.unitChoice0') },
            { id: 1, label: _this.$t('sales.form.pdfOptions.unitChoice1') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.unitChoice2') },
            { id: 3, label: _this.$t('sales.form.pdfOptions.unitChoice3') }
        ];
        _this.basicDisplay = [
            { id: 1, label: _this.$t('sales.form.pdfOptions.displayChoice1') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.displayChoice2') },
            { id: 3, label: _this.$t('sales.form.pdfOptions.displayChoice3') }
        ];
        _this.vatRateCol = [
            { id: false, label: _this.$t('sales.form.pdfOptions.vatrateChoice1') },
            { id: true, label: _this.$t('sales.form.pdfOptions.vatrateChoice2') }
        ];
        _this.pictures = [
            { id: 1, label: _this.$t('sales.form.pdfOptions.picturesChoice1') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.picturesChoice2') }
        ];
        _this.displayAddress = [
            { id: 1, label: _this.$t('sales.form.pdfOptions.addressesChoice1') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.addressesChoice2') },
            { id: 3, label: _this.$t('sales.form.pdfOptions.addressesChoice3') },
            { id: 4, label: _this.$t('sales.form.pdfOptions.addressesChoice4') }
        ];
        _this.vatRateNumber = [
            { id: 0, label: _this.$t('sales.form.pdfOptions.vatrateNumberChoice1') },
            { id: 1, label: _this.$t('sales.form.pdfOptions.vatrateNumberChoice2') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.vatrateNumberChoice3') }
        ];
        _this.totalQuantityCol = [
            { id: false, label: _this.$t('sales.form.pdfOptions.totalQuantityChoice1') },
            { id: true, label: _this.$t('sales.form.pdfOptions.totalQuantityChoice2') }
        ];
        _this.showOnOff = [
            { id: false, label: _this.$t('sales.form.pdfOptions.displayChoice3') },
            { id: true, label: _this.$t('sales.form.pdfOptions.displayChoice2') }
        ];
        _this.showSituationColumns = [
            { id: 0, label: _this.$t('sales.form.pdfOptions.situationColumns1') },
            { id: 1, label: _this.$t('sales.form.pdfOptions.situationColumns2') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.situationColumns3') },
            { id: 3, label: _this.$t('sales.form.pdfOptions.situationColumns4') },
            { id: 4, label: _this.$t('sales.form.pdfOptions.situationColumns5') }
        ];
        return _this;
    }
    SalesPdfOptionsMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            directives: {
                'b-toggle': bootstrap_vue__WEBPACK_IMPORTED_MODULE_1__.VBToggle
            }
        })
    ], SalesPdfOptionsMixin);
    return SalesPdfOptionsMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (SalesPdfOptionsMixin);


/***/ }),

/***/ 1221:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ 1632:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ 1803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfModelArea_PdfModelArea; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfModelArea/PdfModelArea.vue?vue&type=template&id=f5eae350
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('draggable',{staticClass:"pdf-model-editor-area",attrs:{"list":_vm.blocks,"draggable":".pdf-model-editor-block","group":"pdfModelArea"}},[_vm._l((_vm.blocks),function(block,i){return _c('PdfModelBlock',{key:i,attrs:{"pdf-model":_vm.pdfModel,"preview":_vm.preview},on:{"delete":function($event){return _vm.$delete(_vm.blocks, i)}},model:{value:(_vm.blocks[i]),callback:function ($$v) {_vm.$set(_vm.blocks, i, $$v)},expression:"blocks[i]"}})}),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],staticClass:"add-block-btn",attrs:{"variant":"link","title":"Ajouter un block","container":_vm.$refs.$el},on:{"click":function($event){$event.preventDefault();return _vm.addBlock.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuedraggable"
var external_vuedraggable_ = __webpack_require__(25325);
var external_vuedraggable_default = /*#__PURE__*/__webpack_require__.n(external_vuedraggable_);
// EXTERNAL MODULE: ./src/components/PdfModelBlock/PdfModelBlock.vue + 3 modules
var PdfModelBlock = __webpack_require__(82233);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfModelArea/PdfModelArea.ts?vue&type=script&lang=ts&external






var PdfModelArea = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelArea, _super);
    function PdfModelArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.blocks = [];
        return _this;
    }
    PdfModelArea.prototype.mounted = function () {
        this.blocks = Array.from(this.value);
    };
    PdfModelArea.prototype.watchBlocks = function () {
        this.$emit('input', this.blocks);
    };
    PdfModelArea.prototype.addBlock = function () {
        this.blocks.push({
            size: 100,
            content: null,
            quotation_content: null,
            same_content: false,
            options: {
                heightMode: 'auto'
            },
            open: true
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelArea.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelArea.prototype, "pdfModel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelArea.prototype, "preview", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('blocks')
    ], PdfModelArea.prototype, "watchBlocks", null);
    PdfModelArea = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                draggable: (external_vuedraggable_default()),
                PdfModelBlock: PdfModelBlock/* default */.A,
                BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], PdfModelArea);
    return PdfModelArea;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelAreavue_type_script_lang_ts_external = (PdfModelArea);

;// ./src/components/PdfModelArea/PdfModelArea.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelArea_PdfModelAreavue_type_script_lang_ts_external = (PdfModelAreavue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfModelArea/PdfModelArea.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelArea_PdfModelAreavue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelArea_PdfModelArea = (component.exports);

/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72552),
    isObject = __webpack_require__(23805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 2151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractModelList_ContractModelList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractModelList/ContractModelList.vue?vue&type=template&id=6f2756b6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"mb-3",attrs:{"variant":"primary","to":{ name: 'contract-models-form' },"size":"sm"}},[_vm._v(" Créer un modèle de contrat ")]),_c('k-table',{ref:"table",attrs:{"url":"/sales/contract-model","columns":_vm.columns,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"stateKey":"contract-models-list"}}),_c('ContratModelDelete',{attrs:{"element":"modal","modal":_vm.deleteIndex !== null},on:{"deleted":_vm.deleted,"closed":_vm.cancelDelete},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}}),_c('ContractModelDuplicate',{attrs:{"element":"modal","modal":_vm.duplicateModel !== null},on:{"closed":function($event){_vm.duplicateModel = null}},model:{value:(_vm.duplicateModel),callback:function ($$v) {_vm.duplicateModel=$$v},expression:"duplicateModel"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/ContractModelDelete/ContractModelDelete.vue + 3 modules
var ContractModelDelete = __webpack_require__(11873);
// EXTERNAL MODULE: ./src/components/ContractModelDuplicate/ContractModelDuplicate.vue + 3 modules
var ContractModelDuplicate = __webpack_require__(36505);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractModelList/ContractModelList.ts?vue&type=script&lang=ts&external






var ContractModelList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractModelList, _super);
    function ContractModelList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteModel = null;
        _this.deleteIndex = null;
        _this.duplicateModel = null;
        return _this;
    }
    Object.defineProperty(ContractModelList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'name',
                    name: 'Nom du modèle'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractModelList.prototype, "rowActions", {
        get: function () {
            return [
                {
                    title: 'Dupliquer',
                    icon: ['fas', 'copy'],
                    click: this.duplicate
                },
                {
                    icon: 'edit',
                    link: function (data) { return ({
                        name: 'contract-models-form',
                        params: {
                            id: String(data.id)
                        }
                    }); }
                },
                {
                    icon: 'delete',
                    click: this.deleteContractModel
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ContractModelList.prototype.rowLink = function (row) {
        return {
            name: 'contract-models-form',
            params: {
                id: String(row.id)
            }
        };
    };
    ContractModelList.prototype.deleteContractModel = function (model, index) {
        this.toDelete(model, index);
    };
    ContractModelList.prototype.toDelete = function (model, index) {
        this.deleteModel = model;
        this.deleteIndex = index;
    };
    ContractModelList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.cancelDelete();
        }
    };
    ContractModelList.prototype.cancelDelete = function () {
        this.deleteIndex = null;
        this.deleteModel = null;
    };
    ContractModelList.prototype.duplicate = function (model) {
        this.duplicateModel = model;
    };
    ContractModelList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                BButton: external_bootstrap_vue_.BButton,
                ContratModelDelete: ContractModelDelete/* default */.A,
                ContractModelDuplicate: ContractModelDuplicate/* default */.A
            }
        })
    ], ContractModelList);
    return ContractModelList;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractModelListvue_type_script_lang_ts_external = (ContractModelList);

;// ./src/components/ContractModelList/ContractModelList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractModelList_ContractModelListvue_type_script_lang_ts_external = (ContractModelListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractModelList/ContractModelList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractModelList_ContractModelListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractModelList_ContractModelList = (component.exports);

/***/ }),

/***/ 2652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_FecDownloadView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/FecDownloadView.vue?vue&type=template&id=dc51f1b0
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('kwTable.exports.downloadExplain'))+" ")]),_c('FecDownload',{attrs:{"id":_vm.$route.params.id}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/FecDownload/FecDownload.vue + 3 modules
var FecDownload = __webpack_require__(36440);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/FecDownloadView.vue?vue&type=script&lang=ts



var FecDownloadView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FecDownloadView, _super);
    function FecDownloadView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FecDownloadView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FecDownload: FecDownload/* default */.A
            }
        })
    ], FecDownloadView);
    return FecDownloadView;
}(lib/* Vue */.lD));
/* harmony default export */ var FecDownloadViewvue_type_script_lang_ts = (FecDownloadView);

;// ./src/views/FecDownloadView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_FecDownloadViewvue_type_script_lang_ts = (FecDownloadViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/FecDownloadView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_FecDownloadViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_FecDownloadView = (component.exports);

/***/ }),

/***/ 2787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51146);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_3__);





var VariablesMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__extends */ .C6)(VariablesMixin, _super);
    function VariablesMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VariablesMixin.prototype.htmltoText = function (html) {
        var tempDivElement = document.createElement('div');
        tempDivElement.innerHTML = html;
        return tempDivElement.textContent || tempDivElement.innerText || '';
    };
    VariablesMixin.prototype.replaceVariables = function (content, elements, contact) {
        var _this = this;
        var _a;
        (_a = content.match(/<variable(.*?)<\/variable>/gs)) === null || _a === void 0 ? void 0 : _a.forEach(function (variable) {
            // Get variable identifier
            var findIdent = variable.match(/data-variable="(.*?)"/s);
            if (!findIdent) {
                return;
            }
            var ident = findIdent[1];
            if (ident === 'SIGN-LINK') {
                return;
            }
            var findConditionnal = variable.match(/data-conditional-show="(.*?)"/s);
            var conditionnal = findConditionnal ? findConditionnal[1] === 'true' : false;
            var previewValue = _this.previewValues(elements, contact)[ident];
            if (previewValue === undefined || previewValue === null) {
                previewValue = '';
            }
            if (previewValue === '' && conditionnal) {
                content = content.replace(variable, '');
                return;
            }
            var replace = '';
            var findSpaceBeforePrefix = variable.match(/data-prefix-space-before="(.*?)"/s);
            var spaceBeforePrefix = findSpaceBeforePrefix ? findSpaceBeforePrefix[1] === 'true' : false;
            if (spaceBeforePrefix) {
                replace += '<br>';
            }
            var findPrefix = variable.match(/data-prefix="(.*?)"/s);
            if (findPrefix) {
                var prefixLabel = findPrefix[1];
                var findBoldPrefix = variable.match(/data-prefix-bold="(.*?)"/s);
                var boldPrefix = findBoldPrefix ? findBoldPrefix[1] === 'true' : false;
                if (boldPrefix) {
                    prefixLabel = '<strong>' + prefixLabel + '</strong>';
                }
                replace += prefixLabel;
            }
            var findSpaceAfterPrefix = variable.match(/data-prefix-space-after="(.*?)"/s);
            var spaceAfterPrefix = findSpaceAfterPrefix ? findSpaceAfterPrefix[1] === 'true' : false;
            if (spaceAfterPrefix) {
                replace += '<br>';
            }
            replace += previewValue;
            var findSpaceBeforeSuffix = variable.match(/data-suffix-space-before="(.*?)"/s);
            var spaceBeforeSuffix = findSpaceBeforeSuffix ? findSpaceBeforeSuffix[1] === 'true' : false;
            if (spaceBeforeSuffix) {
                replace += '<br>';
            }
            var findSuffix = variable.match(/data-suffix="(.*?)"/s);
            if (findSuffix) {
                replace += findSuffix[1];
            }
            var findSpaceAfterSuffix = variable.match(/data-suffix-space-after="(.*?)"/s);
            var spaceAfterSuffix = findSpaceAfterSuffix ? findSpaceAfterSuffix[1] === 'true' : false;
            if (spaceAfterSuffix) {
                replace += '<br>';
            }
            content = content.replace(variable, replace);
        });
        return content;
    };
    Object.defineProperty(VariablesMixin.prototype, "getCustomer", {
        get: function () {
            return function (elements) {
                var _a, _b;
                var customer = (_a = elements.find(function (el) { return el.type === 'customer'; })) === null || _a === void 0 ? void 0 : _a.data;
                if (!customer) {
                    var document = (_b = elements.find(function (el) { return ['quotation', 'command', 'invoice', 'delivery', 'credit'].includes(el.type); })) === null || _b === void 0 ? void 0 : _b.data;
                    if (document && document.customer) {
                        customer = document.customer;
                    }
                }
                return customer;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "getContact", {
        get: function () {
            return function (elements) { var _a; return (_a = elements.find(function (el) { return el.type === 'contact'; })) === null || _a === void 0 ? void 0 : _a.data; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "getDocument", {
        get: function () {
            return function (elements) {
                var _a;
                return (_a = elements.find(function (el) {
                    return ['quotation', 'command', 'proforma', 'delivery', 'invoice', 'credit', 'contract'].includes(el.type);
                })) === null || _a === void 0 ? void 0 : _a.data;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "getAddress", {
        get: function () {
            return function (address) {
                var _a;
                if (!address) {
                    return '';
                }
                var value = [
                    address.road,
                    address.road2,
                    address.road3,
                    address.postal_code,
                    address.city,
                    (_a = address.country) === null || _a === void 0 ? void 0 : _a.name,
                ];
                return value.filter(function (val) { return val !== '' && val !== null && val !== undefined; }).join(' ');
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "previewValues", {
        get: function () {
            var _this = this;
            return function (elements, contact) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
                if (contact === void 0) { contact = null; }
                var team = _this.team;
                var customer = _this.getCustomer(elements);
                // const contact = this.getContact(elements)
                contact = contact;
                var document = _this.getDocument(elements);
                var dayNumber = moment__WEBPACK_IMPORTED_MODULE_2___default()().isoWeekday();
                var monthNumber = moment__WEBPACK_IMPORTED_MODULE_2___default()().format('M');
                return {
                    'COMPANY-NAME': team.company_name,
                    'COMPANY-ROAD': (_a = team.road1) !== null && _a !== void 0 ? _a : '',
                    'COMPANY-ROAD2': (_b = team.road2) !== null && _b !== void 0 ? _b : '',
                    'COMPANY-ROAD3': (_c = team.road3) !== null && _c !== void 0 ? _c : '',
                    'COMPANY-POSTAL': (_d = team.postal_code) !== null && _d !== void 0 ? _d : '',
                    'COMPANY-TOWN': (_e = team.town) !== null && _e !== void 0 ? _e : '',
                    'COMPANY-COUNTRY': (_g = (_f = team.country) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : '',
                    'COMPANY-PHONE': (_h = team.phone) !== null && _h !== void 0 ? _h : '',
                    'COMPANY-MOBILE': (_j = team.mobile) !== null && _j !== void 0 ? _j : '',
                    'COMPANY-FAX': (_k = team.fax) !== null && _k !== void 0 ? _k : '',
                    'COMPANY-EMAIL': (_l = team.email) !== null && _l !== void 0 ? _l : '',
                    'COMPANY-WEBSITE': (_m = team.website) !== null && _m !== void 0 ? _m : '',
                    'COMPANY-TYPE': (_o = team.company_type) !== null && _o !== void 0 ? _o : '',
                    'COMPANY-SIRET': (_p = team.company_siret) !== null && _p !== void 0 ? _p : '',
                    'COMPANY-RCS': (_q = team.company_rcs) !== null && _q !== void 0 ? _q : '',
                    'COMPANY-TVA': (_r = team.company_vatrate) !== null && _r !== void 0 ? _r : '',
                    'COMPANY-NAF': (_s = team.company_naf) !== null && _s !== void 0 ? _s : '',
                    'COMPANY-CAPITAL': (_t = team.company_capital) !== null && _t !== void 0 ? _t : '',
                    'TIERS-CODE': (_x = (_v = (_u = customer === null || customer === void 0 ? void 0 : customer.reference) === null || _u === void 0 ? void 0 : _u.customer) !== null && _v !== void 0 ? _v : (_w = customer === null || customer === void 0 ? void 0 : customer.reference) === null || _w === void 0 ? void 0 : _w.prospect) !== null && _x !== void 0 ? _x : '',
                    'TIERS-NAME': customer === null || customer === void 0 ? void 0 : customer.name,
                    'TIERS-ROAD': (_y = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _y === void 0 ? void 0 : _y.road1,
                    'TIERS-ROAD2': (_z = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _z === void 0 ? void 0 : _z.road2,
                    'TIERS-ROAD3': (_0 = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _0 === void 0 ? void 0 : _0.road3,
                    'TIERS-POSTAL': (_1 = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _1 === void 0 ? void 0 : _1.postal_code,
                    'TIERS-TOWN': (_2 = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _2 === void 0 ? void 0 : _2.town,
                    'TIERS-COUNTRY': (_4 = (_3 = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _3 === void 0 ? void 0 : _3.country) === null || _4 === void 0 ? void 0 : _4.name,
                    'TIERS-PHONE': customer === null || customer === void 0 ? void 0 : customer.phone,
                    'TIERS-MOBILE': customer === null || customer === void 0 ? void 0 : customer.mobile,
                    'TIERS-FAX': customer === null || customer === void 0 ? void 0 : customer.fax,
                    'TIERS-EMAIL': customer === null || customer === void 0 ? void 0 : customer.email,
                    'TIERS-WEBSITE': customer === null || customer === void 0 ? void 0 : customer.website,
                    'TIERS-SIRET': customer === null || customer === void 0 ? void 0 : customer.company_siret,
                    'TIERS-TVA': customer === null || customer === void 0 ? void 0 : customer.company_vatrate,
                    'TIERS-COMMERCIAL': (_5 = customer === null || customer === void 0 ? void 0 : customer.team_user) === null || _5 === void 0 ? void 0 : _5.fullname,
                    'CONTACT-CIVILITY': (_6 = contact === null || contact === void 0 ? void 0 : contact.civility) === null || _6 === void 0 ? void 0 : _6.short_name,
                    'CONTACT-FULLNAME': contact === null || contact === void 0 ? void 0 : contact.fullname,
                    'CONTACT-FIRSTNAME': contact === null || contact === void 0 ? void 0 : contact.firstname,
                    'CONTACT-LASTNAME': contact === null || contact === void 0 ? void 0 : contact.lastname,
                    'CONTACT-ROAD': contact === null || contact === void 0 ? void 0 : contact.road1,
                    'CONTACT-ROAD2': contact === null || contact === void 0 ? void 0 : contact.road2,
                    'CONTACT-ROAD3': contact === null || contact === void 0 ? void 0 : contact.road3,
                    'CONTACT-POSTAL': contact === null || contact === void 0 ? void 0 : contact.postal_code,
                    'CONTACT-TOWN': contact === null || contact === void 0 ? void 0 : contact.town,
                    'CONTACT-COUNTRY': (_7 = contact === null || contact === void 0 ? void 0 : contact.country) === null || _7 === void 0 ? void 0 : _7.name,
                    'CONTACT-PHONE': contact === null || contact === void 0 ? void 0 : contact.phone,
                    'CONTACT-MOBILE': contact === null || contact === void 0 ? void 0 : contact.mobile,
                    'CONTACT-FAX': contact === null || contact === void 0 ? void 0 : contact.fax,
                    'CONTACT-EMAIL': contact === null || contact === void 0 ? void 0 : contact.email,
                    'CONTACT-WEBSITE': contact === null || contact === void 0 ? void 0 : contact.website,
                    'DOC-NUM': document === null || document === void 0 ? void 0 : document.reference,
                    'EXP-DATE': (document === null || document === void 0 ? void 0 : document.expire_at) ? _this.date(document.expire_at) : '',
                    'DATE': (document === null || document === void 0 ? void 0 : document.date) ? _this.date(document.date) : '',
                    'BDC-TIERS': document === null || document === void 0 ? void 0 : document.customer_command_reference,
                    'INVOICE-ADDRESS': _this.getAddress(document === null || document === void 0 ? void 0 : document.billing_address),
                    'DELIVERY-ADDRESS': _this.getAddress(document === null || document === void 0 ? void 0 : document.delivery_address),
                    'TITLE': document === null || document === void 0 ? void 0 : document.title,
                    'ACOMPTE-AMOUNT': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.advance_payment_amount),
                    'ESCOMPTE': _this.number(document === null || document === void 0 ? void 0 : document.escompte_rate) + '%',
                    'ESCOMPTE-AM0UNT-HT': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.escompte_amount_ht),
                    'ESCOMPTE-AM0UNT-TVA': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.escompte_amount_tva),
                    'ESCOMPTE-AM0UNT-TTC': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.escompte_amount_ttc),
                    'PENALTY-RATE': _this.number(document === null || document === void 0 ? void 0 : document.penalty_rate) + '%',
                    'PAYMENT-TERM': (_8 = document === null || document === void 0 ? void 0 : document.payment_term) === null || _8 === void 0 ? void 0 : _8.label,
                    'TOTAL-HT': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.total_ht),
                    'TOTAL-TVA': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.total_tva),
                    'TOTAL-TTC': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.total_ttc),
                    'TO-PAID': _this.formattedNumber(120),
                    'ALREADY-PAID': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.already_paid),
                    'STAY-TO-PAID': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.stay_to_pay),
                    'TODAY-DATE': moment__WEBPACK_IMPORTED_MODULE_2___default()().format('DD-MM-YYYY'),
                    'TODAY-DAY': _this.$t('communication.today.days.' + dayNumber),
                    'TODAY-DAY-NUMBER': dayNumber,
                    'TODAY-MONTH': _this.$t('communication.today.months.' + monthNumber),
                    'TODAY-MONTH-NUMBER': monthNumber,
                    'TODAY-YEAR': moment__WEBPACK_IMPORTED_MODULE_2___default()().format('YYYY'),
                    'DELIVERY-TRACKING': document === null || document === void 0 ? void 0 : document.delivery_tracking
                };
            };
        },
        enumerable: false,
        configurable: true
    });
    VariablesMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapGetters)('user', ['team']))
        })
    ], VariablesMixin);
    return VariablesMixin;
}((0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Mixins */ .Xe)(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_3__.DateMixin, _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_3__.NumberMixin)));
/* harmony default export */ __webpack_exports__.A = (VariablesMixin);


/***/ }),

/***/ 3035:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ 3322:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ 3478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarPdf_CarPdf; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarPdf/CarPdf.vue?vue&type=template&id=4f149b3a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-overlay',{staticClass:"d-inline-block",attrs:{"show":_vm.loading}},[_c('b-button-group',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.document.automotive_pdf_status < 2 ? 'PDF en cours de génération' : (_vm.document.automotive_pdf_status === 3 ? 'Erreur lors de la génération du PDF' : null) }),expression:"{ title: document.automotive_pdf_status < 2 ? 'PDF en cours de génération' : (document.automotive_pdf_status === 3 ? 'Erreur lors de la génération du PDF' : null) }"}],attrs:{"size":"sm"}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"variant":"primary","title":_vm.$t('interface.download'),"disabled":_vm.document.automotive_pdf_status !== 2},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_vm._v(" Ordre de réparation ")]),_c('b-dropdown',{attrs:{"size":"sm","variant":"primary","disabled":_vm.document.automotive_pdf_status !== 2}},[_c('b-dropdown-item-button',{on:{"click":function($event){$event.preventDefault();return _vm.send.apply(null, arguments)}}},[_vm._v(" Envoyer ")]),_c('b-dropdown-item-button',{on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[_vm._v(" Voir ")]),_c('b-dropdown-item-button',{on:{"click":function($event){$event.preventDefault();return _vm.printPdf.apply(null, arguments)}}},[_vm._v(" Imprimer ")]),_c('b-dropdown-item-button',{on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_vm._v(" Télécharger ")])],1)],1),(_vm.modal)?_c('FilePreview',{attrs:{"value":_vm.document.automotive_pdf},on:{"hidden":function($event){_vm.modal = false}}}):_vm._e(),(_vm.print)?_c('PdfViewer',{ref:"pdfViewer",staticClass:"d-none",attrs:{"src":'data:application/pdf;base64,' + _vm.print.file,"filename":_vm.print.filename}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarPdf/CarPdf.ts?vue&type=script&lang=ts&external





var CarPdf = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarPdf, _super);
    function CarPdf() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modal = false;
        _this.print = null;
        return _this;
    }
    CarPdf.prototype.mounted = function () {
        interface_vue_.emitter.on('AutomotivePdfGenerated', this.pdfGenerated);
    };
    CarPdf.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('AutomotivePdfGenerated', this.pdfGenerated);
    };
    Object.defineProperty(CarPdf.prototype, "pdfUrl", {
        get: function () {
            return '/sales/' + this.type + '/' + this.document.id + '/automotive-pdf';
        },
        enumerable: false,
        configurable: true
    });
    CarPdf.prototype.pdfGenerated = function (datas) {
        if (datas.type === this.type && datas.id === this.document.id) {
            this.document.automotive_pdf_status = datas.status;
            if (datas.pdf) {
                this.document.automotive_pdf = datas.pdf;
            }
        }
    };
    CarPdf.prototype.fetchFile = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get(this.pdfUrl)
                                .then(function (response) {
                                return response.data;
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CarPdf.prototype.download = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var file;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFile()];
                    case 1:
                        file = _a.sent();
                        this.downloadFile(file.file, file.filename);
                        return [2 /*return*/];
                }
            });
        });
    };
    CarPdf.prototype.send = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.openMailForm({
                    customer: this.document.customer,
                    contact: this.document.contact,
                    mail: {
                        elements: [
                            {
                                id: this.document.id,
                                type: this.type,
                                title: this.$t('sales.' + this.type + '.reference', { reference: this.document.reference }),
                                data: this.document
                            }
                        ],
                        add_files: [
                            this.document.automotive_pdf
                        ]
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    CarPdf.prototype.printPdf = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.fetchFile()];
                    case 1:
                        _a.print = _b.sent();
                        setTimeout(function () {
                            var preview = _this.$refs.pdfViewer;
                            preview.print();
                        }, 100);
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarPdf.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarPdf.prototype, "type", void 0);
    CarPdf = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['openMailForm'])),
            components: {
                BButtonGroup: external_bootstrap_vue_.BButtonGroup, BButton: external_bootstrap_vue_.BButton, BOverlay: external_bootstrap_vue_.BOverlay, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItemButton: external_bootstrap_vue_.BDropdownItemButton, BModal: external_bootstrap_vue_.BModal,
                FilePreview: interface_vue_.FilePreview, PdfViewer: interface_vue_.PdfViewer
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CarPdf);
    return CarPdf;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var CarPdfvue_type_script_lang_ts_external = (CarPdf);

;// ./src/components/CarPdf/CarPdf.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarPdf_CarPdfvue_type_script_lang_ts_external = (CarPdfvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarPdf/CarPdf.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarPdf_CarPdfvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarPdf_CarPdf = (component.exports);

/***/ }),

/***/ 3508:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ 3556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ContractListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractListView.vue?vue&type=template&id=5a5468cd
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContractList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ContractList/ContractList.vue + 3 modules
var ContractList = __webpack_require__(66969);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractListView.vue?vue&type=script&lang=ts



var ContractListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractListView, _super);
    function ContractListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContractListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContractList: ContractList/* default */.A
            }
        })
    ], ContractListView);
    return ContractListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractListViewvue_type_script_lang_ts = (ContractListView);

;// ./src/views/ContractListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContractListViewvue_type_script_lang_ts = (ContractListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/ContractListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContractListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ContractListView = (component.exports);

/***/ }),

/***/ 3568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _fetchDatas_contract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99651);





var ContractMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__extends */ .C6)(ContractMixin, _super);
    function ContractMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.contract = null;
        return _this;
    }
    ContractMixin.prototype.mounted = function () {
        _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.emitter.on('contractUpdated', this.contractUpdated);
    };
    ContractMixin.prototype.destroyed = function () {
        _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.emitter.off('contractUpdated', this.contractUpdated);
    };
    ContractMixin.prototype.contractUpdated = function (contract) {
        this.contract = contract;
    };
    ContractMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_2__.mapState)('app', ['pageParams'])),
            methods: (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_2__.mapActions)('app', ['setPageParams'])),
            components: {
                Spinner: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var id, pageParams;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = to.params.id;
                                if (!id) {
                                    next(function (vm) { return (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__awaiter */ .sH)(_this, void 0, void 0, function () {
                                        var contract;
                                        return (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__generator */ .YH)(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    vm.loading = true;
                                                    if (!vm.pageParams) return [3 /*break*/, 3];
                                                    contract = JSON.parse(JSON.stringify(vm.pageParams));
                                                    vm.setPageParams(null);
                                                    if (!(contract.id && (0,_fetchDatas_contract__WEBPACK_IMPORTED_MODULE_3__/* .needFetchContract */ .Pr)(contract))) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, (0,_fetchDatas_contract__WEBPACK_IMPORTED_MODULE_3__/* .fetchContract */ .RA)(contract.id)];
                                                case 1:
                                                    contract = (_a.sent());
                                                    _a.label = 2;
                                                case 2:
                                                    contract.reference = null;
                                                    contract.id = null;
                                                    vm.contract = contract;
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    vm.contract = null;
                                                    _a.label = 4;
                                                case 4:
                                                    vm.loading = false;
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    return [2 /*return*/];
                                }
                                pageParams = vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD.prototype.$kwSales.store.state.app.pageParams;
                                if (pageParams && !(0,_fetchDatas_contract__WEBPACK_IMPORTED_MODULE_3__/* .needFetchContract */ .Pr)(pageParams)) {
                                    next(function (vm) {
                                        vm.loading = true;
                                        vm.contract = JSON.parse(JSON.stringify(vm.pageParams));
                                        vm.setPageParams(null);
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,_fetchDatas_contract__WEBPACK_IMPORTED_MODULE_3__/* .fetchContract */ .RA)(id)
                                        .then(function (contract) {
                                        next(function (vm) {
                                            vm.contract = contract;
                                            vm.loading = false;
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })
                                        .catch(function (error) {
                                        throw new Error(error);
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var id, contract;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = to.params.id;
                                this.loading = true;
                                this.contract = null;
                                if (!id) {
                                    this.loading = false;
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    contract = JSON.parse(JSON.stringify(this.pageParams));
                                    this.setPageParams(null);
                                    if (!(0,_fetchDatas_contract__WEBPACK_IMPORTED_MODULE_3__/* .needFetchContract */ .Pr)(contract)) {
                                        this.contract = contract;
                                        this.loading = false;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                return [4 /*yield*/, (0,_fetchDatas_contract__WEBPACK_IMPORTED_MODULE_3__/* .fetchContract */ .RA)(to.params.id)
                                        .then(function (contract) {
                                        _this.contract = contract;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], ContractMixin);
    return ContractMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (ContractMixin);


/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(74335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 3653:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'empty-set';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f656';
var svgPathData = 'M507.31 27.31L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0l-72.09 72.09C352.57 48.78 306.31 32 256 32 132.29 32 32 132.29 32 256c0 50.3 16.78 96.57 44.78 133.96l-72.09 72.1c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l72.09-72.09C159.43 463.22 205.7 480 256 480c123.71 0 224-100.29 224-224 0-50.3-16.78-96.57-44.78-133.96l72.09-72.09c6.25-6.26 6.25-16.39 0-22.64zM112 256c0-79.4 64.6-144 144-144 28.11 0 54.16 8.41 76.35 22.39L134.39 332.35C120.41 310.16 112 284.11 112 256zm288 0c0 79.4-64.6 144-144 144-28.11 0-54.16-8.41-76.35-22.39L377.6 179.65C391.59 201.84 400 227.89 400 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Vf = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(89935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3894:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'badge-percent';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f646';
var svgPathData = 'M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-320-96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm12.28 181.65c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63l137.37-137.37c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L204.28 341.65zM320 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.gV = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SepaDepositFormView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SepaDepositFormView.vue?vue&type=template&id=48a8f596
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('Spinner'):_c('SepaDepositForm',{model:{value:(_vm.deposit),callback:function ($$v) {_vm.deposit=$$v},expression:"deposit"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SepaDepositForm/SepaDepositForm.vue + 3 modules
var SepaDepositForm = __webpack_require__(83014);
// EXTERNAL MODULE: ./src/mixins/SepaDepositMixin.ts
var SepaDepositMixin = __webpack_require__(22363);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SepaDepositFormView.vue?vue&type=script&lang=ts




var SepaDepositFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositFormView, _super);
    function SepaDepositFormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SepaDepositFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SepaDepositForm: SepaDepositForm/* default */.A
            }
        })
    ], SepaDepositFormView);
    return SepaDepositFormView;
}((0,lib/* Mixins */.Xe)(SepaDepositMixin/* default */.A)));
/* harmony default export */ var SepaDepositFormViewvue_type_script_lang_ts = (SepaDepositFormView);

;// ./src/views/SepaDepositFormView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SepaDepositFormViewvue_type_script_lang_ts = (SepaDepositFormViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/SepaDepositFormView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_SepaDepositFormViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SepaDepositFormView = (component.exports);

/***/ }),

/***/ 4137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SalesVatRatesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SalesVatRatesView.vue?vue&type=template&id=6089ef4c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SalesVatRates')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SalesVatRates/SalesVatRates.vue?vue&type=template&id=7a27ba59
var SalesVatRatesvue_type_template_id_7a27ba59_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Début"}},[_c('k-form-datepicker',{attrs:{"size":"sm","max-date":_vm.end},model:{value:(_vm.begin),callback:function ($$v) {_vm.begin=$$v},expression:"begin"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Fin"}},[_c('k-form-datepicker',{attrs:{"size":"sm","min-date":_vm.begin},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Groupement"}},[_c('k-form-select',{attrs:{"size":"sm","options":[
              { id: 'month', label: 'Mensuel' },
              { id: 'quarter', label: 'Trimestre' }
            ],"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.group),callback:function ($$v) {_vm.group=$$v},expression:"group"}})],1)],1)],1),_c('b-row',[_vm._l((_vm.results),function(result,i){return _c('b-col',{key:i,staticClass:"mb-4",attrs:{"cols":"12","md":"6","lg":"4"}},[_c('b-card',{attrs:{"body-class":"py-2"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center pb-3",attrs:{"colspan":"2"}},[_vm._v(" "+_vm._s(_vm.period(result.groupKey, result.year))+" ")])])]),_c('tbody',[_c('tr',[_c('td',{staticClass:"w-50"},[_vm._v("Total HT :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(result.ht)))])]),_c('tr',[_c('td',[_vm._v("Total TVA :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(result.tva)))])]),_c('tr',[_c('td',[_vm._v("Total TTC :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(result.ttc)))])])])]),_c('table',{staticClass:"table table-sm table-bordered small text-center"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Taux TVA")]),_c('th',[_vm._v("HT")]),_c('th',[_vm._v("TVA")]),_c('th',[_vm._v("TTC")])])]),_c('tbody',_vm._l((result.rates),function(rate,j){return _c('tr',{key:j},[_c('td',[_vm._v(_vm._s(rate.vat_rate.rate)+" %")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(rate.ht)))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(rate.tva)))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(rate.ttc)))])])}),0)])])],1)}),_c('b-col',{staticClass:"mb-4",attrs:{"cols":"12","md":"6","lg":"4"}},[_c('b-card',{attrs:{"body-class":"py-2"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center pb-3",attrs:{"colspan":"2"}},[_vm._v(" TOTAUX ")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("Total HT :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(_vm.totalHt, 2))))])]),_c('tr',[_c('td',[_vm._v("Total TVA :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(_vm.totalTva, 2))))])]),_c('tr',[_c('td',[_vm._v("Total TTC :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(_vm.totalTtc, 2))))])])])]),_c('table',{staticClass:"table table-sm table-bordered small text-center"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Taux TVA")]),_c('th',[_vm._v("HT")]),_c('th',[_vm._v("TVA")]),_c('th',[_vm._v("TTC")])])]),_c('tbody',_vm._l((_vm.allRates),function(rate,j){return _c('tr',{key:j},[_c('td',[_vm._v(_vm._s(rate.vat_rate.rate)+" %")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(rate.ht, 2))))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(rate.tva, 2))))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(rate.ttc, 2))))])])}),0)])])],1)],2)],1)],1)
}
var SalesVatRatesvue_type_template_id_7a27ba59_staticRenderFns = []


// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SalesVatRates/SalesVatRates.ts?vue&type=script&lang=ts&external







var SalesVatRates = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SalesVatRates, _super);
    function SalesVatRates() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.group = 'month';
        _this.begin = null;
        _this.end = null;
        _this.results = null;
        return _this;
    }
    SalesVatRates.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fetchConfig();
                        if (!this.begin) {
                            this.begin = external_moment_default()().startOf('year').format('YYYY-MM-DD');
                        }
                        if (!this.end) {
                            this.end = external_moment_default()().endOf('year').format('YYYY-MM-DD');
                        }
                        return [4 /*yield*/, this.fetchDatas()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SalesVatRates.prototype, "totalHt", {
        get: function () {
            var _this = this;
            if (!this.results) {
                return 0;
            }
            var total = 0;
            forEach_default()(this.results, function (data) {
                total += _this.number(data.ht);
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesVatRates.prototype, "totalTva", {
        get: function () {
            var _this = this;
            if (!this.results) {
                return 0;
            }
            var total = 0;
            forEach_default()(this.results, function (data) {
                total += _this.number(data.tva);
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesVatRates.prototype, "totalTtc", {
        get: function () {
            var _this = this;
            if (!this.results) {
                return 0;
            }
            var total = 0;
            forEach_default()(this.results, function (data) {
                total += _this.number(data.ttc);
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesVatRates.prototype, "allRates", {
        get: function () {
            var _this = this;
            var rates = [];
            forEach_default()(this.results, function (data) {
                forEach_default()(data.rates, function (rate) {
                    var id = rate.vat_rate_id;
                    if (rates[id] === undefined) {
                        rates[id] = {
                            vat_rate_id: id,
                            vat_rate: rate.vat_rate,
                            ht: 0,
                            tva: 0,
                            ttc: 0
                        };
                    }
                    rates[id].ht += _this.number(rate.ht);
                    rates[id].tva += _this.number(rate.tva);
                    rates[id].ttc += _this.number(rate.ttc);
                });
            });
            return rates.filter(function (rate) { return rate !== null; });
        },
        enumerable: false,
        configurable: true
    });
    SalesVatRates.prototype.watchDatas = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchDatas()];
                    case 1:
                        _a.sent();
                        this.saveConfig();
                        return [2 /*return*/];
                }
            });
        });
    };
    SalesVatRates.prototype.fetchDatas = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/report', {
                                params: {
                                    group: this.group,
                                    begin: this.begin,
                                    end: this.end
                                }
                            })
                                .then(function (response) {
                                _this.results = response.data;
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SalesVatRates.prototype, "period", {
        get: function () {
            var _this = this;
            return function (number, year) {
                if (_this.group === 'month') {
                    return _this.$t('sales.months.' + number) + ' ' + year;
                }
                var date = external_moment_default()().set({
                    quarter: number,
                    year: year
                });
                return 'Du ' + _this.date(date.startOf(_this.group).format('YYYY-MM-DD')) + ' au ' + _this.date(date.endOf(_this.group).format('YYYY-MM-DD'));
            };
        },
        enumerable: false,
        configurable: true
    });
    SalesVatRates.prototype.fetchConfig = function () {
        var storage = window.localStorage.getItem('sales-vatrates');
        var config;
        if (storage) {
            config = JSON.parse(storage);
        }
        if (!config) {
            return;
        }
        if (config.begin) {
            this.begin = config.begin;
        }
        if (config.end) {
            this.end = config.end;
        }
        if (config.group) {
            this.group = config.group;
        }
    };
    SalesVatRates.prototype.saveConfig = function () {
        var config = {};
        if (this.begin) {
            config.begin = this.begin;
        }
        if (this.end) {
            config.end = this.end;
        }
        if (this.group) {
            config.group = this.group;
        }
        window.localStorage.setItem('sales-vatrates', JSON.stringify(config));
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('group'),
        (0,lib/* Watch */.ox)('begin'),
        (0,lib/* Watch */.ox)('end')
    ], SalesVatRates.prototype, "watchDatas", null);
    SalesVatRates = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BTooltip: external_bootstrap_vue_.BTooltip,
                KFormDatepicker: form_vue_.KFormDatepicker, KFormSelect: form_vue_.KFormSelect
            }
        })
    ], SalesVatRates);
    return SalesVatRates;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var SalesVatRatesvue_type_script_lang_ts_external = (SalesVatRates);

;// ./src/components/SalesVatRates/SalesVatRates.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SalesVatRates_SalesVatRatesvue_type_script_lang_ts_external = (SalesVatRatesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SalesVatRates/SalesVatRates.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SalesVatRates_SalesVatRatesvue_type_script_lang_ts_external,
  SalesVatRatesvue_type_template_id_7a27ba59_render,
  SalesVatRatesvue_type_template_id_7a27ba59_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SalesVatRates_SalesVatRates = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SalesVatRatesView.vue?vue&type=script&lang=ts




var SalesVatRatesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SalesVatRatesView, _super);
    function SalesVatRatesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesVatRatesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SalesVatRates: SalesVatRates_SalesVatRates
            }
        })
    ], SalesVatRatesView);
    return SalesVatRatesView;
}((external_vue_default())));
/* harmony default export */ var SalesVatRatesViewvue_type_script_lang_ts = (SalesVatRatesView);

;// ./src/views/SalesVatRatesView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SalesVatRatesViewvue_type_script_lang_ts = (SalesVatRatesViewvue_type_script_lang_ts); 
;// ./src/views/SalesVatRatesView.vue





/* normalize component */
;
var SalesVatRatesView_component = (0,componentNormalizer/* default */.A)(
  views_SalesVatRatesViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SalesVatRatesView = (SalesVatRatesView_component.exports);

/***/ }),

/***/ 4509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(12651);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 4549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractDeadlinesRestore_ContractDeadlinesRestore; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractDeadlinesRestore/ContractDeadlinesRestore.vue?vue&type=template&id=72381f38
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value !== null)?_c('FormModal',{attrs:{"visible":_vm.value !== null,"ok-title":"Restaurer","title":"Restauration d'une échéance"},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[_c('k-form',{attrs:{"action":'/sales/contract/deadline/' + _vm.value.id + '/cancel',"value":{ mode: 'restore' }},on:{"submitComplete":response => _vm.$emit('restored', response.data)}},[_vm._v(" Êtes-vous sûr de vouloir restaurer cette échéance ? ")])],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractDeadlinesRestore/ContractDeadlinesRestore.ts?vue&type=script&lang=ts&external




var ContractDeadlinesRestore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractDeadlinesRestore, _super);
    function ContractDeadlinesRestore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlinesRestore.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlinesRestore.prototype, "contract", void 0);
    ContractDeadlinesRestore = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm,
                FormModal: interface_vue_.FormModal
            }
        })
    ], ContractDeadlinesRestore);
    return ContractDeadlinesRestore;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractDeadlinesRestorevue_type_script_lang_ts_external = (ContractDeadlinesRestore);

;// ./src/components/ContractDeadlinesRestore/ContractDeadlinesRestore.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractDeadlinesRestore_ContractDeadlinesRestorevue_type_script_lang_ts_external = (ContractDeadlinesRestorevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractDeadlinesRestore/ContractDeadlinesRestore.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractDeadlinesRestore_ContractDeadlinesRestorevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDeadlinesRestore_ContractDeadlinesRestore = (component.exports);

/***/ }),

/***/ 4614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28057);
/* harmony import */ var _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19529);
/* harmony import */ var bootstrap_vue__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_PdfModelSelect_PdfModelSelect_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32078);
/* harmony import */ var _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19356);
/* harmony import */ var _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _kwixeo_catalog_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68480);
/* harmony import */ var _kwixeo_catalog_vue__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_catalog_vue__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var vuedraggable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25325);
/* harmony import */ var vuedraggable__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(vuedraggable__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash_sumBy__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31126);
/* harmony import */ var lodash_sumBy__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_sumBy__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_forEach__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39754);
/* harmony import */ var lodash_forEach__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_forEach__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55364);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_11__);













var ContractFormMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_12__/* .__extends */ .C6)(ContractFormMixin, _super);
    function ContractFormMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.durationTypeOptions = [
            { label: 'Jours', value: 1 },
            { label: 'Mois', value: 2 },
            { label: 'Années', value: 3 }
        ];
        _this.renewOptions = [
            { label: 'Automatique', value: true },
            { label: 'Manuel', value: false },
        ];
        _this.frequencyOptions = [
            { label: 'Mensuel', value: 1 },
            { label: 'Trimestrielle', value: 2 },
            { label: 'Semestrielle', value: 3 },
            { label: 'Annuelle', value: 4 },
            { label: 'Autre', value: 0, disabled: true },
            { label: '2 mois', value: 5 },
            { label: '4 mois', value: 6 },
            { label: '5 mois', value: 7 },
            { label: '7 mois', value: 8 },
            { label: '8 mois', value: 9 },
            { label: '9 mois', value: 10 },
            { label: '10 mois', value: 11 },
            { label: '11 mois', value: 12 }
        ];
        _this.contentTypeOptions = [
            { label: 'Au total du contrat (toutes échéances incluses)', value: 1 },
            { label: 'À ce qui doit être facturé à chaque échéance', value: 2 }
        ];
        _this.pricesUpdateOptions = [
            { label: 'À chaque renouvellement (si "utiliser les prix du catalogue" est coché)', value: true },
            { label: 'Jamais', value: false }
        ];
        return _this;
    }
    ContractFormMixin.prototype.mounted = function () {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_12__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
            return (0,tslib__WEBPACK_IMPORTED_MODULE_12__/* .__generator */ .YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContractFormMixin.prototype, "invoiceMomentOptions", {
        get: function () {
            var options = [
                { value: 'begin_period', label: 'au début de la période' },
                { value: 'end_period', label: 'à la fin de la période' },
                { value: 'period_before_day', label: 'le jour précédent la période' },
                { value: 'period_before_business_day', label: 'le premier jour ouvré précédent la période' },
                { value: 'first_day', label: 'le premier jour du mois' },
                { value: 'first_business_day', label: 'le premier jour ouvré du mois' },
                { value: 'last_day', label: 'le dernier jour du mois' },
                { value: 'last_business_day', label: 'le dernier jour ouvré du mois' },
                { value: 'period_after_day', label: 'le premier jour suivant la période' },
                { value: 'period_after_business_day', label: 'le premier jour ouvré suivant la période' }
            ];
            for (var i = 1; i <= 31; i++) {
                options.push({ value: String(i), label: 'le ' + i });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractFormMixin.prototype, "contentForCalculation", {
        get: function () {
            return this.element.contents.filter(function (content) { return !content.is_comment; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractFormMixin.prototype, "totalHt", {
        get: function () {
            return lodash_sumBy__WEBPACK_IMPORTED_MODULE_9___default()(this.contentForCalculation, 'total_ht');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractFormMixin.prototype, "totalTva", {
        get: function () {
            var _this = this;
            var rates = {};
            this.contentForCalculation.forEach(function (content) {
                var _a, _b;
                var rate = (_b = (_a = content.vat_rate) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : 0;
                if (!rates[rate]) {
                    rates[rate] = 0;
                }
                rates[rate] += Number(content.total_ht);
            });
            var total = 0;
            lodash_forEach__WEBPACK_IMPORTED_MODULE_10___default()(rates, function (amount, rate) {
                total += _this.roundNumber(_this.number(amount) * _this.number(rate) / 100, 2);
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractFormMixin.prototype, "totalTtc", {
        get: function () {
            return this.totalHt + this.totalTva;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractFormMixin.prototype, "commentEditorConfig", {
        get: function () {
            var customFields = {
                dynamicVariables: {
                    contracts: {
                        label: 'Contrats',
                        variables: [
                            { value: 'CONTRACT-NUM', label: 'Référence du contrat' },
                            { value: 'CONTRACT-TITLE', label: 'Titre du contrat' },
                            { value: 'CONTRACT-BEGIN', label: 'Date de début de l\'échéance' },
                            { value: 'CONTRACT-END', label: 'Date de fin de l\'échéance' }
                        ]
                    }
                }
            };
            var fields = this.getCustomFields('contract');
            if (fields.length > 0) {
                var variables_1 = [];
                fields.forEach(function (field) {
                    variables_1.push({
                        value: 'CUSTOM-FIELD-' + field.id,
                        label: field.label
                    });
                });
                customFields.dynamicVariables['customFields'] = {
                    label: 'Contrats - Champs personnalisés',
                    variables: variables_1
                };
            }
            return lodash_merge__WEBPACK_IMPORTED_MODULE_11___default()(_kwixeo_catalog_vue__WEBPACK_IMPORTED_MODULE_6__.catalogEditorConfig, customFields, {
                zIndex: 1,
                toolbarButtons: {
                    moreText: {
                        buttonsVisible: 12
                    },
                    moreMisc: {
                        buttonsVisible: 0
                    }
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    ContractFormMixin.prototype.addCatalogLine = function (element) {
        var product = element.data;
        this.element.contents.push({
            catalog: {
                type: element.type,
                id: product.id,
                element: product
            },
            designation: product.designation,
            unit_price_ht: Number(product.unit_price_ht),
            vat_rate: product.vat_rate,
            quantity: Number(product.default_quantity),
            total_ht: 0,
            auto_update_price: false,
            is_comment: false
        });
        this.calculPrices(this.element.contents.length - 1);
    };
    ContractFormMixin.prototype.addCommentLine = function () {
        this.element.contents.push({
            designation: null,
            is_comment: true
        });
    };
    ContractFormMixin.prototype.applyAutoPrice = function (index) {
        var _a, _b;
        var content = this.element.contents[index];
        if (!content) {
            return;
        }
        content.unit_price_ht = Number((_b = (_a = content.catalog) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.unit_price_ht);
        this.calculPrices(index);
    };
    ContractFormMixin.prototype.calculPrices = function (index) {
        var content = this.element.contents[index];
        if (!content) {
            return;
        }
        content.total_ht = this.roundNumber(this.number(content.unit_price_ht) * this.number(content.quantity), 2);
    };
    ContractFormMixin.prototype.setTotalPrice = function (index) {
        var content = this.element.contents[index];
        if (!content) {
            return;
        }
        content.unit_price_ht = this.roundNumber(this.number(content.total_ht) / this.number(content.quantity), 2);
        this.calculPrices(index);
    };
    ContractFormMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_12__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            components: {
                PageHeader: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.PageHeader, PaymentTermSelect: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.PaymentTermSelect, PaymentMethodSelect: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.PaymentMethodSelect, VatRateSelect: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.VatRateSelect, Spinner: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.Spinner, AppMessages: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.AppMessages,
                KForm: _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__.KForm, KFormSelect: _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__.KFormSelect, KFormInput: _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__.KFormInput, KFormSpinner: _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__.KFormSpinner, KFormCheckbox: _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__.KFormCheckbox, KFormStickyBar: _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__.KFormStickyBar, KFormNumber: _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__.KFormNumber, KFormEditor: _kwixeo_form_vue__WEBPACK_IMPORTED_MODULE_2__.KFormEditor,
                BFormGroup: bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__.BFormGroup, BInputGroup: bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__.BInputGroup, BRow: bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__.BRow, BCol: bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__.BCol, BTabs: bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__.BTabs, BTab: bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__.BTab, BButton: bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__.BButton,
                PdfModelSelect: _components_PdfModelSelect_PdfModelSelect_vue__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
                FontAwesomeIcon: _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_5__.FontAwesomeIcon,
                CatalogSearch: _kwixeo_catalog_vue__WEBPACK_IMPORTED_MODULE_6__.CatalogSearch,
                draggable: (vuedraggable__WEBPACK_IMPORTED_MODULE_7___default())
            },
            methods: (0,tslib__WEBPACK_IMPORTED_MODULE_12__/* .__assign */ .Cl)((0,tslib__WEBPACK_IMPORTED_MODULE_12__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_8__.mapActions)('customFields', ['loadCustomFields'])), (0,vuex__WEBPACK_IMPORTED_MODULE_8__.mapActions)('globalDatas', ['loadVatRates'])),
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_12__/* .__assign */ .Cl)((0,tslib__WEBPACK_IMPORTED_MODULE_12__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_8__.mapGetters)('user', ['currency'])), (0,vuex__WEBPACK_IMPORTED_MODULE_8__.mapGetters)('customFields', ['getCustomFields'])),
            directives: {
                'b-tooltip': bootstrap_vue__WEBPACK_IMPORTED_MODULE_3__.VBTooltip
            }
        })
    ], ContractFormMixin);
    return ContractFormMixin;
}((0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Mixins */ .Xe)(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.NumberMixin)));
/* harmony default export */ __webpack_exports__.A = (ContractFormMixin);


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(79770),
    stubArray = __webpack_require__(63345);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72552),
    isLength = __webpack_require__(30294),
    isObjectLike = __webpack_require__(40346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AccountSelect_AccountSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountSelect/AccountSelect.vue?vue&type=template&id=794ec836
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-input-group',[_c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.filteredAccounts},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}},'k-form-select',_vm.attributes,false),_vm.$listeners)),(_vm.withForm)?_c('b-input-group-append',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"px-1",attrs:{"title":_vm.buttonTitle,"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[(!_vm.account)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}):_c('font-awesome-icon',{attrs:{"icon":['fas', 'pencil']}})],1)],1):_vm._e(),_c('FormModal',{attrs:{"title":_vm.buttonTitle},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('AccountForm',{on:{"submitComplete":_vm.submitComplete},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/AccountForm/AccountForm.vue + 3 modules
var AccountForm = __webpack_require__(82183);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AccountSelect/AccountSelect.ts?vue&type=script&lang=ts&external








var AccountSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AccountSelect, _super);
    function AccountSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.account = null;
        _this.modalState = false;
        return _this;
    }
    AccountSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadAccounts()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== false && !this.value && this.defaultAccount) {
                            this.$emit('input', this.defaultAccount);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AccountSelect.prototype, "filteredAccounts", {
        get: function () {
            var accounts = this.accounts.filter(function (account) { return account.status.active; });
            if (this.filters) {
                return accounts.filter(this.filters);
            }
            return accounts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                label: 'name',
                value: this.value
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountSelect.prototype, "buttonTitle", {
        get: function () {
            return this.$t('sales.account.' + (!this.account ? 'new' : 'edit'));
        },
        enumerable: false,
        configurable: true
    });
    AccountSelect.prototype.watchValue = function (value) {
        this.account = value ? JSON.parse(JSON.stringify(value)) : null;
    };
    AccountSelect.prototype.onChange = function () {
        return this.account;
    };
    AccountSelect.prototype.submitComplete = function (response) {
        var account = response.data;
        this.account = account;
        this.setAccount(account);
        this.onChange();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AccountSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], AccountSelect.prototype, "withForm", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AccountSelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AccountSelect.prototype, "filters", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], AccountSelect.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], AccountSelect.prototype, "onChange", null);
    AccountSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadAccounts', 'setAccount'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('sales', ['accounts'])), (0,external_vuex_.mapGetters)('sales', ['defaultAccount'])),
            components: {
                AccountForm: AccountForm/* default */.A,
                FormModal: interface_vue_.FormModal,
                KFormSelect: form_vue_.KFormSelect,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BButton: external_bootstrap_vue_.BButton
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], AccountSelect);
    return AccountSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var AccountSelectvue_type_script_lang_ts_external = (AccountSelect);

;// ./src/components/AccountSelect/AccountSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AccountSelect_AccountSelectvue_type_script_lang_ts_external = (AccountSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/AccountSelect/AccountSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AccountSelect_AccountSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccountSelect_AccountSelect = (component.exports);

/***/ }),

/***/ 5569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarSelect_CarSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarSelect/CarSelect.vue?vue&type=template&id=f8438402
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b-form-group',{attrs:{"label":_vm.computedLabel,"label-size":_vm.labelSize}},[_c('b-input-group',[_c('k-form-select',{ref:"select",attrs:{"ajax":_vm.apiUrl,"getOptionLabel":_vm.optionLabel,"required":_vm.required !== false,"disabled":_vm.disabled !== false,"clearable":_vm.clearable,"validationName":_vm.validationName,"size":_vm.size,"searchable":""},on:{"input":_vm.onChange},model:{value:(_vm.car),callback:function ($$v) {_vm.car=$$v},expression:"car"}}),(_vm.withForm)?_c('b-input-group-append',[_c('CarFormButton',{attrs:{"customer":_vm.customer,"disabled":_vm.disabled !== false,"variant":"primary","size":"sm"},on:{"submitComplete":_vm.submitComplete},model:{value:(_vm.car),callback:function ($$v) {_vm.car=$$v},expression:"car"}})],1):_vm._e()],1)],1)],1),_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-group',{attrs:{"label":"Kilométrage"}},[_c('b-input-group',{attrs:{"append":"km"}},[_c('k-form-number',{attrs:{"name":"mileage","maxDecimals":0,"min":0,"noDefaultValue":"","disabled":!_vm.car,"required":_vm.teamConfigs.automotive_mileage_required},model:{value:(_vm.localMileage),callback:function ($$v) {_vm.localMileage=$$v},expression:"localMileage"}})],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/components/CarFormButton/CarFormButton.vue + 3 modules
var CarFormButton = __webpack_require__(40930);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarSelect/CarSelect.ts?vue&type=script&lang=ts&external






var CarSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarSelect, _super);
    function CarSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.car = null;
        _this.localMileage = null;
        return _this;
    }
    CarSelect.prototype.mounted = function () {
        this.localMileage = this.mileage;
    };
    Object.defineProperty(CarSelect.prototype, "apiUrl", {
        get: function () {
            var url = '/automotive/car?sort=brand.name,model.name&include=brand,model';
            if (this.customer) {
                url += '&filter[customer]=' + this.customer.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarSelect.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : 'Véhicule';
        },
        enumerable: false,
        configurable: true
    });
    CarSelect.prototype.optionLabel = function (car) {
        var _a, _b;
        var label = '';
        if ((_a = car.brand) === null || _a === void 0 ? void 0 : _a.name) {
            label += car.brand.name;
        }
        if ((_b = car.model) === null || _b === void 0 ? void 0 : _b.name) {
            if (label !== '')
                label += ' ';
            label += car.model.name;
        }
        if (label !== '') {
            label += ' - ';
        }
        return label + car.numberplate;
    };
    CarSelect.prototype.watchValue = function (value) {
        if (value === null) {
            this.car = null;
        }
        else {
            this.car = JSON.parse(JSON.stringify(this.value));
        }
    };
    CarSelect.prototype.onChange = function () {
        var _a, _b;
        this.localMileage = (_b = (_a = this.car) === null || _a === void 0 ? void 0 : _a.mileage) !== null && _b !== void 0 ? _b : null;
        return this.car;
    };
    CarSelect.prototype.submitComplete = function (car) {
        this.car = car;
        var select = this.$refs.select;
        select.updateOption(car);
        this.onChange();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSelect.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSelect.prototype, "mileage", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CarSelect.prototype, "withForm", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSelect.prototype, "validationName", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CarSelect.prototype, "required", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CarSelect.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CarSelect.prototype, "clearable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSelect.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSelect.prototype, "labelSize", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSelect.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CarSelect.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], CarSelect.prototype, "onChange", null);
    CarSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs'])),
            components: {
                BButton: external_bootstrap_vue_.BButton,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol,
                KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber,
                CarFormButton: CarFormButton/* default */.A
            }
        })
    ], CarSelect);
    return CarSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var CarSelectvue_type_script_lang_ts_external = (CarSelect);

;// ./src/components/CarSelect/CarSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarSelect_CarSelectvue_type_script_lang_ts_external = (CarSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarSelect/CarSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarSelect_CarSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarSelect_CarSelect = (component.exports);

/***/ }),

/***/ 5644:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'file-pdf';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c1';
var svgPathData = 'M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.O_ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ 5861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(55580),
    Map = __webpack_require__(68223),
    Promise = __webpack_require__(32804),
    Set = __webpack_require__(76545),
    WeakMap = __webpack_require__(28303),
    baseGetTag = __webpack_require__(72552),
    toSource = __webpack_require__(47473);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 6181:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Kurdish [ku-kmr]
//! authors : Mazlum Özdogan : https://github.com/mergehez

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(num, withoutSuffix, key, isFuture) {
        var format = {
            s: ['çend sanîye', 'çend sanîyeyan'],
            ss: [num + ' sanîye', num + ' sanîyeyan'],
            m: ['deqîqeyek', 'deqîqeyekê'],
            mm: [num + ' deqîqe', num + ' deqîqeyan'],
            h: ['saetek', 'saetekê'],
            hh: [num + ' saet', num + ' saetan'],
            d: ['rojek', 'rojekê'],
            dd: [num + ' roj', num + ' rojan'],
            w: ['hefteyek', 'hefteyekê'],
            ww: [num + ' hefte', num + ' hefteyan'],
            M: ['mehek', 'mehekê'],
            MM: [num + ' meh', num + ' mehan'],
            y: ['salek', 'salekê'],
            yy: [num + ' sal', num + ' salan'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = '' + num;
        var l = num.substring(num.length - 1),
            ll = num.length > 1 ? num.substring(num.length - 2) : '';
        if (
            !(ll == 12 || ll == 13) &&
            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
        )
            return 'yê';
        return 'ê';
    }

    var kuKmr = moment.defineLocale('ku-kmr', {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
            '_'
        ),
        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
        monthsParseExact: true,
        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'bn' : 'BN';
            } else {
                return isLower ? 'pn' : 'PN';
            }
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[a] YYYY[an]',
            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
            ll: 'Do MMM[.] YYYY[an]',
            lll: 'Do MMM[.] YYYY[an] HH:mm',
            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
        },
        calendar: {
            sameDay: '[Îro di saet] LT [de]',
            nextDay: '[Sibê di saet] LT [de]',
            nextWeek: 'dddd [di saet] LT [de]',
            lastDay: '[Duh di saet] LT [de]',
            lastWeek: 'dddd[a borî di saet] LT [de]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'di %s de',
            past: 'berî %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function (num, period) {
            var p = period.toLowerCase();
            if (p.includes('w') || p.includes('m')) return num + '.';

            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return kuKmr;

})));


/***/ }),

/***/ 6243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DL: function() { return /* binding */ documentRelations; },
/* harmony export */   sW: function() { return /* binding */ fetchDocument; },
/* harmony export */   yt: function() { return /* binding */ needFetchDocument; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var documentRelations = function (type) {
    var includes = [
        'pdf_model', 'customer', 'customer.addresses', 'customer_child', 'contact', 'billing_contact', 'billing_address_country', 'delivery_address_country',
        'currency', 'vat_rate', 'secondary_unit', 'grant', 'teamUser', 'sale_term',
        'contents', 'contents.vat_rate', 'contents.unit', 'contents.variation', 'contents.secondary_unit',
        'contents.sale_category', 'contents.picture',
        'vatrates.vat_rate', 'linked_elements', 'contents.catalog', 'customFields', 'pdf', 'payment_methods', 'tags',
        'used_lots', 'opportunities', 'provider_commands', 'constructions', 'oldVersions', 'car',
    ];
    includes.push(type === 'invoice' || type === 'credit' ? 'affairs' : 'affair');
    switch (type) {
        case 'credit':
            includes.push('uses');
            break;
        case 'invoice':
            includes.push('credits_uses');
            break;
        case 'delivery':
            includes.push('stock_location');
            break;
        case 'quotation':
            includes.push('contract', 'automotivePdf');
            break;
        case 'command':
            includes.push('automotivePdf');
            break;
    }
    if (type !== 'credit') {
        includes.push('payment_term');
    }
    if (type !== 'credit' && type !== 'invoice') {
        includes.push('signatures');
    }
    return includes;
};
var needFetchDocument = function (type, document) {
    return !documentRelations(type).every(function (relation) { return relation in document; });
};
var fetchDocument = function (type, id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/sales/' + type + '/' + id, {
                    params: {
                        include: documentRelations(type).join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 6705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_RecoveryInvoicesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/RecoveryInvoicesView.vue?vue&type=template&id=4e452058
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RecoveryInvoices')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/RecoveryInvoicesView/RecoveryInvoicesView.vue + 3 modules
var RecoveryInvoicesView_RecoveryInvoicesView = __webpack_require__(84777);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/RecoveryInvoicesView.vue?vue&type=script&lang=ts



var RecoveryInvoicesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(RecoveryInvoicesView, _super);
    function RecoveryInvoicesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecoveryInvoicesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                RecoveryInvoices: RecoveryInvoicesView_RecoveryInvoicesView/* default */.A
            }
        })
    ], RecoveryInvoicesView);
    return RecoveryInvoicesView;
}(lib/* Vue */.lD));
/* harmony default export */ var RecoveryInvoicesViewvue_type_script_lang_ts = (RecoveryInvoicesView);

;// ./src/views/RecoveryInvoicesView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_RecoveryInvoicesViewvue_type_script_lang_ts = (RecoveryInvoicesViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/RecoveryInvoicesView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_RecoveryInvoicesViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_RecoveryInvoicesView = (component.exports);

/***/ }),

/***/ 6762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ GrantForm_GrantForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/GrantForm/GrantForm.vue?vue&type=template&id=703d0c5c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.grant.label')}},[_c('k-form-input',{attrs:{"name":"label","required":""},model:{value:(_vm.grant.label),callback:function ($$v) {_vm.$set(_vm.grant, "label", $$v)},expression:"grant.label"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.grant.pdfMentions'),"description":_vm.$t('sales.grant.pdfMentionsExplain')}},[_c('k-form-input',{attrs:{"name":"pdf_mentions","required":""},model:{value:(_vm.grant.pdf_mentions),callback:function ($$v) {_vm.$set(_vm.grant, "pdf_mentions", $$v)},expression:"grant.pdf_mentions"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.grant.type')}},[_c('k-form-select',{attrs:{"name":"type","options":_vm.grantTypes,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.grant.type),callback:function ($$v) {_vm.$set(_vm.grant, "type", $$v)},expression:"grant.type"}})],1),(_vm.grant.type === 'pourcent')?_c('b-form-group',{staticClass:"mt-3",attrs:{"label":_vm.$t('sales.grant.pourcent')}},[_c('b-input-group',{attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"pourcent","required":""},model:{value:(_vm.grant.pourcent),callback:function ($$v) {_vm.$set(_vm.grant, "pourcent", $$v)},expression:"grant.pourcent"}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/GrantForm/GrantForm.ts?vue&type=script&lang=ts&external




var GrantForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GrantForm, _super);
    function GrantForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.grant = {
            type: 'pourcent'
        };
        _this.grantTypes = [
            { value: 'pourcent', label: _this.$t('sales.grant.typePourcent') },
            { value: 'amount', label: _this.$t('sales.grant.typeAmount') }
        ];
        return _this;
    }
    Object.defineProperty(GrantForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/sales/grant';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GrantForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    GrantForm.prototype.watchValue = function (value) {
        this.grant = value ? JSON.parse(JSON.stringify(value)) : {
            type: 'pourcent'
        };
    };
    GrantForm.prototype.formSubmitted = function (response) {
        return response;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], GrantForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], GrantForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], GrantForm.prototype, "formSubmitted", null);
    GrantForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup
            }
        })
    ], GrantForm);
    return GrantForm;
}(lib/* Vue */.lD));
/* harmony default export */ var GrantFormvue_type_script_lang_ts_external = (GrantForm);

;// ./src/components/GrantForm/GrantForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var GrantForm_GrantFormvue_type_script_lang_ts_external = (GrantFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/GrantForm/GrantForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  GrantForm_GrantFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GrantForm_GrantForm = (component.exports);

/***/ }),

/***/ 6924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(85250),
    createAssigner = __webpack_require__(20999);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ 6947:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Palestine) [ar-ps]
//! author : Majd Al-Shihabi : https://github.com/majdal

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arPs = moment.defineLocale('ar-ps', {
        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
            '_'
        ),
        monthsShort:
            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .split('') // reversed since negative lookbehind not supported everywhere
                .reverse()
                .join('')
                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
                    return numberMap[match];
                })
                .split('')
                .reverse()
                .join('')
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arPs;

})));


/***/ }),

/***/ 7070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_PdfModelListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PdfModelListView.vue?vue&type=template&id=5b3fb4f2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PdfModelList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/PdfModelList/PdfModelList.vue + 3 modules
var PdfModelList = __webpack_require__(50257);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PdfModelListView.vue?vue&type=script&lang=ts



var PdfModelListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelListView, _super);
    function PdfModelListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PdfModelListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PdfModelList: PdfModelList/* default */.A
            }
        })
    ], PdfModelListView);
    return PdfModelListView;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelListViewvue_type_script_lang_ts = (PdfModelListView);

;// ./src/views/PdfModelListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_PdfModelListViewvue_type_script_lang_ts = (PdfModelListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/PdfModelListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_PdfModelListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_PdfModelListView = (component.exports);

/***/ }),

/***/ 7143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleLine_SaleLine; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/SaleLine/SaleLine.vue?vue&type=template&id=2074c036
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{class:{
    'editing-active': _vm.editing
  },on:{"click":_vm.setLocationEditing}},[(_vm.loadingPrice)?_c('td',{attrs:{"colspan":_vm.colspanLoadingPrice}},[_c('Spinner')],1):[_c('td',{staticClass:"text-center"},[(_vm.document.contents.length > 1)?_c('font-awesome-icon',{ref:"moveBtn",staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e(),(_vm.value.catalog && _vm.value.catalog.element && _vm.value.catalog?.type === 'product' && !_vm.value.catalog.element.is_group)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"line-type-indicator",attrs:{"title":"Produit"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'box-full']}})],1):(_vm.value.catalog?.type === 'service')?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",modifiers:{"right":true}}],staticClass:"line-type-indicator",attrs:{"title":"Prestation"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'user']}})],1):(_vm.value.catalog && _vm.value.catalog.element && _vm.value.catalog?.type === 'product' && _vm.value.catalog.element.is_group)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"line-type-indicator line-indicator-group",attrs:{"title":"Groupe"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'sitemap']}})],1):(!_vm.value.catalog)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"line-type-indicator",attrs:{"title":"Ligne vide"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'empty-set']}})],1):_vm._e()],1),(_vm.document.input_options.col_number)?_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.lineNumber)+" ")]):_vm._e(),(_vm.document.input_options.col_picture)?_c('td',[(_vm.value.catalog && _vm.value.catalog.element)?[_c('b-button',{staticClass:"sales-picture-selector p-0 w-100",attrs:{"variant":"icon"},on:{"click":function($event){$event.preventDefault();_vm.picturesModal = true}}},[(_vm.value.picture)?_c('img',{staticClass:"w-100",attrs:{"src":'data:image/' + _vm.value.picture.extension + ';base64,' + _vm.value.picture.thumbnail,"alt":""}}):_c('font-awesome-icon',{attrs:{"icon":['far', 'image']}})],1),(_vm.value.picture)?_c('b-button',{staticClass:"p-0 mt-1 text-center w-100",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.value.picture = null}}},[_vm._v(" Supprimer ")]):_vm._e(),_c('b-modal',{attrs:{"size":"xl"},model:{value:(_vm.picturesModal),callback:function ($$v) {_vm.picturesModal=$$v},expression:"picturesModal"}},[_c('CatalogPictures',{attrs:{"id":_vm.value.catalog.id,"type":_vm.value.catalog.type,"defaultPicture":_vm.value.catalog.element.default_picture_id,"withSelection":_vm.selectPicture},on:{"productUpdated":product => _vm.value.catalog.element = product}})],1),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('picture')},domProps:{"value":_vm.value.picture ? _vm.value.picture.id : null}})]:_vm._e()],2):_vm._e(),(_vm.document.input_options.col_reference)?_c('td',[(!_vm.editing)?_c('span',[_vm._v(" "+_vm._s(_vm.value.reference)+" ")]):_c('k-form-input',{attrs:{"validationName":_vm.getInputName('reference'),"size":"sm","disabled":_vm.contentIsDisabled},model:{value:(_vm.value.reference),callback:function ($$v) {_vm.$set(_vm.value, "reference", $$v)},expression:"value.reference"}}),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('reference')},domProps:{"value":_vm.value.reference}})],1):_vm._e(),_c('td',{staticClass:"text-wrap"},[(_vm.hasModule('catalog-variations') && _vm.value.catalog && _vm.value.catalog.element && _vm.value.catalog.element.variations_length > 0)?_c('ProductVariationSelect',{attrs:{"product":_vm.value.catalog.element},on:{"selected":_vm.variationSelected,"unselected":_vm.variationUnselected},model:{value:(_vm.value.variation),callback:function ($$v) {_vm.$set(_vm.value, "variation", $$v)},expression:"value.variation"}}):_vm._e(),(!_vm.editing)?_c('FroalaView',{attrs:{"value":_vm.value.designation ?? null}}):[_c('k-form-editor',{ref:"editor",attrs:{"validationName":_vm.getInputName('designation'),"size":"sm","required":"","config":_vm.editorConfig},model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}}),_c('b-form-row',{staticClass:"sub-description-input"},[(!_vm.withWorkout)?_c('b-col'):_vm._e(),(_vm.withCosts)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.buyPrice'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('catalog_costs_u'),"size":"sm","max-decimal":5},on:{"input":_vm.calculateCosts},model:{value:(_vm.value.catalog_costs_u),callback:function ($$v) {_vm.$set(_vm.value, "catalog_costs_u", $$v)},expression:"value.catalog_costs_u"}})],1)],1)],1):_vm._e(),(_vm.withCosts && _vm.document.input_options.various_costs)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.variousCosts'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('various_costs_u'),"size":"sm","max-decimal":5},on:{"input":_vm.calculateCosts},model:{value:(_vm.value.various_costs_u),callback:function ($$v) {_vm.$set(_vm.value, "various_costs_u", $$v)},expression:"value.various_costs_u"}})],1)],1)],1):_vm._e(),(_vm.withCosts && _vm.document.input_options.various_costs)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.totalBuy'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":"","max-decimal":5},model:{value:(_vm.value.total_costs_u),callback:function ($$v) {_vm.$set(_vm.value, "total_costs_u", $$v)},expression:"value.total_costs_u"}})],1)],1)],1):_vm._e(),(_vm.withCosts && _vm.document.input_options.workforce_entries)?_c('b-col'):_vm._e(),(_vm.withCosts && _vm.withWorkout)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.totalCharge'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":"","max-decimal":5},model:{value:(_vm.value.total_charge_u),callback:function ($$v) {_vm.$set(_vm.value, "total_charge_u", $$v)},expression:"value.total_charge_u"}})],1)],1)],1):_vm._e(),((_vm.withCosts || _vm.withWorkoutCosts) && _vm.document.input_options.gross_margin_amount)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.marginAmount'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","max-decimal":5},on:{"change":_vm.updateGrossMarginAmount},model:{value:(_vm.value.gross_margin_amount_u),callback:function ($$v) {_vm.$set(_vm.value, "gross_margin_amount_u", $$v)},expression:"value.gross_margin_amount_u"}})],1)],1)],1):_vm._e(),((_vm.withCosts || _vm.withWorkoutCosts) && _vm.document.input_options.gross_margin_rate)?_c('b-col',{staticClass:"not-input-width",attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",staticStyle:{"min-width":"85px","max-width":"93px"},attrs:{"label":_vm.$t('sales.form.lines.marginRate'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm"},on:{"change":_vm.updateGrossMarginRate},model:{value:(_vm.value.gross_margin_rate),callback:function ($$v) {_vm.$set(_vm.value, "gross_margin_rate", $$v)},expression:"value.gross_margin_rate"}})],1)],1)],1):_vm._e(),((_vm.withCosts || _vm.withWorkoutCosts) && _vm.document.input_options.markup_rate)?_c('b-col',{staticClass:"not-input-width",attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",staticStyle:{"min-width":"85px","max-width":"93px"},attrs:{"label":_vm.$t('sales.form.lines.markupRate'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm"},on:{"change":_vm.updateMarkupRate},model:{value:(_vm.value.markup_rate),callback:function ($$v) {_vm.$set(_vm.value, "markup_rate", $$v)},expression:"value.markup_rate"}})],1)],1)],1):_vm._e(),_c('b-col',{staticClass:"pt-2",attrs:{"cols":"12"}}),(_vm.withWorkout)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.duration'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"50px"},attrs:{"validationName":_vm.getInputName('duration'),"min":0,"size":"sm"},on:{"input":_vm.calculateCosts},model:{value:(_vm.value.duration),callback:function ($$v) {_vm.$set(_vm.value, "duration", $$v)},expression:"value.duration"}}),_c('b-input-group-append',[_c('k-form-select',{staticClass:"document-small-select",staticStyle:{"width":"70px"},attrs:{"validationName":_vm.getInputName('duration_type'),"options":[
                    { id: 'minute', label: _vm.$t('sales.form.lines.durationMinute') },
                    { id: 'hour', label: _vm.$t('sales.form.lines.durationHour') },
                  ],"reduce":opt => opt.id,"clearable":false,"value":"Mn","size":"sm"},on:{"input":_vm.calculateCosts},model:{value:(_vm.value.duration_type),callback:function ($$v) {_vm.$set(_vm.value, "duration_type", $$v)},expression:"value.duration_type"}})],1)],1)],1)],1):_vm._e(),(_vm.withWorkout)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.technicalNumber'),"label-size":"sm"}},[_c('k-form-spinner',{attrs:{"validationName":_vm.getInputName('number_people_needed'),"min":0,"size":"sm"},on:{"input":_vm.calculateCosts},model:{value:(_vm.value.number_people_needed),callback:function ($$v) {_vm.$set(_vm.value, "number_people_needed", $$v)},expression:"value.number_people_needed"}})],1)],1):_vm._e(),(_vm.withWorkoutCosts)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.hourlyCosts'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('hourly_person_cost'),"size":"sm","min":0,"max-decimal":5},on:{"input":_vm.calculateCosts},model:{value:(_vm.value.hourly_person_cost),callback:function ($$v) {_vm.$set(_vm.value, "hourly_person_cost", $$v)},expression:"value.hourly_person_cost"}})],1)],1)],1):_vm._e(),(_vm.withWorkoutCosts)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.workoutCosts'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":"","max-decimal":5},model:{value:(_vm.value.workforce_costs_u),callback:function ($$v) {_vm.$set(_vm.value, "workforce_costs_u", $$v)},expression:"value.workforce_costs_u"}})],1)],1)],1):_vm._e(),_c('b-col'),(_vm.withEan)?_c('b-col',{staticClass:"not-input-width",staticStyle:{"width":"100%","max-width":"150px"},attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.eanCode'),"label-size":"sm"}},[_c('k-form-input',{staticStyle:{"width":"100% !important"},attrs:{"validationName":_vm.getInputName('ean_code'),"size":"sm"},model:{value:(_vm.value.ean_code),callback:function ($$v) {_vm.$set(_vm.value, "ean_code", $$v)},expression:"value.ean_code"}})],1)],1):_vm._e(),(_vm.withWeight)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.weight'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"kg","size":"sm"}},[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('weight_unit'),"size":"sm"},model:{value:(_vm.value.weight_unit),callback:function ($$v) {_vm.$set(_vm.value, "weight_unit", $$v)},expression:"value.weight_unit"}})],1)],1)],1):_vm._e()],1)],_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('designation')},domProps:{"value":_vm.value.designation}}),(_vm.withCosts)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('catalog_costs_u')},domProps:{"value":_vm.value.catalog_costs_u}}):_vm._e(),(_vm.withCosts && _vm.document.input_options.various_costs)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('various_costs_u')},domProps:{"value":_vm.value.various_costs_u}}):_vm._e(),(_vm.withWorkout)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('duration')},domProps:{"value":_vm.value.duration}}):_vm._e(),(_vm.withWorkout)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('duration_type')},domProps:{"value":_vm.value.duration_type}}):_vm._e(),(_vm.withWorkout)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('number_people_needed')},domProps:{"value":_vm.value.number_people_needed}}):_vm._e(),(_vm.withWorkoutCosts)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('hourly_person_cost')},domProps:{"value":_vm.value.hourly_person_cost}}):_vm._e(),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('ean_code')},domProps:{"value":_vm.value.ean_code}}),(_vm.withWeight)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('weight_unit')},domProps:{"value":_vm.value.weight_unit}}):_vm._e(),(_vm.teamConfigs.sales_private_comments)?_c('b-form-group',{attrs:{"label":"Notes interne"}},[_c('k-form-textarea',{attrs:{"name":_vm.getInputName('comments')},model:{value:(_vm.value.comments),callback:function ($$v) {_vm.$set(_vm.value, "comments", $$v)},expression:"value.comments"}})],1):_vm._e(),(_vm.hasProductLotSelection)?[(_vm.value.quantity > 0)?_c('LotSelected',{staticClass:"mt-3",attrs:{"product":_vm.value.catalog?.element,"usedLots":_vm.value.used_lots,"autoSelect":_vm.teamConfigs.stock_tracabilities_auto_select},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),(!_vm.value.used_lots || _vm.value.used_lots.length === 0)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('use_lots')},domProps:{"value":null}}):_vm._e(),_vm._l((_vm.value.used_lots),function(lot,index){return [_c('input',{key:'id-' + index,attrs:{"type":"hidden","name":_vm.getInputName('use_lots') + '[' + index + '][lot]'},domProps:{"value":lot.lot.id}}),_c('input',{key:'quantity-' + index,attrs:{"type":"hidden","name":_vm.getInputName('use_lots') + '[' + index + '][quantity]'},domProps:{"value":lot.quantity}})]})]:_vm._e()],2),_c('td',{staticClass:"text-center"},[(!_vm.editing)?[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.discount_value))+" "+_vm._s(_vm.value.discount_type === 'pourcent' ? '%' : _vm.currency.symbol)+" ")]:[_c('b-input-group',[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('discount_value'),"size":"sm","min":0},on:{"change":_vm.calculPrices},model:{value:(_vm.value.discount_value),callback:function ($$v) {_vm.$set(_vm.value, "discount_value", $$v)},expression:"value.discount_value"}}),_c('b-input-group-append',[_c('k-form-select',{attrs:{"validationName":_vm.getInputName('discount_type'),"reduce":opt => opt.id,"options":[
                        { id: 'pourcent', label: '%' },
                        { id: 'amount', label: _vm.currency.symbol }
                      ],"clearable":false,"size":"sm"},on:{"input":_vm.calculPrices},model:{value:(_vm.value.discount_type),callback:function ($$v) {_vm.$set(_vm.value, "discount_type", $$v)},expression:"value.discount_type"}})],1)],1)],_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('discount_value')},domProps:{"value":_vm.value.discount_value}}),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('discount_type')},domProps:{"value":_vm.value.discount_type}})],2),(_vm.document.input_mode === 'ht')?_c('td',{staticClass:"text-right"},[(!_vm.editing)?[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.unit_price_ht))+" ")]:[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('unit_price_ht'),"size":"sm","max-decimal":5,"disabled":_vm.contentIsDisabled},on:{"change":_vm.calculHtPrices},model:{value:(_vm.value.unit_price_ht),callback:function ($$v) {_vm.$set(_vm.value, "unit_price_ht", $$v)},expression:"value.unit_price_ht"}})],1),(_vm.withEcotaxe)?_c('b-form-group',{staticClass:"mt-2",attrs:{"label":_vm.$t('sales.form.lines.ecoPart'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol + ' ht',"size":"sm"}},[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('ecotax_u_ht'),"size":"sm","disabled":_vm.contentIsDisabled},on:{"change":_vm.calculHtPrices},model:{value:(_vm.value.ecotax_u_ht),callback:function ($$v) {_vm.$set(_vm.value, "ecotax_u_ht", $$v)},expression:"value.ecotax_u_ht"}})],1)],1):(_vm.value.ecotax_u_ht > 0)?_c('p',{staticClass:"text-center small mt-2"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.lines.ecoPart'))),_c('br'),_vm._v(" "+_vm._s(_vm.value.ecotax_u_ht)+" "+_vm._s(_vm.currency.symbol)+" "+_vm._s(_vm.$t('sales.form.lines.ht'))+" ")]):_vm._e()],_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('unit_price_ht')},domProps:{"value":_vm.value.unit_price_ht}}),(_vm.withEcotaxe)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('ecotax_u_ht')},domProps:{"value":_vm.value.ecotax_u_ht}}):_vm._e()],2):(_vm.document.input_mode === 'ttc')?_c('td',{staticClass:"text-right"},[(!_vm.editing)?[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.unit_price_ttc))+" ")]:[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('unit_price_ttc'),"size":"sm","max-decimal":5,"disabled":_vm.contentIsDisabled},on:{"change":_vm.calculTtcPrices},model:{value:(_vm.value.unit_price_ttc),callback:function ($$v) {_vm.$set(_vm.value, "unit_price_ttc", $$v)},expression:"value.unit_price_ttc"}})],1),(_vm.withEcotaxe)?_c('b-form-group',{staticClass:"mt-2",attrs:{"label":_vm.$t('sales.form.lines.ecoPart'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol + ' ttc',"size":"sm"}},[_c('k-form-number',{attrs:{"validationName":_vm.getInputName('ecotax_u_ttc'),"size":"sm","disabled":_vm.contentIsDisabled},on:{"change":_vm.calculTtcPrices},model:{value:(_vm.value.ecotax_u_ttc),callback:function ($$v) {_vm.$set(_vm.value, "ecotax_u_ttc", $$v)},expression:"value.ecotax_u_ttc"}})],1)],1):(_vm.value.ecotax_u_ttc > 0)?_c('p',{staticClass:"text-center small mt-2"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.lines.ecoPart'))),_c('br'),_vm._v(" "+_vm._s(_vm.value.ecotax_u_ttc)+" "+_vm._s(_vm.currency.symbol)+" "+_vm._s(_vm.$t('sales.form.lines.ttc'))+" ")]):_vm._e()],_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('unit_price_ttc')},domProps:{"value":_vm.value.unit_price_ttc}}),(_vm.withEcotaxe)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('ecotax_u_ttc')},domProps:{"value":_vm.value.ecotax_u_ttc}}):_vm._e()],2):_vm._e(),(!_vm.document.use_global_vatrate)?_c('td',{staticClass:"text-center"},[(!_vm.editing)?[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.vat_rate.rate))+" % ")]:_c('VatRateSelect',{attrs:{"size":"sm","required":""},on:{"input":_vm.calculPrices},model:{value:(_vm.value.vat_rate),callback:function ($$v) {_vm.$set(_vm.value, "vat_rate", $$v)},expression:"value.vat_rate"}}),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('vat_rate')},domProps:{"value":_vm.value.vat_rate ? _vm.value.vat_rate.id : null}})],2):_vm._e(),_c('td',{staticClass:"text-center"},[(!_vm.editing)?[(_vm.value.is_option)?_c('span',[_c('i',{staticClass:"small"},[_vm._v("Option")])]):_c('span',[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.quantity))+" "),(_vm.document.input_options.col_unit && _vm.value.unit)?_c('span',{staticClass:"small"},[_vm._v(" "+_vm._s(_vm.value.unit.label)+" ")]):_vm._e()])]:[(!_vm.computedOption)?_c('k-form-spinner',{attrs:{"validationName":_vm.getInputName('quantity'),"size":"sm","max-decimal":5},on:{"input":_vm.calculPrices},model:{value:(_vm.value.quantity),callback:function ($$v) {_vm.$set(_vm.value, "quantity", $$v)},expression:"value.quantity"}}):_vm._e(),(!_vm.computedOption && _vm.document.input_options.col_unit)?[_c('UnitSelect',{staticClass:"mt-2",attrs:{"size":"sm","placeholder":_vm.$t('sales.form.unit'),"taggable":""},model:{value:(_vm.value.unit),callback:function ($$v) {_vm.$set(_vm.value, "unit", $$v)},expression:"value.unit"}})]:_vm._e(),(_vm.document.input_options.allow_options)?_c('k-form-checkbox',{staticClass:"mt-2",attrs:{"size":"sm","validationName":_vm.getInputName('is_option')},model:{value:(_vm.value.is_option),callback:function ($$v) {_vm.$set(_vm.value, "is_option", $$v)},expression:"value.is_option"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.lines.option'))+" ")]):_vm._e()],_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('quantity')},domProps:{"value":_vm.value.quantity}}),(_vm.document.input_options.allow_options)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('is_option')},domProps:{"value":_vm.value.is_option ? true : false}}):_vm._e(),(!_vm.computedOption && _vm.document.input_options.col_unit)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('unit')},domProps:{"value":_vm.value.unit ? _vm.value.unit.label : null}}):_vm._e(),(_vm.editing && _vm.value.catalog && _vm.value.catalog.element && _vm.value.catalog.type === 'product' && _vm.value.catalog.element.with_stock)?[(_vm.document.input_options.stock_display === 1 || _vm.document.input_options.stock_display === 3)?_c('p',{class:{
            'small mb-0 mt-2': true,
            'font-weight-bold': _vm.document.input_options.stock_display !== 1
          }},[_vm._v(" Stock ")]):_vm._e(),_c('div',{staticClass:"text-left"},[(_vm.document.input_options.stock_display === 2 || _vm.document.input_options.stock_display === 3)?_c('p',{class:{
              'small mb-0': true,
              'text-center mt-2': _vm.document.input_options.stock_display === 2
            }},[(_vm.document.input_options.stock_display === 2)?[_vm._v("Stock ")]:[_vm._v("Réel : ")],_vm._v(" "+_vm._s(_vm.showNumber(_vm.stockQuantity))+" ")],2):_vm._e(),(_vm.document.input_options.stock_display === 1 || _vm.document.input_options.stock_display === 3)?_c('p',{staticClass:"small mb-0"},[_vm._v(" Théorique : "+_vm._s(_vm.showNumber(_vm.stockTheoricalQuantity))+" ")]):_vm._e()])]:_vm._e()],2),(_vm.document.secondary_quantity_mode !== 'disable')?_c('td',{staticClass:"text-center"},[(!_vm.computedOption)?[(_vm.document.secondary_quantity_mode === 'line')?[(!_vm.editing)?_c('span',[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.secondary_quantity))+" "),(_vm.document.input_options.secondary_quantity_unit && _vm.value.secondary_unit)?_c('span',{staticClass:"small"},[_vm._v(" "+_vm._s(_vm.value.secondary_unit.label)+" ")]):_vm._e()]):[_c('k-form-spinner',{attrs:{"validationName":_vm.getInputName('secondary_quantity'),"size":"sm","max-decimal":5},on:{"input":_vm.calculPrices},model:{value:(_vm.value.secondary_quantity),callback:function ($$v) {_vm.$set(_vm.value, "secondary_quantity", $$v)},expression:"value.secondary_quantity"}}),(_vm.document.input_options.secondary_quantity_unit)?[_c('UnitSelect',{staticClass:"mt-2",attrs:{"size":"sm","placeholder":_vm.$t('sales.form.unit'),"taggable":""},model:{value:(_vm.value.secondary_unit),callback:function ($$v) {_vm.$set(_vm.value, "secondary_unit", $$v)},expression:"value.secondary_unit"}})]:_vm._e()],_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('secondary_quantity')},domProps:{"value":_vm.value.secondary_quantity}}),(_vm.document.input_options.secondary_quantity_unit)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('secondary_unit')},domProps:{"value":_vm.value.secondary_unit ? _vm.value.secondary_unit.label : null}}):_vm._e()]:_c('p',{staticClass:"mb-0 pt-1 text-center"},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.document.secondary_quantity))+" ")])]:_vm._e()],2):_vm._e(),(_vm.document.input_mode === 'ht')?_c('td',{staticClass:"text-right"},[(!_vm.computedOption)?[(!_vm.editing)?[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_ht))+" ")]:_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","disabled":_vm.contentIsDisabled},on:{"change":_vm.calculHtTotals},model:{value:(_vm.value.total_ht),callback:function ($$v) {_vm.$set(_vm.value, "total_ht", $$v)},expression:"value.total_ht"}})],1)]:_vm._e()],2):(_vm.document.input_mode === 'ttc')?_c('td',{staticClass:"text-right"},[(!_vm.computedOption)?[(!_vm.editing)?[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_ttc))+" ")]:_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","disabled":_vm.contentIsDisabled},on:{"change":_vm.calculTtcTotals},model:{value:(_vm.value.total_ttc),callback:function ($$v) {_vm.$set(_vm.value, "total_ttc", $$v)},expression:"value.total_ttc"}})],1)]:_vm._e()],2):_vm._e(),_c('td',{staticClass:"text-center"},[(_vm.value.affair_content_id)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('affair_content')},domProps:{"value":_vm.value.affair_content_id}}):_vm._e(),(_vm.value.catalog && _vm.value.catalog.element)?[_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('catalog.type')},domProps:{"value":_vm.value.catalog.type}}),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('catalog.id')},domProps:{"value":_vm.value.catalog.id}}),(_vm.value.variation)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('variation')},domProps:{"value":_vm.value.variation.id}}):_vm._e()]:_vm._e(),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],ref:"deleteBtn",staticClass:"p-0",attrs:{"variant":"link","title":"Supprimer la ligne"}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":_vm.deleteLine}})],1),(_vm.editing)?_c('LineMenu',{attrs:{"line":_vm.value},on:{"add":event => _vm.$emit('addSubLine', event),"setCatalog":_vm.setCatalog}}):_vm._e()],2)]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: ./src/mixins/SalesLineMixin.ts
var SalesLineMixin = __webpack_require__(11172);
// EXTERNAL MODULE: external "@kwixeo/catalog-vue"
var catalog_vue_ = __webpack_require__(68480);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/Form/editorConfig.ts
var editorConfig = __webpack_require__(63457);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/SaleLine/SaleLine.ts?vue&type=script&lang=ts&external











var SaleLine = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleLine, _super);
    function SaleLine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.picturesModal = false;
        _this.loadingPrice = false;
        _this.editorConfig = editorConfig/* default */.A;
        _this.initialized = false;
        return _this;
    }
    SaleLine.prototype.mounted = function () {
        var _this = this;
        if (!this.value.id) {
            this.updateCustomPrice();
        }
        interface_vue_.emitter.on('updateCustomPrice', this.updateCustomPrice);
        this.$nextTick(function () {
            _this.initialized = true;
        });
    };
    SaleLine.prototype.destroyed = function () {
        interface_vue_.emitter.off('updateCustomPrice', this.updateCustomPrice);
    };
    Object.defineProperty(SaleLine.prototype, "colspanLoadingPrice", {
        get: function () {
            var document = this.document;
            var colspan = 7;
            if (!document.use_global_vatrate) {
                colspan++;
            }
            if (document.secondary_quantity_mode === 'line') {
                colspan++;
            }
            if (document.input_options.col_reference) {
                colspan++;
            }
            if (document.input_options.col_picture) {
                colspan++;
            }
            if (document.input_options.col_number) {
                colspan++;
            }
            return colspan;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleLine.prototype, "rateCalc", {
        // Get rate coef for calculation
        get: function () {
            var rate = this.vatRate;
            return rate ? this.number(rate.rate / 100) : 0;
        },
        enumerable: false,
        configurable: true
    });
    SaleLine.prototype.rateAmountFromTtc = function (ttc) {
        var rate = this.vatRate;
        if (!rate) {
            return 0;
        }
        return this.roundNumber(ttc / (100 + rate.rate) * rate.rate, this.allowedDecimals);
    };
    Object.defineProperty(SaleLine.prototype, "withEcotaxe", {
        // If eco participation should be displayed
        get: function () {
            var mode = this.document.input_options.eco_participation;
            var type = this.value.catalog;
            return (mode === 1 && !type) ||
                (mode === 2 && type && type.type === 'product') ||
                (mode === 3 && (!type || type.type === 'product')) ||
                mode === 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleLine.prototype, "withEan", {
        // If ean should be displayed
        get: function () {
            var mode = this.document.input_options.ean;
            var type = this.value.catalog;
            return (mode === 1 && !type) ||
                (mode === 2 && type && type.type === 'product') ||
                (mode === 3 && (!type || type.type === 'product')) ||
                mode === 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleLine.prototype, "withWeight", {
        // If weight should be displayed
        get: function () {
            var mode = this.document.input_options.weight;
            var type = this.value.catalog;
            return (mode === 1 && !type) ||
                (mode === 2 && type && type.type === 'product') ||
                (mode === 3 && (!type || type.type === 'product')) ||
                mode === 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleLine.prototype, "usedLotQuantities", {
        get: function () {
            var _a;
            return (_a = sumBy_default()(this.value.used_lots, function (lot) { return lot.quantity; })) !== null && _a !== void 0 ? _a : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleLine.prototype, "hasProductLotSelection", {
        get: function () {
            var _a;
            if (this.type === 'credit' || !this.hasModule('stock-tracabilities') || !this.value.catalog || this.value.catalog.type !== 'product') {
                return false;
            }
            var product = this.value.catalog.element;
            return product && ((_a = product.stock_tracking_mode) !== null && _a !== void 0 ? _a : 0) > 0 && (this.type === 'delivery' || this.teamConfigs['stock_tracabilities_allow_' + this.type]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleLine.prototype, "allowedDecimals", {
        get: function () {
            return this.teamConfigs.number_nb_decimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleLine.prototype, "stockQuantity", {
        get: function () {
            var _a;
            if (this.value.variation) {
                return this.value.variation.stock_quantity;
            }
            if (!((_a = this.value.catalog) === null || _a === void 0 ? void 0 : _a.element) || !('stock_quantity' in this.value.catalog.element)) {
                return 0;
            }
            return this.value.catalog.element.stock_quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleLine.prototype, "stockTheoricalQuantity", {
        get: function () {
            var _a;
            if (this.value.variation) {
                return this.value.variation.stock_theoretical_quantity;
            }
            if (!((_a = this.value.catalog) === null || _a === void 0 ? void 0 : _a.element) || !('stock_theoretical_quantity' in this.value.catalog.element)) {
                return 0;
            }
            return this.value.catalog.element.stock_theoretical_quantity;
        },
        enumerable: false,
        configurable: true
    });
    SaleLine.prototype.onUnitPriceHtChange = function () {
        this.calculHtPrices();
    };
    SaleLine.prototype.onUnitPriceTtcChange = function () {
        this.calculTtcPrices();
    };
    // Prices calculation from unit price ht
    SaleLine.prototype.calculHtPrices = function () {
        var local = this.value;
        // Unit prices
        var unitHt = this.number(local.unit_price_ht);
        var unitTva = this.roundNumber(unitHt * this.rateCalc, 5);
        var unitTtc = this.roundNumber(unitHt + unitTva, 5);
        local.unit_price_tva = unitTva;
        local.unit_price_ttc = unitTtc;
        // Unit eco participation
        var unitEcoTaxeHt = this.number(local.ecotax_u_ht);
        var unitEcoTaxeTva = this.roundNumber(unitEcoTaxeHt * this.rateCalc, 5);
        var unitEcoTaxeTtc = this.roundNumber(unitEcoTaxeHt + unitEcoTaxeTva, 5);
        local.ecotax_u_tva = unitEcoTaxeTva;
        local.ecotax_u_ttc = unitEcoTaxeTtc;
        // Totals eco participation
        var totalEcoTaxeHt = this.roundNumber(unitEcoTaxeHt * this.number(this.totalQuantity), this.allowedDecimals);
        var totalEcoTaxeTva = this.roundNumber(totalEcoTaxeHt * this.rateCalc, 5);
        var totalEcoTaxeTtc = this.roundNumber(totalEcoTaxeHt + totalEcoTaxeTva, 5);
        local.total_ecotax_ht = totalEcoTaxeHt;
        local.total_ecotax_tva = totalEcoTaxeTva;
        local.total_ecotax_ttc = totalEcoTaxeTtc;
        // Total HT
        var totalHt = this.roundNumber(unitHt * this.number(this.totalQuantity), this.allowedDecimals);
        // Calculate discount
        var discountValue = this.number(local.discount_value);
        var discountHt = 0;
        if (discountValue > 0) {
            if (local.discount_type === 'amount') {
                discountHt = discountValue;
            }
            else {
                // Remove eco-participation for discount calculation
                var baseHt = totalHt - totalEcoTaxeHt;
                discountHt = this.roundNumber(baseHt * discountValue / 100, this.allowedDecimals);
            }
            totalHt -= discountHt;
        }
        var totalTva = this.roundNumber(totalHt * this.rateCalc, 5);
        var totalTtc = this.roundNumber(totalHt + totalTva, 5);
        local.total_ht = totalHt;
        local.total_tva = totalTva;
        local.total_ttc = totalTtc;
        this.calculateCosts();
    };
    // Prices calculation from unit price ttc
    SaleLine.prototype.calculTtcPrices = function () {
        var local = this.value;
        var unitTtc = this.number(local.unit_price_ttc);
        var unitTva = this.rateAmountFromTtc(unitTtc);
        local.unit_price_tva = unitTva;
        local.unit_price_ht = this.roundNumber(unitTtc - unitTva, 5);
        // Unit eco participation
        var unitEcoTaxeTtc = this.number(local.ecotax_u_ttc);
        var unitEcoTaxeTva = this.rateAmountFromTtc(unitEcoTaxeTtc);
        local.ecotax_u_tva = unitEcoTaxeTva;
        local.ecotax_u_ht = this.roundNumber(unitEcoTaxeTtc - unitEcoTaxeTva, 5);
        // Totals eco participation
        var totalEcoTaxeTtc = this.roundNumber(unitEcoTaxeTtc * this.number(this.totalQuantity), this.allowedDecimals);
        var totalEcoTaxeTva = this.rateAmountFromTtc(totalEcoTaxeTtc);
        local.total_ecotax_ht = this.roundNumber(totalEcoTaxeTtc - totalEcoTaxeTva, 5);
        local.total_ecotax_tva = totalEcoTaxeTva;
        local.total_ecotax_ttc = totalEcoTaxeTtc;
        var totalTtc = this.roundNumber(unitTtc * this.number(this.totalQuantity), this.allowedDecimals);
        // Calculate discount
        var discountValue = this.number(local.discount_value);
        var discountHt = 0;
        if (discountValue > 0) {
            if (local.discount_type === 'amount') {
                discountHt = discountValue;
            }
            else {
                // Remove eco-participation for discount calculation
                var baseTtc = totalTtc - totalEcoTaxeTtc;
                discountHt = this.roundNumber(baseTtc * discountValue / 100, this.allowedDecimals);
            }
            totalTtc -= discountHt;
        }
        var totalTva = this.rateAmountFromTtc(totalTtc);
        local.total_ttc = totalTtc;
        local.total_tva = totalTva;
        local.total_ht = this.roundNumber(totalTtc - totalTva, 5);
        this.calculateCosts();
    };
    Object.defineProperty(SaleLine.prototype, "contentIsDisabled", {
        // Check if the content has a product with variation & if the variation is selected
        get: function () {
            var _a, _b, _c;
            var element = (_c = (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.catalog) === null || _b === void 0 ? void 0 : _b.element) !== null && _c !== void 0 ? _c : null;
            if (!element) {
                return false;
            }
            return this.hasModule('catalog-variations') && 'variations_length' in element && element.variations_length > 0 &&
                (this.value.variation === undefined || this.value.variation === null);
        },
        enumerable: false,
        configurable: true
    });
    SaleLine.prototype.variationSelected = function (variation) {
        this.value.reference = variation.reference;
        this.value.unit_price_ht = variation.unit_price_ht;
        this.value.unit_price_ttc = variation.unit_price_ttc;
        this.calculPrices();
    };
    SaleLine.prototype.variationUnselected = function () {
        this.value.reference = '';
        this.value.unit_price_ht = 0;
        this.value.unit_price_ttc = 0;
        this.calculPrices();
    };
    SaleLine.prototype.selectPicture = function (picture) {
        this.value.picture = picture;
        this.picturesModal = false;
    };
    SaleLine.prototype.updateCustomPrice = function () {
        var applied = this.updateUnitPrice();
        if (!applied) {
            this.applySaleCategoryDiscount();
        }
    };
    SaleLine.prototype.watchQuantityUpdated = function () {
        var _a;
        var catalog = (_a = this.value.catalog) === null || _a === void 0 ? void 0 : _a.element;
        if (catalog && 'custom_price_mode' in catalog && catalog.custom_price_mode === 'quantity') {
            this.updateUnitPrice();
        }
    };
    SaleLine.prototype.updateUnitPrice = function () {
        var _a;
        if (!this.value.catalog || (((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) && !this.initialized)) {
            return false;
        }
        var catalog = this.value.catalog.element;
        if (!this.hasModule('catalog-custom-prices') || !('custom_price_mode' in catalog)) {
            return false;
        }
        if ((catalog.custom_price_mode === 'quantity' && catalog.custom_quantity_prices.length === 0)
            || ((catalog.custom_price_mode === 'type' || catalog.custom_price_mode === 'customer' || catalog.custom_price_mode === 'country') && catalog.custom_type_prices.length === 0)) {
            return false;
        }
        var prices = this.fetchUnitPrice();
        if (prices && (prices.ht !== this.value.unit_price_ht || prices.ttc !== this.value.unit_price_ttc)) {
            this.value.unit_price_ht = prices.ht;
            this.value.unit_price_ttc = prices.ttc;
            this.calculPrices();
            return true;
        }
        return false;
    };
    SaleLine.prototype.applySaleCategoryDiscount = function () {
        var _a, _b, _c, _d, _e;
        var discountPourcent = 0;
        var product = (_a = this.value.catalog) === null || _a === void 0 ? void 0 : _a.element;
        var customerType = (_b = this.document.customer) === null || _b === void 0 ? void 0 : _b.type_id;
        if (customerType && product) {
            var discount = (_d = (_c = product.sale_category) === null || _c === void 0 ? void 0 : _c.custom_prices) === null || _d === void 0 ? void 0 : _d.find(function (price) { return price.type_id === customerType; });
            discountPourcent = (_e = discount === null || discount === void 0 ? void 0 : discount.discount) !== null && _e !== void 0 ? _e : 0;
        }
        this.value.discount_type = 'pourcent';
        this.value.discount_value = discountPourcent;
        this.calculPrices();
    };
    // Get unit prices
    SaleLine.prototype.fetchUnitPrice = function () {
        var _this = this;
        var catalog = this.value.catalog;
        if (!catalog || !('custom_price_mode' in catalog.element) || !this.document.customer) {
            return null;
        }
        var product = catalog.element;
        var unitPriceHt = this.number(product.unit_price_ht);
        var unitPriceTtc = this.number(product.unit_price_ttc);
        var customPrice;
        var quantity = 0;
        var stats;
        switch (product.custom_price_mode) {
            case 'quantity':
                switch (product.custom_price_quantity_mode) {
                    case 1:
                        quantity = sumBy_default()(this.document.contents.filter(function (content) { return content.catalog && content.catalog.type === catalog.type && content.catalog.id === catalog.id; }), function (content) {
                            return content.total_quantity;
                        });
                        break;
                    default:
                        stats = this.salesProductsQuantity.find(function (sale) { return sale.type === catalog.type || sale.id === catalog.id; });
                        quantity = stats ? stats.quantity : 0;
                }
                customPrice = product.custom_quantity_prices.find(function (custom) { return custom.minimum <= quantity && quantity <= custom.maximum; });
                break;
            case 'type':
                customPrice = product.custom_type_prices.find(function (type) { var _a, _b; return type.type === 'customerType' && type.id === ((_b = (_a = _this.document.customer) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.id); });
                break;
            case 'customer':
                customPrice = product.custom_type_prices.find(function (type) { var _a; return type.type === 'customer' && type.id === ((_a = _this.document.customer) === null || _a === void 0 ? void 0 : _a.id); });
                break;
            case 'country':
                customPrice = product.custom_type_prices.find(function (type) { var _a, _b, _c; return type.type === 'country' && type.id === ((_c = (_b = (_a = _this.document) === null || _a === void 0 ? void 0 : _a.billing_address) === null || _b === void 0 ? void 0 : _b.country) === null || _c === void 0 ? void 0 : _c.id); });
                break;
        }
        if (customPrice) {
            unitPriceHt = this.number(customPrice.price);
            unitPriceTtc = this.roundNumber(unitPriceHt * (1 + this.rateCalc), this.allowedDecimals);
        }
        return {
            ht: unitPriceHt,
            ttc: unitPriceTtc
        };
    };
    SaleLine.prototype.setCatalog = function (catalog) {
        this.value.catalog = catalog;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SaleLine.prototype, "salesProductsQuantity", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.quantity')
    ], SaleLine.prototype, "watchQuantityUpdated", null);
    SaleLine = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                ProductVariationSelect: catalog_vue_.ProductVariationSelect, CatalogPictures: catalog_vue_.CatalogPictures, LotSelected: catalog_vue_.LotSelected,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert,
                KFormInput: form_vue_.KFormInput, KFormEditor: form_vue_.KFormEditor, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect, KFormSpinner: form_vue_.KFormSpinner, KFormCheckbox: form_vue_.KFormCheckbox, KFormTextarea: form_vue_.KFormTextarea, FroalaView: form_vue_.FroalaView,
                UnitSelect: interface_vue_.UnitSelect, VatRateSelect: interface_vue_.VatRateSelect, Spinner: interface_vue_.Spinner
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], SaleLine);
    return SaleLine;
}((0,lib/* Mixins */.Xe)(SalesLineMixin/* default */.A)));
/* harmony default export */ var SaleLinevue_type_script_lang_ts_external = (SaleLine);

;// ./src/components/Form/SaleLine/SaleLine.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleLine_SaleLinevue_type_script_lang_ts_external = (SaleLinevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/SaleLine/SaleLine.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleLine_SaleLinevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleLine_SaleLine = (component.exports);

/***/ }),

/***/ 7306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ 7352:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'check';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f00c';
var svgPathData = 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.e6 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_AccountingClosingView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AccountingClosingView.vue?vue&type=template&id=37dd7d2f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AccountingClosing')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountingClosing/AccountingClosing.vue?vue&type=template&id=09ed41fd
var AccountingClosingvue_type_template_id_09ed41fd_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AccountingClosingForm',{on:{"closed":_vm.periodAdded}}),_c('h2',{staticClass:"form-title mb-0 border-0 pb-2"},[_vm._v(" Liste des périodes clôturées ")]),_c('b-card',[_c('k-table',{ref:"table",attrs:{"url":"/sales/closed_period?include=teamUser","columns":_vm.columns}})],1)],1)
}
var AccountingClosingvue_type_template_id_09ed41fd_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountingClosingForm/AccountingClosingForm.vue?vue&type=template&id=cb88c46e
var AccountingClosingFormvue_type_template_id_cb88c46e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"form-title mt-0 mb-0 border-0 pb-2"},[_vm._v(" Clôture d'une période comptable ")]),_c('b-card',[_c('b-alert',{attrs:{"variant":"danger","show":""}},[_c('strong',[_vm._v(" Attention : une clôture empèchera de saisir ou de modifier les données suivantes jusqu'à la date de clôture : ")]),_c('ul',[_c('li',[_vm._v("Saisie de nouvelles factures")]),_c('li',[_vm._v("Saisie ou annulation de paiement")]),_c('li',[_vm._v("Saisie ou modification des charges")]),_c('li',[_vm._v("Saisie ou modification des paiements des charges")])]),_c('strong',[_vm._v(" Une fois la période clôturée, il ne sera pas possible de revenir en arrière, même sur demande au support technique. ")])]),_c('b-form-group',{attrs:{"label":"Clôturer mes données jusqu'au :"}},[_c('k-form-datepicker',{ref:"datepicker",attrs:{"min-date":_vm.minDate,"max-date":_vm.yesterday,"required":""},model:{value:(_vm.closingDate),callback:function ($$v) {_vm.closingDate=$$v},expression:"closingDate"}})],1),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.confirmClosing.apply(null, arguments)}}},[_vm._v(" Clôturer ")]),_c('FormModal',{attrs:{"title":"Clôture d\\'une période","ok-title":"Clôturer la période","size":"lg"},model:{value:(_vm.confirmModal),callback:function ($$v) {_vm.confirmModal=$$v},expression:"confirmModal"}},[_c('b-alert',{attrs:{"variant":"danger","show":""}},[_c('p',[_vm._v(" Attention, vous êtes sur le point de clôturer le logiciel jusqu'au "),_c('strong',[_vm._v(_vm._s(_vm.date(_vm.closingDate)))]),_vm._v(". ")]),_vm._v(" Vous ne pourrez plus effectuer les actions suivantes : "),_c('ul',[_c('li',[_vm._v("Saisir de nouvelles factures jusqu'au "+_vm._s(_vm.date(_vm.closingDate)))]),_c('li',[_vm._v("Saisir de nouveaux encaissements jusqu'au "+_vm._s(_vm.date(_vm.closingDate)))]),_c('li',[_vm._v("Annuler des encaissements jusqu'au "+_vm._s(_vm.date(_vm.closingDate)))]),_c('li',[_vm._v("Saisir ou modifier des charges jusqu'au "+_vm._s(_vm.date(_vm.closingDate)))]),_c('li',[_vm._v("Saisir ou modifier les paiements des charges jusqu'au "+_vm._s(_vm.date(_vm.closingDate)))])]),_c('strong',[_vm._v(" Cette action est irréversible et il ne sera pas possible de revenir en arrière, même sur demande au support technique. ")])]),_c('k-form',{attrs:{"action":"/sales/closed_period"},on:{"submitComplete":_vm.submitComplete}},[_c('input',{attrs:{"type":"hidden","name":"end"},domProps:{"value":_vm.closingDate}}),_c('p',{staticClass:"mb-0 font-weight-bold"},[_vm._v(" Pour confirmer la clôture, vous devez saisir la phrase suivante : ")]),_c('p',{staticClass:"mb-0 font-weight-normal"},[_vm._v(" \"Je confirme la clôture de mon année comptable\" ")]),_c('b-form-group',[_c('k-form-input',{attrs:{"name":"confirm","autocomplete":"confirm-closing","required":"","validate":"confirmAccountingClosing"}})],1),_c('b-form-group',{attrs:{"label":"Mot de passe de connexion"}},[_c('k-form-input',{attrs:{"name":"current_password","autocomplete":"new-password","required":"","type":"password","automaticRules":false}})],1)],1)],1)],1)],1)
}
var AccountingClosingFormvue_type_template_id_cb88c46e_staticRenderFns = []


// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AccountingClosingForm/AccountingClosingForm.ts?vue&type=script&lang=ts&external







var AccountingClosingForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AccountingClosingForm, _super);
    function AccountingClosingForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closingDate = null;
        _this.yesterday = null;
        _this.confirmModal = false;
        return _this;
    }
    AccountingClosingForm.prototype.mounted = function () {
        this.yesterday = external_moment_default()().subtract(1, 'day').format('YYYY-MM-DD');
    };
    Object.defineProperty(AccountingClosingForm.prototype, "minDate", {
        get: function () {
            var date = this.team.sales.closed_period;
            if (!date) {
                return null;
            }
            return external_moment_default()(date).add(1, 'day').format('YYYY-MM-DD');
        },
        enumerable: false,
        configurable: true
    });
    AccountingClosingForm.prototype.confirmClosing = function () {
        var date = this.$refs.datepicker;
        var errors = date.valid();
        if (!errors) {
            this.confirmModal = true;
        }
    };
    AccountingClosingForm.prototype.submitComplete = function (response) {
        this.closingDate = null;
        this.confirmModal = false;
        this.$emit('closed', response.data);
    };
    AccountingClosingForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert,
                KFormDatepicker: form_vue_.KFormDatepicker, KFormInput: form_vue_.KFormInput, KForm: form_vue_.KForm,
                FormModal: interface_vue_.FormModal
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team']))
        })
    ], AccountingClosingForm);
    return AccountingClosingForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var AccountingClosingFormvue_type_script_lang_ts_external = (AccountingClosingForm);

;// ./src/components/AccountingClosingForm/AccountingClosingForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AccountingClosingForm_AccountingClosingFormvue_type_script_lang_ts_external = (AccountingClosingFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/AccountingClosingForm/AccountingClosingForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AccountingClosingForm_AccountingClosingFormvue_type_script_lang_ts_external,
  AccountingClosingFormvue_type_template_id_cb88c46e_render,
  AccountingClosingFormvue_type_template_id_cb88c46e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccountingClosingForm_AccountingClosingForm = (component.exports);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AccountingClosing/AccountingClosing.ts?vue&type=script&lang=ts&external





var AccountingClosing = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AccountingClosing, _super);
    function AccountingClosing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AccountingClosing.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'begin',
                    name: 'Début de la période',
                    render: 'date'
                },
                {
                    data: 'end',
                    name: 'Fin de la période',
                    render: 'date'
                },
                {
                    data: 'team_user.fullname',
                    name: 'Utilisateur'
                },
                {
                    data: 'created_at',
                    name: 'Date de clôture',
                    render: 'datetime'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    AccountingClosing.prototype.periodAdded = function () {
        this.$refs.table.refresh();
    };
    AccountingClosing = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AccountingClosingForm: AccountingClosingForm_AccountingClosingForm,
                KTable: table_vue_.KTable,
                BCard: external_bootstrap_vue_.BCard
            }
        })
    ], AccountingClosing);
    return AccountingClosing;
}(lib/* Vue */.lD));
/* harmony default export */ var AccountingClosingvue_type_script_lang_ts_external = (AccountingClosing);

;// ./src/components/AccountingClosing/AccountingClosing.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AccountingClosing_AccountingClosingvue_type_script_lang_ts_external = (AccountingClosingvue_type_script_lang_ts_external); 
;// ./src/components/AccountingClosing/AccountingClosing.vue





/* normalize component */
;
var AccountingClosing_component = (0,componentNormalizer/* default */.A)(
  AccountingClosing_AccountingClosingvue_type_script_lang_ts_external,
  AccountingClosingvue_type_template_id_09ed41fd_render,
  AccountingClosingvue_type_template_id_09ed41fd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccountingClosing_AccountingClosing = (AccountingClosing_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AccountingClosingView.vue?vue&type=script&lang=ts



var AccountingClosingView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AccountingClosingView, _super);
    function AccountingClosingView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountingClosingView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AccountingClosing: AccountingClosing_AccountingClosing
            }
        })
    ], AccountingClosingView);
    return AccountingClosingView;
}(lib/* Vue */.lD));
/* harmony default export */ var AccountingClosingViewvue_type_script_lang_ts = (AccountingClosingView);

;// ./src/views/AccountingClosingView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_AccountingClosingViewvue_type_script_lang_ts = (AccountingClosingViewvue_type_script_lang_ts); 
;// ./src/views/AccountingClosingView.vue





/* normalize component */
;
var AccountingClosingView_component = (0,componentNormalizer/* default */.A)(
  views_AccountingClosingViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_AccountingClosingView = (AccountingClosingView_component.exports);

/***/ }),

/***/ 8081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractForm_ContractForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractForm/ContractForm.vue?vue&type=template&id=2fbc0712
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle}}),_c('AppMessages'),(_vm.loading)?_c('Spinner'):_c('div',[_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[(_vm.element.quotation_id)?_c('input',{attrs:{"type":"hidden","name":"quotation"},domProps:{"value":_vm.element.quotation_id}}):_vm._e(),_c('k-form-input',{staticClass:"mb-4",attrs:{"name":"title","placeholder":"Titre du contrat"},model:{value:(_vm.element.title),callback:function ($$v) {_vm.$set(_vm.element, "title", $$v)},expression:"element.title"}}),_c('b-tabs',{class:{ 'tabs-card': true, 'contract-model-selected': _vm.element.model }},[_c('b-tab',{attrs:{"title":"Informations"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-row',[_c('b-col',[_c('input',{attrs:{"type":"hidden","name":"customer"},domProps:{"value":_vm.element.customer ? _vm.element.customer.id : null}}),_c('CustomerSelect',{attrs:{"required":"","validationName":"customer","include":['address_invoice','address_delivery','addresses', 'childs', 'parent', 'parent.childs', 'parent.datas', 'billing_contact'],"type":"prospect_or_customer"},on:{"input":_vm.selectCustomer},model:{value:(_vm.element.customer),callback:function ($$v) {_vm.$set(_vm.element, "customer", $$v)},expression:"element.customer"}})],1),_c('input',{attrs:{"name":"customer_child","type":"hidden"},domProps:{"value":_vm.element.customer_child ? _vm.element.customer_child.id : null}}),(_vm.hasModule('customers-group') && _vm.element.customer?.childs?.length > 0)?_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.teamConfigs.customer_group_child_name}},[_c('k-form-select',{attrs:{"options":_vm.element.customer?.childs,"label":"name"},model:{value:(_vm.element.customer_child),callback:function ($$v) {_vm.$set(_vm.element, "customer_child", $$v)},expression:"element.customer_child"}})],1)],1):_vm._e()],1),_c('input',{attrs:{"type":"hidden","name":"contact"},domProps:{"value":_vm.element.contact ? _vm.element.contact.id : null}}),_c('ContactSelect',{attrs:{"validationName":"contact","customer":_vm.element.customer,"disabled":!_vm.element.customer},model:{value:(_vm.element.contact),callback:function ($$v) {_vm.$set(_vm.element, "contact", $$v)},expression:"element.contact"}}),_c('b-form-group',{scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"position-relative"},[_vm._v(" Adresse de facturation "),_c('CustomerAddressSelect',{attrs:{"customer":_vm.element.customer},on:{"selected":_vm.selectAddress}})],1)]},proxy:true}])},[_c('k-form-address',{staticClass:"mt-2",attrs:{"size":"sm","countries-list":_vm.countries,"required":"","road-placeholder":_vm.$t('sales.form.road'),"with-road3":"","valuesMap":{
                    city: 'town'
                  },"city-name":"town"},model:{value:(_vm.element),callback:function ($$v) {_vm.element=$$v},expression:"element"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"8","xl":"7","offset-xl":"1"}},[_c('b-row',{staticClass:"mt-md-3 mt-lg-0"},[_c('b-col',{attrs:{"cols":"12","md":"7"}},[_c('b-alert',{staticClass:"px-2 py-0",attrs:{"variant":"warning","show":""}},[_c('b-form-group',{staticClass:"mb-1",attrs:{"label":"Modèle de contrat"}},[_c('input',{attrs:{"type":"hidden","name":"model"},domProps:{"value":_vm.element.model ? _vm.element.model.id : null}}),_c('k-form-select',{attrs:{"validationName":"model","placeholder":"Charger un modèle de contrat","options":_vm.contractModels,"label":"name"},on:{"input":_vm.selectModel},model:{value:(_vm.element.model),callback:function ($$v) {_vm.$set(_vm.element, "model", $$v)},expression:"element.model"}})],1)],1),_c('b-form-group',{attrs:{"label":"Période"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-1",attrs:{"cols":"auto"}},[_vm._v(" Du "),_c('k-form-datepicker',{staticClass:"d-inline-block contract-form-datepicker",attrs:{"name":"period_begin","required":"","max-date":_vm.element.period_end},on:{"input":_vm.selectBegin},model:{value:(_vm.element.period_begin),callback:function ($$v) {_vm.$set(_vm.element, "period_begin", $$v)},expression:"element.period_begin"}})],1),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"auto"}},[_vm._v(" au "),_c('k-form-datepicker',{staticClass:"d-inline-block contract-form-datepicker",attrs:{"name":"period_end","required":"","min-date":_vm.element.period_begin},model:{value:(_vm.element.period_end),callback:function ($$v) {_vm.$set(_vm.element, "period_end", $$v)},expression:"element.period_end"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Mode de règlement"}},[_c('input',{attrs:{"type":"hidden","name":"payment_method"},domProps:{"value":_vm.element.payment_method ? _vm.element.payment_method.id : null}}),_c('PaymentMethodSelect',{staticClass:"with-default-value",attrs:{"validationName":"payment_method","clearable":_vm.element.model && _vm.element.model.payment_method,"required":!_vm.element.model || !_vm.element.model.payment_method,"placeholder":_vm.element.model && _vm.element.model.payment_method ? 'Par défaut : ' + _vm.element.model.payment_method.label : null,"selectFirst":!_vm.element.model && !_vm.element.id},model:{value:(_vm.element.payment_method),callback:function ($$v) {_vm.$set(_vm.element, "payment_method", $$v)},expression:"element.payment_method"}})],1),_c('b-form-group',{attrs:{"label":"Condition de règlement"}},[_c('input',{attrs:{"type":"hidden","name":"payment_term"},domProps:{"value":_vm.element.payment_term ? _vm.element.payment_term.id : null}}),_c('PaymentTermSelect',{staticClass:"with-default-value",attrs:{"validationName":"payment_term","clearable":_vm.element.model && _vm.element.model.payment_term,"required":!_vm.element.model || !_vm.element.model.payment_term,"placeholder":_vm.element.model && _vm.element.model.payment_term ? 'Par défaut : ' + _vm.element.model.payment_term.label : null,"selectFirst":!_vm.element.model && !_vm.element.id},model:{value:(_vm.element.payment_term),callback:function ($$v) {_vm.$set(_vm.element, "payment_term", $$v)},expression:"element.payment_term"}})],1),_c('input',{attrs:{"type":"hidden","name":"sepa"},domProps:{"value":_vm.element.sepa ? _vm.element.sepa.id : null}}),(_vm.hasModule('sales-sepa'))?_c('CustomerSepaSelect',{attrs:{"disabled":!_vm.element.customer,"customerId":_vm.element.customer ? _vm.element.customer.id : null,"validationName":"sepa"},model:{value:(_vm.element.sepa),callback:function ($$v) {_vm.$set(_vm.element, "sepa", $$v)},expression:"element.sepa"}}):_vm._e()],1),_c('b-col',{attrs:{"cols":"12","md":"5","xl":"4","offset-xl":"1"}},[_c('b-form-group',{attrs:{"label":"Renouvellement"}},[_c('k-form-select',{staticClass:"with-default-value",attrs:{"name":"auto_renew","options":[
                        { label: 'Automatique', value: true },
                        { label: 'Manuel', value: false },
                      ],"reduce":opt => opt.value,"clearable":_vm.element.model,"required":!_vm.element.model,"placeholder":_vm.element.model ? 'Par défaut : ' + (_vm.element.model.auto_renew ? 'Automatique' : 'Manuel') : null},model:{value:(_vm.element.auto_renew),callback:function ($$v) {_vm.$set(_vm.element, "auto_renew", $$v)},expression:"element.auto_renew"}})],1),_c('b-form-group',{attrs:{"label":"Signature du contrat"}},[_c('k-form-datepicker',{attrs:{"name":"sign_date"},model:{value:(_vm.element.sign_date),callback:function ($$v) {_vm.$set(_vm.element, "sign_date", $$v)},expression:"element.sign_date"}})],1),_c('b-form-group',{attrs:{"label":"Commercial"}},[_c('input',{attrs:{"type":"hidden","name":"team_user"},domProps:{"value":_vm.element.team_user ? _vm.element.team_user.id : null}}),_c('TeamUserSelect',{attrs:{"role":"commercial","validationName":"team_user","selectDefault":!_vm.element.id},model:{value:(_vm.element.team_user),callback:function ($$v) {_vm.$set(_vm.element, "team_user", $$v)},expression:"element.team_user"}})],1),_c('b-form-group',{attrs:{"label":"Modèle PDF"}},[_c('input',{attrs:{"type":"hidden","name":"pdf_model"},domProps:{"value":_vm.element.pdf_model ? _vm.element.pdf_model.id : null}}),_c('PdfModelSelect',{staticClass:"with-default-value",attrs:{"validationName":"pdf_model","clearable":_vm.element.model && _vm.element.model.pdf_model,"required":!_vm.element.model || !_vm.element.model.pdf_model,"placeholder":_vm.element.model && _vm.element.model.pdf_model ? 'Par défaut : ' + _vm.element.model.pdf_model.label : null},model:{value:(_vm.element.pdf_model),callback:function ($$v) {_vm.$set(_vm.element, "pdf_model", $$v)},expression:"element.pdf_model"}})],1),_c('b-form-group',{attrs:{"label":"Bon de commande client"}},[_c('k-form-input',{attrs:{"name":"customer_command_reference"},model:{value:(_vm.element.customer_command_reference),callback:function ($$v) {_vm.$set(_vm.element, "customer_command_reference", $$v)},expression:"element.customer_command_reference"}})],1)],1)],1)],1)],1)],1),(_vm.getCustomFields('contract').length > 0)?_c('b-tab',{attrs:{"title":"Champs personnalisés"}},[_c('CustomFieldsForm',{attrs:{"type":"contract","withTitle":false,"filter":_vm.element.model && _vm.element.model.restrict_custom_fields ? _vm.element.model.custom_fields : null},model:{value:(_vm.element.custom_fields),callback:function ($$v) {_vm.$set(_vm.element, "custom_fields", $$v)},expression:"element.custom_fields"}})],1):_vm._e(),_c('b-tab',{attrs:{"title":"Paramètres"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"5"}},[_c('b-form-group',{attrs:{"label":"Fréquence de facturation"}},[_c('k-form-select',{staticClass:"with-default-value",attrs:{"name":"billing_frequency","options":_vm.frequencyOptions,"reduce":opt => opt.value,"clearable":_vm.element.model,"required":!_vm.element.model,"placeholder":_vm.element.model ? _vm.defaultValue(_vm.frequencyOptions, _vm.element.model.billing_frequency) : null},model:{value:(_vm.element.billing_frequency),callback:function ($$v) {_vm.$set(_vm.element, "billing_frequency", $$v)},expression:"element.billing_frequency"}})],1),_c('b-form-group',{attrs:{"label":"Créer uniquement des échéances se terminant par le dernier jour du mois","description":"Ex. : Si un contrat commence le 15 du mois, la première échéance concernera la période du 15 au 30 et non du 15 au 15."}},[_c('b-form-radio-group',{attrs:{"name":"only_full_period","options":_vm.periodTypesOptions,"stacked":""},model:{value:(_vm.element.only_full_period),callback:function ($$v) {_vm.$set(_vm.element, "only_full_period", $$v)},expression:"element.only_full_period"}})],1),_c('b-form-group',{attrs:{"label":"Le contenu du contrat correspond"}},[_c('k-form-select',{staticClass:"with-default-value",attrs:{"name":"content_type","options":_vm.contentTypeOptions,"reduce":opt => opt.value,"clearable":_vm.element.model,"required":!_vm.element.model,"placeholder":_vm.element.model ? _vm.defaultValue(_vm.contentTypeOptions, _vm.element.model.content_type) : null},model:{value:(_vm.element.content_type),callback:function ($$v) {_vm.$set(_vm.element, "content_type", $$v)},expression:"element.content_type"}})],1),(_vm.element.content_type === 1)?_c('b-form-group',{attrs:{"label":"Les échéances correspondent à"}},[_c('k-form-select',{staticClass:"with-default-value",attrs:{"name":"deadline_for_payement","options":_vm.deadlineOptions,"reduce":opt => opt.value,"clearable":_vm.element.model && _vm.element.model && _vm.element.model.content_type === 1 && _vm.defaultValue(_vm.deadlineOptions, _vm.element.model.deadline_for_payement),"required":!(_vm.element.model && _vm.element.model && _vm.element.model.content_type === 1 && _vm.defaultValue(_vm.deadlineOptions, _vm.element.model.deadline_for_payement)),"placeholder":_vm.element.model && _vm.element.model.content_type === 1 ? _vm.defaultValue(_vm.deadlineOptions, _vm.element.model.deadline_for_payement) : null},model:{value:(_vm.element.deadline_for_payement),callback:function ($$v) {_vm.$set(_vm.element, "deadline_for_payement", $$v)},expression:"element.deadline_for_payement"}})],1):_vm._e()],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"4"}},[(!_vm.element.deadline_for_payement || _vm.element.content_type !== 1)?[_c('b-form-group',{attrs:{"label":"Créer automatiquement une facture"}},[_vm._l((_vm.createInvoiceOptions),function(option,i){return [_c('b-row',{key:i,attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-radio',{attrs:{"value":option.value,"name":"create_invoice"},model:{value:(_vm.element.create_invoice),callback:function ($$v) {_vm.$set(_vm.element, "create_invoice", $$v)},expression:"element.create_invoice"}},[_vm._v(" "+_vm._s(option.text)+" ")])],1),(option.value === true)?_c('b-col',{staticClass:"pl-0",staticStyle:{"min-width":"250px"},attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"name":"create_invoice_moment","disabled":!_vm.element.create_invoice,"options":_vm.invoiceMomentOptions,"reduce":opt => opt.value,"clearable":false,"required":"","size":"sm"},model:{value:(_vm.element.create_invoice_moment),callback:function ($$v) {_vm.$set(_vm.element, "create_invoice_moment", $$v)},expression:"element.create_invoice_moment"}})],1):_vm._e()],1)]})],2),(_vm.element.create_invoice !== false)?_c('b-form-group',{attrs:{"label":"Envoyer automatiquement la facture par email"}},[_c('b-form-radio-group',{attrs:{"name":"auto_send_invoice","options":_vm.sendInvoiceOptions,"stacked":""},model:{value:(_vm.element.auto_send_invoice),callback:function ($$v) {_vm.$set(_vm.element, "auto_send_invoice", $$v)},expression:"element.auto_send_invoice"}})],1):_vm._e()]:_vm._e()],2),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('input',{attrs:{"type":"hidden","name":"billing_contact"},domProps:{"value":_vm.element.billing_contact ? _vm.element.billing_contact.id : null}}),_c('ContactSelect',{attrs:{"label":"Contact facturation","validationName":"billing_contact","customer":_vm.element.customer,"disabled":!_vm.element.customer},model:{value:(_vm.element.billing_contact),callback:function ($$v) {_vm.$set(_vm.element, "billing_contact", $$v)},expression:"element.billing_contact"}}),(_vm.element.model)?_c('b-form-group',{attrs:{"label":"Mise à jour automatique des prix"}},[_c('k-form-select',{staticClass:"with-default-value",attrs:{"name":"auto_update_prices","options":_vm.pricesUpdateOptions,"reduce":opt => opt.value,"clearable":_vm.element.model,"required":!_vm.element.model,"placeholder":_vm.element.model ? _vm.defaultValue(_vm.pricesUpdateOptions, _vm.element.model.auto_update_prices) : null},model:{value:(_vm.element.auto_update_prices),callback:function ($$v) {_vm.$set(_vm.element, "auto_update_prices", $$v)},expression:"element.auto_update_prices"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Ne pas créer d'échéances les mois suivants"}},[_c('k-form-select',{attrs:{"name":"excluded_months[]","multiple":"","options":_vm.monthsOptions,"reduce":opt => opt.value},model:{value:(_vm.element.excluded_months),callback:function ($$v) {_vm.$set(_vm.element, "excluded_months", $$v)},expression:"element.excluded_months"}}),(!_vm.element.excluded_months || _vm.element.excluded_months.length === 0)?_c('input',{attrs:{"name":"excluded_months","type":"hidden"},domProps:{"value":null}}):_vm._e()],1)],1)],1)],1)],1),_c('b-row',{staticClass:"mt-4",attrs:{"align-v":"center"}},[_c('b-col',[_c('CatalogSearch',{attrs:{"include":{
                  product: ['vat_rate'],
                  service: ['vat_rate']
                }},on:{"selected":_vm.addCatalogLine}})],1),_c('b-col',[_c('b-button-group',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.addEmptyLine}},[_vm._v(" Ligne vide ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.addCommentLine}},[_vm._v(" Commentaire ")])],1)],1)],1),_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm table-bordered mt-1 table-document-content text-nowrap contract-form-contents"},[_c('thead',{staticClass:"thead-dark small text-center"},[_c('tr',[_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}}),_c('th',[_vm._v("Désignation")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Prix U. HT")]),_c('th',{staticStyle:{"width":"90px"}},[_vm._v("Taux TVA")]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Quantité")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Total HT")]),_c('th',{staticStyle:{"width":"25px"}})])]),(_vm.element.contents.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"7"}},[_vm._v(" Aucun contenu ")])])]):_c('draggable',{attrs:{"tag":"tbody","handle":".draggable-handle"},model:{value:(_vm.element.contents),callback:function ($$v) {_vm.$set(_vm.element, "contents", $$v)},expression:"element.contents"}},_vm._l((_vm.element.contents),function(content,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center pt-2"},[_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}),_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][is_comment]'},domProps:{"value":content.is_comment}})],1),_c('td',{staticClass:"text-wrap",attrs:{"colspan":content.is_comment ? 5 : 1}},[_c('k-form-editor',{attrs:{"name":'contents[' + i + '][designation]',"size":"sm","mode":"simple","required":"","config":_vm.commentEditorConfig},model:{value:(_vm.element.contents[i].designation),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "designation", $$v)},expression:"element.contents[i].designation"}})],1),(!content.is_comment)?_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'contents[' + i + '][unit_price_ht]',"size":"sm","readonly":content.auto_update_price},on:{"input":function($event){return _vm.calculPrices(i)}},model:{value:(_vm.element.contents[i].unit_price_ht),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "unit_price_ht", $$v)},expression:"element.contents[i].unit_price_ht"}})],1),(content.catalog && content.catalog.element)?[_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][auto_update_price]'},domProps:{"value":_vm.element.contents[i].auto_update_price}}),_c('k-form-checkbox',{staticClass:"mt-2",attrs:{"size":"sm"},on:{"input":function($event){return _vm.applyAutoPrice(i)}},model:{value:(_vm.element.contents[i].auto_update_price),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "auto_update_price", $$v)},expression:"element.contents[i].auto_update_price"}},[_vm._v(" Utiliser les prix du catalogue ")])]:_vm._e()],2):_vm._e(),(!content.is_comment)?_c('td',[_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][vat_rate]'},domProps:{"value":_vm.element.contents[i].vat_rate ? _vm.element.contents[i].vat_rate.id : null}}),_c('VatRateSelect',{attrs:{"validationName":'element.contents[' + i + '].vat_rate',"size":"sm","required":""},model:{value:(_vm.element.contents[i].vat_rate),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "vat_rate", $$v)},expression:"element.contents[i].vat_rate"}})],1):_vm._e(),(!content.is_comment)?_c('td',[_c('k-form-spinner',{attrs:{"name":'contents[' + i + '][quantity]',"size":"sm","max-decimal":2},on:{"input":function($event){return _vm.calculPrices(i)}},model:{value:(_vm.element.contents[i].quantity),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "quantity", $$v)},expression:"element.contents[i].quantity"}})],1):_vm._e(),(!content.is_comment)?_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'contents[' + i + '][total_ht]',"size":"sm","readonly":content.auto_update_price},on:{"change":function($event){return _vm.setTotalPrice(i)}},model:{value:(_vm.element.contents[i].total_ht),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "total_ht", $$v)},expression:"element.contents[i].total_ht"}})],1)],1):_vm._e(),_c('td',{staticClass:"pt-2 text-center"},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: 'Supprimer la ligne' }),expression:"{ title: 'Supprimer la ligne' }",modifiers:{"left":true}}],staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.element.contents.splice(i, 1)}}}),(content.catalog && content.catalog.element)?[_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][catalog][id]'},domProps:{"value":content.catalog?.id}}),_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][catalog][type]'},domProps:{"value":content.catalog?.type}})]:_vm._e()],2)])}),0)],1)]),_c('b-row',[_c('b-col'),_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered table-document-content align-middle"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Remise générale HT :")]),_c('td',[_c('b-input-group',[_c('k-form-number',{attrs:{"name":"discount_value","min":0},model:{value:(_vm.element.discount_value),callback:function ($$v) {_vm.$set(_vm.element, "discount_value", $$v)},expression:"element.discount_value"}}),_c('b-input-group-append',[_c('k-form-select',{attrs:{"name":"discount_type","reduce":opt => opt.id,"options":[
                        { id: 'pourcent', label: '%' },
                        { id: 'amount', label: _vm.currency.symbol }
                      ],"clearable":false},model:{value:(_vm.element.discount_type),callback:function ($$v) {_vm.$set(_vm.element, "discount_type", $$v)},expression:"element.discount_type"}})],1)],1)],1)]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total HT :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.totalHt, _vm.currency)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total TVA :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.totalTva, _vm.currency)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total TTC :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.totalTtc, _vm.currency)))])])])])])],1),_c('p',{staticClass:"mt-4"}),_c('k-form-sticky-bar',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(" Annuler ")]),_c('b-button',{staticClass:"ml-3",attrs:{"variant":"primary","type":"submit"}},[_vm._v(" Enregistrer ")])],1)],1),_c('b-modal',{attrs:{"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.continue')},on:{"cancel":_vm.cancelModelChange,"hidden":function($event){_vm.modelChangeOld = null}},model:{value:(_vm.modelChangeModal),callback:function ($$v) {_vm.modelChangeModal=$$v},expression:"modelChangeModal"}},[_c('p',{staticClass:"text-danger mb-0 font-weight-bold"},[_vm._v(" En modifiant le modèle de contrat, tous les documents fournis par le client seront supprimés. ")])])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(44696);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/mixins/ContractFormMixin.ts
var ContractFormMixin = __webpack_require__(4614);
// EXTERNAL MODULE: ./src/components/CustomerAddressSelect/CustomerAddressSelect.vue + 3 modules
var CustomerAddressSelect = __webpack_require__(29407);
// EXTERNAL MODULE: ./src/components/CustomerSepaSelect/CustomerSepaSelect.vue + 3 modules
var CustomerSepaSelect = __webpack_require__(53103);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractForm/ContractForm.ts?vue&type=script&lang=ts&external














var ContractForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractForm, _super);
    function ContractForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = {
            period_begin: null,
            period_end: null,
            road1: null,
            road2: null,
            road3: null,
            postal_code: null,
            town: null,
            country: null,
            contents: [],
            pdf_model: null,
            payment_term: null,
            payment_method: null,
            billing_frequency: 1,
            content_type: 2,
            auto_renew: false,
            only_full_period: false,
            create_invoice: false,
            create_invoice_moment: 'begin_period',
            auto_send_invoice: false,
            discount_type: 'pourcent',
            discount_value: 0,
            custom_fields: []
        };
        _this.deadlineOptions = [
            { label: 'des échéances de paiement', value: true },
            { label: 'des dates de facturation', value: false }
        ];
        _this.monthsOptions = [
            { label: 'Janvier', value: '1' },
            { label: 'Février', value: '2' },
            { label: 'Mars', value: '3' },
            { label: 'Avril', value: '4' },
            { label: 'Mai', value: '5' },
            { label: 'Juin', value: '6' },
            { label: 'Juillet', value: '7' },
            { label: 'Août', value: '8' },
            { label: 'Septembre', value: '9' },
            { label: 'Octobre', value: '10' },
            { label: 'Novembre', value: '11' },
            { label: 'Décembre', value: '12' },
        ];
        _this.modelChangeModal = false;
        _this.modelChangeOld = null;
        _this.initialized = false;
        return _this;
    }
    ContractForm.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadContractModels()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadVatRates()];
                    case 3:
                        _a.sent();
                        this.loading = false;
                        if (!this.element.id && this.element.customer) {
                            this.selectCustomer(this.element.customer);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.initialized = false;
                this.$nextTick(function () {
                    _this.initialized = true;
                });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(ContractForm.prototype, "periodTypesOptions", {
        get: function () {
            var options = [
                { text: 'Non', value: false },
                { text: 'Oui', value: true }
            ];
            if (this.element.model) {
                options.unshift({ text: 'Par défaut : ' + (this.element.model.only_full_period ? 'Oui' : 'Non'), value: null });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "createInvoiceOptions", {
        get: function () {
            var options = [
                { text: 'Non', value: false },
                { text: 'Oui', value: true }
            ];
            if (this.element.model) {
                var label = 'Par défaut : ';
                if (this.element.model.create_invoice) {
                    label += 'Oui, ' + this.defaultValue(this.invoiceMomentOptions, this.element.model.create_invoice_moment);
                }
                else {
                    label += 'Non';
                }
                options.unshift({ text: label, value: null });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "sendInvoiceOptions", {
        get: function () {
            var options = [
                { text: 'Non', value: false },
                { text: 'Oui', value: true }
            ];
            if (this.element.model) {
                var label = 'Par défaut : ' + (this.element.model.auto_send_invoice ? 'Oui' : 'Non');
                options.unshift({ text: label, value: null });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "pageTitle", {
        get: function () {
            if (this.element.id) {
                return 'Modification du contrat n°' + this.element.reference;
            }
            return 'Création d\'un contrat';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "formAction", {
        get: function () {
            var url = '/sales/contract';
            if (this.element.id) {
                url += '/' + this.element.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "formMethod", {
        get: function () {
            return this.element.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "defaultValue", {
        get: function () {
            return function (list, value) {
                if (value === null || value === undefined) {
                    return null;
                }
                var selected = list.find(function (el) { return el.value === value; });
                return selected ? 'Par défaut : ' + selected.label : null;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "totalContentHt", {
        get: function () {
            return sumBy_default()(this.contentForCalculation, 'total_ht');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "discountHt", {
        get: function () {
            var discount = this.number(this.element.discount_value);
            if (discount === 0) {
                return 0;
            }
            var total = this.totalContentHt;
            switch (this.element.discount_type) {
                case 'pourcent':
                    return this.roundNumber(this.roundNumber((total * discount / 100), 2), 2);
                case 'amount':
                    return this.roundNumber(discount, 2);
                default:
                    return 0;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "totalHt", {
        get: function () {
            return this.roundNumber(this.totalContentHt - this.discountHt, 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractForm.prototype, "totalTva", {
        get: function () {
            var _this = this;
            var rates = [];
            this.contentForCalculation.forEach(function (content) {
                var _a, _b;
                var rate = (_b = (_a = content.vat_rate) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : 0;
                var index = rates.findIndex(function (val) { return val.rate === rate; });
                if (index === -1) {
                    rates.push({
                        rate: rate,
                        ht: 0,
                        discount: 0,
                        discounted: 0
                    });
                    index = rates.length - 1;
                }
                rates[index].ht += Number(content.total_ht);
                rates[index].discounted += Number(content.total_ht);
            });
            var discountValue = this.number(this.element.discount_value);
            var discountType = this.element.discount_type;
            if (discountValue !== 0) {
                var discountPourcent_1 = discountType === 'pourcent' ? discountValue : (discountValue * 100) / this.totalHt;
                rates = rates.map(function (rate) {
                    rate.discount = _this.roundNumber(rate.ht * discountPourcent_1 / 100, 2);
                    rate.discounted = _this.roundNumber(rate.ht - rate.discount, 2);
                    return rate;
                });
                if (discountType === 'amount') {
                    var diff = this.roundNumber(sumBy_default()(rates, function (rate) { return rate.discount; }), 2);
                    if (diff !== 0) {
                        var rate = rates[0];
                        rate.discount += diff;
                        rate.discounted = rate.ht - rate.discount;
                        rates[0] = rate;
                    }
                }
            }
            var total = 0;
            forEach_default()(rates, function (rate) {
                total += _this.roundNumber(_this.number(rate.discounted) * _this.number(rate.rate) / 100, 2);
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    ContractForm.prototype.addEmptyLine = function () {
        this.element.contents.push({
            designation: null,
            unit_price_ht: 0,
            vat_rate: this.defaultVatRate,
            quantity: 1,
            total_ht: 0,
            is_comment: false
        });
    };
    ContractForm.prototype.watchCustomer = function (customer) {
        var _this = this;
        if (!this.initialized) {
            return;
        }
        if (!customer) {
            return;
        }
        if (this.hasModule('customers-group') && this.teamConfigs.customer_group_sales_parent_select && customer.parent) {
            this.element.customer = customer.parent;
            this.$nextTick(function () {
                _this.element.customer_child = customer;
            });
            return;
        }
    };
    ContractForm.prototype.watchValue = function (contract) {
        var _a, _b, _c, _d;
        contract = JSON.parse(JSON.stringify(contract));
        this.element = Object.assign({
            customer_child: null,
            period_begin: (_b = (_a = contract === null || contract === void 0 ? void 0 : contract.active_period) === null || _a === void 0 ? void 0 : _a.begin) !== null && _b !== void 0 ? _b : null,
            period_end: (_d = (_c = contract === null || contract === void 0 ? void 0 : contract.active_period) === null || _c === void 0 ? void 0 : _c.end) !== null && _d !== void 0 ? _d : null,
            model: null,
            road1: null,
            road2: null,
            road3: null,
            postal_code: null,
            town: null,
            country: null,
            contents: [],
            discount_type: 'pourcent',
            discount_value: 0,
            pdf_model: null,
            payment_term: null,
            payment_method: null,
            billing_frequency: 1,
            content_type: 2,
            auto_renew: false,
            only_full_period: false,
            create_invoice: false,
            create_invoice_moment: 'begin_period',
            auto_send_invoice: false,
            custom_fields: [],
        }, this.element.id === undefined ? this.getDefaultParams() : {}, contract);
    };
    ContractForm.prototype.watchModel = function (value, old) {
        var _a, _b, _c, _d, _e;
        if (!((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) || !((_c = (_b = this.value) === null || _b === void 0 ? void 0 : _b.model) === null || _c === void 0 ? void 0 : _c.id) || ((_e = (_d = this.value) === null || _d === void 0 ? void 0 : _d.model) === null || _e === void 0 ? void 0 : _e.id) === (value === null || value === void 0 ? void 0 : value.id)) {
            return;
        }
        this.modelChangeModal = true;
        this.modelChangeOld = old;
    };
    ContractForm.prototype.cancelModelChange = function (event) {
        event.preventDefault();
        this.element.model = this.modelChangeOld;
        this.modelChangeModal = false;
        this.modelChangeOld = null;
    };
    ContractForm.prototype.selectCustomer = function (customer) {
        var _a;
        if (customer && customer.address_invoice) {
            this.selectAddress(customer.address_invoice);
        }
        this.element.contact = null;
        this.element.billing_contact = (_a = customer === null || customer === void 0 ? void 0 : customer.billing_contact) !== null && _a !== void 0 ? _a : null;
        this.element.sepa = null;
        this.element.customer_child = null;
    };
    ContractForm.prototype.selectAddress = function (address) {
        this.element.road1 = address.road1;
        this.element.road2 = address.road2;
        this.element.road3 = address.road3;
        this.element.postal_code = address.postal_code;
        this.element.town = address.town;
        this.element.country = address.country;
    };
    ContractForm.prototype.selectModel = function (model) {
        var _a;
        if (model === null) {
            this.element = Object.assign(this.element, this.getDefaultParams());
            return;
        }
        this.element = Object.assign(this.element, {
            pdf_model: null,
            payment_term: null,
            payment_method: null,
            billing_frequency: null,
            content_type: null,
            auto_renew: null,
            only_full_period: null,
            create_invoice: null,
            auto_send_invoice: null
        });
        if (!this.element.quotation_id) {
            this.element.contents = (_a = model.contents) === null || _a === void 0 ? void 0 : _a.map(function (content) {
                var _a, _b;
                if (!content.is_comment) {
                    content.designation = (_b = (_a = content.catalog.element) === null || _a === void 0 ? void 0 : _a.designation) !== null && _b !== void 0 ? _b : null;
                }
                return content;
            });
        }
    };
    ContractForm.prototype.getDefaultParams = function () {
        var _a, _b, _c;
        return {
            pdf_model: (_a = this.pdfModels.find(function (model) { return model.use_invoice; })) !== null && _a !== void 0 ? _a : null,
            payment_term: (_b = this.paymentTerms[0]) !== null && _b !== void 0 ? _b : null,
            payment_method: (_c = this.paymentMethods[0]) !== null && _c !== void 0 ? _c : null,
            billing_frequency: 1,
            content_type: 2,
            auto_renew: false,
            only_full_period: false,
            create_invoice: false,
            create_invoice_moment: 'begin_period',
            auto_send_invoice: false
        };
    };
    ContractForm.prototype.getDurationUnit = function (unit) {
        switch (unit) {
            case 1: return 'day';
            case 2: return 'month';
            default: return 'year';
        }
    };
    ContractForm.prototype.selectBegin = function (begin) {
        var _a, _b, _c, _d, _e, _f, _g;
        var model = this.element.model;
        if (!model || !begin) {
            return;
        }
        if (this.element.id
            && ((_a = this.element.model) === null || _a === void 0 ? void 0 : _a.id) === ((_c = (_b = this.value) === null || _b === void 0 ? void 0 : _b.model) === null || _c === void 0 ? void 0 : _c.id)
            && this.element.period_begin === ((_e = (_d = this.value) === null || _d === void 0 ? void 0 : _d.active_period) === null || _e === void 0 ? void 0 : _e.begin)
            && this.element.period_end === ((_g = (_f = this.value) === null || _f === void 0 ? void 0 : _f.active_period) === null || _g === void 0 ? void 0 : _g.end)) {
            return;
        }
        this.element.period_end = external_moment_default()(begin)
            .add(model.duration_value, this.getDurationUnit(model.duration_type))
            .subtract(1, 'day')
            .format('YYYY-MM-DD');
    };
    ContractForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({ name: 'contract-item', params: { id: String(response.data.id) } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractForm.prototype.cancel = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.element.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$router.push({ name: 'contract-item', params: { id: String(this.element.id) } })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.$router.push({ name: 'contract-list' })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('element.customer')
    ], ContractForm.prototype, "watchCustomer", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ContractForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('element.model', { deep: true })
    ], ContractForm.prototype, "watchModel", null);
    ContractForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomerSelect: customers_vue_.CustomerSelect, ContactSelect: customers_vue_.ContactSelect,
                TeamUserSelect: interface_vue_.TeamUserSelect, Spinner: interface_vue_.Spinner,
                KFormDatepicker: form_vue_.KFormDatepicker, KFormAddress: form_vue_.KFormAddress,
                CustomerAddressSelect: CustomerAddressSelect/* default */.A,
                CustomerSepaSelect: CustomerSepaSelect/* default */.A,
                BAlert: external_bootstrap_vue_.BAlert, BFormRadio: external_bootstrap_vue_.BFormRadio, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BModal: external_bootstrap_vue_.BModal, BButtonGroup: external_bootstrap_vue_.BButtonGroup, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm
            },
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries', 'loadVatRates'])), (0,external_vuex_.mapActions)('sales', ['loadContractModels'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries', 'paymentMethods', 'paymentTerms'])), (0,external_vuex_.mapGetters)('globalDatas', ['defaultVatRate'])), (0,external_vuex_.mapState)('sales', ['contractModels', 'pdfModels'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], ContractForm);
    return ContractForm;
}((0,lib/* Mixins */.Xe)(ContractFormMixin/* default */.A)));
/* harmony default export */ var ContractFormvue_type_script_lang_ts_external = (ContractForm);

;// ./src/components/ContractForm/ContractForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractForm_ContractFormvue_type_script_lang_ts_external = (ContractFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractForm/ContractForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractForm_ContractFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractForm_ContractForm = (component.exports);

/***/ }),

/***/ 8235:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ 8446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PaymentItem_PaymentItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentItem/PaymentItem.vue?vue&type=template&id=2825519e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.editState)?_c('FormModal',{attrs:{"title":"Détail du paiement","size":"payment","scrollable":"","body-class":"p-4"},on:{"hidden":function($event){return _vm.$emit('hidden')}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-form-row',{staticClass:"w-100"},[_c('b-col',[(_vm.canBeUpdated && _vm.withActions)?[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.editState = true}}},[_vm._v(" Modifier ")]),_c('CancelPayment',{on:{"closed":function($event){return _vm.$emit('hidden')},"deleted":payment => _vm.$emit('deleted', payment)},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]:_vm._e()],2),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" Fermer ")])],1)],1)]}}],null,false,1251349695),model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.value.sepa_deposit)?_c('p',{staticClass:"text-center"},[_c('b-button',{attrs:{"size":"sm","variant":"primary","to":{ name: 'sepa-deposit-item', params: { id: String(_vm.value.sepa_deposit.id) } }}},[_vm._v(" Voir la remise de prélèvement liée ")])],1):_vm._e(),(_vm.value.account)?_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Compte bancaire","label-cols-md":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.value.account.name)+" ")]):_vm._e(),(_vm.value.payment_method)?_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Mode de règlement","label-cols-md":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.value.payment_method.label)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Date du paiement","label-cols-md":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.date))+" ")]),(_vm.value.reference)?_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Référence","label-cols-md":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.value.reference)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Montant","label-cols":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.amount, _vm.value.currency))+" ")]),_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm table-bordered mb-4 align-middle payment-form-linked-documents text-nowrap"},[_c('thead',[_c('tr',{staticClass:"small text-center"},[_c('th',[_vm._v("Date")]),_c('th',[_vm._v("N° document")]),_c('th',[_vm._v("À payer")]),_c('th',[_vm._v("Montant")])])]),_c('tbody',{staticStyle:{"font-size":".8rem"}},[(_vm.value.documents.length === 0)?_c('tr',[_c('td',{staticClass:"p-4 text-center",attrs:{"colspan":"4"}},[_vm._v(" Aucun document ")])]):_vm._e(),_vm._l((_vm.value.documents),function(document,i){return [_c('tr',{key:i,class:{ withGuaranteeHoldbackTop: document.guarantee_holdback }},[_c('td',[_c('router-link',{attrs:{"to":_vm.routerLink(document)}},[_vm._v(" "+_vm._s(_vm.date(document.document.date))+" ")])],1),_c('td',[_c('router-link',{attrs:{"to":_vm.routerLink(document)}},[_vm._v(" "+_vm._s(document.document.reference)+" ")])],1),_c('td',{staticClass:"text-right"},[_c('router-link',{attrs:{"to":_vm.routerLink(document)}},[_vm._v(" "+_vm._s(_vm.formattedNumber(document.document.stay_to_pay, document.document.currency))+" ")])],1),_c('td',{staticClass:"text-right"},[_c('router-link',{attrs:{"to":_vm.routerLink(document)}},[_vm._v(" "+_vm._s(_vm.formattedNumber(document.ttc, _vm.value.currency))+" ")])],1)]),(document.guarantee_holdback)?_c('tr',{key:'guarantee-' + i,staticClass:"withGuaranteeHoldbackBottom"},[_c('td',{staticClass:"font-weight-bold",attrs:{"colspan":"4"}},[_vm._v(" Paye la retenue de garantie ")])]):_vm._e()]})],2),_c('tfoot',[_c('tr',{class:{
              small: true,
              'text-danger': _vm.stayAmount < 0,
              'text-success': _vm.stayAmount > 0,
            }},[_c('th',{staticClass:"text-right",attrs:{"colspan":"3"}},[_vm._v(" Solde du paiement : ")]),_c('th',{staticClass:"text-right"},[(_vm.stayAmount > 0)?[_vm._v("+")]:_vm._e(),_vm._v(" "+_vm._s(this.formattedNumber(_vm.stayAmount, this.value.currency))+" ")],2)])])])]),(_vm.value.comments)?_c('b-form-group',{attrs:{"label":"Commentaires"}},[_c('TextareaView',{attrs:{"value":_vm.value.comments}})],1):_vm._e(),(_vm.value.currency && _vm.value.currency.id !== _vm.currency.id)?_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Devise","label-cols":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.value.currency.code)+" ("+_vm._s(_vm.value.currency.symbol)+") ")]):_vm._e(),(_vm.value.currency && _vm.value.currency.id !== _vm.currency.id)?_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Taux de change","label-cols":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.exchange_rate, false))+" "+_vm._s(_vm.value.currency.symbol)+" = 1 "+_vm._s(_vm.currency.symbol)+" ")]):_vm._e(),(_vm.value.payment_method && _vm.value.payment_method.type && _vm.value.payment_method.type.id === 2 && (_vm.value.check_bank || _vm.value.check_issuer))?[_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Remise de chèque ")]),(_vm.value.check_bank)?_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Banque émettrice","label-cols":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.value.check_bank)+" ")]):_vm._e(),(_vm.value.check_issuer)?_c('b-form-group',{attrs:{"label-class":"pt-0","label":"Émetteur du chèque","label-cols":_vm.labelCols}},[_vm._v(" "+_vm._s(_vm.value.check_issuer)+" ")]):_vm._e()]:_vm._e()],2):_vm._e(),_c('PaymentForm',{attrs:{"modal":_vm.editState},on:{"hidden":function($event){_vm.editState = false}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./src/components/PaymentForm/PaymentForm.vue + 7 modules
var PaymentForm = __webpack_require__(88274);
// EXTERNAL MODULE: ./src/components/CancelPayment/CancelPayment.vue + 3 modules
var CancelPayment = __webpack_require__(30404);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(95093);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentItem/PaymentItem.ts?vue&type=script&lang=ts&external









var PaymentItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentItem, _super);
    function PaymentItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.editState = false;
        _this.labelCols = 4;
        return _this;
    }
    PaymentItem.prototype.mounted = function () {
        interface_vue_.emitter.on('paymentDeleted', this.paymentDeleted);
    };
    PaymentItem.prototype.destroyed = function () {
        interface_vue_.emitter.off('paymentDeleted', this.paymentDeleted);
    };
    Object.defineProperty(PaymentItem.prototype, "canBeUpdated", {
        get: function () {
            var closed = this.team.sales['closed_period'];
            if (closed) {
                return moment_default()(this.value.date).isAfter(closed);
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentItem.prototype, "stayAmount", {
        get: function () {
            var _this = this;
            return this.number(this.value.amount) - this.roundNumber(sumBy_default()(this.value.documents, function (value) { return _this.number(value.ttc); }), 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentItem.prototype, "routerLink", {
        get: function () {
            return function (use) { return ({
                name: use.document_type + '-item',
                params: {
                    id: String(use.document_id)
                }
            }); };
        },
        enumerable: false,
        configurable: true
    });
    PaymentItem.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    PaymentItem.prototype.paymentDeleted = function (payment) {
        if (payment.id === this.value.id) {
            this.modalState = false;
            this.editState = false;
            this.$emit('hidden');
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PaymentItem.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], PaymentItem.prototype, "withActions", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], PaymentItem.prototype, "watchModal", null);
    PaymentItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency', 'team'])),
            components: {
                PaymentForm: PaymentForm/* default */.A,
                CancelPayment: CancelPayment/* default */.A,
                FormModal: interface_vue_.FormModal,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol,
                TextareaView: interface_vue_.TextareaView
            }
        })
    ], PaymentItem);
    return PaymentItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var PaymentItemvue_type_script_lang_ts_external = (PaymentItem);

;// ./src/components/PaymentItem/PaymentItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentItem_PaymentItemvue_type_script_lang_ts_external = (PaymentItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PaymentItem/PaymentItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PaymentItem_PaymentItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentItem_PaymentItem = (component.exports);

/***/ }),

/***/ 8477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PageBreakLine_PageBreakLine; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/PageBreakLine/PageBreakLine.vue?vue&type=template&id=72de0734
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{on:{"click":_vm.setLocationEditing}},[_c('td',[(_vm.document.contents.length > 1)?_c('font-awesome-icon',{ref:"moveBtn",staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e()],1),_c('td',{staticClass:"text-center p-3",attrs:{"colspan":_vm.colspan}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.lines.pageBreak'))+" ")]),_c('td',[_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('is_pagebreak')},domProps:{"value":true}}),(_vm.value.affair_content_id)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('affair_content')},domProps:{"value":_vm.value.affair_content_id}}):_vm._e(),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],ref:"deleteBtn",staticClass:"p-0",attrs:{"variant":"link","title":"Supprimer la ligne"}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":_vm.deleteLine}})],1),(_vm.editing)?_c('LineMenu',{attrs:{"line":_vm.value},on:{"add":event => _vm.$emit('addSubLine', event)}}):_vm._e()],1)])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentLineMixin.ts + 4 modules
var SalesDocumentLineMixin = __webpack_require__(54575);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/PageBreakLine/PageBreakLine.ts?vue&type=script&lang=ts&external




var PageBreakLine = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PageBreakLine, _super);
    function PageBreakLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PageBreakLine.prototype, "colspan", {
        get: function () {
            var document = this.document;
            var colspan = 5;
            if (!document.use_global_vatrate) {
                colspan++;
            }
            if (document.secondary_quantity_mode !== 'disable') {
                colspan++;
            }
            if (document.input_options.col_reference) {
                colspan++;
            }
            if (document.input_options.col_picture) {
                colspan++;
            }
            if (document.input_options.col_number) {
                colspan++;
            }
            return colspan;
        },
        enumerable: false,
        configurable: true
    });
    PageBreakLine = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], PageBreakLine);
    return PageBreakLine;
}((0,lib/* Mixins */.Xe)(SalesDocumentLineMixin/* default */.A)));
/* harmony default export */ var PageBreakLinevue_type_script_lang_ts_external = (PageBreakLine);

;// ./src/components/Form/PageBreakLine/PageBreakLine.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PageBreakLine_PageBreakLinevue_type_script_lang_ts_external = (PageBreakLinevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/PageBreakLine/PageBreakLine.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PageBreakLine_PageBreakLinevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PageBreakLine_PageBreakLine = (component.exports);

/***/ }),

/***/ 8998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarForm_CarForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarForm/CarForm.vue?vue&type=template&id=6689339b
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":_vm.modalTitle},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[(!_vm.customer)?[_c('input',{attrs:{"type":"hidden","name":"customer"},domProps:{"value":_vm.car.customer?.id}}),_c('CustomerSelect',{attrs:{"validationName":"customer","required":""},model:{value:(_vm.car.customer),callback:function ($$v) {_vm.$set(_vm.car, "customer", $$v)},expression:"car.customer"}})]:(!_vm.car.id)?[_c('input',{attrs:{"type":"hidden","name":"customer"},domProps:{"value":_vm.customer.id}})]:_vm._e(),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Marque"}},[_c('input',{attrs:{"type":"hidden","name":"brand"},domProps:{"value":_vm.car.brand?.name ?? _vm.car.brand}}),_c('k-form-select',{attrs:{"options":_vm.brands,"label":"name","validationName":"brand","required":"","clearable":false,"taggable":""},on:{"input":_vm.brandUpdated},model:{value:(_vm.car.brand),callback:function ($$v) {_vm.$set(_vm.car, "brand", $$v)},expression:"car.brand"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Modèle"}},[_c('input',{attrs:{"type":"hidden","name":"model"},domProps:{"value":_vm.car.model?.name ?? _vm.car.model}}),_c('k-form-select',{attrs:{"validationName":"model","options":_vm.models,"label":"name","required":"","clearable":false,"taggable":"","disabled":!_vm.car.brand},model:{value:(_vm.car.model),callback:function ($$v) {_vm.$set(_vm.car, "model", $$v)},expression:"car.model"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Immatriculation"}},[_c('k-form-input',{attrs:{"name":"numberplate","required":""},model:{value:(_vm.car.numberplate),callback:function ($$v) {_vm.$set(_vm.car, "numberplate", $$v)},expression:"car.numberplate"}})],1),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Kilométrage"}},[_c('b-input-group',{attrs:{"append":"km"}},[_c('k-form-number',{attrs:{"name":"mileage","maxDecimal":0,"min":0,"noDefaultValue":""},model:{value:(_vm.car.mileage),callback:function ($$v) {_vm.$set(_vm.car, "mileage", $$v)},expression:"car.mileage"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"1ère immatriculation"}},[_c('k-form-datepicker',{attrs:{"name":"first_circulation_date"},model:{value:(_vm.car.first_circulation_date),callback:function ($$v) {_vm.$set(_vm.car, "first_circulation_date", $$v)},expression:"car.first_circulation_date"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Numéro de série"}},[_c('k-form-input',{attrs:{"name":"vin"},model:{value:(_vm.car.vin),callback:function ($$v) {_vm.$set(_vm.car, "vin", $$v)},expression:"car.vin"}})],1),_c('b-form-group',{attrs:{"label":"Commentaires"}},[_c('k-form-textarea',{attrs:{"name":"comments"},model:{value:(_vm.car.comments),callback:function ($$v) {_vm.$set(_vm.car, "comments", $$v)},expression:"car.comments"}})],1)],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarForm/CarForm.ts?vue&type=script&lang=ts&external








var CarForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarForm, _super);
    function CarForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.car = {};
        return _this;
    }
    CarForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadBrands()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CarForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            return (((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'Modification' : 'Création') + ' d\'un véhicule';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/automotive/car';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarForm.prototype, "models", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.car.brand) === null || _a === void 0 ? void 0 : _a.models) !== null && _b !== void 0 ? _b : [];
        },
        enumerable: false,
        configurable: true
    });
    CarForm.prototype.watchModal = function () {
        this.modalState = this.modal;
    };
    CarForm.prototype.valueChanged = function () {
        var _a;
        this.car = JSON.parse(JSON.stringify((_a = this.value) !== null && _a !== void 0 ? _a : {
            brand: null,
            model: null
        }));
    };
    CarForm.prototype.brandUpdated = function () {
        external_vue_default().set(this.car, 'model', null);
    };
    CarForm.prototype.submitComplete = function (response) {
        var _a;
        var car = response.data;
        interface_vue_.emitter.emit(((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'CarFormCreated' : 'CarFormUpdated', car);
        this.$emit('submitComplete', car);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarForm.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CarForm.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CarForm.prototype, "valueChanged", null);
    CarForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormDatepicker: form_vue_.KFormDatepicker, KFormTextarea: form_vue_.KFormTextarea, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect,
                CustomerSelect: customers_vue_.CustomerSelect
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('automotive', ['brands'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('automotive', ['loadBrands']))
        })
    ], CarForm);
    return CarForm;
}((external_vue_default())));
/* harmony default export */ var CarFormvue_type_script_lang_ts_external = (CarForm);

;// ./src/components/CarForm/CarForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarForm_CarFormvue_type_script_lang_ts_external = (CarFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarForm/CarForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarForm_CarFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarForm_CarForm = (component.exports);

/***/ }),

/***/ 9033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(34840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm; },
  O5: function() { return /* reexport */ Emit; },
  Xe: function() { return /* reexport */ mixins; },
  kv: function() { return /* reexport */ Prop; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: Inject, InjectReactive, Model, ModelSync, PropSync, Provide, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) // removed by dead control flow
{}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) // removed by dead control flow
{}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FH: function() { return /* binding */ fetchSignature; },
/* harmony export */   UI: function() { return /* binding */ signatureRelations; },
/* harmony export */   b6: function() { return /* binding */ needFetchSignature; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var signatureRelations = [
    'teamUser', 'signatories', 'documents'
];
var needFetchSignature = function (model) {
    return !signatureRelations.every(function (relation) { return relation in model; });
};
var fetchSignature = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/signature/' + id, {
                    params: {
                        include: signatureRelations.join(','),
                        with_document: true
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 10247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   XF: function() { return /* binding */ sepaDepositRelations; },
/* harmony export */   gK: function() { return /* binding */ needFetchSepaDeposit; },
/* harmony export */   qP: function() { return /* binding */ fetchSepaDeposit; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var sepaDepositRelations = [
    'account', 'contents', 'contents.sepa', 'contents.invoice', 'contents.payment'
];
var needFetchSepaDeposit = function (model) {
    return !sepaDepositRelations.every(function (relation) { return relation in model; });
};
var fetchSepaDeposit = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/sales/sepa-deposit/' + id, {
                    params: {
                        include: sepaDepositRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 10392:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 10586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractParams_ContractParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractParams/ContractParams.vue?vue&type=template&id=6983db18
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.params.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceDay')))])])]),_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap",attrs:{"responsive":""}},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_contract_reference_prefix]","required":"","max":"10","size":"sm","validate":"sepaReference"},model:{value:(_vm.localConfig.sales_contract_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_reference_prefix", $$v)},expression:"localConfig.sales_contract_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_contract_reference_number]","min":1,"maxDecimal":0,"size":"sm"},model:{value:(_vm.localConfig.sales_contract_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_reference_number", $$v)},expression:"localConfig.sales_contract_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_contract_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_contract_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_reference_length", $$v)},expression:"localConfig.sales_contract_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.sepaReferenceExample))])])])]),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractParams/ContractParams.ts?vue&type=script&lang=ts&external





var ContractParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractParams, _super);
    function ContractParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        return _this;
    }
    ContractParams.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    ContractParams.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return null;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    Object.defineProperty(ContractParams.prototype, "sepaReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_contract_reference_prefix, this.localConfig.sales_contract_reference_number, this.localConfig.sales_contract_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    ContractParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber,
                BTableSimple: external_bootstrap_vue_.BTableSimple, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], ContractParams);
    return ContractParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var ContractParamsvue_type_script_lang_ts_external = (ContractParams);

;// ./src/components/ContractParams/ContractParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractParams_ContractParamsvue_type_script_lang_ts_external = (ContractParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractParams/ContractParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractParams_ContractParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractParams_ContractParams = (component.exports);

/***/ }),

/***/ 10776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(30756),
    keys = __webpack_require__(95950);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FecExport_FecExport; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FecExport/FecExport.vue?vue&type=template&id=8385b88a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.initLoading)?_c('Spinner'):_c('k-form',{attrs:{"value":_vm.formDatas,"action":_vm.apiUrl},on:{"submitComplete":_vm.formSubmitted,"submitError":_vm.formError}},[(_vm.accountantMode === false)?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" L'export comptable est un fichier FEC provisoire ")]),_vm._v(" Attention , il ne s'agit pas d'un fichier FEC officiel qui doit toujours être produit par votre logiciel de comptabilité ou par votre expert-comptable. Son rôle est uniquement de faciliter le transfert de vos écritures comptables entre Kwixéo et votre logiciel de comptabilité. ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Données à exporter"}},[_c('k-form-checkbox',{attrs:{"value":"sales"},model:{value:(_vm.types),callback:function ($$v) {_vm.types=$$v},expression:"types"}},[_vm._v(" Journal des ventes ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"value":"charges"},model:{value:(_vm.types),callback:function ($$v) {_vm.types=$$v},expression:"types"}},[_vm._v(" Journal des achats ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"value":"bank"},model:{value:(_vm.types),callback:function ($$v) {_vm.types=$$v},expression:"types"}},[_vm._v(" Journal de banque ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"value":"cash"},model:{value:(_vm.types),callback:function ($$v) {_vm.types=$$v},expression:"types"}},[_vm._v(" Journal de caisse ")])],1),_c('b-form-group',{staticClass:"my-4",attrs:{"label":"Période"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"auto"}},[_vm._v("Du ")]),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"max-date":_vm.end},model:{value:(_vm.begin),callback:function ($$v) {_vm.begin=$$v},expression:"begin"}})],1),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_vm._v(" au ")]),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"min-date":_vm.begin},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],1)],1),_c('k-form-checkbox',{model:{value:(_vm.markAsExported),callback:function ($$v) {_vm.markAsExported=$$v},expression:"markAsExported"}},[_vm._v(" Marquer les éléments comme exportés ")]),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.onlyUnexported),callback:function ($$v) {_vm.onlyUnexported=$$v},expression:"onlyUnexported"}},[_vm._v(" Exporter uniquement les éléments qui n'ont jamais été exportés ")]),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.exportFiles),callback:function ($$v) {_vm.exportFiles=$$v},expression:"exportFiles"}},[_c('strong',[_vm._v("Joindre les pièces justificatives")])]),_c('b-button',{staticClass:"mt-4",attrs:{"variant":"primary","type":"submit"}},[_vm._v(" Exporter ")])],1),(_vm.noDataToExport)?_c('b-modal',{attrs:{"visible":"","ok-only":"","ok-title":_vm.$t('interface.close')},on:{"hidden":function($event){_vm.noDataToExport = false}}},[_c('p',{staticClass:"text-center mb-0"},[_vm._v(" Aucune donnée à exporter ")])]):_vm._e(),(_vm.exportFec)?_c('b-modal',{attrs:{"visible":"","ok-only":"","ok-title":_vm.$t('interface.close')},on:{"hidden":function($event){_vm.exportFec = null}}},[(_vm.exportFec.status < 3)?[_c('b-progress',{staticClass:"mb-3",attrs:{"max":_vm.exportFec.nb_items,"show-progress":"","animated":"","variant":"warning"}},[_c('b-progress-bar',{attrs:{"value":_vm.exportFec.nb_processed,"label":`${((_vm.exportFec.nb_processed / _vm.exportFec.nb_items) * 100).toFixed(2)}%`}})],1),_c('p',{staticClass:"text-center"},[_vm._v(" L'export du fichier FEC est en cours."),_c('br')]),_c('p',{staticClass:"text-justify mb-0"},[_vm._v(" Vous pouvez fermer cette popup, vous recevrez un email avec un lien de téléchargement lorsque l'export sera terminé. ")])]:_vm._e(),(_vm.exportFec.status === 3)?_c('p',{staticClass:"text-center mb-0"},[_c('b-overlay',{attrs:{"visible":_vm.loading}},[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.download(_vm.exportFec.id)}}},[_vm._v(" Télécharger ")])],1)],1):_vm._e()],2):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/mixins/FecMixin.ts
var FecMixin = __webpack_require__(67912);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FecExport/FecExport.ts?vue&type=script&lang=ts&external






var FecExport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FecExport, _super);
    function FecExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.types = ['sales', 'charges', 'bank', 'cash'];
        _this.exportFiles = false;
        _this.begin = null;
        _this.end = null;
        _this.markAsExported = true;
        _this.onlyUnexported = true;
        _this.noDataToExport = false;
        _this.exportFec = null;
        _this.params = {};
        _this.initLoading = false;
        return _this;
    }
    FecExport.prototype.mounted = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.loadConfig()];
                    case 1:
                        _b.sent();
                        this.exportFiles = (_a = this.params.always_add_files) !== null && _a !== void 0 ? _a : false;
                        interface_vue_.emitter.on('FecExportUpdated', this.fecExportUpdated);
                        return [2 /*return*/];
                }
            });
        });
    };
    FecExport.prototype.loadConfig = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initLoading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get(this.apiUrl.replace('export', 'config'))
                                .then(function (response) {
                                _this.params = response.data;
                                _this.initLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FecExport.prototype.destroyed = function () {
        interface_vue_.emitter.off('FecExportUpdated', this.fecExportUpdated);
    };
    Object.defineProperty(FecExport.prototype, "formDatas", {
        get: function () {
            return {
                datas: this.types,
                begin: this.begin,
                end: this.end,
                mark_exported: this.markAsExported,
                only_unexported: this.onlyUnexported,
                with_files: this.exportFiles
            };
        },
        enumerable: false,
        configurable: true
    });
    FecExport.prototype.formSubmitted = function (response) {
        this.exportFec = response.data;
    };
    FecExport.prototype.formError = function (error) {
        var _a;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
            this.noDataToExport = true;
        }
    };
    FecExport.prototype.fecExportUpdated = function (fecExport) {
        if (this.exportFec && this.exportFec.id === fecExport.id) {
            this.exportFec = fecExport;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], FecExport.prototype, "accountantMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/fec/export' })
    ], FecExport.prototype, "apiUrl", void 0);
    FecExport = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox, KFormDatepicker: form_vue_.KFormDatepicker,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert, BProgress: external_bootstrap_vue_.BProgress, BProgressBar: external_bootstrap_vue_.BProgressBar, BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            }
        })
    ], FecExport);
    return FecExport;
}((0,lib/* Mixins */.Xe)(FecMixin/* default */.A)));
/* harmony default export */ var FecExportvue_type_script_lang_ts_external = (FecExport);

;// ./src/components/FecExport/FecExport.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FecExport_FecExportvue_type_script_lang_ts_external = (FecExportvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/FecExport/FecExport.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FecExport_FecExportvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FecExport_FecExport = (component.exports);

/***/ }),

/***/ 11025:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ 11040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StripeConfig_StripeConfig; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StripeConfig/StripeConfig.vue?vue&type=template&id=4b7671bd
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.team.stripe_logged)?[_c('b-card',[_c('p',{staticClass:"text-success font-weight-bold"},[_vm._v(" Vous êtes actuellement connecté à Stripe. ")]),(!_vm.team.stripe_enabled)?_c('p',{staticClass:"text-danger font-weight-bold mb-0"},[_vm._v(" Votre compte n'a pas été validé par Stripe pour recevoir des paiements ")]):[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Votre compte est configuré pour recevoir des paiements en lignes. ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" Rendez-vous sur une fiche devis pour demander le paiement d'un acompte à votre client ou sur une fiche facture pour envoyer un lien de paiement. ")])]],2),(_vm.team.stripe_enabled)?[_c('b-tabs',{staticClass:"tabs-card mt-5"},[_c('b-tab',{attrs:{"title":"Configuration"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":"Envoyer une notification aux utilisateurs suivants lorsqu'un paiement est effectué :"}},[(_vm.localConfig.stripe_notifications_users && _vm.localConfig.stripe_notifications_users.length === 0)?_c('input',{attrs:{"type":"hidden","name":'configs[stripe_notifications_users]'},domProps:{"value":null}}):_vm._e(),_vm._l((_vm.localConfig.stripe_notifications_users),function(user,i){return _c('input',{key:i,attrs:{"type":"hidden","name":'configs[stripe_notifications_users][' + i + ']'},domProps:{"value":user.id}})}),_c('k-form-select',{attrs:{"ajax":_vm.userApiUrl,"label":"fullname","multiple":""},model:{value:(_vm.localConfig.stripe_notifications_users),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_notifications_users", $$v)},expression:"localConfig.stripe_notifications_users"}}),_c('input',{attrs:{"type":"hidden","name":'configs[stripe_notifications_commercial]'},domProps:{"value":_vm.localConfig.stripe_notifications_commercial}}),_c('k-form-checkbox',{staticClass:"mt-2 mb-2",model:{value:(_vm.localConfig.stripe_notifications_commercial),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_notifications_commercial", $$v)},expression:"localConfig.stripe_notifications_commercial"}},[_vm._v(" Envoyer également une notification au commercial sélectionné sur le document ")])],2),_c('b-form-group',{attrs:{"label":"Email de contact","description":"Cet email sera affiché dans les emails de demande de paiement"}},[_c('k-form-input',{attrs:{"type":"email","required":"","name":"configs[stripe_contact_email]"},model:{value:(_vm.localConfig.stripe_contact_email),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_contact_email", $$v)},expression:"localConfig.stripe_contact_email"}})],1),_c('b-form-group',{attrs:{"label":"Moyen de paiement","description":"Ce moyen de paiement sera utilisé pour l'ajout des paiements sur les factures"}},[_c('PaymentMethodSelect',{attrs:{"required":"","name":"configs[stripe_payment_method]","reduce":opt => opt.id},model:{value:(_vm.localConfig.stripe_payment_method),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_payment_method", $$v)},expression:"localConfig.stripe_payment_method"}})],1),_c('b-form-group',{staticClass:"mb-5",attrs:{"label":"Compte bancaire","description":"Ce compte bancaire sera utilisé pour l'ajout des paiements"}},[_c('AccountSelect',{attrs:{"name":"configs[stripe_account]","reduce":opt => opt.id},model:{value:(_vm.localConfig.stripe_account),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_account", $$v)},expression:"localConfig.stripe_account"}})],1),(_vm.hasModule('sales-commands') || _vm.hasModule('sales-deliveries'))?_c('b-form-group',{staticClass:"mb-5",attrs:{"label":"Lorsqu'un paiement est effectué sur un devis :"}},[_c('p',{staticClass:"text-muted mb-3 small"},[_vm._v(" Lorsqu'un paiement est effectué à partir d'un devis, une facture sera automatiquement créée. ")]),(_vm.hasModule('sales-commands'))?_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_quotation_command_active]"},domProps:{"value":_vm.localConfig.stripe_quotation_command_active ? true : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stripe_quotation_command_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_quotation_command_active", $$v)},expression:"localConfig.stripe_quotation_command_active"}},[_vm._v(" Créer automatiquement un bon de commande au statut ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"name":"configs[stripe_quotation_command_status]","size":"sm","reduce":opt => opt.value,"options":[
                  { value: 1, label: 'Brouillon' },
                  { value: 2, label: 'Validé' }
                ],"clearable":false,"disabled":!_vm.localConfig.stripe_quotation_command_active},model:{value:(_vm.localConfig.stripe_quotation_command_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_quotation_command_status", $$v)},expression:"localConfig.stripe_quotation_command_status"}})],1)],1):_vm._e(),(_vm.hasModule('sales-deliveries'))?_c('b-row',{staticClass:"mt-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_quotation_delivery_active]"},domProps:{"value":_vm.localConfig.stripe_quotation_delivery_active ? true : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stripe_quotation_delivery_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_quotation_delivery_active", $$v)},expression:"localConfig.stripe_quotation_delivery_active"}},[_vm._v(" Créer automatiquement un bon de livraison au statut ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"name":"configs[stripe_quotation_delivery_status]","size":"sm","reduce":opt => opt.value,"options":[
                  { value: 1, label: 'Brouillon' },
                  { value: 2, label: 'Validé' }
                ],"clearable":false,"disabled":!_vm.localConfig.stripe_quotation_delivery_active},model:{value:(_vm.localConfig.stripe_quotation_delivery_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_quotation_delivery_status", $$v)},expression:"localConfig.stripe_quotation_delivery_status"}})],1)],1):_vm._e()],1):_vm._e(),(_vm.hasModule('sales-commands'))?_c('b-form-group',{attrs:{"label":"Lorsqu'un paiement est effectué sur un bon de commande :"}},[_c('p',{staticClass:"text-muted mb-3 small"},[_vm._v(" Lorsqu'un paiement est effectué à partir d'un bon de commande, une facture sera automatiquement créée. ")]),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_quotation_command_active]"},domProps:{"value":_vm.localConfig.stripe_command_quotation_active ? true : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stripe_command_quotation_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_command_quotation_active", $$v)},expression:"localConfig.stripe_command_quotation_active"}},[_vm._v(" Créer automatiquement un devis au statut ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"name":"configs[stripe_command_quotation_status]","size":"sm","reduce":opt => opt.value,"options":[
                  { value: 1, label: 'Brouillon' },
                  { value: 2, label: 'Validé' }
                ],"clearable":false,"disabled":!_vm.localConfig.stripe_command_quotation_active},model:{value:(_vm.localConfig.stripe_command_quotation_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_command_quotation_status", $$v)},expression:"localConfig.stripe_command_quotation_status"}})],1)],1),(_vm.hasModule('sales-deliveries'))?_c('b-row',{staticClass:"mt-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_command_delivery_active]"},domProps:{"value":_vm.localConfig.stripe_command_delivery_active ? true : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stripe_command_delivery_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_command_delivery_active", $$v)},expression:"localConfig.stripe_command_delivery_active"}},[_vm._v(" Créer automatiquement un bon de livraison au statut ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"name":"configs[stripe_command_delivery_status]","size":"sm","reduce":opt => opt.value,"options":[
                  { value: 1, label: 'Brouillon' },
                  { value: 2, label: 'Validé' }
                ],"clearable":false,"disabled":!_vm.localConfig.stripe_command_delivery_active},model:{value:(_vm.localConfig.stripe_command_delivery_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_command_delivery_status", $$v)},expression:"localConfig.stripe_command_delivery_status"}})],1)],1):_vm._e()],1):_vm._e(),(_vm.hasModule('sales-proformas'))?_c('b-form-group',{staticClass:"mt-5",attrs:{"label":"Lorsqu'un paiement est effectué sur une facture proforma :"}},[_c('p',{staticClass:"text-muted mb-3 small"},[_vm._v(" Lorsqu'un paiement est effectué à partir d'une facture proforma, une facture sera automatiquement créée. ")]),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_proforma_quotation_active]"},domProps:{"value":_vm.localConfig.stripe_proforma_quotation_active ? true : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stripe_proforma_quotation_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_proforma_quotation_active", $$v)},expression:"localConfig.stripe_proforma_quotation_active"}},[_vm._v(" Créer automatiquement un devis au statut ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"name":"configs[stripe_proforma_quotation_status]","size":"sm","reduce":opt => opt.value,"options":[
                  { value: 1, label: 'Brouillon' },
                  { value: 2, label: 'Validé' }
                ],"clearable":false,"disabled":!_vm.localConfig.stripe_proforma_quotation_active},model:{value:(_vm.localConfig.stripe_proforma_quotation_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_proforma_quotation_status", $$v)},expression:"localConfig.stripe_proforma_quotation_status"}})],1)],1),(_vm.hasModule('sales-commands'))?_c('b-row',{staticClass:"mt-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_proforma_command_active]"},domProps:{"value":_vm.localConfig.stripe_proforma_command_active ? true : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stripe_proforma_command_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_proforma_command_active", $$v)},expression:"localConfig.stripe_proforma_command_active"}},[_vm._v(" Créer automatiquement un bon de commande au statut ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"name":"configs[stripe_proforma_command_status]","size":"sm","reduce":opt => opt.value,"options":[
                  { value: 1, label: 'Brouillon' },
                  { value: 2, label: 'Validé' }
                ],"clearable":false,"disabled":!_vm.localConfig.stripe_proforma_command_active},model:{value:(_vm.localConfig.stripe_proforma_command_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_proforma_command_status", $$v)},expression:"localConfig.stripe_proforma_command_status"}})],1)],1):_vm._e(),(_vm.hasModule('sales-deliveries'))?_c('b-row',{staticClass:"mt-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_proforma_delivery_active]"},domProps:{"value":_vm.localConfig.stripe_proforma_delivery_active ? true : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stripe_proforma_delivery_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_proforma_delivery_active", $$v)},expression:"localConfig.stripe_proforma_delivery_active"}},[_vm._v(" Créer automatiquement un bon de livraison au statut ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"name":"configs[stripe_proforma_delivery_status]","size":"sm","reduce":opt => opt.value,"options":[
                  { value: 1, label: 'Brouillon' },
                  { value: 2, label: 'Validé' }
                ],"clearable":false,"disabled":!_vm.localConfig.stripe_proforma_delivery_active},model:{value:(_vm.localConfig.stripe_proforma_delivery_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_proforma_delivery_status", $$v)},expression:"localConfig.stripe_proforma_delivery_status"}})],1)],1):_vm._e()],1):_vm._e(),_c('b-alert',{staticClass:"mt-5",attrs:{"variant":"warning","show":""}},[_vm._v(" Si un type de document est déjà rattaché au document, celui-ci ne sera pas créé."),_c('br'),_vm._v(" Exemple : si un bon de commande est déjà rattaché au devis concerné par le paiement, alors aucun bon de commande ne sera créé. ")]),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Modèles d'email ")]),_c('p',[_vm._v(" Vous pouvez sélectionner un modèle d'email à charger automatiquement lors de l'envoi d'un lien de paiement. ")]),_c('b-form-group',{attrs:{"label":"Envoi d'un lien de paiement depuis un devis"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_mail_model_quotation]"},domProps:{"value":_vm.localConfig.stripe_mail_model_quotation ? _vm.localConfig.stripe_mail_model_quotation.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.stripe_mail_model_quotation),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_mail_model_quotation", $$v)},expression:"localConfig.stripe_mail_model_quotation"}})],1),_c('b-form-group',{attrs:{"label":"Envoi d'un lien de paiement depuis un bon de commande"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_mail_model_command]"},domProps:{"value":_vm.localConfig.stripe_mail_model_command ? _vm.localConfig.stripe_mail_model_command.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.stripe_mail_model_command),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_mail_model_command", $$v)},expression:"localConfig.stripe_mail_model_command"}})],1),_c('b-form-group',{attrs:{"label":"Envoi d'un lien de paiement depuis une facture"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stripe_mail_model_invoice]"},domProps:{"value":_vm.localConfig.stripe_mail_model_invoice ? _vm.localConfig.stripe_mail_model_invoice.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.stripe_mail_model_invoice),callback:function ($$v) {_vm.$set(_vm.localConfig, "stripe_mail_model_invoice", $$v)},expression:"localConfig.stripe_mail_model_invoice"}})],1),_c('p',{staticClass:"mb-4"},[_vm._v(" ")]),_c('KFormStickyBar',{attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1),_c('b-tab',{attrs:{"title":"Prévisualisation des emails"}},[_c('MailTemplate')],1)],1)]:_vm._e()]:[_c('p',[_vm._v(" Pour activer les paiements en ligne, vous devez vous connecter à votre compte Stripe ou en créer un en cliquant sur le bouton ci-dessous. ")]),(_vm.loading)?_c('Spinner'):_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.loginToStripe.apply(null, arguments)}}},[_vm._v(" Me connecter à Stripe ")])]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StripeConfig/MailTemplate.vue?vue&type=template&id=7ce71810
var MailTemplatevue_type_template_id_7ce71810_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('html',[_vm._m(0),_c('body',{staticStyle:{"padding":"0","margin":"0"}},[_c('table',{staticStyle:{"border":"0","margin":"0","padding":"0"},attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0","bgcolor":"#F8F8F8"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"font-size":"16px"}},[_vm._v("     ")]),_c('td',[_c('table',{staticStyle:{"width":"480px","min-width":"480px","max-width":"480px"},attrs:{"cellspacing":"0","cellpadding":"0","border":"0","align":"center"}},[_c('tbody',[_c('tr',[_c('td',[_vm._m(1),_c('table',{attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0"}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-weight":"500","color":"rgb(0,0,0)","font-size":"20px","line-height":"24px"}},[_vm._v(" "+_vm._s(_vm.team.company_name)+" ")])])])])]),_vm._m(2),_vm._m(3),_vm._m(4),_vm._m(5)])])])])]),_c('td',{staticStyle:{"font-size":"16px"}},[_vm._v("     ")])]),_vm._m(6)])])])])
}
var MailTemplatevue_type_template_id_7ce71810_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('head',[_c('meta',{attrs:{"http-equiv":"Content-Type","content":"text/html; charset=UTF-8"}}),_c('title',[_vm._v("Lien de paiement")]),_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1.0"}})])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"30"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"20"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{attrs:{"align":""}},[_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"1px","width":"482px","border-radius":"12px","background-color":"#e3e8ee"},attrs:{"align":""}},[_c('table',{staticStyle:{"width":"100%","background-color":"#ffffff","border-radius":"12px"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0"}},[_c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"32"}},[_c('div',[_vm._v(" ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","min-width":"32px","width":"32px","font-size":"1px"}},[_vm._v("   ")]),_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0"}},[_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%"}},[_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","padding-bottom":"2px"},attrs:{"align":""}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#7a7a7a","font-size":"14px","line-height":"20px","font-weight":"500"}},[_vm._v(" Facture n°FA1222-01234 du 12/12/2022 ")])])])])]),_c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"10"}},[_c('div',[_vm._v(" ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","padding-bottom":"2px"},attrs:{"align":""}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#7a7a7a","font-size":"14px","line-height":"20px","font-weight":"500"}},[_vm._v(" Montant à payer ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","padding-bottom":"2px"},attrs:{"align":""}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#1a1a1a","font-size":"36px","line-height":"40px","font-weight":"600"}},[_vm._v(" 60,00 € ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"16px","font-size":"1px","line-height":"1px"},attrs:{"colspan":"1","height":"16"}},[_vm._v("   ")])]),_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"1px","font-size":"1px","background-color":"#ebebeb","line-height":"1px"},attrs:{"height":"1"}},[_vm._v("   ")])]),_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"12px","font-size":"1px","line-height":"1px"},attrs:{"colspan":"1","height":"12"}},[_vm._v("   ")])])])])]),_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"76px","max-width":"76px"}},[_c('img',{staticStyle:{"border":"0","margin":"0 auto","padding":"0","display":"block"},attrs:{"src":__webpack_require__(96352),"alt":"Facture","width":"94","height":"91"}})])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%"},attrs:{"align":""}},[_c('a',{staticStyle:{"border":"0","margin":"0","padding":"0","text-decoration":"none","outline":"0"},attrs:{"href":"#"}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#7a7a7a","font-size":"14px","line-height":"16px","font-weight":"500"}},[_vm._v(" Télécharger ")])])])])])]),_c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"32"}},[_c('div',[_vm._v(" ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","text-align":"center","background-color":"#dc4146","border-radius":"6px","height":"44px"},attrs:{"align":""}},[_c('a',{staticStyle:{"border":"0","margin":"0","padding":"0","text-decoration":"none","outline":"0","display":"block","text-align":"center","padding-right":"60px","padding-left":"60px"},attrs:{"href":"#"}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-weight":"500","font-size":"16px","line-height":"44px","color":"rgb(255,255,255)"}},[_vm._v(" Payer ")])])])])])]),_c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"32"}},[_c('div',[_vm._v(" ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%"},attrs:{"align":""}},[_vm._v(" Vous avez des questions ? Contactez-nous à l'adresse "),_c('a',{staticStyle:{"border":"0","margin":"0","padding":"0","text-decoration":"none","outline":"0"},attrs:{"href":"#"}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#7a7a7a","font-size":"14px","line-height":"16px","font-weight":"500"}},[_vm._v(" contact@kwixeo.fr ")])]),_vm._v(". ")])])])])]),_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","min-width":"32px","width":"32px","font-size":"1px"}},[_vm._v("   ")])])])]),_c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"24"}},[_c('div',[_vm._v(" ")])])])])])])])])])])])])])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"15"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","text-align":"center","color":"#979797"}},[_c('table',{attrs:{"align":"center"}},[_c('tbody',[_c('tr',[_c('td',[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-size":"12px","line-height":"14px"}},[_vm._v(" Powered by ")])]),_c('td',[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-size":"12px","line-height":"14px"}},[_c('a',{staticStyle:{"border":"0","margin":"0","padding":"0","text-decoration":"none","outline":"0"},attrs:{"href":"#"}},[_c('img',{staticStyle:{"border":"0","line-height":"100%","vertical-align":"middle"},attrs:{"src":__webpack_require__(92053),"alt":"Kwixeo logo","width":"58","height":"15","align":"middle"}})])])]),_c('td',[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-size":"12px","line-height":"14px"}},[_vm._v("   |   "),_c('a',{staticStyle:{"border":"0","margin":"0","padding":"0","text-decoration":"none","outline":"0"},attrs:{"href":"#"}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#979797"}},[_vm._v(" En savoir plus sur Kwixéo ")])])])])])])])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px"},attrs:{"colspan":"3","height":"64"}},[_c('div',[_vm._v(" ")])])])
}]


;// ./src/components/StripeConfig/MailTemplate.vue?vue&type=template&id=7ce71810

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StripeConfig/MailTemplate.ts?vue&type=script&lang=ts&external



var MailTemplate = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MailTemplate, _super);
    function MailTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailTemplate = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team']))
        })
    ], MailTemplate);
    return MailTemplate;
}(lib/* Vue */.lD));
/* harmony default export */ var MailTemplatevue_type_script_lang_ts_external = (MailTemplate);

;// ./src/components/StripeConfig/MailTemplate.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StripeConfig_MailTemplatevue_type_script_lang_ts_external = (MailTemplatevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/StripeConfig/MailTemplate.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StripeConfig_MailTemplatevue_type_script_lang_ts_external,
  MailTemplatevue_type_template_id_7ce71810_render,
  MailTemplatevue_type_template_id_7ce71810_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StripeConfig_MailTemplate = (component.exports);
// EXTERNAL MODULE: ./src/components/AccountSelect/AccountSelect.vue + 3 modules
var AccountSelect = __webpack_require__(5182);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StripeConfig/StripeConfig.ts?vue&type=script&lang=ts&external








var StripeConfig = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StripeConfig, _super);
    function StripeConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    StripeConfig.prototype.mounted = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        if (!((_a = this.$route.query) === null || _a === void 0 ? void 0 : _a.code)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validLogin()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, this.loadModels()];
                    case 3:
                        _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StripeConfig.prototype, "userApiUrl", {
        get: function () {
            return '/team/user?sort=fullname';
        },
        enumerable: false,
        configurable: true
    });
    StripeConfig.prototype.loginToStripe = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/stripe/login')
                                .then(function (response) {
                                window.location.href = response.data;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StripeConfig.prototype.validLogin = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.$kwSales.axios.post('/stripe/login', {
                            code: (_a = this.$route.query) === null || _a === void 0 ? void 0 : _a.code
                        })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.$router.push({ query: {} })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StripeConfig = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BAlert: external_bootstrap_vue_.BAlert, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                Spinner: interface_vue_.Spinner, PaymentMethodSelect: interface_vue_.PaymentMethodSelect,
                KFormSelect: form_vue_.KFormSelect, KFormCheckbox: form_vue_.KFormCheckbox, KForm: form_vue_.KForm, KFormStickyBar: form_vue_.KFormStickyBar, KFormInput: form_vue_.KFormInput,
                MailTemplate: StripeConfig_MailTemplate,
                AccountSelect: AccountSelect/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('communication', ['models'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['loadModels']))
        })
    ], StripeConfig);
    return StripeConfig;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var StripeConfigvue_type_script_lang_ts_external = (StripeConfig);

;// ./src/components/StripeConfig/StripeConfig.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StripeConfig_StripeConfigvue_type_script_lang_ts_external = (StripeConfigvue_type_script_lang_ts_external); 
;// ./src/components/StripeConfig/StripeConfig.vue





/* normalize component */
;
var StripeConfig_component = (0,componentNormalizer/* default */.A)(
  StripeConfig_StripeConfigvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StripeConfig_StripeConfig = (StripeConfig_component.exports);

/***/ }),

/***/ 11172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var _SalesDocumentLineMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54575);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_2__);




var SalesLineMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__extends */ .C6)(SalesLineMixin, _super);
    function SalesLineMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesLineMixin.prototype.mounted = function () {
        this.calculPrices();
    };
    SalesLineMixin.prototype.watchSecondaryQuantity = function () {
        this.calculPrices();
    };
    Object.defineProperty(SalesLineMixin.prototype, "vatRate", {
        // Get selected vat rate
        get: function () {
            var _a;
            if (this.document.use_global_vatrate) {
                return this.document.vat_rate;
            }
            return (_a = this.value) === null || _a === void 0 ? void 0 : _a.vat_rate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesLineMixin.prototype, "secondaryQuantity", {
        // Get selected secondary quantity
        get: function () {
            switch (this.document.secondary_quantity_mode) {
                case 'disable':
                    return 1;
                case 'global':
                    return this.document.secondary_quantity;
                case 'line':
                    return this.value.secondary_quantity;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesLineMixin.prototype, "totalQuantity", {
        // Get total quantity
        get: function () {
            var local = this.value;
            local.total_quantity = this.number(local.quantity) * this.number(this.secondaryQuantity);
            return local.total_quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesLineMixin.prototype, "withCosts", {
        // If costs should be displayed
        get: function () {
            if (!this.can('sales-margin', 1)) {
                return false;
            }
            var mode = this.document.input_options.costs_entries;
            var type = this.value.catalog;
            return (mode === 1 && !type) ||
                (mode === 2 && type && type.type === 'product') ||
                (mode === 3 && type !== null && type !== undefined) ||
                (mode === 4 && (!type || type.type === 'product')) ||
                mode === 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesLineMixin.prototype, "withWorkout", {
        // If workforce costs should be displayed
        get: function () {
            var mode = this.document.input_options.workforce_entries;
            var type = this.value.catalog;
            return (mode === 1 && !type) ||
                (mode === 2 && type && type.type === 'service') ||
                (mode === 3 && type !== null && type !== undefined) ||
                (mode === 4 && (!type || type.type === 'service')) ||
                mode === 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesLineMixin.prototype, "withWorkoutCosts", {
        get: function () {
            return this.can('sales-margin', 1) && this.withWorkout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesLineMixin.prototype, "computedOption", {
        // If options should be displayed
        get: function () {
            return this.document.input_options.allow_options && this.value.is_option;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesLineMixin.prototype, "lineNumber", {
        // Return line number
        get: function () {
            var nb = 0;
            for (var i = 0; i <= this.index; i++) {
                var content = this.document.contents[i];
                if (!content.is_subtotal && !content.is_comments && !content.is_pagebreak) {
                    nb++;
                }
            }
            return nb;
        },
        enumerable: false,
        configurable: true
    });
    // Prices calculation from total ht
    SalesLineMixin.prototype.calculHtTotals = function () {
        var local = this.value;
        var oldValue = local.unit_price_ht;
        var unitPrice = this.applyDiscount(this.roundNumber(this.number(local.total_ht) / this.number(this.totalQuantity), 5));
        local.unit_price_ht = unitPrice;
        this.onUnitPriceHtChange(unitPrice, oldValue);
    };
    // Prices calculation from total ttc
    SalesLineMixin.prototype.calculTtcTotals = function () {
        var local = this.value;
        var oldValue = local.unit_price_ttc;
        var unitPrice = this.applyDiscount(this.roundNumber(this.number(local.total_ttc) / this.number(this.totalQuantity), 5));
        local.unit_price_ttc = unitPrice;
        this.onUnitPriceTtcChange(unitPrice, oldValue);
    };
    // Make price calculation from unit price ht or ttc
    SalesLineMixin.prototype.calculPrices = function () {
        if (this.document.input_mode === 'ttc') {
            this.calculTtcPrices();
        }
        else {
            this.calculHtPrices();
        }
    };
    // Calculate all costs
    SalesLineMixin.prototype.calculateCosts = function () {
        var local = this.value;
        // Unit sale price
        var unitPrice = this.number(local.unit_price_ht);
        var qty = this.totalQuantity;
        if (this.number(local.discount_value) > 0) {
            var discountQty = this.totalQuantity;
            if (discountQty === 0) {
                discountQty = 1;
            }
            // If discount is applied, calculate the unit price ht from the total_ht and the quantity
            unitPrice = this.roundNumber(this.number(discountQty === 1 ? this.applyDiscount(local.unit_price_ht) : local.total_ht) / discountQty, 2);
        }
        // Unit amounts
        local.total_costs_u = this.number(local.catalog_costs_u) + this.number(local.various_costs_u) + this.number(local.ecotax_u_ht);
        var duration = local.duration_type === 'minute' ? this.roundNumber(this.number(local.duration) / 60, 2) : this.number(local.duration);
        local.workforce_costs_u = this.number(local.hourly_person_cost) * duration * this.number(local.number_people_needed);
        local.total_charge_u = local.total_costs_u + local.workforce_costs_u;
        local.gross_margin_amount_u = this.number(unitPrice) - local.total_charge_u;
        // Rates
        local.gross_margin_rate = local.total_charge_u === 0 ? 100 : local.gross_margin_amount_u / local.total_charge_u * 100;
        local.markup_rate = unitPrice === 0 ? 0 : local.gross_margin_amount_u / this.number(unitPrice) * 100;
        // Total amount
        local.total_workforce = this.roundNumber(local.workforce_costs_u * qty, 2);
        local.total_costs = this.roundNumber(local.total_costs_u * qty, 2);
        local.total_charge = this.roundNumber(local.total_charge_u * qty, 2);
        local.gross_margin_amount = this.roundNumber(local.gross_margin_amount_u * qty, 2);
    };
    // Calculate unit price from gross margin amount
    SalesLineMixin.prototype.updateGrossMarginAmount = function () {
        var local = this.value;
        var unitPrice = this.number(local.gross_margin_amount_u) + this.number(local.total_charge_u);
        local.unit_price_ht = this.applyDiscount(unitPrice);
        this.calculPrices();
    };
    // Calculate unit price from gross margin rate
    SalesLineMixin.prototype.updateGrossMarginRate = function () {
        var local = this.value;
        var charge = this.number(local.total_charge_u);
        var unitPrice = this.roundNumber(charge + (charge * this.number(local.gross_margin_rate) / 100), 2);
        local.unit_price_ht = this.applyDiscount(unitPrice);
        this.calculPrices();
    };
    // Calculate unit price from markup rate
    SalesLineMixin.prototype.updateMarkupRate = function () {
        var local = this.value;
        var unitPrice = this.roundNumber((this.number(local.total_charge_u) * 100) / (100 - this.number(local.markup_rate)), 2);
        local.unit_price_ht = this.applyDiscount(unitPrice);
        this.calculPrices();
    };
    // Apply discount to the unit price
    SalesLineMixin.prototype.applyDiscount = function (unitPrice) {
        var discount = this.number(this.value.discount_value);
        switch (this.value.discount_type) {
            case 'amount':
                return unitPrice - discount;
            default:
                return unitPrice - (unitPrice * discount / 100);
        }
    };
    SalesLineMixin.prototype.calculHtPrices = function () {
        //
    };
    SalesLineMixin.prototype.calculTtcPrices = function () {
        //
    };
    // eslint-disable-next-line
    SalesLineMixin.prototype.onUnitPriceHtChange = function (newVal, oldVal) {
        //
    };
    // eslint-disable-next-line
    SalesLineMixin.prototype.onUnitPriceTtcChange = function (newVal, oldVal) {
        //
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Watch */ .ox)('document.secondary_quantity'),
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Watch */ .ox)('document.secondary_quantity_mode')
    ], SalesLineMixin.prototype, "watchSecondaryQuantity", null);
    SalesLineMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_2__.mapGetters)('user', ['can']))
        })
    ], SalesLineMixin);
    return SalesLineMixin;
}((0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Mixins */ .Xe)(_SalesDocumentLineMixin__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)));
/* harmony default export */ __webpack_exports__.A = (SalesLineMixin);


/***/ }),

/***/ 11331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72552),
    getPrototype = __webpack_require__(28879),
    isObjectLike = __webpack_require__(40346);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 11466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentDatas_DocumentDatas; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/DocumentDatas/DocumentDatas.vue?vue&type=template&id=39959932
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100 pb-3"},[_c('b-row',{staticClass:"h-100"},[_c('b-col',{attrs:{"cols":"12","lg":"8","xl":"9"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.title.' + _vm.type)}},[_c('k-form-input',{attrs:{"name":"title"},model:{value:(_vm.value.title),callback:function ($$v) {_vm.$set(_vm.value, "title", $$v)},expression:"value.title"}})],1),_c('b-row',{staticClass:"mr-5"},[_c('b-col',{attrs:{"cols":"12","md":"4","lg":"6","xl":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.date.' + _vm.type)}},[_c('k-form-datepicker',{attrs:{"required":"","name":"date","min-date":_vm.minDate,"max-date":!_vm.teamConfigs.sales_disable_date_check && (_vm.type === 'invoice' || _vm.type === 'credit') ? _vm.today : null},model:{value:(_vm.value.date),callback:function ($$v) {_vm.$set(_vm.value, "date", $$v)},expression:"value.date"}})],1)],1),(_vm.type !== 'delivery' && _vm.type !== 'credit')?_c('b-col',{attrs:{"cols":"12","md":"4","lg":"6","xl":"4"}},[((!_vm.value.payment_term?.with_deadlines || _vm.type !== 'invoice'))?_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.' + (_vm.type === 'invoice' ? 'paymentDate' : 'expirationDate'))}},[_c('k-form-datepicker',{attrs:{"required":"","name":"expire_at","min-date":_vm.value.date},model:{value:(_vm.value.expire_at),callback:function ($$v) {_vm.$set(_vm.value, "expire_at", $$v)},expression:"value.expire_at"}})],1):_vm._e()],1):_vm._e(),_c('b-col',{attrs:{"cols":"12","md":"4","lg":"6","xl":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.reference.' + _vm.type)}},[_c('k-form-input',{attrs:{"value":_vm.value.id ? _vm.value.reference : _vm.team.sales[_vm.type + '_reference'],"readonly":""}})],1)],1),(_vm.type !== 'credit' && _vm.type !== 'delivery')?_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.paymentTerm')}},[_c('b-row',[_c('b-col',[_c('input',{attrs:{"type":"hidden","name":"payment_term"},domProps:{"value":_vm.value.payment_term ? _vm.value.payment_term.id : null}}),_c('PaymentTermSelect',{attrs:{"validateName":"payment_term","required":""},on:{"input":_vm.onPaymentTermChange},model:{value:(_vm.value.payment_term),callback:function ($$v) {_vm.$set(_vm.value, "payment_term", $$v)},expression:"value.payment_term"}})],1),(_vm.value.payment_term?.with_deadlines)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{staticClass:"mt-1",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('showDeadlines')}}},[_vm._v(" Gérer les échéances ")])],1):_vm._e()],1)],1)],1):_vm._e(),(_vm.withCustomerBdc)?_c('b-col',{attrs:{"cols":"12","md":"4","lg":"6","xl":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.commandReference')}},[_c('k-form-input',{attrs:{"name":"customer_command_reference"},model:{value:(_vm.value.customer_command_reference),callback:function ($$v) {_vm.$set(_vm.value, "customer_command_reference", $$v)},expression:"value.customer_command_reference"}})],1)],1):_vm._e(),_c('b-col',{attrs:{"cols":"12"}}),(_vm.type === 'quotation' || _vm.type === 'command')?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"4","xl":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.advancePayment')}},[_c('b-input-group',[_c('k-form-number',{attrs:{"name":"advance_payment_value"},model:{value:(_vm.value.advance_payment_value),callback:function ($$v) {_vm.$set(_vm.value, "advance_payment_value", $$v)},expression:"value.advance_payment_value"}}),_c('b-input-group-append',[_c('k-form-select',{attrs:{"name":"advance_payment_type","reduce":opt => opt.id,"options":[
                    { id: 'pourcent', label: '%' },
                    { id: 'amount', label: _vm.currency.symbol }
                  ],"clearable":false},model:{value:(_vm.value.advance_payment_type),callback:function ($$v) {_vm.$set(_vm.value, "advance_payment_type", $$v)},expression:"value.advance_payment_type"}})],1)],1)],1)],1):_vm._e(),(_vm.type === 'delivery')?_c('b-col',[_c('b-form-group',{attrs:{"label":"Options d'affichage"}},[_c('input',{attrs:{"type":"hidden","name":"not_show_prices"},domProps:{"value":_vm.value.not_show_prices}}),_c('k-form-checkbox',{model:{value:(_vm.value.not_show_prices),callback:function ($$v) {_vm.$set(_vm.value, "not_show_prices", $$v)},expression:"value.not_show_prices"}},[_vm._v(" Ne pas afficher les prix sur le PDF ")]),_c('input',{attrs:{"type":"hidden","name":"show_remaining_quantity"},domProps:{"value":_vm.value.show_remaining_quantity}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.value.show_remaining_quantity),callback:function ($$v) {_vm.$set(_vm.value, "show_remaining_quantity", $$v)},expression:"value.show_remaining_quantity"}},[_vm._v(" Afficher les quantités restantes à livrer ")])],1)],1):_vm._e(),(_vm.value.use_global_vatrate)?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"4","xl":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.vatRate')}},[_c('input',{attrs:{"type":"hidden","name":"vat_rate"},domProps:{"value":_vm.value.vat_rate ? _vm.value.vat_rate.id : null}}),_c('VatRateSelect',{attrs:{"validationName":"vat_rate"},model:{value:(_vm.value.vat_rate),callback:function ($$v) {_vm.$set(_vm.value, "vat_rate", $$v)},expression:"value.vat_rate"}})],1)],1):_vm._e(),(_vm.hasModule('stock-locations') && _vm.type === 'delivery')?_c('b-col',[_c('b-form-group',{attrs:{"label":"Lieu de stock"}},[_c('input',{attrs:{"type":"hidden","name":"stock_location"},domProps:{"value":_vm.value.stock_location?.id ?? null}}),_c('StockLocationSelect',{attrs:{"validationName":"stock_location","selectDefault":"","required":""},model:{value:(_vm.value.stock_location),callback:function ($$v) {_vm.$set(_vm.value, "stock_location", $$v)},expression:"value.stock_location"}})],1)],1):_vm._e(),(_vm.value.secondary_quantity_mode === 'global')?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"4","xl":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.quantity2')}},[_c('b-input-group',[_c('k-form-spinner',{attrs:{"name":"secondary_quantity","maxDecimal":5,"left":""},model:{value:(_vm.value.secondary_quantity),callback:function ($$v) {_vm.$set(_vm.value, "secondary_quantity", $$v)},expression:"value.secondary_quantity"}}),(_vm.value.input_options.secondary_quantity_unit)?_c('b-input-group-append',{staticClass:"flex-fill"},[_c('input',{attrs:{"type":"hidden","name":"secondary_unit"},domProps:{"value":_vm.value.secondary_unit ? _vm.value.secondary_unit.label : null}}),_c('UnitSelect',{staticClass:"w-100",attrs:{"taggable":"","placeholder":_vm.$t('sales.form.unit')},model:{value:(_vm.value.secondary_unit),callback:function ($$v) {_vm.$set(_vm.value, "secondary_unit", $$v)},expression:"value.secondary_unit"}})],1):_vm._e()],1)],1)],1):_vm._e(),(_vm.type !== 'delivery' && _vm.hasModule('sales-guarantee-holdback'))?_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Retenue de garantie"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticStyle:{"max-width":"170px"},attrs:{"cols":"auto"}},[_c('b-input-group',{attrs:{"append":"%"}},[_c('k-form-spinner',{attrs:{"name":"guarantee_holdback_pourcent","min":"0","max":"100","left":"","maxDecimal":2},model:{value:(_vm.value.guarantee_holdback_pourcent),callback:function ($$v) {_vm.$set(_vm.value, "guarantee_holdback_pourcent", $$v)},expression:"value.guarantee_holdback_pourcent"}})],1)],1),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_vm._v("sur")]),_c('b-col',{staticStyle:{"max-width":"170px"},attrs:{"cols":"auto"}},[_c('b-input-group',{attrs:{"append":"mois"}},[_c('k-form-spinner',{attrs:{"name":"guarantee_holdback_duration","min":"0","left":""},model:{value:(_vm.value.guarantee_holdback_duration),callback:function ($$v) {_vm.$set(_vm.value, "guarantee_holdback_duration", $$v)},expression:"value.guarantee_holdback_duration"}})],1)],1)],1)],1)],1):_vm._e()],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4","xl":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.tags')}},[_vm._l((_vm.value.tags),function(tag,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"tags[]"},domProps:{"value":tag.name}})}),(_vm.value.tags && _vm.value.tags.length === 0)?_c('input',{attrs:{"type":"hidden","name":"tags"},domProps:{"value":null}}):_vm._e(),_c('TagSelect',{model:{value:(_vm.value.tags),callback:function ($$v) {_vm.$set(_vm.value, "tags", $$v)},expression:"value.tags"}})],2),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfModel')}},[_c('input',{attrs:{"type":"hidden","name":"pdf_model"},domProps:{"value":_vm.value.pdf_model ? _vm.value.pdf_model.id : null}}),_c('PdfModelSelect',{attrs:{"validationName":"pdf_model","required":""},on:{"input":model => _vm.value.pdf_model = model},model:{value:(_vm.value.pdf_model),callback:function ($$v) {_vm.$set(_vm.value, "pdf_model", $$v)},expression:"value.pdf_model"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.commercial')}},[_c('input',{attrs:{"type":"hidden","name":"team_user"},domProps:{"value":_vm.value.team_user ? _vm.value.team_user.id : null}}),_c('TeamUserSelect',{attrs:{"validationName":"team_user","role":"commercial"},model:{value:(_vm.value.team_user),callback:function ($$v) {_vm.$set(_vm.value, "team_user", $$v)},expression:"value.team_user"}})],1),(_vm.hasModule('sales-currencies'))?_c('b-form-group',{attrs:{"label":"Devise"}},[_c('input',{attrs:{"type":"hidden","name":"currency"},domProps:{"value":_vm.value.currency ? _vm.value.currency.id : null}}),_c('CurrencySelect',{attrs:{"validationName":"currency"},model:{value:(_vm.value.currency),callback:function ($$v) {_vm.$set(_vm.value, "currency", $$v)},expression:"value.currency"}})],1):_vm._e()],1),_c('b-col',{attrs:{"cols":"12"}},[_c('CustomFieldsForm',{attrs:{"type":_vm.type},model:{value:(_vm.value.custom_fields),callback:function ($$v) {_vm.$set(_vm.value, "custom_fields", $$v)},expression:"value.custom_fields"}})],1),_c('b-col',{attrs:{"cols":"12"}},[(_vm.withTracking)?_c('b-form-group',{class:{ 'mb-0': !_vm.withCustomerComments },attrs:{"label":"N° de tracking"}},[_c('k-form-input',{attrs:{"name":"delivery_tracking"},model:{value:(_vm.value.delivery_tracking),callback:function ($$v) {_vm.$set(_vm.value, "delivery_tracking", $$v)},expression:"value.delivery_tracking"}})],1):_vm._e(),(_vm.withCustomerComments)?_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.customerNotes')}},[_c('k-form-editor',{attrs:{"name":"comments","size":"sm","config":_vm.editorConfig},model:{value:(_vm.value.comments),callback:function ($$v) {_vm.$set(_vm.value, "comments", $$v)},expression:"value.comments"}})],1):_vm._e()],1)],1),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.withCustomerComments },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.addCustomerNotes')},on:{"click":function($event){_vm.withCustomerComments = !_vm.withCustomerComments}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.customerNotes'))+" ")]),_vm._v(" | "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.withCustomerBdc },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.addCommandReference')},on:{"click":function($event){_vm.withCustomerBdc = !_vm.withCustomerBdc}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.commandReference'))+" ")]),(_vm.type === 'delivery')?[_vm._v(" | "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.withTracking },attrs:{"size":"sm","variant":"link","title":"Ajouter le numéro de tracking"},on:{"click":function($event){_vm.withTracking = !_vm.withTracking}}},[_vm._v(" N° de tracking ")])]:_vm._e()],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(44696);
// EXTERNAL MODULE: external "@kwixeo/catalog-vue"
var catalog_vue_ = __webpack_require__(68480);
// EXTERNAL MODULE: ./src/components/PdfModelSelect/PdfModelSelect.vue + 3 modules
var PdfModelSelect = __webpack_require__(32078);
// EXTERNAL MODULE: ./src/components/Form/editorConfig.ts
var editorConfig = __webpack_require__(63457);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/DocumentDatas/DocumentDatas.ts?vue&type=script&lang=ts&external











var DocumentDatas = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentDatas, _super);
    function DocumentDatas() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.withCustomerBdc = false;
        _this.withCustomerComments = false;
        _this.withTracking = false;
        _this.today = null;
        _this.editorConfig = editorConfig/* default */.A;
        return _this;
    }
    DocumentDatas.prototype.mounted = function () {
        this.today = external_moment_default()().format('YYYY-MM-DD');
        var isAvailable = function (value) {
            return value !== null && value !== undefined && value !== '';
        };
        this.withCustomerComments = isAvailable(this.value.comments);
        this.withCustomerBdc = isAvailable(this.value.customer_command_reference);
        if ('delivery_tracking' in this.value) {
            this.withTracking = isAvailable(this.value.delivery_tracking);
        }
    };
    Object.defineProperty(DocumentDatas.prototype, "minDate", {
        get: function () {
            if (this.type !== 'invoice' && this.type !== 'credit') {
                return null;
            }
            var closed_period = null;
            if (this.team.sales['closed_period']) {
                closed_period = external_moment_default()(this.team.sales['closed_period']).add(1, 'day').format('YYYY-MM-DD');
            }
            var min = null;
            if (!this.teamConfigs.sales_disable_date_check) {
                min = this.team.sales[this.type + '_date'];
            }
            if (min && (!closed_period || external_moment_default()(min).isAfter(closed_period))) {
                return min;
            }
            else if (closed_period) {
                return closed_period;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    DocumentDatas.prototype.onPaymentTermChange = function () {
        if (this.type === 'credit' || this.type === 'delivery') {
            return;
        }
        var date = external_moment_default()(this.value.date);
        if (this.type === 'invoice' && this.value.payment_term) {
            var term = this.value.payment_term;
            if (term.day_number > 0) {
                date.add(term.day_number, 'days');
            }
            if (term.end_month) {
                date.endOf('month');
            }
            if (term.end_month_day > 0) {
                date.add(1, 'month');
                date.set('date', term.end_month_day);
            }
        }
        else {
            date.add(this.teamConfigs.sales_quotation_default_validity, 'days');
        }
        this.value.expire_at = date.format('YYYY-MM-DD');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], DocumentDatas.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentDatas.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.date'),
        (0,lib/* Watch */.ox)('value.payment_term')
    ], DocumentDatas.prototype, "onPaymentTermChange", null);
    DocumentDatas = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'team', 'currency'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCustomFields'])),
            components: {
                PdfModelSelect: PdfModelSelect/* default */.A,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                StockLocationSelect: catalog_vue_.StockLocationSelect,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BButton: external_bootstrap_vue_.BButton,
                KFormInput: form_vue_.KFormInput, KFormDatepicker: form_vue_.KFormDatepicker, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormSpinner: form_vue_.KFormSpinner, KFormCheckbox: form_vue_.KFormCheckbox, KFormEditor: form_vue_.KFormEditor,
                TeamUserSelect: interface_vue_.TeamUserSelect, TagSelect: interface_vue_.TagSelect, UnitSelect: interface_vue_.UnitSelect, PaymentTermSelect: interface_vue_.PaymentTermSelect, VatRateSelect: interface_vue_.VatRateSelect, CurrencySelect: interface_vue_.CurrencySelect
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], DocumentDatas);
    return DocumentDatas;
}(lib/* Vue */.lD));
/* harmony default export */ var DocumentDatasvue_type_script_lang_ts_external = (DocumentDatas);

;// ./src/components/Form/DocumentDatas/DocumentDatas.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentDatas_DocumentDatasvue_type_script_lang_ts_external = (DocumentDatasvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/DocumentDatas/DocumentDatas.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentDatas_DocumentDatasvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentDatas_DocumentDatas = (component.exports);

/***/ }),

/***/ 11470:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ 11650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfModelNew_PdfModelNew; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfModelNew/PdfModelNew.vue?vue&type=template&id=69a54994
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form-modal',{attrs:{"title":_vm.$t('sales.pdfModel.addTitle'),"okTitle":_vm.$t('interface.create'),"size":"lg","scrollable":""},on:{"submitComplete":_vm.submitComplete},model:{value:(_vm.localState),callback:function ($$v) {_vm.localState=$$v},expression:"localState"}},[_c('k-form',{attrs:{"action":_vm.formApiUrl,"method":"post"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.pdfModel.label')}},[_c('k-form-input',{attrs:{"name":"label","required":"","autofocus":""}}),_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.pdfModels && _vm.pdfModels[_vm.selected] ? _vm.pdfModels[_vm.selected].id : null}})],1),_c('p',{staticClass:"text-center"},[_vm._v(" Choisissez un modèle prédéfini comme base, vous pourrez le modifier à l'étape suivante. ")]),(!_vm.pdfModels)?_c('Spinner'):_c('div',[_c('p',{staticClass:"text-center font-weight-bold mb-1"},[_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.previous}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-circle-left']}})],1),_vm._v(" Modèle n° "+_vm._s(_vm.computedSelected)+" / "+_vm._s(_vm.pdfModels.length)+" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.next}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-circle-right']}})],1)],1),_c('img',{staticClass:"w-100 border",attrs:{"src":'data:image/png;base64,' + _vm.pdfModels[_vm.selected].image}})])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfModelNew/PdfModelNew.ts?vue&type=script&lang=ts&external







var PdfModelNew = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelNew, _super);
    function PdfModelNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localState = false;
        _this.pdfModels = null;
        _this.selected = 0;
        return _this;
    }
    Object.defineProperty(PdfModelNew.prototype, "formApiUrl", {
        get: function () {
            return '/sales/pdf_model';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelNew.prototype, "modelPpfUrl", {
        get: function () {
            return '/sales/pdf_model/models';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelNew.prototype, "computedSelected", {
        get: function () {
            return this.selected + 1;
        },
        enumerable: false,
        configurable: true
    });
    PdfModelNew.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.localState = this.modalState;
                        return [4 /*yield*/, this.loadPdfModels()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfModelNew.prototype.watchModalState = function (state) {
        this.localState = state;
    };
    PdfModelNew.prototype.watchLocalState = function (state) {
        this.$emit('input', state);
    };
    PdfModelNew.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var model;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPdfModel(response.data);
                        model = response.data;
                        this.setPageParams(model);
                        return [4 /*yield*/, this.$router.push({
                                name: 'sales-pdf-model-form',
                                params: {
                                    id: String(model.id)
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfModelNew.prototype.loadPdfModels = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwSales.axios.get(this.modelPpfUrl)
                            .then(function (response) {
                            _this.pdfModels = response.data;
                        })
                            .catch(function (error) {
                            throw new Error(error);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfModelNew.prototype.previous = function () {
        var _a;
        var selected = this.selected - 1;
        if (selected < 0) {
            selected = Number((_a = this.pdfModels) === null || _a === void 0 ? void 0 : _a.length) - 1;
        }
        this.selected = selected;
    };
    PdfModelNew.prototype.next = function () {
        var _a;
        var selected = this.selected + 1;
        if (selected > (Number((_a = this.pdfModels) === null || _a === void 0 ? void 0 : _a.length) - 1)) {
            selected = 0;
        }
        this.selected = selected;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelNew.prototype, "modalState", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], PdfModelNew.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localState')
    ], PdfModelNew.prototype, "watchLocalState", null);
    PdfModelNew = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])), (0,external_vuex_.mapActions)('sales', ['setPdfModel'])),
            components: {
                FormModal: interface_vue_.FormModal,
                Spinner: interface_vue_.Spinner,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], PdfModelNew);
    return PdfModelNew;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelNewvue_type_script_lang_ts_external = (PdfModelNew);

;// ./src/components/PdfModelNew/PdfModelNew.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelNew_PdfModelNewvue_type_script_lang_ts_external = (PdfModelNewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfModelNew/PdfModelNew.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelNew_PdfModelNewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelNew_PdfModelNew = (component.exports);

/***/ }),

/***/ 11713:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ 11873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractModelDelete_ContractModelDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractModelDelete/ContractModelDelete.vue?vue&type=template&id=4436ee26
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce modèle de contrat ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractModelDelete/ContractModelDelete.ts?vue&type=script&lang=ts&external




var ContractModelDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractModelDelete, _super);
    function ContractModelDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ContractModelDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    ContractModelDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    ContractModelDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    ContractModelDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/sales/contract-model/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    ContractModelDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    ContractModelDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ContractModelDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractModelDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ContractModelDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], ContractModelDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractModelDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractModelDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractModelDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ContractModelDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], ContractModelDelete.prototype, "watchModalState", null);
    ContractModelDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ContractModelDelete);
    return ContractModelDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractModelDeletevue_type_script_lang_ts_external = (ContractModelDelete);

;// ./src/components/ContractModelDelete/ContractModelDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractModelDelete_ContractModelDeletevue_type_script_lang_ts_external = (ContractModelDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractModelDelete/ContractModelDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractModelDelete_ContractModelDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractModelDelete_ContractModelDelete = (component.exports);

/***/ }),

/***/ 11885:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ 12249:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'user';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f007';
var svgPathData = 'M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.X4 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 12507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(28754),
    hasUnicode = __webpack_require__(49698),
    stringToArray = __webpack_require__(63912),
    toString = __webpack_require__(13222);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 12651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(74218);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 12653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_InvoiceToPaidView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/InvoiceToPaidView.vue?vue&type=template&id=4481b565
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InvoiceToPaidList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InvoiceToPaidList/InvoiceToPaidList.vue?vue&type=template&id=2bba20a6
var InvoiceToPaidListvue_type_template_id_2bba20a6_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InvoiceList',{attrs:{"statusFilter":[2, 3, 4],"customStateKey":"sales-invoice-topaid"}})
}
var InvoiceToPaidListvue_type_template_id_2bba20a6_staticRenderFns = []


// EXTERNAL MODULE: ./src/components/InvoiceList/InvoiceList.vue + 2 modules
var InvoiceList = __webpack_require__(39690);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/InvoiceToPaidList/InvoiceToPaidList.ts?vue&type=script&lang=ts&external



var InvoiceToPaidList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(InvoiceToPaidList, _super);
    function InvoiceToPaidList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoiceToPaidList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                InvoiceList: InvoiceList/* default */.A
            }
        })
    ], InvoiceToPaidList);
    return InvoiceToPaidList;
}(lib/* Vue */.lD));
/* harmony default export */ var InvoiceToPaidListvue_type_script_lang_ts_external = (InvoiceToPaidList);

;// ./src/components/InvoiceToPaidList/InvoiceToPaidList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var InvoiceToPaidList_InvoiceToPaidListvue_type_script_lang_ts_external = (InvoiceToPaidListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/InvoiceToPaidList/InvoiceToPaidList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  InvoiceToPaidList_InvoiceToPaidListvue_type_script_lang_ts_external,
  InvoiceToPaidListvue_type_template_id_2bba20a6_render,
  InvoiceToPaidListvue_type_template_id_2bba20a6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InvoiceToPaidList_InvoiceToPaidList = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/InvoiceToPaidView.vue?vue&type=script&lang=ts



var InvoiceToPaidView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(InvoiceToPaidView, _super);
    function InvoiceToPaidView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoiceToPaidView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                InvoiceToPaidList: InvoiceToPaidList_InvoiceToPaidList
            }
        })
    ], InvoiceToPaidView);
    return InvoiceToPaidView;
}(lib/* Vue */.lD));
/* harmony default export */ var InvoiceToPaidViewvue_type_script_lang_ts = (InvoiceToPaidView);

;// ./src/views/InvoiceToPaidView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_InvoiceToPaidViewvue_type_script_lang_ts = (InvoiceToPaidViewvue_type_script_lang_ts); 
;// ./src/views/InvoiceToPaidView.vue





/* normalize component */
;
var InvoiceToPaidView_component = (0,componentNormalizer/* default */.A)(
  views_InvoiceToPaidViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_InvoiceToPaidView = (InvoiceToPaidView_component.exports);

/***/ }),

/***/ 12658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StripeSend_StripeSend; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StripeSend/StripeSend.vue?vue&type=template&id=f1fdf5e4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"title":"Envoi d'un lien de paiement","ok-title":"Envoyer","size":"lg","closeOnSubmit":false},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('k-form',{attrs:{"action":_vm.formAction,"value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete,"submitError":_vm.submitError}},[(_vm.error)?_c('b-alert',{attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e(),(_vm.type === 'quotation' || _vm.type === 'command')?_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Type de paiement"}},[_c('b-row',{staticClass:"mb-3 mt-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-radio',{attrs:{"value":1},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}},[_vm._v(" Un acompte de ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"min":1,"max":_vm.document.total_ttc,"size":"sm","disabled":_vm.mode !== 1},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1)],1)],1),_c('b-form-radio',{attrs:{"value":2},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}},[_vm._v(" La totalité du "+_vm._s(_vm.$t('sales.' + _vm.type + '.label').toLowerCase())+" : "+_vm._s(_vm.formattedNumber(_vm.document.total_ttc, _vm.document.currency))+" ")])],1):(_vm.type === 'invoice')?_c('b-form-group',{attrs:{"label":"Montant du paiement"},scopedSlots:_vm._u([{key:"description",fn:function(){return [_vm._v(" Montant restant à payer : "+_vm._s(_vm.formattedNumber(_vm.document.stay_to_pay, _vm.document.currency))+" ")]},proxy:true}])},[_c('div',{staticClass:"d-inline-block"},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol}},[_c('k-form-number',{attrs:{"min":1,"max":_vm.document.stay_to_pay},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1)],1)]):_c('b-form-group',{staticClass:"form-text",attrs:{"label-cols":"auto","label":"Montant du paiement"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.document.total_ttc, _vm.document.currency))+" ")]),_c('b-form-group',{attrs:{"label":"Destinataire"}},[_c('k-form-select',{attrs:{"options":_vm.availableRecipients,"validationName":"email","taggable":"","required":""},model:{value:(_vm.recipient),callback:function ($$v) {_vm.recipient=$$v},expression:"recipient"}})],1),_c('b-form-group',{attrs:{"label":"Sujet (faculatif)"}},[_c('k-form-input',{model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}})],1),_c('b-form-group',{attrs:{"label":"Message (faculatif)"}},[_c('k-form-editor',{attrs:{"size":"sm"},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./src/components/StripeSend/VariablesMixin.ts
var VariablesMixin = __webpack_require__(2787);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StripeSend/StripeSend.ts?vue&type=script&lang=ts&external







var StripeSend = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StripeSend, _super);
    function StripeSend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.mode = 1;
        _this.recipient = null;
        _this.message = null;
        _this.subject = null;
        _this.amount = null;
        _this.error = null;
        return _this;
    }
    StripeSend.prototype.mounted = function () {
        if (this.availableRecipients.length > 0) {
            this.recipient = this.availableRecipients[this.availableRecipients.length - 1];
        }
        if (this.type === 'quotation' || this.type === 'command') {
            var amount = this.document.advance_payment_amount;
            this.mode = amount > 0 ? 1 : 2;
            this.amount = amount;
        }
        else if (this.type === 'invoice') {
            this.amount = this.document.stay_to_pay;
        }
        this.applyModel();
    };
    Object.defineProperty(StripeSend.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StripeSend.prototype, "formAction", {
        get: function () {
            return '/sales/' + this.type + '/' + this.document.id + '/payment-link';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StripeSend.prototype, "formDatas", {
        get: function () {
            var _a, _b, _c, _d, _e, _f;
            var datas = {
                email: (_d = (_b = (_a = this.recipient) === null || _a === void 0 ? void 0 : _a.mail) !== null && _b !== void 0 ? _b : (_c = this.recipient) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : this.recipient,
                name: (_f = (_e = this.recipient) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : null,
                subject: this.subject,
                message: this.message,
            };
            if (this.type === 'quotation' || this.type === 'command') {
                datas.amount = this.mode === 1 ? this.amount : this.document.total_ttc;
            }
            else if (this.type === 'invoice') {
                datas.amount = this.amount;
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StripeSend.prototype, "availableRecipients", {
        get: function () {
            var recipients = [];
            var customer = this.document.customer;
            if (customer && customer.email) {
                recipients.push({
                    id: customer.id,
                    type: 'customer',
                    mail: customer.email,
                    name: customer.name,
                    label: customer.name + ' <' + customer.email + '>',
                    element: {
                        type: 'customer',
                        id: customer.id
                    },
                    data: customer
                });
            }
            var contact = this.document.contact;
            if (contact && contact.email) {
                recipients.push({
                    id: contact.id,
                    type: 'contact',
                    mail: contact.email,
                    name: contact.fullname + ' <' + contact.email + '>',
                    label: contact.fullname + ' <' + contact.email + '>',
                    element: {
                        type: 'contact',
                        id: contact.id
                    },
                    data: contact
                });
            }
            return recipients;
        },
        enumerable: false,
        configurable: true
    });
    StripeSend.prototype.submitComplete = function () {
        this.modalState = false;
    };
    StripeSend.prototype.submitError = function (error) {
        var _a;
        this.error = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
    };
    // Apply a model
    StripeSend.prototype.applyModel = function () {
        var model = null;
        switch (this.type) {
            case 'quotation':
                model = this.teamConfigs.stripe_mail_model_quotation;
                break;
            case 'command':
                model = this.teamConfigs.stripe_mail_model_command;
                break;
            case 'invoice':
                model = this.teamConfigs.stripe_mail_model_invoice;
                break;
        }
        if (!model) {
            return;
        }
        var content = this.getModelContents(model);
        this.message = content.html;
        this.subject = content.subject;
    };
    // Return model datas
    StripeSend.prototype.getModelContents = function (model) {
        var _a, _b, _c, _d;
        var elements = [
            {
                id: this.document.id,
                type: this.type,
                title: this.document.reference,
                data: this.document
            },
            {
                id: this.document.customer.id,
                type: 'customer',
                title: this.document.customer.name,
                data: this.document.customer
            }
        ];
        return {
            html: this.replaceVariables((_a = model.html) !== null && _a !== void 0 ? _a : '', elements, (_b = this.recipient) === null || _b === void 0 ? void 0 : _b.data),
            subject: this.htmltoText(this.replaceVariables((_c = model.subject) !== null && _c !== void 0 ? _c : '', elements, (_d = this.recipient) === null || _d === void 0 ? void 0 : _d.data))
        };
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], StripeSend.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], StripeSend.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], StripeSend.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Envoyer un lien de paiement' })
    ], StripeSend.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], StripeSend.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], StripeSend.prototype, "disabled", void 0);
    StripeSend = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BInputGroup: external_bootstrap_vue_.BInputGroup, BAlert: external_bootstrap_vue_.BAlert,
                KForm: form_vue_.KForm, KFormNumber: form_vue_.KFormNumber, KFormEditor: form_vue_.KFormEditor, KFormInput: form_vue_.KFormInput
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], StripeSend);
    return StripeSend;
}((0,lib/* Mixins */.Xe)(VariablesMixin/* default */.A)));
/* harmony default export */ var StripeSendvue_type_script_lang_ts_external = (StripeSend);

;// ./src/components/StripeSend/StripeSend.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StripeSend_StripeSendvue_type_script_lang_ts_external = (StripeSendvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/StripeSend/StripeSend.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StripeSend_StripeSendvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StripeSend_StripeSend = (component.exports);

/***/ }),

/***/ 12742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'university';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f19c';
var svgPathData = 'M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Qn = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 12749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(81042);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 12762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StripePayment_StripePayment; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StripePayment/StripePayment.vue?vue&type=template&id=908a80ca
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.paymentIntent)?_c('StripePaymentSuccessful',{attrs:{"clientSecret":_vm.paymentIntent.client_secret,"paymentIntent":_vm.paymentIntent,"accountId":_vm.data.link.stripe_account_id}}):(_vm.data)?_c('div',{staticClass:"stripe-public"},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v(_vm._s(_vm.data.name))])]),_c('b-col',{attrs:{"cols":"auto"}},[_vm._v(" Powered by "),_c('a',{attrs:{"href":"https://www.kwixeo.fr","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(92053),"alt":"Kwixeo logo","width":"58","height":"15"}})])])],1),_c('hr'),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","xl":"3","order":"1"}},[_c('b-button',{staticClass:"mb-3",attrs:{"variant":"primary","href":_vm.data.pdf_link,"target":"_blank","size":"sm"}},[_vm._v(" Télécharger ")]),_c('b-card',[_c('p',{staticClass:"font-weight-bold"},[_vm._v("Informations")]),_c('table',{staticClass:"table mb-0"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Numéro")]),_c('td',[_vm._v(_vm._s(_vm.data.document.reference))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Date")]),_c('td',[_vm._v(_vm._s(_vm.formatDate(_vm.data.document.date)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Échance")]),_c('td',[_vm._v(_vm._s(_vm.formatDate(_vm.data.document.expire_at)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Client")]),_c('td',[_vm._v(_vm._s(_vm.data.document.customer))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Montant total")]),_c('td',[_vm._v(_vm._s(_vm.data.document.total_ttc)+" "+_vm._s(_vm.data.document.currency.symbol))])]),(_vm.type === 'invoice')?[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Déjà payé")]),_c('td',[_vm._v(_vm._s(_vm.data.document.already_paid)+" "+_vm._s(_vm.data.document.currency.symbol))])]),_c('tr',{staticClass:"font-weight-bold text-success"},[_c('td',[_vm._v("Reste à payer")]),_c('td',[_vm._v(_vm._s(_vm.data.document.to_paid)+" "+_vm._s(_vm.data.document.currency.symbol))])])]:(_vm.data.link.amount !== _vm.data.document.total_ttc)?[_c('tr',{staticClass:"font-weight-bold text-success"},[_c('td',[_vm._v("Montant de l'acompte")]),_c('td',[_vm._v(_vm._s(_vm.data.link.amount)+" "+_vm._s(_vm.data.document.currency.symbol))])])]:_vm._e()],2)])])],1),_c('b-col',{staticClass:"mt-5 mt-xl-0",attrs:{"cols":"12","xl":"6","order":"3","order-xl":"2"}},[_c('PdfViewer',{attrs:{"src":_vm.data.pdf_link,"filename":_vm.data.document.reference}})],1),_c('b-col',{staticClass:"mt-5 mt-xl-0",attrs:{"cols":"12","md":"6","xl":"3","order":"2","order-xl":"3"}},[_c('b-card',{attrs:{"body-class":"p-0"}},[_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('h3',{staticClass:"px-4 py-3"},[_vm._v(" Paiement de "+_vm._s(_vm.data.link.amount)+" "+_vm._s(_vm.data.document.currency.symbol)+" ")]),_c('div',{ref:"paymentElement",staticClass:"px-4"}),_c('p',{staticClass:"text-center mt-4 pb-4"},[(_vm.errorMsg !== null)?_c('b-alert',{staticClass:"mx-4 mb-3 mt-4",attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_vm._e(),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.confirm.apply(null, arguments)}}},[_vm._v(" Payer ")])],1),(_vm.type !== 'invoice')?_c('b-alert',{staticClass:"mx-4 mb-3 mt-4",attrs:{"show":"","variant":"warning"}},[_vm._v(" Une facture vous sera envoyée à l'adresse "+_vm._s(_vm.data.link.email)+" après le paiement. ")]):_vm._e()],1)],1)],1)],1)],1):_vm._e()],1)
}
var staticRenderFns = []


;// ./src/components/StripePayment/StripePayment.vue?vue&type=template&id=908a80ca

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/mixins/StripeMixin.ts + 1 modules
var StripeMixin = __webpack_require__(50148);
// EXTERNAL MODULE: ./src/components/StripePaymentSuccessful/StripePaymentSuccessful.vue + 3 modules
var StripePaymentSuccessful = __webpack_require__(63849);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StripePayment/StripePayment.ts?vue&type=script&lang=ts&external







var StripePayment = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StripePayment, _super);
    function StripePayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorMsg = null;
        _this.loading = false;
        _this.paymentIntent = null;
        _this.elements = null;
        return _this;
    }
    StripePayment.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initializeStripe()];
                    case 1:
                        _a.sent();
                        this.$nextTick(function () {
                            _this.initializePaymentForm();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StripePayment.prototype, "stripeAccount", {
        get: function () {
            return this.data.link.stripe_account_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StripePayment.prototype, "teamId", {
        get: function () {
            return this.data.link.team_id;
        },
        enumerable: false,
        configurable: true
    });
    StripePayment.prototype.formatDate = function (date) {
        return external_moment_default()(date).format('DD-MM-YYYY');
    };
    // Initialize the payment form
    StripePayment.prototype.initializePaymentForm = function () {
        if (!this.stripe) {
            return;
        }
        this.elements = this.stripe.elements({
            clientSecret: this.data.link.client_secret,
            appearance: {
                variables: {
                    fontSizeBase: '.9rem'
                }
            }
        });
        var paymentElement = this.elements.create('payment', {
            fields: {
                billingDetails: 'never'
            },
            wallets: {
                applePay: 'never',
                googlePay: 'never'
            }
        });
        paymentElement.mount(this.$refs.paymentElement);
    };
    // Send the payment form
    StripePayment.prototype.confirm = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var stripe, elements, document, _h, error, paymentIntent;
            return (0,tslib_es6/* __generator */.YH)(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        stripe = this.stripe;
                        elements = this.elements;
                        if (!stripe || !elements) {
                            this.errorMsg = 'Erreur lors de l\'initialisation de l\'envoi';
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        document = this.data.document;
                        return [4 /*yield*/, stripe.confirmPayment({
                                elements: elements,
                                redirect: 'if_required',
                                confirmParams: {
                                    return_url: window.location.protocol + '//' + window.location.host + '/public/payment/' + this.data.link.stripe_account_id + '/checkout',
                                    payment_method_data: {
                                        billing_details: {
                                            address: {
                                                city: (_a = document.billing_address.city) !== null && _a !== void 0 ? _a : '',
                                                country: (_b = document.billing_address.country_code) !== null && _b !== void 0 ? _b : '',
                                                line1: (_c = document.billing_address.road) !== null && _c !== void 0 ? _c : '',
                                                line2: (_d = document.billing_address.road2) !== null && _d !== void 0 ? _d : '',
                                                postal_code: (_e = document.billing_address.postal_code) !== null && _e !== void 0 ? _e : '',
                                                state: ''
                                            },
                                            email: '',
                                            name: (_f = document.billing_address.name) !== null && _f !== void 0 ? _f : '',
                                            phone: ''
                                        }
                                    }
                                }
                            })];
                    case 1:
                        _h = _j.sent(), error = _h.error, paymentIntent = _h.paymentIntent;
                        this.loading = false;
                        if (error) {
                            this.errorMsg = (_g = error.message) !== null && _g !== void 0 ? _g : 'Une erreur est survenue lors du paiement';
                            return [2 /*return*/];
                        }
                        else if (paymentIntent) {
                            this.paymentIntent = paymentIntent;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], StripePayment.prototype, "data", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], StripePayment.prototype, "type", void 0);
    StripePayment = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert, BOverlay: external_bootstrap_vue_.BOverlay,
                PdfViewer: interface_vue_.PdfViewer,
                StripePaymentSuccessful: StripePaymentSuccessful/* default */.A
            }
        })
    ], StripePayment);
    return StripePayment;
}((0,lib/* Mixins */.Xe)(StripeMixin/* default */.A)));
/* harmony default export */ var StripePaymentvue_type_script_lang_ts_external = (StripePayment);

;// ./src/components/StripePayment/StripePayment.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StripePayment_StripePaymentvue_type_script_lang_ts_external = (StripePaymentvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/StripePayment/StripePayment.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StripePayment_StripePaymentvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StripePayment_StripePayment = (component.exports);

/***/ }),

/***/ 13222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(77556);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 13250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractMail_ContractMail; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractMail/ContractMail.vue?vue&type=template&id=88e1db0a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction + '?with_file=1',"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('p',[_vm._v(" Gérez, ci-dessous, l'email qui est envoyé lorsque vous paramétrez la facturation et l'envoi automatique de la facture. ")]),_c('h3',{staticClass:"form-title-alt"},[_vm._v("Expéditeur des emails")]),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-alert',{staticClass:"mb-0",attrs:{"variant":"warning","show":""}},[_vm._v(" Afin d'éviter le classement en SPAM et pour assurer la délivrabilité des emails, ils sont expédiés depuis l'adresse "),_c('strong',[_vm._v("notification@kwixeo.fr")]),_c('br'),_c('br'),_vm._v(" Vous avez cependant la possibilité de personnaliser le nom de l'expéditeur et l'adresse email utilisée lorsque l'on répond à un email. ")])],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":"Expéditeur :"}},[_c('k-form-input',{attrs:{"name":"configs[sales_contract_mail_name]"},model:{value:(_vm.localConfig.sales_contract_mail_name),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_name", $$v)},expression:"localConfig.sales_contract_mail_name"}})],1),_c('b-form-group',{attrs:{"label":"Email :"}},[_c('k-form-input',{attrs:{"type":"email","name":"configs[sales_contract_mail_reply]"},model:{value:(_vm.localConfig.sales_contract_mail_reply),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_reply", $$v)},expression:"localConfig.sales_contract_mail_reply"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v("Paramètres d'envoi des emails")]),_c('b-form-group',{attrs:{"label":"Heure d'envoi des emails"},scopedSlots:_vm._u([{key:"description",fn:function(){return [_vm._v(" Les factures sont générées à partir de 00h00 (Fuseau horaire de Paris) sans possibilité de connaître l'heure exacte de génération. Il n'est donc pas possible de programmer l'envoi avant 06h00 (Fuseau horaire de Paris). ")]},proxy:true}])},[_c('k-form-select',{attrs:{"name":"configs[sales_contract_mail_hour]","options":_vm.hourOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localConfig.sales_contract_mail_hour),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_hour", $$v)},expression:"localConfig.sales_contract_mail_hour"}})],1),_c('b-form-group',{staticClass:"mb-2",attrs:{"label":"Type d'emails"}},[_c('b-form-radio-group',{attrs:{"name":"configs[sales_contract_mail_type]","stacked":""},model:{value:(_vm.localConfig.sales_contract_mail_type),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_type", $$v)},expression:"localConfig.sales_contract_mail_type"}},[_c('b-form-radio',{attrs:{"value":1}},[_vm._v(" Envoi d'un lien permettant de télécharger la facture "),_c('p',{staticClass:"small"},[_vm._v(" Mode par défaut : utilisez la mise en page fournie par le logiciel. Un bouton sera présent permettant de télécharger la facture. ")])]),_c('b-form-radio',{attrs:{"value":2}},[_vm._v(" Envoi de la facture en pièce jointe "),_c('p',{staticClass:"small"},[_vm._v(" Utilisez un modèle d'emails que vous pourrez entièrement personnalisé. La facture sera alors présente en pièce jointe. ")])])],1)],1),(_vm.localConfig.sales_contract_mail_type === 2)?[_c('b-form-group',{staticClass:"mb-2",attrs:{"label":"Modèle d'email à utiliser :"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_contract_mail_model]"},domProps:{"value":_vm.localConfig.sales_contract_mail_model ? _vm.localConfig.sales_contract_mail_model.id : null}}),_c('k-form-select',{attrs:{"validationName":"configs[sales_contract_mail_model]","options":_vm.models,"required":"","label":"name","clearable":false},model:{value:(_vm.localConfig.sales_contract_mail_model),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_model", $$v)},expression:"localConfig.sales_contract_mail_model"}})],1),_c('b-button',{attrs:{"size":"sm","variant":"secondary","to":{ name: 'communication-models' }}},[_vm._v(" Gérer mes modèles d'email ")])]:[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Personnalisation de l'email ")]),_c('b-row',{ref:"formParent"},[_c('b-col',{ref:"formCol",attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":"Logo"}},[(_vm.localTeam.logo_contract_email)?[_c('p',{staticClass:"mb-2"},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":'data:image/png;base64,' + _vm.localTeam.logo_contract_email.file}})]),_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.askDeleteLogo = true}}},[_vm._v(" Supprimer ")]),_c('b-modal',{attrs:{"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"no-close-on-backdrop":_vm.deleting,"no-close-on-esc":_vm.deleting,"busy":_vm.deleting,"hide-header-close":_vm.deleting},on:{"hidden":function($event){_vm.deleting = false},"ok":_vm.deleteLogo},model:{value:(_vm.askDeleteLogo),callback:function ($$v) {_vm.askDeleteLogo=$$v},expression:"askDeleteLogo"}},[(_vm.deleting)?_c('Spinner'):[_vm._v(" Êtes-vous sûr de vouloir supprimer le logo ? ")]],2)]:_c('k-form-file',{attrs:{"accept":['image/png', 'image/jpeg'],"url":"/team?with_file=1","name":"logo_contract_email","method":"POST","datas":{ _method: 'put' },"required":"","btnMode":"","btnSize":"sm","btnTheme":"secondary","removeUploadedFile":""},on:{"onUpload":_vm.logoUpdated}})],2),_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Sujet du message"}},[_c('k-form-input',{ref:"subject",staticClass:"mb-2",attrs:{"name":"configs[sales_contract_mail_subject]","required":""},model:{value:(_vm.localConfig.sales_contract_mail_subject),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_subject", $$v)},expression:"localConfig.sales_contract_mail_subject"}}),_vm._v(" Vous pouvez utiliser les variables suivantes "),_c('u',[_vm._v("dans le sujet de l'email")]),_vm._v(" : "),_c('table',{staticClass:"table table-sm table-bordered small w-auto"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_c('tr',[_c('td',[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.insertSubjectVariable('[[DOC-NUM]]')}}},[_vm._v(" [[DOC-NUM]] ")])],1),_c('td',[_vm._v("Numéro de la facture")])]),_c('tr',[_c('td',[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.insertSubjectVariable('[[DATE]]')}}},[_vm._v(" [[DATE]] ")])],1),_c('td',[_vm._v("Date de la facture")])]),_c('tr',[_c('td',[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.insertSubjectVariable('[[TO-PAID]]')}}},[_vm._v(" [[TO-PAID]] ")])],1),_c('td',[_vm._v("Montant à payer")])])])])],1),_c('b-form-group',{attrs:{"label":"Début (message affiché au début de l'email)","description":"Il est possible de personnaliser ce message dans chacun des modèles de contrat."}},[_c('k-form-editor',{attrs:{"size":"sm","config":_vm.editorConfig,"name":"configs[sales_contract_mail_begin]","required":""},model:{value:(_vm.localConfig.sales_contract_mail_begin),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_begin", $$v)},expression:"localConfig.sales_contract_mail_begin"}})],1),_c('h3',{staticClass:"form-title-alt mt-4"},[_vm._v(" Bouton télécharger ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Couleur du texte"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm","name":"configs[sales_contract_mail_button_color]","required":""},model:{value:(_vm.localConfig.sales_contract_mail_button_color),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_button_color", $$v)},expression:"localConfig.sales_contract_mail_button_color"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Couleur de fond"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm","name":"configs[sales_contract_mail_button_background]","required":""},model:{value:(_vm.localConfig.sales_contract_mail_button_background),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_button_background", $$v)},expression:"localConfig.sales_contract_mail_button_background"}})],1)],1)],1),_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"Fin (message affiché à la fin de l'email)"}},[_c('k-form-editor',{attrs:{"size":"sm","config":_vm.editorConfig,"name":"configs[sales_contract_mail_end]","required":""},model:{value:(_vm.localConfig.sales_contract_mail_end),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_mail_end", $$v)},expression:"localConfig.sales_contract_mail_end"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":"Aperçu de l'email"}},[_c('MailTemplate',{attrs:{"config":_vm.localConfig}})],1)],1)],1)],_c('p',{staticClass:"mt-5"}),_c('k-form-sticky-bar',{staticClass:"text-center",attrs:{"parent":_vm.$refs.formCol,"relative-parent":_vm.$refs.formParent}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractMail/MailTemplate.vue?vue&type=template&id=02c79eec
var MailTemplatevue_type_template_id_02c79eec_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('html',[_vm._m(0),_c('body',{staticStyle:{"padding":"0","margin":"0"}},[_c('table',{staticStyle:{"border":"0","margin":"0","padding":"0"},attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0","bgcolor":"#F8F8F8"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"font-size":"16px"}},[_vm._v("     ")]),_c('td',[_c('table',{staticStyle:{"width":"480px","min-width":"480px","max-width":"480px"},attrs:{"cellspacing":"0","cellpadding":"0","border":"0","align":"center"}},[_c('tbody',[_c('tr',[_c('td',[_vm._m(1),_c('table',{staticClass:"w-100",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0"},style:({ 'text-align': _vm.team.logo_contract_email ? 'center' : 'left' })},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-weight":"500","color":"rgb(0,0,0)","font-size":"20px","line-height":"24px"}},[(_vm.team.logo_contract_email)?_c('img',{attrs:{"src":'data:image/' + _vm.team.logo_contract_email.extension + ';base64,' + _vm.team.logo_contract_email.file}}):[_vm._v(" "+_vm._s(_vm.team.company_name)+" ")]],2)])])])]),_vm._m(2),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{attrs:{"align":""}},[_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"1px","width":"482px","border-radius":"12px","background-color":"#e3e8ee"},attrs:{"align":""}},[_c('table',{staticStyle:{"width":"100%","background-color":"#ffffff","border-radius":"12px"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0"}},[_vm._m(3),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","min-width":"32px","width":"32px","font-size":"1px"}},[_vm._v("   ")]),_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0"}},[(_vm.messageBegin)?[_c('FroalaView',{staticStyle:{"color":"#000"},model:{value:(_vm.messageBegin),callback:function ($$v) {_vm.messageBegin=$$v},expression:"messageBegin"}}),_vm._m(4)]:_vm._e(),_vm._m(5),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{style:('border:0;border-collapse:collapse;margin:0;padding:0;width:100%;text-align:center;background-color:' + _vm.configs.sales_contract_mail_button_background + ';border-radius:6px;height:44px'),attrs:{"align":""}},[_c('a',{staticStyle:{"border":"0","margin":"0","padding":"0","text-decoration":"none","outline":"0","display":"block","text-align":"center","padding-right":"60px","padding-left":"60px"},attrs:{"href":"#"}},[_c('span',{style:('font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,\'Helvetica Neue\',Ubuntu,sans-serif;text-decoration:none;font-weight:500;font-size:16px;line-height:44px;color:' + _vm.configs.sales_contract_mail_button_color)},[_vm._v(" Télécharger ")])])])])])]),_vm._m(6),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%"},attrs:{"align":""}},[_c('FroalaView',{model:{value:(_vm.messageEnd),callback:function ($$v) {_vm.messageEnd=$$v},expression:"messageEnd"}})],1)])])])],2),_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","min-width":"32px","width":"32px","font-size":"1px"}},[_vm._v("   ")])])])]),_vm._m(7)])])])])])])])])])])])]),_vm._m(8),_vm._m(9)])])])])]),_c('td',{staticStyle:{"font-size":"16px"}},[_vm._v("     ")])]),_vm._m(10)])])])])
}
var MailTemplatevue_type_template_id_02c79eec_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('head',[_c('meta',{attrs:{"http-equiv":"Content-Type","content":"text/html; charset=UTF-8"}}),_c('title',[_vm._v("Lien de paiement")]),_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1.0"}})])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"30"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"20"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"32"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"16px","font-size":"1px","line-height":"1px"},attrs:{"colspan":"1","height":"16"}},[_vm._v("   ")])]),_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"1px","font-size":"1px","background-color":"#ebebeb","line-height":"1px"},attrs:{"height":"1"}},[_vm._v("   ")])]),_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"12px","font-size":"1px","line-height":"1px"},attrs:{"colspan":"1","height":"12"}},[_vm._v("   ")])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%"}},[_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","padding-bottom":"2px"},attrs:{"align":""}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#7a7a7a","font-size":"14px","line-height":"20px","font-weight":"500"}},[_vm._v(" Facture n°FA1222-01234 du 12/12/2022 ")])])])])]),_c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"10"}},[_c('div',[_vm._v(" ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","padding-bottom":"2px"},attrs:{"align":""}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#7a7a7a","font-size":"14px","line-height":"20px","font-weight":"500"}},[_vm._v(" Total TTC ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","padding-bottom":"2px"},attrs:{"align":""}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#1a1a1a","font-size":"36px","line-height":"40px","font-weight":"600"}},[_vm._v(" 60,00 € ")])])])])]),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"16px","font-size":"1px","line-height":"1px"},attrs:{"colspan":"1","height":"16"}},[_vm._v("   ")])]),_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"1px","font-size":"1px","background-color":"#ebebeb","line-height":"1px"},attrs:{"height":"1"}},[_vm._v("   ")])]),_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","height":"12px","font-size":"1px","line-height":"1px"},attrs:{"colspan":"1","height":"12"}},[_vm._v("   ")])])])])]),_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"76px","max-width":"76px"}},[_c('img',{staticStyle:{"border":"0","margin":"0 auto","padding":"0","display":"block"},attrs:{"src":__webpack_require__(96352),"alt":"Facture","width":"94","height":"91"}})])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"32"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"24"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{attrs:{"width":"100%","cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px","max-height":"1px"},attrs:{"height":"15"}},[_c('div',[_vm._v(" ")])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border":"0","border-collapse":"collapse","margin":"0","padding":"0","width":"100%","text-align":"center","color":"#979797"}},[_c('table',{attrs:{"align":"center"}},[_c('tbody',[_c('tr',[_c('td',[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-size":"12px","line-height":"14px"}},[_vm._v(" Powered by ")])]),_c('td',[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-size":"12px","line-height":"14px"}},[_c('a',{staticStyle:{"border":"0","margin":"0","padding":"0","text-decoration":"none","outline":"0"},attrs:{"href":"#"}},[_c('img',{staticStyle:{"border":"0","line-height":"100%","vertical-align":"middle"},attrs:{"src":__webpack_require__(92053),"alt":"Kwixeo logo","width":"58","height":"15","align":"middle"}})])])]),_c('td',[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","font-size":"12px","line-height":"14px"}},[_vm._v("   |   "),_c('a',{staticStyle:{"border":"0","margin":"0","padding":"0","text-decoration":"none","outline":"0"},attrs:{"href":"#"}},[_c('span',{staticStyle:{"font-family":"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Ubuntu,sans-serif","text-decoration":"none","color":"#979797"}},[_vm._v(" En savoir plus sur Kwixéo ")])])])])])])])])])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',{staticStyle:{"border":"0","margin":"0","padding":"0","font-size":"1px","line-height":"1px"},attrs:{"colspan":"3","height":"64"}},[_c('div',[_vm._v(" ")])])])
}]


;// ./src/components/ContractMail/MailTemplate.vue?vue&type=template&id=02c79eec

// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractMail/MailTemplate.ts?vue&type=script&lang=ts&external



var MailTemplate = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MailTemplate, _super);
    function MailTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MailTemplate.prototype, "configs", {
        get: function () {
            var _a;
            return (_a = this.config) !== null && _a !== void 0 ? _a : this.team.configs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MailTemplate.prototype, "messageBegin", {
        get: function () {
            return this.configs.sales_contract_mail_begin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MailTemplate.prototype, "messageEnd", {
        get: function () {
            return this.configs.sales_contract_mail_end;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], MailTemplate.prototype, "config", void 0);
    MailTemplate = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team']))
        })
    ], MailTemplate);
    return MailTemplate;
}(lib/* Vue */.lD));
/* harmony default export */ var MailTemplatevue_type_script_lang_ts_external = (MailTemplate);

;// ./src/components/ContractMail/MailTemplate.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractMail_MailTemplatevue_type_script_lang_ts_external = (MailTemplatevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractMail/MailTemplate.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractMail_MailTemplatevue_type_script_lang_ts_external,
  MailTemplatevue_type_template_id_02c79eec_render,
  MailTemplatevue_type_template_id_02c79eec_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractMail_MailTemplate = (component.exports);
// EXTERNAL MODULE: ./src/components/ContractMail/editorConfig.ts
var editorConfig = __webpack_require__(59368);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractMail/ContractMail.ts?vue&type=script&lang=ts&external








var ContractMail = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractMail, _super);
    function ContractMail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editorConfig = editorConfig/* default */.A;
        _this.askDeleteLogo = false;
        _this.deleting = false;
        _this.loading = false;
        return _this;
    }
    ContractMail.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadModels()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContractMail.prototype, "hourOptions", {
        get: function () {
            var options = [
                { label: 'Immédiatement après création de la facture', value: 0 }
            ];
            for (var i = 6; i < 24; i++) {
                options.push({ label: i + 'h00', value: i });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    ContractMail.prototype.insertSubjectVariable = function (variable) {
        var _a;
        var input = this.$refs.subject.$refs.input;
        var value = this.localConfig.sales_contract_mail_subject;
        var endPos = 0;
        if (input.selectionStart || input.selectionStart === 0) {
            var startPos = input.selectionStart;
            endPos = (_a = input.selectionEnd) !== null && _a !== void 0 ? _a : 0;
            value = value.substring(0, startPos)
                + variable
                + value.substring(endPos, value.length);
        }
        else {
            value += variable;
        }
        this.localConfig.sales_contract_mail_subject = value;
        this.$nextTick(function () {
            var newPos = endPos + variable.length;
            input.setSelectionRange(newPos, newPos);
            input.focus();
        });
    };
    ContractMail.prototype.logoUpdated = function (team) {
        this.setTeam(team);
    };
    ContractMail.prototype.deleteLogo = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.deleting = true;
                        return [4 /*yield*/, this.$kwSales.axios.put('/team?with_file=1', {
                                logo_contract_email: null
                            })
                                .then(function (response) {
                                _this.setTeam(response.data);
                                _this.askDeleteLogo = false;
                                _this.deleting = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractMail = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormSelect: form_vue_.KFormSelect, KForm: form_vue_.KForm, KFormTextarea: form_vue_.KFormTextarea, KFormEditor: form_vue_.KFormEditor, KFormInput: form_vue_.KFormInput, KFormFile: form_vue_.KFormFile, KFormStickyBar: form_vue_.KFormStickyBar,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BAlert: external_bootstrap_vue_.BAlert, BModal: external_bootstrap_vue_.BModal, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio,
                MailTemplate: ContractMail_MailTemplate,
                Spinner: interface_vue_.Spinner
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['loadModels'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('communication', ['models']))
        })
    ], ContractMail);
    return ContractMail;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var ContractMailvue_type_script_lang_ts_external = (ContractMail);

;// ./src/components/ContractMail/ContractMail.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractMail_ContractMailvue_type_script_lang_ts_external = (ContractMailvue_type_script_lang_ts_external); 
;// ./src/components/ContractMail/ContractMail.vue





/* normalize component */
;
var ContractMail_component = (0,componentNormalizer/* default */.A)(
  ContractMail_ContractMailvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractMail_ContractMail = (ContractMail_component.exports);

/***/ }),

/***/ 13333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CreditListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CreditListView.vue?vue&type=template&id=1857c7d4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CreditList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CreditList/CreditList.vue + 2 modules
var CreditList = __webpack_require__(17212);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CreditListView.vue?vue&type=script&lang=ts



var CreditListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CreditListView, _super);
    function CreditListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreditListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CreditList: CreditList/* default */.A
            }
        })
    ], CreditListView);
    return CreditListView;
}(lib/* Vue */.lD));
/* harmony default export */ var CreditListViewvue_type_script_lang_ts = (CreditListView);

;// ./src/views/CreditListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CreditListViewvue_type_script_lang_ts = (CreditListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/CreditListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CreditListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CreditListView = (component.exports);

/***/ }),

/***/ 14248:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 14528:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 14974:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 15374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractDeadlines_ContractDeadlines; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractDeadlines/ContractDeadlines.vue?vue&type=template&id=66454cf8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contract-deadlines"},[(_vm.loading)?_c('Spinner'):_c('div',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Afficher les échéances :","label-size":"sm"}},[_c('k-form-select',{attrs:{"size":"sm","clearable":false,"reduce":opt => opt.value,"options":[
              { label: 'À facturer', value: 1 },
              { label: 'Facturées', value: 2 },
              { label: 'Annulées ', value: 3 },
              { label: 'Toutes', value: 4 }
            ]},model:{value:(_vm.showMode),callback:function ($$v) {_vm.showMode=$$v},expression:"showMode"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Trie par date d'échéance :","label-size":"sm"}},[_c('k-form-select',{attrs:{"size":"sm","clearable":false,"reduce":opt => opt.value,"options":[
              { label: 'Croissante', value: 1 },
              { label: 'Décroissante', value: 2 },
            ]},model:{value:(_vm.orderMode),callback:function ($$v) {_vm.orderMode=$$v},expression:"orderMode"}})],1)],1)],1),_c('div',{staticClass:"contract-deadlines-area"},_vm._l((_vm.deadlines[_vm.currentPage]),function(deadline,i){return _c('div',{key:i},[_c('div',{class:{
            'contract-deadline': true,
            'canceled': deadline.canceled_at !== null
          }},[_c('p',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm.date(deadline.date))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(deadline.total_ttc))+" TTC ")]),_c('p',{staticClass:"period"},[_vm._v(" "+_vm._s(_vm.date(deadline.begin))+" au "+_vm._s(_vm.date(deadline.end))+" ")]),(_vm.contract.status < 4)?_c('div',{staticClass:"actions"},[(deadline.invoice)?[_c('b-button',{attrs:{"variant":"link","to":{ name: 'invoice-item', params: { id: String(deadline.invoice.id) } }}},[_vm._v(" Facture n°"+_vm._s(deadline.invoice.reference)+" ")])]:(deadline.canceled_at === null)?[(_vm.contract.status === 3)?[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.billDeadline = deadline}}},[_vm._v(" Facturer ")]),_vm._v(" | ")]:_vm._e(),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: 'Annuler l\'échéance' }),expression:"{ title: 'Annuler l\\'échéance' }"}],attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.cancelDeadlineIndex = i}}},[_vm._v(" Annuler ")])]:[_c('span',{staticClass:"text-danger"},[_vm._v(" Annulée ")]),_c('span',{staticClass:"hover"},[_vm._v(" | ")]),_c('b-button',{staticClass:"hover",attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.restoreDeadline = i}}},[_vm._v(" Restaurer ")])]],2):_vm._e()])])}),0),(_vm.totals > _vm.perPage)?_c('b-pagination',{staticClass:"mt-4",attrs:{"total-rows":_vm.totals,"per-page":_vm.perPage,"align":"center","size":"sm"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e(),_c('ContractDeadlinesCancel',{attrs:{"value":_vm.cancelDeadlineIndex !== null ? _vm.deadlines[_vm.currentPage][_vm.cancelDeadlineIndex] : null,"contract":_vm.contract,"previous":_vm.previousDeadline,"next":_vm.nextDeadline},on:{"hidden":function($event){_vm.cancelDeadlineIndex = null},"canceled":_vm.canceledDeadline}}),_c('ContractDeadlinesRestore',{attrs:{"value":_vm.restoreDeadline !== null ? _vm.deadlines[_vm.currentPage][_vm.restoreDeadline] : null,"contract":_vm.contract},on:{"hidden":function($event){_vm.restoreDeadline = null},"restored":_vm.restoredDeadline}}),_c('ContractDeadlinesBill',{attrs:{"contract":_vm.contract},on:{"hidden":function($event){_vm.billDeadline = null}},model:{value:(_vm.billDeadline),callback:function ($$v) {_vm.billDeadline=$$v},expression:"billDeadline"}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/ContractDeadlinesCancel/ContractDeadlinesCancel.vue + 3 modules
var ContractDeadlinesCancel = __webpack_require__(60134);
// EXTERNAL MODULE: ./src/components/ContractDeadlinesRestore/ContractDeadlinesRestore.vue + 3 modules
var ContractDeadlinesRestore = __webpack_require__(4549);
// EXTERNAL MODULE: ./src/components/ContractDeadlinesBill/ContractDeadlinesBill.vue + 3 modules
var ContractDeadlinesBill = __webpack_require__(77836);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractDeadlines/ContractDeadlines.ts?vue&type=script&lang=ts&external








var ContractDeadlines = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractDeadlines, _super);
    function ContractDeadlines() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.deadlines = {};
        _this.totals = 0;
        _this.lastPage = 1;
        _this.currentPage = 1;
        _this.perPage = 15;
        _this.showMode = 1;
        _this.orderMode = 1;
        _this.showCanceled = false;
        _this.showInvoiced = false;
        _this.cancelDeadlineIndex = null;
        _this.restoreDeadline = null;
        _this.billDeadline = null;
        return _this;
    }
    ContractDeadlines.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadDeadlines()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContractDeadlines.prototype, "previousDeadline", {
        get: function () {
            var index = this.cancelDeadlineIndex;
            if (index === null || (this.currentPage === 1 && index === 0)) {
                return null;
            }
            else if (index > 0) {
                return this.deadlines[this.currentPage][index - 1];
            }
            else {
                var previousPage = this.currentPage - 1;
                if (!this.deadlines[previousPage]) {
                    this.loadDeadlines(previousPage);
                }
                var deadlines = this.deadlines[previousPage];
                return deadlines ? deadlines[deadlines.length - 1] : null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractDeadlines.prototype, "nextDeadline", {
        get: function () {
            var index = this.cancelDeadlineIndex;
            if (index === null || (this.currentPage === this.lastPage && index === (this.deadlines[this.currentPage].length - 1))) {
                // If no index or this is the last deadline
                return null;
            }
            if ((index + 1) < this.perPage) {
                // If next deadline is on the same page
                return this.deadlines[this.currentPage][index + 1];
            }
            var nextPage = this.currentPage + 1;
            if (!this.deadlines[nextPage]) {
                this.loadDeadlines(nextPage);
            }
            return this.deadlines[nextPage] ? this.deadlines[nextPage][0] : null;
        },
        enumerable: false,
        configurable: true
    });
    ContractDeadlines.prototype.watchChanges = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.deadlines = [];
                        this.currentPage = 1;
                        return [4 /*yield*/, this.loadDeadlines()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractDeadlines.prototype.watchCurrentPage = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadDeadlines()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractDeadlines.prototype.loadDeadlines = function (page) {
        if (page === void 0) { page = null; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var status;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!page) {
                            page = this.currentPage;
                        }
                        if (this.deadlines[page]) {
                            return [2 /*return*/];
                        }
                        status = [];
                        switch (this.showMode) {
                            case 1:
                                status.push(1);
                                break;
                            case 2:
                                status.push(2);
                                break;
                            case 3:
                                status.push(3);
                                break;
                            case 4:
                                status = null;
                                break;
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/contract/deadline', {
                                params: {
                                    filter: {
                                        contract: this.contract.id,
                                        status: status
                                    },
                                    include: ['invoice'],
                                    per_page: this.perPage,
                                    page: page,
                                    sort: 'date:' + (this.orderMode === 1 ? 'asc' : 'desc')
                                }
                            })
                                .then(function (response) {
                                var datas = response.data;
                                lib/* Vue */.lD.set(_this.deadlines, page, datas.data);
                                _this.totals = datas.meta.total;
                                _this.lastPage = datas.meta.last_page;
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractDeadlines.prototype.canceledDeadline = function (deadline) {
        lib/* Vue */.lD.set(this.deadlines[this.currentPage], this.cancelDeadlineIndex, deadline);
        this.cancelDeadlineIndex = null;
    };
    ContractDeadlines.prototype.restoredDeadline = function (deadline) {
        lib/* Vue */.lD.set(this.deadlines[this.currentPage], this.restoreDeadline, deadline);
        this.restoreDeadline = null;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlines.prototype, "contract", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('contract', { deep: true }),
        (0,lib/* Watch */.ox)('orderMode'),
        (0,lib/* Watch */.ox)('showMode')
    ], ContractDeadlines.prototype, "watchChanges", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('currentPage')
    ], ContractDeadlines.prototype, "watchCurrentPage", null);
    ContractDeadlines = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BButton: external_bootstrap_vue_.BButton, BPagination: external_bootstrap_vue_.BPagination, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BOverlay: external_bootstrap_vue_.BOverlay,
                ContractDeadlinesCancel: ContractDeadlinesCancel/* default */.A,
                ContractDeadlinesRestore: ContractDeadlinesRestore/* default */.A,
                ContractDeadlinesBill: ContractDeadlinesBill/* default */.A,
                KFormSelect: form_vue_.KFormSelect
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ContractDeadlines);
    return ContractDeadlines;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var ContractDeadlinesvue_type_script_lang_ts_external = (ContractDeadlines);

;// ./src/components/ContractDeadlines/ContractDeadlines.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractDeadlines_ContractDeadlinesvue_type_script_lang_ts_external = (ContractDeadlinesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractDeadlines/ContractDeadlines.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractDeadlines_ContractDeadlinesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDeadlines_ContractDeadlines = (component.exports);

/***/ }),

/***/ 15389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(93663),
    baseMatchesProperty = __webpack_require__(87978),
    identity = __webpack_require__(83488),
    isArray = __webpack_require__(56449),
    property = __webpack_require__(50583);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 15760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CustomerSepaParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomerSepaParamsView.vue?vue&type=template&id=75230e44
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CustomerSepaParams')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CustomerSepaParams/CustomerSepaParams.vue + 3 modules
var CustomerSepaParams = __webpack_require__(60843);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomerSepaParamsView.vue?vue&type=script&lang=ts



var CustomerSepaParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSepaParamsView, _super);
    function CustomerSepaParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerSepaParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomerSepaParams: CustomerSepaParams/* default */.A
            }
        })
    ], CustomerSepaParamsView);
    return CustomerSepaParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerSepaParamsViewvue_type_script_lang_ts = (CustomerSepaParamsView);

;// ./src/views/CustomerSepaParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CustomerSepaParamsViewvue_type_script_lang_ts = (CustomerSepaParamsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/CustomerSepaParamsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CustomerSepaParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CustomerSepaParamsView = (component.exports);

/***/ }),

/***/ 15867:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ 16041:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'calendar-alt';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f073';
var svgPathData = 'M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.BE = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 16547:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(43360),
    eq = __webpack_require__(75288);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 16618:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
              ? 'genitive'
              : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ 16951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractDownload_ContractDownload; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractDownload/ContractDownload.vue?vue&type=template&id=00999994
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.close'),"ok-only":"","busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:_vm._e()],2)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractDownload/ContractDownload.ts?vue&type=script&lang=ts&external




var ContractDownload = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractDownload, _super);
    function ContractDownload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ContractDownload.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    ContractDownload.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    ContractDownload.prototype.watchModalState = function (state) {
        if (state) {
            this.process();
        }
    };
    ContractDownload.prototype.process = function () {
        var _this = this;
        this.$kwSales.axios.get('/sales/contract/' + this.value.id + '/document', {
            params: {
                force: this.force === false ? 0 : 1
            }
        })
            .then(function (response) {
            var file = response.data;
            _this.downloadFile(file.file, file.filename);
            _this.modalState = false;
            var contract = JSON.parse(JSON.stringify(_this.value));
            contract.document_status = 2;
            _this.$emit('input', contract);
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            throw new Error(error);
        });
    };
    ContractDownload.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    ContractDownload.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ContractDownload.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDownload.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ContractDownload.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Contrat' })
    ], ContractDownload.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractDownload.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractDownload.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractDownload.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractDownload.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractDownload.prototype, "force", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ContractDownload.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], ContractDownload.prototype, "watchModalState", null);
    ContractDownload = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, Spinner: interface_vue_.Spinner
            }
        })
    ], ContractDownload);
    return ContractDownload;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var ContractDownloadvue_type_script_lang_ts_external = (ContractDownload);

;// ./src/components/ContractDownload/ContractDownload.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractDownload_ContractDownloadvue_type_script_lang_ts_external = (ContractDownloadvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractDownload/ContractDownload.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractDownload_ContractDownloadvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDownload_ContractDownload = (component.exports);

/***/ }),

/***/ 17160:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ 17212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CreditList_CreditList; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesListMixin/SalesListMixin.vue + 3 modules
var SalesListMixin = __webpack_require__(68067);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatus.ts
var SalesDocumentStatus = __webpack_require__(70468);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CreditList/CreditList.ts?vue&type=script&lang=ts&external




var CreditList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CreditList, _super);
    function CreditList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'credit';
        _this.includes = [
            'customer', 'contact', 'billing_address_country', 'delivery_address_country',
            'currency', 'teamUser', 'tags', 'affairs'
        ];
        _this.additionalColumns = [
            {
                data: 'already_paid',
                name: 'Déjà utilisé',
                visible: false,
                render: 'currency'
            },
            {
                data: 'stay_to_pay',
                name: 'Reste à utiliser',
                visible: false,
                render: 'currency'
            }
        ];
        return _this;
    }
    Object.defineProperty(CreditList.prototype, "status", {
        get: function () {
            return this.creditStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreditList.prototype, "statusIndicator", {
        get: function () {
            return [
                { class: 'status-credit-1', label: 'Brouillon' },
                { class: 'status-credit-2', label: 'Non utilisé' },
                { class: 'status-credit-4', label: 'Utilisé partiellement' },
                { class: 'status-credit-5', label: 'Utilisé' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CreditList.prototype.canBeEdited = function (invoice) {
        return invoice.is_draft;
    };
    CreditList = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], CreditList);
    return CreditList;
}((0,lib/* Mixins */.Xe)(SalesListMixin/* default */.A, SalesDocumentStatus/* default */.A)));
/* harmony default export */ var CreditListvue_type_script_lang_ts_external = (CreditList);

;// ./src/components/CreditList/CreditList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CreditList_CreditListvue_type_script_lang_ts_external = (CreditListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CreditList/CreditList.vue
var render, staticRenderFns
;



/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CreditList_CreditListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CreditList_CreditList = (component.exports);

/***/ }),

/***/ 17255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(47422);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 17258:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'envelope';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f0e0';
var svgPathData = 'M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.y_ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 17357:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ 17369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionDocumentItem_CommissionDocumentItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionDocumentItem/CommissionDocumentItem.vue?vue&type=template&id=00a35b26
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"size":"lg"},on:{"hidden":function($event){return _vm.$emit('hidden')}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-form-row',{staticClass:"w-100"},[_c('b-col',[(_vm.can('sales-commissions', 3))?_c('b-button',{staticClass:"d-inline-block mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.edit.apply(null, arguments)}}},[_vm._v(" Modifier ")]):_vm._e(),(_vm.can('sales-commissions', 4))?_c('CommissionDocumentDelete',{staticClass:"d-inline-block",on:{"deleted":_vm.deleted},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" Fermer ")])],1)],1)]}}]),model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('b-row',{attrs:{"cols":"3"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Date"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.date))+" ")])],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Commercial"}},[_vm._v(" "+_vm._s(_vm.value.team_user?.fullname)+" ")])],1),_c('b-col',[_c('b-form-group',{staticClass:"font-weight-bold text-danger",attrs:{"label":"Montant de la commission"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.amount))+" ")])],1)],1),(_vm.value?.comments)?_c('b-form-group',{staticClass:"mb-4 mt-2",attrs:{"label":"Commentaires"}},[_c('TextareaView',{attrs:{"value":_vm.value.comments}})],1):_vm._e(),(_vm.value.document_type)?[_c('h2',{staticClass:"form-title-alt mt-3"},[_vm._v(" Élément(s) lié(s) ")]),_c('b-row',{attrs:{"cols":"3"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Document"}},[_c('router-link',{attrs:{"to":{ name: _vm.value.document_type + '-item', params: { id: String(_vm.value.document_id) }}}},[_vm._v(" "+_vm._s(_vm.$t('sales.' + _vm.value.document_type + '.reference', { reference: _vm.value.document_reference }))+" ")])],1)],1),(_vm.paymentUse)?_c('b-col',[_c('b-form-group',{attrs:{"label":"Paiement"}},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.showPayment = true}}},[_vm._v(" HT : "+_vm._s(_vm.formattedNumber(_vm.paymentUse.ht))+" / TTC : "+_vm._s(_vm.formattedNumber(_vm.paymentUse.ttc))+" ")])],1),(_vm.value.payment)?_c('PaymentItem',{attrs:{"value":_vm.value.payment,"modal":_vm.showPayment,"withActions":false},on:{"hidden":function($event){_vm.showPayment = false}}}):_vm._e()],1):_vm._e()],1)]:_vm._e(),_c('h2',{staticClass:"form-title-alt mt-3"},[_vm._v(" Calcul de la prime ")]),(_vm.value?.auto_amount !== null && _vm.value?.manual_amount !== null)?_c('div',{staticClass:"text-danger font-weight-bold"},[_vm._v(" Le montant de la prime a été modifié manuellement ")]):(_vm.value?.manual_amount !== null)?_c('div',{staticClass:"text-danger font-weight-bold"},[_vm._v(" Cette prime a été ajoutée manuellement ")]):_c('b-row',{attrs:{"cols":"3"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Base de calcul"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.base_amount))+" ")])],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Commission"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.pourcentage))+" % ")])],1),(_vm.value.minimum && _vm.value.minimum === _vm.value.amount)?_c('b-col',[_c('b-form-group',{attrs:{"label":"Commission minimum"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.minimum))+" ")])],1):_vm._e(),(_vm.value.maximum && _vm.value.maximum === _vm.value.amount)?_c('b-col',[_c('b-form-group',{attrs:{"label":"Commission maximum"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.maximum))+" ")])],1):_vm._e()],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/PaymentItem/PaymentItem.vue + 3 modules
var PaymentItem = __webpack_require__(8446);
// EXTERNAL MODULE: ./src/components/CommissionDocumentDelete/CommissionDocumentDelete.vue + 3 modules
var CommissionDocumentDelete = __webpack_require__(50643);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionDocumentItem/CommissionDocumentItem.ts?vue&type=script&lang=ts&external







var CommissionDocumentItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionDocumentItem, _super);
    function CommissionDocumentItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.showPayment = false;
        return _this;
    }
    Object.defineProperty(CommissionDocumentItem.prototype, "paymentUse", {
        get: function () {
            var _this = this;
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c.find(function (document) { var _a, _b; return document.document_type === ((_a = _this.value) === null || _a === void 0 ? void 0 : _a.document_type) && document.document_id === ((_b = _this.value) === null || _b === void 0 ? void 0 : _b.document_id); })) !== null && _d !== void 0 ? _d : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionDocumentItem.prototype, "withMinimum", {
        get: function () {
            return this.value !== null && this.value.minimum !== null && this.value.minimum === this.value.amount;
        },
        enumerable: false,
        configurable: true
    });
    CommissionDocumentItem.prototype.watchValue = function () {
        this.modalState = this.value !== null;
    };
    CommissionDocumentItem.prototype.watchModal = function () {
        this.modalState = this.modal;
    };
    CommissionDocumentItem.prototype.deleted = function () {
        this.$emit('deleted', this.value);
        this.modalState = false;
    };
    CommissionDocumentItem.prototype.edit = function () {
        this.$emit('edit', this.value);
        this.modalState = false;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommissionDocumentItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommissionDocumentItem.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CommissionDocumentItem.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CommissionDocumentItem.prototype, "watchModal", null);
    CommissionDocumentItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormRow: external_bootstrap_vue_.BFormRow, BFormGroup: external_bootstrap_vue_.BFormGroup, BModal: external_bootstrap_vue_.BModal, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton,
                TextareaView: interface_vue_.TextareaView,
                PaymentItem: PaymentItem/* default */.A,
                CommissionDocumentDelete: CommissionDocumentDelete/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], CommissionDocumentItem);
    return CommissionDocumentItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var CommissionDocumentItemvue_type_script_lang_ts_external = (CommissionDocumentItem);

;// ./src/components/CommissionDocumentItem/CommissionDocumentItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionDocumentItem_CommissionDocumentItemvue_type_script_lang_ts_external = (CommissionDocumentItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionDocumentItem/CommissionDocumentItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionDocumentItem_CommissionDocumentItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionDocumentItem_CommissionDocumentItem = (component.exports);

/***/ }),

/***/ 17400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(99374);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 17538:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ 17583:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f111';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GE = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 17670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(12651);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 17721:
/***/ (function(module) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),

/***/ 17730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ 17819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractPeriodDelete_ContractPeriodDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractPeriodDelete/ContractPeriodDelete.vue?vue&type=template&id=3ac5c6ff
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'delete')),"ok-only":_vm.errorMsg !== null,"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"cancel":_vm.onCancel},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[(_vm.errorMsg !== null)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" Êtes-vous sûr de vouloir supprimer cette période ? ")])],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractPeriodDelete/ContractPeriodDelete.ts?vue&type=script&lang=ts&external




var ContractPeriodDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractPeriodDelete, _super);
    function ContractPeriodDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    ContractPeriodDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    ContractPeriodDelete.prototype.onCancel = function () {
        this.errorMsg = null;
        return null;
    };
    ContractPeriodDelete.prototype.onOk = function (prevent) {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        prevent.preventDefault();
                        if (this.errorMsg !== null) {
                            this.onCancel();
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.delete('/sales/contract/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.contract_id) + '/period/' + ((_b = this.value) === null || _b === void 0 ? void 0 : _b.id))
                                .then(function (response) {
                                _this.$emit('deleted');
                                interface_vue_.emitter.emit('contractUpdated', response.data);
                                interface_vue_.emitter.emit('contractPeriodDeleted');
                                _this.onCancel();
                            })
                                .catch(function (error) {
                                _this.errorMsg = error.response.data.message;
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractPeriodDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ContractPeriodDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], ContractPeriodDelete.prototype, "onCancel", null);
    ContractPeriodDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], ContractPeriodDelete);
    return ContractPeriodDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractPeriodDeletevue_type_script_lang_ts_external = (ContractPeriodDelete);

;// ./src/components/ContractPeriodDelete/ContractPeriodDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractPeriodDelete_ContractPeriodDeletevue_type_script_lang_ts_external = (ContractPeriodDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractPeriodDelete/ContractPeriodDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractPeriodDelete_ContractPeriodDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractPeriodDelete_ContractPeriodDelete = (component.exports);

/***/ }),

/***/ 17870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionPaymentDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionPaymentDelete/CommissionPaymentDelete.vue?vue&type=template&id=fa61a68a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer le paiement des commissions ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionPaymentDelete/CommissionPaymentDelete.ts?vue&type=script&lang=ts&external




var CommissionDocumentDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionDocumentDelete, _super);
    function CommissionDocumentDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(CommissionDocumentDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    CommissionDocumentDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CommissionDocumentDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CommissionDocumentDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/sales/commission/payment/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    CommissionDocumentDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    CommissionDocumentDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CommissionDocumentDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommissionDocumentDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CommissionDocumentDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], CommissionDocumentDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommissionDocumentDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommissionDocumentDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommissionDocumentDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommissionDocumentDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CommissionDocumentDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CommissionDocumentDelete.prototype, "watchModalState", null);
    CommissionDocumentDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CommissionDocumentDelete);
    return CommissionDocumentDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CommissionPaymentDeletevue_type_script_lang_ts_external = (CommissionDocumentDelete);

;// ./src/components/CommissionPaymentDelete/CommissionPaymentDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionPaymentDelete_CommissionPaymentDeletevue_type_script_lang_ts_external = (CommissionPaymentDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionPaymentDelete/CommissionPaymentDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionPaymentDelete_CommissionPaymentDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionPaymentDelete = (component.exports);

/***/ }),

/***/ 18281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleExportsDownload_SaleExportsDownload; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleExportsDownload/SaleExportsDownload.vue?vue&type=template&id=322a1598
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-overlay',{attrs:{"show":_vm.downloading}},[_c('div',{staticClass:"text-center"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('kwTable.exports.downloadExplain'))+" ")]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.download(_vm.id)}}},[_vm._v(" "+_vm._s(_vm.$t('kwTable.exports.download'))+" ")])],1)])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleExportsDownload/SaleExportsDownload.ts?vue&type=script&lang=ts&external




var SaleExportsDownload = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleExportsDownload, _super);
    function SaleExportsDownload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Downloading loading
        _this.downloading = false;
        return _this;
    }
    SaleExportsDownload.prototype.fetchFile = function (id) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                this.downloading = true;
                return [2 /*return*/, (_a = this.$kwSales.axios) === null || _a === void 0 ? void 0 : _a.get('/sales/pdf-exports/' + id + '/download', { responseType: 'blob' }).then(function (response) {
                        return response;
                    }).finally(function () {
                        _this.downloading = false;
                    })];
            });
        });
    };
    SaleExportsDownload.prototype.download = function (id) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response, filename;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.fetchFile(id)];
                    case 1:
                        response = _b.sent();
                        if (!response) {
                            return [2 /*return*/];
                        }
                        filename = (_a = response.headers['x-suggested-filename']) !== null && _a !== void 0 ? _a : 'export-pdf.zip';
                        this.downloadFile(response.data, filename, false);
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SaleExportsDownload.prototype, "id", void 0);
    SaleExportsDownload = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], SaleExportsDownload);
    return SaleExportsDownload;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var SaleExportsDownloadvue_type_script_lang_ts_external = (SaleExportsDownload);

;// ./src/components/SaleExportsDownload/SaleExportsDownload.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleExportsDownload_SaleExportsDownloadvue_type_script_lang_ts_external = (SaleExportsDownloadvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SaleExportsDownload/SaleExportsDownload.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleExportsDownload_SaleExportsDownloadvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleExportsDownload_SaleExportsDownload = (component.exports);

/***/ }),

/***/ 18648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PublicSignatureView_PublicSignatureView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PublicSignatureView/PublicSignatureView.vue?vue&type=template&id=64803a6f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100"},[(_vm.loading)?_c('Spinner'):_c('div',{staticClass:"sign-public-area h-100"},[_c('header',{class:{ 'text-center': true, 'pt-4': !_vm.link.is_direct_sign, 'py-2': _vm.link.is_direct_sign}},[(_vm.link?.logo)?_c('img',{attrs:{"src":'data:image/' + _vm.link.logo.extension + ';base64, ' + _vm.link.logo.file}}):_vm._e(),(!_vm.link.is_direct_sign)?_c('p',{staticClass:"mt-3 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.link.user)+" vous invite à signer le document suivant "),(_vm.$te('sales.' + _vm.link.documents[0].type + '.reference', { reference: _vm.link.documents[0].reference }))?[_vm._v(" : "+_vm._s(_vm.$t('sales.' + _vm.link.documents[0].type + '.reference', { reference: _vm.link.documents[0].reference }))+" ")]:_vm._e()],2):_vm._e()]),_c('div',{staticClass:"sign-part"},[_c('div',{staticClass:"w-100 h-100",attrs:{"id":"iframe-yousign"}})])])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./src/views/PublicSignatureView/yousign.js
/**
 * Yousign
 * iframe-sdk-1.6.0.min.js
 */
var Yousign=function(){"use strict";var e;!function(e){e.STARTED="started",e.SUCCESS="success",e.ERROR="error",e.PING="ping",e.DECLINED="declined",e.SIGNATURE_DONE="signature.done"}(e||(e={}));class t extends Error{constructor(){super(),this.name="InvalidSignatureLink",this.message="The signature link is invalid."}}class i extends Error{constructor(e){super(),this.name="IframeContainerNotFound",this.message=`The iFrame container with the id "${e}" is not found.`}}class n extends Error{constructor(e){super(),this.name="InvalidCallbackFunction",this.message=`Callback on ${e} event is not a function.`}}return class{constructor({signatureLink:e,iframeContainerId:n,isSandbox:s,iframeAttributes:r}){let a;this.childOrigin=/^https:\/\/yousign.app$/,this.eventCallbacks={};try{a=new URL(e)}catch(e){throw new t}const o=document.getElementById(n);if(!o)throw new i(n);s&&a.searchParams.append("disable_domain_validation","true"),this.urlParams=new Proxy(a.searchParams,{get:(e,t)=>e.get(t)}),this.iframe=document.getElementById("yousign-iframe"),this.iframe||(this.iframe=document.createElement("iframe"),this.iframe.id="yousign-iframe",o.appendChild(this.iframe)),this.iframe.src=a.href,(null==r?void 0:r.referrerPolicy)&&(this.iframe.referrerPolicy=r.referrerPolicy),this.messageHandler=this.receiveMessage.bind(this),window.addEventListener("message",this.messageHandler,!1)}receiveMessage(e){const{origin:t,data:i}=e;t.match(this.childOrigin)&&"yousign"===i.type&&this.eventCallbacks[i.event]&&"function"==typeof this.eventCallbacks[i.event]&&this.eventCallbacks[i.event](i),"__ubble"===i.type&&i.payload.redirectUrl&&(this.iframe.src=`${i.payload.redirectUrl}&k=${this.urlParams.k}`)}onStarted(t){if("function"!=typeof t)throw new n(e.STARTED);this.eventCallbacks.started=t}onSuccess(t){if("function"!=typeof t)throw new n(e.SUCCESS);this.eventCallbacks.success=t}onError(t){if("function"!=typeof t)throw new n(e.ERROR);this.eventCallbacks.error=t}onPing(t){if("function"!=typeof t)throw new n(e.PING);this.eventCallbacks.ping=t}onDeclined(t){if("function"!=typeof t)throw new n(e.DECLINED);this.eventCallbacks.declined=t}onSignatureDone(t){if("function"!=typeof t)throw new n(e.SIGNATURE_DONE);this.eventCallbacks["signature.done"]=t}removeMessageListener(){window.removeEventListener("message",this.messageHandler)}}}();
/* harmony default export */ var PublicSignatureView_yousign = (Yousign);

// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/PublicSignatureView/PublicSignatureView.ts?vue&type=script&lang=ts&external





// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore


var fetchLink = function (id, yousignId, hash, isTest) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        return [2 /*return*/, external_vue_default().prototype.$kwInterface.axios.get("/sign/" + id + "/" + yousignId + "/" + hash, {
                headers: {
                    TestMode: isTest
                }
            })
                .then(function (response) {
                return response.data;
            })];
    });
}); };
var PublicSignatureView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PublicSignatureView, _super);
    function PublicSignatureView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.link = null;
        return _this;
    }
    PublicSignatureView.prototype.watchLoading = function () {
        var _this = this;
        if (this.loading) {
            return;
        }
        this.$nextTick(function () {
            var _a, _b, _c;
            var yousign = new PublicSignatureView_yousign({
                signatureLink: (_a = _this.link) === null || _a === void 0 ? void 0 : _a.link,
                iframeContainerId: 'iframe-yousign',
                isSandbox: (_b = _this.$kwSales.yousignSandbox) !== null && _b !== void 0 ? _b : _this.$route.name === 'public-sign-test'
            });
            if ((_c = _this.link) === null || _c === void 0 ? void 0 : _c.is_direct_sign) {
                yousign.onSuccess(function () {
                    var _a;
                    var document = (_a = _this.link) === null || _a === void 0 ? void 0 : _a.documents[0];
                    if (!document) {
                        return;
                    }
                    switch (document.type) {
                        case 'planification':
                            _this.$router.push({
                                name: _this.can('constructionInterface', 1) ? 'my-planification-list' : 'planification-list',
                                query: {
                                    planificationId: String(document.id)
                                }
                            });
                            break;
                        case 'construction':
                            _this.$router.push({
                                name: 'construction-item',
                                params: {
                                    id: String(document.id)
                                }
                            });
                            break;
                    }
                });
            }
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('loading')
    ], PublicSignatureView.prototype, "watchLoading", null);
    PublicSignatureView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BCard: external_bootstrap_vue_.BCard
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])),
            // eslint-disable-next-line no-undef
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var link;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, fetchLink(to.params.id, to.params.yousignId, to.params.hash, to.name === 'public-sign-test')
                                    .catch(function () {
                                    next({ name: 'error-404' });
                                    return;
                                })];
                            case 1:
                                link = _a.sent();
                                next(function (vm) {
                                    vm.link = link;
                                    vm.loading = false;
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var link;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.loading = true;
                                return [4 /*yield*/, fetchLink(to.params.id, to.params.yousignId, to.params.hash, to.name === 'public-sign-test')
                                        .catch(function () {
                                        next({ name: 'error-404' });
                                        return;
                                    })];
                            case 1:
                                link = _a.sent();
                                this.link = link;
                                this.loading = false;
                                next();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], PublicSignatureView);
    return PublicSignatureView;
}((external_vue_default())));
/* harmony default export */ var PublicSignatureViewvue_type_script_lang_ts_external = (PublicSignatureView);

;// ./src/views/PublicSignatureView/PublicSignatureView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PublicSignatureView_PublicSignatureViewvue_type_script_lang_ts_external = (PublicSignatureViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/PublicSignatureView/PublicSignatureView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PublicSignatureView_PublicSignatureViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PublicSignatureView_PublicSignatureView = (component.exports);

/***/ }),

/***/ 18754:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'calculator';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f1ec';
var svgPathData = 'M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.yq = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 18964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fetchDatas_checkDeposit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86192);




var CheckDepositMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__extends */ .C6)(CheckDepositMixin, _super);
    function CheckDepositMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.deposit = null;
        return _this;
    }
    CheckDepositMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            components: {
                Spinner: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var id;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = to.params.id;
                                if (!id) {
                                    next(function (vm) { return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(_this, void 0, void 0, function () {
                                        return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                                            vm.deposit = null;
                                            vm.loading = false;
                                            return [2 /*return*/];
                                        });
                                    }); });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,_fetchDatas_checkDeposit__WEBPACK_IMPORTED_MODULE_2__/* .fetchCheckDeposit */ .tc)(id)
                                        .then(function (deposit) {
                                        next(function (vm) {
                                            vm.deposit = deposit;
                                            vm.loading = false;
                                        });
                                    })
                                        .catch(function (error) {
                                        throw new Error(error);
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var id;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = to.params.id;
                                this.loading = true;
                                this.deposit = null;
                                if (!id) {
                                    this.loading = false;
                                    next();
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,_fetchDatas_checkDeposit__WEBPACK_IMPORTED_MODULE_2__/* .fetchCheckDeposit */ .tc)(to.params.id)
                                        .then(function (deposit) {
                                        _this.deposit = deposit;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], CheckDepositMixin);
    return CheckDepositMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (CheckDepositMixin);


/***/ }),

/***/ 19137:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'sync';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f021';
var svgPathData = 'M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.VN = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 19219:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 19356:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ 19422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ InputOptions_InputOptions; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/InputOptions/InputOptions.vue?vue&type=template&id=80c1945a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{attrs:{"type":"hidden","name":"input_options[allow_delivery_address]"},domProps:{"value":_vm.value.input_options.allow_delivery_address}}),_c('input',{attrs:{"type":"hidden","name":"use_global_vatrate"},domProps:{"value":_vm.value.use_global_vatrate}}),_c('input',{attrs:{"type":"hidden","name":"input_mode"},domProps:{"value":_vm.value.input_mode}}),_c('input',{attrs:{"type":"hidden","name":"input_options[allow_options]"},domProps:{"value":_vm.value.input_options.allow_options}}),_c('input',{attrs:{"type":"hidden","name":"input_options[ean]"},domProps:{"value":_vm.value.input_options.ean}}),_c('input',{attrs:{"type":"hidden","name":"input_options[weight]"},domProps:{"value":_vm.value.input_options.weight}}),_c('input',{attrs:{"type":"hidden","name":"input_options[eco_participation]"},domProps:{"value":_vm.value.input_options.eco_participation}}),_c('input',{attrs:{"type":"hidden","name":"input_options[col_number]"},domProps:{"value":_vm.value.input_options.col_number}}),_c('input',{attrs:{"type":"hidden","name":"input_options[col_reference]"},domProps:{"value":_vm.value.input_options.col_reference}}),_c('input',{attrs:{"type":"hidden","name":"input_options[col_picture]"},domProps:{"value":_vm.value.input_options.col_picture}}),_c('input',{attrs:{"type":"hidden","name":"input_options[col_unit]"},domProps:{"value":_vm.value.input_options.col_unit}}),_c('input',{attrs:{"type":"hidden","name":"input_options[stock_display]"},domProps:{"value":_vm.value.input_options.stock_display}}),_c('input',{attrs:{"type":"hidden","name":"input_options[stock_tracabilities]"},domProps:{"value":_vm.value.input_options.stock_tracabilities}}),_c('input',{attrs:{"type":"hidden","name":"input_options[costs_entries]"},domProps:{"value":_vm.value.input_options.costs_entries}}),_c('input',{attrs:{"type":"hidden","name":"input_options[various_costs]"},domProps:{"value":_vm.value.input_options.various_costs}}),_c('input',{attrs:{"type":"hidden","name":"input_options[workforce_entries]"},domProps:{"value":_vm.value.input_options.workforce_entries}}),_c('input',{attrs:{"type":"hidden","name":"input_options[gross_margin_amount]"},domProps:{"value":_vm.value.input_options.gross_margin_amount}}),_c('input',{attrs:{"type":"hidden","name":"input_options[gross_margin_rate]"},domProps:{"value":_vm.value.input_options.gross_margin_rate}}),_c('input',{attrs:{"type":"hidden","name":"input_options[markup_rate]"},domProps:{"value":_vm.value.input_options.markup_rate}}),_c('input',{attrs:{"type":"hidden","name":"secondary_quantity_mode"},domProps:{"value":_vm.value.secondary_quantity_mode}}),_c('input',{attrs:{"type":"hidden","name":"input_options[secondary_quantity_unit]"},domProps:{"value":_vm.value.input_options.secondary_quantity_unit}}),_c('b-modal',{attrs:{"title":_vm.$t('sales.form.sidebar.inputOptions'),"size":"lg","ok-title":_vm.$t('interface.save'),"cancel-title":_vm.$t('sales.form.saveDefaultBtn'),"scrollable":"","body-class":"p-3"},on:{"cancel":_vm.askSaveDefault},model:{value:(_vm.localModal),callback:function ($$v) {_vm.localModal=$$v},expression:"localModal"}},[(_vm.saveDefaultState)?_c('ConfirmModal',{attrs:{"message":_vm.$t('sales.form.saveDefaultConfirmation')},on:{"confirmed":_vm.saveDefault,"canceled":function($event){_vm.saveDefaultState = false}}}):_vm._e(),(_vm.loading)?_c('Spinner'):[_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.explain'))+" ")]),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-1",modifiers:{"sales-input-options-1":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'cogs']}}),_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.inputOptions'))+" ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-1","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[(_vm.hasModule('sales-deliveries'))?_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.deliveryAddress')}},[_c('k-form-checkbox',{model:{value:(_vm.value.input_options.allow_delivery_address),callback:function ($$v) {_vm.$set(_vm.value.input_options, "allow_delivery_address", $$v)},expression:"value.input_options.allow_delivery_address"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.activeDeliveryAddress'))+" ")])],1):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.vatrateSelection')}},[_c('k-form-select',{attrs:{"options":_vm.selectVatRates,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.use_global_vatrate),callback:function ($$v) {_vm.$set(_vm.value, "use_global_vatrate", $$v)},expression:"value.use_global_vatrate"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.amountTypes')}},[_c('k-form-select',{attrs:{"options":_vm.amountsType,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_mode),callback:function ($$v) {_vm.$set(_vm.value, "input_mode", $$v)},expression:"value.input_mode"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.allowOptions'),"description":_vm.$t('sales.form.inputOptions.allowOptionsExplain')}},[_c('k-form-select',{attrs:{"options":_vm.allowOptions,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.allow_options),callback:function ($$v) {_vm.$set(_vm.value.input_options, "allow_options", $$v)},expression:"value.input_options.allow_options"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.ean')}},[_c('k-form-select',{attrs:{"options":_vm.eanOptions,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.ean),callback:function ($$v) {_vm.$set(_vm.value.input_options, "ean", $$v)},expression:"value.input_options.ean"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.weight')}},[_c('k-form-select',{attrs:{"options":_vm.weightOptions,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.weight),callback:function ($$v) {_vm.$set(_vm.value.input_options, "weight", $$v)},expression:"value.input_options.weight"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.ecoParticipation')}},[_c('k-form-select',{attrs:{"options":_vm.ecoParticipation,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.eco_participation),callback:function ($$v) {_vm.$set(_vm.value.input_options, "eco_participation", $$v)},expression:"value.input_options.eco_participation"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.columnTitle'),"label-class":"mb-2"}},[_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.value.input_options.col_number),callback:function ($$v) {_vm.$set(_vm.value.input_options, "col_number", $$v)},expression:"value.input_options.col_number"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.columnNumber'))+" ")]),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.value.input_options.col_reference),callback:function ($$v) {_vm.$set(_vm.value.input_options, "col_reference", $$v)},expression:"value.input_options.col_reference"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.columnReference'))+" ")]),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.value.input_options.col_picture),callback:function ($$v) {_vm.$set(_vm.value.input_options, "col_picture", $$v)},expression:"value.input_options.col_picture"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.columnPicture'))+" ")]),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.value.input_options.col_unit),callback:function ($$v) {_vm.$set(_vm.value.input_options, "col_unit", $$v)},expression:"value.input_options.col_unit"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.columnUnit'))+" ")])],1)],1)],1)],1),(_vm.hasModule('stock'))?_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-2",modifiers:{"sales-input-options-2":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'box-open']}}),_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.stockTitle'))+" ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-2","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.stockQuantity')}},[_c('k-form-select',{attrs:{"options":_vm.stockDisplay,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.stock_display),callback:function ($$v) {_vm.$set(_vm.value.input_options, "stock_display", $$v)},expression:"value.input_options.stock_display"}})],1),(_vm.hasModule('stock-tracabilities'))?_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.stockTracabilities')}},[_c('k-form-select',{attrs:{"options":_vm.activeStockTracabilities,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.stock_tracabilities),callback:function ($$v) {_vm.$set(_vm.value.input_options, "stock_tracabilities", $$v)},expression:"value.input_options.stock_tracabilities"}}),_c('small',[_c('span',{staticClass:"font-weight-bold pt-2"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.stockTracabilitiesExplain1'))+" ")]),_c('br'),_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.stockTracabilitiesExplain2'))+" ")])],1):_vm._e()],1)],1)],1):_vm._e(),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-3",modifiers:{"sales-input-options-3":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'calculator']}}),_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.costsTitle'))+" ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-3","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.costs')}},[_c('k-form-select',{attrs:{"options":_vm.costsEntries,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.costs_entries),callback:function ($$v) {_vm.$set(_vm.value.input_options, "costs_entries", $$v)},expression:"value.input_options.costs_entries"}})],1),(_vm.value.input_options.costs_entries !== 0)?_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.value.input_options.various_costs),callback:function ($$v) {_vm.$set(_vm.value.input_options, "various_costs", $$v)},expression:"value.input_options.various_costs"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.variousCosts'))+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.workforce')}},[_c('k-form-select',{attrs:{"options":_vm.workforceEntries,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.workforce_entries),callback:function ($$v) {_vm.$set(_vm.value.input_options, "workforce_entries", $$v)},expression:"value.input_options.workforce_entries"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.marginCalculation'),"label-class":"mb-2"}},[_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.value.input_options.gross_margin_amount),callback:function ($$v) {_vm.$set(_vm.value.input_options, "gross_margin_amount", $$v)},expression:"value.input_options.gross_margin_amount"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.showMarginAmount'))+" ")]),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.value.input_options.gross_margin_rate),callback:function ($$v) {_vm.$set(_vm.value.input_options, "gross_margin_rate", $$v)},expression:"value.input_options.gross_margin_rate"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.showMarginRate'))+" ")]),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.value.input_options.markup_rate),callback:function ($$v) {_vm.$set(_vm.value.input_options, "markup_rate", $$v)},expression:"value.input_options.markup_rate"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.showMarkupRate'))+" ")])],1)],1)],1)],1),(_vm.hasModule('sales-durations'))?_c('b-card',{staticClass:"mb-0",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-4",modifiers:{"sales-input-options-4":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'calculator-alt']}}),_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.secondaryQuantityTitle'))+" ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-4","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('sales.form.inputOptions.secondaryQuantityExplain'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.secondaryQuantity')}},[_c('k-form-select',{attrs:{"options":_vm.secondaryQuantity,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.secondary_quantity_mode),callback:function ($$v) {_vm.$set(_vm.value, "secondary_quantity_mode", $$v)},expression:"value.secondary_quantity_mode"}})],1),(_vm.value.secondary_quantity_mode !== 'disable')?_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.inputOptions.secondaryQuantityUnit')}},[_c('k-form-select',{attrs:{"options":_vm.secondaryQuantityUnit,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.input_options.secondary_quantity_unit),callback:function ($$v) {_vm.$set(_vm.value.input_options, "secondary_quantity_unit", $$v)},expression:"value.input_options.secondary_quantity_unit"}})],1):_vm._e()],1)],1)],1):_vm._e()]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/mixins/SalesInputOptionsMixin.ts
var SalesInputOptionsMixin = __webpack_require__(80924);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/InputOptions/InputOptions.ts?vue&type=script&lang=ts&external









var InputOptions = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(InputOptions, _super);
    function InputOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localModal = false;
        _this.saveDefaultState = false;
        _this.loading = false;
        return _this;
    }
    InputOptions.prototype.watchModal = function (state) {
        this.localModal = state;
    };
    InputOptions.prototype.watchlocalModal = function (state) {
        this.$emit('modalState', state);
    };
    InputOptions.prototype.askSaveDefault = function (bvModalEvent) {
        bvModalEvent.preventDefault();
        this.saveDefaultState = true;
    };
    InputOptions.prototype.saveDefault = function () {
        var _this = this;
        this.loading = true;
        this.saveDefaultState = false;
        var datas = new FormData();
        datas.set('_method', 'put');
        forEach_default()(this.value.input_options, function (value, key) {
            if (value !== undefined) {
                if (value === false)
                    value = 0;
                else if (value === true)
                    value = 1;
                datas.set('configs[sales_' + key + ']', String(value));
            }
        });
        datas.set('configs[sales_use_global_vatrate]', String(this.value.use_global_vatrate ? 1 : 0));
        datas.set('configs[sales_input_mode]', String(this.value.input_mode));
        datas.set('configs[sales_secondary_quantity]', String(this.value.secondary_quantity_mode));
        this.$kwSales.axios.post('/team', datas)
            .then(function (response) {
            _this.setTeam(response.data);
        })
            .catch(function (error) {
            throw new Error(error);
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], InputOptions.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], InputOptions.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], InputOptions.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localModal')
    ], InputOptions.prototype, "watchlocalModal", null);
    InputOptions = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('user', ['setTeam'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                Spinner: interface_vue_.Spinner,
                ConfirmModal: interface_vue_.ConfirmModal,
                BModal: external_bootstrap_vue_.BModal, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BButton: external_bootstrap_vue_.BButton, BCollapse: external_bootstrap_vue_.BCollapse, BCardBody: external_bootstrap_vue_.BCardBody, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle
            }
        })
    ], InputOptions);
    return InputOptions;
}((0,lib/* Mixins */.Xe)(SalesInputOptionsMixin/* default */.A)));
/* harmony default export */ var InputOptionsvue_type_script_lang_ts_external = (InputOptions);

;// ./src/components/Form/InputOptions/InputOptions.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var InputOptions_InputOptionsvue_type_script_lang_ts_external = (InputOptionsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/InputOptions/InputOptions.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  InputOptions_InputOptionsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InputOptions_InputOptions = (component.exports);

/***/ }),

/***/ 19467:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// external "@fortawesome/fontawesome-svg-core"
var fontawesome_svg_core_namespaceObject = require("@fortawesome/fontawesome-svg-core");
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faDownload.js
var faDownload = __webpack_require__(86614);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faFilePdf.js
var faFilePdf = __webpack_require__(5644);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCalculator.js
var faCalculator = __webpack_require__(18754);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faChevronCircleLeft.js
var faChevronCircleLeft = __webpack_require__(48698);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faChevronCircleRight.js
var faChevronCircleRight = __webpack_require__(93);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPalette.js
var faPalette = __webpack_require__(77619);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTruck.js
var faTruck = __webpack_require__(37915);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPlus.js
var faPlus = __webpack_require__(60906);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPencil.js
var faPencil = __webpack_require__(64831);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faTimes.js
var faTimes = __webpack_require__(32349);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faImage.js
var faImage = __webpack_require__(53426);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faShoppingCart.js
var faShoppingCart = __webpack_require__(81256);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faFileAlt.js
var faFileAlt = __webpack_require__(22573);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faFileInvoice.js
var faFileInvoice = __webpack_require__(30817);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCalendarAlt.js
var faCalendarAlt = __webpack_require__(16041);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faEnvelope.js
var faEnvelope = __webpack_require__(17258);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faFileContract.js
var faFileContract = __webpack_require__(77234);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCheck.js
var faCheck = __webpack_require__(7352);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSearch.js
var faSearch = __webpack_require__(60726);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCreditCard.js
var faCreditCard = __webpack_require__(62673);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCopy.js
var faCopy = __webpack_require__(21263);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSignature.js
var faSignature = __webpack_require__(76002);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faArrowRight.js
var faArrowRight = __webpack_require__(69831);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faDoNotEnter.js
var faDoNotEnter = __webpack_require__(79506);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBadgePercent.js
var faBadgePercent = __webpack_require__(3894);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBoxFull.js
var faBoxFull = __webpack_require__(96724);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUser.js
var faUser = __webpack_require__(12249);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSitemap.js
var faSitemap = __webpack_require__(70027);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faEmptySet.js
var faEmptySet = __webpack_require__(3653);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCars.js
var faCars = __webpack_require__(73285);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPaperPlane.js
var faPaperPlane = __webpack_require__(68694);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCircle.js
var faCircle = __webpack_require__(55974);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCheckCircle.js
var faCheckCircle = __webpack_require__(37856);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSync.js
var faSync = __webpack_require__(19137);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUniversity.js
var faUniversity = __webpack_require__(12742);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faBorderAll.js
var faBorderAll = __webpack_require__(31114);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faExpandArrowsAlt.js
var faExpandArrowsAlt = __webpack_require__(96130);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCircle.js
var pro_regular_svg_icons_faCircle = __webpack_require__(17583);
;// ./src/fontawesome.ts







































fontawesome_svg_core_namespaceObject.library.add(faDownload/* faDownload */.cb, faFilePdf/* faFilePdf */.O_, faCalculator/* faCalculator */.yq, faChevronCircleLeft/* faChevronCircleLeft */.QE, faChevronCircleRight/* faChevronCircleRight */.xn, faPalette/* faPalette */.fy, faTruck/* faTruck */.r, faBorderAll/* faBorderAll */.fx, faExpandArrowsAlt/* faExpandArrowsAlt */.pG, faPlus/* faPlus */.QL, faPencil/* faPencil */.zL, faTimes/* faTimes */.GR, faImage/* faImage */.jb, faShoppingCart/* faShoppingCart */._R, faFileAlt/* faFileAlt */.h8, faFileInvoice/* faFileInvoice */.p4, faCalendarAlt/* faCalendarAlt */.BE, faEnvelope/* faEnvelope */.y_, faFileContract/* faFileContract */.IJ, faCheck/* faCheck */.e6, faSearch/* faSearch */.Mj, faCreditCard/* faCreditCard */.$O, faCopy/* faCopy */.jP, faSignature/* faSignature */.uZ, faArrowRight/* faArrowRight */.dm, faBadgePercent/* faBadgePercent */.gV, faBoxFull/* faBoxFull */.KM, faUser/* faUser */.X4, faSitemap/* faSitemap */.FF, faEmptySet/* faEmptySet */.Vf, faCars/* faCars */.TG, faPaperPlane/* faPaperPlane */.is, faDoNotEnter/* faDoNotEnter */.WW, faCircle/* faCircle */.GE, pro_regular_svg_icons_faCircle/* faCircle */.GE, faCheckCircle/* faCheckCircle */.SG, faSync/* faSync */.VN, faUniversity/* faUniversity */.Qn);


/***/ }),

/***/ 19529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 19570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(37334),
    defineProperty = __webpack_require__(93243),
    identity = __webpack_require__(83488);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 19821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SalePdfOptions_SalePdfOptions; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SalePdfOptions/SalePdfOptions.vue?vue&type=template&id=09b9cb06
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('p',{staticClass:"text-center"},[_vm._v(" Personnalisez ici, l'affichage des différentes informations qui apparaîtront sur vos documents PDF."),_c('br'),_vm._v(" Il est possible de personnaliser ces options pour un document en particulier directement lors de la création / modification du document. ")]),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-pdf-options-1",modifiers:{"sales-pdf-options-1":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'cogs']}}),_vm._v(" Contenu du document ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-pdf-options-1","accordion":"sales-pdf-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":"Affichage des montants dans le contenu du document"}},[_c('k-form-select',{attrs:{"options":_vm.amounts,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_amounts]"},model:{value:(_vm.localConfig.sales_pdf_amounts),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_amounts", $$v)},expression:"localConfig.sales_pdf_amounts"}})],1),_c('b-form-group',{attrs:{"label":"Affichage des remises"}},[_c('k-form-select',{attrs:{"options":_vm.discounts,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_discounts]"},model:{value:(_vm.localConfig.sales_pdf_discounts),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_discounts", $$v)},expression:"localConfig.sales_pdf_discounts"}})],1),_c('b-form-group',{attrs:{"label":"Affichage des lignes de commentaires"}},[_c('k-form-select',{attrs:{"options":_vm.comments,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_comments]"},model:{value:(_vm.localConfig.sales_pdf_comments),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_comments", $$v)},expression:"localConfig.sales_pdf_comments"}})],1),_c('b-form-group',{attrs:{"label":"Affichage des unités","description":"Les unités ne seront affichées que si celle-ci sont activées lors de la saisie du document"}},[_c('k-form-select',{attrs:{"options":_vm.units,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_units]"},model:{value:(_vm.localConfig.sales_pdf_units),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_units", $$v)},expression:"localConfig.sales_pdf_units"}})],1),_c('b-form-group',{attrs:{"label":"Affichage de la colonne numéro de ligne"}},[_c('k-form-select',{attrs:{"options":_vm.basicDisplay,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_number_column]"},model:{value:(_vm.localConfig.sales_pdf_number_column),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_number_column", $$v)},expression:"localConfig.sales_pdf_number_column"}})],1),_c('b-form-group',{attrs:{"label":"Affichage de la colonne référence"}},[_c('k-form-select',{attrs:{"options":_vm.basicDisplay,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_reference_column]"},model:{value:(_vm.localConfig.sales_pdf_reference_column),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_reference_column", $$v)},expression:"localConfig.sales_pdf_reference_column"}})],1),_c('b-form-group',{attrs:{"label":"Affichage du code EAN"}},[_c('k-form-select',{attrs:{"options":_vm.basicDisplay,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_ean_column]"},model:{value:(_vm.localConfig.sales_pdf_ean_column),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_ean_column", $$v)},expression:"localConfig.sales_pdf_ean_column"}})],1),_c('b-form-group',{attrs:{"label":"Affichage du poids unitaire"}},[_c('k-form-select',{attrs:{"options":_vm.basicDisplay,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_weight_column]"},model:{value:(_vm.localConfig.sales_pdf_weight_column),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_weight_column", $$v)},expression:"localConfig.sales_pdf_weight_column"}})],1),_c('b-form-group',{attrs:{"label":"Forcer l'affichage de la colonne TVA","description":"La colonne TVA s'affichera automatiquement si plusieurs taux de TVA sont présents."}},[_c('k-form-select',{attrs:{"options":_vm.vatRateCol,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_vatrate_column]"},model:{value:(_vm.localConfig.sales_pdf_vatrate_column),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_vatrate_column", $$v)},expression:"localConfig.sales_pdf_vatrate_column"}})],1),_c('b-form-group',{attrs:{"label":"Afficher la colonne quantité totale","description":"Cette colonne ne peut être affichée que si la quantité secondaire est activée."}},[_c('k-form-select',{attrs:{"options":_vm.totalQuantityCol,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_total_quantity]"},model:{value:(_vm.localConfig.sales_pdf_total_quantity),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_total_quantity", $$v)},expression:"localConfig.sales_pdf_total_quantity"}})],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-pdf-options-2",modifiers:{"sales-pdf-options-2":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'map-signs']}}),_vm._v(" Adresses de livraison et de facturation ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-pdf-options-2","accordion":"sales-pdf-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":"Affichage du contact"}},[_c('k-form-select',{attrs:{"options":_vm.displayAddress,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_contact]"},model:{value:(_vm.localConfig.sales_pdf_contact),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_contact", $$v)},expression:"localConfig.sales_pdf_contact"}})],1),_c('b-form-group',{attrs:{"label":"Affichage du pays"}},[_c('k-form-select',{attrs:{"options":_vm.displayAddress,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_country]"},model:{value:(_vm.localConfig.sales_pdf_country),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_country", $$v)},expression:"localConfig.sales_pdf_country"}})],1),_c('b-form-group',{attrs:{"label":"Affichage du numéro de TVA intracommunautaire du client"}},[_c('k-form-select',{attrs:{"options":_vm.vatRateNumber,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_vatrate_number]"},model:{value:(_vm.localConfig.sales_pdf_vatrate_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_vatrate_number", $$v)},expression:"localConfig.sales_pdf_vatrate_number"}})],1)],1)],1)],1),(_vm.hasModule('sales-situation-billing'))?_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-pdf-options-4",modifiers:{"sales-pdf-options-4":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'badge-percent']}}),_vm._v(" Factures de situation détaillées ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-pdf-options-4","accordion":"sales-pdf-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":"Afficher le montant total commandé"}},[_c('k-form-select',{attrs:{"options":_vm.showOnOff,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_situation_show_base_amount]"},model:{value:(_vm.localConfig.sales_situation_show_base_amount),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_situation_show_base_amount", $$v)},expression:"localConfig.sales_situation_show_base_amount"}})],1),_c('b-form-group',{attrs:{"label":"Afficher le pourcentage de la situation"}},[_c('k-form-select',{attrs:{"options":_vm.showOnOff,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_situation_show_pourcentage]"},model:{value:(_vm.localConfig.sales_situation_show_pourcentage),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_situation_show_pourcentage", $$v)},expression:"localConfig.sales_situation_show_pourcentage"}})],1),_c('b-form-group',{attrs:{"label":"Affichage du poucentage et du montant des situations précédentes"}},[_c('k-form-select',{attrs:{"options":_vm.showSituationColumns,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_situation_show_previous]"},model:{value:(_vm.localConfig.sales_situation_show_previous),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_situation_show_previous", $$v)},expression:"localConfig.sales_situation_show_previous"}})],1),_c('b-form-group',{attrs:{"label":"Affichage du poucentage et du montant total des situations"}},[_c('k-form-select',{attrs:{"options":_vm.showSituationColumns,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_situation_show_totals]"},model:{value:(_vm.localConfig.sales_situation_show_totals),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_situation_show_totals", $$v)},expression:"localConfig.sales_situation_show_totals"}})],1)],1)],1)],1):_vm._e(),_c('p',{staticClass:"mt-3 mb-2 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesPdfOptionsMixin.ts
var SalesPdfOptionsMixin = __webpack_require__(922);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SalePdfOptions/SalePdfOptions.ts?vue&type=script&lang=ts&external








var SalePdfOptions = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SalePdfOptions, _super);
    function SalePdfOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalePdfOptions = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect,
                BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BButton: external_bootstrap_vue_.BButton, BCollapse: external_bootstrap_vue_.BCollapse, BCardBody: external_bootstrap_vue_.BCardBody, BFormGroup: external_bootstrap_vue_.BFormGroup,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], SalePdfOptions);
    return SalePdfOptions;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin, SalesPdfOptionsMixin/* default */.A)));
/* harmony default export */ var SalePdfOptionsvue_type_script_lang_ts_external = (SalePdfOptions);

;// ./src/components/SalePdfOptions/SalePdfOptions.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SalePdfOptions_SalePdfOptionsvue_type_script_lang_ts_external = (SalePdfOptionsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SalePdfOptions/SalePdfOptions.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SalePdfOptions_SalePdfOptionsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SalePdfOptions_SalePdfOptions = (component.exports);

/***/ }),

/***/ 19966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SignItem_SignItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SignItem/SignItem.vue?vue&type=template&id=4636122e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"visible":"","title":"Demande de signature","ok-title":_vm.$t('interface.close'),"ok-only":"","size":"lg"},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[(_vm.loading)?_c('Spinner'):[(_vm.signature?.status === 3)?_c('SignCancel',{staticClass:"mb-3",attrs:{"size":"sm","variant":"primary"},on:{"input":_vm.canceled},model:{value:(_vm.signature),callback:function ($$v) {_vm.signature=$$v},expression:"signature"}}):_vm._e(),(_vm.signature?.status >= 3)?_c('div',{staticClass:"font-weight-bold mb-4 text-danger"},[(_vm.signature?.status === 6)?_c('div',[_vm._v(" La signature a été annulée "),_c('span',{staticClass:"text-lowercase"},[_vm._v(_vm._s(_vm.datetime(_vm.signature.canceled_at)))])]):(!_vm.signature?.is_direct_sign)?_c('div',[_vm._v(" Envoyée "),_c('span',{staticClass:"text-lowercase"},[_vm._v(_vm._s(_vm.datetime(_vm.signature?.send_at)))]),_vm._v(" "),(_vm.signature?.team_user)?_c('span',[_vm._v("par "+_vm._s(_vm.signature?.team_user.fullname))]):_vm._e()]):_vm._e(),(_vm.signature?.status === 5)?_c('div',[_c('p',[_vm._v(" Signée "),(_vm.signature?.is_direct_sign)?[_vm._v(" en personne ")]:_vm._e(),_c('span',{staticClass:"text-lowercase"},[_vm._v(" "+_vm._s(_vm.datetime(_vm.signature?.signed_at))+" ")])],2),_c('b-overlay',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadSigned.apply(null, arguments)}}},[_vm._v(" Télécharger les documents signés ")])],1)],1):_vm._e()]):_vm._e(),_c('h3',{staticClass:"form-title-alt mt-0 mb-1"},[_vm._v(" Signataire ")]),_c('table',{staticClass:"table table-sm mt-3 align-middle"},[_c('thead',{staticClass:"small"},[_c('tr',[_c('th',{staticClass:"py-0"},[_vm._v("Prénom")]),_c('th',{staticClass:"py-0"},[_vm._v("Nom")]),_c('th',{staticClass:"py-0"},[_vm._v("Email")]),_c('th',{staticClass:"py-0"},[_vm._v("Portable")])])]),_c('tbody',_vm._l((_vm.signature?.signatories),function(signatory,i){return _c('tr',{key:i,class:{ 'border-bottom': i === (_vm.signature?.signatories.length - 1) }},[_c('td',[_vm._v(_vm._s(signatory.firstname))]),_c('td',[_vm._v(_vm._s(signatory.lastname))]),_c('td',[_vm._v(_vm._s(signatory.email))]),_c('td',[_vm._v(_vm._s(_vm.showPhone(signatory.mobile)))])])}),0)]),(!_vm.signature?.is_direct_sign)?[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Message ")]),_c('b-form-group',{attrs:{"label":"Sujet"}},[_vm._v(" "+_vm._s(_vm.signature?.subject)+" ")]),_c('b-form-group',{attrs:{"label":"Message"}},[_c('FroalaView',{staticClass:"border p-2 fr-wrapper",attrs:{"value":_vm.signature?.message}})],1)]:_vm._e(),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Documents ")]),_c('table',{staticClass:"table table-sm align-middle sales-sign-documents mt-1 table-bordered"},[_c('tbody',_vm._l((_vm.signature?.documents),function(doc,i){return _c('tr',{key:i},[_c('td',{staticClass:"icon border-right-0",style:({ color: _vm.fileIconColor(doc.file.extension) })},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.fileIcon(doc.file.extension)]}})],1),_c('td',{staticClass:"border-left-0 border-right-0"},[_vm._v(" "+_vm._s(doc.file.filename)+" ")]),_c('td',[_c('k-form-checkbox',{attrs:{"disabled":""},model:{value:(doc.signable_document),callback:function ($$v) {_vm.$set(doc, "signable_document", $$v)},expression:"doc.signable_document"}},[_vm._v(" À signer ")])],1),_c('td',{staticStyle:{"width":"155px"}},[(doc.document_type && doc.document_id)?_c('b-button',{staticClass:"py-0 mr-2",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.goToDocument(doc)}}},[_vm._v(" Voir ")]):_vm._e(),_c('b-button',{staticClass:"py-0",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.downloadDocument(doc.file.id)}}},[_vm._v(" Télécharger ")])],1)])}),0)])]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/fetchDatas/signature.ts
var signature = __webpack_require__(9738);
// EXTERNAL MODULE: ./src/components/SignCancel/SignCancel.vue + 3 modules
var SignCancel = __webpack_require__(82973);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SignItem/SignItem.ts?vue&type=script&lang=ts&external








var SignItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignItem, _super);
    function SignItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.signature = null;
        return _this;
    }
    SignItem.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.value) {
                            this.signature = null;
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, (0,signature/* fetchSignature */.FH)(this.value.id)];
                    case 1:
                        _a.signature = _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SignItem.prototype.canceled = function (signature) {
        this.signature = signature;
        this.$emit('input', signature);
    };
    SignItem.prototype.downloadSigned = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/signature/' + ((_a = this.signature) === null || _a === void 0 ? void 0 : _a.id) + '/download')
                                .then(function (response) {
                                var file = response.data;
                                _this.downloadFile(file.file, file.filename + '.' + file.extension);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SignItem.prototype.downloadDocument = function (id) {
        if (id === void 0) { id = null; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/file/' + id + '?with_file=1')
                                .then(function (response) {
                                var file = response.data;
                                _this.downloadFile(file.file, file.filename);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SignItem.prototype.goToDocument = function (document) {
        var route;
        switch (document.document_type) {
            case 'customerSepa':
                route = { name: 'sepa-list', query: { sepa: String(document.document_id) } };
                break;
            default:
                route = { name: document.document_type + '-item', params: { id: String(document.document_id) } };
        }
        if (this.$router.resolve(route).href === this.$route.path) {
            this.$emit('hidden');
        }
        else {
            this.$router.push(route);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SignItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], SignItem.prototype, "watchValue", null);
    SignItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormCheckbox: form_vue_.KFormCheckbox,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup, BOverlay: external_bootstrap_vue_.BOverlay,
                FroalaView: form_vue_.FroalaView,
                Spinner: interface_vue_.Spinner,
                SignCancel: SignCancel/* default */.A
            }
        })
    ], SignItem);
    return SignItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.PhoneMixin, interface_vue_.FileMixin, interface_vue_.DateMixin)));
/* harmony default export */ var SignItemvue_type_script_lang_ts_external = (SignItem);

;// ./src/components/SignItem/SignItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SignItem_SignItemvue_type_script_lang_ts_external = (SignItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SignItem/SignItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SignItem_SignItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignItem_SignItem = (component.exports);

/***/ }),

/***/ 20206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ RecoveryInvoiceStepForm_RecoveryInvoiceStepForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RecoveryInvoiceStepForm/RecoveryInvoiceStepForm.vue?vue&type=template&id=6a76647f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":response => _vm.$emit('submitComplete', response)}},[_c('b-form-group',{attrs:{"label":"Nom de l'étape :"}},[_c('k-form-input',{attrs:{"name":"name","required":""},model:{value:(_vm.step.name),callback:function ($$v) {_vm.$set(_vm.step, "name", $$v)},expression:"step.name"}})],1),_c('b-form-group',{attrs:{"label":"Nombre de jours par rapport à la date limite de paiement :","description":"Cette valeur peut être négative afin de créer une étape préventive."}},[_c('k-form-spinner',{attrs:{"name":"delay","required":""},model:{value:(_vm.step.delay),callback:function ($$v) {_vm.$set(_vm.step, "delay", $$v)},expression:"step.delay"}})],1),_c('b-form-group',{attrs:{"label":"Type de relance :"}},[_c('k-form-select',{attrs:{"name":"type","options":_vm.types,"reduce":opt => opt.value,"required":"","clearable":false},model:{value:(_vm.step.type),callback:function ($$v) {_vm.$set(_vm.step, "type", $$v)},expression:"step.type"}})],1),(_vm.step.type === 'mail' || _vm.step.type === 'letter')?[(_vm.step.type === 'mail')?_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"auto_send"},domProps:{"value":_vm.step.auto_send ? 1 : 0}}),_c('k-form-checkbox',{staticClass:"mb-4 d-inline-block mr-1",model:{value:(_vm.step.auto_send),callback:function ($$v) {_vm.$set(_vm.step, "auto_send", $$v)},expression:"step.auto_send"}},[_vm._v(" Envoyer automatiquement à ")]),_c('k-form-select',{staticClass:"d-inline-block",attrs:{"name":"auto_send_hour","options":_vm.hours,"required":"","size":"sm","clearable":false,"reduce":opt => opt.value},model:{value:(_vm.step.auto_send_hour),callback:function ($$v) {_vm.$set(_vm.step, "auto_send_hour", $$v)},expression:"step.auto_send_hour"}})],1),_c('b-col')],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Sujet :"}},[_c('k-form-editor',{attrs:{"config":_vm.subjectConfig,"name":"subject","required":_vm.step.type === 'mail' && _vm.step.auto_send,"size":"sm"},model:{value:(_vm.step.subject),callback:function ($$v) {_vm.$set(_vm.step, "subject", $$v)},expression:"step.subject"}})],1),(_vm.step.type === 'letter')?_c('k-form-checkbox',{staticClass:"mb-4",model:{value:(_vm.step.send_ar),callback:function ($$v) {_vm.$set(_vm.step, "send_ar", $$v)},expression:"step.send_ar"}},[_vm._v(" Envoyer en AR ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Message :","description":"La facture sera automatiquement ajoutée en pièce jointe"}},[_c('k-form-editor',{attrs:{"name":"message","size":"sm","config":_vm.editorConfig,"required":_vm.step.type === 'mail' && _vm.step.auto_send},model:{value:(_vm.step.message),callback:function ($$v) {_vm.$set(_vm.step, "message", $$v)},expression:"step.message"}})],1)]:_vm._e()],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "froala-editor"
var external_froala_editor_ = __webpack_require__(30189);
var external_froala_editor_default = /*#__PURE__*/__webpack_require__.n(external_froala_editor_);
;// ./src/components/RecoveryInvoiceStepForm/editorConfig.ts

var config = {
    enter: (external_froala_editor_default()).ENTER_BR,
    fontSizeUnit: 'pt',
    zIndex: 999999,
    heightMin: 100,
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'fontSize',
                '|',
                'textColor',
                'backgroundColor',
                '|',
                'formatUL',
                'formatOL',
                '|',
                'insertImage',
                'insertTable',
                'insertHR',
                '|',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify',
                '|',
                'insertDynamicVariables'
            ],
            buttonsVisible: 16
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedAttrs: [
        'align', 'alt', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'class', 'color',
        'cols', 'colspan', 'content', 'contenteditable', 'data', 'data-.*', 'datetime', 'disabled', 'form', 'height',
        'hidden', 'href', 'id', 'label', 'max', 'min', 'multiple', 'name', 'placeholder', 'radiogroup', 'readonly',
        'rel', 'required', 'rows', 'rowspan', 'selected', 'size', 'sizes', 'span', 'src', 'step', 'style', 'tabindex',
        'target', 'title', 'type', 'value', 'valign', 'width'
    ],
    tableEditButtons: [
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableBorder',
        'tableBackground',
        'tableSpaces',
        '-',
        'tableCells',
        'tableCellBackground',
        'tableCellBorder',
        'tableCellHorizontalAlign',
        'tableCellPadding'
    ],
    imageUpload: false,
    //imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    //imageMaxSize: 5 * 1024 * 1024, // 5MB
    //imageUploadMethod: 'POST',
    //imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageManager'],
    imageDefaultDisplay: 'inline',
    imageEditButtons: ['imageReplace', 'imageRemove', 'imageSize'],
    //imageManagerToggleTags: false,
    requestHeaders: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + ({"NODE_ENV":"production","VUE_APP_ESIGN_FREE":"1","VUE_APP_HERE_API_KEY":"23z1ejZ9DwiGvj9aAxpscJ_yr-et9lqeAeZKxgWynL4","VUE_APP_API_URL":"http://127.0.0.1:8000/api","VUE_APP_PUSHER_APP_KEY":"d683bedd72c05f60b321bbd698222a64","VUE_APP_PUSHER_HOST":"socket.kwixeo.fr","VUE_APP_PUSHER_PORT":"6002","BASE_URL":"/"}).VUE_APP_BEARER_TOKEN
    },
    requestWithCredentials: true,
    requestWithCORS: false,
    imageCORSProxy: false,
    dynamicVariables: {
        company: {
            label: 'Informations de votre entreprise',
            variables: [
                { value: 'COMPANY-NAME', label: 'Nom de l\'entreprise' },
                { value: 'COMPANY-ROAD', label: 'Adresse - rue' },
                { value: 'COMPANY-ROAD2', label: 'Adresse - rue 2' },
                { value: 'COMPANY-ROAD3', label: 'Adresse - rue 3' },
                { value: 'COMPANY-POSTAL', label: 'Code postal' },
                { value: 'COMPANY-TOWN', label: 'Ville' },
                { value: 'COMPANY-COUNTRY', label: 'Pays' },
                { value: 'COMPANY-PHONE', label: 'Téléphone fixe' },
                { value: 'COMPANY-MOBILE', label: 'Téléphone portable' },
                { value: 'COMPANY-FAX', label: 'Fax' },
                { value: 'COMPANY-EMAIL', label: 'Email' },
                { value: 'COMPANY-WEBSITE', label: 'Site internet' },
                { value: 'COMPANY-TYPE', label: 'Type d\'entreprise' },
                { value: 'COMPANY-SIRET', label: 'N° SIRET' },
                { value: 'COMPANY-RCS', label: 'N° RCS' },
                { value: 'COMPANY-TVA', label: 'N° TVA intracommunautaire' },
                { value: 'COMPANY-NAF', label: 'Code NAF' },
                { value: 'COMPANY-CAPITAL', label: 'Capital' }
            ]
        },
        tiers: {
            label: 'Informations sur le client',
            variables: [
                { value: 'TIERS-CODE', label: 'Code client' },
                { value: 'TIERS-NAME', label: 'Nom du client' },
                { value: 'TIERS-PHONE', label: 'Téléphone fixe' },
                { value: 'TIERS-MOBILE', label: 'Téléphone portable' },
                { value: 'TIERS-FAX', label: 'Fax' },
                { value: 'TIERS-EMAIL', label: 'Email' },
                { value: 'TIERS-WEBSITE', label: 'Site internet' },
                { value: 'TIERS-SIRET', label: 'N° SIRET' },
                { value: 'TIERS-TVA', label: 'N° TVA intracommunautaire' },
            ]
        },
        contact: {
            label: 'Informations sur le contact',
            variables: [
                { value: 'CONTACT-FULLNAME', label: 'Nom complet' },
                { value: 'CONTACT-FIRSTNAME', label: 'Prénom' },
                { value: 'CONTACT-LASTNAME', label: 'Nom de famille' },
                { value: 'CONTACT-PHONE', label: 'Téléphone fixe' },
                { value: 'CONTACT-MOBILE', label: 'Téléphone portable' },
                { value: 'CONTACT-FAX', label: 'Fax' },
                { value: 'CONTACT-EMAIL', label: 'Email' },
                { value: 'CONTACT-WEBSITE', label: 'Site internet' }
            ]
        },
        document: {
            label: 'Informations sur le document',
            variables: [
                { value: 'DOC-NUM', label: 'Numéro du document' },
                { value: 'DATE', label: 'Date' },
                { value: 'EXP-DATE', label: 'Date limite de paiement' },
                { value: 'BDC-TIERS', label: 'N° du bon de commande client' },
                { value: 'INVOICE-ADDRESS', label: 'Adresse de facturation' },
                { value: 'TITLE', label: 'Titre' },
                { value: 'PAYMENT-TERM', label: 'Conditions de paiement' },
                { value: 'TOTAL-HT', label: 'Total HT' },
                { value: 'TOTAL-TVA', label: 'Total TVA' },
                { value: 'TOTAL-TTC', label: 'Total TTC' },
                { value: 'TO-PAID', label: 'Montant à payer' },
                { value: 'ALREADY-PAID', label: 'Montant déjà payé' },
                { value: 'STAY-TO-PAID', label: 'Montant restant à payé' }
            ]
        }
    }
};
/* harmony default export */ var editorConfig = (config);

;// ./src/components/RecoveryInvoiceStepForm/subjectConfig.ts
var subjectConfig_config = {
    zIndex: 9999999,
    heightMin: 40,
    multiLine: false,
    toolbarButtons: {
        moreText: {
            buttons: [
                'insertDynamicVariables'
            ],
            buttonsVisible: 2
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedTags: [],
    htmlAllowedAttrs: ['class', 'contenteditable', 'data-.*', 'data'],
    tableEditButtons: [],
    dynamicVariables: {
        company: {
            label: 'Informations de votre entreprise',
            variables: [
                { value: 'COMPANY-NAME', label: 'Nom de l\'entreprise' },
                { value: 'COMPANY-ROAD', label: 'Adresse - rue' },
                { value: 'COMPANY-ROAD2', label: 'Adresse - rue 2' },
                { value: 'COMPANY-ROAD3', label: 'Adresse - rue 3' },
                { value: 'COMPANY-POSTAL', label: 'Code postal' },
                { value: 'COMPANY-TOWN', label: 'Ville' },
                { value: 'COMPANY-COUNTRY', label: 'Pays' },
                { value: 'COMPANY-PHONE', label: 'Téléphone fixe' },
                { value: 'COMPANY-MOBILE', label: 'Téléphone portable' },
                { value: 'COMPANY-FAX', label: 'Fax' },
                { value: 'COMPANY-EMAIL', label: 'Email' },
                { value: 'COMPANY-WEBSITE', label: 'Site internet' },
                { value: 'COMPANY-TYPE', label: 'Type d\'entreprise' },
                { value: 'COMPANY-SIRET', label: 'N° SIRET' },
                { value: 'COMPANY-RCS', label: 'N° RCS' },
                { value: 'COMPANY-TVA', label: 'N° TVA intracommunautaire' },
                { value: 'COMPANY-NAF', label: 'Code NAF' },
                { value: 'COMPANY-CAPITAL', label: 'Capital' }
            ]
        },
        tiers: {
            label: 'Informations sur le client',
            variables: [
                { value: 'TIERS-CODE', label: 'Code client' },
                { value: 'TIERS-NAME', label: 'Nom du client' },
                { value: 'TIERS-PHONE', label: 'Téléphone fixe' },
                { value: 'TIERS-MOBILE', label: 'Téléphone portable' },
                { value: 'TIERS-FAX', label: 'Fax' },
                { value: 'TIERS-EMAIL', label: 'Email' },
                { value: 'TIERS-WEBSITE', label: 'Site internet' },
                { value: 'TIERS-SIRET', label: 'N° SIRET' },
                { value: 'TIERS-TVA', label: 'N° TVA intracommunautaire' },
            ]
        },
        contact: {
            label: 'Informations sur le contact',
            variables: [
                { value: 'CONTACT-FULLNAME', label: 'Nom complet' },
                { value: 'CONTACT-FIRSTNAME', label: 'Prénom' },
                { value: 'CONTACT-LASTNAME', label: 'Nom de famille' },
                { value: 'CONTACT-PHONE', label: 'Téléphone fixe' },
                { value: 'CONTACT-MOBILE', label: 'Téléphone portable' },
                { value: 'CONTACT-FAX', label: 'Fax' },
                { value: 'CONTACT-EMAIL', label: 'Email' },
                { value: 'CONTACT-WEBSITE', label: 'Site internet' }
            ]
        },
        document: {
            label: 'Informations sur le document',
            variables: [
                { value: 'DOC-NUM', label: 'Numéro du document' },
                { value: 'DATE', label: 'Date' },
                { value: 'EXP-DATE', label: 'Date limite de paiement' },
                { value: 'BDC-TIERS', label: 'N° du bon de commande client' },
                { value: 'INVOICE-ADDRESS', label: 'Adresse de facturation' },
                { value: 'TITLE', label: 'Titre' },
                { value: 'PAYMENT-TERM', label: 'Conditions de paiement' },
                { value: 'TOTAL-HT', label: 'Total HT' },
                { value: 'TOTAL-TVA', label: 'Total TVA' },
                { value: 'TOTAL-TTC', label: 'Total TTC' },
                { value: 'TO-PAID', label: 'Montant à payer' },
                { value: 'ALREADY-PAID', label: 'Montant déjà payé' },
                { value: 'STAY-TO-PAID', label: 'Montant restant à payé' }
            ]
        }
    }
};
/* harmony default export */ var subjectConfig = (subjectConfig_config);

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/RecoveryInvoiceStepForm/RecoveryInvoiceStepForm.ts?vue&type=script&lang=ts&external







var RecoveryInvoiceStepForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(RecoveryInvoiceStepForm, _super);
    function RecoveryInvoiceStepForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.step = {
            delay: 0,
            auto_send_hour: 10
        };
        _this.editorConfig = editorConfig;
        _this.subjectConfig = subjectConfig;
        return _this;
    }
    Object.defineProperty(RecoveryInvoiceStepForm.prototype, "types", {
        get: function () {
            var options = [
                { value: 'mail', label: 'Email' }
            ];
            if (this.hasModule('communication-letters')) {
                options.push({ value: 'letter', label: 'Lettre' });
            }
            if (this.hasModule('communication-reports')) {
                options.push({ value: 'phone', label: 'Compte rendu' });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecoveryInvoiceStepForm.prototype, "formAction", {
        get: function () {
            var url = '/sales/recovery-step';
            if (this.step.id) {
                url += '/' + this.step.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecoveryInvoiceStepForm.prototype, "formMethod", {
        get: function () {
            return this.step.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecoveryInvoiceStepForm.prototype, "hours", {
        get: function () {
            var hours = [];
            for (var i = 0; i < 24; i++) {
                hours.push({ value: i, label: (i < 10 ? '0' + i : i) + 'h00' });
            }
            return hours;
        },
        enumerable: false,
        configurable: true
    });
    RecoveryInvoiceStepForm.prototype.watchValue = function (value) {
        if (value) {
            this.step = JSON.parse(JSON.stringify(value));
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], RecoveryInvoiceStepForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], RecoveryInvoiceStepForm.prototype, "watchValue", null);
    RecoveryInvoiceStepForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormEditor: form_vue_.KFormEditor, KFormSelect: form_vue_.KFormSelect, KFormCheckbox: form_vue_.KFormCheckbox, KFormSpinner: form_vue_.KFormSpinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], RecoveryInvoiceStepForm);
    return RecoveryInvoiceStepForm;
}(lib/* Vue */.lD));
/* harmony default export */ var RecoveryInvoiceStepFormvue_type_script_lang_ts_external = (RecoveryInvoiceStepForm);

;// ./src/components/RecoveryInvoiceStepForm/RecoveryInvoiceStepForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var RecoveryInvoiceStepForm_RecoveryInvoiceStepFormvue_type_script_lang_ts_external = (RecoveryInvoiceStepFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/RecoveryInvoiceStepForm/RecoveryInvoiceStepForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  RecoveryInvoiceStepForm_RecoveryInvoiceStepFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RecoveryInvoiceStepForm_RecoveryInvoiceStepForm = (component.exports);

/***/ }),

/***/ 20317:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 20443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ProformaListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProformaListView.vue?vue&type=template&id=6465108b
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProformaList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ProformaList/ProformaList.vue + 2 modules
var ProformaList = __webpack_require__(57182);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProformaListView.vue?vue&type=script&lang=ts



var ProformaListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProformaListView, _super);
    function ProformaListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProformaListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ProformaList: ProformaList/* default */.A
            }
        })
    ], ProformaListView);
    return ProformaListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ProformaListViewvue_type_script_lang_ts = (ProformaListView);

;// ./src/views/ProformaListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ProformaListViewvue_type_script_lang_ts = (ProformaListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/ProformaListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ProformaListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ProformaListView = (component.exports);

/***/ }),

/***/ 20838:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ 20999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(69302),
    isIterateeCall = __webpack_require__(36800);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 21135:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ 21263:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'copy';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f0c5';
var svgPathData = 'M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.jP = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 21478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SepaDepositDelete_SepaDepositDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SepaDepositDelete/SepaDepositDelete.vue?vue&type=template&id=23a45fda
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer cette remise de prélèvement ?")]),(_vm.value && _vm.value.status === 2)?_c('b-alert',{staticClass:"px-2 py-1",attrs:{"show":"","variant":"warning"}},[_vm._v(" Tous les paiements liés seront annulés et les factures concernées seront mise à jour. ")]):_vm._e()]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SepaDepositDelete/SepaDepositDelete.ts?vue&type=script&lang=ts&external




var SepaDepositDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositDelete, _super);
    function SepaDepositDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(SepaDepositDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    SepaDepositDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    SepaDepositDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    SepaDepositDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/sales/sepa-deposit/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    SepaDepositDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    SepaDepositDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    SepaDepositDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SepaDepositDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], SepaDepositDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], SepaDepositDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SepaDepositDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SepaDepositDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], SepaDepositDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], SepaDepositDelete.prototype, "watchModalState", null);
    SepaDepositDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], SepaDepositDelete);
    return SepaDepositDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var SepaDepositDeletevue_type_script_lang_ts_external = (SepaDepositDelete);

;// ./src/components/SepaDepositDelete/SepaDepositDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SepaDepositDelete_SepaDepositDeletevue_type_script_lang_ts_external = (SepaDepositDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SepaDepositDelete/SepaDepositDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SepaDepositDelete_SepaDepositDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SepaDepositDelete_SepaDepositDelete = (component.exports);

/***/ }),

/***/ 21549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(22032),
    hashDelete = __webpack_require__(63862),
    hashGet = __webpack_require__(66721),
    hashHas = __webpack_require__(12749),
    hashSet = __webpack_require__(35749);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 21791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(16547),
    baseAssignValue = __webpack_require__(43360);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 21827:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ 21986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(51873),
    Uint8Array = __webpack_require__(37828),
    eq = __webpack_require__(75288),
    equalArrays = __webpack_require__(25911),
    mapToArray = __webpack_require__(20317),
    setToArray = __webpack_require__(84247);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 22032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(81042);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 22090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentStatus_DocumentStatus; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentStatus/DocumentStatus.vue?vue&type=template&id=09be2bef
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();return _vm.ask.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('b-modal',{attrs:{"ok-only":_vm.errorMsg !== null,"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.updateStatus},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_c('div',{staticClass:"text-justify"},[_vm._v(" Êtes-vous sûr de vouloir modifier le statut du document à "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.computedLabel))]),_vm._v(" ? "),(_vm.explain)?_c('b-alert',{staticClass:"mt-3 mb-0 py-2 px-2",attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.explain)+" ")]):_vm._e()],1),(_vm.status >= 2 && _vm.document.status === 1)?_c('b-form-group',{staticClass:"mt-4 mb-0",attrs:{"label":"Date du document :","label-cols":"auto"}},[_c('k-form-datepicker',{attrs:{"min-date":_vm.minDate,"max-date":!_vm.teamConfigs.sales_disable_date_check && (_vm.type === 'invoice' || _vm.type === 'credit') ? _vm.today : null},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1):_vm._e(),(_vm.cantBeEditedIfValid && _vm.document.is_draft)?_c('b-alert',{staticClass:"mt-3 mb-0 py-2 px-3",attrs:{"variant":"warning","show":""}},[_vm._v(" Attention, ce document étant déjà facturé à 100%, il ne sera plus modifiable. ")]):_vm._e(),(_vm.type === 'invoice' && _vm.document.is_draft && _vm.document.payment_term?.with_deadlines)?[_c('h3',{staticClass:"form-title-alt mt-5"},[_vm._v("Échéances de paiement")]),_c('Deadlines',{attrs:{"type":_vm.type,"value":_vm.document,"short":""}})]:_vm._e()]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/components/Form/Deadlines/Deadlines.vue + 3 modules
var Deadlines = __webpack_require__(72943);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentStatus/DocumentStatus.ts?vue&type=script&lang=ts&external








var DocumentStatus = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentStatus, _super);
    function DocumentStatus() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.errorMsg = null;
        _this.date = null;
        _this.today = null;
        return _this;
    }
    DocumentStatus.prototype.mounted = function () {
        this.today = external_moment_default()().format('YYYY-MM-DD');
    };
    Object.defineProperty(DocumentStatus.prototype, "minDate", {
        get: function () {
            if (this.type !== 'invoice' && this.type !== 'credit') {
                return null;
            }
            var closed_period = null;
            if (this.team.sales['closed_period']) {
                closed_period = external_moment_default()(this.team.sales['closed_period']).add(1, 'day').format('YYYY-MM-DD');
            }
            var min = null;
            if (!this.teamConfigs.sales_disable_date_check) {
                min = this.team.sales[this.type + '_date'];
            }
            if (min && (!closed_period || external_moment_default()(min).isAfter(closed_period))) {
                return min;
            }
            else if (closed_period) {
                return closed_period;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatus.prototype, "cantBeEditedIfValid", {
        get: function () {
            var _a;
            if (this.type === 'invoice' || this.type === 'credit') {
                return false;
            }
            if (this.type === 'delivery') {
                return this.document.billing_status === 3;
            }
            var invoices = (_a = this.document.invoices) !== null && _a !== void 0 ? _a : [];
            return this.status >= 2 && this.number(this.document.to_bill) === 0 && invoices.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatus.prototype, "computedLabel", {
        // Return confirmation label
        get: function () {
            var _a;
            return (_a = this.confirmLabel) !== null && _a !== void 0 ? _a : this.label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatus.prototype, "params", {
        // Return params for ajax query
        get: function () {
            var attrs = {
                status: this.status
            };
            if (this.status >= 2 && this.document.status === 1 && this.date) {
                attrs.date = this.date;
            }
            if (this.type === 'invoice' && this.document.is_draft && this.document.payment_term.with_deadlines) {
                attrs.deadlines = this.document.deadlines;
            }
            return attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatus.prototype, "url", {
        // Return url for ajax query
        get: function () {
            var url = '/sales/' + this.type + '/' + this.document.id;
            if (this.status !== 2) {
                url += '/lite';
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    // Listen document change
    DocumentStatus.prototype.watchDocument = function (document) {
        if (this.teamConfigs.sales_update_date_for_draft) {
            this.date = external_moment_default()().format('YYYY-MM-DD');
        }
        else {
            var date = document.date;
            if (!this.teamConfigs.sales_disable_date_check && (this.type === 'invoice' || this.type === 'credit')) {
                if (external_moment_default()(date).isBefore(this.team.sales[this.type + '_date'])) {
                    date = external_moment_default()().format('YYYY-MM-DD');
                }
            }
            this.date = date;
        }
    };
    // Open modal
    DocumentStatus.prototype.ask = function () {
        this.errorMsg = null;
        this.modalState = true;
    };
    // Send ajax query
    DocumentStatus.prototype.updateStatus = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.put(this.url, this.params)
            .then(function (response) {
            _this.$emit('input', response.data);
            _this.modalState = false;
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            throw new Error(error);
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentStatus.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentStatus.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentStatus.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentStatus.prototype, "status", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentStatus.prototype, "confirmLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentStatus.prototype, "explain", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentStatus.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ size: 'sm' })
    ], DocumentStatus.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('document', { immediate: true })
    ], DocumentStatus.prototype, "watchDocument", null);
    DocumentStatus = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'team'])),
            components: {
                Spinner: interface_vue_.Spinner,
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KFormDatepicker: form_vue_.KFormDatepicker,
                Deadlines: Deadlines/* default */.A
            }
        })
    ], DocumentStatus);
    return DocumentStatus;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var DocumentStatusvue_type_script_lang_ts_external = (DocumentStatus);

;// ./src/components/DocumentStatus/DocumentStatus.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentStatus_DocumentStatusvue_type_script_lang_ts_external = (DocumentStatusvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/DocumentStatus/DocumentStatus.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentStatus_DocumentStatusvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentStatus_DocumentStatus = (component.exports);

/***/ }),

/***/ 22274:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'én time',
            hh: '%d timer',
            d: 'én dag',
            dd: '%d dager',
            w: 'én uke',
            ww: '%d uker',
            M: 'én måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ 22363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fetchDatas_sepaDeposit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10247);




var SepaDepositMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__extends */ .C6)(SepaDepositMixin, _super);
    function SepaDepositMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.deposit = null;
        return _this;
    }
    SepaDepositMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            components: {
                Spinner: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var id;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = to.params.id;
                                if (!id) {
                                    next(function (vm) { return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(_this, void 0, void 0, function () {
                                        return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                                            vm.deposit = null;
                                            vm.loading = false;
                                            return [2 /*return*/];
                                        });
                                    }); });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,_fetchDatas_sepaDeposit__WEBPACK_IMPORTED_MODULE_2__/* .fetchSepaDeposit */ .qP)(id)
                                        .then(function (deposit) {
                                        next(function (vm) {
                                            vm.deposit = deposit;
                                            vm.loading = false;
                                        });
                                    })
                                        .catch(function (error) {
                                        throw new Error(error);
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var id;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = to.params.id;
                                this.loading = true;
                                this.deposit = null;
                                if (!id) {
                                    this.loading = false;
                                    next();
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,_fetchDatas_sepaDeposit__WEBPACK_IMPORTED_MODULE_2__/* .fetchSepaDeposit */ .qP)(to.params.id)
                                        .then(function (deposit) {
                                        _this.deposit = deposit;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], SepaDepositMixin);
    return SepaDepositMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (SepaDepositMixin);


/***/ }),

/***/ 22573:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'file-alt';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f15c';
var svgPathData = 'M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.h8 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 23007:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 23091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TransformToCommand_TransformToCommand; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TransformToCommand/TransformToCommand.vue?vue&type=template&id=74a21a37
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir créer un bon de commande ?")]),_c('b-form-group',{attrs:{"label":"Date du document"}},[_c('k-form-datepicker',{attrs:{"name":"date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('k-form-checkbox',{model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}},[_vm._v(" Créer le document au statut brouillon ")]),(_vm.cantBeEditedIfValid && !_vm.draft)?_c('b-alert',{staticClass:"mt-3 mb-0 py-2 px-3",attrs:{"variant":"warning","show":""}},[_vm._v(" Attention, ce document étant déjà facturé à 100%, si vous ne créez pas le bon de commande au statut brouillon, celui-ci ne sera pas modifiable. ")]):_vm._e()]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TransformToCommand/TransformToCommand.ts?vue&type=script&lang=ts&external







var TransformToCommand = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TransformToCommand, _super);
    function TransformToCommand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        _this.draft = false;
        return _this;
    }
    TransformToCommand.prototype.mounted = function () {
        this.draft = !this.teamConfigs.sales_command_valid;
    };
    Object.defineProperty(TransformToCommand.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToCommand.prototype, "cantBeEditedIfValid", {
        get: function () {
            var _a;
            var invoices = (_a = this.value.invoices) !== null && _a !== void 0 ? _a : [];
            return this.number(this.value.to_bill) === 0 && invoices.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    TransformToCommand.prototype.watchValue = function () {
        if (this.draft) {
            this.draft = !this.cantBeEditedIfValid;
        }
    };
    TransformToCommand.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    TransformToCommand.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.post('/sales/' + this.type + '/' + this.value.id + '/command', {
            date: this.date,
            is_draft: this.draft
        })
            .then(function (response) {
            _this.success(response.data);
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    TransformToCommand.prototype.closeModal = function () {
        this.errorMsg = null;
        return false;
    };
    TransformToCommand.prototype.success = function (command) {
        return command;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToCommand.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToCommand.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TransformToCommand.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Créer un bon de commande' })
    ], TransformToCommand.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToCommand.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TransformToCommand.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TransformToCommand.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], TransformToCommand.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], TransformToCommand.prototype, "closeModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], TransformToCommand.prototype, "success", null);
    TransformToCommand = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert,
                KFormCheckbox: form_vue_.KFormCheckbox, KFormDatepicker: form_vue_.KFormDatepicker
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], TransformToCommand);
    return TransformToCommand;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var TransformToCommandvue_type_script_lang_ts_external = (TransformToCommand);

;// ./src/components/TransformToCommand/TransformToCommand.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TransformToCommand_TransformToCommandvue_type_script_lang_ts_external = (TransformToCommandvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/TransformToCommand/TransformToCommand.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TransformToCommand_TransformToCommandvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TransformToCommand_TransformToCommand = (component.exports);

/***/ }),

/***/ 23805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 23827:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ 24034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SaleParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SaleParamsView.vue?vue&type=template&id=9d13e4a4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":"Paramètres par défaut"}},[_c('SaleDefaultParams')],1),_c('b-tab',{staticClass:"pt-4",attrs:{"title":"Options de saisie"}},[_c('SaleInputOptions')],1),_c('b-tab',{staticClass:"pt-4",attrs:{"title":"Affichage du PDF"}},[_c('SalePdfOptions')],1),_c('b-tab',{attrs:{"title":_vm.$t('sales.params.referenceTitle')}},[_c('SaleReferences')],1),_c('b-tab',{attrs:{"title":_vm.$t('sales.params.depositTitle')}},[_c('SaleDepositParams')],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SaleReferences/SaleReferences.vue + 3 modules
var SaleReferences = __webpack_require__(83862);
// EXTERNAL MODULE: ./src/components/SaleInputOptions/SaleInputOptions.vue + 3 modules
var SaleInputOptions = __webpack_require__(95160);
// EXTERNAL MODULE: ./src/components/SalePdfOptions/SalePdfOptions.vue + 3 modules
var SalePdfOptions = __webpack_require__(19821);
// EXTERNAL MODULE: ./src/components/SaleDefaultParams/SaleDefaultParams.vue + 3 modules
var SaleDefaultParams = __webpack_require__(25080);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleDepositParams/SaleDepositParams.vue?vue&type=template&id=625a45bc
var SaleDepositParamsvue_type_template_id_625a45bc_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{staticClass:"mb-5",attrs:{"label":"Mode de facturation des acomptes"}},[_c('b-form-radio-group',{attrs:{"name":"configs[sales_deposit_mode_invoice]","stacked":""},model:{value:(_vm.localConfig.sales_deposit_mode_invoice),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_deposit_mode_invoice", $$v)},expression:"localConfig.sales_deposit_mode_invoice"}},[_c('b-form-radio',{staticClass:"mb-3 mt-1",attrs:{"value":false}},[_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(" Les factures d'acompte ne rentrent pas dans le chiffres d'affaire ")]),_vm._v(" C'est le mode de fonctionnement comptable."),_c('br'),_vm._v(" L'acompte sera alors déduit de la facture finale entre le total TTC et le montant à payer."),_c('br'),_vm._v(" Conformément à la comptabilité, les factures d'acompte ne seront pas exportées dans le journal des ventes mais dans le journal de banque. "),_c('p',{staticClass:"text-danger font-weight-bold"},[_vm._v(" Attention, ce mode de fonctionnement n'est pas compatible avec la déclaration et le paiement de la TVA sur facture. ")])]),_c('b-form-radio',{attrs:{"value":true}},[_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(" Les factures d'acompte sont prise en compte dans le chiffre d'affaires ")]),_vm._v(" Les factures d'acompte seront alors déduites dans le contenu de la facture finale, avant le calcul des totaux."),_c('br')])],1)],1),_c('k-form-sticky-bar',{staticClass:"text-center",attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var SaleDepositParamsvue_type_template_id_625a45bc_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleDepositParams/SaleDepositParams.ts?vue&type=script&lang=ts&external





var SaleDepositParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleDepositParams, _super);
    function SaleDepositParams() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaleDepositParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormStickyBar: form_vue_.KFormStickyBar, KForm: form_vue_.KForm,
                BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], SaleDepositParams);
    return SaleDepositParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var SaleDepositParamsvue_type_script_lang_ts_external = (SaleDepositParams);

;// ./src/components/SaleDepositParams/SaleDepositParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleDepositParams_SaleDepositParamsvue_type_script_lang_ts_external = (SaleDepositParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SaleDepositParams/SaleDepositParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleDepositParams_SaleDepositParamsvue_type_script_lang_ts_external,
  SaleDepositParamsvue_type_template_id_625a45bc_render,
  SaleDepositParamsvue_type_template_id_625a45bc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleDepositParams_SaleDepositParams = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SaleParamsView.vue?vue&type=script&lang=ts








var SaleParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleParamsView, _super);
    function SaleParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaleParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SaleDefaultParams: SaleDefaultParams/* default */.A,
                SaleReferences: SaleReferences/* default */.A,
                SaleInputOptions: SaleInputOptions/* default */.A,
                SalePdfOptions: SalePdfOptions/* default */.A,
                SaleDepositParams: SaleDepositParams_SaleDepositParams,
                BTabs: external_bootstrap_vue_.BTabs,
                BTab: external_bootstrap_vue_.BTab
            }
        })
    ], SaleParamsView);
    return SaleParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var SaleParamsViewvue_type_script_lang_ts = (SaleParamsView);

;// ./src/views/SaleParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SaleParamsViewvue_type_script_lang_ts = (SaleParamsViewvue_type_script_lang_ts); 
;// ./src/views/SaleParamsView.vue





/* normalize component */
;
var SaleParamsView_component = (0,componentNormalizer/* default */.A)(
  views_SaleParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SaleParamsView = (SaleParamsView_component.exports);

/***/ }),

/***/ 24066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(83488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 24457:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ 24496:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ 24697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarList_CarList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarList/CarList.vue?vue&type=template&id=dbe090dc
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.customer)?_c('PageHeader',{attrs:{"pageTitle":"Gestion des véhicules","buttons":_vm.buttons}}):_vm._e(),_c('AppMessages'),(_vm.loading)?_c('Spinner'):[_c('k-table',{ref:"table",attrs:{"url":"/automotive/car","columns":_vm.columns,"filters":_vm.filters,"ajaxDatas":_vm.ajaxDatas,"rowActions":_vm.rowActions,"rowClick":_vm.rowClick,"stateKey":"stateKey","importable":"car","exportable":"car"},on:{"totalUpdated":nb => _vm.total = nb}}),(_vm.carItem)?_c('CarItem',{attrs:{"modal":true},on:{"hidden":function($event){_vm.carItem = null},"deleted":function($event){_vm.carItem = null}},model:{value:(_vm.carItem),callback:function ($$v) {_vm.carItem=$$v},expression:"carItem"}}):_vm._e(),_c('CarForm',{attrs:{"modal":_vm.carEdit !== null},on:{"hidden":function($event){_vm.carEdit = null}},model:{value:(_vm.carEdit),callback:function ($$v) {_vm.carEdit=$$v},expression:"carEdit"}}),_c('CarDelete',{attrs:{"element":"modal","modal":_vm.carDelete !== null},on:{"closed":function($event){_vm.carDelete = null}},model:{value:(_vm.carDelete),callback:function ($$v) {_vm.carDelete=$$v},expression:"carDelete"}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: ./src/components/CarItem/CarItem.vue + 3 modules
var CarItem = __webpack_require__(96994);
// EXTERNAL MODULE: ./src/components/CarForm/CarForm.vue + 3 modules
var CarForm = __webpack_require__(8998);
// EXTERNAL MODULE: ./src/components/CarDelete/CarDelete.vue + 3 modules
var CarDelete = __webpack_require__(71183);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarList/CarList.ts?vue&type=script&lang=ts&external









var CarList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarList, _super);
    function CarList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.total = 0;
        _this.carItem = null;
        _this.carEdit = null;
        _this.carDelete = null;
        return _this;
    }
    CarList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadBrands()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        interface_vue_.emitter.on('CarFormCreated', this.carCreated);
                        interface_vue_.emitter.on('CarFormUpdated', this.submitComplete);
                        interface_vue_.emitter.on('CarFormDeleted', this.carDeleted);
                        return [2 /*return*/];
                }
            });
        });
    };
    CarList.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('CarFormCreated', this.carCreated);
        interface_vue_.emitter.off('CarFormUpdated', this.submitComplete);
        interface_vue_.emitter.off('CarFormDeleted', this.carDeleted);
    };
    Object.defineProperty(CarList.prototype, "ajaxDatas", {
        get: function () {
            var datas = {
                include: ['brand', 'model', 'customer']
            };
            if (this.customer) {
                datas.filter = {
                    customer: this.customer.id
                };
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarList.prototype, "stateKey", {
        get: function () {
            return (this.customer ? 'customer-' : '') + 'cars-list';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarList.prototype, "buttons", {
        get: function () {
            var _this = this;
            return [
                {
                    label: 'Nouveau véhicule',
                    click: function () {
                        _this.carEdit = {};
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarList.prototype, "columns", {
        get: function () {
            var columns = [];
            if (!this.customer) {
                columns.push({
                    data: 'customer.name',
                    name: 'Client'
                });
            }
            columns.push.apply(columns, [
                {
                    data: 'brand.name',
                    name: 'Marque'
                },
                {
                    data: 'model.name',
                    name: 'Modèle'
                },
                {
                    data: 'numberplate',
                    name: 'Immatriculation'
                },
                {
                    data: 'first_circulation_date',
                    name: 'Première immatriculation',
                    render: 'date',
                    visible: false
                },
                {
                    data: 'mileage',
                    name: 'Kilométrage',
                    render: function (val) {
                        if (val === null) {
                            return null;
                        }
                        return val + ' km';
                    },
                    visible: false
                },
                {
                    data: 'vin',
                    name: 'Numéro de série',
                    visible: false
                },
                {
                    data: 'comments',
                    name: 'Commentaire',
                    render: 'textarea',
                    visible: false,
                    isHtml: true
                },
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime',
                    visible: false
                }
            ]);
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    click: function (car) {
                        _this.carEdit = car;
                    }
                },
                {
                    icon: 'delete',
                    click: function (car) {
                        _this.carDelete = car;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarList.prototype, "filters", {
        get: function () {
            var filters = [];
            if (!this.customer) {
                filters.push({
                    type: 'select',
                    label: 'Client',
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            filters.push.apply(filters, [
                {
                    type: 'select',
                    label: 'Marque',
                    name: 'brand',
                    multiple: true,
                    optionLabel: 'name',
                    options: this.brands,
                    value: 'id',
                    placeOnHeader: true
                },
                {
                    type: 'select',
                    label: 'Modèle',
                    name: 'model',
                    multiple: true,
                    optionLabel: 'name',
                    options: this.models,
                    value: 'id',
                    placeOnHeader: true
                },
                {
                    type: 'text',
                    label: 'Immatriculation',
                    name: 'numberplate',
                    placeOnHeader: true
                },
                {
                    type: 'period',
                    label: 'Date de création',
                    name: 'created_since',
                    name2: 'created_until'
                }
            ]);
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    CarList.prototype.watchTotal = function (total) {
        this.$emit('totalUpdated', total);
    };
    CarList.prototype.rowClick = function (row) {
        this.carItem = row;
    };
    CarList.prototype.carCreated = function (car) {
        this.submitComplete(car);
        this.total++;
    };
    CarList.prototype.submitComplete = function (car) {
        var table = this.$refs.table;
        var datas = table.getDatas();
        var index = datas.findIndex(function (data) { return data.id === car.id; });
        if (index >= 0) {
            table.updateRow(index, car);
        }
        else {
            table.addRow(car);
        }
    };
    CarList.prototype.carDeleted = function (car) {
        var table = this.$refs.table;
        var datas = table.getDatas();
        var index = datas.findIndex(function (data) { return data.id === car.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarList.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('total')
    ], CarList.prototype, "watchTotal", null);
    CarList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PageHeader: interface_vue_.PageHeader, Spinner: interface_vue_.Spinner, AppMessages: interface_vue_.AppMessages,
                CarForm: CarForm/* default */.A, CarDelete: CarDelete/* default */.A, CarItem: CarItem/* default */.A,
                KTable: table_vue_.KTable
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('automotive', ['brands'])), (0,external_vuex_.mapGetters)('automotive', ['models'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('automotive', ['loadBrands']))
        })
    ], CarList);
    return CarList;
}((external_vue_default())));
/* harmony default export */ var CarListvue_type_script_lang_ts_external = (CarList);

;// ./src/components/CarList/CarList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarList_CarListvue_type_script_lang_ts_external = (CarListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarList/CarList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarList_CarListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarList_CarList = (component.exports);

/***/ }),

/***/ 24739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(26025);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 24997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DepositInvoiceListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DepositInvoiceListView.vue?vue&type=template&id=6d537cab
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InvoiceList',{attrs:{"onlyDepositInvoice":""}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/InvoiceList/InvoiceList.vue + 2 modules
var InvoiceList = __webpack_require__(39690);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DepositInvoiceListView.vue?vue&type=script&lang=ts



var InvoiceListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(InvoiceListView, _super);
    function InvoiceListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoiceListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                InvoiceList: InvoiceList/* default */.A
            }
        })
    ], InvoiceListView);
    return InvoiceListView;
}(lib/* Vue */.lD));
/* harmony default export */ var DepositInvoiceListViewvue_type_script_lang_ts = (InvoiceListView);

;// ./src/views/DepositInvoiceListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_DepositInvoiceListViewvue_type_script_lang_ts = (DepositInvoiceListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/DepositInvoiceListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_DepositInvoiceListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DepositInvoiceListView = (component.exports);

/***/ }),

/***/ 25080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleDefaultParams_SaleDefaultParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleDefaultParams/SaleDefaultParams.vue?vue&type=template&id=111b7c29
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[(_vm.user.is_admin)?[_c('input',{attrs:{"type":"hidden","name":"configs[sales_disable_date_check]"},domProps:{"value":_vm.localConfig.sales_disable_date_check}}),_c('k-form-checkbox',{staticClass:"mt-2 mb-2",model:{value:(_vm.localConfig.sales_disable_date_check),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_disable_date_check", $$v)},expression:"localConfig.sales_disable_date_check"}},[_vm._v(" Permettre la création d'une facture ou d'un avoir dont la date est antérieure au dernier document créé. ")]),_c('b-alert',{attrs:{"show":_vm.localConfig.sales_disable_date_check,"variant":"danger"}},[_vm._v(" Attention, l'activation de cette option peut entraîner une incohérence entre la chronologie de la numérotation des factures et leur date. ")])]:_vm._e(),_c('input',{attrs:{"type":"hidden","name":"configs[sales_update_date_for_draft]"},domProps:{"value":_vm.localConfig.sales_update_date_for_draft}}),_c('k-form-checkbox',{staticClass:"mt-2 mb-2",model:{value:(_vm.localConfig.sales_update_date_for_draft),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_update_date_for_draft", $$v)},expression:"localConfig.sales_update_date_for_draft"}},[_vm._v(" Mettre à jour la date du document avec la date du jour lorsqu'un document au statut brouillon est modifié ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_disable_empty_line]"},domProps:{"value":_vm.localConfig.sales_disable_empty_line}}),_c('k-form-checkbox',{staticClass:"mt-2 mb-2",model:{value:(_vm.localConfig.sales_disable_empty_line),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_disable_empty_line", $$v)},expression:"localConfig.sales_disable_empty_line"}},[_vm._v(" Interdire l'utilisation des lignes vides lors de l'édition des documents ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_update_customer_addresses]"},domProps:{"value":_vm.localConfig.sales_update_customer_addresses}}),_c('k-form-checkbox',{staticClass:"mt-2 mb-4",model:{value:(_vm.localConfig.sales_update_customer_addresses),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_update_customer_addresses", $$v)},expression:"localConfig.sales_update_customer_addresses"}},[_vm._v(" Lorsqu'un document est cloné, mettre à jour les adresses de facturation et de livraison si l'adresse du client a été mise à jour. ")]),_c('b-form-group',{scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v(" Cocher automatiquement la case \"Statut validé\" ")]},proxy:true}])},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_quotation_valid]"},domProps:{"value":_vm.localConfig.sales_quotation_valid}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.localConfig.sales_quotation_valid),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_quotation_valid", $$v)},expression:"localConfig.sales_quotation_valid"}},[_vm._v(" Lors de la création d'un devis depuis un document ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_command_valid]"},domProps:{"value":_vm.localConfig.sales_command_valid}}),_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.localConfig.sales_command_valid),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_command_valid", $$v)},expression:"localConfig.sales_command_valid"}},[_vm._v(" Lors de la création d'un bon de commande depuis un document ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_proforma_valid]"},domProps:{"value":_vm.localConfig.sales_proforma_valid}}),_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.localConfig.sales_proforma_valid),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_proforma_valid", $$v)},expression:"localConfig.sales_proforma_valid"}},[_vm._v(" Lors de la création d'une facture proforma depuis un document ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_delivery_valid]"},domProps:{"value":_vm.localConfig.sales_delivery_valid}}),_c('k-form-checkbox',{staticClass:"mt-2 mb-4",model:{value:(_vm.localConfig.sales_delivery_valid),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_delivery_valid", $$v)},expression:"localConfig.sales_delivery_valid"}},[_vm._v(" Lors de la création d'un bon de livraison depuis un document ")])],1),_c('b-form-group',{attrs:{"label":"Sélection du commercial"}},[_c('k-form-select',{attrs:{"options":_vm.selectCommercials,"reduce":opt => opt.id,"name":"configs[sales_use_customer_commercial]","clearable":false},model:{value:(_vm.localConfig.sales_use_customer_commercial),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_use_customer_commercial", $$v)},expression:"localConfig.sales_use_customer_commercial"}})],1),_c('b-form-group',{attrs:{"label":"Durée de validité d'un document"}},[_c('b-input-group',{attrs:{"append":"jours"}},[_c('k-form-spinner',{attrs:{"name":"configs[sales_quotation_default_validity]","min":0},model:{value:(_vm.localConfig.sales_quotation_default_validity),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_quotation_default_validity", $$v)},expression:"localConfig.sales_quotation_default_validity"}})],1)],1),_c('b-form-group',{attrs:{"label":"Conditions de paiement"}},[_c('PaymentTermSelect',{attrs:{"name":"configs[sales_payment_term]","reduce":opt => opt.id,"clearable":false,"required":""},model:{value:(_vm.localConfig.sales_payment_term),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_payment_term", $$v)},expression:"localConfig.sales_payment_term"}})],1),_c('b-form-group',{attrs:{"label":"Conditions générales de vente"}},[_c('SaleTermsSelect',{attrs:{"name":"configs[sales_sale_term]","reduce":opt =>opt.id},model:{value:(_vm.localConfig.sales_sale_term),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_sale_term", $$v)},expression:"localConfig.sales_sale_term"}})],1),_c('b-form-group',{attrs:{"label":"Moyens de paiement par défaut","label-class":"mb-1"}},[_c('k-form-checkbox-group',{attrs:{"options":_vm.paymentMethods,"text-field":"label","value-field":"id"},model:{value:(_vm.selectedPaymentMethods),callback:function ($$v) {_vm.selectedPaymentMethods=$$v},expression:"selectedPaymentMethods"}}),(_vm.selectedPaymentMethods.length > 0)?_vm._l((_vm.selectedPaymentMethods),function(id){return _c('input',{key:id,attrs:{"validation-name":"configs[sales_payment_methods]","type":"hidden","name":"configs[sales_payment_methods][]"},domProps:{"value":id}})}):_c('input',{attrs:{"type":"hidden","name":"configs[sales_payment_methods]"},domProps:{"value":null}})],2),_c('b-form-group',{attrs:{"label":"Taux d'acompte"}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"configs[sales_payment_advance_rate]","min":0,"max":100},model:{value:(_vm.localConfig.sales_payment_advance_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_payment_advance_rate", $$v)},expression:"localConfig.sales_payment_advance_rate"}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux d'escompe"}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"configs[sales_escompte_rate]","min":0,"max":100},model:{value:(_vm.localConfig.sales_escompte_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_escompte_rate", $$v)},expression:"localConfig.sales_escompte_rate"}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux de pénalité"}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"configs[sales_penalty_rate]","min":0,"max":100,"disabled":_vm.localConfig.sales_penalty_rate_law},model:{value:(_vm.localConfig.sales_penalty_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_penalty_rate", $$v)},expression:"localConfig.sales_penalty_rate"}})],1),_c('input',{attrs:{"type":"hidden","name":"configs[sales_penalty_rate_law]"},domProps:{"value":_vm.localConfig.sales_penalty_rate_law}}),_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.localConfig.sales_penalty_rate_law),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_penalty_rate_law", $$v)},expression:"localConfig.sales_penalty_rate_law"}},[_c('p',{staticClass:"mb-0"},[_vm._v(" Afficher la mention suivante : ")]),_c('small',[_vm._v(" En cas de retard de paiement, application d'intérêts de 3 fois le taux légal selon la loi n°2008-776 du 4 août 2008. ")])])],1),_c('b-form-group',{attrs:{"label":"Frais de recouvrement"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_collection_costs_law]"},domProps:{"value":_vm.localConfig.sales_collection_costs_law}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.localConfig.sales_collection_costs_law),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_collection_costs_law", $$v)},expression:"localConfig.sales_collection_costs_law"}},[_c('p',{staticClass:"mb-0"},[_vm._v(" Afficher la mention suivante : ")]),_c('small',[_vm._v(" En cas de retard de paiement, application d'une indemnité forfaitaire pour frais de recouvrement de 40€ selon l'article D. 441-5 du code du commerce. ")])])],1),_c('b-form-group',{staticClass:"mb-5",attrs:{"label":"Désignation à utiliser pour les sous-totaux"}},[_c('k-form-editor',{attrs:{"name":"configs[sales_subtotal_designation]","mode":"pdf","required":"","size":"sm"},model:{value:(_vm.localConfig.sales_subtotal_designation),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_subtotal_designation", $$v)},expression:"localConfig.sales_subtotal_designation"}})],1),(_vm.hasModule('sales-guarantee-holdback'))?[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Retenue de garantie ")]),_c('b-form-group',{staticClass:"mt-3",attrs:{"label":"Pourcentage de retenue de garantie"}},[_c('b-input-group',{attrs:{"append":"%"}},[_c('k-form-spinner',{attrs:{"name":"configs[sales_guarantee_holdback_pourcent]","min":0,"max":100,"left":""},model:{value:(_vm.localConfig.sales_guarantee_holdback_pourcent),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_guarantee_holdback_pourcent", $$v)},expression:"localConfig.sales_guarantee_holdback_pourcent"}})],1)],1),_c('b-form-group',{staticClass:"mb-5",attrs:{"label":"Durée de retenue de garantie"}},[_c('b-input-group',{attrs:{"append":" mois"}},[_c('k-form-spinner',{attrs:{"name":"configs[sales_guarantee_holdback_duration]","min":0,"left":""},model:{value:(_vm.localConfig.sales_guarantee_holdback_duration),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_guarantee_holdback_duration", $$v)},expression:"localConfig.sales_guarantee_holdback_duration"}})],1)],1)]:_vm._e(),_c('k-form-sticky-bar',{staticClass:"text-center",attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/SaleTermsSelect/SaleTermsSelect.vue + 3 modules
var SaleTermsSelect = __webpack_require__(95150);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleDefaultParams/SaleDefaultParams.ts?vue&type=script&lang=ts&external








var SaleDefaultParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleDefaultParams, _super);
    function SaleDefaultParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedPaymentMethods = [];
        _this.selectCommercials = [
            { id: false, label: 'Utiliser l\'utilisateur qui créer le document si celui-ci est commercial' },
            { id: true, label: 'Utiliser le commercial attribué au client' }
        ];
        return _this;
    }
    SaleDefaultParams.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPaymentMethods()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SaleDefaultParams.prototype.watchSalesPaymentMethods = function () {
        var methods = this.localConfig.sales_payment_methods ? this.localConfig.sales_payment_methods : [];
        this.selectedPaymentMethods = methods.map(function (method) { return method.id; });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localConfig.sales_payment_methods', { immediate: true })
    ], SaleDefaultParams.prototype, "watchSalesPaymentMethods", null);
    SaleDefaultParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SaleTermsSelect: SaleTermsSelect/* default */.A,
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect, KFormSpinner: form_vue_.KFormSpinner, KFormNumber: form_vue_.KFormNumber, KFormEditor: form_vue_.KFormEditor, KFormStickyBar: form_vue_.KFormStickyBar, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert,
                PaymentTermSelect: interface_vue_.PaymentTermSelect
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadPaymentMethods'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['paymentMethods'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('user', ['user']))
        })
    ], SaleDefaultParams);
    return SaleDefaultParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var SaleDefaultParamsvue_type_script_lang_ts_external = (SaleDefaultParams);

;// ./src/components/SaleDefaultParams/SaleDefaultParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleDefaultParams_SaleDefaultParamsvue_type_script_lang_ts_external = (SaleDefaultParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SaleDefaultParams/SaleDefaultParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleDefaultParams_SaleDefaultParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleDefaultParams_SaleDefaultParams = (component.exports);

/***/ }),

/***/ 25160:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 25177:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ 25235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);



var PdfModelMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(PdfModelMixin, _super);
    function PdfModelMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.previewDocumentType = 'quotation';
        _this.privateAreaHeight = null;
        _this.demoTableContent = [
            {
                line_number: 1,
                reference: 'REF',
                picture: null,
                discount: '0%',
                vatrate: '20%',
                designation: 'Huic Arabia est conserta, ex alio latere Nabataeis contigua; opima varietate conmerciorum castrisque oppleta validis et castellis, quae ad repellendos gentium vicinarum excursus sollicitudo pervigil veterum per oportunos saltus erexit et cautos. haec quoque civitates habet inter oppida quaedam ingentes Bostram et Gerasam atque Philadelphiam murorum firmitate cautissimas. hanc provinciae inposito nomine rectoreque adtributo obtemperare legibus nostris Traianus conpulit imperator incolarum tumore saepe contunso cum glorioso marte Mediam urgeret et Parthos.',
                unit_price: 100,
                quantity: 1,
                unit: 'U',
                quantity2: 1,
                total_quantity: 1,
                total: 100,
                stay_to_deliver: 0,
                command_quantity: 1
            } /*,
            {
              line_number: 2,
              reference: 'REF',
              picture: null,
              discount: '0%',
              vatrate: '20%',
              designation: 'Huic Arabia est conserta, ex alio latere Nabataeis contigua; opima varietate conmerciorum castrisque oppleta validis et castellis, quae ad repellendos gentium vicinarum excursus sollicitudo pervigil veterum per oportunos saltus erexit et cautos. haec quoque civitates habet inter oppida quaedam ingentes Bostram et Gerasam atque Philadelphiam murorum firmitate cautissimas. hanc provinciae inposito nomine rectoreque adtributo obtemperare legibus nostris Traianus conpulit imperator incolarum tumore saepe contunso cum glorioso marte Mediam urgeret et Parthos.',
              unit_price: 100,
              quantity: 1,
              unit: 'U',
              quantity2: 1,
              total_quantity: 1,
              total: 100,
              stay_to_deliver: 0,
              command_quantity: 1
            }*/
        ];
        return _this;
    }
    PdfModelMixin.prototype.updated = function () {
        if (this.privateAreaHeight === null) {
            var area = this.$refs['document-content'];
            if (area) {
                this.privateAreaHeight = area.clientHeight;
            }
        }
    };
    Object.defineProperty(PdfModelMixin.prototype, "documentStyles", {
        get: function () {
            var _a, _b, _c, _d, _e, _f;
            var options = (_a = this.pdfModel) === null || _a === void 0 ? void 0 : _a.document;
            var styles = {
                'font-size': ((_b = options === null || options === void 0 ? void 0 : options.textSize) !== null && _b !== void 0 ? _b : 0) + 'pt',
                color: ((_c = options === null || options === void 0 ? void 0 : options.textColor) !== null && _c !== void 0 ? _c : null),
                'font-family': ((_d = options === null || options === void 0 ? void 0 : options.textFont) !== null && _d !== void 0 ? _d : null),
                'background-color': ((_e = options === null || options === void 0 ? void 0 : options.bgColor) !== null && _e !== void 0 ? _e : null)
            };
            if ((_f = this.pdfModel) === null || _f === void 0 ? void 0 : _f.background_image) {
                styles['background-image'] = 'url(data:image/png;base64,' + this.pdfModel.background_image.file + ')';
                styles['background-position'] = 'top left';
                styles['background-repeat'] = 'no-repeat';
                styles['background-size'] = '100% auto';
            }
            return styles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelMixin.prototype, "documentMargins", {
        get: function () {
            var _a, _b, _c, _d;
            var styles = (_a = this.pdfModel) === null || _a === void 0 ? void 0 : _a.document;
            return {
                'padding-top': ((_b = styles === null || styles === void 0 ? void 0 : styles.marginTop) !== null && _b !== void 0 ? _b : 0) + 'mm !important',
                'padding-left': ((_c = styles === null || styles === void 0 ? void 0 : styles.marginLeft) !== null && _c !== void 0 ? _c : 0) + 'mm !important',
                'padding-right': ((_d = styles === null || styles === void 0 ? void 0 : styles.marginRight) !== null && _d !== void 0 ? _d : 0) + 'mm !important'
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelMixin.prototype, "tableStyles", {
        get: function () {
            var _a, _b, _c, _d;
            var tableOptions = (_a = this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions;
            return {
                'margin-top': ((_b = tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.marginTop) !== null && _b !== void 0 ? _b : 0) + 'mm',
                'margin-bottom': ((_c = tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.marginBottom) !== null && _c !== void 0 ? _c : 0) + 'mm',
                'border-width': ((_d = tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.borderWidth) !== null && _d !== void 0 ? _d : 0) + 'px',
                'border-style': 'solid',
                'border-color': tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.borderColor,
                'border-collapse': 'collapse'
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelMixin.prototype, "minCellHeight", {
        get: function () {
            var _a;
            var height = 0;
            if (((_a = this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions.fullHeight) && this.privateAreaHeight) {
                var editor = this.$refs['editor-content'];
                if (editor) {
                    var table = editor.querySelector('.document-table');
                    var minHeightCell = table.querySelector('.min-height-cell');
                    height = this.privateAreaHeight - table.clientHeight + minHeightCell.clientHeight;
                }
            }
            return height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelMixin.prototype, "thStyles", {
        get: function () {
            var _this = this;
            return function (column) {
                var _a;
                var tableOptions = (_a = _this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions;
                var styles = {
                    width: column.width ? column.width + 'mm' : null,
                    'text-align': tableOptions.centerTh ? 'center' : column.align,
                    'font-weight': tableOptions.boldTh ? 'bold' : 'normal',
                    'background-color': tableOptions.thBgColor,
                    color: tableOptions.thTextColor
                };
                if (tableOptions.thFontSize) {
                    styles['font-size'] = tableOptions.thFontSize + 'pt';
                }
                if (tableOptions.borderType === 'all') {
                    styles['border-left-width'] = tableOptions.borderWidth + 'px';
                    styles['border-left-style'] = 'solid';
                    styles['border-left-color'] = tableOptions.borderColor;
                    styles['border-right-width'] = tableOptions.borderWidth + 'px';
                    styles['border-right-style'] = 'solid';
                    styles['border-right-color'] = tableOptions.borderColor;
                }
                if (tableOptions.borderTh) {
                    styles['border-bottom-width'] = tableOptions.borderWidth + 'px';
                    styles['border-bottom-style'] = 'solid';
                    styles['border-bottom-color'] = tableOptions.borderColor;
                }
                return styles;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelMixin.prototype, "tdStyles", {
        get: function () {
            var _this = this;
            return function (column) {
                var _a;
                var tableOptions = (_a = _this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions;
                var styles = {
                    'text-align': column.align,
                    'border-bottom-width': !tableOptions.borderCell ? 0 : 0,
                    'padding-top': tableOptions.cellPaddingTop + 'mm',
                    'padding-bottom': tableOptions.cellPaddingBottom + 'mm',
                    'padding-left': tableOptions.cellPaddingLeft + 'mm',
                    'padding-right': tableOptions.cellPaddingRight + 'mm',
                    'background-color': tableOptions.tdBgColor,
                    color: tableOptions.tdTextColor
                };
                if (tableOptions.tdFontSize) {
                    styles['font-size'] = tableOptions.tdFontSize + 'pt';
                }
                if (tableOptions.borderType === 'all') {
                    styles['border-left-width'] = tableOptions.borderWidth + 'px';
                    styles['border-left-style'] = 'solid';
                    styles['border-left-color'] = tableOptions.borderColor;
                    styles['border-right-width'] = tableOptions.borderWidth + 'px';
                    styles['border-right-style'] = 'solid';
                    styles['border-right-color'] = tableOptions.borderColor;
                }
                if (tableOptions.borderCell) {
                    styles['border-bottom-width'] = tableOptions.borderWidth + 'px';
                    styles['border-bottom-style'] = 'solid';
                    styles['border-bottom-color'] = tableOptions.borderColor;
                }
                if (tableOptions.marginCell) {
                    var padding = Number(tableOptions.cellPaddingBottom) + Number(tableOptions.marginCell);
                    styles['padding-bottom'] = padding + 'mm';
                }
                return styles;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelMixin.prototype, "previewTableColumns", {
        get: function () {
            var _this = this;
            var _a, _b;
            var columns = (_b = (_a = this.pdfModel) === null || _a === void 0 ? void 0 : _a.columns) !== null && _b !== void 0 ? _b : [];
            return columns.filter(function (column) {
                var table = _this.tableColumns.find(function (col) { return col.ident === column.ident; });
                return !table.condition || (table.condition && table.condition());
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelMixin.prototype, "tableColumn", {
        get: function () {
            var _this = this;
            return function (key) { return _this.tableColumns.find(function (column) { return column.ident === key; }); };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelMixin.prototype, "tableColumns", {
        get: function () {
            var _this = this;
            return [
                {
                    ident: 'line_number',
                    name: 'Numéro de ligne',
                    placeholder: 'N°',
                    align: 'center',
                    width: 15,
                    condition: function () { return false; }
                },
                {
                    ident: 'reference',
                    name: 'Référence',
                    placeholder: 'Réf.',
                    align: 'left',
                    width: 20
                },
                {
                    ident: 'picture',
                    name: 'Photo',
                    placeholder: 'Photo',
                    align: 'center',
                    width: 25,
                    condition: function () { return false; }
                },
                {
                    ident: 'designation',
                    name: 'Désignation',
                    placeholder: 'Désignation',
                    noWidth: true,
                    align: 'left'
                },
                {
                    ident: 'discount',
                    name: 'Remise',
                    placeholder: 'Remise',
                    align: 'center',
                    width: 15,
                    condition: function () { return false; }
                },
                {
                    ident: 'vatrate',
                    name: 'Taux TVA',
                    placeholder: 'TVA',
                    align: 'center',
                    width: 15,
                    condition: function () { return false; }
                },
                {
                    ident: 'unit_price',
                    name: 'Prix unitaire HT / TTC',
                    placeholder: 'Prix U. HT',
                    placeholder2: 'Prix U. TTC',
                    align: 'right',
                    width: 20,
                    render: function (value) {
                        var _a;
                        if ((_a = _this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions.withCurrency) {
                            value += ' ' + _this.currency.symbol;
                        }
                        return value;
                    }
                },
                {
                    ident: 'unit_price_discount',
                    name: 'Prix unitaire remisé HT / TTC',
                    placeholder: 'Prix U. HT remisé',
                    placeholder2: 'Prix U. TTC remisé',
                    align: 'right',
                    width: 20,
                    render: function (value) {
                        var _a;
                        if ((_a = _this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions.withCurrency) {
                            value += ' ' + _this.currency.symbol;
                        }
                        return value;
                    }
                },
                {
                    ident: 'quantity',
                    name: 'Quantité',
                    placeholder: 'Qté',
                    align: 'center',
                    width: 17,
                    render: function (value) {
                        var _a;
                        if ((_a = _this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions.unitWithQuantity) {
                            value += ' U';
                        }
                        return value;
                    }
                },
                {
                    ident: 'unit',
                    name: 'Unité',
                    placeholder: 'Unité',
                    align: 'center',
                    width: 15,
                    condition: function () { var _a; return ((_a = _this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions.unitWithQuantity) !== true; }
                },
                {
                    ident: 'quantity2',
                    name: 'Quantité 2',
                    placeholder: 'Durée',
                    align: 'center',
                    width: 15,
                    condition: function () { return false; }
                },
                {
                    ident: 'total_quantity',
                    name: 'Quantité total',
                    placeholder: 'Total Qté',
                    align: 'center',
                    width: 15,
                    condition: function () { return false; }
                },
                {
                    ident: 'total',
                    name: 'Total HT/ TTC',
                    placeholder: 'Total HT',
                    placeholder2: 'Total TTC',
                    align: 'right',
                    width: 20,
                    render: function (value) {
                        var _a;
                        if ((_a = _this.pdfModel) === null || _a === void 0 ? void 0 : _a.tableOptions.withCurrency) {
                            value += ' ' + _this.currency.symbol;
                        }
                        return value;
                    }
                },
                {
                    ident: 'stay_to_deliver',
                    name: 'Quantité restante à livrer (BDL)',
                    placeholder: 'Reste à livrer',
                    align: 'center',
                    width: 15,
                    condition: function () { return _this.previewDocumentType === 'delivery'; }
                },
                {
                    ident: 'command_quantity',
                    name: 'Quantités commandées (BDL)',
                    placeholder: 'Qté cmd',
                    align: 'center',
                    width: 20,
                    condition: function () { return _this.previewDocumentType === 'delivery'; }
                },
                {
                    ident: 'situation_base_total_ht',
                    name: 'Montant devisé (Factures de situation)',
                    placeholder: 'Total HT commandé',
                    placeholder2: 'Total TTC commandé',
                    align: 'center',
                    width: 22,
                    condition: function () { return false; }
                },
                {
                    ident: 'situation_previous_total_ht',
                    name: 'Montant de la précédente situation (Factures de situation)',
                    placeholder: 'Total HT déjà facturé',
                    placeholder2: 'Total TTC déjà facturé',
                    align: 'center',
                    width: 20,
                    condition: function () { return false; }
                },
                {
                    ident: 'situation_previous_percentage',
                    name: 'Pourcentage de la précédente situation (Factures de situation)',
                    placeholder: '% déjà facturé',
                    align: 'center',
                    width: 17,
                    condition: function () { return false; }
                },
                {
                    ident: 'situation_percentage',
                    name: 'Pourcentage de la situation (Factures de situation)',
                    placeholder: '% en cours',
                    align: 'center',
                    width: 17,
                    condition: function () { return false; }
                },
                {
                    ident: 'situation_total_percentage',
                    name: 'Pourcentage total facturé (Factures de situation)',
                    placeholder: '% total facturé',
                    align: 'center',
                    width: 17,
                    condition: function () { return false; }
                },
                {
                    ident: 'situation_total_total_ht',
                    name: 'Montant total facturé (Factures de situation)',
                    placeholder: 'Total HT facturé',
                    placeholder2: 'Total TTC facturé',
                    align: 'center',
                    width: 20,
                    condition: function () { return false; }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    PdfModelMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapGetters)('user', ['currency']))
        })
    ], PdfModelMixin);
    return PdfModelMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (PdfModelMixin);


/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);


var SalesDocumentStatusMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__extends */ .C6)(SalesDocumentStatusMixin, _super);
    function SalesDocumentStatusMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SalesDocumentStatusMixin.prototype, "documentStatus", {
        get: function () {
            switch (this.type) {
                case 'proforma':
                    return [
                        { value: 1, label: 'Brouillon' },
                        { value: 2, label: 'Validée' },
                        { value: 3, label: 'Envoyée' },
                        { value: 4, label: 'Acceptée' },
                        { value: 5, label: 'Facturée partiellement' },
                        { value: 6, label: 'Facturée' },
                        { value: 7, label: 'Refusée' },
                        { value: 8, label: 'Annulée' }
                    ];
                case 'invoice':
                    return [
                        { value: 1, label: 'Brouillon' },
                        { value: 2, label: 'Validée' },
                        { value: 3, label: 'Envoyée / En attente de paiement' },
                        { value: 4, label: 'Payée partiellement' },
                        { value: 5, label: 'Payée' },
                        { value: 6, label: 'En recouvrement' },
                        { value: 7, label: 'Annulée' }
                    ];
                case 'delivery':
                    return [
                        { value: 1, label: 'Brouillon' },
                        { value: 2, label: 'Validé' },
                        { value: 3, label: 'À envoyer' },
                        { value: 4, label: 'Envoyé' },
                        { value: 5, label: 'Annulé' }
                    ];
                case 'credit':
                    return [
                        { value: 1, label: 'Brouillon' },
                        { value: 2, label: 'Validé' },
                        { value: 3, label: 'Envoyé' },
                        { value: 4, label: 'Utilisé partiellement' },
                        { value: 5, label: 'Utilisé' }
                    ];
                default:
                    return [
                        { value: 1, label: 'Brouillon' },
                        { value: 2, label: 'Validé' },
                        { value: 3, label: 'Envoyé' },
                        { value: 4, label: 'Accepté' },
                        { value: 5, label: 'Acompte facturé' },
                        { value: 6, label: 'Facturé partiellement' },
                        { value: 7, label: 'Facturé' },
                        { value: 8, label: 'Refusé' },
                        { value: 9, label: 'Annulé' }
                    ];
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesDocumentStatusMixin.prototype, "deliveryStatus", {
        get: function () {
            return [
                { value: 1, label: 'À livrer' },
                { value: 2, label: 'Livré partiellement' },
                { value: 3, label: 'Livré' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesDocumentStatusMixin.prototype, "invoiceStatus", {
        get: function () {
            return [
                { value: 1, label: 'À facturer' },
                { value: 2, label: 'Facturé partiellement' },
                { value: 3, label: 'Facturé' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Prop */ .kv)({ required: true })
    ], SalesDocumentStatusMixin.prototype, "type", void 0);
    SalesDocumentStatusMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], SalesDocumentStatusMixin);
    return SalesDocumentStatusMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (SalesDocumentStatusMixin);


/***/ }),

/***/ 25325:
/***/ (function(module) {

"use strict";
module.exports = require("vuedraggable");

/***/ }),

/***/ 25571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SepaDepositList_SepaDepositList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SepaDepositList/SepaDepositList.vue?vue&type=template&id=12929161
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-table',{ref:"table",attrs:{"url":"/sales/sepa-deposit","columns":_vm.columns,"filters":_vm.filters,"rowLink":_vm.rowLink,"rowActions":_vm.rowActions,"stateKey":"sepa-deposit-list"}}),_c('SepaDepositDelete',{attrs:{"element":"modal","modal":_vm.deleteIndex !== null},on:{"deleted":_vm.deleted,"closed":_vm.cancelDelete},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: ./src/components/SepaDepositDelete/SepaDepositDelete.vue + 3 modules
var SepaDepositDelete = __webpack_require__(21478);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SepaDepositList/SepaDepositList.ts?vue&type=script&lang=ts&external




var SepaDepositList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositList, _super);
    function SepaDepositList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteModel = null;
        _this.deleteIndex = null;
        return _this;
    }
    Object.defineProperty(SepaDepositList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'date',
                    name: 'Date',
                    render: 'date'
                },
                {
                    data: 'total',
                    name: 'Total',
                    render: 'currency'
                },
                {
                    data: 'status_label',
                    name: 'Statut'
                },
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SepaDepositList.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'period',
                    label: 'Date de création',
                    name: 'created_at',
                    name2: 'created_until'
                },
                {
                    type: 'select',
                    label: 'Statut',
                    name: 'status',
                    options: [
                        { label: 'Brouillon', value: 1 },
                        { label: 'Validé', value: 2 }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    SepaDepositList.prototype.rowLink = function (row) {
        return {
            name: 'sepa-deposit-item',
            params: { id: String(row.id) }
        };
    };
    Object.defineProperty(SepaDepositList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    link: function (deposit) { return ({
                        name: 'sepa-deposit-form',
                        params: { id: String(deposit.id) }
                    }); },
                    condition: function (deposit) { return deposit.status === 1; }
                },
                {
                    icon: 'delete',
                    click: function (deposit, index) {
                        _this.deleteModel = deposit;
                        _this.deleteIndex = index;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    SepaDepositList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.deleteModel = null;
        }
    };
    SepaDepositList.prototype.cancelDelete = function () {
        this.deleteIndex = null;
        this.deleteModel = null;
    };
    SepaDepositList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                SepaDepositDelete: SepaDepositDelete/* default */.A
            }
        })
    ], SepaDepositList);
    return SepaDepositList;
}(lib/* Vue */.lD));
/* harmony default export */ var SepaDepositListvue_type_script_lang_ts_external = (SepaDepositList);

;// ./src/components/SepaDepositList/SepaDepositList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SepaDepositList_SepaDepositListvue_type_script_lang_ts_external = (SepaDepositListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SepaDepositList/SepaDepositList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SepaDepositList_SepaDepositListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SepaDepositList_SepaDepositList = (component.exports);

/***/ }),

/***/ 25911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(38859),
    arraySome = __webpack_require__(14248),
    cacheHas = __webpack_require__(19219);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 26025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(75288);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 26111:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ 26199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CreditsUses_CreditsUses; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CreditsUses/CreditsUses.vue?vue&type=template&id=cf2cd67a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" Facture(s) soldée(s) avec cet avoir : ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_vm._m(0),_c('tbody',_vm._l((_vm.uses),function(use,i){return _c('tr',{key:i},[_c('td',[_c('router-link',{attrs:{"to":{ name: 'invoice-item', params: { id: use.invoice.id }}}},[_vm._v(" "+_vm._s(use.invoice.reference)+" ")])],1),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(use.amount)))])])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thead',[_c('tr',[_c('th',[_vm._v("N° facture")]),_c('th',[_vm._v("Montant")])])])
}]


;// ./src/components/CreditsUses/CreditsUses.vue?vue&type=template&id=cf2cd67a

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CreditsUses/CreditsUses.ts?vue&type=script&lang=ts&external



var CreditsUses = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CreditsUses, _super);
    function CreditsUses() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CreditsUses.prototype, "uses", void 0);
    CreditsUses = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], CreditsUses);
    return CreditsUses;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CreditsUsesvue_type_script_lang_ts_external = (CreditsUses);

;// ./src/components/CreditsUses/CreditsUses.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CreditsUses_CreditsUsesvue_type_script_lang_ts_external = (CreditsUsesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CreditsUses/CreditsUses.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CreditsUses_CreditsUsesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CreditsUses_CreditsUses = (component.exports);

/***/ }),

/***/ 26206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ lang; }
});

;// ./src/lang/en.ts
var salesLang = {};
/* harmony default export */ var en = ({
    sales: salesLang
});

;// ./src/lang/fr.ts
var fr_salesLang = {
    menuTitle: 'Ventes',
    params: {
        menu: 'Paramètres',
        pageTitle: 'Configuration des ventes',
        referenceTitle: 'Numérotation des documents',
        referencePrefix: 'Préfixe',
        referenceNextNumber: 'Prochain numéro',
        referenceTypeNumber: 'Type de numérotation',
        referenceLength: 'Nombre de chiffre',
        referenceExplain: 'Vous pouvez utiliser le jour, le mois ou l\'année en cours dans les préfixes des numéros. Pour cela, insérez l\'une des variables ci-dessous :',
        referenceYear4: 'l\'année sur 4 chiffres',
        referenceYear2: 'l\'année sur 2 chiffres',
        referenceMonth: 'le mois',
        referenceDay: 'le jour',
        depositTitle: 'Facturation des acomptes',
    },
    exports: {
        typeLabel: 'Type d\'export',
        typeDatas: 'Données des documents',
        typePdf: 'Fichiers PDF',
        contentDatas: 'Exporter le contenu des documents',
        allDatas: 'Exporter toutes les informations disponibles (En-têtes + contenu)'
    },
    unit: {
        menu: 'Unités',
        pageTitle: 'Gestion des unités',
        label: 'Nom de l\'unité',
        new: 'Création d\'une unité',
        edit: 'Modification d\'une unité',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette unité ?'
    },
    saleTerm: {
        menu: 'CGV',
        pageTitle: 'Gestion des conditions de vente',
        label: 'Nom des conditions de vente',
        contentLabel: 'Contenu des conditions de vente',
        new: 'Création de conditions de vente',
        edit: 'Modification des conditions de vente',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ces conditions de vente ?'
    },
    account: {
        menu: 'Comptes bancaires',
        pageTitle: 'Gestion des comptes bancaires',
        label: 'Nom du compte',
        new: 'Création d\'un compte bancaire',
        edit: 'Modification d\'un compte bancaire',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce compte bancaire ?',
        form: {
            name: 'Nom du compte bancaire',
            useDefault: 'Utiliser ce compte par défaut',
            coordinates: 'Coordonnées bancaires et prélèvements SEPA',
            owner: 'Titulaire du compte bancaire',
            iban: 'IBAN',
            bic: 'BIC',
            sepaId: 'Identifiant SEPA',
            check: 'Remises de chèque',
            checkExplain: 'Ces données sont utilisées pour générer vos remises de chèque PDF.',
            accountNumber: 'Numéro de compte',
            accountCode: 'Code banque / indicatif',
            fecPart: 'Exports comptable - Fichier FEC',
            fecCode: 'Numéro du compte',
            fecExplain: 'Utiliser pour la génération des journaux comptable et du fichier FEC.'
        },
        elementTypes: {
            invoice: 'Facture',
            credit: 'Avoir',
            charge: 'Charge'
        }
    },
    customerSepa: {
        reference: 'Mandat SEPA n°{reference}',
        type: 'Type',
        type1: 'Récurrent',
        type2: 'Ponctuel',
        sepaType: 'Type de mandat SEPA',
        sepaType1: 'CORE',
        sepaType2: 'B2B',
        address: 'Adresse du client',
        customer: 'Client',
        new: 'Création d\'un mandat SEPA',
        edit: 'Modification d\'un mandat SEPA',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce mandat SEPA ?',
        name: 'Nom du mandat SEPA',
        owner: 'Titulaire du compte bancaire',
        iban: 'IBAN',
        bic: 'BIC',
        sepaIdent: 'Numéro de mandat SEPA',
        date: 'Date de signature',
        status: 'Statut',
        status1: 'Brouillon',
        status2: 'En cours',
        status3: 'Terminé'
    },
    sepaDeposit: {
        invoiceSearchResult: 'Aucune facture ne correspond à la recherche | {count} facture correspond à la recherche | {count} factures correspondent à la recherche',
        totalInvoice: '{count} facture | {count} factures'
    },
    checkDeposit: {
        paymentSearchResult: 'Aucun paiement ne correspond à la recherche | {count} paiement correspond à la recherche | {count} paiements correspondent à la recherche',
        totalPayment: '{count} paiement | {count} paiements'
    },
    paymentMethod: {
        menu: 'Moyens de paiement',
        pageTitle: 'Gestion des moyens de paiement',
        label: 'Nom du moyen de paiement',
        typeLabel: 'Type de moyen de paiement',
        typeComments: 'Il est nécessaire d\'indiquer le type de moyen de paiement au logiciel afin que les fonctionnalités liées aux moyens de paiement fonctionnent correctement.',
        new: 'Création d\'un moyen de paiement',
        edit: 'Modification d\'un moyen de paiement',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce moyen de paiement ?',
        types: {
            card: 'Carte bancaire',
            check: 'Chèque',
            cash: 'Espèce',
            directDebit: 'Prélèvement',
            directTransfert: 'Virement',
            other: 'Autre'
        },
        replacementComments: 'Ce moyen de paiement est utilisé, il doit donc être fusionné avec un autre moyen de paiement afin que le logiciel fonctionne normalement.'
    },
    vatRate: {
        menu: 'Taux de TVA',
        pageTitle: 'Gestion des taux de TVA',
        rateLabel: 'Taux de TVA',
        label: 'Label',
        commentsLabel: 'Le label vous permet d\'identifier un taux de TVA lorsque vous avez plusieurs taux de TVA identiques.',
        mentionLabel: 'Mention à afficher sur les documents PDF',
        new: 'Création d\'un taux de TVA',
        edit: 'Modification d\'un taux de TVA',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce taux de TVA ?',
        replacementComments: 'Ce taux de TVA est utilisé, vous ne pouvez donc pas le supprimer. Cependant, il est possible de le fusionner avec un taux de TVA indentique.'
    },
    saleCategory: {
        menu: 'Catégories de vente',
        pageTitle: 'Gestion des catégories de vente',
        label: 'Nom de la catégorie',
        parentLabel: 'Catégorie parente',
        accountLabel: 'Compte comptable',
        new: 'Création d\'une catégorie de vente',
        edit: 'Modification d\'une catégorie de vente',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie de vente ?',
        accountByVatRate: 'Comptes '
    },
    pdfModel: {
        menu: 'Modèles PDF',
        pageTitle: 'Gestion des modèles PDF',
        label: 'Nom du modèle PDF',
        addTitle: 'Création d\'un modèle PDF',
        addLabel: 'Créer un modèle PDF',
        new: 'Création d\'un modèle PDF',
        edit: 'Modification d\'une catégorie de vente',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce modèle PDF ?'
    },
    paymentTerm: {
        menu: 'Conditions de paiement',
        pageTitle: 'Gestion des conditions de paiement',
        new: 'Création d\'une condition de paiement',
        edit: 'Modification d\'une condition de paiement',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette condition de paiement ?',
        label: 'Nom de la condition de paiement',
        nbDays: 'Nombre de jour',
        endMonth: 'Fin de mois',
        endMonthDay: 'Fin de mois le'
    },
    grant: {
        menu: 'Subventions',
        pageTitle: 'Liste des subventions',
        new: 'Création d\'une subvention',
        edit: 'Modification d\'une subvention',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette subvention ?',
        label: 'Désignation',
        pdfMentions: 'Affichage sur le PDF',
        pdfMentionsExplain: 'Ce texte sera affiché sur le document PDF dans le tableau des totaux en face du montant de la subvention.',
        type: 'Type de subvention',
        typePourcent: 'Pourcentage',
        typeAmount: 'Montant',
        pourcent: 'Pourcentage à appliquer au total TTC'
    },
    affair: {
        menu: 'Affaires',
        label: 'Affaire',
        reference: 'Affaire n°{reference}'
    },
    quotation: {
        menu: 'Devis',
        label: 'Devis',
        reference: 'Devis n°{reference}',
        newTitle: 'Création d\'un devis',
        editTitle: 'Modification du devis n°{reference}',
        cantEdited: 'Un devis facturé à 100% ne peut pas être modifié',
        cantEditedWithSituation: 'Un devis avec une facture d\'avancement ne peut pas être modifié'
    },
    command: {
        menu: 'Bons de commande',
        label: 'Bon de commande',
        reference: 'Bon de commande n°{reference}',
        newTitle: 'Création d\'un bon de commande',
        editTitle: 'Modification du bon de commande n°{reference}',
        cantEdited: 'Un bon de commande facturé à 100% ne peut pas être modifié',
        cantEditedWithSituation: 'Un bon de commande avec une facture d\'avancement ne peut pas être modifié',
    },
    depositInvoice: {
        menu: 'Factures d\'acompte',
        label: 'Facture d\'acompte',
        reference: 'Facture d\'acompte n°{reference}',
        newTitle: 'Création d\'une facture d\'acompte',
        editTitle: 'Modification de la facture d\'acompte n°{reference}',
        cantEdited: 'Une facture qui n\'est plus au statut brouillon ne peut pas être modifiée'
    },
    situationInvoice: {
        label: 'Factures de situation',
        reference: 'Facture de situation n°{reference}',
    },
    proforma: {
        menu: 'Factures proforma',
        label: 'Facture proforma',
        reference: 'Facture proforma n°{reference}',
        newTitle: 'Création d\'une facture proforma',
        editTitle: 'Modification de la facture proforma n°{reference}',
        cantEdited: 'Une facture proforma facturée à 100% ne peut pas être modifiée'
    },
    delivery: {
        menu: 'Bons de livraison',
        label: 'Bon de livraison',
        reference: 'Bon de livraison n°{reference}',
        newTitle: 'Création d\'un bon de livraison',
        editTitle: 'Modification du bon de livraison n°{reference}',
        cantEdited: 'Un bon de livraison facturé ne peut pas être modifié'
    },
    invoice: {
        menu: 'Factures',
        label: 'Facture',
        reference: 'Facture n°{reference}',
        newTitle: 'Création d\'une facture',
        editTitle: 'Modification de la facture n°{reference}',
        cantEdited: 'Une facture qui n\'est plus au statut brouillon ne peut pas être modifiée'
    },
    credit: {
        menu: 'Avoirs',
        label: 'Avoir',
        reference: 'Avoir n°{reference}',
        newTitle: 'Création d\'un avoir',
        editTitle: 'Modification de l\'avoir n°{reference}',
        cantEdited: 'Un avoir qui n\'est plus au statut brouillon ne peut pas être modifié'
    },
    provider_command: {
        label: 'Bon de commande'
    },
    contract: {
        reference: 'Contrat n°{reference}',
        label: 'Contrat'
    },
    opportunity: {
        label: 'Opportunité'
    },
    construction: {
        label: 'Chantier'
    },
    form: {
        newPageTitle: {
            quotation: 'Création d\'un devis',
            command: 'Création d\'un bon de commande',
            delivery: 'Création d\'un bon de livraison',
            proforma: 'Création d\'une facture proforma',
            invoice: 'Création d\'une facture',
            credit: 'Création d\'un avoir'
        },
        editPageTitle: {
            quotation: 'Modification d\'un devis',
            command: 'Modification d\'un bon de commande',
            delivery: 'Modification d\'un bon de livraison',
            proforma: 'Modification d\'une facture proforma',
            invoice: 'Modification d\'une facture',
            credit: 'Modification d\'un avoir'
        },
        titleCustomer: 'Informations client',
        titleDocument: {
            quotation: 'Informations du devis',
            command: 'Informations du bon de commande',
            delivery: 'Informations du bon de livraison',
            proforma: 'Informations de la facture proforma',
            invoice: 'Informations de la facture',
            credit: 'Informations de l\'avoir'
        },
        customer: 'Client',
        contact: 'Contact',
        invoiceAddress: 'Adresse de facturation',
        deliveryAddress: 'Adresse de livraison',
        constructionAddress: 'Adresse de chantier',
        customCustomerName: 'Personnaliser le nom du client',
        customContactName: 'Personnaliser le nom du contact',
        withRoad3: 'Ajouter une troisième ligne à l\'adresse',
        withComments: 'Ajouter des commentaires',
        customVatrateNumber: 'Personnaliser le n° de TVA intracommunautaire',
        road: 'Rue',
        road3: 'Rue 3',
        vatrateNumber: 'N° TVA intracommunautaire',
        vartrateNumberShort: 'N° TVA intra.',
        comments: 'Commentaires',
        title: {
            quotation: 'Titre du devis',
            command: 'Titre du bon de commande',
            delivery: 'Titre du bon de livraison',
            proforma: 'Titre de la facture proforma',
            invoice: 'Titre de la facture',
            credit: 'Titre de l\'avoir'
        },
        date: {
            quotation: 'Date du devis',
            command: 'Date du bon de commande',
            delivery: 'Date du bon de livraison',
            proforma: 'Date de la facture proforma',
            invoice: 'Date de la facture',
            credit: 'Date de l\'avoir'
        },
        expirationDate: 'Limite de validité',
        paymentDate: 'Limite de paiement',
        reference: {
            generic: 'N° du document',
            quotation: 'N° du devis',
            command: 'N° du bon de commande',
            delivery: 'N° du bon de livraison',
            proforma: 'N° de la facture proforma',
            invoice: 'N° de la facture',
            credit: 'N° de l\'avoir'
        },
        paymentTerm: 'Conditions de règlement',
        commandReference: 'Bon de commande client',
        addCommandReference: 'Renseigner le numéro de bon de commande fourni par votre client',
        advancePayment: 'Acompte',
        vatRate: 'Taux de TVA',
        quantity2: 'Quantité 2',
        unit: 'Unité',
        tags: 'Mots-clés',
        pdfModel: 'Modèle PDF',
        commercial: 'Commercial',
        customerNotes: 'Notes à l\'attention du client',
        addCustomerNotes: 'Ajouter des notes à l\'attention du client',
        titleContent: 'Contenu du document',
        emptyLine: 'Ligne vide',
        commentsLine: 'Commentaires',
        subtotalLine: 'Sous-total',
        pagebreakLine: 'Saut de page',
        columns: {
            number: 'N°',
            reference: 'Référence',
            unitPriceHt: 'Prix U. HT',
            unitPriceTtc: 'Prix U. TTC',
            vatRate: 'Taux TVA',
            quantity2: 'Quantité 2',
            totalHt: 'Total HT',
            totalTtc: 'Total TTC'
        },
        noContent: 'Le document ne contient aucune ligne',
        totals: {
            globalDiscount: 'Remise générale',
            globalDiscountHt: 'HT',
            globalDiscountTtc: 'TTC',
            totalHt: 'Total HT :',
            tva: 'TVA :',
            tvaRate: 'TVA {rate} % :',
            totalTtc: 'Total TTC :'
        },
        lines: {
            pageBreak: 'Saut de page',
            buyPrice: 'Prix d\'achat :',
            variousCosts: 'Coûts divers :',
            totalBuy: 'Total achat :',
            totalCharge: 'Total charge :',
            marginAmount: 'Marge HT :',
            marginRate: 'Taux marge :',
            markupRate: 'Taux marque :',
            duration: 'Durée :',
            durationMinute: 'Mn',
            durationHour: 'H',
            technicalNumber: 'Nb technicien :',
            hourlyCosts: 'Coûts horaire :',
            workoutCosts: 'Main d\'oeuvre :',
            eanCode: 'Code EAN :',
            weight: 'Poids :',
            ecoPart: 'Dont éco-part. :',
            ht: 'ht',
            ttc: 'ttc',
            option: 'Option'
        },
        saveConflict: {
            mostRecentVersion: 'Une version plus récente du document en cours de modification existe.',
            actionsChoice: 'Quelle action souhaitez-vous effectuer ?',
            newWindow: 'Ouvrir la dernière version dans une nouvelle fenêtre',
            forceSave: 'Forcer l\'enregistrement',
            allDatasLost: 'Toutes les données de la version plus récente seront perdues.',
            goNewVersion: 'Rediriger vers la nouvelle version',
            datasNotSaved: 'Les modifications que vous souhaitez apportées ne seront pas enregistrées et seront donc perdues.'
        },
        sidebar: {
            inputOptions: 'Options de saisie',
            pdfCustomization: 'Personnalisation du PDF',
            sidebarPosition: 'Modifier la position de la barre',
            fullscreen: 'Plein écran',
            totalHt: 'Total HT',
            totalTva: 'Total TVA',
            totalTtc: 'Total TTC',
            workout: 'Main d\'oeuvre',
            costs: 'Coûts',
            marginAmount: 'Marge Brute HT',
            marginRate: 'Taux de marge',
            markupRate: 'Taux de marque',
            saveContinue: 'Enregistrer',
            createDraft: 'Créer en brouillon',
            createValid: 'Créer et valider',
            editDraft: 'Modifier',
            editValid: 'Modifier et valider',
            action: {
                quotation: {
                    create: 'Créer le devis',
                    edit: 'Modifier le devis'
                },
                command: {
                    create: 'Créer le bon de commande',
                    edit: 'Modifier le bon de commande'
                },
                delivery: {
                    create: 'Créer le bon de livraison',
                    edit: 'Modifier le bon de livraison'
                },
                proforma: {
                    create: 'Créer la proforma',
                    edit: 'Modifier la proforma'
                },
                invoice: {
                    create: 'Créer la facture',
                    edit: 'Modifier la facture'
                },
                credit: {
                    create: 'Créer l\'avoir',
                    edit: 'Modifier l\'avoir'
                }
            }
        },
        saveDefaultBtn: 'Enregistrer comme configuration par défaut',
        saveDefaultConfirmation: 'Êtes-vous sûr de vouloir enregistrer ces informations comme configuration par défaut pour vos prochains documents ?',
        inputOptions: {
            explain: 'Gérez les différentes options qu\'il vous est possible de saisir lors de la rédaction de votre document.',
            deliveryAddress: 'Adresse de livraison / de chantier',
            activeDeliveryAddress: 'Activer la saisie de l\'adresse de livraison',
            vatrateSelection: 'Sélection du taux de TVA',
            vatrateSelectionOne: 'Un seul taux de TVA pour tout le document',
            vatrateSelectionMultiple: 'Un taux de TVA pour chaque ligne du document',
            amountTypes: 'Mode de saisie des montants',
            amountTypesHt: 'Saisie des montants HT',
            amountTypesTtc: 'Saisie des montants TTC',
            allowOptions: 'Possibilité de proposer des options',
            allowOptionsExplain: 'Seul le prix unitaire sera affiché sur le PDF avec le terme \'option\' dans la colonne quantité',
            allowOptionOn: 'Activé',
            disallowOptionOn: 'Désactivé',
            ean: 'Code EAN',
            eanChoice1: 'Aucune saisie, le code EAN sera quand même récupéré sur la fiche produit',
            eanChoice2: 'Saisie uniquement pour les lignes vides',
            eanChoice3: 'Saisie uniquement pour les lignes avec produit',
            eanChoice4: 'Saisie pour les lignes vides et les lignes avec produit',
            eanChoice5: 'Saisie pour toutes les lignes',
            weight: 'Poids',
            weightChoice1: 'Aucune saisie, le poids sera quand même récupéré sur la fiche produit',
            weightChoice2: 'Saisie uniquement pour les lignes vides',
            weightChoice3: 'Saisie uniquement pour les lignes avec produit',
            weightChoice4: 'Saisie pour les lignes vides et les lignes avec produit',
            weightChoice5: 'Saisie pour toutes les lignes',
            ecoParticipation: 'Éco-participation',
            ecoParticipationChoice1: 'Aucune saisie, l\'éco-participation sera quand même indiquée pour les produits concernés',
            ecoParticipationChoice2: 'Saisie uniquement pour les lignes vides',
            ecoParticipationChoice3: 'Saisie uniquement pour les lignes avec produit',
            ecoParticipationChoice4: 'Saisie pour les lignes vides et les lignes avec produit',
            ecoParticipationChoice5: 'Saisie pour toutes les lignes',
            columnTitle: 'Affichage des colonnes',
            columnNumber: 'Afficher la colonne n° de ligne (1,2,3...)',
            columnReference: 'Afficher la colonne référence',
            columnPicture: 'Afficher la colonne photo',
            columnUnit: 'Afficher les unités',
            stockTitle: 'Gestion du stock',
            stockQuantity: 'Affichage du niveau de stock',
            stockQuantityChoice1: 'Afficher le stock théorique',
            stockQuantityChoice2: 'Afficher le stock réel',
            stockQuantityChoice3: 'Afficher le stock théorique et le stock réel',
            stockTracabilities: 'Gestion de stock avec gestion de la traçabilité',
            stockTracabilitiesActive: 'Permettre de sélectionner un produit dans le stock',
            stockTracabilitiesDisable: 'Désactivé',
            stockTracabilitiesExplain1: 'Cette fonctionnalité est obligatoirement activée pour les bons de livraison.',
            stockTracabilitiesExplain2: 'Lorsqu\'un produit est sélectionné et que le document est enregistré, le produit sera immédiatement déduit du stock théorique. Pour les devis, bons de commande et factures proforma, le stock sera recrédité à la date d\'expiration du document si celui-ci n\'a pas été facturé.',
            costsTitle: 'Calcul des coûts',
            costs: 'Saisie des coûts',
            costsChoice1: 'Aucune saisie, les données seront quand même récupérées sur les éléments du catalogue',
            costsChoice2: 'Saisie uniquement pour les lignes vides',
            costsChoice3: 'Saisie uniquement pour les lignes avec produit',
            costsChoice4: 'Saisie uniquement pour les lignes avec éléments du catalogue',
            costsChoice5: 'Saisie pour les lignes vides et les lignes avec produit',
            costsChoice6: 'Saisie pour toutes les lignes',
            variousCosts: 'Activer la saisie des coûts divers',
            workforce: 'Saisie de la main d\'oeuvre',
            workforceChoice1: 'Aucune saisie, les données seront quand même récupérées sur la fiche prestation',
            workforceChoice2: 'Saisie uniquement pour les lignes vides',
            workforceChoice3: 'Saisie uniquement pour les lignes avec prestation',
            workforceChoice4: 'Saisie uniquement pour les lignes avec éléments du catalogue',
            workforceChoice5: 'Saisie pour les lignes vides et les lignes avec prestation',
            workforceChoice6: 'Saisie pour toutes les lignes',
            marginCalculation: 'Calcul de la marge',
            showMarginAmount: 'Afficher la marge brute HT',
            showMarginRate: 'Afficher le taux de marge',
            showMarkupRate: 'Afficher le taux de marque',
            secondaryQuantityTitle: 'Quantité secondaire',
            secondaryQuantityExplain: 'Les quantités secondaires vous permettent de saisir une deuxième quantité qui sera complémentaire de la première. Elles sont généralements utilisées pour facturer des durées.',
            secondaryQuantity: 'Mode de saisie de la quantité secondaire',
            secondaryQuantityChoice1: 'Ne pas utiliser de quantité secondaire',
            secondaryQuantityChoice2: 'Une seule quantité pour tout le document',
            secondaryQuantityChoice3: 'Une quantité secondaire pour chaque ligne du document',
            secondaryQuantityUnit: 'Gestion des unités pour les quantités secondaires',
            secondaryQuantityEnable: 'Activé',
            secondaryQuantityDisabled: 'Désactivé'
        },
        pdfOptions: {
            title: 'Options d\'affichage du PDF',
            explain: 'Personnalisez l\'affichage des différentes informations qui apparaîtront sur votre document PDF.',
            contentTitle: 'Contenu du document',
            amounts: 'Affichage des montants dans le contenu du document',
            amountsChoice1: 'Utiliser les réglages de saisie du document',
            amountsChoice2: 'Afficher les montants HT',
            amountsChoice3: 'Afficher les montants TTC',
            amountsChoice4: 'Afficher les montants HT et le total TTC',
            discount: 'Affichage des remises',
            discountChoice1: 'Afficher une ligne négative avec la remise',
            discountChoice2: 'Ajouter une colonne remise et afficher le prix unitaire HT remisé',
            discountChoice3: 'Ajouter une colonne remise et afficher le prix unitaire HT non remisé',
            discountChoice4: 'Ajouter le prix unitaire HT remisé et non remisé',
            comments: 'Affichage des lignes de commentaires',
            commentsChoice1: 'Uniquement la largeur de la colonne description',
            commentsChoice2: 'Occuper toute la largeur du tableau',
            unit: 'Affichage des unités',
            unitExplain: 'Les unités ne seront affichées que si celle-ci sont activées lors de la saisie du document',
            unitChoice0: 'Ne pas afficher',
            unitChoice1: 'Afficher à droite de la quantité',
            unitChoice2: 'Afficher sous la quantité',
            unitChoice3: 'Afficher dans une colonne séparée',
            pictures: 'Affichage des photos',
            picturesExplain: 'Les photos ne seront affichées que si celle-ci sont activées lors de la saisie du document',
            picturesChoice1: 'Afficher les photos dans une colonne séparée',
            picturesChoice2: 'Afficher les photos sous la description',
            number: 'Affichage de la colonne numéro de ligne',
            reference: 'Affichage de la colonne référence',
            ean: 'Affichage du code EAN',
            weight: 'Affichage du poids unitaire',
            displayChoice1: 'Utiliser les réglages de saisie du document',
            displayChoice2: 'Afficher',
            displayChoice3: 'Ne pas afficher',
            vatrate: 'Forcer l\'affichage de la colonne TVA',
            vatrateExplain: 'La colonne TVA s\'affichera automatiquement si plusieurs taux de TVA sont présents.',
            vatrateChoice1: 'Affichage automatique',
            vatrateChoice2: 'Forcer l\'affichage',
            totalQuantity: 'Afficher la colonne quantité totale',
            totalQuantityExplain: 'Cette colonne ne peut être affichée que si la quantité secondaire est activée.',
            totalQuantityChoice1: 'Ne pas afficher',
            totalQuantityChoice2: 'Afficher la colonne quantité totale',
            addressesTitle: 'Adresses de livraison et de facturation',
            addressesChoice1: 'Afficher sur l\'adresse de facturation et de livraison',
            addressesChoice2: 'Masquer sur l\'adresse de facturation uniquement',
            addressesChoice3: 'Masquer sur l\'adresse de livraison uniquement',
            addressesChoice4: 'Masquer sur l\'adresse de facturation et de livraison',
            contact: 'Affichage du contact',
            country: 'Affichage du pays',
            vatrateNumber: 'Affichage du numéro de TVA intracommunautaire du client',
            vatrateNumberChoice1: 'Ne pas l\'afficher',
            vatrateNumberChoice2: 'L\'afficher uniquement pour les pays différents du vôtre',
            vatrateNumberChoice3: 'Toujours l\'afficher',
            situationColumns1: 'Ne pas afficher',
            situationColumns2: 'Afficher le total et le pourcentage dans la même colonne',
            situationColumns3: 'Afficher le total et le pourcentage dans des colonnes séparées',
            situationColumns4: 'Afficher uniquement le total',
            situationColumns5: 'Afficher uniquement le pourcentage'
        }
    },
    list: {
        date: 'Date',
        title: 'Titre',
        totalHt: 'Total HT',
        totalTva: 'Total TVA',
        totalTtc: 'Total TTC',
        status: 'Statut'
    },
    catalogSearch: {
        placeholder: 'Rechercher un produit, une prestation...',
        goToCatalog: 'Accéder au catalogue',
        noResults: 'Aucun résultat'
    },
    recoveryInvoice: {
        config: {
            pageTitle: 'Relances des factures impayées',
            menu: 'Relances des impayées',
            createTitle: 'Création d\'une étape de relance des factures',
            updateTitle: 'Modification d\'une étape de relance des factures',
            deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette étape de relance ?',
        }
    },
    months: {
        1: 'Janvier',
        2: 'Février',
        3: 'Mars',
        4: 'Avril',
        5: 'Mai',
        6: 'Juin',
        7: 'Juillet',
        8: 'Août',
        9: 'Septembre',
        10: 'Octobre',
        11: 'Novembre',
        12: 'Décembre'
    },
    signature: {
        status: {
            1: 'Brouillon',
            2: 'En attente d\'envoi',
            3: 'Envoyée',
            4: 'Signée partiellement',
            5: 'Signée',
            6: 'Annulée'
        },
        documentTypes: {
            quotation: 'Devis n°{reference}',
            command: 'Bon de commande n°{reference}',
            proforma: 'Facture proforma n°{reference}',
            delivery: 'Bon de livraison n°{reference}',
            customerSepa: 'Mandat SEPA n°{reference}',
            contract: 'Contrat n°{reference}'
        }
    }
};
var tasksLang = {
    searchTypes: {
        contract: 'Contrat'
    }
};
var calendarsLang = {
    searchTypes: {
        contract: 'Contrat'
    }
};
/* harmony default export */ var fr = ({
    sales: fr_salesLang,
    tasks: tasksLang,
    calendars: calendarsLang
});

;// ./src/lang/index.ts


var Lang = {
    en: en,
    fr: fr
};
/* harmony default export */ var lang = (Lang);


/***/ }),

/***/ 26308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ 26378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerSepaForm_CustomerSepaForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSepaForm/CustomerSepaForm.vue?vue&type=template&id=66fa7d41
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.formSubmitted}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.type')}},[_c('k-form-select',{attrs:{"name":"type","reduce":opt => opt.value,"options":[
            { value: 1, label: _vm.$t('sales.customerSepa.type1') },
            { value: 2, label: _vm.$t('sales.customerSepa.type2') }
          ],"clearable":false,"required":""},model:{value:(_vm.sepa.type),callback:function ($$v) {_vm.$set(_vm.sepa, "type", $$v)},expression:"sepa.type"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.sepaType')}},[_c('k-form-select',{attrs:{"name":"sepa_type","reduce":opt => opt.value,"options":[
            { value: 1, label: _vm.$t('sales.customerSepa.sepaType1') },
            { value: 2, label: _vm.$t('sales.customerSepa.sepaType2') }
          ],"clearable":false,"required":""},model:{value:(_vm.sepa.sepa_type),callback:function ($$v) {_vm.$set(_vm.sepa, "sepa_type", $$v)},expression:"sepa.sepa_type"}})],1),(!_vm.customerId)?[_c('CustomerSelect',{attrs:{"withForm":false,"clearable":false,"include":['address_invoice'],"required":""},on:{"input":_vm.customerSelected},model:{value:(_vm.sepa.customer),callback:function ($$v) {_vm.$set(_vm.sepa, "customer", $$v)},expression:"sepa.customer"}}),_c('input',{attrs:{"type":"hidden","name":"customer"},domProps:{"value":_vm.sepa.customer ? _vm.sepa.customer.id : null}})]:_c('input',{attrs:{"type":"hidden","name":"customer"},domProps:{"value":_vm.customerId}}),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.name'),"description":"Facultatif, permet d'identifier un mandat SEPA lorsqu'un client en possède plusieurs"}},[_c('k-form-input',{attrs:{"name":"name"},model:{value:(_vm.sepa.name),callback:function ($$v) {_vm.$set(_vm.sepa, "name", $$v)},expression:"sepa.name"}})],1),_c('b-form-group',{attrs:{"label":"Statut"}},[_c('k-form-select',{attrs:{"name":"status","reduce":opt => opt.value,"required":"","options":_vm.status,"clearable":false},model:{value:(_vm.sepa.status),callback:function ($$v) {_vm.$set(_vm.sepa, "status", $$v)},expression:"sepa.status"}})],1)],2),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.owner')}},[_c('k-form-input',{attrs:{"name":"owner","required":"","maxlength":"35"},model:{value:(_vm.sepa.owner),callback:function ($$v) {_vm.$set(_vm.sepa, "owner", $$v)},expression:"sepa.owner"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.iban')}},[_c('k-form-input',{attrs:{"name":"iban","required":""},model:{value:(_vm.sepa.iban),callback:function ($$v) {_vm.$set(_vm.sepa, "iban", $$v)},expression:"sepa.iban"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.bic')}},[_c('k-form-input',{attrs:{"name":"bic","required":""},model:{value:(_vm.sepa.bic),callback:function ($$v) {_vm.$set(_vm.sepa, "bic", $$v)},expression:"sepa.bic"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.sepaIdent'),"description":_vm.sepa.id ? null : 'Le numéro sera généré automatiquement si il n\'est pas renseigné'}},[_c('k-form-input',{attrs:{"name":"reference","required":_vm.sepa.id,"maxlength":"35"},model:{value:(_vm.sepa.reference),callback:function ($$v) {_vm.$set(_vm.sepa, "reference", $$v)},expression:"sepa.reference"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.date')}},[_c('k-form-datepicker',{attrs:{"name":"date"},model:{value:(_vm.sepa.date),callback:function ($$v) {_vm.$set(_vm.sepa, "date", $$v)},expression:"sepa.date"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.address')}},[_c('b-form-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"2"}},[_c('k-form-input',{attrs:{"placeholder":"Numéro","name":"road_number","size":"sm"},model:{value:(_vm.sepa.road_number),callback:function ($$v) {_vm.$set(_vm.sepa, "road_number", $$v)},expression:"sepa.road_number"}})],1),_c('b-col',[_c('k-form-input',{attrs:{"placeholder":"Rue","name":"road","size":"sm"},model:{value:(_vm.sepa.road),callback:function ($$v) {_vm.$set(_vm.sepa, "road", $$v)},expression:"sepa.road"}})],1)],1),_c('b-form-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('k-form-input',{attrs:{"placeholder":"Code postal","name":"postal_code","size":"sm"},model:{value:(_vm.sepa.postal_code),callback:function ($$v) {_vm.$set(_vm.sepa, "postal_code", $$v)},expression:"sepa.postal_code"}})],1),_c('b-col',{attrs:{"cols":"8"}},[_c('k-form-input',{attrs:{"placeholder":"Ville","name":"city","size":"sm"},model:{value:(_vm.sepa.city),callback:function ($$v) {_vm.$set(_vm.sepa, "city", $$v)},expression:"sepa.city"}})],1),_c('b-col',{staticClass:"pt-2",attrs:{"cols":"3"}},[_c('CountrySelect',{attrs:{"placeholder":"Pays","validationName":"country","size":"sm"},model:{value:(_vm.sepa.country),callback:function ($$v) {_vm.$set(_vm.sepa, "country", $$v)},expression:"sepa.country"}}),_c('input',{attrs:{"type":"hidden","name":"country"},domProps:{"value":_vm.sepa.country ? _vm.sepa.country.code : null}})],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSepaForm/CustomerSepaForm.ts?vue&type=script&lang=ts&external







var CustomerSepaForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSepaForm, _super);
    function CustomerSepaForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sepa = {};
        return _this;
    }
    Object.defineProperty(CustomerSepaForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/sales/sepa';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaForm.prototype, "status", {
        get: function () {
            return [
                { value: 1, label: 'Brouillon' },
                { value: 2, label: 'En cours' },
                { value: 3, label: 'Terminé' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CustomerSepaForm.prototype.watchValue = function (value) {
        this.sepa = Object.assign({
            type: 1,
            status: this.teamConfigs['sales_sepa_default_status'],
            sepa_type: 1
        }, JSON.parse(JSON.stringify(value)));
    };
    CustomerSepaForm.prototype.formSubmitted = function (response) {
        return response;
    };
    CustomerSepaForm.prototype.customerSelected = function (customer) {
        var _a, _b, _c, _d;
        var address = customer.address_invoice;
        var road = this.splitAddress((_a = address === null || address === void 0 ? void 0 : address.road1) !== null && _a !== void 0 ? _a : null);
        this.sepa.road_number = road.number;
        this.sepa.road = road.street;
        this.sepa.city = (_b = address === null || address === void 0 ? void 0 : address.town) !== null && _b !== void 0 ? _b : null;
        this.sepa.postal_code = (_c = address === null || address === void 0 ? void 0 : address.postal_code) !== null && _c !== void 0 ? _c : null;
        this.sepa.country = (_d = address === null || address === void 0 ? void 0 : address.country) !== null && _d !== void 0 ? _d : null;
    };
    CustomerSepaForm.prototype.isNumber = function (n) {
        return !isNaN(parseFloat(String(n))) && isFinite(Number(n));
    };
    CustomerSepaForm.prototype.isFractionalChar = function (n) {
        var c = n.charCodeAt(0);
        return (c >= 188 && c <= 190) || (c >= 8531 && c <= 8542);
    };
    CustomerSepaForm.prototype.indexFractionalChar = function (m) {
        var a = m.split('');
        for (var i in a) {
            if (this.isFractionalChar(a[i])) {
                return i;
            }
        }
        return false;
    };
    CustomerSepaForm.prototype.splitAddress = function (x) {
        if (x === null) {
            return { number: null, street: null };
        }
        var a = x.trim().split(' ');
        if (a.length <= 1) {
            return { number: null, street: a.join('') };
        }
        var number;
        if (this.isNumber(a[0].substr(0, 1)) || this.isFractionalChar(a[0].substr(0, 1))) {
            number = a.shift();
        }
        else {
            return { number: '', street: x.trim() };
        }
        if (/[0-9]\/[0-9]/.exec(a[0]) || this.indexFractionalChar(a[0]) !== false) {
            number += ' ' + a.shift();
        }
        return { number: number !== null && number !== void 0 ? number : null, street: a.join(' ') };
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaForm.prototype, "customerId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomerSepaForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], CustomerSepaForm.prototype, "formSubmitted", null);
    CustomerSepaForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormDatepicker: form_vue_.KFormDatepicker, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRow: external_bootstrap_vue_.BFormRow, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                CustomerSelect: customers_vue_.CustomerSelect,
                CountrySelect: interface_vue_.CountrySelect
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], CustomerSepaForm);
    return CustomerSepaForm;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerSepaFormvue_type_script_lang_ts_external = (CustomerSepaForm);

;// ./src/components/CustomerSepaForm/CustomerSepaForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSepaForm_CustomerSepaFormvue_type_script_lang_ts_external = (CustomerSepaFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CustomerSepaForm/CustomerSepaForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerSepaForm_CustomerSepaFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSepaForm_CustomerSepaForm = (component.exports);

/***/ }),

/***/ 26435:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ 26993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContractItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractItemView.vue?vue&type=template&id=c8581304
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('ContractItem',{model:{value:(_vm.contract),callback:function ($$v) {_vm.contract=$$v},expression:"contract"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/ContractMixin.ts
var ContractMixin = __webpack_require__(3568);
// EXTERNAL MODULE: ./src/components/ContractItem/ContractItem.vue + 3 modules
var ContractItem = __webpack_require__(53471);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractItemView.vue?vue&type=script&lang=ts




var ContractFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractFormView, _super);
    function ContractFormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContractFormView.prototype.watchContract = function () {
        var _a;
        window.document.title = 'Contrat n°' + ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.reference);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('contract', { immediate: true })
    ], ContractFormView.prototype, "watchContract", null);
    ContractFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContractItem: ContractItem/* default */.A
            }
        })
    ], ContractFormView);
    return ContractFormView;
}((0,lib/* Mixins */.Xe)(ContractMixin/* default */.A)));
/* harmony default export */ var ContractItemViewvue_type_script_lang_ts = (ContractFormView);

;// ./src/views/ContractItemView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContractItemViewvue_type_script_lang_ts = (ContractItemViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/ContractItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContractItemViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractItemView = (component.exports);

/***/ }),

/***/ 27088:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ 27301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 27534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72552),
    isObjectLike = __webpack_require__(40346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 27569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfModelBlockPreview_PdfModelBlockPreview; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfModelBlockPreview/PdfModelBlockPreview.vue?vue&type=template&id=3666fd5d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FroalaView',{staticClass:"block-preview",model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfModelBlockPreview/PdfModelBlockPreview.ts?vue&type=script&lang=ts&external







var PdfModelBlockPreview = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelBlockPreview, _super);
    function PdfModelBlockPreview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PdfModelBlockPreview.prototype, "computedValue", {
        get: function () {
            var _this = this;
            var _a;
            if (this.value === undefined || this.value === null) {
                return this.value;
            }
            var value = this.value;
            (_a = this.value.match(/<variable(.*?)<\/variable>/gs)) === null || _a === void 0 ? void 0 : _a.forEach(function (variable) {
                // Get variable identifier
                var findIdent = variable.match(/data-variable="(.*?)"/s);
                if (!findIdent) {
                    return;
                }
                var ident = findIdent[1];
                var findConditionnal = variable.match(/data-conditional-show="(.*?)"/s);
                var conditionnal = findConditionnal ? findConditionnal[1] === 'true' : false;
                var previewValue = _this.previewValues[ident];
                if ((previewValue === undefined || previewValue === null || previewValue === '') && conditionnal) {
                    value = value.replace(variable, '');
                }
                var replace = '';
                var findSpaceBeforePrefix = variable.match(/data-prefix-space-before="(.*?)"/s);
                var spaceBeforePrefix = findSpaceBeforePrefix ? findSpaceBeforePrefix[1] === 'true' : false;
                if (spaceBeforePrefix) {
                    replace += '<br>';
                }
                var findPrefix = variable.match(/data-prefix="(.*?)"/s);
                if (findPrefix) {
                    var prefixLabel = findPrefix[1];
                    var findBoldPrefix = variable.match(/data-prefix-bold="(.*?)"/s);
                    var boldPrefix = findBoldPrefix ? findBoldPrefix[1] === 'true' : false;
                    if (boldPrefix) {
                        prefixLabel = '<strong>' + prefixLabel + '</strong>';
                    }
                    replace += prefixLabel;
                }
                var findSpaceAfterPrefix = variable.match(/data-prefix-space-after="(.*?)"/s);
                var spaceAfterPrefix = findSpaceAfterPrefix ? findSpaceAfterPrefix[1] === 'true' : false;
                if (spaceAfterPrefix) {
                    replace += '<br>';
                }
                replace += previewValue;
                var findSpaceBeforeSuffix = variable.match(/data-suffix-space-before="(.*?)"/s);
                var spaceBeforeSuffix = findSpaceBeforeSuffix ? findSpaceBeforeSuffix[1] === 'true' : false;
                if (spaceBeforeSuffix) {
                    replace += '<br>';
                }
                var findSuffix = variable.match(/data-suffix="(.*?)"/s);
                if (findSuffix) {
                    replace += findSuffix[1];
                }
                var findSpaceAfterSuffix = variable.match(/data-suffix-space-after="(.*?)"/s);
                var spaceAfterSuffix = findSpaceAfterSuffix ? findSpaceAfterSuffix[1] === 'true' : false;
                if (spaceAfterSuffix) {
                    replace += '<br>';
                }
                value = value.replace(variable, replace);
            });
            return value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlockPreview.prototype, "previewValues", {
        get: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            var team = this.team;
            var values = {
                'COMPANY-NAME': team.company_name,
                'COMPANY-ROAD2': (_a = team.road2) !== null && _a !== void 0 ? _a : '',
                'COMPANY-ROAD3': (_b = team.road3) !== null && _b !== void 0 ? _b : '',
                'COMPANY-ROAD': (_c = team.road1) !== null && _c !== void 0 ? _c : '',
                'COMPANY-POSTAL': (_d = team.postal_code) !== null && _d !== void 0 ? _d : '',
                'COMPANY-TOWN': (_e = team.town) !== null && _e !== void 0 ? _e : '',
                'COMPANY-COUNTRY': (_g = (_f = team.country) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : '',
                'COMPANY-PHONE': (_h = team.phone) !== null && _h !== void 0 ? _h : '',
                'COMPANY-MOBILE': (_j = team.mobile) !== null && _j !== void 0 ? _j : '',
                'COMPANY-FAX': (_k = team.fax) !== null && _k !== void 0 ? _k : '',
                'COMPANY-EMAIL': (_l = team.email) !== null && _l !== void 0 ? _l : '',
                'COMPANY-WEBSITE': (_m = team.website) !== null && _m !== void 0 ? _m : '',
                'COMPANY-TYPE': (_o = team.company_type) !== null && _o !== void 0 ? _o : '',
                'COMPANY-SIRET': (_p = team.company_siret) !== null && _p !== void 0 ? _p : '',
                'COMPANY-RCS': (_q = team.company_rcs) !== null && _q !== void 0 ? _q : '',
                'COMPANY-TVA': (_r = team.company_vatrate) !== null && _r !== void 0 ? _r : '',
                'COMPANY-NAF': (_s = team.company_naf) !== null && _s !== void 0 ? _s : '',
                'COMPANY-CAPITAL': (_t = team.company_capital) !== null && _t !== void 0 ? _t : '',
                'TIERS-CODE': 'CL0001',
                'TIERS-NAME': 'Client',
                'TIERS-ROAD2': '2ème étage',
                'TIERS-ROAD3': 'Porte droite',
                'TIERS-ROAD': '12 rue de Paris',
                'TIERS-POSTAL': '75012',
                'TIERS-TOWN': 'Paris',
                'TIERS-COUNTRY': 'France',
                'TIERS-PHONE': '01 75 00 00 00',
                'TIERS-MOBILE': '06 75 00 00 00',
                'TIERS-FAX': '06 75 00 00 00',
                'TIERS-EMAIL': 'contact@client.com',
                'TIERS-WEBSITE': 'www.client.com',
                'TIERS-SIRET': '44229377500031',
                'TIERS-TVA': 'FR04442293775',
                'TIERS-COMMERCIAL': 'Nicolas Dupuis',
                'CONTACT-FULLNAME': 'Mathieu Dupond',
                'CONTACT-FIRSTNAME': 'Mathieu',
                'CONTACT-LASTNAME': 'Dupond',
                'CONTACT-ROAD2': '',
                'CONTACT-ROAD3': '',
                'CONTACT-ROAD': '75 rue de Montmartre',
                'CONTACT-POSTAL': '75010',
                'CONTACT-TOWN': 'Paris',
                'CONTACT-COUNTRY': 'France',
                'CONTACT-PHONE': '01 75 00 00 00',
                'CONTACT-MOBILE': '06 75 00 00 00',
                'CONTACT-FAX': '01 75 00 00 01',
                'CONTACT-EMAIL': 'contact@client.com',
                'CONTACT-WEBSITE': 'www.contact.com',
                'COMMERCIAL-NAME': 'Nicolas Dupuis',
                'COMMERCIAL-FIRSTNAME': 'Nicolas',
                'COMMERCIAL-LASTNAME': 'Dupuis',
                'COMMERCIAL-TEL': '01 75 00 00 00',
                'COMMERCIAL-PORT': '06 75 00 00 00',
                'COMMERCIAL-FAX': '01 75 00 00 01',
                'COMMERCIAL-EMAIL': 'nicolas@exemple.com',
                'DOC-TYPE': this.$t('sales.' + this.preview + '.label'),
                'DOC-NUM': 'DOC2212-00012',
                'EXP-DATE': this.date(external_moment_default()().add(1, 'month').format('YYYY-MM-DD')),
                'DATE': this.date(external_moment_default()().format('YYYY-MM-DD')),
                'DATE-LETTER': 'Lundi 25 juin 2022',
                'BDC-TIERS': 'BDC2201020121',
                'INVOICE-ADDRESS': this.address,
                'DELIVERY-ADDRESS': this.address,
                'TITLE': 'Titre de mon document',
                'ACOMPTE': '10 %, soit ' + this.formattedNumber('100'),
                'ACOMPTE-AMOUNT': this.formattedNumber(10),
                'ACOMPTE-POURCENT': this.number(10) + ' %',
                'ESCOMPTE': this.number(2) + '%',
                'ESCOMPTE-AM0UNT-HT': this.formattedNumber(2),
                'ESCOMPTE-AM0UNT-TVA': this.formattedNumber(0.4),
                'ESCOMPTE-AM0UNT-TTC': this.formattedNumber(2.4),
                'PENALTY-RATE': this.number(5) + '%',
                'PAYMENT-TERM': 'À réception de facture',
                'ACCEPTED-PAYMENT-METHODS': '<ul><li>Espèce</li><li>Carte bancaire</li><li>Virement</li></ul>',
                'TOTAL-HT-WITHOUT-DISCOUNT': this.formattedNumber(100),
                'TOTAL-TVA-WITHOUT-DISCOUNT': this.formattedNumber(20),
                'TOTAL-TTC-WITHOUT-DISCOUNT': this.formattedNumber(120),
                'TOTAL-HT': this.formattedNumber(100),
                'TOTAL-TVA': this.formattedNumber(20),
                'TOTAL-TTC': this.formattedNumber(120),
                'TOTAL-TTC-LETTER': 'cent vingt',
                'TO-PAID': this.formattedNumber(120),
                'ALREADY-PAID': this.formattedNumber(0),
                'STAY-TO-PAID': this.formattedNumber(120),
                'TOTALS': this.totalsTable(false),
                'TOTALS-WITH-RATES': this.totalsTable(true),
                'GLOBAL-DISCOUNT-HT': this.formattedNumber(0),
                'GLOBAL-DISCOUNT-TVA': this.formattedNumber(0),
                'GLOBAL-DISCOUNT-TTC': this.formattedNumber(0),
                'TOTAL-ECOTAXE-HT': this.formattedNumber(0),
                'TOTAL-ECOTAXE-TVA': this.formattedNumber(0),
                'TOTAL-ECOTAXE-TTC': this.formattedNumber(0),
                'TOTAL-QUANTITY': this.number(5),
                'TOTAL-WEIGHT': this.number(10) + 'kg',
                'PAYMENTS-LIST': this.paymentsTables,
                'VATRATES-DETAILS': this.vatRatesTables,
                'NOTES': 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.',
                'LAW-COLLECTION-COSTS': 'En cas de retard de paiement, application d\'une indemnité forfaitaire pour frais de recouvrement de 40€ selon l\'article D. 441-5 du code du commerce.',
                'LAW-PENALTY-FEES': 'En cas de retard de paiement, application d\'intérêts de 3 fois le taux légal selon la loi n°2008-776 du 4 août 2008.',
                'MENTIONS-TVA': 'TVA non applicable, article XXX X du CGI',
                'LINKED-QUOTATION': 'DEV0001',
                'LINKED-COMMAND': 'BDC0001',
                'LINKED-DELIVERY': 'BDL0001',
                'LINKED-PROFORMA': 'PRO0001',
                'LINKED-INVOICE': 'FA0001',
                'LINKED-CREDIT': 'AV0001',
                'LINKED-DOCUMENT': 'DEV0001',
                'LINKED-DOCUMENT2': 'Devis n°DEV0001',
                'DELIVERY-MODE': 'Colissmo',
                'DELIVERY-TRACKING': '6Q01929938641',
                'DELIVERY-QTY': '2',
                'PAGE-NUM': '1',
                'TOTAL-PAGE': '1',
                'LOGO': this.logo,
                'CONTRACT-REFERENCE': 'CTR00120',
                'CONTRACT-TITLE': 'Titre du contrat',
                'CONTRACT-DATE': '12-12-2023',
                'SIGNATURE': '<table style="border:1px dashed #000;width: 60mm; font-size: 3mm" cellpadding="5" class="sign-part"><tr><td style="height: 30mm">Signature :</td></tr></table>',
                'SIGNATURE-NAME': '<table style="border:1px dashed #000;width: 60mm; font-size: 3mm" cellpadding="5" class="sign-part"><tr><td style="height: 30mm">Nom :<br/>Signature :</td></tr></table>',
                'SIGNATURE-DATE': 'Date :<table style="margin-top:7px; border:1px dashed #000;width: 60mm; font-size: 3mm" cellpadding="5" class="sign-part"><tr><td style="height: 30mm">Signature :</td></tr></table>',
                'SIGNATURE-NAME-DATE': '<table style="border:1px dashed #000;width: 60mm; font-size: 3mm" cellpadding="5" class="sign-part"><tr><td style="height: 30mm">Nom :<br/>Date :<br/>Signature :</td></tr></table>',
                'CAR-BRAND': 'Renault',
                'CAR-MODEL': 'Clio',
                'CAR-DATE': '20-12-2020',
                'CAR-NUMBERPLATE': 'AA-000-AA',
                'CAR-MILEAGE': '18 543 km',
                'CAR-VIN': 'VRED3745TRUD8',
                'CAR-COMMENTS': '1.5 DCI'
            };
            this.customFields.forEach(function (field) {
                var value = '';
                switch (field.type) {
                    case 'amount':
                        value = _this.formattedNumber(1123);
                        break;
                    case 'number':
                        value = _this.formattedNumber(1123, false);
                        break;
                    case 'quantity':
                        value = _this.formattedNumber(1123);
                        break;
                    case 'date':
                        value = _this.date(external_moment_default()().format('YYYY-MM-DD'));
                        break;
                    default:
                        value = 'Crebris maxime foedere';
                }
                values['CUSTOM-FIELD-' + field.id] = value;
            });
            return values;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlockPreview.prototype, "logo", {
        get: function () {
            var model = this.pdfModel;
            var logo = model.logo;
            if (!logo) {
                return '';
            }
            var styles = '';
            var width = model.document.logoWidth;
            if (width) {
                styles = 'width: ' + width + 'mm';
            }
            var height = model.document.logoHeight;
            if (height) {
                styles = 'height: ' + height + 'mm';
            }
            if (!width && !height) {
                styles = 'width: 100%';
            }
            return '<img src="data:image/' + logo.extension + ';base64,' + logo.file + '" style="' + styles + '" />';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlockPreview.prototype, "address", {
        get: function () {
            var address = 'Client';
            if (this.pdfModel.document.customerNameBold) {
                address = '<b>' + address + '</b>';
            }
            return address + '<br>12 rue de Paris<br>75012 PARIS<br>France';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlockPreview.prototype, "totalsTable", {
        get: function () {
            var _this = this;
            return function (withDetails) {
                var tableStyles = _this.tableStyles('Totals');
                var thStyles = _this.thStyles('Totals');
                var tdStyles = _this.tdStyles('Totals') + 'text-align: right;';
                var text = _this.pdfModel.tables.totals;
                var cellpadding = !_this.pdfModel.tableOptions.applyPaddingTotalsTable ? ' cellpadding="3"' : '';
                var table = "<table style=\"" + tableStyles + "\"" + cellpadding + ">\n                    <tr>\n                      <td style=\"" + thStyles + "\">" + (_this.noEmpty(text === null || text === void 0 ? void 0 : text.totalHt) ? text.totalHt : 'Total HT :') + "</td>\n                      <td style=\"" + tdStyles + "\">" + _this.formattedNumber(100) + "</td>\n                    </tr>";
                if (withDetails) {
                    table += "<tr>\n                    <td style=\"" + thStyles + "\">" + (_this.noEmpty(text === null || text === void 0 ? void 0 : text.totalTvaPourcent) ? text.totalTvaPourcent : 'TVA [RATE] % :').replace('[RATE]', '20') + "</td>\n                    <td style=\"" + tdStyles + "\">" + _this.formattedNumber(20) + "</td>\n                  </tr>";
                }
                else {
                    table += "<tr>\n                    <td style=\"" + thStyles + "\">" + (_this.noEmpty(text === null || text === void 0 ? void 0 : text.totalTva) ? text.totalTva : 'Total TVA :') + "</td>\n                    <td style=\"" + tdStyles + "\">" + _this.formattedNumber(20) + "</td>\n                  </tr>";
                }
                table += "<tr>\n                  <td style=\"" + thStyles + "\">" + (_this.noEmpty(text === null || text === void 0 ? void 0 : text.totalTtc) ? text.totalTtc : 'Total TTC :') + "</td>\n                  <td style=\"" + tdStyles + "\">" + _this.formattedNumber(120) + "</td>\n                </tr>\n              </table>";
                return table;
            };
        },
        enumerable: false,
        configurable: true
    });
    PdfModelBlockPreview.prototype.noEmpty = function (value) {
        return value !== '' && value !== null && value !== undefined;
    };
    Object.defineProperty(PdfModelBlockPreview.prototype, "vatRatesTables", {
        get: function () {
            var tableStyles = this.tableStyles('Rates');
            var thStyles = this.thStyles('Rates');
            var tdStyles = this.tdStyles('Rates');
            var text = this.pdfModel.tables.rates;
            return "<table style=\"" + tableStyles + "\">\n                <thead>\n                    <tr>\n                        <th style=\"" + thStyles + "\">" + (this.noEmpty(text === null || text === void 0 ? void 0 : text.base) ? text.base : 'Base HT') + "</th>\n                        <th style=\"" + thStyles + "\">" + (this.noEmpty(text === null || text === void 0 ? void 0 : text.rate) ? text.rate : 'Taux TVA') + "</th>\n                        <th style=\"" + thStyles + "\">" + (this.noEmpty(text === null || text === void 0 ? void 0 : text.amount) ? text.amount : 'Montant TVA') + "</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr>\n                        <td style=\"" + tdStyles + "\">" + this.formattedNumber(100) + "</td>\n                        <td style=\"" + tdStyles + "\">20%</td>\n                        <td style=\"" + tdStyles + "\">" + this.formattedNumber(20) + "</td>\n                    </tr>\n                </tbody>\n            </table>";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlockPreview.prototype, "paymentsTables", {
        get: function () {
            var tableStyles = this.tableStyles('Payments');
            var thStyles = this.thStyles('Payments');
            var tdStyles = this.tdStyles('Payments');
            var text = this.pdfModel.tables.payments;
            return "<table style=\"" + tableStyles + "\">\n                <thead>\n                    <tr>\n                        <th style=\"" + thStyles + "\">" + (this.noEmpty(text === null || text === void 0 ? void 0 : text.date) ? text.date : 'Date') + "</th>\n                        <th style=\"" + thStyles + "\">" + (this.noEmpty(text === null || text === void 0 ? void 0 : text.type) ? text.type : 'Type') + "</th>\n                        <th style=\"" + thStyles + "\">" + (this.noEmpty(text === null || text === void 0 ? void 0 : text.reference) ? text.reference : 'Référence') + "</th>\n                        <th style=\"" + thStyles + "\">" + (this.noEmpty(text === null || text === void 0 ? void 0 : text.amount) ? text.amount : 'Montant') + "</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr>\n                        <td style=\"" + tdStyles + "\">" + this.date(external_moment_default()().format('YYYY-MM-DD')) + "</td>\n                        <td style=\"" + tdStyles + "\">Virement</td>\n                        <td style=\"" + tdStyles + "\">2930103392</td>\n                        <td style=\"" + tdStyles + "\">" + this.formattedNumber(120) + "</td>\n                    </tr>\n                </tbody>\n            </table>";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlockPreview.prototype, "tableStyles", {
        get: function () {
            var _this = this;
            return function (key) {
                var documentOptions = _this.pdfModel.document;
                var tableOptions = _this.pdfModel.tableOptions;
                var styles = {
                    width: '100%',
                    'border-collapse': 'collapse'
                };
                if (tableOptions['applyCell' + key + 'Table']) {
                    if (documentOptions.totalsTextColor) {
                        styles.color = documentOptions.totalsTextColor;
                    }
                    if (documentOptions.totalsBgColor) {
                        styles['background-color'] = documentOptions.totalsBgColor;
                    }
                }
                if (!tableOptions['applyBorderColor' + key + 'Table']) {
                    styles['border-top-width'] = tableOptions.borderWidth + 'px !important';
                    styles['border-top-style'] = 'solid !important';
                    styles['border-top-color'] = tableOptions.borderColor + ' !important';
                    styles['border-bottom-width'] = tableOptions.borderWidth + 'px !important';
                    styles['border-bottom-style'] = 'solid !important';
                    styles['border-bottom-color'] = tableOptions.borderColor + ' !important';
                }
                return _this.toString(styles);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlockPreview.prototype, "thStyles", {
        get: function () {
            var _this = this;
            return function (key) {
                var tableOptions = _this.pdfModel.tableOptions;
                var styles = {};
                if (tableOptions['applyHead' + key + 'Table']) {
                    if (tableOptions.thTextColor) {
                        styles.color = tableOptions.thTextColor;
                    }
                    if (tableOptions.thBgColor) {
                        styles['background-color'] = tableOptions.thBgColor;
                    }
                }
                if (tableOptions['applyPadding' + key + 'Table']) {
                    if (tableOptions.cellPaddingLeft) {
                        styles['padding-left'] = tableOptions.cellPaddingLeft + 'mm';
                    }
                    if (tableOptions.cellPaddingRight) {
                        styles['padding-right'] = tableOptions.cellPaddingRight + 'mm';
                    }
                    if (tableOptions.cellPaddingTop) {
                        styles['padding-top'] = tableOptions.cellPaddingTop + 'mm';
                    }
                    if (tableOptions.cellPaddingBottom) {
                        styles['padding-bottom'] = tableOptions.cellPaddingBottom + 'mm';
                    }
                }
                if (!tableOptions['applyBorderColor' + key + 'Table']) {
                    styles['border-left-width'] = '1px !important';
                    styles['border-left-style'] = 'solid !important';
                    styles['border-left-color'] = '#000000 !important';
                    styles['border-right-width'] = '1px !important';
                    styles['border-right-style'] = 'solid !important';
                    styles['border-right-color'] = '#000000 !important';
                    styles['border-top-width'] = '1px !important';
                    styles['border-top-style'] = 'solid !important';
                    styles['border-top-color'] = '#000000 !important';
                    styles['border-bottom-width'] = '1px !important';
                    styles['border-bottom-style'] = 'solid !important';
                    styles['border-bottom-color'] = '#000000 !important';
                }
                else {
                    if (!tableOptions['applyBorderType' + key + 'Table']) {
                        styles['border-left-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-left-style'] = 'solid !important';
                        styles['border-left-color'] = tableOptions.borderColor + ' !important';
                        styles['border-right-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-right-style'] = 'solid !important';
                        styles['border-right-color'] = tableOptions.borderColor + ' !important';
                        styles['border-top-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-top-style'] = 'solid !important';
                        styles['border-top-color'] = tableOptions.borderColor + ' !important';
                        styles['border-bottom-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-bottom-style'] = 'solid !important';
                        styles['border-bottom-color'] = tableOptions.borderColor + ' !important';
                    }
                    else {
                        if (tableOptions['borderCell']) {
                            styles['border-bottom-width'] = tableOptions.borderWidth + 'px !important';
                            styles['border-bottom-style'] = 'solid !important';
                            styles['border-bottom-color'] = tableOptions.borderColor + ' !important';
                        }
                        styles['border-left-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-left-style'] = 'solid !important';
                        styles['border-left-color'] = tableOptions.borderColor + ' !important';
                        if (tableOptions['borderType'] === 'all') {
                            styles['border-right-width'] = tableOptions.borderWidth + 'px !important';
                            styles['border-right-style'] = 'solid !important';
                            styles['border-right-color'] = tableOptions.borderColor + ' !important';
                        }
                    }
                }
                return _this.toString(styles);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlockPreview.prototype, "tdStyles", {
        get: function () {
            var _this = this;
            return function (key) {
                var tableOptions = _this.pdfModel.tableOptions;
                var styles = {};
                if (tableOptions['applyCell' + key + 'Table']) {
                    if (tableOptions.tdTextColor) {
                        styles.color = tableOptions.tdTextColor;
                    }
                    if (tableOptions.tdBgColor) {
                        styles['background-color'] = tableOptions.tdBgColor;
                    }
                }
                if (tableOptions['applyPadding' + key + 'Table']) {
                    if (tableOptions.cellPaddingLeft) {
                        styles['padding-left'] = tableOptions.cellPaddingLeft + 'mm';
                    }
                    if (tableOptions.cellPaddingRight) {
                        styles['padding-right'] = tableOptions.cellPaddingRight + 'mm';
                    }
                    if (tableOptions.cellPaddingTop) {
                        styles['padding-top'] = tableOptions.cellPaddingTop + 'mm';
                    }
                    if (tableOptions.cellPaddingBottom) {
                        styles['padding-bottom'] = tableOptions.cellPaddingBottom + 'mm';
                    }
                }
                if (!tableOptions['applyBorderColor' + key + 'Table']) {
                    styles['border-left-width'] = '1px !important';
                    styles['border-left-style'] = 'solid !important';
                    styles['border-left-color'] = '#000000 !important';
                    styles['border-right-width'] = '1px !important';
                    styles['border-right-style'] = 'solid !important';
                    styles['border-right-color'] = '#000000 !important';
                    styles['border-top-width'] = '1px !important';
                    styles['border-top-style'] = 'solid !important';
                    styles['border-top-color'] = '#000000 !important';
                    styles['border-bottom-width'] = '1px !important';
                    styles['border-bottom-style'] = 'solid !important';
                    styles['border-bottom-color'] = '#000000 !important';
                }
                else {
                    if (!tableOptions['applyBorderType' + key + 'Table']) {
                        styles['border-left-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-left-style'] = 'solid !important';
                        styles['border-left-color'] = tableOptions.borderColor + ' !important';
                        styles['border-right-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-right-style'] = 'solid !important';
                        styles['border-right-color'] = tableOptions.borderColor + ' !important';
                        styles['border-top-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-top-style'] = 'solid !important';
                        styles['border-top-color'] = tableOptions.borderColor + ' !important';
                        styles['border-bottom-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-bottom-style'] = 'solid !important';
                        styles['border-bottom-color'] = tableOptions.borderColor + ' !important';
                    }
                    else {
                        if (tableOptions['borderCell']) {
                            styles['border-bottom-width'] = tableOptions.borderWidth + 'px !important';
                            styles['border-bottom-style'] = 'solid !important';
                            styles['border-bottom-color'] = tableOptions.borderColor + ' !important';
                        }
                        styles['border-right-width'] = tableOptions.borderWidth + 'px !important';
                        styles['border-right-style'] = 'solid !important';
                        styles['border-right-color'] = tableOptions.borderColor + ' !important';
                        if (tableOptions['borderType'] === 'all') {
                            styles['border-left-width'] = tableOptions.borderWidth + 'px !important';
                            styles['border-left-style'] = 'solid !important';
                            styles['border-left-color'] = tableOptions.borderColor + ' !important';
                        }
                    }
                }
                return _this.toString(styles);
            };
        },
        enumerable: false,
        configurable: true
    });
    PdfModelBlockPreview.prototype.toString = function (styles) {
        var css = '';
        forEach_default()(styles, function (value, key) {
            css += key + ': ' + value + ';';
        });
        return css;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelBlockPreview.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelBlockPreview.prototype, "pdfModel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelBlockPreview.prototype, "preview", void 0);
    PdfModelBlockPreview = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team'])), (0,external_vuex_.mapState)('customFields', ['customFields'])),
            components: {
                FroalaView: form_vue_.FroalaView
            }
        })
    ], PdfModelBlockPreview);
    return PdfModelBlockPreview;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var PdfModelBlockPreviewvue_type_script_lang_ts_external = (PdfModelBlockPreview);

;// ./src/components/PdfModelBlockPreview/PdfModelBlockPreview.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelBlockPreview_PdfModelBlockPreviewvue_type_script_lang_ts_external = (PdfModelBlockPreviewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfModelBlockPreview/PdfModelBlockPreview.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelBlockPreview_PdfModelBlockPreviewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelBlockPreview_PdfModelBlockPreview = (component.exports);

/***/ }),

/***/ 28057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 28077:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 28298:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ 28303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(56110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 28493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfViewer_PdfViewer; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfViewer/PdfViewer.vue?vue&type=template&id=ab6de9e0
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):(_vm.error)?_c('div',{staticClass:"text-center font-weight-bold text-danger p-4"},[_c('p',[_vm._v(" Erreur lors de la génération du PDF ")]),(!_vm.forceError)?_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.forcePdfGeneration.apply(null, arguments)}}},[_vm._v(" Forcer la génération du PDF ")]):_vm._e()],1):_c('Viewer',{ref:"viewer",attrs:{"width":"100%","src":_vm.pdfFile,"filename":_vm.filename}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfViewer/PdfViewer.ts?vue&type=script&lang=ts&external




var PdfViewer = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfViewer, _super);
    function PdfViewer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.file = null;
        _this.filename = null;
        _this.timeout = null;
        _this.timeoutLimit = 0;
        _this.error = false;
        _this.forceError = false;
        return _this;
    }
    PdfViewer.prototype.mounted = function () {
        interface_vue_.emitter.on('PdfGenerated', this.pdfGenerated);
    };
    PdfViewer.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('PdfGenerated', this.pdfGenerated);
        this.clearTimeout();
    };
    Object.defineProperty(PdfViewer.prototype, "url", {
        get: function () {
            return '/sales/' + this.type + '/' + this.id + '/pdf';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfViewer.prototype, "pdfFile", {
        get: function () {
            return 'data:application/pdf;base64,' + this.file;
        },
        enumerable: false,
        configurable: true
    });
    PdfViewer.prototype.pdfGenerated = function (datas) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(datas.type === this.type && datas.id === this.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadPdf()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.watchId = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.file = null;
                        this.loading = true;
                        this.error = false;
                        return [4 /*yield*/, this.processStatus(this.pdf_status)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.processStatus = function (status) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = status;
                        switch (_a) {
                            case 3: return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 2];
                    case 1:
                        this.loading = false;
                        this.error = true;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.loadPdf()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.loadPdf = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearTimeout();
                        return [4 /*yield*/, this.$kwSales.axios.get(this.url)
                                .then(function (response) {
                                var data = response.data;
                                if (data.status !== undefined) {
                                    if (data.status === 3) {
                                        _this.error = true;
                                    }
                                    else {
                                        _this.setTimeout();
                                    }
                                }
                                else {
                                    _this.file = data.file;
                                    _this.filename = data.filename;
                                    _this.loading = false;
                                    _this.$emit('pdfLoaded', data);
                                }
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.download = function () {
        var viewer = this.$refs.viewer;
        viewer.download();
    };
    PdfViewer.prototype.setTimeout = function () {
        this.clearTimeout();
        if (this.timeoutLimit > 10) {
            // this.loading = false
            // this.error = true
            return;
        }
        this.timeout = setTimeout(this.loadPdf, 1500);
        this.timeoutLimit++;
    };
    PdfViewer.prototype.clearTimeout = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    };
    PdfViewer.prototype.forcePdfGeneration = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.post('/sales/' + this.type + '/' + this.id + '/generate-pdf')
                                .then(function (response) {
                                var data = response.data;
                                _this.file = data.file;
                                _this.filename = data.filename;
                                _this.$emit('pdfLoaded', data);
                                _this.error = false;
                            })
                                .catch(function (error) {
                                _this.forceError = true;
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfViewer.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfViewer.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfViewer.prototype, "pdf_status", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('id', { immediate: true })
    ], PdfViewer.prototype, "watchId", null);
    PdfViewer = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Viewer: interface_vue_.PdfViewer,
                Spinner: interface_vue_.Spinner,
                BButton: external_bootstrap_vue_.BButton
            }
        })
    ], PdfViewer);
    return PdfViewer;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfViewervue_type_script_lang_ts_external = (PdfViewer);

;// ./src/components/PdfViewer/PdfViewer.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfViewer_PdfViewervue_type_script_lang_ts_external = (PdfViewervue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfViewer/PdfViewer.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfViewer_PdfViewervue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfViewer_PdfViewer = (component.exports);

/***/ }),

/***/ 28586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(56449),
    isSymbol = __webpack_require__(44394);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 28631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CheckDepositFormView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CheckDepositFormView.vue?vue&type=template&id=75ed0dac
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('Spinner'):_c('CheckDepositForm',{model:{value:(_vm.deposit),callback:function ($$v) {_vm.deposit=$$v},expression:"deposit"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CheckDepositForm/CheckDepositForm.vue?vue&type=template&id=2af21236
var CheckDepositFormvue_type_template_id_2af21236_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle}}),_c('AppMessages'),(_vm.loading)?_c('Spinner'):(!_vm.deposit.id && _vm.deposit.payments.length === 0)?_c('b-overlay',{attrs:{"show":_vm.filtering}},[_c('b-card',[_c('p',[_vm._v(" Afin de créer une remise de chèque, vous devez commencer par sélectionner les paiements à prélever."),_c('br'),_vm._v(" Vous pourrez retirer ou ajouter des paiements à l'étape suivante. ")]),_c('b-form-group',{attrs:{"label":"Date du paiement (Facultatif)"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-md-0",attrs:{"cols":"12","md":"auto"}},[_vm._v(" Du "),_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"max-date":_vm.filters.date_end},model:{value:(_vm.filters.date_begin),callback:function ($$v) {_vm.$set(_vm.filters, "date_begin", $$v)},expression:"filters.date_begin"}})],1),_c('b-col',{staticClass:"pl-md-1 mt-2 mt-md-0",attrs:{"cols":"12","md":"auto"}},[_vm._v(" au "),_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"min-date":_vm.filters.date_begin},model:{value:(_vm.filters.date_end),callback:function ($$v) {_vm.$set(_vm.filters, "date_end", $$v)},expression:"filters.date_end"}})],1)],1)],1),_c('b-button',{staticClass:"mt-2",attrs:{"variant":_vm.totalPayments > 0 ? 'secondary' : 'primary',"size":_vm.totalPayments > 0 ? 'sm' : null},on:{"click":function($event){$event.preventDefault();return _vm.loadPayments()}}},[_vm._v(" Rechercher les paiements ")]),(_vm.totalPayments !== null)?_c('div',{staticClass:"pt-4"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$tc('sales.checkDeposit.paymentSearchResult', _vm.totalPayments))+" ")]),(_vm.totalPayments > 0)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.nextStep.apply(null, arguments)}}},[_vm._v(" Continuer ")]):_vm._e()],1):_vm._e()],1)],1):_c('div',[_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c('b-card',{staticClass:"mb-4"},[_c('b-form-group',{attrs:{"label":"Compte bancaire"}},[_c('AccountSelect',{attrs:{"selectDefault":"","clearable":false},model:{value:(_vm.deposit.account),callback:function ($$v) {_vm.$set(_vm.deposit, "account", $$v)},expression:"deposit.account"}})],1),_c('b-form-group',{attrs:{"label":"Date de la remise de chèque"}},[_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"required":""},model:{value:(_vm.deposit.date),callback:function ($$v) {_vm.$set(_vm.deposit, "date", $$v)},expression:"deposit.date"}})],1)],1),_c('div',{staticClass:"catalog-search"},[_c('k-form-input',{staticClass:"mb-1",attrs:{"type":"search","placeholder":"Rechercher un paiement","readonly":_vm.searching},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_c('b-list-group',{ref:"list"},[(_vm.searching)?_c('b-list-group-item',{staticClass:"text-center"},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1):_vm._e(),(_vm.searchResults)?[(_vm.searchResults.length === 0)?_c('b-list-group-item',{staticClass:"text-center"},[_vm._v(" Aucun paiement ")]):_vm._e(),_vm._l((_vm.searchResults),function(payment,i){return _c('b-list-group-item',{key:i,on:{"click":function($event){return _vm.selectPayment(payment, i)}}},[_vm._v(" "+_vm._s(payment.customer.name)+" - "+_vm._s(_vm.date(payment.date))+" - "+_vm._s(_vm.formattedNumber(payment.amount, payment.currency))+" ")])})]:_vm._e()],2)],1),_c('b-table',{attrs:{"striped":_vm.totalPayments > 1,"bordered":"","fields":_vm.paymentsColumns,"items":_vm.deposit.payments,"per-page":_vm.perPage,"currentPage":_vm.currentPage,"small":"","table-class":"align-middle text-nowrap","responsive":"","show-empty":"","empty-text":"Aucun paiement"},scopedSlots:_vm._u([{key:"cell(documents)",fn:function({ value }){return [_vm._l((value),function(use,i){return [(i > 0)?_c('span',{key:'separator' + i},[_vm._v(", ")]):_vm._e(),_c('span',{key:i},[_vm._v(" "+_vm._s(use.document.reference)+" ")])]})]}},{key:"cell(check_bank)",fn:function({ item }){return [_c('k-form-input',{attrs:{"size":"sm"},model:{value:(item.check_bank),callback:function ($$v) {_vm.$set(item, "check_bank", $$v)},expression:"item.check_bank"}})]}},{key:"cell(check_issuer)",fn:function({ item }){return [_c('k-form-input',{attrs:{"size":"sm"},model:{value:(item.check_issuer),callback:function ($$v) {_vm.$set(item, "check_issuer", $$v)},expression:"item.check_issuer"}})]}},{key:"cell(amount)",fn:function({ value }){return [_vm._v(" "+_vm._s(_vm.formattedNumber(value))+" ")]}},{key:"cell(remove)",fn:function({ item }){return [_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: 'Retirer le paiement' }),expression:"{ title: 'Retirer le paiement' }"}],staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.removePayment(item)}}})]}}])}),(_vm.totalPayments > 0)?_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"cols":"auto"}},[_vm._v(" Total : "+_vm._s(_vm.$tc('sales.checkDeposit.totalPayment', _vm.totalPayments))+" ")]),_c('b-col',[_c('div',{staticClass:"text-center"},[_c('b-pagination',{attrs:{"perPage":_vm.perPage,"total-rows":_vm.totalPayments,"align":"center","size":"sm"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)]),_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered font-weight-bold",staticStyle:{"width":"300px"}},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Total :")]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.total)))])])])])])],1):_vm._e(),_c('k-form-sticky-bar',[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")]),_c('b-button',{staticClass:"ml-3",on:{"click":function($event){$event.preventDefault();return _vm.$router.back()}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")])],1)],1)],1)],1)
}
var CheckDepositFormvue_type_template_id_2af21236_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: ./src/components/AccountSelect/AccountSelect.vue + 3 modules
var AccountSelect = __webpack_require__(5182);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CheckDepositForm/CheckDepositForm.ts?vue&type=script&lang=ts&external









var CheckDepositForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CheckDepositForm, _super);
    function CheckDepositForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deposit = {
            payments: [],
            date: null
        };
        _this.loading = false;
        _this.filtering = false;
        _this.payments = [];
        _this.totalPayments = null;
        _this.currentPage = 1;
        _this.perPage = 20;
        _this.searchTerm = null;
        _this.searchTimeout = null;
        _this.searching = false;
        _this.searchResults = null;
        _this.filters = {
            date_begin: null,
            date_end: null,
        };
        _this.paymentsColumns = [
            { key: 'date', label: 'Date', formatter: _this.date, sortable: true },
            { key: 'customer.name', label: 'Client', sortable: true },
            { key: 'documents', label: 'Document(s)', sortable: true },
            { key: 'check_bank', label: 'Banque émettrice' },
            { key: 'check_issuer', label: 'Émetteur du chèque' },
            { key: 'amount', label: 'Montant', thStyle: 'width: 150px', tdClass: 'text-right' },
            { key: 'remove', label: '', thStyle: 'width: 40px', tdClass: 'text-center' }
        ];
        return _this;
    }
    Object.defineProperty(CheckDepositForm.prototype, "formAction", {
        get: function () {
            var url = '/sales/check-deposit';
            if (this.deposit.id) {
                url += '/' + this.deposit.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CheckDepositForm.prototype, "formDatas", {
        get: function () {
            var _a, _b;
            var val = this.deposit;
            return {
                account: (_b = (_a = val.account) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
                date: val.date,
                payments: val.payments.map(function (payment) { return ({
                    id: payment.id,
                    check_bank: payment.check_bank,
                    check_issuer: payment.check_issuer
                }); })
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CheckDepositForm.prototype, "formMethod", {
        get: function () {
            return this.deposit.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CheckDepositForm.prototype, "pageTitle", {
        get: function () {
            return (this.deposit.id ? 'Modification' : 'Création') + ' d\'une remise de chèque';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CheckDepositForm.prototype, "total", {
        get: function () {
            var _this = this;
            return sumBy_default()(this.deposit.payments, function (payment) { return _this.number(payment.amount); });
        },
        enumerable: false,
        configurable: true
    });
    CheckDepositForm.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.deposit = Object.assign({
                    payments: [],
                    date: external_moment_default()().format('YYYY-MM-DD')
                }, this.value ? JSON.parse(JSON.stringify(this.value)) : {});
                return [2 /*return*/];
            });
        });
    };
    CheckDepositForm.prototype.watchSearchTerm = function () {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        if (this.searchTerm) {
            this.searchTimeout = setTimeout(this.searchPayments, 500);
        }
        else {
            this.searchResults = null;
        }
    };
    CheckDepositForm.prototype.searchPayments = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.searching = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/payment', {
                                params: {
                                    filter: {
                                        exclude: this.deposit.payments.map(function (payment) { return payment.id; }),
                                        excludeCanceled: true,
                                        isCheck: true,
                                        usedInCheckDeposit: (_a = this.deposit.id) !== null && _a !== void 0 ? _a : false
                                    },
                                    search: encodeURIComponent('%' + this.searchTerm + '%'),
                                    per_page: 20,
                                    include: ['customer', 'currency', 'uses']
                                }
                            })
                                .then(function (response) {
                                _this.searchResults = response.data.data;
                            })
                                .finally(function () {
                                _this.searching = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckDepositForm.prototype.loadPayments = function (page) {
        var _a;
        if (page === void 0) { page = 1; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var filter;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.filtering = true;
                        if (page === 1) {
                            this.payments = [];
                        }
                        filter = {
                            excludeCanceled: true,
                            isCheck: true,
                            usedInCheckDeposit: (_a = this.deposit.id) !== null && _a !== void 0 ? _a : false
                        };
                        if (this.filters.date_begin)
                            filter.date_since = this.filters.date_begin;
                        if (this.filters.date_end)
                            filter.date_until = this.filters.date_end;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/payment', {
                                params: {
                                    filter: filter,
                                    per_page: 500,
                                    page: page,
                                    include: ['customer', 'currency', 'uses']
                                }
                            })
                                .then(function (response) {
                                var _a;
                                var datas = response.data;
                                var meta = datas.meta;
                                (_a = _this.payments).push.apply(_a, datas.data);
                                _this.totalPayments = meta.total;
                                if (meta.current_page < meta.last_page) {
                                    _this.loadPayments(page + 1);
                                }
                                else {
                                    _this.filtering = false;
                                }
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckDepositForm.prototype.nextStep = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.deposit.payments = this.payments.map(function (payment) { return payment; });
                this.payments = [];
                return [2 /*return*/];
            });
        });
    };
    CheckDepositForm.prototype.removePayment = function (item) {
        var index = this.deposit.payments.findIndex(function (payment) { return payment.id === item.id; });
        if (index !== -1) {
            this.deposit.payments.splice(index, 1);
            if (this.totalPayments) {
                this.totalPayments--;
            }
        }
    };
    CheckDepositForm.prototype.selectPayment = function (payment, index) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                (_a = this.searchResults) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
                this.deposit.payments.unshift(payment);
                if (this.totalPayments) {
                    this.totalPayments++;
                }
                return [2 /*return*/];
            });
        });
    };
    CheckDepositForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({
                            name: 'check-deposit-item',
                            params: {
                                id: String(response.data.id)
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CheckDepositForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CheckDepositForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('searchTerm')
    ], CheckDepositForm.prototype, "watchSearchTerm", null);
    CheckDepositForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect, KFormStickyBar: form_vue_.KFormStickyBar, KFormInput: form_vue_.KFormInput,
                BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BOverlay: external_bootstrap_vue_.BOverlay, BTable: external_bootstrap_vue_.BTable, BInputGroup: external_bootstrap_vue_.BInputGroup, BPagination: external_bootstrap_vue_.BPagination, BListGroup: external_bootstrap_vue_.BListGroup, BListGroupItem: external_bootstrap_vue_.BListGroupItem,
                Spinner: interface_vue_.Spinner, PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                AccountSelect: AccountSelect/* default */.A
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CheckDepositForm);
    return CheckDepositForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var CheckDepositFormvue_type_script_lang_ts_external = (CheckDepositForm);

;// ./src/components/CheckDepositForm/CheckDepositForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CheckDepositForm_CheckDepositFormvue_type_script_lang_ts_external = (CheckDepositFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CheckDepositForm/CheckDepositForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CheckDepositForm_CheckDepositFormvue_type_script_lang_ts_external,
  CheckDepositFormvue_type_template_id_2af21236_render,
  CheckDepositFormvue_type_template_id_2af21236_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CheckDepositForm_CheckDepositForm = (component.exports);
// EXTERNAL MODULE: ./src/mixins/CheckDepositMixin.ts
var CheckDepositMixin = __webpack_require__(18964);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CheckDepositFormView.vue?vue&type=script&lang=ts




var CheckDepositFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CheckDepositFormView, _super);
    function CheckDepositFormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckDepositFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CheckDepositForm: CheckDepositForm_CheckDepositForm
            }
        })
    ], CheckDepositFormView);
    return CheckDepositFormView;
}((0,lib/* Mixins */.Xe)(CheckDepositMixin/* default */.A)));
/* harmony default export */ var CheckDepositFormViewvue_type_script_lang_ts = (CheckDepositFormView);

;// ./src/views/CheckDepositFormView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CheckDepositFormViewvue_type_script_lang_ts = (CheckDepositFormViewvue_type_script_lang_ts); 
;// ./src/views/CheckDepositFormView.vue





/* normalize component */
;
var CheckDepositFormView_component = (0,componentNormalizer/* default */.A)(
  views_CheckDepositFormViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CheckDepositFormView = (CheckDepositFormView_component.exports);

/***/ }),

/***/ 28754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(25160);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 28861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ 28879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(74335);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 28959:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ 29231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ 29407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerAddressSelect_CustomerAddressSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerAddressSelect/CustomerAddressSelect.vue?vue&type=template&id=667984ec
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.customer?.addresses.length > 1)?_c('b-dropdown',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: 'Sélectionner une adresse' }),expression:"{ title: 'Sélectionner une adresse' }"}],staticClass:"address-selector",attrs:{"menu-class":"address-selector-dropdown","right":""},on:{"hidden":function($event){_vm.searchTerm = null}}},[(_vm.customer?.addresses.length > 5)?_c('b-dropdown-form',{attrs:{"form-class":"px-2"}},[_c('k-form-input',{attrs:{"placeholder":"Rechercher une adresse","size":"sm"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1):_vm._e(),_vm._l((_vm.addresses),function(address,i){return _c('b-dropdown-item',{key:i,staticClass:"small",on:{"click":function($event){return _vm.$emit('selected', address)}}},[(address.label)?_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(" "+_vm._s(address.label)+" ")]):_vm._e(),(address.road1)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.road1)+" ")]):_vm._e(),(address.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.road2)+" ")]):_vm._e(),(address.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.road3)+" ")]):_vm._e(),(address.postal_code || address.town)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.postal_code)+" "+_vm._s(address.town)+" ")]):_vm._e(),(address.country)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.country.name)+" ")]):_vm._e(),(address.use_for_invoice)?_c('p',{staticClass:"text-danger mb-0"},[_vm._v(" Adresse de facturation par défaut ")]):_vm._e(),(address.use_for_delivery)?_c('p',{staticClass:"text-danger mb-0"},[_vm._v(" Adresse de livraison par défaut ")]):_vm._e()])})],2):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerAddressSelect/CustomerAddressSelect.ts?vue&type=script&lang=ts&external





var CustomerAddressSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerAddressSelect, _super);
    function CustomerAddressSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchTerm = null;
        return _this;
    }
    Object.defineProperty(CustomerAddressSelect.prototype, "addresses", {
        get: function () {
            var _a, _b;
            var addresses = (_b = (_a = this.customer) === null || _a === void 0 ? void 0 : _a.addresses) !== null && _b !== void 0 ? _b : [];
            if (this.searchTerm) {
                var search_1 = this.searchTerm.toLowerCase();
                return addresses.filter(function (address) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return (address.label && ((_a = address.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(search_1)) !== -1)
                        || (address.road1 && ((_b = address.road1) === null || _b === void 0 ? void 0 : _b.toLowerCase().indexOf(search_1)) !== -1)
                        || (address.road2 && ((_c = address.road2) === null || _c === void 0 ? void 0 : _c.toLowerCase().indexOf(search_1)) !== -1)
                        || (address.road3 && ((_d = address.road3) === null || _d === void 0 ? void 0 : _d.toLowerCase().indexOf(search_1)) !== -1)
                        || (address.postal_code && ((_e = address.postal_code) === null || _e === void 0 ? void 0 : _e.toLowerCase().indexOf(search_1)) !== -1)
                        || (address.town && ((_f = address.town) === null || _f === void 0 ? void 0 : _f.toLowerCase().indexOf(search_1)) !== -1)
                        || (address.country && ((_h = (_g = address.country) === null || _g === void 0 ? void 0 : _g.name) === null || _h === void 0 ? void 0 : _h.toLowerCase().indexOf(search_1)) !== -1);
                });
            }
            return addresses;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerAddressSelect.prototype, "customer", void 0);
    CustomerAddressSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItem: external_bootstrap_vue_.BDropdownItem, BDropdownForm: external_bootstrap_vue_.BDropdownForm,
                KFormInput: form_vue_.KFormInput
            }
        })
    ], CustomerAddressSelect);
    return CustomerAddressSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerAddressSelectvue_type_script_lang_ts_external = (CustomerAddressSelect);

;// ./src/components/CustomerAddressSelect/CustomerAddressSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerAddressSelect_CustomerAddressSelectvue_type_script_lang_ts_external = (CustomerAddressSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CustomerAddressSelect/CustomerAddressSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerAddressSelect_CustomerAddressSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerAddressSelect_CustomerAddressSelect = (component.exports);

/***/ }),

/***/ 29783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SignList_SignList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SignList/SignList.vue?vue&type=template&id=42afd3f2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('SignSend',{staticClass:"mb-4",attrs:{"label":"Faire signer des documents","variant":"primary","size":"sm"}}),_c('k-table',{ref:"table",attrs:{"url":"/signature","ajaxDatas":{ include: ['teamUser']},"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowClick":_vm.rowClick,"stateKey":"signatories-list","onlyTopFilters":""}}),(_vm.showSignature)?_c('SignItem',{on:{"hidden":function($event){_vm.showSignature = null}},model:{value:(_vm.showSignature),callback:function ($$v) {_vm.showSignature=$$v},expression:"showSignature"}}):_vm._e(),(_vm.editSignature)?_c('SignSend',{attrs:{"element":"modal","modal":_vm.editSignature !== null},on:{"hidden":function($event){_vm.editSignature = null}},model:{value:(_vm.editSignature),callback:function ($$v) {_vm.editSignature=$$v},expression:"editSignature"}}):_vm._e(),(_vm.deleteSignature)?_c('SignDelete',{attrs:{"modal":_vm.deleteSignature !== null},on:{"closed":function($event){_vm.deleteSignature = null},"deleted":_vm.signatureDeleted},model:{value:(_vm.deleteSignature),callback:function ($$v) {_vm.deleteSignature=$$v},expression:"deleteSignature"}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: ./src/components/SignItem/SignItem.vue + 3 modules
var SignItem = __webpack_require__(19966);
// EXTERNAL MODULE: ./src/components/SignSend/SignSend.vue + 4 modules
var SignSend = __webpack_require__(30210);
// EXTERNAL MODULE: ./src/components/SignDelete/SignDelete.vue + 3 modules
var SignDelete = __webpack_require__(79088);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SignList/SignList.ts?vue&type=script&lang=ts&external







var SignList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignList, _super);
    function SignList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showSignature = null;
        _this.editSignature = null;
        _this.deleteSignature = null;
        return _this;
    }
    SignList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                if (this.$route.query.signatureId) {
                    this.showSignature = null;
                    this.$nextTick(function () {
                        _this.showSignature = { id: Number(_this.$route.query.signatureId) };
                        _this.$router.replace({ query: {} });
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(SignList.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    data: 'subject',
                    name: 'Sujet'
                },
                {
                    data: 'send_at',
                    name: 'Date d\'envoi',
                    render: 'datetime'
                },
                {
                    data: 'expire_at',
                    name: 'Date d\'expiration',
                    render: 'datetime'
                },
                {
                    data: 'signed_at',
                    name: 'Date de signature',
                    render: 'datetime'
                },
                {
                    data: 'team_user.fullname',
                    name: 'Utilisateur'
                },
                {
                    data: 'status',
                    name: 'Statut',
                    render: function (val) { return _this.$t('sales.signature.status.' + val); }
                },
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'updated_at',
                    name: 'Dernière modification',
                    render: 'datetime',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'delete',
                    condition: function (sign) { return sign.status === 1; },
                    click: function (sign) {
                        _this.deleteSignature = sign;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    SignList.prototype.rowClick = function (signature) {
        if (signature.status === 1) {
            this.editSignature = signature;
        }
        else {
            this.showSignature = signature;
        }
    };
    Object.defineProperty(SignList.prototype, "filters", {
        get: function () {
            return [
                {
                    name: 'status',
                    label: 'Statut',
                    type: 'select',
                    multiple: true,
                    options: [
                        { label: 'Brouillon', value: 1 },
                        /*{ label: 'En attente d\'envoi', value: 2 },*/
                        { label: 'Envoyée', value: 3 },
                        /*{ label: 'Signée partiellement', value: 4 },*/
                        { label: 'Signée', value: 5 }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    SignList.prototype.signatureDeleted = function (signature) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === signature.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    SignList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                SignDelete: SignDelete/* default */.A,
                SignSend: SignSend/* default */.A,
                SignItem: SignItem/* default */.A,
                BButton: external_bootstrap_vue_.BButton
            }
        })
    ], SignList);
    return SignList;
}(lib/* Vue */.lD));
/* harmony default export */ var SignListvue_type_script_lang_ts_external = (SignList);

;// ./src/components/SignList/SignList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SignList_SignListvue_type_script_lang_ts_external = (SignListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SignList/SignList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SignList_SignListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignList_SignList = (component.exports);

/***/ }),

/***/ 29817:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 29849:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ 30104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentDelete_DocumentDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentDelete/DocumentDelete.vue?vue&type=template&id=75c90fee
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
    title: _vm.cantDeleteTitle,
    placement: this.element === 'button' ? 'top' : 'right'
  }),expression:"{\n    title: cantDeleteTitle,\n    placement: this.element === 'button' ? 'top' : 'right'\n  }"}]},[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce document ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentDelete/DocumentDelete.ts?vue&type=script&lang=ts&external




var DocumentDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentDelete, _super);
    function DocumentDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(DocumentDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelete.prototype, "cantDeleteTitle", {
        get: function () {
            return this.value && !this.value.is_draft ? 'Vous ne pouvez pas supprimer un document qui a été validé' : null;
        },
        enumerable: false,
        configurable: true
    });
    DocumentDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    DocumentDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    DocumentDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/sales/' + this.type + '/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    DocumentDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    DocumentDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    DocumentDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentDelete.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], DocumentDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], DocumentDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DocumentDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DocumentDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], DocumentDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], DocumentDelete.prototype, "watchModalState", null);
    DocumentDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], DocumentDelete);
    return DocumentDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var DocumentDeletevue_type_script_lang_ts_external = (DocumentDelete);

;// ./src/components/DocumentDelete/DocumentDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentDelete_DocumentDeletevue_type_script_lang_ts_external = (DocumentDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/DocumentDelete/DocumentDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentDelete_DocumentDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentDelete_DocumentDelete = (component.exports);

/***/ }),

/***/ 30189:
/***/ (function(module) {

"use strict";
module.exports = require("froala-editor");

/***/ }),

/***/ 30210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SignSend_SignSend; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SignSend/SignSend.vue?vue&type=template&id=3babc5df
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",modifiers:{"right":true}}],tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size,"title":_vm.disabledTitle},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('FormModal',{attrs:{"title":_vm.signature.is_direct_sign ? null : _vm.title,"ok-title":!_vm.isSignable || (!_vm.isFreeSignatures && _vm.team.subscription.electronic_sign_counter === 0) ? _vm.$t('interface.close') : 'Envoyer',"ok-only":!_vm.isSignable || (!_vm.isFreeSignatures && _vm.team.subscription.electronic_sign_counter === 0),"size":_vm.signature.is_direct_sign ? 'md' : 'lg',"closeOnSubmit":false,"body-class":"signature-form"},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(!_vm.isSignable && !_vm.isEmptyDocument)?[(_vm.baseDocument?.document_type === 'construction' || _vm.baseDocument?.document_type === 'planification')?_c('div',{staticClass:"text-center"},[_vm._v(" Votre fiche d'intervention ne contient pas la variable pour la signature. ")]):(_vm.baseDocument?.document_type === 'contract')?_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Votre modèle de contrat ne contient pas la variable pour la signature. ")]),_c('p',[_vm._v(" Vous devez modifier celui-ci puis regénérer votre contrat. ")]),_c('p',[_c('b-button',{attrs:{"variant":"primary","to":{ name: 'contract-models-form', params: { id: String(_vm.baseDocument.document?.model_id) } }}},[_vm._v(" Modifier mon modèle de contrat ")])],1)]):(_vm.baseDocument?.document_type === 'customerSepa')?_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Votre modèle de mandat SEPA ne contient pas la variable pour la signature. ")]),_c('p',[_vm._v(" Vous devez modifier celui-ci puis regénérer votre mandat SEPA. ")]),_c('p',[_c('b-button',{attrs:{"variant":"primary","to":{ name: 'sepa-params' }}},[_vm._v(" Modifier mon modèle ")])],1)]):[_c('p',{staticClass:"text-center font-weight-bold"},[_vm._v(" Votre modèle PDF ne contient pas de champ pour la signature. ")]),(_vm.baseDocument?.document?.pdf_model)?_c('SignPdfModel',{attrs:{"type":_vm.baseDocument?.document_type,"id":_vm.baseDocument?.document_id,"pdfModelId":_vm.baseDocument?.document.pdf_model.id},on:{"success":_vm.pdfModelUpdated}}):_vm._e()]]:(!_vm.isFreeSignatures && _vm.team.subscription.electronic_sign_counter === 0)?_c('div',{staticClass:"text-center"},[_c('p',[_vm._v(" Votre solde de signature electronique est épuisé. ")]),_c('BuySign',{attrs:{"label":"Acheter des signatures électronique","variant":"primary"}})],1):_c('k-form',{attrs:{"value":_vm.formDatas,"action":_vm.formAction + '/send',"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete,"submitError":_vm.submitError}},[(!_vm.testMode && !_vm.isFreeSignatures)?_c('div',{class:{
          'signature-counter': _vm.withDirectSign === false,
          'text-danger font-weight-bold mb-4': _vm.withDirectSign !== false
        }},[_vm._v(" Signatures restantes : "+_vm._s(_vm.team.subscription.electronic_sign_counter)+" ")]):_vm._e(),(_vm.testMode)?_c('b-alert',{staticClass:"font-weight-bold text-center",attrs:{"show":"","variant":"danger"}},[_vm._v(" En mode démonstration, les signatures électronique n'ont aucune valeur juridique. ")]):_vm._e(),(_vm.error)?_c('b-alert',{attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e(),(!_vm.isEmptyDocument)?_c('b-form-radio-group',{staticClass:"mb-4",attrs:{"name":"is_direct_sign"},model:{value:(_vm.signature.is_direct_sign),callback:function ($$v) {_vm.$set(_vm.signature, "is_direct_sign", $$v)},expression:"signature.is_direct_sign"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" Envoyer un lien de signature par email ")]),_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" Faire signer en direct ")])],1):_vm._e(),_c('h3',{staticClass:"form-title-alt mt-0 pt-1 mb-1"},[_vm._v(" Signataire ")]),(_vm.signature.is_direct_sign)?_vm._l((_vm.signature.signatories),function(signatory,i){return _c('div',{key:i},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Prénom"}},[_c('k-form-input',{attrs:{"validationName":'signatories[' + i + '][firstname]',"required":""},model:{value:(signatory.firstname),callback:function ($$v) {_vm.$set(signatory, "firstname", $$v)},expression:"signatory.firstname"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Nom"}},[_c('k-form-input',{attrs:{"validationName":'signatories[' + i + '][lastname]',"required":""},model:{value:(signatory.lastname),callback:function ($$v) {_vm.$set(signatory, "lastname", $$v)},expression:"signatory.lastname"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Email"}},[_c('k-form-input',{attrs:{"type":"email","validationName":'signatories[' + i + '][email]',"required":""},model:{value:(signatory.email),callback:function ($$v) {_vm.$set(signatory, "email", $$v)},expression:"signatory.email"}})],1),_c('b-form-group',{attrs:{"label":"Portable"}},[_c('k-form-phone',{attrs:{"validationName":'signatories[' + i + '][mobile]',"required":_vm.signature.is_direct_sign},model:{value:(signatory.mobile),callback:function ($$v) {_vm.$set(signatory, "mobile", $$v)},expression:"signatory.mobile"}})],1)],1)}):_vm._e(),(!_vm.signature.is_direct_sign)?[_c('b-row',{staticClass:"d-none"},[_c('b-col',[_c('k-form-input',{attrs:{"type":"search","placeholder":"Rechercher un signataire","size":"sm"}})],1),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addSignatory.apply(null, arguments)}}},[_vm._v(" Nouveau signataire ")])],1)],1),_c('table',{staticClass:"table table-sm mt-3 align-middle"},[_c('thead',{staticClass:"small"},[_c('tr',[_c('th',{staticClass:"py-0"},[_vm._v("Prénom")]),_c('th',{staticClass:"py-0"},[_vm._v("Nom")]),_c('th',{staticClass:"py-0"},[_vm._v("Email")]),_c('th',{staticClass:"py-0"},[_vm._v("Portable")]),_c('th',{staticClass:"py-0"})])]),_c('tbody',_vm._l((_vm.signature.signatories),function(signatory,i){return _c('tr',{key:i},[_c('td',[_c('k-form-input',{attrs:{"validationName":'signatories[' + i + '][firstname]',"size":"sm","required":""},model:{value:(signatory.firstname),callback:function ($$v) {_vm.$set(signatory, "firstname", $$v)},expression:"signatory.firstname"}})],1),_c('td',[_c('k-form-input',{attrs:{"validationName":'signatories[' + i + '][lastname]',"size":"sm","required":""},model:{value:(signatory.lastname),callback:function ($$v) {_vm.$set(signatory, "lastname", $$v)},expression:"signatory.lastname"}})],1),_c('td',[_c('k-form-input',{attrs:{"validationName":'signatories[' + i + '][email]',"type":"email","size":"sm","required":""},model:{value:(signatory.email),callback:function ($$v) {_vm.$set(signatory, "email", $$v)},expression:"signatory.email"}})],1),_c('td',[_c('k-form-phone',{attrs:{"validationName":'signatories[' + i + '][mobile]',"size":"sm"},model:{value:(signatory.mobile),callback:function ($$v) {_vm.$set(signatory, "mobile", $$v)},expression:"signatory.mobile"}})],1),_c('td',[(_vm.signature.signatories.length > 1)?_c('b-button',{staticClass:"p-0 text-danger",attrs:{"variant":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.signature.signatories.splice(i, 1)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1):_vm._e()],1)])}),0)])]:_vm._e(),(!_vm.signature.is_direct_sign)?[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Message ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Sujet"}},[_c('k-form-input',{attrs:{"name":"subject"},model:{value:(_vm.signature.subject),callback:function ($$v) {_vm.$set(_vm.signature, "subject", $$v)},expression:"signature.subject"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticStyle:{"width":"150px"},attrs:{"label":"Charger un modèle","label-class":"small"}},[_c('k-form-select',{attrs:{"label":"name","options":_vm.models,"clearable":false},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Message"},scopedSlots:_vm._u([{key:"description",fn:function(){return [(!_vm.hasSignatureLink)?_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addSignatureLink.apply(null, arguments)}}},[_vm._v(" Ajouter la variable pour le lien vers la signature ")]):_vm._e()]},proxy:true}],null,false,312815680)},[_c('k-form-editor',{ref:"editor",attrs:{"name":"message","size":"sm","config":{ dynamicVariablesEdition: false },"validate":"signatureLink"},model:{value:(_vm.signature.message),callback:function ($$v) {_vm.$set(_vm.signature, "message", $$v)},expression:"signature.message"}})],1)]:_vm._e(),(_vm.signature.is_direct_sign === false)?[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Documents ")]),_c('div',{staticClass:"position-relative"},[_c('b-row',[_c('b-col',{staticClass:"pr-0"},[_c('k-form-input',{attrs:{"type":"search","size":"sm","placeholder":"Rechercher un document..."},model:{value:(_vm.searchDocumentTerm),callback:function ($$v) {_vm.searchDocumentTerm=$$v},expression:"searchDocumentTerm"}})],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.addFileModal = true}}},[_vm._v(" Télécharger un fichier ")])],1)],1),(_vm.searchDocumentTerm)?_c('b-list-group',{staticClass:"sign-documents-search-results"},[(_vm.searchDocumentLoading)?_c('b-list-group-item',{staticClass:"text-center loading"},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1):(_vm.searchDocumentResults)?[(_vm.searchDocumentResults.length === 0)?_c('b-list-group-item',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('catalog.catalogSearch.noResults'))+" ")]):_vm._e(),_vm._l((_vm.searchDocumentResults),function(result,i){return _c('b-list-group-item',{key:i,on:{"click":function($event){$event.preventDefault();return _vm.addDocuments(result)}}},[_c('div',{staticClass:"type text-muted"},[_vm._v(" "+_vm._s(_vm.$t('sales.signature.documentTypes.' + result.type, { reference: result.title }))+" "),(result.data.date)?_c('span',[_vm._v(" - "+_vm._s(_vm.date(result.data.date))+" ")]):_vm._e()]),(result.data.title)?_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(result.data.title)+" ")]):_vm._e()])})]:_vm._e()],2):_vm._e()],1),_c('table',{staticClass:"table table-sm align-middle sales-sign-documents mt-1 table-bordered"},[_c('tbody',_vm._l((_vm.signature.documents),function(doc,i){return _c('tr',{key:i},[(doc.file)?_c('td',{staticClass:"icon border-right-0",style:({ color: _vm.fileIconColor(doc.file.extension) })},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.fileIcon(doc.file.extension)]}})],1):_vm._e(),_c('td',{staticClass:"border-left-0 border-right-0"},[_vm._v(" "+_vm._s(doc.file?.filename)+" ")]),_c('td',[_c('k-form-checkbox',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: doc.signable_document ? null : 'Pour qu\'un document soit signable, il doit comporter la variable {{s1|signature|162|78}}' }),expression:"{ title: doc.signable_document ? null : 'Pour qu\\'un document soit signable, il doit comporter la variable {{s1|signature|162|78}}' }",modifiers:{"left":true}}],attrs:{"disabled":""},model:{value:(doc.signable_document),callback:function ($$v) {_vm.$set(doc, "signable_document", $$v)},expression:"doc.signable_document"}},[_vm._v(" À signer ")])],1),_c('td',{staticClass:"actions border-left-0"},[(!_vm.baseDocument || (doc.document_type !== _vm.baseDocument?.document_type && doc.document_id !== _vm.baseDocument?.document_id))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 text-danger ml-2",attrs:{"variant":"icon","title":_vm.$t('interface.delete')},on:{"click":function($event){$event.preventDefault();_vm.fileToDelete = i}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1):_vm._e()],1)])}),0)])]:_vm._e()],2),(_vm.withDirectSign === false)?_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.close'),"ok-only":"","busy":_vm.loadingFile,"no-close-on-backdrop":_vm.loadingFile,"no-close-on-esc":_vm.loadingFile,"hide-header-close":_vm.loadingFile},on:{"ok":_vm.uploadFile,"hidden":function($event){_vm.fileError = null}},model:{value:(_vm.addFileModal),callback:function ($$v) {_vm.addFileModal=$$v},expression:"addFileModal"}},[(_vm.fileError)?_c('b-alert',{staticClass:"font-weight-bold",attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.fileError)+" ")]):[_c('b-overlay',{attrs:{"show":_vm.loadingFile}},[_c('p',{staticClass:"text-center"},[(_vm.signature.documents.length > 0)?[_vm._v(" Vous pouvez télécharger des documents PDF complémentaires qui seront ajoutés à la demande de signature. ")]:_vm._e()],2),_c('p',{staticClass:"text-center"},[_c('k-form-file',{ref:"file",attrs:{"btnMode":"","name":'add_documents[' + (_vm.formDatas.add_documents?.length ?? 0) + '][file]',"accept":['application/pdf'],"url":_vm.formAction,"method":_vm.formMethod,"datas":_vm.formDatas},on:{"onUpload":_vm.documentAdded,"onError":_vm.uploadFailed}})],1),_c('b-alert',{staticClass:"mt-3",attrs:{"show":"","variant":"warning"}},[_c('p',{staticClass:"text-justify mb-2"},[_vm._v(" Si vous souhaitez que le document puisse être signé, celui-ci doit posséder la variable suivante qui sera automatiquement remplacée par la signature :"),_c('br')]),_c('p',{staticClass:"text-center mb-0"},[_c('span',{staticClass:"font-weight-bold",domProps:{"innerHTML":_vm._s('&#123;&#123;s1|signature|162|78&#125;&#125;')}})])])],1)]],2):_vm._e(),(_vm.withDirectSign === false)?_c('b-modal',{attrs:{"visible":_vm.fileToDelete !== null,"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loadingFile,"no-close-on-backdrop":_vm.loadingFile,"no-close-on-esc":_vm.loadingFile,"hide-header-close":_vm.loadingFile},on:{"ok":_vm.deleteFile,"hidden":function($event){_vm.fileToDelete = null}}},[(_vm.loadingFile)?_c('Spinner'):[_vm._v(" Êtes-vous sûr de vouloir supprimer ce fichier ? ")]],2):_vm._e()],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// external "@kwixeo/subscriptions-vue"
var subscriptions_vue_namespaceObject = require("@kwixeo/subscriptions-vue");
// EXTERNAL MODULE: ./src/fetchDatas/signature.ts
var signature = __webpack_require__(9738);
// EXTERNAL MODULE: ./src/components/StripeSend/VariablesMixin.ts
var VariablesMixin = __webpack_require__(2787);
// EXTERNAL MODULE: ./src/components/SignPdfModel/SignPdfModel.vue + 3 modules
var SignPdfModel = __webpack_require__(49292);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SignSend/SignSend.ts?vue&type=script&lang=ts&external











var SignSend = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignSend, _super);
    function SignSend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.error = null;
        _this.loading = true;
        _this.model = null;
        _this.isFreeSignatures = "1" == 1;
        // Document upload
        _this.addFileModal = false;
        _this.fileToDelete = null;
        _this.loadingFile = false;
        _this.fileError = null;
        // Search documents
        _this.searchDocumentTerm = null;
        _this.searchDocumentTimeout = null;
        _this.searchDocumentLoading = false;
        _this.searchDocumentResults = [];
        // Signature
        _this.signature = {
            is_direct_sign: _this.withDirectSign !== false,
            subject: null,
            message: null,
            signatories: [],
            documents: []
        };
        return _this;
    }
    Object.defineProperty(SignSend.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignSend.prototype, "title", {
        get: function () {
            return 'Envoi de document pour signature';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignSend.prototype, "formAction", {
        get: function () {
            var url = '/signature';
            if (this.signature.id) {
                url += '/' + this.signature.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignSend.prototype, "formMethod", {
        get: function () {
            return this.signature.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignSend.prototype, "formDatas", {
        get: function () {
            var _a;
            var datas = {
                is_direct_sign: this.signature.is_direct_sign,
                sender: (_a = this.defaultSender) === null || _a === void 0 ? void 0 : _a.id,
                subject: this.signature.subject,
                message: this.signature.message,
                signatories: this.signature.signatories.filter(function (signatory) { return signatory.firstname && signatory.lastname; }).map(function (signatory) {
                    var data = {
                        firstname: signatory.firstname,
                        lastname: signatory.lastname,
                        email: signatory.email,
                        mobile: signatory.mobile,
                    };
                    if (signatory.element_type) {
                        data.element = {
                            type: signatory.element_type,
                            id: signatory.element_id
                        };
                    }
                    return data;
                })
            };
            if (!this.signature.id && this.signature.documents.length > 0) {
                datas.add_documents = this.signature.documents.map(function (document) { return ({
                    document: {
                        id: document.document_id,
                        type: document.document_type
                    }
                }); });
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignSend.prototype, "hasSignatureLink", {
        // If the message has the signature link
        get: function () {
            var message = this.signature.message;
            return message !== null && message.includes('data-variable="SIGN-LINK"');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignSend.prototype, "baseDocument", {
        // Get initial document
        get: function () {
            var _a, _b;
            var document = (_a = this.signature.documents.find(function (document) { return document.document_type !== null && document.document_type !== undefined; })) !== null && _a !== void 0 ? _a : null;
            if (document) {
                return document;
            }
            return (_b = this.signature.documents.find(function (document) { return document.signable_document; })) !== null && _b !== void 0 ? _b : null;
        },
        enumerable: false,
        configurable: true
    });
    SignSend.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    SignSend.prototype.watchModalState = function (state) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!state) return [3 /*break*/, 3];
                        this.loading = true;
                        return [4 /*yield*/, this.loadModels()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadSenders()];
                    case 2:
                        _a.sent();
                        this.watchValue(this.value);
                        this.loading = false;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SignSend.prototype.watchValue = function (value) {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var baseDocument, document, model, subject, message;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(value === null || value === void 0 ? void 0 : value.id)) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, (0,signature/* fetchSignature */.FH)(value.id)];
                    case 1:
                        value = _c.sent();
                        this.loading = false;
                        _c.label = 2;
                    case 2:
                        this.signature = Object.assign({
                            is_direct_sign: this.withDirectSign !== false,
                            subject: null,
                            message: null,
                            signatories: [],
                            documents: []
                        }, value);
                        if (!(value === null || value === void 0 ? void 0 : value.id)) {
                            baseDocument = this.baseDocument;
                            if ((baseDocument === null || baseDocument === void 0 ? void 0 : baseDocument.document_type) && ['quotation', 'command', 'contract', 'construction', 'planification'].includes(baseDocument.document_type)) {
                                document = baseDocument === null || baseDocument === void 0 ? void 0 : baseDocument.document;
                                if (baseDocument.document_type === 'planification' && 'construction' in document && document.construction) {
                                    document = document.construction;
                                }
                                if (document && document.contact) {
                                    this.addSignatory({
                                        type: 'contact',
                                        id: document.contact.id,
                                        element: document.contact
                                    });
                                }
                                else if (document && ((_b = (_a = document.customer) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.is_person)) {
                                    this.addSignatory({
                                        type: 'customer',
                                        id: document.customer.id,
                                        element: document.customer
                                    });
                                }
                            }
                            model = void 0;
                            switch (baseDocument === null || baseDocument === void 0 ? void 0 : baseDocument.document_type) {
                                case 'quotation':
                                    model = this.teamConfigs.sign_model_quotation;
                                    break;
                                case 'command':
                                    model = this.teamConfigs.sign_model_command;
                                    break;
                                case 'customerSepa':
                                    model = this.teamConfigs.sign_model_sepa;
                                    break;
                                case 'contract':
                                    model = this.teamConfigs.sign_model_contract;
                                    break;
                                case 'construction':
                                case 'planification':
                                    model = this.teamConfigs.sign_model_construction;
                                    break;
                                default:
                                    model = null;
                            }
                            subject = void 0;
                            message = void 0;
                            if (model) {
                                subject = model.subject;
                                message = model.html;
                            }
                            else {
                                subject = 'Votre proposition commerciale&nbsp;<variable data-variable="DOC-NUM" contenteditable="true" class="fr-dynamic-variable">DOC-NUM</variable>';
                                message = 'Bonjour<variable data-prefix=" " data-variable="CONTACT-FULLNAME" data-conditional-show="true" contenteditable="true" class="fr-dynamic-variable">&nbsp;CONTACT-FULLNAME</variable>,<br><br>Le document&nbsp;<variable data-variable="DOC-NUM" contenteditable="true" class="fr-dynamic-variable">DOC-NUM</variable> est disponible pour signature &eacute;lectronique.<br><br>Vous pouvez y acc&eacute;der en cliquant sur le lien suivant :<br><variable data-variable="SIGN-LINK" contenteditable="true" class="fr-dynamic-variable">SIGN-LINK</variable>';
                            }
                            this.applyMessage(message, subject);
                        }
                        if (this.signature.signatories.length === 0) {
                            this.addSignatory();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SignSend.prototype.watchModel = function () {
        var _this = this;
        if (!this.model) {
            return;
        }
        this.applyMessage(this.model.html, this.model.subject);
        this.$nextTick(function () {
            _this.model = null;
        });
    };
    SignSend.prototype.applyMessage = function (message, subject) {
        var _a, _b, _c;
        var elements = [];
        var document = this.baseDocument;
        if (document) {
            var doc = document.document;
            elements.push.apply(elements, [
                {
                    id: (_a = doc.customer) === null || _a === void 0 ? void 0 : _a.id,
                    type: 'customer',
                    title: '',
                    data: doc.customer
                },
                {
                    id: document.document_id,
                    type: document.document_type,
                    title: '',
                    data: doc
                }
            ]);
        }
        this.signature.subject = this.htmltoText(this.replaceVariables(subject, elements));
        this.signature.message = this.replaceVariables(message, elements) + '<br>' + ((_c = (_b = this.defaultSender) === null || _b === void 0 ? void 0 : _b.signature) !== null && _c !== void 0 ? _c : '');
    };
    Object.defineProperty(SignSend.prototype, "isEmptyDocument", {
        get: function () {
            var _a, _b, _c;
            return ((_c = (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignSend.prototype, "isSignable", {
        // Check if the pdf model can be used for signature
        get: function () {
            var _a, _b;
            return (_b = (_a = this.baseDocument) === null || _a === void 0 ? void 0 : _a.signable_document) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    SignSend.prototype.addSignatory = function (element) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.signature.signatories.push({
            element_type: (_a = element === null || element === void 0 ? void 0 : element.type) !== null && _a !== void 0 ? _a : null,
            element_id: (_b = element === null || element === void 0 ? void 0 : element.id) !== null && _b !== void 0 ? _b : null,
            firstname: (_d = (_c = element === null || element === void 0 ? void 0 : element.element) === null || _c === void 0 ? void 0 : _c.firstname) !== null && _d !== void 0 ? _d : null,
            lastname: (_f = (_e = element === null || element === void 0 ? void 0 : element.element) === null || _e === void 0 ? void 0 : _e.lastname) !== null && _f !== void 0 ? _f : null,
            mobile: (_h = (_g = element === null || element === void 0 ? void 0 : element.element) === null || _g === void 0 ? void 0 : _g.mobile) !== null && _h !== void 0 ? _h : null,
            email: (_k = (_j = element === null || element === void 0 ? void 0 : element.element) === null || _j === void 0 ? void 0 : _j.email) !== null && _k !== void 0 ? _k : null
        });
    };
    // Add the signature link to the message
    SignSend.prototype.addSignatureLink = function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        (this.$refs.editor.$refs.editor).getEditor().html.insert('<variable data-variable="SIGN-LINK" contenteditable="true" class="fr-dynamic-variable">SIGN-LINK</variable>');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        (this.$refs.editor.$refs.editor).getEditor().undo.saveStep();
    };
    // When the signature is successfuly sended
    SignSend.prototype.submitComplete = function (response) {
        var signature = response.data;
        if (signature.is_direct_sign) {
            this.loading = true;
            window.location.href = signature.signatories[0].public_link;
            return;
        }
        this.$emit('sended', response.data);
        this.modalState = false;
    };
    // When send signature and erros appears
    SignSend.prototype.submitError = function (error) {
        var _a;
        this.error = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
    };
    // When the PDF model is updated
    SignSend.prototype.pdfModelUpdated = function (pdfModel) {
        var _a;
        var document = (_a = this.baseDocument) === null || _a === void 0 ? void 0 : _a.document;
        if (document) {
            var value = JSON.parse(JSON.stringify(document));
            value.pdf_model = pdfModel;
            this.$emit('input', value);
        }
    };
    // Launch the file upload
    SignSend.prototype.uploadFile = function (event) {
        var file = this.$refs.file;
        if (file.getFiles().length === 0) {
            return;
        }
        event.preventDefault();
        this.loadingFile = true;
        file.upload();
    };
    // When a file upload failed
    SignSend.prototype.uploadFailed = function (response) {
        this.loadingFile = false;
        this.fileError = response.data.message;
    };
    // When a file is uploaded
    SignSend.prototype.documentAdded = function (signature) {
        this.loadingFile = false;
        this.watchValue(signature);
        this.addFileModal = false;
    };
    // Delete a file
    SignSend.prototype.deleteFile = function (event) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var index;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                event.preventDefault();
                index = this.fileToDelete;
                if (!((_a = this.value) === null || _a === void 0 ? void 0 : _a.id)) {
                    this.signature.documents.splice(index, 1);
                    this.fileToDelete = null;
                    return [2 /*return*/];
                }
                this.loadingFile = false;
                this.$kwSales.axios.put(this.formAction, {
                    remove_documents: [this.signature.documents[index].id]
                })
                    .then(function (response) {
                    _this.loadingFile = false;
                    _this.watchValue(response.data);
                    _this.fileToDelete = null;
                });
                return [2 /*return*/];
            });
        });
    };
    SignSend.prototype.watchSearchDocumentTerm = function () {
        if (this.searchDocumentTimeout) {
            clearTimeout(this.searchDocumentTimeout);
            this.searchDocumentTimeout = null;
        }
        if (!this.searchDocumentTerm) {
            this.searchDocumentResults = [];
            return;
        }
        this.searchDocumentLoading = true;
        this.searchDocumentTimeout = setTimeout(this.searchDocument, 500);
    };
    SignSend.prototype.searchDocument = function () {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var filters, customer;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.searchDocumentLoading = true;
                        filters = {};
                        customer = (_b = (_a = this.baseDocument) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.customer_id;
                        if (customer) {
                            filters.customer = customer;
                        }
                        return [4 /*yield*/, this.$kwSales.axios.get('/signature/search-document', {
                                params: {
                                    search: this.searchDocumentTerm,
                                    filters: filters,
                                    excludeElement: this.signature.documents
                                        .filter(function (document) { return document.document_type; })
                                        .map(function (document) {
                                        return {
                                            type: document.document_type,
                                            id: document.document_id
                                        };
                                    })
                                }
                            })
                                .then(function (response) {
                                _this.searchDocumentResults = response.data.datas;
                                _this.searchDocumentLoading = false;
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SignSend.prototype.addDocuments = function (document) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var data;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        data = this.formDatas;
                        if (!data.add_documents) {
                            data.add_documents = [];
                        }
                        data.add_documents.push({
                            document: {
                                type: document.type,
                                id: document.data.id
                            }
                        });
                        return [4 /*yield*/, this.$kwSales.axios({
                                url: this.formAction,
                                method: this.formMethod,
                                data: data
                            })
                                .then(function (response) {
                                _this.watchValue(response.data);
                                _this.searchDocumentResults = [];
                                _this.searchDocumentTerm = null;
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SignSend.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], SignSend.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Envoyer pour signature' })
    ], SignSend.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SignSend.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SignSend.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SignSend.prototype, "disabledTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SignSend.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SignSend.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SignSend.prototype, "withDirectSign", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], SignSend.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState', { immediate: true })
    ], SignSend.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], SignSend.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('model')
    ], SignSend.prototype, "watchModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('searchDocumentTerm')
    ], SignSend.prototype, "watchSearchDocumentTerm", null);
    SignSend = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BAlert: external_bootstrap_vue_.BAlert, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormRadio: external_bootstrap_vue_.BFormRadio, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay, BFormGroup: external_bootstrap_vue_.BFormGroup, BListGroup: external_bootstrap_vue_.BListGroup, BListGroupItem: external_bootstrap_vue_.BListGroupItem, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormPhone: form_vue_.KFormPhone, KFormEditor: form_vue_.KFormEditor, KFormSelect: form_vue_.KFormSelect, KFormCheckbox: form_vue_.KFormCheckbox, KFormFile: form_vue_.KFormFile,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                SignPdfModel: SignPdfModel/* default */.A,
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                BuySign: subscriptions_vue_namespaceObject.BuySign
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['loadModels', 'loadSenders'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('communication', ['models'])), (0,external_vuex_.mapGetters)('communication', ['defaultSender'])), (0,external_vuex_.mapGetters)('user', ['team', 'teamConfigs', 'testMode']))
        })
    ], SignSend);
    return SignSend;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin, interface_vue_.FileMixin, VariablesMixin/* default */.A, interface_vue_.DateMixin)));
/* harmony default export */ var SignSendvue_type_script_lang_ts_external = (SignSend);

;// ./src/components/SignSend/SignSend.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SignSend_SignSendvue_type_script_lang_ts_external = (SignSendvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SignSend/SignSend.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SignSend_SignSendvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignSend_SignSend = (component.exports);

/***/ }),

/***/ 30294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 30306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ 30361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 30404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CancelPayment_CancelPayment; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CancelPayment/CancelPayment.vue?vue&type=template&id=310dde22
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b-modal',{attrs:{"ok-title":_vm.errorMsg ? _vm.$t('interface.close') : 'Annuler le paiement',"cancel-title":_vm.$t('interface.close'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir annuler ce paiement ?")])]],2)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CancelPayment/CancelPayment.ts?vue&type=script&lang=ts&external




var CancelPayment = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CancelPayment, _super);
    function CancelPayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(CancelPayment.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    CancelPayment.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CancelPayment.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CancelPayment.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.post('/sales/payment/' + this.value.id, {
            _method: 'DELETE'
        })
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    CancelPayment.prototype.closeModal = function () {
        this.errorMsg = null;
        this.modalState = false;
        this.$emit('closed');
    };
    CancelPayment.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CancelPayment.prototype.deleted = function () {
        interface_vue_.emitter.emit('paymentDeleted', this.value);
        this.$emit('deleted', this.value);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CancelPayment.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CancelPayment.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Annuler le paiement' })
    ], CancelPayment.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CancelPayment.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CancelPayment.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CancelPayment.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CancelPayment.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CancelPayment.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CancelPayment.prototype, "watchModalState", null);
    CancelPayment = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CancelPayment);
    return CancelPayment;
}(lib/* Vue */.lD));
/* harmony default export */ var CancelPaymentvue_type_script_lang_ts_external = (CancelPayment);

;// ./src/components/CancelPayment/CancelPayment.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CancelPayment_CancelPaymentvue_type_script_lang_ts_external = (CancelPaymentvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CancelPayment/CancelPayment.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CancelPayment_CancelPaymentvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CancelPayment_CancelPayment = (component.exports);

/***/ }),

/***/ 30469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractStatus_ContractStatus; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractStatus/ContractStatus.vue?vue&type=template&id=7ec698c6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();return _vm.ask.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('b-modal',{attrs:{"ok-only":_vm.errorMsg !== null,"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.updateStatus},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_vm._v(" Êtes-vous sûr de vouloir modifier le statut du contrat à "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.computedLabel))]),_vm._v(" ? ")]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractStatus/ContractStatus.ts?vue&type=script&lang=ts&external




var ContractStatus = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractStatus, _super);
    function ContractStatus() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ContractStatus.prototype, "computedLabel", {
        // Return confirmation label
        get: function () {
            var _a;
            return (_a = this.confirmLabel) !== null && _a !== void 0 ? _a : this.label;
        },
        enumerable: false,
        configurable: true
    });
    // Open modal
    ContractStatus.prototype.ask = function () {
        this.errorMsg = null;
        this.modalState = true;
    };
    // Send ajax query
    ContractStatus.prototype.updateStatus = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.put('/sales/contract/' + this.contract.id, { status: this.status })
            .then(function (response) {
            _this.$emit('input', response.data);
            _this.modalState = false;
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            throw new Error(error);
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractStatus.prototype, "contract", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractStatus.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractStatus.prototype, "status", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractStatus.prototype, "confirmLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractStatus.prototype, "explain", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractStatus.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ size: 'sm' })
    ], ContractStatus.prototype, "size", void 0);
    ContractStatus = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal
            }
        })
    ], ContractStatus);
    return ContractStatus;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractStatusvue_type_script_lang_ts_external = (ContractStatus);

;// ./src/components/ContractStatus/ContractStatus.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractStatus_ContractStatusvue_type_script_lang_ts_external = (ContractStatusvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractStatus/ContractStatus.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractStatus_ContractStatusvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractStatus_ContractStatus = (component.exports);

/***/ }),

/***/ 30641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(86649),
    keys = __webpack_require__(95950);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 30737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SignConfigView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SignConfigView.vue?vue&type=template&id=98381510
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card h-100"},[_c('b-tab',{attrs:{"title":"Signatures envoyées"}},[_c('SignList')],1),_c('b-tab',{attrs:{"title":"Configuration"}},[_c('SignConfig')],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SignConfig/SignConfig.vue + 3 modules
var SignConfig = __webpack_require__(36211);
// EXTERNAL MODULE: ./src/components/SignList/SignList.vue + 3 modules
var SignList = __webpack_require__(29783);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SignConfigView.vue?vue&type=script&lang=ts





var SignConfigView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignConfigView, _super);
    function SignConfigView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SignConfigView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SignConfig: SignConfig/* default */.A,
                SignList: SignList/* default */.A,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab
            }
        })
    ], SignConfigView);
    return SignConfigView;
}(lib/* Vue */.lD));
/* harmony default export */ var SignConfigViewvue_type_script_lang_ts = (SignConfigView);

;// ./src/views/SignConfigView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SignConfigViewvue_type_script_lang_ts = (SignConfigViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/SignConfigView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_SignConfigViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SignConfigView = (component.exports);

/***/ }),

/***/ 30756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(23805);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 30817:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'file-invoice';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f570';
var svgPathData = 'M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.p4 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 31052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'waQ'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'nem'
                    : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'wen'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'ben'
                    : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ 31114:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fal';
var iconName = 'border-all';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f84c';
var svgPathData = 'M432 32H16A16 16 0 0 0 0 48v416a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM32 64h176v176H32zm0 384V272h176v176zm384 0H240V272h176zm0-208H240V64h176z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.fx = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 31126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(15389),
    baseSum = __webpack_require__(17721);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),

/***/ 31175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(26025);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 31380:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 31478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_DeliveryListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DeliveryListView.vue?vue&type=template&id=2b5cbc6f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeliveryList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/DeliveryList/DeliveryList.vue + 2 modules
var DeliveryList = __webpack_require__(56471);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DeliveryListView.vue?vue&type=script&lang=ts



var DeliveryListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DeliveryListView, _super);
    function DeliveryListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeliveryListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DeliveryList: DeliveryList/* default */.A
            }
        })
    ], DeliveryListView);
    return DeliveryListView;
}(lib/* Vue */.lD));
/* harmony default export */ var DeliveryListViewvue_type_script_lang_ts = (DeliveryListView);

;// ./src/views/DeliveryListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_DeliveryListViewvue_type_script_lang_ts = (DeliveryListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/DeliveryListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_DeliveryListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_DeliveryListView = (component.exports);

/***/ }),

/***/ 31541:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ 31545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ 31635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   aN: function() { return /* binding */ __spreadArrays; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 31769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(56449),
    isKey = __webpack_require__(28586),
    stringToPath = __webpack_require__(61802),
    toString = __webpack_require__(13222);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 31800:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 31929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TransformToDepositInvoice_TransformToDepositInvoice; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TransformToDepositInvoice/TransformToDepositInvoice.vue?vue&type=template&id=247a5b64
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",value:({ title: this.title }),expression:"{ title: this.title }",modifiers:{"right":true}}],tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"title":"Création d'une facture d'acompte","ok-title":_vm.errorMsg ? 'Fermer' : 'Créer la facture',"ok-only":_vm.errorMsg !== null},on:{"show":_vm.setDefaultValues,"submitComplete":_vm.submitComplete},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg !== null)?_c('p',{staticClass:"font-weight-bold text-danger mb-0 text-center"},[_vm._v(" Erreur : "+_vm._s(_vm.errorMsg)+" ")]):_c('k-form',{attrs:{"action":_vm.formUrl,"method":"post"},on:{"submitError":_vm.submitError}},[_c('b-form-group',{attrs:{"label":"Date du document"}},[_c('k-form-datepicker',{attrs:{"name":"date","min-date":_vm.minDate,"max-date":!_vm.teamConfigs.sales_disable_date_check ? _vm.today : null},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.draft}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}},[_vm._v(" Créer le document au statut brouillon ")]),_c('b-alert',{staticClass:"py-2 px-3",attrs:{"variant":"danger","show":!_vm.draft}},[_vm._v(" Attention : la facture ne pourra pas être modifiée ")]),_c('input',{attrs:{"type":"hidden","name":"with_details"},domProps:{"value":_vm.withDetails}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.withDetails),callback:function ($$v) {_vm.withDetails=$$v},expression:"withDetails"}},[_vm._v(" Ajouter le contenu du document dans la facture ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.advancePayment')}},[_c('b-input-group',{staticStyle:{"width":"200px"}},[_c('k-form-number',{attrs:{"validationName":_vm.advancePaymentType === 'amount' ? 'amount' : 'percentage'},model:{value:(_vm.advancePaymentValue),callback:function ($$v) {_vm.advancePaymentValue=$$v},expression:"advancePaymentValue"}}),_c('b-input-group-append',[_c('k-form-select',{attrs:{"name":"advance_payment_type","reduce":opt => opt.id,"options":[
                    { id: 'pourcent', label: '%' },
                    { id: 'amount', label: '€' }
                  ],"clearable":false},model:{value:(_vm.advancePaymentType),callback:function ($$v) {_vm.advancePaymentType=$$v},expression:"advancePaymentType"}})],1)],1)],1),_c('input',{attrs:{"type":"hidden","name":_vm.advancePaymentType === 'amount' ? 'amount' : 'percentage'},domProps:{"value":_vm.advancePaymentValue}}),_c('input',{attrs:{"type":"hidden","name":"with_vatrate"},domProps:{"value":_vm.withVatrate}}),_c('k-form-checkbox',{model:{value:(_vm.withVatrate),callback:function ($$v) {_vm.withVatrate=$$v},expression:"withVatrate"}},[_vm._v(" Créer une facture d'acompte avec TVA ")]),_c('b-alert',{staticClass:"mt-2 mb-0 py-2 px-3",attrs:{"variant":"warning","show":!_vm.withVatrate}},[_vm._v(" Attention : seuls les acomptes sur les achats avec livraison ne doivent pas inclure la TVA. ")]),(!_vm.value.billing_address.city || !_vm.value.billing_address.postal_code)?_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Adresse de facturation"}},[_c('k-form-address',{attrs:{"countries-list":_vm.countries,"prefix-name":"billing_address_","required":"","road-placeholder":_vm.$t('sales.form.road'),"size":"sm","with-road3":"","valuesMap":{
              road: 'road',
              city: 'city'
            },"city-name":"city","road-name":"road"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TransformToDepositInvoice/TransformToDepositInvoice.ts?vue&type=script&lang=ts&external







var TransformToDepositInvoice = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TransformToDepositInvoice, _super);
    function TransformToDepositInvoice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        _this.draft = true;
        _this.withVatrate = true;
        _this.withDetails = false;
        _this.advancePaymentValue = 0;
        _this.advancePaymentType = 'pourcent';
        _this.today = null;
        _this.address = {};
        return _this;
    }
    TransformToDepositInvoice.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        this.today = external_moment_default()().format('YYYY-MM-DD');
                        return [2 /*return*/];
                }
            });
        });
    };
    TransformToDepositInvoice.prototype.watchValue = function () {
        this.address = this.value.billing_address;
    };
    Object.defineProperty(TransformToDepositInvoice.prototype, "minDate", {
        get: function () {
            var closed_period = null;
            if (this.team.sales['closed_period']) {
                closed_period = external_moment_default()(this.team.sales['closed_period']).add(1, 'day').format('YYYY-MM-DD');
            }
            var min = null;
            if (!this.teamConfigs.sales_disable_date_check) {
                min = this.team.sales['invoice_date'];
            }
            if (min && (!closed_period || external_moment_default()(min).isAfter(closed_period))) {
                return min;
            }
            else if (closed_period) {
                return closed_period;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToDepositInvoice.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToDepositInvoice.prototype, "formUrl", {
        get: function () {
            return '/sales/' + this.type + '/' + this.value.id + '/deposit-invoice';
        },
        enumerable: false,
        configurable: true
    });
    TransformToDepositInvoice.prototype.setDefaultValues = function () {
        var _a, _b;
        this.date = external_moment_default()().format('YYYY-MM-DD');
        this.draft = true;
        this.withVatrate = true;
        this.withDetails = false;
        this.advancePaymentValue = (_a = this.value.advance_payment_value) !== null && _a !== void 0 ? _a : 0;
        this.advancePaymentType = (_b = this.value.advance_payment_type) !== null && _b !== void 0 ? _b : 'pourcent';
        this.errorMsg = null;
    };
    TransformToDepositInvoice.prototype.submitComplete = function (response) {
        return response.data;
    };
    TransformToDepositInvoice.prototype.submitError = function (error) {
        var _a;
        var response = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        if (response && response.errors !== undefined) {
            return;
        }
        this.errorMsg = response === null || response === void 0 ? void 0 : response.message;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToDepositInvoice.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToDepositInvoice.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TransformToDepositInvoice.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Facturer un acompte' })
    ], TransformToDepositInvoice.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToDepositInvoice.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TransformToDepositInvoice.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToDepositInvoice.prototype, "title", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TransformToDepositInvoice.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], TransformToDepositInvoice.prototype, "submitComplete", null);
    TransformToDepositInvoice = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect, KFormAddress: form_vue_.KFormAddress,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'team'])), (0,external_vuex_.mapState)('globalDatas', ['countries'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], TransformToDepositInvoice);
    return TransformToDepositInvoice;
}(lib/* Vue */.lD));
/* harmony default export */ var TransformToDepositInvoicevue_type_script_lang_ts_external = (TransformToDepositInvoice);

;// ./src/components/TransformToDepositInvoice/TransformToDepositInvoice.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TransformToDepositInvoice_TransformToDepositInvoicevue_type_script_lang_ts_external = (TransformToDepositInvoicevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/TransformToDepositInvoice/TransformToDepositInvoice.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TransformToDepositInvoice_TransformToDepositInvoicevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TransformToDepositInvoice_TransformToDepositInvoice = (component.exports);

/***/ }),

/***/ 32078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfModelSelect_PdfModelSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfModelSelect/PdfModelSelect.vue?vue&type=template&id=223e896c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.pdfModels}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfModelSelect/PdfModelSelect.ts?vue&type=script&lang=ts&external




var PdfModelSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelSelect, _super);
    function PdfModelSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PdfModelSelect.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var defaultModel;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPdfModels()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== null && !this.value) {
                            defaultModel = this.defaultPdfModel(this.selectDefault);
                            if (defaultModel) {
                                this.$emit('input', defaultModel);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PdfModelSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PdfModelSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PdfModelSelect.prototype, "selectDefault", void 0);
    PdfModelSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadPdfModels'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('sales', ['pdfModels'])), (0,external_vuex_.mapGetters)('sales', ['defaultPdfModel'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], PdfModelSelect);
    return PdfModelSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelSelectvue_type_script_lang_ts_external = (PdfModelSelect);

;// ./src/components/PdfModelSelect/PdfModelSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelSelect_PdfModelSelectvue_type_script_lang_ts_external = (PdfModelSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfModelSelect/PdfModelSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelSelect_PdfModelSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelSelect_PdfModelSelect = (component.exports);

/***/ }),

/***/ 32124:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ 32159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfOptions_PdfOptions; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/PdfOptions/PdfOptions.vue?vue&type=template&id=07a51271
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{attrs:{"type":"hidden","name":"pdf_options[amounts]"},domProps:{"value":_vm.value.pdf_options.amounts}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[discounts]"},domProps:{"value":_vm.value.pdf_options.discounts}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[comments]"},domProps:{"value":_vm.value.pdf_options.comments}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[units]"},domProps:{"value":_vm.value.pdf_options.units}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[number_column]"},domProps:{"value":_vm.value.pdf_options.number_column}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[reference_column]"},domProps:{"value":_vm.value.pdf_options.reference_column}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[ean_column]"},domProps:{"value":_vm.value.pdf_options.ean_column}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[weight_column]"},domProps:{"value":_vm.value.pdf_options.weight_column}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[vatrate_column]"},domProps:{"value":_vm.value.pdf_options.vatrate_column}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[total_quantity]"},domProps:{"value":_vm.value.pdf_options.total_quantity}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[contact]"},domProps:{"value":_vm.value.pdf_options.contact}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[country]"},domProps:{"value":_vm.value.pdf_options.country}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[vatrate_number]"},domProps:{"value":_vm.value.pdf_options.vatrate_number}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[situation_show_previous]"},domProps:{"value":_vm.value.pdf_options.situation_show_previous}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[situation_show_totals]"},domProps:{"value":_vm.value.pdf_options.situation_show_totals}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[situation_show_base_amount]"},domProps:{"value":_vm.value.pdf_options.situation_show_base_amount}}),_c('input',{attrs:{"type":"hidden","name":"pdf_options[situation_show_pourcentage]"},domProps:{"value":_vm.value.pdf_options.situation_show_pourcentage}}),_c('b-modal',{attrs:{"title":_vm.$t('sales.form.pdfOptions.title'),"size":"lg","ok-title":_vm.$t('interface.save'),"cancel-title":_vm.$t('sales.form.saveDefaultBtn'),"scrollable":"","body-class":"p-3"},on:{"cancel":_vm.askSaveDefault},model:{value:(_vm.localModal),callback:function ($$v) {_vm.localModal=$$v},expression:"localModal"}},[(_vm.saveDefaultState)?_c('ConfirmModal',{attrs:{"message":_vm.$t('sales.form.saveDefaultConfirmation')},on:{"confirmed":_vm.saveDefault,"canceled":function($event){_vm.saveDefaultState = false}}}):_vm._e(),(_vm.loading)?_c('Spinner'):[_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.pdfOptions.explain'))+" ")]),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-1",modifiers:{"sales-input-options-1":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'cogs']}}),_vm._v(" "+_vm._s(_vm.$t('sales.form.pdfOptions.contentTitle'))+" ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-1","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.amounts')}},[_c('k-form-select',{attrs:{"options":_vm.amounts,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.amounts),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "amounts", $$v)},expression:"value.pdf_options.amounts"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.discount')}},[_c('k-form-select',{attrs:{"options":_vm.discounts,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.discounts),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "discounts", $$v)},expression:"value.pdf_options.discounts"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.comments')}},[_c('k-form-select',{attrs:{"options":_vm.comments,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.comments),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "comments", $$v)},expression:"value.pdf_options.comments"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.unit'),"description":_vm.$t('sales.form.pdfOptions.unitExplain')}},[_c('k-form-select',{attrs:{"options":_vm.units,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.units),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "units", $$v)},expression:"value.pdf_options.units"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.number')}},[_c('k-form-select',{attrs:{"options":_vm.basicDisplay,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.number_column),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "number_column", $$v)},expression:"value.pdf_options.number_column"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.reference')}},[_c('k-form-select',{attrs:{"options":_vm.basicDisplay,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.reference_column),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "reference_column", $$v)},expression:"value.pdf_options.reference_column"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.ean')}},[_c('k-form-select',{attrs:{"options":_vm.basicDisplay,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.ean_column),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "ean_column", $$v)},expression:"value.pdf_options.ean_column"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.weight')}},[_c('k-form-select',{attrs:{"options":_vm.basicDisplay,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.weight_column),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "weight_column", $$v)},expression:"value.pdf_options.weight_column"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.vatrate'),"description":_vm.$t('sales.form.pdfOptions.vatrateExplain')}},[_c('k-form-select',{attrs:{"options":_vm.vatRateCol,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.vatrate_column),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "vatrate_column", $$v)},expression:"value.pdf_options.vatrate_column"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.totalQuantity'),"description":_vm.$t('sales.form.pdfOptions.totalQuantityExplain')}},[_c('k-form-select',{attrs:{"options":_vm.totalQuantityCol,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.total_quantity),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "total_quantity", $$v)},expression:"value.pdf_options.total_quantity"}})],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-2",modifiers:{"sales-input-options-2":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'map-signs']}}),_vm._v(" "+_vm._s(_vm.$t('sales.form.pdfOptions.addressesTitle'))+" ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-2","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.contact')}},[_c('k-form-select',{attrs:{"options":_vm.displayAddress,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.contact),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "contact", $$v)},expression:"value.pdf_options.contact"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.country')}},[_c('k-form-select',{attrs:{"options":_vm.displayAddress,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.country),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "country", $$v)},expression:"value.pdf_options.country"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.pdfOptions.vatrateNumber')}},[_c('k-form-select',{attrs:{"options":_vm.vatRateNumber,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.vatrate_number),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "vatrate_number", $$v)},expression:"value.pdf_options.vatrate_number"}})],1)],1)],1)],1),(_vm.hasModule('sales-situation-billing'))?_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-pdf-options-4",modifiers:{"sales-pdf-options-4":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'badge-percent']}}),_vm._v(" Factures de situation détaillées ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-pdf-options-4","accordion":"sales-pdf-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":"Affichager le montant total commandé"}},[_c('k-form-select',{attrs:{"options":_vm.showOnOff,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.situation_show_base_amount),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "situation_show_base_amount", $$v)},expression:"value.pdf_options.situation_show_base_amount"}})],1),_c('b-form-group',{attrs:{"label":"Affichager le pourcentage de la situation"}},[_c('k-form-select',{attrs:{"options":_vm.showOnOff,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.situation_show_pourcentage),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "situation_show_pourcentage", $$v)},expression:"value.pdf_options.situation_show_pourcentage"}})],1),_c('b-form-group',{attrs:{"label":"Affichage du poucentage et du montant des situations précédentes"}},[_c('k-form-select',{attrs:{"options":_vm.showSituationColumns,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.situation_show_previous),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "situation_show_previous", $$v)},expression:"value.pdf_options.situation_show_previous"}})],1),_c('b-form-group',{attrs:{"label":"Affichage du poucentage et du montant total des situations"}},[_c('k-form-select',{attrs:{"options":_vm.showSituationColumns,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.value.pdf_options.situation_show_totals),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "situation_show_totals", $$v)},expression:"value.pdf_options.situation_show_totals"}})],1)],1)],1)],1):_vm._e()]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesPdfOptionsMixin.ts
var SalesPdfOptionsMixin = __webpack_require__(922);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/PdfOptions/PdfOptions.ts?vue&type=script&lang=ts&external









var PdfOptions = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfOptions, _super);
    function PdfOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localModal = false;
        _this.saveDefaultState = false;
        _this.loading = false;
        return _this;
    }
    PdfOptions.prototype.watchModal = function (state) {
        this.localModal = state;
    };
    PdfOptions.prototype.watchlocalModal = function (state) {
        this.$emit('modalState', state);
    };
    PdfOptions.prototype.askSaveDefault = function (bvModalEvent) {
        bvModalEvent.preventDefault();
        this.saveDefaultState = true;
    };
    PdfOptions.prototype.saveDefault = function () {
        var _this = this;
        this.loading = true;
        this.saveDefaultState = false;
        var datas = new FormData();
        datas.set('_method', 'put');
        forEach_default()(this.value.pdf_options, function (value, key) {
            if (value !== undefined) {
                if (value === false)
                    value = 0;
                else if (value === true)
                    value = 1;
                datas.set('configs[sales_pdf_' + key + ']', String(value));
            }
        });
        this.$kwSales.axios.post('/team', datas)
            .then(function (response) {
            _this.setTeam(response.data);
        })
            .catch(function (error) {
            throw new Error(error);
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PdfOptions.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], PdfOptions.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], PdfOptions.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localModal')
    ], PdfOptions.prototype, "watchlocalModal", null);
    PdfOptions = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('user', ['setTeam'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                Spinner: interface_vue_.Spinner,
                ConfirmModal: interface_vue_.ConfirmModal,
                BModal: external_bootstrap_vue_.BModal, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BCardBody: external_bootstrap_vue_.BCardBody, BButton: external_bootstrap_vue_.BButton, BCollapse: external_bootstrap_vue_.BCollapse, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KFormSelect: form_vue_.KFormSelect,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle
            }
        })
    ], PdfOptions);
    return PdfOptions;
}((0,lib/* Mixins */.Xe)(SalesPdfOptionsMixin/* default */.A)));
/* harmony default export */ var PdfOptionsvue_type_script_lang_ts_external = (PdfOptions);

;// ./src/components/Form/PdfOptions/PdfOptions.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfOptions_PdfOptionsvue_type_script_lang_ts_external = (PdfOptionsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/PdfOptions/PdfOptions.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfOptions_PdfOptionsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfOptions_PdfOptions = (component.exports);

/***/ }),

/***/ 32349:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'times';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 32475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerDatas_CustomerDatas; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/CustomerDatas/CustomerDatas.vue?vue&type=template&id=0fb758d8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sales-form-customer-datas"},[_c('input',{attrs:{"name":"customer","type":"hidden"},domProps:{"value":_vm.value.customer ? _vm.value.customer.id : null}}),_c('b-form-row',[_c('b-col',[_c('CustomerSelect',{class:{
          'mb-3': !_vm.value.customer || _vm.value.customer.sales_statistics?.to_paid <= 0,
          'mb-2': _vm.value.customer && _vm.value.customer.sales_statistics?.to_paid > 0,
        },attrs:{"required":"","validationName":"customer","include":_vm.customerRelationships,"type":"prospect_or_customer"},model:{value:(_vm.value.customer),callback:function ($$v) {_vm.$set(_vm.value, "customer", $$v)},expression:"value.customer"}}),(_vm.value.customer && _vm.value.customer.sales_statistics?.to_paid > 0)?_c('b-alert',{staticClass:"small font-weight-bold p-1",attrs:{"show":"","variant":"danger"}},[_vm._v(" Paiement(s) en attente : "),(_vm.hasModule('customers-group') && _vm.value.customer?.childs?.length > 0)?[_c('br')]:_vm._e(),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.customer?.sales_statistics?.to_paid))+" ")],2):_vm._e()],1),_c('input',{attrs:{"name":"customer_child","type":"hidden"},domProps:{"value":_vm.value.customer_child ? _vm.value.customer_child.id : null}}),(_vm.hasModule('customers-group') && _vm.value.customer?.childs?.length > 0)?_c('b-col',[_c('b-form-group',{staticClass:"mb-2",attrs:{"label":_vm.teamConfigs.customer_group_child_name}},[_c('k-form-select',{attrs:{"options":_vm.value.customer.childs,"label":"name"},model:{value:(_vm.value.customer_child),callback:function ($$v) {_vm.$set(_vm.value, "customer_child", $$v)},expression:"value.customer_child"}})],1),(_vm.value.customer_child && _vm.value.customer_child.sales_statistics?.to_paid > 0)?_c('b-alert',{staticClass:"small font-weight-bold p-1",attrs:{"show":"","variant":"danger"}},[_vm._v(" Paiement(s) en attente :"),_c('br'),_vm._v(_vm._s(_vm.formattedNumber(_vm.value.customer_child?.sales_statistics?.to_paid))+" ")]):_vm._e()],1):_vm._e()],1),(_vm.value.customer?.sales_alert_message)?_c('b-modal',{attrs:{"visible":"","ok-only":"","ok-title":_vm.$t('interface.close')}},[_c('FroalaView',{attrs:{"value":_vm.value.customer.sales_alert_message}})],1):_vm._e(),_c('input',{attrs:{"type":"hidden","name":"contact"},domProps:{"value":_vm.value.contact ? _vm.value.contact.id : null}}),_c('ContactSelect',{attrs:{"validationName":"contact","customer":_vm.value.customer,"disabled":!_vm.value.customer,"include":['custom_fields']},on:{"input":_vm.onContactChange},model:{value:(_vm.value.contact),callback:function ($$v) {_vm.$set(_vm.value, "contact", $$v)},expression:"value.contact"}}),(_vm.hasModule('automotive'))?[_c('CarSelect',{staticClass:"mb-1",attrs:{"mileage":_vm.value.mileage,"customer":_vm.value.customer,"disabled":!_vm.value.customer,"validationName":"car","required":_vm.teamConfigs.automotive_document_required},model:{value:(_vm.value.car),callback:function ($$v) {_vm.$set(_vm.value, "car", $$v)},expression:"value.car"}}),_c('input',{attrs:{"type":"hidden","name":"car"},domProps:{"value":_vm.value.car ? _vm.value.car.id : null}})]:_vm._e(),_c('b-tabs',{class:{
      'disable-tab': !_vm.value.input_options.allow_delivery_address || (!_vm.hasModule('sales-deliveries') && !_vm.hasModule('construction'))
    },attrs:{"content-class":"pt-2","value":_vm.type === 'delivery' ? 1 : 0}},[_c('b-tab',{attrs:{"title":_vm.$t('sales.form.invoiceAddress') + (!_vm.value.input_options.allow_delivery_address || (!_vm.hasModule('sales-deliveries') && !_vm.hasModule('construction')) ? ' :' : '')}},[_c('div',{staticClass:"position-relative"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.billingCustomCustomer },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.customCustomerName')},on:{"click":function($event){_vm.billingCustomCustomer = !_vm.billingCustomCustomer}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.customer'))+" ")]),_vm._v(" | "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.billingCustomContact },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.customContactName')},on:{"click":function($event){_vm.billingCustomContact = !_vm.billingCustomContact}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.contact'))+" ")]),_c('span',[_vm._v(" | ")]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.billingWithRoad3 },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.withRoad3')},on:{"click":function($event){_vm.billingWithRoad3 = !_vm.billingWithRoad3}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.road3'))+" ")]),_vm._v(" | "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.billingWithComments },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.withComments')},on:{"click":function($event){_vm.billingWithComments = !_vm.billingWithComments}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.comments'))+" ")]),_vm._v(" | "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.billingWithVatRate },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.customVatrateNumber')},on:{"click":function($event){_vm.billingWithVatRate = !_vm.billingWithVatRate}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.vartrateNumberShort'))+" ")]),_c('CustomerAddressSelect',{attrs:{"customer":_vm.value.customer},on:{"selected":_vm.selectBillingAddress}})],1),(!_vm.billingCustomCustomer)?_c('input',{attrs:{"type":"hidden","name":"billing_address_name"},domProps:{"value":null}}):_vm._e(),_c('b-form-row',{staticClass:"address-extra-datas"},[(_vm.billingCustomCustomer)?_c('b-col',[_c('b-form-group',{staticClass:"mt-3 mb-2",attrs:{"label":_vm.$t('sales.form.customer'),"label-class":"small"}},[_c('k-form-input',{attrs:{"size":"sm","required":"","name":"billing_address_name"},model:{value:(_vm.value.billing_address.name),callback:function ($$v) {_vm.$set(_vm.value.billing_address, "name", $$v)},expression:"value.billing_address.name"}})],1)],1):_vm._e(),(_vm.billingCustomContact)?_c('b-col',[_c('b-form-group',{staticClass:"mt-3 mb-2",attrs:{"label":_vm.$t('sales.form.contact'),"label-class":"small"}},[_c('k-form-input',{attrs:{"size":"sm","validationName":"billing_address_contact"},model:{value:(_vm.value.billing_address.contact),callback:function ($$v) {_vm.$set(_vm.value.billing_address, "contact", $$v)},expression:"value.billing_address.contact"}})],1)],1):_vm._e()],1),_c('input',{attrs:{"type":"hidden","name":"billing_address_contact"},domProps:{"value":_vm.value.billing_address.contact}}),_c('k-form-address',{staticClass:"mt-2",attrs:{"countries-list":_vm.countries,"prefix-name":"billing_address_","required":_vm.type === 'proforma' || _vm.type === 'invoice' || _vm.type === 'credit',"road-placeholder":_vm.$t('sales.form.road'),"size":"sm","with-road3":_vm.billingWithRoad3,"valuesMap":{
          road: 'road',
          city: 'city'
        },"city-name":"city","road-name":"road"},model:{value:(_vm.value.billing_address),callback:function ($$v) {_vm.$set(_vm.value, "billing_address", $$v)},expression:"value.billing_address"}}),(_vm.billingWithVatRate)?_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.vatrateNumber'),"label-class":"pt-3 small"}},[_c('k-form-input',{attrs:{"size":"sm","name":"customer_vatrate"},model:{value:(_vm.value.customer_vatrate),callback:function ($$v) {_vm.$set(_vm.value, "customer_vatrate", $$v)},expression:"value.customer_vatrate"}})],1):_vm._e(),(_vm.billingWithComments)?_c('b-form-group',{staticClass:"address-extra-datas",attrs:{"label":_vm.$t('sales.form.comments'),"label-class":"pt-3 small"}},[_c('k-form-textarea',{attrs:{"name":"billing_address_comments"},model:{value:(_vm.value.billing_address.comments),callback:function ($$v) {_vm.$set(_vm.value.billing_address, "comments", $$v)},expression:"value.billing_address.comments"}})],1):_vm._e()],1),(_vm.value.input_options.allow_delivery_address && (_vm.hasModule('sales-deliveries') || _vm.hasModule('construction')))?_c('b-tab',{attrs:{"title":_vm.$t('sales.form.' + (_vm.hasModule('sales-deliveries') ? 'deliveryAddress' : 'constructionAddress'))}},[_c('div',{staticClass:"position-relative"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.deliveryCustomCustomer },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.customCustomerName')},on:{"click":function($event){_vm.deliveryCustomCustomer = !_vm.deliveryCustomCustomer}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.customer'))+" ")]),_vm._v(" | "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.deliveryCustomContact },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.customContactName')},on:{"click":function($event){_vm.deliveryCustomContact = !_vm.deliveryCustomContact}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.contact'))+" ")]),_c('span',[_vm._v(" | ")]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.deliveryWithRoad3 },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.withRoad3')},on:{"click":function($event){_vm.deliveryWithRoad3 = !_vm.deliveryWithRoad3}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.road3'))+" ")]),_vm._v(" | "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:{ 'btn-mini-action': true, 'active': _vm.deliveryWithComments },attrs:{"size":"sm","variant":"link","title":_vm.$t('sales.form.withComments')},on:{"click":function($event){_vm.deliveryWithComments = !_vm.deliveryWithComments}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.comments'))+" ")]),_c('CustomerAddressSelect',{attrs:{"customer":_vm.teamConfigs.customer_group_sales_child_delivery && _vm.value.customer_child ? _vm.value.customer_child : _vm.value.customer},on:{"selected":_vm.selectDeliveryAddress}})],1),_c('b-form-row',{staticClass:"address-extra-datas"},[(_vm.deliveryCustomCustomer)?_c('b-col',[_c('b-form-group',{staticClass:"mt-3 mb-2",attrs:{"label":_vm.$t('sales.form.customer'),"label-class":"small"}},[_c('k-form-input',{attrs:{"size":"sm","required":"","name":"delivery_address_name"},model:{value:(_vm.value.delivery_address.name),callback:function ($$v) {_vm.$set(_vm.value.delivery_address, "name", $$v)},expression:"value.delivery_address.name"}})],1)],1):_vm._e(),(_vm.deliveryCustomContact)?_c('b-col',[_c('b-form-group',{staticClass:"mt-3 mb-2",attrs:{"label":_vm.$t('sales.form.contact'),"label-class":"small"}},[_c('k-form-input',{attrs:{"size":"sm","name":"delivery_address_contact"},model:{value:(_vm.value.delivery_address.contact),callback:function ($$v) {_vm.$set(_vm.value.delivery_address, "contact", $$v)},expression:"value.delivery_address.contact"}})],1)],1):_vm._e()],1),_c('k-form-address',{staticClass:"mt-2",attrs:{"countries-list":_vm.countries,"prefix-name":"delivery_address_","valuesMap":{
          road: 'road',
          city: 'city'
        },"city-name":"city","road-name":"road","road-placeholder":_vm.$t('sales.form.road'),"size":"sm","with-road3":_vm.deliveryWithRoad3},model:{value:(_vm.value.delivery_address),callback:function ($$v) {_vm.$set(_vm.value, "delivery_address", $$v)},expression:"value.delivery_address"}}),(_vm.deliveryWithComments)?_c('b-form-group',{staticClass:"address-extra-datas",attrs:{"label":_vm.$t('sales.form.comments'),"label-class":"pt-3 small"}},[_c('k-form-textarea',{attrs:{"name":"delivery_address_comments"},model:{value:(_vm.value.delivery_address.comments),callback:function ($$v) {_vm.$set(_vm.value.delivery_address, "comments", $$v)},expression:"value.delivery_address.comments"}})],1):_vm._e()],1):_vm._e()],1),_c('b-modal',{attrs:{"ok-title":"Appliquer","cancel-title":"Ne pas appliquer","no-close-on-backdrop":""},on:{"ok":_vm.applyCustomPrices},model:{value:(_vm.askCustomPriceModal),callback:function ($$v) {_vm.askCustomPriceModal=$$v},expression:"askCustomPriceModal"}},[_c('p',[_vm._v(" Souhaitez-vous appliquer les prix personnalisés aux lignes déjà présentes dans le document ? ")]),_c('b-alert',{staticClass:"mb-0",attrs:{"show":"","variant":"warning"}},[_vm._v(" Attention : toutes les lignes contenant un produit ou une prestation avec des prix personnalisés seront mises à jour. ")])],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/CustomerAddressSelect/CustomerAddressSelect.vue + 3 modules
var CustomerAddressSelect = __webpack_require__(29407);
// EXTERNAL MODULE: ./src/components/CarSelect/CarSelect.vue + 3 modules
var CarSelect = __webpack_require__(5569);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/CustomerDatas/CustomerDatas.ts?vue&type=script&lang=ts&external









var CustomerDatas = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerDatas, _super);
    function CustomerDatas() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialized = false;
        _this.billingCustomCustomer = false;
        _this.billingCustomContact = false;
        _this.billingWithRoad3 = false;
        _this.billingWithComments = false;
        _this.billingWithVatRate = false;
        _this.deliveryCustomCustomer = false;
        _this.deliveryCustomContact = false;
        _this.deliveryWithRoad3 = false;
        _this.deliveryWithComments = false;
        _this.askCustomPriceModal = false;
        return _this;
    }
    CustomerDatas.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        this.setDefaultStatus();
                        this.initialized = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CustomerDatas.prototype, "customerRelationships", {
        get: function () {
            var relations = customers_vue_.customerRelations.filter(function (relation) { return !['sales_statistics'].includes(relation); });
            relations.push.apply(relations, ['childs.address_invoice', 'childs.address_delivery', 'childs.addresses']);
            if (this.hasModule('customers-group') && this.teamConfigs.customer_group_sales_parent_select) {
                relations.push('parent.datas');
            }
            return relations;
        },
        enumerable: false,
        configurable: true
    });
    CustomerDatas.prototype.setDefaultStatus = function () {
        var _a, _b, _c, _d, _e;
        var address = this.value.billing_address;
        if (address.name && (!this.value.customer || ((_a = this.value.customer) === null || _a === void 0 ? void 0 : _a.name) !== address.name)) {
            this.billingCustomCustomer = true;
        }
        if (address.contact && (!this.value.contact || ((_b = this.value.contact) === null || _b === void 0 ? void 0 : _b.fullname) !== address.contact)) {
            this.billingCustomContact = true;
        }
        if (address.road3) {
            this.billingWithRoad3 = true;
        }
        if (address.comments) {
            this.billingWithComments = true;
        }
        if (this.value.customer_vatrate && (!this.value.customer || ((_c = this.value.customer) === null || _c === void 0 ? void 0 : _c.company_vatrate) !== this.value.customer_vatrate)) {
            this.billingWithVatRate = true;
        }
        var deliveryAddress = this.value.delivery_address;
        if (deliveryAddress.name && (!this.value.customer || ((_d = this.value.customer) === null || _d === void 0 ? void 0 : _d.name) !== deliveryAddress.name)) {
            this.deliveryCustomCustomer = true;
        }
        if (deliveryAddress.contact && (!this.value.contact || ((_e = this.value.contact) === null || _e === void 0 ? void 0 : _e.fullname) !== deliveryAddress.contact)) {
            this.deliveryCustomContact = true;
        }
        if (deliveryAddress.road3) {
            this.deliveryWithRoad3 = true;
        }
        if (deliveryAddress.comments) {
            this.deliveryWithComments = true;
        }
    };
    CustomerDatas.prototype.onCustomerChildChange = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.deliveryCustomCustomer = false;
        this.value.delivery_address.name = undefined;
        if (!this.teamConfigs.customer_group_sales_child_delivery) {
            return;
        }
        var customer;
        var address;
        if (!this.value.customer_child) {
            customer = this.value.customer;
            address = (_d = (_b = (_a = this.value.customer) === null || _a === void 0 ? void 0 : _a.address_delivery) !== null && _b !== void 0 ? _b : (_c = this.value.customer) === null || _c === void 0 ? void 0 : _c.address_invoice) !== null && _d !== void 0 ? _d : null;
        }
        else {
            customer = (_e = this.value.customer_child) !== null && _e !== void 0 ? _e : null;
            address = (_j = (_g = (_f = this.value.customer_child) === null || _f === void 0 ? void 0 : _f.address_delivery) !== null && _g !== void 0 ? _g : (_h = this.value.customer_child) === null || _h === void 0 ? void 0 : _h.address_invoice) !== null && _j !== void 0 ? _j : null;
            this.deliveryCustomCustomer = true;
        }
        if (address) {
            this.value.delivery_address = {
                name: customer === null || customer === void 0 ? void 0 : customer.name,
                road: address === null || address === void 0 ? void 0 : address.road1,
                road2: address === null || address === void 0 ? void 0 : address.road2,
                road3: address === null || address === void 0 ? void 0 : address.road3,
                postal_code: address === null || address === void 0 ? void 0 : address.postal_code,
                city: address === null || address === void 0 ? void 0 : address.town,
                country: address === null || address === void 0 ? void 0 : address.country
            };
            this.deliveryWithRoad3 = (address === null || address === void 0 ? void 0 : address.road3) !== null;
        }
    };
    CustomerDatas.prototype.onCustomerChange = function (customer, oldCustomer) {
        var _this = this;
        var _a;
        if (this.initialized) {
            this.value.contact = null;
            this.value.billing_contact = null;
            this.value.car = null;
            this.value.customer_child = null;
        }
        if (!customer || ((this.value.id || this.value.is_clone) && !this.initialized)) {
            return;
        }
        if (this.hasModule('customers-group') && this.teamConfigs.customer_group_sales_parent_select && customer.parent) {
            this.value.customer = customer.parent;
            this.$nextTick(function () {
                _this.value.customer_child = customer;
            });
            return;
        }
        if (customer.address_invoice) {
            var address = customer.address_invoice;
            this.value.billing_address = {
                name: customer.name,
                road: address.road1,
                road2: address.road2,
                road3: address.road3,
                postal_code: address.postal_code,
                city: address.town,
                country: address.country
            };
            this.billingWithRoad3 = address.road3 !== null;
        }
        if (customer.address_delivery || customer.address_invoice) {
            var address = (_a = customer.address_delivery) !== null && _a !== void 0 ? _a : customer.address_invoice;
            this.value.delivery_address = {
                name: customer.name,
                road: address.road1,
                road2: address.road2,
                road3: address.road3,
                postal_code: address.postal_code,
                city: address.town,
                country: address.country
            };
            this.deliveryWithRoad3 = address.road3 !== null;
        }
        var configs = customer.configs;
        var oldConfigs = (oldCustomer ? oldCustomer.configs : {});
        var teamConfig = this.teamConfigs;
        if (configs.sales_amounts_type) {
            this.value.input_mode = configs.sales_amounts_type;
        }
        else if (oldConfigs.sales_amounts_type && teamConfig.sales_amounts_type) {
            this.value.input_mode = teamConfig.sales_amounts_type;
        }
        if (configs.sales_currency) {
            this.value.currency = configs.sales_currency;
        }
        else if (oldConfigs.sales_currency) {
            this.value.currency = this.currency;
        }
        if (configs.sales_escompte_rate) {
            this.value.escompte_rate = configs.sales_escompte_rate;
        }
        else if (oldConfigs.sales_escompte_rate && teamConfig.sales_escompte_rate) {
            this.value.escompte_rate = teamConfig.sales_escompte_rate;
        }
        if (configs.sales_penalty_rate) {
            this.value.penalty_rate = configs.sales_penalty_rate;
            this.value.penalty_rate_law = false;
        }
        else if (oldConfigs.sales_penalty_rate && teamConfig.sales_penalty_rate) {
            this.value.penalty_rate = teamConfig.sales_penalty_rate;
            this.value.penalty_rate_law = teamConfig.sales_penalty_rate_law;
        }
        if (configs.sales_payment_advance_rate) {
            this.value.advance_payment_value = configs.sales_payment_advance_rate;
            this.value.advance_payment_type = 'pourcent';
        }
        else if (oldConfigs.sales_payment_advance_rate) {
            this.value.advance_payment_value = teamConfig.sales_payment_advance_rate;
        }
        if (configs.sales_global_discount) {
            this.value.global_discount_value = configs.sales_global_discount;
            this.value.global_discount_type = 'pourcent';
        }
        else if (oldConfigs.sales_global_discount) {
            this.value.global_discount_value = 0;
        }
        if (configs.sales_payment_term) {
            this.value.payment_term = configs.sales_payment_term;
        }
        else if (oldConfigs.sales_payment_term && teamConfig.sales_payment_term) {
            this.value.payment_term = teamConfig.sales_payment_term;
        }
        if (configs.sales_pdf_amounts) {
            this.value.pdf_options.amounts = configs.sales_pdf_amounts;
        }
        else if (oldConfigs.sales_pdf_amounts && teamConfig.sales_pdf_amounts) {
            this.value.pdf_options.amounts = teamConfig.sales_pdf_amounts;
        }
        if (configs.sales_sale_term) {
            this.value.sale_term = configs.sales_sale_term;
        }
        else if (oldConfigs.sales_sale_term && teamConfig.sales_sale_term) {
            this.value.sale_term = teamConfig.sales_sale_term;
        }
        if (configs.sales_pdf_model) {
            this.value.pdf_model = configs.sales_pdf_model;
        }
        else if (oldConfigs.sales_pdf_model) {
            this.value.pdf_model = this.defaultPdfModel(this.type);
        }
        if (this.booleanIsNotEmpty(configs.sales_use_global_vatrate)) {
            this.value.use_global_vatrate = configs.sales_use_global_vatrate;
            if (configs.sales_vat_rate) {
                this.value.vat_rate = configs.sales_vat_rate;
            }
        }
        else if (this.booleanIsNotEmpty(oldConfigs.sales_use_global_vatrate) && this.booleanIsNotEmpty(teamConfig.sales_use_global_vatrate)) {
            this.value.use_global_vatrate = teamConfig.sales_use_global_vatrate;
            if (configs.sales_vat_rate) {
                this.value.vat_rate = configs.sales_vat_rate;
            }
        }
        if (configs.sales_payment_methods) {
            this.value.payment_methods = configs.sales_payment_methods;
        }
        else if (oldConfigs.sales_payment_methods && teamConfig.sales_payment_methods) {
            this.value.payment_methods = teamConfig.sales_payment_methods;
        }
        if (configs.sales_guarantee_holdback_pourcent) {
            this.value.guarantee_holdback_pourcent = configs.sales_guarantee_holdback_pourcent;
        }
        else if (oldConfigs.sales_guarantee_holdback_pourcent && teamConfig.sales_guarantee_holdback_pourcent) {
            this.value.guarantee_holdback_pourcent = teamConfig.sales_guarantee_holdback_pourcent;
        }
        if (configs.sales_guarantee_holdback_duration) {
            this.value.guarantee_holdback_duration = configs.sales_guarantee_holdback_duration;
        }
        else if (oldConfigs.sales_guarantee_holdback_duration && teamConfig.sales_guarantee_holdback_duration) {
            this.value.guarantee_holdback_duration = teamConfig.sales_guarantee_holdback_duration;
        }
        this.value.customer_vatrate = customer.company_vatrate;
        if (customer.custom_fields) {
            this.applyCustomFields(customer.custom_fields, ['customer', 'prospect']);
        }
        if (customer && this.hasModule('catalog-custom-prices')) {
            var present = this.value.contents.filter(function (content) { var _a; return ((_a = content.catalog) === null || _a === void 0 ? void 0 : _a.element) && 'custom_price_mode' in content.catalog.element; }).length;
            if (present > 0 && this.initialized) {
                this.askCustomPriceModal = true;
            }
        }
        if (customer.billing_contact) {
            this.value.billing_contact = customer.billing_contact;
        }
    };
    CustomerDatas.prototype.watchContact = function (contact) {
        if (contact && contact.custom_fields) {
            this.applyCustomFields(contact.custom_fields, ['contact']);
        }
    };
    CustomerDatas.prototype.applyCustomFields = function (customFields, usages) {
        var _this = this;
        var documentFields = this.getCustomFields(this.type);
        if (documentFields.length > 0) {
            var customerFields = this.getCustomFields(usages);
            customerFields.forEach(function (field) {
                var _a;
                var documentIndex = documentFields.findIndex(function (val) { return val.id === field.id; });
                if (documentIndex < 0) {
                    return;
                }
                var value = (_a = customFields === null || customFields === void 0 ? void 0 : customFields.find(function (value) { return value.id === field.id; })) !== null && _a !== void 0 ? _a : null;
                if (!value) {
                    value = {
                        id: field.id,
                        label: field.label,
                        type: field.type,
                        value: value
                    };
                }
                var index = _this.value.custom_fields.findIndex(function (val) { return val.id === field.id; });
                if (index >= 0) {
                    lib/* Vue */.lD.set(_this.value.custom_fields, index, value);
                }
                else if (value) {
                    _this.value.custom_fields.push(value);
                }
            });
        }
    };
    CustomerDatas.prototype.applyCustomPrices = function () {
        interface_vue_.emitter.emit('updateCustomPrice', { dontPropagate: false });
    };
    CustomerDatas.prototype.booleanIsNotEmpty = function (value) {
        return value !== undefined && value || value !== null;
    };
    CustomerDatas.prototype.onContactChange = function (contact) {
        if (!contact) {
            return;
        }
        if (this.value.billing_address) {
            this.value.billing_address.contact = contact.fullname;
        }
        if (this.value.delivery_address) {
            this.value.delivery_address.contact = contact.fullname;
        }
    };
    CustomerDatas.prototype.selectBillingAddress = function (address) {
        this.value.billing_address.road = address.road1;
        this.value.billing_address.road2 = address.road2;
        this.value.billing_address.road3 = address.road3;
        this.value.billing_address.postal_code = address.postal_code;
        this.value.billing_address.city = address.town;
        this.value.billing_address.country = address.country;
    };
    CustomerDatas.prototype.selectDeliveryAddress = function (address) {
        this.value.delivery_address.road = address.road1;
        this.value.delivery_address.road2 = address.road2;
        this.value.delivery_address.road3 = address.road3;
        this.value.delivery_address.postal_code = address.postal_code;
        this.value.delivery_address.city = address.town;
        this.value.delivery_address.country = address.country;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], CustomerDatas.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerDatas.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.customer_child')
    ], CustomerDatas.prototype, "onCustomerChildChange", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.customer', { immediate: true })
    ], CustomerDatas.prototype, "onCustomerChange", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.contact', { immediate: true })
    ], CustomerDatas.prototype, "watchContact", null);
    CustomerDatas = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'currency'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('customFields', ['getCustomFields'])), (0,external_vuex_.mapGetters)('sales', ['defaultPdfModel'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            components: {
                CustomerSelect: customers_vue_.CustomerSelect,
                ContactSelect: customers_vue_.ContactSelect,
                CustomerAddressSelect: CustomerAddressSelect/* default */.A,
                CarSelect: CarSelect/* default */.A,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BButton: external_bootstrap_vue_.BButton, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert,
                KFormInput: form_vue_.KFormInput, KFormAddress: form_vue_.KFormAddress, KFormTextarea: form_vue_.KFormTextarea, KFormSelect: form_vue_.KFormSelect, FroalaView: form_vue_.FroalaView
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CustomerDatas);
    return CustomerDatas;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CustomerDatasvue_type_script_lang_ts_external = (CustomerDatas);

;// ./src/components/Form/CustomerDatas/CustomerDatas.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerDatas_CustomerDatasvue_type_script_lang_ts_external = (CustomerDatasvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/CustomerDatas/CustomerDatas.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerDatas_CustomerDatasvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerDatas_CustomerDatas = (component.exports);

/***/ }),

/***/ 32504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionPaymentList_CommissionPaymentList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionPaymentList/CommissionPaymentList.vue?vue&type=template&id=558bc9cf
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-table"},[_c('PageHeader',{attrs:{"pageTitle":"Liste des paiements des commissions","buttons":_vm.buttons}}),_c('AppMessages'),(_vm.loading)?_c('Spinner'):_c('k-table',{ref:"table",attrs:{"url":"/sales/commission/payment","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"rowClick":_vm.rowClick,"filters":_vm.filters}}),(_vm.showCommission)?_c('CommissionPaymentItem',{attrs:{"modal":true},on:{"hidden":function($event){_vm.showCommission = null},"deleted":_vm.commissionDeleted,"edit":_vm.commissionEdit},model:{value:(_vm.showCommission),callback:function ($$v) {_vm.showCommission=$$v},expression:"showCommission"}}):_vm._e(),_c('CommissionPaymentForm',{attrs:{"modal":_vm.newCommission},on:{"submitComplete":_vm.commissionAdded,"hidden":function($event){_vm.newCommission = false}}}),_c('CommissionPaymentForm',{attrs:{"modal":_vm.editCommission !== null},on:{"hidden":function($event){_vm.editCommission = null},"submitComplete":_vm.commissionUpdated},model:{value:(_vm.editCommission),callback:function ($$v) {_vm.editCommission=$$v},expression:"editCommission"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./src/components/CommissionPaymentItem/CommissionPaymentItem.vue + 3 modules
var CommissionPaymentItem = __webpack_require__(79146);
// EXTERNAL MODULE: ./src/components/CommissionPaymentForm/CommissionPaymentForm.vue + 3 modules
var CommissionPaymentForm = __webpack_require__(75579);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionPaymentList/CommissionPaymentList.ts?vue&type=script&lang=ts&external







var CommissionPaymentList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionPaymentList, _super);
    function CommissionPaymentList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.showCommission = null;
        _this.newCommission = false;
        _this.editCommission = null;
        return _this;
    }
    CommissionPaymentList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommissionPaymentList.prototype, "buttons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('sales-commissions', 2)) {
                buttons.push({
                    label: 'Nouveau paiement',
                    click: function () {
                        _this.newCommission = true;
                    }
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionPaymentList.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: ['commissions', 'teamUser']
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionPaymentList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'date',
                    name: 'Date',
                    render: 'date'
                },
                {
                    data: 'amount',
                    name: 'Montant',
                    render: 'currency'
                },
                {
                    data: 'team_user.fullname',
                    name: 'Commercial'
                },
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'updated_at',
                    name: 'Dernière modification',
                    render: 'datetime',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionPaymentList.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'period',
                    label: 'Date',
                    name: 'date_since',
                    name2: 'date_until'
                },
                {
                    type: 'select',
                    label: 'Commercial',
                    name: 'team_user',
                    options: this.teamUsersRole('commercial'),
                    multiple: true,
                    optionLabel: 'fullname',
                    value: 'id'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CommissionPaymentList.prototype.rowClick = function (commission) {
        this.showCommission = commission;
    };
    CommissionPaymentList.prototype.commissionAdded = function (commission) {
        var table = this.$refs.table;
        table.addRow(commission);
    };
    CommissionPaymentList.prototype.commissionEdit = function (commission) {
        this.editCommission = commission;
    };
    CommissionPaymentList.prototype.commissionUpdated = function (commission) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (value) { return value.id === commission.id; });
        if (index > -1) {
            table.updateRow(index, commission);
        }
        else {
            table.addRow(commission);
        }
    };
    CommissionPaymentList.prototype.commissionDeleted = function (commission) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (value) { return value.id === commission.id; });
        if (index > -1) {
            table.deleteRow(index);
        }
        this.$emit('hidden');
    };
    CommissionPaymentList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PageHeader: interface_vue_.PageHeader, Spinner: interface_vue_.Spinner, AppMessages: interface_vue_.AppMessages,
                KTable: table_vue_.KTable,
                CommissionPaymentItem: CommissionPaymentItem/* default */.A,
                CommissionPaymentForm: CommissionPaymentForm/* default */.A
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['teamUsersRole'])), (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], CommissionPaymentList);
    return CommissionPaymentList;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CommissionPaymentListvue_type_script_lang_ts_external = (CommissionPaymentList);

;// ./src/components/CommissionPaymentList/CommissionPaymentList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionPaymentList_CommissionPaymentListvue_type_script_lang_ts_external = (CommissionPaymentListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionPaymentList/CommissionPaymentList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionPaymentList_CommissionPaymentListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionPaymentList_CommissionPaymentList = (component.exports);

/***/ }),

/***/ 32804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(56110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 32818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractNotifications_ContractNotifications; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractNotifications/ContractNotifications.vue?vue&type=template&id=79d8d6da
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":"Recevoir des notifications pour les événements suivants"}},[_c('b-row',{staticClass:"mt-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto pr-0"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_contract_notification_expiration]"},domProps:{"value":_vm.localConfig.sales_contract_notification_expiration}}),_c('k-form-checkbox',{attrs:{"value":true},model:{value:(_vm.localConfig.sales_contract_notification_expiration),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_notification_expiration", $$v)},expression:"localConfig.sales_contract_notification_expiration"}})],1),_c('b-col',{attrs:{"cols":"auto px-0"}},[_c('k-form-select',{attrs:{"size":"sm","options":_vm.delayOptions,"clearable":false,"name":"configs[sales_contract_notification_expiration_delay]","disabled":!_vm.localConfig.sales_contract_notification_expiration},model:{value:(_vm.localConfig.sales_contract_notification_expiration_delay),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_notification_expiration_delay", $$v)},expression:"localConfig.sales_contract_notification_expiration_delay"}})],1),_c('b-col',[_vm._v(" jours avant expiration d'un contrat. ")])],1),_c('input',{attrs:{"type":"hidden","name":"configs[sales_contract_notification_when_expire]"},domProps:{"value":_vm.localConfig.sales_contract_notification_when_expire}}),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"value":true},model:{value:(_vm.localConfig.sales_contract_notification_when_expire),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_notification_when_expire", $$v)},expression:"localConfig.sales_contract_notification_when_expire"}},[_vm._v(" Lors de l'expiration d'un contrat. ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_contract_notification_when_renew]"},domProps:{"value":_vm.localConfig.sales_contract_notification_when_renew}}),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"value":true},model:{value:(_vm.localConfig.sales_contract_notification_when_renew),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_notification_when_renew", $$v)},expression:"localConfig.sales_contract_notification_when_renew"}},[_vm._v(" Lors du renouvellement automatique d'un contrat. ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_contract_notification_when_invoice]"},domProps:{"value":_vm.localConfig.sales_contract_notification_when_invoice}}),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"value":true},model:{value:(_vm.localConfig.sales_contract_notification_when_invoice),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_notification_when_invoice", $$v)},expression:"localConfig.sales_contract_notification_when_invoice"}},[_vm._v(" Lors de la facturation automatique d'une échéance. ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_contract_notification_when_need_invoice]"},domProps:{"value":_vm.localConfig.sales_contract_notification_when_need_invoice}}),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"value":true},model:{value:(_vm.localConfig.sales_contract_notification_when_need_invoice),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_notification_when_need_invoice", $$v)},expression:"localConfig.sales_contract_notification_when_need_invoice"}},[_vm._v(" Lorsque des échéances sont à facturer. ")])],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Destinataire des notifications"}},[_vm._l((_vm.localConfig.sales_contract_notification_users),function(user,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"configs[sales_contract_notification_users][]"},domProps:{"value":user.id}})}),(!_vm.localConfig.sales_contract_notification_users || _vm.localConfig.sales_contract_notification_users.length === 0)?_c('input',{attrs:{"type":"hidden","name":"configs[sales_contract_notification_users]"},domProps:{"value":null}}):_vm._e(),_c('TeamUserSelect',{attrs:{"multiple":""},model:{value:(_vm.localConfig.sales_contract_notification_users),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_notification_users", $$v)},expression:"localConfig.sales_contract_notification_users"}}),_c('input',{attrs:{"type":"hidden","name":"configs[sales_contract_notification_commercial]"},domProps:{"value":_vm.localConfig.sales_contract_notification_commercial}}),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"value":true},model:{value:(_vm.localConfig.sales_contract_notification_commercial),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_contract_notification_commercial", $$v)},expression:"localConfig.sales_contract_notification_commercial"}},[_vm._v(" Envoyer également au commercial en charge du contrat ")])],2),_c('p',{staticClass:"mt-5 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractNotifications/ContractNotifications.ts?vue&type=script&lang=ts&external





var ContractNotifications = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractNotifications, _super);
    function ContractNotifications() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ContractNotifications.prototype, "delayOptions", {
        get: function () {
            var opts = Array(91);
            return Array.from(opts.keys()).slice(1);
        },
        enumerable: false,
        configurable: true
    });
    ContractNotifications = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TeamUserSelect: interface_vue_.TeamUserSelect,
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect,
                BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup
            }
        })
    ], ContractNotifications);
    return ContractNotifications;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var ContractNotificationsvue_type_script_lang_ts_external = (ContractNotifications);

;// ./src/components/ContractNotifications/ContractNotifications.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractNotifications_ContractNotificationsvue_type_script_lang_ts_external = (ContractNotificationsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractNotifications/ContractNotifications.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractNotifications_ContractNotificationsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractNotifications_ContractNotifications = (component.exports);

/***/ }),

/***/ 32865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(19570),
    shortOut = __webpack_require__(51811);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 32934:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ 33478:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),

/***/ 34109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ UseCredit_UseCredit; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UseCredit/UseCredit.vue?vue&type=template&id=0d5cf01c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formUrl},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.withLabel !== false ? 'Avoir à utiliser :' : null}},[_c('k-form-select',{attrs:{"name":"add_credits[]","options":_vm.credits,"getOptionLabel":opt => 'Avoir n°' + opt.reference + ' - ' + _vm.formattedNumber(opt.stay_to_pay, _vm.invoice.currency),"reduce":opt => opt.id,"required":_vm.withButton === false,"size":_vm.size},model:{value:(_vm.useCredit),callback:function ($$v) {_vm.useCredit=$$v},expression:"useCredit"}})],1),(_vm.withButton !== false && _vm.useCredit)?_c('b-button',{staticClass:"mt-2",attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(" Utiliser l'avoir ")]):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UseCredit/UseCredit.ts?vue&type=script&lang=ts&external





var UseCredit = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UseCredit, _super);
    function UseCredit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.credits = [];
        _this.useCredit = null;
        return _this;
    }
    Object.defineProperty(UseCredit.prototype, "formUrl", {
        get: function () {
            return '/sales/invoice/' + this.invoice.id + '/credit';
        },
        enumerable: false,
        configurable: true
    });
    UseCredit.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.invoice) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchCredits()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    UseCredit.prototype.submitComplete = function (response) {
        return response.data;
    };
    UseCredit.prototype.fetchCredits = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/credit', {
                                params: {
                                    filter: {
                                        is_draft: false,
                                        can_be_used: true,
                                        customer: (_a = this.invoice.customer) === null || _a === void 0 ? void 0 : _a.id,
                                        with_currency: this.invoice.currency_id
                                    }
                                }
                            })
                                .then(function (response) {
                                var credits = response.data.data;
                                _this.credits = credits;
                                if (credits.length === 0) {
                                    _this.$emit('noCredits');
                                }
                                else {
                                    _this.$emit('haveCredits');
                                }
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseCredit.prototype, "invoice", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseCredit.prototype, "credit", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], UseCredit.prototype, "withLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], UseCredit.prototype, "withButton", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseCredit.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], UseCredit.prototype, "submitComplete", null);
    UseCredit = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BButton: external_bootstrap_vue_.BButton,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], UseCredit);
    return UseCredit;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var UseCreditvue_type_script_lang_ts_external = (UseCredit);

;// ./src/components/UseCredit/UseCredit.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UseCredit_UseCreditvue_type_script_lang_ts_external = (UseCreditvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/UseCredit/UseCredit.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  UseCredit_UseCreditvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UseCredit_UseCredit = (component.exports);

/***/ }),

/***/ 34840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 34932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 35358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./af": 25177,
	"./af.js": 25177,
	"./ar": 61509,
	"./ar-dz": 41488,
	"./ar-dz.js": 41488,
	"./ar-kw": 58676,
	"./ar-kw.js": 58676,
	"./ar-ly": 42353,
	"./ar-ly.js": 42353,
	"./ar-ma": 24496,
	"./ar-ma.js": 24496,
	"./ar-ps": 6947,
	"./ar-ps.js": 6947,
	"./ar-sa": 82682,
	"./ar-sa.js": 82682,
	"./ar-tn": 89756,
	"./ar-tn.js": 89756,
	"./ar.js": 61509,
	"./az": 95533,
	"./az.js": 95533,
	"./be": 28959,
	"./be.js": 28959,
	"./bg": 47777,
	"./bg.js": 47777,
	"./bm": 54903,
	"./bm.js": 54903,
	"./bn": 61290,
	"./bn-bd": 17357,
	"./bn-bd.js": 17357,
	"./bn.js": 61290,
	"./bo": 31545,
	"./bo.js": 31545,
	"./br": 11470,
	"./br.js": 11470,
	"./bs": 44429,
	"./bs.js": 44429,
	"./ca": 7306,
	"./ca.js": 7306,
	"./cs": 56464,
	"./cs.js": 56464,
	"./cv": 73635,
	"./cv.js": 73635,
	"./cy": 64226,
	"./cy.js": 64226,
	"./da": 93601,
	"./da.js": 93601,
	"./de": 77853,
	"./de-at": 26111,
	"./de-at.js": 26111,
	"./de-ch": 54697,
	"./de-ch.js": 54697,
	"./de.js": 77853,
	"./dv": 60708,
	"./dv.js": 60708,
	"./el": 54691,
	"./el.js": 54691,
	"./en-au": 53872,
	"./en-au.js": 53872,
	"./en-ca": 28298,
	"./en-ca.js": 28298,
	"./en-gb": 56195,
	"./en-gb.js": 56195,
	"./en-ie": 66584,
	"./en-ie.js": 66584,
	"./en-il": 65543,
	"./en-il.js": 65543,
	"./en-in": 9033,
	"./en-in.js": 9033,
	"./en-nz": 79402,
	"./en-nz.js": 79402,
	"./en-sg": 43004,
	"./en-sg.js": 43004,
	"./eo": 32934,
	"./eo.js": 32934,
	"./es": 97650,
	"./es-do": 20838,
	"./es-do.js": 20838,
	"./es-mx": 17730,
	"./es-mx.js": 17730,
	"./es-us": 56575,
	"./es-us.js": 56575,
	"./es.js": 97650,
	"./et": 3035,
	"./et.js": 3035,
	"./eu": 3508,
	"./eu.js": 3508,
	"./fa": 119,
	"./fa.js": 119,
	"./fi": 90527,
	"./fi.js": 90527,
	"./fil": 95995,
	"./fil.js": 95995,
	"./fo": 52477,
	"./fo.js": 52477,
	"./fr": 85498,
	"./fr-ca": 26435,
	"./fr-ca.js": 26435,
	"./fr-ch": 37892,
	"./fr-ch.js": 37892,
	"./fr.js": 85498,
	"./fy": 37071,
	"./fy.js": 37071,
	"./ga": 41734,
	"./ga.js": 41734,
	"./gd": 70217,
	"./gd.js": 70217,
	"./gl": 77329,
	"./gl.js": 77329,
	"./gom-deva": 32124,
	"./gom-deva.js": 32124,
	"./gom-latn": 93383,
	"./gom-latn.js": 93383,
	"./gu": 95050,
	"./gu.js": 95050,
	"./he": 11713,
	"./he.js": 11713,
	"./hi": 43861,
	"./hi.js": 43861,
	"./hr": 26308,
	"./hr.js": 26308,
	"./hu": 90609,
	"./hu.js": 90609,
	"./hy-am": 17160,
	"./hy-am.js": 17160,
	"./id": 74063,
	"./id.js": 74063,
	"./is": 89374,
	"./is.js": 89374,
	"./it": 88383,
	"./it-ch": 21827,
	"./it-ch.js": 21827,
	"./it.js": 88383,
	"./ja": 23827,
	"./ja.js": 23827,
	"./jv": 89722,
	"./jv.js": 89722,
	"./ka": 41794,
	"./ka.js": 41794,
	"./kk": 27088,
	"./kk.js": 27088,
	"./km": 96870,
	"./km.js": 96870,
	"./kn": 84451,
	"./kn.js": 84451,
	"./ko": 63164,
	"./ko.js": 63164,
	"./ku": 98174,
	"./ku-kmr": 6181,
	"./ku-kmr.js": 6181,
	"./ku.js": 98174,
	"./ky": 78474,
	"./ky.js": 78474,
	"./lb": 79680,
	"./lb.js": 79680,
	"./lo": 15867,
	"./lo.js": 15867,
	"./lt": 45766,
	"./lt.js": 45766,
	"./lv": 69532,
	"./lv.js": 69532,
	"./me": 58076,
	"./me.js": 58076,
	"./mi": 41848,
	"./mi.js": 41848,
	"./mk": 30306,
	"./mk.js": 30306,
	"./ml": 73739,
	"./ml.js": 73739,
	"./mn": 99053,
	"./mn.js": 99053,
	"./mr": 86169,
	"./mr.js": 86169,
	"./ms": 73386,
	"./ms-my": 92297,
	"./ms-my.js": 92297,
	"./ms.js": 73386,
	"./mt": 77075,
	"./mt.js": 77075,
	"./my": 72264,
	"./my.js": 72264,
	"./nb": 22274,
	"./nb.js": 22274,
	"./ne": 8235,
	"./ne.js": 8235,
	"./nl": 92572,
	"./nl-be": 43784,
	"./nl-be.js": 43784,
	"./nl.js": 92572,
	"./nn": 54566,
	"./nn.js": 54566,
	"./oc-lnc": 69330,
	"./oc-lnc.js": 69330,
	"./pa-in": 29849,
	"./pa-in.js": 29849,
	"./pl": 94418,
	"./pl.js": 94418,
	"./pt": 79834,
	"./pt-br": 48303,
	"./pt-br.js": 48303,
	"./pt.js": 79834,
	"./ro": 24457,
	"./ro.js": 24457,
	"./ru": 82271,
	"./ru.js": 82271,
	"./sd": 1221,
	"./sd.js": 1221,
	"./se": 33478,
	"./se.js": 33478,
	"./si": 17538,
	"./si.js": 17538,
	"./sk": 5784,
	"./sk.js": 5784,
	"./sl": 46637,
	"./sl.js": 46637,
	"./sq": 86794,
	"./sq.js": 86794,
	"./sr": 45719,
	"./sr-cyrl": 3322,
	"./sr-cyrl.js": 3322,
	"./sr.js": 45719,
	"./ss": 56000,
	"./ss.js": 56000,
	"./sv": 41011,
	"./sv.js": 41011,
	"./sw": 40748,
	"./sw.js": 40748,
	"./ta": 11025,
	"./ta.js": 11025,
	"./te": 11885,
	"./te.js": 11885,
	"./tet": 28861,
	"./tet.js": 28861,
	"./tg": 86571,
	"./tg.js": 86571,
	"./th": 55802,
	"./th.js": 55802,
	"./tk": 59527,
	"./tk.js": 59527,
	"./tl-ph": 29231,
	"./tl-ph.js": 29231,
	"./tlh": 31052,
	"./tlh.js": 31052,
	"./tr": 85096,
	"./tr.js": 85096,
	"./tzl": 79846,
	"./tzl.js": 79846,
	"./tzm": 81765,
	"./tzm-latn": 97711,
	"./tzm-latn.js": 97711,
	"./tzm.js": 81765,
	"./ug-cn": 48414,
	"./ug-cn.js": 48414,
	"./uk": 16618,
	"./uk.js": 16618,
	"./ur": 57777,
	"./ur.js": 57777,
	"./uz": 57609,
	"./uz-latn": 72475,
	"./uz-latn.js": 72475,
	"./uz.js": 57609,
	"./vi": 21135,
	"./vi.js": 21135,
	"./x-pseudo": 64051,
	"./x-pseudo.js": 64051,
	"./yo": 82218,
	"./yo.js": 82218,
	"./zh-cn": 52648,
	"./zh-cn.js": 52648,
	"./zh-hk": 1632,
	"./zh-hk.js": 1632,
	"./zh-mo": 31541,
	"./zh-mo.js": 31541,
	"./zh-tw": 50304,
	"./zh-tw.js": 50304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35358;

/***/ }),

/***/ 35529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(39344),
    getPrototype = __webpack_require__(28879),
    isPrototype = __webpack_require__(55527);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 35749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(81042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 35813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CheckDepositItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CheckDepositItemView.vue?vue&type=template&id=5b469d2a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('Spinner'):_c('CheckDepositItem',{on:{"input":value => _vm.deposit = value},model:{value:(_vm.deposit),callback:function ($$v) {_vm.deposit=$$v},expression:"deposit"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CheckDepositItem/CheckDepositItem.vue?vue&type=template&id=4e5fa9d8
var CheckDepositItemvue_type_template_id_4e5fa9d8_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":"Remise de chèque","buttons":_vm.buttons}}),_c('AppMessages'),_c('b-card',[_c('b-row',[_c('b-col',[(_vm.value.account)?_c('b-form-group',{attrs:{"label":"Compte bancaire"}},[_vm._v(" "+_vm._s(_vm.value.account.name)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Date"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.date))+" ")]),_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Montant de la remise"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total))+" ")]),_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Nombre de chèque"}},[_vm._v(" "+_vm._s(_vm.value.count)+" ")])],1)],1)],1),_c('b-table',{attrs:{"striped":_vm.value.payments.length > 1,"bordered":"","fields":_vm.paymentsColumns,"items":_vm.value.payments,"per-page":_vm.perPage,"currentPage":_vm.currentPage,"small":"","table-class":"align-middle mt-4 text-nowrap","responsive":"","show-empty":"","empty-text":"Aucun paiement"},scopedSlots:_vm._u([{key:"cell(documents)",fn:function({ value }){return [_vm._l((value),function(use,i){return [(i > 0)?_c('span',{key:'separator' + i},[_vm._v(", ")]):_vm._e(),_c('router-link',{key:i,attrs:{"to":{ name: use.document_type + '-item', params: { id: String(use.document_id) } }}},[_vm._v(" "+_vm._s(use.document.reference)+" ")])]})]}},{key:"cell(action)",fn:function({ item }){return [_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: 'Voir la facture' }),expression:"{ title: 'Voir la facture' }",modifiers:{"left":true}}],staticClass:"p-0",attrs:{"variant":"icon","to":{ name: 'invoice-item', params: { id: String(item.invoice.id) }}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'search']}})],1)]}}])}),_c('b-pagination',{attrs:{"perPage":_vm.perPage,"total-rows":_vm.value.payments.length,"align":"center","size":"sm"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_c('b-modal',{attrs:{"hide-footer":"","hide-header":"","no-close-on-backdrop":"","no-close-on-esc":"","size":"sm"},model:{value:(_vm.downloading),callback:function ($$v) {_vm.downloading=$$v},expression:"downloading"}},[_c('Spinner',{attrs:{"size":"4"}})],1)],1)
}
var CheckDepositItemvue_type_template_id_4e5fa9d8_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: ./src/components/CheckDepositDelete/CheckDepositDelete.vue + 3 modules
var CheckDepositDelete = __webpack_require__(40397);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CheckDepositItem/CheckDepositItem.ts?vue&type=script&lang=ts&external







var CheckDepositItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CheckDepositItem, _super);
    function CheckDepositItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentPage = 1;
        _this.perPage = 20;
        _this.downloading = false;
        _this.paymentsColumns = [
            { key: 'date', label: 'Date', formatter: _this.date, sortable: true },
            { key: 'customer.name', label: 'Client', sortable: true },
            { key: 'documents', label: 'Document(s)', sortable: true },
            { key: 'check_bank', label: 'Banque émettrice', sortable: true },
            { key: 'check_issuer', label: 'Émetteur du chèque', sortable: true },
            { key: 'amount', label: 'Montant', thStyle: 'width: 150px', formatter: function (amount) { return _this.formattedNumber(amount); }, sortable: true }
        ];
        return _this;
    }
    CheckDepositItem.prototype.mounted = function () {
        interface_vue_.emitter.on('CheckDepositUpdated', this.CheckDepositUpdated);
    };
    CheckDepositItem.prototype.destroyed = function () {
        interface_vue_.emitter.off('CheckDepositUpdated', this.CheckDepositUpdated);
    };
    Object.defineProperty(CheckDepositItem.prototype, "buttons", {
        get: function () {
            var _this = this;
            var hasPdf = this.value.pdf_status === 2;
            return [
                {
                    label: 'Modifier',
                    to: { name: 'check-deposit-form', params: { id: String(this.value.id) } },
                },
                {
                    label: 'Télécharger',
                    disabled: !hasPdf,
                    title: hasPdf ? null : 'Le PDF est en cours de génération',
                    click: this.download
                },
                {
                    component: CheckDepositDelete/* default */.A,
                    attributes: {
                        value: this.value,
                        size: 'sm',
                        class: 'dropdown'
                    },
                    events: {
                        deleted: function () { return _this.$router.push({ name: 'check-deposit-list' }); }
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CheckDepositItem.prototype.CheckDepositUpdated = function (event) {
        if (event.id !== this.value.id || external_moment_default()(this.value.updated_at).isAfter(event.updated_at)) {
            return;
        }
        var deposit = JSON.parse(JSON.stringify(this.value));
        deposit.pdf_status = event.pdf_status;
        this.$emit('input', deposit);
    };
    // Send ajax query
    CheckDepositItem.prototype.download = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.downloading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/check-deposit/' + this.value.id + '/download')
                                .then(function (response) {
                                var file = response.data;
                                _this.downloadFile(file.file, file.filename);
                            })
                                .finally(function () {
                                _this.downloading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CheckDepositItem.prototype, "value", void 0);
    CheckDepositItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard, BTable: external_bootstrap_vue_.BTable, BPagination: external_bootstrap_vue_.BPagination, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormCheckbox: external_bootstrap_vue_.BFormCheckbox, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert, BModal: external_bootstrap_vue_.BModal,
                PageHeader: interface_vue_.PageHeader,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: interface_vue_.Spinner,
                AppMessages: interface_vue_.AppMessages
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CheckDepositItem);
    return CheckDepositItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin, interface_vue_.FileMixin)));
/* harmony default export */ var CheckDepositItemvue_type_script_lang_ts_external = (CheckDepositItem);

;// ./src/components/CheckDepositItem/CheckDepositItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CheckDepositItem_CheckDepositItemvue_type_script_lang_ts_external = (CheckDepositItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CheckDepositItem/CheckDepositItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CheckDepositItem_CheckDepositItemvue_type_script_lang_ts_external,
  CheckDepositItemvue_type_template_id_4e5fa9d8_render,
  CheckDepositItemvue_type_template_id_4e5fa9d8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CheckDepositItem_CheckDepositItem = (component.exports);
// EXTERNAL MODULE: ./src/mixins/CheckDepositMixin.ts
var CheckDepositMixin = __webpack_require__(18964);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CheckDepositItemView.vue?vue&type=script&lang=ts




var CheckDepositItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CheckDepositItemView, _super);
    function CheckDepositItemView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckDepositItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CheckDepositItem: CheckDepositItem_CheckDepositItem
            }
        })
    ], CheckDepositItemView);
    return CheckDepositItemView;
}((0,lib/* Mixins */.Xe)(CheckDepositMixin/* default */.A)));
/* harmony default export */ var CheckDepositItemViewvue_type_script_lang_ts = (CheckDepositItemView);

;// ./src/views/CheckDepositItemView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CheckDepositItemViewvue_type_script_lang_ts = (CheckDepositItemViewvue_type_script_lang_ts); 
;// ./src/views/CheckDepositItemView.vue





/* normalize component */
;
var CheckDepositItemView_component = (0,componentNormalizer/* default */.A)(
  views_CheckDepositItemViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CheckDepositItemView = (CheckDepositItemView_component.exports);

/***/ }),

/***/ 36211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SignConfig_SignConfig; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SignConfig/SignConfig.vue?vue&type=template&id=0a3a400e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-form-group',{attrs:{"label":"Logo à afficher sur la page de signature :"}},[(_vm.localTeam.logo_sign_email)?[_c('p',{staticClass:"mb-2"},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":'data:image/png;base64,' + _vm.localTeam.logo_sign_email.file}})]),_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.askDeleteLogo = true}}},[_vm._v(" Supprimer ")]),_c('b-modal',{attrs:{"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"no-close-on-backdrop":_vm.deleting,"no-close-on-esc":_vm.deleting,"busy":_vm.deleting,"hide-header-close":_vm.deleting},on:{"hidden":function($event){_vm.deleting = false},"ok":_vm.deleteLogo},model:{value:(_vm.askDeleteLogo),callback:function ($$v) {_vm.askDeleteLogo=$$v},expression:"askDeleteLogo"}},[(_vm.deleting)?_c('Spinner'):[_vm._v(" Êtes-vous sûr de vouloir supprimer le logo ? ")]],2)]:_c('k-form-file',{attrs:{"accept":['image/png', 'image/jpeg'],"url":"/team?with_file=1","name":"logo_sign_email","method":"POST","datas":{ _method: 'put' },"required":"","btnMode":"","btnSize":"sm","btnTheme":"secondary","removeUploadedFile":""},on:{"onUpload":_vm.logoUpdated}})],2),(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{staticClass:"mt-4 d-inline-block",attrs:{"label":"Durée de validité d'une demande de signature"}},[_c('b-input-group',{attrs:{"append":"jour(s)"}},[_c('k-form-number',{attrs:{"name":"configs[sign_expiration_delay]","min":1},model:{value:(_vm.localConfig.sign_expiration_delay),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_expiration_delay", $$v)},expression:"localConfig.sign_expiration_delay"}})],1)],1),_c('b-form-group',{attrs:{"label":"Lors de la signature d'un contrat :"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sign_contract_add_sepa]"},domProps:{"value":_vm.localConfig.sign_contract_add_sepa ?? false}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.localConfig.sign_contract_add_sepa),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_contract_add_sepa", $$v)},expression:"localConfig.sign_contract_add_sepa"}},[_vm._v(" Joindre automatiquement le mandat SEPA ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sign_contract_add_quotation]"},domProps:{"value":_vm.localConfig.sign_contract_add_quotation ?? false}}),_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.localConfig.sign_contract_add_quotation),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_contract_add_quotation", $$v)},expression:"localConfig.sign_contract_add_quotation"}},[_vm._v(" Joindre automatiquement le devis lié ")])],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Relances automatiques ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sign_expiration_reminder]"},domProps:{"value":_vm.localConfig.sign_expiration_reminder ?? false}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.localConfig.sign_expiration_reminder),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_expiration_reminder", $$v)},expression:"localConfig.sign_expiration_reminder"}},[_vm._v(" Relancer automatiquement le destinataire ")]),(_vm.localConfig.sign_expiration_reminder)?[_c('div',{staticClass:"d-inline-block"},[_c('b-input-group',{staticClass:"mt-3",attrs:{"size":"sm","prepend":"Tous les","append":"jour(s)"}},[_c('k-form-number',{attrs:{"name":"configs[sign_expiration_reminder_delay]","min":1,"size":"sm"},model:{value:(_vm.localConfig.sign_expiration_reminder_delay),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_expiration_reminder_delay", $$v)},expression:"localConfig.sign_expiration_reminder_delay"}})],1)],1),_c('b-form-group',{staticClass:"mt-3",attrs:{"label":"Modèle d'email pour les relances"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sign_reminder_model]"},domProps:{"value":_vm.localConfig.sign_reminder_model ? _vm.localConfig.sign_reminder_model.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name","validate":"modelSignatureLink"},model:{value:(_vm.localConfig.sign_reminder_model),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_reminder_model", $$v)},expression:"localConfig.sign_reminder_model"}})],1)]:_vm._e(),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Modèle d'email par défaut : ")]),_c('b-form-group',{attrs:{"label":"Signature d'un devis"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sign_model_quotation]"},domProps:{"value":_vm.localConfig.sign_model_quotation ? _vm.localConfig.sign_model_quotation.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name","validate":"modelSignatureLink"},model:{value:(_vm.localConfig.sign_model_quotation),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_model_quotation", $$v)},expression:"localConfig.sign_model_quotation"}})],1),_c('b-form-group',{attrs:{"label":"Signature d'un bon de commande"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sign_model_command]"},domProps:{"value":_vm.localConfig.sign_model_command ? _vm.localConfig.sign_model_command.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name","validate":"modelSignatureLink"},model:{value:(_vm.localConfig.sign_model_command),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_model_command", $$v)},expression:"localConfig.sign_model_command"}})],1),_c('b-form-group',{attrs:{"label":"Signature d'un mandat SEPA"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sign_model_sepa]"},domProps:{"value":_vm.localConfig.sign_model_sepa ? _vm.localConfig.sign_model_sepa.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name","validate":"modelSignatureLink"},model:{value:(_vm.localConfig.sign_model_sepa),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_model_sepa", $$v)},expression:"localConfig.sign_model_sepa"}})],1),_c('b-form-group',{attrs:{"label":"Signature d'un contrat"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sign_model_contract]"},domProps:{"value":_vm.localConfig.sign_model_contract ? _vm.localConfig.sign_model_contract.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name","validate":"modelSignatureLink"},model:{value:(_vm.localConfig.sign_model_contract),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_model_contract", $$v)},expression:"localConfig.sign_model_contract"}})],1),_c('b-form-group',{attrs:{"label":"Signature d'une fiche d'intervention (Chantiers)"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sign_model_construction]"},domProps:{"value":_vm.localConfig.sign_model_construction ? _vm.localConfig.sign_model_construction.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name","validate":"modelSignatureLink"},model:{value:(_vm.localConfig.sign_model_construction),callback:function ($$v) {_vm.$set(_vm.localConfig, "sign_model_construction", $$v)},expression:"localConfig.sign_model_construction"}})],1),_c('k-form-sticky-bar',{attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SignConfig/SignConfig.ts?vue&type=script&lang=ts&external






var SignConfig = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignConfig, _super);
    function SignConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.askDeleteLogo = false;
        _this.deleting = false;
        _this.loading = false;
        return _this;
    }
    SignConfig.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadModels()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SignConfig.prototype, "isSignableModel", {
        get: function () {
            return function (model) {
                if (!model) {
                    return false;
                }
                var regex = /<variable([a-zA-Z0-9-_"' ]*?)data-variable="SIGN-LINK"(.*?)<\/variable>/gs;
                return regex.test(model.html);
            };
        },
        enumerable: false,
        configurable: true
    });
    SignConfig.prototype.logoUpdated = function (team) {
        this.setTeam(team);
    };
    SignConfig.prototype.deleteLogo = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.deleting = true;
                        return [4 /*yield*/, this.$kwSales.axios.put('/team?with_file=1', {
                                logo_sign_email: null
                            })
                                .then(function (response) {
                                _this.setTeam(response.data);
                                _this.askDeleteLogo = false;
                                _this.deleting = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SignConfig = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormFile: form_vue_.KFormFile, KFormCheckbox: form_vue_.KFormCheckbox, KForm: form_vue_.KForm, KFormStickyBar: form_vue_.KFormStickyBar, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber,
                BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BAlert: external_bootstrap_vue_.BAlert,
                Spinner: interface_vue_.Spinner
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('communication', ['models'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['loadModels']))
        })
    ], SignConfig);
    return SignConfig;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var SignConfigvue_type_script_lang_ts_external = (SignConfig);

;// ./src/components/SignConfig/SignConfig.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SignConfig_SignConfigvue_type_script_lang_ts_external = (SignConfigvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SignConfig/SignConfig.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SignConfig_SignConfigvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignConfig_SignConfig = (component.exports);

/***/ }),

/***/ 36325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_InvoiceListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/InvoiceListView.vue?vue&type=template&id=d4ebf760
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InvoiceList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/InvoiceList/InvoiceList.vue + 2 modules
var InvoiceList = __webpack_require__(39690);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/InvoiceListView.vue?vue&type=script&lang=ts



var InvoiceListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(InvoiceListView, _super);
    function InvoiceListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoiceListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                InvoiceList: InvoiceList/* default */.A
            }
        })
    ], InvoiceListView);
    return InvoiceListView;
}(lib/* Vue */.lD));
/* harmony default export */ var InvoiceListViewvue_type_script_lang_ts = (InvoiceListView);

;// ./src/views/InvoiceListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_InvoiceListViewvue_type_script_lang_ts = (InvoiceListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/InvoiceListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_InvoiceListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_InvoiceListView = (component.exports);

/***/ }),

/***/ 36440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FecDownload_FecDownload; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FecDownload/FecDownload.vue?vue&type=template&id=263c0b25
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.download(_vm.id)}}},[_vm._v(" "+_vm._s(_vm.$t('kwTable.exports.download'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/mixins/FecMixin.ts
var FecMixin = __webpack_require__(67912);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FecDownload/FecDownload.ts?vue&type=script&lang=ts&external




var FecDownload = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FecDownload, _super);
    function FecDownload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FecDownload.prototype, "id", void 0);
    FecDownload = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], FecDownload);
    return FecDownload;
}((0,lib/* Mixins */.Xe)(FecMixin/* default */.A)));
/* harmony default export */ var FecDownloadvue_type_script_lang_ts_external = (FecDownload);

;// ./src/components/FecDownload/FecDownload.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FecDownload_FecDownloadvue_type_script_lang_ts_external = (FecDownloadvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/FecDownload/FecDownload.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FecDownload_FecDownloadvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FecDownload_FecDownload = (component.exports);

/***/ }),

/***/ 36505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractModelDuplicate_ContractModelDuplicate; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractModelDuplicate/ContractModelDuplicate.vue?vue&type=template&id=4ff9891f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.errorMsg ? _vm.$t('interface.close') : 'Dupliquer',"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir dupliquer ce modèle de contrat ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractModelDuplicate/ContractModelDuplicate.ts?vue&type=script&lang=ts&external




var ContractModelDuplicate = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractModelDuplicate, _super);
    function ContractModelDuplicate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ContractModelDuplicate.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    ContractModelDuplicate.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    ContractModelDuplicate.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    ContractModelDuplicate.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.post('/sales/contract-model/' + this.value.id + '/duplicate')
            .then(function (response) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({
                            name: 'contract-models-form',
                            params: {
                                id: String(response.data.id)
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    ContractModelDuplicate.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    ContractModelDuplicate.prototype.canceled = function () {
        this.$emit('canceled');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractModelDuplicate.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ContractModelDuplicate.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], ContractModelDuplicate.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractModelDuplicate.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractModelDuplicate.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractModelDuplicate.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ContractModelDuplicate.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], ContractModelDuplicate.prototype, "watchModalState", null);
    ContractModelDuplicate = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ContractModelDuplicate);
    return ContractModelDuplicate;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractModelDuplicatevue_type_script_lang_ts_external = (ContractModelDuplicate);

;// ./src/components/ContractModelDuplicate/ContractModelDuplicate.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractModelDuplicate_ContractModelDuplicatevue_type_script_lang_ts_external = (ContractModelDuplicatevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractModelDuplicate/ContractModelDuplicate.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractModelDuplicate_ContractModelDuplicatevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractModelDuplicate_ContractModelDuplicate = (component.exports);

/***/ }),

/***/ 36668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ContractModelsListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractModelsListView.vue?vue&type=template&id=1124083d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":"Modèles de contrats"}},[_c('ContractModelList')],1),_c('b-tab',{attrs:{"title":"Numérotation des contrats"}},[_c('ContractParams')],1),_c('b-tab',{attrs:{"title":"Notifications"}},[_c('ContractNotifications')],1),_c('b-tab',{attrs:{"title":"Emails"}},[_c('ContractMail')],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/ContractModelList/ContractModelList.vue + 3 modules
var ContractModelList = __webpack_require__(2151);
// EXTERNAL MODULE: ./src/components/ContractParams/ContractParams.vue + 3 modules
var ContractParams = __webpack_require__(10586);
// EXTERNAL MODULE: ./src/components/ContractNotifications/ContractNotifications.vue + 3 modules
var ContractNotifications = __webpack_require__(32818);
// EXTERNAL MODULE: ./src/components/ContractMail/ContractMail.vue + 8 modules
var ContractMail = __webpack_require__(13250);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractModelsListView.vue?vue&type=script&lang=ts







var ContractModelsListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractModelsListView, _super);
    function ContractModelsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContractModelsListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContractModelList: ContractModelList/* default */.A, ContractParams: ContractParams/* default */.A, ContractNotifications: ContractNotifications/* default */.A, ContractMail: ContractMail/* default */.A,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab
            }
        })
    ], ContractModelsListView);
    return ContractModelsListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractModelsListViewvue_type_script_lang_ts = (ContractModelsListView);

;// ./src/views/ContractModelsListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContractModelsListViewvue_type_script_lang_ts = (ContractModelsListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/ContractModelsListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContractModelsListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ContractModelsListView = (component.exports);

/***/ }),

/***/ 36800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(75288),
    isArrayLike = __webpack_require__(64894),
    isIndex = __webpack_require__(30361),
    isObject = __webpack_require__(23805);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 36898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarDocuments_CarDocuments; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarDocuments/CarDocuments.vue?vue&type=template&id=53f50639
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('b-table',{staticClass:"mt-2 car-document-list",attrs:{"items":_vm.documents,"fields":_vm.fields,"small":"","bordered":"","per-page":10,"current-page":_vm.page,"sort-by":"reference","sort-desc":true,"showEmpty":"","emptyText":"Aucun élément","hover":""},on:{"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"table-colgroup",fn:function(scope){return _vm._l((scope.fields),function(field){return _c('col',{key:field.key,style:({ width: field.width })})})}},{key:"cell(mileage)",fn:function({ value }){return [_vm._v(" "+_vm._s(value ? value + ' km' : null)+" ")]}},{key:"cell(date)",fn:function({ value }){return [_vm._v(" "+_vm._s(_vm.date(value))+" ")]}},{key:"cell(total_ttc)",fn:function({ value }){return [_vm._v(" "+_vm._s(_vm.formattedNumber(value))+" ")]}}])}),(_vm.total > 10)?_c('b-pagination',{attrs:{"size":"sm","per-page":10,"total-rows":_vm.total,"align":"center"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarDocuments/CarDocuments.ts?vue&type=script&lang=ts&external




var CarDocuments = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarDocuments, _super);
    function CarDocuments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.documents = [];
        _this.page = 1;
        _this.total = 0;
        _this.fields = [
            {
                key: 'reference',
                label: 'Référence',
                sortable: true
            },
            {
                key: 'date',
                sortable: true,
                width: '120px',
                class: 'text-center'
            },
            {
                key: 'mileage',
                label: 'Kilométrage',
                sortable: true,
                width: '130px',
                thClass: 'text-center',
                tdClass: 'text-right'
            },
            {
                key: 'total_ttc',
                label: 'Total TTC',
                sortable: true,
                tdClass: 'text-right'
            }
        ];
        return _this;
    }
    CarDocuments.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/' + this.type, {
                                params: {
                                    per_page: 500,
                                    sort: 'reference:desc',
                                    filter: {
                                        car: this.car.id
                                    }
                                }
                            })
                                .then(function (response) {
                                _this.documents = response.data.data;
                                _this.total = response.data.meta.total;
                            })];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CarDocuments.prototype.rowClicked = function (item) {
        this.$emit('redirect');
        this.$router.push({
            name: this.type + '-item',
            params: {
                id: String(item.id)
            }
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarDocuments.prototype, "car", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarDocuments.prototype, "type", void 0);
    CarDocuments = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BTable: external_bootstrap_vue_.BTable, BPagination: external_bootstrap_vue_.BPagination,
                Spinner: interface_vue_.Spinner
            }
        })
    ], CarDocuments);
    return CarDocuments;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var CarDocumentsvue_type_script_lang_ts_external = (CarDocuments);

;// ./src/components/CarDocuments/CarDocuments.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarDocuments_CarDocumentsvue_type_script_lang_ts_external = (CarDocumentsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarDocuments/CarDocuments.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarDocuments_CarDocumentsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarDocuments_CarDocuments = (component.exports);

/***/ }),

/***/ 36944:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRound = __webpack_require__(73893);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;


/***/ }),

/***/ 37071:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ 37167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(27301),
    nodeUtil = __webpack_require__(86009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 37217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80079),
    stackClear = __webpack_require__(51420),
    stackDelete = __webpack_require__(90938),
    stackGet = __webpack_require__(63605),
    stackHas = __webpack_require__(29817),
    stackSet = __webpack_require__(80945);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 37241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(70695),
    baseKeysIn = __webpack_require__(72903),
    isArrayLike = __webpack_require__(64894);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 37280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ RecoveryInvoicesView_RecoveryInvoiceView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RecoveryInvoicesView/RecoveryInvoiceView.vue?vue&type=template&id=1a399bcf
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[(_vm.value.auto_send && _vm.value.type === 'email')?_c('b-alert',{staticClass:"font-weight-bold text-center",attrs:{"show":"","variant":"warning"}},[_vm._v(" Les factures présentes à cette étape sont relancées automatiquement à "+_vm._s(_vm.value.auto_send_hour)+"H00 si le client ou le contact présent sur la facture possède une adresse email. ")]):_vm._e(),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.showAlreadyReminder),callback:function ($$v) {_vm.showAlreadyReminder=$$v},expression:"showAlreadyReminder"}},[_vm._v(" Afficher les factures déjà relancées ")]),_c('k-table',{ref:"table",staticClass:"recovery-invoices-table",attrs:{"url":"/sales/invoice","ajaxDatas":_vm.queryParams,"columns":_vm.finalColumns,"rowClass":_vm.rowClass,"filters":_vm.computedFilters,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"stateKey":"sales-recovery-invoices","exportable":_vm.exportComponent,"exportProps":{ model: 'invoice' },"sortIndex":2,"sortOrder":"asc"}}),(_vm.invoiceLetter)?_c('LetterForm',{attrs:{"elements":_vm.getLinkedElements(_vm.invoiceLetter),"value":{
        subject: _vm.htmltoText(this.replaceVariables(_vm.value.subject, _vm.getLinkedElements(_vm.invoiceLetter), _vm.invoiceLetter.contact)),
        send_ar: _vm.value.send_ar,
        customer: _vm.invoiceLetter.customer,
        contact: _vm.invoiceLetter.contact,
        address: _vm.getPostalAddress(_vm.invoiceLetter),
        content: _vm.replaceVariables(_vm.value.message, _vm.getLinkedElements(_vm.invoiceLetter), _vm.invoiceLetter.contact),
        attachments: _vm.getAttachments(_vm.invoiceLetter),
        is_reminder: true
      },"modalState":true,"customer":_vm.invoiceLetter.customer,"contact":_vm.invoiceLetter.contact},on:{"hidden":function($event){_vm.invoiceLetter = null},"submitComplete":_vm.refreshDatas}}):(_vm.invoiceReport)?_c('ReportForm',{attrs:{"elements":_vm.getLinkedElements(_vm.invoiceReport),"value":_vm.reportAttributes,"modalState":true,"customer":_vm.invoiceReport.customer,"contact":_vm.invoiceReport.contact},on:{"hidden":function($event){_vm.invoiceReport = null},"submitComplete":_vm.refreshDatas}}):_vm._e(),(_vm.passStep)?_c('b-modal',{attrs:{"visible":"","ok-title":_vm.$t('interface.continue'),"cancel-title":_vm.$t('interface.cancel')},on:{"ok":_vm.processPassStep,"hidden":function($event){_vm.passStep = null}}},[(_vm.passStepLoading)?_c('Spinner'):[_vm._v(" Êtes-vous sûr de vouloir passer cette étape ? ")]],2):_vm._e()]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/communication-vue"
var communication_vue_ = __webpack_require__(43055);
// EXTERNAL MODULE: ./src/components/InvoiceList/InvoiceList.vue + 2 modules
var InvoiceList = __webpack_require__(39690);
// EXTERNAL MODULE: ./src/components/StripeSend/VariablesMixin.ts
var VariablesMixin = __webpack_require__(2787);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/RecoveryInvoicesView/RecoveryInvoiceView.ts?vue&type=script&lang=ts&external











var RecoveryInvoiceView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(RecoveryInvoiceView, _super);
    function RecoveryInvoiceView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.showAlreadyReminder = false;
        _this.invoiceLetter = null;
        _this.invoiceReport = null;
        _this.passStep = null;
        _this.passStepLoading = false;
        return _this;
    }
    RecoveryInvoiceView.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadRecoverySteps()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadReportTypes()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RecoveryInvoiceView.prototype, "stepIndex", {
        get: function () {
            var _this = this;
            return this.recoverySteps.findIndex(function (el) { return el.id === _this.value.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecoveryInvoiceView.prototype, "nextStep", {
        get: function () {
            var index = this.stepIndex + 1;
            return index > this.recoverySteps.length ? null : this.recoverySteps[index];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecoveryInvoiceView.prototype, "queryParams", {
        get: function () {
            var params = {
                include: [
                    'customer', 'contact', 'billing_address_country', 'delivery_address_country',
                    'currency', 'teamUser', 'tags', 'affairs', 'pdf', 'billing_contact'
                ],
                filter: {
                    status: [2, 3, 4],
                    with_automatic_reminder: true
                }
            };
            if (!this.nextStep) {
                params.filter.expire_until = external_moment_default()().add(-this.value.delay, 'days').format('YYYY-MM-DD');
            }
            else {
                params.filter.expire_since = external_moment_default()().add(-(this.nextStep.delay - 1), 'days').format('YYYY-MM-DD');
                params.filter.expire_until = external_moment_default()().add(-this.value.delay, 'days').format('YYYY-MM-DD');
            }
            if (!this.showAlreadyReminder) {
                params.filter.no_reminder_since = this.reminderSinceDate;
            }
            return params;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecoveryInvoiceView.prototype, "reminderSinceDate", {
        get: function () {
            if (!this.nextStep) {
                return external_moment_default()().add(-this.value.delay, 'days').format('YYYY-MM-DD');
            }
            return external_moment_default()().add(-(this.nextStep.delay - 1), 'days').format('YYYY-MM-DD');
        },
        enumerable: false,
        configurable: true
    });
    RecoveryInvoiceView.prototype.rowClass = function (row) {
        return {
            finish: row.last_reminder && external_moment_default()(row.last_reminder).isSameOrAfter(this.reminderSinceDate)
        };
    };
    Object.defineProperty(RecoveryInvoiceView.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    label: 'Relancer',
                    variant: 'primary',
                    click: function (invoice) {
                        var type = _this.value.type;
                        if ((type === 'letter' && !_this.hasModule('communication-letters'))
                            || (type === 'phone' && !_this.hasModule('communication-reports'))) {
                            type = 'mail';
                        }
                        var customer = invoice.customer;
                        var contact = invoice.contact;
                        var elements = _this.getLinkedElements(invoice);
                        var to = [];
                        var billingContact = invoice.billing_contact;
                        switch (type) {
                            case 'mail':
                                if (billingContact && billingContact.email) {
                                    to.push({
                                        id: billingContact.id,
                                        type: 'contact',
                                        mail: billingContact.email,
                                        name: billingContact.fullname,
                                        element: {
                                            id: billingContact.id,
                                            type: 'contact'
                                        },
                                        data: billingContact
                                    });
                                }
                                _this.openMailForm({
                                    customer: customer,
                                    contact: contact,
                                    mail: {
                                        subject: _this.htmltoText(_this.replaceVariables(_this.value.subject, elements, contact)),
                                        html: _this.replaceVariables(_this.value.message, elements, contact),
                                        elements: elements,
                                        add_files: _this.getAttachments(invoice),
                                        is_reminder: true,
                                        to: to
                                    }
                                });
                                break;
                            case 'letter':
                                _this.invoiceLetter = invoice;
                                break;
                            case 'phone':
                                _this.invoiceReport = invoice;
                                break;
                        }
                    }
                },
                {
                    label: 'Passer',
                    variant: 'secondary',
                    title: 'Passer cette étape de relance',
                    click: function (invoice) {
                        _this.passStep = invoice;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecoveryInvoiceView.prototype, "reportAttributes", {
        get: function () {
            var _a;
            var invoice = this.invoiceReport;
            return {
                subject: this.value.subject,
                type_id: ((_a = this.reportTypes.find(function (report) { return report.use_default; })) !== null && _a !== void 0 ? _a : this.reportTypes[0]).id,
                customer: invoice.customer,
                recipients: this.getRecipients(invoice),
                date: external_moment_default()().format('YYYY-MM-DD HH:mm:ss'),
                is_reminder: true
            };
        },
        enumerable: false,
        configurable: true
    });
    RecoveryInvoiceView.prototype.getLinkedElements = function (invoice) {
        return [
            {
                id: invoice.id,
                type: 'invoice',
                title: invoice.reference,
                data: invoice
            }
        ];
    };
    RecoveryInvoiceView.prototype.getAttachments = function (invoice) {
        var attachments = [];
        if (invoice.pdf) {
            attachments.push(invoice.pdf);
        }
        return attachments;
    };
    // Generate the address
    RecoveryInvoiceView.prototype.getPostalAddress = function (invoice) {
        var _a;
        var noEmpty = function (part) { return part !== '' && part !== undefined && part !== null; };
        var part = [];
        if (invoice.customer)
            part.push(invoice.customer.name);
        if (invoice.contact)
            part.push(invoice.contact.fullname);
        var address = invoice.billing_address;
        part.push.apply(part, [
            address.road,
            address.road2,
            address.road3,
            [address.postal_code, address.city].filter(noEmpty).join(' '),
            (_a = address.country) === null || _a === void 0 ? void 0 : _a.name
        ]);
        return part.filter(noEmpty).join("\n");
    };
    RecoveryInvoiceView.prototype.getRecipients = function (invoice) {
        var recipients = [];
        if (invoice.customer) {
            recipients.push({
                type: 'customer',
                label: invoice.customer.name,
                id: invoice.customer.id,
                data: invoice.customer
            });
        }
        if (invoice.contact) {
            recipients.push({
                type: 'contact',
                label: invoice.contact.fullname,
                id: invoice.contact.id,
                data: invoice.contact
            });
        }
        return recipients;
    };
    RecoveryInvoiceView.prototype.processPassStep = function (event) {
        var _this = this;
        var _a;
        event.preventDefault();
        this.passStepLoading = true;
        this.$kwSales.axios.post('/sales/recovery-step/pass-step/' + ((_a = this.passStep) === null || _a === void 0 ? void 0 : _a.id))
            .then(function () {
            _this.refreshDatas();
            _this.passStepLoading = false;
            _this.passStep = null;
        });
    };
    RecoveryInvoiceView.prototype.watchFilter = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.refreshDatas();
        });
    };
    RecoveryInvoiceView.prototype.refreshDatas = function () {
        this.$refs.table.refresh();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], RecoveryInvoiceView.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('showAlreadyReminder')
    ], RecoveryInvoiceView.prototype, "watchFilter", null);
    RecoveryInvoiceView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                KFormCheckbox: form_vue_.KFormCheckbox,
                Spinner: interface_vue_.Spinner,
                BAlert: external_bootstrap_vue_.BAlert, BModal: external_bootstrap_vue_.BModal,
                LetterForm: communication_vue_.LetterForm, ReportForm: communication_vue_.ReportForm
            },
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadRecoverySteps'])), (0,external_vuex_.mapActions)('communication', ['openMailForm', 'loadReportTypes'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('sales', ['recoverySteps'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('communication', ['reportTypes']))
        })
    ], RecoveryInvoiceView);
    return RecoveryInvoiceView;
}((0,lib/* Mixins */.Xe)(InvoiceList/* default */.A, VariablesMixin/* default */.A)));
/* harmony default export */ var RecoveryInvoiceViewvue_type_script_lang_ts_external = (RecoveryInvoiceView);

;// ./src/components/RecoveryInvoicesView/RecoveryInvoiceView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var RecoveryInvoicesView_RecoveryInvoiceViewvue_type_script_lang_ts_external = (RecoveryInvoiceViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/RecoveryInvoicesView/RecoveryInvoiceView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  RecoveryInvoicesView_RecoveryInvoiceViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RecoveryInvoicesView_RecoveryInvoiceView = (component.exports);

/***/ }),

/***/ 37334:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 37828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 37856:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'check-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f058';
var svgPathData = 'M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.SG = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 37892:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ 37915:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'truck';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f0d1';
var svgPathData = 'M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.r = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 38310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentDelivery_DocumentDelivery; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentDelivery/DocumentDelivery.vue?vue&type=template&id=864fa88a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.btnLabel)+" "),_c('FormModal',{attrs:{"ok-only":_vm.errorMsg !== null,"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"size":"xxl","title":'Livraison du ' + _vm.$t('sales.' + _vm.type + '.reference', { reference: _vm.document.reference })},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_c('k-form',{attrs:{"action":_vm.formUrl,"method":"POST"},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Date"}},[_c('k-form-datepicker',{attrs:{"name":"date","size":"sm","required":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_c('b-col',{staticClass:"mt-md-4 pt-md-1",attrs:{"cols":"12","md":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.draft}}),_c('k-form-checkbox',{model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}},[_vm._v(" Créer en brouillon ")])],1),(_vm.hasModule('stock-locations'))?_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Lieu de stock"}},[_c('input',{attrs:{"type":"hidden","name":"stock_location"},domProps:{"value":_vm.location?.id ?? null}}),_c('StockLocationSelect',{attrs:{"selectDefault":"","required":""},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1)],1):_vm._e(),_c('b-col',{staticClass:"text-right",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","disabled":_vm.isFullDelivered},on:{"click":function($event){$event.preventDefault();return _vm.deliverAll.apply(null, arguments)}}},[_vm._v(" Tout marquer comme livré ")])],1)],1),_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm table-bordered text-nowrap"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"140px"}},[_vm._v("Réf.")]),_c('th',[_vm._v("Désignation")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("Qté cmd")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("Déjà livrée")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"120px"}},[_vm._v("Reste à livrer")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("Quantité")])])]),_c('tbody',[_vm._l((_vm.contents),function(content,i){return [_c('tr',{key:i},[_c('td',{staticClass:"pt-2"},[_vm._v(_vm._s(content.reference))]),_c('td',{class:{
                    'pt-2': true,
                    'pb-2 border-0': _vm.withStockLot(content),
                    'text-wrap': true
                  }},[_c('FroalaView',{model:{value:(content.designation),callback:function ($$v) {_vm.$set(content, "designation", $$v)},expression:"content.designation"}})],1),_c('td',{staticClass:"text-center pt-2"},[_vm._v(_vm._s(_vm.showNumber(content.total_quantity)))]),_c('td',{staticClass:"text-center pt-2"},[_vm._v(_vm._s(_vm.showNumber(content.delivered_quantity)))]),_c('td',{staticClass:"text-center pt-2"},[_vm._v(_vm._s(_vm.showNumber(content.quantity_to_deliver)))]),_c('td',[_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][affair_content]'},domProps:{"value":content.affair_content_id}}),_c('k-form-spinner',{attrs:{"min":0,"max":_vm.maxQuantity(content),"maxDecimal":5,"size":"sm","name":'contents[' + i + '][quantity]',"readonly":Number(content.quantity_to_deliver) === 0},model:{value:(_vm.contents[i].to_deliver),callback:function ($$v) {_vm.$set(_vm.contents[i], "to_deliver", $$v)},expression:"contents[i].to_deliver"}}),(content.catalog && content.catalog.element && content.catalog.type === 'product' && content.catalog.element.with_stock)?_c('ProductStockIndicator',{attrs:{"product":content.catalog.element,"variation":content.variation,"location":_vm.location,"theorical":_vm.teamConfigs.sales_stock_quantity_to_use === 1,"real":_vm.teamConfigs.sales_stock_quantity_to_use === 0}}):_vm._e()],1)]),(_vm.withStockLot(content) && _vm.contents[i].to_deliver)?_c('tr',{key:'lot-' + i},[_c('td'),_c('td',{staticClass:"border-top-0 pt-3 pb-3",attrs:{"colspan":"5"}},[_c('LotSelected',{attrs:{"quantity":_vm.contents[i].to_deliver,"product":content.catalog?.element,"usedLots":_vm.contents[i].used_lots,"autoSelect":_vm.teamConfigs.stock_tracabilities_auto_select,"lotsFilter":lot => lot.delivery_marker === undefined || lot.delivery_marker === null},model:{value:(_vm.contents[i]),callback:function ($$v) {_vm.$set(_vm.contents, i, $$v)},expression:"contents[i]"}}),_vm._l((_vm.contents[i].used_lots),function(lot,index){return [_c('input',{key:'id-' + index,attrs:{"type":"hidden","name":'contents[' + i + '][use_lots][' + index + '][lot]'},domProps:{"value":lot.lot.id}}),_c('input',{key:'quantity-' + index,attrs:{"type":"hidden","name":'contents[' + i + '][use_lots][' + index + '][quantity]'},domProps:{"value":lot.quantity}})]})],2)]):_vm._e()]})],2)])])],1)]],2)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/catalog-vue"
var catalog_vue_ = __webpack_require__(68480);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentDelivery/DocumentDelivery.ts?vue&type=script&lang=ts&external








var DocumentDelivery = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentDelivery, _super);
    function DocumentDelivery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.errorMsg = null;
        _this.contents = [];
        _this.date = new Date();
        _this.draft = true;
        _this.location = null;
        return _this;
    }
    DocumentDelivery.prototype.mounted = function () {
        this.draft = !this.teamConfigs.sales_delivery_valid;
    };
    Object.defineProperty(DocumentDelivery.prototype, "modalTitle", {
        get: function () {
            return ('Livraison du ' + String(this.$t('sales.' + this.type + '.reference', { reference: this.document.reference })).toLowerCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "btnLabel", {
        get: function () {
            if (this.label) {
                return this.label;
            }
            return this.document.delivery_status === 1 ? 'Livrer' : 'Livrer le reste';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "isFullDelivered", {
        get: function () {
            return this.contents.filter(function (content) {
                return content.quantity_to_deliver > 0 && Number(content.quantity_to_deliver) !== Number(content.to_deliver);
            }).length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "formUrl", {
        get: function () {
            return '/sales/' + this.type + '/' + this.document.id + '/deliver';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "withStockLot", {
        get: function () {
            var _this = this;
            return function (content) {
                var _a, _b;
                if (!_this.hasModule('stock-tracabilities') || ((_a = content.catalog) === null || _a === void 0 ? void 0 : _a.type) !== 'product' || !((_b = content.catalog) === null || _b === void 0 ? void 0 : _b.element)) {
                    return false;
                }
                var product = content.catalog.element;
                return product.stock_tracking_mode !== 0;
                // content.product.stock_tracking_mode !== 0 && (content.quantity > 0 || (content.createdLots && content.createdLots.length > 0))
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "usedLots", {
        get: function () {
            var _this = this;
            return function (index) {
                var selected = [];
                _this.contents.filter(function (content, i) { return i !== index && content.used_lots !== undefined; })
                    .forEach(function (content) {
                    selected.push.apply(selected, content.used_lots);
                });
                return selected;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "maxQuantity", {
        get: function () {
            var _this = this;
            return function (content) {
                var _a;
                var stockKey = _this.teamConfigs.sales_stock_quantity_to_use === 0 ? 'stock_quantity' : 'stock_theoretical_quantity';
                var element = (_a = content.catalog) === null || _a === void 0 ? void 0 : _a.element;
                if (_this.teamConfigs.sales_stock_delivery_quantity === 2 && element && stockKey in element) {
                    return _this.number(_this.stockQuantity(content));
                }
                return _this.teamConfigs.sales_disable_delivery_security ? null : content.quantity_to_deliver;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "stockQuantity", {
        get: function () {
            var _this = this;
            return function (content) {
                var _a, _b, _c;
                var stockKey = _this.teamConfigs.sales_stock_quantity_to_use === 0 ? 'stock_quantity' : 'stock_theoretical_quantity';
                if (!((_a = content.catalog) === null || _a === void 0 ? void 0 : _a.element) || !(stockKey in content.catalog.element)) {
                    return 0;
                }
                if (_this.hasModule('stock-locations') && _this.location) {
                    if (content.variation) {
                        var location_1 = (_b = content.variation.stock_locations) === null || _b === void 0 ? void 0 : _b.find(function (location) { var _a; return location.stock_location_id === ((_a = _this.location) === null || _a === void 0 ? void 0 : _a.id); });
                        return location_1 ? location_1[stockKey] : 0;
                    }
                    var location = (_c = content.catalog.element.stock_locations) === null || _c === void 0 ? void 0 : _c.find(function (location) { var _a; return location.stock_location_id === ((_a = _this.location) === null || _a === void 0 ? void 0 : _a.id); });
                    return location ? location[stockKey] : 0;
                }
                if (content.variation) {
                    return content.variation[stockKey];
                }
                return content.catalog.element[stockKey];
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentDelivery.prototype, "stockTheoricalQuantity", {
        get: function () {
            return function (content) {
                var _a;
                if (content.variation) {
                    return content.variation.stock_theoretical_quantity;
                }
                if (!((_a = content.catalog) === null || _a === void 0 ? void 0 : _a.element) || !('stock_theoretical_quantity' in content.catalog.element)) {
                    return 0;
                }
                return content.catalog.element.stock_theoretical_quantity;
            };
        },
        enumerable: false,
        configurable: true
    });
    DocumentDelivery.prototype.watchDocument = function (document) {
        var _this = this;
        this.contents = document.contents
            .filter(function (content) {
            return !content.is_comments && !content.is_subtotal && !content.is_pagebreak &&
                !content.is_option && content.total_quantity > 0;
        })
            .map(function (content) {
            var local = JSON.parse(JSON.stringify(content));
            var quantity = _this.number(content.quantity_to_deliver);
            if (_this.teamConfigs.sales_stock_delivery_quantity > 0 && local.catalog && local.catalog.element && local.catalog.type === 'product' && 'with_stock' in local.catalog.element && local.catalog.element.with_stock) {
                var stockQty = _this.number(_this.stockQuantity(local));
                if (stockQty > 0) {
                    if (stockQty > quantity) {
                        stockQty = quantity;
                    }
                    quantity = stockQty;
                }
                else if (stockQty <= 0) {
                    quantity = 0;
                }
            }
            if (!('used_lots' in local)) {
                local.used_lots = [];
            }
            local.to_deliver = quantity;
            return local;
        });
    };
    DocumentDelivery.prototype.watchLocation = function () {
        var _this = this;
        var _a;
        if (((_a = this.document) === null || _a === void 0 ? void 0 : _a.contents) && this.location) {
            this.contents.forEach(function (content, i) {
                var quantity = content.quantity_to_deliver;
                if (content.catalog && content.catalog.element && content.catalog.type === 'product' && 'with_stock' in content.catalog.element && content.catalog.element.with_stock) {
                    var stockQty = _this.stockQuantity(content);
                    if (stockQty >= 0) {
                        if (stockQty > quantity) {
                            stockQty = quantity;
                        }
                        quantity = stockQty;
                    }
                    content.to_deliver = quantity;
                    external_vue_default().set(_this.contents, i, content);
                }
            });
        }
    };
    // Open modal
    DocumentDelivery.prototype.openModal = function () {
        this.errorMsg = null;
        this.modalState = true;
        this.loading = false;
    };
    DocumentDelivery.prototype.deliverAll = function () {
        this.contents.forEach(function (content) {
            content.to_deliver = content.quantity_to_deliver;
        });
    };
    DocumentDelivery.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams(response.data);
                        return [4 /*yield*/, this.$router.push({
                                name: 'delivery-item',
                                params: {
                                    id: String(response.data.id)
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentDelivery.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentDelivery.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], DocumentDelivery.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentDelivery.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentDelivery.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentDelivery.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('document', { immediate: true })
    ], DocumentDelivery.prototype, "watchDocument", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('location', { immediate: true })
    ], DocumentDelivery.prototype, "watchLocation", null);
    DocumentDelivery = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs'])),
            components: {
                Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal,
                BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormSpinner: form_vue_.KFormSpinner,
                LotSelected: catalog_vue_.LotSelected, StockLocationSelect: catalog_vue_.StockLocationSelect, ProductStockIndicator: catalog_vue_.ProductStockIndicator
            }
        })
    ], DocumentDelivery);
    return DocumentDelivery;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var DocumentDeliveryvue_type_script_lang_ts_external = (DocumentDelivery);

;// ./src/components/DocumentDelivery/DocumentDelivery.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentDelivery_DocumentDeliveryvue_type_script_lang_ts_external = (DocumentDeliveryvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/DocumentDelivery/DocumentDelivery.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentDelivery_DocumentDeliveryvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentDelivery_DocumentDelivery = (component.exports);

/***/ }),

/***/ 38329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(64894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 38859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(53661),
    setCacheAdd = __webpack_require__(31380),
    setCacheHas = __webpack_require__(51459);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 38876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ mixins_LoadDocumentMixin; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/fetchDatas/document.ts
var fetchDatas_document = __webpack_require__(6243);
;// ./node_modules/vue-i18n/dist/vue-i18n.esm.js
/*!
 * vue-i18n v8.28.2 
 * (c) 2022 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * constants
 */

var numberFormatKeys = [
  'compactDisplay',
  'currency',
  'currencyDisplay',
  'currencySign',
  'localeMatcher',
  'notation',
  'numberingSystem',
  'signDisplay',
  'style',
  'unit',
  'unitDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits'
];

var dateTimeFormatKeys = [
  'dateStyle',
  'timeStyle',
  'calendar',
  'localeMatcher',
  "hour12",
  "hourCycle",
  "timeZone",
  "formatMatcher",
  'weekday',
  'era',
  'year',
  'month',
  'day',
  'hour',
  'minute',
  'second',
  'timeZoneName' ];

/**
 * utilities
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function error (msg, err) {
  if (typeof console !== 'undefined') {
    console.error('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.error(err.stack);
    }
  }
}

var isArray = Array.isArray;

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isBoolean (val) {
  return typeof val === 'boolean'
}

function isString (val) {
  return typeof val === 'string'
}

var vue_i18n_esm_toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return vue_i18n_esm_toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function isFunction (val) {
  return typeof val === 'function'
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject(args[1]) || isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.delete(item)) {
    return arr
  }
}

function arrayFrom (arr) {
  var ret = [];
  arr.forEach(function (a) { return ret.push(a); });
  return ret
}

function includes (arr, item) {
  return !!~arr.indexOf(item)
}

var vue_i18n_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return vue_i18n_esm_hasOwnProperty.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = isArray(a);
      var isArrayB = isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Sanitizes html special characters from input strings. For mitigating risk of XSS attacks.
 * @param rawText The raw input from the user that should be escaped.
 */
function escapeHtml(rawText) {
  return rawText
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;')
}

/**
 * Escapes html tags and special symbols from all provided params which were returned from parseArgs().params.
 * This method performs an in-place operation on the params object.
 *
 * @param {any} params Parameters as provided from `parseArgs().params`.
 *                     May be either an array of strings or a string->any map.
 *
 * @returns The manipulated `params` object.
 */
function escapeParams(params) {
  if(params != null) {
    Object.keys(params).forEach(function (key) {
      if(typeof(params[key]) == 'string') {
        params[key] = escapeHtml(params[key]);
      }
    });
  }
  return params
}

/*  */

function extend (Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get () { return this._i18n }
    });
  }

  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
  };

  Vue.prototype.$d = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
  };

  Vue.prototype.$n = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
  };
}

/*  */

/**
 * Mixin
 * 
 * If `bridge` mode, empty mixin is returned,
 * else regulary mixin implementation is returned.
 */
function defineMixin (bridge) {
  if ( bridge === void 0 ) bridge = false;

  function mounted () {
    if (this !== this.$root && this.$options.__INTLIFY_META__ && this.$el) {
      this.$el.setAttribute('data-intlify', this.$options.__INTLIFY_META__);
    }
  }

  return bridge
    ? { mounted: mounted } // delegate `vue-i18n-bridge` mixin implementation
    : { // regulary 
    beforeCreate: function beforeCreate () {
      var options = this.$options;
      options.i18n = options.i18n || ((options.__i18nBridge || options.__i18n) ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          if ((options.__i18nBridge || options.__i18n)) {
            try {
              var localeMessages = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n = options.__i18nBridge || options.__i18n;
              _i18n.forEach(function (resource) {
                localeMessages = merge(localeMessages, JSON.parse(resource));
              });
              Object.keys(localeMessages).forEach(function (locale) {
                options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
              });
            } catch (e) {
              if (false) // removed by dead control flow
{}
            }
          }
          this._i18n = options.i18n;
          this._i18nWatcher = this._i18n.watchI18nData();
        } else if (isPlainObject(options.i18n)) {
          var rootI18n = this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n
            ? this.$root.$i18n
            : null;
          // component local i18n
          if (rootI18n) {
            options.i18n.root = this.$root;
            options.i18n.formatter = rootI18n.formatter;
            options.i18n.fallbackLocale = rootI18n.fallbackLocale;
            options.i18n.formatFallbackMessages = rootI18n.formatFallbackMessages;
            options.i18n.silentTranslationWarn = rootI18n.silentTranslationWarn;
            options.i18n.silentFallbackWarn = rootI18n.silentFallbackWarn;
            options.i18n.pluralizationRules = rootI18n.pluralizationRules;
            options.i18n.preserveDirectiveContent = rootI18n.preserveDirectiveContent;
          }

          // init locale messages via custom blocks
          if ((options.__i18nBridge || options.__i18n)) {
            try {
              var localeMessages$1 = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n$1 = options.__i18nBridge || options.__i18n;
              _i18n$1.forEach(function (resource) {
                localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
              });
              options.i18n.messages = localeMessages$1;
            } catch (e) {
              if (false) // removed by dead control flow
{}
            }
          }

          var ref = options.i18n;
          var sharedMessages = ref.sharedMessages;
          if (sharedMessages && isPlainObject(sharedMessages)) {
            options.i18n.messages = merge(options.i18n.messages, sharedMessages);
          }

          this._i18n = new VueI18n(options.i18n);
          this._i18nWatcher = this._i18n.watchI18nData();

          if (options.i18n.sync === undefined || !!options.i18n.sync) {
            this._localeWatcher = this.$i18n.watchLocale();
          }

          if (rootI18n) {
            rootI18n.onComponentInstanceCreated(this._i18n);
          }
        } else {
          if (false) // removed by dead control flow
{}
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        // root i18n
        this._i18n = this.$root.$i18n;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        // parent i18n
        this._i18n = options.parent.$i18n;
      }
    },

    beforeMount: function beforeMount () {
      var options = this.$options;
      options.i18n = options.i18n || ((options.__i18nBridge || options.__i18n) ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else if (isPlainObject(options.i18n)) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else {
          if (false) // removed by dead control flow
{}
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    },

    mounted: mounted,

    beforeDestroy: function beforeDestroy () {
      if (!this._i18n) { return }

      var self = this;
      this.$nextTick(function () {
        if (self._subscribing) {
          self._i18n.unsubscribeDataChanging(self);
          delete self._subscribing;
        }

        if (self._i18nWatcher) {
          self._i18nWatcher();
          self._i18n.destroyVM();
          delete self._i18nWatcher;
        }

        if (self._localeWatcher) {
          self._localeWatcher();
          delete self._localeWatcher;
        }
      });
    }
  }
}

/*  */

var interpolationComponent = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var data = ref.data;
    var parent = ref.parent;
    var props = ref.props;
    var slots = ref.slots;

    var $i18n = parent.$i18n;
    if (!$i18n) {
      if (false) // removed by dead control flow
{}
      return
    }

    var path = props.path;
    var locale = props.locale;
    var places = props.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places
        ? useLegacyPlaces(params.default, places)
        : params
    );

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag ? h(tag, data, children) : children
  }
};

function onlyHasDefaultPlace (params) {
  var prop;
  for (prop in params) {
    if (prop !== 'default') { return false }
  }
  return Boolean(prop)
}

function useLegacyPlaces (children, places) {
  var params = places ? createParamsFromPlaces(places) : {};

  if (!children) { return params }

  // Filter empty text nodes
  children = children.filter(function (child) {
    return child.tag || child.text.trim() !== ''
  });

  var everyPlace = children.every(vnodeHasPlaceAttribute);
  if (false) // removed by dead control flow
{}

  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  )
}

function createParamsFromPlaces (places) {
  if (false) // removed by dead control flow
{}

  return Array.isArray(places)
    ? places.reduce(assignChildIndex, {})
    : Object.assign({}, places)
}

function assignChildPlace (params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params
}

function assignChildIndex (params, child, index) {
  params[index] = child;
  return params
}

function vnodeHasPlaceAttribute (vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
}

/*  */

var numberComponent = {
  name: 'i18n-n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var parent = ref.parent;
    var data = ref.data;

    var i18n = parent.$i18n;

    if (!i18n) {
      if (false) // removed by dead control flow
{}
      return null
    }

    var key = null;
    var options = null;

    if (isString(props.format)) {
      key = props.format;
    } else if (isObject(props.format)) {
      if (props.format.key) {
        key = props.format.key;
      }

      // Filter out number format options only
      options = Object.keys(props.format).reduce(function (acc, prop) {
        var obj;

        if (includes(numberFormatKeys, prop)) {
          return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
        }
        return acc
      }, null);
    }

    var locale = props.locale || i18n.locale;
    var parts = i18n._ntp(props.value, locale, key, options);

    var values = parts.map(function (part, index) {
      var obj;

      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
    });

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag
      ? h(tag, {
        attrs: data.attrs,
        'class': data['class'],
        staticClass: data.staticClass
      }, values)
      : values
  }
};

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) &&
    (looseEqual(binding.value, binding.oldValue) &&
     looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return
  }

  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = '';
  }
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
  el._localeMessage = undefined;
  delete el['_localeMessage'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('VueI18n instance does not exists in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn('value type not supported');
    return
  }

  if (!path) {
    warn('`path` is required in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice != null) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (isString(value)) {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue;

function install (_Vue, options) {
  if ( options === void 0 ) options = { bridge: false };

  /* istanbul ignore if */
  if (false) // removed by dead control flow
{}
  install.installed = true;

  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if (false) // removed by dead control flow
{}

  extend(Vue);
  Vue.mixin(defineMixin(options.bridge));
  Vue.directive('t', { bind: bind, update: update, unbind: unbind });
  Vue.component(interpolationComponent.name, interpolationComponent);
  Vue.component(numberComponent.name, numberComponent);

  // use simple mergeStrategies to prevent i18n instance lose '__proto__'
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === '}';

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (false) // removed by dead control flow
{}
        }
        break
      case 'unknown':
        if (false) // removed by dead control flow
{}
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path parser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  return 'ident'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === undefined) { return false }
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null
  } else {
    var length = paths.length;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined || value === null) {
        return null
      }
      last = value;
      i++;
    }

    return last
  }
};

/*  */



var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-zA-Z]+)?:(?:[\w\-_|./]+|\([\w\-_:|./]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-zA-Z]+))?:/;
var bracketsMatcher = /[()]/g;
var defaultModifiers = {
  'upper': function (str) { return str.toLocaleUpperCase(); },
  'lower': function (str) { return str.toLocaleLowerCase(); },
  'capitalize': function (str) { return ("" + (str.charAt(0).toLocaleUpperCase()) + (str.substr(1))); }
};

var defaultFormatter = new BaseFormatter();

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale === false
    ? false
    : options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || options.datetimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._modifiers = options.modifiers || {};
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._fallbackRootWithEmptyString = options.fallbackRootWithEmptyString === undefined
    ? true
    : !!options.fallbackRootWithEmptyString;
  this._formatFallbackMessages = options.formatFallbackMessages === undefined
    ? false
    : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === undefined
    ? false
    : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = new Set();
  this._componentInstanceCreatedListener = options.componentInstanceCreatedListener || null;
  this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
    ? false
    : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';
  this._postTranslation = options.postTranslation || null;
  this._escapeParameterHtml = options.escapeParameterHtml || false;

  if ('__VUE_I18N_BRIDGE__' in options) {
    this.__VUE_I18N_BRIDGE__ = options.__VUE_I18N_BRIDGE__;
  }

  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index
  */
  this.getChoiceIndex = function (choice, choicesLength) {
    var thisPrototype = Object.getPrototypeOf(this$1);
    if (thisPrototype && thisPrototype.getChoiceIndex) {
      var prototypeGetChoiceIndex = (thisPrototype.getChoiceIndex);
      return (prototypeGetChoiceIndex).call(this$1, choice, choicesLength)
    }

    // Default (old) getChoiceIndex implementation - english-compatible
    var defaultImpl = function (_choice, _choicesLength) {
      _choice = Math.abs(_choice);

      if (_choicesLength === 2) {
        return _choice
          ? _choice > 1
            ? 1
            : 0
          : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
    };

    if (this$1.locale in this$1.pluralizationRules) {
      return this$1.pluralizationRules[this$1.locale].apply(this$1, [choice, choicesLength])
    } else {
      return defaultImpl(choice, choicesLength)
    }
  };


  this._exist = function (message, key) {
    if (!message || !key) { return false }
    if (!isNull(this$1._path.getPathValue(message, key))) { return true }
    // fallback for flat key
    if (message[key]) { return true }
    return false
  };

  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true },postTranslation: { configurable: true },sync: { configurable: true } };

VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
  var paths = [];

  var fn = function (level, locale, message, paths) {
    if (isPlainObject(message)) {
      Object.keys(message).forEach(function (key) {
        var val = message[key];
        if (isPlainObject(val)) {
          paths.push(key);
          paths.push('.');
          fn(level, locale, val, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(key);
          fn(level, locale, val, paths);
          paths.pop();
        }
      });
    } else if (isArray(message)) {
      message.forEach(function (item, index) {
        if (isPlainObject(item)) {
          paths.push(("[" + index + "]"));
          paths.push('.');
          fn(level, locale, item, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(("[" + index + "]"));
          fn(level, locale, item, paths);
          paths.pop();
        }
      });
    } else if (isString(message)) {
      var ret = htmlTagMatcher.test(message);
      if (ret) {
        var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level === 'warn') {
          warn(msg);
        } else if (level === 'error') {
          error(msg);
        }
      }
    }
  };

  fn(level, locale, message, paths);
};

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data, __VUE18N__INSTANCE__: true });
  Vue.config.silent = silent;
};

VueI18n.prototype.destroyVM = function destroyVM () {
  this._vm.$destroy();
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.add(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
    var this$1 = this;
  return this._vm.$watch('$data', function () {
    var listeners = arrayFrom(this$1._dataListeners);
    var i = listeners.length;
    while(i--) {
      Vue.nextTick(function () {
        listeners[i] && listeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale (composer) {
  if (!composer) {
    /* istanbul ignore if */
    if (!this._sync || !this._root) { return null }
    var target = this._vm;
    return this._root.$i18n.vm.$watch('locale', function (val) {
      target.$set(target, 'locale', val);
      target.$forceUpdate();
    }, { immediate: true })
  } else {
    // deal with vue-i18n-bridge
    if (!this.__VUE_I18N_BRIDGE__) { return null }
    var self = this;
    var target$1 = this._vm;
    return this.vm.$watch('locale', function (val) {
      target$1.$set(target$1, 'locale', val);
      if (self.__VUE_I18N_BRIDGE__ && composer) {
        composer.locale.value = val;
      }
      target$1.$forceUpdate();
    }, { immediate: true })
  }
};

VueI18n.prototype.onComponentInstanceCreated = function onComponentInstanceCreated (newI18n) {
  if (this._componentInstanceCreatedListener) {
    this._componentInstanceCreatedListener(newI18n, this);
  }
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
prototypeAccessors.availableLocales.get = function () { return Object.keys(this.messages).sort() };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._localeChainCache = {};
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
prototypeAccessors.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

prototypeAccessors.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
prototypeAccessors.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

prototypeAccessors.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
prototypeAccessors.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

prototypeAccessors.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
prototypeAccessors.warnHtmlInMessage.set = function (level) {
    var this$1 = this;

  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === 'warn' || level === 'error')) {
    var messages = this._getMessages();
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }
};

prototypeAccessors.postTranslation.get = function () { return this._postTranslation };
prototypeAccessors.postTranslation.set = function (handler) { this._postTranslation = handler; };

prototypeAccessors.sync.get = function () { return this._sync };
prototypeAccessors.sync.set = function (val) { this._sync = val; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values, interpolateMode) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (isString(missingRet)) {
      return missingRet
    }
  } else {
    if (false) // removed by dead control flow
{}
  }

  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values);
    return this._render(key, interpolateMode, parsedArgs.params, key)
  } else {
    return key
  }
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return (this._fallbackRootWithEmptyString? !val : isNull(val)) && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
  return this._silentFallbackWarn instanceof RegExp
    ? this._silentFallbackWarn.test(key)
    : this._silentFallbackWarn
};

VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
};

VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
  return this._silentTranslationWarn instanceof RegExp
    ? this._silentTranslationWarn.test(key)
    : this._silentTranslationWarn
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (!(isString(ret) || isFunction(ret))) {
        if (false) // removed by dead control flow
{}
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (isString(pathRet) || isFunction(pathRet)) {
      ret = pathRet;
    } else {
      if (false) // removed by dead control flow
{}
      return null
    }
  }

  // Check for the existence of links within the translated string
  if (isString(ret) && (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0)) {
    ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
  }

  return this._render(ret, interpolateMode, values, key)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(linkKeyMatcher);

  // eslint-disable-next-line no-autofix/prefer-const
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
      var formatterName = linkKeyPrefixMatches[1];

    // Remove the leading @:, @.case: and the brackets
    var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

    if (includes(visitedLinkStack, linkPlaceholder)) {
      if (false) // removed by dead control flow
{}
      return ret
    }
    visitedLinkStack.push(linkPlaceholder);

    // Translate the link
    var translated = this._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values,
      visitedLinkStack
    );

    if (this._isFallbackRoot(translated)) {
      if (false) // removed by dead control flow
{}
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      var root = this._root.$i18n;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this._warnDefault(
      locale, linkPlaceholder, translated, host,
      isArray(values) ? values : [values],
      interpolateMode
    );

    if (this._modifiers.hasOwnProperty(formatterName)) {
      translated = this._modifiers[formatterName](translated);
    } else if (defaultModifiers.hasOwnProperty(formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }

    visitedLinkStack.pop();

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._createMessageContext = function _createMessageContext (values, formatter, path, interpolateMode) {
    var this$1 = this;

  var _list = isArray(values) ? values : [];
  var _named = isObject(values) ? values : {};
  var list = function (index) { return _list[index]; };
  var named = function (key) { return _named[key]; };
  var messages = this._getMessages();
  var locale = this.locale;

  return {
    list: list,
    named: named,
    values: values,
    formatter: formatter,
    path: path,
    messages: messages,
    locale: locale,
    linked: function (linkedKey) { return this$1._interpolate(locale, messages[locale] || {}, linkedKey, null, interpolateMode, undefined, [linkedKey]); }
  }
};

VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
  if (isFunction(message)) {
    return message(
      this._createMessageContext(values, this._formatter || defaultFormatter, path, interpolateMode)
    )
  }

  var ret = this._formatter.interpolate(message, values, path);

  // If the custom formatter refuses to work - apply the default one
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }

  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' && !isString(ret) ? ret.join('') : ret
};

VueI18n.prototype._appendItemToChain = function _appendItemToChain (chain, item, blocks) {
  var follow = false;
  if (!includes(chain, item)) {
    follow = true;
    if (item) {
      follow = item[item.length - 1] !== '!';
      item = item.replace(/!/g, '');
      chain.push(item);
      if (blocks && blocks[item]) {
        follow = blocks[item];
      }
    }
  }
  return follow
};

VueI18n.prototype._appendLocaleToChain = function _appendLocaleToChain (chain, locale, blocks) {
  var follow;
  var tokens = locale.split('-');
  do {
    var item = tokens.join('-');
    follow = this._appendItemToChain(chain, item, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && (follow === true))
  return follow
};

VueI18n.prototype._appendBlockToChain = function _appendBlockToChain (chain, block, blocks) {
  var follow = true;
  for (var i = 0; (i < block.length) && (isBoolean(follow)); i++) {
    var locale = block[i];
    if (isString(locale)) {
      follow = this._appendLocaleToChain(chain, locale, blocks);
    }
  }
  return follow
};

VueI18n.prototype._getLocaleChain = function _getLocaleChain (start, fallbackLocale) {
  if (start === '') { return [] }

  if (!this._localeChainCache) {
    this._localeChainCache = {};
  }

  var chain = this._localeChainCache[start];
  if (!chain) {
    if (!fallbackLocale) {
      fallbackLocale = this.fallbackLocale;
    }
    chain = [];

    // first block defined by start
    var block = [start];

    // while any intervening block found
    while (isArray(block)) {
      block = this._appendBlockToChain(
        chain,
        block,
        fallbackLocale
      );
    }

    // last block defined by default
    var defaults;
    if (isArray(fallbackLocale)) {
      defaults = fallbackLocale;
    } else if (isObject(fallbackLocale)) {
      /* $FlowFixMe */
      if (fallbackLocale['default']) {
        defaults = fallbackLocale['default'];
      } else {
        defaults = null;
      }
    } else {
      defaults = fallbackLocale;
    }

    // convert defaults to array
    if (isString(defaults)) {
      block = [defaults];
    } else {
      block = defaults;
    }
    if (block) {
      this._appendBlockToChain(
        chain,
        block,
        null
      );
    }
    this._localeChainCache[start] = chain;
  }
  return chain
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var chain = this._getLocaleChain(locale, fallback);
  var res;
  for (var i = 0; i < chain.length; i++) {
    var step = chain[i];
    res =
      this._interpolate(step, messages[step], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (step !== locale && "production" !== 'production' && 0 && 0) // removed by dead control flow
{}
      return res
    }
  }
  return null
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  if(this._escapeParameterHtml) {
    parsedArgs.params = escapeParams(parsedArgs.params);
  }

  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (false) // removed by dead control flow
{}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
  } else {
    ret = this._warnDefault(locale, key, ret, host, values, 'string');
    if (this._postTranslation && ret !== null && ret !== undefined) {
      ret = this._postTranslation(ret, key);
    }
    return ret
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (false) // removed by dead control flow
{}
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values], 'raw')
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (!isString(locale)) {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }

  var predefined = { 'count': choice, 'n': choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message || !isString(message)) { return null }
  var choices = message.split('|');

  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, merge(
    typeof this._vm.messages[locale] !== 'undefined' && Object.keys(this._vm.messages[locale]).length
      ? Object.assign({}, this._vm.messages[locale])
      : {},
    message
  ));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype._clearDateTimeFormat = function _clearDateTimeFormat (locale, format) {
  // eslint-disable-next-line no-autofix/prefer-const
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._dateTimeFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._dateTimeFormatters[id];
  }
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = dateTimeFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "production" !== 'production' && 0 && 0) // removed by dead control flow
{}
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      formatter = new Intl.DateTimeFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._dateTimeFormatters[id];
      if (!formatter) {
        formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
      }
    }

    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key, options) {
  /* istanbul ignore if */
  if (false) // removed by dead control flow
{}

  if (!key) {
    var dtf = !options ? new Intl.DateTimeFormat(locale) : new Intl.DateTimeFormat(locale, options);
    return dtf.format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key, options);
  if (this._isFallbackRoot(ret)) {
    if (false) // removed by dead control flow
{}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }

    options = Object.keys(args[0]).reduce(function (acc, key) {
        var obj;

      if (includes(dateTimeFormatKeys, key)) {
        return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
      }
      return acc
    }, null);

  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._d(value, locale, key, options)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype._clearNumberFormat = function _clearNumberFormat (locale, format) {
  // eslint-disable-next-line no-autofix/prefer-const
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._numberFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._numberFormatters[id];
  }
};

VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = numberFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "production" !== 'production' && 0 && 0) // removed by dead control flow
{}
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (false) // removed by dead control flow
{}
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    if (false) // removed by dead control flow
{}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (includes(numberFormatKeys, key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (false) // removed by dead control flow
{}
    return []
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    if (false) // removed by dead control flow
{}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n._ntp(value, locale, key, options)
  } else {
    return ret || []
  }
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

var availabilities;
// $FlowFixMe
Object.defineProperty(VueI18n, 'availabilities', {
  get: function get () {
    if (!availabilities) {
      var intlDefined = typeof Intl !== 'undefined';
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
        numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
      };
    }

    return availabilities
  }
});

VueI18n.install = install;
VueI18n.version = '8.28.2';

/* harmony default export */ var vue_i18n_esm = (VueI18n);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var lodash_merge = __webpack_require__(55364);
var merge_default = /*#__PURE__*/__webpack_require__.n(lodash_merge);
// EXTERNAL MODULE: ./src/lang/index.ts + 2 modules
var lang = __webpack_require__(26206);
// EXTERNAL MODULE: external "@kwixeo/communication-vue"
var communication_vue_ = __webpack_require__(43055);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "@kwixeo/catalog-vue"
var catalog_vue_ = __webpack_require__(68480);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(44696);
;// ./src/lang/i18n.ts








external_vue_default().use(vue_i18n_esm);
var i18n = new vue_i18n_esm({
    locale: 'fr',
    fallbackLocale: 'en',
    messages: merge_default()({}, lang/* default */.A, communication_vue_.Lang, customers_vue_.Lang, catalog_vue_.Lang, custom_fields_vue_.Lang)
});
/* harmony default export */ var lang_i18n = (i18n);

;// ./src/mixins/LoadDocumentMixin.ts






var setPageTitle = function (type, document, route) {
    var key = route.name === type + '-form' ? (document !== null ? 'editTitle' : 'newTitle') : 'reference';
    window.document.title = String(lang_i18n.t('sales.' + type + '.' + key, { reference: document === null || document === void 0 ? void 0 : document.reference }));
};
var cleanNewDocument = function (document, teamConfigs) {
    var _a, _b, _c, _d;
    document.reference = null;
    document.id = null;
    document.is_draft = true;
    document.affair = null;
    document.affair_id = null;
    document.date = null;
    document.expire_at = null;
    if (teamConfigs.sales_update_customer_addresses) {
        var billingAddress = (_a = document.customer.address_invoice) !== null && _a !== void 0 ? _a : document.billing_address;
        document.billing_address = {
            road: 'road1' in billingAddress ? billingAddress.road1 : ('road' in billingAddress ? billingAddress.road : null),
            road2: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.road2,
            road3: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.road3,
            postal_code: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postal_code,
            city: 'town' in billingAddress ? billingAddress.town : ('city' in billingAddress ? billingAddress.city : null),
            country: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.country,
        };
        var deliveryAddress = (_c = (_b = document.customer.address_delivery) !== null && _b !== void 0 ? _b : document.delivery_address) !== null && _c !== void 0 ? _c : billingAddress;
        document.delivery_address = {
            road: 'road1' in deliveryAddress ? deliveryAddress.road1 : ('road' in deliveryAddress ? deliveryAddress.road : null),
            road2: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.road2,
            road3: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.road3,
            postal_code: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.postal_code,
            city: 'town' in deliveryAddress ? deliveryAddress.town : ('city' in deliveryAddress ? deliveryAddress.city : null),
            country: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.country,
        };
    }
    (_d = document.contents) === null || _d === void 0 ? void 0 : _d.map(function (content) {
        content.affair_content = null;
        content.affair_content_id = null;
        content.used_lots = [];
        if (content.designation) {
            //content.designation = content.designation.replaceAll('<div>', '<br><div>').replaceAll('<br></', '<div><br></div></')
        }
        return content;
    });
    return document;
};
var LoadDocumentMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LoadDocumentMixin, _super);
    function LoadDocumentMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.document = null;
        _this.loading = true;
        return _this;
    }
    LoadDocumentMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['pageParams'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            components: {
                Spinner: interface_vue_.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                var _a, _b, _c, _d, _e;
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var id, type, pageParams, storageDocument;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                id = to.params.id;
                                type = (_a = to.meta) === null || _a === void 0 ? void 0 : _a.documentType;
                                pageParams = lib/* Vue */.lD.prototype.$kwSales.store.state.app.pageParams;
                                storageDocument = (_c = (_b = pageParams === null || pageParams === void 0 ? void 0 : pageParams.document) !== null && _b !== void 0 ? _b : pageParams) !== null && _c !== void 0 ? _c : null;
                                if (!id && !(storageDocument === null || storageDocument === void 0 ? void 0 : storageDocument.id)) {
                                    next(function (vm) {
                                        vm.loading = true;
                                        if (vm.pageParams) {
                                            vm.document = cleanNewDocument(JSON.parse(JSON.stringify(storageDocument)), vm.teamConfigs);
                                            vm.setPageParams(null);
                                        }
                                        else {
                                            vm.document = {};
                                        }
                                        vm.type = type;
                                        vm.loading = false;
                                    });
                                    setPageTitle(type, null, to);
                                    return [2 /*return*/];
                                }
                                if (pageParams && !(0,fetchDatas_document/* needFetchDocument */.yt)((_d = pageParams.type) !== null && _d !== void 0 ? _d : type, storageDocument)) {
                                    next(function (vm) {
                                        var document = JSON.parse(storageDocument);
                                        if (!id) {
                                            document = cleanNewDocument(document, vm.teamConfigs);
                                        }
                                        vm.document = document;
                                        setPageTitle(type, document, to);
                                        vm.setPageParams(null);
                                        vm.type = type;
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,fetchDatas_document/* fetchDocument */.sW)((_e = pageParams === null || pageParams === void 0 ? void 0 : pageParams.type) !== null && _e !== void 0 ? _e : type, id !== null && id !== void 0 ? id : storageDocument === null || storageDocument === void 0 ? void 0 : storageDocument.id)
                                        .then(function (document) {
                                        next(function (vm) {
                                            vm.type = type;
                                            if (!id) {
                                                document = cleanNewDocument(document, vm.teamConfigs);
                                            }
                                            vm.document = document;
                                            setPageTitle(type, document, to);
                                            vm.loading = false;
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })
                                        .catch(function (error) {
                                        var response = error.response;
                                        if (response && response.status === 409) {
                                            next(function (vm) {
                                                var document = response.data.new_version;
                                                vm.type = type;
                                                vm.document = document;
                                                vm.$router.replace({
                                                    name: vm.$route.name,
                                                    params: {
                                                        id: String(document.id)
                                                    }
                                                });
                                            });
                                            return;
                                        }
                                        throw new Error(error);
                                    })];
                            case 1:
                                _f.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                var _a, _b, _c, _d, _e, _f;
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var id, type, storageDocument, document;
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_g) {
                        switch (_g.label) {
                            case 0:
                                id = to.params.id;
                                type = (_a = to.meta) === null || _a === void 0 ? void 0 : _a.documentType;
                                storageDocument = (_d = (_c = (_b = this.pageParams) === null || _b === void 0 ? void 0 : _b.document) !== null && _c !== void 0 ? _c : this.pageParams) !== null && _d !== void 0 ? _d : null;
                                this.loading = true;
                                this.type = type;
                                this.document = null;
                                if (!id) {
                                    setPageTitle(type, null, to);
                                    this.loading = false;
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    document = JSON.parse(JSON.stringify(storageDocument));
                                    this.setPageParams(null);
                                    if (!(0,fetchDatas_document/* needFetchDocument */.yt)((_f = (_e = this.pageParams) === null || _e === void 0 ? void 0 : _e.type) !== null && _f !== void 0 ? _f : type, document)) {
                                        setPageTitle(type, document, to);
                                        this.document = document;
                                        this.loading = false;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                return [4 /*yield*/, (0,fetchDatas_document/* fetchDocument */.sW)(type, to.params.id)
                                        .then(function (document) {
                                        _this.document = document;
                                        _this.loading = false;
                                        setPageTitle(type, document, to);
                                        next();
                                    })];
                            case 1:
                                _g.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], LoadDocumentMixin);
    return LoadDocumentMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_LoadDocumentMixin = (LoadDocumentMixin);


/***/ }),

/***/ 39344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(23805);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 39491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TransformToProforma_TransformToProforma; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TransformToProforma/TransformToProforma.vue?vue&type=template&id=b88dcb08
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?_c('div',{staticClass:"font-weight-bold text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_c('k-form',{attrs:{"action":'/sales/' + this.type + '/' + this.value.id + '/proforma'},on:{"submitError":_vm.submitError,"submitComplete":_vm.submitComplete}},[_c('p',[_vm._v("Êtes-vous sûr de vouloir créer une facture proforma ?")]),_c('b-form-group',{attrs:{"label":"Date du document"}},[_c('k-form-datepicker',{attrs:{"name":"date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.draft}}),_c('k-form-checkbox',{model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}},[_vm._v(" Créer le document au statut brouillon ")]),(_vm.cantBeEditedIfValid && !_vm.draft)?_c('b-alert',{staticClass:"mt-3 mb-0 py-2 px-3",attrs:{"variant":"warning","show":""}},[_vm._v(" Attention, ce document étant déjà facturé à 100%, si vous ne créez pas la facture proforma au statut brouillon, celle-ci ne sera pas modifiable. ")]):_vm._e(),(!_vm.value.billing_address.city || !_vm.value.billing_address.postal_code)?_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Adresse de facturation"}},[_c('k-form-address',{attrs:{"countries-list":_vm.countries,"prefix-name":"billing_address_","required":"","road-placeholder":_vm.$t('sales.form.road'),"size":"sm","with-road3":"","valuesMap":{
              road: 'road',
              city: 'city'
            },"city-name":"city","road-name":"road"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1):_vm._e()],1)]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TransformToProforma/TransformToProforma.ts?vue&type=script&lang=ts&external







var TransformToProforma = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TransformToProforma, _super);
    function TransformToProforma() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.address = {};
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        _this.draft = false;
        return _this;
    }
    TransformToProforma.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        this.draft = !this.teamConfigs.sales_proforma_valid;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TransformToProforma.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToProforma.prototype, "cantBeEditedIfValid", {
        get: function () {
            var _a;
            var invoices = (_a = this.value.invoices) !== null && _a !== void 0 ? _a : [];
            return this.number(this.value.to_bill) === 0 && invoices.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    TransformToProforma.prototype.watchValue = function () {
        if (this.draft) {
            this.draft = !this.cantBeEditedIfValid;
        }
        this.address = this.value.billing_address;
    };
    TransformToProforma.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    TransformToProforma.prototype.closeModal = function () {
        this.errorMsg = null;
        return false;
    };
    TransformToProforma.prototype.submitComplete = function (response) {
        return response.data;
    };
    TransformToProforma.prototype.submitError = function (error) {
        var _a;
        this.errorMsg = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToProforma.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToProforma.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TransformToProforma.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Créer une facture proforma' })
    ], TransformToProforma.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToProforma.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TransformToProforma.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TransformToProforma.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], TransformToProforma.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], TransformToProforma.prototype, "closeModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], TransformToProforma.prototype, "submitComplete", null);
    TransformToProforma = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal,
                BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert,
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormAddress: form_vue_.KFormAddress
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], TransformToProforma);
    return TransformToProforma;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var TransformToProformavue_type_script_lang_ts_external = (TransformToProforma);

;// ./src/components/TransformToProforma/TransformToProforma.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TransformToProforma_TransformToProformavue_type_script_lang_ts_external = (TransformToProformavue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/TransformToProforma/TransformToProforma.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TransformToProforma_TransformToProformavue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TransformToProforma_TransformToProforma = (component.exports);

/***/ }),

/***/ 39690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ InvoiceList_InvoiceList; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesListMixin/SalesListMixin.vue + 3 modules
var SalesListMixin = __webpack_require__(68067);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatus.ts
var SalesDocumentStatus = __webpack_require__(70468);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/InvoiceList/InvoiceList.ts?vue&type=script&lang=ts&external




var InvoiceList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(InvoiceList, _super);
    function InvoiceList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'invoice';
        _this.include = [
            'customer', 'contact', 'billing_address_country', 'delivery_address_country',
            'currency', 'teamUser', 'tags', 'affairs'
        ];
        _this.additionalColumns = [
            {
                data: 'delivery_status_label',
                name: 'Statut de livraison',
                visible: false
            },
            {
                data: 'already_paid',
                name: 'Déjà payé',
                visible: false,
                render: 'currency'
            },
            {
                data: 'stay_to_pay',
                name: 'Reste à payer',
                visible: false,
                render: 'currency'
            },
            {
                data: 'last_reminder',
                name: 'Dernière relance de paiement',
                visible: false,
                render: 'date'
            },
            {
                data: 'is_advance',
                name: 'Type',
                visible: false,
                render: function (data) {
                    return data ? 'Acompte' : 'Facture';
                }
            }
        ];
        return _this;
    }
    Object.defineProperty(InvoiceList.prototype, "status", {
        get: function () {
            return this.invoiceStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvoiceList.prototype, "statusIndicator", {
        get: function () {
            return [
                { class: 'status-invoice-1', label: 'Brouillon' },
                { class: 'status-invoice-2', label: 'Validée' },
                { class: 'status-invoice-3', label: 'En attente de paiement' },
                { class: 'status-invoice-5', label: 'Payée' },
                { class: 'status-invoice-6', label: 'Annulée' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    InvoiceList.prototype.canBeEdited = function (invoice) {
        return invoice.is_draft;
    };
    Object.defineProperty(InvoiceList.prototype, "defaultFilters", {
        get: function () {
            if (this.onlyDepositInvoice !== false) {
                return {
                    is_deposit_invoice: true
                };
            }
            else if (this.customer || this.contact) {
                return {
                    is_deposit_invoice: null
                };
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvoiceList.prototype, "computedFilters", {
        get: function () {
            var filters = Array.from(this.filters);
            filters.push({
                type: 'select',
                label: 'Statut de livraison',
                name: 'delivery_status',
                options: [
                    { id: 1, label: 'À livrer' },
                    { id: 2, label: 'Livré partiellement' },
                    { id: 3, label: 'Livré' }
                ],
                multiple: true,
                optionLabel: 'label',
                value: 'id'
            }, {
                type: 'period',
                label: 'Dernière relance de paiement',
                name: 'last_reminder_since',
                name2: 'last_reminder_until'
            });
            if (this.onlyDepositInvoice === false && !this.customer && !this.contact) {
                filters.push({
                    type: 'select',
                    label: 'Facture d\'acompte',
                    name: 'is_deposit_invoice',
                    options: [
                        { value: 0, label: 'Ne pas afficher' },
                        { value: null, label: 'Afficher' }
                    ],
                    defaultValue: { value: 0, label: 'Ne pas afficher' },
                    params: { clearable: false },
                    optionLabel: 'label',
                    value: 'value'
                });
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvoiceList.prototype, "tableStateKey", {
        get: function () {
            var _a;
            return (_a = this.customStateKey) !== null && _a !== void 0 ? _a : 'sales-' + this.type + (this.onlyDepositInvoice !== false ? '-deposit' : '');
        },
        enumerable: false,
        configurable: true
    });
    InvoiceList.prototype.rowClass = function (row) {
        if (this.onlyDepositInvoice !== false) {
            return {};
        }
        return {
            'advance-invoice': row.is_advance
        };
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], InvoiceList.prototype, "onlyDepositInvoice", void 0);
    InvoiceList = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], InvoiceList);
    return InvoiceList;
}((0,lib/* Mixins */.Xe)(SalesListMixin/* default */.A, SalesDocumentStatus/* default */.A)));
/* harmony default export */ var InvoiceListvue_type_script_lang_ts_external = (InvoiceList);

;// ./src/components/InvoiceList/InvoiceList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var InvoiceList_InvoiceListvue_type_script_lang_ts_external = (InvoiceListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/InvoiceList/InvoiceList.vue
var render, staticRenderFns
;



/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  InvoiceList_InvoiceListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InvoiceList_InvoiceList = (component.exports);

/***/ }),

/***/ 39754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(83729),
    baseEach = __webpack_require__(80909),
    castFunction = __webpack_require__(24066),
    isArray = __webpack_require__(56449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 40346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 40355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfModelForm_PdfModelForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfModelForm/PdfModelForm.vue?vue&type=template&id=4547fae2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.pdfModel)?_c('k-form',{ref:"form",staticClass:"pdfModel-form",attrs:{"action":_vm.formApiUrl,"method":"put"},on:{"submitComplete":_vm.submitComplete},model:{value:(_vm.computedPdfModel),callback:function ($$v) {_vm.computedPdfModel=$$v},expression:"computedPdfModel"}},[(_vm.loading)?_c('Spinner'):[_c('b-form-group',{attrs:{"label":_vm.$t('sales.pdfModel.label')}},[_c('k-form-input',{attrs:{"name":"label","required":""},model:{value:(_vm.pdfModel.label),callback:function ($$v) {_vm.$set(_vm.pdfModel, "label", $$v)},expression:"pdfModel.label"}})],1),_c('b-tabs',{staticClass:"tabs-card mb-5"},[_c('b-tab',{attrs:{"title":"Paramètres du document"}},[_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.document-uses",modifiers:{"document-uses":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Utilisation du modèle ")])],1),_c('b-collapse',{attrs:{"id":"document-uses","accordion":"document-options","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-form-group',{staticClass:"pt-2",attrs:{"label":"Utilisation du modèle :"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_quotation"},domProps:{"value":_vm.pdfModel.use_quotation}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_quotation),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_quotation", $$v)},expression:"pdfModel.use_quotation"}},[_vm._v(" Devis ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_command"},domProps:{"value":_vm.pdfModel.use_command}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_command),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_command", $$v)},expression:"pdfModel.use_command"}},[_vm._v(" Bon de commande ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_proforma"},domProps:{"value":_vm.pdfModel.use_proforma}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_proforma),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_proforma", $$v)},expression:"pdfModel.use_proforma"}},[_vm._v(" Facture proforma ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_delivery"},domProps:{"value":_vm.pdfModel.use_delivery}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_delivery),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_delivery", $$v)},expression:"pdfModel.use_delivery"}},[_vm._v(" Bon de livraison ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_invoice"},domProps:{"value":_vm.pdfModel.use_invoice}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_invoice),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_invoice", $$v)},expression:"pdfModel.use_invoice"}},[_vm._v(" Facture ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_credit"},domProps:{"value":_vm.pdfModel.use_credit}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_credit),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_credit", $$v)},expression:"pdfModel.use_credit"}},[_vm._v(" Avoir ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_provider_command"},domProps:{"value":_vm.pdfModel.use_provider_command}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_provider_command),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_provider_command", $$v)},expression:"pdfModel.use_provider_command"}},[_vm._v(" Bon de commande fournisseur ")])],1),(_vm.hasModule('automotive'))?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_automotive"},domProps:{"value":_vm.pdfModel.use_automotive}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_automotive),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_automotive", $$v)},expression:"pdfModel.use_automotive"}},[_vm._v(" Ordre de réparation ")])],1):_vm._e(),_c('b-col')],1)],1),_c('b-form-group',{staticClass:"pt-2",attrs:{"label":"Utiliser par défaut :"}},[_c('b-row',[(_vm.pdfModel.use_quotation)?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_quotation_default"},domProps:{"value":_vm.pdfModel.use_quotation_default}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_quotation_default),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_quotation_default", $$v)},expression:"pdfModel.use_quotation_default"}},[_vm._v(" Devis ")])],1):_vm._e(),(_vm.pdfModel.use_command)?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_command_default"},domProps:{"value":_vm.pdfModel.use_command_default}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_command_default),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_command_default", $$v)},expression:"pdfModel.use_command_default"}},[_vm._v(" Bon de commande ")])],1):_vm._e(),(_vm.pdfModel.use_proforma)?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_proforma_default"},domProps:{"value":_vm.pdfModel.use_proforma_default}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_proforma_default),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_proforma_default", $$v)},expression:"pdfModel.use_proforma_default"}},[_vm._v(" Facture proforma ")])],1):_vm._e(),(_vm.pdfModel.use_delivery)?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_delivery_default"},domProps:{"value":_vm.pdfModel.use_delivery_default}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_delivery_default),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_delivery_default", $$v)},expression:"pdfModel.use_delivery_default"}},[_vm._v(" Bon de livraison ")])],1):_vm._e(),(_vm.pdfModel.use_invoice)?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_invoice_default"},domProps:{"value":_vm.pdfModel.use_invoice_default}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_invoice_default),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_invoice_default", $$v)},expression:"pdfModel.use_invoice_default"}},[_vm._v(" Facture ")])],1):_vm._e(),(_vm.pdfModel.use_credit)?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_credit_default"},domProps:{"value":_vm.pdfModel.use_credit_default}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_credit_default),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_credit_default", $$v)},expression:"pdfModel.use_credit_default"}},[_vm._v(" Avoir ")])],1):_vm._e(),(_vm.pdfModel.use_provider_command)?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_provider_command_default"},domProps:{"value":_vm.pdfModel.use_provider_command_default}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_provider_command_default),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_provider_command_default", $$v)},expression:"pdfModel.use_provider_command_default"}},[_vm._v(" Bon de commande fournisseur ")])],1):_vm._e(),(_vm.hasModule('automotive') && _vm.pdfModel.use_automotive)?_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"use_automotive_default"},domProps:{"value":_vm.pdfModel.use_automotive_default}}),_c('k-form-checkbox',{model:{value:(_vm.pdfModel.use_automotive_default),callback:function ($$v) {_vm.$set(_vm.pdfModel, "use_automotive_default", $$v)},expression:"pdfModel.use_automotive_default"}},[_vm._v(" Ordre de réparation ")])],1):_vm._e(),_c('b-col')],1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.document-logo",modifiers:{"document-logo":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Logo ")])],1),_c('b-collapse',{attrs:{"id":"document-logo","accordion":"document-options","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('k-form-file',{staticClass:"d-inline-block",attrs:{"btnMode":"","btnSize":"sm","btnLabel":_vm.pdfModel.logo ? 'Remplacer le logo' : 'Sélectionner un logo',"imageEdit":"","instantImageEdit":"","imagePreview":"","accept":['image/png', 'image/jpeg'],"size":"sm","name":"logo","url":_vm.formApiUrl,"method":"PUT","removeUploadedFile":""},on:{"onUpload":model => _vm.applyPdfFile(model, 'logo')}}),(_vm.pdfModel.logo)?[_c('b-button',{staticClass:"ml-2",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.deleteLogoModal = true}}},[_vm._v(" Supprimer le logo ")]),(_vm.deleteLogoModal)?_c('ConfirmModal',{attrs:{"message":"Êtes-vous sûr de vouloir supprimer ce logo ?","okTitle":"Supprimer"},on:{"confirmed":_vm.deleteLogo,"hidden":function($event){_vm.deleteLogoModal = false}}}):_vm._e(),_c('div',[_c('img',{staticStyle:{"max-width":"100px","max-height":"100px"},attrs:{"src":'data:image/' +  _vm.pdfModel.logo.extension +';base64,' + _vm.pdfModel.logo.file}})]),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Largeur d'affichage","description":"Laisser vide pour utiliser la largeur automatique"}},[_c('b-input-group',{attrs:{"append":"mm"}},[_c('k-form-spinner',{attrs:{"name":"document[logoWidth]","noDefaultValue":""},model:{value:(_vm.pdfModel.document.logoWidth),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "logoWidth", $$v)},expression:"pdfModel.document.logoWidth"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Hauteur d'affichage","description":"Laisser vide pour utiliser une hauteur automatique"}},[_c('b-input-group',{attrs:{"append":"mm"}},[_c('k-form-spinner',{attrs:{"name":"document[logoHeight]","noDefaultValue":""},model:{value:(_vm.pdfModel.document.logoHeight),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "logoHeight", $$v)},expression:"pdfModel.document.logoHeight"}})],1)],1)],1)],1)]:_vm._e()],2)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.document-layout",modifiers:{"document-layout":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Mise en page ")])],1),_c('b-collapse',{attrs:{"id":"document-layout","accordion":"document-options","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-form-group',{attrs:{"label":"Marges du document"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Haut","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{staticClass:"small-spinner",attrs:{"size":"sm","min":"0","left":"","name":"document[marginTop]"},model:{value:(_vm.pdfModel.document.marginTop),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "marginTop", $$v)},expression:"pdfModel.document.marginTop"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Droite","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{staticClass:"small-spinner",attrs:{"size":"sm","min":"0","left":"","name":"document[marginRight]"},model:{value:(_vm.pdfModel.document.marginRight),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "marginRight", $$v)},expression:"pdfModel.document.marginRight"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Gauche","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{staticClass:"small-spinner",attrs:{"size":"sm","min":"0","left":"","name":"document[marginLeft]"},model:{value:(_vm.pdfModel.document.marginLeft),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "marginLeft", $$v)},expression:"pdfModel.document.marginLeft"}})],1)],1)],1)],1)],1),_c('b-form-group',{attrs:{"label":"Fond du document"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Couleur de fond","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm","name":"document[bgColor]"},model:{value:(_vm.pdfModel.document.bgColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "bgColor", $$v)},expression:"pdfModel.document.bgColor"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"document-bg-file",attrs:{"label":"Image de fond","label-size":"sm"}},[_c('k-form-file',{staticClass:"d-inline-block",attrs:{"btnMode":"","btnSize":"sm","btnLabel":_vm.pdfModel.background_image ? 'Remplacer l\'image' : 'Sélectionner une image',"imagePreview":"","accept":['image/png', 'image/jpeg'],"size":"sm","name":"background_image","url":_vm.formApiUrl,"method":"PUT","removeUploadedFile":""},on:{"onUpload":model => _vm.applyPdfFile(model, 'background_image')}}),(_vm.pdfModel.background_image)?[_c('b-button',{staticClass:"ml-2",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.deleteBackgroundImageModal = true}}},[_vm._v(" Supprimer l'image de fond ")]),(_vm.deleteBackgroundImageModal)?_c('ConfirmModal',{attrs:{"message":"Êtes-vous sûr de vouloir supprimer l'image de fond ?","okTitle":"Supprimer"},on:{"confirmed":_vm.deleteBackgroundImage,"hidden":function($event){_vm.deleteBackgroundImageModal = false}}}):_vm._e(),_c('div',[_c('img',{staticClass:"border mt-2",staticStyle:{"max-width":"100px","max-height":"100px"},attrs:{"src":'data:image/' +  _vm.pdfModel.background_image.extension +';base64,' + _vm.pdfModel.background_image.file}})])]:_vm._e()],2)],1)],1)],1),_c('b-form-group',{attrs:{"label":"Texte"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Police d'écriture","label-size":"sm"}},[_c('k-form-select',{attrs:{"options":_vm.fontFamilies,"reduce":opt => opt.value,"size":"sm","clearable":false,"name":"document[textFont]"},model:{value:(_vm.pdfModel.document.textFont),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "textFont", $$v)},expression:"pdfModel.document.textFont"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Taille du texte","label-size":"sm"}},[_c('k-form-spinner',{staticClass:"small-spinner",attrs:{"size":"sm","min":"1","name":"document[textSize]"},model:{value:(_vm.pdfModel.document.textSize),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "textSize", $$v)},expression:"pdfModel.document.textSize"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Couleur du texte","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm","name":"document[textColor]"},model:{value:(_vm.pdfModel.document.textColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "textColor", $$v)},expression:"pdfModel.document.textColor"}})],1)],1)],1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.document-options",modifiers:{"document-options":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Options d'affichage ")])],1),_c('b-collapse',{attrs:{"id":"document-options","accordion":"document-options","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-form-group',{attrs:{"label":"Document :"}},[_c('k-form-checkbox',{staticClass:"mt-2",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.document.showPageNumber),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "showPageNumber", $$v)},expression:"pdfModel.document.showPageNumber"}},[_vm._v(" Afficher le numéro de page en bas à droite ")]),_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"Afficher des conditions générales de vente :","label-size":"sm"}},[_c('k-form-select',{attrs:{"ajax":_vm.saleTermApiUrl,"validateName":"sale_term"},model:{value:(_vm.pdfModel.sale_term),callback:function ($$v) {_vm.$set(_vm.pdfModel, "sale_term", $$v)},expression:"pdfModel.sale_term"}})],1)],1),_c('b-form-group',{attrs:{"label":"Adresse de facturation :"}},[_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.document.customerNameBold),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "customerNameBold", $$v)},expression:"pdfModel.document.customerNameBold"}},[_vm._v(" Afficher le nom du client en gras dans l'adresse de facturation et de livraison ")])],1)],1)],1)],1)],1),_c('b-tab',{attrs:{"title":"Contenu du document"}},[_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.table-columns",modifiers:{"table-columns":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Personnalisation des colonnes ")])],1),_c('b-collapse',{attrs:{"id":"table-columns","accordion":"table-custom","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('table',{staticClass:"table table-sm table-bordered align-middle"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"30px"}}),_c('th',[_vm._v("Colonne")]),_c('th',[_vm._v("Désignation 1")]),_c('th',[_vm._v("Désignation 2")]),_c('th',{staticStyle:{"max-width":"140px"}},[_vm._v("Largeur")]),_c('th',[_vm._v("Alignement")])])]),_c('draggable',{attrs:{"tag":"tbody","handle":".draggable-handle"},model:{value:(_vm.pdfModel.columns),callback:function ($$v) {_vm.$set(_vm.pdfModel, "columns", $$v)},expression:"pdfModel.columns"}},_vm._l((_vm.pdfModel.columns),function(column,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center"},[_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}})],1),_c('td',[_vm._v(_vm._s(_vm.tableColumn(column.ident).name))]),_c('td',[_c('k-form-input',{attrs:{"placeholder":_vm.tableColumn(column.ident).placeholder,"size":"sm"},model:{value:(_vm.pdfModel.columns[i].label),callback:function ($$v) {_vm.$set(_vm.pdfModel.columns[i], "label", $$v)},expression:"pdfModel.columns[i].label"}})],1),_c('td',[(_vm.tableColumn(column.ident).placeholder2)?_c('k-form-input',{attrs:{"placeholder":_vm.tableColumn(column.ident).placeholder2,"size":"sm"},model:{value:(_vm.pdfModel.columns[i].label2),callback:function ($$v) {_vm.$set(_vm.pdfModel.columns[i], "label2", $$v)},expression:"pdfModel.columns[i].label2"}}):_vm._e()],1),_c('td',[(!_vm.tableColumn(column.ident).noWidth)?_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"size":"sm","min":1,"left":""},model:{value:(_vm.pdfModel.columns[i].width),callback:function ($$v) {_vm.$set(_vm.pdfModel.columns[i], "width", $$v)},expression:"pdfModel.columns[i].width"}})],1):_vm._e()],1),_c('td',[_c('k-form-select',{attrs:{"options":_vm.columnsAlignment,"reduce":opt => opt.value,"size":"sm","clearable":false},model:{value:(_vm.pdfModel.columns[i].align),callback:function ($$v) {_vm.$set(_vm.pdfModel.columns[i], "align", $$v)},expression:"pdfModel.columns[i].align"}})],1)])}),0)],1)])],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.table-margins",modifiers:{"table-margins":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Marges ")])],1),_c('b-collapse',{attrs:{"id":"table-margins","accordion":"table-custom","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-form-group',{attrs:{"label":"Marges du tableau"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Haut","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.marginTop),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "marginTop", $$v)},expression:"pdfModel.tableOptions.marginTop"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Bas","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.marginBottom),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "marginBottom", $$v)},expression:"pdfModel.tableOptions.marginBottom"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Espacement entre les lignes","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.marginCell),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "marginCell", $$v)},expression:"pdfModel.tableOptions.marginCell"}})],1)],1)],1)],1)],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Marges interne des cellules"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Haut","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.cellPaddingTop),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "cellPaddingTop", $$v)},expression:"pdfModel.tableOptions.cellPaddingTop"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Bas","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.cellPaddingBottom),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "cellPaddingBottom", $$v)},expression:"pdfModel.tableOptions.cellPaddingBottom"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Droite","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.cellPaddingRight),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "cellPaddingRight", $$v)},expression:"pdfModel.tableOptions.cellPaddingRight"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Gauche","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.cellPaddingLeft),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "cellPaddingLeft", $$v)},expression:"pdfModel.tableOptions.cellPaddingLeft"}})],1)],1)],1)],1),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyPaddingTotalsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyPaddingTotalsTable", $$v)},expression:"pdfModel.tableOptions.applyPaddingTotalsTable"}},[_vm._v(" Appliquer au tableau des totaux ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyPaddingRatesTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyPaddingRatesTable", $$v)},expression:"pdfModel.tableOptions.applyPaddingRatesTable"}},[_vm._v(" Appliquer au tableau du détail de la TVA ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyPaddingPaymentsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyPaddingPaymentsTable", $$v)},expression:"pdfModel.tableOptions.applyPaddingPaymentsTable"}},[_vm._v(" Appliquer au tableau de la liste des encaissements ")])],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.table-colors",modifiers:{"table-colors":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Mise en page et couleurs ")])],1),_c('b-collapse',{attrs:{"id":"table-colors","accordion":"table-custom","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-form-group',{attrs:{"label":"En-têtes"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Taille du texte","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":1,"left":"","size":"sm","noDefaultValue":true},model:{value:(_vm.pdfModel.tableOptions.thFontSize),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "thFontSize", $$v)},expression:"pdfModel.tableOptions.thFontSize"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur du texte","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.thTextColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "thTextColor", $$v)},expression:"pdfModel.tableOptions.thTextColor"}}),(_vm.pdfModel.tableOptions.thTextColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.tableOptions.thTextColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur de fond","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.thBgColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "thBgColor", $$v)},expression:"pdfModel.tableOptions.thBgColor"}}),(_vm.pdfModel.tableOptions.thBgColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.tableOptions.thBgColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1)],1),_c('k-form-checkbox',{staticClass:"mt-2",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.boldTh),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "boldTh", $$v)},expression:"pdfModel.tableOptions.boldTh"}},[_vm._v(" Afficher les titres des tableaux en gras ")]),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyHeadTotalsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyHeadTotalsTable", $$v)},expression:"pdfModel.tableOptions.applyHeadTotalsTable"}},[_vm._v(" Appliquer les couleurs au tableau des totaux ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyHeadRatesTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyHeadRatesTable", $$v)},expression:"pdfModel.tableOptions.applyHeadRatesTable"}},[_vm._v(" Appliquer les couleurs au tableau du détail de la TVA ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyHeadPaymentsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyHeadPaymentsTable", $$v)},expression:"pdfModel.tableOptions.applyHeadPaymentsTable"}},[_vm._v(" Appliquer les couleurs au tableau de la liste des encaissements ")])],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Contenu"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Taille du texte","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":1,"left":"","size":"sm","noDefaultValue":true},model:{value:(_vm.pdfModel.tableOptions.tdFontSize),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "tdFontSize", $$v)},expression:"pdfModel.tableOptions.tdFontSize"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur du texte","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.tdTextColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "tdTextColor", $$v)},expression:"pdfModel.tableOptions.tdTextColor"}}),(_vm.pdfModel.tableOptions.tdTextColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.tableOptions.tdTextColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur de fond","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.tdBgColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "tdBgColor", $$v)},expression:"pdfModel.tableOptions.tdBgColor"}}),(_vm.pdfModel.tableOptions.tdBgColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.tableOptions.tdBgColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1)],1),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyCellTotalsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyCellTotalsTable", $$v)},expression:"pdfModel.tableOptions.applyCellTotalsTable"}},[_vm._v(" Appliquer les couleurs au tableau des totaux ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyCellRatesTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyCellRatesTable", $$v)},expression:"pdfModel.tableOptions.applyCellRatesTable"}},[_vm._v(" Appliquer les couleurs au tableau du détail de la TVA ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyCellPaymentsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyCellPaymentsTable", $$v)},expression:"pdfModel.tableOptions.applyCellPaymentsTable"}},[_vm._v(" Appliquer les couleurs au tableau de la liste des encaissements ")])],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Ligne de commentaires"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur du texte","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.commentsTextColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "commentsTextColor", $$v)},expression:"pdfModel.tableOptions.commentsTextColor"}}),(_vm.pdfModel.tableOptions.commentsTextColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.tableOptions.commentsTextColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur de fond","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.commentsBgColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "commentsBgColor", $$v)},expression:"pdfModel.tableOptions.commentsBgColor"}}),(_vm.pdfModel.tableOptions.commentsBgColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.tableOptions.commentsBgColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1)],1)],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Bordures"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Taille de la bordure","label-size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm","noDefaultValue":true},model:{value:(_vm.pdfModel.tableOptions.borderWidth),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "borderWidth", $$v)},expression:"pdfModel.tableOptions.borderWidth"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur des bordures","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.tableOptions.borderColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "borderColor", $$v)},expression:"pdfModel.tableOptions.borderColor"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Type de bordures","label-size":"sm"}},[_c('k-form-select',{attrs:{"options":_vm.borderTypes,"reduce":opt => opt.value,"size":"sm","clearable":false},model:{value:(_vm.pdfModel.tableOptions.borderType),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "borderType", $$v)},expression:"pdfModel.tableOptions.borderType"}})],1)],1)],1),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.borderTh),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "borderTh", $$v)},expression:"pdfModel.tableOptions.borderTh"}},[_vm._v(" Ajouter une bordure sous les en-têtes ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.borderCell),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "borderCell", $$v)},expression:"pdfModel.tableOptions.borderCell"}},[_vm._v(" Ajouter une bordure entre chaque ligne ")]),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyBorderColorTotalsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyBorderColorTotalsTable", $$v)},expression:"pdfModel.tableOptions.applyBorderColorTotalsTable"}},[_vm._v(" Appliquer la taille et la couleur au tableau des totaux ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyBorderColorRatesTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyBorderColorRatesTable", $$v)},expression:"pdfModel.tableOptions.applyBorderColorRatesTable"}},[_vm._v(" Appliquer la taille et la couleur au tableau du détail de la TVA ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.tableOptions.applyBorderColorPaymentsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyBorderColorPaymentsTable", $$v)},expression:"pdfModel.tableOptions.applyBorderColorPaymentsTable"}},[_vm._v(" Appliquer la taille et la couleur au tableau de la liste des encaissements ")])],1),_c('b-col',[_c('k-form-checkbox',{attrs:{"size":"sm","disabled":_vm.pdfModel.tableOptions.applyBorderColorTotalsTable !== true},model:{value:(_vm.pdfModel.tableOptions.applyBorderTypeTotalsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyBorderTypeTotalsTable", $$v)},expression:"pdfModel.tableOptions.applyBorderTypeTotalsTable"}},[_vm._v(" Appliquer les types de bordures au tableau des totaux ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm","disabled":_vm.pdfModel.tableOptions.applyBorderColorRatesTable !== true},model:{value:(_vm.pdfModel.tableOptions.applyBorderTypeRatesTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyBorderTypeRatesTable", $$v)},expression:"pdfModel.tableOptions.applyBorderTypeRatesTable"}},[_vm._v(" Appliquer les types de bordures au tableau du détail de la TVA ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm","disabled":_vm.pdfModel.tableOptions.applyBorderColorPaymentsTable !== true},model:{value:(_vm.pdfModel.tableOptions.applyBorderTypePaymentsTable),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "applyBorderTypePaymentsTable", $$v)},expression:"pdfModel.tableOptions.applyBorderTypePaymentsTable"}},[_vm._v(" Appliquer les types de bordures au tableau de la liste des encaissements ")])],1)],1)],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Tableau des totaux (Total HT, TVA, Total TTC, ...) :"}},[_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.document.showPaymentStatus),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "showPaymentStatus", $$v)},expression:"pdfModel.document.showPaymentStatus"}},[_vm._v(" Afficher le montant déjà réglé et le reste à payer sur les factures ")]),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"size":"sm"},model:{value:(_vm.pdfModel.document.globalDiscountBold),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "globalDiscountBold", $$v)},expression:"pdfModel.document.globalDiscountBold"}},[_vm._v(" Mettre la remise générale en gras ")]),_c('b-form-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Couleur de fond du tableau","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.document.totalsBgColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "totalsBgColor", $$v)},expression:"pdfModel.document.totalsBgColor"}}),(_vm.pdfModel.document.totalsBgColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.document.totalsBgColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Couleur du texte du tableau","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.document.totalsTextColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "totalsTextColor", $$v)},expression:"pdfModel.document.totalsTextColor"}}),(_vm.pdfModel.document.totalsTextColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.document.totalsTextColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1)],1),_c('b-form-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Couleur de fond de la remise","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.document.globalDiscountBgColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "globalDiscountBgColor", $$v)},expression:"pdfModel.document.globalDiscountBgColor"}}),(_vm.pdfModel.document.globalDiscountBgColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.document.globalDiscountBgColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Couleur du texte de la remise","label-size":"sm"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.pdfModel.document.globalDiscountTextColor),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "globalDiscountTextColor", $$v)},expression:"pdfModel.document.globalDiscountTextColor"}}),(_vm.pdfModel.document.globalDiscountTextColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.document.globalDiscountTextColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1)],1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.table-options",modifiers:{"table-options":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Options d'affichage ")])],1),_c('b-collapse',{attrs:{"id":"table-options","accordion":"table-custom","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.tableOptions.fullHeight),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "fullHeight", $$v)},expression:"pdfModel.tableOptions.fullHeight"}},[_vm._v(" Étirer le tableau pour occuper toute la hauteur disponible ")]),_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.pdfModel.tableOptions.centerTh),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "centerTh", $$v)},expression:"pdfModel.tableOptions.centerTh"}},[_vm._v(" Centrer tous les titres des colonnes ")]),_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.pdfModel.tableOptions.withCurrency),callback:function ($$v) {_vm.$set(_vm.pdfModel.tableOptions, "withCurrency", $$v)},expression:"pdfModel.tableOptions.withCurrency"}},[_vm._v(" Afficher la devise dans le tableau principal ")])],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.table-products",modifiers:{"table-products":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Description des lignes du document (produits, prestations,...) ")])],1),_c('b-collapse',{attrs:{"id":"table-products","accordion":"table-custom","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('p',[_vm._v(" Vous pouvez personnaliser la manière dont la description des différentes lignes apparaîtront dans vos documents."),_c('br')]),_c('b-form-group',{attrs:{"label":"Description :","label-size":"sm"}},[_c('k-form-editor',{attrs:{"config":_vm.computedProductEditorConfig,"size":"sm","required":"","validate":"saleDocumentLineContent"},model:{value:(_vm.pdfModel.document.contentDesignation),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "contentDesignation", $$v)},expression:"pdfModel.document.contentDesignation"}}),_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.document.contentDesignation = _vm.defaultLineDesignation}}},[_vm._v(" Réinitialiser ")]),_vm._v(" | "),_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.pdfModel.document.contentDesignation += _vm.defaultLineDesignation}}},[_vm._v(" Ajouter la variable \"Désignation\" ")])],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.table-customs",modifiers:{"table-customs":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Personnalisation des textes ")])],1),_c('b-collapse',{attrs:{"id":"table-customs","accordion":"table-custom","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('p',[_vm._v(" Vous pouvez personnaliser ici les différentes textes qui sont présents dans les tableaux générés automatiquement (Exemple : tableau des totaux, liste des paiements...) ")]),_c('h3',{staticClass:"form-title-alt mt-0"},[_vm._v(" Contenu du document ")]),_c('b-row',{attrs:{"cols":"4"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Remise de [RATE] [TYPE]","description":"[TYPE] correspond au type de remise : % ou €"}},[_c('k-form-input',{attrs:{"validate":"pdfModelTotalRateLabel|pdfModelTotalTypeLabel","placeholder":"Remise de [RATE] [TYPE]"},model:{value:(_vm.pdfModel.tables.contents.discount),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.contents, "discount", $$v)},expression:"pdfModel.tables.contents.discount"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"En option"}},[_c('k-form-input',{attrs:{"placeholder":"En option"},model:{value:(_vm.pdfModel.tables.contents.option),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.contents, "option", $$v)},expression:"pdfModel.tables.contents.option"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Pas d'escompte en cas de paiement anticipé"}},[_c('k-form-input',{attrs:{"placeholder":"Pas d'escompte en cas de paiement anticipé"},model:{value:(_vm.pdfModel.tables.contents.noEscompte),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.contents, "noEscompte", $$v)},expression:"pdfModel.tables.contents.noEscompte"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Escompte de [RATE] %"}},[_c('k-form-input',{attrs:{"placeholder":"Escompte de [RATE] %","validate":"pdfModelTotalRateLabel"},model:{value:(_vm.pdfModel.tables.contents.escompte),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.contents, "escompte", $$v)},expression:"pdfModel.tables.contents.escompte"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Tableau des totaux ")]),_c('b-row',{attrs:{"cols":"4"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Total HT :"}},[_c('k-form-input',{attrs:{"placeholder":"Total HT :"},model:{value:(_vm.pdfModel.tables.totals.totalHt),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "totalHt", $$v)},expression:"pdfModel.tables.totals.totalHt"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Total TVA :"}},[_c('k-form-input',{attrs:{"placeholder":"Total TVA :"},model:{value:(_vm.pdfModel.tables.totals.totalTva),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "totalTva", $$v)},expression:"pdfModel.tables.totals.totalTva"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"TVA [RATE] % :"}},[_c('k-form-input',{attrs:{"validate":"pdfModelTotalRateLabel","placeholder":"TVA [RATE] % :"},model:{value:(_vm.pdfModel.tables.totals.totalTvaPourcent),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "totalTvaPourcent", $$v)},expression:"pdfModel.tables.totals.totalTvaPourcent"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Total TTC :"}},[_c('k-form-input',{attrs:{"placeholder":"Total TTC :"},model:{value:(_vm.pdfModel.tables.totals.totalTtc),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "totalTtc", $$v)},expression:"pdfModel.tables.totals.totalTtc"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Remise [RATE] :"}},[_c('k-form-input',{attrs:{"validate":"pdfModelTotalRateLabel","placeholder":"Remise [RATE] :"},model:{value:(_vm.pdfModel.tables.totals.discount),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "discount", $$v)},expression:"pdfModel.tables.totals.discount"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Acompte(s) versé(s) :"}},[_c('k-form-input',{attrs:{"placeholder":"Acompte(s) versé(s) :"},model:{value:(_vm.pdfModel.tables.totals.deposit),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "deposit", $$v)},expression:"pdfModel.tables.totals.deposit"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"À payer :"}},[_c('k-form-input',{attrs:{"placeholder":"À payer :"},model:{value:(_vm.pdfModel.tables.totals.toPaid),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "toPaid", $$v)},expression:"pdfModel.tables.totals.toPaid"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Déjà payé :"}},[_c('k-form-input',{attrs:{"placeholder":"Déjà payé :"},model:{value:(_vm.pdfModel.tables.totals.alreadyPay),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "alreadyPay", $$v)},expression:"pdfModel.tables.totals.alreadyPay"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Reste à payer :"}},[_c('k-form-input',{attrs:{"placeholder":"Reste à payer :"},model:{value:(_vm.pdfModel.tables.totals.stayToPay),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "stayToPay", $$v)},expression:"pdfModel.tables.totals.stayToPay"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Retenue de garantie ([RATE] %) :"}},[_c('k-form-input',{attrs:{"validate":"pdfModelTotalRateLabel","placeholder":"RG ([RATE] %) :"},model:{value:(_vm.pdfModel.tables.totals.guaranteeHoldback),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.totals, "guaranteeHoldback", $$v)},expression:"pdfModel.tables.totals.guaranteeHoldback"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Détails de la TVA ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Base HT"}},[_c('k-form-input',{attrs:{"placeholder":"Base HT"},model:{value:(_vm.pdfModel.tables.rates.base),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.rates, "base", $$v)},expression:"pdfModel.tables.rates.base"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Taux TVA"}},[_c('k-form-input',{attrs:{"placeholder":"Taux TVA"},model:{value:(_vm.pdfModel.tables.rates.rate),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.rates, "rate", $$v)},expression:"pdfModel.tables.rates.rate"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Montant TVA"}},[_c('k-form-input',{attrs:{"placeholder":"Montant TVA"},model:{value:(_vm.pdfModel.tables.rates.amount),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.rates, "amount", $$v)},expression:"pdfModel.tables.rates.amount"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Liste des encaissements ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Date"}},[_c('k-form-input',{attrs:{"placeholder":"Date"},model:{value:(_vm.pdfModel.tables.payments.date),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.payments, "date", $$v)},expression:"pdfModel.tables.payments.date"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Type"}},[_c('k-form-input',{attrs:{"placeholder":"Type"},model:{value:(_vm.pdfModel.tables.payments.type),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.payments, "type", $$v)},expression:"pdfModel.tables.payments.type"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Référence"}},[_c('k-form-input',{attrs:{"placeholder":"Référence"},model:{value:(_vm.pdfModel.tables.payments.reference),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.payments, "reference", $$v)},expression:"pdfModel.tables.payments.reference"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Montant"}},[_c('k-form-input',{attrs:{"placeholder":"Montant"},model:{value:(_vm.pdfModel.tables.payments.amount),callback:function ($$v) {_vm.$set(_vm.pdfModel.tables.payments, "amount", $$v)},expression:"pdfModel.tables.payments.amount"}})],1)],1)],1)],1)],1)],1)],1),_c('b-tab',{attrs:{"title":"Page de garde"}},[_c('b-form-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Type de page de garde :"}},[_c('b-form-radio-group',{model:{value:(_vm.pdfModel.cover.mode),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "mode", $$v)},expression:"pdfModel.cover.mode"}},[_c('b-form-radio',{attrs:{"value":"editor"}},[_vm._v(" Utiliser l'éditeur de texte ")]),_c('b-form-radio',{attrs:{"value":"pdf"}},[_vm._v(" Utiliser des fichiers PDF ")])],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Numérotation des pages :"}},[_c('k-form-select',{attrs:{"options":_vm.coverPageNumberChoices,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.pdfModel.cover.pageNumber),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "pageNumber", $$v)},expression:"pdfModel.cover.pageNumber"}})],1)],1)],1),(_vm.pdfModel.cover.mode === 'editor')?_c('div',[_c('b-form-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"pr-4",attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Personnalisation du pied de page :"}},[(_vm.pdfModel.cover.mode === 'editor')?_c('k-form-checkbox',{staticClass:"pt-1",model:{value:(_vm.pdfModel.cover.showFooter),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "showFooter", $$v)},expression:"pdfModel.cover.showFooter"}},[_vm._v(" Afficher le pied de page sur la page de garde ")]):_vm._e()],1)],1),_c('b-col',[(!_vm.pdfModel.cover.showFooter)?_c('b-form-group',{attrs:{"label":"Marge du bas de page :"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"size":"sm","left":""},model:{value:(_vm.pdfModel.cover.marginBottom),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "marginBottom", $$v)},expression:"pdfModel.cover.marginBottom"}})],1)],1):_vm._e()],1)],1),_c('b-form-group',{attrs:{"label":"Afficher la page de garde sur les documents suivants :"}},[_c('b-form-row',{staticClass:"mt-2"},[(_vm.pdfModel.use_quotation)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.cover.quotation),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "quotation", $$v)},expression:"pdfModel.cover.quotation"}},[_vm._v(" Devis ")])],1):_vm._e(),(_vm.pdfModel.use_invoice)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.cover.invoice),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "invoice", $$v)},expression:"pdfModel.cover.invoice"}},[_vm._v(" Facture ")])],1):_vm._e(),(_vm.pdfModel.use_credit)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.cover.credit),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "credit", $$v)},expression:"pdfModel.cover.credit"}},[_vm._v(" Avoir ")])],1):_vm._e(),(_vm.pdfModel.use_command)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.cover.command),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "command", $$v)},expression:"pdfModel.cover.command"}},[_vm._v(" Bon de commande ")])],1):_vm._e(),(_vm.pdfModel.use_proforma)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.cover.proforma),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "proforma", $$v)},expression:"pdfModel.cover.proforma"}},[_vm._v(" Facture proforma ")])],1):_vm._e(),(_vm.pdfModel.use_delivery)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.cover.delivery),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "delivery", $$v)},expression:"pdfModel.cover.delivery"}},[_vm._v(" Bon de livraison ")])],1):_vm._e(),(_vm.pdfModel.use_provider_command)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.cover.provider_command),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "provider_command", $$v)},expression:"pdfModel.cover.provider_command"}},[_vm._v(" Bon de commande fournisseur ")])],1):_vm._e(),(_vm.pdfModel.use_automotive)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.pdfModel.cover.automotive),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "automotive", $$v)},expression:"pdfModel.cover.automotive"}},[_vm._v(" Ordre de réparation ")])],1):_vm._e()],1)],1),_c('b-form-group',{attrs:{"label":"Contenu de la page de garde :"}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.pdfModel.cover.content),callback:function ($$v) {_vm.$set(_vm.pdfModel.cover, "content", $$v)},expression:"pdfModel.cover.content"}})],1)],1):_vm._e(),(_vm.pdfModel.cover.mode === 'pdf')?_c('div',[_c('k-form-file',{attrs:{"btnMode":"","btnSize":"sm","btnLabel":"Sélectionner un fichier","multiple":true,"accept":['application/pdf'],"size":"sm","name":"add_cover_pages[]","url":_vm.formApiUrl,"method":"PUT","removeUploadedFile":""},on:{"onUpload":model => _vm.applyPdfFile(model, 'coverPages')}}),_c('table',{staticClass:"table table-sm table-bordered align-middle"},[_c('thead',[_c('tr',[_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}}),_c('th',[_vm._v("Nom du fichier")]),_c('th',{staticStyle:{"width":"180px"}},[_vm._v("Utilisation")]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),(_vm.pdfModel.coverPages.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-3",attrs:{"colspan":"4"}},[_vm._v(" Aucun fichier ")])])]):_c('draggable',{attrs:{"tag":"tbody","handle":".draggable-handle"},model:{value:(_vm.pdfModel.coverPages),callback:function ($$v) {_vm.$set(_vm.pdfModel, "coverPages", $$v)},expression:"pdfModel.coverPages"}},_vm._l((_vm.pdfModel.coverPages),function(cover,i){return _c('tr',{key:i},[_c('td',{staticClass:"p-0 text-center"},[(_vm.pdfModel.coverPages.length > 1)?_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e()],1),_c('td',[_vm._v(_vm._s(cover.filename))]),_c('td',[_c('k-form-select',{attrs:{"options":_vm.computedCoverPageDocumentChoices,"size":"sm","reduce":opt => opt.value,"clearable":false},model:{value:(_vm.pdfModel.coverPages[i].restrict),callback:function ($$v) {_vm.$set(_vm.pdfModel.coverPages[i], "restrict", $$v)},expression:"pdfModel.coverPages[i].restrict"}})],1),_c('td',{staticClass:"p-0 text-center"},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"text-danger",attrs:{"icon":['fas', 'times'],"title":"Supprimer le fichier"},on:{"click":function($event){$event.preventDefault();_vm.toDeleteCoverPage = cover}}})],1)])}),0)],1),_c('b-modal',{attrs:{"visible":_vm.toDeleteCoverPage !== null,"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"no-close-on-backdrop":_vm.deletingCoverPage,"no-close-on-esc":_vm.deletingCoverPage,"busy":_vm.deletingCoverPage},on:{"ok":_vm.deleteCoverPage,"hidden":function($event){_vm.toDeleteCoverPage = null}}},[(_vm.deletingCoverPage )?_c('Spinner'):[_vm._v(" Êtes-vous sûr de vouloir supprimer cette page de garde ? ")]],2)],1):_vm._e()],1),_c('b-tab',{attrs:{"title":"Documents liés"}},[_c('p',[_vm._v(" Vous pouvez ajouter des documents PDF qui seront automatiquement ajoutés après le document généré. ")]),_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"Affichage du numéro de page :","label-cols":"auto"}},[_c('b-form-radio-group',{staticClass:"pt-2",model:{value:(_vm.pdfModel.document.linkedDocumentPageNumber),callback:function ($$v) {_vm.$set(_vm.pdfModel.document, "linkedDocumentPageNumber", $$v)},expression:"pdfModel.document.linkedDocumentPageNumber"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" Afficher ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" Masquer ")])],1)],1),_c('k-form-file',{attrs:{"btnMode":"","btnSize":"sm","btnLabel":"Sélectionner un fichier","multiple":true,"accept":['application/pdf'],"size":"sm","name":"add_linked_documents[]","url":_vm.formApiUrl,"method":"PUT","removeUploadedFile":""},on:{"onUpload":model => _vm.applyPdfFile(model, 'linkedDocuments')}}),_c('table',{staticClass:"table table-sm table-bordered align-middle"},[_c('thead',[_c('tr',[_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}}),_c('th',[_vm._v("Nom du fichier")]),_c('th',{staticStyle:{"width":"180px"}},[_vm._v("Utilisation")]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),(_vm.pdfModel.linkedDocuments.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-3",attrs:{"colspan":"4"}},[_vm._v(" Aucun fichier ")])])]):_c('draggable',{attrs:{"tag":"tbody","handle":".draggable-handle"},model:{value:(_vm.pdfModel.linkedDocuments),callback:function ($$v) {_vm.$set(_vm.pdfModel, "linkedDocuments", $$v)},expression:"pdfModel.linkedDocuments"}},_vm._l((_vm.pdfModel.linkedDocuments),function(document,i){return _c('tr',{key:i},[_c('td',{staticClass:"p-0 text-center"},[(_vm.pdfModel.linkedDocuments.length > 1)?_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e()],1),_c('td',[_vm._v(_vm._s(document.filename))]),_c('td',[_c('k-form-select',{attrs:{"options":_vm.computedCoverPageDocumentChoices,"size":"sm","reduce":opt => opt.value,"clearable":false},model:{value:(_vm.pdfModel.linkedDocuments[i].restrict),callback:function ($$v) {_vm.$set(_vm.pdfModel.linkedDocuments[i], "restrict", $$v)},expression:"pdfModel.linkedDocuments[i].restrict"}})],1),_c('td',{staticClass:"p-0 text-center"},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"text-danger",attrs:{"icon":['fas', 'times'],"title":"Supprimer le fichier"},on:{"click":function($event){$event.preventDefault();_vm.toDeleteLinkedDocument = document}}})],1)])}),0)],1),_c('b-modal',{attrs:{"visible":_vm.toDeleteLinkedDocument !== null,"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"no-close-on-backdrop":_vm.deletingLinkedDocument,"no-close-on-esc":_vm.deletingLinkedDocument,"busy":_vm.deletingLinkedDocument},on:{"ok":_vm.deleteLinkedDocument,"hidden":function($event){_vm.toDeleteLinkedDocument = null}}},[(_vm.deletingLinkedDocument )?_c('Spinner'):[_vm._v(" Êtes-vous sûr de vouloir supprimer ce document lié ? ")]],2)],1)],1),_c('b-row',{staticClass:"mb-2 editor-content-options",attrs:{"align-v":"start"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Version à afficher :","label-size":"sm"}},[_c('k-form-select',{attrs:{"options":_vm.computedDocumentTypes,"reduce":opt => opt.value,"clearable":false,"size":"sm"},model:{value:(_vm.previewDocumentType),callback:function ($$v) {_vm.previewDocumentType=$$v},expression:"previewDocumentType"}})],1)],1),_c('b-col',{staticClass:"pt-4",attrs:{"cols":"auto"}},[_c('k-form-checkbox',{attrs:{"size":"sm"},model:{value:(_vm.showEditableArea),callback:function ($$v) {_vm.showEditableArea=$$v},expression:"showEditableArea"}},[_vm._v(" Voir les zones éditables ")])],1)],1),_c('b-card',{ref:"editor",class:_vm.documentClasses,style:(_vm.documentStyles),attrs:{"no-body":""}},[_c('div',{ref:"editor-content",staticClass:"editor-content",class:{
          'document-content-full-height': _vm.pdfModel.tableOptions.fullHeight
        },style:(_vm.documentMargins)},[_c('PdfModelArea',{staticClass:"top-area",attrs:{"pdf-model":_vm.pdfModel,"preview":_vm.previewDocumentType},model:{value:(_vm.pdfModel.top),callback:function ($$v) {_vm.$set(_vm.pdfModel, "top", $$v)},expression:"pdfModel.top"}}),_c('div',{ref:"document-content",staticClass:"document-content"},[_c('table',{staticClass:"w-100 document-table",style:(_vm.tableStyles)},[_c('tbody',[_c('tr',_vm._l((_vm.previewTableColumns),function(column,i){return _c('th',{key:i,style:(_vm.thStyles(column))},[_vm._v(" "+_vm._s(column.label !== null && column.label !== '' ? column.label : _vm.tableColumn(column.ident).placeholder)+" ")])}),0),_vm._l((_vm.demoTableContent),function(content,i){return _c('tr',{key:i},_vm._l((_vm.previewTableColumns),function(column,j){return _c('td',{key:j,style:(_vm.tdStyles(column))},[_vm._v(" "+_vm._s(_vm.tableColumn(column.ident).render ? _vm.tableColumn(column.ident).render(content[column.ident]) : content[column.ident])+" "),((i + 1) === _vm.demoTableContent.length && column.ident === 'designation')?_c('div',{staticClass:"min-height-cell",style:({ 'min-height': _vm.minCellHeight + 'px' })}):_vm._e()])}),0)})],2)]),_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('strong',[_vm._v("Toutes les colonnes sont affichées dans la prévisualisation du modèle PDF.")]),_c('br'),_vm._v(" Vous pouvez sélectionner quelles colonnes afficher dans \"Config\" > \"Ventes\" > \"Paramètres\" ou directement lors de l'édition d'un document. ")])],1),_c('PdfModelArea',{staticClass:"bottom-area",attrs:{"pdf-model":_vm.pdfModel,"preview":_vm.previewDocumentType},model:{value:(_vm.pdfModel.bottom),callback:function ($$v) {_vm.$set(_vm.pdfModel, "bottom", $$v)},expression:"pdfModel.bottom"}})],1),_c('PdfModelBlock',{attrs:{"pdf-model":_vm.pdfModel,"preview":_vm.previewDocumentType,"is-footer":""},model:{value:(_vm.pdfModel.footer),callback:function ($$v) {_vm.$set(_vm.pdfModel, "footer", $$v)},expression:"pdfModel.footer"}})],1),_c('k-form-sticky-bar',{attrs:{"parent":"#page"}},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" Enregistrer ")]),_c('b-button',{staticClass:"ml-3",attrs:{"type":"button","variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.submitAndRedirect.apply(null, arguments)}}},[_vm._v(" Enregistrer et quitter ")])],1)]],2):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuedraggable"
var external_vuedraggable_ = __webpack_require__(25325);
var external_vuedraggable_default = /*#__PURE__*/__webpack_require__.n(external_vuedraggable_);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(55364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: ./src/components/PdfModelBlock/PdfModelBlock.vue + 3 modules
var PdfModelBlock = __webpack_require__(82233);
// EXTERNAL MODULE: ./src/components/PdfModelArea/PdfModelArea.vue + 3 modules
var PdfModelArea = __webpack_require__(1803);
// EXTERNAL MODULE: external "froala-editor"
var external_froala_editor_ = __webpack_require__(30189);
var external_froala_editor_default = /*#__PURE__*/__webpack_require__.n(external_froala_editor_);
;// ./src/components/PdfModelForm/productEditorConfig.ts

var config = {
    enter: (external_froala_editor_default()).ENTER_BR,
    fontSizeUnit: 'pt',
    zIndex: 999999,
    heightMin: 100,
    pastePlain: false,
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'formatUL',
                'formatOL',
                '|',
                'alignLeft',
                'alignCenter',
                'alignRight',
                '|',
                'insertDynamicVariables'
            ],
            buttonsVisible: 16
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    htmlAllowComments: false,
    htmlAllowedAttrs: [
        'align', 'alt', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'class', 'color',
        'cols', 'colspan', 'content', 'contenteditable', 'data', 'data-.*', 'datetime', 'disabled', 'form', 'height',
        'hidden', 'href', 'id', 'label', 'max', 'min', 'multiple', 'name', 'placeholder', 'radiogroup', 'readonly',
        'rel', 'required', 'rows', 'rowspan', 'selected', 'size', 'sizes', 'span', 'src', 'step', 'style', 'tabindex',
        'target', 'title', 'type', 'value', 'valign', 'width'
    ],
    htmlAllowedStyleProps: [
        'font-size', 'background', 'color', 'text-align', 'vertical-align', 'background-color', 'height', 'width',
        'border', 'border-top', 'border-bottom', 'border-right', 'border-left'
    ],
    events: {
        'paste.afterCleanup': function (content) {
            return content.replaceAll(/<br([^>])+?>/gi, '<br>')
                .replaceAll(/font-size: ?([\d.]+)px/gi, 'font-size: $1pt');
        }
    },
    dynamicVariables: {
        common: {
            label: 'Informations sur le produit, la prestation ou le groupe',
            variables: [
                { value: 'DESIGNATION', label: 'Description' },
                { value: 'CATALOG-NAME', label: 'Nom' },
                { value: 'CATALOG-REF', label: 'Référence' },
                { value: 'ECO-PART-UNIT-HT', label: 'Montant unitaire HT de l\'éco-participation' },
                { value: 'ECO-PART-UNIT-TVA', label: 'Montant unitaire TVA de l\'éco-participation' },
                { value: 'ECO-PART-UNIT-TTC', label: 'Montant unitaire TTC de l\'éco-participation' },
                { value: 'ECO-PART-TOTAL-HT', label: 'Montant total HT de l\'éco-participation' },
                { value: 'ECO-PART-TOTAL-TVA', label: 'Montant total TVA de l\'éco-participation' },
                { value: 'ECO-PART-TOTAL-TTC', label: 'Montant total TTC de l\'éco-participation' }
            ]
        },
        product: {
            label: 'Informations sur le produit',
            variables: [
                { value: 'PRODUCT-EAN', label: 'Code EAN' },
                { value: 'PRODUCT-WEIGHT', label: 'Poids' },
                { value: 'PRODUCT-TOTAL-WEIGHT', label: 'Poids total' },
                { value: 'PRODUCT-LOTS', label: 'Informations sur le(s) lot(s)' },
                { value: 'PRODUCT-LOTS-NO-WARRANTY', label: 'Informations sur le(s) lot(s) sans date de garantie ou de péremption' },
                { value: 'SALES-CATEGORY', label: 'Catégorie de vente' },
            ]
        }
    }
};
/* harmony default export */ var productEditorConfig = (config);

// EXTERNAL MODULE: ./src/components/PdfModelBlock/editorConfig.ts
var editorConfig = __webpack_require__(93443);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/mixins/PdfModelMixin.ts
var PdfModelMixin = __webpack_require__(25235);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfModelForm/PdfModelForm.ts?vue&type=script&lang=ts&external














var PdfModelForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelForm, _super);
    function PdfModelForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.showEditableArea = true;
        _this.defaultLineDesignation = '<variable class="fr-dynamic-variable" contenteditable="false" data-variable="DESIGNATION">DESIGNATION</variable>';
        _this.deleteLogoModal = false;
        _this.deleteBackgroundImageModal = false;
        _this.toDeleteCoverPage = null;
        _this.deletingCoverPage = false;
        _this.toDeleteLinkedDocument = null;
        _this.deletingLinkedDocument = false;
        _this.redirectAfterSubmit = false;
        _this.pdfModel = {
            cover: {},
            document: {},
            tableOptions: {},
            top: [],
            bottom: [],
            footer: {},
            columns: [],
            tables: {
                contents: {},
                totals: {},
                rates: {},
                payments: {}
            },
            coverPages: [],
            linkedDocuments: []
        };
        _this.columnsAlignment = [
            { value: 'left', label: 'Gauche' },
            { value: 'center', label: 'Centre' },
            { value: 'right', label: 'Droite' }
        ];
        _this.borderTypes = [
            { value: 'all', label: 'Contour du tableau + Colonnes' },
            { value: 'external', label: 'Contour du tableau seulement' }
        ];
        _this.coverPageNumberChoices = [
            { value: 1, label: 'Affiché' },
            { value: 2, label: 'Masqué mais pris en compte dans la numérotation des pages' },
            { value: 3, label: 'Masqué et non pris en compte dans la numérotation des pages' }
        ];
        _this.coverPageDocumentChoices = [
            { value: 'none', label: 'Tous les documents' },
            { value: 'quotation', label: 'Devis' },
            { value: 'command', label: 'Bon de commande' },
            { value: 'delivery', label: 'Bon de livraison' },
            { value: 'proforma', label: 'Facture proforma' },
            { value: 'invoice', label: 'Facture' },
            { value: 'credit', label: 'Avoir' },
            { value: 'provider_command', label: 'Bon de commande fournisseur' },
            { value: 'automotive', label: 'Ordre de réparation' }
        ];
        _this.fontFamilies = [
            { value: 'arial', label: 'Arial' },
            { value: 'courier', label: 'Courier' },
            { value: 'dejavusans', label: 'Déjà Vu Sans' },
            { value: 'helvetica', label: 'Helvetica' },
            { value: 'montserrat', label: 'Montserrat' },
            { value: 'opensans', label: 'Open Sans' },
            // { value: 'nunito', label: 'Nunito' },
            // { value: 'oswald', label: 'Oswald' },
            { value: 'tahoma', label: 'Tahoma' },
            { value: 'times', label: 'Times New Roman' },
            { value: 'verdana', label: 'Verdana' }
        ];
        return _this;
    }
    Object.defineProperty(PdfModelForm.prototype, "computedCoverPageDocumentChoices", {
        get: function () {
            var _this = this;
            return this.coverPageDocumentChoices.filter(function (option) {
                var key = 'use_' + option.value;
                return option.value === 'none' || (_this.pdfModel[key] === true);
            });
        },
        enumerable: false,
        configurable: true
    });
    PdfModelForm.prototype.submitAndRedirect = function () {
        this.redirectAfterSubmit = true;
        var form = this.$refs.form;
        form.submit();
    };
    PdfModelForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.applyPdfModel(response.data);
                        if (!this.redirectAfterSubmit) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$router.push({ name: 'pdf-models' })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PdfModelForm.prototype.watchValue = function (value) {
        var model = JSON.parse(JSON.stringify(value));
        if (!model.tables.contents) {
            model.tables.contents = {};
        }
        if (!model.tables.payments) {
            model.tables.payments = {};
        }
        if (!model.tables.rates) {
            model.tables.rates = {};
        }
        if (!model.tables.totals) {
            model.tables.totals = {};
        }
        this.pdfModel = model;
    };
    PdfModelForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        this.addMissingColumns();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PdfModelForm.prototype, "computedPdfModel", {
        get: function () {
            var model = JSON.parse(JSON.stringify(this.pdfModel));
            if (model.coverPages.length > 0) {
                model.cover_pages_options = model.coverPages.map(function (cover, i) { return ({
                    id: cover.id,
                    order: i,
                    restrict: cover.restrict
                }); });
            }
            if (model.linkedDocuments.length > 0) {
                model.linked_documents_options = model.linkedDocuments.map(function (document, i) { return ({
                    id: document.id,
                    order: i,
                    restrict: document.restrict
                }); });
            }
            delete model.logo;
            delete model.background_image;
            delete model.coverPages;
            delete model.linkedDocuments;
            return model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelForm.prototype, "computedEditorConfig", {
        get: function () {
            var _this = this;
            var fields = this.customFields.filter(function (field) {
                var usages = field.usage;
                return usages.includes('quotation') || usages.includes('command') || usages.includes('proforma') || usages.includes('delivery') || usages.includes('invoice') || usages.includes('credit') || usages.includes('provider_command') || usages.includes('automotive');
            });
            var customFields = {};
            if (fields.length > 0) {
                var variables_1 = [];
                fields.forEach(function (field) {
                    var usages = [];
                    field.usage.forEach(function (usage) {
                        if (['quotation', 'command', 'proforma', 'delivery', 'invoice', 'credit', 'provider_command', 'automotive'].includes(usage)) {
                            usages.push(_this.$t('sales.' + usage + '.label'));
                        }
                    });
                    variables_1.push({
                        value: 'CUSTOM-FIELD-' + field.id,
                        label: field.label + ' (' + usages.join(', ') + ')'
                    });
                });
                customFields.dynamicVariables = {
                    customFields: {
                        label: 'Champs personnalisés',
                        variables: variables_1
                    }
                };
            }
            return merge_default()(editorConfig/* default */.A, {
                imageUploadURL: '/sales/pdf_model/' + this.pdfModel.id + '/image',
                imageManagerDeleteURL: '/sales/pdf_model/' + this.pdfModel.id + '/image/',
                imageManagerLoadURL: '/sales/pdf_model/' + this.pdfModel.id + '/image'
            }, customFields);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelForm.prototype, "computedProductEditorConfig", {
        get: function () {
            var _this = this;
            var fields = this.customFields.filter(function (field) {
                var usages = field.usage;
                return usages.includes('product') || usages.includes('service');
            });
            var customFields = {};
            if (fields.length > 0) {
                var variables_2 = [];
                fields.forEach(function (field) {
                    var usages = [];
                    field.usage.forEach(function (usage) {
                        if (usage === 'product' || usage === 'service') {
                            usages.push(_this.$t('catalog.' + usage + '.label'));
                        }
                    });
                    variables_2.push({
                        value: 'CUSTOM-FIELD-' + field.id,
                        label: field.label + ' (' + usages.join(', ') + ')'
                    });
                });
                customFields.dynamicVariables = {
                    customFields: {
                        label: 'Champs personnalisés',
                        variables: variables_2
                    }
                };
            }
            return merge_default()(productEditorConfig, customFields);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelForm.prototype, "formApiUrl", {
        get: function () {
            return '/sales/pdf_model/' + this.pdfModel.id + '?with_file=1';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelForm.prototype, "saleTermApiUrl", {
        get: function () {
            return '/sales/sale_term';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelForm.prototype, "documentClasses", {
        get: function () {
            return {
                'pdfModel-editor': true,
                'p-0': true,
                'with-editable-area': this.showEditableArea
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelForm.prototype, "computedDocumentTypes", {
        get: function () {
            var model = this.pdfModel;
            var types = [];
            if (model.use_quotation)
                types.push({ value: 'quotation', label: 'Devis' });
            if (model.use_command)
                types.push({ value: 'command', label: 'Bon de commande' });
            if (model.use_proforma)
                types.push({ value: 'proforma', label: 'Facture proforma' });
            if (model.use_delivery)
                types.push({ value: 'delivery', label: 'Bon de livraison' });
            if (model.use_invoice)
                types.push({ value: 'invoice', label: 'Facture' });
            if (model.use_credit)
                types.push({ value: 'credit', label: 'Avoir' });
            if (model.use_provider_command)
                types.push({ value: 'provider_command', label: 'Bon de commande fournisseur' });
            if (model.use_automotive)
                types.push({ value: 'automotive', label: 'Ordre de réparation' });
            return types;
        },
        enumerable: false,
        configurable: true
    });
    PdfModelForm.prototype.watchComputedDocumentTypes = function () {
        var _this = this;
        if (!this.computedDocumentTypes.find(function (opt) { return opt.value === _this.previewDocumentType; })) {
            var type = this.computedDocumentTypes[0];
            if (type) {
                this.previewDocumentType = type.value;
            }
        }
    };
    PdfModelForm.prototype.addMissingColumns = function () {
        var _a;
        var columns = (_a = this.pdfModel.columns) !== null && _a !== void 0 ? _a : [];
        this.tableColumns.forEach(function (column) {
            var search = columns.find(function (col) { return col.ident === column.ident; });
            if (!search) {
                columns.push({
                    ident: column.ident,
                    width: column.width,
                    align: column.align,
                    label: null,
                    label2: null
                });
            }
        });
        lib/* Vue */.lD.set(this.pdfModel, 'columns', columns);
    };
    PdfModelForm.prototype.deleteLogo = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwSales.axios.put(this.formApiUrl, {
                            logo: null
                        })
                            .then(function (response) {
                            _this.applyPdfFile(response.data, 'logo');
                            _this.deleteLogoModal = false;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfModelForm.prototype.deleteBackgroundImage = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwSales.axios.put(this.formApiUrl, {
                            background_image: null
                        })
                            .then(function (response) {
                            _this.applyPdfFile(response.data, 'background_image');
                            _this.deleteBackgroundImageModal = false;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfModelForm.prototype.applyPdfModel = function (pdfModel) {
        this.watchValue(pdfModel);
        this.setPdfModel(pdfModel);
    };
    PdfModelForm.prototype.applyPdfFile = function (pdfModel, type) {
        var newModel = JSON.parse(JSON.stringify(this.value));
        if (type === 'logo' || type === 'background_image') {
            this.pdfModel[type] = pdfModel[type];
            newModel[type] = pdfModel[type];
        }
        else if (type === 'coverPages' || type === 'linkedDocuments') {
            this.pdfModel[type] = pdfModel[type];
            newModel[type] = pdfModel[type];
        }
        this.setPdfModel(pdfModel);
    };
    PdfModelForm.prototype.deleteCoverPage = function (bvModalEvent) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.toDeleteCoverPage) {
                            return [2 /*return*/];
                        }
                        bvModalEvent.preventDefault();
                        this.deletingCoverPage = true;
                        return [4 /*yield*/, this.$kwSales.axios.put(this.formApiUrl, {
                                delete_cover_pages: [
                                    this.toDeleteCoverPage.id
                                ]
                            })
                                .then(function (response) {
                                _this.applyPdfFile(response.data, 'coverPages');
                            })
                                .finally(function () {
                                _this.deletingCoverPage = false;
                                _this.toDeleteCoverPage = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfModelForm.prototype.deleteLinkedDocument = function (bvModalEvent) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.toDeleteLinkedDocument) {
                            return [2 /*return*/];
                        }
                        bvModalEvent.preventDefault();
                        this.deletingLinkedDocument = true;
                        return [4 /*yield*/, this.$kwSales.axios.put(this.formApiUrl, {
                                delete_linked_documents: [
                                    this.toDeleteLinkedDocument.id
                                ]
                            })
                                .then(function (response) {
                                _this.applyPdfFile(response.data, 'linkedDocuments');
                            })
                                .finally(function () {
                                _this.deletingLinkedDocument = false;
                                _this.toDeleteLinkedDocument = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], PdfModelForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('computedDocumentTypes')
    ], PdfModelForm.prototype, "watchComputedDocumentTypes", null);
    PdfModelForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('customFields', ['customFields'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['setPdfModel'])), (0,external_vuex_.mapActions)('customFields', ['loadCustomFields'])),
            components: {
                draggable: (external_vuedraggable_default()),
                PdfModelBlock: PdfModelBlock/* default */.A,
                PdfModelArea: PdfModelArea/* default */.A,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormCheckbox: form_vue_.KFormCheckbox, KFormSpinner: form_vue_.KFormSpinner, KFormFile: form_vue_.KFormFile, KFormSelect: form_vue_.KFormSelect, KFormEditor: form_vue_.KFormEditor, KFormStickyBar: form_vue_.KFormStickyBar,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BButton: external_bootstrap_vue_.BButton, BCollapse: external_bootstrap_vue_.BCollapse, BCardBody: external_bootstrap_vue_.BCardBody, BInputGroup: external_bootstrap_vue_.BInputGroup, BFormRow: external_bootstrap_vue_.BFormRow,
                BFormRadio: external_bootstrap_vue_.BFormRadio, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BAlert: external_bootstrap_vue_.BAlert, BModal: external_bootstrap_vue_.BModal,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                ConfirmModal: interface_vue_.ConfirmModal, Spinner: interface_vue_.Spinner
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle,
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], PdfModelForm);
    return PdfModelForm;
}((0,lib/* Mixins */.Xe)(PdfModelMixin/* default */.A)));
/* harmony default export */ var PdfModelFormvue_type_script_lang_ts_external = (PdfModelForm);

;// ./src/components/PdfModelForm/PdfModelForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelForm_PdfModelFormvue_type_script_lang_ts_external = (PdfModelFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfModelForm/PdfModelForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelForm_PdfModelFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelForm_PdfModelForm = (component.exports);

/***/ }),

/***/ 40397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CheckDepositDelete_CheckDepositDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CheckDepositDelete/CheckDepositDelete.vue?vue&type=template&id=d33ec3da
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer cette remise de prélèvement ?")]),(_vm.value && _vm.value.status === 2)?_c('b-alert',{staticClass:"px-2 py-1",attrs:{"show":"","variant":"warning"}},[_vm._v(" Tous les paiements liés seront annulés et les factures concernées seront mise à jour. ")]):_vm._e()]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CheckDepositDelete/CheckDepositDelete.ts?vue&type=script&lang=ts&external




var CheckDepositDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CheckDepositDelete, _super);
    function CheckDepositDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(CheckDepositDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    CheckDepositDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CheckDepositDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CheckDepositDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/sales/check-deposit/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    CheckDepositDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    CheckDepositDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CheckDepositDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CheckDepositDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CheckDepositDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], CheckDepositDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CheckDepositDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CheckDepositDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CheckDepositDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CheckDepositDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CheckDepositDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CheckDepositDelete.prototype, "watchModalState", null);
    CheckDepositDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CheckDepositDelete);
    return CheckDepositDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CheckDepositDeletevue_type_script_lang_ts_external = (CheckDepositDelete);

;// ./src/components/CheckDepositDelete/CheckDepositDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CheckDepositDelete_CheckDepositDeletevue_type_script_lang_ts_external = (CheckDepositDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CheckDepositDelete/CheckDepositDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CheckDepositDelete_CheckDepositDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CheckDepositDelete_CheckDepositDelete = (component.exports);

/***/ }),

/***/ 40748:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ 40930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarFormButton_CarFormButton; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarFormButton/CarFormButton.vue?vue&type=template&id=7c728375
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"px-1",attrs:{"title":_vm.buttonTitle,"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled !== false},on:{"click":function($event){$event.preventDefault();_vm.showForm = true}}},[(!_vm.value)?_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.addIcon]}}):_c('font-awesome-icon',{attrs:{"icon":['fas', 'pencil']}}),_c('CarForm',{attrs:{"modal":_vm.showForm,"customer":_vm.customer},on:{"hidden":function($event){_vm.showForm = false},"submitComplete":car => _vm.$emit('submitComplete', car)},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/CarForm/CarForm.vue + 3 modules
var CarForm = __webpack_require__(8998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarFormButton/CarFormButton.ts?vue&type=script&lang=ts&external






var CarFormButton = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarFormButton, _super);
    function CarFormButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showForm = false;
        return _this;
    }
    Object.defineProperty(CarFormButton.prototype, "buttonTitle", {
        get: function () {
            return !this.value ? 'Créer un véhicule' : 'Modifier le véhicule';
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarFormButton.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarFormButton.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CarFormButton.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'primary' })
    ], CarFormButton.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarFormButton.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'plus' })
    ], CarFormButton.prototype, "addIcon", void 0);
    CarFormButton = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CarForm: CarForm/* default */.A,
                BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CarFormButton);
    return CarFormButton;
}((external_vue_default())));
/* harmony default export */ var CarFormButtonvue_type_script_lang_ts_external = (CarFormButton);

;// ./src/components/CarFormButton/CarFormButton.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarFormButton_CarFormButtonvue_type_script_lang_ts_external = (CarFormButtonvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarFormButton/CarFormButton.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarFormButton_CarFormButtonvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarFormButton_CarFormButton = (component.exports);

/***/ }),

/***/ 41011:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                          ? ':a'
                          : b === 2
                            ? ':a'
                            : b === 3
                              ? ':e'
                              : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ 41109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ StripePaymentView_StripePaymentView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/StripePaymentView/StripePaymentView.vue?vue&type=template&id=2f23d228
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stripe-expired"},[(_vm.loading)?_c('Spinner'):(_vm.link && 'is_expired' in _vm.link)?_c('div',[_c('b-card',{staticClass:"text-center"},[_vm._v(" Le lien est expiré."),_c('br'),(_vm.link.contact)?[_vm._v(" Pour obtenir un nouveau lien, contactez-nous à l'adresse "),_c('a',{attrs:{"href":'mailto:' + _vm.link.contact}},[_vm._v(_vm._s(_vm.link.contact))])]:_vm._e()],2)],1):_c('StripePayment',{attrs:{"data":_vm.link,"type":_vm.$route.params.type}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/StripePayment/StripePayment.vue + 4 modules
var StripePayment = __webpack_require__(12762);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/StripePaymentView/StripePaymentView.ts?vue&type=script&lang=ts&external





var fetchLink = function (type, id, token, hash) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        return [2 /*return*/, lib/* Vue */.lD.prototype.$kwInterface.axios.get("/sales/" + type + "/" + id + "/" + token + "/" + hash + "/payment")
                .then(function (response) {
                return response.data;
            })];
    });
}); };
var StripePaymentView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StripePaymentView, _super);
    function StripePaymentView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.link = null;
        return _this;
    }
    StripePaymentView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                StripePayment: StripePayment/* default */.A,
                Spinner: interface_vue_.Spinner,
                BCard: external_bootstrap_vue_.BCard
            },
            // eslint-disable-next-line no-undef
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var link;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, fetchLink(to.params.type, to.params.id, to.params.token, to.params.hash)
                                    .catch(function () {
                                    next({ name: 'error-404' });
                                    return;
                                })];
                            case 1:
                                link = _a.sent();
                                next(function (vm) {
                                    vm.link = link;
                                    vm.loading = false;
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var link;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.loading = true;
                                return [4 /*yield*/, fetchLink(to.params.type, to.params.id, to.params.token, to.params.hash)
                                        .catch(function () {
                                        next({ name: 'error-404' });
                                        return;
                                    })];
                            case 1:
                                link = _a.sent();
                                this.link = link;
                                this.loading = false;
                                next();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], StripePaymentView);
    return StripePaymentView;
}(lib/* Vue */.lD));
/* harmony default export */ var StripePaymentViewvue_type_script_lang_ts_external = (StripePaymentView);

;// ./src/views/StripePaymentView/StripePaymentView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StripePaymentView_StripePaymentViewvue_type_script_lang_ts_external = (StripePaymentViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/StripePaymentView/StripePaymentView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StripePaymentView_StripePaymentViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StripePaymentView_StripePaymentView = (component.exports);

/***/ }),

/***/ 41488:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ 41734:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ 41794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ 41799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(37217),
    baseIsEqual = __webpack_require__(60270);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 41848:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ 42000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(63945),
    baseAggregator = __webpack_require__(62429),
    baseIteratee = __webpack_require__(15389),
    isArray = __webpack_require__(56449);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 42054:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommentLine_CommentLine; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/CommentLine/CommentLine.vue?vue&type=template&id=794d0634
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{on:{"click":_vm.setLocationEditing}},[_c('td',[(_vm.document.contents.length > 1)?_c('font-awesome-icon',{ref:"moveBtn",staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e()],1),_c('td',{staticClass:"text-wrap",attrs:{"colspan":_vm.colspan}},[(!_vm.editing)?_c('FroalaView',{model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}}):_c('k-form-editor',{attrs:{"size":"sm","required":"","config":_vm.editorConfig},model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}}),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('designation')},domProps:{"value":_vm.value.designation}})],1),_c('td',[_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('is_comments')},domProps:{"value":true}}),(_vm.value.affair_content_id)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('affair_content')},domProps:{"value":_vm.value.affair_content_id}}):_vm._e(),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],ref:"deleteBtn",staticClass:"p-0",attrs:{"variant":"link","title":"Supprimer la ligne"}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":_vm.deleteLine}})],1),(_vm.editing)?_c('LineMenu',{attrs:{"line":_vm.value},on:{"add":event => _vm.$emit('addSubLine', event)}}):_vm._e()],1)])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentLineMixin.ts + 4 modules
var SalesDocumentLineMixin = __webpack_require__(54575);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/components/Form/editorConfig.ts
var editorConfig = __webpack_require__(63457);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/CommentLine/CommentLine.ts?vue&type=script&lang=ts&external






var CommentLine = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentLine, _super);
    function CommentLine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editorConfig = editorConfig/* default */.A;
        return _this;
    }
    Object.defineProperty(CommentLine.prototype, "colspan", {
        get: function () {
            var document = this.document;
            var colspan = 5;
            if (!document.use_global_vatrate) {
                colspan++;
            }
            if (document.secondary_quantity_mode !== 'disable') {
                colspan++;
            }
            if (document.input_options.col_reference) {
                colspan++;
            }
            if (document.input_options.col_picture) {
                colspan++;
            }
            if (document.input_options.col_number) {
                colspan++;
            }
            return colspan;
        },
        enumerable: false,
        configurable: true
    });
    CommentLine.prototype.watchValue = function (value) {
        this.$emit('input', value);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localValue')
    ], CommentLine.prototype, "watchValue", null);
    CommentLine = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KFormEditor: form_vue_.KFormEditor, FroalaView: form_vue_.FroalaView
            }
        })
    ], CommentLine);
    return CommentLine;
}((0,lib/* Mixins */.Xe)(SalesDocumentLineMixin/* default */.A)));
/* harmony default export */ var CommentLinevue_type_script_lang_ts_external = (CommentLine);

;// ./src/components/Form/CommentLine/CommentLine.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentLine_CommentLinevue_type_script_lang_ts_external = (CommentLinevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/CommentLine/CommentLine.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommentLine_CommentLinevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentLine_CommentLine = (component.exports);

/***/ }),

/***/ 42353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ 42652:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/interface-vue");

/***/ }),

/***/ 42824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(87805),
    cloneBuffer = __webpack_require__(93290),
    cloneTypedArray = __webpack_require__(71961),
    copyArray = __webpack_require__(23007),
    initCloneObject = __webpack_require__(35529),
    isArguments = __webpack_require__(72428),
    isArray = __webpack_require__(56449),
    isArrayLikeObject = __webpack_require__(83693),
    isBuffer = __webpack_require__(3656),
    isFunction = __webpack_require__(1882),
    isObject = __webpack_require__(23805),
    isPlainObject = __webpack_require__(11331),
    isTypedArray = __webpack_require__(37167),
    safeGet = __webpack_require__(14974),
    toPlainObject = __webpack_require__(69884);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 43004:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ 43055:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/communication-vue");

/***/ }),

/***/ 43243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarSpeedItem_CarSpeedItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarSpeedItem/CarSpeedItem.vue?vue&type=template&id=798f12ae
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{attrs:{"label":_vm.label,"size":_vm.size}},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[_vm._v(" "+_vm._s(_vm.value.brand?.name)+" "+_vm._s(_vm.value.model?.name)+" "),(_vm.value.brand || _vm.value.model)?_c('span',[_vm._v(" - ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.value.numberplate)+" ")]),_c('CarItem',{attrs:{"customer":_vm.customer,"modal":_vm.modal,"canDelete":false},on:{"hidden":function($event){_vm.modal = false}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/CarItem/CarItem.vue + 3 modules
var CarItem = __webpack_require__(96994);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarSpeedItem/CarSpeedItem.ts?vue&type=script&lang=ts&external





var CarSpeedItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarSpeedItem, _super);
    function CarSpeedItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        return _this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarSpeedItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSpeedItem.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Véhicule' })
    ], CarSpeedItem.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarSpeedItem.prototype, "size", void 0);
    CarSpeedItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton,
                CarItem: CarItem/* default */.A
            }
        })
    ], CarSpeedItem);
    return CarSpeedItem;
}((external_vue_default())));
/* harmony default export */ var CarSpeedItemvue_type_script_lang_ts_external = (CarSpeedItem);

;// ./src/components/CarSpeedItem/CarSpeedItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarSpeedItem_CarSpeedItemvue_type_script_lang_ts_external = (CarSpeedItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarSpeedItem/CarSpeedItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarSpeedItem_CarSpeedItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarSpeedItem_CarSpeedItem = (component.exports);

/***/ }),

/***/ 43360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(93243);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 43784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ 43825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_GuaranteeHoldbackView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/GuaranteeHoldbackView.vue?vue&type=template&id=76009a1a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GuaranteeHoldbackList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/GuaranteeHoldbackList/GuaranteeHoldbackList.vue + 3 modules
var GuaranteeHoldbackList = __webpack_require__(73599);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/GuaranteeHoldbackView.vue?vue&type=script&lang=ts



var GuaranteeHoldbackView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GuaranteeHoldbackView, _super);
    function GuaranteeHoldbackView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GuaranteeHoldbackView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                GuaranteeHoldbackList: GuaranteeHoldbackList/* default */.A
            }
        })
    ], GuaranteeHoldbackView);
    return GuaranteeHoldbackView;
}(lib/* Vue */.lD));
/* harmony default export */ var GuaranteeHoldbackViewvue_type_script_lang_ts = (GuaranteeHoldbackView);

;// ./src/views/GuaranteeHoldbackView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_GuaranteeHoldbackViewvue_type_script_lang_ts = (GuaranteeHoldbackViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/GuaranteeHoldbackView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_GuaranteeHoldbackViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_GuaranteeHoldbackView = (component.exports);

/***/ }),

/***/ 43861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ 44394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72552),
    isObjectLike = __webpack_require__(40346);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 44429:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! author : Rasid Redzic : https://github.com/rasidre
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 'm':
                return withoutSuffix
                    ? 'jedna minuta'
                    : isFuture
                      ? 'jednu minutu'
                      : 'jedne minute';
        }
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jedan sat';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ 44696:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/custom-fields-vue");

/***/ }),

/***/ 44805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TransformToQuotation_TransformToQuotation; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TransformToQuotation/TransformToQuotation.vue?vue&type=template&id=d0451028
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir créer un devis ?")]),_c('b-form-group',{attrs:{"label":"Date du document"}},[_c('k-form-datepicker',{attrs:{"name":"date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('k-form-checkbox',{model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}},[_vm._v(" Créer le document au statut brouillon ")]),(_vm.cantBeEditedIfValid && !_vm.draft)?_c('b-alert',{staticClass:"mt-3 mb-0 py-2 px-3",attrs:{"variant":"warning","show":""}},[_vm._v(" Attention, ce document étant déjà facturé à 100%, si vous ne créez pas le devis au statut brouillon, celui-ci ne sera pas modifiable. ")]):_vm._e()]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TransformToQuotation/TransformToQuotation.ts?vue&type=script&lang=ts&external







var TransformToQuotation = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TransformToQuotation, _super);
    function TransformToQuotation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        _this.draft = false;
        return _this;
    }
    TransformToQuotation.prototype.mounted = function () {
        this.draft = !this.teamConfigs.sales_quotation_valid;
    };
    Object.defineProperty(TransformToQuotation.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToQuotation.prototype, "cantBeEditedIfValid", {
        get: function () {
            var _a;
            var invoices = (_a = this.value.invoices) !== null && _a !== void 0 ? _a : [];
            return this.number(this.value.to_bill) === 0 && invoices.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    TransformToQuotation.prototype.watchValue = function () {
        if (this.draft) {
            this.draft = !this.cantBeEditedIfValid;
        }
    };
    TransformToQuotation.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    TransformToQuotation.prototype.process = function (bvModalEvt) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.errorMsg) {
                            return [2 /*return*/];
                        }
                        bvModalEvt.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.post('/sales/' + this.type + '/' + this.value.id + '/quotation', {
                                date: this.date,
                                is_draft: this.draft
                            })
                                .then(function (response) {
                                _this.success(response.data);
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                _this.errorMsg = error.response.data.message;
                                _this.loading = false;
                                throw new Error(error);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TransformToQuotation.prototype.closeModal = function () {
        this.errorMsg = null;
        return false;
    };
    TransformToQuotation.prototype.success = function (quotation) {
        return quotation;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToQuotation.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToQuotation.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TransformToQuotation.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Créer un devis' })
    ], TransformToQuotation.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToQuotation.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TransformToQuotation.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TransformToQuotation.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], TransformToQuotation.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], TransformToQuotation.prototype, "closeModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], TransformToQuotation.prototype, "success", null);
    TransformToQuotation = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert,
                KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], TransformToQuotation);
    return TransformToQuotation;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var TransformToQuotationvue_type_script_lang_ts_external = (TransformToQuotation);

;// ./src/components/TransformToQuotation/TransformToQuotation.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TransformToQuotation_TransformToQuotationvue_type_script_lang_ts_external = (TransformToQuotationvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/TransformToQuotation/TransformToQuotation.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TransformToQuotation_TransformToQuotationvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TransformToQuotation_TransformToQuotation = (component.exports);

/***/ }),

/***/ 45083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isMasked = __webpack_require__(87296),
    isObject = __webpack_require__(23805),
    toSource = __webpack_require__(47473);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 45179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PaymentList_PaymentList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentList/PaymentList.vue?vue&type=template&id=af0460b4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-table',{ref:"table",attrs:{"url":"/sales/payment","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowClick":_vm.rowClick,"stateKey":"payments-list","exportable":"payment"},on:{"totalUpdated":_vm.totalUpdated}}),(_vm.editedPayment)?_c('PaymentItem',{attrs:{"modal":true},on:{"hidden":function($event){_vm.editedPayment = null}},model:{value:(_vm.editedPayment),callback:function ($$v) {_vm.editedPayment=$$v},expression:"editedPayment"}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: ./src/components/PaymentItem/PaymentItem.vue + 3 modules
var PaymentItem = __webpack_require__(8446);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentList/PaymentList.ts?vue&type=script&lang=ts&external






var PaymentList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentList, _super);
    function PaymentList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editedPayment = null;
        _this.loading = false;
        return _this;
    }
    PaymentList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadAccounts()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadPaymentMethods()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentList.prototype.created = function () {
        interface_vue_.emitter.on('paymentCreated', this.paymentCreated);
        interface_vue_.emitter.on('paymentUpdated', this.paymentUpdated);
        interface_vue_.emitter.on('paymentDeleted', this.paymentDeleted);
    };
    PaymentList.prototype.destroyed = function () {
        interface_vue_.emitter.off('paymentCreated', this.paymentCreated);
        interface_vue_.emitter.off('paymentUpdated', this.paymentUpdated);
        interface_vue_.emitter.off('paymentDeleted', this.paymentDeleted);
    };
    Object.defineProperty(PaymentList.prototype, "ajaxDatas", {
        get: function () {
            var filter = {
                excludeCanceled: true
            };
            if (this.document) {
                filter.document = {
                    type: this.type,
                    id: this.document.id
                };
            }
            return {
                include: 'payment_method,customer,account,uses,sepa_deposit,currency',
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'date',
                    name: 'Date',
                    render: 'date'
                },
                {
                    data: 'customer.reference.customer',
                    name: 'N° Client',
                    visible: false
                },
                {
                    data: 'customer.name',
                    name: 'Client'
                },
                {
                    data: 'account.name',
                    name: 'Compte bancaire',
                    visible: false
                },
                {
                    data: 'payment_method.label',
                    name: 'Mode de règlement'
                },
                {
                    data: 'reference',
                    name: 'Référence'
                },
                {
                    data: 'ht',
                    name: 'HT',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'tva',
                    name: 'TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'ttc',
                    name: 'TTC',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'amount',
                    name: 'Montant',
                    render: 'currency'
                },
                {
                    data: 'amount_used',
                    name: 'Montant attribué',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'stay_to_use',
                    name: 'Montant non-attribué',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'documents',
                    name: 'Document(s)',
                    sortable: false,
                    render: function (data) {
                        return data.map(function (use) { return use.document.reference; }).join(', ');
                    }
                },
                {
                    data: 'check_bank',
                    name: 'Banque émettrice',
                    visible: false
                },
                {
                    data: 'check_issuer',
                    name: 'Émetteur du chèque',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentList.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    type: 'period',
                    label: 'Date du paiement',
                    name: 'date_since',
                    name2: 'date_until'
                },
                {
                    type: 'text',
                    label: 'Référence',
                    name: 'reference'
                },
                {
                    type: 'number',
                    label: 'Montant',
                    name: 'amount'
                },
                {
                    type: 'select',
                    label: 'Compte bancaire',
                    name: 'account',
                    options: this.accounts,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: 'Mode de règlement',
                    name: 'payment_method',
                    options: this.paymentMethods,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                }
            ];
            if (!this.document) {
                filters.push({
                    type: 'select',
                    label: 'Client',
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentList.prototype, "table", {
        get: function () {
            return this.$refs.table;
        },
        enumerable: false,
        configurable: true
    });
    PaymentList.prototype.watchDocument = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.$nextTick(function () { return _this.table.refresh(); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentList.prototype.rowClick = function (row) {
        this.editedPayment = row;
    };
    PaymentList.prototype.paymentCreated = function (payment) {
        var _this = this;
        if (this.loading) {
            return;
        }
        if (this.document && payment.documents) {
            var document = payment.documents.find(function (use) { return use.document_type === _this.type && use.document_id === _this.document.id; });
            if (!document) {
                return;
            }
        }
        this.table.addRow(payment);
    };
    PaymentList.prototype.paymentUpdated = function (event) {
        var _this = this;
        if (this.loading) {
            return;
        }
        this.editedPayment = event.new;
        var index = this.table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (this.document && event.new.documents) {
            var document = event.new.documents.find(function (use) { return use.document_type === _this.type && use.document_id === _this.document.id; });
            if (document) {
                if (index >= 0) {
                    this.table.updateRow(index, event.new);
                }
                else {
                    this.table.addRow(event.new);
                }
                return;
            }
        }
        if (index >= 0) {
            this.table.deleteRow(index);
        }
    };
    PaymentList.prototype.paymentDeleted = function (payment) {
        if (this.loading) {
            return;
        }
        var index = this.table.getDatas().findIndex(function (data) { return data.id === payment.id; });
        if (index >= 0) {
            this.table.deleteRow(index);
        }
    };
    PaymentList.prototype.totalUpdated = function (total) {
        return total;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentList.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentList.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('document')
    ], PaymentList.prototype, "watchDocument", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('totalUpdated')
    ], PaymentList.prototype, "totalUpdated", null);
    PaymentList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadAccounts'])), (0,external_vuex_.mapActions)('globalDatas', ['loadPaymentMethods'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('sales', ['accounts'])), (0,external_vuex_.mapState)('globalDatas', ['paymentMethods'])),
            components: {
                Spinner: interface_vue_.Spinner,
                PaymentItem: PaymentItem/* default */.A,
                KTable: table_vue_.KTable
            }
        })
    ], PaymentList);
    return PaymentList;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var PaymentListvue_type_script_lang_ts_external = (PaymentList);

;// ./src/components/PaymentList/PaymentList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentList_PaymentListvue_type_script_lang_ts_external = (PaymentListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PaymentList/PaymentList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PaymentList_PaymentListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentList_PaymentList = (component.exports);

/***/ }),

/***/ 45719:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ 45766:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
              ? forms(key)[1]
              : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ 46353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarBrandList_CarBrandList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarBrandList/CarBrandList.vue?vue&type=template&id=d1c51018
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":"/automotive/brand","datas":{ include: 'models' },"createTitle":"Création d'une marque","updateTitle":"Modification d'une marque","deleteMsg":"Êtes-vous sûr de vouloir supprimer cette marque ?","columns":_vm.columns,"customForm":_vm.formComponent},on:{"submitted":_vm.setBrand,"deleted":_vm.deleteBrand}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/CarBrandForm/CarBrandForm.vue + 3 modules
var CarBrandForm = __webpack_require__(76733);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarBrandList/CarBrandList.ts?vue&type=script&lang=ts&external





var CarBrandList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarBrandList, _super);
    function CarBrandList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = CarBrandForm/* default */.A;
        return _this;
    }
    Object.defineProperty(CarBrandList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: 'Nom de la marque',
                    key: 'name'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CarBrandList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('automotive', ['setBrand', 'deleteBrand'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], CarBrandList);
    return CarBrandList;
}(lib/* Vue */.lD));
/* harmony default export */ var CarBrandListvue_type_script_lang_ts_external = (CarBrandList);

;// ./src/components/CarBrandList/CarBrandList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarBrandList_CarBrandListvue_type_script_lang_ts_external = (CarBrandListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarBrandList/CarBrandList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarBrandList_CarBrandListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarBrandList_CarBrandList = (component.exports);

/***/ }),

/***/ 46637:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ 47237:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 47286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_StripeConfigView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/StripeConfigView.vue?vue&type=template&id=7d03570c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StripeConfig')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/StripeConfig/StripeConfig.vue + 8 modules
var StripeConfig = __webpack_require__(11040);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/StripeConfigView.vue?vue&type=script&lang=ts



var StripeConfigView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StripeConfigView, _super);
    function StripeConfigView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripeConfigView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                StripeConfig: StripeConfig/* default */.A
            }
        })
    ], StripeConfigView);
    return StripeConfigView;
}(lib/* Vue */.lD));
/* harmony default export */ var StripeConfigViewvue_type_script_lang_ts = (StripeConfigView);

;// ./src/views/StripeConfigView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_StripeConfigViewvue_type_script_lang_ts = (StripeConfigViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/StripeConfigView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_StripeConfigViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_StripeConfigView = (component.exports);

/***/ }),

/***/ 47422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(31769),
    toKey = __webpack_require__(77797);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 47473:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 47777:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ 48303:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ 48414:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ 48655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(26025);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 48698:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-circle-left';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f137';
var svgPathData = 'M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.QE = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 49171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfModelDelete_PdfModelDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfModelDelete/PdfModelDelete.vue?vue&type=template&id=6dd0b39a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'delete')),"ok-only":_vm.errorMsg !== null,"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"cancel":_vm.onCancel},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[(_vm.errorMsg !== null)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.pdfModel.deleteMsg'))+" ")])],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfModelDelete/PdfModelDelete.ts?vue&type=script&lang=ts&external




var PdfModelDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelDelete, _super);
    function PdfModelDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    PdfModelDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    PdfModelDelete.prototype.onCancel = function () {
        this.errorMsg = null;
        return null;
    };
    PdfModelDelete.prototype.onOk = function (prevent) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prevent.preventDefault();
                        if (this.errorMsg !== null) {
                            this.onCancel();
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.delete(this.apiUrl)
                                .then(function () {
                                _this.deletePdfModel(_this.value);
                                _this.$emit('deleted');
                                _this.onCancel();
                            })
                                .catch(function (error) {
                                _this.errorMsg = error.response.data.message;
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PdfModelDelete.prototype, "apiUrl", {
        get: function () {
            var _a;
            return '/sales/pdf_model/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], PdfModelDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], PdfModelDelete.prototype, "onCancel", null);
    PdfModelDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['deletePdfModel'])),
            components: {
                BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], PdfModelDelete);
    return PdfModelDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelDeletevue_type_script_lang_ts_external = (PdfModelDelete);

;// ./src/components/PdfModelDelete/PdfModelDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelDelete_PdfModelDeletevue_type_script_lang_ts_external = (PdfModelDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfModelDelete/PdfModelDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelDelete_PdfModelDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelDelete_PdfModelDelete = (component.exports);

/***/ }),

/***/ 49292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SignPdfModel_SignPdfModel; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SignPdfModel/SignPdfModel.vue?vue&type=template&id=aafae72c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('p',{staticClass:"text-justify"},[_vm._v(" L'outil ci-dessous vous permet de placer le champ signature dans la partie basse de votre modèle PDF. Par défaut, celui-ci est automatiquement placé en dessous du tableau des totaux."),_c('br'),_c('br'),_vm._v(" Si vous souhaitez plus de possibilité de personnalisation, vous pouvez également placer manuellement la variable en "),_c('router-link',{attrs:{"to":{ name: 'pdf-models' }}},[_vm._v("modifiant votre modèle PDF")]),_vm._v(". ")],1),_c('b-card',{ref:"editor",staticClass:"sign-pdf-model",style:(_vm.documentStyles),attrs:{"no-body":""}},[_c('div',{staticClass:"editor-content",style:(_vm.documentMargins)},[_c('div',{staticClass:"pdf-model-editor-area"},_vm._l((_vm.pdfModel?.top),function(bloc,i){return _c('div',{key:i,staticClass:"pdf-model-editor-block",style:({ width: _vm.blocWidth(bloc) + '%' })},[_c('div',{staticClass:"content"},[_c('PdfModelBlockPreview',{style:(_vm.computedBlocStyles(bloc)),attrs:{"value":_vm.previewContent(bloc),"pdf-model":_vm.pdfModel,"preview":_vm.type}})],1)])}),0),_c('div',{ref:"document-content",staticClass:"document-content"},[_c('table',{staticClass:"w-100 document-table",style:(_vm.tableStyles)},[_c('tbody',[_c('tr',_vm._l((_vm.previewTableColumns),function(column,i){return _c('th',{key:i,style:(_vm.thStyles(column))},[_vm._v(" "+_vm._s(column.label !== null && column.label !== '' ? column.label : _vm.tableColumn(column.ident).placeholder)+" ")])}),0),_vm._l((_vm.demoTableContent),function(content,i){return _c('tr',{key:i},_vm._l((_vm.previewTableColumns),function(column,j){return _c('td',{key:j,style:(_vm.tdStyles(column))},[_vm._v(" "+_vm._s(_vm.tableColumn(column.ident).render ? _vm.tableColumn(column.ident).render(content[column.ident]) : content[column.ident])+" "),((i + 1) === _vm.demoTableContent.length && column.ident === 'designation')?_c('div',{staticClass:"min-height-cell",style:({ 'min-height': _vm.minCellHeight + 'px' })}):_vm._e()])}),0)})],2)])]),_c('div',{staticClass:"pdf-model-editor-area sign-pdf-model-area"},_vm._l((_vm.pdfModel?.bottom),function(bloc,i){return _c('div',{key:i,staticClass:"pdf-model-editor-block",style:({ width: _vm.blocWidth(bloc) + '%' }),on:{"click":function($event){$event.preventDefault();_vm.signEmplacement = bloc.id}}},[_c('div',{class:{
                'content': true,
                'sign-selected': true
              }},[_c('PdfModelBlockPreview',{style:(_vm.computedBlocStyles(bloc)),attrs:{"value":_vm.previewContent(bloc, i),"pdf-model":_vm.pdfModel,"preview":_vm.type}})],1)])}),0)]),(_vm.pdfModel)?_c('PdfModelBlockPreview',{style:(_vm.computedBlocStyles(_vm.pdfModel.footer)),attrs:{"value":_vm.previewContent(_vm.pdfModel.footer),"pdf-model":_vm.pdfModel,"preview":_vm.type,"is-footer":""}}):_vm._e()],1)],_c('k-form',{attrs:{"action":'/sales/pdf_model/' + _vm.pdfModelId + '/add-sign'},on:{"submitComplete":_vm.submitComplete}},[_c('input',{attrs:{"type":"hidden","name":"document_type"},domProps:{"value":_vm.type}}),_c('input',{attrs:{"type":"hidden","name":"document_id"},domProps:{"value":_vm.id}}),_c('input',{attrs:{"type":"hidden","name":"block_id"},domProps:{"value":_vm.signEmplacement}}),_c('div',{staticClass:"text-center mt-3"},[_c('p',{staticClass:"text-left d-inline-block"},[_c('b-row',[_c('b-col',{staticClass:"text-nowrap"},[_c('b-form-group',{attrs:{"label":"Choix du type de signature :"}},[_c('b-form-radio-group',{staticClass:"text-left d-inline-block",attrs:{"name":"sign_type","stacked":"","options":[
                  { value: 'SIGNATURE', text: 'Signature simple' },
                  { value: 'SIGNATURE-DATE', text: 'Date + signature' }
                ]},model:{value:(_vm.signType),callback:function ($$v) {_vm.signType=$$v},expression:"signType"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Ajouter la signature sur :"}},[_c('k-form-checkbox-group',{attrs:{"name":"types[]","options":_vm.addOptions,"stacked":""},model:{value:(_vm.signDocuments),callback:function ($$v) {_vm.signDocuments=$$v},expression:"signDocuments"}})],1)],1)],1)],1),_c('p'),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" Enregistrer ")])],1)])],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/fetchDatas/pdfModel.ts
var pdfModel = __webpack_require__(80549);
// EXTERNAL MODULE: ./src/components/PdfModelBlockPreview/PdfModelBlockPreview.vue + 3 modules
var PdfModelBlockPreview = __webpack_require__(27569);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/mixins/PdfModelMixin.ts
var PdfModelMixin = __webpack_require__(25235);
// EXTERNAL MODULE: ./src/components/PdfModelBlock/PdfModelBlock.vue + 3 modules
var PdfModelBlock = __webpack_require__(82233);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SignPdfModel/SignPdfModel.ts?vue&type=script&lang=ts&external









var SignPdfModel = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignPdfModel, _super);
    function SignPdfModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.pdfModel = null;
        _this.signType = 'SIGNATURE';
        _this.signEmplacement = null;
        _this.signDocuments = ['quotation', 'command', 'delivery', 'proforma'];
        return _this;
    }
    SignPdfModel.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, (0,pdfModel/* fetchPdfModel */.gp)(this.pdfModelId)];
                    case 1:
                        _a.pdfModel = _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SignPdfModel.prototype, "addOptions", {
        get: function () {
            var _a, _b, _c, _d;
            var options = [];
            if (!((_a = this.pdfModel) === null || _a === void 0 ? void 0 : _a.can_sign_quotation)) {
                options.push({ value: 'quotation', text: 'Devis', readonly: this.type === 'quotation' });
            }
            if (!((_b = this.pdfModel) === null || _b === void 0 ? void 0 : _b.can_sign_command)) {
                options.push({ value: 'command', text: 'Bon de commande', readonly: this.type === 'command' });
            }
            if (!((_c = this.pdfModel) === null || _c === void 0 ? void 0 : _c.can_sign_delivery)) {
                options.push({ value: 'delivery', text: 'Bon de livraison', readonly: this.type === 'delivery' });
            }
            if (!((_d = this.pdfModel) === null || _d === void 0 ? void 0 : _d.can_sign_proforma)) {
                options.push({ value: 'proforma', text: 'Facture porforma', readonly: this.type === 'proforma' });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignPdfModel.prototype, "blocWidth", {
        get: function () {
            return function (bloc) {
                var _a;
                switch (bloc.size) {
                    case 33:
                        return 33.33;
                    case 66:
                        return 66.66;
                    default:
                        return (_a = bloc.size) !== null && _a !== void 0 ? _a : 100;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignPdfModel.prototype, "content", {
        get: function () {
            var _this = this;
            return function (bloc) {
                if (bloc.same_content) {
                    return bloc.content;
                }
                switch (_this.type) {
                    case 'quotation':
                        return bloc.quotation_content;
                    case 'command':
                        return bloc.command_content;
                    case 'delivery':
                        return bloc.delivery_content;
                    case 'proforma':
                        return bloc.proforma_content;
                    default:
                        return null;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignPdfModel.prototype, "previewContent", {
        get: function () {
            var _this = this;
            return function (bloc, index) {
                var _a;
                if (index === void 0) { index = null; }
                var content = (_a = _this.content(bloc)) !== null && _a !== void 0 ? _a : '';
                if ((_this.signEmplacement === bloc.id && index !== null) || (_this.signEmplacement === null && _this.selectedByDefault(content))) {
                    content += '<br><variable data-variable="' + _this.signType + '" contenteditable="true" class="fr-dynamic-variable">SIGNATURE-DATE</variable>';
                    _this.signEmplacement = bloc.id;
                }
                return content;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignPdfModel.prototype, "selectedByDefault", {
        get: function () {
            return function (content) {
                var _a;
                return ((_a = content === null || content === void 0 ? void 0 : content.indexOf('data-variable="TOTALS')) !== null && _a !== void 0 ? _a : -1) >= 0;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignPdfModel.prototype, "computedBlocStyles", {
        get: function () {
            return function (bloc, isFooter) {
                var _a;
                if (isFooter === void 0) { isFooter = false; }
                var opt = (_a = bloc.options) !== null && _a !== void 0 ? _a : {};
                var styles = {
                    color: opt.textColor,
                    'background-color': opt.backgroundColor,
                    'border-style': 'solid',
                    'border-color': opt.borderColor,
                    'border-radius': opt.borderRadius + 'pt',
                    paddingTop: opt.paddingTop + 'mm',
                    paddingBottom: opt.paddingBottom + 'mm',
                    paddingLeft: opt.paddingLeft + 'mm',
                    paddingRight: opt.paddingRight + 'mm',
                    marginTop: opt.marginTop + 'mm',
                    marginBottom: opt.marginBottom + 'mm',
                    marginLeft: opt.marginLeft + 'mm',
                    marginRight: opt.marginRight + 'mm',
                    height: opt.heightMode === 'fixed' ? opt.height + 'mm' : 'auto'
                };
                if (isFooter !== false) {
                    styles['border-top-width'] = opt.borderSize + 'pt';
                    styles['border-left-width'] = 0;
                    styles['border-right-width'] = 0;
                    styles['border-bottom-width'] = 0;
                }
                else {
                    styles['border-width'] = opt.borderSize + 'pt';
                }
                return styles;
            };
        },
        enumerable: false,
        configurable: true
    });
    SignPdfModel.prototype.submitComplete = function (response) {
        this.$emit('success', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SignPdfModel.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SignPdfModel.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SignPdfModel.prototype, "pdfModelId", void 0);
    SignPdfModel = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup,
                PdfModelBlock: PdfModelBlock/* default */.A,
                Spinner: interface_vue_.Spinner,
                PdfModelBlockPreview: PdfModelBlockPreview/* default */.A,
                KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KForm: form_vue_.KForm
            }
        })
    ], SignPdfModel);
    return SignPdfModel;
}((0,lib/* Mixins */.Xe)(PdfModelMixin/* default */.A)));
/* harmony default export */ var SignPdfModelvue_type_script_lang_ts_external = (SignPdfModel);

;// ./src/components/SignPdfModel/SignPdfModel.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SignPdfModel_SignPdfModelvue_type_script_lang_ts_external = (SignPdfModelvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SignPdfModel/SignPdfModel.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SignPdfModel_SignPdfModelvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignPdfModel_SignPdfModel = (component.exports);

/***/ }),

/***/ 49326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(31769),
    isArguments = __webpack_require__(72428),
    isArray = __webpack_require__(56449),
    isIndex = __webpack_require__(30361),
    isLength = __webpack_require__(30294),
    toKey = __webpack_require__(77797);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 49653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(37828);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 49698:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 50002:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(82199),
    getSymbols = __webpack_require__(4664),
    keys = __webpack_require__(95950);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 50104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(53661);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 50148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ mixins_StripeMixin; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// external "@stripe/stripe-js"
var stripe_js_namespaceObject = require("@stripe/stripe-js");
;// ./src/mixins/StripeMixin.ts




var StripeMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StripeMixin, _super);
    function StripeMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stripe = null;
        return _this;
    }
    Object.defineProperty(StripeMixin.prototype, "stripeAccount", {
        get: function () {
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StripeMixin.prototype, "teamId", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    // Initialize Stripe
    StripeMixin.prototype.initializeStripe = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var key, options, stripe;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = this.app.stripe_public_key;
                        if (!key) {
                            return [2 /*return*/];
                        }
                        options = {};
                        if (this.teamId !== 2) {
                            options.stripeAccount = this.stripeAccount;
                        }
                        return [4 /*yield*/, (0,stripe_js_namespaceObject.loadStripe)(key, options)];
                    case 1:
                        stripe = _a.sent();
                        if (!stripe) {
                            return [2 /*return*/];
                        }
                        this.stripe = stripe;
                        return [2 /*return*/];
                }
            });
        });
    };
    StripeMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['app']))
        })
    ], StripeMixin);
    return StripeMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_StripeMixin = (StripeMixin);


/***/ }),

/***/ 50257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfModelList_PdfModelList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfModelList/PdfModelList.vue?vue&type=template&id=007dd720
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-table',{ref:"table",attrs:{"url":"/sales/pdf_model?include=top,bottom,footer,columns","columns":_vm.columns,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink}}),_c('PdfModelNew',{attrs:{"modal-state":_vm.modalNew},on:{"input":state => _vm.modalNew = state}}),_c('PdfModelDelete',{on:{"deleted":_vm.deleted},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}}),_c('b-modal',{attrs:{"visible":_vm.cloneModel !== null,"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.continue'),"busy":_vm.cloneLoading,"no-close-on-backdrop":_vm.cloneLoading,"no-close-on-esc":_vm.cloneLoading,"hide-header-close":_vm.cloneLoading},on:{"ok":_vm.clone,"hidden":function($event){_vm.cloneModel = null}}},[(_vm.cloneLoading)?_c('Spinner'):[_vm._v(" Êtes-vous sûr de vouloir cloner ce modèle PDF ? ")]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: ./src/components/PdfModelNew/PdfModelNew.vue + 3 modules
var PdfModelNew = __webpack_require__(11650);
// EXTERNAL MODULE: ./src/components/PdfModelDelete/PdfModelDelete.vue + 3 modules
var PdfModelDelete = __webpack_require__(49171);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfModelList/PdfModelList.ts?vue&type=script&lang=ts&external








var PdfModelList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelList, _super);
    function PdfModelList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteModel = null;
        _this.deleteIndex = null;
        _this.modalNew = false;
        _this.cloneModel = null;
        _this.cloneLoading = false;
        return _this;
    }
    Object.defineProperty(PdfModelList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'label',
                    name: this.$t('sales.pdfModel.label')
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: ['fas', 'copy'],
                    title: 'Cloner le modèle',
                    click: function (model) {
                        _this.cloneModel = model;
                    }
                },
                {
                    icon: 'edit',
                    link: this.rowLink
                },
                {
                    icon: 'delete',
                    condition: function () {
                        var table = _this.$refs['table'];
                        return table.getDatas().length > 1;
                    },
                    click: function (model, index) {
                        _this.deleteModel = model;
                        _this.deleteIndex = index;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    PdfModelList.prototype.rowLink = function (model) {
        return {
            name: 'sales-pdf-model-form',
            params: {
                id: String(model.id)
            }
        };
    };
    PdfModelList.prototype.watchHeaderAction = function (action) {
        if (action === 'new-pdf-model') {
            this.resetHeaderAction();
            this.modalNew = true;
        }
    };
    PdfModelList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.deleteModel = null;
        }
    };
    PdfModelList.prototype.clone = function (event) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        this.cloneLoading = true;
                        return [4 /*yield*/, this.$kwSales.axios.post('/sales/pdf_model/' + ((_a = this.cloneModel) === null || _a === void 0 ? void 0 : _a.id) + '/clone')
                                .then(function (response) {
                                _this.$router.push({
                                    name: 'sales-pdf-model-form',
                                    params: {
                                        id: String(response.data.id)
                                    }
                                });
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('headerAction')
    ], PdfModelList.prototype, "watchHeaderAction", null);
    PdfModelList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['headerAction'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['resetHeaderAction', 'setPageParams'])),
            components: {
                PdfModelNew: PdfModelNew/* default */.A,
                PdfModelDelete: PdfModelDelete/* default */.A,
                KTable: table_vue_.KTable,
                BModal: external_bootstrap_vue_.BModal,
                Spinner: interface_vue_.Spinner
            }
        })
    ], PdfModelList);
    return PdfModelList;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelListvue_type_script_lang_ts_external = (PdfModelList);

;// ./src/components/PdfModelList/PdfModelList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelList_PdfModelListvue_type_script_lang_ts_external = (PdfModelListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfModelList/PdfModelList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelList_PdfModelListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelList_PdfModelList = (component.exports);

/***/ }),

/***/ 50304:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ 50583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(47237),
    basePropertyDeep = __webpack_require__(17255),
    isKey = __webpack_require__(28586),
    toKey = __webpack_require__(77797);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 50624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_DocumentFormView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DocumentFormView.vue?vue&type=template&id=9ea2b9fe
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('DocumentForm',{attrs:{"type":_vm.type},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/LoadDocumentMixin.ts + 2 modules
var LoadDocumentMixin = __webpack_require__(38876);
// EXTERNAL MODULE: ./src/components/DocumentForm/DocumentForm.vue + 27 modules
var DocumentForm = __webpack_require__(72740);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DocumentFormView.vue?vue&type=script&lang=ts




var DocumentFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentFormView, _super);
    function DocumentFormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DocumentForm: DocumentForm/* default */.A
            }
        })
    ], DocumentFormView);
    return DocumentFormView;
}((0,lib/* Mixins */.Xe)(LoadDocumentMixin/* default */.A)));
/* harmony default export */ var DocumentFormViewvue_type_script_lang_ts = (DocumentFormView);

;// ./src/views/DocumentFormView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_DocumentFormViewvue_type_script_lang_ts = (DocumentFormViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/DocumentFormView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_DocumentFormViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_DocumentFormView = (component.exports);

/***/ }),

/***/ 50643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionDocumentDelete_CommissionDocumentDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionDocumentDelete/CommissionDocumentDelete.vue?vue&type=template&id=1badad4e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer cette commission ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionDocumentDelete/CommissionDocumentDelete.ts?vue&type=script&lang=ts&external




var CommissionDocumentDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionDocumentDelete, _super);
    function CommissionDocumentDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(CommissionDocumentDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    CommissionDocumentDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CommissionDocumentDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CommissionDocumentDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/sales/commission/sales/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    CommissionDocumentDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    CommissionDocumentDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CommissionDocumentDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommissionDocumentDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CommissionDocumentDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], CommissionDocumentDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommissionDocumentDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommissionDocumentDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommissionDocumentDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommissionDocumentDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CommissionDocumentDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CommissionDocumentDelete.prototype, "watchModalState", null);
    CommissionDocumentDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CommissionDocumentDelete);
    return CommissionDocumentDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CommissionDocumentDeletevue_type_script_lang_ts_external = (CommissionDocumentDelete);

;// ./src/components/CommissionDocumentDelete/CommissionDocumentDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionDocumentDelete_CommissionDocumentDeletevue_type_script_lang_ts_external = (CommissionDocumentDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionDocumentDelete/CommissionDocumentDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionDocumentDelete_CommissionDocumentDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionDocumentDelete_CommissionDocumentDelete = (component.exports);

/***/ }),

/***/ 50689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(50002);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 50964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TransformToInvoice_TransformToInvoice; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TransformToInvoice/TransformToInvoice.vue?vue&type=template&id=09042e21
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",value:({ title: this.title }),expression:"{ title: this.title }",modifiers:{"right":true}}],tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"title":"Facturation du document","ok-title":_vm.errorMsg ? 'Fermer' : 'Créer la facture',"ok-only":_vm.errorMsg !== null},on:{"show":_vm.setDefaultValues,"submitComplete":_vm.submitComplete},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg !== null)?_c('p',{staticClass:"font-weight-bold text-danger mb-0 text-center"},[_vm._v(" Erreur : "+_vm._s(_vm.errorMsg)+" ")]):_c('k-form',{attrs:{"action":_vm.formUrl,"method":"post"},on:{"submitError":_vm.submitError}},[_c('b-form-group',{attrs:{"label":"Date du document"}},[_c('k-form-datepicker',{attrs:{"name":"date","min-date":_vm.minDate,"max-date":!_vm.teamConfigs.sales_disable_date_check ? _vm.today : null},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.draft}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}},[_vm._v(" Créer la facture au statut brouillon ")]),_c('b-alert',{staticClass:"py-2 px-3",attrs:{"variant":"danger","show":!_vm.draft}},[_vm._v(" Attention : la facture ne pourra pas être modifiée ")]),(!_vm.value.billing_address.city || !_vm.value.billing_address.postal_code)?_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Adresse de facturation"}},[_c('k-form-address',{attrs:{"countries-list":_vm.countries,"prefix-name":"billing_address_","required":"","road-placeholder":_vm.$t('sales.form.road'),"size":"sm","with-road3":"","valuesMap":{
              road: 'road',
              city: 'city'
            },"city-name":"city","road-name":"road"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TransformToInvoice/TransformToInvoice.ts?vue&type=script&lang=ts&external







var TransformToInvoice = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TransformToInvoice, _super);
    function TransformToInvoice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        _this.draft = true;
        _this.today = null;
        _this.address = {};
        return _this;
    }
    TransformToInvoice.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        this.today = external_moment_default()().format('YYYY-MM-DD');
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TransformToInvoice.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToInvoice.prototype, "formUrl", {
        get: function () {
            return '/sales/' + this.type + '/' + this.value.id + '/bill';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToInvoice.prototype, "minDate", {
        get: function () {
            var closed_period = null;
            if (this.team.sales['closed_period']) {
                closed_period = external_moment_default()(this.team.sales['closed_period']).add(1, 'day').format('YYYY-MM-DD');
            }
            var min = null;
            if (!this.teamConfigs.sales_disable_date_check) {
                min = this.team.sales['invoice_date'];
            }
            if (min && (!closed_period || external_moment_default()(min).isAfter(closed_period))) {
                return min;
            }
            else if (closed_period) {
                return closed_period;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    TransformToInvoice.prototype.setDefaultValues = function () {
        this.date = external_moment_default()().format('YYYY-MM-DD');
        this.draft = true;
        this.errorMsg = null;
    };
    TransformToInvoice.prototype.watchValue = function () {
        this.address = this.value.billing_address;
    };
    TransformToInvoice.prototype.submitComplete = function (response) {
        return response.data;
    };
    TransformToInvoice.prototype.submitError = function (error) {
        var _a;
        this.errorMsg = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToInvoice.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToInvoice.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TransformToInvoice.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Facturer le document' })
    ], TransformToInvoice.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToInvoice.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TransformToInvoice.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToInvoice.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToInvoice.prototype, "title", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TransformToInvoice.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], TransformToInvoice.prototype, "submitComplete", null);
    TransformToInvoice = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormAddress: form_vue_.KFormAddress,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'team'])), (0,external_vuex_.mapState)('globalDatas', ['countries'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], TransformToInvoice);
    return TransformToInvoice;
}(lib/* Vue */.lD));
/* harmony default export */ var TransformToInvoicevue_type_script_lang_ts_external = (TransformToInvoice);

;// ./src/components/TransformToInvoice/TransformToInvoice.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TransformToInvoice_TransformToInvoicevue_type_script_lang_ts_external = (TransformToInvoicevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/TransformToInvoice/TransformToInvoice.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TransformToInvoice_TransformToInvoicevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TransformToInvoice_TransformToInvoice = (component.exports);

/***/ }),

/***/ 51146:
/***/ (function(module) {

"use strict";
module.exports = require("moment");

/***/ }),

/***/ 51335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_PaymentListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentListView.vue?vue&type=template&id=e91b87ca
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PaymentList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/PaymentList/PaymentList.vue + 3 modules
var PaymentList = __webpack_require__(45179);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentListView.vue?vue&type=script&lang=ts



var PaymentListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentListView, _super);
    function PaymentListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PaymentList: PaymentList/* default */.A
            }
        })
    ], PaymentListView);
    return PaymentListView;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentListViewvue_type_script_lang_ts = (PaymentListView);

;// ./src/views/PaymentListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_PaymentListViewvue_type_script_lang_ts = (PaymentListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/PaymentListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_PaymentListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_PaymentListView = (component.exports);

/***/ }),

/***/ 51420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80079);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 51459:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 51565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CommandListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommandListView.vue?vue&type=template&id=a1fdf3ac
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CommandList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CommandList/CommandList.vue + 2 modules
var CommandList = __webpack_require__(53991);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommandListView.vue?vue&type=script&lang=ts



var CommandListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandListView, _super);
    function CommandListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommandListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommandList: CommandList/* default */.A
            }
        })
    ], CommandListView);
    return CommandListView;
}(lib/* Vue */.lD));
/* harmony default export */ var CommandListViewvue_type_script_lang_ts = (CommandListView);

;// ./src/views/CommandListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CommandListViewvue_type_script_lang_ts = (CommandListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/CommandListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CommandListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CommandListView = (component.exports);

/***/ }),

/***/ 51811:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 51873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 52477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ 52648:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ 53103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerSepaSelect_CustomerSepaSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSepaSelect/CustomerSepaSelect.vue?vue&type=template&id=c6dabe9a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{attrs:{"label":_vm.computedLabel,"label-size":_vm.labelSize}},[_c('b-input-group',[_c('k-form-select',{ref:"select",attrs:{"ajax":_vm.sepaApiUrl,"getOptionLabel":_vm.getOptionLabel,"required":_vm.required !== false,"disabled":_vm.disabled !== false,"clearable":_vm.clearable,"validationName":_vm.validationName,"size":_vm.size},on:{"input":_vm.onChange},model:{value:(_vm.sepa),callback:function ($$v) {_vm.sepa=$$v},expression:"sepa"}}),(_vm.withForm)?_c('b-input-group-append',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"px-1",attrs:{"title":_vm.buttonTitle,"variant":"primary","size":"sm","disabled":_vm.disabled !== false},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[(!_vm.value)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}):_c('font-awesome-icon',{attrs:{"icon":['fas', 'pencil']}})],1)],1):_vm._e()],1),_c('FormModal',{attrs:{"size":"xl"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('CustomerSepaForm',{attrs:{"customerId":_vm.customerId},on:{"submitComplete":_vm.submitComplete},model:{value:(_vm.sepa),callback:function ($$v) {_vm.sepa=$$v},expression:"sepa"}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/CustomerSepaForm/CustomerSepaForm.vue + 3 modules
var CustomerSepaForm = __webpack_require__(26378);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSepaSelect/CustomerSepaSelect.ts?vue&type=script&lang=ts&external








var CustomerSepaSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSepaSelect, _super);
    function CustomerSepaSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sepa = null;
        _this.modal = false;
        return _this;
    }
    Object.defineProperty(CustomerSepaSelect.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : 'Mandat SEPA';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaSelect.prototype, "buttonTitle", {
        get: function () {
            return !this.value ? 'Créer un mandat SEPA' : 'Modifier le mandat SEPA';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaSelect.prototype, "sepaApiUrl", {
        get: function () {
            var url = '/sales/sepa?filter[status]=1,2';
            if (this.customerId) {
                url += '&filter[customer]=' + this.customerId;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    CustomerSepaSelect.prototype.getOptionLabel = function (sepa) {
        var _a;
        return ((_a = sepa.name) !== null && _a !== void 0 ? _a : sepa.owner) + ' (' + (sepa.type === 1 ? 'Récurrent' : 'Ponctuel') + ')';
    };
    CustomerSepaSelect.prototype.watchValue = function (value) {
        this.sepa = value ? JSON.parse(JSON.stringify(value)) : null;
    };
    CustomerSepaSelect.prototype.onChange = function () {
        return this.sepa;
    };
    CustomerSepaSelect.prototype.submitComplete = function (response) {
        var _a;
        var select = this.$refs.select;
        var sepa = response.data;
        if ((_a = this.sepa) === null || _a === void 0 ? void 0 : _a.id) {
            select.updateOption(sepa);
        }
        else {
            select.addOption(sepa);
        }
        this.sepa = sepa;
        this.onChange();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaSelect.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaSelect.prototype, "customerId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerSepaSelect.prototype, "withForm", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaSelect.prototype, "validationName", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerSepaSelect.prototype, "required", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerSepaSelect.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerSepaSelect.prototype, "clearable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaSelect.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaSelect.prototype, "labelSize", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomerSepaSelect.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], CustomerSepaSelect.prototype, "onChange", null);
    CustomerSepaSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KFormSelect: form_vue_.KFormSelect,
                CustomerSepaForm: CustomerSepaForm/* default */.A,
                FormModal: interface_vue_.FormModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CustomerSepaSelect);
    return CustomerSepaSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerSepaSelectvue_type_script_lang_ts_external = (CustomerSepaSelect);

;// ./src/components/CustomerSepaSelect/CustomerSepaSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSepaSelect_CustomerSepaSelectvue_type_script_lang_ts_external = (CustomerSepaSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CustomerSepaSelect/CustomerSepaSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerSepaSelect_CustomerSepaSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSepaSelect_CustomerSepaSelect = (component.exports);

/***/ }),

/***/ 53254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentContents_DocumentContents; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/DocumentContents/DocumentContents.vue?vue&type=template&id=a93a2aa6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-document-contents-area"},[_c('h3',{staticClass:"form-title pb-1 mb-0"},[_vm._v(_vm._s(_vm.$t('sales.form.titleContent')))]),_c('b-overlay',{attrs:{"show":_vm.loadingSalesProductsQuantity,"bg-color":"#fff"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center"},[_c('Spinner',{staticClass:"py-0"}),_vm._v(" Chargement des prix personnalisés en cours... ")],1)]},proxy:true}])},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"5","order":"2","order-md":"1"}},[_c('CatalogSearch',{staticStyle:{"flex":"1 1 auto"},attrs:{"size":"sm","filters":{ not_for_sale: 0 },"include":{
            product: ['unit', 'vat_rate', 'variation_levels', 'default_picture', 'custom_prices', 'sale_category'],
            service: ['unit', 'vat_rate', 'default_picture', 'custom_prices', 'sale_category'],
            group: ['unit', 'vat_rate', 'default_picture', 'custom_prices', 'sale_category']
          }},on:{"selected":element => _vm.addCatalogLine(element)}})],1),_c('b-col',{staticClass:"mb-2 mb-md-0",attrs:{"cols":"12","md":"7","order":"1","order-md":"2"}},[_c('b-button-group',[(!_vm.teamConfigs.sales_disable_empty_line)?_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addEmptyLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.emptyLine'))+" ")]):_vm._e(),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addCommentsLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.commentsLine'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addSubtotalLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.subtotalLine'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addPageBreakLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.pagebreakLine'))+" ")])],1)],1)],1),_c('div',{staticClass:"table-responsive-lg"},[_c('table',{class:{
          'table table-sm table-bordered mt-1 table-document-content text-nowrap': true,
          'table-collapsed': _vm.editingModeActive
        }},[_c('thead',{staticClass:"thead-dark small text-center"},[_c('tr',[_c('th',{staticStyle:{"width":"18px"}}),(_vm.value.input_options.col_number)?_c('th',{staticStyle:{"width":"20px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.number'))+" ")]):_vm._e(),(_vm.value.input_options.col_picture)?_c('th',{staticStyle:{"width":"100px"}},[_vm._v(" Photo ")]):_vm._e(),(_vm.value.input_options.col_reference)?_c('th',{staticStyle:{"width":"100px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.reference'))+" ")]):_vm._e(),_c('th',{staticClass:"text-left"},[_vm._v("Désignation")]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Remise")]),(_vm.value.input_mode === 'ht')?_c('th',{staticStyle:{"width":"110px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.unitPriceHt'))+" ")]):_vm._e(),(_vm.value.input_mode === 'ttc')?_c('th',{staticStyle:{"width":"110px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.unitPriceTtc'))+" ")]):_vm._e(),(!_vm.value.use_global_vatrate)?_c('th',{staticStyle:{"width":"76px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.vatRate'))+" ")]):_vm._e(),_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Quantité")]),(_vm.value.secondary_quantity_mode !== 'disable')?_c('th',{staticStyle:{"width":"100px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.quantity2'))+" ")]):_vm._e(),(_vm.value.input_mode === 'ht')?_c('th',{staticStyle:{"width":"110px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.totalHt'))+" ")]):_vm._e(),(_vm.value.input_mode === 'ttc')?_c('th',{staticStyle:{"width":"110px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.totalTtc'))+" ")]):_vm._e(),_c('th',{staticStyle:{"width":"21px"}})])]),(_vm.value.contents.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"10"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.noContent'))+" ")])])]):_vm._e(),(_vm.value.contents.length > 0)?_c('draggable',{ref:"draggable",attrs:{"list":_vm.value.contents,"handle":".draggable-handle","tag":"tbody"},on:{"start":_vm.startDragging,"end":_vm.stopDragging}},[_vm._l((_vm.value.contents),function(content,i){return [(content.is_comments)?_c('CommentLine',{key:i,ref:'content' + i,refInFor:true,attrs:{"document":_vm.value,"type":_vm.type,"index":i,"editingMode":_vm.editingMode(i),"lastInsertIndex":_vm.lastInsertIndex},on:{"deleteLine":function($event){return _vm.deleteLine(i)},"addSubLine":event => _vm.addSubLine(i, event)},model:{value:(_vm.value.contents[i]),callback:function ($$v) {_vm.$set(_vm.value.contents, i, $$v)},expression:"value.contents[i]"}}):(content.is_pagebreak)?_c('PageBreakLine',{key:i,ref:'content' + i,refInFor:true,attrs:{"document":_vm.value,"type":_vm.type,"index":i,"editingMode":_vm.editingMode(i),"lastInsertIndex":_vm.lastInsertIndex},on:{"deleteLine":function($event){return _vm.deleteLine(i)},"addSubLine":event => _vm.addSubLine(i, event)},model:{value:(_vm.value.contents[i]),callback:function ($$v) {_vm.$set(_vm.value.contents, i, $$v)},expression:"value.contents[i]"}}):(content.is_subtotal)?_c('SubTotalLine',{key:i,ref:'content' + i,refInFor:true,attrs:{"document":_vm.value,"type":_vm.type,"index":i,"editingMode":_vm.editingMode(i),"lastInsertIndex":_vm.lastInsertIndex},on:{"deleteLine":function($event){return _vm.deleteLine(i)},"addSubLine":event => _vm.addSubLine(i, event)},model:{value:(_vm.value.contents[i]),callback:function ($$v) {_vm.$set(_vm.value.contents, i, $$v)},expression:"value.contents[i]"}}):_c('SaleLine',{key:i,ref:'content' + i,refInFor:true,attrs:{"document":_vm.value,"type":_vm.type,"salesProductsQuantity":_vm.salesProductsQuantity,"index":i,"editingMode":_vm.editingMode(i),"lastInsertIndex":_vm.lastInsertIndex},on:{"deleteLine":function($event){return _vm.deleteLine(i)},"addSubLine":event => _vm.addSubLine(i, event)},model:{value:(_vm.value.contents[i]),callback:function ($$v) {_vm.$set(_vm.value.contents, i, $$v)},expression:"value.contents[i]"}})]})],2):_vm._e()],1)]),_c('b-form-row',[_c('b-col',[(_vm.value.contents.length > 4)?_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('CatalogSearch',{staticStyle:{"flex":"1 1 auto"},attrs:{"size":"sm","include":{
                product: ['unit', 'vat_rate', 'variation_levels', 'default_picture', 'custom_prices', 'sale_category'],
                service: ['unit', 'vat_rate', 'default_picture', 'custom_prices', 'sale_category'],
                group: ['unit', 'vat_rate', 'default_picture', 'custom_prices', 'sale_category']
              }},on:{"selected":element => _vm.addCatalogLine(element)}})],1),_c('b-col',[_c('b-button-group',[(!_vm.teamConfigs.sales_disable_empty_line)?_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addEmptyLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.emptyLine'))+" ")]):_vm._e(),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addCommentsLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.commentsLine'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addSubtotalLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.subtotalLine'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addPageBreakLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.pagebreakLine'))+" ")])],1)],1)],1):_vm._e()],1),_c('b-col',{attrs:{"cols":"auto"}},[(_vm.type !== 'delivery' && _vm.hasModule('sales-grants'))?_c('b-form-group',{attrs:{"label":"Subvention :"}},[_c('input',{attrs:{"type":"hidden","name":"grant"},domProps:{"value":_vm.value.grant ? _vm.value.grant.id : null}}),_c('GrantSelect',{attrs:{"validationName":"grant"},on:{"input":_vm.calculateTotals},model:{value:(_vm.value.grant),callback:function ($$v) {_vm.$set(_vm.value, "grant", $$v)},expression:"value.grant"}})],1):_vm._e(),_c('table',{staticClass:"table table-sm table-bordered mt-1 table-document-content align-middle"},[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.totals.globalDiscount'))+" "+_vm._s(_vm.$t('sales.form.totals.globalDiscount' + (_vm.value.input_mode === 'ht' ? 'Ht' : 'Ttc')))+" : "),_c('input',{attrs:{"type":"hidden","name":"global_discount_type_amount"},domProps:{"value":_vm.value.input_mode}})]),_c('td',[_c('b-input-group',[_c('k-form-number',{attrs:{"name":"global_discount_value","min":0},on:{"change":_vm.calculateTotals},model:{value:(_vm.value.global_discount_value),callback:function ($$v) {_vm.$set(_vm.value, "global_discount_value", $$v)},expression:"value.global_discount_value"}}),_c('b-input-group-append',[_c('k-form-select',{attrs:{"name":"global_discount_type","reduce":opt => opt.id,"options":[
                      { id: 'pourcent', label: '%' },
                      { id: 'amount', label: _vm.value.currency ? _vm.value.currency.symbol : null }
                    ],"clearable":false},on:{"input":_vm.calculateTotals},model:{value:(_vm.value.global_discount_type),callback:function ($$v) {_vm.$set(_vm.value, "global_discount_type", $$v)},expression:"value.global_discount_type"}})],1)],1)],1)]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('sales.form.totals.totalHt')))]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.value.currency ? _vm.value.currency.symbol : null}},[_c('k-form-number',{attrs:{"value":_vm.value.total_ht,"readonly":_vm.value.input_mode === 'ttc'},on:{"change":_vm.calculateHtTotals}})],1)],1)]),(!_vm.value.vatrates || _vm.value.vatrates.length === 0)?_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.totals.tva'))+" ")]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.value.currency ? _vm.value.currency.symbol : null}},[_c('k-form-number',{attrs:{"value":0,"readonly":""}})],1)],1)]):_vm._e(),_vm._l((_vm.value.vatrates),function(rate,i){return _c('tr',{key:i},[_c('td',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.totals.tvaRate', { rate: rate.vat_rate ? rate.vat_rate.rate : 0 }))+" ")]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.value.currency ? _vm.value.currency.symbol : null}},[_c('k-form-number',{attrs:{"value":rate.tva,"readonly":""}})],1)],1)])}),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('sales.form.totals.totalTtc')))]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.value.currency ? _vm.value.currency.symbol : null}},[_c('k-form-number',{attrs:{"value":_vm.value.total_ttc,"readonly":_vm.value.input_mode === 'ht'},on:{"change":_vm.calculateTtcTotals}})],1)],1)]),(_vm.value.grant)?[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(" Subvention "),(_vm.value.grant.type === 'pourcent')?[_vm._v(" ("+_vm._s(_vm.showNumber(_vm.value.grant.pourcent))+" %) ")]:_vm._e(),_vm._v(" : ")],2),_c('td',[_c('b-input-group',{attrs:{"append":_vm.value.currency ? _vm.value.currency.symbol : null}},[_c('k-form-number',{attrs:{"name":"grant_amount","min":"0","readonly":_vm.value.grant.type === 'pourcent'},on:{"change":_vm.calculateTotals},model:{value:(_vm.value.grant_amount),callback:function ($$v) {_vm.$set(_vm.value, "grant_amount", $$v)},expression:"value.grant_amount"}})],1)],1)]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("À payer")]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.value.currency ? _vm.value.currency.symbol : null}},[_c('k-form-number',{attrs:{"value":_vm.value.to_paid,"readonly":""}})],1)],1)])]:_vm._e()],2)],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuedraggable"
var external_vuedraggable_ = __webpack_require__(25325);
var external_vuedraggable_default = /*#__PURE__*/__webpack_require__.n(external_vuedraggable_);
;// external "lodash"
var external_lodash_namespaceObject = require("lodash");
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/catalog-vue"
var catalog_vue_ = __webpack_require__(68480);
// EXTERNAL MODULE: ./src/components/Form/SaleLine/SaleLine.vue + 3 modules
var SaleLine = __webpack_require__(7143);
// EXTERNAL MODULE: ./src/components/Form/CommentLine/CommentLine.vue + 3 modules
var CommentLine = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/components/Form/PageBreakLine/PageBreakLine.vue + 3 modules
var PageBreakLine = __webpack_require__(8477);
// EXTERNAL MODULE: ./src/components/Form/SubTotalLine/SubTotalLine.vue + 3 modules
var SubTotalLine = __webpack_require__(97302);
// EXTERNAL MODULE: ./src/components/GrantSelect/GrantSelect.vue + 3 modules
var GrantSelect = __webpack_require__(59755);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/DocumentContents/DocumentContents.ts?vue&type=script&lang=ts&external















var DocumentContents = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentContents, _super);
    function DocumentContents() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.salesProductsQuantity = [];
        _this.loadingSalesProductsQuantity = false;
        _this.lastInsertIndex = 0;
        return _this;
    }
    DocumentContents.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadVatRates()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DocumentContents.prototype, "allowedDecimals", {
        get: function () {
            return this.teamConfigs.number_nb_decimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentContents.prototype, "editingMode", {
        get: function () {
            var _this = this;
            return function (index) {
                return _this.forceEditing.includes(index) || _this.value.contents.length < _this.teamConfigs.sales_form_compact_number;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentContents.prototype, "editingModeActive", {
        get: function () {
            return this.value.contents.length >= this.teamConfigs.sales_form_compact_number;
        },
        enumerable: false,
        configurable: true
    });
    DocumentContents.prototype.watchDocumentVatRate = function () {
        var _this = this;
        if (!this.value.use_global_vatrate) {
            return;
        }
        this.value.contents.forEach(function (content) {
            content.vat_rate = _this.value.vat_rate;
        });
    };
    DocumentContents.prototype.watchDocument = function () {
        this.calculateTotals();
    };
    DocumentContents.prototype.watchCustomer = function (customer, oldCustomer) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(customer && (oldCustomer === null || oldCustomer.id !== customer.id))) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.fetchQuantitiesForCustomPrices(this.getElementsForCustomPrices())];
                    case 1:
                        _a.salesProductsQuantity = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DocumentContents.prototype.addCatalogLine = function (element, index) {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var product, catalog_costs_u, type, document, content, configs;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        product = element.data;
                        catalog_costs_u = 0;
                        type = '';
                        switch (element.type) {
                            case 'product':
                            case 'group':
                                catalog_costs_u = 0;
                                if ('unit_buy_price_ht' in product) {
                                    catalog_costs_u = this.teamConfigs.sales_costs_average_buy_price && product.average_buy_price > 0 ? this.number(product.average_buy_price) : this.number(product.unit_buy_price_ht);
                                }
                                type = 'product';
                                break;
                            case 'service':
                                catalog_costs_u = 'products_costs' in product ? product.products_costs : 0;
                                type = 'service';
                                break;
                        }
                        return [4 /*yield*/, this.fetchElementForCustomPrices({
                                type: type,
                                id: product.id,
                                element: product
                            })];
                    case 1:
                        _c.sent();
                        document = this.value;
                        content = {
                            is_comments: false,
                            is_pagebreak: false,
                            is_subtotal: false,
                            catalog: {
                                type: type,
                                id: product.id,
                                element: product
                            },
                            picture: 'default_picture' in product ? product.default_picture : null,
                            reference: product.reference,
                            designation: product.designation,
                            weight_unit: 'unit_weight' in product ? product.unit_weight : null,
                            ean_code: 'ean_code' in product ? product.ean_code : null,
                            unit_price_ht: this.number(product.unit_price_ht),
                            unit_price_ttc: this.number(product.unit_price_ttc),
                            ecotax_u_ht: 'eco_tax_ht' in product ? this.number(product.eco_tax_ht) : 0,
                            ecotax_u_ttc: 'eco_tax_ttc' in product ? this.number(product.eco_tax_ttc) : 0,
                            catalog_costs_u: catalog_costs_u,
                            various_costs_u: this.number(product.various_costs),
                            hourly_person_cost: 'hourly_person_cost' in product ? product.hourly_person_cost : 0,
                            number_people_needed: 'number_people_needed' in product ? product.number_people_needed : 0,
                            duration: 'duration' in product ? product.duration : 0,
                            duration_type: 'duration_type' in product ? product.duration_type : 'minute',
                            quantity: this.number(product.default_quantity),
                            unit: product.unit,
                            secondary_quantity: 1,
                            vat_rate: document.use_global_vatrate ? document.vat_rate : product.vat_rate ? product.vat_rate : this.defaultVatRate,
                            discount_value: 0,
                            discount_type: 'pourcent',
                            total_ht: 0,
                            total_ttc: 0
                        };
                        configs = (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.configs;
                        if (configs && configs.sales_vat_rate) {
                            content.vat_rate = configs.sales_vat_rate;
                        }
                        this.addNewLine(content, index);
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentContents.prototype.addEmptyLine = function (index) {
        var _a, _b;
        if (index === void 0) { index = null; }
        var document = this.value;
        var content = {
            is_comments: false,
            is_pagebreak: false,
            is_subtotal: false,
            catalog: undefined,
            vat_rate: document.use_global_vatrate ? document.vat_rate : this.defaultVatRate,
            discount_type: 'pourcent',
            duration_type: 'minute',
            unit_price_ht: 0,
            unit_price_ttc: 0,
            quantity: 1,
            secondary_quantity: 1,
            total_ht: 0,
            total_ttc: 0
        };
        var configs = (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.configs;
        if (configs && configs.sales_vat_rate) {
            content.vat_rate = configs.sales_vat_rate;
        }
        this.addNewLine(content, index);
    };
    DocumentContents.prototype.addCommentsLine = function (index) {
        if (index === void 0) { index = null; }
        this.addNewLine({ is_comments: true }, index);
    };
    DocumentContents.prototype.addSubtotalLine = function (index) {
        if (index === void 0) { index = null; }
        this.addNewLine({
            is_subtotal: true,
            designation: this.teamConfigs.sales_subtotal_designation
        }, index);
    };
    DocumentContents.prototype.addPageBreakLine = function (index) {
        if (index === void 0) { index = null; }
        this.addNewLine({ is_pagebreak: true }, index);
    };
    DocumentContents.prototype.addNewLine = function (content, index) {
        var _this = this;
        if (index === void 0) { index = null; }
        if (index !== null) {
            this.value.contents.splice(index, 0, content);
            this.lastInsertIndex = index;
            this.$nextTick(function () {
                var line = _this.$refs['content' + index];
                line[0].calculPrices();
            });
        }
        else {
            var length = this.value.contents.push(content);
            this.lastInsertIndex = length - 1;
        }
    };
    DocumentContents.prototype.addSubLine = function (index, event) {
        var newIndex = index;
        if (event.position === 'bottom') {
            newIndex++;
        }
        var content;
        switch (event.type) {
            case 'empty':
                this.addEmptyLine(newIndex);
                break;
            case 'comments':
                this.addCommentsLine(newIndex);
                break;
            case 'pagebreak':
                this.addPageBreakLine(newIndex);
                break;
            case 'subtotal':
                this.addSubtotalLine(newIndex);
                break;
            case 'catalog':
                this.addCatalogLine(event.catalog, newIndex);
                break;
            case 'clone':
                if (this.value.contents[index]) {
                    content = JSON.parse(JSON.stringify(this.value.contents[index]));
                    delete content.id;
                    delete content.affair_content;
                    delete content.affair_content_id;
                    this.addNewLine(content, newIndex);
                }
                break;
        }
    };
    DocumentContents.prototype.deleteLine = function (key) {
        this.value.contents.splice(key, 1);
    };
    DocumentContents.prototype.calculateTotals = function () {
        var _this = this;
        var document = this.value;
        var contents = [];
        var totalWorkforce = 0;
        var totalCosts = 0;
        var grossMarginAmount = 0;
        var totalCharge = 0;
        var totalHT = 0;
        var totalTTC = 0;
        var mode = document.input_mode;
        document.contents.forEach(function (content) {
            if (content.is_option || content.is_pagebreak || content.is_subtotal || content.is_comments) {
                return;
            }
            totalWorkforce += _this.number(content.total_workforce);
            totalCosts += _this.number(content.total_costs);
            totalCharge += _this.number(content.total_charge);
            totalHT += _this.number(content.total_ht);
            totalTTC += _this.number(content.total_ttc);
            var contentsByRate = [{
                    rate: content.vat_rate,
                    total: _this.number(content[mode === 'ht' ? 'total_ht' : 'total_ttc'])
                }];
            (0,external_lodash_namespaceObject.forEach)(contentsByRate, function (content) {
                var rate = content.rate ? content.rate.rate : 0;
                var vatrate = contents.findIndex(function (content) { return content.rate === rate; });
                if (vatrate < 0) {
                    contents.push({
                        vatrate: content.rate,
                        rate: rate,
                        amount: content.total
                    });
                }
                else {
                    contents[vatrate].amount += content.total;
                }
            });
        });
        var discountValue = this.number(document.global_discount_value);
        var discountPourcent = discountValue;
        if (discountValue > 0 && document.global_discount_type === 'amount') {
            discountPourcent = (discountValue * 100) / (mode === 'ht' ? totalHT : totalTTC);
        }
        if (totalHT < 0 && discountValue > 0) {
            document.global_discount_value = 0;
            discountPourcent = 0;
        }
        document.vatrates = contents.map(function (content) {
            var ht, tva, ttc;
            if (mode === 'ht') {
                ht = _this.number(content.amount);
                if (discountPourcent > 0) {
                    ht -= _this.roundNumber(ht * discountPourcent / 100, _this.allowedDecimals);
                }
                tva = _this.roundNumber(ht * (content.rate / 100), _this.allowedDecimals);
                ttc = ht + tva;
            }
            else {
                ttc = _this.number(content.amount);
                if (discountPourcent > 0) {
                    ttc -= _this.roundNumber(ttc * discountPourcent / 100, _this.allowedDecimals);
                }
                tva = _this.roundNumber(ttc / (100 + content.rate) * content.rate, _this.allowedDecimals);
                ht = ttc - tva;
            }
            grossMarginAmount += _this.number(ht);
            return {
                vat_rate: content.vatrate,
                ht: ht,
                tva: tva,
                ttc: ttc
            };
        });
        grossMarginAmount -= this.number(totalCharge);
        var totalHt = this.roundNumber(document.vatrates.map(function (rate) { return rate.ht; }).reduce(function (a, b) { return a + b; }, 0), this.allowedDecimals);
        document.total_ht = totalHt;
        document.total_tva = this.roundNumber(document.vatrates.map(function (rate) { return rate.tva; }).reduce(function (a, b) { return a + b; }, 0), this.allowedDecimals);
        document.total_ttc = this.roundNumber(document.vatrates.map(function (rate) { return rate.ttc; }).reduce(function (a, b) { return a + b; }, 0), this.allowedDecimals);
        document.total_workforce = this.roundNumber(totalWorkforce, 2);
        document.total_costs = this.roundNumber(totalCosts, 2);
        document.gross_margin_amount = this.roundNumber(grossMarginAmount, this.allowedDecimals);
        document.total_charge = this.roundNumber(totalCharge, 2);
        document.gross_margin_rate = totalCharge === 0 ? 100 : this.roundNumber((grossMarginAmount / totalCharge * 100), 2);
        document.markup_rate = totalHt === 0 ? 0 : this.roundNumber((grossMarginAmount / totalHt * 100), 2);
        this.calculateGrant();
    };
    DocumentContents.prototype.calculateHtTotals = function (totalHt, oldValue) {
        this.calculateFromTotals('ht', totalHt, oldValue);
    };
    DocumentContents.prototype.calculateTtcTotals = function (totalTtc, oldValue) {
        this.calculateFromTotals('ttc', totalTtc, oldValue);
    };
    DocumentContents.prototype.calculateFromTotals = function (mode, newValue, oldValue) {
        var _this = this;
        var document = this.value;
        var calculTotal = this.number(newValue);
        // Global discount
        if (document.global_discount_value && document.global_discount_value > 0) {
            var discountValue = this.number(document.global_discount_value);
            if (document.global_discount_type === 'pourcent') {
                calculTotal = this.roundNumber((calculTotal * 100) / (100 - discountValue), this.allowedDecimals);
            }
            else {
                calculTotal += discountValue;
            }
        }
        var key = mode === 'ht' ? 'total_ht' : 'total_ttc';
        var contents = document.contents;
        var checkTotal = 0;
        contents.forEach(function (content, i) {
            var total = _this.number(content[key]);
            if (total > 0) {
                var coef = _this.number(total / _this.number(oldValue));
                var newTotal = _this.roundNumber(calculTotal * coef, _this.allowedDecimals);
                checkTotal += newTotal;
                if (contents.length === (i + 1)) {
                    var diff = _this.roundNumber(calculTotal - checkTotal, _this.allowedDecimals);
                    if (diff !== 0) {
                        newTotal += diff;
                    }
                }
                content[key] = newTotal;
                var components = _this.$refs['content' + i];
                var component = components[0];
                if (component) {
                    if (mode === 'ht' && 'calculHtTotals' in component) {
                        component.calculHtTotals();
                    }
                    else if (mode === 'ttc' && 'calculTtcTotals' in component) {
                        component.calculTtcTotals();
                    }
                }
            }
        });
    };
    DocumentContents.prototype.calculateGrant = function () {
        var _a;
        var document = this.value;
        var toPaid = this.number(document.total_ttc);
        var grantAmount = 0;
        var grant = document.grant;
        if (grant) {
            switch (grant.type) {
                case 'pourcent':
                    grantAmount = this.roundNumber(toPaid * grant.pourcent / 100, this.allowedDecimals);
                    break;
                case 'amount':
                    grantAmount = (_a = this.number(document.grant_amount)) !== null && _a !== void 0 ? _a : 0;
                    break;
            }
            toPaid -= grantAmount;
        }
        document.to_paid = toPaid;
        document.grant_amount = grantAmount;
    };
    // Return all catalog elements who need to retrieve quantities sold
    DocumentContents.prototype.getElementsForCustomPrices = function () {
        var customer = this.value.customer;
        if (!customer) {
            return [];
        }
        return this.value.contents
            .filter(function (content) {
            var catalog = content.catalog;
            if (!catalog) {
                return false;
            }
            var element = catalog.element;
            if (!catalog || !('custom_price_mode' in element) || element.custom_price_mode !== 'quantity' || element.custom_price_quantity_mode === 1) {
                return false;
            }
            return true;
        })
            .map(function (content) {
            var catalog = content.catalog;
            return {
                type: catalog.type,
                id: catalog.id,
                element: catalog.element
            };
        });
    };
    DocumentContents.prototype.fetchElementForCustomPrices = function (catalog) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var element, presence, _a, _b, _c;
            var _d;
            return (0,tslib_es6/* __generator */.YH)(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!catalog || !this.value.customer) {
                            return [2 /*return*/];
                        }
                        element = catalog.element;
                        if (!catalog || !('custom_price_mode' in element) || element.custom_price_mode !== 'quantity' || element.custom_price_quantity_mode === 1) {
                            return [2 /*return*/];
                        }
                        presence = this.salesProductsQuantity.find(function (el) { return el.type === catalog.type && el.id === catalog.id; });
                        if (presence) {
                            return [2 /*return*/];
                        }
                        _b = (_a = (_d = this.salesProductsQuantity).push).apply;
                        _c = [_d];
                        return [4 /*yield*/, this.fetchQuantitiesForCustomPrices([{
                                    type: catalog.type,
                                    id: catalog.id,
                                    element: catalog.element
                                }])];
                    case 1:
                        _b.apply(_a, _c.concat([_e.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentContents.prototype.fetchQuantitiesForCustomPrices = function (elements) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var params, url;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                if (elements.length === 0) {
                    return [2 /*return*/, []];
                }
                this.loadingSalesProductsQuantity = true;
                params = {
                    elements: []
                };
                elements.forEach(function (element) {
                    var _a;
                    var param = {
                        id: element.id,
                        type: element.type
                    };
                    var catalog = element.element;
                    var date;
                    switch (catalog.custom_price_quantity_mode) {
                        case 2: // Quantity ordered from 01/01 to 12/31 of the current year
                            date = external_moment_default()().year();
                            param.since = date + '-01-01';
                            param.until = date + '-12-31';
                            break;
                        case 3: // Quantity ordered from 01/01 to 12/31 of the previous year
                            date = external_moment_default()().add(-1, 'year').year();
                            param.since = date + '-01-01';
                            param.until = date + '-12-31';
                            break;
                        case 4: // Quantity ordered over the last X months
                            date = external_moment_default()().add(-((_a = catalog.custom_price_quantity_month_length) !== null && _a !== void 0 ? _a : 0), 'month');
                            param.since = date.format('YYYY-MM-DD');
                            break;
                    }
                    params.elements.push(param);
                });
                url = '/catalog/custom-prices/' + ((_a = this.value.customer) === null || _a === void 0 ? void 0 : _a.id);
                return [2 /*return*/, this.$kwSales.axios.get(url, { params: params })
                        .then(function (response) {
                        return response.data;
                    })
                        .finally(function () {
                        _this.loadingSalesProductsQuantity = false;
                    })];
            });
        });
    };
    DocumentContents.prototype.startDragging = function () {
        var _a;
        ((_a = this.$refs.draggable) === null || _a === void 0 ? void 0 : _a.$el).classList.add('dragging');
    };
    DocumentContents.prototype.stopDragging = function () {
        var _a;
        ((_a = this.$refs.draggable) === null || _a === void 0 ? void 0 : _a.$el).classList.remove('dragging');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], DocumentContents.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentContents.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], DocumentContents.prototype, "forceEditing", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.vat_rate'),
        (0,lib/* Watch */.ox)('value.use_global_vatrate')
    ], DocumentContents.prototype, "watchDocumentVatRate", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.contents', { deep: true })
    ], DocumentContents.prototype, "watchDocument", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.customer')
    ], DocumentContents.prototype, "watchCustomer", null);
    DocumentContents = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadVatRates'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['defaultVatRate'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                CatalogSearch: catalog_vue_.CatalogSearch,
                SaleLine: SaleLine/* default */.A,
                SubTotalLine: SubTotalLine/* default */.A,
                PageBreakLine: PageBreakLine/* default */.A,
                CommentLine: CommentLine/* default */.A,
                GrantSelect: GrantSelect/* default */.A,
                draggable: (external_vuedraggable_default()),
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButtonGroup: external_bootstrap_vue_.BButtonGroup, BButton: external_bootstrap_vue_.BButton, BFormRow: external_bootstrap_vue_.BFormRow, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BOverlay: external_bootstrap_vue_.BOverlay, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber,
                Spinner: interface_vue_.Spinner
            }
        })
    ], DocumentContents);
    return DocumentContents;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var DocumentContentsvue_type_script_lang_ts_external = (DocumentContents);

;// ./src/components/Form/DocumentContents/DocumentContents.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentContents_DocumentContentsvue_type_script_lang_ts_external = (DocumentContentsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/DocumentContents/DocumentContents.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentContents_DocumentContentsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentContents_DocumentContents = (component.exports);

/***/ }),

/***/ 53426:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'image';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f03e';
var svgPathData = 'M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.jb = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 53471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractItem_ContractItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractItem/ContractItem.vue?vue&type=template&id=62914ef9
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"document-item"},[(_vm.loading)?_c('Spinner'):[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle,"buttons":_vm.buttons}},[_c('b-col',{staticClass:"text-md-right text-center mt-2 mt-md-1 col",attrs:{"cols":"12","md":""}},[_c('ul',{staticClass:"status-bar w-auto d-inline-block"},_vm._l((_vm.contractStatusBar),function(status){return _c('li',{key:status.value,class:{
              selected: status.value === _vm.value.status
            }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0)])],1),_c('AppMessages'),(_vm.value.title)?_c('h2',{staticClass:"mb-3"},[_vm._v(" "+_vm._s(_vm.value.title)+" ")]):_vm._e(),(_vm.value.status <= 2 || (_vm.value.document_status !== 2 && _vm.value.model && _vm.value.model.contract))?_c('div',{staticClass:"mb-4"},[(_vm.app.electronic_sign_status && !_vm.signed && _vm.value.document_status === 2 && _vm.can('sales-signatures', 1) && _vm.can('sales-contracts', 2))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
          title: _vm.waitingSign ? 'Un demande de signature est déjà en attente' : null
        }),expression:"{\n          title: waitingSign ? 'Un demande de signature est déjà en attente' : null\n        }"}],staticClass:"d-inline-block mr-2"},[_c('SignSend',{attrs:{"size":"sm","variant":"primary","value":{
            documents: _vm.contractSignDocuments
          },"disabled":_vm.waitingSign},on:{"input":_vm.emitContract,"sended":_vm.markAsSent}})],1):_vm._e(),(_vm.value.status === 1)?_c('ContractStatus',{staticClass:"mr-2 d-inline-block",attrs:{"contract":_vm.value,"label":"Marquer comme \"En attente\"","status":2,"size":"sm"},on:{"input":_vm.emitContract}}):_vm._e(),(_vm.value.status <= 2)?_c('ContractStatus',{staticClass:"mr-2 d-inline-block",attrs:{"contract":_vm.value,"label":"Activer le contrat","confirmLabel":"En cours","status":3,"size":"sm","variant":"success"},on:{"input":_vm.emitContract}}):_vm._e(),(_vm.value.document_status === 2 && _vm.value.model && _vm.value.model.contract)?_c('ContractDownload',{attrs:{"value":_vm.value,"size":"sm"},on:{"input":_vm.emitContract}}):_vm._e()],1):_vm._e(),(_vm.app.electronic_sign_status)?_c('SignState',{attrs:{"signatures":_vm.value.signatures},on:{"signed":state => _vm.signed = state,"waiting":state => _vm.waitingSign = state}}):_vm._e(),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"4","xl":"3"}},[_c('b-card',[_c('b-form-group',{attrs:{"label":"Client"}},[_c('CustomerSpeedItem',{model:{value:(_vm.value.customer),callback:function ($$v) {_vm.$set(_vm.value, "customer", $$v)},expression:"value.customer"}})],1),(_vm.value.customer_child)?_c('b-form-group',{attrs:{"label":_vm.teamConfigs.customer_group_child_name}},[_c('CustomerSpeedItem',{model:{value:(_vm.value.customer_child),callback:function ($$v) {_vm.$set(_vm.value, "customer_child", $$v)},expression:"value.customer_child"}})],1):_vm._e(),(_vm.value.contact)?_c('b-form-group',{attrs:{"label":"Contact"}},[_c('ContactSpeedItem',{model:{value:(_vm.value.contact),callback:function ($$v) {_vm.$set(_vm.value, "contact", $$v)},expression:"value.contact"}})],1):_vm._e(),(_vm.value.billing_contact)?_c('b-form-group',{attrs:{"label":"Contact facturation"}},[_c('ContactSpeedItem',{model:{value:(_vm.value.billing_contact),callback:function ($$v) {_vm.$set(_vm.value, "billing_contact", $$v)},expression:"value.billing_contact"}})],1):_vm._e(),(_vm.value.model)?_c('b-form-group',{attrs:{"label":"Modèle de contrat"}},[_vm._v(" "+_vm._s(_vm.value.model.name)+" ")]):_vm._e(),(_vm.value.active_period)?_c('b-form-group',{attrs:{"label":"Période"}},[_vm._v(" Du "+_vm._s(_vm.date(_vm.value.active_period.begin))+" au "+_vm._s(_vm.date(_vm.value.active_period.end))+" ")]):_vm._e(),(_vm.value.next_deadline)?_c('b-form-group',{attrs:{"label":"Prochaine échéance"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.next_deadline))+" ")]):_vm._e(),(_vm.value.sign_date)?_c('b-form-group',{attrs:{"label":"Date de signature"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.sign_date))+" ")]):_vm._e(),(_vm.value.customer_command_reference)?_c('b-form-group',{attrs:{"label":"Bon de commande client"}},[_vm._v(" "+_vm._s(_vm.value.customer_command_reference)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Adresse de facturation"}},[(_vm.value.road1)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.value.road1)+" ")]):_vm._e(),(_vm.value.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.value.road2)+" ")]):_vm._e(),(_vm.value.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.value.road3)+" ")]):_vm._e(),(_vm.value.postal_code || _vm.value.town)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.value.postal_code)+" "+_vm._s(_vm.value.town)+" ")]):_vm._e(),(_vm.value.country)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.value.country.name)+" ")]):_vm._e()]),(_vm.value.team_user)?_c('b-form-group',{attrs:{"label":"Commercial"}},[_vm._v(" "+_vm._s(_vm.value.team_user.fullname)+" ")]):_vm._e(),(_vm.value.sepa)?_c('b-form-group',{attrs:{"label":"Mandat SEPA"}},[_vm._v(" "+_vm._s(_vm.value.sepa.name ? _vm.value.sepa.name : _vm.value.sepa.owner)+" ")]):_vm._e(),(_vm.value.quotation)?_c('b-badge',{staticClass:"mr-2 mb-2 badge-md",attrs:{"variant":"light","to":{ name: 'quotation-item', params: { id: _vm.value.quotation.id } }}},[_vm._v(" Devis n°"+_vm._s(_vm.value.quotation?.reference)+" ")]):_vm._e(),(_vm.value.custom_fields.length > 0 && !_vm.team.configs['custom_field_contract_tab'])?_c('CustomFieldsDisplay',{staticClass:"mb-5",attrs:{"type":"contract","value":_vm.value.custom_fields,"titleClass":"form-title-alt","filter":_vm.value.model && _vm.value.model.restrict_custom_fields ? _vm.value.model.custom_fields : null}}):_vm._e()],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"8","xl":"9"}},[_c('div',{staticClass:"table-responsive-lg mt-4 mt-lg-0"},[_c('table',{staticClass:"table table-sm table-bordered mt-1 table-document-content text-nowrap"},[_c('thead',{staticClass:"thead-dark small text-center"},[_c('tr',[_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Référence")]),_c('th',[_vm._v("Désignation")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Prix U. HT")]),_c('th',{staticStyle:{"width":"90px"}},[_vm._v("Taux TVA")]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Quantité")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Total HT")])])]),_c('tbody',[(_vm.value.contents.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"6"}},[_vm._v(" Aucun contenu ")])]):_vm._e(),_vm._l((_vm.value.contents),function(content,i){return _c('tr',{key:i},[(!content.is_comment)?_c('td',[_vm._v(" "+_vm._s(content.catalog?.element?.reference)+" ")]):_vm._e(),_c('td',{staticClass:"text-wrap",attrs:{"colspan":content.is_comment ? 6 : 1}},[_c('FroalaView',{attrs:{"value":_vm.computedDesignation(content.designation)}})],1),(!content.is_comment)?_c('td',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.formattedNumber(content.unit_price_ht))+" ")]):_vm._e(),(!content.is_comment)?_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(content.vat_rate ? content.vat_rate.rate : 0)+" % ")]):_vm._e(),(!content.is_comment)?_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.showNumber(content.quantity))+" ")]):_vm._e(),(!content.is_comment)?_c('td',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.formattedNumber(content.total_ht))+" ")]):_vm._e()])})],2)])]),_c('b-row',[_c('b-col'),_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered table-document-content align-middle",staticStyle:{"min-width":"300px"}},[_c('tbody',[(_vm.value.discount_value > 0)?_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(" Remise générale "+_vm._s(_vm.value.discount_type === 'pourcent' ? _vm.showNumber(_vm.value.discount_value) + '%' : '')+" : ")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.discount_ht))+" ")])]):_vm._e(),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total HT :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.value.discounted_total_ht)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total TVA :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.value.discounted_total_tva)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total TTC :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.value.discounted_total_ttc)))])])])])])],1),_c('b-tabs',{staticClass:"tabs-card",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Échéances "),_c('b-badge',{staticClass:"ml-2",attrs:{"pill":"","variant":_vm.activeTab === 0 ? 'primary' : 'secondary'}},[_vm._v(" "+_vm._s(_vm.value.deadlines_nb)+" ")])]},proxy:true}])},[(_vm.value.create_invoice === true || (_vm.value.create_invoice === null && _vm.value.model && _vm.value.model.create_invoice === true))?_c('div',{staticClass:"text-danger font-weight-bold mb-3"},[(_vm.value.auto_send_invoice === true || (_vm.value.auto_send_invoice === null && _vm.value.model && _vm.value.model.auto_send_invoice === true))?[(_vm.value.customer.email !== null || (_vm.value.contact?.email !== null && _vm.value.contact?.email !== undefined))?[_vm._v(" La facturation automatique et l'envoi par email est activé sur ce contrat. ")]:[_c('b-alert',{staticClass:"font-weight-normal",attrs:{"show":"","variant":"danger"}},[_vm._v(" La facturation automatique est activée sur ce contrat mais celle-ci ne pourra pas être envoyée automatiquement par email car, ni le client, ni le contact n'ont d'adresse email de renseigner. ")])]]:[_vm._v(" La facturation automatique est activée sur ce contrat. ")]],2):_vm._e(),_c('ContractDeadlines',{attrs:{"contract":_vm.value}})],1),(_vm.value.custom_fields.length > 0 && _vm.team.configs['custom_field_contract_tab'])?_c('CustomFieldsDisplayTab',{attrs:{"type":"contract","value":_vm.value.custom_fields,"formUrl":'/sales/contract/' + _vm.value.id,"canUpdate":_vm.can('sales-contracts', 3),"filter":_vm.value.model && _vm.value.model.restrict_custom_fields ? _vm.value.model.custom_fields : null},on:{"input":contract => _vm.$emit('input', contract)}}):_vm._e(),_c('b-tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Éléments "),_c('b-badge',{staticClass:"ml-2",attrs:{"pill":"","variant":_vm.activeTab === 1 ? 'primary' : 'secondary'}},[_vm._v(" "+_vm._s(_vm.value.elements_nb)+" ")])]},proxy:true}])},[_c('AgregateDatas',_vm._b({},'AgregateDatas',_vm.agregateProperties,false))],1),_c('b-tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Périodes "),_c('b-badge',{staticClass:"ml-2",attrs:{"pill":"","variant":_vm.activeTab === 2 ? 'primary' : 'secondary'}},[_vm._v(" "+_vm._s(_vm.value.periods_nb)+" ")]),(_vm.can('sales-contracts', 3))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer une période"},on:{"click":function($event){$event.preventDefault();_vm.periodFormModal = true}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}])},[_c('ContractPeriods',{attrs:{"value":_vm.value},on:{"input":_vm.emitContract}})],1),(_vm.value.model && _vm.value.model.documents.length > 0)?_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Documents "),_c('b-badge',{staticClass:"ml-2",attrs:{"pill":"","variant":_vm.activeTab === 3 ? 'primary' : 'secondary'}},[_vm._v(" "+_vm._s(_vm.value.documents.length)+" / "+_vm._s(_vm.value.model.documents.length)+" ")])]},proxy:true}],null,false,1380437114)},[_c('ContractDocuments',{attrs:{"value":_vm.value},on:{"input":_vm.emitContract}})],1):_vm._e()],1)],1)],1),_c('ContractPeriodForm',{attrs:{"contract":_vm.value,"modal":_vm.periodFormModal},on:{"hidden":function($event){_vm.periodFormModal = false}}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(95093);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "@kwixeo/communication-vue"
var communication_vue_ = __webpack_require__(43055);
// EXTERNAL MODULE: external "@kwixeo/calendars-vue"
var calendars_vue_ = __webpack_require__(59792);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(44696);
// EXTERNAL MODULE: ./src/components/ContractDeadlines/ContractDeadlines.vue + 3 modules
var ContractDeadlines = __webpack_require__(15374);
// EXTERNAL MODULE: ./src/components/ContractStatus/ContractStatus.vue + 3 modules
var ContractStatus = __webpack_require__(30469);
// EXTERNAL MODULE: ./src/components/ContractStatusSelector/ContractStatusSelector.vue + 3 modules
var ContractStatusSelector = __webpack_require__(90613);
// EXTERNAL MODULE: ./src/components/ContractDelete/ContractDelete.vue + 3 modules
var ContractDelete = __webpack_require__(57553);
// EXTERNAL MODULE: ./src/components/ContractDocuments/ContractDocuments.vue + 3 modules
var ContractDocuments = __webpack_require__(81038);
// EXTERNAL MODULE: ./src/components/ContractPeriods/ContractPeriods.vue + 3 modules
var ContractPeriods = __webpack_require__(62288);
// EXTERNAL MODULE: ./src/components/ContractPeriodForm/ContractPeriodForm.vue + 3 modules
var ContractPeriodForm = __webpack_require__(70128);
// EXTERNAL MODULE: ./src/components/ContractDownload/ContractDownload.vue + 3 modules
var ContractDownload = __webpack_require__(16951);
// EXTERNAL MODULE: ./src/components/SignSend/SignSend.vue + 4 modules
var SignSend = __webpack_require__(30210);
// EXTERNAL MODULE: ./src/components/SignState/SignState.vue + 3 modules
var SignState = __webpack_require__(66346);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractItem/ContractItem.ts?vue&type=script&lang=ts&external






















var ContractItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractItem, _super);
    function ContractItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.activeTab = 0;
        _this.periodFormModal = false;
        _this.signed = false;
        _this.waitingSign = false;
        return _this;
    }
    ContractItem.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        interface_vue_.emitter.on('contractGenerated', this.contractGenerated);
                        this.loading = true;
                        return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractItem.prototype.destroyed = function () {
        interface_vue_.emitter.off('contractGenerated', this.contractGenerated);
    };
    Object.defineProperty(ContractItem.prototype, "contractStatusBar", {
        get: function () {
            return [
                { value: 1, label: 'Brouillon' },
                { value: 2, label: 'En attente' },
                { value: 3, label: 'En cours' },
                { value: 4, label: 'Terminé' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractItem.prototype, "pageTitle", {
        get: function () {
            return 'Contrat n°' + this.value.reference;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractItem.prototype, "buttons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('sales-contracts', 3)) {
                buttons.push({
                    label: 'Modifier',
                    to: { name: 'contract-form', params: { id: String(this.value.id) } }
                });
            }
            buttons.push({
                component: ContractDownload/* default */.A,
                attributes: {
                    value: this.value,
                    disabled: this.value.document_status !== 2
                },
                events: {
                    input: this.emitContract
                }
            });
            if (this.hasModule('task') && this.can('task', 1)) {
                buttons.push({
                    label: 'Tâche',
                    click: function () {
                        _this.openModal({
                            key: 'task-form',
                            value: {
                                elements: _this.linkedElements(true)
                            }
                        });
                    }
                });
            }
            var relations = [];
            if (!this.signed && !this.waitingSign && this.can('sales-contracts', 2) && this.can('sales-signatures', 1)) {
                relations.push({
                    component: SignSend/* default */.A,
                    attributes: {
                        element: 'dropdown',
                        size: 'sm',
                        value: {
                            documents: this.contractSignDocuments
                        }
                    },
                    events: {
                        input: this.emitContract,
                        sended: this.markAsSent
                    }
                });
            }
            if (this.can('send-mail', 1)) {
                relations.push(this.sendMailAction('dropdown'));
            }
            if (this.hasModule('communication-reports') && this.can('communication-reports', 1)) {
                relations.push({
                    component: communication_vue_.ReportFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Compte-rendu',
                        customer: this.value.customer,
                        contact: this.value.contact,
                        linkedElements: this.linkedElements()
                    }
                });
            }
            if (this.hasModule('communication-letters') && this.can('communication-letters', 1)) {
                relations.push({
                    component: communication_vue_.LetterFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Lettre',
                        customer: this.value.customer,
                        contact: this.value.contact,
                        linkedElements: this.linkedElements()
                    }
                });
            }
            if (this.hasModule('calendar') && this.can('calendar', 1)) {
                relations.push({
                    component: calendars_vue_.CalendarButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Rendez-vous',
                        linkedElements: this.linkedElements(true)
                    }
                });
            }
            if (relations.length > 1) {
                buttons.push.apply(buttons, [
                    {
                        label: 'Relation',
                        items: relations
                    }
                ]);
            }
            else if (this.can('send-mail', 1)) {
                buttons.push(this.sendMailAction('button'));
            }
            buttons.push({
                label: 'Autres',
                items: this.otherActions
            });
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    ContractItem.prototype.markAsSent = function (signature) {
        var contract = JSON.parse(JSON.stringify(this.value));
        contract.status = 2;
        if (!contract.signatures) {
            contract.signatures = [];
        }
        contract.signatures.push(signature);
        this.emitContract(contract);
    };
    Object.defineProperty(ContractItem.prototype, "otherActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('sales-contracts', 3)) {
                actions.push.apply(actions, [
                    {
                        label: 'Créer une période',
                        click: function () { return _this.periodFormModal = true; }
                    },
                    {
                        component: ContractStatusSelector/* default */.A,
                        attributes: {
                            contract: this.value,
                            element: 'dropdown'
                        },
                        events: {
                            input: this.emitContract
                        }
                    }
                ]);
                if (this.value.document_status === 2) {
                    actions.push({
                        component: ContractDownload/* default */.A,
                        attributes: {
                            value: this.value,
                            label: 'Regénérer le contrat',
                            element: 'dropdown',
                            force: true
                        },
                        events: {
                            input: this.emitContract
                        }
                    });
                }
                actions.push({
                    isSeparator: true
                });
            }
            if (this.can('sales-contracts', 2)) {
                actions.push({
                    label: 'Cloner',
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.setPageParams(this.value);
                                    return [4 /*yield*/, this.$router.push({ name: 'contract-form' })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (this.can('sales-contracts', 4)) {
                actions.push({
                    component: ContractDelete/* default */.A,
                    attributes: {
                        value: this.value,
                        element: 'dropdown'
                    },
                    events: {
                        deleted: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.$router.push({ name: 'contract-list' })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractItem.prototype, "agregateProperties", {
        get: function () {
            return {
                type: 'contract',
                id: this.value.id,
                model: this.value,
                customer: this.value.customer,
                contact: this.value.contact,
                modelTitle: this.modelTitle,
                url: '/sales/contract/' + this.value.id + '/aggregate-datas'
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractItem.prototype, "modelTitle", {
        get: function () {
            return this.value.reference;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractItem.prototype, "sendMailAction", {
        get: function () {
            var _this = this;
            return function (btnType) {
                var attachments = [];
                if (_this.value.pdf) {
                    attachments.push(_this.value.pdf);
                }
                var to = [];
                var billingContact = _this.value.billing_contact;
                if (billingContact && billingContact.email) {
                    to.push({
                        id: billingContact.id,
                        type: 'contact',
                        mail: billingContact.email,
                        name: billingContact.fullname,
                        element: {
                            id: billingContact.id,
                            type: 'contact'
                        },
                        data: billingContact
                    });
                }
                return {
                    component: communication_vue_.SendEmailButton,
                    attributes: {
                        linkedElements: _this.linkedElements(),
                        attachments: attachments,
                        to: to,
                        element: btnType,
                        customer: _this.value.customer,
                        contact: _this.value.contact
                    }
                };
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractItem.prototype, "linkedElements", {
        get: function () {
            var _this = this;
            return function (withCustomer) {
                if (withCustomer === void 0) { withCustomer = false; }
                var elements = [{
                        type: 'contract',
                        id: _this.value.id,
                        title: _this.modelTitle,
                        data: _this.value
                    }];
                var customer = _this.value.customer;
                if (withCustomer && customer) {
                    elements.push({
                        type: 'customer',
                        id: customer.id,
                        title: customer.name,
                        data: customer
                    });
                    var contact = _this.value.contact;
                    if (contact) {
                        elements.push({
                            type: 'contact',
                            id: contact.id,
                            title: contact.fullname,
                            data: contact
                        });
                    }
                }
                return elements;
            };
        },
        enumerable: false,
        configurable: true
    });
    ContractItem.prototype.emitContract = function (contract) {
        this.$emit('input', contract);
    };
    Object.defineProperty(ContractItem.prototype, "computedDesignation", {
        get: function () {
            var _this = this;
            return function (designation) {
                var _a;
                if (designation === undefined || designation === null) {
                    return designation;
                }
                var value = designation;
                (_a = designation.match(/<variable(.*?)<\/variable>/gs)) === null || _a === void 0 ? void 0 : _a.forEach(function (variable) {
                    // Get variable identifier
                    var findIdent = variable.match(/data-variable="(.*?)"/s);
                    if (!findIdent) {
                        return;
                    }
                    var ident = findIdent[1];
                    var findConditionnal = variable.match(/data-conditional-show="(.*?)"/s);
                    var conditionnal = findConditionnal ? findConditionnal[1] === 'true' : false;
                    var previewValue = _this.previewValues[ident];
                    if ((previewValue === undefined || previewValue === null || previewValue === '') && conditionnal) {
                        value = value.replace(variable, '');
                        return;
                    }
                    var replace = '';
                    var findSpaceBeforePrefix = variable.match(/data-prefix-space-before="(.*?)"/s);
                    var spaceBeforePrefix = findSpaceBeforePrefix ? findSpaceBeforePrefix[1] === 'true' : false;
                    if (spaceBeforePrefix) {
                        replace += '<br>';
                    }
                    var findPrefix = variable.match(/data-prefix="(.*?)"/s);
                    if (findPrefix) {
                        replace += findPrefix[1];
                    }
                    var findSpaceAfterPrefix = variable.match(/data-prefix-space-after="(.*?)"/s);
                    var spaceAfterPrefix = findSpaceAfterPrefix ? findSpaceAfterPrefix[1] === 'true' : false;
                    if (spaceAfterPrefix) {
                        replace += '<br>';
                    }
                    replace += previewValue;
                    var findSpaceBeforeSuffix = variable.match(/data-suffix-space-before="(.*?)"/s);
                    var spaceBeforeSuffix = findSpaceBeforeSuffix ? findSpaceBeforeSuffix[1] === 'true' : false;
                    if (spaceBeforeSuffix) {
                        replace += '<br>';
                    }
                    var findSuffix = variable.match(/data-suffix="(.*?)"/s);
                    if (findSuffix) {
                        replace += findSuffix[1];
                    }
                    var findSpaceAfterSuffix = variable.match(/data-suffix-space-after="(.*?)"/s);
                    var spaceAfterSuffix = findSpaceAfterSuffix ? findSpaceAfterSuffix[1] === 'true' : false;
                    if (spaceAfterSuffix) {
                        replace += '<br>';
                    }
                    value = value.replace(variable, replace);
                });
                return value;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractItem.prototype, "previewValues", {
        get: function () {
            var _this = this;
            var _a;
            var values = {
                'CONTRACT-NUM': this.value.reference,
                'CONTRACT-TITLE': (_a = this.value.title) !== null && _a !== void 0 ? _a : '',
                'CONTRACT-BEGIN': '[DEBUT-ECHEANCE]',
                'CONTRACT-END': '[FIN-ECHEANCE]'
            };
            this.getCustomFields('contract').forEach(function (field) {
                var _a, _b, _c, _d, _e;
                var fieldValue = (_a = _this.value.custom_fields) === null || _a === void 0 ? void 0 : _a.find(function (value) { return value.id === field.id; });
                var value = null;
                if (fieldValue) {
                    switch (field.type) {
                        case 'amount':
                            value = _this.formattedNumber(fieldValue.value);
                            break;
                        case 'number':
                            value = _this.formattedNumber(fieldValue.value, false);
                            break;
                        case 'quantity':
                            value = _this.formattedNumber(fieldValue.value);
                            break;
                        case 'date':
                            value = _this.date(moment_default()(fieldValue.value).format('YYYY-MM-DD'));
                            break;
                        case 'phone':
                            value = _this.showPhone(fieldValue.value);
                            break;
                        case 'select':
                        case 'radio':
                            value = (_b = fieldValue.value) === null || _b === void 0 ? void 0 : _b.label;
                            break;
                        case 'commercial':
                        case 'user':
                        case 'contact':
                            value = (_c = fieldValue.value) === null || _c === void 0 ? void 0 : _c.fullname;
                            break;
                        case 'customer':
                        case 'product':
                        case 'service':
                            value = (_d = fieldValue.value) === null || _d === void 0 ? void 0 : _d.name;
                            break;
                        case 'checkbox':
                            value = (_e = fieldValue.value) === null || _e === void 0 ? void 0 : _e.map(function (val) { return val.label; }).join(', ');
                            break;
                        default:
                            value = fieldValue.value;
                    }
                }
                values['CUSTOM-FIELD-' + field.id] = value;
            });
            return values;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractItem.prototype, "contractSignDocuments", {
        get: function () {
            var _a, _b;
            var documents = [
                {
                    document_type: 'contract',
                    document_id: this.value.id,
                    document: this.value,
                    file: this.value.pdf,
                    signable_document: (_b = (_a = this.value.model) === null || _a === void 0 ? void 0 : _a.can_be_signed) !== null && _b !== void 0 ? _b : false
                }
            ];
            if (this.teamConfigs.sign_contract_add_sepa && this.value.sepa) {
                documents.push({
                    document_type: 'customerSepa',
                    document_id: this.value.sepa.id,
                    document: this.value.sepa,
                    file: this.value.sepa.pdf,
                    signable_document: true
                });
            }
            if (this.teamConfigs.sign_contract_add_quotation && this.value.quotation) {
                documents.push({
                    document_type: 'quotation',
                    document_id: this.value.quotation.id,
                    document: this.value.quotation,
                    file: this.value.quotation.pdf,
                    signable_document: true
                });
            }
            return documents;
        },
        enumerable: false,
        configurable: true
    });
    ContractItem.prototype.contractGenerated = function (datas) {
        if (datas.id !== this.value.id) {
            return;
        }
        var contract = this.value;
        contract.document_status = datas.status;
        contract.pdf = datas.pdf;
        this.emitContract(contract);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractItem.prototype, "value", void 0);
    ContractItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('app', ['setPageParams'])), (0,external_vuex_.mapActions)('customFields', ['loadCustomFields'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'team', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('customFields', ['getCustomFields'])), (0,external_vuex_.mapState)('app', ['app'])),
            components: {
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BBadge: external_bootstrap_vue_.BBadge,
                FroalaView: form_vue_.FroalaView,
                PageHeader: interface_vue_.PageHeader, Spinner: interface_vue_.Spinner, AppMessages: interface_vue_.AppMessages,
                CustomerSpeedItem: customers_vue_.CustomerSpeedItem, ContactSpeedItem: customers_vue_.ContactSpeedItem,
                AgregateDatas: communication_vue_.AgregateDatas,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                ContractDeadlines: ContractDeadlines/* default */.A,
                ContractStatus: ContractStatus/* default */.A,
                ContractDocuments: ContractDocuments/* default */.A,
                ContractPeriods: ContractPeriods/* default */.A,
                ContractPeriodForm: ContractPeriodForm/* default */.A,
                ContractDownload: ContractDownload/* default */.A,
                SignSend: SignSend/* default */.A,
                SignState: SignState/* default */.A,
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay, CustomFieldsDisplayTab: custom_fields_vue_.CustomFieldsDisplayTab
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ContractItem);
    return ContractItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin, interface_vue_.PhoneMixin)));
/* harmony default export */ var ContractItemvue_type_script_lang_ts_external = (ContractItem);

;// ./src/components/ContractItem/ContractItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractItem_ContractItemvue_type_script_lang_ts_external = (ContractItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractItem/ContractItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractItem_ContractItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractItem_ContractItem = (component.exports);

/***/ }),

/***/ 53489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CommissionDocumentView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommissionDocumentView.vue?vue&type=template&id=6c2af3e1
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CommissionDocumentList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CommissionDocumentList/CommissionDocumentList.vue + 3 modules
var CommissionDocumentList = __webpack_require__(70032);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommissionDocumentView.vue?vue&type=script&lang=ts



var CommissionDocumentView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionDocumentView, _super);
    function CommissionDocumentView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommissionDocumentView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommissionDocumentList: CommissionDocumentList/* default */.A
            }
        })
    ], CommissionDocumentView);
    return CommissionDocumentView;
}(lib/* Vue */.lD));
/* harmony default export */ var CommissionDocumentViewvue_type_script_lang_ts = (CommissionDocumentView);

;// ./src/views/CommissionDocumentView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CommissionDocumentViewvue_type_script_lang_ts = (CommissionDocumentViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/CommissionDocumentView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CommissionDocumentViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CommissionDocumentView = (component.exports);

/***/ }),

/***/ 53661:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(63040),
    mapCacheDelete = __webpack_require__(17670),
    mapCacheGet = __webpack_require__(90289),
    mapCacheHas = __webpack_require__(4509),
    mapCacheSet = __webpack_require__(72949);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ 53991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommandList_CommandList; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesListMixin/SalesListMixin.vue + 3 modules
var SalesListMixin = __webpack_require__(68067);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatus.ts
var SalesDocumentStatus = __webpack_require__(70468);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandList/CommandList.ts?vue&type=script&lang=ts&external




var CommandList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandList, _super);
    function CommandList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'command';
        _this.additionalColumns = [
            {
                data: 'delivery_status_label',
                name: 'Statut de livraison',
                visible: false
            },
            {
                data: 'already_billed',
                name: 'Déjà facturé',
                visible: false,
                render: 'currency'
            },
            {
                data: 'pourcent_billed',
                name: '% facturé',
                visible: false,
                render: 'pourcent'
            },
            {
                data: 'to_bill',
                name: 'À facturer',
                visible: false,
                render: 'currency'
            },
            {
                data: 'pourcent_to_bill',
                name: '% à facturer',
                visible: false,
                render: 'pourcent'
            },
            {
                data: 'accepted_at',
                name: 'Date acceptation',
                visible: false,
                render: 'datetime'
            },
            {
                data: 'refused_at',
                name: 'Date refus',
                visible: false,
                render: 'datetime'
            }
        ];
        return _this;
    }
    Object.defineProperty(CommandList.prototype, "status", {
        get: function () {
            return this.commandStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandList.prototype, "statusIndicator", {
        get: function () {
            return [
                { class: 'status-quotation-1', label: 'Brouillon' },
                { class: 'status-quotation-2', label: 'Validé' },
                { class: 'status-quotation-3', label: 'Envoyé' },
                { class: 'status-quotation-4', label: 'Accepté' },
                { class: 'status-quotation-7', label: 'Facturé' },
                { class: 'status-quotation-8', label: 'Annulé' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandList.prototype, "computedFilters", {
        get: function () {
            var filters = this.filters;
            filters.push({
                type: 'select',
                label: 'Statut de livraison',
                name: 'delivery_status',
                options: [
                    { id: 1, label: 'À livrer' },
                    { id: 2, label: 'Livré partiellement' },
                    { id: 3, label: 'Livré' }
                ],
                multiple: true,
                optionLabel: 'label',
                value: 'id'
            });
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    CommandList.prototype.canBeEdited = function (command) {
        var _a;
        return command.total_ttc == 0 || ((_a = command.to_bill) !== null && _a !== void 0 ? _a : 0) > 0;
    };
    CommandList = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], CommandList);
    return CommandList;
}((0,lib/* Mixins */.Xe)(SalesListMixin/* default */.A, SalesDocumentStatus/* default */.A)));
/* harmony default export */ var CommandListvue_type_script_lang_ts_external = (CommandList);

;// ./src/components/CommandList/CommandList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandList_CommandListvue_type_script_lang_ts_external = (CommandListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommandList/CommandList.vue
var render, staticRenderFns
;



/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommandList_CommandListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandList_CommandList = (component.exports);

/***/ }),

/***/ 54128:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(31800);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 54352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_AffairListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AffairListView.vue?vue&type=template&id=7995a348
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AffairListView.vue?vue&type=script&lang=ts


var AffairListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AffairListView, _super);
    function AffairListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AffairListView = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], AffairListView);
    return AffairListView;
}(lib/* Vue */.lD));
/* harmony default export */ var AffairListViewvue_type_script_lang_ts = (AffairListView);

;// ./src/views/AffairListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_AffairListViewvue_type_script_lang_ts = (AffairListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/AffairListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_AffairListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_AffairListView = (component.exports);

/***/ }),

/***/ 54362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleExports_SaleExports; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleExports/SaleExports.vue?vue&type=template&id=d91b0fd4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('kwTable.exports.title'),"ok-title":_vm.errorMessage !== null || _vm.dataExport !== null ? 'Fermer' : 'Exporter',"cancel-title":_vm.$t('kwTable.exports.cancel'),"ok-only":_vm.errorMessage !== null || _vm.dataExport !== null,"hide-header-close":_vm.exportLoading,"no-close-on-backdrop":_vm.exportLoading,"no-close-on-esc":_vm.exportLoading,"busy":_vm.exportLoading,"content-class":"kwtable-datas-export"},on:{"ok":_vm.exportDatas,"show":_vm.onExportModalOpen,"hidden":_vm.modalHide},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.errorMessage !== null)?_c('div',{staticClass:"text-center font-weight-bold"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):(_vm.dataExport !== null)?_c('div',[(_vm.dataExport.advancement === 100 && _vm.dataExport.status === 'completed')?_c('div',{staticClass:"text-center"},[_c('b-overlay',{attrs:{"show":_vm.downloading}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.downloadExport(_vm.dataExport.id)}}},[_vm._v(" "+_vm._s(_vm.$t('kwTable.exports.download'))+" ")])],1)],1):_c('div',[_c('p',{staticClass:"text-center m-0"},[_vm._v(" "+_vm._s(_vm.$t('kwTable.exports.inProgress'))+" ")]),_c('b-progress',{staticClass:"mt-2 mb-3",attrs:{"value":_vm.dataExport.nb_processed,"max":_vm.dataExport.nb_items,"show-progress":"","animated":""}}),_c('p',{staticClass:"text-center m-0"},[_vm._v(" "+_vm._s(_vm.$t('kwTable.exports.progressExplain'))+" ")])],1)]):_c('b-overlay',{attrs:{"show":_vm.exportLoading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.exports.typeLabel')}},[_c('b-form-radio-group',{attrs:{"options":_vm.exportTypes},model:{value:(_vm.exportType),callback:function ($$v) {_vm.exportType=$$v},expression:"exportType"}})],1),(_vm.exportType === 'datas')?_c('b-form-group',{attrs:{"label":_vm.$t('kwTable.exports.formatTitle')}},[_c('b-form-radio-group',{attrs:{"options":_vm.exportFormats},model:{value:(_vm.exportFormat),callback:function ($$v) {_vm.exportFormat=$$v},expression:"exportFormat"}})],1):_vm._e(),(_vm.noFilters === false)?_c('b-form-group',{attrs:{"label":_vm.$t('kwTable.exports.contentTitle')}},[_c('b-form-radio-group',{attrs:{"options":[
            { text: _vm.$t('kwTable.exports.withFilters'), value: true },
            { text: _vm.$t('kwTable.exports.withoutFilters'), value: false }
          ]},model:{value:(_vm.exportWithFilters),callback:function ($$v) {_vm.exportWithFilters=$$v},expression:"exportWithFilters"}})],1):_vm._e(),(_vm.allColumns === false && _vm.exportType === 'datas')?_c('div',[_c('b-form-group',{attrs:{"label":_vm.$t('kwTable.exports.columnsTitle')}},[_c('b-form-radio-group',{attrs:{"options":[
            { text: _vm.$t('kwTable.exports.allColumns'), value: 1 },
            { text: _vm.$t('kwTable.exports.customColumns'), value: 0 },
            { text: _vm.$t('sales.exports.contentDatas'), value: 3 },
            { text: _vm.$t('sales.exports.allDatas'), value: 2 }
          ]},model:{value:(_vm.exportAllColumns),callback:function ($$v) {_vm.exportAllColumns=$$v},expression:"exportAllColumns"}})],1),(!_vm.exportAllColumns)?_c('b-form-group',{attrs:{"label":_vm.$t('kwTable.exports.columnsSelectTitle')}},[_c('k-form-checkbox-group',{staticClass:"columns-selector form-row",attrs:{"validate":{ minChecked: 1}},model:{value:(_vm.exportColumns),callback:function ($$v) {_vm.exportColumns=$$v},expression:"exportColumns"}},_vm._l((_vm.columns),function(column,i){return _c('k-form-checkbox',{key:i,attrs:{"value":column.dataName ? column.dataName : column.data}},[_vm._v(" "+_vm._s(column.name)+" ")])}),1)],1):_vm._e()],1):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(55364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleExports/SaleExports.ts?vue&type=script&lang=ts&external







var SaleExports = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleExports, _super);
    function SaleExports() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.exportTypes = [
            { text: _this.$t('sales.exports.typeDatas'), value: 'datas' },
            { text: _this.$t('sales.exports.typePdf'), value: 'pdf' }
        ];
        _this.exportFormats = [
            { text: 'Excel (xlsx)', value: 'xlsx' },
            { text: 'Excel (xls)', value: 'xls' },
            { text: 'CSV', value: 'csv' }
        ];
        // State for modal
        _this.modalState = false;
        // Export type
        _this.exportType = 'datas';
        // Export format
        _this.exportFormat = 'xlsx';
        // Exports with active table filters
        _this.exportWithFilters = true;
        // If all or some specified columns must be exported
        _this.exportAllColumns = 1;
        // Columns to export
        _this.exportColumns = [];
        // Loader when datas export is send to server
        _this.exportLoading = false;
        // Export id
        _this.dataExport = null;
        // Interval id
        _this.exportRefresh = null;
        // Error message
        _this.errorMessage = null;
        return _this;
    }
    SaleExports.prototype.watchModalState = function (state) {
        this.modalState = state;
    };
    SaleExports.prototype.watchExportModalState = function (state) {
        this.$emit('input', state);
    };
    // On modal openning
    SaleExports.prototype.onExportModalOpen = function () {
        var columns = this.columns;
        if (!columns) {
            return;
        }
        this.exportColumns = columns
            .filter(function (column) { return column.visible !== false; })
            .map(function (column) { return column.data; });
    };
    // Process to export
    SaleExports.prototype.exportDatas = function (bvModalEvt) {
        var _this = this;
        if (this.errorMessage !== null || this.dataExport !== null) {
            return;
        }
        bvModalEvt.preventDefault();
        this.exportLoading = true;
        var model = this.model;
        if (this.exportAllColumns === 2) {
            model += '-full';
        }
        else if (this.exportAllColumns === 3) {
            model += '-contents';
        }
        var datas = {
            model: model,
            format: this.exportFormat
        };
        if (this.parentId) {
            datas.parent_id = this.parentId;
        }
        if (this.ajaxDatas) {
            datas = merge_default()({}, datas, this.ajaxDatas);
        }
        if (this.noFilters === false && this.exportWithFilters) {
            datas = merge_default()({}, datas, { filter: this.filters });
        }
        if (this.search && this.exportWithFilters) {
            var search = this.search.split('+')
                .filter(function (term) { return term !== null && term !== '' && term !== undefined; })
                .map(function (term) { return '%' + term + '%'; })
                .join(',');
            datas = merge_default()({}, datas, { search: search });
        }
        if (this.allColumns === false && this.exportAllColumns === 0) {
            datas.columns = this.exportColumns;
        }
        else if (this.onlyTableColumns !== false && this.columns) {
            datas.columns = this.columns.map(function (column) { var _a; return (_a = column.sortableName) !== null && _a !== void 0 ? _a : column.data; });
        }
        this.$kwSales.axios.post(this.exportUrl, datas, {
            headers: this.headers,
            responseType: 'json'
        })
            .then(function (response) {
            _this.dataExport = response.data;
            _this.exportRefresh = setInterval(_this.getExportStatus, 3000);
        })
            .catch(function (error) {
            if (error.response && error.response.status === 404) {
                _this.errorMessage = error.response.data.message;
            }
            else {
                throw new Error(error);
            }
        })
            .finally(function () {
            _this.exportLoading = false;
        });
    };
    Object.defineProperty(SaleExports.prototype, "exportUrl", {
        get: function () {
            var _a;
            if (this.exportType === 'pdf') {
                return '/sales/pdf-exports';
            }
            return (_a = this.$kwTable.exportUrl) !== null && _a !== void 0 ? _a : '/exports';
        },
        enumerable: false,
        configurable: true
    });
    SaleExports.prototype.getExportStatus = function () {
        var _this = this;
        var dataExport = this.dataExport;
        if (!dataExport || dataExport.status === 'completed') {
            return;
        }
        this.$kwSales.axios.get(this.exportUrl + '/' + dataExport.id, {
            headers: this.headers,
            responseType: 'json'
        })
            .then(function (response) {
            var dataExport = response.data;
            _this.dataExport = dataExport;
            if (dataExport.status === 'completed') {
                _this.clearInterval();
            }
        })
            .catch(function (error) {
            _this.errorMessage = error.response.data.message;
            _this.clearInterval();
            throw new Error(error);
        });
    };
    SaleExports.prototype.modalHide = function () {
        this.errorMessage = null;
        this.dataExport = null;
        this.clearInterval();
    };
    SaleExports.prototype.clearInterval = function () {
        if (this.exportRefresh) {
            clearInterval(this.exportRefresh);
            this.exportRefresh = null;
        }
    };
    SaleExports.prototype.downloadExport = function (id) {
        if (this.exportType === 'pdf') {
            this.downloadPdf(id);
        }
        else {
            this.download(id);
        }
    };
    SaleExports.prototype.fetchPdfFile = function (id) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                this.downloading = true;
                return [2 /*return*/, (_a = this.$kwSales.axios) === null || _a === void 0 ? void 0 : _a.get('/sales/pdf-exports/' + id + '/download', { responseType: 'blob' }).then(function (response) {
                        return response;
                    }).finally(function () {
                        _this.downloading = false;
                    })];
            });
        });
    };
    SaleExports.prototype.downloadPdf = function (id) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response, filename;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.fetchPdfFile(id)];
                    case 1:
                        response = _b.sent();
                        if (!response) {
                            return [2 /*return*/];
                        }
                        filename = (_a = response.headers['x-suggested-filename']) !== null && _a !== void 0 ? _a : 'export-pdf.zip';
                        this.downloadFile(response.data, filename, false);
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: false })
    ], SaleExports.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SaleExports.prototype, "model", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SaleExports.prototype, "parentId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SaleExports.prototype, "columns", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SaleExports.prototype, "search", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], SaleExports.prototype, "filters", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], SaleExports.prototype, "headers", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SaleExports.prototype, "ajaxDatas", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SaleExports.prototype, "allColumns", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SaleExports.prototype, "onlyTableColumns", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SaleExports.prototype, "noFilters", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], SaleExports.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], SaleExports.prototype, "watchExportModalState", null);
    SaleExports = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BProgress: external_bootstrap_vue_.BProgress, BButton: external_bootstrap_vue_.BButton, BOverlay: external_bootstrap_vue_.BOverlay, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup,
                KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormCheckbox: form_vue_.KFormCheckbox
            }
        })
    ], SaleExports);
    return SaleExports;
}((0,lib/* Mixins */.Xe)(table_vue_.DownloadExportFile, interface_vue_.FileMixin)));
/* harmony default export */ var SaleExportsvue_type_script_lang_ts_external = (SaleExports);

;// ./src/components/SaleExports/SaleExports.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleExports_SaleExportsvue_type_script_lang_ts_external = (SaleExportsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SaleExports/SaleExports.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleExports_SaleExportsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleExports_SaleExports = (component.exports);

/***/ }),

/***/ 54566:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ 54575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ mixins_SalesDocumentLineMixin; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/LineMenu/LineMenu.vue?vue&type=template&id=366fdae5
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-dropdown',{ref:"main",staticClass:"sales-line-dropdown-menu d-block",attrs:{"size":"sm","variant":"icon","toggle-class":"p-0","right":"","menu-class":"py-0"},on:{"hide":_vm.hideMain}},[_c('b-dropdown',{attrs:{"size":"sm","text":"Ajouter une ligne au dessus","dropleft":"","block":"","menu-class":"py-0"},on:{"show":_vm.showSub,"hide":_vm.hideSub}},[_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.showCatalog('top')}}},[_vm._v(" Catalogue produit ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('empty', 'top')}}},[_vm._v(" Ligne vide ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('comments', 'top')}}},[_vm._v(" Commentaires ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('pagebreak', 'top')}}},[_vm._v(" Saut de page ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('subtotal', 'top')}}},[_vm._v(" Sous-total ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('clone', 'top')}}},[_vm._v(" Cloner la ligne ")])],1),_c('b-dropdown',{attrs:{"size":"sm","text":"Ajouter une ligne en dessous","dropleft":"","block":"","menu-class":"py-0"},on:{"show":_vm.showSub,"hide":_vm.hideSub}},[_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.showCatalog('bottom')}}},[_vm._v(" Catalogue produit ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('empty', 'bottom')}}},[_vm._v(" Ligne vide ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('comments', 'bottom')}}},[_vm._v(" Commentaires ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('pagebreak', 'bottom')}}},[_vm._v(" Saut de page ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('subtotal', 'bottom')}}},[_vm._v(" Sous-total ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('clone', 'bottom')}}},[_vm._v(" Cloner la ligne ")])],1),(!_vm.line.is_comments && !_vm.line.is_subtotal && !_vm.line.is_pagebreak)?[_c('b-dropdown-divider'),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.createCatalog('product')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}),_vm._v(" Créer un produit ")],1),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.createCatalog('service')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}),_vm._v(" Créer une prestation ")],1)]:_vm._e(),_c('b-modal',{staticClass:"catalog-modal",attrs:{"content-class":"catalog-modal-content","size":"xxl","ok-only":"","ok-title":_vm.$t('interface.close'),"scrollable":""},model:{value:(_vm.showCatalogModal),callback:function ($$v) {_vm.showCatalogModal=$$v},expression:"showCatalogModal"}},[_c('CatalogList',{attrs:{"include":{
        product: ['unit', 'vat_rate', 'variation_levels', 'default_picture', 'custom_prices'],
        service: ['unit', 'vat_rate', 'default_picture', 'custom_prices'],
      }},on:{"selected":_vm.selectCatalog}})],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/catalog-vue"
var catalog_vue_ = __webpack_require__(68480);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/LineMenu/LineMenu.ts?vue&type=script&lang=ts&external






var LineMenu = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LineMenu, _super);
    function LineMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDropdownTopVisible = false;
        _this.isSubDropdownVisible = false;
        _this.showCatalogModal = false;
        _this.position = null;
        return _this;
    }
    LineMenu.prototype.productCreated = function (product) {
        this.$emit('setCatalog', {
            id: product.id,
            type: 'product',
            element: JSON.parse(JSON.stringify(product))
        });
    };
    LineMenu.prototype.serviceCreated = function (service) {
        this.$emit('setCatalog', {
            id: service.id,
            type: 'service',
            element: JSON.parse(JSON.stringify(service))
        });
    };
    LineMenu.prototype.hideMain = function (bvEvent) {
        if (this.isDropdownTopVisible) {
            bvEvent.preventDefault();
        }
    };
    LineMenu.prototype.hideSub = function (bvEvent) {
        if (this.isSubDropdownVisible) {
            bvEvent.preventDefault();
        }
    };
    LineMenu.prototype.showSub = function () {
        var _this = this;
        this.isDropdownTopVisible = true;
        this.$nextTick(function () {
            _this.isDropdownTopVisible = false;
        });
    };
    LineMenu.prototype.event = function (type, position, catalog) {
        var _this = this;
        //(this.$refs.main as BDropdown).hide()
        this.$emit('add', {
            type: type,
            position: position,
            catalog: catalog
        });
        this.isDropdownTopVisible = false;
        this.isSubDropdownVisible = true;
        this.$nextTick(function () {
            _this.isSubDropdownVisible = false;
        });
    };
    LineMenu.prototype.showCatalog = function (position) {
        this.showCatalogModal = true;
        this.position = position;
    };
    LineMenu.prototype.selectCatalog = function (entry) {
        this.event('catalog', this.position, entry);
    };
    LineMenu.prototype.createCatalog = function (type) {
        var _this = this;
        var line = this.line;
        var value = {
            reference: line.reference,
            designation: line.designation,
            default_quantity: line.quantity,
            unit_price_ht: line.unit_price_ht,
            vat_rate: line.vat_rate,
            various_costs: line.various_costs_u
        };
        switch (type) {
            case 'service':
                value = Object.assign(value, {
                    duration: line.duration,
                    duration_type: line.duration_type,
                    number_people_needed: line.number_people_needed,
                    hourly_person_cost: line.hourly_person_cost
                });
                break;
            case 'product':
                value = Object.assign(value, {
                    unit_weight: line.weight_unit,
                    ean_code: line.ean_code,
                    eco_tax_ht: line.ecotax_u_ht,
                    eco_tax_tva: line.ecotax_u_tva,
                    eco_tax_ttc: line.ecotax_u_ttc,
                    unit_buy_price_ht: line.catalog_costs_u,
                    various_costs: line.various_costs_u
                });
                break;
        }
        this.openModal({
            key: 'catalog-' + type + '-form',
            value: value,
            submitted: function (response) {
                switch (type) {
                    case 'service':
                        _this.serviceCreated(response.data);
                        break;
                    case 'product':
                        _this.productCreated(response.data);
                        break;
                }
            }
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LineMenu.prototype, "line", void 0);
    LineMenu = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            components: {
                BDropdown: external_bootstrap_vue_.BDropdown,
                BDropdownDivider: external_bootstrap_vue_.BDropdownDivider,
                BDropdownItemButton: external_bootstrap_vue_.BDropdownItemButton,
                BModal: external_bootstrap_vue_.BModal,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                CatalogList: catalog_vue_.CatalogList
            }
        })
    ], LineMenu);
    return LineMenu;
}(lib/* Vue */.lD));
/* harmony default export */ var LineMenuvue_type_script_lang_ts_external = (LineMenu);

;// ./src/components/Form/LineMenu/LineMenu.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LineMenu_LineMenuvue_type_script_lang_ts_external = (LineMenuvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/LineMenu/LineMenu.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LineMenu_LineMenuvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LineMenu_LineMenu = (component.exports);
;// ./src/mixins/SalesDocumentLineMixin.ts






var SalesDocumentLineMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SalesDocumentLineMixin, _super);
    function SalesDocumentLineMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localEditing = false;
        return _this;
    }
    SalesDocumentLineMixin.prototype.mounted = function () {
        if (this.index === this.lastInsertIndex) {
            this.activeEditing();
        }
    };
    SalesDocumentLineMixin.prototype.beforeDestroy = function () {
        if (this.localEditing) {
            window.document.removeEventListener('click', this.clickOutside);
        }
    };
    Object.defineProperty(SalesDocumentLineMixin.prototype, "editing", {
        get: function () {
            if (this.editingMode) {
                return true;
            }
            return this.localEditing;
        },
        enumerable: false,
        configurable: true
    });
    SalesDocumentLineMixin.prototype.setLocationEditing = function (event) {
        if (this.editing) {
            return;
        }
        var target = event.target;
        var element = this.$refs.deleteBtn;
        var element2 = this.$refs.moveBtn;
        if ((element && (element === target || element.contains(target))) || (element2 && (element2 === target || element2.contains(target)))) {
            return;
        }
        this.activeEditing();
    };
    SalesDocumentLineMixin.prototype.activeEditing = function () {
        var _this = this;
        this.localEditing = true;
        setTimeout(function () {
            window.document.addEventListener('click', _this.clickOutside);
        }, 10);
    };
    SalesDocumentLineMixin.prototype.clickOutside = function (event) {
        var _a;
        var element = this.$el;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if ((_a = window.document.querySelector('div.modal')) === null || _a === void 0 ? void 0 : _a.contains(event.target)) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!(element === event.target || element.contains(event.target))) {
            this.localEditing = false;
            window.document.removeEventListener('click', this.clickOutside);
        }
    };
    SalesDocumentLineMixin.prototype.getInputName = function (name) {
        if (name.indexOf('.')) {
            name = name.replaceAll('.', '][');
        }
        return 'contents[' + this.index + '][' + name + ']';
    };
    SalesDocumentLineMixin.prototype.deleteLine = function () {
        this.localEditing = false;
        this.$emit('deleteLine');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return ({}); } })
    ], SalesDocumentLineMixin.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return ({}); } })
    ], SalesDocumentLineMixin.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SalesDocumentLineMixin.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SalesDocumentLineMixin.prototype, "index", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SalesDocumentLineMixin.prototype, "lastInsertIndex", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], SalesDocumentLineMixin.prototype, "editingMode", void 0);
    SalesDocumentLineMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            components: {
                LineMenu: LineMenu_LineMenu,
                BButton: external_bootstrap_vue_.BButton
            }
        })
    ], SalesDocumentLineMixin);
    return SalesDocumentLineMixin;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var mixins_SalesDocumentLineMixin = (SalesDocumentLineMixin);


/***/ }),

/***/ 54691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ 54697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ 54765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarParams_CarParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarParams/CarParams.vue?vue&type=template&id=1b088ceb
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('h3',{staticClass:"form-title-alt mt-0"},[_vm._v(" Paramètre de saisie ")]),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.teamConfigs.automotive_document_required),callback:function ($$v) {_vm.$set(_vm.teamConfigs, "automotive_document_required", $$v)},expression:"teamConfigs.automotive_document_required"}},[_vm._v(" Rendre obligatoire la sélection d'un véhicule lors de la rédaction des documents ")]),_c('input',{attrs:{"type":"hidden","name":"configs[automotive_document_required]"},domProps:{"value":_vm.teamConfigs.automotive_document_required ?? false}}),_c('k-form-checkbox',{model:{value:(_vm.teamConfigs.automotive_mileage_required),callback:function ($$v) {_vm.$set(_vm.teamConfigs, "automotive_mileage_required", $$v)},expression:"teamConfigs.automotive_mileage_required"}},[_vm._v(" Rendre obligatoire la saisie du kilométrage lorsqu'un véhicule est sélectionné ")]),_c('input',{attrs:{"type":"hidden","name":"configs[automotive_mileage_required]"},domProps:{"value":_vm.teamConfigs.automotive_mileage_required ?? false}}),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Numérotation des ordres de réparation ")]),_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.params.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceDay')))])])]),_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap",attrs:{"responsive":""}},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))]),_c('th',[_vm._v("Numérotation")])])]),_c('tbody',[_c('tr',[_c('td',[_c('k-form-input',{attrs:{"name":"configs[automotive_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.automotive_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "automotive_reference_prefix", $$v)},expression:"localConfig.automotive_reference_prefix"}})],1),_c('td',[_vm._v(_vm._s(_vm.referenceExample))]),_c('td',[_c('i',[_vm._v(" Le numéro utilisé sera repris sur le devis"),_c('br'),_vm._v("ou le bon de commande depuis lequel"),_c('br'),_vm._v("est généré l'ordre de réparation ")])])])])]),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarParams/CarParams.ts?vue&type=script&lang=ts&external





var CarParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarParams, _super);
    function CarParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        return _this;
    }
    CarParams.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    CarParams.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return null;
        }
        var numberLength = String(number).length;
        if (numberLength > length) {
            length = numberLength;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    Object.defineProperty(CarParams.prototype, "referenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.automotive_reference_prefix, this.localConfig.sales_quotation_reference_number, this.localConfig.sales_quotation_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    CarParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormCheckbox: form_vue_.KFormCheckbox,
                BTableSimple: external_bootstrap_vue_.BTableSimple, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], CarParams);
    return CarParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var CarParamsvue_type_script_lang_ts_external = (CarParams);

;// ./src/components/CarParams/CarParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarParams_CarParamsvue_type_script_lang_ts_external = (CarParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarParams/CarParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarParams_CarParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarParams_CarParams = (component.exports);

/***/ }),

/***/ 54903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ 55149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ UsedCredits_UsedCredits; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UsedCredits/UsedCredits.vue?vue&type=template&id=4b30666c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" Avoir(s) utilisé(s) pour solder la facture : ")]),_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("N° avoir")]),_c('th',[_vm._v("Montant")]),_c('th',{staticStyle:{"width":"40px"}})])]),_c('tbody',_vm._l((_vm.uses),function(use,i){return _c('tr',{key:i},[_c('td',[_c('router-link',{attrs:{"to":{ name: 'credit-item', params: { id: use.credit.id }}}},[_vm._v(" "+_vm._s(use.credit.reference)+" ")])],1),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(use.amount)))]),_c('td',{staticClass:"p-0 text-center"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",modifiers:{"left":true}}],attrs:{"variant":"icon","title":"Supprimer l'utilisation de l'avoir"},on:{"click":function($event){$event.preventDefault();_vm.removeCredit = use.credit}}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']}})],1)],1)])}),0)])]),(_vm.removeCredit !== null)?_c('ConfirmModal',{attrs:{"ok-title":_vm.$t('interface.delete')},on:{"confirmed":_vm.removeCreditUse,"canceled":function($event){_vm.removeCredit = null}}},[_vm._v(" Êtes-vous sur de vouloir supprimer l'attribution de cet avoir à cette facture ? ")]):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UsedCredits/UsedCredits.ts?vue&type=script&lang=ts&external





var UsedCredits = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UsedCredits, _super);
    function UsedCredits() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.removeCredit = null;
        return _this;
    }
    UsedCredits.prototype.removeCreditUse = function () {
        var _this = this;
        var _a;
        this.loading = true;
        this.$kwSales.axios.post('/sales/invoice/' + this.invoice.id + '/credit', {
            remove_credits: [(_a = this.removeCredit) === null || _a === void 0 ? void 0 : _a.id]
        })
            .then(function (response) {
            _this.$emit('input', response.data);
        })
            .finally(function () {
            _this.loading = false;
            _this.removeCredit = null;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], UsedCredits.prototype, "invoice", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], UsedCredits.prototype, "uses", void 0);
    UsedCredits = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BOverlay: external_bootstrap_vue_.BOverlay,
                ConfirmModal: interface_vue_.ConfirmModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], UsedCredits);
    return UsedCredits;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var UsedCreditsvue_type_script_lang_ts_external = (UsedCredits);

;// ./src/components/UsedCredits/UsedCredits.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UsedCredits_UsedCreditsvue_type_script_lang_ts_external = (UsedCreditsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/UsedCredits/UsedCredits.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  UsedCredits_UsedCreditsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UsedCredits_UsedCredits = (component.exports);

/***/ }),

/***/ 55295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PdfModelFormView_PdfModelFormView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PdfModelFormView/PdfModelFormView.vue?vue&type=template&id=76119ef0
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('PdfModelForm',{model:{value:(_vm.pdfModel),callback:function ($$v) {_vm.pdfModel=$$v},expression:"pdfModel"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/PdfModelForm/PdfModelForm.vue + 4 modules
var PdfModelForm = __webpack_require__(40355);
// EXTERNAL MODULE: ./src/fetchDatas/pdfModel.ts
var fetchDatas_pdfModel = __webpack_require__(80549);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/PdfModelFormView/PdfModelFormView.ts?vue&type=script&lang=ts&external






var PdfModelFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelFormView, _super);
    function PdfModelFormView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pdfModel = null;
        _this.loading = true;
        return _this;
    }
    PdfModelFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['pageParams'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            components: {
                PdfModelForm: PdfModelForm/* default */.A,
                Spinner: interface_vue_.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var pageParams;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                pageParams = lib/* Vue */.lD.prototype.$kwSales.store.state.app.pageParams;
                                if (pageParams && !(0,fetchDatas_pdfModel/* needFetchPdfModel */.uM)(pageParams)) {
                                    next(function (vm) {
                                        vm.pdfModel = JSON.parse(JSON.stringify(vm.pageParams));
                                        vm.setPageParams(null);
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                if (!to.params.id) {
                                    next(function (vm) {
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,fetchDatas_pdfModel/* fetchPdfModel */.gp)(to.params.id)
                                        .then(function (pdfModel) {
                                        next(function (vm) {
                                            vm.pdfModel = pdfModel;
                                            vm.loading = false;
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })
                                        .catch(function () {
                                        next({ name: 'error-404' });
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var pdfModel;
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!to.params.id) {
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    pdfModel = JSON.parse(JSON.stringify(this.pageParams));
                                    this.setPageParams(null);
                                    if ((0,fetchDatas_pdfModel/* needFetchPdfModel */.uM)(pdfModel)) {
                                        this.pdfModel = pdfModel;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                if (!to.params.id) {
                                    this.loading = false;
                                    next();
                                    return [2 /*return*/];
                                }
                                this.loading = true;
                                this.pdfModel = null;
                                return [4 /*yield*/, (0,fetchDatas_pdfModel/* fetchPdfModel */.gp)(to.params.id)
                                        .then(function (pdfModel) {
                                        _this.pdfModel = pdfModel;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], PdfModelFormView);
    return PdfModelFormView;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelFormViewvue_type_script_lang_ts_external = (PdfModelFormView);

;// ./src/views/PdfModelFormView/PdfModelFormView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelFormView_PdfModelFormViewvue_type_script_lang_ts_external = (PdfModelFormViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/PdfModelFormView/PdfModelFormView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelFormView_PdfModelFormViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelFormView_PdfModelFormView = (component.exports);

/***/ }),

/***/ 55316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentItem_DocumentItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentItem/DocumentItem.vue?vue&type=template&id=630d3103
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"document-item"},[_c('PageHeader',{attrs:{"page-title":_vm.pageTitle,"buttons":_vm.headerButtons}},[_c('b-col',{staticClass:"col text-md-right text-center mt-md-1 mt-2",attrs:{"cols":"12","md":""}},[_c('ul',{staticClass:"status-bar w-auto d-inline-block"},_vm._l((_vm.documentStatusBar),function(status){return _c('li',{key:status.value,class:{
            selected: status.value === _vm.value.status
          }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0),(_vm.hasModule('sales-deliveries') && (_vm.type === 'quotation' || _vm.type === 'command' || _vm.type === 'proforma' || (_vm.type === 'invoice' && _vm.value.is_advance === false)))?_c('ul',{staticClass:"status-bar delivery-status-bar"},_vm._l((_vm.deliveryStatusBar),function(status){return _c('li',{key:status.value,class:{
            selected: status.value === _vm.value.delivery_status
          }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0):_vm._e(),(_vm.type === 'delivery')?_c('ul',{staticClass:"status-bar delivery-status-bar"},_vm._l((_vm.invoiceStatusBar),function(status){return _c('li',{key:status.value,class:{
            selected: status.value === _vm.value.billing_status
          }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0):_vm._e()])],1),_c('AppMessages'),_c('b-row',{staticClass:"mb-1",attrs:{"no-gutters":"","align-v":"center"}},[_c('b-col',[(_vm.value.title)?_c('h2',[_vm._v(" "+_vm._s(_vm.value.title)+" ")]):_vm._e()])],1),_c('div',[(_vm.hasModule('automotive') && _vm.value.car && (_vm.type === 'quotation' || _vm.type === 'command'))?_c('CarPdf',{staticClass:"mr-2",attrs:{"document":_vm.value,"type":_vm.type}}):_vm._e(),(_vm.app.electronic_sign_status && !_vm.signed && _vm.value.status < 5 && _vm.can('sales-signatures', 1) && _vm.can('sales-' + _vm.type, 2) && (_vm.type === 'quotation' || _vm.type === 'command' || _vm.type === 'proforma' || _vm.type === 'delivery'))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
        title: _vm.value.is_draft ? 'Vous devez valider le document pour l\'envoyer pour signature' : (_vm.waitingSign ? 'Un demande de signature est déjà en attente' : null)
      }),expression:"{\n        title: value.is_draft ? 'Vous devez valider le document pour l\\'envoyer pour signature' : (waitingSign ? 'Un demande de signature est déjà en attente' : null)\n      }"}],staticClass:"d-inline-block"},[_c('SignSend',{staticClass:"mr-2",attrs:{"size":"sm","variant":"primary","value":{
          documents: [
            {
              document_type: _vm.type,
              document_id: _vm.value.id,
              document: _vm.value,
              file: _vm.value.pdf,
              signable_document: _vm.value.pdf_model ? _vm.value.pdf_model['can_sign_' + _vm.type] : false
            }
          ]
        },"modal":_vm.signSendModal,"disabled":_vm.value.is_draft || _vm.waitingSign},on:{"hidden":function($event){_vm.signSendModal = false},"input":_vm.updateDocument,"sended":_vm.markAsSent}})],1):_vm._e(),(_vm.value.is_draft)?_c('DocumentStatus',{staticClass:"mb-2 d-inline-block mr-2",attrs:{"document":_vm.value,"type":_vm.type,"status":2,"variant":"success","size":"sm","label":"Valider le document","confirmLabel":"Validé","explain":_vm.type === 'invoice' || _vm.type === 'credit' ? 'Attention, une fois validé, le document ne sera plus modifiable' : null},on:{"input":_vm.updateDocument}}):_vm._e(),(_vm.type === 'delivery' && _vm.value.status < 3)?_c('DocumentStatus',{staticClass:"mb-2 d-inline-block mr-2",attrs:{"document":_vm.value,"type":_vm.type,"status":3,"variant":"secondary","size":"sm","label":"Marquer comme à envoyer","confirmLabel":"À envoyer"},on:{"input":_vm.updateDocument}}):_vm._e(),(_vm.type === 'delivery' && _vm.value.status < 4)?_c('DocumentStatus',{staticClass:"mb-2 d-inline-block mr-2",attrs:{"document":_vm.value,"type":_vm.type,"status":4,"variant":"secondary","size":"sm","label":"Marquer comme envoyé","confirmLabel":"Envoyé"},on:{"input":_vm.updateDocument}}):_vm._e(),(_vm.type !== 'delivery' && _vm.value.status < 3)?_c('DocumentStatus',{staticClass:"mb-2 d-inline-block mr-2",attrs:{"document":_vm.value,"type":_vm.type,"status":3,"variant":_vm.type === 'invoice' && _vm.value.status === 2 ? 'success' : 'secondary',"explain":_vm.value.status === 1 && (_vm.type === 'invoice' || _vm.type === 'credit') ? 'Attention, le document sera validé et ne sera plus modifiable' : null,"size":"sm","label":_vm.type === 'invoice' || _vm.type === 'proforma' ? 'Marquer comme envoyée' : 'Marquer comme envoyé',"confirmLabel":_vm.type === 'invoice' ? 'Envoyée / En attente de paiement' : _vm.type === 'proforma' ? 'Envoyée' : 'Envoyé'},on:{"input":_vm.updateDocument}}):_vm._e(),(_vm.type !== 'delivery' && _vm.type !== 'invoice' && _vm.type !== 'credit' && _vm.value.status === 3)?_c('DocumentStatus',{staticClass:"mb-2 d-inline-block mr-2",attrs:{"document":_vm.value,"type":_vm.type,"status":4,"variant":"secondary","size":"sm","label":"Accepté","confirmLabel":"Accepté par le client"},on:{"input":_vm.updateDocument}}):_vm._e(),(_vm.type !== 'delivery' && _vm.type !== 'invoice' && _vm.type !== 'credit' && _vm.value.status === 3)?_c('DocumentStatus',{staticClass:"mb-2 d-inline-block mr-2",attrs:{"document":_vm.value,"type":_vm.type,"status":_vm.type === 'proforma' ? 7 : 8,"variant":"secondary","size":"sm","label":"Refusé","confirmLabel":"Refusé par le client"},on:{"input":_vm.updateDocument}}):_vm._e(),(_vm.canBeBill && _vm.value.status >= 3 && _vm.value.status < 6)?_c('div',{staticClass:"mb-2 d-inline-block mr-2"},[_c('TransformToInvoice',{attrs:{"type":_vm.type,"size":"sm","label":"Facturer","variant":"success"},on:{"success":invoice => _vm.$router.push({ name: 'invoice-item', params: { id: String(invoice.id) } })},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e(),(_vm.app.electronic_sign_status && _vm.type !== 'invoice' && _vm.type !== 'credit')?_c('SignState',{attrs:{"signatures":_vm.value.signatures},on:{"signed":state => _vm.signed = state,"waiting":state => _vm.waitingSign = state}}):_vm._e()],1),_c('b-row',{staticClass:"document-elements",attrs:{"align-v":"stretch"}},[_c('b-col',{attrs:{"lg":"4","xxl":"3"}},[_c('b-card',{attrs:{"body-class":"pb-2"}},[(_vm.value.tags.length > 0)?_c('div',{staticClass:"mb-3"},_vm._l((_vm.value.tags),function(tag,i){return _c('b-badge',{key:i,class:{
              'px-2': true,
              'py-1': true,
              'mb-1': true,
              'ml-1': i > 0
            },attrs:{"variant":"tag"}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1):_vm._e(),_c('b-form-group',{attrs:{"label":"Client"}},[(_vm.value.customer)?_c('CustomerSpeedItem',{model:{value:(_vm.value.customer),callback:function ($$v) {_vm.$set(_vm.value, "customer", $$v)},expression:"value.customer"}}):_c('span',[_vm._v(" Client supprimé ")])],1),(_vm.value.customer_child)?_c('b-form-group',{attrs:{"label":_vm.teamConfigs.customer_group_child_name}},[_c('CustomerSpeedItem',{model:{value:(_vm.value.customer_child),callback:function ($$v) {_vm.$set(_vm.value, "customer_child", $$v)},expression:"value.customer_child"}})],1):_vm._e(),(_vm.value.contact)?_c('b-form-group',{attrs:{"label":"Contact"}},[_c('ContactSpeedItem',{model:{value:(_vm.value.contact),callback:function ($$v) {_vm.$set(_vm.value, "contact", $$v)},expression:"value.contact"}})],1):_vm._e(),(_vm.value.billing_contact)?_c('b-form-group',{attrs:{"label":"Contact de facturation"}},[_c('ContactSpeedItem',{model:{value:(_vm.value.billing_contact),callback:function ($$v) {_vm.$set(_vm.value, "billing_contact", $$v)},expression:"value.billing_contact"}})],1):_vm._e(),(_vm.hasModule('automotive') && _vm.value.car)?_c('CarSpeedItem',{attrs:{"customer":_vm.value.customer},model:{value:(_vm.value.car),callback:function ($$v) {_vm.$set(_vm.value, "car", $$v)},expression:"value.car"}}):_vm._e(),_c('b-form-group',{attrs:{"label":"Date"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.date))+" ")]),(_vm.type === 'quotation' || _vm.type === 'command' || _vm.type === 'proforma')?_c('b-form-group',{attrs:{"label":"Limite de validité"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.expire_at))+" ")]):_vm._e(),(_vm.type === 'invoice' && !_vm.value.payment_term?.with_deadlines)?_c('b-form-group',{attrs:{"label":"Limite de paiement"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.expire_at))+" ")]):(_vm.type !== 'credit' && _vm.type !== 'delivery' && _vm.value.deadlines)?_c('b-form-group',{attrs:{"label":"Échéances"}},[_c('ul',{staticClass:"pl-3 small"},_vm._l((_vm.value.deadlines),function(deadline,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(_vm.showNumber(deadline.pourcent))+" %, soit "+_vm._s(_vm.formattedNumber(deadline.amount, _vm.value.currency))+" "),(_vm.type === 'invoice')?[_vm._v(" le "+_vm._s(_vm.date(deadline.date))+" ")]:(i === 0 && deadline.delay === 0)?[_vm._v(" à réception de facture ")]:[_vm._v(" à "+_vm._s(_vm.deadlineDelay(i))+" ")]],2)}),0)]):_vm._e(),(_vm.value.team_user)?_c('b-form-group',{attrs:{"label":"Commercial"}},[_vm._v(" "+_vm._s(_vm.value.team_user.fullname)+" ")]):_vm._e(),(_vm.value.stock_location)?_c('b-form-group',{attrs:{"label":"Lieu de stock"}},[_vm._v(" "+_vm._s(_vm.value.stock_location.name)+" ")]):_vm._e(),(_vm.value.total_weight > 0)?_c('b-form-group',{attrs:{"label":"Poids total"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.total_weight))+" kg ")]):_vm._e(),_vm._l((_vm.linkedDocuments),function(el,i){return _c('b-badge',{key:i,staticClass:"mr-2 mb-2 badge-md",attrs:{"variant":"light","to":{ name: el.type + '-item', params: { id: el.document.id } }}},[(el.type === 'construction')?[_vm._v(" "+_vm._s(_vm.upperFirst(_vm.termText('construction.title', 'chantier', false, { reference: el.document.reference })))+" ")]:[_vm._v(" "+_vm._s(_vm.$t('sales.' + el.type + '.label'))+" "),(el.document.is_advance)?_c('span',[_vm._v("d'acompte")]):(el.document.is_situation)?_c('span',[_vm._v("de situation")]):_vm._e(),_vm._v(" n°"+_vm._s(el.document.reference)+" ")]],2)}),(_vm.value.provider_commands && _vm.value.provider_commands.length > 0)?_c('b-form-group',{staticClass:"mt-3",attrs:{"label":"Commandes fournisseurs liées :"}},_vm._l((_vm.value.provider_commands),function(command,i){return _c('b-badge',{key:i,staticClass:"mr-2 mb-2 badge-md",attrs:{"variant":"light","to":{ name: 'stock-command-item', params: { id: command.id } }}},[_vm._v(" Commande n°"+_vm._s(command.reference)+" ")])}),1):_vm._e(),(_vm.withCommissions)?_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"Montant des commissions"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.commission_amount))+" ")]):_vm._e(),(_vm.value.custom_fields.length > 0 && !_vm.team.configs['custom_field_' + _vm.type + '_tab'])?_c('CustomFieldsDisplay',{staticClass:"mb-5",attrs:{"type":_vm.type,"value":_vm.value.custom_fields,"titleClass":"form-title-alt"}}):_vm._e(),(_vm.type === 'invoice' && _vm.value.escompte_status)?_c('b-alert',{staticClass:"py-1 px-2",attrs:{"show":"","variant":"warning"}},[_vm._v(" Escompte de "+_vm._s(_vm.formattedNumber(_vm.value.escompte_amount_ttc, _vm.value.currency))+" en date du "+_vm._s(_vm.date(_vm.value.escompte_date))+" ")]):_vm._e(),(_vm.type === 'invoice' && _vm.value.guarantee_holdback_amount > 0 && _vm.value.guarantee_holdback_status !== 1 && _vm.value.guarantee_holdback_status !== 3)?_c('b-alert',{staticClass:"py-1 px-2 mt-3 text-justify",attrs:{"show":"","variant":"danger"}},[_c('p',{staticClass:"mb-2"},[_vm._v(" Retenue de garantie de "+_vm._s(_vm.showNumber(_vm.value.guarantee_holdback_pourcent))+" %, soit "+_vm._s(_vm.formattedNumber(_vm.value.guarantee_holdback_amount, _vm.value.currency))+" à régler en date du "+_vm._s(_vm.date(_vm.value.guarantee_holdback_expiration))+". ")]),(_vm.value.guarantee_holdback_status === 2)?_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" La retenue de garantie a été annulée comptablement en date du "+_vm._s(_vm.date(_vm.value.guarantee_holdback_cancel_date))+". ")]):_vm._e(),(_vm.value.stay_to_pay <= 0)?[_c('CancelGuaranteeHoldback',{attrs:{"value":_vm.value,"size":"sm"},on:{"input":_vm.updateDocument}}),_c('PaymentFormButton',{staticClass:"d-inline-block ml-2",attrs:{"type":"invoice","document":_vm.value,"size":"sm","variant":"primary","label":"Payer","withGuaranteeHoldback":""},on:{"invoiceUpdated":_vm.updateDocument}})]:_vm._e()],2):_vm._e()],2),_c('b-row',{staticClass:"text-center my-4 my-2 document-totals mx-0 font-weight-bold"},[_c('b-col',{attrs:{"cols":"4"}},[_c('small',[_vm._v("Total HT")]),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_ht, _vm.value.currency))+" ")]),_c('b-col',{attrs:{"cols":"4"}},[_c('small',[_vm._v("Total TVA")]),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_tva, _vm.value.currency))+" ")]),_c('b-col',{attrs:{"cols":"4"}},[_c('small',[_vm._v("Total TTC")]),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_ttc, _vm.value.currency))+" ")]),(_vm.can('sales-margin', 1))?[_c('b-col',{staticClass:"text-danger border-left-0 border-top",attrs:{"cols":"6"}},[_c('small',[_vm._v("Coûts HT")]),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_charge, _vm.value.currency))+" ")]),_c('b-col',{staticClass:"text-success border-top",attrs:{"cols":"6"}},[_c('small',[_vm._v("Marge HT")]),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.gross_margin_amount, _vm.value.currency))+" ")]),(_vm.type === 'invoice' || _vm.type === 'credit')?_c('b-col',{staticClass:"border-top",attrs:{"cols":"12"}},[_c('small',[_vm._v("Reste à payer")]),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.stay_to_pay, _vm.value.currency))+" ")]):_vm._e(),(((_vm.type === 'quotation' || _vm.type === 'command') && _vm.value.status === 6) || (_vm.type === 'proforma' && _vm.value.status === 5))?_c('b-col',{staticClass:"border-top text-danger font-weight-bold",attrs:{"cols":"12"}},[_c('small',[_vm._v("Reste à facturer")]),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.to_bill, _vm.value.currency))+" ")]):_vm._e()]:_vm._e()],2),_c('b-card',{staticClass:"mb-3"},[(_vm.hasModule('sales-deliveries') || _vm.hasModule('construction'))?_c('h3',{staticClass:"form-title-alt mt-0 border-bottom-0 mb-1"},[_vm._v(" Adresses ")]):_vm._e(),_c('tabs',{staticClass:"mb-4",attrs:{"content-class":"pt-2","size":"sm"}},[_c('tab',{attrs:{"title":_vm.hasModule('sales-deliveries') || _vm.hasModule('construction') ? 'Facturation' :  'Adresse facturation',"title-link-class":"px-2 py-1"}},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.billing_address.name))]),(_vm.value.billing_address.contact)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.billing_address.contact))]):_vm._e(),(_vm.value.billing_address.road)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.billing_address.road))]):_vm._e(),(_vm.value.billing_address.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.billing_address.road2))]):_vm._e(),(_vm.value.billing_address.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.billing_address.road3))]):_vm._e(),_vm._v(" "+_vm._s(_vm.value.billing_address.postal_code)+" "+_vm._s(_vm.value.billing_address.city)+" "),(_vm.value.billing_address.country)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.billing_address.country.name))]):_vm._e()]),(_vm.hasModule('sales-deliveries') || _vm.hasModule('construction'))?_c('tab',{attrs:{"title":_vm.hasModule('sales-deliveries') ? 'Livraison' : 'Chantier',"title-link-class":"px-2 py-1"}},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.delivery_address.name))]),(_vm.value.delivery_address.contact)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.delivery_address.contact))]):_vm._e(),(_vm.value.delivery_address.road)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.delivery_address.road))]):_vm._e(),(_vm.value.delivery_address.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.delivery_address.road2))]):_vm._e(),(_vm.value.delivery_address.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.delivery_address.road3))]):_vm._e(),_vm._v(" "+_vm._s(_vm.value.delivery_address.postal_code)+" "+_vm._s(_vm.value.delivery_address.city)+" "),(_vm.value.delivery_address.country)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.delivery_address.country.name))]):_vm._e()]):_vm._e()],1),(_vm.value.payment_term)?_c('b-form-group',{attrs:{"label":"Conditions de paiement"}},[_vm._v(" "+_vm._s(_vm.value.payment_term.label)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Escompte"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.escompte_rate))+" % ")]),(_vm.type === 'quotation' || _vm.type === 'command')?[_c('b-form-group',{attrs:{"label":"Acompte"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.advance_payment_value))+" "+_vm._s(_vm.value.advance_payment_type === 'pourcent' ? '%' : _vm.value.currency.symbol)+" ")]),(_vm.value.accepted_at)?_c('b-form-group',{attrs:{"label":"Date d'acception"}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.value.accepted_at))+" ")]):_vm._e(),(_vm.value.refused_at)?_c('b-form-group',{attrs:{"label":"Date de refus"}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.value.refused_at))+" ")]):_vm._e()]:_vm._e()],2),_c('OldDocumentsList',{attrs:{"documents":_vm.value.oldVersions,"type":_vm.type}})],1),_c('b-col',{staticClass:"mt-lg-0 mt-4",attrs:{"lg":"8","xxl":"9"}},[_c('tabs',{staticClass:"tabs-card pb-3",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('tab',{staticClass:"p-0",attrs:{"title":"PDF","lazy":""}},[_c('PdfViewer',{ref:"pdfviewer",attrs:{"type":_vm.type,"id":_vm.value.id,"pdf_status":_vm.value.pdf_status},on:{"pdfLoaded":_vm.pdfLoaded}})],1),_c('tab',{attrs:{"title":"Éléments","lazy":""}},[_c('AgregateDatas',_vm._b({on:{"loaded":_vm.agregateLoaded,"mailSent":_vm.markAsSent}},'AgregateDatas',_vm.agregateProperties,false))],1),(_vm.value.custom_fields.length > 0 && _vm.team.configs['custom_field_' + _vm.type + '_tab'])?_c('CustomFieldsDisplayTab',{attrs:{"type":_vm.type,"value":_vm.value.custom_fields,"formUrl":'/sales/' + _vm.type + '/' + _vm.value.id + '/lite',"component":"tab","canUpdate":_vm.can('sales-' + this.type, 3)},on:{"input":document => _vm.$emit('input', document)}}):_vm._e(),(_vm.type === 'invoice' || _vm.type === 'credit')?_c('tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Paiement(s) "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"secondary"}},[_vm._v(" "+_vm._s(_vm.totalPayments)+" ")]),_c('PaymentFormButton',{staticClass:"d-inline-block",attrs:{"btn-class":"p-0 pl-1","variant":"icon","type":_vm.type,"document":_vm.value,"disabled":_vm.payementFormButtonDisable,"title":_vm.payementFormButtonTitle(true)},on:{"invoiceUpdated":_vm.updateDocument}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1)]},proxy:true}],null,false,3210869203)},[(_vm.type === 'invoice' && _vm.value.total_credit_use > 0)?_c('UsedCredits',{staticClass:"mb-5",attrs:{"invoice":_vm.value,"uses":_vm.value.credits_uses},on:{"input":_vm.updateDocument}}):_vm._e(),(_vm.type === 'credit' && _vm.value.uses.length > 0)?_c('CreditsUses',{staticClass:"mb-5",attrs:{"uses":_vm.value.uses}}):_vm._e(),_c('PaymentList',{attrs:{"type":_vm.type,"document":_vm.value},on:{"totalUpdated":_vm.updateTotalPayments}})],1):_vm._e(),(_vm.hasModule('charges'))?_c('tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Charges(s) "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Rattacher une charge"},on:{"click":function($event){_vm.addNewCharge = true}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1)]},proxy:true}],null,false,1047105187)},[_c('AttachChargeList',{attrs:{"affair":_vm.value.affairs ? _vm.value.affairs : _vm.value.affair},on:{"updateAmount":_vm.updateChargeAmount}})],1):_vm._e(),(_vm.hasModule('stock-tracabilities') && _vm.value.used_lots)?_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Lot(s) "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"secondary"}},[_vm._v(" "+_vm._s(_vm.value.used_lots.length)+" ")])]},proxy:true}],null,false,1917254363)},[_c('LotUsed',{ref:"lots",attrs:{"value":_vm.value.used_lots}})],1):_vm._e()],1)],1)],1),_c('b-modal',{attrs:{"title":"Contenu du document","size":"xxl","ok-only":"","ok-title":_vm.$t('interface.close'),"lazy":""},model:{value:(_vm.modalDocumentContent),callback:function ($$v) {_vm.modalDocumentContent=$$v},expression:"modalDocumentContent"}},[(_vm.modalDocumentContent)?_c('DocumentContent',{attrs:{"document":_vm.value}}):_vm._e()],1),_c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close'),"size":"sm"},model:{value:(_vm.modalClone),callback:function ($$v) {_vm.modalClone=$$v},expression:"modalClone"}},[(_vm.can('sales-quotation', 2))?_c('b-button',{staticClass:"w-100 text-center mb-2",on:{"click":function($event){$event.preventDefault();return _vm.cloneDocument('quotation')}}},[_vm._v(" Créer un devis ")]):_vm._e(),(_vm.can('sales-command', 2) && _vm.hasModule('sales-commands'))?_c('b-button',{staticClass:"w-100 text-center mb-2",on:{"click":function($event){$event.preventDefault();return _vm.cloneDocument('command')}}},[_vm._v(" Créer un bon de commande ")]):_vm._e(),(_vm.can('sales-delivery', 2) && _vm.hasModule('sales-deliveries'))?_c('b-button',{staticClass:"w-100 text-center mb-2",on:{"click":function($event){$event.preventDefault();return _vm.cloneDocument('delivery')}}},[_vm._v(" Créer un bon de livraison ")]):_vm._e(),(_vm.can('sales-proforma', 2) && _vm.hasModule('sales-proformas'))?_c('b-button',{staticClass:"w-100 text-center mb-2",on:{"click":function($event){$event.preventDefault();return _vm.cloneDocument('proforma')}}},[_vm._v(" Créer une facture proforma ")]):_vm._e(),(_vm.can('sales-invoice', 2))?_c('b-button',{staticClass:"w-100 text-center mb-2",on:{"click":function($event){$event.preventDefault();return _vm.cloneDocument('invoice')}}},[_vm._v(" Créer une facture ")]):_vm._e(),(_vm.can('sales-credit', 2))?_c('b-button',{staticClass:"w-100 text-center",on:{"click":function($event){$event.preventDefault();return _vm.cloneDocument('credit')}}},[_vm._v(" Créer un avoir ")]):_vm._e()],1),_c('AttachChargeForm',{attrs:{"modal":_vm.addNewCharge,"affair":_vm.value.affairs ? _vm.value.affairs[0] : _vm.value.affair},on:{"hidden":function($event){_vm.addNewCharge = false},"affairChargeUpdate":_vm.chargeAmountAdded}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__(55808);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "@kwixeo/communication-vue"
var communication_vue_ = __webpack_require__(43055);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(44696);
// EXTERNAL MODULE: external "@kwixeo/calendars-vue"
var calendars_vue_ = __webpack_require__(59792);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "@kwixeo/catalog-vue"
var catalog_vue_ = __webpack_require__(68480);
;// external "@kwixeo/constructions-vue"
var constructions_vue_namespaceObject = require("@kwixeo/constructions-vue");
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./src/components/PdfViewer/PdfViewer.vue + 3 modules
var PdfViewer = __webpack_require__(28493);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatusMixin.ts
var SalesDocumentStatusMixin = __webpack_require__(25267);
// EXTERNAL MODULE: ./src/components/DocumentContent/DocumentContent.vue + 3 modules
var DocumentContent = __webpack_require__(94425);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentCostsUpdate/DocumentCostsUpdate.vue?vue&type=template&id=4abded82
var DocumentCostsUpdatevue_type_template_id_4abded82_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"title":"Modification des coûts","size":"xxl","ok-title":_vm.$t('interface.save'),"cancel-title":_vm.$t('interface.cancel')},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.document)?_c('k-form',{ref:"form",attrs:{"action":_vm.formApi,"method":"PUT"},on:{"submitComplete":_vm.submitted}},[_c('b-row',{staticClass:"mb-2"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.withVariousCosts),callback:function ($$v) {_vm.withVariousCosts=$$v},expression:"withVariousCosts"}},[_vm._v(" Afficher les coûts divers ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{model:{value:(_vm.withWorkout),callback:function ($$v) {_vm.withWorkout=$$v},expression:"withWorkout"}},[_vm._v(" Afficher la main d'oeuvre ")])],1)],1),_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm table-bordered text-nowrap table-document-content"},[_c('thead',[_c('tr',{staticClass:"text-center"},[_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Référence")]),_c('th',{staticClass:"text-left"},[_vm._v("Désignation")]),_c('th',{staticStyle:{"width":"110px"}},[_vm._v("Prix U. HT")]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Quantité")]),_c('th',{staticStyle:{"width":"110px"}},[_vm._v("Total HT")])])]),_c('tbody',_vm._l((_vm.document.contents),function(content,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(content.reference))]),_c('td',{staticClass:"text-wrap"},[_c('FroalaView',{staticClass:"mb-3",attrs:{"value":content.designation}}),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName(i, 'affair_content')},domProps:{"value":content.affair_content_id}}),_c('b-form-row',{staticClass:"sub-description-input"},[(!_vm.withWorkout)?_c('b-col'):_vm._e(),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.buyPrice'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":_vm.getInputName(i, 'catalog_costs_u'),"size":"sm","max-decimal":5},on:{"input":function($event){return _vm.calculateCosts(i)}},model:{value:(content.catalog_costs_u),callback:function ($$v) {_vm.$set(content, "catalog_costs_u", $$v)},expression:"content.catalog_costs_u"}})],1)],1)],1),(_vm.withVariousCosts)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.variousCosts'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":_vm.getInputName(i, 'various_costs_u'),"size":"sm","max-decimal":5},on:{"input":function($event){return _vm.calculateCosts(i)}},model:{value:(content.various_costs_u),callback:function ($$v) {_vm.$set(content, "various_costs_u", $$v)},expression:"content.various_costs_u"}})],1)],1)],1):_vm._e(),(_vm.withVariousCosts)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.totalBuy'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":"","max-decimal":5},model:{value:(content.total_costs_u),callback:function ($$v) {_vm.$set(content, "total_costs_u", $$v)},expression:"content.total_costs_u"}})],1)],1)],1):_vm._e(),(_vm.withWorkout)?_c('b-col'):_vm._e(),(_vm.withWorkout)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.totalCharge'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":"","max-decimal":5},model:{value:(content.total_charge_u),callback:function ($$v) {_vm.$set(content, "total_charge_u", $$v)},expression:"content.total_charge_u"}})],1)],1)],1):_vm._e(),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.marginAmount'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","max-decimal":5},on:{"change":function($event){return _vm.updateGrossMarginAmount(i)}},model:{value:(content.gross_margin_amount_u),callback:function ($$v) {_vm.$set(content, "gross_margin_amount_u", $$v)},expression:"content.gross_margin_amount_u"}})],1)],1)],1),_c('b-col',{staticClass:"not-input-width",attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.marginRate'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"80px"},attrs:{"size":"sm","readonly":""},model:{value:(content.gross_margin_rate),callback:function ($$v) {_vm.$set(content, "gross_margin_rate", $$v)},expression:"content.gross_margin_rate"}})],1)],1)],1),_c('b-col',{staticClass:"not-input-width",attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.markupRate'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"85px"},attrs:{"size":"sm","readonly":""},model:{value:(content.markup_rate),callback:function ($$v) {_vm.$set(content, "markup_rate", $$v)},expression:"content.markup_rate"}})],1)],1)],1),_c('b-col',{staticClass:"pt-2",attrs:{"cols":"12"}}),(_vm.withWorkout)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.duration'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"50px"},attrs:{"name":_vm.getInputName(i, 'duration'),"min":0,"size":"sm"},on:{"input":function($event){return _vm.calculateCosts(i)}},model:{value:(content.duration),callback:function ($$v) {_vm.$set(content, "duration", $$v)},expression:"content.duration"}}),_c('b-input-group-append',[_c('k-form-select',{staticClass:"document-small-select",staticStyle:{"width":"70px"},attrs:{"name":_vm.getInputName(i, 'duration_type'),"options":[
                              { id: 'minute', label: _vm.$t('sales.form.lines.durationMinute') },
                              { id: 'hour', label: _vm.$t('sales.form.lines.durationHour') },
                            ],"reduce":opt => opt.id,"clearable":false,"value":"Mn","size":"sm"},on:{"input":function($event){return _vm.calculateCosts(i)}},model:{value:(content.duration_type),callback:function ($$v) {_vm.$set(content, "duration_type", $$v)},expression:"content.duration_type"}})],1)],1)],1)],1):_vm._e(),(_vm.withWorkout)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.technicalNumber'),"label-size":"sm"}},[_c('k-form-spinner',{attrs:{"name":_vm.getInputName(i, 'number_people_needed'),"min":0,"size":"sm"},on:{"input":function($event){return _vm.calculateCosts(i)}},model:{value:(content.number_people_needed),callback:function ($$v) {_vm.$set(content, "number_people_needed", $$v)},expression:"content.number_people_needed"}})],1)],1):_vm._e(),(_vm.withWorkout)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.hourlyCosts'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":_vm.getInputName(i, 'hourly_person_cost'),"size":"sm","min":0,"max-decimal":5},on:{"input":function($event){return _vm.calculateCosts(i)}},model:{value:(content.hourly_person_cost),callback:function ($$v) {_vm.$set(content, "hourly_person_cost", $$v)},expression:"content.hourly_person_cost"}})],1)],1)],1):_vm._e(),(_vm.withWorkout)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.workoutCosts'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":"","max-decimal":5},model:{value:(content.workforce_costs_u),callback:function ($$v) {_vm.$set(content, "workforce_costs_u", $$v)},expression:"content.workforce_costs_u"}})],1)],1)],1):_vm._e()],1),(_vm.teamConfigs.sales_private_comments)?_c('b-form-group',{attrs:{"label":"Notes interne"}},[_c('k-form-textarea',{attrs:{"name":_vm.getInputName(i, 'comments')},model:{value:(_vm.value.comments),callback:function ($$v) {_vm.$set(_vm.value, "comments", $$v)},expression:"value.comments"}})],1):_vm._e()],1),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(content.unit_price_net_ht, _vm.document.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(content.total_quantity)))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(content.total_net_ht, _vm.document.currency)))])])}),0)])]),_c('b-row',[_c('b-col',[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Total coûts"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"80px"},attrs:{"size":"sm","readonly":""},model:{value:(_vm.document.total_charge),callback:function ($$v) {_vm.$set(_vm.document, "total_charge", $$v)},expression:"document.total_charge"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Total marge brute HT"}},[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"80px"},attrs:{"size":"sm","readonly":""},model:{value:(_vm.document.gross_margin_amount),callback:function ($$v) {_vm.$set(_vm.document, "gross_margin_amount", $$v)},expression:"document.gross_margin_amount"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"Taux de marge"}},[_c('b-form-group',{attrs:{"label":"Coûts"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"80px"},attrs:{"size":"sm","readonly":""},model:{value:(_vm.document.gross_margin_rate),callback:function ($$v) {_vm.$set(_vm.document, "gross_margin_rate", $$v)},expression:"document.gross_margin_rate"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Taux de marque"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"80px"},attrs:{"size":"sm","readonly":""},model:{value:(_vm.document.markup_rate),callback:function ($$v) {_vm.$set(_vm.document, "markup_rate", $$v)},expression:"document.markup_rate"}})],1)],1)],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered mt-1 table-document-content align-middle"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('sales.form.totals.totalHt')))]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"value":_vm.document.total_ht,"readonly":"","size":"sm"}})],1)],1)]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('sales.form.totals.tva')))]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"value":_vm.value.total_tva,"readonly":"","size":"sm"}})],1)],1)]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('sales.form.totals.totalTtc')))]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.document.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"value":_vm.value.total_ttc,"readonly":"","size":"sm"}})],1)],1)])])])])],1)],1):_vm._e()],1)],1)
}
var DocumentCostsUpdatevue_type_template_id_4abded82_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentCostsUpdate/DocumentCostsUpdate.ts?vue&type=script&lang=ts&external







var DocumentCostsUpdate = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentCostsUpdate, _super);
    function DocumentCostsUpdate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.document = null;
        _this.modalState = false;
        _this.withWorkout = false;
        _this.withVariousCosts = false;
        return _this;
    }
    Object.defineProperty(DocumentCostsUpdate.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentCostsUpdate.prototype, "formApi", {
        get: function () {
            var _a;
            return '/sales/' + this.type + '/' + ((_a = this.document) === null || _a === void 0 ? void 0 : _a.id) + '/lite';
        },
        enumerable: false,
        configurable: true
    });
    DocumentCostsUpdate.prototype.watchValue = function (document) {
        var _a, _b, _c, _d;
        this.document = JSON.parse(JSON.stringify(document));
        this.withWorkout = ((_b = (_a = this.document) === null || _a === void 0 ? void 0 : _a.input_options.workforce_entries) !== null && _b !== void 0 ? _b : 0) > 0;
        this.withVariousCosts = (_d = (_c = this.document) === null || _c === void 0 ? void 0 : _c.input_options.various_costs) !== null && _d !== void 0 ? _d : false;
    };
    DocumentCostsUpdate.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    DocumentCostsUpdate.prototype.submitted = function (response) {
        return response.data;
    };
    DocumentCostsUpdate.prototype.getInputName = function (index, name) {
        if (name.indexOf('.')) {
            name = name.replaceAll('.', '][');
        }
        return 'contents[' + index + '][' + name + ']';
    };
    // Calculate all costs
    DocumentCostsUpdate.prototype.calculateCosts = function (index) {
        var _a;
        var local = (_a = this.document) === null || _a === void 0 ? void 0 : _a.contents[index];
        if (!local) {
            return;
        }
        // Unit sale price
        var unitPrice = this.number(local.unit_price_net_ht);
        var qty = local.total_quantity;
        if (qty === 0) {
            qty = 1;
        }
        if (this.number(local.discount_value) > 0) {
            // If discount is applied, calculate the unit price ht from the total_ht and the quantity
            unitPrice = this.roundNumber(this.number(qty === 1 ? local.unit_price_net_ht : local.total_net_ht) / qty, 2);
        }
        // Unit amounts
        local.total_costs_u = this.number(local.catalog_costs_u) + this.number(local.various_costs_u) + this.number(local.ecotax_u_ht);
        var duration = local.duration_type === 'minute' ? this.roundNumber(this.number(local.duration) / 60, 2) : this.number(local.duration);
        local.workforce_costs_u = this.number(local.hourly_person_cost) * duration * this.number(local.number_people_needed);
        local.total_charge_u = local.total_costs_u + local.workforce_costs_u;
        local.gross_margin_amount_u = this.number(unitPrice) - local.total_charge_u;
        // Rates
        local.gross_margin_rate = local.total_charge_u === 0 ? 100 : local.gross_margin_amount_u / local.total_charge_u * 100;
        local.markup_rate = unitPrice === 0 ? 0 : local.gross_margin_amount_u / this.number(unitPrice) * 100;
        // Total amount
        local.total_workforce = this.roundNumber(local.workforce_costs_u * qty, 2);
        local.total_costs = this.roundNumber(local.total_costs_u * qty, 2);
        local.total_charge = this.roundNumber(local.total_charge_u * qty, 2);
        local.gross_margin_amount = this.roundNumber(local.gross_margin_amount_u * qty, 2);
        this.calculateGlobalAmounts();
    };
    // Calculate unit price from gross margin amount
    DocumentCostsUpdate.prototype.updateGrossMarginAmount = function (index) {
        var _a;
        var local = (_a = this.document) === null || _a === void 0 ? void 0 : _a.contents[index];
        if (!local) {
            return;
        }
        local.catalog_costs_u = this.roundNumber(this.number(local.unit_price_net_ht) - this.number(local.gross_margin_amount_u) - this.number(local.various_costs_u), 2);
        this.calculateCosts(index);
    };
    DocumentCostsUpdate.prototype.calculateGlobalAmounts = function () {
        var _this = this;
        var document = this.document;
        if (!document) {
            return;
        }
        document.total_charge = this.roundNumber(sumBy_default()(document.contents, function (content) { return _this.number(content.total_charge); }), 2);
        document.gross_margin_amount = this.roundNumber(document.total_ht - document.total_charge, 2);
        document.gross_margin_rate = this.roundNumber(document.gross_margin_amount / document.total_charge * 100, 2);
        document.markup_rate = this.roundNumber(document.gross_margin_amount / this.number(document.total_ht) * 100, 2);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentCostsUpdate.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentCostsUpdate.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], DocumentCostsUpdate.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Modification des coûts' })
    ], DocumentCostsUpdate.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentCostsUpdate.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DocumentCostsUpdate.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], DocumentCostsUpdate.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal')
    ], DocumentCostsUpdate.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], DocumentCostsUpdate.prototype, "submitted", null);
    DocumentCostsUpdate = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormRow: external_bootstrap_vue_.BFormRow,
                BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormSpinner: form_vue_.KFormSpinner, FroalaView: form_vue_.FroalaView, KFormEditor: form_vue_.KFormEditor, KFormInput: form_vue_.KFormInput, KFormTextarea: form_vue_.KFormTextarea, KFormCheckbox: form_vue_.KFormCheckbox,
                FormModal: interface_vue_.FormModal,
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], DocumentCostsUpdate);
    return DocumentCostsUpdate;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var DocumentCostsUpdatevue_type_script_lang_ts_external = (DocumentCostsUpdate);

;// ./src/components/DocumentCostsUpdate/DocumentCostsUpdate.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentCostsUpdate_DocumentCostsUpdatevue_type_script_lang_ts_external = (DocumentCostsUpdatevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/DocumentCostsUpdate/DocumentCostsUpdate.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentCostsUpdate_DocumentCostsUpdatevue_type_script_lang_ts_external,
  DocumentCostsUpdatevue_type_template_id_4abded82_render,
  DocumentCostsUpdatevue_type_template_id_4abded82_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentCostsUpdate_DocumentCostsUpdate = (component.exports);
// EXTERNAL MODULE: ./src/components/DocumentSpeedEdit/DocumentSpeedEdit.vue + 3 modules
var DocumentSpeedEdit = __webpack_require__(61061);
// EXTERNAL MODULE: ./src/components/TransformToQuotation/TransformToQuotation.vue + 3 modules
var TransformToQuotation = __webpack_require__(44805);
// EXTERNAL MODULE: ./src/components/TransformToCommand/TransformToCommand.vue + 3 modules
var TransformToCommand = __webpack_require__(23091);
// EXTERNAL MODULE: ./src/components/TransformToProforma/TransformToProforma.vue + 3 modules
var TransformToProforma = __webpack_require__(39491);
// EXTERNAL MODULE: ./src/components/TransformToDepositInvoice/TransformToDepositInvoice.vue + 3 modules
var TransformToDepositInvoice = __webpack_require__(31929);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TransformToSituationInvoice/TransformToSituationInvoice.vue?vue&type=template&id=1029123a
var TransformToSituationInvoicevue_type_template_id_1029123a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",value:({ title: _vm.disabledTitle }),expression:"{ title: disabledTitle }",modifiers:{"right":true}}],tag:"component",attrs:{"disabled":_vm.computedDisabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b-modal',{attrs:{"title":"Création d'une facture de situation","ok-title":_vm.okTitle,"ok-only":_vm.errorMsg !== null,"cancel-title":_vm.$t('interface.cancel'),"size":_vm.situationInvoice.situationType === 1 || _vm.step === 1 ? 'situation-invoice' : 'xxl'},on:{"ok":_vm.onOk,"show":_vm.setDefaultValues},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg !== null)?_c('p',{staticClass:"font-weight-bold text-danger mb-0 text-center"},[_vm._v(" Erreur : "+_vm._s(_vm.errorMsg)+" ")]):_c('k-form',{ref:"form",attrs:{"action":_vm.formUrl,"value":_vm.formDatas,"method":"post"},on:{"submitError":_vm.submitError,"submitComplete":_vm.submitComplete}},[(_vm.value.situation_count === 0)?_c('b-alert',{staticClass:"font-weight-bold",attrs:{"show":"","variant":"danger"}},[_vm._v(" Attention : Le devis ne sera plus modifiable après la création de la première facture d'avancement ")]):_vm._e(),_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Facture de situation n°"+_vm._s(_vm.nextSituationNumber)+" du "+_vm._s(_vm.$t('sales.' + _vm.type + '.label').toLowerCase())+" n°"+_vm._s(_vm.value.reference)+" ")]),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Date du document"}},[_c('k-form-datepicker',{staticStyle:{"width":"150px"},attrs:{"name":"date","min-date":_vm.minDate,"max-date":!_vm.teamConfigs.sales_disable_date_check ? _vm.today : null},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_c('b-col',{staticClass:"mb-4 mb-md-0",attrs:{"cols":"12","md":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.draft}}),_c('k-form-checkbox',{staticClass:"mt-md-4",model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}},[_vm._v(" Créer le document au statut brouillon ")])],1)],1),_c('b-alert',{staticClass:"py-2 px-3 mt-2",attrs:{"variant":"danger","show":!_vm.draft}},[_vm._v(" Attention : la facture ne pourra pas être modifiée ")]),(!_vm.value.billing_address.city || !_vm.value.billing_address.postal_code)?_c('b-form-group',{staticClass:"mb-4",attrs:{"label":"Adresse de facturation"}},[_c('k-form-address',{attrs:{"countries-list":_vm.countries,"prefix-name":"billing_address_","required":"","road-placeholder":_vm.$t('sales.form.road'),"size":"sm","with-road3":"","valuesMap":{
              road: 'road',
              city: 'city'
            },"city-name":"city","road-name":"road"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1):_vm._e(),(_vm.step === 1)?[_c('b-form-group',{attrs:{"label":"Type de facture de situation :"}},[_c('b-form-radio-group',{attrs:{"name":"situation_type","options":[
               { text: 'Situation globale', value: 1 },
               { text: 'Situation détaillée', value: 2 }
             ]},model:{value:(_vm.situationInvoice.situationType),callback:function ($$v) {_vm.$set(_vm.situationInvoice, "situationType", $$v)},expression:"situationInvoice.situationType"}})],1),(_vm.depositInvoices.length > 0)?_c('b-form-group',{attrs:{"label":"Déduction des acomptes :"}},[_c('b-form-radio-group',{attrs:{"name":"deposit_mode","options":[
               { text: 'Sur la première situation', value: 1 },
               { text: 'Au prorata sur chaque situation', value: 2 }
             ]},model:{value:(_vm.situationInvoice.depositMode),callback:function ($$v) {_vm.$set(_vm.situationInvoice, "depositMode", $$v)},expression:"situationInvoice.depositMode"}})],1):_vm._e(),_c('b-alert',{staticClass:"mb-0 font-weight-bold",attrs:{"show":"","variant":"warning"}},[_vm._v(" Vous ne pourrez plus changer le type de situation pour ce devis par la suite ")])]:(_vm.step === 2 && _vm.situationInvoice.situationType === 1)?[_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm text-nowrap"},[_c('thead',[_c('tr',[_c('th'),_c('th',{staticClass:"text-center"},[_vm._v("HT")]),_c('th',{staticClass:"text-center"},[_vm._v("TVA")]),_c('th',{staticClass:"text-center"},[_vm._v("TTC")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("Devis n°"+_vm._s(_vm.value.reference))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.value.total_ht, _vm.value.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.value.total_tva, _vm.value.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.value.total_ttc, _vm.value.currency)))])]),_vm._l((_vm.invoices),function(invoice,i){return _c('tr',{key:i},[_c('td',[_vm._v("Situation n°"+_vm._s(invoice.situation_number)+" - Facture n°"+_vm._s(invoice.reference))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(invoice.total_ht, invoice.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(invoice.total_tva, invoice.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(invoice.total_ttc, invoice.currency)))])])}),_c('tr',{staticClass:"font-weight-bold"},[_c('td',[_vm._v("Reste à facturer ("+_vm._s(_vm.showNumber(_vm.value.pourcent_to_bill))+" %) :")]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.stayToBillHt, _vm.value.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.stayToBillTva, _vm.value.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.stayToBillTtc, _vm.value.currency)))])])],2)])]),_c('div',{staticClass:"table-responsive-lg mb-0"},[_c('table',{staticClass:"table table-sm mt-5 text-nowrap"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"font-weight-bold align-middle border-0 pb-3"},[_vm._v("Montant de la facture de situation :")]),_c('td',{staticClass:"text-right border-0 pb-3",staticStyle:{"width":"200px"}},[_c('b-input-group',{attrs:{"size":"sm"}},[_c('k-form-number',{attrs:{"name":"amount","size":"sm","min":0,"max":_vm.maxAmount},model:{value:(_vm.situationInvoice.amount),callback:function ($$v) {_vm.$set(_vm.situationInvoice, "amount", $$v)},expression:"situationInvoice.amount"}}),_c('b-input-group-append',[_c('k-form-select',{attrs:{"name":"amount_type","size":"sm","options":_vm.globalAmountTypes(),"clearable":false,"reduce":opt => opt.value},model:{value:(_vm.situationInvoice.amountType),callback:function ($$v) {_vm.$set(_vm.situationInvoice, "amountType", $$v)},expression:"situationInvoice.amountType"}})],1)],1)],1)]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Montant facturé HT :")]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.totalHt, _vm.value.currency)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Montant facturé TVA :")]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.totalTva, _vm.value.currency)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Montant facturé TTC :")]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.totalTtc, _vm.value.currency)))])]),(_vm.depositInvoices.length > 0 && _vm.situationInvoice.depositAmount > 0)?_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Acompte versé :")]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.depositAmount, _vm.value.currency)))])]):_vm._e(),_c('tr',{staticClass:"alert-warning font-weight-bold"},[_c('td',[_vm._v("Montant à payer :")]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.toPaid, _vm.value.currency)))])]),_c('tr',[_c('td',{staticClass:"pt-3 border-0",attrs:{"colspan":"2"}})]),_c('tr',{staticClass:"alert-secondary font-weight-bold"},[_c('td',[_vm._v("Reste à facturer :")]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.stayToBill, _vm.value.currency)))])])])])])]:(_vm.step === 2 && _vm.situationInvoice.situationType === 2)?[_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm text-nowrap table-bordered align-middle"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Désignation")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"120px"}},[_vm._v("Prix U.")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"120px"}},[_vm._v("Quantité")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"120px"}},[_vm._v("Déjà facturé")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("Quantité")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"115px"}},[_vm._v("Pourcentage")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"130px"}},[_vm._v("Total HT")])])]),_c('tbody',_vm._l((_vm.contents),function(content,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(content.reference))]),_c('td',{staticClass:"text-wrap"},[_c('FroalaView',{attrs:{"value":content.designation}})],1),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(content.unit_price_ht)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(content.original_quantity)))]),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.formattedNumber(content.billed_amount))+" / "+_vm._s(_vm.showNumber(content.billed_percentage))+" % / "),_c('small',[_vm._v("Qté : ")]),_vm._v(_vm._s(_vm.showNumber(content.billed_quantity))+" ")]),_c('td',{staticClass:"text-center small"},[(content.quantity_to_bill > 0)?_c('k-form-spinner',{attrs:{"size":"sm","min":0,"max":content.quantity_to_bill,"maxDecimal":2},on:{"change":function($event){return _vm.calculateFromQuantity(i)}},model:{value:(_vm.contents[i].quantity),callback:function ($$v) {_vm.$set(_vm.contents[i], "quantity", $$v)},expression:"contents[i].quantity"}}):[_vm._v(" "+_vm._s(_vm.showNumber(0))+" ")]],2),_c('td',{staticClass:"text-center small"},[(content.to_bill_percentage > 0)?_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-spinner',{attrs:{"size":"sm","left":"","min":0,"max":content.to_bill_percentage,"maxDecimal":2},on:{"change":function($event){return _vm.calculateFromPourcentage(i)}},model:{value:(_vm.contents[i].pourcentage),callback:function ($$v) {_vm.$set(_vm.contents[i], "pourcentage", $$v)},expression:"contents[i].pourcentage"}})],1):[_vm._v(" "+_vm._s(_vm.showNumber(0))+" % ")]],2),_c('td',{staticClass:"text-center small"},[(content.to_bill_percentage > 0)?_c('b-input-group',{attrs:{"append":"€","size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","min":0,"max":content.amount_to_bill},on:{"change":function($event){return _vm.calculateFromTotal(i)}},model:{value:(_vm.contents[i].total_ht),callback:function ($$v) {_vm.$set(_vm.contents[i], "total_ht", $$v)},expression:"contents[i].total_ht"}})],1):[_vm._v(" "+_vm._s(_vm.formattedNumber(0, _vm.value.currency))+" ")]],2)])}),0)]),_c('b-row',[_c('b-col'),_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm text-nowrap situation-totals-table"},[_c('tr',[_c('td',{staticClass:"font-weight-bold border-left"},[_vm._v("Montant facturé HT :")]),_c('td',{staticClass:"text-right border-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.totalHt, _vm.value.currency)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold border-left"},[_vm._v("Montant facturé TVA :")]),_c('td',{staticClass:"text-right border-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.totalTva, _vm.value.currency)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold border-left"},[_vm._v("Montant facturé TTC :")]),_c('td',{staticClass:"text-right border-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.totalTtc, _vm.value.currency)))])]),(_vm.depositInvoices.length > 0 && _vm.situationInvoice.depositAmount > 0)?_c('tr',[_c('td',{staticClass:"font-weight-bold border-left"},[_vm._v("Acompte versé :")]),_c('td',{staticClass:"text-right border-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.depositAmount, _vm.value.currency)))])]):_vm._e(),_c('tr',{staticClass:"alert-warning font-weight-bold"},[_c('td',{staticClass:"border-left"},[_vm._v("Montant à payer :")]),_c('td',{staticClass:"text-right border-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.situationInvoice.toPaid, _vm.value.currency)))])]),_c('tr',[_c('td',{staticClass:"pt-3 border-0",attrs:{"colspan":"2"}})]),_c('tr',{staticClass:"alert-secondary font-weight-bold"},[_c('td',{staticClass:"border-left"},[_vm._v("Reste à facturer :")]),_c('td',{staticClass:"text-right border-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.stayToBill, _vm.value.currency)))])])])])],1)],1)]:_vm._e()],2)],1)],1)
}
var TransformToSituationInvoicevue_type_template_id_1029123a_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(94394);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TransformToSituationInvoice/TransformToSituationInvoice.ts?vue&type=script&lang=ts&external










var TransformToSituationInvoice = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TransformToSituationInvoice, _super);
    function TransformToSituationInvoice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorMsg = null;
        _this.loading = false;
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        _this.draft = true;
        _this.address = {};
        _this.modalState = false;
        _this.step = 1;
        _this.today = null;
        _this.contents = [];
        _this.valueUpdated = false;
        _this.situationInvoice = {
            situationType: 1,
            depositMode: 1,
            totalHt: 0.0,
            totalTva: 0.0,
            totalTtc: 0.0,
            amount: 0,
            amountType: 'pourcent',
            depositAmount: 0.0,
            toPaid: 0.0
        };
        return _this;
    }
    TransformToSituationInvoice.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        this.today = external_moment_default()().format('YYYY-MM-DD');
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TransformToSituationInvoice.prototype, "computedDisabled", {
        get: function () {
            var _a, _b;
            if (this.disabled) {
                return true;
            }
            return ((_b = (_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.filter(function (invoice) { return invoice.is_draft; }).length) !== null && _b !== void 0 ? _b : 0) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "disabledTitle", {
        get: function () {
            var _a;
            if (!this.computedDisabled) {
                return null;
            }
            return (_a = this.title) !== null && _a !== void 0 ? _a : 'Vous devez valider les factures liées avant de créer une nouvelle facture de situation';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "minDate", {
        get: function () {
            var closed_period = null;
            if (this.team.sales['closed_period']) {
                closed_period = external_moment_default()(this.team.sales['closed_period']).add(1, 'day').format('YYYY-MM-DD');
            }
            var min = null;
            if (!this.teamConfigs.sales_disable_date_check) {
                min = this.team.sales['invoice_date'];
            }
            if (min && (!closed_period || external_moment_default()(min).isAfter(closed_period))) {
                return min;
            }
            else if (closed_period) {
                return closed_period;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "invoices", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.filter(function (invoice) { return !invoice.is_advance && invoice.status !== 7; })) !== null && _b !== void 0 ? _b : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "stayToBillHt", {
        get: function () {
            var _this = this;
            return this.roundNumber(this.value.total_ht - sumBy_default()(this.invoices, function (invoice) { return _this.number(invoice.total_ht); }), 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "stayToBillTva", {
        get: function () {
            var _this = this;
            return this.roundNumber(this.value.total_tva - sumBy_default()(this.invoices, function (invoice) { return _this.number(invoice.total_tva); }), 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "stayToBillTtc", {
        get: function () {
            var _this = this;
            return this.roundNumber(this.value.total_ttc - sumBy_default()(this.invoices, function (invoice) { return _this.number(invoice.total_ttc); }), 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "stayToBill", {
        get: function () {
            return this.roundNumber(this.value.to_bill - this.situationInvoice.totalTtc, 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "nextSituationNumber", {
        get: function () {
            return this.value.situation_count + 1;
        },
        enumerable: false,
        configurable: true
    });
    TransformToSituationInvoice.prototype.watchSituationAmount = function () {
        var _this = this;
        var amount = this.number(this.situationInvoice.amount);
        var pourcent;
        switch (this.situationInvoice.amountType) {
            case 'pourcent':
                pourcent = amount / 100;
                break;
            case 'ht':
                pourcent = amount / this.value.total_ht;
                break;
            case 'ttc':
                pourcent = amount / this.value.total_ttc;
                break;
            default:
                pourcent = 0;
        }
        var totalHT = 0;
        var totalTVA = 0;
        var totalTTC = 0;
        this.value.vatrates.forEach(function (rate) {
            var totalHtLine = _this.roundNumber(rate.ht * pourcent, 2);
            var totalTvaLine = _this.roundNumber(totalHtLine * rate.vat_rate.rate / 100, 2);
            var totalTtcLine = _this.roundNumber(totalHtLine + totalTvaLine, 2);
            totalHT += totalHtLine;
            totalTVA += totalTvaLine;
            totalTTC += totalTtcLine;
        });
        this.situationInvoice.totalHt = totalHT;
        this.situationInvoice.totalTva = totalTVA;
        this.situationInvoice.totalTtc = totalTTC;
        this.calculateDepositAmount(pourcent);
    };
    TransformToSituationInvoice.prototype.calculateDepositAmount = function (pourcent) {
        var totalTTC = this.situationInvoice.totalTtc;
        var depositAmount = this.depositInvoicesAmount;
        if (this.situationInvoice.depositMode === 2) {
            depositAmount = this.roundNumber(depositAmount * pourcent, 2);
        }
        if (depositAmount > totalTTC) {
            depositAmount = totalTTC;
        }
        if (depositAmount > this.availableDepositInvoicesAmount) {
            depositAmount = this.availableDepositInvoicesAmount;
        }
        this.situationInvoice.depositAmount = depositAmount;
        this.situationInvoice.toPaid = this.roundNumber(totalTTC - depositAmount, 2);
    };
    TransformToSituationInvoice.prototype.watchValue = function () {
        this.address = this.value.billing_address;
        if (this.value.situation_count > 0) {
            this.situationInvoice.situationType = this.value.situation_type;
            this.situationInvoice.depositMode = this.value.situation_deposit_mode;
            this.step = 2;
        }
        if (this.value.situation_count === 0 || this.value.situation_type === 2) {
            this.contents = this.value.contents
                .filter(function (content) {
                return !content.is_comments && !content.is_pagebreak && !content.is_subtotal && content.quantity > 0 && content.unit_price_ht > 0;
            })
                .map(function (content) { return ({
                reference: content.reference,
                designation: content.designation,
                affair_content_id: content.affair_content_id,
                unit_price_ht: content.unit_price_ht,
                original_quantity: content.quantity,
                original_total_ht: content.total_ht,
                quantity: 0,
                pourcentage: 0,
                total_ht: 0,
                vat_rate: content.vat_rate,
                billed_amount: content.billed_amount,
                billed_quantity: content.billed_quantity,
                billed_percentage: content.billed_percentage,
                amount_to_bill: content.amount_to_bill,
                quantity_to_bill: content.quantity_to_bill,
                to_bill_percentage: content.to_bill_percentage
            }); });
        }
    };
    TransformToSituationInvoice.prototype.calculateFromQuantity = function (index) {
        var content = this.contents[index];
        content.pourcentage = this.roundNumber((content.quantity * 100) / content.original_quantity, 2);
        content.total_ht = this.roundNumber(content.quantity * content.unit_price_ht, 2);
        this.calculateTotals();
    };
    TransformToSituationInvoice.prototype.calculateFromPourcentage = function (index) {
        var content = this.contents[index];
        content.quantity = this.roundNumber(content.original_quantity * content.pourcentage / 100, 2);
        this.calculateFromQuantity(index);
    };
    TransformToSituationInvoice.prototype.calculateFromTotal = function (index) {
        var content = this.contents[index];
        content.pourcentage = this.roundNumber(content.total_ht * 100 / content.original_total_ht, 2);
        this.calculateFromPourcentage(index);
    };
    TransformToSituationInvoice.prototype.totalByRates = function () {
        var _this = this;
        var rates = [];
        forEach_default()(groupBy_default()(this.contents, 'vat_rate.rate'), function (contents) {
            var rate = contents[0].vat_rate;
            var ht = sumBy_default()(contents, function (content) { return _this.number(content.total_ht); });
            var tva = _this.roundNumber(ht * _this.number(rate.rate) / 100, 2);
            rates.push({
                vat_rate: rate,
                ht: ht,
                tva: tva,
                ttc: _this.roundNumber(ht + tva, 2)
            });
        });
        return rates;
    };
    TransformToSituationInvoice.prototype.calculateTotals = function () {
        var _this = this;
        var totalHt = sumBy_default()(this.contents, function (content) { return _this.number(content.total_ht); });
        var totalTva = sumBy_default()(this.totalByRates(), function (rate) { return rate.tva; });
        this.situationInvoice.totalTva = totalTva;
        this.situationInvoice.totalTtc = this.roundNumber(totalHt + totalTva, 2);
        this.situationInvoice.totalHt = totalHt;
        this.situationInvoice.amountType = 'ht';
        this.calculateDepositAmount(totalHt / this.value.total_ht);
        if (!this.valueUpdated) {
            this.valueUpdated = true;
            this.$nextTick(function () {
                _this.calculateTotals();
            });
        }
    };
    Object.defineProperty(TransformToSituationInvoice.prototype, "depositInvoices", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.filter(function (invoice) { return invoice.is_advance && invoice.status !== 7; })) !== null && _b !== void 0 ? _b : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "depositInvoicesAmount", {
        get: function () {
            var _this = this;
            var _a;
            return sumBy_default()((_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.filter(function (invoice) { return invoice.is_advance && invoice.status !== 7; }), function (invoice) { return _this.number(invoice.total_ttc); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "availableDepositInvoicesAmount", {
        get: function () {
            var _this = this;
            var _a;
            return this.depositInvoicesAmount - sumBy_default()((_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.filter(function (invoice) { return !invoice.is_advance && invoice.status !== 7; }), function (invoice) { return _this.number(invoice.total_advance_ttc); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "formUrl", {
        get: function () {
            return '/sales/' + this.type + '/' + this.value.id + '/bill-situation';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "okTitle", {
        get: function () {
            if (this.errorMsg) {
                return 'Fermer';
            }
            if (this.step === 1) {
                return this.$t('interface.continue');
            }
            return 'Créer la facture';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "formDatas", {
        get: function () {
            var datas = {
                is_draft: this.draft,
                date: this.date
            };
            var situation = this.situationInvoice;
            if (this.value.situation_count === 0) {
                datas.situation_type = situation.situationType;
                datas.situation_deposit_mode = situation.depositMode;
            }
            if (situation.situationType === 1) {
                datas.amount = situation.amount;
                datas.amount_type = situation.amountType;
            }
            else {
                datas.contents = this.contents.map(function (content) { return ({
                    id: content.affair_content_id,
                    quantity: content.quantity
                }); });
            }
            if (this.address.road)
                datas.billing_address_road = this.address.road;
            if (this.address.road2)
                datas.billing_address_road2 = this.address.road2;
            if (this.address.road3)
                datas.billing_address_road3 = this.address.road3;
            if (this.address.city)
                datas.billing_address_city = this.address.city;
            if (this.address.postal_code)
                datas.billing_address_postal_code = this.address.postal_code;
            if (this.address.country)
                datas.billing_address_country = this.address.country.code;
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformToSituationInvoice.prototype, "maxAmount", {
        get: function () {
            var _this = this;
            var _a;
            switch (this.situationInvoice.amountType) {
                case 'pourcent':
                    return this.value.pourcent_to_bill;
                case 'ht':
                    return this.value.total_ht - sumBy_default()((_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.filter(function (invoice) { return invoice.is_situation; }), function (invoice) { return _this.number(invoice.total_ht); });
                case 'ttc':
                    return this.value.to_bill;
            }
        },
        enumerable: false,
        configurable: true
    });
    TransformToSituationInvoice.prototype.setDefaultValues = function () {
        this.step = this.value.situation_count === 0 ? 1 : 2;
        this.date = external_moment_default()().format('YYYY-MM-DD');
        this.draft = true;
        this.errorMsg = null;
    };
    TransformToSituationInvoice.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({
                            name: 'invoice-item',
                            params: {
                                id: response.data.id
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TransformToSituationInvoice.prototype.submitError = function (error) {
        var _a;
        var response = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        this.errorMsg = response === null || response === void 0 ? void 0 : response.message;
    };
    TransformToSituationInvoice.prototype.onOk = function (event) {
        if (this.errorMsg !== null) {
            return;
        }
        event.preventDefault();
        if (this.step === 1) {
            this.step = 2;
            return;
        }
        else {
            this.$refs.form.submit();
        }
    };
    TransformToSituationInvoice.prototype.globalAmountTypes = function () {
        var _a;
        var pourcent = (_a = this.value.currency) === null || _a === void 0 ? void 0 : _a.symbol;
        return [
            { label: '%', value: 'pourcent' },
            { label: pourcent + ' HT', value: 'ht' },
            { label: pourcent + ' TTC', value: 'ttc' }
        ];
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToSituationInvoice.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToSituationInvoice.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TransformToSituationInvoice.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Créer une facture de situation' })
    ], TransformToSituationInvoice.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToSituationInvoice.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TransformToSituationInvoice.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToSituationInvoice.prototype, "title", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('situationInvoice.amount'),
        (0,lib/* Watch */.ox)('situationInvoice.amountType'),
        (0,lib/* Watch */.ox)('situationInvoice.depositMode')
    ], TransformToSituationInvoice.prototype, "watchSituationAmount", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TransformToSituationInvoice.prototype, "watchValue", null);
    TransformToSituationInvoice = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect, FroalaView: form_vue_.FroalaView, KFormSpinner: form_vue_.KFormSpinner, KFormAddress: form_vue_.KFormAddress,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRow: external_bootstrap_vue_.BFormRow, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BModal: external_bootstrap_vue_.BModal
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency', 'teamConfigs', 'team'])), (0,external_vuex_.mapState)('globalDatas', ['countries'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], TransformToSituationInvoice);
    return TransformToSituationInvoice;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var TransformToSituationInvoicevue_type_script_lang_ts_external = (TransformToSituationInvoice);

;// ./src/components/TransformToSituationInvoice/TransformToSituationInvoice.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TransformToSituationInvoice_TransformToSituationInvoicevue_type_script_lang_ts_external = (TransformToSituationInvoicevue_type_script_lang_ts_external); 
;// ./src/components/TransformToSituationInvoice/TransformToSituationInvoice.vue





/* normalize component */
;
var TransformToSituationInvoice_component = (0,componentNormalizer/* default */.A)(
  TransformToSituationInvoice_TransformToSituationInvoicevue_type_script_lang_ts_external,
  TransformToSituationInvoicevue_type_template_id_1029123a_render,
  TransformToSituationInvoicevue_type_template_id_1029123a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TransformToSituationInvoice_TransformToSituationInvoice = (TransformToSituationInvoice_component.exports);
// EXTERNAL MODULE: ./src/components/DocumentStatus/DocumentStatus.vue + 3 modules
var DocumentStatus = __webpack_require__(22090);
// EXTERNAL MODULE: ./src/components/TransformToInvoice/TransformToInvoice.vue + 3 modules
var TransformToInvoice = __webpack_require__(50964);
// EXTERNAL MODULE: ./src/components/DocumentDelete/DocumentDelete.vue + 3 modules
var DocumentDelete = __webpack_require__(30104);
// EXTERNAL MODULE: ./src/components/DocumentStatusSelector/DocumentStatusSelector.vue + 3 modules
var DocumentStatusSelector = __webpack_require__(76873);
// EXTERNAL MODULE: ./src/components/DocumentDelivery/DocumentDelivery.vue + 3 modules
var DocumentDelivery = __webpack_require__(38310);
// EXTERNAL MODULE: ./src/components/CancelInvoice/CancelInvoice.vue + 3 modules
var CancelInvoice = __webpack_require__(57114);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UseCreditButton/UseCreditButton.vue?vue&type=template&id=045e68f3
var UseCreditButtonvue_type_template_id_045e68f3_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",modifiers:{"right":true}}],tag:"component",attrs:{"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled,"title":_vm.disabledTitle},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" "),_c('FormModal',{attrs:{"title":_vm.modalTitle,"ok-title":_vm.okTitle,"ok-only":_vm.errorMsg !== null},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.errorMsg !== null)?_c('p',{staticClass:"font-weight-bold text-danger mb-0 text-center"},[_vm._v(" Erreur : "+_vm._s(_vm.errorMsg)+" ")]):(_vm.invoice)?[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Facture n°"+_vm._s(_vm.invoice.reference)),_c('br'),_vm._v(" Reste à payer : "+_vm._s(_vm.formattedNumber(_vm.invoice.stay_to_pay, _vm.invoice.currency))+" ")]),_c('UseCredit',{attrs:{"invoice":_vm.invoice,"credit":_vm.credit},on:{"success":result => _vm.$emit('success', result),"noCredits":function($event){_vm.errorMsg = 'Aucun avoir n\'est disponible pour ce client.'}}})]:_vm._e()],2)],1)
}
var UseCreditButtonvue_type_template_id_045e68f3_staticRenderFns = []


// EXTERNAL MODULE: ./src/components/UseCredit/UseCredit.vue + 3 modules
var UseCredit = __webpack_require__(34109);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UseCreditButton/UseCreditButton.ts?vue&type=script&lang=ts&external






var UseCreditButton = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UseCreditButton, _super);
    function UseCreditButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(UseCreditButton.prototype, "computedLabel", {
        get: function () {
            if (this.label) {
                return this.label;
            }
            if (this.invoice) {
                return 'Solder avec un avoir';
            }
            else {
                return 'Solder une facture';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseCreditButton.prototype, "modalTitle", {
        get: function () {
            if (this.invoice) {
                return 'Solder la facture avec un avoir';
            }
            return 'Utiliser l\'avoir pour solder une facture';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseCreditButton.prototype, "okTitle", {
        get: function () {
            if (this.errorMsg) {
                return this.$t('interface.close');
            }
            else {
                return 'Utiliser l\'avoir';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseCreditButton.prototype, "disabledTitle", {
        get: function () {
            if (this.invoice && this.invoice.is_draft) {
                return 'Cette facture est au statut Brouillon';
            }
            else if (this.invoice && this.invoice.stay_to_pay <= 0) {
                return 'Cette facture a déjà un reste à payer à 0';
            }
            else if (this.credit && this.credit.is_draft) {
                return 'Cet avoir est au statut Brouillon';
            }
            else if (this.credit && this.credit.stay_to_pay <= 0) {
                return 'Cet avoir est déjà utilisé';
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseCreditButton.prototype, "disabled", {
        get: function () {
            if (this.invoice && (this.invoice.stay_to_pay <= 0 || this.invoice.is_draft)) {
                return true;
            }
            else if (this.credit && (this.credit.stay_to_pay <= 0 || this.invoice.is_draft)) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseCreditButton.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseCreditButton.prototype, "invoice", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseCreditButton.prototype, "credit", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], UseCreditButton.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseCreditButton.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseCreditButton.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseCreditButton.prototype, "size", void 0);
    UseCreditButton = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BInputGroup: external_bootstrap_vue_.BInputGroup,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect,
                UseCredit: UseCredit/* default */.A
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], UseCreditButton);
    return UseCreditButton;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var UseCreditButtonvue_type_script_lang_ts_external = (UseCreditButton);

;// ./src/components/UseCreditButton/UseCreditButton.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UseCreditButton_UseCreditButtonvue_type_script_lang_ts_external = (UseCreditButtonvue_type_script_lang_ts_external); 
;// ./src/components/UseCreditButton/UseCreditButton.vue





/* normalize component */
;
var UseCreditButton_component = (0,componentNormalizer/* default */.A)(
  UseCreditButton_UseCreditButtonvue_type_script_lang_ts_external,
  UseCreditButtonvue_type_template_id_045e68f3_render,
  UseCreditButtonvue_type_template_id_045e68f3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UseCreditButton_UseCreditButton = (UseCreditButton_component.exports);
// EXTERNAL MODULE: ./src/components/PaymentFormButton/PaymentFormButton.vue + 3 modules
var PaymentFormButton = __webpack_require__(72827);
// EXTERNAL MODULE: ./src/components/PaymentList/PaymentList.vue + 3 modules
var PaymentList = __webpack_require__(45179);
// EXTERNAL MODULE: ./src/components/CancelGuaranteeHoldback/CancelGuaranteeHoldback.vue + 3 modules
var CancelGuaranteeHoldback = __webpack_require__(81593);
// EXTERNAL MODULE: ./src/components/CreateProviderCommand/CreateProviderCommand.vue + 3 modules
var CreateProviderCommand = __webpack_require__(61954);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TransformToConstruction/TransformToConstruction.vue?vue&type=template&id=406b9f2e
var TransformToConstructionvue_type_template_id_406b9f2e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_vm._v(" Êtes-vous sûr de vouloir créer un chantier ? ")]],2)],1)
}
var TransformToConstructionvue_type_template_id_406b9f2e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TransformToConstruction/TransformToConstruction.ts?vue&type=script&lang=ts&external




var TransformToConstruction = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TransformToConstruction, _super);
    function TransformToConstruction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(TransformToConstruction.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    TransformToConstruction.prototype.watchModal = function (state) {
        if (state) {
            this.modalState = true;
        }
    };
    TransformToConstruction.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    TransformToConstruction.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.post('/sales/' + this.type + '/' + this.value.id + '/construction')
            .then(function (response) {
            _this.success(response.data);
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    TransformToConstruction.prototype.closeModal = function () {
        this.errorMsg = null;
        return false;
    };
    TransformToConstruction.prototype.success = function (construction) {
        return construction;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToConstruction.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TransformToConstruction.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TransformToConstruction.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Créer un chantier' })
    ], TransformToConstruction.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TransformToConstruction.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TransformToConstruction.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TransformToConstruction.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal')
    ], TransformToConstruction.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], TransformToConstruction.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], TransformToConstruction.prototype, "closeModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], TransformToConstruction.prototype, "success", null);
    TransformToConstruction = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            }
        })
    ], TransformToConstruction);
    return TransformToConstruction;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var TransformToConstructionvue_type_script_lang_ts_external = (TransformToConstruction);

;// ./src/components/TransformToConstruction/TransformToConstruction.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TransformToConstruction_TransformToConstructionvue_type_script_lang_ts_external = (TransformToConstructionvue_type_script_lang_ts_external); 
;// ./src/components/TransformToConstruction/TransformToConstruction.vue





/* normalize component */
;
var TransformToConstruction_component = (0,componentNormalizer/* default */.A)(
  TransformToConstruction_TransformToConstructionvue_type_script_lang_ts_external,
  TransformToConstructionvue_type_template_id_406b9f2e_render,
  TransformToConstructionvue_type_template_id_406b9f2e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TransformToConstruction_TransformToConstruction = (TransformToConstruction_component.exports);
// EXTERNAL MODULE: ./src/components/UsedCredits/UsedCredits.vue + 3 modules
var UsedCredits = __webpack_require__(55149);
// EXTERNAL MODULE: ./src/components/CreditsUses/CreditsUses.vue + 4 modules
var CreditsUses = __webpack_require__(26199);
// EXTERNAL MODULE: ./src/components/StripeSend/StripeSend.vue + 3 modules
var StripeSend = __webpack_require__(12658);
// EXTERNAL MODULE: ./src/components/SignSend/SignSend.vue + 4 modules
var SignSend = __webpack_require__(30210);
// EXTERNAL MODULE: ./src/components/SignState/SignState.vue + 3 modules
var SignState = __webpack_require__(66346);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AttachChargeForm/AttachChargeForm.vue?vue&type=template&id=5cd1d052
var AttachChargeFormvue_type_template_id_5cd1d052_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":"Rattachement d'une charge","ok-title":_vm.$t('interface.' + (_vm.charge !== null || _vm.typeCharge === 2 ? 'save' : 'close')),"cancel-title":_vm.$t('interface.' + (_vm.typeCharge === 1 && _vm.charge === null ? 'close' : 'cancel')),"ok-only":!_vm.charge && _vm.typeCharge === 1,"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"size":"xl","lazy":""},on:{"hidden":_vm.onHidden},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:(_vm.charge === null)?[(!_vm.value?.id)?_c('b-form-radio-group',{staticClass:"mb-3",model:{value:(_vm.typeCharge),callback:function ($$v) {_vm.typeCharge=$$v},expression:"typeCharge"}},[_c('b-form-radio',{attrs:{"value":1}},[_vm._v(" Rattacher une charge ")]),_c('b-form-radio',{attrs:{"value":2}},[_vm._v(" Renseigner une charge ")])],1):_vm._e(),(_vm.typeCharge === 1)?[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('CustomerSelect',{attrs:{"label":"Fournisseur","withForm":false,"type":"provider","size":"sm"},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Date"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-2",attrs:{"cols":"auto"}},[_vm._v(" Du ")]),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"max-date":_vm.end,"size":"sm"},model:{value:(_vm.begin),callback:function ($$v) {_vm.begin=$$v},expression:"begin"}})],1),_c('b-col',{staticClass:"px-2",attrs:{"cols":"auto"}},[_vm._v(" au ")]),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"min-date":_vm.begin,"size":"sm"},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],1)],1)],1),_c('b-col',[_c('b-button',{staticClass:"mt-4",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[_vm._v(" Rechercher ")])],1)],1),(_vm.searched)?[(_vm.searching)?_c('Spinner'):_c('b-table-simple',{attrs:{"bordered":"","small":"","striped":"","table-class":"align-middle text-nowrap","responsive":""}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Fournisseur")]),_c('th',[_vm._v("N° charge")]),_c('th',[_vm._v("Date")]),_c('th',[_vm._v("Total HT")]),_c('th',[_vm._v("Total TVA")]),_c('th',[_vm._v("Total TTC")]),_c('th',{staticStyle:{"width":"40px"}})])]),_c('tbody',[(_vm.total === 0)?_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"7"}},[_vm._v(" Aucune charge ")])]):_vm._e(),_vm._l((_vm.charges),function(charge,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(charge.customer?.name))]),_c('td',[_vm._v(_vm._s(charge.reference))]),_c('td',[_vm._v(_vm._s(_vm.date(charge.date)))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(charge.total_ht, charge.currency)))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(charge.total_tva, charge.currency)))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(charge.total_ttc, charge.currency)))]),_c('td',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.selectCharge(charge)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'arrow-right']}})],1)],1)])})],2)]),_c('b-pagination',{attrs:{"total-rows":_vm.total,"size":"sm","align":"center"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})]:_vm._e()]:[_c('k-form',{attrs:{"method":_vm.value?.id ? 'PUT' : 'POST',"action":_vm.formAction},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":"Désignation"}},[_c('k-form-editor',{attrs:{"mode":"simple","size":"sm","required":"","name":"designation"},model:{value:(_vm.designation),callback:function ($$v) {_vm.designation=$$v},expression:"designation"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Prix Unitaire HT"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_ht"},model:{value:(_vm.unitPriceHt),callback:function ($$v) {_vm.unitPriceHt=$$v},expression:"unitPriceHt"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Quantité"}},[_c('k-form-spinner',{attrs:{"name":"quantity"},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{staticClass:"form-text",attrs:{"label":"Total HT","label-class":"mb-1"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.totalHT))+" ")])],1)],1)],1)]]:[_c('b-button',{staticClass:"mb-3",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.backAllCharges.apply(null, arguments)}}},[_vm._v(" Retour ")]),_c('k-form',{attrs:{"action":'/sales/affair/' + _vm.affair?.id + '/charge'},on:{"submitComplete":_vm.submitComplete}},[_c('input',{attrs:{"type":"hidden","name":"charge"},domProps:{"value":_vm.charge.id}}),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Fournisseur"}},[_vm._v(" "+_vm._s(_vm.charge.customer?.name)+" ")])],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Date"}},[_vm._v(" "+_vm._s(_vm.date(_vm.charge.date))+" ")])],1),_c('b-col'),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Total HT"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.charge.total_ht, _vm.charge.currency))+" ")])],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Total TVA"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.charge.total_tva, _vm.charge.currency))+" ")])],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Total TTC"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.charge.total_ttc, _vm.charge.currency))+" ")])],1)],1),_c('h2',{staticClass:"form-title-alt mt-3"},[_vm._v(" Contenu de la charge ")]),_c('b-table-simple',{attrs:{"small":"","bordered":"","table-class":"align-middle text-nowrap","responsive":""}},[_c('thead',[_c('tr',{staticClass:"text-center"},[_c('th',{staticClass:"text-left"},[_vm._v("Désignation")]),_c('th',[_vm._v("Prix U. HT")]),_c('th',[_vm._v("Quantité")]),_c('th',[_vm._v("Total HT")]),_c('th',{staticStyle:{"width":"100px"}},[_c('b-button',{staticClass:"sales-select-all-charges",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.selectAll.apply(null, arguments)}}},[_vm._v(" Tout ")])],1)])]),_c('tbody',_vm._l((_vm.charge?.contents),function(content,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-wrap"},[_c('FroalaView',{attrs:{"value":content.designation}})],1),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(content.unit_price_ht, _vm.charge.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formattedNumber(content.quantity, false)))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(content.total_ht, _vm.charge.currency)))]),_c('td',{staticClass:"text-center"},[_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][id]'},domProps:{"value":content.id}}),_c('k-form-spinner',{attrs:{"name":'contents[' + i + '][quantity]',"max":content.quantity,"maxDecimal":2,"size":"sm"},model:{value:(_vm.quantities[i]),callback:function ($$v) {_vm.$set(_vm.quantities, i, $$v)},expression:"quantities[i]"}})],1)])}),0)])],1)]],2)
}
var AttachChargeFormvue_type_template_id_5cd1d052_staticRenderFns = []


;// external "@kwixeo/charges-vue"
var charges_vue_namespaceObject = require("@kwixeo/charges-vue");
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AttachChargeForm/AttachChargeForm.ts?vue&type=script&lang=ts&external









var AttachChargeForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AttachChargeForm, _super);
    function AttachChargeForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.searched = false;
        _this.searching = false;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.typeCharge = 1;
        _this.customer = null;
        _this.begin = null;
        _this.end = null;
        _this.charges = null;
        _this.total = 0;
        _this.page = 1;
        _this.charge = null;
        _this.quantities = {};
        _this.unitPriceHt = 0;
        _this.quantity = 1;
        _this.designation = null;
        return _this;
    }
    Object.defineProperty(AttachChargeForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/sales/affair/';
            var id = (_a = this.value) === null || _a === void 0 ? void 0 : _a.id;
            if (id) {
                return url += 'charge/' + id;
            }
            if (this.affair) {
                url += this.affair.id;
            }
            else if (this.value) {
                url += this.value.affair_id;
            }
            return url + '/charge';
        },
        enumerable: false,
        configurable: true
    });
    AttachChargeForm.prototype.watchValue = function (value) {
        if (!value) {
            return;
        }
        this.typeCharge = value.charge_content_id ? 1 : 2;
        if (this.typeCharge === 2) {
            this.unitPriceHt = value.unit_price_ht;
            this.quantity = value.quantity;
            this.designation = value.designation;
        }
    };
    AttachChargeForm.prototype.watchModal = function () {
        this.modalState = this.modal;
    };
    AttachChargeForm.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
            this.charge = null;
            this.searched = false;
            this.quantities = {};
            this.designation = null;
            this.unitPriceHt = 0;
            this.quantity = 1;
        }
    };
    Object.defineProperty(AttachChargeForm.prototype, "totalHT", {
        get: function () {
            return this.roundNumber(this.unitPriceHt * this.quantity, 2);
        },
        enumerable: false,
        configurable: true
    });
    AttachChargeForm.prototype.search = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var filter;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.searching = true;
                        this.searched = true;
                        filter = {
                            type: 1
                        };
                        if (this.customer) {
                            filter.customer = this.customer.id;
                        }
                        if (this.begin) {
                            filter.date_since = this.begin;
                        }
                        if (this.end) {
                            filter.date_until = this.end;
                        }
                        return [4 /*yield*/, this.$kwSales.axios.get('/charge', {
                                params: {
                                    include: ['customer', 'currency'],
                                    filter: filter,
                                    sort: ['date:desc'],
                                    page: this.page,
                                    per_page: 20
                                }
                            })
                                .then(function (response) {
                                _this.charges = response.data.data;
                                _this.total = response.data.meta.total;
                                _this.searching = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AttachChargeForm.prototype.selectCharge = function (charge) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, (0,charges_vue_namespaceObject.fetchCharge)(charge.id)];
                    case 1:
                        _a.charge = _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AttachChargeForm.prototype.backAllCharges = function () {
        this.charge = null;
        this.quantities = {};
    };
    AttachChargeForm.prototype.onHidden = function () {
        this.errorMsg = null;
    };
    AttachChargeForm.prototype.selectAll = function () {
        var _a;
        var quantities = {};
        (_a = this.charge) === null || _a === void 0 ? void 0 : _a.contents.forEach(function (content, i) {
            quantities[i] = content.quantity;
        });
        this.quantities = quantities;
    };
    AttachChargeForm.prototype.submitComplete = function (response) {
        interface_vue_.emitter.emit('affairChargeUpdate', response.data);
        this.$emit('affairChargeUpdate', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AttachChargeForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AttachChargeForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AttachChargeForm.prototype, "affair", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], AttachChargeForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal')
    ], AttachChargeForm.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], AttachChargeForm.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('hidden')
    ], AttachChargeForm.prototype, "onHidden", null);
    AttachChargeForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BTableSimple: external_bootstrap_vue_.BTableSimple, BPagination: external_bootstrap_vue_.BPagination, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BFormRadio: external_bootstrap_vue_.BFormRadio, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BInputGroup: external_bootstrap_vue_.BInputGroup,
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, FroalaView: form_vue_.FroalaView, KFormSpinner: form_vue_.KFormSpinner, KFormEditor: form_vue_.KFormEditor, KFormNumber: form_vue_.KFormNumber,
                CustomerSelect: customers_vue_.CustomerSelect,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency']))
        })
    ], AttachChargeForm);
    return AttachChargeForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var AttachChargeFormvue_type_script_lang_ts_external = (AttachChargeForm);

;// ./src/components/AttachChargeForm/AttachChargeForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AttachChargeForm_AttachChargeFormvue_type_script_lang_ts_external = (AttachChargeFormvue_type_script_lang_ts_external); 
;// ./src/components/AttachChargeForm/AttachChargeForm.vue





/* normalize component */
;
var AttachChargeForm_component = (0,componentNormalizer/* default */.A)(
  AttachChargeForm_AttachChargeFormvue_type_script_lang_ts_external,
  AttachChargeFormvue_type_template_id_5cd1d052_render,
  AttachChargeFormvue_type_template_id_5cd1d052_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AttachChargeForm_AttachChargeForm = (AttachChargeForm_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AttachChargeList/AttachChargeList.vue?vue&type=template&id=15dfdb60
var AttachChargeListvue_type_template_id_15dfdb60_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100"},[_c('k-table',{ref:"table",attrs:{"url":"/sales/affair/charge","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"stateKey":"affair-charges-list"}}),_c('AttachChargeForm',{attrs:{"modal":_vm.editCharge !== null,"value":_vm.editCharge},on:{"hidden":function($event){_vm.editCharge = null}}}),(_vm.deleteCharge)?_c('AttachChargeDelete',{attrs:{"modal":true,"value":_vm.deleteCharge},on:{"closed":function($event){_vm.deleteCharge = null}}}):_vm._e()],1)
}
var AttachChargeListvue_type_template_id_15dfdb60_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AttachChargeDelete/AttachChargeDelete.vue?vue&type=template&id=cd0f4c72
var AttachChargeDeletevue_type_template_id_cd0f4c72_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer cette charge ?")])]],2)],1)
}
var AttachChargeDeletevue_type_template_id_cd0f4c72_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AttachChargeDelete/AttachChargeDelete.ts?vue&type=script&lang=ts&external




var AttachChargeDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AttachChargeDelete, _super);
    function AttachChargeDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(AttachChargeDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    AttachChargeDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    AttachChargeDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    AttachChargeDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/sales/affair/charge/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    AttachChargeDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    AttachChargeDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    AttachChargeDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('affairChargeUpdate', { deleted: [this.value.id] });
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AttachChargeDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], AttachChargeDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], AttachChargeDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AttachChargeDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AttachChargeDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AttachChargeDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], AttachChargeDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], AttachChargeDelete.prototype, "watchModalState", null);
    AttachChargeDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], AttachChargeDelete);
    return AttachChargeDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var AttachChargeDeletevue_type_script_lang_ts_external = (AttachChargeDelete);

;// ./src/components/AttachChargeDelete/AttachChargeDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AttachChargeDelete_AttachChargeDeletevue_type_script_lang_ts_external = (AttachChargeDeletevue_type_script_lang_ts_external); 
;// ./src/components/AttachChargeDelete/AttachChargeDelete.vue





/* normalize component */
;
var AttachChargeDelete_component = (0,componentNormalizer/* default */.A)(
  AttachChargeDelete_AttachChargeDeletevue_type_script_lang_ts_external,
  AttachChargeDeletevue_type_template_id_cd0f4c72_render,
  AttachChargeDeletevue_type_template_id_cd0f4c72_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AttachChargeDelete_AttachChargeDelete = (AttachChargeDelete_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AttachChargeList/AttachChargeList.ts?vue&type=script&lang=ts&external






var AttachChargeList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AttachChargeList, _super);
    function AttachChargeList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editCharge = null;
        _this.deleteCharge = null;
        return _this;
    }
    AttachChargeList.prototype.mounted = function () {
        interface_vue_.emitter.on('affairChargeUpdate', this.updateCharges);
    };
    AttachChargeList.prototype.destroyed = function () {
        interface_vue_.emitter.off('affairChargeUpdate', this.updateCharges);
    };
    Object.defineProperty(AttachChargeList.prototype, "ajaxDatas", {
        get: function () {
            var filter = {};
            if (this.affair) {
                filter.affair = Array.isArray(this.affair) ? this.affair.map(function (affair) { return affair.id; }) : this.affair.id;
            }
            return {
                include: ['charge_content', 'charge_content.charge'],
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachChargeList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'charge_content.charge.reference',
                    name: 'N° charge',
                    render: function (reference) { return reference !== null && reference !== void 0 ? reference : '-'; }
                },
                {
                    data: 'designation',
                    name: 'Désignation',
                    isHtml: true,
                    render: function (data, row) {
                        var _a, _b, _c;
                        return (_c = (_b = (_a = row.charge_content) === null || _a === void 0 ? void 0 : _a.designation) !== null && _b !== void 0 ? _b : data) !== null && _c !== void 0 ? _c : null;
                    }
                },
                {
                    data: 'unit_price_ht',
                    name: 'Prix U. HT',
                    render: 'currency'
                },
                {
                    data: 'quantity',
                    name: 'Quantité',
                    render: 'number'
                },
                {
                    data: 'total_ht',
                    name: 'Total HT',
                    render: 'currency'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttachChargeList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    condition: function (charge) {
                        return charge.charge_content_id === null;
                    },
                    click: function (charge) {
                        _this.editCharge = charge;
                    }
                },
                {
                    icon: 'delete',
                    click: function (charge) {
                        _this.deleteCharge = charge;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    AttachChargeList.prototype.rowLink = function (row) {
        var _a, _b;
        if (!((_b = (_a = row.charge_content) === null || _a === void 0 ? void 0 : _a.charge) === null || _b === void 0 ? void 0 : _b.id)) {
            return null;
        }
        return {
            name: 'charges-item',
            params: { id: String(row.charge_content.charge.id) }
        };
    };
    AttachChargeList.prototype.updateCharges = function (datas) {
        var _this = this;
        var _a, _b;
        var table = this.$refs.table;
        var tableDatas = table.getDatas();
        var updateAmount = 0;
        var deleted = (_a = datas.deleted) !== null && _a !== void 0 ? _a : [];
        deleted.forEach(function (id) {
            var index = tableDatas.findIndex(function (data) { return data.id === id; });
            if (index >= 0) {
                updateAmount -= tableDatas[index].total_ht;
                table.deleteRow(index);
            }
        });
        var elements = (_b = datas.elements) !== null && _b !== void 0 ? _b : [];
        elements.forEach(function (element) {
            var index = tableDatas.findIndex(function (data) { return data.id === element.id; });
            if (index >= 0) {
                updateAmount += element.total_ht - tableDatas[index].total_ht;
                table.updateRow(index, element);
            }
            else {
                updateAmount += _this.number(element.total_ht);
                table.addRow(element);
            }
        });
        this.$emit('updateAmount', updateAmount);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AttachChargeList.prototype, "affair", void 0);
    AttachChargeList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                AttachChargeForm: AttachChargeForm_AttachChargeForm,
                AttachChargeDelete: AttachChargeDelete_AttachChargeDelete
            }
        })
    ], AttachChargeList);
    return AttachChargeList;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var AttachChargeListvue_type_script_lang_ts_external = (AttachChargeList);

;// ./src/components/AttachChargeList/AttachChargeList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AttachChargeList_AttachChargeListvue_type_script_lang_ts_external = (AttachChargeListvue_type_script_lang_ts_external); 
;// ./src/components/AttachChargeList/AttachChargeList.vue





/* normalize component */
;
var AttachChargeList_component = (0,componentNormalizer/* default */.A)(
  AttachChargeList_AttachChargeListvue_type_script_lang_ts_external,
  AttachChargeListvue_type_template_id_15dfdb60_render,
  AttachChargeListvue_type_template_id_15dfdb60_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AttachChargeList_AttachChargeList = (AttachChargeList_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DownloadAcquittedInvoice/DownloadAcquittedInvoice.vue?vue&type=template&id=4961a657
var DownloadAcquittedInvoicevue_type_template_id_4961a657_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",value:({ title: _vm.disabled ? 'La facture doit être payée pour générer une facture acquittée' : null }),expression:"{ title: disabled ? 'La facture doit être payée pour générer une facture acquittée' : null }",modifiers:{"right":true}}],tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.close'),"ok-only":""},on:{"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('Spinner'),_vm._v(" Génération du PDF en cours... ")],1):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:_c('div',{staticClass:"text-center"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary"},on:{"click":_vm.send}},[_vm._v(" Envoyer par email ")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.download}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")])],1)],2)],1)
}
var DownloadAcquittedInvoicevue_type_template_id_4961a657_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DownloadAcquittedInvoice/DownloadAcquittedInvoice.ts?vue&type=script&lang=ts&external





var DownloadAcquittedInvoice = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DownloadAcquittedInvoice, _super);
    function DownloadAcquittedInvoice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.file = null;
        return _this;
    }
    Object.defineProperty(DownloadAcquittedInvoice.prototype, "disabled", {
        get: function () {
            return this.invoice.already_paid <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DownloadAcquittedInvoice.prototype, "label", {
        get: function () {
            return this.invoice.stay_to_pay <= 0 ? 'Facture acquittée' : 'Facture avec paiement(s)';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DownloadAcquittedInvoice.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    DownloadAcquittedInvoice.prototype.watchModalState = function (state, old) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(state && !old)) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.process()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DownloadAcquittedInvoice.prototype.process = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.errorMsg) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/invoice/' + this.invoice.id + '/acquitted')
                                .then(function (response) {
                                _this.file = response.data;
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                _this.errorMsg = error.response.data.message;
                                _this.file = null;
                                throw new Error(error);
                            })
                                .then(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DownloadAcquittedInvoice.prototype.closeModal = function () {
        this.errorMsg = null;
        return false;
    };
    DownloadAcquittedInvoice.prototype.download = function () {
        this.downloadFile(this.file, this.invoice.reference + '.pdf');
    };
    DownloadAcquittedInvoice.prototype.send = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var datas;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadSenders()];
                    case 1:
                        _a.sent();
                        datas = new FormData();
                        if (this.defaultSender) {
                            datas.append('sender', String(this.defaultSender.id));
                        }
                        datas.append('elements[0][id]', String(this.invoice.id));
                        datas.append('elements[0][type]', 'invoice');
                        datas.append('add_attachments[0]', new File([this.base64ToBlob(this.file)], this.invoice.reference + '.pdf', { type: 'application/pdf' }));
                        return [4 /*yield*/, this.$kwSales.axios.post('/mail/draft', datas, { headers: { 'Content-Type': 'multipart/form-data' } })
                                .then(function (response) {
                                _this.openMailForm({
                                    customer: _this.invoice.customer,
                                    contact: _this.invoice.contact,
                                    mail: response.data
                                });
                                _this.modalState = false;
                                _this.loading = false;
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DownloadAcquittedInvoice.prototype, "invoice", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], DownloadAcquittedInvoice.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DownloadAcquittedInvoice.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], DownloadAcquittedInvoice.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], DownloadAcquittedInvoice.prototype, "closeModal", null);
    DownloadAcquittedInvoice = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['openMailForm', 'loadSenders'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('communication', ['defaultSender'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], DownloadAcquittedInvoice);
    return DownloadAcquittedInvoice;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var DownloadAcquittedInvoicevue_type_script_lang_ts_external = (DownloadAcquittedInvoice);

;// ./src/components/DownloadAcquittedInvoice/DownloadAcquittedInvoice.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DownloadAcquittedInvoice_DownloadAcquittedInvoicevue_type_script_lang_ts_external = (DownloadAcquittedInvoicevue_type_script_lang_ts_external); 
;// ./src/components/DownloadAcquittedInvoice/DownloadAcquittedInvoice.vue





/* normalize component */
;
var DownloadAcquittedInvoice_component = (0,componentNormalizer/* default */.A)(
  DownloadAcquittedInvoice_DownloadAcquittedInvoicevue_type_script_lang_ts_external,
  DownloadAcquittedInvoicevue_type_template_id_4961a657_render,
  DownloadAcquittedInvoicevue_type_template_id_4961a657_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DownloadAcquittedInvoice_DownloadAcquittedInvoice = (DownloadAcquittedInvoice_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OldDocumentsList/OldDocumentsList.vue?vue&type=template&id=1f2dd7b8
var OldDocumentsListvue_type_template_id_1f2dd7b8_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.documents.length > 0)?_c('b-card',[(_vm.loading)?_c('Spinner'):[_c('h3',{staticClass:"form-title-alt mt-0"},[_vm._v(" Ancienne(s) version(s) ")]),_c('b-table',{staticClass:"small",attrs:{"fields":_vm.fields,"items":_vm.documents,"per-page":_vm.perPage,"current-page":_vm.page,"small":""},scopedSlots:_vm._u([{key:"cell(created_at)",fn:function({ value }){return [_vm._v(" "+_vm._s(_vm.datetime(value))+" ")]}},{key:"cell(id)",fn:function({ item }){return [_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",modifiers:{"right":true}}],staticClass:"p-0",attrs:{"variant":"icon","title":"Télécharger le PDF"},on:{"click":function($event){$event.preventDefault();return _vm.downloadOldVersion(item.id)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'file-pdf']}})],1)]}}],null,false,4228515901)}),(_vm.total > _vm.perPage)?_c('b-pagination',{attrs:{"per-page":_vm.perPage,"total-rows":_vm.total,"size":"sm","align":"center"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()]],2):_vm._e()
}
var OldDocumentsListvue_type_template_id_1f2dd7b8_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/OldDocumentsList/OldDocumentsList.ts?vue&type=script&lang=ts&external





var OldDocumentsList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OldDocumentsList, _super);
    function OldDocumentsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.page = 1;
        _this.perPage = 10;
        _this.fields = [
            {
                key: 'created_at',
                label: 'Date de création'
            },
            {
                key: 'version',
                label: 'Version',
                class: 'text-center'
            },
            {
                key: 'id',
                label: '',
                class: 'text-right'
            }
        ];
        return _this;
    }
    Object.defineProperty(OldDocumentsList.prototype, "total", {
        get: function () {
            return this.documents.length;
        },
        enumerable: false,
        configurable: true
    });
    OldDocumentsList.prototype.downloadOldVersion = function (id) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/' + this.type + '/' + id + '/pdf?old_version=1')
                                .then(function (response) {
                                var pdf = response.data;
                                _this.loading = false;
                                _this.downloadFile(pdf.file, pdf.filename);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], OldDocumentsList.prototype, "documents", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], OldDocumentsList.prototype, "type", void 0);
    OldDocumentsList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard, BTable: external_bootstrap_vue_.BTable, BPagination: external_bootstrap_vue_.BPagination,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: interface_vue_.Spinner
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], OldDocumentsList);
    return OldDocumentsList;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin, interface_vue_.DateMixin)));
/* harmony default export */ var OldDocumentsListvue_type_script_lang_ts_external = (OldDocumentsList);

;// ./src/components/OldDocumentsList/OldDocumentsList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var OldDocumentsList_OldDocumentsListvue_type_script_lang_ts_external = (OldDocumentsListvue_type_script_lang_ts_external); 
;// ./src/components/OldDocumentsList/OldDocumentsList.vue





/* normalize component */
;
var OldDocumentsList_component = (0,componentNormalizer/* default */.A)(
  OldDocumentsList_OldDocumentsListvue_type_script_lang_ts_external,
  OldDocumentsListvue_type_template_id_1f2dd7b8_render,
  OldDocumentsListvue_type_template_id_1f2dd7b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OldDocumentsList_OldDocumentsList = (OldDocumentsList_component.exports);
// EXTERNAL MODULE: ./src/components/CarSpeedItem/CarSpeedItem.vue + 3 modules
var CarSpeedItem = __webpack_require__(43243);
// EXTERNAL MODULE: ./src/components/CarPdf/CarPdf.vue + 3 modules
var CarPdf = __webpack_require__(3478);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentItem/DocumentItem.ts?vue&type=script&lang=ts&external

















































var DocumentItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentItem, _super);
    function DocumentItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalDocumentContent = false;
        _this.modalClone = false;
        _this.totalPayments = 0;
        _this.activeTab = 0;
        _this.saveTabKey = 'documentTab';
        _this.addNewCharge = false;
        _this.signed = false;
        _this.waitingSign = false;
        _this.constructionModal = false;
        _this.signSendModal = false;
        return _this;
    }
    DocumentItem.prototype.created = function () {
        if (this.type === 'invoice' || this.type === 'credit') {
            interface_vue_.emitter.on('paymentCreated', this.paymentCreated);
            interface_vue_.emitter.on('paymentUpdated', this.paymentUpdated);
            interface_vue_.emitter.on('paymentDeleted', this.paymentDeleted);
        }
        interface_vue_.emitter.on('mailSent', this.mailSent);
        interface_vue_.emitter.on('signSend', this.signSendEmitter);
        if (this.teamConfigs.params_remember_tab) {
            this.activeTab = Number(localStorage.getItem(this.saveTabKey + '-' + this.type));
        }
    };
    DocumentItem.prototype.destroyed = function () {
        if (this.type === 'invoice' || this.type === 'credit') {
            interface_vue_.emitter.off('paymentCreated', this.paymentCreated);
            interface_vue_.emitter.off('paymentUpdated', this.paymentUpdated);
            interface_vue_.emitter.off('paymentDeleted', this.paymentDeleted);
        }
        interface_vue_.emitter.off('mailSent', this.mailSent);
        interface_vue_.emitter.off('signSend', this.signSendEmitter);
    };
    DocumentItem.prototype.signSendEmitter = function () {
        this.signSendModal = true;
    };
    DocumentItem.prototype.onActiveTabChange = function () {
        if (this.teamConfigs.params_remember_tab) {
            localStorage.setItem(this.saveTabKey + '-' + this.type, String(this.activeTab));
        }
    };
    DocumentItem.prototype.watchValue = function (value, old) {
        var _a, _b, _c, _d;
        if ((value === null || value === void 0 ? void 0 : value.id) !== (old === null || old === void 0 ? void 0 : old.id)) {
            this.activeTab = 0;
        }
        switch (this.type) {
            case 'invoice':
                this.totalPayments = ((_a = this.value.payments_count) !== null && _a !== void 0 ? _a : 0) + ((_b = this.value.credits_uses_count) !== null && _b !== void 0 ? _b : 0);
                break;
            case 'credit':
                this.totalPayments = ((_c = this.value.payments_count) !== null && _c !== void 0 ? _c : 0) + ((_d = this.value.uses_count) !== null && _d !== void 0 ? _d : 0);
                break;
        }
    };
    DocumentItem.prototype.watchType = function () {
        this.activeTab = 0;
    };
    Object.defineProperty(DocumentItem.prototype, "pageTitle", {
        get: function () {
            var type = this.type;
            if (type === 'invoice') {
                if (this.value.is_advance) {
                    type = 'depositInvoice';
                }
                else if (this.value.is_situation) {
                    type = 'situationInvoice';
                }
            }
            return this.$t('sales.' + type + '.reference', {
                reference: this.value.reference
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "deadlineDelay", {
        get: function () {
            var _this = this;
            return function (index) {
                var deadlines = _this.value.deadlines;
                var months = sumBy_default()(deadlines.filter(function (deadline, i) { return i <= index && deadline.delay_type === 'month'; }), function (deadline) { return _this.number(deadline.delay); });
                var days = sumBy_default()(deadlines.filter(function (deadline, i) { return i <= index && deadline.delay_type === 'day'; }), function (deadline) { return _this.number(deadline.delay); });
                var data = '';
                if (months > 0) {
                    data += months + ' mois';
                }
                if (days > 0) {
                    if (data !== '') {
                        data += ' et ';
                    }
                    data += days + ' jour';
                    if (days > 1) {
                        data += 's';
                    }
                }
                return data;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "documentStatusBar", {
        get: function () {
            var _this = this;
            var status = this.documentStatus;
            switch (this.type) {
                case 'proforma':
                    return status.filter(function (status) {
                        return status.value === 2 || status.value === 3 || status.value === 6 || status.value === _this.value.status;
                    });
                case 'invoice':
                    return status.filter(function (status) {
                        return status.value < 4 || status.value === 5 || status.value === _this.value.status;
                    });
                case 'credit':
                    return status.filter(function (status) {
                        return status.value !== 4 || status.value === _this.value.status;
                    });
                default:
                    return status.filter(function (status) {
                        return status.value < 5 || status.value === 7 || status.value === _this.value.status;
                    });
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "deliveryStatusBar", {
        get: function () {
            var _this = this;
            return this.deliveryStatus.filter(function (status) { return status.value !== 2 || _this.value.delivery_status === status.value; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "invoiceStatusBar", {
        get: function () {
            var _this = this;
            return this.invoiceStatus.filter(function (status) { return status.value !== 2 || _this.value.billing_status === status.value; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "agregateProperties", {
        get: function () {
            return {
                type: this.type,
                id: this.value.id,
                model: this.value,
                customer: this.value.customer,
                contact: this.value.contact,
                modelTitle: this.modelTitle,
                attachments: [this.value.pdf],
                url: '/sales/' + this.type + '/' + this.value.id + '/aggregate-datas'
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "modelTitle", {
        get: function () {
            return this.$t('sales.' + this.type + '.reference', { reference: this.value.reference });
        },
        enumerable: false,
        configurable: true
    });
    DocumentItem.prototype.canBeEdited = function () {
        if (this.type === 'invoice' || this.type === 'credit') {
            return this.value.is_draft;
        }
        if (this.value.is_draft) {
            return true;
        }
        if (this.type === 'delivery') {
            return this.value.billing_status !== 3;
        }
        var toBill = Number(this.value.to_bill);
        var notAllbilled = Number(this.value.total_ttc) === 0 || toBill > 0;
        if (notAllbilled && this.hasSituationInvoices) {
            return false;
        }
        return notAllbilled;
    };
    Object.defineProperty(DocumentItem.prototype, "hasSituationInvoices", {
        get: function () {
            var _a, _b;
            return ['quotation', 'command'].includes(this.type) && ((_b = (_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.filter(function (invoice) { return invoice.is_situation; }).length) !== null && _b !== void 0 ? _b : 0) > 0;
        },
        enumerable: false,
        configurable: true
    });
    DocumentItem.prototype.cantBeEditedTooltip = function () {
        if (!this.canBeEdited()) {
            return this.$t('sales.' + this.type + '.' + (this.hasSituationInvoices ? 'cantEditedWithSituation' : 'cantEdited'));
        }
        else {
            return null;
        }
    };
    Object.defineProperty(DocumentItem.prototype, "canBeBill", {
        get: function () {
            var _a;
            switch (this.type) {
                case 'invoice':
                case 'credit':
                    return false;
                case 'delivery':
                    return this.value.billing_status !== 3;
                default:
                    if (((_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.filter(function (invoice) { return !invoice.is_situation && !invoice.is_advance; }).length) === 0) {
                        return true;
                    }
                    return this.value.pourcent_to_bill !== undefined && this.value.pourcent_to_bill > 0;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            var actions = [];
            actions.push({
                title: 'Télécharger le PDF',
                icon: ['fas', 'download'],
                click: function () {
                    var viewer = _this.$refs.pdfviewer;
                    viewer.download();
                }
            });
            if (this.can('sales-' + this.type, 3)) {
                actions.push({
                    label: 'Modifier',
                    disabled: !this.canBeEdited(),
                    title: this.cantBeEditedTooltip(),
                    to: {
                        name: this.type + '-form',
                        params: {
                            id: String(this.value.id)
                        }
                    }
                });
                if (this.type === 'invoice' || this.type === 'credit') {
                    actions.push({
                        component: PaymentFormButton/* default */.A,
                        attributes: {
                            element: this.windowWidth < 900 ? 'dropdown' : 'button',
                            type: this.type,
                            document: this.value,
                            size: 'sm',
                            disabled: this.payementFormButtonDisable,
                            title: this.payementFormButtonTitle,
                            class: 'btn-group'
                        },
                        events: {
                            invoiceUpdated: this.updateDocument
                        }
                    });
                }
            }
            if ((this.type === 'quotation' || this.type === 'command' || this.type === 'proforma' || (this.type === 'invoice' && !this.value.is_advance)) && this.value.delivery_status !== 3 && this.hasModule('sales-deliveries') && this.can('sales-delivery', 2)) {
                actions.push({
                    component: DocumentDelivery/* default */.A,
                    attributes: {
                        element: this.windowWidth < 900 ? 'dropdown' : 'button',
                        type: this.type,
                        document: this.value,
                        size: 'sm'
                    }
                });
            }
            if (this.canBeBill && this.can('sales-invoice', 2)) {
                if (this.invoiceActions.length === 1) {
                    var invoice = this.invoiceActions[0];
                    if (invoice.attributes) {
                        invoice.attributes.element = 'button';
                        invoice.attributes.label = this.hasSituationInvoices ? 'Facturer le solde' : 'Facturer';
                    }
                    actions.push(invoice);
                }
                else {
                    actions.push({
                        label: 'Facturer',
                        items: this.invoiceActions
                    });
                }
            }
            if (this.hasModule('task') && this.can('task', 1)) {
                actions.push({
                    label: 'Tâche',
                    click: function () {
                        _this.openModal({
                            key: 'task-form',
                            value: {
                                elements: _this.linkedElements(true)
                            }
                        });
                    }
                });
            }
            var relations = [];
            if (this.app.electronic_sign_status && !this.signed && this.can('sales-' + this.type, 1) && this.can('sales-signatures', 1) && (this.type === 'quotation' || this.type === 'command' || this.type === 'proforma' || this.type === 'delivery')) {
                relations.push({
                    component: SignSend/* default */.A,
                    attributes: {
                        disabled: this.value.is_draft,
                        disabledTitle: this.value.is_draft ? 'Vous devez valider le document pour l\'envoyer pour signature' : null,
                        element: 'dropdown',
                        size: 'sm',
                        value: {
                            documents: [
                                {
                                    document_type: this.type,
                                    document_id: this.value.id,
                                    document: this.value,
                                    file: this.value.pdf,
                                    signable_document: this.value.pdf_model ? this.value.pdf_model['can_sign_' + this.type] : false
                                }
                            ]
                        }
                    },
                    events: {
                        input: this.updateDocument,
                        sended: this.markAsSent
                    }
                });
            }
            if (this.can('send-mail', 1)) {
                relations.push(this.sendMailAction('dropdown'));
            }
            if (this.hasModule('communication-reports') && this.can('communication-reports', 1)) {
                relations.push({
                    component: communication_vue_.ReportFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Compte-rendu',
                        customer: this.value.customer,
                        contact: this.value.contact,
                        linkedElements: this.linkedElements()
                    }
                });
            }
            if (this.hasModule('communication-letters') && this.can('communication-letters', 1)) {
                relations.push({
                    component: communication_vue_.LetterFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Lettre',
                        customer: this.value.customer,
                        contact: this.value.contact,
                        linkedElements: this.linkedElements(),
                        preload: this.type
                    }
                });
            }
            if (this.hasModule('calendar') && this.can('calendar', 1)) {
                relations.push({
                    component: calendars_vue_.CalendarButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Rendez-vous',
                        linkedElements: this.linkedElements(true)
                    }
                });
            }
            if (relations.length > 1) {
                actions.push.apply(actions, [
                    {
                        label: 'Relation',
                        items: relations
                    }
                ]);
            }
            else if (this.can('send-mail', 1)) {
                actions.push(this.sendMailAction('button'));
            }
            actions.push({
                label: 'Autres',
                items: this.otherActions
            });
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "payementFormButtonDisable", {
        get: function () {
            return /*this.value.is_draft || */ this.value.status === 7 || this.value.stay_to_pay <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "payementFormButtonTitle", {
        get: function () {
            var _this = this;
            return function (withDefault) {
                if (withDefault === void 0) { withDefault = false; }
                /*if (this.value.is_draft) {
                  return 'Vous devez valider le document pour ajouter un paiement'
                } else */ if (_this.value.status === 7) {
                    return 'Vous ne pouvez pas ajouter de paiement sur une facture annulée';
                }
                else if (_this.value.stay_to_pay <= 0) {
                    if (_this.type === 'invoice') {
                        return 'Cette facture est déjà réglée';
                    }
                    else {
                        return 'Cet avoir est déjà réglé';
                    }
                }
                else if (withDefault) {
                    return 'Ajouter un paiement';
                }
                else {
                    return null;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "sendMailAction", {
        get: function () {
            var _this = this;
            return function (btnType) {
                var to = [];
                if (_this.type === 'invoice' || _this.type === 'credit') {
                    var billingContact = _this.value.billing_contact;
                    if (billingContact && billingContact.email) {
                        to.push({
                            id: billingContact.id,
                            type: 'contact',
                            mail: billingContact.email,
                            name: billingContact.fullname,
                            element: {
                                id: billingContact.id,
                                type: 'contact'
                            },
                            data: billingContact
                        });
                    }
                }
                return {
                    component: communication_vue_.SendEmailButton,
                    attributes: {
                        disabled: _this.value.pdf_status < 2,
                        linkedElements: _this.linkedElements(),
                        attachments: [_this.value.pdf],
                        to: to,
                        element: btnType,
                        preload: _this.type,
                        customer: _this.value.customer,
                        contact: _this.value.contact
                    }
                };
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "linkedElements", {
        get: function () {
            var _this = this;
            return function (withCustomer) {
                if (withCustomer === void 0) { withCustomer = false; }
                var elements = [{
                        type: _this.type,
                        id: _this.value.id,
                        title: _this.modelTitle,
                        data: _this.value
                    }];
                var customer = _this.value.customer;
                if (withCustomer && customer) {
                    elements.push({
                        type: 'customer',
                        id: customer.id,
                        title: customer.name,
                        data: customer
                    });
                    var contact = _this.value.contact;
                    if (contact) {
                        elements.push({
                            type: 'contact',
                            id: contact.id,
                            title: contact.fullname,
                            data: contact
                        });
                    }
                    var billingContact = _this.value.billing_contact;
                    if (billingContact) {
                        elements.push({
                            type: 'contact',
                            id: billingContact.id,
                            title: billingContact.fullname,
                            data: billingContact
                        });
                    }
                }
                return elements;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "invoiceActions", {
        get: function () {
            var _this = this;
            var _a, _b;
            var actions = [
                {
                    component: TransformToInvoice/* default */.A,
                    attributes: {
                        value: this.value,
                        type: this.type,
                        element: 'dropdown',
                        label: this.hasSituationInvoices ? 'Facturer le solde' : 'Facturer le document',
                        disabled: this.value.is_draft,
                        title: this.value.is_draft ? 'Vous devez valider le document pour le facturer' : null
                    },
                    events: {
                        success: function (invoice) { return _this.$router.push({ name: 'invoice-item', params: { id: String(invoice.id) } }); }
                    }
                }
            ];
            if (this.value.pourcent_to_bill !== undefined && this.value.pourcent_to_bill > 0 && !((_a = this.value.payment_term) === null || _a === void 0 ? void 0 : _a.with_deadlines)) {
                if ((this.type === 'quotation' || this.type === 'command') && this.hasModule('sales-situation-billing')) {
                    actions.unshift({
                        component: TransformToSituationInvoice_TransformToSituationInvoice,
                        attributes: {
                            value: this.value,
                            type: this.type,
                            element: 'dropdown',
                            disabled: this.value.is_draft,
                            title: this.value.is_draft ? 'Vous devez valider le document pour le facturer' : null
                        },
                        events: {
                            success: function (invoice) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.$router.push({ name: 'invoice-item', params: { id: String(invoice.id) } })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }
                    });
                }
                if ((this.type === 'quotation' || this.type === 'command') && !this.hasSituationInvoices) {
                    var invoices = (_b = this.value.invoices) !== null && _b !== void 0 ? _b : [];
                    var depositInvoices = invoices.filter(function (invoice) { return invoice.is_advance && invoice.status !== 7; });
                    var depositInvoicesAmount = sumBy_default()(depositInvoices, function (invoice) { return _this.number(invoice.total_ht); });
                    if (depositInvoicesAmount < Number(this.value.total_ht)) {
                        actions.unshift({
                            component: TransformToDepositInvoice/* default */.A,
                            attributes: {
                                value: this.value,
                                type: this.type,
                                element: 'dropdown',
                                label: depositInvoices.length === 0 ? 'Facturer un acompte' : 'Facturer un autre acompte',
                                disabled: this.value.is_draft,
                                title: this.value.is_draft ? 'Vous devez valider le document pour le facturer' : null
                            },
                            events: {
                                success: function (invoice) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.$router.push({ name: 'invoice-item', params: { id: String(invoice.id) } })];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }
                            }
                        });
                    }
                }
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "otherActions", {
        get: function () {
            var _this = this;
            var _a;
            var actions = [];
            var previewElement = 0;
            if (this.can('sales-' + this.type, 2)
                && this.hasModule('stripe')
                && !this.value.is_draft
                && (((this.type === 'quotation' || this.type === 'command' || this.type === 'proforma') && ((_a = this.value.invoices) === null || _a === void 0 ? void 0 : _a.length) === 0) || (this.type === 'invoice' && this.value.stay_to_pay > 0))) {
                actions.push({
                    component: StripeSend/* default */.A,
                    attributes: {
                        document: this.value,
                        type: this.type,
                        element: 'dropdown'
                    }
                });
                previewElement++;
            }
            if (this.type === 'invoice' && !this.value.is_draft) {
                actions.push({
                    component: DownloadAcquittedInvoice_DownloadAcquittedInvoice,
                    attributes: {
                        invoice: this.value,
                        element: 'dropdown'
                    }
                });
                previewElement++;
            }
            if (previewElement > 0) {
                actions.push({
                    isSeparator: true
                });
            }
            if (this.hasModule('construction') && this.can('construction', 2)) {
                actions.push({
                    component: TransformToConstruction_TransformToConstruction,
                    attributes: {
                        value: this.value,
                        type: this.type,
                        element: 'dropdown',
                        modal: this.constructionModal
                    },
                    events: {
                        success: function (construction) { return _this.$router.push({ name: 'construction-item', params: { id: String(construction.id) } }); }
                    }
                });
                previewElement++;
            }
            if (this.hasModule('stock') && this.can('manage-stock', 1) && !['proforma', 'credit'].includes(this.type)) {
                actions.push({
                    component: CreateProviderCommand/* default */.A,
                    attributes: {
                        value: this.value,
                        type: this.type,
                        element: 'dropdown'
                    },
                    events: {
                        created: function (commands) {
                            commands.forEach(function (command) {
                                var _a, _b;
                                var index = ((_a = _this.value.provider_commands) !== null && _a !== void 0 ? _a : []).findIndex(function (val) { return val.id === command.id; });
                                if (index < 0) {
                                    (_b = _this.value.provider_commands) === null || _b === void 0 ? void 0 : _b.push(command);
                                }
                            });
                        }
                    }
                });
                previewElement++;
            }
            if (this.hasModule('charges')) {
                actions.push({
                    label: 'Rattacher une charge',
                    click: function () {
                        _this.addNewCharge = true;
                    }
                });
                previewElement++;
            }
            actions.push({
                label: 'Contenu du document',
                click: function () {
                    _this.modalDocumentContent = true;
                }
            });
            if (this.can('sales-' + this.type, 3)) {
                if (previewElement > 0) {
                    actions.push({
                        isSeparator: true
                    });
                }
                if (this.can('sales-margin', 1)) {
                    actions.push({
                        component: DocumentCostsUpdate_DocumentCostsUpdate,
                        attributes: {
                            value: this.value,
                            type: this.type,
                            element: 'dropdown'
                        },
                        events: {
                            input: this.updateDocument
                        }
                    });
                }
                actions.push({
                    label: 'Modification rapide',
                    component: DocumentSpeedEdit/* default */.A,
                    attributes: {
                        value: this.value,
                        type: this.type,
                        element: 'dropdown'
                    },
                    events: {
                        input: this.updateDocument
                    }
                });
            }
            var toQuotation = (this.type === 'command' || this.type === 'proforma' || this.type === 'delivery') && !this.value.quotation && this.can('sales-quotation', 2);
            var toCommand = (this.type === 'quotation' || this.type === 'proforma' || this.type === 'delivery') && !this.value.command && this.can('sales-command', 2) && this.hasModule('sales-commands');
            var toProforma = (this.type === 'quotation' || this.type === 'command') && !this.value.proforma && this.can('sales-proforma', 2) && this.hasModule('sales-proformas');
            if (toCommand || toProforma || toQuotation) {
                actions.push({ isSeparator: true });
            }
            if (toQuotation) {
                actions.push({
                    label: 'Créer un devis',
                    component: TransformToQuotation/* default */.A,
                    attributes: {
                        value: this.value,
                        type: this.type,
                        element: 'dropdown'
                    },
                    events: {
                        success: function (quotation) { return _this.$router.push({ name: 'quotation-item', params: { id: String(quotation.id) } }); }
                    }
                });
            }
            if (toCommand) {
                actions.push({
                    label: 'Créer un bon de commande',
                    component: TransformToCommand/* default */.A,
                    attributes: {
                        value: this.value,
                        type: this.type,
                        element: 'dropdown'
                    },
                    events: {
                        success: function (command) { return _this.$router.push({ name: 'command-item', params: { id: String(command.id) } }); }
                    }
                });
            }
            if (toProforma) {
                actions.push({
                    label: 'Créer une facture proforma',
                    component: TransformToProforma/* default */.A,
                    attributes: {
                        value: this.value,
                        type: this.type,
                        element: 'dropdown'
                    },
                    events: {
                        success: function (proforma) { return _this.$router.push({ name: 'proforma-item', params: { id: String(proforma.id) } }); }
                    }
                });
            }
            if (this.type === 'quotation') {
                actions.push({
                    label: 'Créer un contrat',
                    click: this.createContract
                });
            }
            actions.push({
                isSeparator: true
            });
            if (this.can('sales-quotation', 2)
                || (this.can('sales-command', 2) && this.hasModule('sales-commands'))
                || (this.can('sales-delivery', 2) && this.hasModule('sales-deliveries'))
                || (this.can('sales-proforma', 2) && this.hasModule('sales-proformas'))
                || this.can('sales-invoice', 2)
                || this.can('sales-credit', 2)) {
                actions.push({
                    label: 'Cloner le document',
                    click: function () { return (_this.modalClone = true); }
                });
            }
            if (this.can('sales-' + this.type, 3)) {
                actions.push({
                    component: DocumentStatusSelector/* default */.A,
                    attributes: {
                        document: this.value,
                        type: this.type,
                        element: 'dropdown'
                    },
                    events: {
                        input: this.updateDocument
                    }
                });
            }
            if (this.type === 'invoice' && this.can('sales-invoice', 3)) {
                actions.push.apply(actions, [
                    {
                        isSeparator: true
                    },
                    {
                        component: CancelInvoice/* default */.A,
                        attributes: {
                            element: 'dropdown',
                            invoice: this.value
                        },
                        events: {
                            success: function (credit) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, Promise, function () {
                                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.$router.push({
                                                name: 'credit-item',
                                                params: {
                                                    id: String(credit.id),
                                                    document: JSON.stringify(credit)
                                                }
                                            })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }
                    },
                    {
                        component: UseCreditButton_UseCreditButton,
                        attributes: {
                            element: 'dropdown',
                            invoice: this.value
                        },
                        events: {
                            success: this.updateDocument
                        }
                    },
                    {
                        isSeparator: true
                    }
                ]);
            }
            if (this.can('sales-invoice', 4)) {
                actions.push({
                    component: DocumentDelete/* default */.A,
                    attributes: {
                        type: this.type,
                        value: this.value,
                        element: 'dropdown',
                        disabled: !this.value.is_draft
                    },
                    events: {
                        deleted: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.$router.push({ name: this.type + '-list' })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    DocumentItem.prototype.updateDocument = function (document) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var newStatus, oldStatus;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(document.id !== this.value.id)) return [3 /*break*/, 2];
                        this.setPageParams(document);
                        return [4 /*yield*/, this.$router.replace({
                                name: this.$route.name,
                                params: {
                                    id: String(document.id)
                                }
                            })];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (this.hasModule('construction') && this.can('construction', 2) && this.type === 'quotation') {
                            newStatus = document.status;
                            oldStatus = this.value.status;
                            if (newStatus !== oldStatus && oldStatus < 4
                                && newStatus >= 4 && newStatus <= 7
                                && this.teamConfigs['construction_automatic_creation'] === 2
                                && ((_a = this.value.constructions) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                                this.constructionModal = true;
                            }
                        }
                        this.$emit('input', document);
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DocumentItem.prototype, "linkedDocuments", {
        get: function () {
            var linked = [];
            if (this.value.quotation) {
                linked.push({
                    type: 'quotation',
                    document: this.value.quotation
                });
            }
            else if (this.value.quotations) {
                this.value.quotations.forEach(function (quotation) {
                    linked.push({
                        type: 'quotation',
                        document: quotation
                    });
                });
            }
            if (this.value.command) {
                linked.push({
                    type: 'command',
                    document: this.value.command
                });
            }
            else if (this.value.commands) {
                this.value.commands.forEach(function (command) {
                    linked.push({
                        type: 'command',
                        document: command
                    });
                });
            }
            if (this.value.proforma) {
                linked.push({
                    type: 'proforma',
                    document: this.value.proforma
                });
            }
            else if (this.value.proformas) {
                this.value.proformas.forEach(function (proforma) {
                    linked.push({
                        type: 'proforma',
                        document: proforma
                    });
                });
            }
            if (this.value.deliveries) {
                this.value.deliveries.forEach(function (delivery) {
                    linked.push({
                        type: 'delivery',
                        document: delivery
                    });
                });
            }
            if (this.value.invoices) {
                this.value.invoices.forEach(function (invoice) {
                    linked.push({
                        type: 'invoice',
                        document: invoice
                    });
                });
            }
            if (this.value.credits) {
                this.value.credits.forEach(function (credit) {
                    linked.push({
                        type: 'credit',
                        document: credit
                    });
                });
            }
            if (this.value.contract) {
                linked.push({
                    type: 'contract',
                    document: this.value.contract
                });
            }
            if (this.value.opportunities) {
                this.value.opportunities.forEach(function (opportunity) {
                    linked.push({
                        type: 'opportunity',
                        document: opportunity
                    });
                });
            }
            if (this.value.constructions) {
                this.value.constructions.forEach(function (construction) {
                    linked.push({
                        type: 'construction',
                        document: construction
                    });
                });
            }
            return linked;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentItem.prototype, "withCommissions", {
        get: function () {
            var _a, _b;
            var allowedTeamUser = [this.teamUser.id];
            if (((_a = this.teamUser.roles) === null || _a === void 0 ? void 0 : _a.includes('manager')) && this.teamUser.team_users) {
                (_b = this.teamUser.team_users) === null || _b === void 0 ? void 0 : _b.forEach(function (teamUser) {
                    allowedTeamUser.push(teamUser.id);
                });
            }
            return this.hasModule('sales-commissions')
                && this.can('sales-commissions', 1)
                && this.value.commission_amount !== 0
                && (this.type === 'quotation' || this.type === 'invoice' || this.type === 'credit')
                && (this.can('sales-commissions-limit', 2) || allowedTeamUser.includes(this.value.team_user_id));
        },
        enumerable: false,
        configurable: true
    });
    DocumentItem.prototype.cloneDocument = function (type) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams({
                            type: this.type,
                            document: this.value
                        });
                        return [4 /*yield*/, this.$router.push({ name: type + '-form' })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentItem.prototype.createContract = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var value, billingAddress, customer;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        value = this.value;
                        billingAddress = value.billing_address;
                        customer = JSON.parse(JSON.stringify(value.customer));
                        delete customer.address_invoice;
                        this.setPageParams({
                            quotation_id: value.id,
                            title: value.title,
                            customer: customer,
                            contact: value.contact,
                            road1: billingAddress.road,
                            road2: billingAddress.road2,
                            road3: billingAddress.road3,
                            postal_code: billingAddress.postal_code,
                            town: billingAddress.city,
                            country: billingAddress.country,
                            customer_command_reference: value.customer_command_reference,
                            team_user: value.team_user,
                            discount_type: value.global_discount_type,
                            discount_value: value.global_discount_value,
                            payment_term: value.payment_term,
                            pdf_model: value.pdf_model,
                            contents: value.contents.map(function (content) {
                                var _a, _b, _c;
                                return ({
                                    catalog: {
                                        type: (_a = content.catalog) === null || _a === void 0 ? void 0 : _a.type,
                                        id: (_b = content.catalog) === null || _b === void 0 ? void 0 : _b.id,
                                        element: (_c = content.catalog) === null || _c === void 0 ? void 0 : _c.element
                                    },
                                    is_comment: content.is_comments,
                                    designation: content.designation,
                                    vat_rate: content.vat_rate,
                                    unit_price_ht: content.unit_price_ht,
                                    quantity: content.quantity,
                                    auto_update_price: false,
                                });
                            })
                        });
                        return [4 /*yield*/, this.$router.push({ name: 'contract-form' })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentItem.prototype.agregateLoaded = function (data) {
        this.updateTotalPayments(data.totals.payment);
    };
    DocumentItem.prototype.updateTotalPayments = function (totalPayments) {
        this.totalPayments = totalPayments;
        if (this.type === 'invoice' && this.value.credits_uses) {
            this.totalPayments += this.value.credits_uses.length;
        }
        else if (this.type === 'credit' && this.value.uses) {
            this.totalPayments += this.value.uses.length;
        }
    };
    DocumentItem.prototype.markAsSent = function (signature) {
        if (this.type !== 'delivery' && this.value.status === 2) {
            this.value.status = 3;
        }
        var sepa = this.value;
        if (!sepa.signatures) {
            sepa.signatures = [];
        }
        sepa.signatures.push(signature);
    };
    DocumentItem.prototype.paymentCreated = function (payment) {
        var _this = this;
        if (!payment.documents) {
            return;
        }
        var documents = payment.documents.filter(function (use) { return use.document_type === _this.type && use.document_id === _this.value.id; });
        if (documents.length === 0) {
            return;
        }
        this.updateDocumentStatus({
            add: documents
        });
        if (this.value.payments_count !== undefined) {
            this.value.payments_count++;
        }
    };
    DocumentItem.prototype.paymentUpdated = function (event) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var mouvements = {
            add: ((_b = (_a = event.new) === null || _a === void 0 ? void 0 : _a.documents) !== null && _b !== void 0 ? _b : []).filter(function (use) { return use.document_type === _this.type && use.document_id === _this.value.id; }),
            remove: ((_d = (_c = event.old) === null || _c === void 0 ? void 0 : _c.documents) !== null && _d !== void 0 ? _d : []).filter(function (use) { return use.document_type === _this.type && use.document_id === _this.value.id; })
        };
        if (((_f = (_e = mouvements.add) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0 || ((_h = (_g = mouvements.remove) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 0) > 0) {
            this.updateDocumentStatus(mouvements);
        }
    };
    DocumentItem.prototype.paymentDeleted = function (payment) {
        var _this = this;
        if (payment.documents) {
            var documents = payment.documents.filter(function (use) { return use.document_type === _this.type && use.document_id === _this.value.id; });
            if (documents.length === 0) {
                return;
            }
            this.updateDocumentStatus({
                remove: documents
            });
            if (this.value.payments_count) {
                this.value.payments_count--;
            }
        }
    };
    DocumentItem.prototype.mailSent = function (event) {
        var _this = this;
        var index = event.elements.findIndex(function (element) { return element.type === _this.type && element.id === _this.value.id; });
        if (index >= 0 && this.value.status < 3) {
            var document = JSON.parse(JSON.stringify(this.value));
            document.status = 3;
            this.updateDocument(document);
        }
    };
    DocumentItem.prototype.updateDocumentStatus = function (movements) {
        var _this = this;
        var document = JSON.parse(JSON.stringify(this.value));
        if (movements.add) {
            movements.add.forEach(function (use) {
                if (use.guarantee_holdback) {
                    document.guarantee_holdback_status = 1;
                }
                else {
                    var ttc = _this.number(use.ttc);
                    document.already_paid = _this.number(document.already_paid) + ttc;
                    document.stay_to_pay = _this.number(document.stay_to_pay) - ttc;
                }
            });
        }
        if (movements.remove) {
            movements.remove.forEach(function (use) {
                if (use.guarantee_holdback) {
                    document.guarantee_holdback_status = 0;
                }
                else {
                    var ttc = -(_this.number(use.ttc));
                    document.already_paid = _this.number(document.already_paid) + ttc;
                    document.stay_to_pay = _this.number(document.stay_to_pay) - ttc;
                }
            });
        }
        if (!document.is_draft) {
            if (document.stay_to_pay === 0) {
                document.status = 5;
            }
            else if (document.already_paid > 0) {
                document.status = 4;
            }
            else {
                document.status = 3;
            }
        }
        this.updateDocument(document);
    };
    DocumentItem.prototype.pdfLoaded = function (file) {
        var document = JSON.parse(JSON.stringify(this.value));
        document.pdf_status = 2;
        document.pdf = file;
        this.updateDocument(document);
    };
    DocumentItem.prototype.updateChargeAmount = function (amount) {
        this.value.total_charge += amount;
        this.value.gross_margin_amount -= amount;
    };
    DocumentItem.prototype.chargeAmountAdded = function (datas) {
        var _this = this;
        var _a;
        if (((this.type === 'invoice' || this.type === 'credit') && this.activeTab === 3) || this.activeTab === 2) {
            return;
        }
        var updateAmount = 0;
        var elements = (_a = datas.elements) !== null && _a !== void 0 ? _a : [];
        elements.forEach(function (element) {
            updateAmount += _this.number(element.total_ht);
        });
        this.updateChargeAmount(updateAmount);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentItem.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('activeTab')
    ], DocumentItem.prototype, "onActiveTabChange", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], DocumentItem.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('type')
    ], DocumentItem.prototype, "watchType", null);
    DocumentItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('app', ['setPageParams'])), { termText: constructions_vue_namespaceObject.termText,
                upperFirst: (upperFirst_default()),
                moment: (external_moment_default()) }),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'team', 'teamConfigs', 'teamUser'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('app', ['windowWidth', 'app'])),
            components: {
                OldDocumentsList: OldDocumentsList_OldDocumentsList,
                KTable: table_vue_.KTable,
                DocumentContent: DocumentContent/* default */.A,
                PdfViewer: PdfViewer/* default */.A,
                CustomerSpeedItem: customers_vue_.CustomerSpeedItem,
                ContactSpeedItem: customers_vue_.ContactSpeedItem,
                DocumentStatus: DocumentStatus/* default */.A,
                DocumentStatusSelector: DocumentStatusSelector/* default */.A,
                TransformToInvoice: TransformToInvoice/* default */.A,
                AgregateDatas: communication_vue_.AgregateDatas,
                PaymentList: PaymentList/* default */.A,
                PaymentFormButton: PaymentFormButton/* default */.A,
                CancelGuaranteeHoldback: CancelGuaranteeHoldback/* default */.A,
                UsedCredits: UsedCredits/* default */.A,
                CreditsUses: CreditsUses/* default */.A,
                AttachChargeList: AttachChargeList_AttachChargeList,
                AttachChargeForm: AttachChargeForm_AttachChargeForm,
                SignSend: SignSend/* default */.A, SignState: SignState/* default */.A,
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay, CustomFieldsDisplayTab: custom_fields_vue_.CustomFieldsDisplayTab,
                PageHeader: interface_vue_.PageHeader, FormModal: interface_vue_.FormModal, Tab: interface_vue_.Tab, Tabs: interface_vue_.Tabs, AppMessages: interface_vue_.AppMessages,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BBadge: external_bootstrap_vue_.BBadge, BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                LotUsed: catalog_vue_.LotUsed,
                CarSpeedItem: CarSpeedItem/* default */.A,
                CarPdf: CarPdf/* default */.A
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], DocumentItem);
    return DocumentItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin, SalesDocumentStatusMixin/* default */.A)));
/* harmony default export */ var DocumentItemvue_type_script_lang_ts_external = (DocumentItem);

;// ./src/components/DocumentItem/DocumentItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentItem_DocumentItemvue_type_script_lang_ts_external = (DocumentItemvue_type_script_lang_ts_external); 
;// ./src/components/DocumentItem/DocumentItem.vue





/* normalize component */
;
var DocumentItem_component = (0,componentNormalizer/* default */.A)(
  DocumentItem_DocumentItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentItem_DocumentItem = (DocumentItem_component.exports);

/***/ }),

/***/ 55364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(85250),
    createAssigner = __webpack_require__(20999);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 55481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 55527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 55580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(56110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 55802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ 55808:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(12507);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 55974:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f111';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GE = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 56000:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ 56041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_RecoveryInvoiceParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/RecoveryInvoiceParamsView.vue?vue&type=template&id=62b4ff40
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('RecoveryInvoiceStepParams',{staticClass:"mb-5"}),_c('h2',{staticClass:"form-title"},[_vm._v(" Gestion des étapes de relance des factures impayées ")]),_c('RecoveryInvoiceStepList')],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/RecoveryInvoiceStepList/RecoveryInvoiceStepList.vue + 3 modules
var RecoveryInvoiceStepList = __webpack_require__(98528);
// EXTERNAL MODULE: ./src/components/RecoveryInvoiceStepParams/RecoveryInvoiceStepParams.vue + 3 modules
var RecoveryInvoiceStepParams = __webpack_require__(83966);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/RecoveryInvoiceParamsView.vue?vue&type=script&lang=ts




var RecoveryInvoiceParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(RecoveryInvoiceParamsView, _super);
    function RecoveryInvoiceParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecoveryInvoiceParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                RecoveryInvoiceStepList: RecoveryInvoiceStepList/* default */.A,
                RecoveryInvoiceStepParams: RecoveryInvoiceStepParams/* default */.A
            }
        })
    ], RecoveryInvoiceParamsView);
    return RecoveryInvoiceParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var RecoveryInvoiceParamsViewvue_type_script_lang_ts = (RecoveryInvoiceParamsView);

;// ./src/views/RecoveryInvoiceParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_RecoveryInvoiceParamsViewvue_type_script_lang_ts = (RecoveryInvoiceParamsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/RecoveryInvoiceParamsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_RecoveryInvoiceParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_RecoveryInvoiceParamsView = (component.exports);

/***/ }),

/***/ 56110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(45083),
    getValue = __webpack_require__(10392);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 56195:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ 56246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerSepaList_CustomerSepaList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSepaList/CustomerSepaList.vue?vue&type=template&id=742a3a6c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":"Liste des mandats SEPA","buttons":_vm.headerButtons}}),_c('AppMessages'),_c('k-table',{ref:"table",attrs:{"url":_vm.apiUrl,"ajaxDatas":_vm.apiDatas,"columns":_vm.columns,"rowClick":_vm.rowClick,"rowActions":_vm.rowActions,"stateKey":_vm.stateKey,"exportable":"customerSepa","importable":"customerSepa"}}),_c('b-modal',{attrs:{"visible":_vm.showSepa !== null && _vm.editSepa === null && _vm.deleteSepa === null,"size":"lg"},on:{"hidden":function($event){_vm.showSepa = null}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-row',{staticClass:"w-100"},[_c('b-col',[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){_vm.editSepa = _vm.showSepa}}},[_vm._v(" Modifier ")]),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.deleteSepa = _vm.showSepa}}},[_vm._v(" Supprimer ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":close}},[_vm._v(" Fermer ")])],1)],1)]}}])},[(_vm.showSepa)?_c('CustomerSepaItem',{model:{value:(_vm.showSepa),callback:function ($$v) {_vm.showSepa=$$v},expression:"showSepa"}}):_vm._e()],1),_c('FormModal',{attrs:{"title":_vm.editSepa?.id ? 'Modification du mandat SEPA' : 'Création d\'un mandat SEPA',"visible":_vm.editSepa !== null,"size":"xl"},on:{"hidden":function($event){_vm.editSepa = null},"submitComplete":_vm.edited}},[_c('CustomerSepaForm',{attrs:{"customerId":_vm.customerId},model:{value:(_vm.editSepa),callback:function ($$v) {_vm.editSepa=$$v},expression:"editSepa"}})],1),_c('CustomerSepaDelete',{on:{"deleted":_vm.deleted,"hidden":function($event){_vm.deleteSepa = null}},model:{value:(_vm.deleteSepa),callback:function ($$v) {_vm.deleteSepa=$$v},expression:"deleteSepa"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSepaItem/CustomerSepaItem.vue?vue&type=template&id=6392735a
var CustomerSepaItemvue_type_template_id_6392735a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):(_vm.sepa)?[_c('b-overlay',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.sepa?.document_status !== 2 ? 'Document en cours de génération' : null }),expression:"{ title: sepa?.document_status !== 2 ? 'Document en cours de génération' : null }"}],staticClass:"d-inline-block mb-4",attrs:{"show":_vm.downloading}},[_c('b-button',{staticClass:"mr-2",attrs:{"size":"sm","variant":"primary","disabled":_vm.sepa?.document_status !== 2},on:{"click":_vm.download}},[_vm._v(" Télécharger ")]),(_vm.app.electronic_sign_status && _vm.sepa && !_vm.signed && _vm.can('sales-signatures', 1))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.waitingSign ? 'Un demande de signature est déjà en attente' : null }),expression:"{ title: waitingSign ? 'Un demande de signature est déjà en attente' : null }"}],staticClass:"d-inline-block"},[_c('SignSend',{attrs:{"size":"sm","variant":"primary","disabled":_vm.sepa?.document_status !== 2 || _vm.waitingSign,"value":{
              documents: [
                {
                  document_type: 'customerSepa',
                  document_id: _vm.sepa?.id,
                  document: _vm.sepa,
                  file: _vm.sepa?.pdf,
                  signable_document: _vm.team.customer_sepa_signable
                }
              ]
            }},on:{"sended":_vm.sended}})],1):_vm._e()],1),(_vm.app.electronic_sign_status && _vm.sepa?.signatures)?_c('SignState',{attrs:{"signatures":_vm.sepa.signatures},on:{"signed":state => _vm.signed = state,"waiting":state => _vm.waitingSign = state}}):_vm._e(),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.type')}},[_vm._v(" "+_vm._s(_vm.$t('sales.customerSepa.type' + _vm.sepa?.type))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.sepaType')}},[_vm._v(" "+_vm._s(_vm.$t('sales.customerSepa.sepaType' + _vm.sepa?.sepa_type))+" ")]),_c('b-form-group',{attrs:{"label":"Client"}},[_vm._v(" "+_vm._s(_vm.sepa?.customer?.name)+" ")]),(_vm.sepa?.name)?_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.name')}},[_vm._v(" "+_vm._s(_vm.sepa?.name)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Statut"}},[_vm._v(" "+_vm._s(_vm.$t('sales.customerSepa.status' + _vm.sepa?.status))+" ")])],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.owner')}},[_vm._v(" "+_vm._s(_vm.sepa?.owner)+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.iban')}},[_vm._v(" "+_vm._s(_vm.sepa?.iban)+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.bic')}},[_vm._v(" "+_vm._s(_vm.sepa?.bic)+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.sepaIdent')}},[_vm._v(" "+_vm._s(_vm.sepa?.reference)+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.date')}},[_vm._v(" "+_vm._s(_vm.date(_vm.sepa?.date))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.customerSepa.address')}},[_vm._v(" "+_vm._s(_vm.sepa?.road_number)+" "),(_vm.sepa?.road_number && _vm.sepa?.road)?void 0:_vm._e(),_vm._v(" "+_vm._s(_vm.sepa?.road)+" "),((_vm.sepa?.road_number || _vm.sepa?.road) && (_vm.sepa?.postal_code || _vm.sepa?.city))?[_c('br')]:_vm._e(),_vm._v(" "+_vm._s(_vm.sepa?.postal_code)+" "),(_vm.sepa?.postal_code && _vm.sepa?.city)?void 0:_vm._e(),_vm._v(" "+_vm._s(_vm.sepa?.city)+" "),(_vm.sepa?.country)?[_c('br'),_vm._v(" "+_vm._s(_vm.sepa?.country.name)+" ")]:_vm._e()],2)],1)],1)]:_vm._e()],2)
}
var CustomerSepaItemvue_type_template_id_6392735a_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/fetchDatas/customerSepa.ts
var customerSepa = __webpack_require__(91597);
// EXTERNAL MODULE: ./src/components/SignSend/SignSend.vue + 4 modules
var SignSend = __webpack_require__(30210);
// EXTERNAL MODULE: ./src/components/SignState/SignState.vue + 3 modules
var SignState = __webpack_require__(66346);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSepaItem/CustomerSepaItem.ts?vue&type=script&lang=ts&external










var CustomerSepaItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSepaItem, _super);
    function CustomerSepaItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.downloading = false;
        _this.sepa = null;
        _this.signed = false;
        _this.waitingSign = false;
        return _this;
    }
    CustomerSepaItem.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, (0,customerSepa/* fetchCustomerSepa */.Mx)(this.value.id)];
                    case 1:
                        _a.sepa = _b.sent();
                        this.loading = false;
                        interface_vue_.emitter.on('sepaGenerated', this.sepaGenerated);
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerSepaItem.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('sepaGenerated', this.sepaGenerated);
    };
    CustomerSepaItem.prototype.download = function () {
        var _this = this;
        var _a;
        this.downloading = true;
        this.$kwSales.axios.get('/sales/sepa/' + ((_a = this.sepa) === null || _a === void 0 ? void 0 : _a.id) + '/download')
            .then(function (response) {
            var file = response.data;
            _this.downloadFile(file.file, file.filename);
            _this.downloading = false;
        });
    };
    CustomerSepaItem.prototype.sended = function (signature) {
        var sepa = this.sepa;
        if (!sepa.signatures) {
            sepa.signatures = [];
        }
        sepa.signatures.push(signature);
    };
    CustomerSepaItem.prototype.sepaGenerated = function (datas) {
        if (datas.id !== this.value.id) {
            return;
        }
        if (this.sepa) {
            this.sepa.document_status = datas.status;
            this.sepa.pdf = datas.pdf;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaItem.prototype, "customerId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerSepaItem.prototype, "value", void 0);
    CustomerSepaItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormDatepicker: form_vue_.KFormDatepicker, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRow: external_bootstrap_vue_.BFormRow, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BOverlay: external_bootstrap_vue_.BOverlay, BModal: external_bootstrap_vue_.BModal,
                CustomerSelect: customers_vue_.CustomerSelect,
                CountrySelect: interface_vue_.CountrySelect,
                SignSend: SignSend/* default */.A, SignState: SignState/* default */.A,
                Spinner: interface_vue_.Spinner
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'team'])), (0,external_vuex_.mapState)('app', ['app']))
        })
    ], CustomerSepaItem);
    return CustomerSepaItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.FileMixin)));
/* harmony default export */ var CustomerSepaItemvue_type_script_lang_ts_external = (CustomerSepaItem);

;// ./src/components/CustomerSepaItem/CustomerSepaItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSepaItem_CustomerSepaItemvue_type_script_lang_ts_external = (CustomerSepaItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CustomerSepaItem/CustomerSepaItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerSepaItem_CustomerSepaItemvue_type_script_lang_ts_external,
  CustomerSepaItemvue_type_template_id_6392735a_render,
  CustomerSepaItemvue_type_template_id_6392735a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSepaItem_CustomerSepaItem = (component.exports);
// EXTERNAL MODULE: ./src/components/CustomerSepaForm/CustomerSepaForm.vue + 3 modules
var CustomerSepaForm = __webpack_require__(26378);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSepaDelete/CustomerSepaDelete.vue?vue&type=template&id=a39af450
var CustomerSepaDeletevue_type_template_id_a39af450_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'delete')),"ok-only":_vm.errorMsg !== null,"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"hidden":_vm.onHidden},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[(_vm.errorMsg !== null)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" Êtes-vous sûr de vouloir supprimer ce mandat SEPA ? ")])],2)
}
var CustomerSepaDeletevue_type_template_id_a39af450_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSepaDelete/CustomerSepaDelete.ts?vue&type=script&lang=ts&external



var CustomerSepaDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSepaDelete, _super);
    function CustomerSepaDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    CustomerSepaDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    CustomerSepaDelete.prototype.onHidden = function () {
        this.errorMsg = null;
        return null;
    };
    CustomerSepaDelete.prototype.onOk = function (prevent) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        prevent.preventDefault();
                        if (this.errorMsg !== null) {
                            this.errorMsg = null;
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.delete('/sales/sepa/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.$emit('deleted');
                                _this.showModal = false;
                            })
                                .catch(function (error) {
                                _this.errorMsg = error.response.data.message;
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerSepaDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomerSepaDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('hidden')
    ], CustomerSepaDelete.prototype, "onHidden", null);
    CustomerSepaDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], CustomerSepaDelete);
    return CustomerSepaDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerSepaDeletevue_type_script_lang_ts_external = (CustomerSepaDelete);

;// ./src/components/CustomerSepaDelete/CustomerSepaDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSepaDelete_CustomerSepaDeletevue_type_script_lang_ts_external = (CustomerSepaDeletevue_type_script_lang_ts_external); 
;// ./src/components/CustomerSepaDelete/CustomerSepaDelete.vue





/* normalize component */
;
var CustomerSepaDelete_component = (0,componentNormalizer/* default */.A)(
  CustomerSepaDelete_CustomerSepaDeletevue_type_script_lang_ts_external,
  CustomerSepaDeletevue_type_template_id_a39af450_render,
  CustomerSepaDeletevue_type_template_id_a39af450_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSepaDelete_CustomerSepaDelete = (CustomerSepaDelete_component.exports);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSepaList/CustomerSepaList.ts?vue&type=script&lang=ts&external








var CustomerSepaList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSepaList, _super);
    function CustomerSepaList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showSepa = null;
        _this.editSepa = null;
        _this.deleteSepa = null;
        return _this;
    }
    CustomerSepaList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                interface_vue_.emitter.on('sepaGenerated', this.sepaGenerated);
                if (this.$route.query.sepa) {
                    this.showSepa = null;
                    this.$nextTick(function () {
                        _this.showSepa = {
                            id: Number(_this.$route.query.sepa)
                        };
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    CustomerSepaList.prototype.destroyed = function () {
        interface_vue_.emitter.off('sepaGenerated', this.sepaGenerated);
    };
    Object.defineProperty(CustomerSepaList.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            return [
                {
                    label: 'Créer un mandat',
                    click: function () {
                        _this.editSepa = {};
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaList.prototype, "columns", {
        get: function () {
            var columns = [];
            if (!this.customerId) {
                columns.push({
                    name: this.$t('sales.customerSepa.customer'),
                    data: 'customer.name'
                });
            }
            columns.push.apply(columns, [
                {
                    name: this.$t('sales.customerSepa.name'),
                    data: 'name'
                },
                {
                    name: this.$t('sales.customerSepa.owner'),
                    data: 'owner'
                },
                {
                    name: this.$t('sales.customerSepa.sepaIdent'),
                    data: 'reference'
                },
                {
                    name: this.$t('sales.customerSepa.status'),
                    data: 'status',
                    render: function (status) {
                        switch (status) {
                            case 1: return 'Brouillon';
                            case 2: return 'En cours';
                            case 3: return 'Terminé';
                            default: return null;
                        }
                    }
                },
                {
                    name: this.$t('sales.customerSepa.iban'),
                    data: 'iban'
                },
                {
                    name: this.$t('sales.customerSepa.bic'),
                    data: 'bic'
                },
                {
                    name: 'Date de création',
                    data: 'created_at',
                    render: 'datetime'
                }
            ]);
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaList.prototype, "apiUrl", {
        get: function () {
            return '/sales/sepa';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaList.prototype, "apiDatas", {
        get: function () {
            if (this.customerId) {
                return {
                    filter: {
                        customer: this.customerId
                    }
                };
            }
            return {
                include: ['customer', 'country']
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaList.prototype, "stateKey", {
        get: function () {
            return (this.customerId ? 'customer-' : '') + 'sepa-list';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSepaList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    click: function (sepa) {
                        _this.editSepa = sepa;
                    }
                },
                {
                    icon: 'delete',
                    click: function (sepa) {
                        _this.deleteSepa = sepa;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CustomerSepaList.prototype.rowClick = function (sepa) {
        this.showSepa = sepa;
    };
    CustomerSepaList.prototype.edited = function (response) {
        var sepa = response.data;
        this.showSepa = sepa;
        var table = this.$refs.table;
        var datas = table.getDatas();
        var index = datas.findIndex(function (val) { return val.id === sepa.id; });
        if (index >= 0) {
            table.updateRow(index, sepa);
        }
        else {
            table.addRow(sepa);
        }
    };
    CustomerSepaList.prototype.deleted = function () {
        var _this = this;
        var table = this.$refs.table;
        var datas = table.getDatas();
        var index = datas.findIndex(function (val) { var _a; return val.id === ((_a = _this.deleteSepa) === null || _a === void 0 ? void 0 : _a.id); });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    CustomerSepaList.prototype.sepaGenerated = function (datas) {
        var table = this.$refs.table;
        var tableDatas = table.getDatas();
        var index = tableDatas.findIndex(function (val) { return val.id === datas.id; });
        if (index >= 0) {
            var sepa = tableDatas[index];
            sepa.document_status = datas.status;
            sepa.pdf = datas.pdf;
            table.updateRow(index, sepa);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSepaList.prototype, "customerId", void 0);
    CustomerSepaList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                CustomerSepaItem: CustomerSepaItem_CustomerSepaItem,
                CustomerSepaForm: CustomerSepaForm/* default */.A,
                CustomerSepaDelete: CustomerSepaDelete_CustomerSepaDelete,
                FormModal: interface_vue_.FormModal, PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages,
                BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            }
        })
    ], CustomerSepaList);
    return CustomerSepaList;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerSepaListvue_type_script_lang_ts_external = (CustomerSepaList);

;// ./src/components/CustomerSepaList/CustomerSepaList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSepaList_CustomerSepaListvue_type_script_lang_ts_external = (CustomerSepaListvue_type_script_lang_ts_external); 
;// ./src/components/CustomerSepaList/CustomerSepaList.vue





/* normalize component */
;
var CustomerSepaList_component = (0,componentNormalizer/* default */.A)(
  CustomerSepaList_CustomerSepaListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSepaList_CustomerSepaList = (CustomerSepaList_component.exports);

/***/ }),

/***/ 56449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 56464:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            standalone:
                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                    '_'
                ),
            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                '_'
            ),
            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ 56471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DeliveryList_DeliveryList; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesListMixin/SalesListMixin.vue + 3 modules
var SalesListMixin = __webpack_require__(68067);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatus.ts
var SalesDocumentStatus = __webpack_require__(70468);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DeliveryList/DeliveryList.ts?vue&type=script&lang=ts&external




var DeliveryList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DeliveryList, _super);
    function DeliveryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'delivery';
        _this.includes = [
            'customer', 'contact', 'billing_address_country', 'delivery_address_country', 'teamUser', 'customFields'
        ];
        _this.additionalColumns = [
            {
                data: 'billing_status_label',
                name: 'Statut de facturation',
                visible: false,
                cssClass: function (row) {
                    var status = {
                        'status-indicator': true
                    };
                    status['billing-status-delivery-' + row.billing_status] = true;
                    return status;
                }
            }
        ];
        return _this;
    }
    Object.defineProperty(DeliveryList.prototype, "status", {
        get: function () {
            return this.deliveryStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryList.prototype, "statusIndicator", {
        get: function () {
            return [
                { class: 'status-delivery-1', label: 'Brouillon' },
                { class: 'status-delivery-2', label: 'Validé' },
                { class: 'status-delivery-3', label: 'En attente d\'envoi' },
                { class: 'status-delivery-4', label: 'Envoyé' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryList.prototype, "computedFilters", {
        get: function () {
            var filters = Array.from(this.filters);
            filters.push({
                type: 'select',
                label: 'Statut de facturation',
                name: 'billing_status',
                options: [
                    { id: 1, label: 'À facturer' },
                    { id: 2, label: 'Facturé partiellement' },
                    { id: 3, label: 'Facturé' }
                ],
                multiple: true,
                optionLabel: 'label',
                value: 'id'
            });
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    DeliveryList = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], DeliveryList);
    return DeliveryList;
}((0,lib/* Mixins */.Xe)(SalesListMixin/* default */.A, SalesDocumentStatus/* default */.A)));
/* harmony default export */ var DeliveryListvue_type_script_lang_ts_external = (DeliveryList);

;// ./src/components/DeliveryList/DeliveryList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DeliveryList_DeliveryListvue_type_script_lang_ts_external = (DeliveryListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/DeliveryList/DeliveryList.vue
var render, staticRenderFns
;



/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DeliveryList_DeliveryListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DeliveryList_DeliveryList = (component.exports);

/***/ }),

/***/ 56476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_DocumentItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DocumentItemView.vue?vue&type=template&id=b8d3f824
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('DocumentItem',{attrs:{"type":_vm.type},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/LoadDocumentMixin.ts + 2 modules
var LoadDocumentMixin = __webpack_require__(38876);
// EXTERNAL MODULE: ./src/components/DocumentItem/DocumentItem.vue + 41 modules
var DocumentItem = __webpack_require__(55316);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DocumentItemView.vue?vue&type=script&lang=ts




var DocumentItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentItemView, _super);
    function DocumentItemView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DocumentItem: DocumentItem/* default */.A
            }
        })
    ], DocumentItemView);
    return DocumentItemView;
}((0,lib/* Mixins */.Xe)(LoadDocumentMixin/* default */.A)));
/* harmony default export */ var DocumentItemViewvue_type_script_lang_ts = (DocumentItemView);

;// ./src/views/DocumentItemView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_DocumentItemViewvue_type_script_lang_ts = (DocumentItemViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/DocumentItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_DocumentItemViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_DocumentItemView = (component.exports);

/***/ }),

/***/ 56575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ 56757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(91033);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 57114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CancelInvoice_CancelInvoice; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CancelInvoice/CancelInvoice.vue?vue&type=template&id=7c0da544
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",modifiers:{"right":true}}],tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size,"title":_vm.disabledTitle},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"title":"Annulation de la facture","ok-title":_vm.errorMsg ? 'Fermer' : 'Annuler la facture',"ok-only":_vm.errorMsg !== null,"size":_vm.cancelMode === 'content' ? 'xl' : 'md'},on:{"show":_vm.setDefaultValues,"submitComplete":_vm.submitComplete},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.errorMsg !== null)?_c('p',{staticClass:"font-weight-bold text-danger mb-0 text-center"},[_vm._v(" Erreur : "+_vm._s(_vm.errorMsg)+" ")]):_c('k-form',{attrs:{"action":_vm.formUrl,"method":"post"},on:{"submitError":_vm.submitError}},[_c('b-form-group',{staticStyle:{"max-width":"140px"},attrs:{"label":"Date de l'avoir"}},[_c('k-form-datepicker',{attrs:{"name":"date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.draft}}),(_vm.number(_vm.invoice.total_advance_ttc) === 0)?_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}},[_vm._v(" Créer l'avoir au statut brouillon ")]):_vm._e(),_c('b-alert',{staticClass:"py-2 px-3",attrs:{"variant":!_vm.draft ? 'danger' : 'warning',"show":""}},[(!_vm.draft)?[_vm._v(" Attention : l'avoir ne pourra pas être modifié ")]:[_vm._v(" Attention : si l'avoir est créé en brouillon, celui-ci n'annulera pas automatiquement la facture. ")]],2),_c('b-form-group',{attrs:{"label":"Type d'annulation :"}},[_c('b-form-radio-group',{attrs:{"options":_vm.cancelModeOptions,"stacked":""},model:{value:(_vm.cancelMode),callback:function ($$v) {_vm.cancelMode=$$v},expression:"cancelMode"}})],1),(_vm.cancelMode === 'content')?_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Désignation")]),_c('th',[_vm._v("Prix U. HT")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Qté facturée")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Qté annulée")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Quantité")]),_c('th',[_vm._v("Total")])])]),_c('tbody',_vm._l((_vm.invoice.contents),function(content,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(content.reference))]),_c('td',[_c('FroalaView',{model:{value:(content.designation),callback:function ($$v) {_vm.$set(content, "designation", $$v)},expression:"content.designation"}})],1),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(content.unit_price_ht, _vm.invoice.currency)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(content.total_quantity)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(_vm.canceledQuantity(content))))]),_c('td',{staticClass:"text-center"},[(_vm.maxQuantity(content) > 0)?[_c('k-form-spinner',{attrs:{"name":'contents[' + i + '][quantity]',"min":0,"max":_vm.maxQuantity(content),"size":"sm"},model:{value:(_vm.contents[content.affair_content_id]),callback:function ($$v) {_vm.$set(_vm.contents, content.affair_content_id, $$v)},expression:"contents[content.affair_content_id]"}}),_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][id]'},domProps:{"value":content.affair_content_id}})]:_vm._e()],2),_c('td',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.totalLineContent(content.affair_content_id), _vm.invoice.currency))+" ")])])}),0),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right",attrs:{"colspan":"6"}},[_vm._v(" Total : ")]),_c('th',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.totalContent, _vm.invoice.currency))+" ")])])])]):(_vm.cancelMode === 'amount')?_c('b-form-group',{staticStyle:{"max-width":"200px"},attrs:{"label":"Montant à annuler"}},[_c('b-input-group',[_c('k-form-number',{attrs:{"name":"amount","min":0.01,"max":_vm.cancelableAmount,"required":""}}),_c('b-input-group-append',[_c('k-form-select',{staticStyle:{"width":"90px"},attrs:{"name":"amount_type","options":_vm.amountOptions,"value":"ttc","reduce":opt => opt.value,"clearable":false}})],1)],1)],1):_vm._e(),(_vm.hasModule('stock') && _vm.cancelMode !== 'amount' && _vm.teamConfigs.stock_real_out === 7)?_c('b-form-group',{attrs:{"label":"Gestion de stock"}},[_c('input',{attrs:{"type":"hidden","name":"with_stock"},domProps:{"value":_vm.withStock}}),_c('k-form-checkbox',{model:{value:(_vm.withStock),callback:function ($$v) {_vm.withStock=$$v},expression:"withStock"}},[_vm._v(" Réintégrer les produits au stock ")])],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: ./node_modules/lodash/round.js
var round = __webpack_require__(36944);
var round_default = /*#__PURE__*/__webpack_require__.n(round);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CancelInvoice/CancelInvoice.ts?vue&type=script&lang=ts&external










var CancelInvoice = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CancelInvoice, _super);
    function CancelInvoice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        _this.draft = false;
        _this.withStock = true;
        _this.cancelMode = 'all';
        _this.contents = {};
        return _this;
    }
    Object.defineProperty(CancelInvoice.prototype, "amountOptions", {
        get: function () {
            var _a, _b;
            return [
                { value: 'ht', label: ((_a = this.invoice.currency) === null || _a === void 0 ? void 0 : _a.symbol) + ' HT' },
                { value: 'ttc', label: ((_b = this.invoice.currency) === null || _b === void 0 ? void 0 : _b.symbol) + ' TTC' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "cancelModeOptions", {
        get: function () {
            var _this = this;
            return [
                { value: 'all', text: 'Annuler toute la facture' },
                { value: 'amount', text: 'Annuler un montant' },
                { value: 'content', text: 'Annuler une partie du contenu de la facture' }
            ].filter(function (option) {
                var _a;
                if (_this.number((_a = _this.invoice) === null || _a === void 0 ? void 0 : _a.total_advance_ttc) > 0) {
                    return option.value === 'all';
                }
                return option.value !== 'amount' || !_this.haveMultipleVatRates;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "formUrl", {
        get: function () {
            return '/sales/invoice/' + this.invoice.id + '/cancel';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "totalLineContent", {
        get: function () {
            var _this = this;
            return function (id) {
                var _a;
                var qty = (_a = _this.number(_this.contents[id])) !== null && _a !== void 0 ? _a : 0;
                var content = _this.invoice.contents.find(function (content) { return content.affair_content_id === id; });
                var unitPrice = content ? _this.number(content.unit_price_ht) : 0;
                return qty * unitPrice;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "totalContent", {
        get: function () {
            var _this = this;
            var total = 0;
            forEach_default()(this.contents, function (quantity, id) {
                total += _this.totalLineContent(Number(id));
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "cancelableAmount", {
        get: function () {
            return round_default()(this.number(this.invoice.total_ttc) - this.totalCredit, 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "disabled", {
        get: function () {
            var invoice = this.invoice;
            return invoice.is_draft || invoice.total_ttc <= 0 || this.totalCredit >= invoice.total_ttc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "totalCredit", {
        get: function () {
            var _this = this;
            var _a;
            return round_default()(sumBy_default()((_a = this.invoice.credits) === null || _a === void 0 ? void 0 : _a.filter(function (credit) { return credit.invoice_id === _this.invoice.id; }), function (credit) { return _this.number(credit.total_ttc); }), 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "disabledTitle", {
        get: function () {
            var invoice = this.invoice;
            if (invoice.is_draft) {
                return 'Vous ne pouvez pas annuler une facture au statut brouillon';
            }
            else if (invoice.total_ttc <= 0) {
                return 'Vous ne pouvez pas annuler une facture dont le total est inférieur ou égal à 0';
            }
            else if (this.totalCredit >= invoice.total_ttc) {
                return 'Cette facture a déjà été annulée à 100%';
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "canceledQuantity", {
        get: function () {
            var _this = this;
            return function (content) {
                var _a;
                var affairContentId = content.affair_content_id;
                var contents = [];
                (_a = _this.invoice.credits) === null || _a === void 0 ? void 0 : _a.forEach(function (credit) {
                    contents.push.apply(contents, credit.contents.filter(function (content) { return content.affair_content_id === affairContentId; }));
                });
                return sumBy_default()(contents, function (content) { return _this.number(content.total_quantity); });
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "maxQuantity", {
        get: function () {
            var _this = this;
            return function (content) {
                return _this.number(content.total_quantity) - _this.canceledQuantity(content);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CancelInvoice.prototype, "haveMultipleVatRates", {
        get: function () {
            return this.invoice.vatrates.length > 1;
        },
        enumerable: false,
        configurable: true
    });
    CancelInvoice.prototype.setDefaultValues = function () {
        this.date = external_moment_default()().format('YYYY-MM-DD');
        this.draft = false;
        this.cancelMode = 'all';
        this.errorMsg = null;
    };
    CancelInvoice.prototype.submitComplete = function (response) {
        return response.data;
    };
    CancelInvoice.prototype.submitError = function (error) {
        var _a, _b;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== 422) {
            this.errorMsg = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data.message;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CancelInvoice.prototype, "invoice", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CancelInvoice.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Annuler la facture' })
    ], CancelInvoice.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CancelInvoice.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CancelInvoice.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], CancelInvoice.prototype, "submitComplete", null);
    CancelInvoice = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend,
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber, KFormSpinner: form_vue_.KFormSpinner, FroalaView: form_vue_.FroalaView, KFormSelect: form_vue_.KFormSelect
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CancelInvoice);
    return CancelInvoice;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CancelInvoicevue_type_script_lang_ts_external = (CancelInvoice);

;// ./src/components/CancelInvoice/CancelInvoice.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CancelInvoice_CancelInvoicevue_type_script_lang_ts_external = (CancelInvoicevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CancelInvoice/CancelInvoice.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CancelInvoice_CancelInvoicevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CancelInvoice_CancelInvoice = (component.exports);

/***/ }),

/***/ 57182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProformaList_ProformaList; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesListMixin/SalesListMixin.vue + 3 modules
var SalesListMixin = __webpack_require__(68067);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatus.ts
var SalesDocumentStatus = __webpack_require__(70468);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProformaList/ProformaList.ts?vue&type=script&lang=ts&external




var ProformaList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProformaList, _super);
    function ProformaList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'proforma';
        return _this;
    }
    Object.defineProperty(ProformaList.prototype, "status", {
        get: function () {
            return this.proformaStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProformaList.prototype, "statusIndicator", {
        get: function () {
            return [
                { class: 'status-proforma-1', label: 'Brouillon' },
                { class: 'status-proforma-2', label: 'Validée' },
                { class: 'status-proforma-3', label: 'Envoyée' },
                { class: 'status-proforma-4', label: 'Acceptée' },
                { class: 'status-proforma-6', label: 'Facturée' },
                { class: 'status-proforma-7', label: 'Annulée' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ProformaList.prototype.canBeEdited = function (proforma) {
        var _a;
        return ((_a = proforma.to_bill) !== null && _a !== void 0 ? _a : 0) > 0;
    };
    ProformaList = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], ProformaList);
    return ProformaList;
}((0,lib/* Mixins */.Xe)(SalesDocumentStatus/* default */.A, SalesListMixin/* default */.A)));
/* harmony default export */ var ProformaListvue_type_script_lang_ts_external = (ProformaList);

;// ./src/components/ProformaList/ProformaList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProformaList_ProformaListvue_type_script_lang_ts_external = (ProformaListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ProformaList/ProformaList.vue
var render, staticRenderFns
;



/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProformaList_ProformaListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProformaList_ProformaList = (component.exports);

/***/ }),

/***/ 57553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractDelete_ContractDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractDelete/ContractDelete.vue?vue&type=template&id=5c1fe312
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce contrat ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractDelete/ContractDelete.ts?vue&type=script&lang=ts&external




var ContractDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractDelete, _super);
    function ContractDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ContractDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    ContractDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    ContractDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    ContractDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/sales/contract/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    ContractDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    ContractDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ContractDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ContractDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], ContractDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ContractDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], ContractDelete.prototype, "watchModalState", null);
    ContractDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ContractDelete);
    return ContractDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractDeletevue_type_script_lang_ts_external = (ContractDelete);

;// ./src/components/ContractDelete/ContractDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractDelete_ContractDeletevue_type_script_lang_ts_external = (ContractDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractDelete/ContractDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractDelete_ContractDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDelete_ContractDelete = (component.exports);

/***/ }),

/***/ 57609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ 57777:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ 58076:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                  ? wordKey[1]
                  : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ 58156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(47422);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 58399:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/table-vue");

/***/ }),

/***/ 58676:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ 59304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CustomerSepaListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomerSepaListView.vue?vue&type=template&id=29dec1c8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CustomerSepaList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CustomerSepaList/CustomerSepaList.vue + 11 modules
var CustomerSepaList = __webpack_require__(56246);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomerSepaListView.vue?vue&type=script&lang=ts



var CustomerSepaListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSepaListView, _super);
    function CustomerSepaListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerSepaListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomerSepaList: CustomerSepaList/* default */.A
            }
        })
    ], CustomerSepaListView);
    return CustomerSepaListView;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerSepaListViewvue_type_script_lang_ts = (CustomerSepaListView);

;// ./src/views/CustomerSepaListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CustomerSepaListViewvue_type_script_lang_ts = (CustomerSepaListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/CustomerSepaListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CustomerSepaListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CustomerSepaListView = (component.exports);

/***/ }),

/***/ 59350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 59368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var froala_editor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30189);
/* harmony import */ var froala_editor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(froala_editor__WEBPACK_IMPORTED_MODULE_0__);

var config = {
    enter: (froala_editor__WEBPACK_IMPORTED_MODULE_0___default().ENTER_BR),
    fontSizeUnit: 'pt',
    zIndex: 999999,
    heightMin: 100,
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'fontSize',
                '|',
                'textColor',
                'backgroundColor',
                '|',
                'formatUL',
                'formatOL',
                '|',
                'insertImage',
                'insertTable',
                'insertHR',
                '|',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify',
                '|',
                'insertDynamicVariables'
            ],
            buttonsVisible: 16
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedAttrs: [
        'align', 'alt', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'class', 'color',
        'cols', 'colspan', 'content', 'contenteditable', 'data', 'data-.*', 'datetime', 'disabled', 'form', 'height',
        'hidden', 'href', 'id', 'label', 'max', 'min', 'multiple', 'name', 'placeholder', 'radiogroup', 'readonly',
        'rel', 'required', 'rows', 'rowspan', 'selected', 'size', 'sizes', 'span', 'src', 'step', 'style', 'tabindex',
        'target', 'title', 'type', 'value', 'valign', 'width', 'pagebreak', 'nobr'
    ],
    tableEditButtons: [
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableBorder',
        'tableBackground',
        'tableSpaces',
        '-',
        'tableCells',
        'tableCellBackground',
        'tableCellBorder',
        'tableCellHorizontalAlign',
        'tableCellHeight'
    ],
    imageUpload: false,
    //imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    //imageMaxSize: 5 * 1024 * 1024, // 5MB
    //imageUploadMethod: 'POST',
    //imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageManager'],
    imageDefaultDisplay: 'inline',
    imageEditButtons: ['imageReplace', 'imageRemove', 'imageSize'],
    //imageManagerToggleTags: false,
    requestHeaders: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + ({"NODE_ENV":"production","VUE_APP_ESIGN_FREE":"1","VUE_APP_HERE_API_KEY":"23z1ejZ9DwiGvj9aAxpscJ_yr-et9lqeAeZKxgWynL4","VUE_APP_API_URL":"http://127.0.0.1:8000/api","VUE_APP_PUSHER_APP_KEY":"d683bedd72c05f60b321bbd698222a64","VUE_APP_PUSHER_HOST":"socket.kwixeo.fr","VUE_APP_PUSHER_PORT":"6002","BASE_URL":"/"}).VUE_APP_BEARER_TOKEN
    },
    requestWithCredentials: true,
    requestWithCORS: false,
    imageCORSProxy: false,
    dynamicVariables: {
        company: {
            label: 'Informations de votre entreprise',
            variables: [
                { value: 'COMPANY-NAME', label: 'Nom de l\'entreprise' },
                { value: 'COMPANY-ROAD', label: 'Adresse - rue' },
                { value: 'COMPANY-ROAD2', label: 'Adresse - rue 2' },
                { value: 'COMPANY-ROAD3', label: 'Adresse - rue 3' },
                { value: 'COMPANY-POSTAL', label: 'Code postal' },
                { value: 'COMPANY-TOWN', label: 'Ville' },
                { value: 'COMPANY-COUNTRY', label: 'Pays' },
                { value: 'COMPANY-PHONE', label: 'Téléphone fixe' },
                { value: 'COMPANY-MOBILE', label: 'Téléphone portable' },
                { value: 'COMPANY-FAX', label: 'Fax' },
                { value: 'COMPANY-EMAIL', label: 'Email' },
                { value: 'COMPANY-WEBSITE', label: 'Site internet' },
                { value: 'COMPANY-TYPE', label: 'Type d\'entreprise' },
                { value: 'COMPANY-SIRET', label: 'N° SIRET' },
                { value: 'COMPANY-RCS', label: 'N° RCS' },
                { value: 'COMPANY-TVA', label: 'N° TVA intracommunautaire' },
                { value: 'COMPANY-NAF', label: 'Code NAF' },
                { value: 'COMPANY-CAPITAL', label: 'Capital' }
            ]
        },
        tiers: {
            label: 'Informations sur le client',
            variables: [
                { value: 'TIERS-CODE', label: 'Code client' },
                { value: 'TIERS-NAME', label: 'Nom du client' },
                { value: 'TIERS-ROAD', label: 'Adresse - rue' },
                { value: 'TIERS-ROAD2', label: 'Adresse - rue 2' },
                { value: 'TIERS-ROAD3', label: 'Adresse - rue 3' },
                { value: 'TIERS-POSTAL', label: 'Code postal' },
                { value: 'TIERS-TOWN', label: 'Ville' },
                { value: 'TIERS-COUNTRY', label: 'Pays' },
                { value: 'TIERS-PHONE', label: 'Téléphone fixe' },
                { value: 'TIERS-MOBILE', label: 'Téléphone portable' },
                { value: 'TIERS-FAX', label: 'Fax' },
                { value: 'TIERS-EMAIL', label: 'Email' },
                { value: 'TIERS-WEBSITE', label: 'Site internet' },
                { value: 'TIERS-SIRET', label: 'N° SIRET' },
                { value: 'TIERS-TVA', label: 'N° TVA intracommunautaire' },
                { value: 'TIERS-COMMERCIAL', label: 'Prénom et nom du commercial' }
            ]
        },
        contact: {
            label: 'Informations sur le contact',
            variables: [
                { value: 'CONTACT-FULLNAME', label: 'Nom complet' },
                { value: 'CONTACT-FIRSTNAME', label: 'Prénom' },
                { value: 'CONTACT-LASTNAME', label: 'Nom de famille' },
                { value: 'CONTACT-ROAD', label: 'Adresse - rue' },
                { value: 'CONTACT-ROAD2', label: 'Adresse - rue 2' },
                { value: 'CONTACT-ROAD3', label: 'Adresse - rue 3' },
                { value: 'CONTACT-POSTAL', label: 'Code postal' },
                { value: 'CONTACT-TOWN', label: 'Ville' },
                { value: 'CONTACT-COUNTRY', label: 'Pays' },
                { value: 'CONTACT-PHONE', label: 'Téléphone fixe' },
                { value: 'CONTACT-MOBILE', label: 'Téléphone portable' },
                { value: 'CONTACT-FAX', label: 'Fax' },
                { value: 'CONTACT-EMAIL', label: 'Email' },
                { value: 'CONTACT-WEBSITE', label: 'Site internet' }
            ]
        },
        document: {
            label: 'Informations sur le document',
            variables: [
                { value: 'COMMERCIAL-NAME', label: 'Prénom et nom du commercial' },
                { value: 'COMMERCIAL-FIRSTNAME', label: 'Prénom du commercial' },
                { value: 'COMMERCIAL-LASTNAME', label: 'Nom du commercial' },
                { value: 'COMMERCIAL-TEL', label: 'Téléphone du commercial' },
                { value: 'COMMERCIAL-PORT', label: 'Portable du commercial' },
                { value: 'COMMERCIAL-FAX', label: 'Fax du commercial' },
                { value: 'COMMERCIAL-EMAIL', label: 'Email du commercial' },
                { value: 'DOC-NUM', label: 'Numéro du document' },
                { value: 'DATE', label: 'Date' },
                { value: 'EXP-DATE', label: 'Date d\'expiration' },
                { value: 'BDC-TIERS', label: 'N° du bon de commande client' },
                { value: 'INVOICE-ADDRESS', label: 'Adresse de facturation' },
                { value: 'TOTAL-HT', label: 'Total HT' },
                { value: 'TOTAL-TVA', label: 'Total TVA' },
                { value: 'TOTAL-TTC', label: 'Total TTC' },
                { value: 'TO-PAID', label: 'Montant à payer' }
            ]
        },
        contrat: {
            label: 'Informations sur le contrat',
            variables: [
                { value: 'CONTRAT-NUM', label: 'Numéro du contrat' },
                { value: 'CONTRAT-TITLE', label: 'Titre du contrat' },
                { value: 'CONTRAT-BEGIN', label: 'Date de début de l\'échéance' },
                { value: 'CONTRAT-END', label: 'Date de fin de l\'échéance' }
            ]
        }
    }
};
/* harmony default export */ __webpack_exports__.A = (config);


/***/ }),

/***/ 59527:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ 59755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ GrantSelect_GrantSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/GrantSelect/GrantSelect.vue?vue&type=template&id=24e4c4fe
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.grants}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/GrantSelect/GrantSelect.ts?vue&type=script&lang=ts&external




var GrantSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GrantSelect, _super);
    function GrantSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GrantSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadGrants()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(GrantSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], GrantSelect.prototype, "value", void 0);
    GrantSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadGrants'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('sales', ['grants'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], GrantSelect);
    return GrantSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var GrantSelectvue_type_script_lang_ts_external = (GrantSelect);

;// ./src/components/GrantSelect/GrantSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var GrantSelect_GrantSelectvue_type_script_lang_ts_external = (GrantSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/GrantSelect/GrantSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  GrantSelect_GrantSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GrantSelect_GrantSelect = (component.exports);

/***/ }),

/***/ 59792:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/calendars-vue");

/***/ }),

/***/ 60134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractDeadlinesCancel_ContractDeadlinesCancel; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractDeadlinesCancel/ContractDeadlinesCancel.vue?vue&type=template&id=1b5d68c9
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value !== null)?_c('FormModal',{attrs:{"visible":_vm.value !== null,"ok-title":!_vm.errorMsg ? 'Annuler l\'échéance' : 'Fermer',"ok-only":_vm.errorMsg,"title":"Annulation d'une échéance"},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[(_vm.errorMsg)?_c('div',{staticClass:"text-danger font-weight-bold text-center"},[_vm._v(" Erreur : "+_vm._s(_vm.errorMsg)+" ")]):_c('k-form',{attrs:{"action":'/sales/contract/deadline/' + _vm.value.id + '/cancel'},on:{"submitComplete":response => _vm.$emit('canceled', response.data),"submitError":_vm.submitError}},[_c('b-form-group',{attrs:{"label":"Quelle action souhaitez-vous effectuer ?"}},[_c('b-form-radio-group',{attrs:{"name":"mode","options":_vm.cancelOptions,"stacked":""},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})],1),_c('b-alert',{attrs:{"show":_vm.mode !== 'cancel',"variant":"danger"}},[_vm._v(" Fusionner une échéance est une action irréversible. ")])],1)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractDeadlinesCancel/ContractDeadlinesCancel.ts?vue&type=script&lang=ts&external





var ContractDeadlinesCancel = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractDeadlinesCancel, _super);
    function ContractDeadlinesCancel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mode = 'cancel';
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ContractDeadlinesCancel.prototype, "cancelOptions", {
        get: function () {
            var options = [
                { text: 'Annuler l\'échéance', value: 'cancel' }
            ];
            if (this.previous && !this.previous.canceled_at && !this.previous.invoice_id) {
                options.push({ text: 'Fusionner avec l\'échéance précédente', value: 'previous' });
            }
            if (this.next && !this.next.canceled_at && !this.next.invoice_id) {
                options.push({ text: 'Fusionner avec l\'échéance suivante', value: 'next' });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    ContractDeadlinesCancel.prototype.watchValue = function () {
        this.mode = 'cancel';
        this.errorMsg = null;
    };
    ContractDeadlinesCancel.prototype.submitError = function (error) {
        var _a;
        this.errorMsg = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlinesCancel.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlinesCancel.prototype, "contract", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlinesCancel.prototype, "previous", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlinesCancel.prototype, "next", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ContractDeadlinesCancel.prototype, "watchValue", null);
    ContractDeadlinesCancel = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BAlert: external_bootstrap_vue_.BAlert,
                KForm: form_vue_.KForm,
                FormModal: interface_vue_.FormModal
            }
        })
    ], ContractDeadlinesCancel);
    return ContractDeadlinesCancel;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractDeadlinesCancelvue_type_script_lang_ts_external = (ContractDeadlinesCancel);

;// ./src/components/ContractDeadlinesCancel/ContractDeadlinesCancel.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractDeadlinesCancel_ContractDeadlinesCancelvue_type_script_lang_ts_external = (ContractDeadlinesCancelvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractDeadlinesCancel/ContractDeadlinesCancel.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractDeadlinesCancel_ContractDeadlinesCancelvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDeadlinesCancel_ContractDeadlinesCancel = (component.exports);

/***/ }),

/***/ 60270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(87068),
    isObjectLike = __webpack_require__(40346);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 60516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractDeadlinesList_ContractDeadlinesList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractDeadlinesList/ContractDeadlinesList.vue?vue&type=template&id=56df3148
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-table',{ref:"table",attrs:{"url":"/sales/contract/deadline","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowLink":_vm.rowLink,"stateKey":"contract-deadline-list","exportable":"contract-deadline"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractDeadlinesList/ContractDeadlinesList.ts?vue&type=script&lang=ts&external





var ContractDeadlinesList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractDeadlinesList, _super);
    function ContractDeadlinesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    ContractDeadlinesList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadContractModels()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContractDeadlinesList.prototype, "ajaxDatas", {
        get: function () {
            var include = ['invoice', 'contract', 'contract.model'];
            var filter = { is_canceled: false };
            if (this.customerId) {
                filter.customer = this.customerId;
            }
            else {
                include.push('contract.customer');
            }
            return {
                include: include,
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractDeadlinesList.prototype, "columns", {
        get: function () {
            var columns = [
                {
                    data: 'period.contract.reference',
                    name: 'N° Contrat'
                },
                {
                    data: 'period.contract.title',
                    name: 'Titre du contrat',
                    visible: false
                },
                {
                    data: 'period.contract.model.name',
                    name: 'Type de contrat',
                    visible: false
                }
            ];
            if (!this.customerId) {
                columns.push({
                    data: 'period.contract.customer.name',
                    name: 'Client'
                });
            }
            columns.push.apply(columns, [
                {
                    data: 'date',
                    name: 'Date de l\'échéance',
                    render: 'date'
                },
                {
                    data: 'begin',
                    name: 'Début de la période',
                    render: 'date'
                },
                {
                    data: 'end',
                    name: 'Fin de la période',
                    render: 'date'
                },
                {
                    data: 'total_ht',
                    name: 'Montant HT',
                    render: 'currency'
                },
                {
                    data: 'total_tva',
                    name: 'Montant TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ttc',
                    name: 'Montant TTC',
                    render: 'currency'
                },
                {
                    data: 'invoice_id',
                    name: 'Statut de l\'échéance',
                    render: function (data, row) {
                        if (row.canceled_at !== null) {
                            return 'Annulée';
                        }
                        return data === null || data === '' ? 'À venir' : 'Facturée';
                    }
                },
                {
                    data: 'period.contract.status',
                    name: 'Statut du contrat',
                    render: function (data) {
                        switch (data) {
                            case 1: return 'Brouillon';
                            case 2: return 'En attente';
                            case 3: return 'En cours';
                            case 4: return 'Terminé';
                            default: return '';
                        }
                    },
                    visible: false
                },
                {
                    data: 'invoice.reference',
                    name: 'Facture'
                }
            ]);
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractDeadlinesList.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    type: 'period',
                    label: 'Date de l\'échéance',
                    name: 'date_since',
                    name2: 'date_until'
                }
            ];
            if (!this.customerId) {
                filters.push({
                    type: 'select',
                    label: 'Client',
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[hasContract]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            filters.push.apply(filters, [
                {
                    type: 'select',
                    label: 'Type de contrat',
                    name: 'model',
                    options: this.contractModels,
                    optionLabel: 'name',
                    value: 'id',
                    multiple: true
                },
                {
                    type: 'select',
                    label: 'Statut des contrats',
                    name: 'contract_status',
                    options: [
                        { value: 1, label: 'Brouillon' },
                        { value: 2, label: 'En attente' },
                        { value: 3, label: 'En cours' },
                        { value: 4, label: 'Terminé' }
                    ],
                    optionLabel: 'label',
                    value: 'value',
                    multiple: true
                },
                {
                    type: 'select',
                    label: 'Statut des échéances',
                    name: 'status',
                    placeholder: 'À venir et Facturée',
                    options: [
                        { value: 1, label: 'À venir' },
                        { value: 2, label: 'Facturée' },
                        { value: 3, label: 'Annulée' }
                    ],
                    optionLabel: 'label',
                    value: 'value',
                    multiple: true,
                    params: {
                        class: 'contract-deadline-status-filter'
                    }
                }
            ]);
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    ContractDeadlinesList.prototype.rowLink = function (row) {
        var _a, _b;
        return {
            name: 'contract-item',
            params: { id: String((_b = (_a = row.period) === null || _a === void 0 ? void 0 : _a.contract) === null || _b === void 0 ? void 0 : _b.id) }
        };
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractDeadlinesList.prototype, "customerId", void 0);
    ContractDeadlinesList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                Spinner: interface_vue_.Spinner
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadContractModels'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('sales', ['contractModels']))
        })
    ], ContractDeadlinesList);
    return ContractDeadlinesList;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractDeadlinesListvue_type_script_lang_ts_external = (ContractDeadlinesList);

;// ./src/components/ContractDeadlinesList/ContractDeadlinesList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractDeadlinesList_ContractDeadlinesListvue_type_script_lang_ts_external = (ContractDeadlinesListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractDeadlinesList/ContractDeadlinesList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractDeadlinesList_ContractDeadlinesListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDeadlinesList_ContractDeadlinesList = (component.exports);

/***/ }),

/***/ 60708:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ 60726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'search';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f002';
var svgPathData = 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Mj = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 60843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerSepaParams_CustomerSepaParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSepaParams/CustomerSepaParams.vue?vue&type=template&id=2529f928
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":"Paramètres"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":"Identifiant créancier SEPA"}},[_c('k-form-input',{attrs:{"name":"configs[sales_sepa_ics]"},model:{value:(_vm.localConfig.sales_sepa_ics),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_sepa_ics", $$v)},expression:"localConfig.sales_sepa_ics"}})],1),_c('b-form-group',{attrs:{"label":"Mode de règlement à utiliser lors de la création des remise de prélèvement"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_sepa_payment_method]"},domProps:{"value":_vm.localConfig.sales_sepa_payment_method ? _vm.localConfig.sales_sepa_payment_method.id : null}}),_c('PaymentMethodSelect',{attrs:{"required":""},model:{value:(_vm.localConfig.sales_sepa_payment_method),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_sepa_payment_method", $$v)},expression:"localConfig.sales_sepa_payment_method"}})],1),_c('b-form-group',{attrs:{"label":"Statut par défaut des mandats SEPA"}},[_c('k-form-select',{attrs:{"name":"configs[sales_sepa_default_status]","clearable":false,"options":_vm.sepaStatus,"reduce":opt => opt.value},model:{value:(_vm.localConfig.sales_sepa_default_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_sepa_default_status", $$v)},expression:"localConfig.sales_sepa_default_status"}})],1),_c('p',{staticClass:"mt-2 mb-0"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1),_c('b-tab',{attrs:{"title":"Numéro de mandat SEPA"}},[_c('p',[_vm._v(" Vous pouvez paramétrez ici, la numérotation des mandats SEPA. ")]),_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.params.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceDay')))])])]),_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap",attrs:{"responsive":""}},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_sepa_reference_prefix]","required":"","max":"10","size":"sm","validate":"sepaReference"},model:{value:(_vm.localConfig.sales_sepa_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_sepa_reference_prefix", $$v)},expression:"localConfig.sales_sepa_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_sepa_reference_number]","min":1,"maxDecimal":0,"size":"sm"},model:{value:(_vm.localConfig.sales_sepa_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_sepa_reference_number", $$v)},expression:"localConfig.sales_sepa_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_sepa_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_sepa_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_sepa_reference_length", $$v)},expression:"localConfig.sales_sepa_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.sepaReferenceExample))])])])]),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1),_c('b-tab',{attrs:{"title":"Mandat SEPA PDF"}},[_c('p',[_vm._v(" Vous avez la possibilité de personnaliser les mandats SEPA PDF qui seront générés depuis le logiciel en utilisant un document Word. ")]),_c('b-form-group',{attrs:{"label":"Mandat SEPA"}},[(_vm.localTeam.customer_sepa_model)?_c('div',{staticClass:"mt-2"},[_c('div',[_c('p',{staticClass:"text-center d-inline-block mb-1"},[_c('font-awesome-icon',{staticClass:"icon",style:({ color: '#5959ff', 'font-size': '2rem' }),attrs:{"icon":['fad', 'file-word' ]}}),_c('span',{staticClass:"d-inline-block text-truncate w-100 small pt-1"},[_vm._v(" "+_vm._s(_vm.localTeam.customer_sepa_model.filename)+" ")])],1)]),_c('b-overlay',{attrs:{"show":_vm.loadingDefaultModel}},[_c('div',{staticClass:"my-2"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadCustomModel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toDelete = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])],1)]),_c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"no-close-on-esc":_vm.loadingDelete,"hide-header-close":_vm.loadingDelete,"no-close-on-backdrop":_vm.loadingDelete,"busy":_vm.loadingDelete},on:{"ok":_vm.deleteSepaModel},model:{value:(_vm.toDelete),callback:function ($$v) {_vm.toDelete=$$v},expression:"toDelete"}},[(_vm.loadingDelete)?_c('Spinner'):_c('div',[_vm._v(" Êtes-vous sûr de vouloir supprimer ce modèle de mandat SEPA ? ")])],1)],1):_c('div',[_c('small',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.fileType'))+" ")]),_c('k-form-file',{attrs:{"url":_vm.formAction,"name":"customer_sepa_model","datas":{ _method: 'PUT' },"btnMode":"","btnSize":"sm","accept":['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text']},on:{"onUpload":_vm.applyNewTeam}})],1),_c('div',{staticClass:"mt-5"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.explain2'))),_c('br'),_c('b-overlay',{attrs:{"show":_vm.loadingDefaultModel}},[_c('b-button',{staticClass:"my-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadDefaultModel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.downloadDefault'))+" ")])],1),_c('p',{staticClass:"mt-4 mb-2"},[_vm._v(" Liste des variables dynamiques qui peuvent être utilisées dans le document Word. Celles-ci seront automatiquement remplacées lors de la génération du mandat SEPA."),_c('br')]),_c('b-tabs',[_c('b-tab',{attrs:{"title":"Votre entreprise"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$companyName$")]),_c('td',[_vm._v("Nom de l'entreprise")])]),_c('tr',[_c('td',[_vm._v("$IcsNumber$")]),_c('td',[_vm._v("Identifiant Créancier SEPA")])]),_c('tr',[_c('td',[_vm._v("$companyRoad$")]),_c('td',[_vm._v("Adresse - Rue 1")])]),_c('tr',[_c('td',[_vm._v("$companyRoad2$")]),_c('td',[_vm._v("Adresse - Rue 2")])]),_c('tr',[_c('td',[_vm._v("$companyRoad3$")]),_c('td',[_vm._v("Adresse - Rue 3")])]),_c('tr',[_c('td',[_vm._v("$companyPostalCode$")]),_c('td',[_vm._v("Adresse - Code postal")])]),_c('tr',[_c('td',[_vm._v("$companyCity$")]),_c('td',[_vm._v("Adresse - Ville")])]),_c('tr',[_c('td',[_vm._v("$companyCountry$")]),_c('td',[_vm._v("Adresse - Pays")])])])])]),_c('b-tab',{attrs:{"title":"Mandat SEPA"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$reference$")]),_c('td',[_vm._v("Référence unique du mandat")])]),_c('tr',[_c('td',[_vm._v("$type$")]),_c('td',[_vm._v("Type de mandat (Récurrent, Ponctuel)")])]),_c('tr',[_c('td',[_vm._v("$iban$")]),_c('td',[_vm._v("IBAN")])]),_c('tr',[_c('td',[_vm._v("$bic$")]),_c('td',[_vm._v("Bic")])]),_c('tr',[_c('td',[_vm._v("$holder$")]),_c('td',[_vm._v("Titulaire du compte")])]),_c('tr',[_c('td',[_vm._v("$roadNumber$")]),_c('td',[_vm._v("Adresse - Numéro de rue")])]),_c('tr',[_c('td',[_vm._v("$road$")]),_c('td',[_vm._v("Adresse - Rue")])]),_c('tr',[_c('td',[_vm._v("$postalCode$")]),_c('td',[_vm._v("Adresse - Code postal")])]),_c('tr',[_c('td',[_vm._v("$city$")]),_c('td',[_vm._v("Adresse - Ville")])]),_c('tr',[_c('td',[_vm._v("$country$")]),_c('td',[_vm._v("Adresse - Pays")])])])])]),_c('b-tab',{attrs:{"title":"Signature électronique"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$signBlock$")]),_c('td',[_vm._v("Emplacement pour la signature")])]),_c('tr',[_c('td',[_vm._v("$signDate$")]),_c('td',[_vm._v("Emplacement pour la date de signature")])])])])])],1)],1)])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSepaParams/CustomerSepaParams.ts?vue&type=script&lang=ts&external






var CustomerSepaParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSepaParams, _super);
    function CustomerSepaParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        _this.sepaStatus = [
            { label: 'Brouillon', value: 1 },
            { label: 'En cours', value: 2 }
        ];
        _this.toDelete = false;
        _this.loadingDelete = false;
        _this.loadingDefaultModel = false;
        _this.loadingCustomModel = false;
        return _this;
    }
    CustomerSepaParams.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    CustomerSepaParams.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return null;
        }
        var numberLength = String(number).length;
        if (numberLength > length) {
            length = numberLength;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    Object.defineProperty(CustomerSepaParams.prototype, "sepaReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_sepa_reference_prefix, this.localConfig.sales_sepa_reference_number, this.localConfig.sales_sepa_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    CustomerSepaParams.prototype.downloadCustomModel = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var model;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        model = (_a = this.localTeam) === null || _a === void 0 ? void 0 : _a.customer_sepa_model;
                        if (!model) {
                            return [2 /*return*/];
                        }
                        this.loadingCustomModel = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/file/' + model.id + '?with_file=1')
                                .then(function (response) {
                                _this.downloadFile(response.data.file, model.filename);
                            })
                                .finally(function () {
                                _this.loadingCustomModel = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerSepaParams.prototype.downloadDefaultModel = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingDefaultModel = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/default-sepa-model')
                                .then(function (response) {
                                _this.downloadFile(response.data, 'sepa-model.docx');
                            })
                                .finally(function () {
                                _this.loadingDefaultModel = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerSepaParams.prototype.deleteSepaModel = function (evt) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.preventDefault();
                        this.loadingDelete = true;
                        return [4 /*yield*/, this.$kwSales.axios.put(this.formAction, {
                                customer_sepa_model: null
                            })
                                .then(function (response) {
                                _this.applyNewTeam(response.data);
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.toDelete = false;
                                _this.loadingDelete = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerSepaParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber,
                BTableSimple: external_bootstrap_vue_.BTableSimple, BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BOverlay: external_bootstrap_vue_.BOverlay, BModal: external_bootstrap_vue_.BModal,
                PaymentMethodSelect: interface_vue_.PaymentMethodSelect, Spinner: interface_vue_.Spinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], CustomerSepaParams);
    return CustomerSepaParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin, interface_vue_.FileMixin)));
/* harmony default export */ var CustomerSepaParamsvue_type_script_lang_ts_external = (CustomerSepaParams);

;// ./src/components/CustomerSepaParams/CustomerSepaParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSepaParams_CustomerSepaParamsvue_type_script_lang_ts_external = (CustomerSepaParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CustomerSepaParams/CustomerSepaParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerSepaParams_CustomerSepaParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSepaParams_CustomerSepaParams = (component.exports);

/***/ }),

/***/ 60906:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f067';
var svgPathData = 'M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.QL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 61061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentSpeedEdit_DocumentSpeedEdit; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentSpeedEdit/DocumentSpeedEdit.vue?vue&type=template&id=d40e862e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"title":_vm.$t('interface.speedEdit'),"size":"lg","ok-title":_vm.$t('interface.save'),"cancel-title":_vm.$t('interface.cancel')},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.document)?_c('k-form',{ref:"form",attrs:{"action":_vm.formApi,"method":"PUT"},on:{"submitComplete":_vm.submitted}},[(_vm.type === 'invoice' && _vm.value.escompte_rate > 0)?_c('b-row',[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"escompte_status"},domProps:{"value":_vm.document.escompte_status}}),_c('k-form-checkbox',{staticClass:"mb-4",model:{value:(_vm.document.escompte_status),callback:function ($$v) {_vm.$set(_vm.document, "escompte_status", $$v)},expression:"document.escompte_status"}},[_vm._v(" Appliquer l'escompte de "+_vm._s(_vm.showNumber(_vm.value.escompte_rate))+" %, soit "+_vm._s(_vm.formattedNumber(_vm.value.escompte_amount_ttc, _vm.value.currency))+" "),(_vm.document.escompte_status)?[_vm._v(" en date du ")]:_vm._e()],2)],1),(_vm.document.escompte_status)?_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"name":"escompte_date","size":"sm","required":""},model:{value:(_vm.document.escompte_date),callback:function ($$v) {_vm.$set(_vm.document, "escompte_date", $$v)},expression:"document.escompte_date"}})],1):_vm._e()],1):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.title.' + _vm.type)}},[_c('k-form-input',{attrs:{"name":"title"},model:{value:(_vm.document.title),callback:function ($$v) {_vm.$set(_vm.document, "title", $$v)},expression:"document.title"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.tags')}},[_vm._l((_vm.document.tags),function(tag,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"tags[]"},domProps:{"value":typeof tag === 'object' ? tag.name : tag}})}),(_vm.document.tags && _vm.document.tags.length === 0)?_c('input',{attrs:{"type":"hidden","name":"tags"},domProps:{"value":null}}):_vm._e(),_c('TagSelect',{model:{value:(_vm.document.tags),callback:function ($$v) {_vm.$set(_vm.document, "tags", $$v)},expression:"document.tags"}})],2),_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.commercial')}},[_c('input',{attrs:{"type":"hidden","name":"team_user"},domProps:{"value":_vm.document.team_user ? _vm.document.team_user.id : null}}),_c('TeamUserSelect',{attrs:{"validationName":"team_user","role":"commercial","clearable":false},model:{value:(_vm.document.team_user),callback:function ($$v) {_vm.$set(_vm.document, "team_user", $$v)},expression:"document.team_user"}})],1),_c('input',{attrs:{"type":"hidden","name":"contact"},domProps:{"value":_vm.document.contact ? _vm.document.contact.id : null}}),_c('ContactSelect',{attrs:{"validationName":"contact"},model:{value:(_vm.document.contact),callback:function ($$v) {_vm.$set(_vm.document, "contact", $$v)},expression:"document.contact"}}),(_vm.currency.id !== _vm.value.currency.id)?_c('b-form-group',{staticStyle:{"max-width":"140px"},attrs:{"label":"Taux de change"}},[_c('b-input-group',{attrs:{"append":_vm.value.currency.symbol + ' = 1 ' + _vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"exchange_rate"},model:{value:(_vm.document.exchange_rate),callback:function ($$v) {_vm.$set(_vm.document, "exchange_rate", $$v)},expression:"document.exchange_rate"}})],1)],1):_vm._e(),(_vm.type === 'invoice' || _vm.type === 'credit')?_c('b-form-group',{attrs:{"label":"Date de comptabilisation pour le tableau de bord"}},[_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"name":"accounting_date","required":""},model:{value:(_vm.document.accounting_date),callback:function ($$v) {_vm.$set(_vm.document, "accounting_date", $$v)},expression:"document.accounting_date"}})],1):_vm._e(),_c('input',{attrs:{"type":"hidden","name":"disable_automatic_reminder"},domProps:{"value":_vm.document.disable_automatic_reminder}}),_c('k-form-checkbox',{staticClass:"mb-4",model:{value:(_vm.document.disable_automatic_reminder),callback:function ($$v) {_vm.$set(_vm.document, "disable_automatic_reminder", $$v)},expression:"document.disable_automatic_reminder"}},[_vm._v(" Ne pas relancer automatiquement cette facture dans les relances de paiement automatisées ")]),_c('CustomFieldsForm',{attrs:{"type":_vm.type},model:{value:(_vm.document.custom_fields),callback:function ($$v) {_vm.$set(_vm.document, "custom_fields", $$v)},expression:"document.custom_fields"}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(44696);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentSpeedEdit/DocumentSpeedEdit.ts?vue&type=script&lang=ts&external









var DocumentSpeedEdit = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentSpeedEdit, _super);
    function DocumentSpeedEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.document = {};
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(DocumentSpeedEdit.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentSpeedEdit.prototype, "formApi", {
        get: function () {
            return '/sales/' + this.type + '/' + this.document.id + '/lite';
        },
        enumerable: false,
        configurable: true
    });
    DocumentSpeedEdit.prototype.watchValue = function (document) {
        this.document = JSON.parse(JSON.stringify(document));
    };
    DocumentSpeedEdit.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    DocumentSpeedEdit.prototype.submitted = function (response) {
        return response.data;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentSpeedEdit.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentSpeedEdit.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], DocumentSpeedEdit.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Modification rapide' })
    ], DocumentSpeedEdit.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentSpeedEdit.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DocumentSpeedEdit.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], DocumentSpeedEdit.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal')
    ], DocumentSpeedEdit.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], DocumentSpeedEdit.prototype, "submitted", null);
    DocumentSpeedEdit = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormCheckbox: form_vue_.KFormCheckbox, KFormDatepicker: form_vue_.KFormDatepicker,
                TagSelect: interface_vue_.TagSelect, TeamUserSelect: interface_vue_.TeamUserSelect, FormModal: interface_vue_.FormModal,
                ContactSelect: customers_vue_.ContactSelect,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], DocumentSpeedEdit);
    return DocumentSpeedEdit;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var DocumentSpeedEditvue_type_script_lang_ts_external = (DocumentSpeedEdit);

;// ./src/components/DocumentSpeedEdit/DocumentSpeedEdit.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentSpeedEdit_DocumentSpeedEditvue_type_script_lang_ts_external = (DocumentSpeedEditvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/DocumentSpeedEdit/DocumentSpeedEdit.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentSpeedEdit_DocumentSpeedEditvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentSpeedEdit_DocumentSpeedEdit = (component.exports);

/***/ }),

/***/ 61074:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 61110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_PaymentVatRatesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentVatRatesView.vue?vue&type=template&id=731a4b5c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PaymentVatRates')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: ./src/components/PaymentVatRates/PaymentVatRates.vue + 3 modules
var PaymentVatRates = __webpack_require__(89694);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentVatRatesView.vue?vue&type=script&lang=ts




var PaymentVatRatesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentVatRatesView, _super);
    function PaymentVatRatesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentVatRatesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PaymentVatRates: PaymentVatRates/* default */.A
            }
        })
    ], PaymentVatRatesView);
    return PaymentVatRatesView;
}((external_vue_default())));
/* harmony default export */ var PaymentVatRatesViewvue_type_script_lang_ts = (PaymentVatRatesView);

;// ./src/views/PaymentVatRatesView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_PaymentVatRatesViewvue_type_script_lang_ts = (PaymentVatRatesViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/PaymentVatRatesView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_PaymentVatRatesViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_PaymentVatRatesView = (component.exports);

/***/ }),

/***/ 61290:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ 61489:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(17400);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 61509:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ 61796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_GrantsListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/GrantsListView.vue?vue&type=template&id=840f1fce
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GrantList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/GrantList/GrantList.vue + 3 modules
var GrantList = __webpack_require__(65759);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/GrantsListView.vue?vue&type=script&lang=ts



var GrantsListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GrantsListView, _super);
    function GrantsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GrantsListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                GrantList: GrantList/* default */.A
            }
        })
    ], GrantsListView);
    return GrantsListView;
}(lib/* Vue */.lD));
/* harmony default export */ var GrantsListViewvue_type_script_lang_ts = (GrantsListView);

;// ./src/views/GrantsListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_GrantsListViewvue_type_script_lang_ts = (GrantsListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/GrantsListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_GrantsListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_GrantsListView = (component.exports);

/***/ }),

/***/ 61802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(62224);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 61860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FormSidebar_FormSidebar; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/FormSidebar/FormSidebar.vue?vue&type=template&id=540acd8c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-2",attrs:{"id":"sales-form-sidebar"}},[_c('InputOptions',{attrs:{"modal":_vm.inputModal},on:{"modalState":state => _vm.inputModal = state},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('PdfOptions',{attrs:{"modal":_vm.pdfModal},on:{"modalState":state => _vm.pdfModal = state},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('b-row',{staticClass:"text-center icon-menu mb-3"},[_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ boundary: 'window' }),expression:"{ boundary: 'window' }"}],attrs:{"title":_vm.$t('sales.form.sidebar.inputOptions')},on:{"click":function($event){_vm.inputModal = true}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'sliders-v-square']}})],1)],1),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ boundary: 'window' }),expression:"{ boundary: 'window' }"}],attrs:{"title":_vm.$t('sales.form.sidebar.pdfCustomization')},on:{"click":function($event){_vm.pdfModal = true}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'file-pdf']}})],1)],1),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ boundary: 'window' }),expression:"{ boundary: 'window' }"}],attrs:{"title":_vm.$t('sales.form.sidebar.sidebarPosition')},on:{"click":function($event){$event.preventDefault();return _vm.changeSidebarMode.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'window-alt']}})],1)],1),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ boundary: 'window' }),expression:"{ boundary: 'window' }"}],attrs:{"title":_vm.$t('sales.form.sidebar.fullscreen')},on:{"click":function($event){$event.preventDefault();return _vm.setFullscreenMode(!_vm.fullscreenMode)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'expand-alt']}})],1)],1)],1),_c('table',{staticClass:"table-totals"},[_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.totalHt'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_ht))+" ")])]),_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.totalTva'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_tva))+" ")])]),_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.totalTtc'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_ttc))+" ")])])]),_c('div',{class:{ submit: true, 'text-center': _vm.rightSidebar }},[_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.value.is_draft}}),_c('b-button-group',{class:{ 'sidebar-btn-group': true, 'w-100': _vm.rightSidebar }},[_c('b-button',{staticClass:"my-3",attrs:{"variant":"primary"},on:{"click":_vm.defaultSubmitMode.action}},[_vm._v(" "+_vm._s(_vm.defaultSubmitMode.label)+" ")]),_c('b-dropdown',{attrs:{"variant":"primary","boundary":"viewport","dropup":!_vm.rightSidebar}},_vm._l((_vm.submitActions),function(action,i){return _c('b-dropdown-item',{key:i,on:{"click":action.action}},[_vm._v(" "+_vm._s(action.label)+" ")])}),1)],1)],1),(_vm.can('sales-margin', 1))?_c('table',{staticClass:"table-totals"},[(_vm.value.input_options.workforce_entries !== 0)?_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.workout'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_workforce))+" ")])]):_vm._e(),(_vm.value.input_options.costs_entries !== 0)?_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.costs'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_costs))+" ")])]):_vm._e(),(_vm.value.input_options.gross_margin_amount)?_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.marginAmount'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.gross_margin_amount))+" ")])]):_vm._e(),(_vm.value.input_options.gross_margin_rate)?_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.marginRate'))+" ")]),_vm._v(" "+_vm._s(_vm.value.gross_margin_rate)+" % ")])]):_vm._e(),(_vm.value.input_options.markup_rate)?_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.sidebar.markupRate'))+" ")]),_vm._v(" "+_vm._s(_vm.value.markup_rate)+" % ")])]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./src/components/Form/InputOptions/InputOptions.vue + 3 modules
var InputOptions = __webpack_require__(19422);
// EXTERNAL MODULE: ./src/components/Form/PdfOptions/PdfOptions.vue + 3 modules
var PdfOptions = __webpack_require__(32159);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/FormSidebar/FormSidebar.ts?vue&type=script&lang=ts&external








var FormSidebar = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FormSidebar, _super);
    function FormSidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rightSidebar = true;
        _this.inputModal = false;
        _this.pdfModal = false;
        _this.submitMode = null;
        return _this;
    }
    FormSidebar.prototype.mounted = function () {
        this.rightSidebar = !(localStorage.getItem('sales-form-right-sidebar') !== 'true');
        this.setSidebarMode();
    };
    FormSidebar.prototype.beforeDestroy = function () {
        this.setDynamicAppClass(null);
    };
    Object.defineProperty(FormSidebar.prototype, "submitActions", {
        get: function () {
            var _this = this;
            var actions = [{
                    mode: 1,
                    label: this.$t('sales.form.sidebar.' + (this.value.id ? 'editDraft' : 'createDraft')),
                    action: function () { return _this.submit(1); }
                }];
            if (!this.value.id || (this.value.id && this.value.is_draft)) {
                actions.push({
                    mode: 2,
                    label: this.$t('sales.form.sidebar.' + (this.value.id ? 'editValid' : 'createValid')),
                    action: function () { return _this.submit(2); }
                });
            }
            actions.push({
                mode: 3,
                label: this.$t('sales.form.sidebar.saveContinue'),
                action: function () { return _this.submit(3); }
            });
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormSidebar.prototype, "defaultSubmitMode", {
        get: function () {
            var _a, _b;
            var mode = (_a = this.submitMode) !== null && _a !== void 0 ? _a : 1;
            return (_b = this.submitActions.find(function (action) { return action.mode === mode; })) !== null && _b !== void 0 ? _b : this.submitActions[0];
        },
        enumerable: false,
        configurable: true
    });
    FormSidebar.prototype.submit = function (mode) {
        this.submitMode = mode;
        this.value.is_draft = mode !== 2 && (!this.value.id || this.value.is_draft);
        this.$emit('submit', mode);
    };
    FormSidebar.prototype.changeSidebarMode = function () {
        this.rightSidebar = !this.rightSidebar;
        this.setSidebarMode();
    };
    FormSidebar.prototype.setSidebarMode = function () {
        localStorage.setItem('sales-form-right-sidebar', String(this.rightSidebar));
        this.setDynamicAppClass({
            'sales-form-sidebar': this.rightSidebar,
            'sales-form-bottombar': !this.rightSidebar
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], FormSidebar.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FormSidebar.prototype, "type", void 0);
    FormSidebar = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['fullscreenMode'])), (0,external_vuex_.mapGetters)('user', ['can'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setFullscreenMode', 'setDynamicAppClass'])),
            components: {
                InputOptions: InputOptions/* default */.A,
                PdfOptions: PdfOptions/* default */.A,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BButtonGroup: external_bootstrap_vue_.BButtonGroup, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItem: external_bootstrap_vue_.BDropdownItem
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], FormSidebar);
    return FormSidebar;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var FormSidebarvue_type_script_lang_ts_external = (FormSidebar);

;// ./src/components/Form/FormSidebar/FormSidebar.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FormSidebar_FormSidebarvue_type_script_lang_ts_external = (FormSidebarvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/FormSidebar/FormSidebar.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FormSidebar_FormSidebarvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormSidebar_FormSidebar = (component.exports);

/***/ }),

/***/ 61954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CreateProviderCommand_CreateProviderCommand; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CreateProviderCommand/CreateProviderCommand.vue?vue&type=template&id=088f59ba
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"title":"Commande des produits auprès des fournisseurs","ok-title":_vm.onlyOkButton ? 'Fermer' : 'Commander les produits',"ok-only":_vm.onlyOkButton,"size":_vm.modalSize,"closeOnSubmit":false},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.createdCommands !== null)?_c('div',[_c('p',{staticClass:"font-weight-bold mb-2"},[_vm._v(" Liste des commandes créées : ")]),_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-bordered text-nowrap"},[_c('thead',[_c('tr',[_c('th',[_vm._v("N° commande")]),_c('th',[_vm._v("Fournisseur")])])]),_c('tbody',_vm._l((_vm.createdCommands),function(command){return _c('tr',{key:command.id},[_c('td',[_c('router-link',{attrs:{"to":{ name: 'stock-command-item', params: { id: String(command.id) }}}},[_vm._v(" "+_vm._s(command.reference)+" ")])],1),_c('td',{staticClass:"text-wrap"},[_c('router-link',{attrs:{"to":{ name: 'stock-command-item', params: { id: String(command.id) }}}},[_vm._v(" "+_vm._s(command.provider.name)+" ")])],1)])}),0)])])]):(_vm.loading)?_c('Spinner'):(_vm.commandContents.length === 0)?_c('div',{staticClass:"text-center p-2"},[_vm._v(" Aucun produit commandable n'est présent dans le document ")]):_c('k-form',{attrs:{"value":_vm.formDatas,"action":'/sales/' + _vm.type + '/' + _vm.value.id + '/catalog-command'},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-md-5",attrs:{"cols":"12","md":"auto"}},[_c('b-row',{staticClass:"mb-4 d-inline-flex py-2",staticStyle:{"background-color":"#e2e2e2"},attrs:{"align-v":"end"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Sélection automatique des fournisseurs :"}},[_c('k-form-select',{attrs:{"options":[
                    { value: 'provider', label: 'Privilégier le même fournisseur' },
                    { value: 'price', label: 'Prix le moins cher' }
                  ],"reduce":opt => opt.value,"clearable":false,"size":"sm"},model:{value:(_vm.automaticMode),callback:function ($$v) {_vm.automaticMode=$$v},expression:"automaticMode"}})],1)],1),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","disabled":_vm.automaticMode === null},on:{"click":function($event){$event.preventDefault();return _vm.selectProviders.apply(null, arguments)}}},[_vm._v(" OK ")])],1)],1)],1),_c('b-col',[_c('k-form-checkbox',{model:{value:(_vm.groupCommands),callback:function ($$v) {_vm.groupCommands=$$v},expression:"groupCommands"}},[_vm._v(" Ajouter les produits aux commandes fournisseur existantes "),_c('p',{staticClass:"text-muted small"},[_vm._v(" Si une commande du même fournisseur existe au statut brouillon, alors les produits seront ajoutés à la commande au lieu de créer une nouvelle commande. ")])])],1)],1),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered align-middle text-nowrap"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"130px"}},[_vm._v("Référence")]),_c('th',[_vm._v("Nom du produit")]),(_vm.withInCommand)?_c('th',{staticClass:"text-center",staticStyle:{"width":"130px"}},[_vm._v(" En commande ")]):_vm._e(),_c('th',{staticClass:"text-center",staticStyle:{"width":"130px"}},[_vm._v("Qté")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"130px"}},[_vm._v("Stock")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"130px"}},[_vm._v("Stock théorique")]),_c('th',{staticStyle:{"width":"350px"}},[_vm._v("Fournisseur")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"130px"}},[_vm._v("Quantité")])])]),_c('tbody',_vm._l((_vm.commandContents),function(content,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(content.product.reference))]),_c('td',{staticClass:"text-wrap"},[_vm._v(_vm._s(content.product.name))]),(_vm.withInCommand)?_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.showNumber(content.in_command_quantity))+" ")]):_vm._e(),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(content.document_quantity)))]),(content.product.with_stock)?[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(content.product.stock_quantity)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(content.product.stock_theoretical_quantity)))])]:[_c('td',{staticClass:"text-center small text-muted",attrs:{"colspan":"2"}},[_vm._v(" Stock non géré ")])],_c('td',[_c('k-form-select',{attrs:{"options":content.product.providers_references,"getOptionLabel":_vm.providerReferenceLabel,"placeholder":"Ne pas commander","validationName":'contents.' + i + '.provider'},model:{value:(content.provider_reference),callback:function ($$v) {_vm.$set(content, "provider_reference", $$v)},expression:"content.provider_reference"}})],1),_c('td',[_c('k-form-spinner',{attrs:{"min":0,"disabled":content.provider_reference === null,"validationName":'contents.' + i + '.quantity'},model:{value:(content.quantity),callback:function ($$v) {_vm.$set(content, "quantity", $$v)},expression:"content.quantity"}})],1)],2)}),0)])])],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CreateProviderCommand/CreateProviderCommand.ts?vue&type=script&lang=ts&external






var CreateProviderCommand = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CreateProviderCommand, _super);
    function CreateProviderCommand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.loaded = false;
        _this.automaticMode = 'provider';
        _this.groupCommands = true;
        _this.contents = [];
        _this.commandContents = [];
        _this.createdCommands = null;
        return _this;
    }
    CreateProviderCommand.prototype.watchModalState = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.modalState && !this.loaded)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadDocumentWithProviders()];
                    case 1:
                        _a.sent();
                        this.loaded = true;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CreateProviderCommand.prototype, "formDatas", {
        get: function () {
            return {
                group_command: this.groupCommands,
                contents: this.commandContents
                    .filter(function (content) { return content.provider_reference !== null && content.quantity > 0; })
                    .map(function (content) {
                    var _a;
                    return {
                        affair_content: content.affair_content,
                        product: content.product.id,
                        provider: (_a = content.provider_reference) === null || _a === void 0 ? void 0 : _a.customer.id,
                        quantity: content.quantity
                    };
                })
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateProviderCommand.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateProviderCommand.prototype, "withInCommand", {
        get: function () {
            return this.commandContents.filter(function (content) { return content.in_command_quantity > 0; }).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    CreateProviderCommand.prototype.parseContents = function () {
        var _this = this;
        var key = this.teamConfigs.sales_provider_command_stock === 0 ? 'stock_quantity' : 'stock_theoretical_quantity';
        var contents = [];
        this.contents.forEach(function (content) {
            var _a;
            if (content.quantity < 0 || !content.catalog || content.catalog.type !== 'product' || !content.catalog.element) {
                return;
            }
            var product = content.catalog.element;
            if (product.is_group) {
                product.group_contents.forEach(function (groupContent) {
                    var _a, _b;
                    if (groupContent.catalog && groupContent.catalog.type === 'product') {
                        var product_1 = (_a = groupContent === null || groupContent === void 0 ? void 0 : groupContent.catalog) === null || _a === void 0 ? void 0 : _a.element;
                        if (!product_1 || !product_1.providers_references || product_1.providers_references.length === 0) {
                            return;
                        }
                        var documentQuantity = _this.number(content.total_quantity) * _this.number(groupContent.quantity);
                        var quantity = documentQuantity - _this.number(product_1[key]);
                        if (quantity < 0) {
                            quantity = 0;
                        }
                        contents.push({
                            affair_content: content.affair_content_id,
                            product: product_1,
                            document_quantity: documentQuantity,
                            quantity: quantity,
                            in_command_quantity: 0,
                            provider_reference: (_b = product_1.providers_references[0]) !== null && _b !== void 0 ? _b : null,
                            provider_references: product_1.providers_references
                        });
                    }
                });
            }
            else {
                if (!product.providers_references || product.providers_references.length === 0) {
                    return;
                }
                var quantity = _this.number(content.total_quantity) - _this.number(product[key]);
                if (_this.teamConfigs.sales_minus_provider_stock) {
                    quantity -= _this.number(content.provider_command_quantity);
                }
                if (quantity < 0) {
                    quantity = 0;
                }
                contents.push({
                    affair_content: content.affair_content_id,
                    product: product,
                    in_command_quantity: _this.number(content.provider_command_quantity),
                    document_quantity: _this.number(content.total_quantity),
                    quantity: quantity,
                    provider_reference: (_a = product.providers_references[0]) !== null && _a !== void 0 ? _a : null,
                    provider_references: product.providers_references
                });
            }
        });
        this.commandContents = contents;
    };
    CreateProviderCommand.prototype.parseProduct = function (product) {
        if (!product.providers_references || product.providers_references.length === 0) {
            return;
        }
    };
    Object.defineProperty(CreateProviderCommand.prototype, "onlyOkButton", {
        get: function () {
            return this.createdCommands !== null || this.commandContents.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateProviderCommand.prototype, "modalSize", {
        get: function () {
            if (this.commandContents.length === 0 || this.createdCommands !== null) {
                return 'md';
            }
            else {
                return 'xxl';
            }
        },
        enumerable: false,
        configurable: true
    });
    CreateProviderCommand.prototype.loadDocumentWithProviders = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/' + this.type + '/' + this.value.id, {
                                params: {
                                    include: ['contents.catalog', 'contents.providers', 'contents.groupProviders']
                                }
                            })
                                .then(function (response) {
                                _this.contents = response.data.contents;
                                _this.parseContents();
                                _this.groupCommands = _this.teamConfigs.sales_provider_command_stock_draft;
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateProviderCommand.prototype.commandQty = function (content) {
        var _a;
        var product = content.catalog.element;
        var quantity = content.total_quantity;
        if (product.with_stock) {
            quantity -= ((_a = product.stock_theoretical_quantity) !== null && _a !== void 0 ? _a : 0);
            if (quantity < 0) {
                quantity = 0;
            }
        }
        return quantity;
    };
    CreateProviderCommand.prototype.providerReferenceLabel = function (reference) {
        return reference.customer.name + ' - ' + reference.reference + ' - ' + this.formattedNumber(reference.total_costs);
    };
    CreateProviderCommand.prototype.selectProviders = function () {
        switch (this.automaticMode) {
            case 'provider':
                this.parseContentByProviders();
                break;
            case 'price':
                this.commandContents.map(function (content) {
                    var references = content.product.providers_references
                        .sort(function (a, b) { return a.buy_price_ht - b.buy_price_ht; });
                    content.provider_reference = references[0];
                });
                break;
        }
        this.automaticMode = null;
    };
    CreateProviderCommand.prototype.parseContentByProviders = function (contents) {
        var _this = this;
        if (contents === undefined) {
            contents = Array.from(this.commandContents);
        }
        var providers = [];
        contents.map(function (content, index) {
            content.product.providers_references.map(function (reference) {
                var provider = providers.find(function (content) { return content.providerId === reference.customer.id; });
                if (provider === undefined) {
                    provider = {
                        providerId: reference.customer.id,
                        provider: reference.customer,
                        contents: []
                    };
                    providers.push(provider);
                }
                provider.contents.push({
                    index: index,
                    reference: reference
                });
            });
        });
        if (providers.length === 0) {
            return;
        }
        var ordered = providers.sort(function (a, b) {
            return b.contents.length - a.contents.length;
        });
        var process = ordered[0];
        process.contents.map(function (content) {
            _this.commandContents[content.index].provider_reference = content.reference;
            delete contents[content.index];
        });
        if (contents.length > 0) {
            this.parseContentByProviders(contents);
        }
    };
    CreateProviderCommand.prototype.submitComplete = function (response) {
        this.createdCommands = response.data;
        this.$emit('created', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CreateProviderCommand.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CreateProviderCommand.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CreateProviderCommand.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Commander chez le(s) fournisseur(s)' })
    ], CreateProviderCommand.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CreateProviderCommand.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CreateProviderCommand.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState', { immediate: true })
    ], CreateProviderCommand.prototype, "watchModalState", null);
    CreateProviderCommand = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs'])),
            components: {
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormCheckbox: form_vue_.KFormCheckbox, KFormSpinner: form_vue_.KFormSpinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], CreateProviderCommand);
    return CreateProviderCommand;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CreateProviderCommandvue_type_script_lang_ts_external = (CreateProviderCommand);

;// ./src/components/CreateProviderCommand/CreateProviderCommand.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CreateProviderCommand_CreateProviderCommandvue_type_script_lang_ts_external = (CreateProviderCommandvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CreateProviderCommand/CreateProviderCommand.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CreateProviderCommand_CreateProviderCommandvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CreateProviderCommand_CreateProviderCommand = (component.exports);

/***/ }),

/***/ 62035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_FecFileView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/FecFileView.vue?vue&type=template&id=47f9ca42
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":"Exporter"}},[_c('FecExport')],1),_c('b-tab',{attrs:{"title":"Liste des exports","lazy":""}},[_c('FecExportList')],1),_c('b-tab',{attrs:{"title":"Paramètres","lazy":""}},[_c('FecParams')],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/FecExport/FecExport.vue + 3 modules
var FecExport = __webpack_require__(10989);
// EXTERNAL MODULE: ./src/components/FecParams/FecParams.vue + 3 modules
var FecParams = __webpack_require__(65004);
// EXTERNAL MODULE: ./src/components/FecExportList/FecExportList.vue + 3 modules
var FecExportList = __webpack_require__(76982);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/FecFileView.vue?vue&type=script&lang=ts






var FecFileView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FecFileView, _super);
    function FecFileView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FecFileView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FecExport: FecExport/* default */.A,
                FecParams: FecParams/* default */.A,
                FecExportList: FecExportList/* default */.A,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab
            }
        })
    ], FecFileView);
    return FecFileView;
}(lib/* Vue */.lD));
/* harmony default export */ var FecFileViewvue_type_script_lang_ts = (FecFileView);

;// ./src/views/FecFileView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_FecFileViewvue_type_script_lang_ts = (FecFileViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/FecFileView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_FecFileViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_FecFileView = (component.exports);

/***/ }),

/***/ 62224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(50104);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 62288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractPeriods_ContractPeriods; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractPeriods/ContractPeriods.vue?vue&type=template&id=32fcf21d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-table',{ref:"table",attrs:{"url":'/sales/contract/' + _vm.value.id + '/period',"columns":_vm.columns,"stateSave":false,"hideable":false,"searchable":false,"resizable":false,"rowActions":_vm.rowActions},on:{"totalUpdated":val => _vm.total = val}}),_c('ContractPeriodDelete',{on:{"deleted":_vm.deleted},model:{value:(_vm.deletePeriod),callback:function ($$v) {_vm.deletePeriod=$$v},expression:"deletePeriod"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/ContractPeriodDelete/ContractPeriodDelete.vue + 3 modules
var ContractPeriodDelete = __webpack_require__(17819);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractPeriods/ContractPeriods.ts?vue&type=script&lang=ts&external





var ContractPeriods = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractPeriods, _super);
    function ContractPeriods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deletePeriod = null;
        _this.total = 0;
        return _this;
    }
    ContractPeriods.prototype.mounted = function () {
        interface_vue_.emitter.on('contractPeriodCreated', this.refreshPeriod);
        interface_vue_.emitter.on('contractPeriodDeleted', this.refreshPeriod);
    };
    ContractPeriods.prototype.destroyed = function () {
        interface_vue_.emitter.off('contractPeriodCreated', this.refreshPeriod);
        interface_vue_.emitter.off('contractPeriodDeleted', this.refreshPeriod);
    };
    Object.defineProperty(ContractPeriods.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'begin',
                    name: 'Début',
                    render: 'date'
                },
                {
                    data: 'end',
                    name: 'Fin',
                    render: 'date'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractPeriods.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'delete',
                    condition: function (period) {
                        var _a;
                        return period.invoiced_deadlines === 0 && ((_a = _this.value.periods_nb) !== null && _a !== void 0 ? _a : 0) > 1;
                    },
                    click: function (period) {
                        _this.deletePeriod = period;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ContractPeriods.prototype.refreshPeriod = function () {
        var table = this.$refs.table;
        table.refresh();
    };
    ContractPeriods.prototype.deleted = function () {
        if (this.deletePeriod !== null) {
            var table = this.$refs.table;
            table.refresh();
            this.deletePeriod = null;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractPeriods.prototype, "value", void 0);
    ContractPeriods = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                ContractPeriodDelete: ContractPeriodDelete/* default */.A
            }
        })
    ], ContractPeriods);
    return ContractPeriods;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractPeriodsvue_type_script_lang_ts_external = (ContractPeriods);

;// ./src/components/ContractPeriods/ContractPeriods.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractPeriods_ContractPeriodsvue_type_script_lang_ts_external = (ContractPeriodsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractPeriods/ContractPeriods.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractPeriods_ContractPeriodsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractPeriods_ContractPeriods = (component.exports);

/***/ }),

/***/ 62429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(80909);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 62673:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'credit-card';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f09d';
var svgPathData = 'M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.$O = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 63040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(21549),
    ListCache = __webpack_require__(80079),
    Map = __webpack_require__(68223);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 63164:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ 63345:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 63384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AccountList_AccountList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountList/AccountList.vue?vue&type=template&id=29129c09
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.$t('sales.account.pageTitle')}},[(_vm.can('sales-accounts', 1))?_c('b-col',[_c('AccountSync',{attrs:{"label":"Synchronisation avec la banque","variant":"primary"}})],1):_vm._e()],1),_c('AppMessages'),_c('DynamicList',{ref:"list",attrs:{"url":_vm.apiUrl,"datas":_vm.ajaxDatas,"columns":_vm.columns,"createTitle":_vm.$t('sales.account.new'),"updateTitle":_vm.$t('sales.account.edit'),"deleteMsg":_vm.$t('sales.account.deleteMsg'),"sort":"name","customForm":_vm.formComponent,"customFormProperties":{ apiUrl: _vm.apiUrl },"withDefault":"","actionsColWidth":"125px"},on:{"submitted":_vm.setAccount,"deleted":_vm.deleteAccount}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/AccountForm/AccountForm.vue + 3 modules
var AccountForm = __webpack_require__(82183);
// EXTERNAL MODULE: ./src/components/AccountSync/AccountSync.vue + 3 modules
var AccountSync = __webpack_require__(80153);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AccountList/AccountList.ts?vue&type=script&lang=ts&external







var AccountList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AccountList, _super);
    function AccountList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = AccountForm/* default */.A;
        return _this;
    }
    Object.defineProperty(AccountList.prototype, "ajaxDatas", {
        get: function () {
            var datas = {};
            if (this.can('sales-accounts', 1)) {
                datas['include'] = ['syncAccount'];
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    AccountList.prototype.watchAccounts = function () {
        var list = this.$refs.list;
        list.refresh();
    };
    Object.defineProperty(AccountList.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [{
                    label: this.$t('sales.account.label'),
                    key: 'name',
                    required: true
                }];
            if (this.can('sales-accounts', 1)) {
                columns.push({
                    label: 'Synchronisation',
                    key: 'syncAccount',
                    hideOnForm: true,
                    show: function (data) {
                        return data === null || !data.is_synced ? _this.$t('interface.no') : _this.$t('interface.yes');
                    }
                });
            }
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    AccountList.prototype.submitted = function (account) {
        if (this.accountantMode === false) {
            this.setAccount(account);
        }
    };
    AccountList.prototype.deleted = function (account) {
        if (this.accountantMode === false) {
            this.deleteAccount(account);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AccountList.prototype, "accountantMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/sales/account' })
    ], AccountList.prototype, "apiUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('accounts')
    ], AccountList.prototype, "watchAccounts", null);
    AccountList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['setAccount', 'deleteAccount'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'permissions'])), (0,external_vuex_.mapState)('sales', ['accounts'])),
            components: {
                DynamicList: interface_vue_.DynamicList, PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages,
                AccountSync: AccountSync/* default */.A,
                BCol: external_bootstrap_vue_.BCol
            }
        })
    ], AccountList);
    return AccountList;
}(lib/* Vue */.lD));
/* harmony default export */ var AccountListvue_type_script_lang_ts_external = (AccountList);

;// ./src/components/AccountList/AccountList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AccountList_AccountListvue_type_script_lang_ts_external = (AccountListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/AccountList/AccountList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AccountList_AccountListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccountList_AccountList = (component.exports);

/***/ }),

/***/ 63457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var froala_editor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30189);
/* harmony import */ var froala_editor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(froala_editor__WEBPACK_IMPORTED_MODULE_0__);

var buttons = [
    'bold',
    'italic',
    'underline',
    '|',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    '|',
    'fontSize',
    '|',
    'textColor',
    'backgroundColor',
    '|',
    'formatUL',
    'formatOL'
];
var moreMisc = {
    buttons: ['undo', 'redo', 'html'],
    align: 'right',
    buttonsVisible: 0
};
var config = {
    enter: (froala_editor__WEBPACK_IMPORTED_MODULE_0___default().ENTER_BR),
    fontSizeUnit: 'pt',
    listAdvancedTypes: false,
    quickInsertEnabled: false,
    wordCounterCount: false,
    pasteDeniedAttrs: ['class', 'id'],
    pastePlain: false,
    htmlAllowedStyleProps: ['font-size', 'background', 'color', 'text-align', 'vertical-align', 'background-color'],
    htmlRemoveTags: ['script', 'style'],
    toolbarButtonsXS: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 0,
        },
        moreMisc: moreMisc
    },
    toolbarButtonsSM: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 4,
        }
    },
    toolbarButtonsMD: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 5,
        }
    },
    toolbarButtons: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 12
        },
        moreMisc: moreMisc
    },
    events: {
        'paste.afterCleanup': function (content) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var tbody = this.$el.closest('tbody');
            if (tbody.length > 0 && tbody[0].classList.contains('dragging')) {
                return '';
            }
            if (!content) {
                return content;
            }
            return content.replaceAll(/<br([^>])+?>/gi, '<br>')
                .replaceAll(/<(\/)?table(([^>])+?)?>|<(\/)?tbody(([^>])+?)?>|<(\/)?thead(([^>])+?)?>|<tr(([^>])+?)?>|<td(([^>])+?)?>|\t/gi, '')
                .replaceAll(/<\/td>/gi, ' ')
                .replaceAll(/<\/tr>/gi, '<br>')
                .replaceAll(/font-size: ?([\d.]+)px/gi, '')
                .replaceAll(/font-size: ?([\d.]+)pt/gi, '')
                .replaceAll(/font-size: ?([\d.]+)rem/gi, '')
                .replaceAll(/background(-color)?: ?(#[0-9A-Fa-f]{3,6}|rgb\([0-9]{3} ?, ?[0-9]{3} ?, ?[0-9]{3}\))/gi, '');
        }
    }
};
/* harmony default export */ __webpack_exports__.A = (config);


/***/ }),

/***/ 63605:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 63630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleTerms_SaleTerms; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleTerms/SaleTerms.vue?vue&type=template&id=aba21098
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"customForm":_vm.formComponent,"createTitle":_vm.$t('sales.saleTerm.new'),"updateTitle":_vm.$t('sales.saleTerm.edit'),"deleteMsg":_vm.$t('sales.saleTerm.deleteMsg'),"sort":"label","modalSize":"xl"},on:{"submitted":_vm.setSaleTerm,"deleted":_vm.deleteSaleTerm}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleTermsForm/SaleTermsForm.vue?vue&type=template&id=842ec1ea
var SaleTermsFormvue_type_template_id_842ec1ea_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.saleTerm.label')}},[_c('k-form-input',{attrs:{"name":"label","required":""},model:{value:(_vm.saleTerm.label),callback:function ($$v) {_vm.$set(_vm.saleTerm, "label", $$v)},expression:"saleTerm.label"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.saleTerm.contentLabel')}},[_c('k-form-editor',{attrs:{"name":"content","required":"","config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.saleTerm.content),callback:function ($$v) {_vm.$set(_vm.saleTerm, "content", $$v)},expression:"saleTerm.content"}})],1)],1)],1)
}
var SaleTermsFormvue_type_template_id_842ec1ea_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(55364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./src/components/PdfModelBlock/editorConfig.ts
var editorConfig = __webpack_require__(93443);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleTermsForm/SaleTermsForm.ts?vue&type=script&lang=ts&external








var SaleTermsForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleTermsForm, _super);
    function SaleTermsForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.saleTerm = {
            label: '',
            content: ''
        };
        return _this;
    }
    SaleTermsForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SaleTermsForm.prototype, "computedEditorConfig", {
        get: function () {
            var _this = this;
            var fields = this.customFields.filter(function (field) {
                var usages = field.usage;
                return usages.includes('quotation') || usages.includes('command') || usages.includes('proforma') || usages.includes('delivery') || usages.includes('invoice') || usages.includes('credit');
            });
            var customFields = {};
            if (fields.length > 0) {
                var variables_1 = [];
                fields.forEach(function (field) {
                    var usages = [];
                    field.usage.forEach(function (usage) {
                        usages.push(_this.$t('sales.' + usage + '.label'));
                    });
                    variables_1.push({
                        value: 'CUSTOM-FIELD-' + field.id,
                        label: field.label + ' (' + usages.join(', ') + ')'
                    });
                });
                customFields.dynamicVariables = {
                    customFields: {
                        label: 'Champs personnalisés',
                        variables: variables_1
                    }
                };
            }
            return merge_default()(editorConfig/* default */.A, customFields);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleTermsForm.prototype, "formAction", {
        get: function () {
            var url = '/sales/sale_term';
            if (this.saleTerm.id) {
                url += '/' + this.saleTerm.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleTermsForm.prototype, "formMethod", {
        get: function () {
            return this.saleTerm.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    SaleTermsForm.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.saleTerm = this.value ? JSON.parse(JSON.stringify(this.value)) : {
                    label: '',
                    content: ''
                };
                return [2 /*return*/];
            });
        });
    };
    SaleTermsForm.prototype.formSubmitted = function (response) {
        return response;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SaleTermsForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], SaleTermsForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], SaleTermsForm.prototype, "formSubmitted", null);
    SaleTermsForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormEditor: form_vue_.KFormEditor, KFormInput: form_vue_.KFormInput,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                Spinner: interface_vue_.Spinner
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('customFields', ['customFields'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['loadCustomFields']))
        })
    ], SaleTermsForm);
    return SaleTermsForm;
}(lib/* Vue */.lD));
/* harmony default export */ var SaleTermsFormvue_type_script_lang_ts_external = (SaleTermsForm);

;// ./src/components/SaleTermsForm/SaleTermsForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleTermsForm_SaleTermsFormvue_type_script_lang_ts_external = (SaleTermsFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SaleTermsForm/SaleTermsForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleTermsForm_SaleTermsFormvue_type_script_lang_ts_external,
  SaleTermsFormvue_type_template_id_842ec1ea_render,
  SaleTermsFormvue_type_template_id_842ec1ea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleTermsForm_SaleTermsForm = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleTerms/SaleTerms.ts?vue&type=script&lang=ts&external





var SaleTerms = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleTerms, _super);
    function SaleTerms() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = SaleTermsForm_SaleTermsForm;
        return _this;
    }
    Object.defineProperty(SaleTerms.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('sales.saleTerm.label'),
                    key: 'label',
                    required: true
                },
                {
                    label: this.$t('sales.saleTerm.contentLabel'),
                    key: 'content',
                    required: true,
                    type: 'editor'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleTerms.prototype, "apiUrl", {
        get: function () {
            return '/sales/sale_term';
        },
        enumerable: false,
        configurable: true
    });
    SaleTerms = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['setSaleTerm', 'deleteSaleTerm'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], SaleTerms);
    return SaleTerms;
}(lib/* Vue */.lD));
/* harmony default export */ var SaleTermsvue_type_script_lang_ts_external = (SaleTerms);

;// ./src/components/SaleTerms/SaleTerms.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleTerms_SaleTermsvue_type_script_lang_ts_external = (SaleTermsvue_type_script_lang_ts_external); 
;// ./src/components/SaleTerms/SaleTerms.vue





/* normalize component */
;
var SaleTerms_component = (0,componentNormalizer/* default */.A)(
  SaleTerms_SaleTermsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleTerms_SaleTerms = (SaleTerms_component.exports);

/***/ }),

/***/ 63702:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 63849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StripePaymentSuccessful_StripePaymentSuccessful; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StripePaymentSuccessful/StripePaymentSuccessful.vue?vue&type=template&id=2667fef2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('b-card',{class:{
      'border-0': this.paymentIntent !== null
    },attrs:{"body-class":"text-center"}},[(_vm.errorMsg)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.successMsg)+" ")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/mixins/StripeMixin.ts + 1 modules
var StripeMixin = __webpack_require__(50148);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StripePaymentSuccessful/StripePaymentSuccessful.ts?vue&type=script&lang=ts&external





var StripePaymentSuccessful = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StripePaymentSuccessful, _super);
    function StripePaymentSuccessful() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.paymentIntentStatus = null;
        _this.errorMsg = null;
        return _this;
    }
    StripePaymentSuccessful.prototype.mounted = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _b, paymentIntent, error;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.paymentIntent) {
                            this.paymentIntentStatus = this.paymentIntent.status;
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.initializeStripe()];
                    case 1:
                        _c.sent();
                        if (!this.stripe) {
                            this.errorMsg = 'Erreur lors de l\'initialisation';
                            this.loading = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.stripe.retrievePaymentIntent(this.clientSecret)];
                    case 2:
                        _b = _c.sent(), paymentIntent = _b.paymentIntent, error = _b.error;
                        if (error) {
                            this.errorMsg = (_a = error.message) !== null && _a !== void 0 ? _a : 'Une erreur est survenue';
                        }
                        else if (paymentIntent) {
                            this.paymentIntentStatus = paymentIntent.status;
                        }
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StripePaymentSuccessful.prototype, "stripeAccount", {
        get: function () {
            return this.accountId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StripePaymentSuccessful.prototype, "successMsg", {
        get: function () {
            switch (this.paymentIntentStatus) {
                case 'succeeded':
                    return 'Votre paiement a été accepté.';
                case 'processing':
                    return 'Votre paiement est en cours de traitement.';
                case 'requires_payment_method':
                    return 'Votre paiement n\'a pas abouti, veuillez réessayer.';
                default:
                    return 'Une erreur est survenue.';
            }
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], StripePaymentSuccessful.prototype, "clientSecret", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], StripePaymentSuccessful.prototype, "accountId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], StripePaymentSuccessful.prototype, "paymentIntent", void 0);
    StripePaymentSuccessful = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard, BAlert: external_bootstrap_vue_.BAlert,
                Spinner: interface_vue_.Spinner
            }
        })
    ], StripePaymentSuccessful);
    return StripePaymentSuccessful;
}((0,lib/* Mixins */.Xe)(StripeMixin/* default */.A)));
/* harmony default export */ var StripePaymentSuccessfulvue_type_script_lang_ts_external = (StripePaymentSuccessful);

;// ./src/components/StripePaymentSuccessful/StripePaymentSuccessful.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StripePaymentSuccessful_StripePaymentSuccessfulvue_type_script_lang_ts_external = (StripePaymentSuccessfulvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/StripePaymentSuccessful/StripePaymentSuccessful.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StripePaymentSuccessful_StripePaymentSuccessfulvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StripePaymentSuccessful_StripePaymentSuccessful = (component.exports);

/***/ }),

/***/ 63862:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 63912:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(61074),
    hasUnicode = __webpack_require__(49698),
    unicodeToArray = __webpack_require__(42054);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 63945:
/***/ (function(module) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 63991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $$: function() { return /* binding */ contractModelRelations; },
/* harmony export */   gC: function() { return /* binding */ needFetchContractModel; },
/* harmony export */   qz: function() { return /* binding */ fetchContractModel; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var contractModelRelations = ['payment_term', 'payment_method', 'pdf_model', 'documents', 'contents'];
var needFetchContractModel = function (model) {
    return !contractModelRelations.every(function (relation) { return relation in model; });
};
var fetchContractModel = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/sales/contract-model/' + id, {
                    params: {
                        include: contractModelRelations.join(','),
                        with_file: true
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 64051:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ 64226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ 64831:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'pencil';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f040';
var svgPathData = 'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.zL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 64894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(30294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 65004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FecParams_FecParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FecParams/FecParams.vue?vue&type=template&id=42609688
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.apiUrl,"method":"PUT"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.fec-params-journals",modifiers:{"fec-params-journals":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Configuration des journaux ")])],1),_c('b-collapse',{attrs:{"id":"fec-params-journals","accordion":"fec-params-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('h3',{staticClass:"form-title-alt mt-0"},[_vm._v(" Journal de banque ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Code"}},[_c('k-form-input',{attrs:{"name":"journal_bank_code","required":""},model:{value:(_vm.params.journal_bank_code),callback:function ($$v) {_vm.$set(_vm.params, "journal_bank_code", $$v)},expression:"params.journal_bank_code"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"journal_bank_label","required":""},model:{value:(_vm.params.journal_bank_label),callback:function ($$v) {_vm.$set(_vm.params, "journal_bank_label", $$v)},expression:"params.journal_bank_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-2"},[_vm._v(" Journal des achats ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Code"}},[_c('k-form-input',{attrs:{"name":"journal_charges_code","required":""},model:{value:(_vm.params.journal_charges_code),callback:function ($$v) {_vm.$set(_vm.params, "journal_charges_code", $$v)},expression:"params.journal_charges_code"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"journal_charges_label","required":""},model:{value:(_vm.params.journal_charges_label),callback:function ($$v) {_vm.$set(_vm.params, "journal_charges_label", $$v)},expression:"params.journal_charges_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-2"},[_vm._v(" Journal des ventes ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Code"}},[_c('k-form-input',{attrs:{"name":"journal_sales_code","required":""},model:{value:(_vm.params.journal_sales_code),callback:function ($$v) {_vm.$set(_vm.params, "journal_sales_code", $$v)},expression:"params.journal_sales_code"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"journal_sales_label","required":""},model:{value:(_vm.params.journal_sales_label),callback:function ($$v) {_vm.$set(_vm.params, "journal_sales_label", $$v)},expression:"params.journal_sales_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-2"},[_vm._v(" Journal de caisse ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Code"}},[_c('k-form-input',{attrs:{"name":"journal_cash_code","required":""},model:{value:(_vm.params.journal_cash_code),callback:function ($$v) {_vm.$set(_vm.params, "journal_cash_code", $$v)},expression:"params.journal_cash_code"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"journal_cash_label","required":""},model:{value:(_vm.params.journal_cash_label),callback:function ($$v) {_vm.$set(_vm.params, "journal_cash_label", $$v)},expression:"params.journal_cash_label"}})],1)],1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.fec-params-libelles",modifiers:{"fec-params-libelles":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Comptes et libellés ")])],1),_c('b-collapse',{attrs:{"id":"fec-params-libelles","accordion":"fec-params-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('p',[_vm._v(" Il est possible de renseigner les comptes comptable sur les éléments suivants : ")]),(_vm.accountantMode === false)?_c('div',{staticClass:"mb-4 pb-2"},[_c('b-button',{attrs:{"variant":"primary","size":"sm","to":{ name: 'sales-sales-categories' }}},[_vm._v(" Catégories de vente ")]),_c('b-button',{staticClass:"ml-2",attrs:{"variant":"primary","size":"sm","to":{ name: 'charges-charge-categories' }}},[_vm._v(" Catégories de charge ")]),_c('b-button',{staticClass:"ml-2",attrs:{"variant":"primary","size":"sm","to":{ name: 'sales-accounts' }}},[_vm._v(" Comptes bancaire ")]),_c('b-button',{staticClass:"ml-2",attrs:{"variant":"primary","size":"sm","to":{ name: 'sales-vatrates' }}},[_vm._v(" Taux de TVA ")]),_c('b-button',{staticClass:"ml-2",attrs:{"variant":"primary","size":"sm","to":{ name: 'sales-payment-methods' }}},[_vm._v(" Moyens de paiement ")])],1):_vm._e(),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Comptes clients ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte"}},[_c('k-form-input',{attrs:{"name":"global_customers_account","required":""},model:{value:(_vm.params.global_customers_account),callback:function ($$v) {_vm.$set(_vm.params, "global_customers_account", $$v)},expression:"params.global_customers_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"global_customers_label","required":""},model:{value:(_vm.params.global_customers_label),callback:function ($$v) {_vm.$set(_vm.params, "global_customers_label", $$v)},expression:"params.global_customers_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Comptes des fournisseurs ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte"}},[_c('k-form-input',{attrs:{"name":"global_providers_account","required":""},model:{value:(_vm.params.global_providers_account),callback:function ($$v) {_vm.$set(_vm.params, "global_providers_account", $$v)},expression:"params.global_providers_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"global_providers_label","required":""},model:{value:(_vm.params.global_providers_label),callback:function ($$v) {_vm.$set(_vm.params, "global_providers_label", $$v)},expression:"params.global_providers_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Comptes de banque ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte"}},[_c('k-form-input',{attrs:{"name":"bank_account","required":""},model:{value:(_vm.params.bank_account),callback:function ($$v) {_vm.$set(_vm.params, "bank_account", $$v)},expression:"params.bank_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"banks_label","required":""},model:{value:(_vm.params.banks_label),callback:function ($$v) {_vm.$set(_vm.params, "banks_label", $$v)},expression:"params.banks_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Comptes de ventes ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte"}},[_c('k-form-input',{attrs:{"name":"sales_account","required":""},model:{value:(_vm.params.sales_account),callback:function ($$v) {_vm.$set(_vm.params, "sales_account", $$v)},expression:"params.sales_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"},scopedSlots:_vm._u([{key:"description",fn:function(){return [_vm._v(" [REFERENCE] sera remplacée par le numéro du document"),_c('br'),_vm._v(" [CUSTOMER] sera remplacée par le nom du client"),_c('br')]},proxy:true}])},[_c('k-form-input',{attrs:{"name":"sales_label","required":""},model:{value:(_vm.params.sales_label),callback:function ($$v) {_vm.$set(_vm.params, "sales_label", $$v)},expression:"params.sales_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Comptes de charges ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte"}},[_c('k-form-input',{attrs:{"name":"charge_account","required":""},model:{value:(_vm.params.charge_account),callback:function ($$v) {_vm.$set(_vm.params, "charge_account", $$v)},expression:"params.charge_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"charges_label","required":""},model:{value:(_vm.params.charges_label),callback:function ($$v) {_vm.$set(_vm.params, "charges_label", $$v)},expression:"params.charges_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Comptes de caisse ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte"}},[_c('k-form-input',{attrs:{"name":"cash_account","required":""},model:{value:(_vm.params.cash_account),callback:function ($$v) {_vm.$set(_vm.params, "cash_account", $$v)},expression:"params.cash_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"cash_label","required":""},model:{value:(_vm.params.cash_label),callback:function ($$v) {_vm.$set(_vm.params, "cash_label", $$v)},expression:"params.cash_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Comptes de TVA ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte TVA sur les charges"}},[_c('k-form-input',{attrs:{"name":"vatrate_charges_account","required":""},model:{value:(_vm.params.vatrate_charges_account),callback:function ($$v) {_vm.$set(_vm.params, "vatrate_charges_account", $$v)},expression:"params.vatrate_charges_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé TVA sur les charges"}},[_c('k-form-input',{attrs:{"name":"vatrate_charges_label","required":""},model:{value:(_vm.params.vatrate_charges_label),callback:function ($$v) {_vm.$set(_vm.params, "vatrate_charges_label", $$v)},expression:"params.vatrate_charges_label"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé de la TVA collectée","description":"La variable [RATE] sera remplacée par le taux de TVA"}},[_c('k-form-input',{attrs:{"name":"vatrate_sales_label","required":""},model:{value:(_vm.params.vatrate_sales_label),callback:function ($$v) {_vm.$set(_vm.params, "vatrate_sales_label", $$v)},expression:"params.vatrate_sales_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Comptes pour les acomptes perçus ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte"}},[_c('k-form-input',{attrs:{"name":"advances_deposits_account","required":""},model:{value:(_vm.params.advances_deposits_account),callback:function ($$v) {_vm.$set(_vm.params, "advances_deposits_account", $$v)},expression:"params.advances_deposits_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"advances_deposits_label","required":""},model:{value:(_vm.params.advances_deposits_label),callback:function ($$v) {_vm.$set(_vm.params, "advances_deposits_label", $$v)},expression:"params.advances_deposits_label"}})],1)],1)],1),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Comptes pour la TVA sur les acomptes perçus ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numéro de compte"}},[_c('k-form-input',{attrs:{"name":"vatrates_regularize_account","required":""},model:{value:(_vm.params.vatrates_regularize_account),callback:function ($$v) {_vm.$set(_vm.params, "vatrates_regularize_account", $$v)},expression:"params.vatrates_regularize_account"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Libellé"}},[_c('k-form-input',{attrs:{"name":"vatrates_regularize_label","required":""},model:{value:(_vm.params.vatrates_regularize_label),callback:function ($$v) {_vm.$set(_vm.params, "vatrates_regularize_label", $$v)},expression:"params.vatrates_regularize_label"}})],1)],1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.fec-params-files",modifiers:{"fec-params-files":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Exports avec pièces justificatives ")])],1),_c('b-collapse',{attrs:{"id":"fec-params-files","accordion":"fec-params-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('input',{attrs:{"type":"hidden","name":"always_add_files"},domProps:{"value":_vm.params.always_add_files ?? false}}),_c('k-form-checkbox',{staticClass:"mb-4",attrs:{"validationName":"always_add_files"},model:{value:(_vm.params.always_add_files),callback:function ($$v) {_vm.$set(_vm.params, "always_add_files", $$v)},expression:"params.always_add_files"}},[_vm._v(" Toujours exporter avec les pièces jutificatives ")]),_c('b-form-group',{attrs:{"label":"Emplacements des pièces justificatives"}},[_c('k-form-select',{attrs:{"name":"files_folder_option","options":_vm.filesFolderOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.params.files_folder_option),callback:function ($$v) {_vm.$set(_vm.params, "files_folder_option", $$v)},expression:"params.files_folder_option"}})],1),(_vm.params.files_folder_option === 'one')?_c('b-form-group',{attrs:{"label":"Nom du dossier"}},[_c('k-form-input',{attrs:{"name":"files_folder_name","required":""},model:{value:(_vm.params.files_folder_name),callback:function ($$v) {_vm.$set(_vm.params, "files_folder_name", $$v)},expression:"params.files_folder_name"}})],1):_vm._e(),(_vm.params.files_folder_option === 'separate')?[_c('b-form-group',{attrs:{"label":"Nom du dossier pour les ventes"}},[_c('k-form-input',{attrs:{"name":"files_folder_sales_name","required":""},model:{value:(_vm.params.files_folder_sales_name),callback:function ($$v) {_vm.$set(_vm.params, "files_folder_sales_name", $$v)},expression:"params.files_folder_sales_name"}})],1),_c('b-form-group',{attrs:{"label":"Nom du dossier pour les achats"}},[_c('k-form-input',{attrs:{"name":"files_folder_charges_name","required":""},model:{value:(_vm.params.files_folder_charges_name),callback:function ($$v) {_vm.$set(_vm.params, "files_folder_charges_name", $$v)},expression:"params.files_folder_charges_name"}})],1)]:_vm._e(),_c('b-form-group',{attrs:{"label":"Préfixe du nom du fichier pour les ventes","description":"Laisser vide pour ne pas ajouter de préfixe"}},[_c('b-input-group',{staticStyle:{"width":"500px"},attrs:{"append":" + la référence du document"}},[_c('k-form-input',{attrs:{"name":"files_sales_prefix"},model:{value:(_vm.params.files_sales_prefix),callback:function ($$v) {_vm.$set(_vm.params, "files_sales_prefix", $$v)},expression:"params.files_sales_prefix"}})],1)],1),_c('b-form-group',{attrs:{"label":"Préfixe du nom du fichier pour les achats","description":"Laisser vide pour ne pas ajouter de préfixe"}},[_c('b-input-group',{staticStyle:{"width":"500px"},attrs:{"append":" + la référence de l'achat"}},[_c('k-form-input',{attrs:{"name":"files_charges_prefix"},model:{value:(_vm.params.files_charges_prefix),callback:function ($$v) {_vm.$set(_vm.params, "files_charges_prefix", $$v)},expression:"params.files_charges_prefix"}})],1)],1)],2)],1)],1),_c('p',[_vm._v(" ")]),_c('k-form-sticky-bar',[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" Enregistrer ")]),_c('b-button',{staticClass:"ml-4",attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.loadConfig.apply(null, arguments)}}},[_vm._v(" Annuler ")])],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FecParams/FecParams.ts?vue&type=script&lang=ts&external





var FecParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FecParams, _super);
    function FecParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.params = {};
        _this.filesFolderOptions = [
            { value: 'root', label: 'Placer les fichiers dans le dossier racine' },
            { value: 'one', label: 'Placer tous les fichiers dans un seul dossier' },
            { value: 'separate', label: 'Utiliser un dossier pour les ventes et un autre pour les achats' },
        ];
        return _this;
    }
    FecParams.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadConfig()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FecParams.prototype.loadConfig = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get(this.apiUrl)
                                .then(function (response) {
                                _this.params = response.data;
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FecParams.prototype.formSubmitted = function (response) {
        this.params = response.data;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], FecParams.prototype, "accountantMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/fec/config' })
    ], FecParams.prototype, "apiUrl", void 0);
    FecParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormStickyBar: form_vue_.KFormStickyBar, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BCardBody: external_bootstrap_vue_.BCardBody, BCollapse: external_bootstrap_vue_.BCollapse, BAlert: external_bootstrap_vue_.BAlert, BInputGroup: external_bootstrap_vue_.BInputGroup
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle
            }
        })
    ], FecParams);
    return FecParams;
}(lib/* Vue */.lD));
/* harmony default export */ var FecParamsvue_type_script_lang_ts_external = (FecParams);

;// ./src/components/FecParams/FecParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FecParams_FecParamsvue_type_script_lang_ts_external = (FecParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/FecParams/FecParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FecParams_FecParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FecParams_FecParams = (component.exports);

/***/ }),

/***/ 65543:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ 65759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ GrantList_GrantList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/GrantList/GrantList.vue?vue&type=template&id=4090a7f2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('sales.grant.new'),"updateTitle":_vm.$t('sales.grant.edit'),"deleteMsg":_vm.$t('sales.grant.deleteMsg'),"sort":"label","customForm":_vm.formComponent},on:{"submitted":_vm.setGrant,"deleted":_vm.deleteGrant}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/GrantForm/GrantForm.vue + 3 modules
var GrantForm = __webpack_require__(6762);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/GrantList/GrantList.ts?vue&type=script&lang=ts&external





var GrantList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GrantList, _super);
    function GrantList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = GrantForm/* default */.A;
        return _this;
    }
    Object.defineProperty(GrantList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('sales.grant.label'),
                    key: 'label',
                    required: true
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GrantList.prototype, "apiUrl", {
        get: function () {
            return '/sales/grant';
        },
        enumerable: false,
        configurable: true
    });
    GrantList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['setGrant', 'deleteGrant'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], GrantList);
    return GrantList;
}(lib/* Vue */.lD));
/* harmony default export */ var GrantListvue_type_script_lang_ts_external = (GrantList);

;// ./src/components/GrantList/GrantList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var GrantList_GrantListvue_type_script_lang_ts_external = (GrantListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/GrantList/GrantList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  GrantList_GrantListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GrantList_GrantList = (component.exports);

/***/ }),

/***/ 66346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SignState_SignState; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SignState/SignState.vue?vue&type=template&id=3b4dd1eb
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.signature)?_c('div',{staticClass:"text-danger font-weight-bold mb-4"},[_vm._v(" Signée numériquement "),_c('span',{staticClass:"text-lowercase"},[_vm._v(_vm._s(_vm.datetime(_vm.signature.signed_at )))]),_c('b-button',{staticClass:"ml-3",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.signShow = _vm.signature}}},[_vm._v(" Voir ")])],1):(_vm.waitingSignature)?_c('div',{staticClass:"text-danger font-weight-bold mb-4"},[(_vm.waitingSignature.is_direct_sign)?[_vm._v(" Signature en attente : "),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.goDirectSign}},[_vm._v(" Continuer ")]),(_vm.waitingSignature.status === 3)?_c('SignCancel',{staticClass:"d-inline-block ml-2",attrs:{"size":"sm","value":_vm.waitingSignature,"variant":"secondary"},on:{"input":_vm.signUpdated}}):_vm._e()]:[_vm._v(" Demande de signature envoyée "),_c('span',{staticClass:"text-lowercase"},[_vm._v(_vm._s(_vm.datetime(_vm.waitingSignature.signed_at ?? _vm.waitingSignature.created_at )))]),_c('b-button',{staticClass:"ml-3",attrs:{"size":"sm","variant":_vm.waitingSignature.status === 3 ? 'primary' : 'secondary'},on:{"click":function($event){$event.preventDefault();_vm.signShow = _vm.waitingSignature}}},[_vm._v(" Voir ")]),(_vm.waitingSignature.status === 3)?_c('SignCancel',{staticClass:"d-inline-block ml-2",attrs:{"size":"sm","value":_vm.waitingSignature,"variant":"secondary"},on:{"input":_vm.signUpdated}}):_vm._e()]],2):_vm._e(),(_vm.signShow)?_c('SignItem',{on:{"hidden":function($event){_vm.signShow = null},"input":_vm.signUpdated},model:{value:(_vm.signShow),callback:function ($$v) {_vm.signShow=$$v},expression:"signShow"}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/SignItem/SignItem.vue + 3 modules
var SignItem = __webpack_require__(19966);
// EXTERNAL MODULE: ./src/components/SignCancel/SignCancel.vue + 3 modules
var SignCancel = __webpack_require__(82973);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SignState/SignState.ts?vue&type=script&lang=ts&external






var SignState = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignState, _super);
    function SignState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.signShow = null;
        return _this;
    }
    SignState.prototype.mounted = function () {
        interface_vue_.emitter.on('signatureDone', this.signatureDone);
    };
    SignState.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('signatureDone', this.signatureDone);
    };
    Object.defineProperty(SignState.prototype, "waitingSignature", {
        get: function () {
            var _a;
            return (_a = this.signatures.find(function (signature) { return signature.status >= 2 && signature.status <= 4; })) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignState.prototype, "signature", {
        get: function () {
            var _a;
            return (_a = this.signatures.find(function (signature) { return signature.status === 5; })) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    SignState.prototype.signUpdated = function (signature) {
        var index = this.signatures.findIndex(function (sign) { return sign.id === signature.id; });
        if (index >= 0) {
            lib/* Vue */.lD.delete(this.signatures, index);
            this.$emit('input', this.signatures);
        }
        this.signShow = null;
    };
    SignState.prototype.watchWaiting = function () {
        this.$emit('waiting', this.waitingSignature !== null);
    };
    SignState.prototype.watchSigned = function () {
        this.$emit('signed', this.signature !== null);
    };
    SignState.prototype.isRecentDay = function (date) {
        if (!date) {
            return false;
        }
        return (0,interface_vue_.moment)(date).isSameOrAfter((0,interface_vue_.moment)().subtract(1, 'day'), 'day');
    };
    SignState.prototype.signatureDone = function (signature) {
        var index = this.signatures.findIndex(function (sign) { return sign.id === signature.id; });
        if (index >= 0) {
            lib/* Vue */.lD.set(this.signatures, index, signature);
        }
    };
    SignState.prototype.goDirectSign = function () {
        if (this.waitingSignature) {
            window.location.href = this.waitingSignature.signatories[0].public_link;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SignState.prototype, "signatures", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('waitingSignature', { immediate: true })
    ], SignState.prototype, "watchWaiting", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('signature', { immediate: true })
    ], SignState.prototype, "watchSigned", null);
    SignState = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SignCancel: SignCancel/* default */.A,
                BButton: external_bootstrap_vue_.BButton,
                SignItem: SignItem/* default */.A
            }
        })
    ], SignState);
    return SignState;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var SignStatevue_type_script_lang_ts_external = (SignState);

;// ./src/components/SignState/SignState.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SignState_SignStatevue_type_script_lang_ts_external = (SignStatevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SignState/SignState.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SignState_SignStatevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignState_SignState = (component.exports);

/***/ }),

/***/ 66584:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ 66597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ConflictModal_ConflictModal; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/ConflictModal/ConflictModal.vue?vue&type=template&id=6f4478c6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.forceSaveState)?_c('input',{attrs:{"type":"hidden","name":"force_update","value":"1"}}):_vm._e(),(_vm.modal)?_c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close')},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('b-alert',{attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.saveConflict.mostRecentVersion'))+" ")]),_c('p',{staticClass:"font-weight-bold mb-2"},[_vm._v(" "+_vm._s(_vm.$t('sales.form.saveConflict.actionsChoice'))+" ")]),_c('ul',[_c('li',{staticClass:"mb-2"},[_c('a',{attrs:{"href":_vm.documentHref,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.saveConflict.newWindow'))+" ")]),_c('br')]),_c('li',{staticClass:"mb-2"},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":_vm.forceSave}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.saveConflict.forceSave'))+" ")]),_c('br'),_c('small',[_vm._v(" "+_vm._s(_vm.$t('sales.form.saveConflict.allDatasLost'))+" ")])],1),_c('li',[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":_vm.redirect}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.saveConflict.goNewVersion'))+" ")]),_c('br'),_c('small',[_vm._v(" "+_vm._s(_vm.$t('sales.form.saveConflict.datasNotSaved'))+" ")])],1)])],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/ConflictModal/ConflictModal.ts?vue&type=script&lang=ts&external




var ConflictModal = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConflictModal, _super);
    function ConflictModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.forceSaveState = false;
        _this.modal = false;
        return _this;
    }
    Object.defineProperty(ConflictModal.prototype, "documentHref", {
        get: function () {
            return this.$router.resolve({
                name: this.type + '-item',
                params: { id: String(this.lastVersion.id) }
            }).href;
        },
        enumerable: false,
        configurable: true
    });
    ConflictModal.prototype.watchLastVersion = function (document) {
        this.modal = document !== null;
        this.forceSaveState = false;
    };
    ConflictModal.prototype.redirect = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams(this.lastVersion);
                        return [4 /*yield*/, this.$router.push({
                                name: this.type + '-item',
                                params: { id: String(this.lastVersion.id) }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConflictModal.prototype.forceSave = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.forceSaveState = true;
                        return [4 /*yield*/, this.$nextTick(function () {
                                _this.$emit('submit');
                                _this.modal = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConflictModal.prototype, "lastVersion", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ConflictModal.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('lastVersion')
    ], ConflictModal.prototype, "watchLastVersion", null);
    ConflictModal = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            components: {
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], ConflictModal);
    return ConflictModal;
}(lib/* Vue */.lD));
/* harmony default export */ var ConflictModalvue_type_script_lang_ts_external = (ConflictModal);

;// ./src/components/Form/ConflictModal/ConflictModal.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConflictModal_ConflictModalvue_type_script_lang_ts_external = (ConflictModalvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/ConflictModal/ConflictModal.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ConflictModal_ConflictModalvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConflictModal_ConflictModal = (component.exports);

/***/ }),

/***/ 66721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(81042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 66969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractList_ContractList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractList/ContractList.vue?vue&type=template&id=7ce88b0e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-table"},[(_vm.loading)?_c('Spinner'):[(!_vm.customerId)?_c('PageHeader',{attrs:{"useMeta":true}},[(_vm.can('app-configuration', 1))?[_c('b-col'),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"secondary","to":{ name: 'contract-models-list' },"size":"sm"}},[_vm._v(" Modèles de contrats ")])],1)]:_vm._e()],2):_vm._e(),_c('AppMessages'),_c('k-table',{ref:"table",attrs:{"url":"/sales/contract","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"stateKey":_vm.customStateKey ? _vm.customStateKey : 'contract-list',"exportable":"contract","saveMainSearch":_vm.disableMainSearchSave === false}}),_c('ContractDelete',{attrs:{"element":"modal","modal":_vm.deleteIndex !== null},on:{"deleted":_vm.deleted,"closed":_vm.cancelDelete},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/ContractDelete/ContractDelete.vue + 3 modules
var ContractDelete = __webpack_require__(57553);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(44696);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractList/ContractList.ts?vue&type=script&lang=ts&external








var ContractList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractList, _super);
    function ContractList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteModel = null;
        _this.deleteIndex = null;
        _this.loading = false;
        return _this;
    }
    ContractList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadContractModels()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContractList.prototype, "ajaxDatas", {
        get: function () {
            var include = ['customer_child', 'contact', 'country', 'teamUser', 'payment_term', 'payment_method', 'model', 'active_period', 'customFields'];
            var filter = {};
            if (this.customerId) {
                filter.customer_or_child = this.customerId;
            }
            else {
                include.push('customer');
            }
            return {
                include: include,
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractList.prototype, "columns", {
        get: function () {
            var columns = [
                {
                    data: 'reference',
                    name: 'N° Contrat'
                },
                {
                    data: 'title',
                    name: 'Titre'
                }
            ];
            if (!this.customerId) {
                columns.push({
                    data: 'customer.name',
                    name: 'Client'
                });
            }
            if (this.hasModule('customers-group')) {
                columns.push({
                    data: 'customer_child.name',
                    name: this.teamConfigs.customer_group_child_name
                });
            }
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'contact.fullname',
                    name: 'Contact',
                    visible: false
                },
                {
                    data: 'road1',
                    name: 'Rue',
                    visible: false
                },
                {
                    data: 'road2',
                    name: 'Rue 2',
                    visible: false
                },
                {
                    data: 'road3',
                    name: 'Rue 3',
                    visible: false
                },
                {
                    data: 'postal_code',
                    name: 'Code postal',
                    visible: false
                },
                {
                    data: 'town',
                    name: 'Ville',
                    visible: false
                },
                {
                    data: 'country.name',
                    name: 'Pays',
                    visible: false
                },
                {
                    data: 'model.name',
                    name: 'Modèle de contrat',
                    visible: !this.customerId
                },
                {
                    data: 'payment_method.label',
                    name: 'Mode de règlement',
                    visible: false,
                    render: function (data, display, row) {
                        var _a, _b, _c;
                        if (data === '' || data === undefined || data === null) {
                            data = (_c = (_b = (_a = row.model) === null || _a === void 0 ? void 0 : _a.payment_method) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : '';
                        }
                        return data;
                    }
                },
                {
                    data: 'payment_term.label',
                    name: 'Condition de règlement',
                    visible: false,
                    render: function (data, display, row) {
                        var _a, _b, _c;
                        if (data === '' || data === undefined || data === null) {
                            data = (_c = (_b = (_a = row.model) === null || _a === void 0 ? void 0 : _a.payment_term) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : '';
                        }
                        return data;
                    }
                },
                {
                    data: 'next_deadline',
                    name: 'Prochaine échéance',
                    render: 'date'
                },
                {
                    data: 'auto_renew',
                    name: 'Renouvellement',
                    visible: false,
                    render: function (data, display, row) {
                        var _a, _b;
                        if (data === null) {
                            data = (_b = (_a = row.model) === null || _a === void 0 ? void 0 : _a.auto_renew) !== null && _b !== void 0 ? _b : false;
                        }
                        return data ? 'Oui' : 'Non';
                    }
                },
                {
                    data: 'active_period.begin',
                    name: 'Début',
                    render: 'date',
                    visible: !this.customerId
                },
                {
                    data: 'active_period.end',
                    name: 'Fin',
                    render: 'date',
                    visible: !this.customerId
                },
                {
                    data: 'discounted_total_ht',
                    name: 'Total HT',
                    render: 'currency'
                },
                {
                    data: 'discounted_total_tva',
                    name: 'Total TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'discounted_total_ttc',
                    name: 'Total TTC',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'team_user.fullname',
                    name: 'Commercial',
                    visible: !this.customerId
                },
                {
                    data: 'status',
                    name: 'Statut du contrat',
                    render: function (data) {
                        switch (data) {
                            case 1: return 'Brouillon';
                            case 2: return 'En attente';
                            case 3: return 'En cours';
                            case 4: return 'Terminé';
                            default: return '';
                        }
                    }
                }
            ], this.customFieldTableColumns('contract')));
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractList.prototype, "filters", {
        get: function () {
            var filters = [];
            if (!this.customerId) {
                filters.push({
                    type: 'select',
                    label: 'Client',
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[hasContract]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            if (this.hasModule('customers-group')) {
                filters.push({
                    type: 'select',
                    label: this.teamConfigs.customer_group_child_name,
                    name: 'customer_child',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1&filter[isParent]=0',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            filters.push.apply(filters, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'select',
                    label: 'Type de contrat',
                    name: 'model',
                    options: this.contractModels,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: 'Statut',
                    name: 'status',
                    options: [
                        { value: 1, label: 'Brouillon' },
                        { value: 2, label: 'En attente' },
                        { value: 3, label: 'En cours' },
                        { value: 4, label: 'Terminé' }
                    ],
                    multiple: true,
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'select',
                    label: 'Commercial',
                    name: 'team_user',
                    options: this.teamUsersRole('commercial'),
                    multiple: true,
                    optionLabel: 'fullname',
                    value: 'id'
                },
                {
                    type: 'period',
                    label: 'Début du contrat',
                    name: 'begin_since',
                    name2: 'begin_until'
                },
                {
                    type: 'period',
                    label: 'Fin du contrat',
                    name: 'end_since',
                    name2: 'end_until'
                }
            ], this.customFieldTableFilters('contract')));
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    title: 'Dupliquer',
                    icon: ['fas', 'copy'],
                    click: function (contract) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, Promise, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.setPageParams(contract);
                                    return [4 /*yield*/, this.$router.push({ name: 'contract-form' })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                },
                {
                    icon: 'edit',
                    link: function (contract) { return ({
                        name: 'contract-form',
                        params: { id: String(contract.id) }
                    }); }
                },
                {
                    icon: 'delete',
                    click: function (model, index) {
                        _this.deleteModel = model;
                        _this.deleteIndex = index;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ContractList.prototype.rowLink = function (row) {
        return {
            name: 'contract-item',
            params: { id: String(row.id) }
        };
    };
    ContractList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.deleteModel = null;
        }
    };
    ContractList.prototype.cancelDelete = function () {
        this.deleteIndex = null;
        this.deleteModel = null;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractList.prototype, "customerId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractList.prototype, "customStateKey", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractList.prototype, "disableMainSearchSave", void 0);
    ContractList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BRow: external_bootstrap_vue_.BRow,
                BCard: external_bootstrap_vue_.BCard,
                PageHeader: interface_vue_.PageHeader,
                AppMessages: interface_vue_.AppMessages,
                KTable: table_vue_.KTable,
                BButton: external_bootstrap_vue_.BButton, BCol: external_bootstrap_vue_.BCol,
                ContractDelete: ContractDelete/* default */.A,
                Spinner: interface_vue_.Spinner
            },
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])), (0,external_vuex_.mapActions)('sales', ['loadContractModels'])), (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'teamConfigs'])), (0,external_vuex_.mapState)('sales', ['contractModels'])), (0,external_vuex_.mapGetters)('globalDatas', ['teamUsersRole'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], ContractList);
    return ContractList;
}((0,lib/* Mixins */.Xe)(custom_fields_vue_.CustomFieldsTableMixin)));
/* harmony default export */ var ContractListvue_type_script_lang_ts_external = (ContractList);

;// ./src/components/ContractList/ContractList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractList_ContractListvue_type_script_lang_ts_external = (ContractListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractList/ContractList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractList_ContractListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractList_ContractList = (component.exports);

/***/ }),

/***/ 67197:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 67912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__);



var FecMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(FecMixin, _super);
    function FecMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    FecMixin.prototype.fetchFile = function (id) {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__generator */ .YH)(this, function (_a) {
                this.loading = true;
                return [2 /*return*/, this.$kwSales.axios.get(this.downloadUrl(id), { responseType: 'blob' })
                        .then(function (response) {
                        return response;
                    })
                        .finally(function () {
                        _this.loading = false;
                    })];
            });
        });
    };
    FecMixin.prototype.download = function (id) {
        var _a;
        return (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
            var response, headers, extension, filename;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__generator */ .YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.fetchFile(id)];
                    case 1:
                        response = _b.sent();
                        if (!response) {
                            return [2 /*return*/];
                        }
                        headers = response.headers;
                        extension = headers['content-type'] === 'application/zip' ? 'zip' : 'txt';
                        filename = (_a = headers['x-suggested-filename']) !== null && _a !== void 0 ? _a : 'export-fec.' + extension;
                        this.downloadFile(response.data, filename, false);
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Prop */ .kv)({ default: function () { return function (id) { return '/fec/export/' + id + '/download'; }; } })
    ], FecMixin.prototype, "downloadUrl", void 0);
    FecMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], FecMixin);
    return FecMixin;
}((0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Mixins */ .Xe)(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.FileMixin)));
/* harmony default export */ __webpack_exports__.A = (FecMixin);


/***/ }),

/***/ 68067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SalesListMixin_SalesListMixin; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/mixins/SalesListMixin/SalesListMixin.vue?vue&type=template&id=60600d38
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100 flex-table"},[(_vm.loading || !_vm.customFieldsLoaded)?_c('Spinner'):[_c('AppMessages'),_c('k-table',{ref:"table",staticStyle:{"flex":"1 1 auto"},attrs:{"url":_vm.ajaxUrl,"ajaxDatas":_vm.ajaxDatas,"columns":_vm.finalColumns,"filters":_vm.computedFilters,"rowActions":_vm.rowActions,"rowClass":_vm.rowClass,"rowLink":_vm.rowLink,"stateKey":_vm.tableStateKey,"sortIndex":2,"sortOrder":"desc","exportable":_vm.exportComponent,"exportProps":{ model: _vm.type },"saveMainSearch":_vm.disableMainSearchSave === false}}),(_vm.statusIndicator.length > 0)?_c('div',{staticClass:"text-center"},[_c('b-card',{staticClass:"d-inline-block small mt-2 status-indicator-explain text-left",attrs:{"body-class":"px-3 py-2"}},[_c('b-row',{attrs:{"align-v":"center"}},_vm._l((_vm.statusIndicator),function(status,i){return _c('b-col',{key:i,attrs:{"cols":"auto"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{class:'pr-0 status-indicator ' + status.class,attrs:{"cols":"auto"}}),_c('b-col',{staticClass:"pl-2",attrs:{"cols":"auto"}},[_vm._v(_vm._s(status.label))])],1)],1)}),1)],1)],1):_vm._e(),_c('DocumentDelete',{attrs:{"type":_vm.type,"element":"modal","modal":_vm.deleteIndex !== null},on:{"deleted":_vm.deleted,"closed":_vm.cancelDelete},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(44696);
// EXTERNAL MODULE: ./src/components/DocumentDelete/DocumentDelete.vue + 3 modules
var DocumentDelete = __webpack_require__(30104);
// EXTERNAL MODULE: ./src/components/SaleExports/SaleExports.vue + 3 modules
var SaleExports = __webpack_require__(54362);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/mixins/SalesListMixin/SalesListMixin.ts?vue&type=script&lang=ts&external









var SalesListMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SalesListMixin, _super);
    function SalesListMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.additionalColumns = [];
        _this.finalColumns = [];
        _this.deleteModel = null;
        _this.deleteIndex = null;
        _this.exportComponent = SaleExports/* default */.A;
        _this.includes = [
            'customer', 'customer_child', 'contact', 'billing_address_country', 'delivery_address_country', 'teamUser', 'payment_term',
            'customFields', 'currency', 'tags', 'car'
        ];
        return _this;
    }
    Object.defineProperty(SalesListMixin.prototype, "status", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "statusIndicator", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    SalesListMixin.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadTags()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadCustomFields()];
                    case 3:
                        _a.sent();
                        this.setColumns();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SalesListMixin.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    condition: function (document) {
                        if (!_this.can('sales-' + _this.type, 3)) {
                            return false;
                        }
                        return _this.canBeEdited(document);
                    },
                    link: function (document) { return ({
                        name: _this.type + '-form',
                        params: {
                            id: String(document.id)
                        }
                    }); }
                },
                {
                    icon: 'delete',
                    condition: function (document) {
                        return document.is_draft && _this.can('sales-' + _this.type, 4);
                    },
                    click: function (document, index) {
                        _this.deleteModel = document;
                        _this.deleteIndex = index;
                    }
                },
                {
                    icon: ['fas', 'file-pdf'],
                    title: 'Télécharger',
                    click: function (document) {
                        _this.$kwSales.axios.get('/sales/' + _this.type + '/' + document.id + '/pdf')
                            .then(function (response) {
                            var file = response.data;
                            _this.downloadFile(file.file, file.filename);
                        });
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "tableStateKey", {
        get: function () {
            var _a;
            return (_a = this.customStateKey) !== null && _a !== void 0 ? _a : 'sales-' + this.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [
                {
                    data: 'number',
                    name: 'N° suivi',
                    visible: false
                },
                {
                    data: 'reference',
                    name: 'N° document',
                    sticky: true
                }
            ];
            if (!this.customer) {
                columns.push({
                    data: 'customer.name',
                    name: 'Client',
                    visible: !this.contact
                });
            }
            if (this.hasModule('customers-group')) {
                columns.push({
                    data: 'customer_child.name',
                    name: this.teamConfigs.customer_group_child_name
                });
            }
            if (!this.contact) {
                columns.push({
                    data: 'contact.fullname',
                    name: 'Contact',
                    visible: !this.customer
                });
            }
            columns.push.apply(columns, [
                {
                    data: 'customer_command_reference',
                    name: 'N° BDC client',
                    visible: false
                },
                {
                    data: 'title',
                    name: 'Titre',
                    visible: !this.customer && !this.contact
                },
                {
                    data: 'date',
                    name: 'Date',
                    render: 'date'
                }
            ]);
            if (this.type !== 'credit' && this.type !== 'delivery') {
                columns.push({
                    data: 'expire_at',
                    name: this.type === 'invoice' ? 'Limite de paiement' : 'Date de validité',
                    render: 'date'
                });
            }
            if (this.hasModule('automotive')) {
                columns.push.apply(columns, [
                    {
                        data: 'car.brand.name',
                        name: 'Marque'
                    },
                    {
                        data: 'car.model.name',
                        name: 'Modèle'
                    },
                    {
                        data: 'car.numberplate',
                        name: 'Immatriculation'
                    },
                    {
                        data: 'mileage',
                        name: 'Kilométrage',
                        render: function (val) { return val === null ? null : val + ' km'; }
                    },
                    {
                        data: 'car.vin',
                        name: 'N° de série',
                        visible: false
                    },
                    {
                        data: 'car.first_circulation_date',
                        name: 'Première mise en circulation',
                        render: 'date',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'billing_address.road',
                    name: 'Rue (facturation)',
                    visible: false
                },
                {
                    data: 'billing_address.road2',
                    name: 'Rue 2 (facturation)',
                    visible: false
                },
                {
                    data: 'billing_address.road3',
                    name: 'Rue 3 (facturation)',
                    visible: false
                },
                {
                    data: 'billing_address.city',
                    name: 'Ville (facturation)',
                    visible: false
                },
                {
                    data: 'billing_address.postal_code',
                    name: 'Code postal (facturation)',
                    visible: false
                },
                {
                    data: 'billing_address.country.name',
                    name: 'Pays (facturation)',
                    visible: false
                },
                {
                    data: 'delivery_address.road',
                    name: 'Rue (livraison)',
                    visible: false
                },
                {
                    data: 'delivery_address.road2',
                    name: 'Rue 2 (livraison)',
                    visible: false
                },
                {
                    data: 'delivery_address.road3',
                    name: 'Rue 3 (livraison)',
                    visible: false
                },
                {
                    data: 'delivery_address.city',
                    name: 'Ville (livraison)',
                    visible: false
                },
                {
                    data: 'delivery_address.postal_code',
                    name: 'Code postal (livraison)',
                    visible: false
                },
                {
                    data: 'delivery_address.country.name',
                    name: 'Pays (livraison)',
                    visible: false
                },
                {
                    data: 'total_ht',
                    name: 'Total HT',
                    render: 'currency'
                },
                {
                    data: 'total_tva',
                    name: 'Total TVA',
                    render: 'currency',
                    visible: !this.customer && !this.contact
                },
                {
                    data: 'total_ttc',
                    name: 'Total TTC',
                    render: 'currency'
                }
            ]);
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'total_costs',
                        name: 'Coûts catalogue',
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'workforce_costs',
                        name: 'Main d\'oeuvre',
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'total_charge',
                        name: 'Coûts',
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'gross_margin_amount',
                        name: 'Marge brute HT',
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'gross_margin_rate',
                        name: 'Taux de marge',
                        visible: false,
                        render: 'pourcent'
                    },
                    {
                        data: 'markup_rate',
                        name: 'Taux de marque',
                        visible: false,
                        render: 'pourcent'
                    }
                ]);
            }
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'team_user.fullname',
                    name: 'Commercial',
                    visible: !this.customer && !this.contact
                },
                {
                    data: 'status_label',
                    name: 'Statut',
                    cssClass: function (row) {
                        var cssClass = {
                            'status-indicator': true
                        };
                        cssClass['status-' + _this.type + '-' + row.status] = true;
                        return cssClass;
                    }
                },
                {
                    data: 'tags',
                    name: 'Mots clés',
                    render: function (data) {
                        return data ? data.map(function (tag) { return tag.name; }).join(', ') : null;
                    },
                    visible: false,
                    sortable: false
                }
            ], this.customFieldTableColumns(this.type)));
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    type: 'period',
                    label: 'Date du document',
                    name: 'date_since',
                    name2: 'date_until'
                }
            ];
            if (this.type !== 'credit' && this.type !== 'delivery') {
                filters.push({
                    type: 'period',
                    label: this.type === 'invoice' ? 'Limite de paiement' : 'Date d\'expiration',
                    name: 'expire_since',
                    name2: 'expire_until'
                });
            }
            if (!this.customer) {
                filters.push({
                    type: 'select',
                    label: 'Client',
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            if (this.hasModule('customers-group')) {
                filters.push({
                    type: 'select',
                    label: this.teamConfigs.customer_group_child_name,
                    name: 'customer_child',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1&filter[isParent]=0',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            if (!this.contact) {
                filters.push({
                    type: 'select',
                    label: 'Contact',
                    name: 'contact',
                    multiple: true,
                    ajax: '/customer/contact?sort=fullname',
                    optionLabel: 'fullname',
                    value: 'id'
                });
            }
            if (!this.statusFilter) {
                filters.push({
                    type: 'select',
                    label: 'Statut',
                    name: 'status',
                    options: this.status,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                });
            }
            filters.push.apply(filters, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'select',
                    label: 'Tous les mots-clés',
                    name: 'all_tags',
                    options: this.tags,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'name'
                },
                {
                    type: 'select',
                    label: 'Au moins un mots clé',
                    name: 'any_tags',
                    options: this.tags,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'name'
                },
                {
                    type: 'select',
                    label: 'Commercial',
                    name: 'team_user',
                    options: this.teamUsersRole('commercial'),
                    multiple: true,
                    optionLabel: 'fullname',
                    value: 'id'
                }
            ], this.customFieldTableFilters(this.type)));
            if (this.hasModule('automotive')) {
                filters.push.apply(filters, [
                    {
                        type: 'text',
                        label: 'Immatriculation',
                        name: 'numberplate',
                        placeOnHeader: true
                    }
                ]);
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "computedFilters", {
        get: function () {
            return this.filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "computedIncludes", {
        get: function () {
            var includes = this.includes;
            if (this.customer) {
                includes.splice(includes.findIndex(function (val) { return val === 'customer'; }), 1);
            }
            if (this.contact) {
                includes.splice(includes.findIndex(function (val) { return val === 'contact'; }), 1);
            }
            return includes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "defaultFilters", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "ajaxUrl", {
        get: function () {
            return '/sales/' + this.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesListMixin.prototype, "ajaxDatas", {
        get: function () {
            var filter = this.defaultFilters;
            if (this.customer) {
                filter.customer_or_child = this.customer;
            }
            if (this.contact) {
                filter.contact = this.contact;
            }
            if (this.statusFilter) {
                filter.status = this.statusFilter;
            }
            return {
                include: this.computedIncludes.join(','),
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    SalesListMixin.prototype.setColumns = function () {
        var _a;
        this.finalColumns = Array.from(this.columns);
        (_a = this.finalColumns).push.apply(_a, Array.from(this.additionalColumns));
    };
    SalesListMixin.prototype.rowLink = function (row) {
        return {
            name: this.type + '-item',
            params: {
                id: String(row.id),
                document: JSON.stringify(row)
            }
        };
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    SalesListMixin.prototype.rowClass = function (row) {
        return {};
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    SalesListMixin.prototype.canBeEdited = function (document) {
        return true;
    };
    SalesListMixin.prototype.toDelete = function (document, index) {
        this.deleteModel = document;
        this.deleteIndex = index;
    };
    SalesListMixin.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.cancelDelete();
        }
    };
    SalesListMixin.prototype.cancelDelete = function () {
        this.deleteIndex = null;
        this.deleteModel = null;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SalesListMixin.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SalesListMixin.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SalesListMixin.prototype, "statusFilter", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SalesListMixin.prototype, "customStateKey", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SalesListMixin.prototype, "disableMainSearchSave", void 0);
    SalesListMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers', 'loadTags'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['tags'])), (0,external_vuex_.mapGetters)('globalDatas', ['teamUsersRole'])), (0,external_vuex_.mapGetters)('user', ['can', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                DocumentDelete: DocumentDelete/* default */.A,
                KTable: table_vue_.KTable,
                BCard: external_bootstrap_vue_.BCard, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                Spinner: interface_vue_.Spinner, AppMessages: interface_vue_.AppMessages
            }
        })
    ], SalesListMixin);
    return SalesListMixin;
}((0,lib/* Mixins */.Xe)(custom_fields_vue_.CustomFieldsTableMixin, interface_vue_.FileMixin)));
/* harmony default export */ var SalesListMixinvue_type_script_lang_ts_external = (SalesListMixin);

;// ./src/mixins/SalesListMixin/SalesListMixin.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SalesListMixin_SalesListMixinvue_type_script_lang_ts_external = (SalesListMixinvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/mixins/SalesListMixin/SalesListMixin.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SalesListMixin_SalesListMixinvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SalesListMixin_SalesListMixin = (component.exports);

/***/ }),

/***/ 68223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(56110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 68480:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/catalog-vue");

/***/ }),

/***/ 68694:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'paper-plane';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f1d8';
var svgPathData = 'M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.is = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 69302:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(83488),
    overRest = __webpack_require__(56757),
    setToString = __webpack_require__(32865);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 69330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ 69532:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ 69831:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f061';
var svgPathData = 'M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.dm = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 69884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(21791),
    keysIn = __webpack_require__(37241);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 69998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ }),

/***/ 70027:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'sitemap';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f0e8';
var svgPathData = 'M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.FF = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 70032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionDocumentList_CommissionDocumentList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionDocumentList/CommissionDocumentList.vue?vue&type=template&id=195a99ad
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-table"},[_c('PageHeader',{attrs:{"pageTitle":"Liste des commissions","buttons":_vm.buttons}}),_c('AppMessages'),(_vm.loading)?_c('Spinner'):_c('k-table',{ref:"table",attrs:{"url":"/sales/commission/sales","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"rowClick":_vm.rowClick,"filters":_vm.filters}}),(_vm.showCommission)?_c('CommissionDocumentItem',{attrs:{"modal":true},on:{"hidden":function($event){_vm.showCommission = null},"deleted":_vm.commissionDeleted,"edit":_vm.commissionEdit},model:{value:(_vm.showCommission),callback:function ($$v) {_vm.showCommission=$$v},expression:"showCommission"}}):_vm._e(),_c('CommissionDocumentForm',{attrs:{"modal":_vm.newCommission},on:{"submitComplete":_vm.commissionAdded,"hidden":function($event){_vm.newCommission = false}}}),_c('CommissionDocumentForm',{attrs:{"modal":_vm.editCommission !== null},on:{"hidden":function($event){_vm.editCommission = null},"submitComplete":_vm.commissionUpdated},model:{value:(_vm.editCommission),callback:function ($$v) {_vm.editCommission=$$v},expression:"editCommission"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./src/components/CommissionDocumentItem/CommissionDocumentItem.vue + 3 modules
var CommissionDocumentItem = __webpack_require__(17369);
// EXTERNAL MODULE: ./src/components/CommissionDocumentForm/CommissionDocumentForm.vue + 3 modules
var CommissionDocumentForm = __webpack_require__(92746);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionDocumentList/CommissionDocumentList.ts?vue&type=script&lang=ts&external







var CommissionDocumentList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionDocumentList, _super);
    function CommissionDocumentList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.showCommission = null;
        _this.newCommission = false;
        _this.editCommission = null;
        return _this;
    }
    CommissionDocumentList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommissionDocumentList.prototype, "buttons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('sales-commissions', 2)) {
                buttons.push({
                    label: 'Créer une commission',
                    click: function () {
                        _this.newCommission = true;
                    }
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionDocumentList.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: ['document', 'payment', 'teamUser']
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionDocumentList.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    data: 'date',
                    name: 'Date',
                    render: 'date'
                },
                {
                    data: 'base_amount',
                    name: 'Base de calcul',
                    render: function (amount) {
                        if (amount === null) {
                            return null;
                        }
                        return _this.formattedNumber(amount);
                    },
                },
                {
                    data: 'amount',
                    name: 'Montant',
                    render: 'currency'
                },
                {
                    data: 'document_reference',
                    name: 'Document',
                    sortable: false
                },
                {
                    data: 'team_user.fullname',
                    name: 'Commercial'
                },
                {
                    data: 'status',
                    name: 'Statut',
                    render: function (data) {
                        switch (data) {
                            case 1: return 'À payer';
                            case 2: return 'Payée';
                            default: return null;
                        }
                    }
                },
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'updated_at',
                    name: 'Dernière modification',
                    render: 'datetime',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionDocumentList.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'period',
                    label: 'Date',
                    name: 'date_since',
                    name2: 'date_until'
                },
                {
                    type: 'select',
                    label: 'Commercial',
                    name: 'team_user',
                    options: this.teamUsersRole('commercial'),
                    multiple: true,
                    optionLabel: 'fullname',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: 'Statut',
                    name: 'status',
                    options: [
                        { value: 1, label: 'À payer' },
                        { value: 2, label: 'Payée' }
                    ],
                    optionLabel: 'label',
                    value: 'value',
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CommissionDocumentList.prototype.rowClick = function (commission) {
        this.showCommission = commission;
    };
    CommissionDocumentList.prototype.commissionAdded = function (commission) {
        var table = this.$refs.table;
        table.addRow(commission);
    };
    CommissionDocumentList.prototype.commissionEdit = function (commission) {
        this.editCommission = commission;
    };
    CommissionDocumentList.prototype.commissionUpdated = function (commission) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (value) { return value.id === commission.id; });
        if (index > -1) {
            table.updateRow(index, commission);
        }
        else {
            table.addRow(commission);
        }
    };
    CommissionDocumentList.prototype.commissionDeleted = function (commission) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (value) { return value.id === commission.id; });
        if (index > -1) {
            table.deleteRow(index);
        }
        this.$emit('hidden');
    };
    CommissionDocumentList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PageHeader: interface_vue_.PageHeader, Spinner: interface_vue_.Spinner, AppMessages: interface_vue_.AppMessages,
                KTable: table_vue_.KTable,
                CommissionDocumentItem: CommissionDocumentItem/* default */.A,
                CommissionDocumentForm: CommissionDocumentForm/* default */.A
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['teamUsersRole'])), (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], CommissionDocumentList);
    return CommissionDocumentList;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CommissionDocumentListvue_type_script_lang_ts_external = (CommissionDocumentList);

;// ./src/components/CommissionDocumentList/CommissionDocumentList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionDocumentList_CommissionDocumentListvue_type_script_lang_ts_external = (CommissionDocumentListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionDocumentList/CommissionDocumentList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionDocumentList_CommissionDocumentListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionDocumentList_CommissionDocumentList = (component.exports);

/***/ }),

/***/ 70080:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(26025);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 70128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractPeriodForm_ContractPeriodForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractPeriodForm/ContractPeriodForm.vue?vue&type=template&id=ffc4b8ee
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":"Création d'une nouvelle période"},on:{"hidden":function($event){return _vm.$emit('hidden')},"submitComplete":_vm.submitComplete},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":'/sales/contract/' + _vm.contract.id + '/period'}},[_c('b-form-group',{attrs:{"label":"Début de la période"}},[_c('k-form-datepicker',{attrs:{"min-date":_vm.minDate,"max-date":_vm.end,"name":"begin","required":""},on:{"input":_vm.updateEndDate},model:{value:(_vm.begin),callback:function ($$v) {_vm.begin=$$v},expression:"begin"}})],1),_c('b-form-group',{attrs:{"label":"Fin de la période"}},[_c('k-form-datepicker',{attrs:{"min-date":_vm.begin,"name":"end","required":""},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractPeriodForm/ContractPeriodForm.ts?vue&type=script&lang=ts&external






var ContractPeriodForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractPeriodForm, _super);
    function ContractPeriodForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.lastPeriod = null;
        _this.minDate = null;
        _this.duration = 0;
        _this.begin = null;
        _this.end = null;
        return _this;
    }
    ContractPeriodForm.prototype.watchValue = function (state) {
        var _a, _b, _c;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var minDate;
            return (0,tslib_es6/* __generator */.YH)(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.modalState = state;
                        if (!state) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getLastPeriod()];
                    case 1:
                        _d.sent();
                        minDate = external_moment_default()((_a = this.lastPeriod) === null || _a === void 0 ? void 0 : _a.end).add(1, 'day');
                        this.minDate = minDate.format('YYYY-MM-DD');
                        this.duration = external_moment_default()((_b = this.lastPeriod) === null || _b === void 0 ? void 0 : _b.end).diff((_c = this.lastPeriod) === null || _c === void 0 ? void 0 : _c.begin, 'day');
                        this.begin = this.minDate;
                        this.end = minDate.add(this.duration, 'days').format('YYYY-MM-DD');
                        _d.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ContractPeriodForm.prototype.getLastPeriod = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/contract/' + this.contract.id + '/period', {
                                params: {
                                    sort: 'end:desc'
                                }
                            })
                                .then(function (response) {
                                var _a;
                                _this.lastPeriod = (_a = response.data.data[0]) !== null && _a !== void 0 ? _a : null;
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractPeriodForm.prototype.updateEndDate = function () {
        this.end = external_moment_default()(this.begin).add(this.duration, 'days').format('YYYY-MM-DD');
    };
    ContractPeriodForm.prototype.submitComplete = function (response) {
        this.$emit('created');
        interface_vue_.emitter.emit('contractUpdated', response.data);
        interface_vue_.emitter.emit('contractPeriodCreated');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractPeriodForm.prototype, "contract", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContractPeriodForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal')
    ], ContractPeriodForm.prototype, "watchValue", null);
    ContractPeriodForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner
            }
        })
    ], ContractPeriodForm);
    return ContractPeriodForm;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractPeriodFormvue_type_script_lang_ts_external = (ContractPeriodForm);

;// ./src/components/ContractPeriodForm/ContractPeriodForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractPeriodForm_ContractPeriodFormvue_type_script_lang_ts_external = (ContractPeriodFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractPeriodForm/ContractPeriodForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractPeriodForm_ContractPeriodFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractPeriodForm_ContractPeriodForm = (component.exports);

/***/ }),

/***/ 70217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ 70219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_AccountsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AccountsView.vue?vue&type=template&id=5ca16d84
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AccountList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/AccountList/AccountList.vue + 3 modules
var AccountList = __webpack_require__(63384);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AccountsView.vue?vue&type=script&lang=ts



var AccountsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AccountsView, _super);
    function AccountsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AccountList: AccountList/* default */.A
            }
        })
    ], AccountsView);
    return AccountsView;
}(lib/* Vue */.lD));
/* harmony default export */ var AccountsViewvue_type_script_lang_ts = (AccountsView);

;// ./src/views/AccountsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_AccountsViewvue_type_script_lang_ts = (AccountsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/AccountsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_AccountsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_AccountsView = (component.exports);

/***/ }),

/***/ 70468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);


var SalesDocumentStatus = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__extends */ .C6)(SalesDocumentStatus, _super);
    function SalesDocumentStatus() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.quotationStatus = [
            { id: 1, label: 'Brouillon' },
            { id: 2, label: 'Validé' },
            { id: 3, label: 'Envoyé' },
            { id: 4, label: 'Accepté' },
            { id: 5, label: 'Acompte facturé' },
            { id: 6, label: 'Facturé partiellement' },
            { id: 7, label: 'Facturé' },
            { id: 8, label: 'Refusé' },
            { id: 9, label: 'Annulé' }
        ];
        _this.commandStatus = [
            { id: 1, label: 'Brouillon' },
            { id: 2, label: 'Validé' },
            { id: 3, label: 'Envoyé' },
            { id: 4, label: 'Accepté' },
            { id: 5, label: 'Acompte facturé' },
            { id: 6, label: 'Facturé partiellement' },
            { id: 7, label: 'Facturé' },
            { id: 8, label: 'Refusé' },
            { id: 9, label: 'Annulé' }
        ];
        _this.proformaStatus = [
            { id: 1, label: 'Brouillon' },
            { id: 2, label: 'Validée' },
            { id: 3, label: 'Envoyée' },
            { id: 4, label: 'Acceptée' },
            { id: 5, label: 'Facturée partiellement' },
            { id: 6, label: 'Facturée' },
            { id: 7, label: 'Refusée' },
            { id: 8, label: 'Annulée' }
        ];
        _this.deliveryStatus = [
            { id: 1, label: 'Brouillon' },
            { id: 2, label: 'Validé' },
            { id: 3, label: 'À envoyer' },
            { id: 4, label: 'Envoyé' }
        ];
        _this.invoiceStatus = [
            { id: 1, label: 'Brouillon' },
            { id: 2, label: 'Validée' },
            { id: 3, label: 'Envoyée / En attente de paiement' },
            { id: 4, label: 'Payées partiellement' },
            { id: 5, label: 'Payée' },
            { id: 6, label: 'En recouvrement' },
            { id: 7, label: 'Annulée' }
        ];
        _this.creditStatus = [
            { id: 1, label: 'Brouillon' },
            { id: 2, label: 'Validé' },
            { id: 3, label: 'Envoyé' },
            { id: 4, label: 'Utilisé partiellement' },
            { id: 5, label: 'Utilisé' }
        ];
        return _this;
    }
    SalesDocumentStatus = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], SalesDocumentStatus);
    return SalesDocumentStatus;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (SalesDocumentStatus);


/***/ }),

/***/ 70695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(78096),
    isArguments = __webpack_require__(72428),
    isArray = __webpack_require__(56449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(30361),
    isTypedArray = __webpack_require__(37167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 71183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarDelete_CarDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarDelete/CarDelete.vue?vue&type=template&id=3cdce71f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce véhicule ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarDelete/CarDelete.ts?vue&type=script&lang=ts&external




var CarDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarDelete, _super);
    function CarDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(CarDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    CarDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CarDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CarDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/automotive/car/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    CarDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
        this.modalState = false;
    };
    CarDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CarDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('CarFormDeleted', this.value);
        this.$emit('deleted', this.value);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CarDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], CarDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CarDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CarDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CarDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CarDelete.prototype, "watchModalState", null);
    CarDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CarDelete);
    return CarDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CarDeletevue_type_script_lang_ts_external = (CarDelete);

;// ./src/components/CarDelete/CarDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarDelete_CarDeletevue_type_script_lang_ts_external = (CarDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarDelete/CarDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarDelete_CarDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarDelete_CarDelete = (component.exports);

/***/ }),

/***/ 71961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(49653);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 72264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ 72428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(27534),
    isObjectLike = __webpack_require__(40346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 72475:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ 72552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(51873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(59350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 72706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionList/CommissionList.vue?vue&type=template&id=65c7e25a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"datas":{ include: ['team_users', 'origins', 'salesCategories', 'steps'] },"columns":_vm.columns,"createTitle":"Création d'une commission","updateTitle":"Modification d'une commission","deleteMsg":"Êtes-vous sûr de vouloir supprimer cette commission ?","sort":"name","customForm":_vm.formComponent,"modalSize":"xl"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/CommissionForm/CommissionForm.vue + 3 modules
var CommissionForm = __webpack_require__(83793);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionList/CommissionList.ts?vue&type=script&lang=ts&external




var GrantList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GrantList, _super);
    function GrantList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = CommissionForm/* default */.A;
        return _this;
    }
    Object.defineProperty(GrantList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: 'Nom de la commission',
                    key: 'name',
                    required: true
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GrantList.prototype, "apiUrl", {
        get: function () {
            return '/sales/commission';
        },
        enumerable: false,
        configurable: true
    });
    GrantList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], GrantList);
    return GrantList;
}(lib/* Vue */.lD));
/* harmony default export */ var CommissionListvue_type_script_lang_ts_external = (GrantList);

;// ./src/components/CommissionList/CommissionList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionList_CommissionListvue_type_script_lang_ts_external = (CommissionListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionList/CommissionList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionList_CommissionListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionList = (component.exports);

/***/ }),

/***/ 72740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentForm/DocumentForm.vue?vue&type=template&id=10a3f0b8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.document !== undefined)?_c('div',[(_vm.loading)?_c('Spinner'):[_c('PageHeader',{attrs:{"pageTitle":_vm.$t('sales.form.' + (_vm.document.id ? 'edit' : 'new') + 'PageTitle.' + _vm.type)}}),_c('AppMessages'),(_vm.errors !== null)?_c('b-alert',{ref:"errors",attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.errors)+" ")]):_vm._e(),(_vm.loaded)?_c('k-form',{ref:"form",staticClass:"sales-form",attrs:{"action":_vm.formUrl,"method":_vm.formMethod,"validateDatas":_vm.validateDatas,"beforeSubmit":() => { _vm.forceEditing = [] },"parent":"#page"},on:{"submitComplete":_vm.submitComplete,"submitError":_vm.submitError}},[_c('b-row',{staticClass:"sale-form-top"},[_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('tabs',{staticClass:"tabs-card"},[_c('tab',{attrs:{"title":_vm.$t('sales.form.titleCustomer')}},[_c('CustomerDatas',{attrs:{"type":_vm.type},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}})],1)],1)],1),_c('b-col',{staticClass:"mt-3 mt-lg-0",attrs:{"cols":"12","lg":"8"}},[_c('tabs',{staticClass:"tabs-card",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('tab',{attrs:{"title":_vm.$t('sales.form.titleDocument.' + _vm.type)}},[_c('DocumentDatas',{attrs:{"type":_vm.type},on:{"showDeadlines":function($event){_vm.activeTab = 2}},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}})],1),_c('tab',{attrs:{"title":"Paramètres"}},[_c('Parameters',{attrs:{"type":_vm.type},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}})],1),(_vm.document.payment_term?.with_deadlines && _vm.type !== 'credit' && _vm.type !== 'delivery')?_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Échéances "),_c('b-badge',{staticClass:"ml-2",attrs:{"variant":"secondary"}},[_vm._v(" "+_vm._s(_vm.document.deadlines.length)+" ")])]},proxy:true}],null,false,1678365069)},[_c('Deadlines',{attrs:{"type":_vm.type},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}})],1):_vm._e()],1)],1)],1),_c('DocumentContents',{attrs:{"type":_vm.type,"forceEditing":_vm.forceEditing},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}}),_c('FormSidebar',{attrs:{"type":_vm.type},on:{"submit":_vm.submitForm},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}}),_c('ConflictModal',{attrs:{"type":_vm.type,"lastVersion":_vm.lastDocumentVersion},on:{"submit":_vm.submitForm}}),(_vm.document.opportunity_id)?_c('input',{attrs:{"name":"opportunity","type":"hidden"},domProps:{"value":_vm.document.opportunity_id}}):_vm._e(),(_vm.document.construction_id)?_c('input',{attrs:{"name":"construction","type":"hidden"},domProps:{"value":_vm.document.construction_id}}):_vm._e(),_c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close')},model:{value:(_vm.contentIsEmpty),callback:function ($$v) {_vm.contentIsEmpty=$$v},expression:"contentIsEmpty"}},[_vm._v(" Vous devez ajouter au moins une ligne au document ")])],1):_vm._e()],(_vm.showWelcome)?_c('WelcomeModal'):_vm._e()],2):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(6924);
var mergeWith_default = /*#__PURE__*/__webpack_require__.n(mergeWith);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/components/Form/CustomerDatas/CustomerDatas.vue + 3 modules
var CustomerDatas = __webpack_require__(32475);
// EXTERNAL MODULE: ./src/components/Form/DocumentDatas/DocumentDatas.vue + 3 modules
var DocumentDatas = __webpack_require__(11466);
// EXTERNAL MODULE: ./src/components/Form/FormSidebar/FormSidebar.vue + 3 modules
var FormSidebar = __webpack_require__(61860);
// EXTERNAL MODULE: ./src/components/Form/DocumentContents/DocumentContents.vue + 4 modules
var DocumentContents = __webpack_require__(53254);
// EXTERNAL MODULE: ./src/components/Form/ConflictModal/ConflictModal.vue + 3 modules
var ConflictModal = __webpack_require__(66597);
// EXTERNAL MODULE: ./src/components/Form/Parameters/Parameters.vue + 3 modules
var Parameters = __webpack_require__(583);
// EXTERNAL MODULE: ./src/components/Form/Deadlines/Deadlines.vue + 3 modules
var Deadlines = __webpack_require__(72943);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Welcome/WelcomeModal/WelcomeModal.vue?vue&type=template&id=abcd983e
var WelcomeModalvue_type_template_id_abcd983e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"size":"sales-welcome","body-class":"pb-3","scrollable":""},scopedSlots:_vm._u([{key:"modal-footer",fn:function(){return [_c('b-row',{staticClass:"w-100",attrs:{"align-v":"center"}},[_c('b-col',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.disableWelcome.apply(null, arguments)}}},[_vm._v(" Plus tard ")])],1),_c('b-col',{staticClass:"text-center"},_vm._l((_vm.totalStep),function(step){return _c('font-awesome-icon',{key:step,class:{ 'mr-1 btn-step-action': true, active: step === _vm.activeStep },attrs:{"icon":[step === _vm.activeStep ? 'fas' : 'far', 'circle']},on:{"click":function($event){$event.preventDefault();_vm.activeStep = step}}})}),1),_c('b-col',{staticClass:"text-right"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.nextStep.apply(null, arguments)}}},[(_vm.activeStep === _vm.totalStep)?[_vm._v(" Terminé ")]:[_vm._v(" Suivant ")]],2)],1)],1)]},proxy:true}]),model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('keep-alive',[(_vm.activeStep === 1)?_c('DocumentReferences',{ref:"step1",on:{"next":_vm.next}}):_vm._e()],1),_c('keep-alive',[(_vm.activeStep === 2)?_c('PdfModel',{ref:"step2",on:{"next":_vm.next}}):_vm._e()],1),_c('keep-alive',[(_vm.activeStep === 3)?_c('PdfModelLogo',{ref:"step3",on:{"next":_vm.next}}):_vm._e()],1),_c('keep-alive',[(_vm.activeStep === 4)?_c('VatRate',{ref:"step4",on:{"next":_vm.next}}):_vm._e()],1)],1)
}
var WelcomeModalvue_type_template_id_abcd983e_staticRenderFns = []


// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Welcome/DocumentReferences/DocumentReferences.vue?vue&type=template&id=76442ffd
var DocumentReferencesvue_type_template_id_76442ffd_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sales_welcome"},[_c('h5',{staticClass:"text-center mb-4"},[_vm._v(" Numérotation des documents (devis, factures...) ")]),_c('b-form-radio-group',{attrs:{"options":_vm.customizeOptions,"buttons":"","button-variant":"primary"},model:{value:(_vm.customize),callback:function ($$v) {_vm.customize=$$v},expression:"customize"}}),(_vm.customize === 0)?[_c('table',{staticClass:"mx-auto mt-4 text-left",attrs:{"cellpadding":"5"}},[_c('tbody',[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Devis : ")]),_c('td',[_vm._v(_vm._s(_vm.generateReferenceExample('quotation')))])]),(_vm.hasModule('sales-commands'))?_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Bons de commande : ")]),_c('td',[_vm._v(_vm._s(_vm.generateReferenceExample('command')))])]):_vm._e(),(_vm.hasModule('sales-deliveries'))?_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Bons de livraison : ")]),_c('td',[_vm._v(_vm._s(_vm.generateReferenceExample('delivery')))])]):_vm._e(),(_vm.hasModule('sales-proformas'))?_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Factures proforma : ")]),_c('td',[_vm._v(_vm._s(_vm.generateReferenceExample('proforma')))])]):_vm._e(),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Factures : ")]),_c('td',[_vm._v(_vm._s(_vm.generateReferenceExample('invoice')))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Avoirs : ")]),_c('td',[_vm._v(_vm._s(_vm.generateReferenceExample('credit')))])])])])]:(_vm.customize === 1)?_c('k-form',{ref:"form",attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.submitComplete}},[_c('b-tabs',{staticClass:"mt-4",attrs:{"align":"center","content-class":"pt-4"}},[_c('b-tab',{attrs:{"title":"Devis"}},[_c('DocumentReference',{attrs:{"type":"quotation"}})],1),(_vm.hasModule('sales-commands'))?_c('b-tab',{attrs:{"title":"Bons de commande"}},[_c('DocumentReference',{attrs:{"type":"command"}})],1):_vm._e(),(_vm.hasModule('sales-deliveries'))?_c('b-tab',{attrs:{"title":"Bons de livraison"}},[_c('DocumentReference',{attrs:{"type":"delivery"}})],1):_vm._e(),(_vm.hasModule('sales-proformas'))?_c('b-tab',{attrs:{"title":"Factures proforma"}},[_c('DocumentReference',{attrs:{"type":"proforma"}})],1):_vm._e(),_c('b-tab',{attrs:{"title":"Factures"}},[_c('DocumentReference',{attrs:{"type":"invoice"}})],1),_c('b-tab',{attrs:{"title":"Avoirs"}},[_c('DocumentReference',{attrs:{"type":"credit"}})],1)],1)],1):_vm._e()],2)
}
var DocumentReferencesvue_type_template_id_76442ffd_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Welcome/DocumentReferences/DocumentReference.vue?vue&type=template&id=5d245301
var DocumentReferencevue_type_template_id_5d245301_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{attrs:{"type":"hidden","name":'configs[sales_' + _vm.type + '_reference_prefix]'},domProps:{"value":_vm.reference !== '' ? _vm.reference : _vm.prefix}}),_c('input',{attrs:{"type":"hidden","name":'configs[sales_' + _vm.type + '_reference_mode]'},domProps:{"value":_vm.referenceType}}),_c('input',{attrs:{"type":"hidden","name":'configs[sales_' + _vm.type + '_reference_number]'},domProps:{"value":_vm.nextNumber}}),_c('input',{attrs:{"type":"hidden","name":'configs[sales_' + _vm.type + '_reference_length]'},domProps:{"value":_vm.length}}),_c('b-form-group',{staticClass:"big-label",attrs:{"label":'Je remets à 0 la numérotation de mes ' + _vm.$t('sales.' + _vm.type + '.label')}},[_c('b-form-radio-group',{attrs:{"options":_vm.referenceTypes,"buttons":"","button-variant":"primary"},model:{value:(_vm.referenceType),callback:function ($$v) {_vm.referenceType=$$v},expression:"referenceType"}})],1),(_vm.referenceType !== null)?[(_vm.referenceType === 1)?_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Prochain numéro","label-class":"mb-1"}},[_c('div',{staticClass:"d-inline-block"},[_c('k-form-spinner',{attrs:{"vertical":false,"min":1},model:{value:(_vm.nextNumber),callback:function ($$v) {_vm.nextNumber=$$v},expression:"nextNumber"}})],1)]):_vm._e(),_c('b-form-group',{staticClass:"big-label mt-5",attrs:{"label":"Ma numérotation"}},[_c('b-form-radio-group',{attrs:{"buttons":"","button-variant":"primary","options":_vm.referenceExamples},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1),(_vm.reference === '')?_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mt-5",attrs:{"label":"Préfixe"}},[_c('k-form-input',{attrs:{"required":""},model:{value:(_vm.prefix),callback:function ($$v) {_vm.prefix=$$v},expression:"prefix"}})],1),_c('p',{staticClass:"mb-0 small text-left"},[_c('strong',[_vm._v("Variables :")]),_c('br'),_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.prefix = _vm.prefix + '{YY}'}}},[_vm._v(" {YY} ")]),_vm._v(" : l'année sur 4 chiffres"),_c('br'),_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.prefix = _vm.prefix + '{Y}'}}},[_vm._v(" {Y} ")]),_vm._v(" : l'année sur 2 chiffres"),_c('br'),_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.prefix = _vm.prefix + '{m}'}}},[_vm._v(" {m} ")]),_vm._v(" : le mois"),_c('br'),_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.prefix = _vm.prefix + '{d}'}}},[_vm._v(" {d} ")]),_vm._v(" : le jour"),_c('br')],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mt-5",attrs:{"label":"Nombre de chiffre"}},[_c('k-form-spinner',{attrs:{"required":"","min":1,"max":10},model:{value:(_vm.length),callback:function ($$v) {_vm.length=$$v},expression:"length"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mt-5",attrs:{"label":"Exemple","label-class":"mb-2"}},[_vm._v(" "+_vm._s(_vm.example(_vm.prefix, _vm.length))+" ")])],1)],1):_vm._e()]:_vm._e()],2)
}
var DocumentReferencevue_type_template_id_5d245301_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Welcome/DocumentReferences/DocumentReference.ts?vue&type=script&lang=ts&external






var DocumentReference = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentReference, _super);
    function DocumentReference() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.referenceType = 1;
        _this.nextNumber = 1;
        _this.reference = '';
        _this.length = 5;
        _this.prefix = '';
        _this.referenceTypes = [
            { text: 'Jamais', value: 1 },
            { text: 'Tous les mois', value: 2 },
            { text: 'Tous les ans', value: 3 }
        ];
        return _this;
    }
    DocumentReference.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.referenceType = this.localConfig['sales_' + this.type + '_reference_mode'];
                this.nextNumber = this.localConfig['sales_' + this.type + '_reference_number'];
                this.length = this.localConfig['sales_' + this.type + '_reference_length'];
                this.reference = this.localConfig['sales_' + this.type + '_reference_prefix'];
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(DocumentReference.prototype, "prefix1", {
        get: function () {
            switch (this.type) {
                case 'quotation':
                    return 'D';
                case 'command':
                    return 'C';
                case 'delivery':
                    return 'B';
                case 'proforma':
                    return 'P';
                case 'invoice':
                    return 'F';
                case 'credit':
                    return 'A';
                default:
                    return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "prefix2", {
        get: function () {
            switch (this.type) {
                case 'quotation':
                    return 'DEV';
                case 'command':
                    return 'CMD';
                case 'delivery':
                    return 'BL';
                case 'proforma':
                    return 'PRO';
                case 'invoice':
                    return 'FA';
                case 'credit':
                    return 'AV';
                default:
                    return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "referenceExamples", {
        get: function () {
            var options = [
                { text: this.example(this.prefix1 + '{Y}{m}-', 4), value: this.prefix1 + '{Y}{m}-' },
                { text: this.example(this.prefix1 + '{Y}{m}', 4), value: this.prefix1 + '{Y}{m}' },
                { text: this.example(this.prefix1 + '-{Y}{m}', 4), value: this.prefix1 + '-{Y}{m}' },
                { text: 'Personnalisée', value: '' }
            ];
            if (this.referenceType === 1) {
                options.unshift.apply(options, [
                    { text: this.example(this.prefix2, 4), value: this.prefix2 },
                    { text: this.example(this.prefix1, 4), value: this.prefix1 }
                ]);
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    DocumentReference.prototype.watchReference = function () {
        if (this.reference === '') {
            this.prefix = this.referenceExamples[0].value;
        }
    };
    DocumentReference.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    Object.defineProperty(DocumentReference.prototype, "example", {
        get: function () {
            var _this = this;
            return function (prefix, length) {
                if (!prefix) {
                    return null;
                }
                var example = _this.pad(_this.referenceType === 1 ? _this.nextNumber : 1, length);
                var date = new Date();
                prefix = prefix.replace('{YY}', String(date.getFullYear()))
                    .replace('{Y}', String(date.getFullYear()).substr(2, 2))
                    .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
                    .replace('{d}', String(('0' + date.getDate()).slice(-2)));
                return prefix + example;
            };
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentReference.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('reference')
    ], DocumentReference.prototype, "watchReference", null);
    DocumentReference = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BButton: external_bootstrap_vue_.BButton,
                KFormSpinner: form_vue_.KFormSpinner, KFormInput: form_vue_.KFormInput
            }
        })
    ], DocumentReference);
    return DocumentReference;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var DocumentReferencevue_type_script_lang_ts_external = (DocumentReference);

;// ./src/components/Welcome/DocumentReferences/DocumentReference.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentReferences_DocumentReferencevue_type_script_lang_ts_external = (DocumentReferencevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Welcome/DocumentReferences/DocumentReference.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentReferences_DocumentReferencevue_type_script_lang_ts_external,
  DocumentReferencevue_type_template_id_5d245301_render,
  DocumentReferencevue_type_template_id_5d245301_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentReferences_DocumentReference = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Welcome/DocumentReferences/DocumentReferences.ts?vue&type=script&lang=ts&external







var DocumentReferences = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentReferences, _super);
    function DocumentReferences() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customize = 0;
        _this.customizeOptions = [
            { text: 'Personnaliser la numérotation', value: 1 },
            { text: 'Utiliser la configuration par défaut', value: 0 }
        ];
        return _this;
    }
    DocumentReferences.prototype.submit = function () {
        if (this.customize === 0) {
            this.$emit('next');
        }
        else {
            this.$refs.form.submit();
        }
    };
    DocumentReferences.prototype.submitComplete = function (response) {
        this.formSubmitted(response);
        this.$emit('next');
    };
    DocumentReferences.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    DocumentReferences.prototype.generateReferenceExample = function (type) {
        var prefix = this.localConfig['sales_' + type + '_reference_prefix'];
        var number = this.localConfig['sales_' + type + '_reference_number'];
        var length = this.localConfig['sales_' + type + '_reference_length'];
        if (!prefix) {
            return null;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    DocumentReferences = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                DocumentReference: DocumentReferences_DocumentReference,
                KForm: form_vue_.KForm
            }
        })
    ], DocumentReferences);
    return DocumentReferences;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var DocumentReferencesvue_type_script_lang_ts_external = (DocumentReferences);

;// ./src/components/Welcome/DocumentReferences/DocumentReferences.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentReferences_DocumentReferencesvue_type_script_lang_ts_external = (DocumentReferencesvue_type_script_lang_ts_external); 
;// ./src/components/Welcome/DocumentReferences/DocumentReferences.vue





/* normalize component */
;
var DocumentReferences_component = (0,componentNormalizer/* default */.A)(
  DocumentReferences_DocumentReferencesvue_type_script_lang_ts_external,
  DocumentReferencesvue_type_template_id_76442ffd_render,
  DocumentReferencesvue_type_template_id_76442ffd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentReferences_DocumentReferences = (DocumentReferences_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Welcome/PdfModel/PdfModel.vue?vue&type=template&id=c7771ff0
var PdfModelvue_type_template_id_c7771ff0_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sales-welcome-pdf"},[_c('h5',{staticClass:"text-center mb-4"},[_vm._v(" Sélection du modèle PDF ")]),_c('p',{staticClass:"text-center"},[_vm._v(" Vous pouvez sélectionner un modèle PDF pré-configuré ci-dessous."),_c('br'),_vm._v(" Par la suite, il reste possible de créer un modèle PDF personnalisé depuis l'"),_c('router-link',{attrs:{"to":{ name: 'pdf-models' },"target":"_blank"}},[_vm._v("espace configuration")]),_vm._v(". ")],1),_c('k-form',{ref:"form",attrs:{"action":"/welcome/pdf-model","method":"post"},on:{"submitComplete":function($event){return _vm.$emit('next')}}},[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.pdfModels && _vm.pdfModels[_vm.selected] ? _vm.pdfModels[_vm.selected].id : null}}),(!_vm.pdfModels)?_c('Spinner'):_c('div',[_c('b-row',{staticClass:"pdf-selection",attrs:{"align-h":"center"}},[_vm._l((_vm.pdfModels),function(model,i){return _c('b-col',{key:i,class:{ 'mt-3':true, 'active': _vm.selected === i, 'pdf-model': true },attrs:{"cols":"2"}},[_c('img',{staticClass:"w-100 border",attrs:{"src":'data:image/png;base64,' + model.image},on:{"click":function($event){$event.preventDefault();_vm.selected = i}}}),(_vm.selected === i)?_c('div',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check-circle']}})],1):_vm._e()])}),_c('b-col',{staticClass:"mt-2",attrs:{"cols":"8"}},[_c('img',{staticClass:"w-100 border",attrs:{"src":'data:image/png;base64,' + _vm.pdfModels[_vm.selected].image}})])],2)],1)],1)],1)
}
var PdfModelvue_type_template_id_c7771ff0_staticRenderFns = []


// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Welcome/PdfModel/PdfModel.ts?vue&type=script&lang=ts&external







var PdfModel = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModel, _super);
    function PdfModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pdfModels = null;
        _this.selected = 0;
        return _this;
    }
    PdfModel.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPdfModels()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PdfModel.prototype, "computedSelected", {
        get: function () {
            return this.selected + 1;
        },
        enumerable: false,
        configurable: true
    });
    PdfModel.prototype.submit = function () {
        if (this.selected === 0) {
            this.$emit('next');
        }
        else {
            this.$refs['form'].submit();
        }
    };
    PdfModel.prototype.loadPdfModels = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwSales.axios.get('/sales/pdf_model/models')
                            .then(function (response) {
                            _this.pdfModels = response.data;
                        })
                            .catch(function (error) {
                            throw new Error(error);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfModel = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm,
                BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: interface_vue_.Spinner
            }
        })
    ], PdfModel);
    return PdfModel;
}((external_vue_default())));
/* harmony default export */ var PdfModelvue_type_script_lang_ts_external = (PdfModel);

;// ./src/components/Welcome/PdfModel/PdfModel.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModel_PdfModelvue_type_script_lang_ts_external = (PdfModelvue_type_script_lang_ts_external); 
;// ./src/components/Welcome/PdfModel/PdfModel.vue





/* normalize component */
;
var PdfModel_component = (0,componentNormalizer/* default */.A)(
  PdfModel_PdfModelvue_type_script_lang_ts_external,
  PdfModelvue_type_template_id_c7771ff0_render,
  PdfModelvue_type_template_id_c7771ff0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModel_PdfModel = (PdfModel_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Welcome/PdfModelLogo/PdfModelLogo.vue?vue&type=template&id=49252c3c
var PdfModelLogovue_type_template_id_49252c3c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h5',{staticClass:"text-center mb-4"},[_vm._v(" Ajoutez votre logo sur vos PDF ")]),_c('div',{staticClass:"text-center"},[_c('k-form-file',{attrs:{"url":"/welcome/pdf-model-logo?with_file=1","name":"logo","accept":['image/png', 'image/jpeg'],"imagePreview":"","removeUploadedFile":"","btnMode":"","btnLabel":_vm.logo ? 'Modifier le logo' : 'Sélectionner un fichier'},on:{"onUpload":_vm.logoUpdated}}),(_vm.logo)?_c('img',{staticClass:"mt-4 w-auto",staticStyle:{"max-width":"100%"},attrs:{"src":'data:image/png;base64,' + _vm.logo.file}}):_vm._e()],1)])
}
var PdfModelLogovue_type_template_id_49252c3c_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Welcome/PdfModelLogo/PdfModelLogo.ts?vue&type=script&lang=ts&external



var PdfModelLogo = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelLogo, _super);
    function PdfModelLogo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logo = null;
        return _this;
    }
    PdfModelLogo.prototype.logoUpdated = function (response) {
        this.logo = response;
        this.$emit('next');
    };
    PdfModelLogo = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormFile: form_vue_.KFormFile
            }
        })
    ], PdfModelLogo);
    return PdfModelLogo;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelLogovue_type_script_lang_ts_external = (PdfModelLogo);

;// ./src/components/Welcome/PdfModelLogo/PdfModelLogo.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelLogo_PdfModelLogovue_type_script_lang_ts_external = (PdfModelLogovue_type_script_lang_ts_external); 
;// ./src/components/Welcome/PdfModelLogo/PdfModelLogo.vue





/* normalize component */
;
var PdfModelLogo_component = (0,componentNormalizer/* default */.A)(
  PdfModelLogo_PdfModelLogovue_type_script_lang_ts_external,
  PdfModelLogovue_type_template_id_49252c3c_render,
  PdfModelLogovue_type_template_id_49252c3c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelLogo_PdfModelLogo = (PdfModelLogo_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Welcome/VatRate/VatRate.vue?vue&type=template&id=0e19b90a
var VatRatevue_type_template_id_0e19b90a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sales-welcome-vatrates"},[_c('h5',{staticClass:"mb-4"},[_vm._v(" Taux de TVA ")]),_c('k-form',{ref:"form",attrs:{"action":"/welcome/vatrate","value":_vm.formDatas},on:{"submitComplete":function($event){return _vm.$emit('next')}}},[_c('b-form-group',{staticClass:"d-inline-flex",attrs:{"label":"Êtes-vous soumis à la TVA :","label-cols":"auto"}},[_c('b-form-radio-group',{staticClass:"mt-1",attrs:{"options":[
          { value: true, text: 'Oui' },
          { value: false, text: 'Non' }
        ],"buttons":"","button-variant":"outline-primary","size":"sm"},model:{value:(_vm.useVatRate),callback:function ($$v) {_vm.useVatRate=$$v},expression:"useVatRate"}})],1),(!_vm.useVatRate)?_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Texte de loi à afficher sur les PDF :"}},[_c('b-form-row',[_c('b-col',[_c('k-form-select',{staticClass:"d-inline-block",staticStyle:{"width":"350px"},attrs:{"options":_vm.vatRateLaws,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.vatRateLaw),callback:function ($$v) {_vm.vatRateLaw=$$v},expression:"vatRateLaw"}})],1),(_vm.vatRateLaw === false)?_c('b-col',[_c('k-form-input',{attrs:{"placeholder":"Texte de loi personnalisé","required":""},model:{value:(_vm.vatRateLawCustom),callback:function ($$v) {_vm.vatRateLawCustom=$$v},expression:"vatRateLawCustom"}})],1):_vm._e()],1)],1):[_c('h4',{staticClass:"form-title-alt mt-4"},[_vm._v("Mes taux de TVA")]),(_vm.loading)?_c('Spinner'):[_c('table',{staticClass:"table table-sm my-vatrates align-middle"},[_c('tbody',_vm._l((_vm.localVatRates),function(rate,i){return _c('tr',{key:i},[_c('td',[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{attrs:{"min":0,"size":"sm","required":""},model:{value:(_vm.localVatRates[i]),callback:function ($$v) {_vm.$set(_vm.localVatRates, i, $$v)},expression:"localVatRates[i]"}})],1)],1),_c('td',[_c('b-form-radio',{class:{
                  'text-muted': true,
                  'selected': i === _vm.defaultVatRate
                },attrs:{"name":"default_vatrate","size":"sm","value":i},model:{value:(_vm.defaultVatRate),callback:function ($$v) {_vm.defaultVatRate=$$v},expression:"defaultVatRate"}},[_vm._v(" Par défaut ")])],1),_c('td',[(_vm.localVatRates.length > 1)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",modifiers:{"right":true}}],staticClass:"text-danger p-0",attrs:{"variant":"icon","title":"Supprimer le taux de TVA"},on:{"click":function($event){$event.preventDefault();return _vm.onDelete(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1):_vm._e()],1)])}),0)]),_c('b-button',{staticClass:"p-0 mt-2 mb-4",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.localVatRates.push(null)}}},[_vm._v(" Ajouter un taux de TVA ")])]]],2)],1)
}
var VatRatevue_type_template_id_0e19b90a_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Welcome/VatRate/VatRate.ts?vue&type=script&lang=ts&external







var WelcomeApp = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(WelcomeApp, _super);
    function WelcomeApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.useVatRate = true;
        _this.vatRateLaw = 1;
        _this.vatRateLawCustom = null;
        _this.localVatRates = [];
        _this.defaultVatRate = 0;
        _this.vatRateLaws = [
            { value: 1, label: 'TVA non applicable, article 293 B du CGI' },
            { value: 2, label: 'TVA non applicable, article 262 ter I du CGI' },
            { value: 3, label: 'TVA non applicable, article 259 A du CGI' },
            { value: 4, label: 'TVA non applicable, article 259 B du CGI' },
            { value: 5, label: 'TVA non applicable, article 261-7-1° -b du CGI' },
            { value: 6, label: 'TVA non applicable, article 261-1°-c° du CGI' },
            { value: false, label: 'Autre' }
        ];
        return _this;
    }
    WelcomeApp.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var rates, findIndex;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadVatRates()];
                    case 1:
                        _a.sent();
                        rates = [];
                        this.vatRates.forEach(function (rate) {
                            rates.push(rate.rate);
                        });
                        this.localVatRates = rates;
                        findIndex = this.vatRates.findIndex(function (rate) { return rate.use_default; });
                        if (findIndex >= 0) {
                            this.defaultVatRate = findIndex;
                        }
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(WelcomeApp.prototype, "formDatas", {
        get: function () {
            var _this = this;
            return {
                with_vatrate: this.useVatRate,
                legal_notice: this.vatRateLaw ? this.vatRateLaws[this.vatRateLaw].label : this.vatRateLawCustom,
                rates: this.localVatRates.map(function (rate, i) { return ({
                    rate: rate,
                    use_default: _this.defaultVatRate === i,
                }); })
            };
        },
        enumerable: false,
        configurable: true
    });
    WelcomeApp.prototype.submit = function () {
        this.$refs.form.submit();
    };
    WelcomeApp.prototype.onDelete = function (index) {
        this.localVatRates.splice(index, 1);
        if (this.defaultVatRate === index) {
            this.defaultVatRate = 0;
        }
    };
    WelcomeApp = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BInputGroup: external_bootstrap_vue_.BInputGroup, BButton: external_bootstrap_vue_.BButton,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormInput: form_vue_.KFormInput, KFormNumber: form_vue_.KFormNumber, BFormRadio: external_bootstrap_vue_.BFormRadio,
                Spinner: interface_vue_.Spinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['vatRates'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadVatRates'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], WelcomeApp);
    return WelcomeApp;
}(lib/* Vue */.lD));
/* harmony default export */ var VatRatevue_type_script_lang_ts_external = (WelcomeApp);

;// ./src/components/Welcome/VatRate/VatRate.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var VatRate_VatRatevue_type_script_lang_ts_external = (VatRatevue_type_script_lang_ts_external); 
;// ./src/components/Welcome/VatRate/VatRate.vue





/* normalize component */
;
var VatRate_component = (0,componentNormalizer/* default */.A)(
  VatRate_VatRatevue_type_script_lang_ts_external,
  VatRatevue_type_template_id_0e19b90a_render,
  VatRatevue_type_template_id_0e19b90a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VatRate = (VatRate_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Welcome/WelcomeModal/WelcomeModal.ts?vue&type=script&lang=ts&external









var WelcomeModal = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(WelcomeModal, _super);
    function WelcomeModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = true;
        _this.activeStep = 1;
        _this.totalStep = 4;
        return _this;
    }
    WelcomeModal.prototype.watchActiveStep = function () {
        this.$kwSales.axios.post('/tracking', {
            type: 'modal',
            name: 'sales-welcome',
            path: this.activeStep,
        });
    };
    WelcomeModal.prototype.nextStep = function () {
        var component = this.$refs['step' + this.activeStep];
        if (component && 'submit' in component && typeof component.submit === 'function') {
            component.submit();
        }
        else {
            this.next();
        }
    };
    WelcomeModal.prototype.next = function () {
        if (this.activeStep === this.totalStep) {
            this.modalState = false;
            return;
        }
        this.activeStep++;
    };
    WelcomeModal.prototype.disableWelcome = function () {
        var _this = this;
        this.modalState = false;
        this.$kwSales.axios.put('/team', {
            configs: {
                sales_welcome: 0
            }
        })
            .then(function (response) {
            _this.formSubmitted(response);
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('activeStep')
    ], WelcomeModal.prototype, "watchActiveStep", null);
    WelcomeModal = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                DocumentReferences: DocumentReferences_DocumentReferences, PdfModel: PdfModel_PdfModel, PdfModelLogo: PdfModelLogo_PdfModelLogo, VatRate: VatRate,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], WelcomeModal);
    return WelcomeModal;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamFormMixin)));
/* harmony default export */ var WelcomeModalvue_type_script_lang_ts_external = (WelcomeModal);

;// ./src/components/Welcome/WelcomeModal/WelcomeModal.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var WelcomeModal_WelcomeModalvue_type_script_lang_ts_external = (WelcomeModalvue_type_script_lang_ts_external); 
;// ./src/components/Welcome/WelcomeModal/WelcomeModal.vue





/* normalize component */
;
var WelcomeModal_component = (0,componentNormalizer/* default */.A)(
  WelcomeModal_WelcomeModalvue_type_script_lang_ts_external,
  WelcomeModalvue_type_template_id_abcd983e_render,
  WelcomeModalvue_type_template_id_abcd983e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var WelcomeModal_WelcomeModal = (WelcomeModal_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentForm/DocumentForm.ts?vue&type=script&lang=ts&external


















var SalesForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SalesForm, _super);
    function SalesForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = false;
        _this.loading = false;
        _this.submitMode = 1;
        _this.lastDocumentVersion = null;
        _this.forceEditing = [];
        _this.contentIsEmpty = false;
        _this.showWelcome = false;
        _this.activeTab = 0;
        _this.errors = null;
        _this.document = {
            contact: null,
            billing_contact: null,
            customer: null,
            customer_child: null,
            reference: null,
            billing_address: {},
            delivery_address: {},
            input_options: {},
            pdf_options: {},
            contents: [],
            payment_methods: [],
            total_ht: 0,
            total_tva: 0,
            total_ttc: 0,
            grant: null,
            car: null
        };
        return _this;
    }
    SalesForm.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadVatRates()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadPaymentTerms()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadPdfModels()];
                    case 3:
                        _a.sent();
                        this.loading = false;
                        this.watchValue(this.value);
                        return [2 /*return*/];
                }
            });
        });
    };
    SalesForm.prototype.mounted = function () {
        this.showWelcome = this.teamConfigs.sales_welcome;
    };
    Object.defineProperty(SalesForm.prototype, "formMethod", {
        get: function () {
            return this.document.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesForm.prototype, "formUrl", {
        get: function () {
            var url = '/sales/' + this.type;
            if (this.document.id) {
                url += '/' + this.document.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    SalesForm.prototype.watchValue = function (document) {
        var _this = this;
        this.loaded = false;
        if (document && Object.keys(document).length > 10) {
            this.setLocalDocument(document);
        }
        else {
            this.setNewDocument();
            if (document && document.customer !== undefined) {
                if (document.customer !== undefined) {
                    this.$nextTick(function () {
                        _this.document.customer = document.customer;
                        if (document.contact !== undefined) {
                            _this.$nextTick(function () {
                                _this.document.contact = document.contact;
                            });
                        }
                    });
                }
                else if (document.contact !== undefined) {
                    this.$nextTick(function () {
                        _this.document.contact = document.contact;
                    });
                }
                if (document.opportunity_id) {
                    this.document.opportunity_id = document.opportunity_id;
                }
            }
        }
        this.loaded = true;
    };
    SalesForm.prototype.setLocalDocument = function (document) {
        this.document = document;
        if (this.document.id === null) {
            if (this.document.penalty_rate === null) {
                delete this.document.penalty_rate;
            }
            if (this.document.penalty_rate_law === null) {
                delete this.document.penalty_rate_law;
            }
            var base = this.baseDocument();
            this.document = this.applyDefaultValues(Object.assign(base, this.document, {
                input_options: Object.assign(base.input_options, this.document.input_options),
                pdf_options: Object.assign(base.pdf_options, this.document.pdf_options)
            }));
            this.document.is_clone = true;
        }
        if (!this.document.deadlines) {
            external_vue_default().set(this.document, 'deadlines', []);
        }
    };
    SalesForm.prototype.setNewDocument = function () {
        this.document = this.applyDefaultValues(this.baseDocument());
    };
    SalesForm.prototype.baseDocument = function () {
        var _a, _b;
        var config = this.teamConfigs;
        return {
            is_draft: true,
            customer: null,
            customer_child: null,
            contact: null,
            billing_contact: null,
            billing_address: {},
            delivery_address: {},
            customer_vatrate: null,
            title: null,
            date: null,
            expire_at: null,
            reference: null,
            secondary_quantity: 1,
            secondary_unit: null,
            tags: [],
            pdf_model: this.defaultPdfModel(this.type),
            team_user: JSON.parse(JSON.stringify(this.teamUser)),
            customer_command_reference: null,
            comments: null,
            vat_rate: this.defaultVatRate ? JSON.parse(JSON.stringify(this.defaultVatRate)) : null,
            global_discount_value: 0,
            global_discount_type: 'pourcent',
            global_discount_type_amount: 'ht',
            total_ht: 0,
            total_tva: 0,
            total_ttc: 0,
            total_ecotax_ht: 0,
            total_ecotax_tva: 0,
            total_ecotax_ttc: 0,
            total_workforce: 0,
            total_costs: 0,
            total_charge: 0,
            gross_margin_amount: 0,
            gross_margin_rate: 0,
            markup_rate: 0,
            contents: [],
            vatrates: [],
            use_global_vatrate: config.sales_use_global_vatrate,
            secondary_quantity_mode: config.sales_secondary_quantity,
            input_mode: config.sales_amounts_type,
            currency: this.currency,
            custom_fields: [],
            not_show_prices: !config.sales_pdf_delivery_prices,
            show_remaining_quantity: config.sales_pdf_delivery_remaining_quantity,
            sale_term: config.sales_sale_term,
            payment_methods: config.sales_payment_methods,
            escompte_rate: config.sales_escompte_rate,
            penalty_rate: config.sales_penalty_rate,
            penalty_rate_law: config.sales_penalty_rate_law,
            collection_costs_law: config.sales_collection_costs_law,
            guarantee_holdback_pourcent: config.sales_guarantee_holdback_pourcent,
            guarantee_holdback_duration: config.sales_guarantee_holdback_duration,
            grant: null,
            car: null,
            deadlines: [],
            input_options: {
                allow_delivery_address: config.sales_allow_delivery_address,
                allow_options: config.sales_allow_options,
                ean: config.sales_ean,
                weight: config.sales_weight,
                eco_participation: config.sales_eco_participation,
                col_number: config.sales_col_number,
                col_reference: config.sales_col_reference,
                col_picture: config.sales_col_picture,
                col_unit: config.sales_col_unit,
                stock_display: config.sales_stock_display,
                stock_tracabilities: config.sales_stock_tracabilities,
                costs_entries: config.sales_costs_entries,
                various_costs: config.sales_various_costs,
                workforce_entries: config.sales_workforce_entries,
                gross_margin_amount: config.sales_gross_margin_amount,
                gross_margin_rate: config.sales_gross_margin_rate,
                markup_rate: config.sales_markup_rate,
                secondary_quantity_unit: config.sales_secondary_quantity_unit
            },
            pdf_options: {
                amounts: config.sales_pdf_amounts,
                discounts: config.sales_pdf_discounts,
                comments: config.sales_pdf_comments,
                units: config.sales_pdf_units,
                pictures: config.sales_pdf_pictures,
                number_column: config.sales_pdf_number_column,
                reference_column: config.sales_pdf_reference_column,
                ean_column: config.sales_pdf_ean_column,
                weight_column: config.sales_pdf_weight_column,
                vatrate_column: (_a = config.sales_pdf_vatrate_column) !== null && _a !== void 0 ? _a : 1,
                total_quantity: (_b = config.sales_pdf_total_quantity) !== null && _b !== void 0 ? _b : 1,
                situation_show_previous: config.sales_situation_show_previous,
                situation_show_totals: config.sales_situation_show_totals,
                situation_show_base_amount: config.sales_situation_show_base_amount,
                situation_show_pourcentage: config.sales_situation_show_pourcentage,
                contact: config.sales_pdf_contact,
                country: config.sales_pdf_country,
                vatrate_number: config.sales_pdf_vatrate_number,
                show_deadline_pourcent: true
            }
        };
    };
    SalesForm.prototype.getDefaultValues = function () {
        var config = this.teamConfigs;
        var date = external_moment_default()();
        if (this.type === 'invoice' || this.type === 'credit') {
            var lastDate = this.team.sales[this.type + '_date'];
            if (lastDate && date.isBefore(lastDate)) {
                date = external_moment_default()(lastDate);
            }
        }
        var paymentTerm;
        if (this.document.payment_term) {
            paymentTerm = this.document.payment_term;
        }
        else if (config.sales_payment_term) {
            paymentTerm = config.sales_payment_term;
        }
        else if (this.paymentTerms.length > 0) {
            paymentTerm = this.paymentTerms[0];
        }
        var expireDate;
        if (this.type === 'invoice' && paymentTerm) {
            var date_1 = this.document.date ? external_moment_default()(this.document.date) : external_moment_default()();
            if (paymentTerm.day_number > 0) {
                date_1.add(paymentTerm.day_number, 'days');
            }
            if (paymentTerm.end_month) {
                date_1.endOf('month');
            }
            if (paymentTerm.end_month_day > 0) {
                date_1.add(1, 'month');
                date_1.set('date', paymentTerm.end_month_day);
            }
            expireDate = date_1;
        }
        else {
            expireDate = date.clone().add(this.teamConfigs.sales_quotation_default_validity, 'days');
        }
        return {
            date: date.format('YYYY-MM-DD'),
            expire_at: expireDate.format('YYYY-MM-DD'),
            payment_term: paymentTerm,
            advance_payment_value: config.sales_payment_advance_rate,
            advance_payment_type: 'pourcent'
        };
    };
    SalesForm.prototype.applyDefaultValues = function (document) {
        return mergeWith_default()({}, this.getDefaultValues(), document, function (a, b) { return b === null ? a : undefined; });
    };
    SalesForm.prototype.submitForm = function (mode) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (mode) {
                            this.submitMode = mode;
                        }
                        return [4 /*yield*/, this.$nextTick(function () {
                                var form = _this.$refs.form;
                                form.submit();
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SalesForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var document;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.lastDocumentVersion = null;
                        document = response.data;
                        if (!(this.submitMode === 3)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.redirectForm(document)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.redirectItem(document)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SalesForm.prototype.redirectItem = function (document) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams(document);
                        return [4 /*yield*/, this.$router.push({
                                name: this.type + '-item',
                                params: {
                                    id: String(document.id)
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SalesForm.prototype.redirectForm = function (document) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams(document);
                        return [4 /*yield*/, this.$router.replace({
                                name: this.type + '-form',
                                params: {
                                    id: String(document.id)
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SalesForm.prototype.submitError = function (error) {
        var _this = this;
        var _a, _b, _c;
        var response = error.response;
        if (response && response.status === 409) {
            this.lastDocumentVersion = response.data.new_version;
        }
        else if (response && response.status === 500) {
            this.errors = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : null;
            this.$nextTick(function () {
                document.getElementById('page').scrollTop = 0;
            });
        }
        else {
            this.lastDocumentVersion = null;
            var errors_1 = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.errors;
            if (errors_1) {
                var forceEditing_1 = [];
                forEach_default()(errors_1, function (value, key) {
                    if (/^contents.([0-9]+).designation$/.test(key)) {
                        var index = key.replace('contents.', '').replace('.designation', '');
                        forceEditing_1.push(Number(index));
                    }
                });
                this.forceEditing = forceEditing_1;
                this.$nextTick(function () {
                    var form = _this.$refs.form;
                    form.globalErrorsState = false;
                    setTimeout(function () {
                        form.showAjaxValidationErrors(errors_1);
                    }, 300);
                });
            }
        }
    };
    SalesForm.prototype.validateDatas = function () {
        var _a, _b;
        this.errors = null;
        if (((_b = (_a = this.document) === null || _a === void 0 ? void 0 : _a.contents) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            this.contentIsEmpty = true;
            var element = document.querySelector('.form-document-contents-area');
            if (element) {
                element.scrollIntoView();
            }
            return false;
        }
        return true;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SalesForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SalesForm.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], SalesForm.prototype, "watchValue", null);
    SalesForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['vatRates', 'paymentTerms'])), (0,external_vuex_.mapGetters)('globalDatas', ['defaultVatRate'])), (0,external_vuex_.mapGetters)('user', ['teamUser', 'teamConfigs', 'currency', 'team'])), (0,external_vuex_.mapGetters)('sales', ['defaultPdfModel'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadVatRates', 'loadPaymentTerms'])), (0,external_vuex_.mapActions)('app', ['setPageParams'])), (0,external_vuex_.mapActions)('sales', ['loadPdfModels'])),
            components: {
                CustomerDatas: CustomerDatas/* default */.A,
                DocumentContents: DocumentContents/* default */.A,
                DocumentDatas: DocumentDatas/* default */.A,
                Deadlines: Deadlines/* default */.A,
                FormSidebar: FormSidebar/* default */.A,
                ConflictModal: ConflictModal/* default */.A,
                Parameters: Parameters/* default */.A,
                WelcomeModal: WelcomeModal_WelcomeModal,
                PageHeader: interface_vue_.PageHeader, Spinner: interface_vue_.Spinner, Tabs: interface_vue_.Tabs, Tab: interface_vue_.Tab, AppMessages: interface_vue_.AppMessages,
                KForm: form_vue_.KForm,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BModal: external_bootstrap_vue_.BModal, BBadge: external_bootstrap_vue_.BBadge, BAlert: external_bootstrap_vue_.BAlert
            }
        })
    ], SalesForm);
    return SalesForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var DocumentFormvue_type_script_lang_ts_external = (SalesForm);

;// ./src/components/DocumentForm/DocumentForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentForm_DocumentFormvue_type_script_lang_ts_external = (DocumentFormvue_type_script_lang_ts_external); 
;// ./src/components/DocumentForm/DocumentForm.vue





/* normalize component */
;
var DocumentForm_component = (0,componentNormalizer/* default */.A)(
  DocumentForm_DocumentFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentForm = (DocumentForm_component.exports);

/***/ }),

/***/ 72827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PaymentFormButton_PaymentFormButton; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentFormButton/PaymentFormButton.vue?vue&type=template&id=fc98b350
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
    title: _vm.title,
    placement: this.element === 'button' ? 'top' : 'right'
  }),expression:"{\n    title,\n    placement: this.element === 'button' ? 'top' : 'right'\n  }"}]},[_c(_vm.component,{tag:"component",class:_vm.btnClass,attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[(_vm.hasSlot())?[_vm._t("default")]:[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")],_c('PaymentForm',{attrs:{"value":_vm.value,"modal":_vm.modal,"type":_vm.type,"document":_vm.document,"withGuaranteeHoldback":_vm.withGuaranteeHoldback},on:{"hidden":function($event){_vm.modal = false},"submitComplete":payment => _vm.$emit('submitComplete', payment),"invoiceUpdated":invoice => _vm.$emit('invoiceUpdated', invoice)}})],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/PaymentForm/PaymentForm.vue + 7 modules
var PaymentForm = __webpack_require__(88274);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentFormButton/PaymentFormButton.ts?vue&type=script&lang=ts&external




var PaymentFormButton = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentFormButton, _super);
    function PaymentFormButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        return _this;
    }
    Object.defineProperty(PaymentFormButton.prototype, "buttonLabel", {
        get: function () {
            if (this.label) {
                return this.label;
            }
            else if (this.value && this.value.id) {
                return this.$t('interface.edit');
            }
            else {
                return 'Paiement';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormButton.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    PaymentFormButton.prototype.hasSlot = function () {
        return this.$slots.default !== undefined;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], PaymentFormButton.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentFormButton.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentFormButton.prototype, "btnClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentFormButton.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentFormButton.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PaymentFormButton.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentFormButton.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentFormButton.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentFormButton.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentFormButton.prototype, "title", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PaymentFormButton.prototype, "withGuaranteeHoldback", void 0);
    PaymentFormButton = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PaymentForm: PaymentForm/* default */.A
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], PaymentFormButton);
    return PaymentFormButton;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentFormButtonvue_type_script_lang_ts_external = (PaymentFormButton);

;// ./src/components/PaymentFormButton/PaymentFormButton.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentFormButton_PaymentFormButtonvue_type_script_lang_ts_external = (PaymentFormButtonvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PaymentFormButton/PaymentFormButton.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PaymentFormButton_PaymentFormButtonvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentFormButton_PaymentFormButton = (component.exports);

/***/ }),

/***/ 72903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(23805),
    isPrototype = __webpack_require__(55527),
    nativeKeysIn = __webpack_require__(90181);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 72943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Deadlines_Deadlines; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/Deadlines/Deadlines.vue?vue&type=template&id=b11de636
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.value.total_ttc === 0)?[_vm._v(" Vous ne pouvez pas gérer les échéances lorsque le total TTC du document est de 0 "+_vm._s(_vm.value.currency.symbol)+" ")]:[_c('table',{staticClass:"table table-sm table-bordered align-middle w-auto"},[_c('thead',[_c('tr',[(_vm.type === 'invoice')?_c('th',[_vm._v("Date")]):_vm._e(),_c('th',[_vm._v("Montant")]),_c('th',[_vm._v("Pourcentage")]),(_vm.type !== 'invoice')?_c('th',[_vm._v("Délai")]):_vm._e(),(_vm.short === false)?_c('th',{staticClass:"text-center"},[_vm._v("Figer")]):_vm._e(),(_vm.value.deadlines?.length > 2)?_c('th'):_vm._e()])]),_c('tbody',_vm._l((_vm.value.deadlines),function(deadline,i){return _c('tr',{key:i},[(_vm.type === 'invoice')?_c('td',[_c('k-form-datepicker',{attrs:{"name":'deadlines[' + i + '][date]',"size":"sm","min-date":i === 0 ? _vm.value.date : _vm.value.deadlines[i-1].date,"required":""},model:{value:(deadline.date),callback:function ($$v) {_vm.$set(deadline, "date", $$v)},expression:"deadline.date"}}),_c('input',{attrs:{"type":"hidden","name":'deadlines[' + i + '][delay]'},domProps:{"value":deadline.delay}}),_c('input',{attrs:{"type":"hidden","name":'deadlines[' + i + '][delay_type]'},domProps:{"value":deadline.delay_type}})],1):_vm._e(),_c('td',[_c('b-input-group',{attrs:{"append":_vm.value.currency?.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'deadlines[' + i + '][amount]',"min":0,"size":"sm"},on:{"change":function($event){return _vm.amountUpdated(i)}},model:{value:(deadline.amount),callback:function ($$v) {_vm.$set(deadline, "amount", $$v)},expression:"deadline.amount"}})],1)],1),_c('td',[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{attrs:{"min":0,"max":100,"size":"sm"},on:{"change":function($event){return _vm.pourcentUpdated(i)}},model:{value:(deadline.pourcent),callback:function ($$v) {_vm.$set(deadline, "pourcent", $$v)},expression:"deadline.pourcent"}})],1)],1),(_vm.type !== 'invoice')?_c('td',[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"size":"sm"},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('k-form-select',{attrs:{"size":"sm","name":'deadlines[' + i + '][delay_type]',"options":_vm.delayTypes,"reduce":opt => opt.value,"clearable":false},model:{value:(deadline.delay_type),callback:function ($$v) {_vm.$set(deadline, "delay_type", $$v)},expression:"deadline.delay_type"}})]},proxy:true}],null,true)},[_c('k-form-number',{attrs:{"size":"sm","name":'deadlines[' + i + '][delay]',"min":i === 0 ? 0 : 1,"maxDecimal":0},model:{value:(deadline.delay),callback:function ($$v) {_vm.$set(deadline, "delay", $$v)},expression:"deadline.delay"}})],1)],1),_c('b-col',{staticClass:"small text-nowrap pl-0"},[(i === 0)?[_vm._v(" après date de facture ")]:[_vm._v(" après dernière échéance ")]],2)],1)],1):_vm._e(),(_vm.short === false)?_c('td',{staticClass:"text-center"},[_c('k-form-checkbox',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right",value:('Figer le montant de l\'échéance'),expression:"'Figer le montant de l\\'échéance'",modifiers:{"right":true}}],attrs:{"name":'deadlines[' + i + '][fixed]',"size":"sm","value":true,"disabled":_vm.fixedDisabled(i)},model:{value:(deadline.fixed),callback:function ($$v) {_vm.$set(deadline, "fixed", $$v)},expression:"deadline.fixed"}})],1):_vm._e(),(_vm.value.deadlines?.length > 2)?_c('td',[_c('b-button',{staticClass:"p-0 text-danger",attrs:{"variant":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.deleteDeadline(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1):_vm._e()])}),0)]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addDeadline.apply(null, arguments)}}},[_vm._v(" Ajouter une échéance ")]),(_vm.short === false)?[_c('b-alert',{staticClass:"mt-3 mb-0",attrs:{"variant":"warning","show":""}},[_vm._v(" Vous pouvez figer des échéances afin que leur montant ne soit pas modifié lorsque le "),_c('strong',[_vm._v("total TTC du document est mis à jour")]),_vm._v(". ")]),_c('p',{staticClass:"mt-4 mb-0"},[_c('input',{attrs:{"type":"hidden","name":"pdf_options[show_deadline_pourcent]"},domProps:{"value":_vm.value.pdf_options.show_deadline_pourcent ?? false}}),_c('k-form-checkbox',{staticClass:"d-inline-block mr-4",model:{value:(_vm.value.pdf_options.show_deadline_pourcent),callback:function ($$v) {_vm.$set(_vm.value.pdf_options, "show_deadline_pourcent", $$v)},expression:"value.pdf_options.show_deadline_pourcent"}},[_vm._v(" Afficher le pourcentage ")])],1)]:_vm._e(),_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"Texte apparaissant sur le PDF"}},[_c('ul',_vm._l((_vm.value.deadlines),function(deadline,i){return _c('li',{key:i},[(_vm.value.pdf_options.show_deadline_pourcent)?[_vm._v(" "+_vm._s(_vm.showNumber(deadline.pourcent))+" %, soit ")]:_vm._e(),_vm._v(" "+_vm._s(_vm.formattedNumber(deadline.amount, _vm.value.currency))+" à payer "),(_vm.type === 'invoice')?[_vm._v(" le "+_vm._s(_vm.date(deadline.date))+" ")]:(i === 0 && deadline.delay === 0)?[_vm._v(" à réception de facture ")]:[_vm._v(" à "+_vm._s(_vm.deadlineDelay(i))+" ")]],2)}),0)])]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/Deadlines/Deadlines.ts?vue&type=script&lang=ts&external








var Deadlines = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Deadlines, _super);
    function Deadlines() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = false;
        return _this;
    }
    Deadlines.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.loaded = true;
        });
        if (!this.value.deadlines || this.value.deadlines.length === 0) {
            this.generateDeadlines();
        }
        else if (!this.value.id) {
            this.updateDeadlinesDate();
        }
    };
    Object.defineProperty(Deadlines.prototype, "delayTypes", {
        get: function () {
            return [
                { value: 'day', label: this.$t('interface.day') },
                { value: 'month', label: this.$t('interface.month') },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Deadlines.prototype, "fixedDisabled", {
        get: function () {
            var _this = this;
            return function (index) {
                var deadlines = _this.value.deadlines;
                var fixed = deadlines.filter(function (deadline) { return deadline.fixed; }).length;
                return fixed >= (deadlines.length - 1) && !deadlines[index].fixed;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Deadlines.prototype, "deadlineDelay", {
        get: function () {
            var _this = this;
            return function (index) {
                var deadlines = _this.value.deadlines;
                var months = sumBy_default()(deadlines.filter(function (deadline, i) { return i <= index && deadline.delay_type === 'month'; }), function (deadline) { return _this.number(deadline.delay); });
                var days = sumBy_default()(deadlines.filter(function (deadline, i) { return i <= index && deadline.delay_type === 'day'; }), function (deadline) { return _this.number(deadline.delay); });
                var data = '';
                if (months > 0) {
                    data += months + ' mois';
                }
                if (days > 0) {
                    if (data !== '') {
                        data += ' et ';
                    }
                    data += days + ' jour';
                    if (days > 1) {
                        data += 's';
                    }
                }
                return data;
            };
        },
        enumerable: false,
        configurable: true
    });
    Deadlines.prototype.watchPaymentTermChange = function () {
        var _a;
        if (this.loaded && ((_a = this.value.payment_term) === null || _a === void 0 ? void 0 : _a.with_deadlines)) {
            this.generateDeadlines();
        }
    };
    Deadlines.prototype.watchTotalTtc = function () {
        var _this = this;
        if (!this.loaded) {
            return;
        }
        var deadlines = this.value.deadlines;
        var totalTtc = this.number(this.value.total_ttc);
        var editableIndex = [];
        var checkTtc = totalTtc;
        var checkPourcent = 100;
        deadlines.forEach(function (deadline, i) {
            var amount;
            if (!deadline.fixed) {
                editableIndex.push(i);
                amount = _this.roundNumber(totalTtc * _this.number(deadline.pourcent) / 100, 2);
                deadline.amount = amount;
            }
            else {
                amount = deadline.amount;
            }
            deadline.pourcent = _this.roundNumber((_this.number(deadline.amount) * 100) / totalTtc, 2);
            checkPourcent -= deadline.pourcent;
            checkTtc -= amount;
        });
        if (checkTtc !== 0) {
            var deadline = deadlines[editableIndex[editableIndex.length - 1]];
            if (deadline) {
                deadline.amount += checkTtc;
            }
        }
    };
    Deadlines.prototype.generateDeadlines = function () {
        var _this = this;
        var _a, _b;
        var deadlines = [];
        var date = external_moment_default()(this.value.date);
        var totalAmount = this.number(this.value.to_paid);
        (_b = (_a = this.value.payment_term) === null || _a === void 0 ? void 0 : _a.deadlines) === null || _b === void 0 ? void 0 : _b.forEach(function (deadline) {
            var amount = _this.roundNumber(_this.number(_this.value.to_paid) * _this.number(deadline.pourcent) / 100, 2);
            totalAmount -= amount;
            date.add(deadline.delay, 'days');
            deadlines.push({
                date: date.format('YYYY-MM-DD'),
                amount: amount,
                pourcent: deadline.pourcent,
                delay: deadline.delay,
                delay_type: deadline.delay_type
            });
        });
        if (totalAmount !== 0) {
            //
        }
        this.value.deadlines = deadlines;
    };
    Deadlines.prototype.updateDeadlinesDate = function () {
        var _a;
        var date = external_moment_default()(this.value.date);
        (_a = this.value.deadlines) === null || _a === void 0 ? void 0 : _a.forEach(function (deadline) {
            date.add(deadline.delay, 'days');
            deadline.date = date.format('YYYY-MM-DD');
        });
    };
    Deadlines.prototype.addDeadline = function () {
        var deadlines = this.value.deadlines;
        deadlines.push({
            date: external_moment_default()(deadlines[deadlines.length - 1].date).add(30, 'days').format('YYYY-MM-DD'),
            amount: 0,
            pourcent: 0
        });
    };
    Deadlines.prototype.deleteDeadline = function (index) {
        var _a;
        (_a = this.value.deadlines) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
        this.amountUpdated();
    };
    Deadlines.prototype.pourcentUpdated = function (index) {
        var _this = this;
        var deadlines = this.value.deadlines;
        var isLast = index === (deadlines.length - 1);
        var usedPourcent;
        var length;
        if (isLast) {
            usedPourcent = this.number(index !== undefined ? deadlines[index].pourcent : 0);
            length = deadlines.length - 1;
        }
        else {
            length = deadlines.length;
            if (index !== undefined) {
                length -= (index + 1);
                usedPourcent = sumBy_default()(deadlines.filter(function (deadline, i) { return i <= index; }), function (deadline) { return _this.number(deadline.pourcent); });
            }
            else {
                usedPourcent = 0;
            }
        }
        var toPaid = this.number(this.value.to_paid);
        var checkToPaid = toPaid;
        var check = 100 - usedPourcent;
        var pourcent = this.roundNumber(check / length, 2);
        var editableIndex = [];
        deadlines.forEach(function (deadline, i) {
            var amount;
            if (index === undefined || (isLast && i !== index) || (!isLast && i > index)) {
                editableIndex.push(i);
                deadline.pourcent = pourcent;
                check -= pourcent;
                amount = _this.roundNumber(toPaid * pourcent / 100, 2);
            }
            else {
                amount = _this.roundNumber(toPaid * usedPourcent / 100, 2);
            }
            checkToPaid -= amount;
            deadline.amount = amount;
        });
        if (check !== 0) {
            var deadline = deadlines[editableIndex[editableIndex.length - 1]];
            deadline.pourcent += check;
        }
        if (checkToPaid !== 0) {
            var deadline = deadlines[editableIndex[editableIndex.length - 1]];
            deadline.amount += checkToPaid;
        }
    };
    Deadlines.prototype.amountUpdated = function (index) {
        var _this = this;
        var deadlines = this.value.deadlines;
        var isLast = index === (deadlines.length - 1);
        var usedAmount;
        var length;
        if (isLast) {
            usedAmount = this.number(index !== undefined ? deadlines[index].amount : 0);
            length = deadlines.length - 1;
        }
        else {
            length = deadlines.length;
            if (index !== undefined) {
                length -= (index + 1);
                usedAmount = sumBy_default()(deadlines.filter(function (deadline, i) { return i <= index; }), function (deadline) { return _this.number(deadline.amount); });
            }
            else {
                usedAmount = 0;
            }
        }
        var toPaid = this.number(this.value.to_paid);
        var check = toPaid - usedAmount;
        var amount = this.roundNumber(check / length, 2);
        var editableIndex = [];
        deadlines.forEach(function (deadline, i) {
            if (index === undefined || (isLast && i !== index) || (!isLast && i > index)) {
                editableIndex.push(i);
                deadline.amount = amount;
                check -= amount;
            }
            deadline.pourcent = _this.roundNumber((deadline.amount * 100) / toPaid, 2);
        });
        if (check !== 0) {
            var deadline = deadlines[editableIndex[editableIndex.length - 1]];
            deadline.amount += check;
            deadline.pourcent = this.roundNumber((deadline.amount * 100) / toPaid, 2);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Deadlines.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Deadlines.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Deadlines.prototype, "short", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.payment_term')
    ], Deadlines.prototype, "watchPaymentTermChange", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.total_ttc')
    ], Deadlines.prototype, "watchTotalTtc", null);
    Deadlines = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormDatepicker: form_vue_.KFormDatepicker, KFormNumber: form_vue_.KFormNumber, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect,
                BInputGroup: external_bootstrap_vue_.BInputGroup, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], Deadlines);
    return Deadlines;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var Deadlinesvue_type_script_lang_ts_external = (Deadlines);

;// ./src/components/Form/Deadlines/Deadlines.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Deadlines_Deadlinesvue_type_script_lang_ts_external = (Deadlinesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/Deadlines/Deadlines.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Deadlines_Deadlinesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Deadlines_Deadlines = (component.exports);

/***/ }),

/***/ 72949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(12651);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 73285:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'cars';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f85b';
var svgPathData = 'M252.13 243.23A131.77 131.77 0 0 1 375.07 160h38.41a57.49 57.49 0 0 0-32.9-36.44L376 112.2l-17.84-49.08A99.92 99.92 0 0 0 264.93 0H151.07a99.92 99.92 0 0 0-93.23 63.12L40 112.2l-4.55 11.36A57.39 57.39 0 0 0 0 176.55v28.69a57 57 0 0 0 21.52 44.46V288a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-32h139.88zM111.11 92c6.53-16.92 22.36-28 40-28h113.82c17.6 0 33.42 11.1 40 28L317 128H99zM76 215.85c-14.4 0-24-9.57-24-23.92S61.6 168 76 168s36 21.53 36 35.89-21.6 11.96-36 11.96zm528.58 99.71L600 304.2l-17.87-49.08a99.92 99.92 0 0 0-93.2-63.12H375.07a99.92 99.92 0 0 0-93.23 63.12L264 304.2l-4.55 11.36a57.39 57.39 0 0 0-35.42 53v28.69a57 57 0 0 0 21.52 44.46V480a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-32h200.79v32a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-38.3A57 57 0 0 0 640 397.24v-28.69a57.39 57.39 0 0 0-35.42-52.99zM335.11 284c6.53-16.92 22.36-28 40-28h113.82c17.6 0 33.42 11.1 40 28L541 320H323zM300 407.85c-14.4 0-24-9.57-24-23.93S285.6 360 300 360s36 21.53 36 35.89-21.6 11.96-36 11.96zm264 0c-14.4 0-36 2.39-36-12S549.6 360 564 360s24 9.57 24 23.92-9.6 23.93-24 23.93z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.TG = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 73386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ 73599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ GuaranteeHoldbackList_GuaranteeHoldbackList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/GuaranteeHoldbackList/GuaranteeHoldbackList.vue?vue&type=template&id=6ba2d039
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-table',{ref:"table",attrs:{"url":"/sales/invoice","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowLink":_vm.rowLink,"stateKey":"guarantee-holdback-list"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/GuaranteeHoldbackList/GuaranteeHoldbackList.ts?vue&type=script&lang=ts&external



var GuaranteeHoldbackList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GuaranteeHoldbackList, _super);
    function GuaranteeHoldbackList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(GuaranteeHoldbackList.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: 'customer',
                filter: {
                    with_guarantee_holdback: true,
                    is_draft: false
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuaranteeHoldbackList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'reference',
                    name: 'N° document'
                },
                {
                    data: 'date',
                    name: 'Date',
                    render: 'date'
                },
                {
                    data: 'customer.name',
                    name: 'Client'
                },
                {
                    data: 'title',
                    name: 'Titre'
                },
                {
                    data: 'guarantee_holdback_amount',
                    name: 'Montant de la retenue de garantie',
                    render: 'currency'
                },
                {
                    data: 'guarantee_holdback_expiration',
                    name: 'Date limite de paiement',
                    render: 'date'
                },
                {
                    data: 'guarantee_holdback_status',
                    name: 'Statut',
                    render: function (status) {
                        switch (status) {
                            case 0:
                                return 'En attente';
                            case 1:
                                return 'Payée';
                            case 2:
                                return 'Annulée';
                            default:
                                return null;
                        }
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuaranteeHoldbackList.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'period',
                    label: 'Date limite de paiement',
                    name: 'guarantee_holdback_expire_since',
                    name2: 'guarantee_holdback_expire_until'
                },
                {
                    type: 'select',
                    label: 'Statut',
                    name: 'guarantee_holdback_status',
                    options: [
                        { value: 0, label: 'En attente' },
                        { value: 1, label: 'Payée' },
                        { value: 2, label: 'Annulée' }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'select',
                    label: 'Client',
                    name: 'customer',
                    optionLabel: 'name',
                    value: 'id',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    GuaranteeHoldbackList.prototype.rowLink = function (row) {
        return {
            name: 'invoice-item',
            params: {
                id: String(row.id),
                document: JSON.stringify(row)
            }
        };
    };
    GuaranteeHoldbackList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable
            }
        })
    ], GuaranteeHoldbackList);
    return GuaranteeHoldbackList;
}(lib/* Vue */.lD));
/* harmony default export */ var GuaranteeHoldbackListvue_type_script_lang_ts_external = (GuaranteeHoldbackList);

;// ./src/components/GuaranteeHoldbackList/GuaranteeHoldbackList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var GuaranteeHoldbackList_GuaranteeHoldbackListvue_type_script_lang_ts_external = (GuaranteeHoldbackListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/GuaranteeHoldbackList/GuaranteeHoldbackList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  GuaranteeHoldbackList_GuaranteeHoldbackListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GuaranteeHoldbackList_GuaranteeHoldbackList = (component.exports);

/***/ }),

/***/ 73635:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                      ? 'тан'
                      : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ 73739:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ 73893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325),
    toInteger = __webpack_require__(61489),
    toNumber = __webpack_require__(99374),
    toString = __webpack_require__(13222);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),

/***/ 74063:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ 74218:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 74335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 75288:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 75579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionPaymentForm_CommissionPaymentForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionPaymentForm/CommissionPaymentForm.vue?vue&type=template&id=cfb33ea6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":_vm.modalTitle,"size":!_vm.nextStep || _vm.payment.commissions?.length === 0 ? 'lg' : 'xl',"ok-title":!_vm.nextStep || _vm.payment.commissions?.length === 0 ? _vm.$t('interface.close') : _vm.$t('interface.save'),"ok-only":!_vm.nextStep || _vm.payment.commissions?.length === 0},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(!_vm.nextStep)?[_c('h2',{staticClass:"form-title-alt mt-0"},[_vm._v(" Rechercher des commissions en attente de paiement ")]),(_vm.searching)?_c('Spinner'):[_c('b-form-group',{attrs:{"label":"Commercial","label-cols":"2"}},[_c('TeamUserSelect',{attrs:{"required":"","role":"commercial"},model:{value:(_vm.payment.team_user),callback:function ($$v) {_vm.$set(_vm.payment, "team_user", $$v)},expression:"payment.team_user"}})],1),_c('b-form-group',{attrs:{"label":"Période","label-cols":"2"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_vm._v("Du")]),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"max-date":_vm.end},model:{value:(_vm.begin),callback:function ($$v) {_vm.begin=$$v},expression:"begin"}})],1),_c('b-col',{staticClass:"pr-0",attrs:{"cols":"auto"}},[_vm._v("au")]),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"min-date":_vm.begin},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],1)],1),_c('p',{staticClass:"text-center mt-4 mb-0"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[_vm._v(" Rechercher ")])],1)]]:(_vm.payment.commissions?.length === 0)?_c('p',{staticClass:"text-center mb-0"},[_vm._v(" Aucune commission n'est actuellement à payer avec ces critères ")]):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.formDatas},on:{"submitComplete":response => _vm.$emit('submitComplete', response.data)}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Date du paiement"}},[_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"name":"date","required":""},model:{value:(_vm.payment.date),callback:function ($$v) {_vm.$set(_vm.payment, "date", $$v)},expression:"payment.date"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Commercial"}},[_c('input',{attrs:{"type":"hidden","name":"team_user"},domProps:{"value":_vm.payment.team_user ? _vm.payment.team_user.id : null}}),_c('p',{staticClass:"pt-1 pb-0"},[_vm._v(" "+_vm._s(_vm.payment.team_user?.fullname)+" ")])])],1)],1),_c('h2',{staticClass:"form-title-alt mt-2 border-bottom-0 mb-0"},[_vm._v(" Commissions ")]),_c('b-table',{attrs:{"items":_vm.payment.commissions,"fields":_vm.columns,"small":"","bordered":"","striped":"","perPage":_vm.perPage,"currentPage":_vm.page,"foot-clone":""},scopedSlots:_vm._u([{key:"cell(remove)",fn:function({ item }){return [(_vm.payment.commissions.length > 1)?_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: 'Retirer la commission' }),expression:"{ title: 'Retirer la commission' }"}],staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.removeCommission(item)}}}):_vm._e()]}},{key:"foot(date)",fn:function(){return [_vm._v("   ")]},proxy:true},{key:"foot(document_reference)",fn:function(){return [_c('p',{staticClass:"text-right mb-0"},[_vm._v("Total :")])]},proxy:true},{key:"foot(amount)",fn:function(){return [_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.totalCommissions))+" ")]},proxy:true}])}),_c('b-pagination',{staticClass:"mb-0",attrs:{"perPage":_vm.perPage,"totalRows":_vm.payment.commissions?.length,"size":"sm","align":"center"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionPaymentForm/CommissionPaymentForm.ts?vue&type=script&lang=ts&external









var CommissionPaymentForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionPaymentForm, _super);
    function CommissionPaymentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.begin = null;
        _this.end = null;
        _this.searching = false;
        _this.nextStep = false;
        _this.page = 1;
        _this.perPage = 20;
        _this.payment = {
            commissions: []
        };
        _this.columns = [
            {
                label: 'Date',
                key: 'date',
                formatter: function (date) { return _this.date(date); },
            },
            {
                label: 'Document',
                key: 'document_reference'
            },
            {
                label: 'Montant',
                key: 'amount',
                formatter: function (amount) { return _this.formattedNumber(amount); },
            },
            { key: 'remove', label: '', thStyle: 'width: 40px', tdClass: 'text-center' }
        ];
        return _this;
    }
    CommissionPaymentForm.prototype.mounted = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _b.sent();
                        if (!this.payment.team_user) {
                            this.payment.team_user = (_a = this.teamUsersRole('commercial')[0]) !== null && _a !== void 0 ? _a : null;
                        }
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommissionPaymentForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/sales/commission/payment';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionPaymentForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionPaymentForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            return (((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'Modification' : 'Création') + ' d\'un paiement de commissions';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionPaymentForm.prototype, "totalCommissions", {
        get: function () {
            var _this = this;
            return sumBy_default()(this.payment.commissions, function (commission) { return _this.number(commission.amount); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionPaymentForm.prototype, "formDatas", {
        get: function () {
            var _a, _b;
            return {
                date: this.payment.date,
                team_user: (_a = this.payment.team_user) === null || _a === void 0 ? void 0 : _a.id,
                commissions: (_b = this.payment.commissions) === null || _b === void 0 ? void 0 : _b.map(function (commission) { return commission.id; })
            };
        },
        enumerable: false,
        configurable: true
    });
    CommissionPaymentForm.prototype.watchValue = function () {
        var _a, _b;
        this.payment = Object.assign({
            date: external_moment_default()().format('YYYY-MM-DD'),
            commissions: []
        }, this.value ? JSON.parse(JSON.stringify(this.value)) : {});
        this.nextStep = ((_b = (_a = this.payment) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null) !== null;
    };
    CommissionPaymentForm.prototype.watchModal = function () {
        var _a, _b;
        this.modalState = this.modal;
        if (this.modal) {
            this.nextStep = ((_b = (_a = this.payment) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null) !== null;
            this.page = 1;
        }
    };
    CommissionPaymentForm.prototype.search = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var filter;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.searching = true;
                        filter = {
                            team_user: (_a = this.payment.team_user) === null || _a === void 0 ? void 0 : _a.id,
                            status: 1
                        };
                        if (this.begin) {
                            filter.date_since = this.begin;
                        }
                        if (this.end) {
                            filter.date_until = this.end;
                        }
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/commission/sales', {
                                params: {
                                    filter: filter,
                                    include: ['document'],
                                    sort: 'date:asc'
                                }
                            })
                                .then(function (response) {
                                _this.payment.commissions = response.data.data;
                                _this.searching = false;
                                _this.nextStep = true;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommissionPaymentForm.prototype.removeCommission = function (commission) {
        var _a;
        var index = this.payment.commissions.findIndex(function (val) { return val.id === commission.id; });
        if (index > -1) {
            (_a = this.payment.commissions) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommissionPaymentForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommissionPaymentForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CommissionPaymentForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CommissionPaymentForm.prototype, "watchModal", null);
    CommissionPaymentForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BTable: external_bootstrap_vue_.BTable, BPagination: external_bootstrap_vue_.BPagination,
                TeamUserSelect: interface_vue_.TeamUserSelect, Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['teamUsersRole'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CommissionPaymentForm);
    return CommissionPaymentForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var CommissionPaymentFormvue_type_script_lang_ts_external = (CommissionPaymentForm);

;// ./src/components/CommissionPaymentForm/CommissionPaymentForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionPaymentForm_CommissionPaymentFormvue_type_script_lang_ts_external = (CommissionPaymentFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionPaymentForm/CommissionPaymentForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionPaymentForm_CommissionPaymentFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionPaymentForm_CommissionPaymentForm = (component.exports);

/***/ }),

/***/ 76002:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'signature';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f5b7';
var svgPathData = 'M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.uZ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 76545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(56110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 76733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarBrandForm_CarBrandForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarBrandForm/CarBrandForm.vue?vue&type=template&id=7b4ebd40
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":response => _vm.$emit('submitComplete', response)}},[_c('b-form-group',{attrs:{"label":"Nom de la marque"}},[_c('k-form-input',{attrs:{"name":"name","required":""},model:{value:(_vm.brand.name),callback:function ($$v) {_vm.$set(_vm.brand, "name", $$v)},expression:"brand.name"}})],1),_c('table',{staticClass:"table table-sm mb-1"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Modèle")]),_c('th',{staticStyle:{"width":"30px"}})])]),_c('tbody',[(_vm.brand.models.length === 0)?_c('tr',[_c('td',{staticClass:"text-center small text-muted p-2",attrs:{"colspan":"2"}},[_vm._v(" Aucun modèle ")])]):_vm._e(),_vm._l((_vm.brand.models),function(model,i){return _c('tr',{key:i},[_c('td',[_c('k-form-input',{attrs:{"size":"sm","name":'models[' + i + ']',"required":""},model:{value:(model.name),callback:function ($$v) {_vm.$set(model, "name", $$v)},expression:"model.name"}})],1),_c('td',{staticClass:"px-0"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"text-danger",attrs:{"variant":"icon","size":"sm","title":"Supprimer le modèle"},on:{"click":function($event){$event.preventDefault();return _vm.brand.models.splice(i, 1)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1)])})],2)]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.brand.models.push({ name: null })}}},[_vm._v(" Ajouter ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarBrandForm/CarBrandForm.ts?vue&type=script&lang=ts&external






var CarBrandForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarBrandForm, _super);
    function CarBrandForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.brand = {
            models: []
        };
        return _this;
    }
    Object.defineProperty(CarBrandForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/automotive/brand';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarBrandForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    CarBrandForm.prototype.valueChanged = function () {
        var _a;
        this.brand = JSON.parse(JSON.stringify((_a = this.value) !== null && _a !== void 0 ? _a : { models: [{ name: null }] }));
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarBrandForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CarBrandForm.prototype, "valueChanged", null);
    CarBrandForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CarBrandForm);
    return CarBrandForm;
}((external_vue_default())));
/* harmony default export */ var CarBrandFormvue_type_script_lang_ts_external = (CarBrandForm);

;// ./src/components/CarBrandForm/CarBrandForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarBrandForm_CarBrandFormvue_type_script_lang_ts_external = (CarBrandFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarBrandForm/CarBrandForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarBrandForm_CarBrandFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarBrandForm_CarBrandForm = (component.exports);

/***/ }),

/***/ 76873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentStatusSelector_DocumentStatusSelector; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentStatusSelector/DocumentStatusSelector.vue?vue&type=template&id=c71aef2c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-only":_vm.errorMsg !== null,"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.updateStatus},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_c('div',{staticClass:"text-justify"},[_vm._v(" Modifier le statut du document à "),_c('k-form-select',{attrs:{"required":"","options":_vm.documentStatusManual,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1),(_vm.validateDocument)?_c('div',[_c('b-alert',{staticClass:"mt-3 p-2",attrs:{"variant":_vm.type === 'invoice' || _vm.type === 'credit' ? 'danger' : 'warning',"show":""}},[_vm._v(" Le document va être validé, celui-ci ne pourra plus être "),(_vm.type === 'invoice' || _vm.type === 'credit')?_c('span',[_vm._v(" ni modifié, ni ")]):_vm._e(),_vm._v(" supprimé. ")]),_c('b-form-group',{staticClass:"mt-4 mb-0",attrs:{"label":"Date du document :","label-cols":"auto"}},[_c('k-form-datepicker',{attrs:{"min-date":!_vm.teamConfigs.sales_disable_date_check && (_vm.type === 'invoice' || _vm.type === 'credit') ? _vm.team.sales[_vm.type + '_date'] : null,"max-date":!_vm.teamConfigs.sales_disable_date_check && (_vm.type === 'invoice' || _vm.type === 'credit') ? _vm.today : null},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1):_vm._e(),(_vm.cantBeEditedIfValid && _vm.type !== 'invoice' && _vm.type !== 'credit')?_c('b-alert',{staticClass:"mt-2 mb-0",attrs:{"variant":"danger","show":""}},[_vm._v(" Attention, ce document étant déjà facturé à 100%, il ne sera plus modifiable. ")]):_vm._e()]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatusMixin.ts
var SalesDocumentStatusMixin = __webpack_require__(25267);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentStatusSelector/DocumentStatusSelector.ts?vue&type=script&lang=ts&external








var DocumentStatusSelector = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentStatusSelector, _super);
    function DocumentStatusSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = null;
        _this.modalState = false;
        _this.loading = false;
        _this.errorMsg = null;
        _this.date = null;
        _this.today = null;
        return _this;
    }
    DocumentStatusSelector.prototype.mounted = function () {
        this.today = external_moment_default()().format('YYYY-MM-DD');
    };
    Object.defineProperty(DocumentStatusSelector.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatusSelector.prototype, "cantBeEditedIfValid", {
        get: function () {
            var _a;
            if (!this.validateDocument) {
                return false;
            }
            if (this.type === 'invoice') {
                return false;
            }
            if (this.type === 'delivery') {
                return this.document.billing_status === 3;
            }
            var invoices = (_a = this.document.invoices) !== null && _a !== void 0 ? _a : [];
            return this.status !== null && this.status >= 2 && this.number(this.document.to_bill) === 0 && invoices.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatusSelector.prototype, "validateDocument", {
        get: function () {
            return this.document.status === 1 && this.status !== null && this.status >= 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatusSelector.prototype, "documentStatusManual", {
        get: function () {
            var _this = this;
            var status = this.documentStatus.filter(function (status) { return status.value > 1 && status.value !== _this.document.status; });
            switch (this.type) {
                case 'invoice':
                    return status.filter(function (status) {
                        return status.value !== 4;
                    });
                default:
                    return status.filter(function (status) {
                        return status.value !== 6;
                    });
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatusSelector.prototype, "params", {
        // Return params for ajax query
        get: function () {
            var attrs = {
                status: this.status
            };
            if (this.validateDocument && this.date) {
                attrs.date = this.date;
            }
            return attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentStatusSelector.prototype, "url", {
        // Return url for ajax query
        get: function () {
            var url = '/sales/' + this.type + '/' + this.document.id;
            if (!this.validateDocument) {
                url += '/lite';
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    // Open modal
    DocumentStatusSelector.prototype.openModal = function () {
        this.errorMsg = null;
        this.modalState = true;
        this.status = null;
        this.loading = false;
    };
    // Listen document change
    DocumentStatusSelector.prototype.watchDocument = function (document) {
        if (this.teamConfigs.sales_update_date_for_draft) {
            this.date = external_moment_default()().format('YYYY-MM-DD');
        }
        else {
            var date = document.date;
            if (!this.teamConfigs.sales_disable_date_check && (this.type === 'invoice' || this.type === 'credit')) {
                if (external_moment_default()(date).isBefore(this.team.sales[this.type + '_date'])) {
                    date = external_moment_default()().format('YYYY-MM-DD');
                }
            }
            this.date = date;
        }
    };
    // Send ajax query
    DocumentStatusSelector.prototype.updateStatus = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.put(this.url, this.params)
            .then(function (response) {
            _this.$emit('input', response.data);
            _this.modalState = false;
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentStatusSelector.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentStatusSelector.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], DocumentStatusSelector.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Statut du document' })
    ], DocumentStatusSelector.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DocumentStatusSelector.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('document', { immediate: true })
    ], DocumentStatusSelector.prototype, "watchDocument", null);
    DocumentStatusSelector = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'team'])),
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KFormSelect: form_vue_.KFormSelect, KFormDatepicker: form_vue_.KFormDatepicker
            }
        })
    ], DocumentStatusSelector);
    return DocumentStatusSelector;
}((0,lib/* Mixins */.Xe)(SalesDocumentStatusMixin/* default */.A, interface_vue_.NumberMixin)));
/* harmony default export */ var DocumentStatusSelectorvue_type_script_lang_ts_external = (DocumentStatusSelector);

;// ./src/components/DocumentStatusSelector/DocumentStatusSelector.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentStatusSelector_DocumentStatusSelectorvue_type_script_lang_ts_external = (DocumentStatusSelectorvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/DocumentStatusSelector/DocumentStatusSelector.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentStatusSelector_DocumentStatusSelectorvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentStatusSelector_DocumentStatusSelector = (component.exports);

/***/ }),

/***/ 76982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FecExportList_FecExportList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FecExportList/FecExportList.vue?vue&type=template&id=27427cef
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-table',{attrs:{"fields":_vm.fields,"items":_vm.items,"busy":_vm.loading,"per-page":_vm.perPage,"current-page":_vm.currentPage,"sort-by":"created_at","sort-desc":true,"bordered":"","table-class":"align-middle"},on:{"update:busy":function($event){_vm.loading=$event}},scopedSlots:_vm._u([{key:"cell(begin)",fn:function(data){return [(data.item.begin)?_c('p',{staticClass:"mb-0"},[_vm._v(" Début : "+_vm._s(_vm.date(data.item.begin))+" ")]):_vm._e(),(data.item.end)?_c('p',{staticClass:"mb-0"},[_vm._v(" Fin : "+_vm._s(_vm.date(data.item.end))+" ")]):_vm._e(),(data.item.only_unexported)?_c('p',{staticClass:"mb-0"},[_vm._v(" Données jamais exportées uniquement ")]):_vm._e(),(data.item.mark_exported)?_c('p',{staticClass:"mb-0"},[_vm._v(" Marquer les données comme exportées ")]):_vm._e()]}},{key:"cell(id)",fn:function(data){return [(data.item.status < 3)?_c('b-progress',{attrs:{"max":data.item.nb_items,"show-progress":"","animated":"","variant":"warning"}},[_c('b-progress-bar',{attrs:{"value":data.item.nb_processed,"label":`${((data.item.nb_processed / data.item.nb_items) * 100).toFixed(2)}%`}})],1):(!_vm.isExpired(data.item.expire_at))?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.download(data.item.id)}}},[_vm._v(" Télécharger ")]):_vm._e()]}}]),model:{value:(_vm.datas),callback:function ($$v) {_vm.datas=$$v},expression:"datas"}}),(!_vm.loading)?_c('b-pagination',{attrs:{"total-rows":_vm.total,"per-page":_vm.perPage,"size":"sm"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./src/mixins/FecMixin.ts
var FecMixin = __webpack_require__(67912);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FecExportList/FecExportList.ts?vue&type=script&lang=ts&external






var FecExportList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FecExportList, _super);
    function FecExportList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentPage = 1;
        _this.perPage = 20;
        _this.total = 0;
        _this.datas = [];
        return _this;
    }
    FecExportList.prototype.mounted = function () {
        interface_vue_.emitter.on('FecExportUpdated', this.fecExportUpdated);
    };
    FecExportList.prototype.destroyed = function () {
        interface_vue_.emitter.off('FecExportUpdated', this.fecExportUpdated);
    };
    Object.defineProperty(FecExportList.prototype, "fields", {
        get: function () {
            var _this = this;
            return [
                {
                    key: 'created_at',
                    label: 'Date de création',
                    formatter: function (value) {
                        return _this.datetime(value);
                    }
                },
                {
                    key: 'datas',
                    label: 'Données',
                    sortable: false,
                    formatter: function (value) {
                        if (!value) {
                            return null;
                        }
                        return value.map(function (value) {
                            switch (value) {
                                case 'sales':
                                    return 'Ventes';
                                case 'charges':
                                    return 'Charges';
                                case 'bank':
                                    return 'Banque';
                                case 'cash':
                                    return 'Caisse';
                            }
                        }).join(', ');
                    }
                },
                {
                    label: 'Filtre(s)',
                    sortable: false,
                    key: 'begin'
                },
                {
                    key: 'status',
                    label: 'Statut',
                    formatter: function (value, key, item) {
                        if (_this.isExpired(item.expire_at)) {
                            return 'Expiré';
                        }
                        switch (value) {
                            case 2:
                                return 'En cours';
                            case 3:
                                return 'Terminé';
                            default:
                                return 'En attente';
                        }
                    }
                },
                {
                    key: 'id',
                    label: '',
                    thStyle: {
                        width: '120px'
                    },
                    tdClass: 'text-center'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    FecExportList.prototype.items = function (ctx) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwSales.axios.get(this.apiUrl, {
                            params: {
                                page: ctx.currentPage,
                                per_page: ctx.perPage,
                                sort: ctx.sortBy + ':' + (ctx.sortDesc ? 'desc' : 'asc')
                            }
                        })];
                    case 1:
                        response = _a.sent();
                        this.total = response.data.meta.total;
                        return [2 /*return*/, response.data.data];
                }
            });
        });
    };
    Object.defineProperty(FecExportList.prototype, "isExpired", {
        get: function () {
            return function (date) { return external_moment_default()(date).isBefore(); };
        },
        enumerable: false,
        configurable: true
    });
    FecExportList.prototype.fecExportUpdated = function (fecExport) {
        var index = this.datas.findIndex(function (val) { return val.id === fecExport.id; });
        if (index >= 0) {
            lib/* Vue */.lD.set(this.datas, index, fecExport);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/fec/export' })
    ], FecExportList.prototype, "apiUrl", void 0);
    FecExportList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BTable: external_bootstrap_vue_.BTable, BPagination: external_bootstrap_vue_.BPagination, BProgress: external_bootstrap_vue_.BProgress, BProgressBar: external_bootstrap_vue_.BProgressBar, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], FecExportList);
    return FecExportList;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, FecMixin/* default */.A)));
/* harmony default export */ var FecExportListvue_type_script_lang_ts_external = (FecExportList);

;// ./src/components/FecExportList/FecExportList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FecExportList_FecExportListvue_type_script_lang_ts_external = (FecExportListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/FecExportList/FecExportList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FecExportList_FecExportListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FecExportList_FecExportList = (component.exports);

/***/ }),

/***/ 77075:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ 77128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CommissionView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommissionView.vue?vue&type=template&id=68f9f174
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CommissionList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CommissionList/CommissionList.vue + 3 modules
var CommissionList = __webpack_require__(72706);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommissionView.vue?vue&type=script&lang=ts



var CommissionView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionView, _super);
    function CommissionView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommissionView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommissionList: CommissionList/* default */.A
            }
        })
    ], CommissionView);
    return CommissionView;
}(lib/* Vue */.lD));
/* harmony default export */ var CommissionViewvue_type_script_lang_ts = (CommissionView);

;// ./src/views/CommissionView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CommissionViewvue_type_script_lang_ts = (CommissionViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/CommissionView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CommissionViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CommissionView = (component.exports);

/***/ }),

/***/ 77234:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'file-contract';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f56c';
var svgPathData = 'M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.IJ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 77329:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ 77387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CheckDepositListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CheckDepositListView.vue?vue&type=template&id=05fdf79e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CheckDepositList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CheckDepositList/CheckDepositList.vue?vue&type=template&id=3d3f7ada
var CheckDepositListvue_type_template_id_3d3f7ada_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-table',{ref:"table",attrs:{"url":"/sales/check-deposit","columns":_vm.columns,"filters":_vm.filters,"rowLink":_vm.rowLink,"rowActions":_vm.rowActions,"stateKey":"sepa-deposit-list"}}),_c('CheckDepositDelete',{attrs:{"element":"modal","modal":_vm.deleteIndex !== null},on:{"deleted":_vm.deleted,"closed":_vm.cancelDelete},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}})],1)
}
var CheckDepositListvue_type_template_id_3d3f7ada_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: ./src/components/CheckDepositDelete/CheckDepositDelete.vue + 3 modules
var CheckDepositDelete = __webpack_require__(40397);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CheckDepositList/CheckDepositList.ts?vue&type=script&lang=ts&external




var CheckDepositList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CheckDepositList, _super);
    function CheckDepositList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteModel = null;
        _this.deleteIndex = null;
        return _this;
    }
    Object.defineProperty(CheckDepositList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'date',
                    name: 'Date',
                    render: 'date'
                },
                {
                    data: 'total',
                    name: 'Total',
                    render: 'currency'
                },
                {
                    data: 'count',
                    name: 'Nombre de chèque'
                },
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CheckDepositList.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'period',
                    label: 'Date de création',
                    name: 'created_at',
                    name2: 'created_until'
                },
                {
                    type: 'select',
                    label: 'Statut',
                    name: 'status',
                    options: [
                        { label: 'Brouillon', value: 1 },
                        { label: 'Validé', value: 2 }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CheckDepositList.prototype.rowLink = function (row) {
        return {
            name: 'check-deposit-item',
            params: { id: String(row.id) }
        };
    };
    Object.defineProperty(CheckDepositList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    link: function (deposit) { return ({
                        name: 'check-deposit-form',
                        params: { id: String(deposit.id) }
                    }); }
                },
                {
                    icon: 'delete',
                    click: function (model, index) {
                        _this.deleteModel = model;
                        _this.deleteIndex = index;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CheckDepositList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.deleteModel = null;
        }
    };
    CheckDepositList.prototype.cancelDelete = function () {
        this.deleteIndex = null;
        this.deleteModel = null;
    };
    CheckDepositList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                CheckDepositDelete: CheckDepositDelete/* default */.A
            }
        })
    ], CheckDepositList);
    return CheckDepositList;
}(lib/* Vue */.lD));
/* harmony default export */ var CheckDepositListvue_type_script_lang_ts_external = (CheckDepositList);

;// ./src/components/CheckDepositList/CheckDepositList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CheckDepositList_CheckDepositListvue_type_script_lang_ts_external = (CheckDepositListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CheckDepositList/CheckDepositList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CheckDepositList_CheckDepositListvue_type_script_lang_ts_external,
  CheckDepositListvue_type_template_id_3d3f7ada_render,
  CheckDepositListvue_type_template_id_3d3f7ada_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CheckDepositList_CheckDepositList = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CheckDepositListView.vue?vue&type=script&lang=ts



var CheckDepositListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CheckDepositListView, _super);
    function CheckDepositListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckDepositListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CheckDepositList: CheckDepositList_CheckDepositList
            }
        })
    ], CheckDepositListView);
    return CheckDepositListView;
}(lib/* Vue */.lD));
/* harmony default export */ var CheckDepositListViewvue_type_script_lang_ts = (CheckDepositListView);

;// ./src/views/CheckDepositListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CheckDepositListViewvue_type_script_lang_ts = (CheckDepositListViewvue_type_script_lang_ts); 
;// ./src/views/CheckDepositListView.vue





/* normalize component */
;
var CheckDepositListView_component = (0,componentNormalizer/* default */.A)(
  views_CheckDepositListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CheckDepositListView = (CheckDepositListView_component.exports);

/***/ }),

/***/ 77556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(51873),
    arrayMap = __webpack_require__(34932),
    isArray = __webpack_require__(56449),
    isSymbol = __webpack_require__(44394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 77619:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'palette';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f53f';
var svgPathData = 'M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.fy = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 77797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(44394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 77836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractDeadlinesBill_ContractDeadlinesBill; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractDeadlinesBill/ContractDeadlinesBill.vue?vue&type=template&id=5d720a84
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value !== null)?_c('FormModal',{attrs:{"visible":_vm.value !== null,"ok-title":!_vm.errorMsg ? 'Facturer' : 'Fermer',"ok-only":_vm.errorMsg,"title":"Facturation d'une échéance"},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[(_vm.errorMsg)?_c('div',{staticClass:"text-danger font-weight-bold text-center"},[_vm._v(" Erreur : "+_vm._s(_vm.errorMsg)+" ")]):_c('k-form',{attrs:{"action":'/sales/contract/deadline/' + _vm.value.id + '/bill'},on:{"submitComplete":_vm.success,"submitError":_vm.submitError}},[_c('b-form-group',{attrs:{"label":"Date de la facture"}},[_c('k-form-datepicker',{attrs:{"name":"date","required":"","min-date":_vm.minDate,"max-date":!_vm.teamConfigs.sales_disable_date_check ? _vm.today : null},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.isDraft}}),_c('k-form-checkbox',{model:{value:(_vm.isDraft),callback:function ($$v) {_vm.isDraft=$$v},expression:"isDraft"}},[_vm._v(" Créer la facture en brouillon ")]),_c('b-alert',{staticClass:"mt-3 mb-0",attrs:{"show":!_vm.isDraft,"variant":"danger"}},[_vm._v(" Attention, la facture ne sera pas modifiable ")])],1)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractDeadlinesBill/ContractDeadlinesBill.ts?vue&type=script&lang=ts&external







var ContractDeadlinesBill = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractDeadlinesBill, _super);
    function ContractDeadlinesBill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDraft = true;
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        _this.errorMsg = null;
        _this.today = null;
        return _this;
    }
    ContractDeadlinesBill.prototype.mounted = function () {
        this.today = external_moment_default()().format('YYYY-MM-DD');
    };
    Object.defineProperty(ContractDeadlinesBill.prototype, "minDate", {
        get: function () {
            var closed_period = null;
            if (this.team.sales['closed_period']) {
                closed_period = external_moment_default()(this.team.sales['closed_period']).add(1, 'day').format('YYYY-MM-DD');
            }
            var min = null;
            if (!this.teamConfigs.sales_disable_date_check) {
                min = this.team.sales['invoice_date'];
            }
            if (min && (!closed_period || external_moment_default()(min).isAfter(closed_period))) {
                return min;
            }
            else if (closed_period) {
                return closed_period;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    ContractDeadlinesBill.prototype.watchValue = function () {
        this.errorMsg = null;
    };
    ContractDeadlinesBill.prototype.success = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({ name: 'invoice-item', params: { id: response.data.id } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractDeadlinesBill.prototype.submitError = function (error) {
        var _a;
        this.errorMsg = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlinesBill.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDeadlinesBill.prototype, "contract", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ContractDeadlinesBill.prototype, "watchValue", null);
    ContractDeadlinesBill = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, KFormDatepicker: form_vue_.KFormDatepicker, BAlert: external_bootstrap_vue_.BAlert,
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox,
                FormModal: interface_vue_.FormModal
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'team']))
        })
    ], ContractDeadlinesBill);
    return ContractDeadlinesBill;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractDeadlinesBillvue_type_script_lang_ts_external = (ContractDeadlinesBill);

;// ./src/components/ContractDeadlinesBill/ContractDeadlinesBill.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractDeadlinesBill_ContractDeadlinesBillvue_type_script_lang_ts_external = (ContractDeadlinesBillvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractDeadlinesBill/ContractDeadlinesBill.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractDeadlinesBill_ContractDeadlinesBillvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDeadlinesBill_ContractDeadlinesBill = (component.exports);

/***/ }),

/***/ 77853:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ 78096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 78474:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ 79088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SignDelete_SignDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SignDelete/SignDelete.vue?vue&type=template&id=541363ea
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer cette demande de signature ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SignDelete/SignDelete.ts?vue&type=script&lang=ts&external




var SignDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignDelete, _super);
    function SignDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(SignDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    SignDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    SignDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    SignDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/signature/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    SignDelete.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    SignDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    SignDelete.prototype.deleted = function () {
        this.$emit('deleted', this.value);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SignDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], SignDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], SignDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SignDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SignDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SignDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SignDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], SignDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], SignDelete.prototype, "watchModalState", null);
    SignDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], SignDelete);
    return SignDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var SignDeletevue_type_script_lang_ts_external = (SignDelete);

;// ./src/components/SignDelete/SignDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SignDelete_SignDeletevue_type_script_lang_ts_external = (SignDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SignDelete/SignDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SignDelete_SignDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignDelete_SignDelete = (component.exports);

/***/ }),

/***/ 79146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionPaymentItem_CommissionPaymentItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionPaymentItem/CommissionPaymentItem.vue?vue&type=template&id=47055f22
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"size":"xl"},on:{"hidden":function($event){return _vm.$emit('hidden')}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-form-row',{staticClass:"w-100"},[_c('b-col',[(_vm.can('sales-commissions', 3))?_c('b-button',{staticClass:"d-inline-block mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.edit.apply(null, arguments)}}},[_vm._v(" Modifier ")]):_vm._e(),(_vm.can('sales-commissions', 4))?_c('CommissionPaymentDelete',{staticClass:"d-inline-block",on:{"deleted":_vm.deleted},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" Fermer ")])],1)],1)]}}]),model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(!_vm.payment || _vm.loading)?_c('Spinner'):[_c('b-row',{attrs:{"cols":"3"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Date"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.date))+" ")])],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Commercial"}},[_vm._v(" "+_vm._s(_vm.value.team_user?.fullname)+" ")])],1),_c('b-col',[_c('b-form-group',{staticClass:"font-weight-bold text-danger",attrs:{"label":"Montant"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.amount))+" ")])],1)],1),_c('h2',{staticClass:"form-title-alt mt-2 border-bottom-0 mb-0"},[_vm._v(" Commissions ")]),_c('b-table',{attrs:{"items":_vm.payment.commissions,"fields":_vm.columns,"small":"","bordered":"","striped":"","perPage":_vm.perPage,"currentPage":_vm.page,"foot-clone":""},scopedSlots:_vm._u([{key:"cell(remove)",fn:function({ item }){return [(_vm.payment.commissions.length > 1)?_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: 'Retirer la commission' }),expression:"{ title: 'Retirer la commission' }"}],staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.removeCommission(item)}}}):_vm._e()]}},{key:"foot(date)",fn:function(){return [_vm._v("   ")]},proxy:true},{key:"foot(document_reference)",fn:function(){return [_c('p',{staticClass:"text-right mb-0"},[_vm._v("Total :")])]},proxy:true},{key:"foot(amount)",fn:function(){return [_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.payment.amount))+" ")]},proxy:true}])}),_c('b-pagination',{staticClass:"mb-0",attrs:{"perPage":_vm.perPage,"totalRows":_vm.payment.commissions?.length,"size":"sm","align":"center"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/CommissionPaymentDelete/CommissionPaymentDelete.vue + 3 modules
var CommissionPaymentDelete = __webpack_require__(17870);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./src/fetchDatas/checkCommissionPayment.ts
var checkCommissionPayment = __webpack_require__(82819);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionPaymentItem/CommissionPaymentItem.ts?vue&type=script&lang=ts&external








var CommissionPaymentItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionPaymentItem, _super);
    function CommissionPaymentItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.page = 1;
        _this.perPage = 20;
        _this.payment = null;
        _this.columns = [
            {
                label: 'Date',
                key: 'date',
                formatter: function (date) { return _this.date(date); },
            },
            {
                label: 'Document',
                key: 'document_reference'
            },
            {
                label: 'Montant',
                key: 'amount',
                formatter: function (amount) { return _this.formattedNumber(amount); },
            }
        ];
        return _this;
    }
    Object.defineProperty(CommissionPaymentItem.prototype, "paymentUse", {
        get: function () {
            var _this = this;
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c.find(function (document) { var _a, _b; return document.document_type === ((_a = _this.value) === null || _a === void 0 ? void 0 : _a.document_type) && document.document_id === ((_b = _this.value) === null || _b === void 0 ? void 0 : _b.document_id); })) !== null && _d !== void 0 ? _d : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionPaymentItem.prototype, "withMinimum", {
        get: function () {
            return this.value !== null && this.value.minimum !== null && this.value.minimum === this.value.amount;
        },
        enumerable: false,
        configurable: true
    });
    CommissionPaymentItem.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.modalState = this.value !== null;
                        if (!this.value) return [3 /*break*/, 2];
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, (0,checkCommissionPayment/* fetchCommissionPayment */.Os)(this.value.id)];
                    case 1:
                        _a.payment = _b.sent();
                        this.loading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CommissionPaymentItem.prototype.watchModal = function () {
        this.modalState = this.modal;
    };
    CommissionPaymentItem.prototype.deleted = function () {
        this.$emit('deleted', this.value);
        this.modalState = false;
    };
    CommissionPaymentItem.prototype.edit = function () {
        this.$emit('edit', this.value);
        this.modalState = false;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommissionPaymentItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommissionPaymentItem.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CommissionPaymentItem.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CommissionPaymentItem.prototype, "watchModal", null);
    CommissionPaymentItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BFormRow: external_bootstrap_vue_.BFormRow, BFormGroup: external_bootstrap_vue_.BFormGroup, BModal: external_bootstrap_vue_.BModal, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BTable: external_bootstrap_vue_.BTable, BPagination: external_bootstrap_vue_.BPagination,
                CommissionPaymentDelete: CommissionPaymentDelete/* default */.A,
                Spinner: interface_vue_.Spinner
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], CommissionPaymentItem);
    return CommissionPaymentItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var CommissionPaymentItemvue_type_script_lang_ts_external = (CommissionPaymentItem);

;// ./src/components/CommissionPaymentItem/CommissionPaymentItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionPaymentItem_CommissionPaymentItemvue_type_script_lang_ts_external = (CommissionPaymentItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionPaymentItem/CommissionPaymentItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionPaymentItem_CommissionPaymentItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionPaymentItem_CommissionPaymentItem = (component.exports);

/***/ }),

/***/ 79402:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ 79506:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'do-not-enter';
var width = 496;
var height = 512;
var ligatures = [];
var unicode = 'f5ec';
var svgPathData = 'M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm176 296H72c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h352c8.84 0 16 7.16 16 16v64c0 8.84-7.16 16-16 16z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.WW = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 79680:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ 79770:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 79834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ 79846:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
              ? format[key][0]
              : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ 80079:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(63702),
    listCacheDelete = __webpack_require__(70080),
    listCacheGet = __webpack_require__(24739),
    listCacheHas = __webpack_require__(48655),
    listCacheSet = __webpack_require__(31175);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 80153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AccountSync_AccountSync; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountSync/AccountSync.vue?vue&type=template&id=08abb0ae
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.computedElement,_vm._b({tag:"component",on:{"click":function($event){$event.preventDefault();return _vm.buttonClick.apply(null, arguments)}}},'component',_vm.elementAttributes,false),[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close'),"title":"Synchronisation des comptes bancaires","size":_vm.hasntAccount ? 'md' : (_vm.connectionId !== null ? 'lg' : 'xl'),"body-class":"accounts-sync-config"},on:{"hidden":_vm.modalHidden},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.waitingConnection)?_c('div',{staticClass:"text-center"},[_c('Spinner'),_vm._v(" Synchronisation en cours d'initialisation... ")],1):(_vm.hasntAccount)?[_c('p',{staticClass:"text-center"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.newSync.apply(null, arguments)}}},[_vm._v(" Synchroniser ma banque ")])],1)]:[_c('b-overlay',{attrs:{"show":_vm.saving}},[(!_vm.connectionId)?_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.newSync}},[_vm._v(" Connecter une nouvelle banque ")]):_vm._e(),_vm._l((_vm.computedBanks),function(bank,i){return [(_vm.connectionId === null)?_c('h3',{key:'bank-' + i,staticClass:"form-title-alt",class:{ 'mt-3': i === 0, 'mt-5': i > 0 }},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(bank.name)+" ")]),_c('b-col',{staticClass:"text-right"},[_vm._v(" Synchronisation : "),_c('span',{class:{
                  'font-weight-bold': true,
                  'text-success': bank.status === 0,
                  'text-danger': bank.status !== 0
                }},[_vm._v(" "+_vm._s(_vm.status(bank.status))+" ")])]),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toDeleteBank = bank}}},[_vm._v(" Supprimer la synchronisation ")])],1)],1)],1):_c('p',{key:'bank-' + i,staticClass:"font-weight-bold text-danger text-center"},[_vm._v(" La connexion avec la banque a bien été effectuée."),_c('br'),_vm._v(" Vous devez maintenant sélectionner ci-dessous le(s) compte(s) bancaire(s) à synchroniser. ")]),_c('table',{key:'bank-accounts-' + i,staticClass:"table table-sm table-bordered mb-1 align-middle text-nowrap text-center"},[_c('thead',[_c('tr',{staticClass:"small"},[_c('th',{staticClass:"text-left"},[_vm._v("Nom")]),_c('th',[_vm._v("Type")]),(_vm.connectionId === null)?[_c('th',[_vm._v("Devise")]),_c('th',{staticStyle:{"width":"230px"}},[_vm._v("Compte bancaire sur "+_vm._s(_vm.app.name))])]:_vm._e(),_c('th',{staticStyle:{"width":"130px"}},[_vm._v("Synchronisation")])],2)]),_c('tbody',_vm._l((_vm.computedAccounts(bank.accounts)),function(account,j){return _c('tr',{key:j},[_c('td',{staticClass:"text-left"},[_vm._v(" "+_vm._s(account.name)+" "),(account.iban)?_c('p',{staticClass:"mb-0 small text-muted"},[_vm._v(" IBAN : "+_vm._s(account.iban)+" ")]):_vm._e()]),_c('td',[_vm._v(_vm._s(_vm.accountType(account)))]),(_vm.connectionId === null)?[_c('td',[_vm._v(_vm._s(account.currency))]),_c('td',[_vm._v(" "+_vm._s(account?.account?.name)+" ")])]:_vm._e(),_c('td',[_c('b-form-radio-group',{attrs:{"buttons":"","size":"sm","button-variant":"success","options":[
                    { text: 'Oui', value: true },
                    { text: 'Non', value: false }
                  ]},on:{"input":val => _vm.updateSynchronization(account, val)},model:{value:(account.is_synced),callback:function ($$v) {_vm.$set(account, "is_synced", $$v)},expression:"account.is_synced"}})],1)],2)}),0)])]}),(_vm.toDeleteBank)?_c('ConfirmModal',{attrs:{"message":"Êtes-vous sûr de vouloir supprimer la connexion à cette banque ?","okTitle":_vm.$t('interface.delete')},on:{"confirmed":_vm.deleteBank,"hidden":function($event){_vm.toDeleteBank = null}}}):_vm._e()],2)]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AccountSync/AccountSync.ts?vue&type=script&lang=ts&external





var AccountSync = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AccountSync, _super);
    function AccountSync() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.connectionId = null;
        _this.waitingConnection = false;
        _this.loading = false;
        _this.saving = false;
        _this.banks = null;
        _this.toDeleteBank = null;
        return _this;
    }
    AccountSync.prototype.mounted = function () {
        var _a, _b, _c;
        if (((_a = this.$route.query) === null || _a === void 0 ? void 0 : _a.connection_id) !== undefined) {
            this.connectionId = ((_b = this.$route.query) === null || _b === void 0 ? void 0 : _b.connection_id) ? Number((_c = this.$route.query) === null || _c === void 0 ? void 0 : _c.connection_id) : null;
            this.modalState = true;
        }
        interface_vue_.emitter.on('bankCreated', this.onBankUpdated);
        interface_vue_.emitter.on('bankUpdated', this.onBankUpdated);
        interface_vue_.emitter.on('bankDeleted', this.onBankDeleted);
    };
    AccountSync.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('bankCreated', this.onBankUpdated);
        interface_vue_.emitter.off('bankUpdated', this.onBankUpdated);
        interface_vue_.emitter.off('bankDeleted', this.onBankDeleted);
    };
    AccountSync.prototype.onBankUpdated = function (bank) {
        if (!this.banks) {
            return;
        }
        var index = this.banks.findIndex(function (val) { return val.id === bank.id; });
        if (index < 0) {
            this.banks.push(bank);
        }
        else {
            lib/* Vue */.lD.set(this.banks, index, bank);
        }
        if (this.waitingConnection) {
            this.waitingConnection = false;
            this.$router.replace({ query: {} });
        }
    };
    AccountSync.prototype.onBankDeleted = function (bank) {
        if (!this.banks) {
            return;
        }
        var index = this.banks.findIndex(function (val) { return val.id === bank.id; });
        if (index >= 0) {
            lib/* Vue */.lD.delete(this.banks, index);
        }
    };
    Object.defineProperty(AccountSync.prototype, "elementAttributes", {
        get: function () {
            if (this.element !== 'button') {
                return {};
            }
            return {
                size: this.size,
                variant: this.variant,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountSync.prototype, "computedElement", {
        get: function () {
            switch (this.element) {
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return external_bootstrap_vue_.BButton;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountSync.prototype, "computedBanks", {
        get: function () {
            var _this = this;
            var _a;
            var banks = ((_a = this.banks) !== null && _a !== void 0 ? _a : []);
            if (this.connectionId) {
                return banks.filter(function (bank) { return bank.connection_id === _this.connectionId; });
            }
            return banks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountSync.prototype, "hasntAccount", {
        get: function () {
            return !this.banks || this.banks.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountSync.prototype, "status", {
        get: function () {
            return function (status) {
                switch (status) {
                    case -2:
                    case -3:
                        return 'Synchronisation en cours';
                    case 402:
                        return 'Erreur';
                    case 429:
                        return 'Erreur';
                    case 1003:
                        return 'Erreur';
                    case 1005:
                        return 'Compte non supporté';
                    case 1007:
                        return 'Synchronisation temporairement désactivée';
                    case 1010:
                        return 'Authentification requise';
                    case 1099:
                        return 'Compte migré vers une nouvelle banque';
                    case 1100:
                        return 'Authentification requise';
                    default:
                        return 'Active';
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountSync.prototype, "computedAccounts", {
        get: function () {
            return function (accounts) { return accounts
                .filter(function (account) { return account.type !== 'pending' && account.type !== 'special'; })
                .sort(function (a, b) {
                if (a.name < b.name)
                    return -1;
                else if (a.name > b.name)
                    return 1;
                else
                    return 0;
            }); };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountSync.prototype, "accountType", {
        get: function () {
            return function (account) {
                switch (account.type) {
                    case 'savings':
                        return 'Compte épargne';
                    case 'brokerage':
                        return 'Compte de courtage';
                    case 'card':
                        return 'Carte de crédit ou de débit';
                    case 'loan':
                        return 'Prêt';
                    case 'shared_saving_plan':
                        return 'PEA';
                    case 'life_insurance':
                        return 'Assurance vie';
                    case 'unknown':
                        return 'Inconnu';
                    default:
                        return 'Compte courant';
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    AccountSync.prototype.watchModalstate = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.modalState) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchBanks()];
                    case 1:
                        _a.sent();
                        if (this.connectionId && this.computedBanks.length === 0) {
                            this.waitingConnection = true;
                        }
                        if (!this.waitingConnection && this.directConnect !== false && (!this.banks || this.banks.length === 0)) {
                            this.newSync();
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AccountSync.prototype.fetchBanks = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/accounts-sync/bank')
                                .then(function (response) {
                                _this.banks = response.data;
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountSync.prototype.newSync = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.post('/accounts-sync/connect')
                                .then(function (response) {
                                window.location.href = response.data;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountSync.prototype.updateSynchronization = function (account, state) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.saving = true;
                        return [4 /*yield*/, this.$kwSales.axios.post('/accounts-sync/account/' + account.id + '/' + (state ? 'enable' : 'disable'))
                                .then(function () {
                                _this.loadAccounts(true);
                                _this.fetchBanks();
                                _this.saving = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountSync.prototype.deleteBank = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var id;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        id = (_a = this.toDeleteBank) === null || _a === void 0 ? void 0 : _a.id;
                        return [4 /*yield*/, this.$kwSales.axios.delete('/accounts-sync/bank/' + id)
                                .then(function () {
                                var _a, _b, _c;
                                var index = (_b = (_a = _this.banks) === null || _a === void 0 ? void 0 : _a.findIndex(function (bank) { return bank.id === id; })) !== null && _b !== void 0 ? _b : -1;
                                if (index > -1) {
                                    (_c = _this.banks) === null || _c === void 0 ? void 0 : _c.splice(index, 1);
                                }
                                _this.toDeleteBank = null;
                                _this.loadAccounts(true);
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountSync.prototype.modalHidden = function () {
        this.$emit('hidden');
        if (this.connectionId) {
            this.$router.replace({ query: {} });
            this.connectionId = null;
        }
    };
    AccountSync.prototype.buttonClick = function () {
        this.modalState = true;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], AccountSync.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Synchronisation' })
    ], AccountSync.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'sm' })
    ], AccountSync.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'secondary' })
    ], AccountSync.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AccountSync.prototype, "directConnect", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], AccountSync.prototype, "watchModalstate", null);
    AccountSync = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BOverlay: external_bootstrap_vue_.BOverlay, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio,
                Spinner: interface_vue_.Spinner, ConfirmModal: interface_vue_.ConfirmModal
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['app'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadAccounts']))
        })
    ], AccountSync);
    return AccountSync;
}(lib/* Vue */.lD));
/* harmony default export */ var AccountSyncvue_type_script_lang_ts_external = (AccountSync);

;// ./src/components/AccountSync/AccountSync.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AccountSync_AccountSyncvue_type_script_lang_ts_external = (AccountSyncvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/AccountSync/AccountSync.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AccountSync_AccountSyncvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccountSync_AccountSync = (component.exports);

/***/ }),

/***/ 80168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ QuotationList_QuotationList; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesListMixin/SalesListMixin.vue + 3 modules
var SalesListMixin = __webpack_require__(68067);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatus.ts
var SalesDocumentStatus = __webpack_require__(70468);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/QuotationList/QuotationList.ts?vue&type=script&lang=ts&external




var QuotationList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(QuotationList, _super);
    function QuotationList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'quotation';
        _this.additionalColumns = [
            {
                data: 'delivery_status_label',
                name: 'Statut de livraison',
                visible: false
            },
            {
                data: 'already_billed',
                name: 'Déjà facturé',
                visible: false,
                render: 'currency'
            },
            {
                data: 'pourcent_billed',
                name: '% facturé',
                visible: false,
                render: 'pourcent'
            },
            {
                data: 'to_bill',
                name: 'À facturer',
                visible: false,
                render: 'currency'
            },
            {
                data: 'pourcent_to_bill',
                name: '% à facturer',
                visible: false,
                render: 'pourcent'
            },
            {
                data: 'accepted_at',
                name: 'Date acceptation',
                visible: false,
                render: 'datetime'
            },
            {
                data: 'refused_at',
                name: 'Date refus',
                visible: false,
                render: 'datetime'
            }
        ];
        return _this;
    }
    Object.defineProperty(QuotationList.prototype, "status", {
        get: function () {
            return this.quotationStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotationList.prototype, "statusIndicator", {
        get: function () {
            return [
                { class: 'status-quotation-1', label: 'Brouillon' },
                { class: 'status-quotation-2', label: 'Validé' },
                { class: 'status-quotation-3', label: 'Envoyé' },
                { class: 'status-quotation-4', label: 'Accepté' },
                { class: 'status-quotation-7', label: 'Facturé' },
                { class: 'status-quotation-8', label: 'Annulé' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotationList.prototype, "computedFilters", {
        get: function () {
            var filters = Array.from(this.filters);
            filters.push({
                type: 'select',
                label: 'Statut de livraison',
                name: 'delivery_status',
                options: [
                    { id: 1, label: 'À livrer' },
                    { id: 2, label: 'Livré partiellement' },
                    { id: 3, label: 'Livré' }
                ],
                multiple: true,
                optionLabel: 'label',
                value: 'id'
            });
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    QuotationList.prototype.canBeEdited = function (quotation) {
        var _a;
        return quotation.total_ttc == 0 || ((_a = quotation.to_bill) !== null && _a !== void 0 ? _a : 0) > 0;
    };
    QuotationList = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], QuotationList);
    return QuotationList;
}((0,lib/* Mixins */.Xe)(SalesListMixin/* default */.A, SalesDocumentStatus/* default */.A)));
/* harmony default export */ var QuotationListvue_type_script_lang_ts_external = (QuotationList);

;// ./src/components/QuotationList/QuotationList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var QuotationList_QuotationListvue_type_script_lang_ts_external = (QuotationListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/QuotationList/QuotationList.vue
var render, staticRenderFns
;



/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  QuotationList_QuotationListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var QuotationList_QuotationList = (component.exports);

/***/ }),

/***/ 80200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractModelForm_ContractModelForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractModelForm/ContractModelForm.vue?vue&type=template&id=283228c8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle}}),_c('AppMessages'),(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c('k-form-input',{staticClass:"mb-4",attrs:{"required":"","placeholder":"Nom du modèle de contrat"},model:{value:(_vm.element.name),callback:function ($$v) {_vm.$set(_vm.element, "name", $$v)},expression:"element.name"}}),_c('b-tabs',{staticClass:"tabs-card mb-3"},[_c('b-tab',{attrs:{"title":"Options du contrat"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Renouvellement du contrat","description":"En automatique, le contrat sera renouvellé automatiquement un jour avant la date d'échéance et un nouvel échéancier sera généré."}},[_c('k-form-select',{attrs:{"options":_vm.renewOptions,"reduce":opt => opt.value,"clearable":false,"required":""},model:{value:(_vm.element.auto_renew),callback:function ($$v) {_vm.$set(_vm.element, "auto_renew", $$v)},expression:"element.auto_renew"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Mise à jour automatique des prix"}},[_c('k-form-select',{attrs:{"options":_vm.pricesUpdateOptions,"reduce":opt => opt.value,"clearable":false,"required":""},model:{value:(_vm.element.auto_update_prices),callback:function ($$v) {_vm.$set(_vm.element, "auto_update_prices", $$v)},expression:"element.auto_update_prices"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Le contenu du contrat correspond"}},[_c('k-form-select',{attrs:{"options":_vm.contentTypeOptions,"reduce":opt => opt.value,"clearable":false,"required":""},model:{value:(_vm.element.content_type),callback:function ($$v) {_vm.$set(_vm.element, "content_type", $$v)},expression:"element.content_type"}})],1),(_vm.element.content_type === 1)?[_c('k-form-checkbox',{model:{value:(_vm.element.deadline_for_payement),callback:function ($$v) {_vm.$set(_vm.element, "deadline_for_payement", $$v)},expression:"element.deadline_for_payement"}},[_vm._v(" Les échéances correspondent à des échéances de paiement et non à des dates de facturation. ")])]:_vm._e()],2)],1),_c('h3',{staticClass:"form-title-alt mt-5"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'calendar-alt']}}),_vm._v(" Génération des échéances ")],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Durée du contrat"}},[_c('b-input-group',{scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('k-form-select',{attrs:{"options":_vm.durationTypeOptions,"reduce":opt => opt.value,"clearable":false,"required":""},model:{value:(_vm.element.duration_type),callback:function ($$v) {_vm.$set(_vm.element, "duration_type", $$v)},expression:"element.duration_type"}})]},proxy:true}])},[_c('k-form-spinner',{attrs:{"min":1,"left":""},model:{value:(_vm.element.duration_value),callback:function ($$v) {_vm.$set(_vm.element, "duration_value", $$v)},expression:"element.duration_value"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Fréquence de facturation"}},[_c('k-form-select',{attrs:{"options":_vm.frequencyOptions,"reduce":opt => opt.value,"clearable":false,"required":""},model:{value:(_vm.element.billing_frequency),callback:function ($$v) {_vm.$set(_vm.element, "billing_frequency", $$v)},expression:"element.billing_frequency"}})],1)],1),_c('b-col')],1),_c('k-form-checkbox',{attrs:{"value":true},model:{value:(_vm.element.only_full_period),callback:function ($$v) {_vm.$set(_vm.element, "only_full_period", $$v)},expression:"element.only_full_period"}},[_c('p',{staticClass:"mb-0"},[_vm._v(" Créer uniquement des échéances se terminant par le dernier jour du mois ")]),_c('small',[_vm._v(" Ex. : Si un contrat commence le 15 du mois, la première échéance concernera la période du 15 au 30 et non du 15 au 15. ")])]),_c('h3',{staticClass:"form-title-alt mt-5"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'file-invoice']}}),_vm._v(" Facturation ")],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Condition de règlement"}},[_c('PaymentTermSelect',{attrs:{"clearable":false,"required":"","selectFirst":""},model:{value:(_vm.element.payment_term),callback:function ($$v) {_vm.$set(_vm.element, "payment_term", $$v)},expression:"element.payment_term"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Mode de règlement","description":"Si vous utilisez les mandats SEPA, attention à bien sélectionner un mode de règlement correspondant."}},[_c('PaymentMethodSelect',{attrs:{"clearable":false,"required":"","selectFirst":""},model:{value:(_vm.element.payment_method),callback:function ($$v) {_vm.$set(_vm.element, "payment_method", $$v)},expression:"element.payment_method"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Modèle PDF"}},[_c('PdfModelSelect',{attrs:{"clearable":false,"required":"","selectDefault":"invoice"},model:{value:(_vm.element.pdf_model),callback:function ($$v) {_vm.$set(_vm.element, "pdf_model", $$v)},expression:"element.pdf_model"}})],1)],1)],1),(!_vm.element.deadline_for_payement || _vm.element.content_type !== 1)?[_c('b-row',{staticClass:"mt-3 mb-3",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{attrs:{"value":true},model:{value:(_vm.element.create_invoice),callback:function ($$v) {_vm.$set(_vm.element, "create_invoice", $$v)},expression:"element.create_invoice"}},[_vm._v(" Créer automatiquement une facture ")])],1),_c('b-col',{staticClass:"pl-0",staticStyle:{"min-width":"250px"},attrs:{"cols":"auto"}},[_c('k-form-select',{attrs:{"disabled":!_vm.element.create_invoice,"options":_vm.invoiceMomentOptions,"reduce":opt => opt.value,"clearable":false,"required":""},model:{value:(_vm.element.create_invoice_moment),callback:function ($$v) {_vm.$set(_vm.element, "create_invoice_moment", $$v)},expression:"element.create_invoice_moment"}})],1)],1),(_vm.element.create_invoice)?[_c('h3',{staticClass:"form-title-alt"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'envelope']}}),_vm._v(" Envoi de la facture par email ")],1),_c('k-form-checkbox',{attrs:{"value":true},model:{value:(_vm.element.auto_send_invoice),callback:function ($$v) {_vm.$set(_vm.element, "auto_send_invoice", $$v)},expression:"element.auto_send_invoice"}},[_vm._v(" Envoyer automatiquement la facture par email ")]),(_vm.element.auto_send_invoice)?_c('b-form-group',{staticClass:"mt-3",attrs:{"label":"Message"}},[_c('k-form-editor',{attrs:{"size":"sm","config":_vm.editorConfig},model:{value:(_vm.element.send_message),callback:function ($$v) {_vm.$set(_vm.element, "send_message", $$v)},expression:"element.send_message"}})],1):_vm._e()]:_vm._e()]:_vm._e()],2),_c('b-tab',{attrs:{"title":"Contenu du contrat"}},[_c('p',{staticClass:"small"},[_vm._v(" Ajoutez ci-dessous les différents produits et prestations que vous vendez dans ce modèle de contrat. Il restera toujours possible d'en ajouter de nouveau lors de la mise en place d'un contrat avec un client. ")]),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('CatalogSearch',{attrs:{"include":{
                product: ['vat_rate'],
                service: ['vat_rate']
              }},on:{"selected":_vm.addCatalogLine}})],1),_c('b-col',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.addCommentLine}},[_vm._v(" Commentaire ")])],1)],1),_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm table-bordered mt-1 align-middle mb-0 text-nowrap contract-model-contents"},[_c('thead',[_c('tr',[_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}}),_c('th',[_vm._v("Référence / Nom")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Prix U. HT")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Taux TVA")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Quantité")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Total HT")]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),(_vm.element.contents.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"7"}},[_vm._v(" Aucun contenu ")])])]):_c('draggable',{attrs:{"tag":"tbody","handle":".draggable-handle"},model:{value:(_vm.element.contents),callback:function ($$v) {_vm.$set(_vm.element, "contents", $$v)},expression:"element.contents"}},_vm._l((_vm.element.contents),function(content,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center"},[_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}})],1),(content.is_comment)?[_c('td',{attrs:{"colspan":"5"}},[_c('k-form-editor',{attrs:{"mode":"simple","size":"sm","config":_vm.commentEditorConfig},model:{value:(_vm.element.contents[i].designation),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "designation", $$v)},expression:"element.contents[i].designation"}})],1)]:[_c('td',[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(content.catalog.element.reference)+" "),(content.catalog.element.reference)?[_vm._v("/")]:_vm._e(),_vm._v(" "+_vm._s(content.catalog.element.name)+" ")],2),_c('k-form-checkbox',{attrs:{"size":"sm"},on:{"input":function($event){return _vm.applyAutoPrice(i)}},model:{value:(_vm.element.contents[i].auto_update_price),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "auto_update_price", $$v)},expression:"element.contents[i].auto_update_price"}},[_vm._v(" Utiliser les prix du catalogue ")])],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":content.auto_update_price},on:{"input":function($event){return _vm.calculPrices(i)}},model:{value:(_vm.element.contents[i].unit_price_ht),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "unit_price_ht", $$v)},expression:"element.contents[i].unit_price_ht"}})],1)],1),_c('td',[_c('VatRateSelect',{attrs:{"size":"sm","required":""},model:{value:(_vm.element.contents[i].vat_rate),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "vat_rate", $$v)},expression:"element.contents[i].vat_rate"}})],1),_c('td',[_c('k-form-spinner',{attrs:{"size":"sm"},on:{"input":function($event){return _vm.calculPrices(i)}},model:{value:(_vm.element.contents[i].quantity),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "quantity", $$v)},expression:"element.contents[i].quantity"}})],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":content.auto_update_price},on:{"change":function($event){return _vm.setTotalPrice(i)}},model:{value:(_vm.element.contents[i].total_ht),callback:function ($$v) {_vm.$set(_vm.element.contents[i], "total_ht", $$v)},expression:"element.contents[i].total_ht"}})],1)],1)],_c('td',{staticClass:"text-center"},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: 'Supprimer la ligne' }),expression:"{ title: 'Supprimer la ligne' }",modifiers:{"left":true}}],staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.element.contents.splice(i, 1)}}})],1)],2)}),0)],1)]),_c('b-row',[_c('b-col'),_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered table-document-content align-middle"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total HT :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.totalHt, _vm.currency)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total TVA :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.totalTva, _vm.currency)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total TTC :")]),_c('td',{staticClass:"pl-3 text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.totalTtc, _vm.currency)))])])])])])],1)],1),_c('b-tab',{attrs:{"title":"Génération du contrat"}},[_c('p',[_vm._v(" Vous pouvez générer automatiquement les contrats à faire signer à vos clients. Pour cela, vous devez utiliser un document Word dans lequel, vous allez insérer des variables. ")]),_c('b-form-group',{attrs:{"label":"Modèle de contrat :"}},[(_vm.element.contract)?_c('div',{staticClass:"mt-2"},[_c('div',[_c('p',{staticClass:"text-center d-inline-block mb-1"},[_c('font-awesome-icon',{staticClass:"icon",style:({ color: '#5959ff', 'font-size': '2rem' }),attrs:{"icon":['fad', 'file-word' ]}}),_c('span',{staticClass:"d-inline-block text-truncate w-100 small pt-1"},[_vm._v(" "+_vm._s(_vm.element.contract.filename)+" ")])],1)]),_c('b-overlay',{attrs:{"show":_vm.loadingContract}},[_c('div',{staticClass:"my-2"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadContract.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toDelete = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])],1)]),_c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"no-close-on-esc":_vm.loadingDelete,"hide-header-close":_vm.loadingDelete,"no-close-on-backdrop":_vm.loadingDelete,"busy":_vm.loadingDelete},on:{"ok":_vm.deleteContract},model:{value:(_vm.toDelete),callback:function ($$v) {_vm.toDelete=$$v},expression:"toDelete"}},[(_vm.loadingDelete)?_c('Spinner'):_c('div',[_vm._v(" Êtes-vous sûr de vouloir supprimer le modèle de contrat ? ")])],1)],1):_c('div',[_c('small',{staticClass:"mb-2"},[_vm._v(" Fichier word (.docx) ou Open Office (.odt) uniquement. ")]),_c('k-form-file',{attrs:{"url":_vm.formAction,"method":_vm.formMethod,"datas":_vm.formDatas,"name":"contract","accept":['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text'],"btnMode":"","btnSize":"sm"},on:{"onUpload":_vm.fileUploaded}})],1)]),_c('b-form-group',{attrs:{"label":"Restriction des champs personnalisés :"}},[_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.element.restrict_custom_fields),callback:function ($$v) {_vm.$set(_vm.element, "restrict_custom_fields", $$v)},expression:"element.restrict_custom_fields"}},[_vm._v(" Lors de la création et la modification d'un contrat, n'afficher que les champs personnalisés présents dans le modèle de contrat. ")])],1),_c('b-overlay',{attrs:{"show":_vm.loadingDefaultModel}},[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Liste des variables dynamiques pouvant être utilisées dans le document Word ")]),_c('p',{staticClass:"mb-2"},[_vm._v(" Les variables seront automatiquement remplacées lors de la génération du contrat. ")]),_c('p',{staticClass:"mb-4"},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadDefaultModel.apply(null, arguments)}}},[_vm._v(" Télécharger le contrat d'exemple ")])],1),_c('b-tabs',[_c('b-tab',{attrs:{"title":"Client"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$customerName$")]),_c('td',[_vm._v("Nom")])]),_c('tr',[_c('td',[_vm._v("$customerReference$")]),_c('td',[_vm._v("Référence client")])]),_c('tr',[_c('td',[_vm._v("$customerCompanyType$")]),_c('td',[_vm._v("Type d'entreprise")])]),_c('tr',[_c('td',[_vm._v("$customerSiret$")]),_c('td',[_vm._v("N°SIRET")])]),_c('tr',[_c('td',[_vm._v("$customerRcs$")]),_c('td',[_vm._v("N°RCS")])]),_c('tr',[_c('td',[_vm._v("$customerVatrate$")]),_c('td',[_vm._v("N° de TVA intracommunautaire")])]),_c('tr',[_c('td',[_vm._v("$customerNaf$")]),_c('td',[_vm._v("Code NAF")])]),_c('tr',[_c('td',[_vm._v("$customerCapital$")]),_c('td',[_vm._v("Capital")])]),_c('tr',[_c('td',[_vm._v("$customerEmail$")]),_c('td',[_vm._v("Email")])]),_c('tr',[_c('td',[_vm._v("$customerWebsite$")]),_c('td',[_vm._v("Site internet")])]),_c('tr',[_c('td',[_vm._v("$customerPhone$")]),_c('td',[_vm._v("N° de téléphone")])]),_c('tr',[_c('td',[_vm._v("$customerMobile$")]),_c('td',[_vm._v("N° de portable")])]),_c('tr',[_c('td',[_vm._v("$customerFax$")]),_c('td',[_vm._v("N° de fax")])])])])]),_c('b-tab',{attrs:{"title":"Contact"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$contactName$")]),_c('td',[_vm._v("Nom complet")])]),_c('tr',[_c('td',[_vm._v("$contactCivility$")]),_c('td',[_vm._v("Civilité")])]),_c('tr',[_c('td',[_vm._v("$contactFirstname$")]),_c('td',[_vm._v("Prénom")])]),_c('tr',[_c('td',[_vm._v("$contactLastname$")]),_c('td',[_vm._v("Nom de famille")])]),_c('tr',[_c('td',[_vm._v("$contactEmail$")]),_c('td',[_vm._v("Email")])]),_c('tr',[_c('td',[_vm._v("$contactWebsite$")]),_c('td',[_vm._v("Site internet")])]),_c('tr',[_c('td',[_vm._v("$contactPhone$")]),_c('td',[_vm._v("N° de téléphone")])]),_c('tr',[_c('td',[_vm._v("$contactMobile$")]),_c('td',[_vm._v("N° de portable")])]),_c('tr',[_c('td',[_vm._v("$contactFax$")]),_c('td',[_vm._v("N° de fax")])])])])]),_c('b-tab',{attrs:{"title":"Commercial"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$commercialFullname$")]),_c('td',[_vm._v("Nom complet")])]),_c('tr',[_c('td',[_vm._v("$commercialFirstname$")]),_c('td',[_vm._v("Prénom")])]),_c('tr',[_c('td',[_vm._v("$commercialLastname$")]),_c('td',[_vm._v("Nom")])]),_c('tr',[_c('td',[_vm._v("$commercialPhone$")]),_c('td',[_vm._v("Téléphone")])]),_c('tr',[_c('td',[_vm._v("$commercialMobile$")]),_c('td',[_vm._v("Portable")])]),_c('tr',[_c('td',[_vm._v("$commercialEmail$")]),_c('td',[_vm._v("Email")])])])])]),_c('b-tab',{attrs:{"title":"Contrat"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$contractAddress$")]),_c('td',[_vm._v("Adresse de facturation complète")])]),_c('tr',[_c('td',[_vm._v("$contractRoad1$")]),_c('td',[_vm._v("Adresse de facturation - Rue 1")])]),_c('tr',[_c('td',[_vm._v("$contractRoad2$")]),_c('td',[_vm._v("Adresse de facturation - Rue 2")])]),_c('tr',[_c('td',[_vm._v("$contractRoad3$")]),_c('td',[_vm._v("Adresse de facturation - Rue 3")])]),_c('tr',[_c('td',[_vm._v("$contractPostalCode$")]),_c('td',[_vm._v("Adresse de facturation - Code postal")])]),_c('tr',[_c('td',[_vm._v("$contractTown$")]),_c('td',[_vm._v("Adresse de facturation - Ville")])]),_c('tr',[_c('td',[_vm._v("$contractCountry$")]),_c('td',[_vm._v("Adresse de facturation - Pays")])]),_c('tr',[_c('td',[_vm._v("$contractReference$")]),_c('td',[_vm._v("Référence du contrat")])]),_c('tr',[_c('td',[_vm._v("$contractPeriodBegin$")]),_c('td',[_vm._v("Début de la période")])]),_c('tr',[_c('td',[_vm._v("$contractPeriodEnd$")]),_c('td',[_vm._v("Fin de la période")])]),_c('tr',[_c('td',[_vm._v("$contractTitle$")]),_c('td',[_vm._v("Titre du contrat")])]),_c('tr',[_c('td',[_vm._v("$contractSignDate$")]),_c('td',[_vm._v("Date de signature")])]),_c('tr',[_c('td',[_vm._v("$contractSignBlock$")]),_c('td',[_vm._v("Emplacement pour la signature électronique")])]),_c('tr',[_c('td',[_vm._v("$contractCustomerCommandReference$")]),_c('td',[_vm._v("N° du bon de commande client")])]),_c('tr',[_c('td',[_vm._v("$contractPaymentTerm$")]),_c('td',[_vm._v("Condition de paiement")])]),_c('tr',[_c('td',[_vm._v("$contractPaymentMethod$")]),_c('td',[_vm._v("Mode de règlement")])]),_c('tr',[_c('td',[_vm._v("$contractFrequency$")]),_c('td',[_vm._v("Fréquence de facturation")])]),_c('tr',[_c('td',[_vm._v("$contractTotalHtWithoutDiscount$")]),_c('td',[_vm._v("Total HT sans remise générale")])]),_c('tr',[_c('td',[_vm._v("$contractTotalTvaWithoutDiscount$")]),_c('td',[_vm._v("Total TVA sans remise générale")])]),_c('tr',[_c('td',[_vm._v("$contractTotalTtcWithoutDiscount$")]),_c('td',[_vm._v("Total TTC sans remise générale")])]),_c('tr',[_c('td',[_vm._v("$contractDiscountHt$")]),_c('td',[_vm._v("Montant HT de la remise générale")])]),_c('tr',[_c('td',[_vm._v("$contractDiscountTva$")]),_c('td',[_vm._v("Montant TVA de la remise générale")])]),_c('tr',[_c('td',[_vm._v("$contractDiscountTtc$")]),_c('td',[_vm._v("Montant TTC de la remise générale")])]),_c('tr',[_c('td',[_vm._v("$contractTotalHt$")]),_c('td',[_vm._v("Total HT")])]),_c('tr',[_c('td',[_vm._v("$contractTotalTva$")]),_c('td',[_vm._v("Total TVA")])]),_c('tr',[_c('td',[_vm._v("$contractTotalTtc$")]),_c('td',[_vm._v("Total TTC")])])])])]),_c('b-tab',{attrs:{"title":"Contenu du contrat"}},[_c('p',[_vm._v(" Le contenu doit être inséré dans un tableau sur une même ligne."),_c('br'),_vm._v(" Le ligne sera automatiquement dupliquée en fonction du nombre de ligne dans votre contrat. ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$contentReference$")]),_c('td',[_vm._v("Référence")])]),_c('tr',[_c('td',[_vm._v("$contentDesignation$")]),_c('td',[_vm._v("Désignation")])]),_c('tr',[_c('td',[_vm._v("$contentPrixUHt$")]),_c('td',[_vm._v("Prix unitaire HT")])]),_c('tr',[_c('td',[_vm._v("$contentPrixUTva$")]),_c('td',[_vm._v("Prix unitaire TVA")])]),_c('tr',[_c('td',[_vm._v("$contentPrixUTtc$")]),_c('td',[_vm._v("Prix unitaire TTC")])]),_c('tr',[_c('td',[_vm._v("$contentQty$")]),_c('td',[_vm._v("Quantité")])]),_c('tr',[_c('td',[_vm._v("$contentTotalHt$")]),_c('td',[_vm._v("Total HT")])]),_c('tr',[_c('td',[_vm._v("$contentTotalTva$")]),_c('td',[_vm._v("Total TVA")])]),_c('tr',[_c('td',[_vm._v("$contentTotalTtc$")]),_c('td',[_vm._v("Total TTC")])]),_c('tr',[_c('td',[_vm._v("$contentVatRate$")]),_c('td',[_vm._v("Taux de TVA")])])])])]),_c('b-tab',{attrs:{"title":"Échéances du contrat"}},[_c('p',[_vm._v(" Une échéance doit être insérée dans un tableau sur une même ligne."),_c('br'),_vm._v(" Le ligne sera automatiquement dupliquée en fonction du nombre d'échéance dans votre contrat. ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$dueBegin$")]),_c('td',[_vm._v("Début de la période")])]),_c('tr',[_c('td',[_vm._v("$dueEnd$")]),_c('td',[_vm._v("Fin de la période")])]),_c('tr',[_c('td',[_vm._v("$dueDate$")]),_c('td',[_vm._v("Date de l'échéance")])]),_c('tr',[_c('td',[_vm._v("$dueAmount$")]),_c('td',[_vm._v("Montant")])])])])]),(_vm.getCustomFields(['contract']).length > 0)?_c('b-tab',{attrs:{"title":"Champs personnalisés"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_vm._l((_vm.getCustomFields('contract')),function(field,i){return [_c('tr',{key:i},[_c('td',[_vm._v("$customField"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(" "+_vm._s(field.label)+" "),(field.type === 'checkbox')?_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" Sous forme de texte. Les valeurs seront séparées par \", \". ")]):_vm._e()])]),(field.type === 'checkbox')?_c('tr',{key:i + '-multiple'},[_c('td',[_vm._v("$customFieldList"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(" "+_vm._s(field.label)+" "),_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" Sous forme de liste. Chaque valeur sera alors affichée sur une nouvelle ligne. Il est possible d'utiliser des listes à puce. ")])])]):_vm._e()]})],2)])]):_vm._e(),(_vm.getCustomFields(['customer']).length > 0)?_c('b-tab',{attrs:{"title":"Champs personnalisés du client"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_vm._l((_vm.getCustomFields('customer')),function(field,i){return [_c('tr',{key:i},[_c('td',[_vm._v("$customField"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(" "+_vm._s(field.label)+" "),(field.type === 'checkbox')?_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" Sous forme de texte. Les valeurs seront séparées par \", \". ")]):_vm._e()])]),(field.type === 'checkbox')?_c('tr',{key:i + '-multiple'},[_c('td',[_vm._v("$customFieldList"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(" "+_vm._s(field.label)+" "),_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" Sous forme de liste. Chaque valeur sera alors affichée sur une nouvelle ligne. Il est possible d'utiliser des listes à puce. ")])])]):_vm._e()]})],2)])]):_vm._e()],1)],1)],1),_c('b-tab',{attrs:{"title":"Document(s) à fournir par le client"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addDocument.apply(null, arguments)}}},[_vm._v(" Ajouter un document ")]),_c('table',{staticClass:"table table-sm table-bordered mt-1 align-middle mb-0"},[(_vm.element.documents.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"3"}},[_vm._v(" Aucun document ")])])]):_c('draggable',{attrs:{"tag":"tbody","handle":".draggable-handle"},model:{value:(_vm.element.documents),callback:function ($$v) {_vm.$set(_vm.element, "documents", $$v)},expression:"element.documents"}},_vm._l((_vm.element.documents),function(content,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center",staticStyle:{"width":"25px"}},[_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}})],1),_c('td',[_c('k-form-input',{attrs:{"required":"","placeholder":"Nom du document à fournir"},model:{value:(_vm.element.documents[i].label),callback:function ($$v) {_vm.$set(_vm.element.documents[i], "label", $$v)},expression:"element.documents[i].label"}}),_c('k-form-textarea',{staticClass:"mt-1",attrs:{"placeholder":"Ajouter une description du document (facultatif)","size":"sm"},model:{value:(_vm.element.documents[i].description),callback:function ($$v) {_vm.$set(_vm.element.documents[i], "description", $$v)},expression:"element.documents[i].description"}})],1),_c('td',{staticClass:"p-0 text-center",staticStyle:{"width":"25px"}},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: 'Supprimer le document' }),expression:"{ title: 'Supprimer le document' }",modifiers:{"left":true}}],staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.element.documents.splice(i, 1)}}})],1)])}),0)],1)],1)],1),_c('k-form-sticky-bar',{attrs:{"parent":"#content"}},[_c('b-button',{attrs:{"variant":"secondary","to":{ name: 'contract-models-list' }}},[_vm._v(" Annuler ")]),_c('b-button',{staticClass:"ml-3",attrs:{"type":"submit","variant":"primary"}},[_vm._v(" Enregistrer ")])],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/ContractMail/editorConfig.ts
var editorConfig = __webpack_require__(59368);
// EXTERNAL MODULE: ./src/mixins/ContractFormMixin.ts
var ContractFormMixin = __webpack_require__(4614);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractModelForm/ContractModelForm.ts?vue&type=script&lang=ts&external







var ContractModelForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractModelForm, _super);
    function ContractModelForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = {
            contents: [],
            documents: []
        };
        _this.editorConfig = editorConfig/* default */.A;
        _this.toDelete = false;
        _this.loadingDelete = false;
        _this.loadingContract = false;
        _this.loadingDefaultModel = false;
        return _this;
    }
    Object.defineProperty(ContractModelForm.prototype, "pageTitle", {
        get: function () {
            return (this.element.id ? 'Modification' : 'Création') + ' d\'un modèle de contrat';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractModelForm.prototype, "formAction", {
        get: function () {
            var url = '/sales/contract-model';
            if (this.element.id) {
                url += '/' + this.element.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractModelForm.prototype, "formMethod", {
        get: function () {
            return this.element.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractModelForm.prototype, "formDatas", {
        get: function () {
            var _a, _b, _c, _d;
            var model = this.element;
            return {
                name: model.name,
                auto_renew: model.auto_renew,
                auto_update_prices: model.auto_update_prices,
                content_type: model.content_type,
                deadline_for_payement: model.deadline_for_payement,
                duration_value: model.duration_value,
                duration_type: model.duration_type,
                billing_frequency: model.billing_frequency,
                only_full_period: model.only_full_period,
                payment_term: (_a = model.payment_term) === null || _a === void 0 ? void 0 : _a.id,
                payment_method: (_b = model.payment_method) === null || _b === void 0 ? void 0 : _b.id,
                pdf_model: (_c = model.pdf_model) === null || _c === void 0 ? void 0 : _c.id,
                create_invoice: model.create_invoice,
                create_invoice_moment: model.create_invoice_moment,
                auto_send_invoice: model.auto_send_invoice,
                send_message: model.send_message,
                restrict_custom_fields: (_d = model.restrict_custom_fields) !== null && _d !== void 0 ? _d : false,
                contents: model.contents.map(function (content) {
                    var _a, _b, _c;
                    if (content.is_comment) {
                        return {
                            designation: content.designation,
                            is_comment: content.is_comment
                        };
                    }
                    return {
                        catalog: {
                            id: (_a = content.catalog) === null || _a === void 0 ? void 0 : _a.id,
                            type: (_b = content.catalog) === null || _b === void 0 ? void 0 : _b.type
                        },
                        unit_price_ht: content.unit_price_ht,
                        vat_rate: (_c = content.vat_rate) === null || _c === void 0 ? void 0 : _c.id,
                        quantity: content.quantity,
                        auto_update_price: content.auto_update_price,
                        is_comment: content.is_comment
                    };
                }),
                documents: model.documents.map(function (document) {
                    var attrs = {
                        label: document.label,
                        description: document.description
                    };
                    if (document.id) {
                        attrs.id = document.id;
                    }
                    return attrs;
                })
            };
        },
        enumerable: false,
        configurable: true
    });
    ContractModelForm.prototype.watchValue = function (value) {
        if (value) {
            this.element = JSON.parse(JSON.stringify(value));
            if (!this.element.create_invoice) {
                this.element.create_invoice_moment = 'begin_period';
            }
            this.element.contents = this.element.contents.filter(function (content) { return content.catalog && content.catalog.element; });
            return;
        }
        this.element = {
            duration_value: 12,
            duration_type: 2,
            auto_renew: true,
            billing_frequency: 1,
            only_full_period: false,
            create_invoice: false,
            create_invoice_moment: 'begin_period',
            auto_send_invoice: false,
            auto_update_prices: false,
            deadline_for_payement: false,
            send_message: null,
            content_type: 2,
            contents: [],
            documents: []
        };
    };
    ContractModelForm.prototype.submitComplete = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({ name: 'contract-models-list' })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractModelForm.prototype.addDocument = function () {
        this.element.documents.push({
            label: '',
            description: null
        });
    };
    ContractModelForm.prototype.fileUploaded = function (model) {
        this.watchValue(model);
    };
    ContractModelForm.prototype.downloadContract = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var model;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        model = this.element.contract;
                        if (!model) {
                            return [2 /*return*/];
                        }
                        this.loadingContract = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/file/' + model.id + '?with_file=1')
                                .then(function (response) {
                                _this.downloadFile(response.data.file, model.filename);
                            })
                                .finally(function () {
                                _this.loadingContract = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractModelForm.prototype.deleteContract = function (evt) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.preventDefault();
                        this.loadingDelete = true;
                        return [4 /*yield*/, this.$kwSales.axios.put(this.formAction, {
                                contract: null
                            })
                                .then(function () {
                                _this.element.contract = null;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.toDelete = false;
                                _this.loadingDelete = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractModelForm.prototype.downloadDefaultModel = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingDefaultModel = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.get('/sales/contract-model-example')
                                .then(function (response) {
                                _this.downloadFile(response.data, 'contract-example.docx');
                            })
                                .finally(function () {
                                _this.loadingDefaultModel = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractModelForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ContractModelForm.prototype, "watchValue", null);
    ContractModelForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                KFormTextarea: form_vue_.KFormTextarea, KFormFile: form_vue_.KFormFile,
                BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], ContractModelForm);
    return ContractModelForm;
}((0,lib/* Mixins */.Xe)(ContractFormMixin/* default */.A, interface_vue_.FileMixin)));
/* harmony default export */ var ContractModelFormvue_type_script_lang_ts_external = (ContractModelForm);

;// ./src/components/ContractModelForm/ContractModelForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractModelForm_ContractModelFormvue_type_script_lang_ts_external = (ContractModelFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractModelForm/ContractModelForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractModelForm_ContractModelFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractModelForm_ContractModelForm = (component.exports);

/***/ }),

/***/ 80549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NV: function() { return /* binding */ pdfModelRelations; },
/* harmony export */   gp: function() { return /* binding */ fetchPdfModel; },
/* harmony export */   uM: function() { return /* binding */ needFetchPdfModel; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var pdfModelRelations = ['top', 'bottom', 'footer', 'columns', 'logo', 'background_image', 'coverPages', 'linkedDocuments'];
var needFetchPdfModel = function (pdfModel) {
    return !pdfModelRelations.every(function (relation) { return relation in pdfModel; });
};
var fetchPdfModel = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/sales/pdf_model/' + id, {
                    params: {
                        include: pdfModelRelations.join(','),
                        with_file: true
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 80631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(28077),
    hasPath = __webpack_require__(49326);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 80909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(30641),
    createBaseEach = __webpack_require__(38329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 80924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var bootstrap_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19529);
/* harmony import */ var bootstrap_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue__WEBPACK_IMPORTED_MODULE_1__);



var SalesInputOptionsMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(SalesInputOptionsMixin, _super);
    function SalesInputOptionsMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectVatRates = [
            { id: true, label: _this.$t('sales.form.inputOptions.vatrateSelectionOne') },
            { id: false, label: _this.$t('sales.form.inputOptions.vatrateSelectionMultiple') }
        ];
        _this.amountsType = [
            { id: 'ht', label: _this.$t('sales.form.inputOptions.amountTypesHt') },
            { id: 'ttc', label: _this.$t('sales.form.inputOptions.amountTypesTtc') }
        ];
        _this.allowOptions = [
            { id: false, label: _this.$t('sales.form.inputOptions.disallowOptionOn') },
            { id: true, label: _this.$t('sales.form.inputOptions.allowOptionOn') }
        ];
        _this.eanOptions = [
            { id: 0, label: _this.$t('sales.form.inputOptions.eanChoice1') },
            { id: 1, label: _this.$t('sales.form.inputOptions.eanChoice2') },
            { id: 2, label: _this.$t('sales.form.inputOptions.eanChoice3') },
            { id: 3, label: _this.$t('sales.form.inputOptions.eanChoice4') },
            { id: 4, label: _this.$t('sales.form.inputOptions.eanChoice5') }
        ];
        _this.weightOptions = [
            { id: 0, label: _this.$t('sales.form.inputOptions.weightChoice1') },
            { id: 1, label: _this.$t('sales.form.inputOptions.weightChoice2') },
            { id: 2, label: _this.$t('sales.form.inputOptions.weightChoice3') },
            { id: 3, label: _this.$t('sales.form.inputOptions.weightChoice4') },
            { id: 4, label: _this.$t('sales.form.inputOptions.weightChoice5') }
        ];
        _this.ecoParticipation = [
            { id: 0, label: _this.$t('sales.form.inputOptions.ecoParticipationChoice1') },
            { id: 1, label: _this.$t('sales.form.inputOptions.ecoParticipationChoice2') },
            { id: 2, label: _this.$t('sales.form.inputOptions.ecoParticipationChoice3') },
            { id: 3, label: _this.$t('sales.form.inputOptions.ecoParticipationChoice4') },
            { id: 4, label: _this.$t('sales.form.inputOptions.ecoParticipationChoice5') }
        ];
        _this.stockDisplay = [
            { id: 1, label: _this.$t('sales.form.inputOptions.stockQuantityChoice1') },
            { id: 2, label: _this.$t('sales.form.inputOptions.stockQuantityChoice2') },
            { id: 3, label: _this.$t('sales.form.inputOptions.stockQuantityChoice3') }
        ];
        _this.activeStockTracabilities = [
            { id: true, label: _this.$t('sales.form.inputOptions.stockTracabilitiesActive') },
            { id: false, label: _this.$t('sales.form.inputOptions.stockTracabilitiesDisable') }
        ];
        _this.costsEntries = [
            { id: 0, label: _this.$t('sales.form.inputOptions.costsChoice1') },
            { id: 1, label: _this.$t('sales.form.inputOptions.costsChoice2') },
            { id: 2, label: _this.$t('sales.form.inputOptions.costsChoice3') },
            { id: 3, label: _this.$t('sales.form.inputOptions.costsChoice4') },
            { id: 4, label: _this.$t('sales.form.inputOptions.costsChoice5') },
            { id: 5, label: _this.$t('sales.form.inputOptions.costsChoice6') }
        ];
        _this.workforceEntries = [
            { id: 0, label: _this.$t('sales.form.inputOptions.workforceChoice1') },
            { id: 1, label: _this.$t('sales.form.inputOptions.workforceChoice2') },
            { id: 2, label: _this.$t('sales.form.inputOptions.workforceChoice3') },
            { id: 3, label: _this.$t('sales.form.inputOptions.workforceChoice4') },
            { id: 4, label: _this.$t('sales.form.inputOptions.workforceChoice5') },
            { id: 5, label: _this.$t('sales.form.inputOptions.workforceChoice6') }
        ];
        _this.secondaryQuantity = [
            { id: 'disable', label: _this.$t('sales.form.inputOptions.secondaryQuantityChoice1') },
            { id: 'global', label: _this.$t('sales.form.inputOptions.secondaryQuantityChoice2') },
            { id: 'line', label: _this.$t('sales.form.inputOptions.secondaryQuantityChoice3') }
        ];
        _this.secondaryQuantityUnit = [
            { id: false, label: _this.$t('sales.form.inputOptions.secondaryQuantityDisabled') },
            { id: true, label: _this.$t('sales.form.inputOptions.secondaryQuantityEnable') }
        ];
        _this.showOnOff = [
            { id: false, label: _this.$t('sales.form.pdfOptions.displayChoice3') },
            { id: true, label: _this.$t('sales.form.pdfOptions.displayChoice2') }
        ];
        return _this;
    }
    SalesInputOptionsMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            directives: {
                'b-toggle': bootstrap_vue__WEBPACK_IMPORTED_MODULE_1__.VBToggle
            }
        })
    ], SalesInputOptionsMixin);
    return SalesInputOptionsMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (SalesInputOptionsMixin);


/***/ }),

/***/ 80945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80079),
    Map = __webpack_require__(68223),
    MapCache = __webpack_require__(53661);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 81038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractDocuments_ContractDocuments; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractDocuments/ContractDocuments.vue?vue&type=template&id=cadc9b6e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contract-documents"},[(_vm.value?.model?.documents.length > 0)?_c('table',{staticClass:"table table-sm table-bordered mt-1 align-middle mb-0"},[_c('tbody',_vm._l((_vm.value.model.documents),function(doc,i){return _c('tr',{key:i},[_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: _vm.document(doc.id) === undefined ? 'Document non renseigné' : null }),expression:"{ title: document(doc.id) === undefined ? 'Document non renseigné' : null }",modifiers:{"left":true}}],class:{
          'indicator-col': true,
          'text-danger': _vm.document(doc.id) === undefined,
          'text-success': _vm.document(doc.id) !== undefined
        }},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.document(doc.id) ? 'check' : 'times']}})],1),_c('td',[_c('p',{staticClass:"mb-1 font-weight-bold"},[_vm._v(" "+_vm._s(doc.label)+" ")]),(doc.description)?_c('p',{staticClass:"small mb-0"},[_vm._v(" "+_vm._s(doc.description)+" ")]):_vm._e(),_c('div',{staticClass:"mt-3"},[(_vm.document(doc.id) === undefined)?_c('k-form-file',{attrs:{"url":'/sales/contract/' + _vm.value.id,"method":"PUT","name":"documents[0][file]","datas":{ documents: [ { id: doc.id } ] },"accept":['image/png', 'image/jpeg', 'application/pdf'],"maxSize":5000000,"btn-mode":"","btn-size":"sm","removeUploadedFile":""},on:{"onUpload":data => _vm.$emit('input', data)}}):_c('div',[(_vm.toDownload?.id === _vm.document(doc.id)?.id)?_c('Spinner',{staticClass:"d-inline-block",attrs:{"size":"1"}}):_c('b-button',{attrs:{"size":"sm","variant":"secondary","disabled":_vm.toDownload !== null},on:{"click":function($event){$event.preventDefault();_vm.download(_vm.document(doc.id))}}},[_vm._v(" Télécharger ")]),_c('b-button',{staticClass:"ml-2",attrs:{"variant":"light","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.deleteDocument(doc.id)}}},[_vm._v(" Supprimer ")])],1)],1)])])}),0)]):_vm._e(),_c('b-modal',{attrs:{"visible":_vm.toDelete !== null,"ok-title":_vm.$t('interface.' + (_vm.deleteError ? 'close' : 'delete')),"ok-only":_vm.deleteError !== null,"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.deleteLoading,"hide-header-close":_vm.deleteLoading,"no-close-on-esc":_vm.deleteLoading,"no-close-on-backdrop":_vm.deleteLoading},on:{"ok":_vm.processDeleteDocument,"hidden":function($event){_vm.toDelete = null; _vm.deleteError = null}}},[(_vm.deleteLoading)?_c('Spinner'):(_vm.deleteError)?_c('div',{staticClass:"text-danger font-weight-bold"},[_vm._v(" "+_vm._s(_vm.deleteError)+" ")]):[_vm._v(" Êtes-vous sûr de vouloir supprimer ce document ? ")]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractDocuments/ContractDocuments.ts?vue&type=script&lang=ts&external






var ContractDocuments = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractDocuments, _super);
    function ContractDocuments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toDelete = null;
        _this.deleteLoading = false;
        _this.deleteError = null;
        _this.toDownload = null;
        return _this;
    }
    Object.defineProperty(ContractDocuments.prototype, "document", {
        get: function () {
            var _this = this;
            return function (id) { var _a; return (_a = _this.value.documents) === null || _a === void 0 ? void 0 : _a.find(function (document) { return document.model_document_id === id; }); };
        },
        enumerable: false,
        configurable: true
    });
    ContractDocuments.prototype.deleteDocument = function (id) {
        this.toDelete = id;
    };
    ContractDocuments.prototype.processDeleteDocument = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.deleteError !== null) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        this.deleteLoading = true;
                        return [4 /*yield*/, this.$kwSales.axios.put('/sales/contract/' + this.value.id, {
                                delete_documents: [this.toDelete]
                            })
                                .then(function (response) {
                                _this.deleteError = null;
                                _this.toDelete = null;
                                _this.$emit('input', response.data);
                            })
                                .catch(function (error) {
                                var response = error.response.data;
                                _this.deleteError = response.errors ? response.errors['delete_documents.0'][0] : response.message;
                            })
                                .finally(function () {
                                _this.deleteLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractDocuments.prototype.download = function (document) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.toDownload = document;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/contract/document/' + this.toDownload.id)
                                .then(function (response) {
                                _this.downloadFile(response.data, document.filename);
                            })
                                .finally(function () {
                                _this.toDownload = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractDocuments.prototype, "value", void 0);
    ContractDocuments = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormFile: form_vue_.KFormFile,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal,
                Spinner: interface_vue_.Spinner
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ContractDocuments);
    return ContractDocuments;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var ContractDocumentsvue_type_script_lang_ts_external = (ContractDocuments);

;// ./src/components/ContractDocuments/ContractDocuments.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractDocuments_ContractDocumentsvue_type_script_lang_ts_external = (ContractDocumentsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractDocuments/ContractDocuments.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractDocuments_ContractDocumentsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDocuments_ContractDocuments = (component.exports);

/***/ }),

/***/ 81042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(56110);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 81256:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'shopping-cart';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f07a';
var svgPathData = 'M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports._R = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 81593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CancelGuaranteeHoldback_CancelGuaranteeHoldback; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CancelGuaranteeHoldback/CancelGuaranteeHoldback.vue?vue&type=template&id=98049666
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" "),_c('b-modal',{attrs:{"title":"Statut de la retenue de garantie","cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.continue')},on:{"ok":_vm.proccess},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[(_vm.value.guarantee_holdback_status === 0)?[_c('p',[_vm._v(" Êtes-vous sur de vouloir annuler la retenue de garantie ?"),_c('br')]),_c('p',{staticClass:"text-muted"},[_vm._v(" Ce statut sert à annuler comptablement la retenue de garantie dans le cas où elle ne sera pas payée par le client. ")]),_c('b-form-group',{attrs:{"label":"Date de l'annulation"}},[_c('k-form-datepicker',{attrs:{"name":"guarantee_holdback_cancel_date","required":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)]:[_vm._v(" Êtes-vous sûr de vouloir rétablir la retenue de garantie et que celle-ci sera payée par le client ? ")]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CancelGuaranteeHoldback/CancelGuaranteeHoldback.ts?vue&type=script&lang=ts&external






var CancelGuaranteeHoldback = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CancelGuaranteeHoldback, _super);
    function CancelGuaranteeHoldback() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        _this.loading = false;
        _this.date = external_moment_default()().format('YYYY-MM-DD');
        return _this;
    }
    Object.defineProperty(CancelGuaranteeHoldback.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : (this.value.guarantee_holdback_status === 0 ? 'Annuler' : 'Restaurer');
        },
        enumerable: false,
        configurable: true
    });
    CancelGuaranteeHoldback.prototype.proccess = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loading = true;
                this.$kwSales.axios.put('/sales/invoice/' + this.value.id + '/lite', {
                    guarantee_holdback_status: this.value.guarantee_holdback_status === 0 ? 2 : 0,
                    guarantee_holdback_cancel_date: this.date
                })
                    .then(function (response) {
                    _this.$emit('input', response.data);
                    _this.modal = false;
                })
                    .finally(function () {
                    _this.loading = false;
                });
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CancelGuaranteeHoldback.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CancelGuaranteeHoldback.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CancelGuaranteeHoldback.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CancelGuaranteeHoldback.prototype, "size", void 0);
    CancelGuaranteeHoldback = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KFormDatepicker: form_vue_.KFormDatepicker,
                Spinner: interface_vue_.Spinner
            }
        })
    ], CancelGuaranteeHoldback);
    return CancelGuaranteeHoldback;
}(lib/* Vue */.lD));
/* harmony default export */ var CancelGuaranteeHoldbackvue_type_script_lang_ts_external = (CancelGuaranteeHoldback);

;// ./src/components/CancelGuaranteeHoldback/CancelGuaranteeHoldback.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CancelGuaranteeHoldback_CancelGuaranteeHoldbackvue_type_script_lang_ts_external = (CancelGuaranteeHoldbackvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CancelGuaranteeHoldback/CancelGuaranteeHoldback.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CancelGuaranteeHoldback_CancelGuaranteeHoldbackvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CancelGuaranteeHoldback_CancelGuaranteeHoldback = (component.exports);

/***/ }),

/***/ 81656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 81752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SepaDepositItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SepaDepositItemView.vue?vue&type=template&id=1b9e0310
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('Spinner'):_c('SepaDepositItem',{model:{value:(_vm.deposit),callback:function ($$v) {_vm.deposit=$$v},expression:"deposit"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SepaDepositItem/SepaDepositItem.vue + 3 modules
var SepaDepositItem = __webpack_require__(97508);
// EXTERNAL MODULE: ./src/mixins/SepaDepositMixin.ts
var SepaDepositMixin = __webpack_require__(22363);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SepaDepositItemView.vue?vue&type=script&lang=ts




var SepaDepositFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositFormView, _super);
    function SepaDepositFormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SepaDepositFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SepaDepositItem: SepaDepositItem/* default */.A
            }
        })
    ], SepaDepositFormView);
    return SepaDepositFormView;
}((0,lib/* Mixins */.Xe)(SepaDepositMixin/* default */.A)));
/* harmony default export */ var SepaDepositItemViewvue_type_script_lang_ts = (SepaDepositFormView);

;// ./src/views/SepaDepositItemView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SepaDepositItemViewvue_type_script_lang_ts = (SepaDepositItemViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/SepaDepositItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_SepaDepositItemViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SepaDepositItemView = (component.exports);

/***/ }),

/***/ 81765:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ 81945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SepaDepositValidation_SepaDepositValidation; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SepaDepositValidation/SepaDepositValidation.vue?vue&type=template&id=98399922
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();return _vm.ask.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" "),_c('b-modal',{attrs:{"ok-only":_vm.errorMsg !== null,"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.updateStatus},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_vm._v(" Êtes-vous sûr de vouloir valider la remise de prélèvement ? "),_c('b-alert',{staticClass:"mt-3 text-justify",attrs:{"variant":"danger","show":""}},[_vm._v(" Après validation de la remise, celle-ci ne sera plus modifiable et des paiements seront ajoutés sur les factures."),_c('br'),_c('br'),_vm._v(" Il vous sera toujours possible de supprimer la remise, les paiements ajoutés sur les factures seront alors annulés. ")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SepaDepositValidation/SepaDepositValidation.ts?vue&type=script&lang=ts&external




var SepaDepositValidation = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositValidation, _super);
    function SepaDepositValidation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(SepaDepositValidation.prototype, "computedLabel", {
        // Return confirmation label
        get: function () {
            var _a;
            return (_a = this.confirmLabel) !== null && _a !== void 0 ? _a : this.label;
        },
        enumerable: false,
        configurable: true
    });
    // Open modal
    SepaDepositValidation.prototype.ask = function () {
        this.errorMsg = null;
        this.modalState = true;
    };
    // Send ajax query
    SepaDepositValidation.prototype.updateStatus = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.put('/sales/sepa-deposit/' + this.deposit.id, { status: 2 })
            .then(function (response) {
            _this.$emit('input', response.data);
            _this.modalState = false;
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            throw new Error(error);
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SepaDepositValidation.prototype, "deposit", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Valider' })
    ], SepaDepositValidation.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositValidation.prototype, "confirmLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositValidation.prototype, "explain", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositValidation.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ size: 'sm' })
    ], SepaDepositValidation.prototype, "size", void 0);
    SepaDepositValidation = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert
            }
        })
    ], SepaDepositValidation);
    return SepaDepositValidation;
}(lib/* Vue */.lD));
/* harmony default export */ var SepaDepositValidationvue_type_script_lang_ts_external = (SepaDepositValidation);

;// ./src/components/SepaDepositValidation/SepaDepositValidation.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SepaDepositValidation_SepaDepositValidationvue_type_script_lang_ts_external = (SepaDepositValidationvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SepaDepositValidation/SepaDepositValidation.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SepaDepositValidation_SepaDepositValidationvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SepaDepositValidation_SepaDepositValidation = (component.exports);

/***/ }),

/***/ 82115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_DownloadPdfExportView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DownloadPdfExportView.vue?vue&type=template&id=26151316
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('SaleExportsDownload',{attrs:{"id":_vm.$route.params.id}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SaleExportsDownload/SaleExportsDownload.vue + 3 modules
var SaleExportsDownload = __webpack_require__(18281);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/DownloadPdfExportView.vue?vue&type=script&lang=ts



var DownloadPdfExportView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DownloadPdfExportView, _super);
    function DownloadPdfExportView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DownloadPdfExportView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SaleExportsDownload: SaleExportsDownload/* default */.A
            }
        })
    ], DownloadPdfExportView);
    return DownloadPdfExportView;
}(lib/* Vue */.lD));
/* harmony default export */ var DownloadPdfExportViewvue_type_script_lang_ts = (DownloadPdfExportView);

;// ./src/views/DownloadPdfExportView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_DownloadPdfExportViewvue_type_script_lang_ts = (DownloadPdfExportViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/DownloadPdfExportView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_DownloadPdfExportViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_DownloadPdfExportView = (component.exports);

/***/ }),

/***/ 82183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AccountForm_AccountForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AccountForm/AccountForm.vue?vue&type=template&id=0b150007
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.account.form.name')}},[_c('k-form-input',{attrs:{"name":"name","required":""},model:{value:(_vm.account.name),callback:function ($$v) {_vm.$set(_vm.account, "name", $$v)},expression:"account.name"}})],1),_c('input',{attrs:{"type":"hidden","name":"use_default"},domProps:{"value":_vm.account.use_default}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.account.use_default),callback:function ($$v) {_vm.$set(_vm.account, "use_default", $$v)},expression:"account.use_default"}},[_vm._v(" "+_vm._s(_vm.$t('sales.account.form.useDefault'))+" ")]),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.account-form-coordinate",modifiers:{"account-form-coordinate":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" "+_vm._s(_vm.$t('sales.account.form.coordinates'))+" ")])],1),_c('b-collapse',{attrs:{"id":"account-form-coordinate","accordion":"account-form-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":_vm.$t('sales.account.form.owner')}},[_c('k-form-input',{attrs:{"name":"owner"},model:{value:(_vm.account.owner),callback:function ($$v) {_vm.$set(_vm.account, "owner", $$v)},expression:"account.owner"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.account.form.iban')}},[_c('k-form-input',{attrs:{"name":"iban"},model:{value:(_vm.account.iban),callback:function ($$v) {_vm.$set(_vm.account, "iban", $$v)},expression:"account.iban"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.account.form.bic')}},[_c('k-form-input',{attrs:{"name":"bic"},model:{value:(_vm.account.bic),callback:function ($$v) {_vm.$set(_vm.account, "bic", $$v)},expression:"account.bic"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.account.form.sepaId')}},[_c('k-form-input',{attrs:{"name":"sepa_id"},model:{value:(_vm.account.sepa_id),callback:function ($$v) {_vm.$set(_vm.account, "sepa_id", $$v)},expression:"account.sepa_id"}})],1)],1)],1)],1),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.account-form-check",modifiers:{"account-form-check":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" "+_vm._s(_vm.$t('sales.account.form.check'))+" ")])],1),_c('b-collapse',{attrs:{"id":"account-form-check","accordion":"account-form-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('sales.account.form.checkExplain'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.account.form.accountNumber')}},[_c('k-form-input',{attrs:{"name":"account_number"},model:{value:(_vm.account.account_number),callback:function ($$v) {_vm.$set(_vm.account, "account_number", $$v)},expression:"account.account_number"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('sales.account.form.accountCode')}},[_c('k-form-input',{attrs:{"name":"bank_code"},model:{value:(_vm.account.bank_code),callback:function ($$v) {_vm.$set(_vm.account, "bank_code", $$v)},expression:"account.bank_code"}})],1)],1)],1)],1),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.account-form-fec",modifiers:{"account-form-fec":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" "+_vm._s(_vm.$t('sales.account.form.fecPart'))+" ")])],1),_c('b-collapse',{attrs:{"id":"account-form-fec","accordion":"account-form-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('sales.account.form.fecExplain'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('sales.account.form.fecCode')}},[_c('k-form-input',{attrs:{"name":"fec_code"},model:{value:(_vm.account.fec_code),callback:function ($$v) {_vm.$set(_vm.account, "fec_code", $$v)},expression:"account.fec_code"}})],1)],1)],1)],1),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.account-form-transactions",modifiers:{"account-form-transactions":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v(" Rapprochement bancaire ")])],1),_c('b-collapse',{attrs:{"id":"account-form-transactions","accordion":"account-form-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('k-form-select',{attrs:{"name":"show_transactions","options":[
            { id: true, label: 'Afficher le compte' },
            { id: false, label: 'Ne pas afficher le compte' }
          ],"clearable":false,"reduce":opt => opt.id},model:{value:(_vm.account.show_transactions),callback:function ($$v) {_vm.$set(_vm.account, "show_transactions", $$v)},expression:"account.show_transactions"}})],1)],1)],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Statut"}},[_c('k-form-select',{attrs:{"value":_vm.account.status?.active,"name":"status","options":[
        { id: true, label: this.$t('interface.activeStatus.on') },
        { id: false, label: this.$t('interface.activeStatus.off') }
      ],"clearable":false,"reduce":opt => opt.id}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AccountForm/AccountForm.ts?vue&type=script&lang=ts&external




var AccountForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AccountForm, _super);
    function AccountForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.account = {};
        return _this;
    }
    Object.defineProperty(AccountForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = this.apiUrl;
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    AccountForm.prototype.watchValue = function (value) {
        this.account = value ? JSON.parse(JSON.stringify(value)) : {
            use_default: false,
            status: {
                active: true,
                label: ''
            },
            show_transactions: true
        };
    };
    AccountForm.prototype.formSubmitted = function (response) {
        return response;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AccountForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/sales/account' })
    ], AccountForm.prototype, "apiUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], AccountForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], AccountForm.prototype, "formSubmitted", null);
    AccountForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BCardBody: external_bootstrap_vue_.BCardBody, BButton: external_bootstrap_vue_.BButton, BCollapse: external_bootstrap_vue_.BCollapse
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle
            }
        })
    ], AccountForm);
    return AccountForm;
}(lib/* Vue */.lD));
/* harmony default export */ var AccountFormvue_type_script_lang_ts_external = (AccountForm);

;// ./src/components/AccountForm/AccountForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AccountForm_AccountFormvue_type_script_lang_ts_external = (AccountFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/AccountForm/AccountForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AccountForm_AccountFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccountForm_AccountForm = (component.exports);

/***/ }),

/***/ 82199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(14528),
    isArray = __webpack_require__(56449);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 82218:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ 82233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfModelBlock_PdfModelBlock; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfModelBlock/PdfModelBlock.vue?vue&type=template&id=a4b418de
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'pdf-model-editor-block': true,
    'hover': _vm.hover || _vm.forceHover
  },style:({
    width: _vm.blocWidth + '%'
  }),on:{"mouseover":_vm.showActions,"mouseleave":_vm.hideActions}},[_c('div',{staticClass:"content"},[_c('PdfModelBlockPreview',{style:(_vm.computedBlocStyles),attrs:{"pdf-model":_vm.pdfModel,"preview":_vm.preview},model:{value:(_vm.previewContent),callback:function ($$v) {_vm.previewContent=$$v},expression:"previewContent"}}),(_vm.isFooter !== false)?_c('div',{staticClass:"page-indicator"},[_vm._v(" Page 1/1 ")]):_vm._e()],1),_c('b-overlay',{attrs:{"show":_vm.hover || _vm.forceHover,"no-wrap":""},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('b-row',{staticClass:"text-center",attrs:{"align-v":"end"}},[(_vm.isFooter === false)?_c('b-col',{staticClass:"my-1"},[_vm._v(" Largeur : "),_c('b-dropdown',{attrs:{"size":"sm","text":_vm.localValue.size + ' %'}},_vm._l((_vm.sizes),function(size,i){return _c('b-dropdown-item',{key:i,on:{"click":function($event){$event.preventDefault();return _vm.updateSize(size)}}},[_vm._v(" "+_vm._s(size)+" % ")])}),1)],1):_vm._e(),_c('b-col',{staticClass:"my-1"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.edit = true}}},[_vm._v(" Modifier ")])],1),(_vm.isFooter === false)?_c('b-col',{staticClass:"my-1"},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.openDeleteModal.apply(null, arguments)}}},[_vm._v(" Supprimer ")])],1):_vm._e()],1)]},proxy:true}])}),_c('b-modal',{attrs:{"size":"lg","body-class":"pt-3 pdf-model-editor-block","ok-title":"OK","cancel-title":"Annuler","no-close-on-esc":""},on:{"ok":function($event){return _vm.$emit('input', _vm.localValue)},"cancel":_vm.restoreBlock},model:{value:(_vm.edit),callback:function ($$v) {_vm.edit=$$v},expression:"edit"}},[(_vm.edit)?_c('div',[_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localValue.same_content),callback:function ($$v) {_vm.$set(_vm.localValue, "same_content", $$v)},expression:"localValue.same_content"}},[_vm._v(" Utiliser le même contenu pour tous les types de document ")]),(!_vm.localValue.same_content)?_c('b-tabs',{attrs:{"content-class":"pt-1 mb-4","small":""}},[(_vm.pdfModel.use_quotation)?_c('b-tab',{attrs:{"title":"Devis","active":_vm.preview === 'quotation'}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.localValue.quotation_content),callback:function ($$v) {_vm.$set(_vm.localValue, "quotation_content", $$v)},expression:"localValue.quotation_content"}})],1):_vm._e(),(_vm.pdfModel.use_command)?_c('b-tab',{attrs:{"title":"Bon de commande","active":_vm.preview === 'command'}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.localValue.command_content),callback:function ($$v) {_vm.$set(_vm.localValue, "command_content", $$v)},expression:"localValue.command_content"}})],1):_vm._e(),(_vm.pdfModel.use_delivery)?_c('b-tab',{attrs:{"title":"Bon de livraison","active":_vm.preview === 'delivery'}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.localValue.delivery_content),callback:function ($$v) {_vm.$set(_vm.localValue, "delivery_content", $$v)},expression:"localValue.delivery_content"}})],1):_vm._e(),(_vm.pdfModel.use_proforma)?_c('b-tab',{attrs:{"title":"Proforma","active":_vm.preview === 'proforma'}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.localValue.proforma_content),callback:function ($$v) {_vm.$set(_vm.localValue, "proforma_content", $$v)},expression:"localValue.proforma_content"}})],1):_vm._e(),(_vm.pdfModel.use_invoice)?_c('b-tab',{attrs:{"title":"Facture","active":_vm.preview === 'invoice'}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.localValue.invoice_content),callback:function ($$v) {_vm.$set(_vm.localValue, "invoice_content", $$v)},expression:"localValue.invoice_content"}})],1):_vm._e(),(_vm.pdfModel.use_credit)?_c('b-tab',{attrs:{"title":"Avoir","active":_vm.preview === 'credit'}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.localValue.credit_content),callback:function ($$v) {_vm.$set(_vm.localValue, "credit_content", $$v)},expression:"localValue.credit_content"}})],1):_vm._e(),(_vm.pdfModel.use_provider_command)?_c('b-tab',{attrs:{"title":"Fournisseur","active":_vm.preview === 'provider_command'}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.localValue.provider_command_content),callback:function ($$v) {_vm.$set(_vm.localValue, "provider_command_content", $$v)},expression:"localValue.provider_command_content"}})],1):_vm._e(),(_vm.pdfModel.use_automotive)?_c('b-tab',{attrs:{"title":"Ordre de réparation","active":_vm.preview === 'automotive'}},[_c('k-form-editor',{attrs:{"config":_vm.computedEditorConfig,"size":"sm"},model:{value:(_vm.localValue.automotive_content),callback:function ($$v) {_vm.$set(_vm.localValue, "automotive_content", $$v)},expression:"localValue.automotive_content"}})],1):_vm._e()],1):_c('k-form-editor',{staticClass:"mb-4 mt-3",attrs:{"size":"sm","config":_vm.computedEditorConfig},model:{value:(_vm.localValue.content),callback:function ($$v) {_vm.$set(_vm.localValue, "content", $$v)},expression:"localValue.content"}}),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.pdf-model-block-edit-1",modifiers:{"pdf-model-block-edit-1":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'palette']}}),_vm._v(" Couleurs ")],1)],1),_c('b-collapse',{attrs:{"id":"pdf-model-block-edit-1","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-row',{attrs:{"cols":"4"}},[_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur du texte"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.localValue.options.textColor),callback:function ($$v) {_vm.$set(_vm.localValue.options, "textColor", $$v)},expression:"localValue.options.textColor"}}),(_vm.localValue.options.textColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.localValue.options.textColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1),_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur de fond"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.localValue.options.backgroundColor),callback:function ($$v) {_vm.$set(_vm.localValue.options, "backgroundColor", $$v)},expression:"localValue.options.backgroundColor"}}),(_vm.localValue.options.backgroundColor)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.localValue.options.backgroundColor = null}}},[_vm._v(" Effacer ")]):_vm._e()],1)],1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.pdf-model-block-edit-2",modifiers:{"pdf-model-block-edit-2":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fal', 'border-all']}}),_vm._v(" Bordures ")],1)],1),_c('b-collapse',{attrs:{"id":"pdf-model-block-edit-2","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-row',{attrs:{"cols":"4"}},[_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Taille bordures"}},[_c('k-form-spinner',{attrs:{"min":0,"size":"sm"},model:{value:(_vm.localValue.options.borderSize),callback:function ($$v) {_vm.$set(_vm.localValue.options, "borderSize", $$v)},expression:"localValue.options.borderSize"}})],1)],1),_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Couleur bordure"}},[_c('k-form-input',{attrs:{"type":"color","size":"sm"},model:{value:(_vm.localValue.options.borderColor),callback:function ($$v) {_vm.$set(_vm.localValue.options, "borderColor", $$v)},expression:"localValue.options.borderColor"}})],1)],1),_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Bords arrondis"}},[_c('k-form-spinner',{attrs:{"min":0,"size":"sm"},model:{value:(_vm.localValue.options.borderRadius),callback:function ($$v) {_vm.$set(_vm.localValue.options, "borderRadius", $$v)},expression:"localValue.options.borderRadius"}})],1)],1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.pdf-model-block-edit-3",modifiers:{"pdf-model-block-edit-3":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['far', 'expand-arrows-alt']}}),_vm._v(" Marges ")],1)],1),_c('b-collapse',{attrs:{"id":"pdf-model-block-edit-3","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-form-group',{attrs:{"label":"Marges internes"}},[_c('b-row',{attrs:{"cols":"4"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Haut","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.localValue.options.paddingTop),callback:function ($$v) {_vm.$set(_vm.localValue.options, "paddingTop", $$v)},expression:"localValue.options.paddingTop"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Bas","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.localValue.options.paddingBottom),callback:function ($$v) {_vm.$set(_vm.localValue.options, "paddingBottom", $$v)},expression:"localValue.options.paddingBottom"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Gauche","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.localValue.options.paddingLeft),callback:function ($$v) {_vm.$set(_vm.localValue.options, "paddingLeft", $$v)},expression:"localValue.options.paddingLeft"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Droite","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.localValue.options.paddingRight),callback:function ($$v) {_vm.$set(_vm.localValue.options, "paddingRight", $$v)},expression:"localValue.options.paddingRight"}})],1)],1)],1)],1)],1),_c('b-form-group',{attrs:{"label":"Marges externes"}},[_c('b-row',{attrs:{"cols":"4"}},[_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Haut","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.localValue.options.marginTop),callback:function ($$v) {_vm.$set(_vm.localValue.options, "marginTop", $$v)},expression:"localValue.options.marginTop"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Bas","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.localValue.options.marginBottom),callback:function ($$v) {_vm.$set(_vm.localValue.options, "marginBottom", $$v)},expression:"localValue.options.marginBottom"}})],1)],1)],1),(_vm.isFooter === false)?_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Gauche","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.localValue.options.marginLeft),callback:function ($$v) {_vm.$set(_vm.localValue.options, "marginLeft", $$v)},expression:"localValue.options.marginLeft"}})],1)],1)],1):_vm._e(),(_vm.isFooter === false)?_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Droite","label-size":"sm"}},[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{attrs:{"min":0,"left":"","size":"sm"},model:{value:(_vm.localValue.options.marginRight),callback:function ($$v) {_vm.$set(_vm.localValue.options, "marginRight", $$v)},expression:"localValue.options.marginRight"}})],1)],1)],1):_vm._e()],1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.pdf-model-block-edit-4",modifiers:{"pdf-model-block-edit-4":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['far', 'arrows-alt-v']}}),_vm._v(" Hauteur & Saut de page ")],1)],1),_c('b-collapse',{attrs:{"id":"pdf-model-block-edit-4","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',{staticClass:"p-3"},[_c('b-form-group',{attrs:{"label":"Hauteur du bloc"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-radio',{attrs:{"size":"sm","value":"auto"},model:{value:(_vm.localValue.options.heightMode),callback:function ($$v) {_vm.$set(_vm.localValue.options, "heightMode", $$v)},expression:"localValue.options.heightMode"}},[_vm._v(" Automatique ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-radio',{attrs:{"size":"sm","value":"fixed"},model:{value:(_vm.localValue.options.heightMode),callback:function ($$v) {_vm.$set(_vm.localValue.options, "heightMode", $$v)},expression:"localValue.options.heightMode"}},[_vm._v(" Fixe ")])],1),_c('b-col',[_c('b-input-group',{attrs:{"append":"mm","size":"sm"}},[_c('k-form-spinner',{staticStyle:{"width":"100px"},attrs:{"min":0,"left":"","size":"sm","disabled":_vm.localValue.options.heightMode === 'auto'},model:{value:(_vm.localValue.options.height),callback:function ($$v) {_vm.$set(_vm.localValue.options, "height", $$v)},expression:"localValue.options.height"}})],1)],1)],1)],1),_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Empêcher le block de s'afficher sur plusieurs pages"}},[_c('b-form-radio',{staticClass:"d-inline-block",attrs:{"size":"sm","value":true},model:{value:(_vm.localValue.options.dontCut),callback:function ($$v) {_vm.$set(_vm.localValue.options, "dontCut", $$v)},expression:"localValue.options.dontCut"}},[_vm._v(" Oui ")]),_c('b-form-radio',{staticClass:"d-inline-block ml-4",attrs:{"size":"sm","value":false},model:{value:(_vm.localValue.options.dontCut),callback:function ($$v) {_vm.$set(_vm.localValue.options, "dontCut", $$v)},expression:"localValue.options.dontCut"}},[_vm._v(" Non ")])],1)],1)],1)],1)],1):_vm._e()]),_c('b-modal',{attrs:{"ok-title":"Supprimer","cancel-title":"Annuler"},on:{"ok":function($event){return _vm.$emit('delete')},"hidden":function($event){_vm.forceHover = false}},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_vm._v(" Êtes-vous sûr de vouloir supprimer ce bloc ? ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(55364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./src/components/PdfModelBlock/editorConfig.ts
var editorConfig = __webpack_require__(93443);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: ./src/components/PdfModelBlockPreview/PdfModelBlockPreview.vue + 3 modules
var PdfModelBlockPreview = __webpack_require__(27569);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfModelBlock/PdfModelBlock.ts?vue&type=script&lang=ts&external









var PdfModelBlock = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelBlock, _super);
    function PdfModelBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = {
            options: {
                textColor: null,
                backgroundColor: null,
                dontCut: false
            }
        };
        _this.edit = false;
        _this.hover = false;
        _this.forceHover = false;
        _this.deleteModal = false;
        _this.sizes = [25, 33, 50, 66, 75, 100];
        _this.actionsShowTimeout = null;
        return _this;
    }
    Object.defineProperty(PdfModelBlock.prototype, "blocWidth", {
        get: function () {
            var _a;
            switch (this.localValue.size) {
                case 33:
                    return 33.33;
                case 66:
                    return 66.66;
                default:
                    return (_a = this.localValue.size) !== null && _a !== void 0 ? _a : 100;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlock.prototype, "computedBlocStyles", {
        get: function () {
            var _a;
            var opt = (_a = this.localValue.options) !== null && _a !== void 0 ? _a : {};
            var styles = {
                color: opt.textColor,
                'background-color': opt.backgroundColor,
                'border-style': 'solid',
                'border-color': opt.borderColor,
                'border-radius': opt.borderRadius + 'pt',
                paddingTop: opt.paddingTop + 'mm',
                paddingBottom: opt.paddingBottom + 'mm',
                paddingLeft: opt.paddingLeft + 'mm',
                paddingRight: opt.paddingRight + 'mm',
                marginTop: opt.marginTop + 'mm',
                marginBottom: opt.marginBottom + 'mm',
                marginLeft: opt.marginLeft + 'mm',
                marginRight: opt.marginRight + 'mm',
                height: opt.heightMode === 'fixed' ? opt.height + 'mm' : 'auto'
            };
            if (this.isFooter !== false) {
                styles['border-top-width'] = opt.borderSize + 'pt';
                styles['border-left-width'] = 0;
                styles['border-right-width'] = 0;
                styles['border-bottom-width'] = 0;
            }
            else {
                styles['border-width'] = opt.borderSize + 'pt';
            }
            return styles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlock.prototype, "computedEditorConfig", {
        get: function () {
            var _this = this;
            var fields = this.customFields.filter(function (field) {
                var usages = field.usage;
                return usages.includes('quotation') || usages.includes('command') || usages.includes('proforma') || usages.includes('delivery') || usages.includes('invoice') || usages.includes('credit') || usages.includes('provider_command') || usages.includes('automotive');
            });
            var customFields = {};
            if (fields.length > 0) {
                var variables_1 = [];
                fields.forEach(function (field) {
                    var usages = [];
                    field.usage.forEach(function (usage) {
                        usages.push(_this.$t('sales.' + usage + '.label'));
                    });
                    variables_1.push({
                        value: 'CUSTOM-FIELD-' + field.id,
                        label: field.label + ' (' + usages.join(', ') + ')'
                    });
                });
                customFields.dynamicVariables = {
                    customFields: {
                        label: 'Champs personnalisés',
                        variables: variables_1
                    }
                };
            }
            return merge_default()(editorConfig/* default */.A, {
                imageUploadURL: '/sales/pdf_model/' + this.value.pdf_model_id + '/image',
                imageManagerDeleteURL: '/sales/pdf_model/' + this.value.pdf_model_id + '/image/',
                imageManagerLoadURL: '/sales/pdf_model/' + this.value.pdf_model_id + '/image'
            }, customFields);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfModelBlock.prototype, "previewContent", {
        get: function () {
            var val = this.localValue;
            if (val.same_content) {
                return this.replaceVariables(val.content);
            }
            switch (this.preview) {
                case 'quotation':
                    return val.quotation_content;
                case 'command':
                    return val.command_content;
                case 'delivery':
                    return val.delivery_content;
                case 'proforma':
                    return val.proforma_content;
                case 'invoice':
                    return val.invoice_content;
                case 'credit':
                    return val.credit_content;
                case 'provider_command':
                    return val.provider_command_content;
                case 'automotive':
                    return val.automotive_content;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    PdfModelBlock.prototype.replaceVariables = function (content) {
        return content;
    };
    PdfModelBlock.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.setLocalValue(this.value);
                if (this.value.open) {
                    lib/* Vue */.lD.delete(this.value, 'open');
                    this.edit = true;
                }
                return [2 /*return*/];
            });
        });
    };
    PdfModelBlock.prototype.setLocalValue = function (value) {
        this.localValue = JSON.parse(JSON.stringify(value));
    };
    PdfModelBlock.prototype.restoreBlock = function () {
        this.setLocalValue(this.value);
    };
    // Show action menu
    PdfModelBlock.prototype.showActions = function () {
        if (this.actionsShowTimeout) {
            clearTimeout(this.actionsShowTimeout);
        }
        this.hover = true;
    };
    // Hide action menu
    PdfModelBlock.prototype.hideActions = function () {
        var _this = this;
        if (this.actionsShowTimeout) {
            clearTimeout(this.actionsShowTimeout);
        }
        this.actionsShowTimeout = setTimeout(function () { return (_this.hover = false); }, 200);
    };
    // Update block size
    PdfModelBlock.prototype.updateSize = function (size) {
        this.localValue.size = size;
        this.$emit('input', this.localValue);
    };
    // Open delete modal for confirmation
    PdfModelBlock.prototype.openDeleteModal = function () {
        this.deleteModal = true;
        this.forceHover = true;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PdfModelBlock.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelBlock.prototype, "pdfModel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfModelBlock.prototype, "preview", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PdfModelBlock.prototype, "isFooter", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], PdfModelBlock.prototype, "setLocalValue", null);
    PdfModelBlock = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PdfModelBlockPreview: PdfModelBlockPreview/* default */.A,
                BOverlay: external_bootstrap_vue_.BOverlay, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItem: external_bootstrap_vue_.BDropdownItem, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BCollapse: external_bootstrap_vue_.BCollapse,
                BCardBody: external_bootstrap_vue_.BCardBody, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BFormRadio: external_bootstrap_vue_.BFormRadio,
                KFormCheckbox: form_vue_.KFormCheckbox, KFormEditor: form_vue_.KFormEditor, KFormInput: form_vue_.KFormInput, KFormSpinner: form_vue_.KFormSpinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('customFields', ['customFields']))
        })
    ], PdfModelBlock);
    return PdfModelBlock;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfModelBlockvue_type_script_lang_ts_external = (PdfModelBlock);

;// ./src/components/PdfModelBlock/PdfModelBlock.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfModelBlock_PdfModelBlockvue_type_script_lang_ts_external = (PdfModelBlockvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PdfModelBlock/PdfModelBlock.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfModelBlock_PdfModelBlockvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfModelBlock_PdfModelBlock = (component.exports);

/***/ }),

/***/ 82271:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ 82682:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ 82819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DG: function() { return /* binding */ commissionPaymentRelations; },
/* harmony export */   Os: function() { return /* binding */ fetchCommissionPayment; },
/* harmony export */   SO: function() { return /* binding */ needFetchCommissionPayment; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var commissionPaymentRelations = [
    'teamUser', 'commissions'
];
var needFetchCommissionPayment = function (model) {
    return !commissionPaymentRelations.every(function (relation) { return relation in model; });
};
var fetchCommissionPayment = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/sales/commission/payment/' + id, {
                    params: {
                        include: commissionPaymentRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 82973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SignCancel_SignCancel; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SignCancel/SignCancel.vue?vue&type=template&id=9511895e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.errorMsg ? _vm.$t('interface.close') : 'Annuler la signature',"cancel-title":_vm.$t('interface.close'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir annuler cette demande de signature ?")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SignCancel/SignCancel.ts?vue&type=script&lang=ts&external




var SignCancel = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SignCancel, _super);
    function SignCancel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(SignCancel.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    SignCancel.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    SignCancel.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    SignCancel.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.closeModal();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.put('/signature/' + this.value.id, {
            status: 6
        })
            .then(function (response) {
            _this.$emit('input', response.data);
            _this.closeModal();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    SignCancel.prototype.closeModal = function () {
        this.errorMsg = null;
        this.$emit('closed');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SignCancel.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], SignCancel.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Annuler' })
    ], SignCancel.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SignCancel.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SignCancel.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SignCancel.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SignCancel.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], SignCancel.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], SignCancel.prototype, "watchModalState", null);
    SignCancel = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], SignCancel);
    return SignCancel;
}(lib/* Vue */.lD));
/* harmony default export */ var SignCancelvue_type_script_lang_ts_external = (SignCancel);

;// ./src/components/SignCancel/SignCancel.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SignCancel_SignCancelvue_type_script_lang_ts_external = (SignCancelvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SignCancel/SignCancel.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SignCancel_SignCancelvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SignCancel_SignCancel = (component.exports);

/***/ }),

/***/ 83014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SepaDepositForm_SepaDepositForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SepaDepositForm/SepaDepositForm.vue?vue&type=template&id=2b8cdfee
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle}}),_c('AppMessages'),(_vm.loading)?_c('Spinner'):(!_vm.deposit.id && _vm.deposit.contents.length === 0)?_c('b-overlay',{attrs:{"show":_vm.filtering}},[_c('b-card',[_c('p',[_vm._v(" Afin de créer une remise de prélèvement, vous devez commencer par sélectionner les factures à prélever."),_c('br'),_vm._v(" Vous pourrez retirer ou ajouter des factures à l'étape suivante. ")]),_c('b-form-group',{attrs:{"label":"Date de la facture (Facultatif)"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-md-0",attrs:{"cols":"12","md":"auto"}},[_vm._v(" Du "),_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"max-date":_vm.filters.date_end},model:{value:(_vm.filters.date_begin),callback:function ($$v) {_vm.$set(_vm.filters, "date_begin", $$v)},expression:"filters.date_begin"}})],1),_c('b-col',{staticClass:"pl-md-1 mt-2 mt-md-0",attrs:{"cols":"12","md":"auto"}},[_vm._v(" au "),_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"min-date":_vm.filters.date_begin},model:{value:(_vm.filters.date_end),callback:function ($$v) {_vm.$set(_vm.filters, "date_end", $$v)},expression:"filters.date_end"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Date limite de paiement (Facultatif)"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-md-0",attrs:{"cols":"12","md":"auto"}},[_vm._v(" Du "),_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"max-date":_vm.filters.expire_end},model:{value:(_vm.filters.expire_begin),callback:function ($$v) {_vm.$set(_vm.filters, "expire_begin", $$v)},expression:"filters.expire_begin"}})],1),_c('b-col',{staticClass:"pl-md-1 mt-2 mt-md-0",attrs:{"cols":"12","md":"auto"}},[_vm._v(" au "),_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"min-date":_vm.filters.expire_begin},model:{value:(_vm.filters.expire_end),callback:function ($$v) {_vm.$set(_vm.filters, "expire_end", $$v)},expression:"filters.expire_end"}})],1)],1)],1),_c('k-form-checkbox',{staticClass:"mt-4",model:{value:(_vm.filters.only_payment_method),callback:function ($$v) {_vm.$set(_vm.filters, "only_payment_method", $$v)},expression:"filters.only_payment_method"}},[_vm._v(" Uniquement les factures contenant un mode de paiement \"Prélèvement\" ")]),_c('b-button',{staticClass:"mt-3",attrs:{"variant":_vm.totalInvoices > 0 ? 'secondary' : 'primary',"size":_vm.totalInvoices > 0 ? 'sm' : null},on:{"click":function($event){$event.preventDefault();return _vm.loadInvoices()}}},[_vm._v(" Rechercher les factures ")]),(_vm.totalInvoices !== null)?_c('div',{staticClass:"pt-4"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$tc('sales.sepaDeposit.invoiceSearchResult', _vm.totalInvoices))+" ")]),(_vm.totalInvoices > 0)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.nextStep.apply(null, arguments)}}},[_vm._v(" Continuer ")]):_vm._e()],1):_vm._e()],1)],1):_c('div',[_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c('b-card',{staticClass:"mb-4"},[_c('b-form-group',{attrs:{"label":"Compte bancaire"}},[_c('AccountSelect',{attrs:{"selectDefault":"","required":"","clearable":false},model:{value:(_vm.deposit.account),callback:function ($$v) {_vm.$set(_vm.deposit, "account", $$v)},expression:"deposit.account"}})],1),_c('b-form-group',{attrs:{"label":"Date du mandat SEPA"}},[_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"min-date":_vm.minDate,"required":""},model:{value:(_vm.deposit.date),callback:function ($$v) {_vm.$set(_vm.deposit, "date", $$v)},expression:"deposit.date"}})],1),_c('k-form-checkbox',{model:{value:(_vm.deposit.use_expire_date),callback:function ($$v) {_vm.$set(_vm.deposit, "use_expire_date", $$v)},expression:"deposit.use_expire_date"}},[_vm._v(" Utiliser la date limite de paiement des factures comme date de prélèvement ")]),_c('k-form-checkbox',{staticClass:"mt-3",model:{value:(_vm.deposit.group_sepa),callback:function ($$v) {_vm.$set(_vm.deposit, "group_sepa", $$v)},expression:"deposit.group_sepa"}},[_vm._v(" Grouper les prélèvements par mandat SEPA lors de la génération du fichier de prélèvement ")])],1),_c('div',{staticClass:"catalog-search"},[_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('k-form-input',{staticClass:"mb-1",attrs:{"type":"search","placeholder":"Rechercher une facture à ajouter","readonly":_vm.searching},model:{value:(_vm.addSearchTerm),callback:function ($$v) {_vm.addSearchTerm=$$v},expression:"addSearchTerm"}})],1),_c('b-col',[_c('k-form-input',{staticClass:"mb-1",attrs:{"type":"search","placeholder":"Rechercher dans les factures sélectionnées","readonly":_vm.searching},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1)],1),_c('b-list-group',{ref:"list"},[(_vm.searching)?_c('b-list-group-item',{staticClass:"text-center"},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1):_vm._e(),(_vm.searchResults)?[(_vm.searchResults.length === 0)?_c('b-list-group-item',{staticClass:"text-center"},[_vm._v(" Aucune facture ")]):_vm._e(),_vm._l((_vm.searchResults),function(invoice,i){return _c('b-list-group-item',{key:i,on:{"click":function($event){return _vm.selectInvoice(invoice, i)}}},[_vm._v(" "+_vm._s(invoice.customer_name)+" - Facture n°"+_vm._s(invoice.reference)+" du "+_vm._s(_vm.date(invoice.date))+" - Reste à payer "+_vm._s(_vm.formattedNumber(invoice.stay_to_pay, false) + ' ' + invoice.currency)+" ")])})]:_vm._e()],2)],1),_c('b-table',{attrs:{"striped":"","bordered":"","fields":_vm.invoicesColumns,"items":_vm.deposit.contents,"per-page":_vm.perPage,"currentPage":_vm.currentPage,"filter":_vm.searchTerm,"filter-debounce":300,"small":"","table-class":"align-middle text-nowrap","responsive":"","empty-text":"Aucun paiement","show-empty":""},scopedSlots:_vm._u([{key:"cell(amount)",fn:function({ item }){return [_c('b-input-group',{attrs:{"size":"sm","append":"€"}},[_c('k-form-number',{attrs:{"size":"sm","min":1,"max":item.invoice.stay_to_pay},model:{value:(item.amount),callback:function ($$v) {_vm.$set(item, "amount", $$v)},expression:"item.amount"}})],1)]}},{key:"cell(sepa_id)",fn:function({ item }){return [_c('k-form-select',{attrs:{"options":_vm.customerSepa(item.invoice.customer_id),"reduce":opt => opt.id,"getOptionLabel":_vm.sepaLabel,"size":"sm","required":"","clearable":false},model:{value:(item.sepa_id),callback:function ($$v) {_vm.$set(item, "sepa_id", $$v)},expression:"item.sepa_id"}})]}},{key:"cell(remove)",fn:function({ item }){return [_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: 'Retirer la facture' }),expression:"{ title: 'Retirer la facture' }"}],staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.removeInvoice(item)}}})]}}])}),(_vm.totalInvoices > 0)?_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"cols":"auto"}},[_vm._v(" Total : "+_vm._s(_vm.$tc('sales.sepaDeposit.totalInvoice', _vm.totalInvoices))+" ")]),_c('b-col',[_c('div',{staticClass:"text-center"},[_c('b-pagination',{attrs:{"perPage":_vm.perPage,"total-rows":_vm.totalInvoices,"align":"center","size":"sm"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)]),_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered font-weight-bold",staticStyle:{"width":"300px"}},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Total :")]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.total)))])])])])])],1):_vm._e(),_c('k-form-sticky-bar',[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")]),_c('b-button',{staticClass:"ml-3",on:{"click":function($event){$event.preventDefault();return _vm.$router.back()}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./src/components/AccountSelect/AccountSelect.vue + 3 modules
var AccountSelect = __webpack_require__(5182);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SepaDepositForm/SepaDepositForm.ts?vue&type=script&lang=ts&external










var SepaDepositForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositForm, _super);
    function SepaDepositForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deposit = {
            contents: []
        };
        _this.loading = false;
        _this.filtering = false;
        _this.invoices = [];
        _this.totalInvoices = null;
        _this.customerSepas = [];
        _this.currentPage = 1;
        _this.perPage = 20;
        _this.addSearchTerm = null;
        _this.searchTimeout = null;
        _this.searchTerm = null;
        _this.searching = false;
        _this.searchResults = null;
        _this.filters = {
            date_begin: null,
            date_end: null,
            expire_begin: null,
            expire_end: null,
            only_payment_method: true
        };
        _this.invoicesColumns = [
            { key: 'invoice.customer_reference', label: 'N° client', sortable: true },
            { key: 'invoice.customer_name', label: 'Client', sortable: true },
            { key: 'invoice.reference', label: 'N° Facture', sortable: true },
            { key: 'invoice.date', label: 'Date', formatter: _this.date, sortable: true },
            { key: 'invoice.expire_at', label: 'Limite paiement', formatter: _this.date, sortable: true },
            { key: 'invoice.stay_to_pay', label: 'À payer', formatter: function (value, key, item) { return _this.formattedNumber(value, false) + ' ' + item.invoice.currency; }, sortable: true },
            { key: 'sepa_id', label: 'Mandat SEPA' },
            { key: 'amount', label: 'Montant', thStyle: 'width: 150px' },
            { key: 'remove', label: '', thStyle: 'width: 40px', tdClass: 'text-center' }
        ];
        return _this;
    }
    Object.defineProperty(SepaDepositForm.prototype, "minDate", {
        get: function () {
            var closed_period = this.team.sales['closed_period'];
            if (closed_period) {
                return closed_period;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SepaDepositForm.prototype, "formAction", {
        get: function () {
            var url = '/sales/sepa-deposit';
            if (this.deposit.id) {
                url += '/' + this.deposit.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SepaDepositForm.prototype, "formDatas", {
        get: function () {
            var _a;
            var val = this.deposit;
            return {
                account: (_a = val.account) === null || _a === void 0 ? void 0 : _a.id,
                date: val.date,
                use_expire_date: val.use_expire_date,
                group_sepa: val.group_sepa,
                contents: val.contents.map(function (content) {
                    var _a;
                    return ({
                        invoice: (_a = content.invoice) === null || _a === void 0 ? void 0 : _a.id,
                        sepa: content.sepa_id,
                        amount: content.amount
                    });
                })
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SepaDepositForm.prototype, "formMethod", {
        get: function () {
            return this.deposit.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SepaDepositForm.prototype, "pageTitle", {
        get: function () {
            return (this.deposit.id ? 'Modification' : 'Création') + ' d\'une remise de prélèvement';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SepaDepositForm.prototype, "customerSepa", {
        get: function () {
            var _this = this;
            return function (customerId) { return _this.customerSepas.filter(function (sepa) { return sepa.customer_id === customerId; }); };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SepaDepositForm.prototype, "total", {
        get: function () {
            var _this = this;
            return sumBy_default()(this.deposit.contents, function (content) { return _this.number(content.amount); });
        },
        enumerable: false,
        configurable: true
    });
    SepaDepositForm.prototype.sepaLabel = function (sepa) {
        var _a;
        return ((_a = sepa.name) !== null && _a !== void 0 ? _a : sepa.owner) + ' (' + (sepa.type === 1 ? 'Récurrent' : 'Ponctuel') + ')';
    };
    SepaDepositForm.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.deposit = Object.assign({
                            contents: [],
                            use_expire_date: false,
                            group_sepa: true,
                            date: external_moment_default()().format('YYYY-MM-DD')
                        }, this.value ? JSON.parse(JSON.stringify(this.value)) : {});
                        if (!this.deposit.id) return [3 /*break*/, 2];
                        this.totalInvoices = this.deposit.contents.length;
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get(this.formAction + '/customer-sepa')
                                .then(function (response) {
                                _this.customerSepas = response.data;
                            })];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SepaDepositForm.prototype.watchSearchTerm = function () {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        if (this.addSearchTerm) {
            this.searchTimeout = setTimeout(this.searchInvoices, 500);
        }
        else {
            this.searchResults = null;
        }
    };
    SepaDepositForm.prototype.searchInvoices = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.searching = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/sepa-deposit/invoices', {
                                params: {
                                    filter: {
                                        status: [2, 3, 4],
                                        with_to_paid: true,
                                        with_customer_sepa: true,
                                        exclude: this.deposit.contents.map(function (content) { return content.invoice_id; }),
                                        used_in_draft_sepa_deposit: false
                                    },
                                    search: encodeURIComponent('%' + this.addSearchTerm + '%'),
                                    per_page: 20,
                                    include: ['customer', 'currency', 'contract']
                                }
                            })
                                .then(function (response) {
                                _this.searchResults = response.data.data;
                            })
                                .finally(function () {
                                _this.searching = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SepaDepositForm.prototype.loadInvoices = function (page) {
        if (page === void 0) { page = 1; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var filter;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filtering = true;
                        if (page === 1) {
                            this.invoices = [];
                        }
                        filter = {
                            status: [2, 3, 4],
                            with_customer_sepa: true,
                            with_to_paid: true,
                            used_in_draft_sepa_deposit: false
                        };
                        if (this.filters.date_begin)
                            filter.date_since = this.filters.date_begin;
                        if (this.filters.date_end)
                            filter.date_until = this.filters.date_end;
                        if (this.filters.expire_begin)
                            filter.expire_since = this.filters.expire_begin;
                        if (this.filters.expire_end)
                            filter.expire_until = this.filters.expire_end;
                        if (this.filters.only_payment_method)
                            filter.with_direct_debit_method = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/sepa-deposit/invoices', {
                                params: {
                                    per_page: 500,
                                    filter: filter,
                                    page: page,
                                    include: ['customer', 'currency', 'contract']
                                }
                            })
                                .then(function (response) {
                                var _a;
                                var datas = response.data;
                                var meta = datas.meta;
                                (_a = _this.invoices).push.apply(_a, datas.data);
                                _this.totalInvoices = meta.total;
                                if (meta.current_page < meta.last_page) {
                                    _this.loadInvoices(page + 1);
                                }
                                else {
                                    _this.filtering = false;
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SepaDepositForm.prototype.loadCustomerSepa = function (page, customers) {
        if (page === void 0) { page = 1; }
        if (customers === void 0) { customers = null; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filtering = true;
                        if (!customers) {
                            customers = this.deposit.contents.map(function (content) { var _a; return (_a = content.invoice) === null || _a === void 0 ? void 0 : _a.customer_id; });
                            customers = customers.filter(function (item, pos) {
                                return (customers === null || customers === void 0 ? void 0 : customers.indexOf(item)) === pos;
                            });
                        }
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/sepa', {
                                params: {
                                    filter: {
                                        customer: customers
                                    },
                                    per_page: 500,
                                    page: page
                                }
                            })
                                .then(function (response) {
                                var datas = response.data;
                                var meta = datas.meta;
                                datas.data.forEach(function (data) {
                                    if (_this.customerSepas.findIndex(function (sepa) { return sepa.id === data.id; }) === -1) {
                                        _this.customerSepas.push(data);
                                    }
                                });
                                if (meta.current_page < meta.last_page) {
                                    _this.loadCustomerSepa(page + 1, customers);
                                }
                                else {
                                    _this.filtering = false;
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SepaDepositForm.prototype.nextStep = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCustomerSepa()];
                    case 1:
                        _a.sent();
                        this.deposit.contents = this.invoices.map(function (invoice) {
                            var sepa;
                            if (invoice.sepa_id) {
                                sepa = _this.customerSepa(invoice.customer_id).find(function (sepa) { return sepa.id === invoice.sepa_id; });
                            }
                            if (!sepa) {
                                sepa = _this.customerSepa(invoice.customer_id)[0];
                            }
                            return {
                                invoice_id: invoice.id,
                                invoice: invoice,
                                amount: invoice.stay_to_pay,
                                sepa: sepa,
                                sepa_id: sepa.id
                            };
                        });
                        this.invoices = [];
                        return [2 /*return*/];
                }
            });
        });
    };
    SepaDepositForm.prototype.removeInvoice = function (item) {
        var index = this.deposit.contents.findIndex(function (value) { var _a, _b; return ((_a = value.invoice) === null || _a === void 0 ? void 0 : _a.id) === ((_b = item.invoice) === null || _b === void 0 ? void 0 : _b.id); });
        if (index !== -1) {
            this.deposit.contents.splice(index, 1);
            if (this.totalInvoices) {
                this.totalInvoices--;
            }
        }
    };
    SepaDepositForm.prototype.selectInvoice = function (invoice, index) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var customerId, sepa;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        customerId = invoice.customer_id;
                        sepa = this.customerSepa(customerId)[0];
                        if (!!sepa) return [3 /*break*/, 2];
                        this.searching = true;
                        return [4 /*yield*/, this.loadCustomerSepa(1, [customerId])];
                    case 1:
                        _b.sent();
                        this.searching = false;
                        this.selectInvoice(invoice, index);
                        _b.label = 2;
                    case 2:
                        (_a = this.searchResults) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
                        this.deposit.contents.unshift({
                            invoice_id: invoice.id,
                            invoice: invoice,
                            amount: invoice.stay_to_pay,
                            sepa: sepa,
                            sepa_id: sepa.id
                        });
                        if (this.totalInvoices) {
                            this.totalInvoices++;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SepaDepositForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({
                            name: 'sepa-deposit-item',
                            params: {
                                id: String(response.data.id)
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], SepaDepositForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('addSearchTerm')
    ], SepaDepositForm.prototype, "watchSearchTerm", null);
    SepaDepositForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect, KFormStickyBar: form_vue_.KFormStickyBar, KFormInput: form_vue_.KFormInput,
                BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BOverlay: external_bootstrap_vue_.BOverlay, BTable: external_bootstrap_vue_.BTable, BInputGroup: external_bootstrap_vue_.BInputGroup, BPagination: external_bootstrap_vue_.BPagination, BListGroup: external_bootstrap_vue_.BListGroup, BListGroupItem: external_bootstrap_vue_.BListGroupItem,
                Spinner: interface_vue_.Spinner, PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                AccountSelect: AccountSelect/* default */.A
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team']))
        })
    ], SepaDepositForm);
    return SepaDepositForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var SepaDepositFormvue_type_script_lang_ts_external = (SepaDepositForm);

;// ./src/components/SepaDepositForm/SepaDepositForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SepaDepositForm_SepaDepositFormvue_type_script_lang_ts_external = (SepaDepositFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SepaDepositForm/SepaDepositForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SepaDepositForm_SepaDepositFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SepaDepositForm_SepaDepositForm = (component.exports);

/***/ }),

/***/ 83221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 83283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SepaDepositListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SepaDepositListView.vue?vue&type=template&id=eb080f4c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SepaDepositList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SepaDepositList/SepaDepositList.vue + 3 modules
var SepaDepositList = __webpack_require__(25571);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SepaDepositListView.vue?vue&type=script&lang=ts



var SepaDepositListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositListView, _super);
    function SepaDepositListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SepaDepositListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SepaDepositList: SepaDepositList/* default */.A
            }
        })
    ], SepaDepositListView);
    return SepaDepositListView;
}(lib/* Vue */.lD));
/* harmony default export */ var SepaDepositListViewvue_type_script_lang_ts = (SepaDepositListView);

;// ./src/views/SepaDepositListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SepaDepositListViewvue_type_script_lang_ts = (SepaDepositListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/SepaDepositListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_SepaDepositListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SepaDepositListView = (component.exports);

/***/ }),

/***/ 83488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 83693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(64894),
    isObjectLike = __webpack_require__(40346);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 83729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 83793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionForm_CommissionForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionForm/CommissionForm.vue?vue&type=template&id=1e500eb8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":response => _vm.$emit('submitComplete', response)}},[_c('b-form-group',{attrs:{"label":"Nom de la commission"}},[_c('k-form-input',{attrs:{"name":"name","required":""},model:{value:(_vm.commission.name),callback:function ($$v) {_vm.$set(_vm.commission, "name", $$v)},expression:"commission.name"}})],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"La commission est calculée sur"}},[_c('b-form-radio-group',{attrs:{"name":"based_on","options":_vm.basedOnOptions},model:{value:(_vm.commission.based_on),callback:function ($$v) {_vm.$set(_vm.commission, "based_on", $$v)},expression:"commission.based_on"}})],1),_c('b-form-group',{attrs:{"label":"La commission est validée"}},[_c('b-form-radio-group',{attrs:{"name":"valid_at","options":_vm.validAtOptions},model:{value:(_vm.commission.valid_at),callback:function ($$v) {_vm.$set(_vm.commission, "valid_at", $$v)},expression:"commission.valid_at"}})],1),(_vm.commission.valid_at === 1)?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(" Si un devis accepté est modifié, la commission existante sera mise à jour. ")]):(_vm.commission.valid_at === 3)?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(" Si un paiement est annulé, une commission négative sera créée en date d'annulation du paiement. ")]):_vm._e(),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Montants des commissions ")]),_c('b-form-group',{attrs:{"label":"Appliquer les commissions selon des paliers"}},[_c('b-form-radio-group',{attrs:{"name":"with_step","options":_vm.withSteps},model:{value:(_vm.commission.with_step),callback:function ($$v) {_vm.$set(_vm.commission, "with_step", $$v)},expression:"commission.with_step"}})],1),(_vm.commission.with_step)?[_c('b-form-group',{attrs:{"label":"Calculer les paliers selon"}},[_c('b-form-radio-group',{attrs:{"name":"step_mode","options":_vm.stepModes},model:{value:(_vm.commission.step_mode),callback:function ($$v) {_vm.$set(_vm.commission, "step_mode", $$v)},expression:"commission.step_mode"}})],1),_c('table',{staticClass:"table table-sm table-bordered mb-1 align-middle"},[_c('thead',[_c('tr',[_c('th',[(_vm.commission.based_on === 1)?[_vm._v("Chiffre d'affaires")]:(_vm.commission.based_on === 2)?[_vm._v("Marge brute")]:_vm._e(),_vm._v(" mini ")],2),_c('th',[(_vm.commission.based_on === 1)?[_vm._v("Chiffre d'affaires")]:(_vm.commission.based_on === 2)?[_vm._v("Marge brute")]:_vm._e(),_vm._v(" maxi ")],2),_c('th',[_vm._v("Pourcentage")]),_c('th',[_vm._v("Commission mini")]),_c('th',[_vm._v("Commission maxi")]),(_vm.commission.steps?.length > 1)?_c('th',{staticStyle:{"width":"38px"}}):_vm._e()])]),_c('tbody',_vm._l((_vm.commission.steps),function(step,i){return _c('tr',{key:i},[_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'steps[' + i + '][minimum]',"min":_vm.minStepValue(i),"noDefaultValue":"","size":"sm","required":i > 0},model:{value:(_vm.commission.steps[i].minimum),callback:function ($$v) {_vm.$set(_vm.commission.steps[i], "minimum", $$v)},expression:"commission.steps[i].minimum"}})],1)],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'steps[' + i + '][maximum]',"min":step.step_mini + 1,"noDefaultValue":"","size":"sm","required":(i + 1) < _vm.commission.steps?.length},model:{value:(_vm.commission.steps[i].maximum),callback:function ($$v) {_vm.$set(_vm.commission.steps[i], "maximum", $$v)},expression:"commission.steps[i].maximum"}})],1)],1),_c('td',[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{attrs:{"name":'steps[' + i + '][pourcentage]',"min":0,"max":100,"size":"sm","required":""},model:{value:(_vm.commission.steps[i].pourcentage),callback:function ($$v) {_vm.$set(_vm.commission.steps[i], "pourcentage", $$v)},expression:"commission.steps[i].pourcentage"}})],1)],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'steps[' + i + '][minimum_amount]',"min":0,"noDefaultValue":"","size":"sm"},model:{value:(_vm.commission.steps[i].minimum_amount),callback:function ($$v) {_vm.$set(_vm.commission.steps[i], "minimum_amount", $$v)},expression:"commission.steps[i].minimum_amount"}})],1)],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'steps[' + i + '][maximum_amount]',"min":0,"noDefaultValue":"","size":"sm"},model:{value:(_vm.commission.steps[i].maximum_amount),callback:function ($$v) {_vm.$set(_vm.commission.steps[i], "maximum_amount", $$v)},expression:"commission.steps[i].maximum_amount"}})],1)],1),(_vm.commission.steps?.length > 1)?_c('td',{staticClass:"p-0"},[_c('b-button',{staticClass:"text-danger",attrs:{"variant":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.deleteStep(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1):_vm._e()])}),0)]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.addStep.apply(null, arguments)}}},[_vm._v(" Ajouter un palier ")])]:[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Pourcentage :"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{attrs:{"name":"pourcentage","min":0,"max":100,"size":"sm"},model:{value:(_vm.commission.pourcentage),callback:function ($$v) {_vm.$set(_vm.commission, "pourcentage", $$v)},expression:"commission.pourcentage"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Commission minimum"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":"minimum","min":0,"noDefaultValue":"","size":"sm","placeholder":"Aucun minimum"},model:{value:(_vm.commission.minimum),callback:function ($$v) {_vm.$set(_vm.commission, "minimum", $$v)},expression:"commission.minimum"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Commission maximum"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":"maximum","min":_vm.commission.minimum,"noDefaultValue":"","size":"sm","placeholder":"Aucun maximum"},model:{value:(_vm.commission.maximum),callback:function ($$v) {_vm.$set(_vm.commission, "maximum", $$v)},expression:"commission.maximum"}})],1)],1)],1)],1)],_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Conditions d'attribution ")]),_c('div',{staticClass:"mb-5"},[_c('div',{staticClass:"small font-weight-bold mb-1"},[_c('k-form-select',{staticClass:"d-inline-block",staticStyle:{"width":"160px"},attrs:{"name":"apply_team_users","options":_vm.applyMode,"reduce":val => val.value,"size":"sm","clearable":false},model:{value:(_vm.commission.apply_team_users),callback:function ($$v) {_vm.$set(_vm.commission, "apply_team_users", $$v)},expression:"commission.apply_team_users"}}),_vm._v(" aux commerciaux suivants ")],1),(_vm.commission.team_users?.length === 0)?_c('input',{attrs:{"type":"hidden","name":"team_users"},domProps:{"value":null}}):_vm._l((_vm.commission.team_users),function(teamUser,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"team_users[]"},domProps:{"value":teamUser.id}})}),_c('TeamUserSelect',{attrs:{"validationName":"team_users","role":"commercial","multiple":"","size":"sm","placeholder":_vm.commission.apply_team_users ? 'Tous les commerciaux' : null,"required":!_vm.commission.apply_team_users},model:{value:(_vm.commission.team_users),callback:function ($$v) {_vm.$set(_vm.commission, "team_users", $$v)},expression:"commission.team_users"}})],2),_c('div',{staticClass:"mb-5"},[_c('div',{staticClass:"small font-weight-bold mb-1"},[_c('k-form-select',{staticClass:"d-inline-block",staticStyle:{"width":"160px"},attrs:{"name":"apply_elements","options":_vm.applyMode,"reduce":val => val.value,"size":"sm","clearable":false},model:{value:(_vm.commission.apply_elements),callback:function ($$v) {_vm.$set(_vm.commission, "apply_elements", $$v)},expression:"commission.apply_elements"}}),_vm._v(" aux éléments suivants ")],1),_c('input',{attrs:{"type":"hidden","name":"empty_lines"},domProps:{"value":_vm.commission.empty_lines}}),_c('k-form-checkbox',{staticClass:"d-inline-block mr-3",attrs:{"validationName":"empty_lines","size":"sm"},model:{value:(_vm.commission.empty_lines),callback:function ($$v) {_vm.$set(_vm.commission, "empty_lines", $$v)},expression:"commission.empty_lines"}},[_vm._v(" Lignes vides ")]),_c('input',{attrs:{"type":"hidden","name":"products"},domProps:{"value":_vm.commission.products}}),_c('k-form-checkbox',{staticClass:"d-inline-block mr-3",attrs:{"validationName":"products","size":"sm"},model:{value:(_vm.commission.products),callback:function ($$v) {_vm.$set(_vm.commission, "products", $$v)},expression:"commission.products"}},[_vm._v(" Produits ")]),_c('input',{attrs:{"type":"hidden","name":"services"},domProps:{"value":_vm.commission.services}}),_c('k-form-checkbox',{staticClass:"d-inline-block mr-3",attrs:{"validationName":"services","size":"sm"},model:{value:(_vm.commission.services),callback:function ($$v) {_vm.$set(_vm.commission, "services", $$v)},expression:"commission.services"}},[_vm._v(" Prestations ")]),_c('input',{attrs:{"type":"hidden","name":"groups"},domProps:{"value":_vm.commission.groups}}),_c('k-form-checkbox',{staticClass:"d-inline-block",attrs:{"validationName":"groups","size":"sm"},model:{value:(_vm.commission.groups),callback:function ($$v) {_vm.$set(_vm.commission, "groups", $$v)},expression:"commission.groups"}},[_vm._v(" Groupes de produits ")])],1),_c('div',{staticClass:"mb-5"},[_c('div',{staticClass:"small font-weight-bold mb-1"},[_c('k-form-select',{staticClass:"d-inline-block",staticStyle:{"width":"160px"},attrs:{"name":"apply_sales_categories","options":_vm.applyMode,"reduce":val => val.value,"size":"sm","clearable":false},model:{value:(_vm.commission.apply_sales_categories),callback:function ($$v) {_vm.$set(_vm.commission, "apply_sales_categories", $$v)},expression:"commission.apply_sales_categories"}}),_vm._v(" aux articles avec les catégories de vente suivantes ")],1),(_vm.commission.sales_categories?.length === 0)?_c('input',{attrs:{"type":"hidden","name":"sales_categories"},domProps:{"value":null}}):_vm._l((_vm.commission.sales_categories),function(category,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"sales_categories[]"},domProps:{"value":category.id}})}),_c('k-form-select',{attrs:{"validationName":"sales_categories","options":_vm.saleCategories,"multiple":"","size":"sm","placeholder":_vm.commission.apply_sales_categories ? 'Toutes les catégories' : null,"required":!_vm.commission.apply_sales_categories},model:{value:(_vm.commission.sales_categories),callback:function ($$v) {_vm.$set(_vm.commission, "sales_categories", $$v)},expression:"commission.sales_categories"}})],2),_c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"small font-weight-bold mb-1"},[_c('k-form-select',{staticClass:"d-inline-block",staticStyle:{"width":"160px"},attrs:{"name":"apply_origins","options":_vm.applyMode,"reduce":val => val.value,"size":"sm","clearable":false},model:{value:(_vm.commission.apply_origins),callback:function ($$v) {_vm.$set(_vm.commission, "apply_origins", $$v)},expression:"commission.apply_origins"}}),_vm._v(" aux clients avec les origines suivantes ")],1),(_vm.commission.origins?.length === 0)?_c('input',{attrs:{"type":"hidden","name":"origins"},domProps:{"value":null}}):_vm._l((_vm.commission.origins),function(origin,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"origins[]"},domProps:{"value":origin.id}})}),_c('k-form-select',{attrs:{"validationName":"origins","options":_vm.origins,"multiple":"","size":"sm","placeholder":_vm.commission.apply_origins ? 'Toutes les origines' : null,"required":!_vm.commission.apply_origins},model:{value:(_vm.commission.origins),callback:function ($$v) {_vm.$set(_vm.commission, "origins", $$v)},expression:"commission.origins"}})],2),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Durée des commissions ")]),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"apply_duration"},domProps:{"value":_vm.commission.apply_duration}}),_c('k-form-checkbox',{attrs:{"validationName":"apply_duration"},model:{value:(_vm.commission.apply_duration),callback:function ($$v) {_vm.$set(_vm.commission, "apply_duration", $$v)},expression:"commission.apply_duration"}},[_vm._v(" Appliquer les commissions sur ")])],1),_c('b-col',{staticClass:"p-0",staticStyle:{"width":"100px"},attrs:{"cols":"auto"}},[_c('k-form-spinner',{attrs:{"name":"duration_value","size":"sm","min":0,"disabled":!_vm.commission.apply_duration},model:{value:(_vm.commission.duration_value),callback:function ($$v) {_vm.$set(_vm.commission, "duration_value", $$v)},expression:"commission.duration_value"}})],1),_c('b-col',{attrs:{"cols":"auto"}},[_vm._v(" mois à partir de la création du client ou de la conversion du prospect. ")])],1)],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionForm/CommissionForm.ts?vue&type=script&lang=ts&external







var CommissionForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionForm, _super);
    function CommissionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.commission = {
            based_on: 1,
            valid_at: 3,
            with_step: false,
            step_mode: 1,
            steps: [],
            apply_team_users: true,
            team_users: [],
            apply_elements: true,
            products: true,
            services: true,
            groups: true,
            empty_lines: true,
            apply_sales_categories: true,
            sales_categories: [],
            apply_origins: true,
            origins: [],
            apply_duration: false,
            duration_value: 0
        };
        _this.basedOnOptions = [
            { text: 'Le chiffre d\'affaires', value: 1 },
            { text: 'La marge brute', value: 2 }
        ];
        _this.withSteps = [
            { text: 'Non', value: false },
            { text: 'Oui', value: true }
        ];
        _this.stepModes = [
            { text: 'Le montant de la vente', value: 1 },
            { text: 'Les chiffres mensuels', value: 2 },
            { text: 'Les chiffres annuels', value: 3 }
        ];
        _this.validAtOptions = [
            { text: 'Lors de la réception du paiement', value: 3 },
            { text: 'À la validation d\'une facture', value: 2 },
            { text: 'Lorsque le devis est marqué comme accepté par le client', value: 1 }
        ];
        _this.useWith = [
            { value: 'empty', text: 'Lignes vides' },
            { value: 'product', text: 'Produits' },
            { value: 'service', text: 'Prestations' },
            { value: 'group', text: 'Groupe de produits/prestations' }
        ];
        _this.applyMode = [
            { label: 'Appliquer', value: true },
            { label: 'Ne pas appliquer', value: false }
        ];
        return _this;
    }
    CommissionForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadOrigins()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadSaleCategories()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommissionForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/sales/commission';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionForm.prototype, "minStepValue", {
        get: function () {
            var _this = this;
            return function (index) {
                var _a;
                if (index === 0) {
                    return 0;
                }
                return ((_a = _this.commission.steps[index - 1].maximum) !== null && _a !== void 0 ? _a : 0) + 1;
            };
        },
        enumerable: false,
        configurable: true
    });
    CommissionForm.prototype.watchStepMode = function () {
        var _a, _b;
        if (this.commission.with_step && ((_b = (_a = this.commission.steps) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0) {
            this.commission.steps = [];
            this.addStep();
        }
    };
    CommissionForm.prototype.watchValue = function () {
        this.commission = Object.assign({
            based_on: 1,
            valid_at: 3,
            with_step: false,
            step_mode: 1,
            steps: [],
            apply_team_users: true,
            team_users: [],
            apply_elements: true,
            products: true,
            services: true,
            groups: true,
            empty_lines: true,
            apply_sales_categories: true,
            sales_categories: [],
            apply_origins: true,
            origins: [],
            apply_duration: false,
            duration_value: 0
        }, this.value ? JSON.parse(JSON.stringify(this.value)) : {});
    };
    CommissionForm.prototype.addStep = function () {
        var _a;
        (_a = this.commission.steps) === null || _a === void 0 ? void 0 : _a.push({
            minimum: null,
            maximum: null,
            pourcentage: 0,
            minimum_amount: null,
            maximum_amount: null,
        });
    };
    CommissionForm.prototype.deleteStep = function (index) {
        var _a;
        (_a = this.commission.steps) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommissionForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('commission.with_step', { deep: true })
    ], CommissionForm.prototype, "watchStepMode", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CommissionForm.prototype, "watchValue", null);
    CommissionForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('customers', ['origins'])), (0,external_vuex_.mapState)('catalog', ['saleCategories'])), (0,external_vuex_.mapGetters)('user', ['currency'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customers', ['loadOrigins'])), (0,external_vuex_.mapActions)('catalog', ['loadSaleCategories'])),
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormSpinner: form_vue_.KFormSpinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BAlert: external_bootstrap_vue_.BAlert,
                TeamUserSelect: interface_vue_.TeamUserSelect, Spinner: interface_vue_.Spinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], CommissionForm);
    return CommissionForm;
}(lib/* Vue */.lD));
/* harmony default export */ var CommissionFormvue_type_script_lang_ts_external = (CommissionForm);

;// ./src/components/CommissionForm/CommissionForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionForm_CommissionFormvue_type_script_lang_ts_external = (CommissionFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionForm/CommissionForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionForm_CommissionFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionForm_CommissionForm = (component.exports);

/***/ }),

/***/ 83862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleReferences_SaleReferences; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleReferences/SaleReferences.vue?vue&type=template&id=060b272d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{ref:"form",attrs:{"action":_vm.formAction,"method":"put","validateDatas":_vm.validateReferences},on:{"submitComplete":_vm.formSubmitted}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.params.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceDay')))])])]),_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap",attrs:{"responsive":""}},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th'),_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referenceTypeNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('sales.params.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.affair.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_affair_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.sales_affair_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_affair_reference_prefix", $$v)},expression:"localConfig.sales_affair_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_affair_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_affair_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_affair_reference_mode", $$v)},expression:"localConfig.sales_affair_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_affair_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.sales_affair_reference_mode !== 1},model:{value:(_vm.localConfig.sales_affair_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_affair_reference_number", $$v)},expression:"localConfig.sales_affair_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_affair_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_affair_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_affair_reference_length", $$v)},expression:"localConfig.sales_affair_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.affairReferenceExample))])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.quotation.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_quotation_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.sales_quotation_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_quotation_reference_prefix", $$v)},expression:"localConfig.sales_quotation_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_quotation_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_quotation_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_quotation_reference_mode", $$v)},expression:"localConfig.sales_quotation_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_quotation_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.sales_quotation_reference_mode !== 1},model:{value:(_vm.localConfig.sales_quotation_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_quotation_reference_number", $$v)},expression:"localConfig.sales_quotation_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_quotation_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_quotation_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_quotation_reference_length", $$v)},expression:"localConfig.sales_quotation_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.quotationReferenceExample))])]),(_vm.hasModule('sales-commands'))?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.command.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_command_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.sales_command_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_command_reference_prefix", $$v)},expression:"localConfig.sales_command_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_command_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_command_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_command_reference_mode", $$v)},expression:"localConfig.sales_command_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_command_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.sales_command_reference_mode !== 1},model:{value:(_vm.localConfig.sales_command_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_command_reference_number", $$v)},expression:"localConfig.sales_command_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_command_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_command_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_command_reference_length", $$v)},expression:"localConfig.sales_command_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.commandReferenceExample))])]):_vm._e(),(_vm.hasModule('sales-proformas'))?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.proforma.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_proforma_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.sales_proforma_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_proforma_reference_prefix", $$v)},expression:"localConfig.sales_proforma_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_proforma_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_proforma_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_proforma_reference_mode", $$v)},expression:"localConfig.sales_proforma_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_proforma_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.sales_proforma_reference_mode !== 1},model:{value:(_vm.localConfig.sales_proforma_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_proforma_reference_number", $$v)},expression:"localConfig.sales_proforma_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_proforma_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_proforma_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_proforma_reference_length", $$v)},expression:"localConfig.sales_proforma_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.proformaReferenceExample))])]):_vm._e(),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.invoice.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_invoice_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.sales_invoice_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_invoice_reference_prefix", $$v)},expression:"localConfig.sales_invoice_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_invoice_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_invoice_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_invoice_reference_mode", $$v)},expression:"localConfig.sales_invoice_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_invoice_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.sales_invoice_reference_mode !== 1},model:{value:(_vm.localConfig.sales_invoice_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_invoice_reference_number", $$v)},expression:"localConfig.sales_invoice_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_invoice_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_invoice_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_invoice_reference_length", $$v)},expression:"localConfig.sales_invoice_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.invoiceReferenceExample))])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.credit.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_credit_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.sales_credit_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_credit_reference_prefix", $$v)},expression:"localConfig.sales_credit_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_credit_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_credit_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_credit_reference_mode", $$v)},expression:"localConfig.sales_credit_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_credit_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.sales_credit_reference_mode !== 1},model:{value:(_vm.localConfig.sales_credit_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_credit_reference_number", $$v)},expression:"localConfig.sales_credit_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_credit_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_credit_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_credit_reference_length", $$v)},expression:"localConfig.sales_credit_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.creditReferenceExample))])]),(_vm.hasModule('sales-deliveries'))?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.delivery.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[sales_delivery_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.sales_delivery_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_delivery_reference_prefix", $$v)},expression:"localConfig.sales_delivery_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_delivery_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_delivery_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_delivery_reference_mode", $$v)},expression:"localConfig.sales_delivery_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[sales_delivery_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.sales_delivery_reference_mode !== 1},model:{value:(_vm.localConfig.sales_delivery_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_delivery_reference_number", $$v)},expression:"localConfig.sales_delivery_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[sales_delivery_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.sales_delivery_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_delivery_reference_length", $$v)},expression:"localConfig.sales_delivery_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.deliveryReferenceExample))])]):_vm._e()])]),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1),_c('b-modal',{attrs:{"ok-title":"Valider l'enregistrement","cancel-title":_vm.$t('interface.cancel'),"ok-disabled":_vm.referencesLoading},on:{"hidden":function($event){_vm.referencesValidated = false},"ok":_vm.saveDatas},model:{value:(_vm.validatingReferences),callback:function ($$v) {_vm.validatingReferences=$$v},expression:"validatingReferences"}},[(_vm.referencesLoading)?_c('Spinner'):(_vm.referencesPreview)?[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Vous trouverez ci-dessous vos prochaines références en fonction des paramètres que vous avez spécifiés. ")]),_c('table',{staticClass:"table table-sm mb-0"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Devis :")]),_c('td',[_vm._v(_vm._s(_vm.referencesPreview.quotation_reference))])]),_c('tr',[_c('td',[_vm._v("Bon de commande :")]),_c('td',[_vm._v(_vm._s(_vm.referencesPreview.command_reference))])]),_c('tr',[_c('td',[_vm._v("Facture proforma :")]),_c('td',[_vm._v(_vm._s(_vm.referencesPreview.proforma_reference))])]),_c('tr',[_c('td',[_vm._v("Facture :")]),_c('td',[_vm._v(_vm._s(_vm.referencesPreview.invoice_reference))])]),_c('tr',[_c('td',[_vm._v("Avoir :")]),_c('td',[_vm._v(_vm._s(_vm.referencesPreview.credit_reference))])]),_c('tr',[_c('td',[_vm._v("Bon de livraison :")]),_c('td',[_vm._v(_vm._s(_vm.referencesPreview.delivery_reference))])])])])]:_vm._e()],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleReferences/SaleReferences.ts?vue&type=script&lang=ts&external






var SaleReferences = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleReferences, _super);
    function SaleReferences() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        _this.validatingReferences = false;
        _this.referencesValidated = false;
        _this.referencesLoading = false;
        _this.referencesPreview = null;
        _this.numberTypes = [
            { id: 1, label: 'Normal' },
            { id: 2, label: 'Remise à 0 tous les mois' },
            { id: 3, label: 'Remise à 0 tous les ans' }
        ];
        return _this;
    }
    Object.defineProperty(SaleReferences.prototype, "affairReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_affair_reference_prefix, this.localConfig.sales_affair_reference_number, this.localConfig.sales_affair_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleReferences.prototype, "quotationReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_quotation_reference_prefix, this.localConfig.sales_quotation_reference_number, this.localConfig.sales_quotation_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleReferences.prototype, "commandReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_command_reference_prefix, this.localConfig.sales_command_reference_number, this.localConfig.sales_command_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleReferences.prototype, "proformaReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_proforma_reference_prefix, this.localConfig.sales_proforma_reference_number, this.localConfig.sales_proforma_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleReferences.prototype, "invoiceReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_invoice_reference_prefix, this.localConfig.sales_invoice_reference_number, this.localConfig.sales_invoice_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleReferences.prototype, "creditReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_credit_reference_prefix, this.localConfig.sales_credit_reference_number, this.localConfig.sales_credit_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleReferences.prototype, "deliveryReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.sales_delivery_reference_prefix, this.localConfig.sales_delivery_reference_number, this.localConfig.sales_delivery_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    SaleReferences.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    SaleReferences.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return null;
        }
        var numberLength = String(number).length;
        if (numberLength > length) {
            length = numberLength;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    SaleReferences.prototype.validateReferences = function (data) {
        if (!this.referencesValidated) {
            this.validatingReferences = true;
            this.loadPreviewReferences(data);
            return false;
        }
        return true;
    };
    SaleReferences.prototype.loadPreviewReferences = function (data) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.referencesLoading = true;
                        return [4 /*yield*/, this.$kwSales.axios.post('/sales/test-references', data)
                                .then(function (response) {
                                _this.referencesPreview = response.data;
                                _this.referencesLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SaleReferences.prototype.saveDatas = function () {
        this.referencesValidated = true;
        var form = this.$refs.form;
        form.submit();
    };
    SaleReferences = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber,
                BTableSimple: external_bootstrap_vue_.BTableSimple, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal,
                Spinner: interface_vue_.Spinner
            }
        })
    ], SaleReferences);
    return SaleReferences;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var SaleReferencesvue_type_script_lang_ts_external = (SaleReferences);

;// ./src/components/SaleReferences/SaleReferences.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleReferences_SaleReferencesvue_type_script_lang_ts_external = (SaleReferencesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SaleReferences/SaleReferences.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleReferences_SaleReferencesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleReferences_SaleReferences = (component.exports);

/***/ }),

/***/ 83966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ RecoveryInvoiceStepParams_RecoveryInvoiceStepParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RecoveryInvoiceStepParams/RecoveryInvoiceStepParams.vue?vue&type=template&id=1da6fb9a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',[_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":"Expéditeur à utiliser pour l'envoi des relances automatique par email"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_recovery_use_commercial]"},domProps:{"value":_vm.localConfig.sales_recovery_use_commercial ? 1 : 0}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.localConfig.sales_recovery_use_commercial),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_recovery_use_commercial", $$v)},expression:"localConfig.sales_recovery_use_commercial"}},[_vm._v(" Utiliser le commercial renseigné sur le document de vente ")])],1),(!_vm.localConfig.sales_recovery_use_commercial)?_c('b-form-group',{staticClass:"mt-3",attrs:{"label":"Utilisateur à utiliser pour l'envoi des emails"}},[_c('TeamUserSelect',{attrs:{"required":"","reduce":val => val.id},model:{value:(_vm.recoverySenderId),callback:function ($$v) {_vm.recoverySenderId=$$v},expression:"recoverySenderId"}}),_c('input',{attrs:{"type":"hidden","name":"configs[sales_recovery_sender]"},domProps:{"value":_vm.recoverySenderId}})],1):_vm._e(),_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(" Annuler ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(" Enregistrer ")])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/RecoveryInvoiceStepParams/RecoveryInvoiceStepParams.ts?vue&type=script&lang=ts&external





var RecoveryInvoiceStepParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(RecoveryInvoiceStepParams, _super);
    function RecoveryInvoiceStepParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.recoverySenderId = null;
        return _this;
    }
    RecoveryInvoiceStepParams.prototype.watchRecoverySender = function () {
        var _a;
        this.recoverySenderId = (_a = this.localConfig.sales_recovery_sender) === null || _a === void 0 ? void 0 : _a.id;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localConfig.sales_recovery_sender', { immediate: true })
    ], RecoveryInvoiceStepParams.prototype, "watchRecoverySender", null);
    RecoveryInvoiceStepParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BCard: external_bootstrap_vue_.BCard, BButton: external_bootstrap_vue_.BButton,
                TeamUserSelect: interface_vue_.TeamUserSelect
            }
        })
    ], RecoveryInvoiceStepParams);
    return RecoveryInvoiceStepParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var RecoveryInvoiceStepParamsvue_type_script_lang_ts_external = (RecoveryInvoiceStepParams);

;// ./src/components/RecoveryInvoiceStepParams/RecoveryInvoiceStepParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var RecoveryInvoiceStepParams_RecoveryInvoiceStepParamsvue_type_script_lang_ts_external = (RecoveryInvoiceStepParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/RecoveryInvoiceStepParams/RecoveryInvoiceStepParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  RecoveryInvoiceStepParams_RecoveryInvoiceStepParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RecoveryInvoiceStepParams_RecoveryInvoiceStepParams = (component.exports);

/***/ }),

/***/ 84034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SaleTermsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SaleTermsView.vue?vue&type=template&id=7ffc118f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SaleTerms')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SaleTerms/SaleTerms.vue + 7 modules
var SaleTerms = __webpack_require__(63630);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SaleTermsView.vue?vue&type=script&lang=ts



var SaleTermsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleTermsView, _super);
    function SaleTermsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaleTermsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SaleTerms: SaleTerms/* default */.A
            }
        })
    ], SaleTermsView);
    return SaleTermsView;
}(lib/* Vue */.lD));
/* harmony default export */ var SaleTermsViewvue_type_script_lang_ts = (SaleTermsView);

;// ./src/views/SaleTermsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SaleTermsViewvue_type_script_lang_ts = (SaleTermsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/SaleTermsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_SaleTermsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SaleTermsView = (component.exports);

/***/ }),

/***/ 84247:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 84451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ 84777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ RecoveryInvoicesView_RecoveryInvoicesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RecoveryInvoicesView/RecoveryInvoicesView.vue?vue&type=template&id=9ec363cc
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[(_vm.recoverySteps.length === 0)?_c('div',{staticClass:"text-center mt-5"},[_c('p',[_vm._v(" Vous n'avez aucune étape de relance de paiement ")]),_c('b-button',{staticClass:"mt-2",attrs:{"variant":"primary","size":"sm","to":{ name: 'sales-recovery-invoice-steps' }}},[_vm._v(" Configurer mes étapes de relance ")])],1):_c('b-tabs',{staticClass:"tabs-card sales-recovery-invoice-tabs"},_vm._l((_vm.recoverySteps),function(step){return _c('b-tab',{key:step.id,attrs:{"title":step.name,"lazy":""}},[_c('RecoveryInvoiceView',{attrs:{"value":step}})],1)}),1)]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/RecoveryInvoicesView/RecoveryInvoiceView.vue + 3 modules
var RecoveryInvoiceView = __webpack_require__(37280);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/RecoveryInvoicesView/RecoveryInvoicesView.ts?vue&type=script&lang=ts&external






var RecoveryInvoicesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(RecoveryInvoicesView, _super);
    function RecoveryInvoicesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    RecoveryInvoicesView.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadRecoverySteps()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    RecoveryInvoicesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadRecoverySteps'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('sales', ['recoverySteps'])),
            components: {
                Spinner: interface_vue_.Spinner,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BButton: external_bootstrap_vue_.BButton,
                RecoveryInvoiceView: RecoveryInvoiceView/* default */.A
            }
        })
    ], RecoveryInvoicesView);
    return RecoveryInvoicesView;
}(lib/* Vue */.lD));
/* harmony default export */ var RecoveryInvoicesViewvue_type_script_lang_ts_external = (RecoveryInvoicesView);

;// ./src/components/RecoveryInvoicesView/RecoveryInvoicesView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var RecoveryInvoicesView_RecoveryInvoicesViewvue_type_script_lang_ts_external = (RecoveryInvoicesViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/RecoveryInvoicesView/RecoveryInvoicesView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  RecoveryInvoicesView_RecoveryInvoicesViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RecoveryInvoicesView_RecoveryInvoicesView = (component.exports);

/***/ }),

/***/ 85096:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ 85250:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(37217),
    assignMergeValue = __webpack_require__(87805),
    baseFor = __webpack_require__(86649),
    baseMergeDeep = __webpack_require__(42824),
    isObject = __webpack_require__(23805),
    keysIn = __webpack_require__(37241),
    safeGet = __webpack_require__(14974);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 85498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ 85858:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/customers-vue");

/***/ }),

/***/ 86009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(34840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 86070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SepaDepositDownload_SepaDepositDownload; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SepaDepositDownload/SepaDepositDownload.vue?vue&type=template&id=1c434040
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" "),_c('b-modal',{attrs:{"hide-footer":"","no-close-on-backdrop":"","no-close-on-esc":"","hide-header-close":""},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('Spinner')],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SepaDepositDownload/SepaDepositDownload.ts?vue&type=script&lang=ts&external




var SepaDepositDownload = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositDownload, _super);
    function SepaDepositDownload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(SepaDepositDownload.prototype, "computedLabel", {
        // Return confirmation label
        get: function () {
            var _a;
            return (_a = this.confirmLabel) !== null && _a !== void 0 ? _a : this.label;
        },
        enumerable: false,
        configurable: true
    });
    // Send ajax query
    SepaDepositDownload.prototype.download = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.modalState = true;
                this.$kwSales.axios.get('/sales/sepa-deposit/' + this.deposit.id + '/download')
                    .then(function (response) {
                    var file = response.data;
                    _this.downloadFile(file.file, file.filename);
                })
                    .finally(function () {
                    _this.modalState = false;
                });
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SepaDepositDownload.prototype, "deposit", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Télécharger' })
    ], SepaDepositDownload.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositDownload.prototype, "confirmLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositDownload.prototype, "explain", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositDownload.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ size: 'sm' })
    ], SepaDepositDownload.prototype, "size", void 0);
    SepaDepositDownload = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal
            }
        })
    ], SepaDepositDownload);
    return SepaDepositDownload;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var SepaDepositDownloadvue_type_script_lang_ts_external = (SepaDepositDownload);

;// ./src/components/SepaDepositDownload/SepaDepositDownload.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SepaDepositDownload_SepaDepositDownloadvue_type_script_lang_ts_external = (SepaDepositDownloadvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SepaDepositDownload/SepaDepositDownload.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SepaDepositDownload_SepaDepositDownloadvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SepaDepositDownload_SepaDepositDownload = (component.exports);

/***/ }),

/***/ 86169:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ 86192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IH: function() { return /* binding */ checkDepositRelations; },
/* harmony export */   XP: function() { return /* binding */ needFetchCheckDeposit; },
/* harmony export */   tc: function() { return /* binding */ fetchCheckDeposit; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var checkDepositRelations = [
    'account', 'payments', 'payments.uses'
];
var needFetchCheckDeposit = function (model) {
    return !checkDepositRelations.every(function (relation) { return relation in model; });
};
var fetchCheckDeposit = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/sales/check-deposit/' + id, {
                    params: {
                        include: checkDepositRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 86571:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ 86614:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'download';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f019';
var svgPathData = 'M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.cb = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 86649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(83221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 86794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ 87068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(37217),
    equalArrays = __webpack_require__(25911),
    equalByTag = __webpack_require__(21986),
    equalObjects = __webpack_require__(50689),
    getTag = __webpack_require__(5861),
    isArray = __webpack_require__(56449),
    isBuffer = __webpack_require__(3656),
    isTypedArray = __webpack_require__(37167);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 87296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(55481);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 87805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(43360),
    eq = __webpack_require__(75288);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 87978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(60270),
    get = __webpack_require__(58156),
    hasIn = __webpack_require__(80631),
    isKey = __webpack_require__(28586),
    isStrictComparable = __webpack_require__(30756),
    matchesStrictComparable = __webpack_require__(67197),
    toKey = __webpack_require__(77797);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 88274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PaymentForm_PaymentForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentForm/PaymentForm.vue?vue&type=template&id=19ec18d2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":_vm.modalTitle,"size":"payment","scrollable":"","body-class":"p-0","form":_vm.$refs.form?.$el},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.document && _vm.transaction === null)?_c('b-form-row',{staticClass:"text-center payment-indicator m-0"},[_c('b-col',[_vm._v(" "+_vm._s(_vm.totalDueLabel)),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.document.to_paid, _vm.document.currency))+" ")]),_c('b-col',[_vm._v(" "+_vm._s(_vm.alreadyPaidLabel)),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.document.already_paid, _vm.document.currency))+" ")]),_c('b-col',[_vm._v(" "+_vm._s(_vm.stayToPayLabel)),_c('br'),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.document.stay_to_pay, _vm.document.currency))+" ")])],1):_vm._e(),(_vm.transaction === null && !_vm.payment.id && _vm.type === 'invoice' && (_vm.availableCredits !== false || (_vm.document?.customer?.sales_statistics?.payment_not_used ?? 0) > 0))?_c('div',{class:{
      'px-4 pt-4 pb-0': true,
      'd-none': _vm.availableCredits === null
    }},[(_vm.availableCredits !== false)?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_c('p',{staticClass:"font-weight-bold small mb-1"},[_vm._v(" Avoir(s) disponible(s) pour ce client ")]),_c('UseCredit',{attrs:{"invoice":_vm.document,"withLabel":false,"withButton":"","size":"sm"},on:{"noCredits":function($event){_vm.availableCredits = false},"haveCredits":function($event){_vm.availableCredits = true},"success":_vm.creditUsed}})],1):_vm._e(),((_vm.document?.customer?.sales_statistics?.payment_not_used ?? 0) > 0)?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_c('p',{staticClass:"font-weight-bold small mb-1"},[_vm._v(" Paiement(s) non entièrement utilisé(s) pour ce client ")]),_c('UseAvailablePayment',{attrs:{"invoice":_vm.document,"withLabel":false,"withButton":"","size":"sm"},on:{"success":_vm.creditUsed}})],1):_vm._e()],1):_vm._e(),_c('k-form',{ref:"form",staticClass:"p-4",attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.formDatas},on:{"submitComplete":_vm.formSubmitted}},[(_vm.payment.id)?_c('b-alert',{staticClass:"p-2 small",attrs:{"variant":"warning","show":""}},[_c('p',{staticClass:"mb-1"},[_vm._v(" Seules les informations qui ne concernent pas directement le paiement peuvent être modifiées. Vous ne pouvez également pas supprimer le paiement mais celui-ci peut être annulé. ")]),_c('p',{staticClass:"text-center mb-0"},[_c('CancelPayment',{attrs:{"size":"sm"},model:{value:(_vm.payment),callback:function ($$v) {_vm.payment=$$v},expression:"payment"}})],1)]):_vm._e(),(_vm.transaction === null)?_c('b-form-group',{attrs:{"label":"Compte bancaire","label-cols-md":_vm.labelCols}},[_c('AccountSelect',{attrs:{"selectDefault":""},model:{value:(_vm.payment.account),callback:function ($$v) {_vm.$set(_vm.payment, "account", $$v)},expression:"payment.account"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Mode de règlement","label-cols-md":_vm.labelCols}},[(!_vm.payment.id)?_c('PaymentMethodSelect',{attrs:{"required":""},model:{value:(_vm.payment.payment_method),callback:function ($$v) {_vm.$set(_vm.payment, "payment_method", $$v)},expression:"payment.payment_method"}}):_c('div',{staticClass:"py-2"},[_vm._v(" "+_vm._s(_vm.payment.payment_method.label)+" ")])],1),_c('b-form-group',{attrs:{"label":"Date du paiement","label-cols-md":_vm.labelCols}},[_c('div',{staticStyle:{"max-width":"160px"}},[(!_vm.payment.id && _vm.transaction === null)?_c('k-form-datepicker',{attrs:{"min-date":_vm.minDate,"required":""},model:{value:(_vm.payment.date),callback:function ($$v) {_vm.$set(_vm.payment, "date", $$v)},expression:"payment.date"}}):_c('div',{staticClass:"py-2"},[_vm._v(" "+_vm._s(_vm.date(_vm.payment.date))+" ")])],1)]),(_vm.transaction === null)?_c('b-form-group',{attrs:{"label":"Référence","label-cols-md":_vm.labelCols}},[(!_vm.payment.id)?_c('k-form-input',{model:{value:(_vm.payment.reference),callback:function ($$v) {_vm.$set(_vm.payment, "reference", $$v)},expression:"payment.reference"}}):_c('div',{staticClass:"py-2"},[_vm._v(" "+_vm._s(_vm.payment.reference ? _vm.payment.reference : '-')+" ")])],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Montant","label-cols-md":_vm.labelCols}},[_c('div',{staticStyle:{"max-width":"160px"}},[(!_vm.payment.id && _vm.transaction === null)?_c('b-input-group',{attrs:{"append":_vm.payment.currency ? _vm.payment.currency.symbol : null}},[_c('k-form-number',{on:{"input":_vm.amountUpdated},model:{value:(_vm.payment.amount),callback:function ($$v) {_vm.$set(_vm.payment, "amount", $$v)},expression:"payment.amount"}})],1):_c('div',{staticClass:"py-2"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.payment.amount, _vm.payment.currency))+" ")])],1),(_vm.withGuaranteeHoldback === false && _vm.documentHasGuaranteeHoldback)?[_c('input',{attrs:{"type":"hidden","name":"with_guarantee_holdback_paid"},domProps:{"value":_vm.withGuaranteeHoldbackPaid ?? false}}),_c('k-form-checkbox',{staticClass:"mt-2",attrs:{"size":"sm"},model:{value:(_vm.withGuaranteeHoldbackPaid),callback:function ($$v) {_vm.withGuaranteeHoldbackPaid=$$v},expression:"withGuaranteeHoldbackPaid"}},[_vm._v(" Régler également la retenue de garantie ")])]:_vm._e(),(_vm.document !== null)?_c('k-form-checkbox',{staticClass:"mt-2",attrs:{"size":"sm"},model:{value:(_vm.multipleDocuments),callback:function ($$v) {_vm.multipleDocuments=$$v},expression:"multipleDocuments"}},[_vm._v(" "+_vm._s(_vm.linkMultipleDocumentLabel)+" ")]):_vm._e()],2),(_vm.multipleDocuments || _vm.document === null)?[_c('p',{staticClass:"font-weight-bold mb-1 mt-4"},[_vm._v(" "+_vm._s(_vm.linkedDocumentsTitle)+" ")]),_c('div',{staticClass:"position-relative"},[_c('k-form-input',{ref:"search",staticClass:"mb-1",attrs:{"type":"search","placeholder":_vm.searchDocumentsLabel,"size":"sm"},on:{"input":_vm.searchInvoice,"focus":function($event){return _vm.searchInvoice()}},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_c('b-list-group',{ref:"list",staticClass:"payment-form-search-results position-absolute w-100 small",staticStyle:{"z-index":"99"}},[(_vm.fetchLoading)?_c('b-list-group-item',{staticClass:"text-center"},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1):_vm._e(),(_vm.searchDocuments)?[(_vm.searchDocuments.length === 0)?_c('b-list-group-item',{staticClass:"text-center"},[_vm._v(" Aucun document ")]):_c('b-list-group-item',{staticClass:"px-2 py-1 header"},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" Date ")]),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" Référence ")]),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" Total HT ")]),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" À payer ")])],1)],1),_vm._l((_vm.searchDocuments),function(document,i){return _c('b-list-group-item',{key:i,staticClass:"px-2 py-1",on:{"click":function($event){$event.preventDefault();return _vm.addDocument(document, i)}}},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.date(document.date))+" ")]),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(document.reference)+" ")]),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(document.total_ttc, document.currency))+" ")]),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(document.stay_to_pay, document.currency))+" ")])],1)],1)})]:_vm._e()],2)],1),_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm table-bordered mb-4 align-middle payment-form-linked-documents text-nowrap"},[_c('thead',[_c('tr',{staticClass:"small text-center"},[_c('th',[_vm._v("Date")]),_c('th',[_vm._v(_vm._s(_vm.referenceDocumentsTitle))]),_c('th',[_vm._v("À payer")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Montant")]),_c('th',{staticStyle:{"width":"30px"}})])]),_c('tbody',{staticStyle:{"font-size":".8rem"}},[(_vm.payment.documents.length === 0)?_c('tr',[_c('td',{staticClass:"p-4 text-center",attrs:{"colspan":"5"}},[_vm._v(" "+_vm._s(_vm.noDocumentLabel)+" ")])]):_vm._e(),_vm._l((_vm.payment.documents),function(document,i){return [_c('tr',{key:i,class:{ withGuaranteeHoldbackTop: _vm.hasGuaranteeHoldback(document) }},[_c('td',[_vm._v(_vm._s(_vm.date(document.document.date)))]),_c('td',[_vm._v(_vm._s(document.document.reference))]),_c('td',[_vm._v(_vm._s(_vm.stayToPay(document)))]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.payment.currency ? _vm.payment.currency.symbol : null,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'documents[' + i + '][amount]',"size":"sm","readonly":document.guarantee_holdback},model:{value:(document.ttc),callback:function ($$v) {_vm.$set(document, "ttc", $$v)},expression:"document.ttc"}})],1)],1),_c('td',{staticClass:"p-0 text-center"},[(_vm.payment.documents.length > 1)?_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times'],"rowspan":_vm.hasGuaranteeHoldback(document) ? 2 : 1},on:{"click":function($event){$event.preventDefault();return _vm.removeDocument(i)}}}):_vm._e()],1)]),(_vm.hasGuaranteeHoldback(document))?_c('tr',{key:'guarantee-' + i,staticClass:"withGuaranteeHoldbackBottom"},[_c('td',{attrs:{"colspan":"4"}},[_c('k-form-checkbox',{attrs:{"name":'documents[' + i + '][guarantee_holdback]',"size":"sm","disabled":_vm.payment.id !== undefined},on:{"input":function($event){return _vm.onSelectGuaranteeHoldback(i)}},model:{value:(_vm.payment.documents[i].guarantee_holdback),callback:function ($$v) {_vm.$set(_vm.payment.documents[i], "guarantee_holdback", $$v)},expression:"payment.documents[i].guarantee_holdback"}},[_vm._v(" Payer la retenue de garantie ")])],1)]):_vm._e()]})],2),_c('tfoot',[_c('tr',{class:{
                small: true,
                'text-danger': _vm.stayAmount < 0,
                'text-success': _vm.stayAmount > 0,
              }},[_c('th',{staticClass:"text-right",attrs:{"colspan":"3"}},[_vm._v(" Solde du paiement : ")]),_c('th',{staticClass:"text-right"},[(_vm.stayAmount > 0)?[_vm._v("+")]:_vm._e(),_vm._v(" "+_vm._s(this.formattedNumber(_vm.stayAmount, this.payment.currency ? this.payment.currency : null))+" ")],2),_c('th')])])])])]:_vm._e(),(_vm.transaction === null)?_c('b-form-group',{attrs:{"label":"Commentaires"}},[_c('k-form-textarea',{model:{value:(_vm.payment.comments),callback:function ($$v) {_vm.$set(_vm.payment, "comments", $$v)},expression:"payment.comments"}})],1):_vm._e(),((!_vm.payment.id && _vm.document && _vm.document.currency && _vm.document.currency.id !== _vm.currency.id) || (_vm.payment.id && _vm.payment.currency && _vm.payment.currency.id !== _vm.currency.id))?_c('b-form-group',{attrs:{"label":"Devise","label-cols-md":_vm.labelCols}},[(!_vm.payment.id)?_c('CurrencySelect',{attrs:{"selectDefault":""},model:{value:(_vm.payment.currency),callback:function ($$v) {_vm.$set(_vm.payment, "currency", $$v)},expression:"payment.currency"}}):_c('div',{staticClass:"py-2"},[_vm._v(" "+_vm._s(_vm.payment.currency.code)+" ("+_vm._s(_vm.payment.currency.symbol)+") ")])],1):_vm._e(),(_vm.payment.currency && _vm.payment.currency.id !== _vm.currency.id)?_c('b-form-group',{attrs:{"label":"Taux de change","label-cols-md":_vm.labelCols}},[_c('div',{staticStyle:{"max-width":"200px"}},[_c('b-input-group',[_c('k-form-number',{attrs:{"noDefaultValue":""},model:{value:(_vm.payment.exchange_rate),callback:function ($$v) {_vm.$set(_vm.payment, "exchange_rate", $$v)},expression:"payment.exchange_rate"}}),_c('b-input-group-text',[_vm._v(" "+_vm._s(_vm.payment.currency ? _vm.payment.currency.symbol : '')+" = 1 "+_vm._s(_vm.currency.symbol)+" ")])],1)],1)]):_vm._e(),(_vm.payment.payment_method && _vm.payment.payment_method.type && _vm.payment.payment_method.type.id === 2)?[_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Remise de chèque ")]),_c('b-form-group',{attrs:{"label":"Banque émettrice","label-cols-md":_vm.labelCols}},[_c('k-form-input',{model:{value:(_vm.payment.check_bank),callback:function ($$v) {_vm.$set(_vm.payment, "check_bank", $$v)},expression:"payment.check_bank"}})],1),_c('b-form-group',{attrs:{"label":"Émetteur du chèque","label-cols-md":_vm.labelCols}},[_c('k-form-input',{model:{value:(_vm.payment.check_issuer),callback:function ($$v) {_vm.$set(_vm.payment, "check_issuer", $$v)},expression:"payment.check_issuer"}})],1)]:_vm._e()],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(31126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/components/AccountSelect/AccountSelect.vue + 3 modules
var AccountSelect = __webpack_require__(5182);
// EXTERNAL MODULE: ./src/components/CancelPayment/CancelPayment.vue + 3 modules
var CancelPayment = __webpack_require__(30404);
// EXTERNAL MODULE: ./src/components/UseCredit/UseCredit.vue + 3 modules
var UseCredit = __webpack_require__(34109);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UseAvailablePayment/UseAvailablePayment.vue?vue&type=template&id=2cc9d973
var UseAvailablePaymentvue_type_template_id_2cc9d973_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formUrl},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.withLabel !== false ? 'Paiement à utiliser :' : null}},[_c('k-form-select',{attrs:{"validationName":"invoice","options":_vm.payments,"getOptionLabel":opt => 'Paiement du ' + _vm.date(opt.date) + ' - Solde : ' + _vm.formattedNumber(opt.stay_to_use, opt.currency),"reduce":opt => opt.id,"required":_vm.withButton === false,"size":_vm.size},model:{value:(_vm.usePayment),callback:function ($$v) {_vm.usePayment=$$v},expression:"usePayment"}}),_c('input',{attrs:{"type":"hidden","name":"invoice"},domProps:{"value":_vm.invoice.id}})],1),(_vm.withButton !== false && _vm.usePayment)?_c('b-button',{staticClass:"mt-2",attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(" Utiliser le solde ")]):_vm._e()],1)],1)
}
var UseAvailablePaymentvue_type_template_id_2cc9d973_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UseAvailablePayment/UseAvailablePayment.ts?vue&type=script&lang=ts&external





var UseAvailablePayment = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UseAvailablePayment, _super);
    function UseAvailablePayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.payments = [];
        _this.usePayment = null;
        return _this;
    }
    Object.defineProperty(UseAvailablePayment.prototype, "formUrl", {
        get: function () {
            return '/sales/payment/' + this.usePayment + '/use';
        },
        enumerable: false,
        configurable: true
    });
    UseAvailablePayment.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.invoice) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchPayments()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    UseAvailablePayment.prototype.submitComplete = function (response) {
        return response.data;
    };
    UseAvailablePayment.prototype.fetchPayments = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/payment', {
                                params: {
                                    include: 'currency',
                                    filter: {
                                        customer: (_a = this.invoice.customer) === null || _a === void 0 ? void 0 : _a.id,
                                        excludeCanceled: true,
                                        withSold: true
                                    }
                                }
                            })
                                .then(function (response) {
                                _this.payments = response.data.data;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], UseAvailablePayment.prototype, "invoice", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], UseAvailablePayment.prototype, "withLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], UseAvailablePayment.prototype, "withButton", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UseAvailablePayment.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('success')
    ], UseAvailablePayment.prototype, "submitComplete", null);
    UseAvailablePayment = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BButton: external_bootstrap_vue_.BButton,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], UseAvailablePayment);
    return UseAvailablePayment;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var UseAvailablePaymentvue_type_script_lang_ts_external = (UseAvailablePayment);

;// ./src/components/UseAvailablePayment/UseAvailablePayment.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UseAvailablePayment_UseAvailablePaymentvue_type_script_lang_ts_external = (UseAvailablePaymentvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/UseAvailablePayment/UseAvailablePayment.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  UseAvailablePayment_UseAvailablePaymentvue_type_script_lang_ts_external,
  UseAvailablePaymentvue_type_template_id_2cc9d973_render,
  UseAvailablePaymentvue_type_template_id_2cc9d973_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UseAvailablePayment_UseAvailablePayment = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentForm/PaymentForm.ts?vue&type=script&lang=ts&external













var PaymentForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentForm, _super);
    function PaymentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.payment = {
            documents: []
        };
        _this.modalState = false;
        _this.timeout = null;
        _this.labelCols = 4;
        _this.multipleDocuments = false;
        _this.fetchLoading = false;
        _this.searchTerm = null;
        _this.searchDocuments = null;
        _this.localWithGuaranteeHoldback = false;
        _this.withGuaranteeHoldbackPaid = false;
        _this.availableCredits = null;
        return _this;
    }
    PaymentForm.prototype.beforeDestroy = function () {
        window.removeEventListener('click', this.listenClick);
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    };
    Object.defineProperty(PaymentForm.prototype, "documentHasGuaranteeHoldback", {
        get: function () {
            return this.document !== null && this.document.guarantee_holdback_status === 0 && this.document.guarantee_holdback_amount > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "minDate", {
        get: function () {
            if (this.team.sales['closed_period']) {
                return external_moment_default()(this.team.sales['closed_period']).add(1, 'day').format('YYYY-MM-DD');
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/sales/payment';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "formDatas", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g;
            var payment = this.payment;
            return {
                account: payment.account ? payment.account.id : null,
                payment_method: payment.payment_method ? payment.payment_method.id : null,
                date: payment.date,
                reference: (_a = payment.reference) !== null && _a !== void 0 ? _a : null,
                amount: payment.amount,
                with_guarantee_holdback_paid: this.withGuaranteeHoldbackPaid,
                documents: payment.documents.map(function (use) {
                    var _a;
                    return ({
                        type: use.document_type,
                        id: use.document_id,
                        amount: use.ttc,
                        guarantee_holdback: (_a = use.guarantee_holdback) !== null && _a !== void 0 ? _a : false,
                    });
                }),
                comments: (_b = payment.comments) !== null && _b !== void 0 ? _b : null,
                currency: payment.currency ? payment.currency.id : null,
                exchange_rate: (_c = payment.exchange_rate) !== null && _c !== void 0 ? _c : null,
                check_bank: (_d = payment.check_bank) !== null && _d !== void 0 ? _d : null,
                check_issuer: (_e = payment.check_issuer) !== null && _e !== void 0 ? _e : null,
                transaction: (_g = (_f = this.transaction) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : null
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'Modification du paiement' : 'Création d\'un paiement';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "totalDueLabel", {
        get: function () {
            return this.type === 'credit' ? 'Total dû' : 'Total à payer';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "alreadyPaidLabel", {
        get: function () {
            return this.type === 'credit' ? 'Déjà remboursé' : 'Déjà payé';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "stayToPayLabel", {
        get: function () {
            return this.type === 'credit' ? 'Reste à rembourser' : 'Reste à payer';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "linkedDocumentsTitle", {
        get: function () {
            return this.type === 'credit' ? 'Avoir(s) concerné(s) par ce paiement' : 'Facture(s) concernée(s) par ce paiement';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "searchDocumentsLabel", {
        get: function () {
            return this.type === 'credit' ? 'Rechercher un avoir...' : 'Rechercher une facture...';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "referenceDocumentsTitle", {
        get: function () {
            return this.type === 'credit' ? 'N° Avoir' : 'N° Facture';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "noDocumentLabel", {
        get: function () {
            return this.type === 'credit' ? 'Aucun avoir sélectionné' : 'Aucune facture sélectionnée';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "linkMultipleDocumentLabel", {
        get: function () {
            return this.type === 'credit' ? 'Régler plusieurs avoirs avec ce paiement' : 'Régler plusieurs factures avec ce paiement';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "stayAmount", {
        get: function () {
            var _this = this;
            return this.number(this.payment.amount) - this.roundNumber(sumBy_default()(this.payment.documents, function (use) { return _this.number(use.ttc); }), 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "stayToPay", {
        get: function () {
            var _this = this;
            return function (use) {
                var _a;
                var stay = _this.stayToPaidDocument(use);
                if ((_a = _this.value) === null || _a === void 0 ? void 0 : _a.id) {
                    var document = _this.value.documents.find(function (doc) { return doc.document_id === use.document_id; });
                    if (document) {
                        stay += _this.number(document.ttc);
                    }
                }
                return _this.formattedNumber(stay, use.document.currency);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "stayToPaidDocument", {
        get: function () {
            var _this = this;
            return function (use) {
                var document = use.document;
                if (_this.localWithGuaranteeHoldback && use.guarantee_holdback) {
                    return _this.number((document === null || document === void 0 ? void 0 : document.guarantee_holdback_status) === 1 ? 0 : document === null || document === void 0 ? void 0 : document.guarantee_holdback_amount);
                }
                var number = _this.number(document === null || document === void 0 ? void 0 : document.stay_to_pay);
                if (_this.withGuaranteeHoldbackPaid && document && document.guarantee_holdback_amount > 0) {
                    number += _this.number(document.guarantee_holdback_amount);
                }
                return number;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentForm.prototype, "hasGuaranteeHoldback", {
        get: function () {
            var _this = this;
            return function (use) {
                return (_this.localWithGuaranteeHoldback && use.document && use.document.guarantee_holdback_amount > 0) || use.guarantee_holdback === true;
            };
        },
        enumerable: false,
        configurable: true
    });
    PaymentForm.prototype.watchModal = function (state) {
        this.modalState = state;
        if (state) {
            this.watchValue(this.value);
        }
    };
    PaymentForm.prototype.watchValue = function (value) {
        var _a, _b, _c, _d;
        this.localWithGuaranteeHoldback = this.withGuaranteeHoldback !== false || (value !== null && ((_a = value.documents) === null || _a === void 0 ? void 0 : _a.find(function (doc) { return doc.guarantee_holdback; })) !== undefined);
        var payment = value ? JSON.parse(JSON.stringify(value)) : {
            date: external_moment_default()().format('YYYY-MM-DD'),
            amount: 0,
            currency: (_b = this.document) === null || _b === void 0 ? void 0 : _b.currency,
            exchange_rate: 1
        };
        var use = {
            guarantee_holdback: this.localWithGuaranteeHoldback,
            document: (_c = this.document) !== null && _c !== void 0 ? _c : undefined,
            document_type: this.type,
            document_id: (_d = this.document) === null || _d === void 0 ? void 0 : _d.id
        };
        var stayToPaid = this.stayToPaidDocument(use);
        if (!payment.amount) {
            payment.amount = stayToPaid;
        }
        else if (stayToPaid > payment.amount) {
            stayToPaid = payment.amount;
        }
        use.ttc = stayToPaid;
        if (!payment.documents) {
            payment.documents = [use].filter(function (doc) { return doc.document_id !== undefined; });
        }
        this.payment = payment;
    };
    PaymentForm.prototype.formSubmitted = function (response) {
        if (this.value && this.value.id) {
            interface_vue_.emitter.emit('paymentUpdated', {
                old: this.value,
                new: response.data
            });
        }
        else {
            interface_vue_.emitter.emit('paymentCreated', response.data);
        }
        return response;
    };
    PaymentForm.prototype.creditUsed = function (invoice) {
        this.$emit('invoiceUpdated', invoice);
        this.modalState = false;
    };
    PaymentForm.prototype.watchWithGuaranteeHoldbackPaid = function () {
        var _a;
        if (this.withGuaranteeHoldbackPaid && this.document && this.number((_a = this.payment) === null || _a === void 0 ? void 0 : _a.amount) === this.number(this.document.to_paid) && this.document.guarantee_holdback_amount > 0) {
            this.payment.amount = this.number(this.document.to_paid) + this.number(this.document.guarantee_holdback_amount);
        }
        this.amountUpdated();
    };
    PaymentForm.prototype.amountUpdated = function () {
        var _this = this;
        var _a;
        var amount = this.number((_a = this.payment) === null || _a === void 0 ? void 0 : _a.amount);
        this.payment.documents.forEach(function (document) {
            var _a, _b;
            var toPaid = (_b = (_a = document.document) === null || _a === void 0 ? void 0 : _a.stay_to_pay) !== null && _b !== void 0 ? _b : 0;
            var stay = _this.number(toPaid);
            if (_this.withGuaranteeHoldbackPaid && document.document && document.document.guarantee_holdback_amount > 0) {
                stay += _this.number(document.document.guarantee_holdback_amount);
            }
            if (amount < toPaid) {
                stay = _this.number(amount);
            }
            document.ttc = stay;
            amount -= stay;
        });
    };
    PaymentForm.prototype.searchInvoice = function (value) {
        var _this = this;
        this.searchDocuments = null;
        this.fetchLoading = true;
        window.removeEventListener('click', this.listenClick);
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(function () { return _this.fetchInvoices(value); }, 200);
    };
    PaymentForm.prototype.fetchInvoices = function (value) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var customer;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        customer = null;
                        if (this.payment.documents.length > 1) {
                            customer = this.payment.documents[0].document.customer.id;
                        }
                        else if (this.document) {
                            customer = this.document.customer.id;
                        }
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/' + this.type, {
                                params: {
                                    search: value ? '%25' + value + '%25' : null,
                                    per_page: 10,
                                    filter: {
                                        exclude: this.payment.documents.map(function (document) { return document.document_id; }),
                                        customer: customer,
                                        is_draft: false,
                                        status: [2, 3, 4]
                                    },
                                    include: 'currency'
                                }
                            })
                                .then(function (response) {
                                _this.searchDocuments = response.data.data;
                            })
                                .finally(function () {
                                _this.fetchLoading = false;
                                window.addEventListener('click', _this.listenClick);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentForm.prototype.listenClick = function (e) {
        var element = e.target;
        if (!element || !element.closest('.payment-form-search-results')) {
            this.searchDocuments = null;
            this.searchTerm = null;
            window.removeEventListener('click', this.listenClick);
        }
    };
    PaymentForm.prototype.addDocument = function (document, index) {
        var _a;
        var documents = this.payment.documents;
        if (documents.find(function (value) { return value.document_id === document.id; })) {
            return;
        }
        var amount = document.stay_to_pay;
        if (amount > this.stayAmount) {
            amount = this.stayAmount;
        }
        if (amount < 0) {
            amount = 0;
        }
        documents.push({
            document: document,
            document_type: this.type,
            document_id: document.id,
            ttc: this.number(amount)
        });
        (_a = this.searchDocuments) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
    };
    PaymentForm.prototype.removeDocument = function (index) {
        this.payment.documents.splice(index, 1);
    };
    PaymentForm.prototype.onSelectGuaranteeHoldback = function (index) {
        var _a;
        var document = this.payment.documents[index];
        if (document.guarantee_holdback) {
            document.ttc = (_a = document.document) === null || _a === void 0 ? void 0 : _a.guarantee_holdback_amount;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'invoice' })
    ], PaymentForm.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentForm.prototype, "document", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PaymentForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PaymentForm.prototype, "withGuaranteeHoldback", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentForm.prototype, "transaction", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], PaymentForm.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], PaymentForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], PaymentForm.prototype, "formSubmitted", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('withGuaranteeHoldbackPaid')
    ], PaymentForm.prototype, "watchWithGuaranteeHoldbackPaid", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('multipleDocuments')
    ], PaymentForm.prototype, "amountUpdated", null);
    PaymentForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency', 'team'])),
            components: {
                AccountSelect: AccountSelect/* default */.A,
                CancelPayment: CancelPayment/* default */.A,
                UseCredit: UseCredit/* default */.A,
                UseAvailablePayment: UseAvailablePayment_UseAvailablePayment,
                PaymentMethodSelect: interface_vue_.PaymentMethodSelect, FormModal: interface_vue_.FormModal, CurrencySelect: interface_vue_.CurrencySelect,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormTextarea: form_vue_.KFormTextarea, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BListGroup: external_bootstrap_vue_.BListGroup, BListGroupItem: external_bootstrap_vue_.BListGroupItem, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BInputGroupText: external_bootstrap_vue_.BInputGroupText, BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], PaymentForm);
    return PaymentForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var PaymentFormvue_type_script_lang_ts_external = (PaymentForm);

;// ./src/components/PaymentForm/PaymentForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentForm_PaymentFormvue_type_script_lang_ts_external = (PaymentFormvue_type_script_lang_ts_external); 
;// ./src/components/PaymentForm/PaymentForm.vue





/* normalize component */
;
var PaymentForm_component = (0,componentNormalizer/* default */.A)(
  PaymentForm_PaymentFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentForm_PaymentForm = (PaymentForm_component.exports);

/***/ }),

/***/ 88383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ 88984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(55527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 89374:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ 89694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PaymentVatRates_PaymentVatRates; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentVatRates/PaymentVatRates.vue?vue&type=template&id=e82a6d5a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Début"}},[_c('k-form-datepicker',{attrs:{"size":"sm","max-date":_vm.end},model:{value:(_vm.begin),callback:function ($$v) {_vm.begin=$$v},expression:"begin"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Fin"}},[_c('k-form-datepicker',{attrs:{"size":"sm","min-date":_vm.begin},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-form-group',{attrs:{"label":"Groupement"}},[_c('k-form-select',{attrs:{"size":"sm","options":[
              { id: 'month', label: 'Mensuel' },
              { id: 'quarter', label: 'Trimestre' }
            ],"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.group),callback:function ($$v) {_vm.group=$$v},expression:"group"}})],1)],1)],1),_c('b-row',[_vm._l((_vm.results),function(result,i){return _c('b-col',{key:i,staticClass:"mb-4",attrs:{"cols":"12","md":"6","lg":"4"}},[_c('b-card',{attrs:{"body-class":"py-2"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center pb-3",attrs:{"colspan":"2"}},[_vm._v(" "+_vm._s(_vm.period(result.groupKey, result.year))+" ")])])]),_c('tbody',[_c('tr',[_c('td',{staticClass:"w-50"},[_vm._v("Total HT :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(result.ht)))])]),_c('tr',[_c('td',[_vm._v("Total TVA :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(result.tva)))])]),_c('tr',[_c('td',[_vm._v("Total TTC :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(result.ttc)))])])])]),_c('table',{staticClass:"table table-sm table-bordered small text-center"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Taux TVA")]),_c('th',[_vm._v("HT")]),_c('th',[_vm._v("TVA")]),_c('th',[_vm._v("TTC")])])]),_c('tbody',_vm._l((result.rates),function(rate,j){return _c('tr',{key:j},[_c('td',[_vm._v(_vm._s(rate.vat_rate.rate)+" %")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(rate.ht)))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(rate.tva)))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(rate.ttc)))])])}),0)])])],1)}),_c('b-col',{staticClass:"mb-4",attrs:{"cols":"12","md":"6","lg":"4"}},[_c('b-card',{attrs:{"body-class":"py-2"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center pb-3",attrs:{"colspan":"2"}},[_vm._v(" TOTAUX ")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("Total HT :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(_vm.totalHt, 2))))])]),_c('tr',[_c('td',[_vm._v("Total TVA :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(_vm.totalTva, 2))))])]),_c('tr',[_c('td',[_vm._v("Total TTC :")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(_vm.totalTtc, 2))))])])])]),_c('table',{staticClass:"table table-sm table-bordered small text-center"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Taux TVA")]),_c('th',[_vm._v("HT")]),_c('th',[_vm._v("TVA")]),_c('th',[_vm._v("TTC")])])]),_c('tbody',_vm._l((_vm.allRates),function(rate,j){return _c('tr',{key:j},[_c('td',[_vm._v(_vm._s(rate.vat_rate.rate)+" %")]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(rate.ht, 2))))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(rate.tva, 2))))]),_c('td',[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(rate.ttc, 2))))])])}),0)])])],1)],2)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentVatRates/PaymentVatRates.ts?vue&type=script&lang=ts&external







var PaymentVatRates = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentVatRates, _super);
    function PaymentVatRates() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.group = 'month';
        _this.begin = null;
        _this.end = null;
        _this.results = null;
        return _this;
    }
    PaymentVatRates.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fetchConfig();
                        if (!this.begin) {
                            this.begin = external_moment_default()().startOf('year').format('YYYY-MM-DD');
                        }
                        if (!this.end) {
                            this.end = external_moment_default()().endOf('year').format('YYYY-MM-DD');
                        }
                        return [4 /*yield*/, this.fetchDatas()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PaymentVatRates.prototype, "totalHt", {
        get: function () {
            var _this = this;
            if (!this.results) {
                return 0;
            }
            var total = 0;
            forEach_default()(this.results, function (data) {
                total += _this.number(data.ht);
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentVatRates.prototype, "totalTva", {
        get: function () {
            var _this = this;
            if (!this.results) {
                return 0;
            }
            var total = 0;
            forEach_default()(this.results, function (data) {
                total += _this.number(data.tva);
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentVatRates.prototype, "totalTtc", {
        get: function () {
            var _this = this;
            if (!this.results) {
                return 0;
            }
            var total = 0;
            forEach_default()(this.results, function (data) {
                total += _this.number(data.ttc);
            });
            return total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentVatRates.prototype, "allRates", {
        get: function () {
            var _this = this;
            var rates = [];
            forEach_default()(this.results, function (data) {
                forEach_default()(data.rates, function (rate) {
                    var id = rate.vat_rate_id;
                    if (rates[id] === undefined) {
                        rates[id] = {
                            vat_rate_id: id,
                            vat_rate: rate.vat_rate,
                            ht: 0,
                            tva: 0,
                            ttc: 0
                        };
                    }
                    rates[id].ht += _this.number(rate.ht);
                    rates[id].tva += _this.number(rate.tva);
                    rates[id].ttc += _this.number(rate.ttc);
                });
            });
            return rates.filter(function (rate) { return rate !== null; });
        },
        enumerable: false,
        configurable: true
    });
    PaymentVatRates.prototype.watchDatas = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchDatas()];
                    case 1:
                        _a.sent();
                        this.saveConfig();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentVatRates.prototype.fetchDatas = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/sales/vat-rate/report', {
                                params: {
                                    group: this.group,
                                    begin: this.begin,
                                    end: this.end
                                }
                            })
                                .then(function (response) {
                                _this.results = response.data;
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PaymentVatRates.prototype, "period", {
        get: function () {
            var _this = this;
            return function (number, year) {
                if (_this.group === 'month') {
                    return _this.$t('sales.months.' + number) + ' ' + year;
                }
                var date = external_moment_default()().set({
                    quarter: number,
                    year: year
                });
                return 'Du ' + _this.date(date.startOf(_this.group).format('YYYY-MM-DD')) + ' au ' + _this.date(date.endOf(_this.group).format('YYYY-MM-DD'));
            };
        },
        enumerable: false,
        configurable: true
    });
    PaymentVatRates.prototype.fetchConfig = function () {
        var storage = window.localStorage.getItem('payments-vatrates');
        var config;
        if (storage) {
            config = JSON.parse(storage);
        }
        if (!config) {
            return;
        }
        if (config.begin) {
            this.begin = config.begin;
        }
        if (config.end) {
            this.end = config.end;
        }
        if (config.group) {
            this.group = config.group;
        }
    };
    PaymentVatRates.prototype.saveConfig = function () {
        var config = {};
        if (this.begin) {
            config.begin = this.begin;
        }
        if (this.end) {
            config.end = this.end;
        }
        if (this.group) {
            config.group = this.group;
        }
        window.localStorage.setItem('payments-vatrates', JSON.stringify(config));
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('group'),
        (0,lib/* Watch */.ox)('begin'),
        (0,lib/* Watch */.ox)('end')
    ], PaymentVatRates.prototype, "watchDatas", null);
    PaymentVatRates = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BTooltip: external_bootstrap_vue_.BTooltip,
                KFormDatepicker: form_vue_.KFormDatepicker, KFormSelect: form_vue_.KFormSelect
            }
        })
    ], PaymentVatRates);
    return PaymentVatRates;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var PaymentVatRatesvue_type_script_lang_ts_external = (PaymentVatRates);

;// ./src/components/PaymentVatRates/PaymentVatRates.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentVatRates_PaymentVatRatesvue_type_script_lang_ts_external = (PaymentVatRatesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/PaymentVatRates/PaymentVatRates.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PaymentVatRates_PaymentVatRatesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentVatRates_PaymentVatRates = (component.exports);

/***/ }),

/***/ 89722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ 89756:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ 89916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ContractFormView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractFormView.vue?vue&type=template&id=dfbef98a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('ContractForm',{attrs:{"value":_vm.contract}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/ContractMixin.ts
var ContractMixin = __webpack_require__(3568);
// EXTERNAL MODULE: ./src/components/ContractForm/ContractForm.vue + 3 modules
var ContractForm = __webpack_require__(8081);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractFormView.vue?vue&type=script&lang=ts




var ContractFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractFormView, _super);
    function ContractFormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContractFormView.prototype.watchContract = function () {
        var _a;
        window.document.title = ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.id) ? 'Modification du contrat n°' + this.contract.reference : 'Création d\'un contract';
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('contract', { immediate: true })
    ], ContractFormView.prototype, "watchContract", null);
    ContractFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContractForm: ContractForm/* default */.A
            }
        })
    ], ContractFormView);
    return ContractFormView;
}((0,lib/* Mixins */.Xe)(ContractMixin/* default */.A)));
/* harmony default export */ var ContractFormViewvue_type_script_lang_ts = (ContractFormView);

;// ./src/views/ContractFormView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContractFormViewvue_type_script_lang_ts = (ContractFormViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/ContractFormView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContractFormViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ContractFormView = (component.exports);

/***/ }),

/***/ 89935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 90121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContractDeadlineListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractDeadlineListView.vue?vue&type=template&id=00d4ee78
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContractDeadlinesList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ContractDeadlinesList/ContractDeadlinesList.vue + 3 modules
var ContractDeadlinesList = __webpack_require__(60516);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractDeadlineListView.vue?vue&type=script&lang=ts



var ContractListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractListView, _super);
    function ContractListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContractListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContractDeadlinesList: ContractDeadlinesList/* default */.A
            }
        })
    ], ContractListView);
    return ContractListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractDeadlineListViewvue_type_script_lang_ts = (ContractListView);

;// ./src/views/ContractDeadlineListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContractDeadlineListViewvue_type_script_lang_ts = (ContractDeadlineListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/ContractDeadlineListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContractDeadlineListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractDeadlineListView = (component.exports);

/***/ }),

/***/ 90181:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 90289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(12651);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 90527:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ 90609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ 90613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContractStatusSelector_ContractStatusSelector; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContractStatusSelector/ContractStatusSelector.vue?vue&type=template&id=06ccf76a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-only":_vm.errorMsg !== null,"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.updateStatus},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_c('div',{staticClass:"text-justify"},[_vm._v(" Modifier le statut du contrat à "),_c('k-form-select',{attrs:{"required":"","options":_vm.contractStatus,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContractStatusSelector/ContractStatusSelector.ts?vue&type=script&lang=ts&external





var ContractStatusSelector = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContractStatusSelector, _super);
    function ContractStatusSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = null;
        _this.modalState = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ContractStatusSelector.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractStatusSelector.prototype, "contractStatus", {
        get: function () {
            var _this = this;
            return [
                { value: 1, label: 'Brouillon' },
                { value: 2, label: 'En attente' },
                { value: 3, label: 'En cours' },
                { value: 4, label: 'Terminé' }
            ].filter(function (status) { return status.value !== _this.contract.status; });
        },
        enumerable: false,
        configurable: true
    });
    // Open modal
    ContractStatusSelector.prototype.openModal = function () {
        this.errorMsg = null;
        this.modalState = true;
        this.status = null;
        this.loading = false;
    };
    // Send ajax query
    ContractStatusSelector.prototype.updateStatus = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.put('/sales/contract/' + this.contract.id, { status: this.status })
            .then(function (response) {
            _this.$emit('input', response.data);
            _this.modalState = false;
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContractStatusSelector.prototype, "contract", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ContractStatusSelector.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Statut du contrat' })
    ], ContractStatusSelector.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContractStatusSelector.prototype, "variant", void 0);
    ContractStatusSelector = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal,
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], ContractStatusSelector);
    return ContractStatusSelector;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractStatusSelectorvue_type_script_lang_ts_external = (ContractStatusSelector);

;// ./src/components/ContractStatusSelector/ContractStatusSelector.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractStatusSelector_ContractStatusSelectorvue_type_script_lang_ts_external = (ContractStatusSelectorvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/ContractStatusSelector/ContractStatusSelector.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractStatusSelector_ContractStatusSelectorvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractStatusSelector_ContractStatusSelector = (component.exports);

/***/ }),

/***/ 90622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 90938:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 91033:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 91597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Mx: function() { return /* binding */ fetchCustomerSepa; },
/* harmony export */   fG: function() { return /* binding */ customerSepaRelations; },
/* harmony export */   yW: function() { return /* binding */ needFetchCustomerSepa; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var customerSepaRelations = [
    'customer', 'country', 'pdf', 'signatures'
];
var needFetchCustomerSepa = function (model) {
    return !customerSepaRelations.every(function (relation) { return relation in model; });
};
var fetchCustomerSepa = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/sales/sepa/' + id, {
                    params: {
                        include: customerSepaRelations.join(','),
                        with_document: true
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 92053:
/***/ (function(module) {

"use strict";
module.exports = "data:image/png;base64,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";

/***/ }),

/***/ 92297:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ 92572:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ 92595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_QuotationListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/QuotationListView.vue?vue&type=template&id=750fd3ac
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('QuotationList')],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/QuotationList/QuotationList.vue + 2 modules
var QuotationList = __webpack_require__(80168);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/QuotationListView.vue?vue&type=script&lang=ts



var QuotationListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(QuotationListView, _super);
    function QuotationListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuotationListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                QuotationList: QuotationList/* default */.A
            }
        })
    ], QuotationListView);
    return QuotationListView;
}(lib/* Vue */.lD));
/* harmony default export */ var QuotationListViewvue_type_script_lang_ts = (QuotationListView);

;// ./src/views/QuotationListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_QuotationListViewvue_type_script_lang_ts = (QuotationListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/QuotationListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_QuotationListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_QuotationListView = (component.exports);

/***/ }),

/***/ 92746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommissionDocumentForm_CommissionDocumentForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommissionDocumentForm/CommissionDocumentForm.vue?vue&type=template&id=5d7a88fb
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":_vm.modalTitle},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":response => _vm.$emit('submitComplete', response.data)}},[_c('b-form-group',{attrs:{"label":"Date de la commission"}},[_c('k-form-datepicker',{attrs:{"name":"date","required":""},model:{value:(_vm.commission.date),callback:function ($$v) {_vm.$set(_vm.commission, "date", $$v)},expression:"commission.date"}})],1),_c('b-form-group',{attrs:{"label":"Commercial"}},[_c('input',{attrs:{"type":"hidden","name":"team_user"},domProps:{"value":_vm.commission.team_user ? _vm.commission.team_user.id : null}}),_c('TeamUserSelect',{attrs:{"validationName":"team_user","required":"","role":"commercial"},model:{value:(_vm.commission.team_user),callback:function ($$v) {_vm.$set(_vm.commission, "team_user", $$v)},expression:"commission.team_user"}})],1),(_vm.commission.auto_amount)?_c('b-form-group',{attrs:{"label":"Montant initial de la commission"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"auto_amount","readonly":""},model:{value:(_vm.commission.auto_amount),callback:function ($$v) {_vm.$set(_vm.commission, "auto_amount", $$v)},expression:"commission.auto_amount"}})],1)],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Montant de la commission","description":"Laisser vide pour utiliser le montant initial"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"manual_amount","noDefaultValue":_vm.commission.id && _vm.commission.auto_amount !== null},model:{value:(_vm.commission.manual_amount),callback:function ($$v) {_vm.$set(_vm.commission, "manual_amount", $$v)},expression:"commission.manual_amount"}})],1)],1),_c('b-form-group',{attrs:{"label":"Commentaires"}},[_c('k-form-textarea',{attrs:{"name":"comments"},model:{value:(_vm.commission.comments),callback:function ($$v) {_vm.$set(_vm.commission, "comments", $$v)},expression:"commission.comments"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommissionDocumentForm/CommissionDocumentForm.ts?vue&type=script&lang=ts&external







var CommissionDocumentForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommissionDocumentForm, _super);
    function CommissionDocumentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.commission = {};
        return _this;
    }
    Object.defineProperty(CommissionDocumentForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/sales/commission/sales';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionDocumentForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommissionDocumentForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            return (((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'Modification' : 'Création') + ' d\'une commission';
        },
        enumerable: false,
        configurable: true
    });
    CommissionDocumentForm.prototype.watchValue = function () {
        this.commission = Object.assign({
            date: external_moment_default()().format('YYYY-MM-DD')
        }, this.value ? JSON.parse(JSON.stringify(this.value)) : {});
    };
    CommissionDocumentForm.prototype.watchModal = function () {
        this.modalState = this.modal;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommissionDocumentForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommissionDocumentForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CommissionDocumentForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CommissionDocumentForm.prototype, "watchModal", null);
    CommissionDocumentForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormNumber: form_vue_.KFormNumber, KFormTextarea: form_vue_.KFormTextarea, KFormDatepicker: form_vue_.KFormDatepicker,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup,
                TeamUserSelect: interface_vue_.TeamUserSelect, Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency']))
        })
    ], CommissionDocumentForm);
    return CommissionDocumentForm;
}(lib/* Vue */.lD));
/* harmony default export */ var CommissionDocumentFormvue_type_script_lang_ts_external = (CommissionDocumentForm);

;// ./src/components/CommissionDocumentForm/CommissionDocumentForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommissionDocumentForm_CommissionDocumentFormvue_type_script_lang_ts_external = (CommissionDocumentFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CommissionDocumentForm/CommissionDocumentForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommissionDocumentForm_CommissionDocumentFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommissionDocumentForm_CommissionDocumentForm = (component.exports);

/***/ }),

/***/ 93243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(56110);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 93290:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 93383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ 93443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var froala_editor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30189);
/* harmony import */ var froala_editor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(froala_editor__WEBPACK_IMPORTED_MODULE_0__);

var config = {
    enter: (froala_editor__WEBPACK_IMPORTED_MODULE_0___default().ENTER_BR),
    fontSize: ['6', '7', '8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
    fontSizeUnit: 'pt',
    zIndex: 999999,
    heightMin: 100,
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'fontSize',
                '|',
                'textColor',
                'backgroundColor',
                '|',
                'formatUL',
                'formatOL',
                '|',
                'insertImage',
                'insertTable',
                'insertHR',
                '|',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify',
                '|',
                'insertDynamicVariables'
            ],
            buttonsVisible: 16
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: false,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedAttrs: [
        'align', 'alt', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'class', 'color',
        'cols', 'colspan', 'content', 'contenteditable', 'data', 'data-.*', 'datetime', 'disabled', 'form', 'height',
        'hidden', 'href', 'id', 'label', 'max', 'min', 'multiple', 'name', 'placeholder', 'radiogroup', 'readonly',
        'rel', 'required', 'rows', 'rowspan', 'selected', 'size', 'sizes', 'span', 'src', 'step', 'style', 'tabindex',
        'target', 'title', 'type', 'value', 'valign', 'width', 'pagebreak', 'nobr'
    ],
    htmlAllowedStyleProps: [
        'font-size', 'background', 'color', 'text-align', 'vertical-align', 'background-color', 'height', 'width',
        'border', 'border-top', 'border-bottom', 'border-right', 'border-left'
    ],
    tableEditButtons: [
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableBorder',
        'tableBackground',
        'tableSpaces',
        '-',
        'tableCells',
        'tableCellBackground',
        'tableCellBorder',
        'tableCellHorizontalAlign',
        'tableCellHeight'
    ],
    tableHeightUnit: 'mm',
    imageUpload: false,
    imageDefaultDisplay: 'inline',
    imageEditButtons: ['imageReplace', 'imageRemove', 'imageSize'],
    imageInsertButtons: ['uploadInlineImage'],
    events: {
        'paste.afterCleanup': function (content) {
            return content.replaceAll(/<br([^>])+?>/gi, '<br>')
                .replaceAll(/font-size: ?([\d.]+)px/gi, 'font-size: $1pt');
        }
    },
    dynamicVariables: {
        company: {
            label: 'Informations de votre entreprise',
            variables: [
                { value: 'COMPANY-NAME', label: 'Nom de l\'entreprise' },
                { value: 'COMPANY-ROAD', label: 'Adresse - rue' },
                { value: 'COMPANY-ROAD2', label: 'Adresse - rue 2' },
                { value: 'COMPANY-ROAD3', label: 'Adresse - rue 3' },
                { value: 'COMPANY-POSTAL', label: 'Code postal' },
                { value: 'COMPANY-TOWN', label: 'Ville' },
                { value: 'COMPANY-COUNTRY', label: 'Pays' },
                { value: 'COMPANY-PHONE', label: 'Téléphone fixe' },
                { value: 'COMPANY-MOBILE', label: 'Téléphone portable' },
                { value: 'COMPANY-FAX', label: 'Fax' },
                { value: 'COMPANY-EMAIL', label: 'Email' },
                { value: 'COMPANY-WEBSITE', label: 'Site internet' },
                { value: 'COMPANY-TYPE', label: 'Type d\'entreprise' },
                { value: 'COMPANY-SIRET', label: 'N° SIRET' },
                { value: 'COMPANY-RCS', label: 'N° RCS' },
                { value: 'COMPANY-TVA', label: 'N° TVA intracommunautaire' },
                { value: 'COMPANY-NAF', label: 'Code NAF' },
                { value: 'COMPANY-CAPITAL', label: 'Capital' }
            ]
        },
        tiers: {
            label: 'Informations sur le client',
            variables: [
                { value: 'TIERS-CODE', label: 'Code client' },
                { value: 'TIERS-NAME', label: 'Nom du client' },
                { value: 'TIERS-ROAD', label: 'Adresse - rue' },
                { value: 'TIERS-ROAD2', label: 'Adresse - rue 2' },
                { value: 'TIERS-ROAD3', label: 'Adresse - rue 3' },
                { value: 'TIERS-POSTAL', label: 'Code postal' },
                { value: 'TIERS-TOWN', label: 'Ville' },
                { value: 'TIERS-COUNTRY', label: 'Pays' },
                { value: 'TIERS-PHONE', label: 'Téléphone fixe' },
                { value: 'TIERS-MOBILE', label: 'Téléphone portable' },
                { value: 'TIERS-FAX', label: 'Fax' },
                { value: 'TIERS-EMAIL', label: 'Email' },
                { value: 'TIERS-WEBSITE', label: 'Site internet' },
                { value: 'TIERS-SIRET', label: 'N° SIRET' },
                { value: 'TIERS-TVA', label: 'N° TVA intracommunautaire' },
                { value: 'TIERS-COMMERCIAL', label: 'Prénom et nom du commercial' }
            ]
        },
        contact: {
            label: 'Informations sur le contact',
            variables: [
                { value: 'CONTACT-FULLNAME', label: 'Nom complet' },
                { value: 'CONTACT-FIRSTNAME', label: 'Prénom' },
                { value: 'CONTACT-LASTNAME', label: 'Nom de famille' },
                { value: 'CONTACT-ROAD', label: 'Adresse - rue' },
                { value: 'CONTACT-ROAD2', label: 'Adresse - rue 2' },
                { value: 'CONTACT-ROAD3', label: 'Adresse - rue 3' },
                { value: 'CONTACT-POSTAL', label: 'Code postal' },
                { value: 'CONTACT-TOWN', label: 'Ville' },
                { value: 'CONTACT-COUNTRY', label: 'Pays' },
                { value: 'CONTACT-PHONE', label: 'Téléphone fixe' },
                { value: 'CONTACT-MOBILE', label: 'Téléphone portable' },
                { value: 'CONTACT-FAX', label: 'Fax' },
                { value: 'CONTACT-EMAIL', label: 'Email' },
                { value: 'CONTACT-WEBSITE', label: 'Site internet' }
            ]
        },
        document: {
            label: 'Informations sur le document',
            variables: [
                { value: 'LOGO', label: 'Logo de votre entreprise' },
                { value: 'COMMERCIAL-NAME', label: 'Prénom et nom du commercial' },
                { value: 'COMMERCIAL-FIRSTNAME', label: 'Prénom du commercial' },
                { value: 'COMMERCIAL-LASTNAME', label: 'Nom du commercial' },
                { value: 'COMMERCIAL-TEL', label: 'Téléphone du commercial' },
                { value: 'COMMERCIAL-PORT', label: 'Portable du commercial' },
                { value: 'COMMERCIAL-FAX', label: 'Fax du commercial' },
                { value: 'COMMERCIAL-EMAIL', label: 'Email du commercial' },
                { value: 'DOC-TYPE', label: 'Type de document (Devis, Facture...)' },
                { value: 'DOC-NUM', label: 'Numéro du document' },
                { value: 'DATE', label: 'Date' },
                { value: 'DATE-LETTER', label: 'Date en toutes lettres' },
                { value: 'EXP-DATE', label: 'Date d\'expiration' },
                { value: 'BDC-TIERS', label: 'N° du bon de commande client' },
                { value: 'INVOICE-ADDRESS', label: 'Adresse de facturation' },
                { value: 'DELIVERY-ADDRESS', label: 'Adresse de livraison' },
                { value: 'TITLE', label: 'Titre' },
                { value: 'ACOMPTE', label: 'Acompte (% + Montant)' },
                { value: 'ACOMPTE-AMOUNT', label: 'Montant de l\'acompte' },
                { value: 'ACOMPTE-POURCENT', label: '% d\'acompte' },
                { value: 'ESCOMPTE', label: 'Escompte' },
                { value: 'ESCOMPTE-AM0UNT-HT', label: 'Montant escompte HT' },
                { value: 'ESCOMPTE-AM0UNT-TVA', label: 'Montant escompte TVA' },
                { value: 'ESCOMPTE-AM0UNT-TTC', label: 'Montant escompte TTC' },
                { value: 'PENALTY-RATE', label: 'Taux de pénalité' },
                { value: 'PAYMENT-TERM', label: 'Conditions de paiement' },
                { value: 'ACCEPTED-PAYMENT-METHODS', label: 'Moyens de paiement acceptés' },
                { value: 'TOTAL-HT-WITHOUT-DISCOUNT', label: 'Total HT hors remise générale' },
                { value: 'TOTAL-TVA-WITHOUT-DISCOUNT', label: 'Total TVA hors remise générale' },
                { value: 'TOTAL-TTC-WITHOUT-DISCOUNT', label: 'Total TTC hors remise générale' },
                { value: 'TOTAL-HT', label: 'Total HT' },
                { value: 'TOTAL-TVA', label: 'Total TVA' },
                { value: 'TOTAL-TTC', label: 'Total TTC' },
                { value: 'TOTAL-TTC-LETTER', label: 'Total TTC en toutes lettres' },
                { value: 'TO-PAID', label: 'Montant à payer' },
                { value: 'ALREADY-PAID', label: 'Montant déjà payé' },
                { value: 'STAY-TO-PAID', label: 'Montant restant à payé' },
                { value: 'PAYMENTS-LIST', label: 'Liste des encaissements (Facture acquitée uniquement)' },
                { value: 'TOTALS', label: 'Tableau des totaux' },
                { value: 'TOTALS-WITH-RATES', label: 'Tableau des totaux avec détails de la TVA' },
                { value: 'GLOBAL-DISCOUNT-HT', label: 'Remise générale HT' },
                { value: 'GLOBAL-DISCOUNT-TVA', label: 'Remise générale TVA' },
                { value: 'GLOBAL-DISCOUNT-TTC', label: 'Remise générale TTC' },
                { value: 'TOTAL-ECOTAXE-HT', label: 'Total éco-participation HT' },
                { value: 'TOTAL-ECOTAXE-TVA', label: 'Total éco-participation TVA' },
                { value: 'TOTAL-ECOTAXE-TTC', label: 'Total éco-participation TTC' },
                { value: 'TOTAL-QUANTITY', label: 'Quantité totale des produits' },
                { value: 'TOTAL-WEIGHT', label: 'Poids total' },
                { value: 'PAIEMENTS-LIST', label: 'Liste des paiements' },
                { value: 'VATRATES-DETAILS', label: 'Tableau avec le détail de la TVA' },
                { value: 'NOTES', label: 'Notes à l\'attention du client' },
                { value: 'LAW-COLLECTION-COSTS', label: 'Mention pour les frais de recouvrement' },
                { value: 'LAW-PENALTY-FEES', label: 'Mention pour les frais de pénalité' },
                { value: 'MENTIONS-TVA', label: 'Mentions liées au taux de TVA' },
                { value: 'PAGE-NUM', label: 'Numéro de la page' },
                { value: 'TOTAL-PAGE', label: 'Nombre total de page' },
                { value: 'DOCUMENT-CUSTOMER-VATRATE', label: 'N° TVA intracommunautaire (selon les réglages du document)' },
                { value: 'PAGE-BREAK', label: 'Saut de page' },
                { value: 'LINKED-QUOTATION', label: 'Numéro du devis lié' },
                { value: 'LINKED-COMMAND', label: 'Numéro du bon de commande lié' },
                { value: 'LINKED-DELIVERY', label: 'Numéro du bon de livraison lié' },
                { value: 'LINKED-PROFORMA', label: 'Numéro de la facture proforma liée' },
                { value: 'LINKED-INVOICE', label: 'Numéro de la facture liée' },
                { value: 'LINKED-CREDIT', label: 'Numéro de l\'avoir lié' },
                { value: 'LINKED-DOCUMENT', label: 'Numéro du document lié (tous types de document)' },
                { value: 'LINKED-DOCUMENT2', label: 'Numéro du document lié (tous types de document) avec le nom du type de document.' },
                { value: 'DELIVERY-MODE', label: 'Mode de livraison' },
                { value: 'DELIVERY-TRACKING', label: 'N° de suivi de la livraison' },
                { value: 'DELIVERY-QTY', label: 'Nombre de colis' },
            ]
        },
        providerCommand: {
            label: 'Informations sur la commande fournisseur',
            variables: [
                { value: 'LOGO', label: 'Logo de votre entreprise' },
                { value: 'PROVIDER-CODE', label: 'Code fournisseur' },
                { value: 'TIERS-NAME', label: 'Nom du fournisseur' },
                { value: 'TIERS-ROAD', label: 'Adresse - rue' },
                { value: 'TIERS-ROAD2', label: 'Adresse - rue 2' },
                { value: 'TIERS-ROAD3', label: 'Adresse - rue 3' },
                { value: 'TIERS-POSTAL', label: 'Code postal' },
                { value: 'TIERS-TOWN', label: 'Ville' },
                { value: 'TIERS-COUNTRY', label: 'Pays' },
                { value: 'TIERS-PHONE', label: 'Téléphone fixe' },
                { value: 'TIERS-MOBILE', label: 'Téléphone portable' },
                { value: 'TIERS-FAX', label: 'Fax' },
                { value: 'TIERS-EMAIL', label: 'Email' },
                { value: 'TIERS-WEBSITE', label: 'Site internet' },
                { value: 'TIERS-SIRET', label: 'N° SIRET' },
                { value: 'TIERS-TVA', label: 'N° TVA intracommunautaire' },
                { value: 'TITLE', label: 'Titre de la commande' },
                { value: 'DOC-NUM', label: 'N° de la commande' },
                { value: 'DATE', label: 'Date de la commande' },
                { value: 'DATE-LETTER', label: 'Date en toutes lettres' },
                { value: 'NOTES', label: 'Commentaires de la commande' },
                { value: 'DELIVERY-ADDRESS', label: 'Adresse de livraison' }
            ]
        },
        contract: {
            label: 'Information sur le contrat',
            variables: [
                { value: 'CONTRACT-REFERENCE', label: 'N° du contrat' },
                { value: 'CONTRACT-TITLE', label: 'Titre du contrat' },
                { value: 'CONTRACT-DATE', label: 'Date de l\'échéance' }
            ]
        },
        electronicSign: {
            label: 'Signature du document',
            variables: [
                { value: 'SIGNATURE', label: 'Signature simple' },
                { value: 'SIGNATURE-NAME', label: 'Nom du signataire + Signature' },
                { value: 'SIGNATURE-DATE', label: 'Date + Signature' },
                { value: 'SIGNATURE-NAME-DATE', label: 'Nom du signataire + Date + Signature' }
            ]
        },
        automotive: {
            label: 'Véhicule',
            variables: [
                { value: 'CAR-BRAND', label: 'Marque' },
                { value: 'CAR-MODEL', label: 'Modèle' },
                { value: 'CAR-DATE', label: 'Première mise en circulation' },
                { value: 'CAR-NUMBERPLATE', label: 'Immatriculation' },
                { value: 'CAR-MILEAGE', label: 'Kilométrage' },
                { value: 'CAR-VIN', label: 'N° de série' },
                { value: 'CAR-COMMENTS', label: 'Commentaires' }
            ]
        }
    }
};
/* harmony default export */ __webpack_exports__.A = (config);


/***/ }),

/***/ 93601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ 93663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(41799),
    getMatchData = __webpack_require__(10776),
    matchesStrictComparable = __webpack_require__(67197);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 94184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContractModelFormView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContractModelFormView/ContractModelFormView.vue?vue&type=template&id=cf1e9c64
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('ContractModelForm',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/ContractModelForm/ContractModelForm.vue + 3 modules
var ContractModelForm = __webpack_require__(80200);
// EXTERNAL MODULE: ./src/fetchDatas/contractModel.ts
var contractModel = __webpack_require__(63991);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/ContractModelFormView/ContractModelFormView.ts?vue&type=script&lang=ts&external





var PdfModelFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfModelFormView, _super);
    function PdfModelFormView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = null;
        _this.loading = true;
        return _this;
    }
    PdfModelFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContractModelForm: ContractModelForm/* default */.A,
                Spinner: interface_vue_.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!to.params.id) {
                                    next(function (vm) {
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,contractModel/* fetchContractModel */.qz)(to.params.id)
                                        .then(function (model) {
                                        next(function (vm) {
                                            vm.model = model;
                                            vm.loading = false;
                                        });
                                    })
                                        .catch(function () {
                                        next({ name: 'error-404' });
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!to.params.id) {
                                    this.loading = false;
                                    next();
                                    return [2 /*return*/];
                                }
                                this.loading = true;
                                this.model = null;
                                return [4 /*yield*/, (0,contractModel/* fetchContractModel */.qz)(to.params.id)
                                        .then(function (model) {
                                        _this.model = model;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], PdfModelFormView);
    return PdfModelFormView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContractModelFormViewvue_type_script_lang_ts_external = (PdfModelFormView);

;// ./src/views/ContractModelFormView/ContractModelFormView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContractModelFormView_ContractModelFormViewvue_type_script_lang_ts_external = (ContractModelFormViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/ContractModelFormView/ContractModelFormView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContractModelFormView_ContractModelFormViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContractModelFormView = (component.exports);

/***/ }),

/***/ 94394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(43360),
    createAggregator = __webpack_require__(42000);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),

/***/ 94418:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ 94425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DocumentContent_DocumentContent; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DocumentContent/DocumentContent.vue?vue&type=template&id=2b8e1924
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-table',{attrs:{"columns":_vm.columns,"datas":_vm.document.contents,"state-key":"sales-documents-content"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(58399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DocumentContent/DocumentContent.ts?vue&type=script&lang=ts&external




var DocumentContent = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DocumentContent, _super);
    function DocumentContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DocumentContent.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [
                {
                    data: 'is_comments',
                    name: 'Type de ligne',
                    sortable: false,
                    render: function (d, row) {
                        if (row.is_comments) {
                            return 'Commentaires';
                        }
                        else if (row.is_subtotal) {
                            return 'Sous-total';
                        }
                        else if (row.is_pagebreak) {
                            return 'Saut de page';
                        }
                        else if (row.catalog) {
                            switch (row.catalog.type) {
                                case 'service':
                                    return 'Prestation';
                                case 'product':
                                    return 'Produit';
                                default:
                                    return null;
                            }
                        }
                        else {
                            return 'Ligne vide';
                        }
                    }
                },
                {
                    data: 'line_number',
                    name: 'N° ligne',
                    render: 'integer',
                    visible: false
                },
                {
                    data: 'reference',
                    name: 'Référence'
                },
                {
                    data: 'designation',
                    name: 'Désignation',
                    isHtml: true
                },
                {
                    data: 'comments',
                    name: 'Commentaires',
                    visible: false,
                    render: 'textarea',
                    isHtml: true
                },
                {
                    data: 'ean_code',
                    name: 'Code EAN',
                    visible: false
                },
                {
                    data: 'weight_unit',
                    name: 'Poids unitaire',
                    visible: false,
                    render: 'amount'
                },
                {
                    data: 'unit_price_net_ht',
                    name: 'Prix U. HT',
                    render: 'currency'
                },
                {
                    data: 'unit_price_net_tva',
                    name: 'Prix U. TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'unit_price_net_ttc',
                    name: 'Prix U. TTC',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'ecotax_u_ht',
                    name: 'Éco-part. U. HT',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'ecotax_u_tva',
                    name: 'Éco-part. U. TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'ecotax_u_ttc',
                    name: 'Éco-part. U. TTC',
                    render: 'currency',
                    visible: false
                }
            ];
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'catalog_costs_u',
                        name: 'Prix d\'achat U.',
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'various_costs_u',
                        name: 'Coûts divers U.',
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_costs_u',
                        name: 'Coûts total U.',
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'hourly_person_cost',
                        name: 'Coûts horaire',
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'number_people_needed',
                    name: 'Nb technicien',
                    render: 'integer',
                    visible: false
                },
                {
                    data: 'duration',
                    name: 'Durée U.',
                    visible: false,
                    render: function (d, row) {
                        return d + ' ' + _this.$tc('interface.duration.' + row.duration_type, d);
                    }
                }
            ]);
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'workforce_costs_u',
                        name: 'Main d\'oeuvre U.',
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_charge_u',
                        name: 'Total charge U.',
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'gross_margin_amount_u',
                        name: 'Marge brute HT U.',
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'quantity',
                    name: 'Quantité',
                    render: function (data, row, column, rowIndex, colIndex, options) {
                        if (row.is_option) {
                            return 'Option';
                        }
                        return (0,table_vue_.number)(data, options);
                    },
                    visible: false
                },
                {
                    data: 'unit.label',
                    name: 'Unité',
                    visible: false
                },
                {
                    data: 'secondary_quantity',
                    name: 'Quantité 2',
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'secondary_unit_value.label',
                    name: 'Unité secondaire',
                    visible: false
                },
                {
                    data: 'total_quantity',
                    name: 'Quantité totale',
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'vat_rate_value',
                    name: 'Taux TVA',
                    render: 'pourcent'
                },
                {
                    data: 'sale_category.label',
                    name: 'Catégorie de vente',
                    visible: false
                },
                {
                    data: 'total_net_ht',
                    name: 'Total HT',
                    render: 'currency'
                },
                {
                    data: 'total_net_tva',
                    name: 'Total TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_net_ttc',
                    name: 'Total TTC',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ecotax_ht',
                    name: 'Total Éco-part. HT',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ecotax_tva',
                    name: 'Total Éco-part. TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ecotax_ttc',
                    name: 'Total Éco-part. TTC',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_weight',
                    name: 'Poids total',
                    render: 'amount',
                    visible: false
                }
            ]);
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'total_catalog_costs',
                        name: 'Total coûts achats',
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_various_costs',
                        name: 'Total coûts divers',
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_costs',
                        name: 'Coûts total',
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'total_duration_hour',
                    name: 'Durée totale',
                    render: 'amount',
                    visible: false
                }
            ]);
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'total_workforce',
                        name: 'Total main d\'oeuvre',
                        render: 'amount',
                        visible: false
                    },
                    {
                        data: 'total_charge',
                        name: 'Charge totale',
                        render: 'amount',
                        visible: false
                    },
                    {
                        data: 'gross_margin_amount',
                        name: 'Marge brute',
                        render: 'amount',
                        visible: false
                    },
                    {
                        data: 'gross_margin_rate',
                        name: 'Taux de marge',
                        render: 'pourcent',
                        visible: false
                    },
                    {
                        data: 'markup_rate',
                        name: 'Taux de marque',
                        render: 'pourcent',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'billed_quantity',
                    name: 'Quantité facturée',
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'quantity_to_bill',
                    name: 'Quantité à facturer',
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'delivered_quantity',
                    name: 'Quantité livrée',
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'quantity_to_deliver',
                    name: 'Quantité à livrer',
                    render: 'amount',
                    visible: false
                }
            ]);
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DocumentContent.prototype, "document", void 0);
    DocumentContent = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], DocumentContent);
    return DocumentContent;
}(lib/* Vue */.lD));
/* harmony default export */ var DocumentContentvue_type_script_lang_ts_external = (DocumentContent);

;// ./src/components/DocumentContent/DocumentContent.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DocumentContent_DocumentContentvue_type_script_lang_ts_external = (DocumentContentvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/DocumentContent/DocumentContent.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DocumentContent_DocumentContentvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DocumentContent_DocumentContent = (component.exports);

/***/ }),

/***/ 94804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_PaymentSuccessfulView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentSuccessfulView.vue?vue&type=template&id=b9832674
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-4"},[(!_vm.clientSecret)?[_vm._v(" Erreur ")]:_c('PaymentSuccessful',{attrs:{"clientSecret":_vm.clientSecret,"accountId":_vm.$route.params.accountId}})],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/StripePaymentSuccessful/StripePaymentSuccessful.vue + 3 modules
var StripePaymentSuccessful = __webpack_require__(63849);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentSuccessfulView.vue?vue&type=script&lang=ts



var PaymentSuccessfulView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentSuccessfulView, _super);
    function PaymentSuccessfulView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PaymentSuccessfulView.prototype, "clientSecret", {
        get: function () {
            return new URLSearchParams(window.location.search).get('payment_intent_client_secret');
        },
        enumerable: false,
        configurable: true
    });
    PaymentSuccessfulView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PaymentSuccessful: StripePaymentSuccessful/* default */.A
            }
        })
    ], PaymentSuccessfulView);
    return PaymentSuccessfulView;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentSuccessfulViewvue_type_script_lang_ts = (PaymentSuccessfulView);

;// ./src/views/PaymentSuccessfulView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_PaymentSuccessfulViewvue_type_script_lang_ts = (PaymentSuccessfulViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/views/PaymentSuccessfulView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_PaymentSuccessfulViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_PaymentSuccessfulView = (component.exports);

/***/ }),

/***/ 95050:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ 95093:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                __webpack_require__(35358)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 95150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleTermsSelect_SaleTermsSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleTermsSelect/SaleTermsSelect.vue?vue&type=template&id=f1155962
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.saleTerms}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleTermsSelect/SaleTermsSelect.ts?vue&type=script&lang=ts&external




var SaleTermsSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleTermsSelect, _super);
    function SaleTermsSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaleTermsSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadSaleTerms()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SaleTermsSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SaleTermsSelect.prototype, "value", void 0);
    SaleTermsSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('sales', ['loadSaleTerms'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('sales', ['saleTerms'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], SaleTermsSelect);
    return SaleTermsSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var SaleTermsSelectvue_type_script_lang_ts_external = (SaleTermsSelect);

;// ./src/components/SaleTermsSelect/SaleTermsSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleTermsSelect_SaleTermsSelectvue_type_script_lang_ts_external = (SaleTermsSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SaleTermsSelect/SaleTermsSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleTermsSelect_SaleTermsSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleTermsSelect_SaleTermsSelect = (component.exports);

/***/ }),

/***/ 95160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleInputOptions_SaleInputOptions; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleInputOptions/SaleInputOptions.vue?vue&type=template&id=91f40104
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('p',{staticClass:"text-center"},[_vm._v(" Gérez ici, les différentes options qu'il vous est possible de saisir lors de la rédaction des documents."),_c('br'),_vm._v(" Il est possible de personnaliser ces options pour un document en particulier directement lors de la création / modification du document. ")]),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-1",modifiers:{"sales-input-options-1":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'cogs']}}),_vm._v(" Options de saisie ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-1","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[(_vm.hasModule('sales-deliveries'))?_c('b-form-group',{attrs:{"label":"Adresse de livraison / de chantier"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_allow_delivery_address]"},domProps:{"value":_vm.localConfig.sales_allow_delivery_address}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.sales_allow_delivery_address),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_allow_delivery_address", $$v)},expression:"localConfig.sales_allow_delivery_address"}},[_vm._v(" Activer la saisie de l'adresse de livraison ")])],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Sélection du taux de TVA"}},[_c('k-form-select',{attrs:{"options":_vm.selectVatRates,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_use_global_vatrate]"},model:{value:(_vm.localConfig.sales_use_global_vatrate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_use_global_vatrate", $$v)},expression:"localConfig.sales_use_global_vatrate"}})],1),_c('b-form-group',{attrs:{"label":"Mode de saisie des montants"}},[_c('k-form-select',{attrs:{"options":_vm.amountsType,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_amounts_type]"},model:{value:(_vm.localConfig.sales_amounts_type),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_amounts_type", $$v)},expression:"localConfig.sales_amounts_type"}})],1),_c('b-form-group',{attrs:{"label":"Possibilité de proposer des options","description":"Seul le prix unitaire sera affiché sur le PDF avec le terme 'option' dans la colonne quantité"}},[_c('k-form-select',{attrs:{"options":_vm.allowOptions,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_allow_options]"},model:{value:(_vm.localConfig.sales_allow_options),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_allow_options", $$v)},expression:"localConfig.sales_allow_options"}})],1),_c('b-form-group',{attrs:{"label":"Code EAN"}},[_c('k-form-select',{attrs:{"options":_vm.eanOptions,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_ean]"},model:{value:(_vm.localConfig.sales_ean),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_ean", $$v)},expression:"localConfig.sales_ean"}})],1),_c('b-form-group',{attrs:{"label":"Poids"}},[_c('k-form-select',{attrs:{"options":_vm.weightOptions,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_weight]"},model:{value:(_vm.localConfig.sales_weight),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_weight", $$v)},expression:"localConfig.sales_weight"}})],1),_c('b-form-group',{attrs:{"label":"Éco-participation"}},[_c('k-form-select',{attrs:{"options":_vm.ecoParticipation,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_eco_participation]"},model:{value:(_vm.localConfig.sales_eco_participation),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_eco_participation", $$v)},expression:"localConfig.sales_eco_participation"}})],1),_c('b-form-group',{attrs:{"label":"Affichage des colonnes","label-class":"mb-2"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_col_number]"},domProps:{"value":_vm.localConfig.sales_col_number}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.sales_col_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_col_number", $$v)},expression:"localConfig.sales_col_number"}},[_vm._v(" Afficher la colonne n° de ligne (1,2,3...) ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_col_reference]"},domProps:{"value":_vm.localConfig.sales_col_reference}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.sales_col_reference),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_col_reference", $$v)},expression:"localConfig.sales_col_reference"}},[_vm._v(" Afficher la colonne référence ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_col_picture]"},domProps:{"value":_vm.localConfig.sales_col_picture}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.sales_col_picture),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_col_picture", $$v)},expression:"localConfig.sales_col_picture"}},[_vm._v(" Afficher la colonne photo ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_col_unit]"},domProps:{"value":_vm.localConfig.sales_col_unit}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.sales_col_unit),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_col_unit", $$v)},expression:"localConfig.sales_col_unit"}},[_vm._v(" Afficher les unités ")])],1),_c('b-form-group',{attrs:{"label":"Autre options","label-class":"mb-2"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_private_comments]"},domProps:{"value":_vm.localConfig.sales_private_comments}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.sales_private_comments),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_private_comments", $$v)},expression:"localConfig.sales_private_comments"}},[_vm._v(" Ajouter une ligne de commentaire sur chaque ligne d'un document (Non visible sur le PDF final) ")])],1),_c('b-form-group',{attrs:{"label":"Lors de la rédaction d'un document, masquer les formulaires de saisie à partir de :","description":"Il faudra alors cliquer sur la ligne pour afficher les différents champs du formulaire (Référence, Description, Prix U...)."}},[_c('b-input-group',{attrs:{"append":"ligne(s)"}},[_c('k-form-spinner',{attrs:{"name":"configs[sales_form_compact_number]","value":_vm.localConfig.sales_form_compact_number,"min":1}})],1)],1)],1)],1)],1),(_vm.hasModule('stock'))?_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-2",modifiers:{"sales-input-options-2":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'box-open']}}),_vm._v(" Gestion du stock ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-2","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":"Affichage du niveau de stock"}},[_c('k-form-select',{attrs:{"options":_vm.stockDisplay,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_stock_display]"},model:{value:(_vm.localConfig.sales_stock_display),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_stock_display", $$v)},expression:"localConfig.sales_stock_display"}})],1),(_vm.hasModule('stock-tracabilities'))?_c('b-form-group',{attrs:{"label":"Gestion de stock avec gestion de la traçabilité"}},[_c('k-form-select',{attrs:{"options":_vm.activeStockTracabilities,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_stock_tracabilities]"},model:{value:(_vm.localConfig.sales_stock_tracabilities),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_stock_tracabilities", $$v)},expression:"localConfig.sales_stock_tracabilities"}}),_c('small',[_c('p',{staticClass:"font-weight-bold mb-0 mt-2"},[_vm._v(" Cette fonctionnalité est obligatoirement activée pour les bons de livraison. ")]),_vm._v(" Lorsqu'un produit est sélectionné et que le document est enregistré, le produit sera immédiatement déduit du stock théorique. Pour les devis, bons de commande et factures proforma, le stock sera recrédité à la date d'expiration du document si celui-ci n'a pas été facturé. ")])],1):_vm._e()],1)],1)],1):_vm._e(),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-3",modifiers:{"sales-input-options-3":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'calculator']}}),_vm._v(" Calcul des coûts ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-3","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('input',{attrs:{"type":"hidden","name":"configs[sales_costs_average_buy_price]"},domProps:{"value":_vm.localConfig.sales_costs_average_buy_price}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.localConfig.sales_costs_average_buy_price),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_costs_average_buy_price", $$v)},expression:"localConfig.sales_costs_average_buy_price"}},[_vm._v(" Utiliser le prix pondéré à la place du prix d'achat ")]),_c('b-form-group',{attrs:{"label":"Saisie des coûts"}},[_c('k-form-select',{attrs:{"options":_vm.costsEntries,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_costs_entries]"},model:{value:(_vm.localConfig.sales_costs_entries),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_costs_entries", $$v)},expression:"localConfig.sales_costs_entries"}})],1),_c('input',{attrs:{"type":"hidden","name":"configs[sales_various_costs]"},domProps:{"value":_vm.localConfig.sales_various_costs}}),(_vm.localConfig.sales_costs_entries !== 0)?_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.localConfig.sales_various_costs),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_various_costs", $$v)},expression:"localConfig.sales_various_costs"}},[_vm._v(" Activer la saisie des coûts divers ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Saisie de la main d'oeuvre"}},[_c('k-form-select',{attrs:{"options":_vm.workforceEntries,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_workforce_entries]"},model:{value:(_vm.localConfig.sales_workforce_entries),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_workforce_entries", $$v)},expression:"localConfig.sales_workforce_entries"}})],1),_c('b-form-group',{attrs:{"label":"Calcul de la marge","label-class":"mb-2"}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_gross_margin_amount]"},domProps:{"value":_vm.localConfig.sales_gross_margin_amount}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.sales_gross_margin_amount),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_gross_margin_amount", $$v)},expression:"localConfig.sales_gross_margin_amount"}},[_vm._v(" Afficher la marge brute HT ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_gross_margin_rate]"},domProps:{"value":_vm.localConfig.sales_gross_margin_rate}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.sales_gross_margin_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_gross_margin_rate", $$v)},expression:"localConfig.sales_gross_margin_rate"}},[_vm._v(" Afficher le taux de marge ")]),_c('input',{attrs:{"type":"hidden","name":"configs[sales_markup_rate]"},domProps:{"value":_vm.localConfig.sales_markup_rate}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.sales_markup_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_markup_rate", $$v)},expression:"localConfig.sales_markup_rate"}},[_vm._v(" Afficher le taux de marque ")])],1)],1)],1)],1),(_vm.hasModule('sales-durations'))?_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-input-options-4",modifiers:{"sales-input-options-4":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'calculator-alt']}}),_vm._v(" Quantité secondaire ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-input-options-4","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('p',[_vm._v(" Les quantités secondaires vous permettent de saisir une deuxième quantité qui sera complémentaire de la première. Elles sont généralements utilisées pour facturer des durées. ")]),_c('b-form-group',{attrs:{"label":"Mode de saisie de la quantité secondaire"}},[_c('k-form-select',{attrs:{"options":_vm.secondaryQuantity,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_secondary_quantity]"},model:{value:(_vm.localConfig.sales_secondary_quantity),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_secondary_quantity", $$v)},expression:"localConfig.sales_secondary_quantity"}})],1),(_vm.localConfig.sales_secondary_quantity !== 0)?_c('b-form-group',{attrs:{"label":"Gestion des unités pour les quantités secondaires"}},[_c('k-form-select',{attrs:{"options":_vm.secondaryQuantityUnit,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_secondary_quantity_unit]"},model:{value:(_vm.localConfig.sales_secondary_quantity_unit),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_secondary_quantity_unit", $$v)},expression:"localConfig.sales_secondary_quantity_unit"}})],1):_vm._e()],1)],1)],1):_vm._e(),(_vm.hasModule('sales-deliveries'))?_c('b-card',{staticClass:"mb-0",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sales-pdf-options-3",modifiers:{"sales-pdf-options-3":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_c('font-awesome-icon',{staticClass:"mr-2 text-center",staticStyle:{"width":"25px"},attrs:{"icon":['fas', 'truck']}}),_vm._v(" Bons de livraison ")],1)],1),_c('b-collapse',{attrs:{"id":"sales-pdf-options-3","accordion":"sales-input-options","role":"tabpanel"}},[_c('b-card-body',[_c('h3',{staticClass:"form-title-alt mt-0"},[_vm._v(" Personnalisation du PDF ")]),_c('b-form-group',{attrs:{"label":"Affichage des prix et des totaux"}},[_c('k-form-select',{attrs:{"options":_vm.showOnOff,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_delivery_prices]"},model:{value:(_vm.localConfig.sales_pdf_delivery_prices),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_delivery_prices", $$v)},expression:"localConfig.sales_pdf_delivery_prices"}})],1),_c('b-form-group',{attrs:{"label":"Affichage des quantités restantes à livrer"}},[_c('k-form-select',{attrs:{"options":_vm.showOnOff,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_delivery_remaining_quantity]"},model:{value:(_vm.localConfig.sales_pdf_delivery_remaining_quantity),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_delivery_remaining_quantity", $$v)},expression:"localConfig.sales_pdf_delivery_remaining_quantity"}})],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Livraison à partir d'un devis, d'un bon de commande ou d'une facture ")]),_c('b-form-group',{attrs:{"label":"Calculer les quantités restantes à livrer en se basant prioritairement sur"}},[_c('k-form-select',{attrs:{"options":_vm.deliveryRemainingQuantityFrom,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_pdf_delivery_remaining_quantity_from]"},model:{value:(_vm.localConfig.sales_pdf_delivery_remaining_quantity_from),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_delivery_remaining_quantity_from", $$v)},expression:"localConfig.sales_pdf_delivery_remaining_quantity_from"}})],1),_c('b-form-group',{attrs:{"label":"Empêcher de livrer plus que la quantité commandée"}},[_c('k-form-select',{attrs:{"options":_vm.disableDeliverySecurity,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_disable_delivery_security]"},model:{value:(_vm.localConfig.sales_disable_delivery_security),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_disable_delivery_security", $$v)},expression:"localConfig.sales_disable_delivery_security"}})],1),_c('b-form-group',{attrs:{"label":"Déduire les quantités en cours de commande chez le fournisseur"}},[_c('k-form-select',{attrs:{"options":[
              { id: true, label: _vm.$t('interface.yes') },
              { id: false, label: _vm.$t('interface.no') },
            ],"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_minus_provider_stock]"},model:{value:(_vm.localConfig.sales_minus_provider_stock),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_minus_provider_stock", $$v)},expression:"localConfig.sales_minus_provider_stock"}})],1),_c('b-form-group',{attrs:{"label":"Livraison d'un document et quantité en stock"}},[_c('k-form-select',{attrs:{"options":_vm.deliveryStockQuantity,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_stock_delivery_quantity]"},model:{value:(_vm.localConfig.sales_stock_delivery_quantity),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_stock_delivery_quantity", $$v)},expression:"localConfig.sales_stock_delivery_quantity"}})],1),_c('b-form-group',{attrs:{"label":"Stock à prendre en compte pour les quantités à livrer"}},[_c('k-form-select',{attrs:{"options":_vm.deliveryStockToUse,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_stock_quantity_to_use]"},model:{value:(_vm.localConfig.sales_stock_quantity_to_use),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_stock_quantity_to_use", $$v)},expression:"localConfig.sales_stock_quantity_to_use"}})],1)],1)],1)],1):_vm._e(),_c('p',{staticClass:"mt-3 mb-2 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesInputOptionsMixin.ts
var SalesInputOptionsMixin = __webpack_require__(80924);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleInputOptions/SaleInputOptions.ts?vue&type=script&lang=ts&external








var SaleInputOptions = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleInputOptions, _super);
    function SaleInputOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deliveryRemainingQuantityFrom = [
            { id: 'quotation', label: 'Le devis lié, puis le bon de commande si le devis n\'existe pas' },
            { id: 'command', label: 'Le bon de commande lié, puis le devis si le bon de commande n\'existe pas' }
        ];
        _this.disableDeliverySecurity = [
            { id: false, label: 'Empêcher de livrer plus que la quantité commandée' },
            { id: true, label: 'DÉSACTIVER LA SECURITÉ et permettre de livrer plus que la quantité commandée' }
        ];
        _this.deliveryStockQuantity = [
            { id: 0, label: 'Toujours sélectionner la quantité totale' },
            { id: 1, label: 'Sélectionner uniquement la quantité en stock' },
            { id: 2, label: 'Empêcher de sélectionner plus que la quantité présente en stock' }
        ];
        _this.deliveryStockToUse = [
            { id: 0, label: 'Utiliser le stock réel' },
            { id: 1, label: 'Utiliser le stock théorique' }
        ];
        return _this;
    }
    SaleInputOptions = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect, KFormSpinner: form_vue_.KFormSpinner,
                BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BButton: external_bootstrap_vue_.BButton, BCollapse: external_bootstrap_vue_.BCollapse, BCardBody: external_bootstrap_vue_.BCardBody, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], SaleInputOptions);
    return SaleInputOptions;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin, SalesInputOptionsMixin/* default */.A)));
/* harmony default export */ var SaleInputOptionsvue_type_script_lang_ts_external = (SaleInputOptions);

;// ./src/components/SaleInputOptions/SaleInputOptions.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleInputOptions_SaleInputOptionsvue_type_script_lang_ts_external = (SaleInputOptionsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SaleInputOptions/SaleInputOptions.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleInputOptions_SaleInputOptionsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleInputOptions_SaleInputOptions = (component.exports);

/***/ }),

/***/ 95533:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ 95950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(70695),
    baseKeys = __webpack_require__(88984),
    isArrayLike = __webpack_require__(64894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 95995:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ 96130:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'expand-arrows-alt';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f31e';
var svgPathData = 'M252.3 256l121.4 121.4 53.8-53.8c7.6-7.6 20.5-2.2 20.5 8.5v136c0 6.6-5.4 12-12 12H300c-10.7 0-16-12.9-8.5-20.5l53.8-53.8L224 284.3 102.6 405.7l53.8 53.8c7.6 7.6 2.2 20.5-8.5 20.5h-136c-6.6 0-12-5.4-12-12V332c0-10.7 12.9-16 20.5-8.5l53.8 53.8L195.7 256 74.3 134.6l-53.8 53.8C12.9 196 0 190.7 0 180V44c0-6.6 5.4-12 12-12h136c10.7 0 16 12.9 8.5 20.5l-53.8 53.8L224 227.7l121.4-121.4-53.8-53.8C284 44.9 289.3 32 300 32h136c6.6 0 12 5.4 12 12v136c0 10.7-12.9 16-20.5 8.5l-53.8-53.8L252.3 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.pG = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 96352:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "img/invoice-illustration.92bad52f.png";

/***/ }),

/***/ 96724:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'box-full';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f49c';
var svgPathData = 'M384.3 360.6L320 254l-64.2 106.6c-6.4 10.7-26.1 29.8-54.7 21.6L64 343v82c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 456c14.2-3.6 24.2-16.4 24.2-31v-82l-137 39.1c-28.5 8.2-48.2-10.7-54.7-21.5zM194.2 143.7c-1.3-5.1-2.2-10.3-2.2-15.7 0-35.3 28.7-64 64-64s64 28.7 64 64c0 11.2-3.1 21.5-8.2 30.7l8.2 1L475.3 140 511 41.7c3-8.3-1.3-17.5-9.6-20.5L445.9 1c-8.3-3-17.5 1.3-20.5 9.6L383.7 125C382 55.7 325.7 0 256 0c-70.7 0-128 57.3-128 128 0 2.5.6 4.9.7 7.4zM53.2 169L1.7 271.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 192 69.8 160.1c-6.9-.8-13.5 2.7-16.6 8.9zm585.1 102.8L586.8 169c-3.1-6.2-9.8-9.8-16.7-8.9L320 192l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.KM = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 96870:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ 96994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CarItem_CarItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CarItem/CarItem.vue?vue&type=template&id=b795f63c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close'),"size":"lg"},on:{"hidden":function($event){return _vm.$emit('hidden')}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-row',{staticClass:"w-100"},[_c('b-col',[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.edit = true}}},[_vm._v(" Modifier ")]),(_vm.canDelete)?_c('CarDelete',{staticClass:"d-inline-block",attrs:{"variant":"secondary"},on:{"deleted":_vm.deleted},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" Fermer ")])],1)],1)]}}]),model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('b-row',{attrs:{"cols":"4"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Client"}},[_c('CustomerSpeedItem',{model:{value:(_vm.customerModel),callback:function ($$v) {_vm.customerModel=$$v},expression:"customerModel"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Marque"}},[_vm._v(" "+_vm._s(_vm.value.brand?.name)+" ")])],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Modèle"}},[_vm._v(" "+_vm._s(_vm.value.model?.name)+" ")])],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Immatriculation"}},[_vm._v(" "+_vm._s(_vm.value.numberplate)+" ")])],1),(_vm.value.mileage)?_c('b-col',[_c('b-form-group',{attrs:{"label":"Kilométrage"}},[_vm._v(" "+_vm._s(_vm.value.mileage)+" km ")])],1):_vm._e(),(_vm.value.first_circulation_date)?_c('b-col',[_c('b-form-group',{attrs:{"label":"1ère immatriculation"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.first_circulation_date))+" ")])],1):_vm._e(),_c('b-col',[(_vm.value.vin)?_c('b-form-group',{attrs:{"label":"Numéro de série"}},[_vm._v(" "+_vm._s(_vm.value.vin)+" ")]):_vm._e()],1),_c('b-col',[(_vm.value.comments)?_c('b-form-group',{attrs:{"label":"Commentaires"}},[_vm._v(" "+_vm._s(_vm.value.comments)+" ")]):_vm._e()],1)],1),_c('b-tabs',{staticClass:"mt-2"},[_c('b-tab',{attrs:{"title":"Devis","lazy":""}},[_c('CarDocuments',{attrs:{"car":_vm.value,"type":"quotation"},on:{"redirect":function($event){_vm.modalState = false}}})],1),_c('b-tab',{attrs:{"title":"Factures","lazy":""}},[_c('CarDocuments',{attrs:{"car":_vm.value,"type":"invoice"},on:{"redirect":function($event){_vm.modalState = false}}})],1)],1),_c('CarForm',{attrs:{"modal":_vm.edit},on:{"submitComplete":car => _vm.$emit('input', car),"hidden":function($event){_vm.edit = false}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: ./src/components/CarForm/CarForm.vue + 3 modules
var CarForm = __webpack_require__(8998);
// EXTERNAL MODULE: ./src/components/CarDelete/CarDelete.vue + 3 modules
var CarDelete = __webpack_require__(71183);
// EXTERNAL MODULE: ./src/components/CarDocuments/CarDocuments.vue + 3 modules
var CarDocuments = __webpack_require__(36898);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CarItem/CarItem.ts?vue&type=script&lang=ts&external








var CarItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CarItem, _super);
    function CarItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.edit = false;
        return _this;
    }
    CarItem.prototype.watchModalState = function () {
        this.modalState = this.modal;
    };
    CarItem.prototype.deleted = function () {
        this.modalState = false;
        this.$emit('deleted');
    };
    Object.defineProperty(CarItem.prototype, "customerModel", {
        get: function () {
            var _a;
            return (_a = this.customer) !== null && _a !== void 0 ? _a : this.value.customer;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarItem.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CarItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CarItem.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CarItem.prototype, "canDelete", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CarItem.prototype, "watchModalState", null);
    CarItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CarForm: CarForm/* default */.A, CarDelete: CarDelete/* default */.A, CarDocuments: CarDocuments/* default */.A,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BCol: external_bootstrap_vue_.BCol, BRow: external_bootstrap_vue_.BRow, BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                CustomerSpeedItem: customers_vue_.CustomerSpeedItem,
                Spinner: interface_vue_.Spinner
            }
        })
    ], CarItem);
    return CarItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var CarItemvue_type_script_lang_ts_external = (CarItem);

;// ./src/components/CarItem/CarItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CarItem_CarItemvue_type_script_lang_ts_external = (CarItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/CarItem/CarItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CarItem_CarItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CarItem_CarItem = (component.exports);

/***/ }),

/***/ 97302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SubTotalLine_SubTotalLine; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/SubTotalLine/SubTotalLine.vue?vue&type=template&id=566acd50
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{on:{"click":_vm.setLocationEditing}},[_c('td',[(_vm.document.contents.length > 1)?_c('font-awesome-icon',{ref:"moveBtn",staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e()],1),_c('td',{staticClass:"text-wrap",attrs:{"colspan":_vm.colspan}},[(!_vm.editing)?_c('FroalaView',{model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}}):[_c('k-form-editor',{attrs:{"size":"sm","required":"","config":_vm.editorConfig},model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}}),_c('b-form-row',{staticClass:"sub-description-input"},[_c('b-col'),(_vm.withWorkoutCosts)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label-size":"sm","label":"Main d'oeuvre :"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","value":_vm.totalWorkout,"readonly":""}})],1)],1)],1):_vm._e(),(_vm.withCosts)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label-size":"sm","label":"Achats :"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","value":_vm.totalCatalog,"readonly":""}})],1)],1)],1):_vm._e(),(_vm.withCosts && _vm.withWorkoutCosts)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label-size":"sm","label":"Charge :"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","value":_vm.totalCharge,"readonly":""}})],1)],1)],1):_vm._e(),((_vm.withCosts || _vm.withWorkoutCosts) && _vm.document.input_options.gross_margin_amount)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label-size":"sm","label":"Marge HT :"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","value":_vm.totalMargin,"readonly":""}})],1)],1)],1):_vm._e(),((_vm.withCosts || _vm.withWorkoutCosts) && _vm.document.input_options.gross_margin_rate)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label-size":"sm","label":"Taux marge :"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","value":_vm.totalMarginRate,"readonly":""}})],1)],1)],1):_vm._e(),((_vm.withCosts || _vm.withWorkoutCosts) && _vm.document.input_options.markup_rate)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label-size":"sm","label":"Taux marque :"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","value":_vm.totalMarkupRate,"readonly":""}})],1)],1)],1):_vm._e()],1)],_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('designation')},domProps:{"value":_vm.value.designation}})],2),_c('td',[(!_vm.editing)?[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.total))+" ")]:_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","value":_vm.total,"readonly":""}})],1)],2),_c('td',[_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('is_subtotal')},domProps:{"value":true}}),(_vm.value.affair_content_id)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('affair_content')},domProps:{"value":_vm.value.affair_content_id}}):_vm._e(),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],ref:"deleteBtn",staticClass:"p-0",attrs:{"variant":"link","title":"Supprimer la ligne"}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":_vm.deleteLine}})],1),(_vm.editing)?_c('LineMenu',{attrs:{"line":_vm.value},on:{"add":event => _vm.$emit('addSubLine', event)}}):_vm._e()],1)])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/mixins/SalesLineMixin.ts
var SalesLineMixin = __webpack_require__(11172);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/components/Form/editorConfig.ts
var editorConfig = __webpack_require__(63457);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Form/SubTotalLine/SubTotalLine.ts?vue&type=script&lang=ts&external








var SubTotalLine = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SubTotalLine, _super);
    function SubTotalLine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editorConfig = editorConfig/* default */.A;
        return _this;
    }
    Object.defineProperty(SubTotalLine.prototype, "colspan", {
        get: function () {
            var document = this.document;
            var colspan = 4;
            if (!document.use_global_vatrate) {
                colspan++;
            }
            if (document.secondary_quantity_mode !== 'disable') {
                colspan++;
            }
            if (document.input_options.col_reference) {
                colspan++;
            }
            if (document.input_options.col_picture) {
                colspan++;
            }
            if (document.input_options.col_number) {
                colspan++;
            }
            return colspan;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "withCosts", {
        // If costs should be displayed
        get: function () {
            if (!this.can('sales-margin', 1)) {
                return false;
            }
            return this.document.input_options.costs_entries > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "withWorkout", {
        // If workforce costs should be displayed
        get: function () {
            if (!this.can('sales-margin', 1)) {
                return false;
            }
            return this.document.input_options.workforce_entries > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "total", {
        get: function () {
            return this.getAmount(this.document.input_mode === 'ht' ? 'total_ht' : 'total_ttc');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "totalCharge", {
        get: function () {
            return this.getAmount('total_charge_u');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "totalWorkout", {
        get: function () {
            return this.getAmount('total_workforce');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "totalCatalog", {
        get: function () {
            return this.getAmount('total_costs');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "totalMargin", {
        get: function () {
            return this.getAmount('gross_margin_amount');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "totalMarginRate", {
        get: function () {
            var charge = this.totalCharge;
            var margin = this.totalMargin;
            return this.roundNumber(charge === 0 ? 100 : margin / charge * 100, 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubTotalLine.prototype, "totalMarkupRate", {
        get: function () {
            var sellPrice = this.getAmount('total_ht');
            var margin = this.totalMargin;
            return this.roundNumber(sellPrice === 0 ? 100 : margin / sellPrice * 100, 2);
        },
        enumerable: false,
        configurable: true
    });
    SubTotalLine.prototype.getAmount = function (key) {
        var total = 0;
        for (var i = 0; i <= this.index; i++) {
            var content = this.document.contents[i];
            if (content.is_subtotal && i !== this.index) {
                total = 0;
            }
            else if (!content.is_option && !content.is_subtotal && !content.is_comments && !content.is_pagebreak) {
                total += content[key];
            }
        }
        return total;
    };
    SubTotalLine.prototype.watchValue = function (value) {
        this.$emit('input', value);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localValue')
    ], SubTotalLine.prototype, "watchValue", null);
    SubTotalLine = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency'])),
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KFormEditor: form_vue_.KFormEditor, KFormNumber: form_vue_.KFormNumber, FroalaView: form_vue_.FroalaView,
                BInputGroup: external_bootstrap_vue_.BInputGroup, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol
            }
        })
    ], SubTotalLine);
    return SubTotalLine;
}((0,lib/* Mixins */.Xe)(SalesLineMixin/* default */.A)));
/* harmony default export */ var SubTotalLinevue_type_script_lang_ts_external = (SubTotalLine);

;// ./src/components/Form/SubTotalLine/SubTotalLine.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SubTotalLine_SubTotalLinevue_type_script_lang_ts_external = (SubTotalLinevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/Form/SubTotalLine/SubTotalLine.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SubTotalLine_SubTotalLinevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SubTotalLine_SubTotalLine = (component.exports);

/***/ }),

/***/ 97508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SepaDepositItem_SepaDepositItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SepaDepositItem/SepaDepositItem.vue?vue&type=template&id=345740b9
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":"Remise de prélèvement SEPA","buttons":_vm.buttons}}),_c('AppMessages'),(_vm.value.status === 1)?_c('SepaDepositValidation',{staticClass:"mb-3",attrs:{"size":"sm","label":"Valider la remise","variant":"success","deposit":_vm.value},on:{"input":_vm.depositUpdated}}):_vm._e(),_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":"Compte bancaire"}},[_vm._v(" "+_vm._s(_vm.value.account?.name)+" ")]),_c('b-form-group',{attrs:{"label":"Date"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.date))+" ")]),(_vm.value.use_expire_date)?_c('div',[_c('b-form-checkbox',{staticClass:"d-inline-block",attrs:{"checked":true,"disabled":""}}),_vm._v(" Utiliser la date limite de paiement des factures comme date de prélèvement ")],1):_vm._e(),(_vm.value.group_sepa)?_c('div',{staticClass:"mt-2"},[_c('b-form-checkbox',{staticClass:"d-inline-block",attrs:{"checked":true,"disabled":""}}),_vm._v(" Grouper les prélèvements par mandat SEPA lors de la génération du fichier de prélèvement ")],1):_vm._e()],1),_c('b-col',{staticClass:"mt-3 mt-md-0",attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{class:{
            'font-weight-bold': true,
            'text-danger mb-1': _vm.value.status === 1,
            'text-success': _vm.value.status === 2
          },attrs:{"label":"Statut"}},[_vm._v(" "+_vm._s(_vm.value.status_label)+" ")]),(_vm.value.status === 1)?_c('b-alert',{staticClass:"py-1 px-2",attrs:{"show":"","variant":"warning"}},[_vm._v(" Le fichier de prélèvement sera disponible une fois la remise validée. ")]):_vm._e(),_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Montant de la remise"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total))+" ")])],1)],1)],1),_c('b-table',{attrs:{"striped":"","bordered":"","fields":_vm.invoicesColumns,"items":_vm.value.contents,"per-page":_vm.perPage,"currentPage":_vm.currentPage,"small":"","table-class":"align-middle mt-4 text-nowrap","responsive":""},scopedSlots:_vm._u([{key:"cell(amount)",fn:function({ item }){return [_c(item.payment && item.payment.cancel_id ? 'del' : 'span',{tag:"component"},[_vm._v(" "+_vm._s(_vm.formattedNumber(item.amount))+" ")]),(item.payment && item.payment.cancel_id)?_c('span',{staticClass:"text-danger ml-2"},[_vm._v(" Annulé ")]):_vm._e()]}},{key:"cell(action)",fn:function({ item }){return [_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: 'Voir la facture' }),expression:"{ title: 'Voir la facture' }",modifiers:{"left":true}}],staticClass:"p-0",attrs:{"variant":"icon","to":{ name: 'invoice-item', params: { id: String(item.invoice.id) }}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'search']}})],1)]}}])}),_c('b-row',{staticClass:"text-center"},[_c('b-col',{staticClass:"font-weight-bold"},[_vm._v(" Total : "+_vm._s(_vm.value.contents.length)+" factures ")]),_c('b-col',[_c('b-pagination',{attrs:{"perPage":_vm.perPage,"total-rows":_vm.value.contents.length,"align":"center","size":"sm"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
// EXTERNAL MODULE: ./src/components/SepaDepositValidation/SepaDepositValidation.vue + 3 modules
var SepaDepositValidation = __webpack_require__(81945);
// EXTERNAL MODULE: ./src/components/SepaDepositDelete/SepaDepositDelete.vue + 3 modules
var SepaDepositDelete = __webpack_require__(21478);
// EXTERNAL MODULE: ./src/components/SepaDepositDownload/SepaDepositDownload.vue + 3 modules
var SepaDepositDownload = __webpack_require__(86070);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SepaDepositItem/SepaDepositItem.ts?vue&type=script&lang=ts&external








var SepaDepositItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SepaDepositItem, _super);
    function SepaDepositItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentPage = 1;
        _this.perPage = 50;
        _this.invoicesColumns = [
            { key: 'invoice.customer_reference', label: 'N° client', sortable: true },
            { key: 'invoice.customer_name', label: 'Client', sortable: true },
            { key: 'invoice.reference', label: 'N° Facture', sortable: true },
            { key: 'invoice.date', label: 'Date', formatter: _this.date, sortable: true },
            { key: 'invoice.expire_at', label: 'Limite paiement', formatter: _this.date, sortable: true },
            {
                key: 'invoice.to_paid',
                label: 'À payer',
                formatter: function (value, key, item) { return _this.formattedNumber(value, item.currency); },
                sortable: true
            },
            {
                key: 'sepa',
                label: 'Mandat SEPA',
                formatter: function (value) {
                    var _a;
                    if (!value) {
                        return 'supprimé';
                    }
                    return ((_a = value.name) !== null && _a !== void 0 ? _a : value.owner) + ' (' + (value.type === 1 ? 'Récurrent' : 'Ponctuel') + ')';
                },
                sortable: true,
                tdClass: function (value) {
                    return value === null || value === undefined || value === '' ? 'font-italic' : null;
                }
            },
            {
                key: 'amount',
                label: 'Montant',
                thStyle: 'width: 150px',
                formatter: function (value, key, item) { return _this.formattedNumber(value, item.currency); },
                sortable: true
            },
            { key: 'action', label: '', tdClass: 'text-center' }
        ];
        return _this;
    }
    Object.defineProperty(SepaDepositItem.prototype, "buttons", {
        get: function () {
            var _this = this;
            var buttons = [
                {
                    label: 'Modifier',
                    to: { name: 'sepa-deposit-form', params: { id: String(this.value.id) } },
                    disabled: this.value.status === 2,
                    title: this.value.status ? 'Vous ne pouvez pas modifier une remise validée' : null
                }
            ];
            if (this.value.status === 1) {
                buttons.push({
                    component: SepaDepositValidation/* default */.A,
                    attributes: {
                        deposit: this.value
                    },
                    events: {
                        input: this.depositUpdated
                    }
                });
            }
            else {
                buttons.push({
                    label: 'Télécharger',
                    component: SepaDepositDownload/* default */.A,
                    attributes: {
                        deposit: this.value
                    }
                });
            }
            buttons.push({
                component: SepaDepositDelete/* default */.A,
                attributes: {
                    value: this.value,
                    size: 'sm',
                    class: 'dropdown'
                },
                events: {
                    deleted: function () { return _this.$router.push({ name: 'sepa-deposit-list' }); }
                }
            });
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    SepaDepositItem.prototype.depositUpdated = function (deposit) {
        this.$emit('input', deposit);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SepaDepositItem.prototype, "value", void 0);
    SepaDepositItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard, BTable: external_bootstrap_vue_.BTable, BPagination: external_bootstrap_vue_.BPagination, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormCheckbox: external_bootstrap_vue_.BFormCheckbox, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert,
                PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages,
                SepaDepositValidation: SepaDepositValidation/* default */.A,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], SepaDepositItem);
    return SepaDepositItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var SepaDepositItemvue_type_script_lang_ts_external = (SepaDepositItem);

;// ./src/components/SepaDepositItem/SepaDepositItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SepaDepositItem_SepaDepositItemvue_type_script_lang_ts_external = (SepaDepositItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/SepaDepositItem/SepaDepositItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SepaDepositItem_SepaDepositItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SepaDepositItem_SepaDepositItem = (component.exports);

/***/ }),

/***/ 97650:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ 97711:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ 98174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ 98528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ RecoveryInvoiceStepList_RecoveryInvoiceStepList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RecoveryInvoiceStepList/RecoveryInvoiceStepList.vue?vue&type=template&id=176ea17d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":"/sales/recovery-step","createTitle":_vm.$t('sales.recoveryInvoice.config.createTitle'),"updateTitle":_vm.$t('sales.recoveryInvoice.config.updateTitle'),"deleteMsg":_vm.$t('sales.recoveryInvoice.config.deleteMsg'),"columns":_vm.columns,"customForm":_vm.formComponent,"modalSize":"xl","sort":"delay"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: ./src/components/RecoveryInvoiceStepForm/RecoveryInvoiceStepForm.vue + 5 modules
var RecoveryInvoiceStepForm = __webpack_require__(20206);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/RecoveryInvoiceStepList/RecoveryInvoiceStepList.ts?vue&type=script&lang=ts&external




var RecoveryInvoiceStepList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(RecoveryInvoiceStepList, _super);
    function RecoveryInvoiceStepList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = RecoveryInvoiceStepForm/* default */.A;
        return _this;
    }
    Object.defineProperty(RecoveryInvoiceStepList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: 'Nom de l\'étape',
                    key: 'name',
                },
                {
                    label: 'Délais',
                    key: 'delay',
                    show: function (val) { return val + ' jour' + (val !== 0 ? 's' : ''); }
                },
                {
                    label: 'Type',
                    key: 'type',
                    show: function (val) {
                        switch (val) {
                            case 'mail':
                                return 'Email';
                            case 'letter':
                                return 'Lettre';
                            case 'phone':
                                return 'Compte rendu';
                            default:
                                return null;
                        }
                    }
                },
                {
                    label: 'Envoi automatique',
                    key: 'auto_send',
                    show: function (val, row) { return row.type === 'mail' ? (val ? 'Oui' : 'Non') : ''; }
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    RecoveryInvoiceStepList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], RecoveryInvoiceStepList);
    return RecoveryInvoiceStepList;
}(lib/* Vue */.lD));
/* harmony default export */ var RecoveryInvoiceStepListvue_type_script_lang_ts_external = (RecoveryInvoiceStepList);

;// ./src/components/RecoveryInvoiceStepList/RecoveryInvoiceStepList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var RecoveryInvoiceStepList_RecoveryInvoiceStepListvue_type_script_lang_ts_external = (RecoveryInvoiceStepListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/RecoveryInvoiceStepList/RecoveryInvoiceStepList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  RecoveryInvoiceStepList_RecoveryInvoiceStepListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RecoveryInvoiceStepList_RecoveryInvoiceStepList = (component.exports);

/***/ }),

/***/ 99053:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ 99374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(54128),
    isObject = __webpack_require__(23805),
    isSymbol = __webpack_require__(44394);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 99651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Pr: function() { return /* binding */ needFetchContract; },
/* harmony export */   RA: function() { return /* binding */ fetchContract; },
/* harmony export */   uo: function() { return /* binding */ contractRelations; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var contractRelations = [
    'model', 'customer', 'customer_child', 'customer.addresses', 'contact', 'country', 'teamUser', 'sepa',
    'payment_term', 'payment_method', 'pdf_model', 'contents', 'active_period', 'periods', 'documents',
    'customFields', 'pdf', 'signatures', 'quotation', 'billing_contact'
];
var needFetchContract = function (model) {
    return !contractRelations.every(function (relation) { return relation in model; });
};
var fetchContract = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwSales.axios.get('/sales/contract/' + id, {
                    params: {
                        include: contractRelations.join(','),
                        with_document: true
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	!function() {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = function(chunkId) {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce(function(promises, key) {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return "sales.common." + "sales" + ".js";
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	!function() {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@kwixeo/sales-vue:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = function(url, done, key, chunkId) {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = function(prev, event) {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach(function(fn) { return fn(event); });
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			46: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = function(chunkId, promises) {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = function(event) {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_sales_vue"] = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_sales_vue"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AccountForm: function() { return /* reexport */ AccountForm/* default */.A; },
  AccountList: function() { return /* reexport */ AccountList/* default */.A; },
  AccountSelect: function() { return /* reexport */ AccountSelect/* default */.A; },
  AccountingClosingView: function() { return /* reexport */ AccountingClosingView["default"]; },
  AccountsView: function() { return /* reexport */ AccountsView["default"]; },
  AffairItem: function() { return /* reexport */ AffairItem_AffairItem; },
  AffairItemView: function() { return /* reexport */ views_AffairItemView; },
  AffairList: function() { return /* reexport */ AffairList_AffairList; },
  AffairListView: function() { return /* reexport */ AffairListView["default"]; },
  CancelGuaranteeHoldback: function() { return /* reexport */ CancelGuaranteeHoldback/* default */.A; },
  CancelInvoice: function() { return /* reexport */ CancelInvoice/* default */.A; },
  CancelPayment: function() { return /* reexport */ CancelPayment/* default */.A; },
  CarBrandForm: function() { return /* reexport */ CarBrandForm/* default */.A; },
  CarBrandList: function() { return /* reexport */ CarBrandList/* default */.A; },
  CarDelete: function() { return /* reexport */ CarDelete/* default */.A; },
  CarDocuments: function() { return /* reexport */ CarDocuments/* default */.A; },
  CarForm: function() { return /* reexport */ CarForm/* default */.A; },
  CarFormButton: function() { return /* reexport */ CarFormButton/* default */.A; },
  CarItem: function() { return /* reexport */ CarItem/* default */.A; },
  CarList: function() { return /* reexport */ CarList/* default */.A; },
  CarParams: function() { return /* reexport */ CarParams/* default */.A; },
  CarPdf: function() { return /* reexport */ CarPdf/* default */.A; },
  CarSelect: function() { return /* reexport */ CarSelect/* default */.A; },
  CarSpeedItem: function() { return /* reexport */ CarSpeedItem/* default */.A; },
  CheckDepositFormView: function() { return /* reexport */ CheckDepositFormView["default"]; },
  CheckDepositItemView: function() { return /* reexport */ CheckDepositItemView["default"]; },
  CheckDepositListView: function() { return /* reexport */ CheckDepositListView["default"]; },
  CheckDepositMixin: function() { return /* reexport */ CheckDepositMixin/* default */.A; },
  CommandList: function() { return /* reexport */ CommandList/* default */.A; },
  CommandListView: function() { return /* reexport */ CommandListView["default"]; },
  CommentLine: function() { return /* reexport */ CommentLine/* default */.A; },
  CommissionDocumentDelete: function() { return /* reexport */ CommissionDocumentDelete/* default */.A; },
  CommissionDocumentForm: function() { return /* reexport */ CommissionDocumentForm/* default */.A; },
  CommissionDocumentItem: function() { return /* reexport */ CommissionDocumentItem/* default */.A; },
  CommissionDocumentList: function() { return /* reexport */ CommissionDocumentList/* default */.A; },
  CommissionDocumentView: function() { return /* reexport */ CommissionDocumentView["default"]; },
  CommissionForm: function() { return /* reexport */ CommissionForm/* default */.A; },
  CommissionList: function() { return /* reexport */ CommissionList/* default */.A; },
  CommissionPaymentDelete: function() { return /* reexport */ CommissionPaymentDelete/* default */.A; },
  CommissionPaymentForm: function() { return /* reexport */ CommissionPaymentForm/* default */.A; },
  CommissionPaymentItem: function() { return /* reexport */ CommissionPaymentItem/* default */.A; },
  CommissionPaymentList: function() { return /* reexport */ CommissionPaymentList/* default */.A; },
  CommissionView: function() { return /* reexport */ CommissionView["default"]; },
  ConflictModal: function() { return /* reexport */ ConflictModal/* default */.A; },
  ContractDeadlineListView: function() { return /* reexport */ ContractDeadlineListView["default"]; },
  ContractDeadlines: function() { return /* reexport */ ContractDeadlines/* default */.A; },
  ContractDeadlinesBill: function() { return /* reexport */ ContractDeadlinesBill/* default */.A; },
  ContractDeadlinesCancel: function() { return /* reexport */ ContractDeadlinesCancel/* default */.A; },
  ContractDeadlinesList: function() { return /* reexport */ ContractDeadlinesList/* default */.A; },
  ContractDeadlinesRestore: function() { return /* reexport */ ContractDeadlinesRestore/* default */.A; },
  ContractDelete: function() { return /* reexport */ ContractDelete/* default */.A; },
  ContractDocuments: function() { return /* reexport */ ContractDocuments/* default */.A; },
  ContractDownload: function() { return /* reexport */ ContractDownload/* default */.A; },
  ContractForm: function() { return /* reexport */ ContractForm/* default */.A; },
  ContractFormMixin: function() { return /* reexport */ ContractFormMixin/* default */.A; },
  ContractFormView: function() { return /* reexport */ ContractFormView["default"]; },
  ContractItem: function() { return /* reexport */ ContractItem/* default */.A; },
  ContractItemView: function() { return /* reexport */ ContractItemView["default"]; },
  ContractList: function() { return /* reexport */ ContractList/* default */.A; },
  ContractListView: function() { return /* reexport */ ContractListView["default"]; },
  ContractMail: function() { return /* reexport */ ContractMail/* default */.A; },
  ContractMixin: function() { return /* reexport */ ContractMixin/* default */.A; },
  ContractModelDelete: function() { return /* reexport */ ContractModelDelete/* default */.A; },
  ContractModelDuplicate: function() { return /* reexport */ ContractModelDuplicate/* default */.A; },
  ContractModelForm: function() { return /* reexport */ ContractModelForm/* default */.A; },
  ContractModelFormView: function() { return /* reexport */ ContractModelFormView["default"]; },
  ContractModelList: function() { return /* reexport */ ContractModelList/* default */.A; },
  ContractModelsListView: function() { return /* reexport */ ContractModelsListView["default"]; },
  ContractNotifications: function() { return /* reexport */ ContractNotifications/* default */.A; },
  ContractParams: function() { return /* reexport */ ContractParams/* default */.A; },
  ContractPeriodDelete: function() { return /* reexport */ ContractPeriodDelete/* default */.A; },
  ContractPeriodForm: function() { return /* reexport */ ContractPeriodForm/* default */.A; },
  ContractPeriods: function() { return /* reexport */ ContractPeriods/* default */.A; },
  ContractStatus: function() { return /* reexport */ ContractStatus/* default */.A; },
  ContractStatusSelector: function() { return /* reexport */ ContractStatusSelector/* default */.A; },
  CreateProviderCommand: function() { return /* reexport */ CreateProviderCommand/* default */.A; },
  CreditList: function() { return /* reexport */ CreditList/* default */.A; },
  CreditListView: function() { return /* reexport */ CreditListView["default"]; },
  CreditsUses: function() { return /* reexport */ CreditsUses/* default */.A; },
  CustomerAddressSelect: function() { return /* reexport */ CustomerAddressSelect/* default */.A; },
  CustomerDatas: function() { return /* reexport */ CustomerDatas/* default */.A; },
  CustomerSepaForm: function() { return /* reexport */ CustomerSepaForm/* default */.A; },
  CustomerSepaList: function() { return /* reexport */ CustomerSepaList/* default */.A; },
  CustomerSepaListView: function() { return /* reexport */ CustomerSepaListView["default"]; },
  CustomerSepaParams: function() { return /* reexport */ CustomerSepaParams/* default */.A; },
  CustomerSepaParamsView: function() { return /* reexport */ CustomerSepaParamsView["default"]; },
  CustomerSepaSelect: function() { return /* reexport */ CustomerSepaSelect/* default */.A; },
  DeliveryList: function() { return /* reexport */ DeliveryList/* default */.A; },
  DeliveryListView: function() { return /* reexport */ DeliveryListView["default"]; },
  DepositInvoiceListView: function() { return /* reexport */ DepositInvoiceListView["default"]; },
  DocumentContent: function() { return /* reexport */ DocumentContent/* default */.A; },
  DocumentContents: function() { return /* reexport */ DocumentContents/* default */.A; },
  DocumentDatas: function() { return /* reexport */ DocumentDatas/* default */.A; },
  DocumentDelete: function() { return /* reexport */ DocumentDelete/* default */.A; },
  DocumentDelivery: function() { return /* reexport */ DocumentDelivery/* default */.A; },
  DocumentForm: function() { return /* reexport */ DocumentForm/* default */.A; },
  DocumentFormView: function() { return /* reexport */ DocumentFormView["default"]; },
  DocumentItem: function() { return /* reexport */ DocumentItem/* default */.A; },
  DocumentItemView: function() { return /* reexport */ DocumentItemView["default"]; },
  DocumentSpeedEdit: function() { return /* reexport */ DocumentSpeedEdit/* default */.A; },
  DocumentStatus: function() { return /* reexport */ DocumentStatus/* default */.A; },
  DocumentStatusSelector: function() { return /* reexport */ DocumentStatusSelector/* default */.A; },
  DownloadPdfExportView: function() { return /* reexport */ DownloadPdfExportView["default"]; },
  FecDownload: function() { return /* reexport */ FecDownload/* default */.A; },
  FecDownloadView: function() { return /* reexport */ FecDownloadView["default"]; },
  FecExport: function() { return /* reexport */ FecExport/* default */.A; },
  FecExportList: function() { return /* reexport */ FecExportList/* default */.A; },
  FecFileView: function() { return /* reexport */ FecFileView["default"]; },
  FecMixin: function() { return /* reexport */ FecMixin/* default */.A; },
  FecParams: function() { return /* reexport */ FecParams/* default */.A; },
  FormSidebar: function() { return /* reexport */ FormSidebar/* default */.A; },
  GrantForm: function() { return /* reexport */ GrantForm/* default */.A; },
  GrantList: function() { return /* reexport */ GrantList/* default */.A; },
  GrantSelect: function() { return /* reexport */ GrantSelect/* default */.A; },
  GrantsListView: function() { return /* reexport */ GrantsListView["default"]; },
  GuaranteeHoldbackList: function() { return /* reexport */ GuaranteeHoldbackList/* default */.A; },
  GuaranteeHoldbackView: function() { return /* reexport */ GuaranteeHoldbackView["default"]; },
  InputOptions: function() { return /* reexport */ InputOptions/* default */.A; },
  InvoiceList: function() { return /* reexport */ InvoiceList/* default */.A; },
  InvoiceListView: function() { return /* reexport */ InvoiceListView["default"]; },
  InvoiceMultipleDocuments: function() { return /* reexport */ InvoiceMultipleDocuments_InvoiceMultipleDocuments; },
  InvoiceToPaidView: function() { return /* reexport */ InvoiceToPaidView["default"]; },
  KwixeoSales: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ lang/* default */.A; },
  LoadDocumentMixin: function() { return /* reexport */ LoadDocumentMixin/* default */.A; },
  PageBreakLine: function() { return /* reexport */ PageBreakLine/* default */.A; },
  Parameters: function() { return /* reexport */ Parameters/* default */.A; },
  PaymentForm: function() { return /* reexport */ PaymentForm/* default */.A; },
  PaymentFormButton: function() { return /* reexport */ PaymentFormButton/* default */.A; },
  PaymentItem: function() { return /* reexport */ PaymentItem/* default */.A; },
  PaymentList: function() { return /* reexport */ PaymentList/* default */.A; },
  PaymentListView: function() { return /* reexport */ PaymentListView["default"]; },
  PaymentSuccessfulView: function() { return /* reexport */ PaymentSuccessfulView["default"]; },
  PaymentVatRates: function() { return /* reexport */ PaymentVatRates/* default */.A; },
  PaymentVatRatesView: function() { return /* reexport */ PaymentVatRatesView["default"]; },
  PdfModelArea: function() { return /* reexport */ PdfModelArea/* default */.A; },
  PdfModelBlock: function() { return /* reexport */ PdfModelBlock/* default */.A; },
  PdfModelBlockPreview: function() { return /* reexport */ PdfModelBlockPreview/* default */.A; },
  PdfModelDelete: function() { return /* reexport */ PdfModelDelete/* default */.A; },
  PdfModelForm: function() { return /* reexport */ PdfModelForm/* default */.A; },
  PdfModelFormView: function() { return /* reexport */ PdfModelFormView["default"]; },
  PdfModelList: function() { return /* reexport */ PdfModelList/* default */.A; },
  PdfModelListView: function() { return /* reexport */ PdfModelListView["default"]; },
  PdfModelMixin: function() { return /* reexport */ PdfModelMixin/* default */.A; },
  PdfModelNew: function() { return /* reexport */ PdfModelNew/* default */.A; },
  PdfModelSelect: function() { return /* reexport */ PdfModelSelect/* default */.A; },
  PdfOptions: function() { return /* reexport */ PdfOptions/* default */.A; },
  PdfViewer: function() { return /* reexport */ PdfViewer/* default */.A; },
  ProformaList: function() { return /* reexport */ ProformaList/* default */.A; },
  ProformaListView: function() { return /* reexport */ ProformaListView["default"]; },
  PublicSignatureView: function() { return /* reexport */ PublicSignatureView["default"]; },
  QuotationList: function() { return /* reexport */ QuotationList/* default */.A; },
  QuotationListView: function() { return /* reexport */ QuotationListView["default"]; },
  RecoveryInvoiceParamsView: function() { return /* reexport */ RecoveryInvoiceParamsView["default"]; },
  RecoveryInvoiceStepForm: function() { return /* reexport */ RecoveryInvoiceStepForm/* default */.A; },
  RecoveryInvoiceStepList: function() { return /* reexport */ RecoveryInvoiceStepList/* default */.A; },
  RecoveryInvoiceStepParams: function() { return /* reexport */ RecoveryInvoiceStepParams/* default */.A; },
  RecoveryInvoiceView: function() { return /* reexport */ RecoveryInvoiceView/* default */.A; },
  RecoveryInvoicesView: function() { return /* reexport */ RecoveryInvoicesView/* default */.A; },
  RecoveryInvoicesViewView: function() { return /* reexport */ views_RecoveryInvoicesView["default"]; },
  SaleDefaultParams: function() { return /* reexport */ SaleDefaultParams/* default */.A; },
  SaleExports: function() { return /* reexport */ SaleExports/* default */.A; },
  SaleExportsDownload: function() { return /* reexport */ SaleExportsDownload/* default */.A; },
  SaleInputOptions: function() { return /* reexport */ SaleInputOptions/* default */.A; },
  SaleLine: function() { return /* reexport */ SaleLine/* default */.A; },
  SaleParamsView: function() { return /* reexport */ SaleParamsView["default"]; },
  SalePdfOptions: function() { return /* reexport */ SalePdfOptions/* default */.A; },
  SaleReferences: function() { return /* reexport */ SaleReferences/* default */.A; },
  SaleTerms: function() { return /* reexport */ SaleTerms/* default */.A; },
  SaleTermsSelect: function() { return /* reexport */ SaleTermsSelect/* default */.A; },
  SaleTermsView: function() { return /* reexport */ SaleTermsView["default"]; },
  SalesDocumentLineMixin: function() { return /* reexport */ SalesDocumentLineMixin/* default */.A; },
  SalesDocumentStatus: function() { return /* reexport */ SalesDocumentStatus/* default */.A; },
  SalesDocumentStatusMixin: function() { return /* reexport */ SalesDocumentStatusMixin/* default */.A; },
  SalesInputOptionsMixin: function() { return /* reexport */ SalesInputOptionsMixin/* default */.A; },
  SalesLineMixin: function() { return /* reexport */ SalesLineMixin/* default */.A; },
  SalesListMixin: function() { return /* reexport */ SalesListMixin/* default */.A; },
  SalesPdfOptionsMixin: function() { return /* reexport */ SalesPdfOptionsMixin/* default */.A; },
  SalesStore: function() { return /* reexport */ modules_SalesStore; },
  SalesVatRatesView: function() { return /* reexport */ SalesVatRatesView["default"]; },
  SepaDepositDelete: function() { return /* reexport */ SepaDepositDelete/* default */.A; },
  SepaDepositDownload: function() { return /* reexport */ SepaDepositDownload/* default */.A; },
  SepaDepositForm: function() { return /* reexport */ SepaDepositForm/* default */.A; },
  SepaDepositFormView: function() { return /* reexport */ SepaDepositFormView["default"]; },
  SepaDepositItem: function() { return /* reexport */ SepaDepositItem/* default */.A; },
  SepaDepositItemView: function() { return /* reexport */ SepaDepositItemView["default"]; },
  SepaDepositList: function() { return /* reexport */ SepaDepositList/* default */.A; },
  SepaDepositListView: function() { return /* reexport */ SepaDepositListView["default"]; },
  SepaDepositMixin: function() { return /* reexport */ SepaDepositMixin/* default */.A; },
  SepaDepositValidation: function() { return /* reexport */ SepaDepositValidation/* default */.A; },
  SignCancel: function() { return /* reexport */ SignCancel/* default */.A; },
  SignConfig: function() { return /* reexport */ SignConfig/* default */.A; },
  SignConfigView: function() { return /* reexport */ SignConfigView["default"]; },
  SignDelete: function() { return /* reexport */ SignDelete/* default */.A; },
  SignItem: function() { return /* reexport */ SignItem/* default */.A; },
  SignList: function() { return /* reexport */ SignList/* default */.A; },
  SignPdfModel: function() { return /* reexport */ SignPdfModel/* default */.A; },
  SignSend: function() { return /* reexport */ SignSend/* default */.A; },
  SignState: function() { return /* reexport */ SignState/* default */.A; },
  StripeConfig: function() { return /* reexport */ StripeConfig/* default */.A; },
  StripeConfigView: function() { return /* reexport */ StripeConfigView["default"]; },
  StripeMixin: function() { return /* reexport */ StripeMixin/* default */.A; },
  StripePayment: function() { return /* reexport */ StripePayment/* default */.A; },
  StripePaymentSuccessful: function() { return /* reexport */ StripePaymentSuccessful/* default */.A; },
  StripePaymentView: function() { return /* reexport */ StripePaymentView["default"]; },
  StripeSend: function() { return /* reexport */ StripeSend/* default */.A; },
  SubTotalLine: function() { return /* reexport */ SubTotalLine/* default */.A; },
  TransformToCommand: function() { return /* reexport */ TransformToCommand/* default */.A; },
  TransformToDepositInvoice: function() { return /* reexport */ TransformToDepositInvoice/* default */.A; },
  TransformToInvoice: function() { return /* reexport */ TransformToInvoice/* default */.A; },
  TransformToProforma: function() { return /* reexport */ TransformToProforma/* default */.A; },
  TransformToQuotation: function() { return /* reexport */ TransformToQuotation/* default */.A; },
  UseCredit: function() { return /* reexport */ UseCredit/* default */.A; },
  UsedCredits: function() { return /* reexport */ UsedCredits/* default */.A; },
  VariablesMixin: function() { return /* reexport */ VariablesMixin/* default */.A; },
  checkDepositRelations: function() { return /* reexport */ checkDeposit/* checkDepositRelations */.IH; },
  commissionPaymentRelations: function() { return /* reexport */ checkCommissionPayment/* commissionPaymentRelations */.DG; },
  configMenu: function() { return /* reexport */ menu_configMenu; },
  configRoutes: function() { return /* reexport */ config; },
  contractModelRelations: function() { return /* reexport */ contractModel/* contractModelRelations */.$$; },
  contractRelations: function() { return /* reexport */ contract/* contractRelations */.uo; },
  customerSepaRelations: function() { return /* reexport */ customerSepa/* customerSepaRelations */.fG; },
  documentRelations: function() { return /* reexport */ fetchDatas_document/* documentRelations */.DL; },
  fetchCheckDeposit: function() { return /* reexport */ checkDeposit/* fetchCheckDeposit */.tc; },
  fetchCommissionPayment: function() { return /* reexport */ checkCommissionPayment/* fetchCommissionPayment */.Os; },
  fetchContract: function() { return /* reexport */ contract/* fetchContract */.RA; },
  fetchContractModel: function() { return /* reexport */ contractModel/* fetchContractModel */.qz; },
  fetchCustomerSepa: function() { return /* reexport */ customerSepa/* fetchCustomerSepa */.Mx; },
  fetchDocument: function() { return /* reexport */ fetchDatas_document/* fetchDocument */.sW; },
  fetchPdfModel: function() { return /* reexport */ pdfModel/* fetchPdfModel */.gp; },
  fetchSepaDeposit: function() { return /* reexport */ sepaDeposit/* fetchSepaDeposit */.qP; },
  fetchSignature: function() { return /* reexport */ signature/* fetchSignature */.FH; },
  menu: function() { return /* reexport */ main; },
  needFetchCheckDeposit: function() { return /* reexport */ checkDeposit/* needFetchCheckDeposit */.XP; },
  needFetchCommissionPayment: function() { return /* reexport */ checkCommissionPayment/* needFetchCommissionPayment */.SO; },
  needFetchContract: function() { return /* reexport */ contract/* needFetchContract */.Pr; },
  needFetchContractModel: function() { return /* reexport */ contractModel/* needFetchContractModel */.gC; },
  needFetchCustomerSepa: function() { return /* reexport */ customerSepa/* needFetchCustomerSepa */.yW; },
  needFetchDocument: function() { return /* reexport */ fetchDatas_document/* needFetchDocument */.yt; },
  needFetchPdfModel: function() { return /* reexport */ pdfModel/* needFetchPdfModel */.uM; },
  needFetchSepaDeposit: function() { return /* reexport */ sepaDeposit/* needFetchSepaDeposit */.gK; },
  needFetchSignature: function() { return /* reexport */ signature/* needFetchSignature */.b6; },
  pdfModelRelations: function() { return /* reexport */ pdfModel/* pdfModelRelations */.NV; },
  routes: function() { return /* reexport */ router_routes; },
  sepaDepositRelations: function() { return /* reexport */ sepaDeposit/* sepaDepositRelations */.XF; },
  signatureRelations: function() { return /* reexport */ signature/* signatureRelations */.UI; },
  validationRules: function() { return /* reexport */ src_validate; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) // removed by dead control flow
{ var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/components/AccountForm/AccountForm.vue + 3 modules
var AccountForm = __webpack_require__(82183);
// EXTERNAL MODULE: ./src/components/AccountList/AccountList.vue + 3 modules
var AccountList = __webpack_require__(63384);
// EXTERNAL MODULE: ./src/components/AccountSelect/AccountSelect.vue + 3 modules
var AccountSelect = __webpack_require__(5182);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AffairItem/AffairItem.vue?vue&type=template&id=552a0e02
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(31635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AffairItem/AffairItem.ts?vue&type=script&lang=ts&external


var AffairItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AffairItem, _super);
    function AffairItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AffairItem = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], AffairItem);
    return AffairItem;
}(lib/* Vue */.lD));
/* harmony default export */ var AffairItemvue_type_script_lang_ts_external = (AffairItem);

;// ./src/components/AffairItem/AffairItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AffairItem_AffairItemvue_type_script_lang_ts_external = (AffairItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(81656);
;// ./src/components/AffairItem/AffairItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AffairItem_AffairItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AffairItem_AffairItem = (component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AffairList/AffairList.vue?vue&type=template&id=db845618
var AffairListvue_type_template_id_db845618_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div')
}
var AffairListvue_type_template_id_db845618_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AffairList/AffairList.ts?vue&type=script&lang=ts&external


var AffairList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AffairList, _super);
    function AffairList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AffairList = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], AffairList);
    return AffairList;
}(lib/* Vue */.lD));
/* harmony default export */ var AffairListvue_type_script_lang_ts_external = (AffairList);

;// ./src/components/AffairList/AffairList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AffairList_AffairListvue_type_script_lang_ts_external = (AffairListvue_type_script_lang_ts_external); 
;// ./src/components/AffairList/AffairList.vue





/* normalize component */
;
var AffairList_component = (0,componentNormalizer/* default */.A)(
  AffairList_AffairListvue_type_script_lang_ts_external,
  AffairListvue_type_template_id_db845618_render,
  AffairListvue_type_template_id_db845618_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AffairList_AffairList = (AffairList_component.exports);
// EXTERNAL MODULE: ./src/components/CancelGuaranteeHoldback/CancelGuaranteeHoldback.vue + 3 modules
var CancelGuaranteeHoldback = __webpack_require__(81593);
// EXTERNAL MODULE: ./src/components/CancelInvoice/CancelInvoice.vue + 3 modules
var CancelInvoice = __webpack_require__(57114);
// EXTERNAL MODULE: ./src/components/CancelPayment/CancelPayment.vue + 3 modules
var CancelPayment = __webpack_require__(30404);
// EXTERNAL MODULE: ./src/components/CarBrandForm/CarBrandForm.vue + 3 modules
var CarBrandForm = __webpack_require__(76733);
// EXTERNAL MODULE: ./src/components/CarBrandList/CarBrandList.vue + 3 modules
var CarBrandList = __webpack_require__(46353);
// EXTERNAL MODULE: ./src/components/CarDelete/CarDelete.vue + 3 modules
var CarDelete = __webpack_require__(71183);
// EXTERNAL MODULE: ./src/components/CarDocuments/CarDocuments.vue + 3 modules
var CarDocuments = __webpack_require__(36898);
// EXTERNAL MODULE: ./src/components/CarForm/CarForm.vue + 3 modules
var CarForm = __webpack_require__(8998);
// EXTERNAL MODULE: ./src/components/CarFormButton/CarFormButton.vue + 3 modules
var CarFormButton = __webpack_require__(40930);
// EXTERNAL MODULE: ./src/components/CarItem/CarItem.vue + 3 modules
var CarItem = __webpack_require__(96994);
// EXTERNAL MODULE: ./src/components/CarList/CarList.vue + 3 modules
var CarList = __webpack_require__(24697);
// EXTERNAL MODULE: ./src/components/CarParams/CarParams.vue + 3 modules
var CarParams = __webpack_require__(54765);
// EXTERNAL MODULE: ./src/components/CarPdf/CarPdf.vue + 3 modules
var CarPdf = __webpack_require__(3478);
// EXTERNAL MODULE: ./src/components/CarSelect/CarSelect.vue + 3 modules
var CarSelect = __webpack_require__(5569);
// EXTERNAL MODULE: ./src/components/CarSpeedItem/CarSpeedItem.vue + 3 modules
var CarSpeedItem = __webpack_require__(43243);
// EXTERNAL MODULE: ./src/components/CommandList/CommandList.vue + 2 modules
var CommandList = __webpack_require__(53991);
// EXTERNAL MODULE: ./src/components/CommissionDocumentDelete/CommissionDocumentDelete.vue + 3 modules
var CommissionDocumentDelete = __webpack_require__(50643);
// EXTERNAL MODULE: ./src/components/CommissionDocumentForm/CommissionDocumentForm.vue + 3 modules
var CommissionDocumentForm = __webpack_require__(92746);
// EXTERNAL MODULE: ./src/components/CommissionDocumentItem/CommissionDocumentItem.vue + 3 modules
var CommissionDocumentItem = __webpack_require__(17369);
// EXTERNAL MODULE: ./src/components/CommissionDocumentList/CommissionDocumentList.vue + 3 modules
var CommissionDocumentList = __webpack_require__(70032);
// EXTERNAL MODULE: ./src/components/CommissionForm/CommissionForm.vue + 3 modules
var CommissionForm = __webpack_require__(83793);
// EXTERNAL MODULE: ./src/components/CommissionList/CommissionList.vue + 3 modules
var CommissionList = __webpack_require__(72706);
// EXTERNAL MODULE: ./src/components/CommissionPaymentDelete/CommissionPaymentDelete.vue + 3 modules
var CommissionPaymentDelete = __webpack_require__(17870);
// EXTERNAL MODULE: ./src/components/CommissionPaymentForm/CommissionPaymentForm.vue + 3 modules
var CommissionPaymentForm = __webpack_require__(75579);
// EXTERNAL MODULE: ./src/components/CommissionPaymentItem/CommissionPaymentItem.vue + 3 modules
var CommissionPaymentItem = __webpack_require__(79146);
// EXTERNAL MODULE: ./src/components/CommissionPaymentList/CommissionPaymentList.vue + 3 modules
var CommissionPaymentList = __webpack_require__(32504);
// EXTERNAL MODULE: ./src/components/ContractDeadlines/ContractDeadlines.vue + 3 modules
var ContractDeadlines = __webpack_require__(15374);
// EXTERNAL MODULE: ./src/components/ContractDeadlinesBill/ContractDeadlinesBill.vue + 3 modules
var ContractDeadlinesBill = __webpack_require__(77836);
// EXTERNAL MODULE: ./src/components/ContractDeadlinesCancel/ContractDeadlinesCancel.vue + 3 modules
var ContractDeadlinesCancel = __webpack_require__(60134);
// EXTERNAL MODULE: ./src/components/ContractDeadlinesList/ContractDeadlinesList.vue + 3 modules
var ContractDeadlinesList = __webpack_require__(60516);
// EXTERNAL MODULE: ./src/components/ContractDeadlinesRestore/ContractDeadlinesRestore.vue + 3 modules
var ContractDeadlinesRestore = __webpack_require__(4549);
// EXTERNAL MODULE: ./src/components/ContractDelete/ContractDelete.vue + 3 modules
var ContractDelete = __webpack_require__(57553);
// EXTERNAL MODULE: ./src/components/ContractDocuments/ContractDocuments.vue + 3 modules
var ContractDocuments = __webpack_require__(81038);
// EXTERNAL MODULE: ./src/components/ContractDownload/ContractDownload.vue + 3 modules
var ContractDownload = __webpack_require__(16951);
// EXTERNAL MODULE: ./src/components/ContractForm/ContractForm.vue + 3 modules
var ContractForm = __webpack_require__(8081);
// EXTERNAL MODULE: ./src/components/ContractItem/ContractItem.vue + 3 modules
var ContractItem = __webpack_require__(53471);
// EXTERNAL MODULE: ./src/components/ContractList/ContractList.vue + 3 modules
var ContractList = __webpack_require__(66969);
// EXTERNAL MODULE: ./src/components/ContractMail/ContractMail.vue + 8 modules
var ContractMail = __webpack_require__(13250);
// EXTERNAL MODULE: ./src/components/ContractModelDelete/ContractModelDelete.vue + 3 modules
var ContractModelDelete = __webpack_require__(11873);
// EXTERNAL MODULE: ./src/components/ContractModelDuplicate/ContractModelDuplicate.vue + 3 modules
var ContractModelDuplicate = __webpack_require__(36505);
// EXTERNAL MODULE: ./src/components/ContractModelForm/ContractModelForm.vue + 3 modules
var ContractModelForm = __webpack_require__(80200);
// EXTERNAL MODULE: ./src/components/ContractModelList/ContractModelList.vue + 3 modules
var ContractModelList = __webpack_require__(2151);
// EXTERNAL MODULE: ./src/components/ContractNotifications/ContractNotifications.vue + 3 modules
var ContractNotifications = __webpack_require__(32818);
// EXTERNAL MODULE: ./src/components/ContractParams/ContractParams.vue + 3 modules
var ContractParams = __webpack_require__(10586);
// EXTERNAL MODULE: ./src/components/ContractPeriodDelete/ContractPeriodDelete.vue + 3 modules
var ContractPeriodDelete = __webpack_require__(17819);
// EXTERNAL MODULE: ./src/components/ContractPeriodForm/ContractPeriodForm.vue + 3 modules
var ContractPeriodForm = __webpack_require__(70128);
// EXTERNAL MODULE: ./src/components/ContractPeriods/ContractPeriods.vue + 3 modules
var ContractPeriods = __webpack_require__(62288);
// EXTERNAL MODULE: ./src/components/ContractStatus/ContractStatus.vue + 3 modules
var ContractStatus = __webpack_require__(30469);
// EXTERNAL MODULE: ./src/components/ContractStatusSelector/ContractStatusSelector.vue + 3 modules
var ContractStatusSelector = __webpack_require__(90613);
// EXTERNAL MODULE: ./src/components/CreateProviderCommand/CreateProviderCommand.vue + 3 modules
var CreateProviderCommand = __webpack_require__(61954);
// EXTERNAL MODULE: ./src/components/CreditList/CreditList.vue + 2 modules
var CreditList = __webpack_require__(17212);
// EXTERNAL MODULE: ./src/components/CreditsUses/CreditsUses.vue + 4 modules
var CreditsUses = __webpack_require__(26199);
// EXTERNAL MODULE: ./src/components/CustomerAddressSelect/CustomerAddressSelect.vue + 3 modules
var CustomerAddressSelect = __webpack_require__(29407);
// EXTERNAL MODULE: ./src/components/CustomerSepaForm/CustomerSepaForm.vue + 3 modules
var CustomerSepaForm = __webpack_require__(26378);
// EXTERNAL MODULE: ./src/components/CustomerSepaList/CustomerSepaList.vue + 11 modules
var CustomerSepaList = __webpack_require__(56246);
// EXTERNAL MODULE: ./src/components/CustomerSepaParams/CustomerSepaParams.vue + 3 modules
var CustomerSepaParams = __webpack_require__(60843);
// EXTERNAL MODULE: ./src/components/CustomerSepaSelect/CustomerSepaSelect.vue + 3 modules
var CustomerSepaSelect = __webpack_require__(53103);
// EXTERNAL MODULE: ./src/components/DeliveryList/DeliveryList.vue + 2 modules
var DeliveryList = __webpack_require__(56471);
// EXTERNAL MODULE: ./src/components/DocumentContent/DocumentContent.vue + 3 modules
var DocumentContent = __webpack_require__(94425);
// EXTERNAL MODULE: ./src/components/DocumentDelete/DocumentDelete.vue + 3 modules
var DocumentDelete = __webpack_require__(30104);
// EXTERNAL MODULE: ./src/components/DocumentDelivery/DocumentDelivery.vue + 3 modules
var DocumentDelivery = __webpack_require__(38310);
// EXTERNAL MODULE: ./src/components/DocumentForm/DocumentForm.vue + 27 modules
var DocumentForm = __webpack_require__(72740);
// EXTERNAL MODULE: ./src/components/DocumentItem/DocumentItem.vue + 41 modules
var DocumentItem = __webpack_require__(55316);
// EXTERNAL MODULE: ./src/components/DocumentSpeedEdit/DocumentSpeedEdit.vue + 3 modules
var DocumentSpeedEdit = __webpack_require__(61061);
// EXTERNAL MODULE: ./src/components/DocumentStatus/DocumentStatus.vue + 3 modules
var DocumentStatus = __webpack_require__(22090);
// EXTERNAL MODULE: ./src/components/DocumentStatusSelector/DocumentStatusSelector.vue + 3 modules
var DocumentStatusSelector = __webpack_require__(76873);
// EXTERNAL MODULE: ./src/components/FecDownload/FecDownload.vue + 3 modules
var FecDownload = __webpack_require__(36440);
// EXTERNAL MODULE: ./src/components/FecExport/FecExport.vue + 3 modules
var FecExport = __webpack_require__(10989);
// EXTERNAL MODULE: ./src/components/FecExportList/FecExportList.vue + 3 modules
var FecExportList = __webpack_require__(76982);
// EXTERNAL MODULE: ./src/components/FecParams/FecParams.vue + 3 modules
var FecParams = __webpack_require__(65004);
// EXTERNAL MODULE: ./src/components/Form/CommentLine/CommentLine.vue + 3 modules
var CommentLine = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/components/Form/ConflictModal/ConflictModal.vue + 3 modules
var ConflictModal = __webpack_require__(66597);
// EXTERNAL MODULE: ./src/components/Form/CustomerDatas/CustomerDatas.vue + 3 modules
var CustomerDatas = __webpack_require__(32475);
// EXTERNAL MODULE: ./src/components/Form/DocumentContents/DocumentContents.vue + 4 modules
var DocumentContents = __webpack_require__(53254);
// EXTERNAL MODULE: ./src/components/Form/DocumentDatas/DocumentDatas.vue + 3 modules
var DocumentDatas = __webpack_require__(11466);
// EXTERNAL MODULE: ./src/components/Form/FormSidebar/FormSidebar.vue + 3 modules
var FormSidebar = __webpack_require__(61860);
// EXTERNAL MODULE: ./src/components/Form/InputOptions/InputOptions.vue + 3 modules
var InputOptions = __webpack_require__(19422);
// EXTERNAL MODULE: ./src/components/Form/PageBreakLine/PageBreakLine.vue + 3 modules
var PageBreakLine = __webpack_require__(8477);
// EXTERNAL MODULE: ./src/components/Form/Parameters/Parameters.vue + 3 modules
var Parameters = __webpack_require__(583);
// EXTERNAL MODULE: ./src/components/Form/PdfOptions/PdfOptions.vue + 3 modules
var PdfOptions = __webpack_require__(32159);
// EXTERNAL MODULE: ./src/components/Form/SaleLine/SaleLine.vue + 3 modules
var SaleLine = __webpack_require__(7143);
// EXTERNAL MODULE: ./src/components/Form/SubTotalLine/SubTotalLine.vue + 3 modules
var SubTotalLine = __webpack_require__(97302);
// EXTERNAL MODULE: ./src/components/GrantForm/GrantForm.vue + 3 modules
var GrantForm = __webpack_require__(6762);
// EXTERNAL MODULE: ./src/components/GrantList/GrantList.vue + 3 modules
var GrantList = __webpack_require__(65759);
// EXTERNAL MODULE: ./src/components/GrantSelect/GrantSelect.vue + 3 modules
var GrantSelect = __webpack_require__(59755);
// EXTERNAL MODULE: ./src/components/GuaranteeHoldbackList/GuaranteeHoldbackList.vue + 3 modules
var GuaranteeHoldbackList = __webpack_require__(73599);
// EXTERNAL MODULE: ./src/components/InvoiceList/InvoiceList.vue + 2 modules
var InvoiceList = __webpack_require__(39690);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InvoiceMultipleDocuments/InvoiceMultipleDocuments.vue?vue&type=template&id=55b829ba
var InvoiceMultipleDocumentsvue_type_template_id_55b829ba_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('FormModal',{attrs:{"title":"Facturation de plusieurs documents","ok-only":_vm.errorMsg !== null || _vm.processingMultiple,"ok-title":_vm.errorMsg || _vm.processingMultiple ? _vm.$t('interface.close') : 'Facturer les documents',"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading && !_vm.processingMultiple,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"size":_vm.errorMsg ? 'md' : 'xl',"closeOnSubmit":false},on:{"hidden":_vm.modalHide},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.errorMsg)?_c('b-alert',{staticClass:"mb-0",attrs:{"show":"","variant":"danger"}},[_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v("Erreur")]),_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):(_vm.processingMultiple)?_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Client")]),_c('th',[_vm._v("Nombre de document(s)")]),(_vm.type !== 'delivery')?_c('th',{staticClass:"text-center"},[_vm._v("Total TTC")]):_vm._e(),_c('th',{staticClass:"text-center"},[_vm._v("Création")]),(_vm.sendInvoice)?_c('th',{staticClass:"text-center"},[_vm._v(" Envoi ")]):_vm._e(),_c('th',{staticStyle:{"width":"45px"}})])]),_c('tbody',_vm._l((_vm.jobsUniqId),function(job){return _c('tr',{key:job.data.customer_id},[_c('td',[_vm._v(_vm._s(job.data.customer?.name))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(job.data.count)))]),(_vm.type !== 'delivery')?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(job.data.to_bill)))]):_vm._e(),_c('td',{staticClass:"text-center"},[(job.status && job.error)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":job.error}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']}})],1):(job.status && job.error === null)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0",attrs:{"variant":"icon","target":"_blank","title":"La facture a été générée"}},[_c('font-awesome-icon',{staticClass:"text-success",attrs:{"icon":['fas', 'check']}})],1):_c('Spinner',{staticClass:"p-0",attrs:{"size":"1rem"}})],1),(_vm.sendInvoice)?_c('td',{staticClass:"text-center"},[(job.send_status && job.send_error)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":job.send_error}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']}})],1):(job.send_status && job.send_error === null)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":"La facture a bien été envoyée"}},[_c('font-awesome-icon',{staticClass:"text-success",attrs:{"icon":['fas', 'check']}})],1):(job.error === null)?_c('Spinner',{staticClass:"p-0",attrs:{"size":"1rem"}}):_vm._e()],1):_vm._e(),_c('td',{staticClass:"px-0 text-center"},[(job.status && job.error === null)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0",attrs:{"to":{ name: 'invoice-item', params: { id: job.invoice_id }},"variant":"icon","target":"_blank","title":"Voir la facture"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'search']}})],1):_vm._e()],1)])}),0)]):(_vm.loading)?_c('Spinner'):[_c('b-form-radio-group',{staticClass:"mb-4",model:{value:(_vm.multipleBill),callback:function ($$v) {_vm.multipleBill=$$v},expression:"multipleBill"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" Facturer un seul client ")]),_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" Facturer plusieurs clients ")])],1),(_vm.multipleBill)?[_c('k-form',{attrs:{"action":'/sales/' + _vm.type + '/bill-multiple-search',"method":"post","keepLoaderAfterSubmit":true},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{staticStyle:{"max-width":"200px"},attrs:{"label":"Date des factures :"}},[_c('k-form-datepicker',{attrs:{"name":"date","required":"","min-date":_vm.minDate,"max-date":!_vm.teamConfigs.sales_disable_date_check ? _vm.today : null},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}})],1),_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.isDraft ?? false}}),_c('k-form-checkbox',{staticClass:"mb-2",attrs:{"validationName":"is_draft"},model:{value:(_vm.isDraft),callback:function ($$v) {_vm.isDraft=$$v},expression:"isDraft"}},[_vm._v(" Créer les factures en brouillon ")]),(!_vm.isDraft)?_c('b-alert',{staticClass:"py-1 px-2 font-weight-bold",attrs:{"show":"","variant":"danger"}},[_vm._v(" Attention : les factures ne pourront pas être modifiées ou supprimées ")]):_vm._e(),_c('input',{attrs:{"type":"hidden","name":"add_documents_infos"},domProps:{"value":_vm.addDocumentsInfos ?? false}}),_c('k-form-checkbox',{staticClass:"mb-2",attrs:{"validationName":"add_documents_infos"},model:{value:(_vm.addDocumentsInfos),callback:function ($$v) {_vm.addDocumentsInfos=$$v},expression:"addDocumentsInfos"}},[_vm._v(" Ajouter une ligne avec la référence des documents avant le contenu du document ")]),_c('input',{attrs:{"type":"hidden","name":"send_invoice"},domProps:{"value":_vm.sendInvoice ?? false}}),_c('k-form-checkbox',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.isDraft ? 'Vous ne pouvez pas envoyer les factures créées en brouillon' : null }),expression:"{ title: isDraft ? 'Vous ne pouvez pas envoyer les factures créées en brouillon' : null }"}],staticClass:"d-inline-block",attrs:{"validationName":"send_invoice","disabled":_vm.isDraft},model:{value:(_vm.sendInvoice),callback:function ($$v) {_vm.sendInvoice=$$v},expression:"sendInvoice"}},[_vm._v(" Envoyer la facture par email après sa création ")]),(_vm.sendInvoice && !_vm.isDraft)?_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"Modèle d'email :","label-cols":"auto","label-size":"sm"}},[_c('k-form-select',{staticStyle:{"max-width":"300px"},attrs:{"name":"mail_model","options":_vm.models,"reduce":opt => opt.id,"required":"","size":"sm","label":"name","clearable":false},model:{value:(_vm.mailModel),callback:function ($$v) {_vm.mailModel=$$v},expression:"mailModel"}})],1):_vm._e(),_c('h3',{staticClass:"form-title-alt mb-1 mt-4 border-0"},[_vm._v(" Sélectionner les clients à facturer : ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Client")]),_c('th',[_vm._v("Nombre de document(s)")]),_c('th',{staticClass:"text-center"},[_vm._v("Total HT")]),_c('th',{staticClass:"text-center"},[_vm._v("Total TTC")]),(_vm.type !== 'delivery')?_c('th',{staticClass:"text-center"},[_vm._v("Reste à facturer")]):_vm._e(),_c('th',{staticClass:"text-center",staticStyle:{"width":"30px"}},[(_vm.documents.length > 0)?_c('k-form-checkbox',{staticClass:"mr-0",attrs:{"noLabel":"","indeterminate":_vm.selectedDocuments.length > 0 && _vm.selectedDocuments.length < _vm.documents.length,"checked":_vm.selectedDocuments.length === _vm.documents.length},on:{"input":_vm.selectAllCustomers}}):_vm._e()],1)])]),_c('tbody',[(_vm.documentLoading)?_c('tr',[_c('td',{attrs:{"colspan":_vm.type !== 'delivery' ? 6 : 5}},[_c('Spinner')],1)]):[(_vm.documents.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":_vm.type !== 'delivery' ? 6 : 5}},[_vm._v(" Aucun client à facturer ")])]):_vm._e(),_vm._l((_vm.documents),function(document){return _c('tr',{key:document.id},[_c('td',[_vm._v(_vm._s(document.customer?.name))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(document.count)))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(document.total_ht)))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(document.total_ttc)))]),(_vm.type !== 'delivery')?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(document.to_bill)))]):_vm._e(),_c('td',{staticClass:"text-center"},[_c('k-form-checkbox',{staticClass:"mr-0",attrs:{"value":document.customer_id,"noLabel":"","name":"customers[]"},model:{value:(_vm.selectedDocuments),callback:function ($$v) {_vm.selectedDocuments=$$v},expression:"selectedDocuments"}})],1)])})]],2)])],1)]:[(!_vm.customer)?_c('CustomerSelect',{attrs:{"withForm":false,"clearable":false},model:{value:(_vm.localCustomer),callback:function ($$v) {_vm.localCustomer=$$v},expression:"localCustomer"}}):_c('b-form-group',{attrs:{"label":"Client :"}},[_vm._v(" "+_vm._s(_vm.customer.name)+" ")]),(!_vm.localCustomer)?_c('p',{staticClass:"text-center"},[_vm._v(" Sélectionner un client pour continuer ")]):[_c('k-form',{attrs:{"action":'/sales/' + _vm.type + '/bill-multiple',"method":"post","keepLoaderAfterSubmit":true},on:{"submitComplete":_vm.submitComplete}},[(_vm.documents.length > 0)?[_c('b-form-group',{staticStyle:{"max-width":"200px"},attrs:{"label":"Date de la facture :"}},[_c('k-form-datepicker',{attrs:{"name":"date","required":"","min-date":_vm.minDate,"max-date":!_vm.teamConfigs.sales_disable_date_check ? _vm.today : null},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}})],1),_c('input',{attrs:{"type":"hidden","name":"is_draft"},domProps:{"value":_vm.isDraft ?? false}}),_c('k-form-checkbox',{staticClass:"mb-2",attrs:{"validationName":"is_draft"},model:{value:(_vm.isDraft),callback:function ($$v) {_vm.isDraft=$$v},expression:"isDraft"}},[_vm._v(" Créer la facture en brouillon ")]),_c('input',{attrs:{"type":"hidden","name":"add_documents_infos"},domProps:{"value":_vm.addDocumentsInfos ?? false}}),_c('k-form-checkbox',{attrs:{"validationName":"add_documents_infos"},model:{value:(_vm.addDocumentsInfos),callback:function ($$v) {_vm.addDocumentsInfos=$$v},expression:"addDocumentsInfos"}},[_vm._v(" Ajouter une ligne avec la référence des documents avant le contenu du document ")]),(_vm.needAddress)?_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Adresse de facturation"}},[_c('k-form-address',{attrs:{"countries-list":_vm.countries,"prefix-name":"billing_address_","required":"","road-placeholder":_vm.$t('sales.form.road'),"size":"sm","with-road3":"","valuesMap":{
                    road: 'road',
                    city: 'city'
                  },"city-name":"city","road-name":"road"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1):_vm._e()]:_vm._e(),_c('h3',{staticClass:"form-title-alt mb-1 mt-4 border-0"},[_vm._v(" Sélectionner les documents à facturer : ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("N° document")]),_c('th',[_vm._v("Titre")]),_c('th',{staticClass:"text-center"},[_vm._v("Date")]),_c('th',{staticClass:"text-center"},[_vm._v("Total HT")]),_c('th',{staticClass:"text-center"},[_vm._v("Total TTC")]),(_vm.type !== 'delivery')?_c('th',{staticClass:"text-center"},[_vm._v("Reste à facturer")]):_vm._e(),_c('th',{staticClass:"text-center",staticStyle:{"width":"30px"}},[(_vm.documents.length > 0)?_c('k-form-checkbox',{staticClass:"mr-0",attrs:{"noLabel":"","indeterminate":_vm.selectedDocuments.length > 0 && _vm.selectedDocuments.length < _vm.documents.length,"checked":_vm.selectedDocuments.length === _vm.documents.length},on:{"input":_vm.selectAll}}):_vm._e()],1)])]),_c('tbody',[(_vm.documentLoading)?_c('tr',[_c('td',{attrs:{"colspan":_vm.type !== 'delivery' ? 6 : 5}},[_c('Spinner')],1)]):[(_vm.documents.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":_vm.type !== 'delivery' ? 6 : 5}},[_vm._v(" Aucun document à facturer ")])]):_vm._e(),_vm._l((_vm.documents),function(document){return _c('tr',{key:document.id},[_c('td',[_vm._v(_vm._s(document.reference))]),_c('td',[_vm._v(_vm._s(document.title))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(document.date)))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(document.total_ht)))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(document.total_ttc)))]),(_vm.type !== 'delivery')?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(document.to_bill)))]):_vm._e(),_c('td',{staticClass:"text-center"},[_c('k-form-checkbox',{staticClass:"mr-0",attrs:{"value":document.id,"noLabel":"","name":"documents[]"},model:{value:(_vm.selectedDocuments),callback:function ($$v) {_vm.selectedDocuments=$$v},expression:"selectedDocuments"}})],1)])})]],2)])],2)]]]],2)],1)
}
var InvoiceMultipleDocumentsvue_type_template_id_55b829ba_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(85858);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(19529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(42652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(28057);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(51146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(69998);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(19356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/InvoiceMultipleDocuments/InvoiceMultipleDocuments.ts?vue&type=script&lang=ts&external









var InvoiceMultipleDocuments = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(InvoiceMultipleDocuments, _super);
    function InvoiceMultipleDocuments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.multipleBill = false;
        _this.processingMultiple = false;
        _this.localCustomer = null;
        _this.documentLoading = true;
        _this.documents = [];
        _this.invoiceDate = null;
        _this.isDraft = true;
        _this.addDocumentsInfos = true;
        _this.sendInvoice = false;
        _this.mailModel = null;
        _this.today = null;
        _this.selectedDocuments = [];
        _this.address = {};
        _this.jobUniqId = null;
        _this.jobsUniqId = null;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(InvoiceMultipleDocuments.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    InvoiceMultipleDocuments.prototype.mounted = function () {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var today;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, this.loadModels()];
                    case 2:
                        _c.sent();
                        today = external_moment_default()().format('YYYY-MM-DD');
                        this.today = today;
                        this.invoiceDate = today;
                        this.mailModel = (_b = (_a = this.teamConfigs.communication_model_invoice) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    InvoiceMultipleDocuments.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('multipleBillDone', this.multipleBillDone);
        interface_vue_.emitter.off('multipleBillFailed', this.multipleBillFailed);
        interface_vue_.emitter.off('mailSent', this.mailSent);
        interface_vue_.emitter.off('documentSendFailed', this.mailFailed);
    };
    Object.defineProperty(InvoiceMultipleDocuments.prototype, "needAddress", {
        get: function () {
            var _this = this;
            if (this.selectedDocuments.length === 0) {
                return false;
            }
            var hasAddress = false;
            this.selectedDocuments.every(function (id) {
                var _a, _b;
                var invoice = _this.documents.find(function (invoice) { return invoice.id === id; });
                if (((_a = invoice === null || invoice === void 0 ? void 0 : invoice.billing_address) === null || _a === void 0 ? void 0 : _a.city) && ((_b = invoice === null || invoice === void 0 ? void 0 : invoice.billing_address) === null || _b === void 0 ? void 0 : _b.postal_code)) {
                    hasAddress = true;
                    return false;
                }
                return true;
            });
            return !hasAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvoiceMultipleDocuments.prototype, "minDate", {
        get: function () {
            var closed_period = null;
            if (this.team.sales['closed_period']) {
                closed_period = external_moment_default()(this.team.sales['closed_period']).add(1, 'day').format('YYYY-MM-DD');
            }
            var min = null;
            if (!this.teamConfigs.sales_disable_date_check) {
                min = this.team.sales['invoice_date'];
            }
            if (min && (!closed_period || external_moment_default()(min).isAfter(closed_period))) {
                return min;
            }
            else if (closed_period) {
                return closed_period;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    InvoiceMultipleDocuments.prototype.watchIsDraft = function () {
        if (this.isDraft && this.sendInvoice) {
            this.sendInvoice = false;
        }
    };
    InvoiceMultipleDocuments.prototype.watchMultipleBill = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.multipleBill) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadCustomers()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.watchLocalCustomer()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    InvoiceMultipleDocuments.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    InvoiceMultipleDocuments.prototype.watchModalState = function (state) {
        if (state) {
            interface_vue_.emitter.on('multipleBillDone', this.multipleBillDone);
            interface_vue_.emitter.on('multipleBillFailed', this.multipleBillFailed);
            interface_vue_.emitter.on('mailSent', this.mailSent);
            interface_vue_.emitter.on('documentSendFailed', this.mailFailed);
            this.watchMultipleBill();
        }
        else {
            interface_vue_.emitter.off('multipleBillDone', this.multipleBillDone);
            interface_vue_.emitter.off('multipleBillFailed', this.multipleBillFailed);
            interface_vue_.emitter.off('mailSent', this.mailSent);
            interface_vue_.emitter.off('documentSendFailed', this.mailFailed);
        }
        this.errorMsg = null;
        this.processingMultiple = false;
        this.selectedDocuments = [];
    };
    InvoiceMultipleDocuments.prototype.watchCustomer = function (customer) {
        this.localCustomer = customer;
    };
    InvoiceMultipleDocuments.prototype.watchLocalCustomer = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.localCustomer) {
                            this.documents = [];
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.loadDocuments()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Get documents to bill
    InvoiceMultipleDocuments.prototype.loadCustomers = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.documents = [];
                this.documentLoading = true;
                this.$kwSales.axios.get('/sales/' + this.type + '/bill-multiple-search')
                    .then(function (response) {
                    _this.documents = response.data;
                    _this.documentLoading = false;
                })
                    .catch(function (error) {
                    throw new Error(error);
                });
                return [2 /*return*/];
            });
        });
    };
    // Get documents to bill
    InvoiceMultipleDocuments.prototype.loadDocuments = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                this.documents = [];
                this.documentLoading = true;
                this.$kwSales.axios.get('/sales/' + this.type, {
                    params: {
                        filter: {
                            customer: (_a = this.localCustomer) === null || _a === void 0 ? void 0 : _a.id,
                            is_draft: false,
                            can_be_billed: true,
                            main_currency: true
                        }
                    }
                })
                    .then(function (response) {
                    _this.documents = response.data.data;
                    _this.documentLoading = false;
                })
                    .catch(function (error) {
                    throw new Error(error);
                });
                return [2 /*return*/];
            });
        });
    };
    InvoiceMultipleDocuments.prototype.modalHide = function () {
        if (!this.customer) {
            this.localCustomer = null;
        }
    };
    InvoiceMultipleDocuments.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                if (this.multipleBill) {
                    this.jobsUniqId = response.data.map(function (job) { return ({
                        uniq_id: job.uniq_id,
                        data: _this.documents.find(function (document) { return document.customer_id === job.customer_id; }),
                        status: false,
                        error: null,
                        send_status: false,
                        send_error: null,
                        invoice_id: null
                    }); });
                    this.processingMultiple = true;
                }
                else {
                    this.jobUniqId = response.data;
                }
                return [2 /*return*/];
            });
        });
    };
    InvoiceMultipleDocuments.prototype.multipleBillDone = function (datas) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var element;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                if (this.multipleBill) {
                    element = (_a = this.jobsUniqId) === null || _a === void 0 ? void 0 : _a.find(function (job) { return job.uniq_id === datas.uniq_id; });
                    if (element) {
                        element.status = true;
                        element.invoice_id = datas.invoice_id;
                    }
                }
                else {
                    this.redirectInvoice(datas);
                }
                return [2 /*return*/];
            });
        });
    };
    InvoiceMultipleDocuments.prototype.multipleBillFailed = function (datas) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var element;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                if (this.multipleBill) {
                    element = (_a = this.jobsUniqId) === null || _a === void 0 ? void 0 : _a.find(function (job) { return job.uniq_id === datas.uniq_id; });
                    if (element) {
                        element.status = true;
                        element.error = datas.error;
                    }
                }
                else if (datas.uniq_id == this.jobUniqId) {
                    this.errorMsg = datas.error;
                }
                return [2 /*return*/];
            });
        });
    };
    InvoiceMultipleDocuments.prototype.mailSent = function (event) {
        var _this = this;
        var _a;
        var element = event.elements.find(function (element) {
            var _a, _b;
            var subIndex = (_b = (_a = _this.jobsUniqId) === null || _a === void 0 ? void 0 : _a.findIndex(function (job) { return job.invoice_id === element.id && element.type === 'invoice'; })) !== null && _b !== void 0 ? _b : -1;
            return subIndex >= 0;
        });
        if (element) {
            var job = (_a = this.jobsUniqId) === null || _a === void 0 ? void 0 : _a.find(function (job) { return job.invoice_id === element.id; });
            if (job) {
                job.send_status = true;
            }
        }
    };
    InvoiceMultipleDocuments.prototype.mailFailed = function (event) {
        var _this = this;
        var _a;
        var element = event.elements.find(function (element) {
            var _a, _b;
            var subIndex = (_b = (_a = _this.jobsUniqId) === null || _a === void 0 ? void 0 : _a.findIndex(function (job) { return job.invoice_id === element.id && element.type === 'invoice'; })) !== null && _b !== void 0 ? _b : -1;
            return subIndex >= 0;
        });
        if (element) {
            var job = (_a = this.jobsUniqId) === null || _a === void 0 ? void 0 : _a.find(function (job) { return job.invoice_id === element.id; });
            if (job) {
                job.send_status = true;
                job.send_error = event.error;
            }
        }
    };
    InvoiceMultipleDocuments.prototype.redirectInvoice = function (datas) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (datas.uniq_id !== this.jobUniqId) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.$router.push({
                                name: 'invoice-item',
                                params: {
                                    id: String(datas.invoice_id)
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InvoiceMultipleDocuments.prototype.selectAll = function (state) {
        if (!state) {
            this.selectedDocuments = [];
        }
        else {
            this.selectedDocuments = this.documents.map(function (document) { return document.id; });
        }
    };
    InvoiceMultipleDocuments.prototype.selectAllCustomers = function (state) {
        if (!state) {
            this.selectedDocuments = [];
        }
        else {
            this.selectedDocuments = this.documents.map(function (document) { return document.customer_id; });
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], InvoiceMultipleDocuments.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], InvoiceMultipleDocuments.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], InvoiceMultipleDocuments.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], InvoiceMultipleDocuments.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], InvoiceMultipleDocuments.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], InvoiceMultipleDocuments.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], InvoiceMultipleDocuments.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], InvoiceMultipleDocuments.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('isDraft')
    ], InvoiceMultipleDocuments.prototype, "watchIsDraft", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('multipleBill')
    ], InvoiceMultipleDocuments.prototype, "watchMultipleBill", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], InvoiceMultipleDocuments.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState', { immediate: true })
    ], InvoiceMultipleDocuments.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('customer', { immediate: true })
    ], InvoiceMultipleDocuments.prototype, "watchCustomer", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localCustomer', { immediate: true })
    ], InvoiceMultipleDocuments.prototype, "watchLocalCustomer", null);
    InvoiceMultipleDocuments = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomerSelect: customers_vue_.CustomerSelect,
                Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal,
                KFormAddress: form_vue_.KFormAddress, KFormCheckbox: form_vue_.KFormCheckbox, KFormDatepicker: form_vue_.KFormDatepicker, KForm: form_vue_.KForm, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])), (0,external_vuex_.mapActions)('communication', ['loadModels'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'team'])), (0,external_vuex_.mapState)('globalDatas', ['countries'])), (0,external_vuex_.mapState)('communication', ['models']))
        })
    ], InvoiceMultipleDocuments);
    return InvoiceMultipleDocuments;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var InvoiceMultipleDocumentsvue_type_script_lang_ts_external = (InvoiceMultipleDocuments);

;// ./src/components/InvoiceMultipleDocuments/InvoiceMultipleDocuments.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var InvoiceMultipleDocuments_InvoiceMultipleDocumentsvue_type_script_lang_ts_external = (InvoiceMultipleDocumentsvue_type_script_lang_ts_external); 
;// ./src/components/InvoiceMultipleDocuments/InvoiceMultipleDocuments.vue





/* normalize component */
;
var InvoiceMultipleDocuments_component = (0,componentNormalizer/* default */.A)(
  InvoiceMultipleDocuments_InvoiceMultipleDocumentsvue_type_script_lang_ts_external,
  InvoiceMultipleDocumentsvue_type_template_id_55b829ba_render,
  InvoiceMultipleDocumentsvue_type_template_id_55b829ba_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InvoiceMultipleDocuments_InvoiceMultipleDocuments = (InvoiceMultipleDocuments_component.exports);
// EXTERNAL MODULE: ./src/components/PaymentForm/PaymentForm.vue + 7 modules
var PaymentForm = __webpack_require__(88274);
// EXTERNAL MODULE: ./src/components/PaymentFormButton/PaymentFormButton.vue + 3 modules
var PaymentFormButton = __webpack_require__(72827);
// EXTERNAL MODULE: ./src/components/PaymentItem/PaymentItem.vue + 3 modules
var PaymentItem = __webpack_require__(8446);
// EXTERNAL MODULE: ./src/components/PaymentList/PaymentList.vue + 3 modules
var PaymentList = __webpack_require__(45179);
// EXTERNAL MODULE: ./src/components/PaymentVatRates/PaymentVatRates.vue + 3 modules
var PaymentVatRates = __webpack_require__(89694);
// EXTERNAL MODULE: ./src/components/PdfModelArea/PdfModelArea.vue + 3 modules
var PdfModelArea = __webpack_require__(1803);
// EXTERNAL MODULE: ./src/components/PdfModelBlock/PdfModelBlock.vue + 3 modules
var PdfModelBlock = __webpack_require__(82233);
// EXTERNAL MODULE: ./src/components/PdfModelBlockPreview/PdfModelBlockPreview.vue + 3 modules
var PdfModelBlockPreview = __webpack_require__(27569);
// EXTERNAL MODULE: ./src/components/PdfModelDelete/PdfModelDelete.vue + 3 modules
var PdfModelDelete = __webpack_require__(49171);
// EXTERNAL MODULE: ./src/components/PdfModelForm/PdfModelForm.vue + 4 modules
var PdfModelForm = __webpack_require__(40355);
// EXTERNAL MODULE: ./src/components/PdfModelList/PdfModelList.vue + 3 modules
var PdfModelList = __webpack_require__(50257);
// EXTERNAL MODULE: ./src/components/PdfModelNew/PdfModelNew.vue + 3 modules
var PdfModelNew = __webpack_require__(11650);
// EXTERNAL MODULE: ./src/components/PdfModelSelect/PdfModelSelect.vue + 3 modules
var PdfModelSelect = __webpack_require__(32078);
// EXTERNAL MODULE: ./src/components/PdfViewer/PdfViewer.vue + 3 modules
var PdfViewer = __webpack_require__(28493);
// EXTERNAL MODULE: ./src/components/ProformaList/ProformaList.vue + 2 modules
var ProformaList = __webpack_require__(57182);
// EXTERNAL MODULE: ./src/components/QuotationList/QuotationList.vue + 2 modules
var QuotationList = __webpack_require__(80168);
// EXTERNAL MODULE: ./src/components/RecoveryInvoiceStepForm/RecoveryInvoiceStepForm.vue + 5 modules
var RecoveryInvoiceStepForm = __webpack_require__(20206);
// EXTERNAL MODULE: ./src/components/RecoveryInvoiceStepList/RecoveryInvoiceStepList.vue + 3 modules
var RecoveryInvoiceStepList = __webpack_require__(98528);
// EXTERNAL MODULE: ./src/components/RecoveryInvoiceStepParams/RecoveryInvoiceStepParams.vue + 3 modules
var RecoveryInvoiceStepParams = __webpack_require__(83966);
// EXTERNAL MODULE: ./src/components/RecoveryInvoicesView/RecoveryInvoicesView.vue + 3 modules
var RecoveryInvoicesView = __webpack_require__(84777);
// EXTERNAL MODULE: ./src/components/RecoveryInvoicesView/RecoveryInvoiceView.vue + 3 modules
var RecoveryInvoiceView = __webpack_require__(37280);
// EXTERNAL MODULE: ./src/components/SaleDefaultParams/SaleDefaultParams.vue + 3 modules
var SaleDefaultParams = __webpack_require__(25080);
// EXTERNAL MODULE: ./src/components/SaleExports/SaleExports.vue + 3 modules
var SaleExports = __webpack_require__(54362);
// EXTERNAL MODULE: ./src/components/SaleExportsDownload/SaleExportsDownload.vue + 3 modules
var SaleExportsDownload = __webpack_require__(18281);
// EXTERNAL MODULE: ./src/components/SaleInputOptions/SaleInputOptions.vue + 3 modules
var SaleInputOptions = __webpack_require__(95160);
// EXTERNAL MODULE: ./src/components/SalePdfOptions/SalePdfOptions.vue + 3 modules
var SalePdfOptions = __webpack_require__(19821);
// EXTERNAL MODULE: ./src/components/SaleReferences/SaleReferences.vue + 3 modules
var SaleReferences = __webpack_require__(83862);
// EXTERNAL MODULE: ./src/components/SaleTerms/SaleTerms.vue + 7 modules
var SaleTerms = __webpack_require__(63630);
// EXTERNAL MODULE: ./src/components/SaleTermsSelect/SaleTermsSelect.vue + 3 modules
var SaleTermsSelect = __webpack_require__(95150);
// EXTERNAL MODULE: ./src/components/SepaDepositDelete/SepaDepositDelete.vue + 3 modules
var SepaDepositDelete = __webpack_require__(21478);
// EXTERNAL MODULE: ./src/components/SepaDepositDownload/SepaDepositDownload.vue + 3 modules
var SepaDepositDownload = __webpack_require__(86070);
// EXTERNAL MODULE: ./src/components/SepaDepositForm/SepaDepositForm.vue + 3 modules
var SepaDepositForm = __webpack_require__(83014);
// EXTERNAL MODULE: ./src/components/SepaDepositItem/SepaDepositItem.vue + 3 modules
var SepaDepositItem = __webpack_require__(97508);
// EXTERNAL MODULE: ./src/components/SepaDepositList/SepaDepositList.vue + 3 modules
var SepaDepositList = __webpack_require__(25571);
// EXTERNAL MODULE: ./src/components/SepaDepositValidation/SepaDepositValidation.vue + 3 modules
var SepaDepositValidation = __webpack_require__(81945);
// EXTERNAL MODULE: ./src/components/SignCancel/SignCancel.vue + 3 modules
var SignCancel = __webpack_require__(82973);
// EXTERNAL MODULE: ./src/components/SignConfig/SignConfig.vue + 3 modules
var SignConfig = __webpack_require__(36211);
// EXTERNAL MODULE: ./src/components/SignDelete/SignDelete.vue + 3 modules
var SignDelete = __webpack_require__(79088);
// EXTERNAL MODULE: ./src/components/SignItem/SignItem.vue + 3 modules
var SignItem = __webpack_require__(19966);
// EXTERNAL MODULE: ./src/components/SignList/SignList.vue + 3 modules
var SignList = __webpack_require__(29783);
// EXTERNAL MODULE: ./src/components/SignPdfModel/SignPdfModel.vue + 3 modules
var SignPdfModel = __webpack_require__(49292);
// EXTERNAL MODULE: ./src/components/SignSend/SignSend.vue + 4 modules
var SignSend = __webpack_require__(30210);
// EXTERNAL MODULE: ./src/components/SignState/SignState.vue + 3 modules
var SignState = __webpack_require__(66346);
// EXTERNAL MODULE: ./src/components/StripeConfig/StripeConfig.vue + 8 modules
var StripeConfig = __webpack_require__(11040);
// EXTERNAL MODULE: ./src/components/StripePayment/StripePayment.vue + 4 modules
var StripePayment = __webpack_require__(12762);
// EXTERNAL MODULE: ./src/components/StripePaymentSuccessful/StripePaymentSuccessful.vue + 3 modules
var StripePaymentSuccessful = __webpack_require__(63849);
// EXTERNAL MODULE: ./src/components/StripeSend/StripeSend.vue + 3 modules
var StripeSend = __webpack_require__(12658);
// EXTERNAL MODULE: ./src/components/TransformToCommand/TransformToCommand.vue + 3 modules
var TransformToCommand = __webpack_require__(23091);
// EXTERNAL MODULE: ./src/components/TransformToDepositInvoice/TransformToDepositInvoice.vue + 3 modules
var TransformToDepositInvoice = __webpack_require__(31929);
// EXTERNAL MODULE: ./src/components/TransformToInvoice/TransformToInvoice.vue + 3 modules
var TransformToInvoice = __webpack_require__(50964);
// EXTERNAL MODULE: ./src/components/TransformToProforma/TransformToProforma.vue + 3 modules
var TransformToProforma = __webpack_require__(39491);
// EXTERNAL MODULE: ./src/components/TransformToQuotation/TransformToQuotation.vue + 3 modules
var TransformToQuotation = __webpack_require__(44805);
// EXTERNAL MODULE: ./src/components/UseCredit/UseCredit.vue + 3 modules
var UseCredit = __webpack_require__(34109);
// EXTERNAL MODULE: ./src/components/UsedCredits/UsedCredits.vue + 3 modules
var UsedCredits = __webpack_require__(55149);
// EXTERNAL MODULE: ./src/views/ContractModelFormView/ContractModelFormView.vue + 3 modules
var ContractModelFormView = __webpack_require__(94184);
// EXTERNAL MODULE: ./src/views/PdfModelFormView/PdfModelFormView.vue + 3 modules
var PdfModelFormView = __webpack_require__(55295);
// EXTERNAL MODULE: ./src/views/PublicSignatureView/PublicSignatureView.vue + 4 modules
var PublicSignatureView = __webpack_require__(18648);
// EXTERNAL MODULE: ./src/views/StripePaymentView/StripePaymentView.vue + 3 modules
var StripePaymentView = __webpack_require__(41109);
// EXTERNAL MODULE: ./src/views/AccountingClosingView.vue + 11 modules
var AccountingClosingView = __webpack_require__(7770);
// EXTERNAL MODULE: ./src/views/AccountsView.vue + 3 modules
var AccountsView = __webpack_require__(70219);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AffairItemView.vue?vue&type=template&id=071850b0
var AffairItemViewvue_type_template_id_071850b0_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div')
}
var AffairItemViewvue_type_template_id_071850b0_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AffairItemView.vue?vue&type=script&lang=ts


var AffairItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AffairItemView, _super);
    function AffairItemView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AffairItemView = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], AffairItemView);
    return AffairItemView;
}(lib/* Vue */.lD));
/* harmony default export */ var AffairItemViewvue_type_script_lang_ts = (AffairItemView);

;// ./src/views/AffairItemView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_AffairItemViewvue_type_script_lang_ts = (AffairItemViewvue_type_script_lang_ts); 
;// ./src/views/AffairItemView.vue





/* normalize component */
;
var AffairItemView_component = (0,componentNormalizer/* default */.A)(
  views_AffairItemViewvue_type_script_lang_ts,
  AffairItemViewvue_type_template_id_071850b0_render,
  AffairItemViewvue_type_template_id_071850b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_AffairItemView = (AffairItemView_component.exports);
// EXTERNAL MODULE: ./src/views/AffairListView.vue + 3 modules
var AffairListView = __webpack_require__(54352);
// EXTERNAL MODULE: ./src/views/CheckDepositFormView.vue + 7 modules
var CheckDepositFormView = __webpack_require__(28631);
// EXTERNAL MODULE: ./src/views/CheckDepositItemView.vue + 7 modules
var CheckDepositItemView = __webpack_require__(35813);
// EXTERNAL MODULE: ./src/views/CheckDepositListView.vue + 7 modules
var CheckDepositListView = __webpack_require__(77387);
// EXTERNAL MODULE: ./src/views/CommandListView.vue + 3 modules
var CommandListView = __webpack_require__(51565);
// EXTERNAL MODULE: ./src/views/CommissionDocumentView.vue + 3 modules
var CommissionDocumentView = __webpack_require__(53489);
// EXTERNAL MODULE: ./src/views/CommissionView.vue + 3 modules
var CommissionView = __webpack_require__(77128);
// EXTERNAL MODULE: ./src/views/ContractDeadlineListView.vue + 3 modules
var ContractDeadlineListView = __webpack_require__(90121);
// EXTERNAL MODULE: ./src/views/ContractFormView.vue + 3 modules
var ContractFormView = __webpack_require__(89916);
// EXTERNAL MODULE: ./src/views/ContractItemView.vue + 3 modules
var ContractItemView = __webpack_require__(26993);
// EXTERNAL MODULE: ./src/views/ContractListView.vue + 3 modules
var ContractListView = __webpack_require__(3556);
// EXTERNAL MODULE: ./src/views/ContractModelsListView.vue + 3 modules
var ContractModelsListView = __webpack_require__(36668);
// EXTERNAL MODULE: ./src/views/CreditListView.vue + 3 modules
var CreditListView = __webpack_require__(13333);
// EXTERNAL MODULE: ./src/views/CustomerSepaListView.vue + 3 modules
var CustomerSepaListView = __webpack_require__(59304);
// EXTERNAL MODULE: ./src/views/CustomerSepaParamsView.vue + 3 modules
var CustomerSepaParamsView = __webpack_require__(15760);
// EXTERNAL MODULE: ./src/views/DeliveryListView.vue + 3 modules
var DeliveryListView = __webpack_require__(31478);
// EXTERNAL MODULE: ./src/views/DepositInvoiceListView.vue + 3 modules
var DepositInvoiceListView = __webpack_require__(24997);
// EXTERNAL MODULE: ./src/views/DocumentFormView.vue + 3 modules
var DocumentFormView = __webpack_require__(50624);
// EXTERNAL MODULE: ./src/views/DocumentItemView.vue + 3 modules
var DocumentItemView = __webpack_require__(56476);
// EXTERNAL MODULE: ./src/views/DownloadPdfExportView.vue + 3 modules
var DownloadPdfExportView = __webpack_require__(82115);
// EXTERNAL MODULE: ./src/views/FecDownloadView.vue + 3 modules
var FecDownloadView = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/views/FecFileView.vue + 3 modules
var FecFileView = __webpack_require__(62035);
// EXTERNAL MODULE: ./src/views/GrantsListView.vue + 3 modules
var GrantsListView = __webpack_require__(61796);
// EXTERNAL MODULE: ./src/views/GuaranteeHoldbackView.vue + 3 modules
var GuaranteeHoldbackView = __webpack_require__(43825);
// EXTERNAL MODULE: ./src/views/InvoiceListView.vue + 3 modules
var InvoiceListView = __webpack_require__(36325);
// EXTERNAL MODULE: ./src/views/InvoiceToPaidView.vue + 7 modules
var InvoiceToPaidView = __webpack_require__(12653);
// EXTERNAL MODULE: ./src/views/PaymentListView.vue + 3 modules
var PaymentListView = __webpack_require__(51335);
// EXTERNAL MODULE: ./src/views/PaymentSuccessfulView.vue + 3 modules
var PaymentSuccessfulView = __webpack_require__(94804);
// EXTERNAL MODULE: ./src/views/PaymentVatRatesView.vue + 3 modules
var PaymentVatRatesView = __webpack_require__(61110);
// EXTERNAL MODULE: ./src/views/PdfModelListView.vue + 3 modules
var PdfModelListView = __webpack_require__(7070);
// EXTERNAL MODULE: ./src/views/ProformaListView.vue + 3 modules
var ProformaListView = __webpack_require__(20443);
// EXTERNAL MODULE: ./src/views/QuotationListView.vue + 3 modules
var QuotationListView = __webpack_require__(92595);
// EXTERNAL MODULE: ./src/views/RecoveryInvoiceParamsView.vue + 3 modules
var RecoveryInvoiceParamsView = __webpack_require__(56041);
// EXTERNAL MODULE: ./src/views/RecoveryInvoicesView.vue + 3 modules
var views_RecoveryInvoicesView = __webpack_require__(6705);
// EXTERNAL MODULE: ./src/views/SaleParamsView.vue + 7 modules
var SaleParamsView = __webpack_require__(24034);
// EXTERNAL MODULE: ./src/views/SalesVatRatesView.vue + 7 modules
var SalesVatRatesView = __webpack_require__(4137);
// EXTERNAL MODULE: ./src/views/SaleTermsView.vue + 3 modules
var SaleTermsView = __webpack_require__(84034);
// EXTERNAL MODULE: ./src/views/SepaDepositFormView.vue + 3 modules
var SepaDepositFormView = __webpack_require__(4110);
// EXTERNAL MODULE: ./src/views/SepaDepositItemView.vue + 3 modules
var SepaDepositItemView = __webpack_require__(81752);
// EXTERNAL MODULE: ./src/views/SepaDepositListView.vue + 3 modules
var SepaDepositListView = __webpack_require__(83283);
// EXTERNAL MODULE: ./src/views/SignConfigView.vue + 3 modules
var SignConfigView = __webpack_require__(30737);
// EXTERNAL MODULE: ./src/views/StripeConfigView.vue + 3 modules
var StripeConfigView = __webpack_require__(47286);
// EXTERNAL MODULE: ./src/lang/index.ts + 2 modules
var lang = __webpack_require__(26206);
;// ./src/router/routes.ts
var routes_StripePaymentView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41109)); };
var routes_PaymentSuccessfulView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 94804)); };
var routes_PublicSignatureView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18648)); };

var routes_QuotationList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 92595)); };
var routes_AffairList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 54352)); };
var routes_CommandList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 51565)); };
var routes_ProformaList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 20443)); };
var routes_DeliveryList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 31478)); };
var routes_DocumentForm = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 50624)); };
var routes_DocumentItem = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 56476)); };
var routes_InvoiceList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 36325)); };
var DepositInvoiceList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 24997)); };
var routes_CreditList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 13333)); };
var routes_PaymentList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 51335)); };
var GuaranteeHoldback = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 43825)); };
var DownloadPdfExport = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 82115)); };
var routes_RecoveryInvoicesView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 6705)); };
var routes_CustomerSepaListView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 59304)); };
var routes_ContractListView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 3556)); };
var routes_ContractFormView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 89916)); };
var routes_ContractItemView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 26993)); };
var routes_ContractDeadlineListView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 90121)); };
var routes_SepaDepositListView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 83283)); };
var routes_SepaDepositFormView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 4110)); };
var routes_SepaDepositItemView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 81752)); };
var InvoiceToPaidList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 12653)); };
var routes_CheckDepositListView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 77387)); };
var routes_CheckDepositFormView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 28631)); };
var routes_CheckDepositItemView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 35813)); };
var routes_PaymentVatRatesView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 61110)); };
var routes_SalesVatRatesView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 4137)); };
var routes_CommissionDocumentView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 53489)); };
var CommissionPaymentView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 6618)); };
var CarListView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 56596)); };
var AccountTransactionView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 13059)); };
var routes = function () { return ([
    {
        path: '/sales/affairs',
        name: 'affair-list',
        component: routes_AffairList,
        meta: {
            title: 'Liste des affaires'
        }
    },
    {
        path: '/sales/quotations',
        name: 'quotation-list',
        component: routes_QuotationList,
        meta: {
            title: 'Liste des devis',
            userPermission: ['sales-quotation', 1],
            buttons: [
                {
                    label: 'Nouveau devis',
                    to: '/sales/quotations/form',
                    userPermission: ['sales-quotation', 2]
                },
                {
                    component: InvoiceMultipleDocuments_InvoiceMultipleDocuments,
                    attributes: {
                        label: 'Facturer plusieurs devis',
                        type: 'quotation',
                        userPermission: ['sales-invoice', 2]
                    }
                }
            ]
        }
    },
    {
        path: '/sales/quotations/form/:id?',
        name: 'quotation-form',
        component: routes_DocumentForm,
        meta: {
            sidebarMode: 2,
            allowFullscreen: true,
            pageHeader: false,
            documentType: 'quotation',
            userPermission: ['sales-quotation', 2]
        }
    },
    {
        path: '/sales/quotations/:id',
        name: 'quotation-item',
        component: routes_DocumentItem,
        meta: {
            pageHeader: false,
            documentType: 'quotation',
            userPermission: ['sales-quotation', 1],
            appClass: { 'sales-page-item': true }
        }
    },
    {
        path: '/sales/commands',
        name: 'command-list',
        component: routes_CommandList,
        meta: {
            title: 'Liste des bons de commande',
            appModule: 'sales-commands',
            userPermission: ['sales-command', 1],
            buttons: [
                {
                    label: 'Nouveau bon de commande',
                    to: '/sales/commands/form',
                    userPermission: ['sales-command', 2]
                },
                {
                    component: InvoiceMultipleDocuments_InvoiceMultipleDocuments,
                    attributes: {
                        label: 'Facturer plusieurs bons de commande',
                        type: 'command',
                        userPermission: ['sales-invoice', 2],
                    }
                }
            ]
        }
    },
    {
        path: '/sales/commands/form/:id?',
        name: 'command-form',
        component: routes_DocumentForm,
        meta: {
            appModule: 'sales-commands',
            userPermission: ['sales-command', 2],
            sidebarMode: 2,
            allowFullscreen: true,
            pageHeader: false,
            documentType: 'command'
        }
    },
    {
        path: '/sales/commands/:id',
        name: 'command-item',
        component: routes_DocumentItem,
        meta: {
            appModule: 'sales-commands',
            userPermission: ['sales-command', 1],
            pageHeader: false,
            documentType: 'command',
            appClass: { 'sales-page-item': true }
        }
    },
    {
        path: '/sales/proformas',
        name: 'proforma-list',
        component: routes_ProformaList,
        meta: {
            title: 'Liste des factures proforma',
            appModule: 'sales-proformas',
            userPermission: ['sales-proforma', 1],
            buttons: [
                {
                    label: 'Nouvelle facture proforma',
                    to: '/sales/proformas/form',
                    userPermission: ['sales-proforma', 2]
                },
                {
                    component: InvoiceMultipleDocuments_InvoiceMultipleDocuments,
                    attributes: {
                        label: 'Facturer plusieurs factures proforma',
                        type: 'proforma',
                        userPermission: ['sales-invoice', 2]
                    }
                }
            ]
        }
    },
    {
        path: '/sales/proformas/form/:id?',
        name: 'proforma-form',
        component: routes_DocumentForm,
        meta: {
            appModule: 'sales-proformas',
            userPermission: ['sales-proforma', 2],
            sidebarMode: 2,
            allowFullscreen: true,
            pageHeader: false,
            documentType: 'proforma'
        }
    },
    {
        path: '/sales/proformas/:id',
        name: 'proforma-item',
        component: routes_DocumentItem,
        meta: {
            appModule: 'sales-proformas',
            userPermission: ['sales-proforma', 1],
            pageHeader: false,
            documentType: 'proforma',
            appClass: { 'sales-page-item': true }
        }
    },
    {
        path: '/sales/deliveries',
        name: 'delivery-list',
        component: routes_DeliveryList,
        meta: {
            title: 'Liste des bons de livraison',
            appModule: 'sales-deliveries',
            userPermission: ['sales-delivery', 1],
            buttons: [
                {
                    label: 'Nouveau bon de livraison',
                    to: '/sales/deliveries/form',
                    userPermission: ['sales-delivery', 2]
                },
                {
                    component: InvoiceMultipleDocuments_InvoiceMultipleDocuments,
                    attributes: {
                        label: 'Facturer plusieurs bons de livraison',
                        type: 'delivery',
                        userPermission: ['sales-invoice', 2]
                    }
                }
            ]
        }
    },
    {
        path: '/sales/deliveries/form/:id?',
        name: 'delivery-form',
        component: routes_DocumentForm,
        meta: {
            appModule: 'sales-deliveries',
            userPermission: ['sales-delivery', 2],
            sidebarMode: 2,
            allowFullscreen: true,
            pageHeader: false,
            documentType: 'delivery'
        }
    },
    {
        path: '/sales/deliveries/:id',
        name: 'delivery-item',
        component: routes_DocumentItem,
        meta: {
            appModule: 'sales-deliveries',
            userPermission: ['sales-delivery', 1],
            pageHeader: false,
            documentType: 'delivery',
            appClass: { 'sales-page-item': true }
        }
    },
    {
        path: '/invoicing/invoices',
        name: 'invoice-list',
        component: routes_InvoiceList,
        meta: {
            title: 'Liste des factures',
            userPermission: ['sales-invoice', 1],
            buttons: [
                {
                    label: 'Nouvelle facture',
                    to: '/invoicing/invoices/form',
                    userPermission: ['sales-invoice', 2]
                }
            ]
        }
    },
    {
        path: '/invoicing/to-paid-invoices',
        name: 'invoice-to-paid-list',
        component: InvoiceToPaidList,
        meta: {
            title: 'Factures en attente de paiement',
            userPermission: ['sales-invoice', 1]
        }
    },
    {
        path: '/invoicing/deposit-invoices',
        name: 'deposit-invoice-list',
        component: DepositInvoiceList,
        meta: {
            title: 'Liste des factures d\'acompte',
            userPermission: ['sales-invoice', 1]
        }
    },
    {
        path: '/invoicing/invoices/form/:id?',
        name: 'invoice-form',
        component: routes_DocumentForm,
        meta: {
            sidebarMode: 2,
            allowFullscreen: true,
            pageHeader: false,
            documentType: 'invoice',
            userPermission: ['sales-invoice', 2]
        }
    },
    {
        path: '/invoicing/invoices/:id',
        name: 'invoice-item',
        component: routes_DocumentItem,
        meta: {
            pageHeader: false,
            documentType: 'invoice',
            userPermission: ['sales-invoice', 1],
            appClass: { 'sales-page-item': true }
        }
    },
    {
        path: '/invoicing/credits',
        name: 'credit-list',
        component: routes_CreditList,
        meta: {
            title: 'Liste des avoirs',
            userPermission: ['sales-credit', 1],
            buttons: [
                {
                    label: 'Nouvel avoir',
                    to: '/invoicing/credits/form',
                    userPermission: ['sales-credit', 2]
                }
            ]
        }
    },
    {
        path: '/invoicing/credits/form/:id?',
        name: 'credit-form',
        component: routes_DocumentForm,
        meta: {
            sidebarMode: 2,
            allowFullscreen: true,
            pageHeader: false,
            documentType: 'credit',
            userPermission: ['sales-credit', 2]
        }
    },
    {
        path: '/invoicing/credits/:id',
        name: 'credit-item',
        component: routes_DocumentItem,
        meta: {
            pageHeader: false,
            documentType: 'credit',
            userPermission: ['sales-credit', 1],
            appClass: { 'sales-page-item': true }
        }
    },
    {
        path: '/invoicing/vatrates',
        name: 'sales-vatrates-dashboard',
        component: routes_SalesVatRatesView,
        meta: {
            title: 'Récapitulatif de la TVA',
            userPermission: ['sales-invoice', 1]
        }
    },
    {
        path: '/payments/payments',
        name: 'payment-list',
        component: routes_PaymentList,
        meta: {
            title: 'Liste des encaissements',
            userPermission: ['sales-invoice', 1]
        }
    },
    {
        path: '/payments/vatrates',
        name: 'payments-vatrates-dashboard',
        component: routes_PaymentVatRatesView,
        meta: {
            title: 'Récapitulatif de la TVA',
            userPermission: ['sales-invoice', 1]
        }
    },
    {
        path: '/invoicing/guarantee-holdback',
        name: 'guarantee-holdback-list',
        component: GuaranteeHoldback,
        meta: {
            title: 'Liste des retenues de garantie',
            userPermission: ['sales-invoice', 1],
            appModule: 'sales-guarantee-holdback'
        }
    },
    {
        path: '/pdf-exports/:id/download',
        name: 'pdf-export-download',
        component: DownloadPdfExport,
        meta: {
            pageHeader: false,
            title: 'Téléchargement'
        }
    },
    {
        path: '/invoicing/recovery',
        name: 'invoicing-recovery',
        component: routes_RecoveryInvoicesView,
        meta: {
            title: 'Relance des factures impayées',
            appModule: 'sales-recovery',
            buttons: [
                {
                    label: 'Configuration',
                    variant: 'secondary',
                    to: { name: 'sales-recovery-invoice-steps' }
                }
            ]
        }
    },
    {
        path: '/payments/sepa',
        name: 'sepa-list',
        component: routes_CustomerSepaListView,
        meta: {
            title: 'Liste des mandats SEPA',
            appModule: 'sales-sepa',
            userPermission: ['sales-invoice', 1],
            pageHeader: false
        }
    },
    {
        path: '/payments/deposit-sepa',
        name: 'sepa-deposit-list',
        component: routes_SepaDepositListView,
        meta: {
            title: 'Liste des remises de prélèvement SEPA',
            appModule: 'sales-sepa',
            userPermission: ['sales-invoice', 1],
            buttons: [
                {
                    label: 'Créer une remise',
                    variant: 'primary',
                    to: { name: 'sepa-deposit-form' }
                }
            ]
        }
    },
    {
        path: '/payments/deposit-sepa/form/:id?',
        name: 'sepa-deposit-form',
        component: routes_SepaDepositFormView,
        meta: {
            title: 'Remise de prélèvement SEPA',
            appModule: 'sales-sepa',
            userPermission: ['sales-invoice', 3],
            pageHeader: false
        }
    },
    {
        path: '/payments/deposit-sepa/:id',
        name: 'sepa-deposit-item',
        component: routes_SepaDepositItemView,
        meta: {
            title: 'Remise de prélèvement SEPA',
            appModule: 'sales-sepa',
            userPermission: ['sales-invoice', 1],
            pageHeader: false
        }
    },
    {
        path: '/public/sign/:id/:yousignId/:hash',
        name: 'public-sign',
        component: routes_PublicSignatureView,
        meta: {
            isPublic: true,
            noTemplate: true
        }
    },
    {
        path: '/public/sign/test/:id/:yousignId/:hash',
        name: 'public-sign-test',
        component: routes_PublicSignatureView,
        meta: {
            isPublic: true,
            noTemplate: true
        }
    },
    {
        path: '/public/:type/:id/:token/:hash',
        name: 'public-stripe-payment',
        component: routes_StripePaymentView,
        meta: {
            isPublic: true,
            noTemplate: true
        }
    },
    {
        path: '/public/payment/:accountId/checkout',
        name: 'public-stripe-checkout',
        component: routes_PaymentSuccessfulView,
        meta: {
            isPublic: true,
            noTemplate: true
        }
    },
    {
        path: '/contracts/contracts',
        name: 'contract-list',
        component: routes_ContractListView,
        meta: {
            pageHeader: false,
            title: 'Liste des contracts',
            appModule: 'sales-contracts',
            userPermission: ['sales-contracts', 1],
            buttons: [
                {
                    label: 'Créer un contrat',
                    variant: 'primary',
                    to: { name: 'contract-form' }
                }
            ]
        }
    },
    {
        path: '/contracts/contracts/form/:id?',
        name: 'contract-form',
        component: routes_ContractFormView,
        meta: {
            pageHeader: false,
            sidebarMode: 2,
            allowFullscreen: true,
            title: 'Modification d\'un contrat',
            appModule: 'sales-contracts',
            userPermission: ['sales-contracts', 2]
        }
    },
    {
        path: '/contracts/contracts/:id',
        name: 'contract-item',
        component: routes_ContractItemView,
        meta: {
            pageHeader: false,
            title: 'Fiche contrat',
            appModule: 'sales-contracts',
            userPermission: ['sales-contracts', 1]
        }
    },
    {
        path: '/contracts/deadlines',
        name: 'contract-deadline-list',
        component: routes_ContractDeadlineListView,
        meta: {
            title: 'Liste des échéances',
            appModule: 'sales-contracts',
            userPermission: ['sales-contracts', 1]
        }
    },
    {
        path: '/payments/check-deposit',
        name: 'check-deposit-list',
        component: routes_CheckDepositListView,
        meta: {
            title: 'Liste des remises de chèques',
            appModule: 'sales-checks-deposits',
            userPermission: ['sales-invoice', 1],
            buttons: [
                {
                    label: 'Créer une remise',
                    variant: 'primary',
                    to: { name: 'check-deposit-form' }
                }
            ]
        }
    },
    {
        path: '/payments/check-deposit/form/:id?',
        name: 'check-deposit-form',
        component: routes_CheckDepositFormView,
        meta: {
            title: 'Remise de chèque',
            appModule: 'sales-checks-deposits',
            userPermission: ['sales-invoice', 3],
            pageHeader: false
        }
    },
    {
        path: '/payments/check-deposit/:id',
        name: 'check-deposit-item',
        component: routes_CheckDepositItemView,
        meta: {
            title: 'Remise de chèque',
            appModule: 'sales-checks-deposits',
            userPermission: ['sales-invoice', 1],
            pageHeader: false
        }
    },
    {
        path: '/commissions/commissions',
        name: 'commissions-list',
        component: routes_CommissionDocumentView,
        meta: {
            title: 'Liste des commissions',
            pageHeader: false,
            appModule: 'sales-commissions',
            userPermission: ['sales-commissions', 1]
        }
    },
    {
        path: '/commissions/payments',
        name: 'commissions-payments-list',
        component: CommissionPaymentView,
        meta: {
            title: 'Paiements des commissions',
            pageHeader: false,
            appModule: 'sales-commissions',
            userPermission: ['sales-commissions', 1]
        }
    },
    {
        path: '/cars',
        name: 'cars-list',
        component: CarListView,
        meta: {
            title: 'Liste des véhicules',
            pageHeader: false,
            appModule: 'automotive'
        }
    },
    {
        path: '/accounts',
        name: 'accounts',
        component: AccountTransactionView,
        meta: {
            title: 'Comptes bancaires',
            pageHeader: false,
            userPermission: ['sales-accounts', 1]
        }
    }
]); };
/* harmony default export */ var router_routes = (routes);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(90622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./src/router/config.ts

var SaleParams = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 24034)); };
var config_SaleTerms = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 84034)); };
var GrantsList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 61796)); };
var config_PdfModelList = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 7070)); };
var config_PdfModelForm = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 55295)); };
var AccountListView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 70219)); };
var config_RecoveryInvoiceParamsView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 56041)); };
var config_CustomerSepaParamsView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 15760)); };
var config_StripeConfigView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 47286)); };
var config_SignConfigView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 30737)); };
var config_ContractModelsListView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 36668)); };
var config_ContractModelFormView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 94184)); };
var config_FecFileView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 62035)); };
var config_FecDownloadView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 2652)); };
var config_AccountingClosingView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 7770)); };
var config_CommissionView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 77128)); };
var CarParamsView = function () { return __webpack_require__.e(/* import() | sales */ 189).then(__webpack_require__.bind(__webpack_require__, 64394)); };
var configRoutes = function (i18n) { return ([
    {
        name: 'sales-params',
        path: 'sales/params',
        component: SaleParams,
        meta: {
            title: i18n.t('sales.params.pageTitle')
        }
    },
    {
        name: 'sales-terms',
        path: 'sales/sale-terms',
        component: config_SaleTerms,
        meta: {
            title: i18n.t('sales.saleTerm.pageTitle')
        }
    },
    {
        name: 'sales-grants',
        path: 'sales/grants',
        component: GrantsList,
        meta: {
            title: i18n.t('sales.grant.pageTitle'),
            appModule: 'sales-grants'
        }
    },
    {
        name: 'sales-accounts',
        path: 'sales/accounts',
        component: AccountListView,
        meta: {
            title: i18n.t('sales.account.pageTitle'),
            pageHeader: false
        }
    },
    {
        name: 'pdf-models',
        path: 'pdf-models',
        component: config_PdfModelList,
        meta: {
            title: i18n.t('sales.pdfModel.pageTitle'),
            buttons: [
                {
                    label: i18n.t('sales.pdfModel.addLabel'),
                    click: function () {
                        external_vue_default().prototype.$kwSales.store.commit('app/updateHeaderAction', 'new-pdf-model');
                    }
                }
            ]
        }
    },
    {
        name: 'sales-pdf-model-form',
        path: 'pdf-models/:id',
        component: config_PdfModelForm,
        meta: {
            title: i18n.t('sales.pdfModel.pageTitle')
        }
    },
    {
        path: 'sales/recovery-invoice-steps',
        name: 'sales-recovery-invoice-steps',
        component: config_RecoveryInvoiceParamsView,
        meta: {
            title: i18n.t('sales.recoveryInvoice.config.pageTitle'),
            appModule: 'sales-recovery'
        }
    },
    {
        path: 'sales/sepa',
        name: 'sepa-params',
        component: config_CustomerSepaParamsView,
        meta: {
            title: 'Mandats SEPA',
            appModule: 'sales-sepa'
        }
    },
    {
        path: 'sales/stripe',
        name: 'stripe-params',
        component: config_StripeConfigView,
        meta: {
            title: 'Paiement en ligne',
            appModule: 'stripe'
        }
    },
    {
        path: 'sales/contract-models',
        name: 'contract-models-list',
        component: config_ContractModelsListView,
        meta: {
            title: 'Contrats et abonnements',
            appModule: 'sales-contracts'
        }
    },
    {
        path: 'sales/contract-models/form/:id?',
        name: 'contract-models-form',
        component: config_ContractModelFormView,
        meta: {
            title: 'Modèle de contrat',
            pageHeader: false,
            appModule: 'sales-contracts'
        }
    },
    {
        path: 'accounting/fec',
        name: 'fec-file',
        component: config_FecFileView,
        meta: {
            title: 'Export des écritures comptable'
        }
    },
    {
        path: 'accounting/fec/download/:id',
        name: 'fec-download',
        component: config_FecDownloadView,
        meta: {
            pageHeader: false,
            title: 'Téléchargement'
        }
    },
    {
        path: 'accounting/accounting-closing',
        name: 'accounting-closing',
        component: config_AccountingClosingView,
        meta: {
            title: 'Clôture comptable'
        }
    },
    {
        path: 'sign-params',
        name: 'sign-params',
        component: config_SignConfigView,
        meta: {
            title: 'Signature électronique',
            appElectronicSign: true
        }
    },
    {
        path: 'commissions',
        name: 'commissions',
        component: config_CommissionView,
        meta: {
            title: 'Configuration des commissions',
            appModule: 'sales-commissions'
        }
    },
    {
        path: 'automotive',
        name: 'automotive',
        component: CarParamsView,
        meta: {
            title: 'Garage',
            appModule: 'automotive'
        }
    }
]); };
/* harmony default export */ var config = (configRoutes);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(39754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
;// ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var esm_config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!esm_config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

;// ./src/store/modules/SalesStore.ts



var SalesStore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SalesStore, _super);
    function SalesStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saleTermsLoaded = false;
        _this.saleTerms = [];
        _this.pdfModelsLoaded = false;
        _this.pdfModels = [];
        _this.accountsLoaded = false;
        _this.accounts = [];
        _this.grantsLoaded = false;
        _this.grants = [];
        _this.recoveryStepsLoaded = false;
        _this.recoverySteps = [];
        _this.contractModelsLoaded = false;
        _this.contractModels = [];
        return _this;
    }
    // CLEAR STORE STATE
    SalesStore.prototype.clearStore = function () {
        var _this = this;
        var elements = ['SaleTerms', 'PdfModels', 'Accounts', 'Grants', 'RecoverySteps', 'ContractModels'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    // Sort a list alphabetically
    SalesStore.prototype.orderList = function (param) {
        var key = param.key;
        param.list.sort(function (a, b) {
            var aKey = a[key].toLowerCase();
            var bKey = b[key].toLowerCase();
            if (aKey < bKey)
                return -1;
            else if (aKey > bKey)
                return 1;
            else
                return 0;
        });
    };
    // Change the loaded state
    SalesStore.prototype.setSaleTermsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.saleTermsLoaded = state;
    };
    // Set the sale terms
    SalesStore.prototype.setSaleTerms = function (saleTerms) {
        this.saleTerms = saleTerms;
    };
    // Add or update a sale term
    SalesStore.prototype.updateSaleTerm = function (saleTerm) {
        if (!this.saleTermsLoaded) {
            return;
        }
        var index = this.saleTerms.findIndex(function (type) { return type.id === saleTerm.id; });
        if (index >= 0) {
            external_vue_default().set(this.saleTerms, index, saleTerm);
        }
        else {
            this.saleTerms.push(saleTerm);
        }
    };
    // Remove a sale term
    SalesStore.prototype.removeSaleTerm = function (saleTerm) {
        if (!this.saleTermsLoaded) {
            return;
        }
        var index = this.saleTerms.findIndex(function (type) { return type.id === saleTerm.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.saleTerms, index);
        }
    };
    // Load the sale terms from api
    SalesStore.prototype.loadSaleTerms = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.saleTermsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/sales/sale_term?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setSaleTerms', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setSaleTermsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SalesStore.prototype.loadSaleTerm = function (id) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.saleTermsLoaded) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/sales/sale_term/' + id)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('updateSaleTerm', response.data)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a sale term
    SalesStore.prototype.setSaleTerm = function (saleTerm) {
        this.context.commit('updateSaleTerm', saleTerm);
        if (this.saleTermsLoaded) {
            this.context.commit('orderList', { list: this.saleTerms, key: 'label' });
        }
    };
    // Delete a sale term
    SalesStore.prototype.deleteSaleTerm = function (saleTerm) {
        this.context.commit('removeSaleTerm', saleTerm);
    };
    // Change the loaded state
    SalesStore.prototype.setPdfModelsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.pdfModelsLoaded = state;
    };
    // Set the pdf models
    SalesStore.prototype.setPdfModels = function (pdfModels) {
        this.pdfModels = pdfModels;
    };
    // Add or update a pdf model
    SalesStore.prototype.updatePdfModel = function (pdfModel) {
        if (!this.pdfModelsLoaded) {
            return;
        }
        var index = this.pdfModels.findIndex(function (type) { return type.id === pdfModel.id; });
        if (index >= 0) {
            external_vue_default().set(this.pdfModels, index, pdfModel);
        }
        else {
            this.pdfModels.push(pdfModel);
        }
    };
    // Remove a pdf model
    SalesStore.prototype.removePdfModel = function (pdfModel) {
        if (!this.pdfModelsLoaded) {
            return;
        }
        var index = this.pdfModels.findIndex(function (type) { return type.id === pdfModel.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.pdfModels, index);
        }
    };
    // Load the pdf models from the server
    SalesStore.prototype.loadPdfModels = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.pdfModelsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/sales/pdf_model?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setPdfModels', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setPdfModelsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a pdf model
    SalesStore.prototype.setPdfModel = function (pdfModel) {
        // Remove unnecessary properties
        external_vue_default()["delete"](pdfModel, 'document');
        external_vue_default()["delete"](pdfModel, 'columns');
        external_vue_default()["delete"](pdfModel, 'top');
        external_vue_default()["delete"](pdfModel, 'bottom');
        external_vue_default()["delete"](pdfModel, 'footer');
        external_vue_default()["delete"](pdfModel, 'tableOptions');
        external_vue_default()["delete"](pdfModel, 'sale_term');
        external_vue_default()["delete"](pdfModel, 'cover');
        this.context.commit('updatePdfModel', pdfModel);
        if (this.pdfModelsLoaded) {
            this.context.commit('orderList', { list: this.pdfModels, key: 'label' });
        }
    };
    // Delete a pdf model
    SalesStore.prototype.deletePdfModel = function (pdfModel) {
        this.context.commit('removePdfModel', pdfModel);
    };
    Object.defineProperty(SalesStore.prototype, "defaultPdfModel", {
        // Return the default pdf model to use for a type
        get: function () {
            var _this = this;
            return function (type) {
                var key = 'use_' + type;
                var defaultModel = _this.pdfModels.find(function (model) { return model[key + '_default'] === true; });
                if (!defaultModel) {
                    defaultModel = _this.pdfModels.find(function (model) { return model[key] === true; });
                }
                return defaultModel;
            };
        },
        enumerable: false,
        configurable: true
    });
    // Change the loaded state
    SalesStore.prototype.setAccountsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.accountsLoaded = state;
    };
    // Set the accounts
    SalesStore.prototype.setAccounts = function (accounts) {
        this.accounts = accounts;
    };
    // Add or update an account
    SalesStore.prototype.updateAccount = function (account) {
        if (!this.accountsLoaded) {
            return;
        }
        var index = this.accounts.findIndex(function (type) { return type.id === account.id; });
        if (index >= 0) {
            external_vue_default().set(this.accounts, index, account);
        }
        else {
            this.accounts.push(account);
        }
    };
    // Remove an account
    SalesStore.prototype.removeAccount = function (account) {
        if (!this.accountsLoaded) {
            return;
        }
        var index = this.accounts.findIndex(function (type) { return type.id === account.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.accounts, index);
        }
    };
    // Load the accounts from the server
    SalesStore.prototype.loadAccounts = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.accountsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/sales/account?per_page=500&sort=name&include=syncAccount,syncAccount.bank')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setAccounts', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setAccountsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a pdf model
    SalesStore.prototype.setAccount = function (account) {
        this.context.commit('updateAccount', account);
        if (this.accountsLoaded) {
            this.context.commit('orderList', { list: this.accounts, key: 'name' });
        }
    };
    // Delete a pdf model
    SalesStore.prototype.deleteAccount = function (account) {
        this.context.commit('removeAccount', account);
    };
    Object.defineProperty(SalesStore.prototype, "defaultAccount", {
        // Return the default customer type to use
        get: function () {
            return this.accounts.find(function (account) { return account.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    // Change the loaded state
    SalesStore.prototype.setGrantsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.grantsLoaded = state;
    };
    // Set the grants
    SalesStore.prototype.setGrants = function (grants) {
        this.grants = grants;
    };
    // Add or update a grant
    SalesStore.prototype.updateGrant = function (grant) {
        if (!this.grantsLoaded) {
            return;
        }
        var index = this.grants.findIndex(function (type) { return type.id === grant.id; });
        if (index >= 0) {
            external_vue_default().set(this.grants, index, grant);
        }
        else {
            this.grants.push(grant);
        }
    };
    // Remove a grant
    SalesStore.prototype.removeGrant = function (grant) {
        if (!this.grantsLoaded) {
            return;
        }
        var index = this.grants.findIndex(function (type) { return type.id === grant.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.grants, index);
        }
    };
    // Load the grants from api
    SalesStore.prototype.loadGrants = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.grantsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/sales/grant?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setGrants', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setGrantsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a grant
    SalesStore.prototype.setGrant = function (grant) {
        this.context.commit('updateGrant', grant);
        if (this.grantsLoaded) {
            this.context.commit('orderList', { list: this.grants, key: 'label' });
        }
    };
    // Delete a grant
    SalesStore.prototype.deleteGrant = function (grant) {
        this.context.commit('removeGrant', grant);
    };
    // Change the loaded state
    SalesStore.prototype.setRecoveryStepsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.recoveryStepsLoaded = state;
    };
    // Set the recovery steps
    SalesStore.prototype.setRecoverySteps = function (steps) {
        this.recoverySteps = steps;
    };
    // Add or update a recovery step
    SalesStore.prototype.updateRecoveryStep = function (step) {
        if (!this.recoveryStepsLoaded) {
            return;
        }
        var index = this.recoverySteps.findIndex(function (el) { return el.id === step.id; });
        if (index >= 0) {
            external_vue_default().set(this.recoverySteps, index, step);
        }
        else {
            this.recoverySteps.push(step);
        }
    };
    // Remove a recovery step
    SalesStore.prototype.removeRecoveryStep = function (step) {
        if (!this.recoveryStepsLoaded) {
            return;
        }
        var index = this.recoverySteps.findIndex(function (el) { return el.id === step.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.recoverySteps, index);
        }
    };
    // Load the recovery steps from api
    SalesStore.prototype.loadRecoverySteps = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.recoveryStepsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/sales/recovery-step?per_page=500&sort=delay')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setRecoverySteps', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setRecoveryStepsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a recovery step
    SalesStore.prototype.setRecoveryStep = function (step) {
        this.context.commit('updateRecoveryStep', step);
        if (this.recoveryStepsLoaded) {
            this.context.commit('orderList', { list: this.recoverySteps, key: 'delay' });
        }
    };
    // Delete a recovery step
    SalesStore.prototype.deleteRecoveryStep = function (step) {
        this.context.commit('removeRecoveryStep', step);
    };
    // Change the loaded state
    SalesStore.prototype.setContractModelsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.contractModelsLoaded = state;
    };
    // Set the contract models
    SalesStore.prototype.setContractModels = function (models) {
        this.contractModels = models;
    };
    // Add or update a contract model
    SalesStore.prototype.updateContractModels = function (model) {
        if (!this.contractModelsLoaded) {
            return;
        }
        var index = this.contractModels.findIndex(function (el) { return el.id === model.id; });
        if (index >= 0) {
            external_vue_default().set(this.contractModels, index, model);
        }
        else {
            this.contractModels.push(model);
        }
    };
    // Remove a contract model
    SalesStore.prototype.removeContractModel = function (model) {
        if (!this.contractModelsLoaded) {
            return;
        }
        var index = this.contractModels.findIndex(function (el) { return el.id === model.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.contractModels, index);
        }
    };
    // Load the contract models from api
    SalesStore.prototype.loadContractModels = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.contractModelsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/sales/contract-model', {
                                params: {
                                    per_page: 500,
                                    sort: 'name',
                                    include: ['payment_term', 'payment_method', 'pdf_model', 'documents', 'contents']
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setContractModels', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setContractModelsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SalesStore.prototype.loadContractModel = function (id) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.contractModelsLoaded) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/sales/contract-model/' + id, {
                                params: {
                                    include: ['payment_term', 'payment_method', 'pdf_model', 'documents', 'contents']
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('updateContractModels', response.data)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a contract model
    SalesStore.prototype.setContractModel = function (model) {
        this.context.commit('updateContractModel', model);
        if (this.contractModelsLoaded) {
            this.context.commit('orderList', { list: this.contractModels, key: 'name' });
        }
    };
    // Delete a contract model
    SalesStore.prototype.deleteContractModel = function (model) {
        this.context.commit('removeContractModel', model);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "orderList", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setSaleTermsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setSaleTerms", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "updateSaleTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "removeSaleTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "loadSaleTerms", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "loadSaleTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "setSaleTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "deleteSaleTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setPdfModelsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setPdfModels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "updatePdfModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "removePdfModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "loadPdfModels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "setPdfModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "deletePdfModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setAccountsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setAccounts", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "updateAccount", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "removeAccount", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "loadAccounts", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "setAccount", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "deleteAccount", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setGrantsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setGrants", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "updateGrant", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "removeGrant", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "loadGrants", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "setGrant", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "deleteGrant", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setRecoveryStepsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setRecoverySteps", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "updateRecoveryStep", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "removeRecoveryStep", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "loadRecoverySteps", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "setRecoveryStep", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "deleteRecoveryStep", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setContractModelsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "setContractModels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "updateContractModels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], SalesStore.prototype, "removeContractModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "loadContractModels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "loadContractModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "setContractModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], SalesStore.prototype, "deleteContractModel", null);
    SalesStore = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], SalesStore);
    return SalesStore;
}(VuexModule));
/* harmony default export */ var modules_SalesStore = (SalesStore);

;// ./src/store/modules/AutomotiveStore.ts



var AutomotiveStore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AutomotiveStore, _super);
    function AutomotiveStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.brandsLoaded = false;
        _this.brands = [];
        return _this;
    }
    // CLEAR STORE STATE
    AutomotiveStore.prototype.clearStore = function () {
        var _this = this;
        var elements = ['Brands'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    // Sort a list alphabetically
    AutomotiveStore.prototype.orderList = function (param) {
        var key = param.key;
        param.list.sort(function (a, b) {
            var aKey = a[key].toLowerCase();
            var bKey = b[key].toLowerCase();
            if (aKey < bKey)
                return -1;
            else if (aKey > bKey)
                return 1;
            else
                return 0;
        });
    };
    AutomotiveStore.prototype.setBrandsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.brandsLoaded = state;
    };
    AutomotiveStore.prototype.setBrands = function (brands) {
        this.brands = brands;
    };
    AutomotiveStore.prototype.updateBrand = function (brand) {
        if (!this.brandsLoaded) {
            return;
        }
        var index = this.brands.findIndex(function (type) { return type.id === brand.id; });
        if (index >= 0) {
            external_vue_default().set(this.brands, index, brand);
        }
        else {
            this.brands.push(brand);
        }
    };
    AutomotiveStore.prototype.removeBrand = function (brand) {
        if (!this.brandsLoaded) {
            return;
        }
        var index = this.brands.findIndex(function (type) { return type.id === brand.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.brands, index);
        }
    };
    AutomotiveStore.prototype.loadBrands = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.brandsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/automotive/brand?per_page=500&sort=name&include=models')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setBrands', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setBrandsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AutomotiveStore.prototype.loadBrand = function (id) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.brandsLoaded) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/automotive/brand/' + id + '?include=models')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('updateBrand', response.data)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AutomotiveStore.prototype.setBrand = function (brand) {
        this.context.commit('updateBrand', brand);
        if (this.brandsLoaded) {
            this.context.commit('orderList', { list: this.brands, key: 'name' });
        }
    };
    AutomotiveStore.prototype.deleteBrand = function (brand) {
        this.context.commit('removeBrand', brand);
    };
    Object.defineProperty(AutomotiveStore.prototype, "models", {
        get: function () {
            var models = [];
            this.brands.forEach(function (brand) {
                if (brand.models && brand.models.length > 0) {
                    models.push({
                        id: 'brand' + brand.id,
                        name: brand.name,
                        disabled: true
                    });
                    models.push.apply(models, brand.models);
                }
            });
            return models;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], AutomotiveStore.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], AutomotiveStore.prototype, "orderList", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], AutomotiveStore.prototype, "setBrandsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], AutomotiveStore.prototype, "setBrands", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], AutomotiveStore.prototype, "updateBrand", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], AutomotiveStore.prototype, "removeBrand", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], AutomotiveStore.prototype, "loadBrands", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], AutomotiveStore.prototype, "loadBrand", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], AutomotiveStore.prototype, "setBrand", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], AutomotiveStore.prototype, "deleteBrand", null);
    AutomotiveStore = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], AutomotiveStore);
    return AutomotiveStore;
}(VuexModule));
/* harmony default export */ var modules_AutomotiveStore = (AutomotiveStore);

;// ./src/broadcasts/team.ts


/* harmony default export */ var team = (function (store) { return ([
    {
        name: '.SaleTermCreated',
        callback: function (data) {
            var term = store.state.sales.contractModels.find(function (term) { return term.id === data.id; });
            if (!term || external_moment_default()(term.updated_at).isBefore(data.updated_at)) {
                store.dispatch('sales/loadSaleTerm', data.id);
            }
        }
    },
    {
        name: '.SaleTermUpdated',
        callback: function (data) {
            var term = store.state.sales.contractModels.find(function (term) { return term.id === data.id; });
            if (!term || external_moment_default()(term.updated_at).isBefore(data.updated_at)) {
                store.dispatch('sales/loadSaleTerm', data.id);
            }
        }
    },
    {
        name: '.SaleTermDeleted',
        callback: function (term) {
            store.dispatch('sales/deleteSaleTerm', term);
        }
    },
    {
        name: '.PdfModelCreated',
        callback: function (model) {
            store.dispatch('sales/setPdfModel', model);
        }
    },
    {
        name: '.PdfModelUpdated',
        callback: function (model) {
            store.dispatch('sales/setPdfModel', model);
        }
    },
    {
        name: '.PdfModelDeleted',
        callback: function (model) {
            store.dispatch('sales/deletePdfModel', model);
        }
    },
    {
        name: '.AccountCreated',
        callback: function (account) {
            store.dispatch('sales/setAccount', account);
        }
    },
    {
        name: '.AccountUpdated',
        callback: function (account) {
            store.dispatch('sales/setAccount', account);
        }
    },
    {
        name: '.AccountDeleted',
        callback: function (account) {
            store.dispatch('sales/deleteAccount', account);
        }
    },
    {
        name: '.BankCreated',
        callback: function (bank) {
            interface_vue_.emitter.emit('bankCreated', bank);
        }
    },
    {
        name: '.BankUpdated',
        callback: function (bank) {
            interface_vue_.emitter.emit('bankUpdated', bank);
        }
    },
    {
        name: '.BankDeleted',
        callback: function (bank) {
            interface_vue_.emitter.emit('bankDeleted', bank);
        }
    },
    {
        name: '.GrantCreated',
        callback: function (grant) {
            store.dispatch('sales/setGrant', grant);
        }
    },
    {
        name: '.GrantUpdated',
        callback: function (grant) {
            store.dispatch('sales/setGrant', grant);
        }
    },
    {
        name: '.GrantDeleted',
        callback: function (grant) {
            store.dispatch('sales/deleteGrant', grant);
        }
    },
    {
        name: '.RecoveryInvoiceStepCreated',
        callback: function (step) {
            store.dispatch('sales/setRecoveryStep', step);
        }
    },
    {
        name: '.RecoveryInvoiceStepUpdated',
        callback: function (step) {
            store.dispatch('sales/setRecoveryStep', step);
        }
    },
    {
        name: '.RecoveryInvoiceStepDeleted',
        callback: function (step) {
            store.dispatch('sales/deleteRecoveryStep', step);
        }
    },
    {
        name: '.ContractModelCreated',
        callback: function (data) {
            store.dispatch('sales/loadContractModel', data.id);
        }
    },
    {
        name: '.ContractModelUpdated',
        callback: function (data) {
            var model = store.state.sales.contractModels.find(function (contract) { return contract.id === data.id; });
            if (!model || external_moment_default()(model.updated_at).isBefore(data.updated_at)) {
                store.dispatch('sales/loadContractModel', data.id);
            }
        }
    },
    {
        name: '.ContractModelDeleted',
        callback: function (data) {
            store.dispatch('sales/deleteContractModel', data);
        }
    },
    {
        name: '.CheckDepositUpdated',
        callback: function (data) {
            interface_vue_.emitter.emit('CheckDepositUpdated', data);
        }
    },
    {
        name: '.FecExportUpdated',
        callback: function (exportFec) {
            interface_vue_.emitter.emit('FecExportUpdated', exportFec);
        }
    },
    {
        name: '.DocumentCreated',
        callback: function (datas) {
            var team = JSON.parse(JSON.stringify(store.getters['user/team']));
            var type = datas.type;
            if (type === 'invoice' || type === 'credit') {
                team.sales[type + '_date'] = datas.date;
            }
            team.sales[type + '_reference'] = datas.next_reference;
            store.dispatch('user/setTeam', team);
        }
    },
    {
        name: '.PdfGenerated',
        callback: function (datas) {
            interface_vue_.emitter.emit('PdfGenerated', datas);
        }
    },
    {
        name: '.AutomotivePdfGenerated',
        callback: function (datas) {
            interface_vue_.emitter.emit('AutomotivePdfGenerated', datas);
        }
    },
    {
        name: '.ClosedPeriodCreated',
        callback: function (datas) {
            var team = JSON.parse(JSON.stringify(store.getters['user/team']));
            team.sales['closed_period'] = datas.end;
            store.dispatch('user/setTeam', team);
        }
    },
    {
        name: '.ContractGenerated',
        callback: function (datas) {
            interface_vue_.emitter.emit('contractGenerated', datas);
        }
    },
    {
        name: '.CustomerSepaGenerated',
        callback: function (datas) {
            interface_vue_.emitter.emit('sepaGenerated', datas);
        }
    },
    {
        name: '.BrandCreated',
        callback: function (data) {
            if (store.state.automotive.brandsLoaded) {
                var brand = store.state.automotive.brands.find(function (brand) { return data.id === brand.id; });
                if (!brand || external_moment_default()(brand.updated_at).isBefore(data.updated_at)) {
                    store.dispatch('automotive/loadBrand', brand.id);
                }
            }
        }
    },
    {
        name: '.BrandUpdated',
        callback: function (data) {
            if (store.state.automotive.brandsLoaded) {
                var brand = store.state.automotive.brands.find(function (brand) { return data.id === brand.id; });
                if (!brand || external_moment_default()(brand.updated_at).isBefore(data.updated_at)) {
                    store.dispatch('automotive/loadBrand', brand.id);
                }
            }
        }
    },
    {
        name: '.BrandDeleted',
        callback: function (brand) {
            store.dispatch('automotive/deleteBrand', brand);
        }
    },
    {
        name: '.BrandModelCreated',
        callback: function (datas) {
            if (!store.state.automotive.brandsLoaded) {
                return;
            }
            var brand = store.state.automotive.brands.find(function (brand) { return datas.brand_id === brand.id; });
            if (brand) {
                var model = brand.models.find(function (model) { return model.id === datas.id; });
                if (!model || external_moment_default()(model.updated_at).isBefore(datas.updated_at)) {
                    store.dispatch('automotive/loadBrand', datas.brand_id);
                }
            }
        }
    },
    {
        name: '.BrandModelUpdated',
        callback: function (datas) {
            if (!store.state.automotive.brandsLoaded) {
                return;
            }
            var brand = store.state.automotive.brands.find(function (brand) { return datas.brand_id === brand.id; });
            if (brand) {
                var model = brand.models.find(function (model) { return model.id === datas.id; });
                if (!model || external_moment_default()(model.updated_at).isBefore(datas.updated_at)) {
                    store.dispatch('automotive/loadBrand', datas.brand_id);
                }
            }
        }
    },
    {
        name: '.BrandModelDeleted',
        callback: function (datas) {
            if (!store.state.automotive.brandsLoaded) {
                return;
            }
            var brand = store.state.automotive.brands.find(function (brand) { return datas.brand_id === brand.id; });
            if (brand) {
                var model = brand.models.find(function (model) { return model.id === datas.id; });
                if (!model || external_moment_default()(model.updated_at).isBefore(datas.updated_at)) {
                    store.dispatch('automotive/loadBrand', datas.brand_id);
                }
            }
        }
    },
    {
        name: '.MultipleBillDone',
        callback: function (datas) {
            interface_vue_.emitter.emit('multipleBillDone', datas);
        }
    },
    {
        name: '.MultipleBillFailed',
        callback: function (datas) {
            interface_vue_.emitter.emit('multipleBillFailed', datas);
        }
    },
    {
        name: '.DocumentSendFailed',
        callback: function (datas) {
            interface_vue_.emitter.emit('documentSendFailed', datas);
        }
    },
    {
        name: '.SignatureDone',
        callback: function (signatureDone) {
            interface_vue_.emitter.emit('signatureDone', signatureDone);
        }
    },
    {
        name: '.AccountTransactionUpdated',
        callback: function (transaction) {
            interface_vue_.emitter.emit('accountTransactionUpdated', transaction);
        }
    }
]); });

;// ./src/install.ts







var KwixeoSales = {
    install: function (Vue, options) {
        // Install lang
        this.installLang(options);
        Vue.prototype.$kwSales = options;
        // Install VueX
        this.installVueX(options);
        // Install routes
        this.installRoutes(options);
        __webpack_require__(19467);
        // Initialize broadcasts
        this.installBroadcasts(Vue, options);
    },
    installVueX: function (options) {
        var store = options.store;
        // Register VueX modules
        var modules = {
            sales: modules_SalesStore,
            automotive: modules_AutomotiveStore
        };
        forEach_default()(modules, function (module, key) {
            if (!store.hasModule(key)) {
                store.registerModule(key, module);
            }
        });
    },
    installRoutes: function (options) {
        var router = options.router;
        var i18n = options.i18n;
        router_routes(i18n).forEach(function (route) {
            router.addRoute(route);
        });
        config(i18n).forEach(function (route) {
            router.addRoute('configuration', route);
        });
    },
    installLang: function (options) {
        var i18n = options.i18n;
        forEach_default()(lang/* default */.A, function (messages, locale) {
            i18n.mergeLocaleMessage(locale, messages);
        });
    },
    installBroadcasts: function (Vue, options) {
        var broadcast = Vue.prototype.$broadcast;
        if (!broadcast) {
            return;
        }
        broadcast.registerListeners('team', team(options.store));
    }
};
/* harmony default export */ var install = (KwixeoSales);

// EXTERNAL MODULE: ./src/fetchDatas/checkCommissionPayment.ts
var checkCommissionPayment = __webpack_require__(82819);
// EXTERNAL MODULE: ./src/fetchDatas/checkDeposit.ts
var checkDeposit = __webpack_require__(86192);
// EXTERNAL MODULE: ./src/fetchDatas/contract.ts
var contract = __webpack_require__(99651);
// EXTERNAL MODULE: ./src/fetchDatas/contractModel.ts
var contractModel = __webpack_require__(63991);
// EXTERNAL MODULE: ./src/fetchDatas/customerSepa.ts
var customerSepa = __webpack_require__(91597);
// EXTERNAL MODULE: ./src/fetchDatas/document.ts
var fetchDatas_document = __webpack_require__(6243);
// EXTERNAL MODULE: ./src/fetchDatas/pdfModel.ts
var pdfModel = __webpack_require__(80549);
// EXTERNAL MODULE: ./src/fetchDatas/sepaDeposit.ts
var sepaDeposit = __webpack_require__(10247);
// EXTERNAL MODULE: ./src/fetchDatas/signature.ts
var signature = __webpack_require__(9738);
// EXTERNAL MODULE: ./src/mixins/SalesListMixin/SalesListMixin.vue + 3 modules
var SalesListMixin = __webpack_require__(68067);
// EXTERNAL MODULE: ./src/mixins/CheckDepositMixin.ts
var CheckDepositMixin = __webpack_require__(18964);
// EXTERNAL MODULE: ./src/mixins/ContractFormMixin.ts
var ContractFormMixin = __webpack_require__(4614);
// EXTERNAL MODULE: ./src/mixins/ContractMixin.ts
var ContractMixin = __webpack_require__(3568);
// EXTERNAL MODULE: ./src/mixins/FecMixin.ts
var FecMixin = __webpack_require__(67912);
// EXTERNAL MODULE: ./src/mixins/LoadDocumentMixin.ts + 2 modules
var LoadDocumentMixin = __webpack_require__(38876);
// EXTERNAL MODULE: ./src/mixins/PdfModelMixin.ts
var PdfModelMixin = __webpack_require__(25235);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentLineMixin.ts + 4 modules
var SalesDocumentLineMixin = __webpack_require__(54575);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatus.ts
var SalesDocumentStatus = __webpack_require__(70468);
// EXTERNAL MODULE: ./src/mixins/SalesDocumentStatusMixin.ts
var SalesDocumentStatusMixin = __webpack_require__(25267);
// EXTERNAL MODULE: ./src/mixins/SalesInputOptionsMixin.ts
var SalesInputOptionsMixin = __webpack_require__(80924);
// EXTERNAL MODULE: ./src/mixins/SalesLineMixin.ts
var SalesLineMixin = __webpack_require__(11172);
// EXTERNAL MODULE: ./src/mixins/SalesPdfOptionsMixin.ts
var SalesPdfOptionsMixin = __webpack_require__(922);
// EXTERNAL MODULE: ./src/mixins/SepaDepositMixin.ts
var SepaDepositMixin = __webpack_require__(22363);
// EXTERNAL MODULE: ./src/mixins/StripeMixin.ts + 1 modules
var StripeMixin = __webpack_require__(50148);
// EXTERNAL MODULE: ./src/components/StripeSend/VariablesMixin.ts
var VariablesMixin = __webpack_require__(2787);
;// ./src/menu/configMenu.ts
var configMenu = function (i18n) { return ([
    {
        label: i18n.t('interface.menuLabel.teamInformations'),
        path: '/configuration/team/informations',
        icon: ['fas', 'building']
    },
    {
        label: i18n.t('interface.menuLabel.teamParams'),
        path: '/configuration/parameters',
        icon: ['fas', 'cogs']
    },
    {
        label: 'Modules',
        path: '/configuration/app-modules',
        icon: ['fas', 'cubes']
    },
    {
        label: 'Voitures',
        path: '/configuration/automotive',
        icon: ['fas', 'cars'],
        appModule: 'automotive'
    },
    {
        label: i18n.t('interface.menuLabel.tiers'),
        icon: ['fas', 'users-cog'],
        open: false,
        active: '/configuration/tiers',
        items: [
            {
                label: i18n.t('customers.params.menu'),
                path: '/configuration/tiers/params'
            },
            {
                label: i18n.t('customers.customerType.menu'),
                path: '/configuration/tiers/types'
            },
            {
                label: i18n.t('interface.menuLabel.civilities'),
                path: '/configuration/tiers/civilities'
            },
            {
                label: i18n.t('customers.contactActivity.menu'),
                path: '/configuration/tiers/contact-activities'
            },
            {
                label: i18n.t('customers.contactFunction.menu'),
                path: '/configuration/tiers/contact-functions'
            },
            {
                label: i18n.t('customers.contactOrigin.menu'),
                path: '/configuration/tiers/contact-origins'
            }
        ]
    },
    {
        label: i18n.t('sales.menuTitle'),
        icon: ['fas', 'shopping-cart'],
        open: false,
        active: '/configuration/sales',
        items: [
            {
                label: i18n.t('sales.params.menu'),
                path: '/configuration/sales/params'
            },
            {
                label: i18n.t('catalog.params.menu'),
                path: '/configuration/sales/catalog'
            },
            {
                label: i18n.t('catalog.productVariations.menu'),
                path: '/configuration/sales/product-variations'
            },
            {
                label: i18n.t('sales.saleCategory.menu'),
                path: '/configuration/sales/sales-categories'
            },
            {
                label: i18n.t('sales.paymentTerm.menu'),
                path: '/configuration/sales/payment-terms'
            },
            {
                label: 'Contrats & abonnements',
                path: '/configuration/sales/contract-models'
            },
            {
                label: i18n.t('sales.unit.menu'),
                path: '/configuration/sales/units'
            },
            {
                label: i18n.t('sales.saleTerm.menu'),
                path: '/configuration/sales/sale-terms'
            },
            {
                label: i18n.t('sales.paymentMethod.menu'),
                path: '/configuration/sales/payment-methods'
            },
            {
                label: i18n.t('sales.vatRate.menu'),
                path: '/configuration/sales/vat-rates'
            },
            {
                label: i18n.t('sales.account.menu'),
                path: '/configuration/sales/accounts'
            },
            {
                label: i18n.t('sales.grant.menu'),
                path: '/configuration/sales/grants',
                appModule: 'sales-grants'
            },
            {
                label: i18n.t('sales.recoveryInvoice.config.menu'),
                path: '/configuration/sales/recovery-invoice-steps',
                appModule: 'sales-recovery'
            },
            {
                label: 'Mandats SEPA',
                path: '/configuration/sales/sepa',
                appModule: 'sales-sepa'
            },
            {
                label: 'Paiements en ligne',
                path: '/configuration/sales/stripe',
                appModule: 'stripe'
            }
        ]
    },
    {
        label: 'Commissions',
        path: '/configuration/commissions',
        icon: ['fas', 'badge-percent'],
        appModule: 'sales-commissions'
    },
    {
        label: i18n.t('sales.pdfModel.menu'),
        path: '/configuration/pdf-models',
        icon: ['fas', 'file-pdf']
    },
    {
        label: i18n.t('catalog.config.menu'),
        path: '/configuration/stock-params',
        icon: ['fas', 'box-open']
    },
    {
        label: 'Charges',
        icon: ['fas', 'truck-container'],
        open: false,
        active: '/configuration/charges',
        items: [
            {
                label: i18n.t('catalog.chargeCategory.menu'),
                path: '/configuration/charges/charge-categories'
            }
        ]
    },
    {
        label: i18n.t('customFields.menu'),
        path: '/configuration/custom-fields',
        icon: ['fas', 'sliders-v-square']
    },
    {
        label: i18n.t('interface.menuLabel.tags'),
        path: '/configuration/tags',
        icon: ['fas', 'tags']
    },
    {
        label: i18n.t('interface.menuLabel.importsExports'),
        path: '/configuration/imports-exports',
        icon: ['fas', 'file-import']
    },
    {
        label: i18n.t('interface.menuLabel.users'),
        path: '/configuration/users',
        icon: ['fas', 'users']
    },
    {
        label: i18n.t('interface.menuLabel.historics'),
        path: '/configuration/historics',
        icon: ['fas', 'history']
    },
    {
        label: i18n.t('communication.menuTitle'),
        icon: ['fas', 'comments'],
        open: false,
        active: '/configuration/communication',
        items: [
            {
                label: i18n.t('communication.models.menu'),
                path: '/configuration/communication/models'
            },
            {
                label: i18n.t('communication.files.menu'),
                path: '/configuration/communication/files'
            },
            {
                label: i18n.t('communication.letters.menu'),
                path: '/configuration/communication/letters',
                appModule: 'communication-letters'
            },
            {
                label: i18n.t('communication.params.menu'),
                path: '/configuration/communication/params'
            }
        ]
    },
    {
        label: 'Exports comptable',
        path: '/configuration/accounting/fec',
        icon: ['fas', 'file-import'],
        keywords: ['fichier', 'fec', 'export', 'comptable', 'comptabilite']
    },
    {
        label: 'Clôture comptable',
        path: '/configuration/accounting/accounting-closing',
        icon: ['fas', 'do-not-enter'],
        keywords: ['cloture', 'comptable'],
        appElectronicSign: true
    },
    {
        label: 'Signatures électronique',
        path: '/configuration/sign-params',
        icon: ['fas', 'signature'],
        keywords: ['signature', 'electronique']
    },
    {
        label: 'Mon abonnement',
        path: '/configuration/subscription/manage',
        icon: ['fas', 'credit-card'],
        userPermission: ['manage-subscription', 1]
    }
]); };
/* harmony default export */ var menu_configMenu = (configMenu);

;// ./src/menu/main.ts
var addIcon = ['fas', 'plus-circle'];
var menu = function (i18n) { return ([
    {
        label: 'Tbord',
        path: '/test'
    },
    {
        label: i18n.t('customers.menuTitle'),
        icon: ['fas', 'user-friends'],
        open: false,
        active: '/contacts',
        items: [
            {
                label: i18n.t('customers.contact.menu'),
                path: '/contacts/contacts',
                addIcon: addIcon,
                addTitle: i18n.t('customers.contact.addLabel'),
                addModal: 'contact-form'
            },
            {
                label: i18n.t('customers.prospect.menu'),
                path: '/contacts/prospect',
                addIcon: addIcon,
                addTitle: i18n.t('customers.prospect.addLabel'),
                addModal: 'prospect-form',
                appModule: 'customers-prospects'
            },
            {
                label: i18n.t('customers.customer.menu'),
                path: '/contacts/customer',
                addIcon: addIcon,
                addTitle: i18n.t('customers.customer.addLabel'),
                addModal: 'customer-form'
            },
            {
                label: i18n.t('customers.provider.menu'),
                path: '/contacts/provider',
                addIcon: addIcon,
                addTitle: i18n.t('customers.provider.addLabel'),
                addModal: 'provider-form'
            },
            {
                label: i18n.t('customers.subcontractor.menu'),
                path: '/contacts/subcontractor',
                addIcon: addIcon,
                addTitle: i18n.t('customers.subcontractor.addLabel'),
                addModal: 'subcontractor-form',
                appModule: 'customers-subcontractors'
            }
        ]
    },
    {
        label: 'Véhicules',
        icon: ['fas', 'cars'],
        active: '/cars',
        path: '/cars'
    },
    {
        label: i18n.t('opportunities.opportunities.menu'),
        icon: ['fas', 'folders'],
        active: '/opportunities',
        appModule: 'opportunities',
        userPermission: ['opportunities', 1],
        open: false,
        items: [
            {
                label: i18n.t('opportunities.funnels.menu'),
                path: '/opportunities/funnels',
            },
            {
                label: i18n.t('opportunities.opportunities.menu'),
                path: '/opportunities/opportunities',
            }
        ]
    },
    {
        label: 'Ventes',
        icon: ['fas', 'file-alt'],
        open: false,
        active: '/sales',
        items: [
            {
                label: 'Devis',
                path: '/sales/quotations',
                addIcon: addIcon,
                addRoute: '/sales/quotations/form'
            },
            {
                label: 'Bons de commande',
                path: '/sales/commands',
                addIcon: addIcon,
                addRoute: '/sales/commands/form',
                appModule: 'sales-commands'
            },
            {
                label: 'Bons de livraison',
                path: '/sales/deliveries',
                addIcon: addIcon,
                addRoute: '/sales/deliveries/form',
                appModule: 'sales-deliveries'
            },
            {
                label: 'Factures proforma',
                path: '/sales/proformas',
                addIcon: addIcon,
                addRoute: '/sales/proformas/form',
                appModule: 'sales-proformas'
            }
        ]
    },
    {
        label: 'Contrats',
        icon: ['fas', 'file-contract'],
        open: false,
        active: '/contracts',
        items: [
            {
                label: 'Contrats',
                path: '/contracts/contracts',
                appModule: 'sales-contracts',
                userPermission: ['sales-contracts', 1],
                addIcon: addIcon,
                addRoute: '/contracts/contracts/form',
                addUserPermission: ['sales-contracts', 2]
            },
            {
                label: 'Échéances',
                path: '/contracts/deadlines',
                appModule: 'sales-contracts',
                userPermission: ['sales-contracts', 1]
            }
        ]
    },
    {
        label: 'Facturation',
        icon: ['fas', 'file-invoice'],
        open: false,
        active: '/invoicing',
        items: [
            {
                label: 'Factures',
                path: '/invoicing/invoices',
                addIcon: addIcon,
                addRoute: '/invoicing/invoices/form'
            },
            {
                label: 'Factures d\'acompte',
                path: '/invoicing/deposit-invoices'
            },
            {
                label: 'Avoirs',
                path: '/invoicing/credits',
                addIcon: addIcon,
                addRoute: '/invoicing/credits/form'
            },
            {
                label: 'Retenues de garantie',
                path: '/invoicing/guarantee-holdback'
            },
            {
                label: 'Factures impayées',
                path: '/invoicing/to-paid-invoices'
            },
            {
                label: 'Relance des impayées',
                path: '/invoicing/recovery'
            },
            {
                label: 'Récapitulatif de la TVA',
                path: '/invoicing/vatrates'
            }
        ]
    },
    {
        label: 'Encaissements',
        icon: ['fas', 'credit-card'],
        open: false,
        active: '/payments',
        items: [
            {
                label: 'Encaissements',
                path: '/payments/payments'
            },
            {
                label: 'Récapitulatif de la TVA',
                path: '/payments/vatrates'
            },
            {
                label: 'Remise de chèque',
                path: '/payments/check-deposit',
                addIcon: addIcon,
                addRoute: '/payments/check-deposit/form'
            },
            {
                label: 'Prélèvements SEPA',
                path: '/payments/deposit-sepa',
                addIcon: addIcon,
                addRoute: '/payments/deposit-sepa/form'
            },
            {
                label: 'Mandats SEPA',
                path: '/payments/sepa'
            }
        ]
    },
    {
        label: 'Comptes bancaires',
        icon: ['fas', 'university'],
        path: '/accounts',
        userPermission: ['sales-accounts', 1]
    },
    {
        label: 'Commissions',
        icon: ['fas', 'badge-percent'],
        open: false,
        active: '/commissions',
        appModule: 'sales-commissions',
        userPermission: ['sales-commissions', 1],
        items: [
            {
                label: 'Commissions',
                path: '/commissions/commissions'
            },
            {
                label: 'Paiements',
                path: '/commissions/payments'
            }
        ]
    },
    {
        label: i18n.t('catalog.menuTitle'),
        icon: ['fas', 'books'],
        open: false,
        active: '/catalog',
        items: [
            {
                label: i18n.t('catalog.product.menu'),
                path: '/catalog/products',
                addIcon: addIcon,
                addModal: 'catalog-product-form'
            },
            {
                label: i18n.t('catalog.service.menu'),
                path: '/catalog/services',
                addIcon: addIcon,
                addModal: 'catalog-service-form'
            },
            {
                label: i18n.t('catalog.group.menu'),
                path: '/catalog/groups',
                addIcon: addIcon,
                addModal: 'catalog-group-form',
                appModule: 'catalog-groups'
            }
        ]
    },
    {
        label: i18n.t('catalog.stock.menuTitle'),
        icon: ['fas', 'box-open'],
        open: false,
        active: '/stock',
        appModule: 'stock',
        items: [
            {
                label: 'Mouvements',
                path: '/stock/mouvements'
            },
            {
                label: 'Lots de produits',
                path: '/stock/lots',
                appModule: 'stock-tracabilities'
            },
            {
                label: 'Commandes',
                path: '/stock/commands',
                addIcon: addIcon,
                addRoute: '/stock/commands/form'
            },
            {
                label: 'Entrées & Sorties',
                path: '/stock/manual-mouvements',
                addIcon: addIcon,
                addModal: 'stock-manual-form'
            }
        ]
    },
    {
        label: i18n.t('charges.menuTitle'),
        icon: ['fas', 'shopping-cart'],
        open: false,
        active: '/charges',
        appModule: 'charges',
        items: [
            {
                label: i18n.t('charges.charges.menu'),
                path: '/charges/charges',
                userPermission: ['charges', 1],
                addIcon: addIcon,
                addRoute: { name: 'charges-form' },
                addUserPermission: ['charges', 2]
            },
            {
                label: i18n.t('charges.payments.menu'),
                path: '/charges/payments',
                userPermission: ['charges', 1]
            }
        ]
    },
    {
        label: 'Chantiers',
        icon: ['fas', 'traffic-cone'],
        open: false,
        active: '/constructions',
        appModule: 'construction',
        items: [
            {
                label: 'Liste des chantiers',
                path: '/constructions/constructions',
                addIcon: addIcon,
                addRoute: { name: 'construction-form' },
                addTitle: 'Créer un chantier',
            },
            {
                label: 'Liste des planifications',
                path: '/constructions/planifications'
            },
            {
                label: 'Planning des chantiers',
                path: '/constructions/calendar'
            },
            {
                label: 'Planning des techniciens',
                path: '/constructions/technicians/calendar'
            }
        ]
    },
]); };
/* harmony default export */ var main = (menu);

;// ./src/validate.ts
var validate = {
    saleDocumentLineContent: function (value) {
        if (!value || !value.includes('data-variable="DESIGNATION"')) {
            return 'La variable "désignation" doit être ajoutée';
        }
    },
    pdfModelTotalRateLabel: function (value) {
        if (value && !value.includes('[RATE]')) {
            return 'La variable "[RATE]" doit être ajoutée';
        }
    },
    pdfModelTotalTypeLabel: function (value) {
        if (value && !value.includes('[TYPE]')) {
            return 'La variable "[TYPE]" doit être ajoutée';
        }
    },
    sepaReference: function (value) {
        var regex = /^([a-zA-Z0-9-_]+)$/i;
        if (!value || value === '') {
            return;
        }
        var final = value
            .replaceAll('{YY}', '0000')
            .replaceAll('{Y}', '00')
            .replaceAll('{m}', '00')
            .replaceAll('{d}', '00');
        if (!regex.test(final)) {
            return 'Le préfixe ne peut contenir que des caractères alphanumériques et les caractères - et _';
        }
        else if (final.length > 10) {
            return 'Le préfixe doit faire 10 caractères maximum';
        }
    },
    confirmAccountingClosing: function (value) {
        if (!value || value !== 'Je confirme la clôture de mon année comptable') {
            return 'Vous devez confirmer la clôture';
        }
    },
    signatureLink: function (value) {
        if (!value || (!value.includes('data-variable="SIGN-LINK"') && !value.includes('$SIGN-LINK$'))) {
            return 'La variable pour le lien de la signature doit être ajoutée';
        }
    },
    modelSignatureLink: function (model) {
        var _a, _b;
        if (!model || (!((_a = model.html) === null || _a === void 0 ? void 0 : _a.includes('data-variable="SIGN-LINK"')) && !((_b = model.html) === null || _b === void 0 ? void 0 : _b.includes('$SIGN-LINK$')))) {
            return 'Ce modèle ne possède pas la variable avec le lien pour la signature';
        }
    },
};
/* harmony default export */ var src_validate = (validate);

;// ./src/index.ts











































































































































































































// Vue X Modules


































;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=sales.common.js.map